export const pictograms = {
  "0": [
    {
      "id": 2626,
      "keyword": "0",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6972,
      "keyword": "0",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35693,
      "keyword": "0",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "1": [
    {
      "id": 39296,
      "keyword": "1",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours",
        "communication",
        "language",
        "adverb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29452,
      "keyword": "1",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours",
        "communication",
        "language",
        "adverb",
        "adverb of time"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4889,
      "keyword": "1",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7291,
      "keyword": "1",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35677,
      "keyword": "1",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2627,
      "keyword": "1",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "2": [
    {
      "id": 39292,
      "keyword": "2",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39327,
      "keyword": "2",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29476,
      "keyword": "2",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2628,
      "keyword": "2",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4890,
      "keyword": "2",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7027,
      "keyword": "2",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35679,
      "keyword": "2",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "3": [
    {
      "id": 29482,
      "keyword": "3",
      "keywords": 4,
      "type": null,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2629,
      "keyword": "3",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4891,
      "keyword": "3",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7283,
      "keyword": "3",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35681,
      "keyword": "3",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "4": [
    {
      "id": 39301,
      "keyword": "4",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39316,
      "keyword": "4",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29488,
      "keyword": "4",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2630,
      "keyword": "4",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4892,
      "keyword": "4",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7005,
      "keyword": "4",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35665,
      "keyword": "4",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "5": [
    {
      "id": 39311,
      "keyword": "5",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39359,
      "keyword": "5",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29494,
      "keyword": "5",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2631,
      "keyword": "5",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4893,
      "keyword": "5",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6979,
      "keyword": "5",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35631,
      "keyword": "5",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "6": [
    {
      "id": 39355,
      "keyword": "6",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39376,
      "keyword": "6",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29500,
      "keyword": "6",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2632,
      "keyword": "6",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4894,
      "keyword": "6",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7241,
      "keyword": "6",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35683,
      "keyword": "6",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "7": [
    {
      "id": 39351,
      "keyword": "7",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39383,
      "keyword": "7",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29506,
      "keyword": "7",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2633,
      "keyword": "7",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4895,
      "keyword": "7",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7248,
      "keyword": "7",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35685,
      "keyword": "7",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "8": [
    {
      "id": 39346,
      "keyword": "8",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39379,
      "keyword": "8",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29512,
      "keyword": "8",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2634,
      "keyword": "8",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4896,
      "keyword": "8",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7189,
      "keyword": "8",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35687,
      "keyword": "8",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "9": [
    {
      "id": 39364,
      "keyword": "9",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29518,
      "keyword": "9",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2635,
      "keyword": "9",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4897,
      "keyword": "9",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7188,
      "keyword": "9",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35689,
      "keyword": "9",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39343,
      "keyword": "9",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "10": [
    {
      "id": 39339,
      "keyword": "10",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39371,
      "keyword": "10",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29454,
      "keyword": "10",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7025,
      "keyword": "10",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29254,
      "keyword": "10",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35691,
      "keyword": "10",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "11": [
    {
      "id": 39337,
      "keyword": "11",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39367,
      "keyword": "11",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29460,
      "keyword": "11",
      "keywords": 4,
      "type": null,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29260,
      "keyword": "11",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "12": [
    {
      "id": 39300,
      "keyword": "12",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39324,
      "keyword": "12",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29468,
      "keyword": "12",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29262,
      "keyword": "12",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "13": [
    {
      "id": 29264,
      "keyword": "13",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "14": [
    {
      "id": 29266,
      "keyword": "14",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "15": [
    {
      "id": 29268,
      "keyword": "15",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "16": [
    {
      "id": 29270,
      "keyword": "16",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "17": [
    {
      "id": 29272,
      "keyword": "17",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "18": [
    {
      "id": 29274,
      "keyword": "18",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "19": [
    {
      "id": 29276,
      "keyword": "19",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "20": [
    {
      "id": 29550,
      "keyword": "20",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "21": [
    {
      "id": 29280,
      "keyword": "21",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "22": [
    {
      "id": 29282,
      "keyword": "22",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "23": [
    {
      "id": 29284,
      "keyword": "23",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "24": [
    {
      "id": 29286,
      "keyword": "24",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "25": [
    {
      "id": 29288,
      "keyword": "25",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "26": [
    {
      "id": 29290,
      "keyword": "26",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "27": [
    {
      "id": 29292,
      "keyword": "27",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "28": [
    {
      "id": 29294,
      "keyword": "28",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "29": [
    {
      "id": 29296,
      "keyword": "29",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "30": [
    {
      "id": 29298,
      "keyword": "30",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "31": [
    {
      "id": 29302,
      "keyword": "31",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "32": [
    {
      "id": 29304,
      "keyword": "32",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "33": [
    {
      "id": 29306,
      "keyword": "33",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "34": [
    {
      "id": 29308,
      "keyword": "34",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "35": [
    {
      "id": 29310,
      "keyword": "35",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "36": [
    {
      "id": 29312,
      "keyword": "36",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "37": [
    {
      "id": 29314,
      "keyword": "37",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "38": [
    {
      "id": 29316,
      "keyword": "38",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "39": [
    {
      "id": 29318,
      "keyword": "39",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "40": [
    {
      "id": 29320,
      "keyword": "40",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "41": [
    {
      "id": 29324,
      "keyword": "41",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "42": [
    {
      "id": 29326,
      "keyword": "42",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "43": [
    {
      "id": 29328,
      "keyword": "43",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "44": [
    {
      "id": 29330,
      "keyword": "44",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "45": [
    {
      "id": 29332,
      "keyword": "45",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "46": [
    {
      "id": 29334,
      "keyword": "46",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "47": [
    {
      "id": 29336,
      "keyword": "47",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "48": [
    {
      "id": 29338,
      "keyword": "48",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "49": [
    {
      "id": 29340,
      "keyword": "49",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "50": [
    {
      "id": 29342,
      "keyword": "50",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "51": [
    {
      "id": 29346,
      "keyword": "51",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "52": [
    {
      "id": 29348,
      "keyword": "52",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "53": [
    {
      "id": 29350,
      "keyword": "53",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "54": [
    {
      "id": 29352,
      "keyword": "54",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "55": [
    {
      "id": 29354,
      "keyword": "55",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "56": [
    {
      "id": 29356,
      "keyword": "56",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "57": [
    {
      "id": 29358,
      "keyword": "57",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "58": [
    {
      "id": 29360,
      "keyword": "58",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "59": [
    {
      "id": 29362,
      "keyword": "59",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "60": [
    {
      "id": 29364,
      "keyword": "60",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "61": [
    {
      "id": 29366,
      "keyword": "61",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "62": [
    {
      "id": 29368,
      "keyword": "62",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "63": [
    {
      "id": 29370,
      "keyword": "63",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "64": [
    {
      "id": 29372,
      "keyword": "64",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "65": [
    {
      "id": 29374,
      "keyword": "65",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "66": [
    {
      "id": 29376,
      "keyword": "66",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "67": [
    {
      "id": 29378,
      "keyword": "67",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "68": [
    {
      "id": 29380,
      "keyword": "68",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "69": [
    {
      "id": 29382,
      "keyword": "69",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "70": [
    {
      "id": 29388,
      "keyword": "70",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "71": [
    {
      "id": 29390,
      "keyword": "71",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "72": [
    {
      "id": 29392,
      "keyword": "72",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "73": [
    {
      "id": 29394,
      "keyword": "73",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "74": [
    {
      "id": 29396,
      "keyword": "74",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "75": [
    {
      "id": 29398,
      "keyword": "75",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "76": [
    {
      "id": 29400,
      "keyword": "76",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "77": [
    {
      "id": 29402,
      "keyword": "77",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "78": [
    {
      "id": 29404,
      "keyword": "78",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "79": [
    {
      "id": 29406,
      "keyword": "79",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "80": [
    {
      "id": 29410,
      "keyword": "80",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "81": [
    {
      "id": 29412,
      "keyword": "81",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "82": [
    {
      "id": 29414,
      "keyword": "82",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "83": [
    {
      "id": 29416,
      "keyword": "83",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "84": [
    {
      "id": 29418,
      "keyword": "84",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "85": [
    {
      "id": 29420,
      "keyword": "85",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "86": [
    {
      "id": 29422,
      "keyword": "86",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "87": [
    {
      "id": 29424,
      "keyword": "87",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "88": [
    {
      "id": 29426,
      "keyword": "88",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "89": [
    {
      "id": 29428,
      "keyword": "89",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "90": [
    {
      "id": 29430,
      "keyword": "90",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "91": [
    {
      "id": 29434,
      "keyword": "91",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "92": [
    {
      "id": 29436,
      "keyword": "92",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "93": [
    {
      "id": 29438,
      "keyword": "93",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "94": [
    {
      "id": 29440,
      "keyword": "94",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "95": [
    {
      "id": 29442,
      "keyword": "95",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "96": [
    {
      "id": 29444,
      "keyword": "96",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "97": [
    {
      "id": 29446,
      "keyword": "97",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "98": [
    {
      "id": 29448,
      "keyword": "98",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "99": [
    {
      "id": 29450,
      "keyword": "99",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "100": [
    {
      "id": 29256,
      "keyword": "100",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "200": [
    {
      "id": 29278,
      "keyword": "200",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "300": [
    {
      "id": 29300,
      "keyword": "300",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "400": [
    {
      "id": 29322,
      "keyword": "400",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "500": [
    {
      "id": 29344,
      "keyword": "500",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "600": [
    {
      "id": 29384,
      "keyword": "600",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "700": [
    {
      "id": 29386,
      "keyword": "700",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "800": [
    {
      "id": 29408,
      "keyword": "800",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "900": [
    {
      "id": 29432,
      "keyword": "900",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "1000": [
    {
      "id": 29258,
      "keyword": "1000",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acera": [
    {
      "id": 2247,
      "keyword": "acera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aceras": [
    {
      "id": 2247,
      "keyword": "acera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vereda": [
    {
      "id": 2247,
      "keyword": "vereda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veredas": [
    {
      "id": 2247,
      "keyword": "vereda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agua": [
    {
      "id": 32464,
      "keyword": "agua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2248,
      "keyword": "agua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "mineral rich food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6889,
      "keyword": "agua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "mineral rich food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aguas": [
    {
      "id": 32464,
      "keyword": "agua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2248,
      "keyword": "agua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "mineral rich food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6889,
      "keyword": "agua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "mineral rich food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alfombra": [
    {
      "id": 2249,
      "keyword": "alfombra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alfombras": [
    {
      "id": 2249,
      "keyword": "alfombra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almohada": [
    {
      "id": 2250,
      "keyword": "almohada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almohadas": [
    {
      "id": 2250,
      "keyword": "almohada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ambulancia": [
    {
      "id": 6899,
      "keyword": "ambulancia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36203,
      "keyword": "ambulancia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2251,
      "keyword": "ambulancia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36199,
      "keyword": "ambulancia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36214,
      "keyword": "ambulancia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36200,
      "keyword": "ambulancia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ambulancias": [
    {
      "id": 6899,
      "keyword": "ambulancia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36203,
      "keyword": "ambulancia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2251,
      "keyword": "ambulancia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36199,
      "keyword": "ambulancia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36214,
      "keyword": "ambulancia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36200,
      "keyword": "ambulancia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anillo": [
    {
      "id": 6900,
      "keyword": "anillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 6900,
      "keyword": "anillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2252,
      "keyword": "anillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anillos": [
    {
      "id": 6900,
      "keyword": "anillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 6900,
      "keyword": "anillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2252,
      "keyword": "anillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "antena": [
    {
      "id": 39068,
      "keyword": "antena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "invertebrate",
        "arthropod",
        "insect"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3252,
      "keyword": "antena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2253,
      "keyword": "antena",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "antenas": [
    {
      "id": 39068,
      "keyword": "antena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "invertebrate",
        "arthropod",
        "insect"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3252,
      "keyword": "antena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2253,
      "keyword": "antena",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parabólica": [
    {
      "id": 2253,
      "keyword": "parabólica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parabólicas": [
    {
      "id": 2253,
      "keyword": "parabólica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "araña": [
    {
      "id": 2254,
      "keyword": "araña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "arachnid",
        "oviparous",
        "terrestrial animal",
        "carnivorous",
        "event",
        "popular event",
        "halloween",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38275,
      "keyword": "araña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "arachnid",
        "oviparous",
        "terrestrial animal",
        "carnivorous",
        "wild",
        "event",
        "popular event",
        "halloween",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arañas": [
    {
      "id": 2254,
      "keyword": "araña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "arachnid",
        "oviparous",
        "terrestrial animal",
        "carnivorous",
        "event",
        "popular event",
        "halloween",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38275,
      "keyword": "araña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "arachnid",
        "oviparous",
        "terrestrial animal",
        "carnivorous",
        "wild",
        "event",
        "popular event",
        "halloween",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amigos": [
    {
      "id": 25790,
      "keyword": "amigo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25792,
      "keyword": "amigos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2255,
      "keyword": "amigos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8487,
      "keyword": "amigo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "árbol": [
    {
      "id": 3057,
      "keyword": "árbol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "summer",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2256,
      "keyword": "árbol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "árboles": [
    {
      "id": 3057,
      "keyword": "árbol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "summer",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2256,
      "keyword": "árbol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ardilla": [
    {
      "id": 25815,
      "keyword": "ardilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2257,
      "keyword": "ardilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ardillas": [
    {
      "id": 25815,
      "keyword": "ardilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2257,
      "keyword": "ardilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "armario": [
    {
      "id": 6909,
      "keyword": "armario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2258,
      "keyword": "armario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2258,
      "keyword": "armario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36766,
      "keyword": "armario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "armarios": [
    {
      "id": 6909,
      "keyword": "armario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2258,
      "keyword": "armario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2258,
      "keyword": "armario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36766,
      "keyword": "armario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ropero": [
    {
      "id": 6909,
      "keyword": "ropero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2258,
      "keyword": "ropero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2258,
      "keyword": "ropero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "roperos": [
    {
      "id": 6909,
      "keyword": "ropero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2258,
      "keyword": "ropero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2258,
      "keyword": "ropero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arroz con tomate": [
    {
      "id": 2259,
      "keyword": "arroz con tomate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arroces con tomate": [
    {
      "id": 2259,
      "keyword": "arroz con tomate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ascensor": [
    {
      "id": 2260,
      "keyword": "ascensor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2260,
      "keyword": "ascensor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15826,
      "keyword": "ascensor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "health",
        "medicine",
        "medical center",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ascensores": [
    {
      "id": 2260,
      "keyword": "ascensor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2260,
      "keyword": "ascensor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15826,
      "keyword": "ascensor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "health",
        "medicine",
        "medical center",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asustado": [
    {
      "id": 35535,
      "keyword": "asustado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31896,
      "keyword": "asustado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2261,
      "keyword": "asustado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asustados": [
    {
      "id": 35535,
      "keyword": "asustado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31896,
      "keyword": "asustado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2261,
      "keyword": "asustado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asustada": [
    {
      "id": 35535,
      "keyword": "asustada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11951,
      "keyword": "asustada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2261,
      "keyword": "asustada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asustadas": [
    {
      "id": 35535,
      "keyword": "asustada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11951,
      "keyword": "asustada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2261,
      "keyword": "asustada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abeja": [
    {
      "id": 24823,
      "keyword": "abeja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal",
        "work",
        "primary sector",
        "apiculture",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2239,
      "keyword": "abeja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal",
        "work",
        "primary sector",
        "apiculture",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abejas": [
    {
      "id": 24823,
      "keyword": "abeja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal",
        "work",
        "primary sector",
        "apiculture",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2239,
      "keyword": "abeja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal",
        "work",
        "primary sector",
        "apiculture",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abrigo": [
    {
      "id": 2242,
      "keyword": "abrigo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2242,
      "keyword": "abrigo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8122,
      "keyword": "abrigo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 8122,
      "keyword": "abrigo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrigos": [
    {
      "id": 2242,
      "keyword": "abrigo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2242,
      "keyword": "abrigo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8122,
      "keyword": "abrigo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 8122,
      "keyword": "abrigo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abuela": [
    {
      "id": 23710,
      "keyword": "abuela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 23710,
      "keyword": "abuela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2243,
      "keyword": "abuela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10194,
      "keyword": "abuela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23709,
      "keyword": "abuela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abuelas": [
    {
      "id": 23710,
      "keyword": "abuela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 23710,
      "keyword": "abuela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2243,
      "keyword": "abuela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10194,
      "keyword": "abuela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23709,
      "keyword": "abuela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "yaya": [
    {
      "id": 23710,
      "keyword": "yaya",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 23710,
      "keyword": "yaya",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2243,
      "keyword": "yaya",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10194,
      "keyword": "yaya",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23709,
      "keyword": "yaya",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yayas": [
    {
      "id": 23710,
      "keyword": "yaya",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 23710,
      "keyword": "yaya",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2243,
      "keyword": "yaya",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10194,
      "keyword": "yaya",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23709,
      "keyword": "yaya",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abuelo": [
    {
      "id": 23718,
      "keyword": "abuelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 23718,
      "keyword": "abuelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2244,
      "keyword": "abuelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4560,
      "keyword": "abuelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23717,
      "keyword": "abuelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abuelos": [
    {
      "id": 23718,
      "keyword": "abuelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 23718,
      "keyword": "abuelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6876,
      "keyword": "abuelos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2244,
      "keyword": "abuelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4560,
      "keyword": "abuelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23717,
      "keyword": "abuelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30482,
      "keyword": "abuelos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yayo": [
    {
      "id": 23718,
      "keyword": "yayo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 23718,
      "keyword": "yayo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2244,
      "keyword": "yayo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4560,
      "keyword": "yayo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23717,
      "keyword": "yayo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yayos": [
    {
      "id": 23718,
      "keyword": "yayo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 23718,
      "keyword": "yayo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2244,
      "keyword": "yayo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4560,
      "keyword": "yayo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23717,
      "keyword": "yayo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30482,
      "keyword": "yayos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "elderly",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aburrido": [
    {
      "id": 35531,
      "keyword": "aburrido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31744,
      "keyword": "aburrido",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2245,
      "keyword": "aburrido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aburridos": [
    {
      "id": 35531,
      "keyword": "aburrido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31744,
      "keyword": "aburrido",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2245,
      "keyword": "aburrido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aburrida": [
    {
      "id": 35531,
      "keyword": "aburrida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28705,
      "keyword": "aburrida",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2245,
      "keyword": "aburrida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aburridas": [
    {
      "id": 35531,
      "keyword": "aburrida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28705,
      "keyword": "aburrida",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2245,
      "keyword": "aburrida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aceite": [
    {
      "id": 2246,
      "keyword": "aceite",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery",
        "core vocabulary",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34357,
      "keyword": "aceite",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8481,
      "keyword": "aceite",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aceites": [
    {
      "id": 2246,
      "keyword": "aceite",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery",
        "core vocabulary",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34357,
      "keyword": "aceite",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8481,
      "keyword": "aceite",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aceite de oliva": [
    {
      "id": 2246,
      "keyword": "aceite de oliva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery",
        "core vocabulary",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aceites de oliva": [
    {
      "id": 2246,
      "keyword": "aceite de oliva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery",
        "core vocabulary",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "autobús": [
    {
      "id": 26654,
      "keyword": "autobús",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2262,
      "keyword": "autobús",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2262,
      "keyword": "autobús",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38090,
      "keyword": "autobús",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2263,
      "keyword": "autobús",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autobuses": [
    {
      "id": 26654,
      "keyword": "autobús",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2262,
      "keyword": "autobús",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2262,
      "keyword": "autobús",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38090,
      "keyword": "autobús",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2263,
      "keyword": "autobús",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colectivo": [
    {
      "id": 26654,
      "keyword": "colectivo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2262,
      "keyword": "colectivo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2262,
      "keyword": "colectivo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38090,
      "keyword": "colectivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2263,
      "keyword": "colectivo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colectivos": [
    {
      "id": 26654,
      "keyword": "colectivo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2262,
      "keyword": "colectivo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2262,
      "keyword": "colectivo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38090,
      "keyword": "colectivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2263,
      "keyword": "colectivo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "micro": [
    {
      "id": 26654,
      "keyword": "micro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2262,
      "keyword": "micro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2262,
      "keyword": "micro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2263,
      "keyword": "micro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "micros": [
    {
      "id": 26654,
      "keyword": "micro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2262,
      "keyword": "micro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2262,
      "keyword": "micro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2263,
      "keyword": "micro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "avión": [
    {
      "id": 6924,
      "keyword": "avión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2264,
      "keyword": "avión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2264,
      "keyword": "avión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21409,
      "keyword": "avión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9205,
      "keyword": "avión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aviones": [
    {
      "id": 6924,
      "keyword": "avión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2264,
      "keyword": "avión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2264,
      "keyword": "avión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21409,
      "keyword": "avión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9205,
      "keyword": "avión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "azucarero": [
    {
      "id": 2265,
      "keyword": "azucarero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2266,
      "keyword": "azucarero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "azucareros": [
    {
      "id": 2265,
      "keyword": "azucarero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2266,
      "keyword": "azucarero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barco": [
    {
      "id": 6932,
      "keyword": "barco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 6932,
      "keyword": "barco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2273,
      "keyword": "barco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21425,
      "keyword": "barco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21425,
      "keyword": "barco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37673,
      "keyword": "barco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "outdoor activity",
        "river"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8714,
      "keyword": "barco",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21423,
      "keyword": "barco",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28913,
      "keyword": "barco",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barcos": [
    {
      "id": 6932,
      "keyword": "barco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 6932,
      "keyword": "barco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2273,
      "keyword": "barco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37673,
      "keyword": "barco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "outdoor activity",
        "river"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8714,
      "keyword": "barco",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21423,
      "keyword": "barco",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28913,
      "keyword": "barco",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "batidora": [
    {
      "id": 2274,
      "keyword": "batidora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17175,
      "keyword": "batidora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25688,
      "keyword": "batidora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "batidoras": [
    {
      "id": 2274,
      "keyword": "batidora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 17175,
      "keyword": "batidora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25688,
      "keyword": "batidora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bebé": [
    {
      "id": 2275,
      "keyword": "bebé",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6060,
      "keyword": "bebé",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 6060,
      "keyword": "bebé",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36886,
      "keyword": "bebé",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36887,
      "keyword": "bebé",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28215,
      "keyword": "bebé",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28216,
      "keyword": "bebé",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bebés": [
    {
      "id": 2275,
      "keyword": "bebé",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6060,
      "keyword": "bebé",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 6060,
      "keyword": "bebé",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36886,
      "keyword": "bebé",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36887,
      "keyword": "bebé",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28215,
      "keyword": "bebé",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28216,
      "keyword": "bebé",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "beber": [
    {
      "id": 6061,
      "keyword": "beber",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "feeding",
        "food",
        "beverage",
        "person",
        "basic needs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2276,
      "keyword": "beber",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29716,
      "keyword": "beber",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37528,
      "keyword": "beber",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomar": [
    {
      "id": 6061,
      "keyword": "tomar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "feeding",
        "food",
        "beverage",
        "person",
        "basic needs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6453,
      "keyword": "tomar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32773,
      "keyword": "tomar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17044,
      "keyword": "tomar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10148,
      "keyword": "tomar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2276,
      "keyword": "tomar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2349,
      "keyword": "tomar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6452,
      "keyword": "tomar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28641,
      "keyword": "tomar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29716,
      "keyword": "tomar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35019,
      "keyword": "tomar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17042,
      "keyword": "tomar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bicicleta": [
    {
      "id": 6935,
      "keyword": "bicicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "sport",
        "cycling",
        "road safety",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 6935,
      "keyword": "bicicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "sport",
        "cycling",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2277,
      "keyword": "bicicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39236,
      "keyword": "bicicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "cycling",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bicicletas": [
    {
      "id": 6935,
      "keyword": "bicicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "sport",
        "cycling",
        "road safety",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 6935,
      "keyword": "bicicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "sport",
        "cycling",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2277,
      "keyword": "bicicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39236,
      "keyword": "bicicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "cycling",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bici": [
    {
      "id": 6935,
      "keyword": "bici",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "sport",
        "cycling",
        "road safety",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 6935,
      "keyword": "bici",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "sport",
        "cycling",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2277,
      "keyword": "bici",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bicis": [
    {
      "id": 6935,
      "keyword": "bici",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "sport",
        "cycling",
        "road safety",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 6935,
      "keyword": "bici",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "sport",
        "cycling",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2277,
      "keyword": "bici",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bidé": [
    {
      "id": 2278,
      "keyword": "bidé",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bidés": [
    {
      "id": 2278,
      "keyword": "bidé",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ballena": [
    {
      "id": 2268,
      "keyword": "ballena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ballenas": [
    {
      "id": 2268,
      "keyword": "ballena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "babero": [
    {
      "id": 37411,
      "keyword": "babero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 37411,
      "keyword": "babero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2267,
      "keyword": "babero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baberos": [
    {
      "id": 37411,
      "keyword": "babero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 37411,
      "keyword": "babero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2267,
      "keyword": "babero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "balón": [
    {
      "id": 2269,
      "keyword": "balón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4918,
      "keyword": "balón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balones": [
    {
      "id": 2269,
      "keyword": "balón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4918,
      "keyword": "balón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "basketball"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bocadillo": [
    {
      "id": 2281,
      "keyword": "bocadillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16581,
      "keyword": "bocadillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bocadillos": [
    {
      "id": 2281,
      "keyword": "bocadillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16581,
      "keyword": "bocadillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "blusa": [
    {
      "id": 2280,
      "keyword": "blusa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13642,
      "keyword": "blusa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "blusas": [
    {
      "id": 2280,
      "keyword": "blusa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 13642,
      "keyword": "blusa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolígrafo": [
    {
      "id": 2282,
      "keyword": "bolígrafo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolígrafos": [
    {
      "id": 2282,
      "keyword": "bolígrafo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "boli": [
    {
      "id": 2282,
      "keyword": "boli",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolis": [
    {
      "id": 2282,
      "keyword": "boli",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "birome": [
    {
      "id": 2282,
      "keyword": "birome",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "biromes": [
    {
      "id": 2282,
      "keyword": "birome",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolso": [
    {
      "id": 2284,
      "keyword": "bolso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2284,
      "keyword": "bolso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8511,
      "keyword": "bolso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "sport",
        "sport material",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 8511,
      "keyword": "bolso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "sport",
        "sport material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27620,
      "keyword": "bolso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "accessories",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsos": [
    {
      "id": 2284,
      "keyword": "bolso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2284,
      "keyword": "bolso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8511,
      "keyword": "bolso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "sport",
        "sport material",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 8511,
      "keyword": "bolso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "sport",
        "sport material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27620,
      "keyword": "bolso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "accessories",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bombilla": [
    {
      "id": 2285,
      "keyword": "bombilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bombillas": [
    {
      "id": 2285,
      "keyword": "bombilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolos": [
    {
      "id": 8297,
      "keyword": "bolo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2283,
      "keyword": "bolos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10163,
      "keyword": "bolos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35245,
      "keyword": "bolos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botas": [
    {
      "id": 2287,
      "keyword": "botas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2287,
      "keyword": "botas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2667,
      "keyword": "botas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8299,
      "keyword": "bota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5401,
      "keyword": "bota",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36503,
      "keyword": "bota",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botella": [
    {
      "id": 39042,
      "keyword": "botella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39043,
      "keyword": "botella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2288,
      "keyword": "botella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "container",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botellas": [
    {
      "id": 39042,
      "keyword": "botella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39043,
      "keyword": "botella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2288,
      "keyword": "botella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "container",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "borrar": [
    {
      "id": 2286,
      "keyword": "borrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6939,
      "keyword": "borrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11196,
      "keyword": "borrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11195,
      "keyword": "borrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28189,
      "keyword": "borrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bañador": [
    {
      "id": 2270,
      "keyword": "bañador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "leisure",
        "sport",
        "swimming",
        "sportswear",
        "clothing",
        "outdoor activity",
        "swimming pool",
        "beach",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2270,
      "keyword": "bañador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "leisure",
        "sport",
        "swimming",
        "sportswear",
        "clothing",
        "outdoor activity",
        "swimming pool",
        "beach",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2601,
      "keyword": "bañador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "leisure",
        "sport",
        "swimming",
        "sportswear",
        "clothing",
        "outdoor activity",
        "swimming pool",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bañadores": [
    {
      "id": 2270,
      "keyword": "bañador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "leisure",
        "sport",
        "swimming",
        "sportswear",
        "clothing",
        "outdoor activity",
        "swimming pool",
        "beach",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2270,
      "keyword": "bañador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "leisure",
        "sport",
        "swimming",
        "sportswear",
        "clothing",
        "outdoor activity",
        "swimming pool",
        "beach",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2601,
      "keyword": "bañador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "leisure",
        "sport",
        "swimming",
        "sportswear",
        "clothing",
        "outdoor activity",
        "swimming pool",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "malla": [
    {
      "id": 2270,
      "keyword": "malla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "leisure",
        "sport",
        "swimming",
        "sportswear",
        "clothing",
        "outdoor activity",
        "swimming pool",
        "beach",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2270,
      "keyword": "malla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "leisure",
        "sport",
        "swimming",
        "sportswear",
        "clothing",
        "outdoor activity",
        "swimming pool",
        "beach",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mallas": [
    {
      "id": 2270,
      "keyword": "malla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "leisure",
        "sport",
        "swimming",
        "sportswear",
        "clothing",
        "outdoor activity",
        "swimming pool",
        "beach",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2270,
      "keyword": "malla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "leisure",
        "sport",
        "swimming",
        "sportswear",
        "clothing",
        "outdoor activity",
        "swimming pool",
        "beach",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39452,
      "keyword": "mallas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "traje de baño": [
    {
      "id": 2270,
      "keyword": "traje de baño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "leisure",
        "sport",
        "swimming",
        "sportswear",
        "clothing",
        "outdoor activity",
        "swimming pool",
        "beach",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2270,
      "keyword": "traje de baño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "leisure",
        "sport",
        "swimming",
        "sportswear",
        "clothing",
        "outdoor activity",
        "swimming pool",
        "beach",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trajes de baño": [
    {
      "id": 2270,
      "keyword": "traje de baño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "leisure",
        "sport",
        "swimming",
        "sportswear",
        "clothing",
        "outdoor activity",
        "swimming pool",
        "beach",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2270,
      "keyword": "traje de baño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "leisure",
        "sport",
        "swimming",
        "sportswear",
        "clothing",
        "outdoor activity",
        "swimming pool",
        "beach",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bañar": [
    {
      "id": 6058,
      "keyword": "bañar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "usual verbs",
        "core vocabulary",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25845,
      "keyword": "bañar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "swimming pool",
        "beach",
        "geography",
        "physical geography",
        "landform",
        "river",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2271,
      "keyword": "bañar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25843,
      "keyword": "bañar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "swimming pool",
        "beach",
        "geography",
        "physical geography",
        "landform",
        "river",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25844,
      "keyword": "bañar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "swimming pool",
        "geography",
        "physical geography",
        "landform",
        "river",
        "beach",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31853,
      "keyword": "bañar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36349,
      "keyword": "bañar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bañera": [
    {
      "id": 2272,
      "keyword": "bañera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32142,
      "keyword": "bañera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bañeras": [
    {
      "id": 2272,
      "keyword": "bañera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32142,
      "keyword": "bañera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bufanda": [
    {
      "id": 2290,
      "keyword": "bufanda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2290,
      "keyword": "bufanda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bufandas": [
    {
      "id": 2290,
      "keyword": "bufanda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2290,
      "keyword": "bufanda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "braga": [
    {
      "id": 2289,
      "keyword": "braga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bragas": [
    {
      "id": 2289,
      "keyword": "braga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bombacha": [
    {
      "id": 2289,
      "keyword": "bombacha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bombachas": [
    {
      "id": 2289,
      "keyword": "bombacha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bikini": [
    {
      "id": 2279,
      "keyword": "bikini",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bikinis": [
    {
      "id": 2279,
      "keyword": "bikini",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "biquini": [
    {
      "id": 2279,
      "keyword": "biquini",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "biquinis": [
    {
      "id": 2279,
      "keyword": "biquini",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "buzón": [
    {
      "id": 2293,
      "keyword": "buzón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2292,
      "keyword": "buzón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "work",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24911,
      "keyword": "buzón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "work",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36083,
      "keyword": "buzón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "work",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buzones": [
    {
      "id": 2293,
      "keyword": "buzón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2292,
      "keyword": "buzón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "work",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24911,
      "keyword": "buzón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "work",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36083,
      "keyword": "buzón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "work",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cabra": [
    {
      "id": 25887,
      "keyword": "cabra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2295,
      "keyword": "cabra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cabras": [
    {
      "id": 25887,
      "keyword": "cabra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2295,
      "keyword": "cabra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chivo": [
    {
      "id": 2295,
      "keyword": "chivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chivos": [
    {
      "id": 2295,
      "keyword": "chivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cafetera": [
    {
      "id": 2297,
      "keyword": "cafetera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17186,
      "keyword": "cafetera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8052,
      "keyword": "cafetera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38032,
      "keyword": "cafetera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cafeteras": [
    {
      "id": 2297,
      "keyword": "cafetera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 17186,
      "keyword": "cafetera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8052,
      "keyword": "cafetera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38032,
      "keyword": "cafetera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calcetines": [
    {
      "id": 2298,
      "keyword": "calcetines",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2298,
      "keyword": "calcetines",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8339,
      "keyword": "calcetín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calle": [
    {
      "id": 2299,
      "keyword": "calle",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "urban area",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2299,
      "keyword": "calle",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "urban area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26720,
      "keyword": "calle",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calles": [
    {
      "id": 2299,
      "keyword": "calle",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "urban area",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2299,
      "keyword": "calle",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "urban area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26720,
      "keyword": "calle",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "swimming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "avenida": [
    {
      "id": 2299,
      "keyword": "avenida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "urban area",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2299,
      "keyword": "avenida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "urban area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "avenidas": [
    {
      "id": 2299,
      "keyword": "avenida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "urban area",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2299,
      "keyword": "avenida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "urban area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caluroso": [
    {
      "id": 35549,
      "keyword": "caluroso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31845,
      "keyword": "caluroso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2300,
      "keyword": "caluroso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calurosos": [
    {
      "id": 35549,
      "keyword": "caluroso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31845,
      "keyword": "caluroso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2300,
      "keyword": "caluroso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calurosa": [
    {
      "id": 35549,
      "keyword": "calurosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28655,
      "keyword": "calurosa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2300,
      "keyword": "calurosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calurosas": [
    {
      "id": 35549,
      "keyword": "calurosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28655,
      "keyword": "calurosa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2300,
      "keyword": "calurosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carretera": [
    {
      "id": 5946,
      "keyword": "carretera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2302,
      "keyword": "carretera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carreteras": [
    {
      "id": 5946,
      "keyword": "carretera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2302,
      "keyword": "carretera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calzada": [
    {
      "id": 2302,
      "keyword": "calzada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6953,
      "keyword": "calzada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28627,
      "keyword": "calzada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calzadas": [
    {
      "id": 2302,
      "keyword": "calzada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6953,
      "keyword": "calzada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28627,
      "keyword": "calzada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "burro": [
    {
      "id": 2291,
      "keyword": "burro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "christmas",
        "domestic",
        "core vocabulary",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "burros": [
    {
      "id": 2291,
      "keyword": "burro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "christmas",
        "domestic",
        "core vocabulary",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asno": [
    {
      "id": 2291,
      "keyword": "asno",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "christmas",
        "domestic",
        "core vocabulary",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asnos": [
    {
      "id": 2291,
      "keyword": "asno",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "christmas",
        "domestic",
        "core vocabulary",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "burra": [
    {
      "id": 2291,
      "keyword": "burra",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "christmas",
        "domestic",
        "core vocabulary",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "burras": [
    {
      "id": 2291,
      "keyword": "burra",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "christmas",
        "domestic",
        "core vocabulary",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asna": [
    {
      "id": 2291,
      "keyword": "asna",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "christmas",
        "domestic",
        "core vocabulary",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asnas": [
    {
      "id": 2291,
      "keyword": "asna",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "christmas",
        "domestic",
        "core vocabulary",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cama": [
    {
      "id": 25900,
      "keyword": "cama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 25900,
      "keyword": "cama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6954,
      "keyword": "cama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25690,
      "keyword": "cama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2304,
      "keyword": "cama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camas": [
    {
      "id": 25900,
      "keyword": "cama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 25900,
      "keyword": "cama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6954,
      "keyword": "cama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25690,
      "keyword": "cama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2304,
      "keyword": "cama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camión de juguete": [
    {
      "id": 2307,
      "keyword": "camión de juguete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camiones de juguete": [
    {
      "id": 2307,
      "keyword": "camión de juguete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camión": [
    {
      "id": 6956,
      "keyword": "camión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 6956,
      "keyword": "camión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2306,
      "keyword": "camión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camiones": [
    {
      "id": 6956,
      "keyword": "camión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 6956,
      "keyword": "camión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2306,
      "keyword": "camión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camisa": [
    {
      "id": 13640,
      "keyword": "camisa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 13640,
      "keyword": "camisa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2308,
      "keyword": "camisa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camisas": [
    {
      "id": 13640,
      "keyword": "camisa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 13640,
      "keyword": "camisa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2308,
      "keyword": "camisa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camiseta": [
    {
      "id": 2309,
      "keyword": "camiseta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2309,
      "keyword": "camiseta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2310,
      "keyword": "camiseta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camisetas": [
    {
      "id": 2309,
      "keyword": "camiseta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2309,
      "keyword": "camiseta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2310,
      "keyword": "camiseta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "remera": [
    {
      "id": 2309,
      "keyword": "remera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2309,
      "keyword": "remera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2310,
      "keyword": "remera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "remeras": [
    {
      "id": 2309,
      "keyword": "remera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2309,
      "keyword": "remera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2310,
      "keyword": "remera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "musculosa": [
    {
      "id": 2310,
      "keyword": "musculosa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "musculosas": [
    {
      "id": 2310,
      "keyword": "musculosa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camisón": [
    {
      "id": 2311,
      "keyword": "camisón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39240,
      "keyword": "camisón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camisones": [
    {
      "id": 2311,
      "keyword": "camisón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39240,
      "keyword": "camisón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calzoncillo": [
    {
      "id": 2303,
      "keyword": "calzoncillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2303,
      "keyword": "calzoncillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calzoncillos": [
    {
      "id": 2303,
      "keyword": "calzoncillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2303,
      "keyword": "calzoncillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dromedario": [
    {
      "id": 2305,
      "keyword": "dromedario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7080,
      "keyword": "dromedario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dromedarios": [
    {
      "id": 2305,
      "keyword": "dromedario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7080,
      "keyword": "dromedario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dromedaria": [
    {
      "id": 2305,
      "keyword": "dromedaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7080,
      "keyword": "dromedaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dromedarias": [
    {
      "id": 2305,
      "keyword": "dromedaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7080,
      "keyword": "dromedaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cansado": [
    {
      "id": 35537,
      "keyword": "cansado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "human body",
        "body sensation",
        "covid-19",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2314,
      "keyword": "cansado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "human body",
        "body sensation",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31925,
      "keyword": "cansado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "human body",
        "body sensation",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cansados": [
    {
      "id": 35537,
      "keyword": "cansado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "human body",
        "body sensation",
        "covid-19",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2314,
      "keyword": "cansado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "human body",
        "body sensation",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31925,
      "keyword": "cansado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "human body",
        "body sensation",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cantar": [
    {
      "id": 6960,
      "keyword": "cantar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "music",
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2315,
      "keyword": "cantar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28657,
      "keyword": "cantar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32015,
      "keyword": "cantar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37413,
      "keyword": "cantar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carne": [
    {
      "id": 2316,
      "keyword": "carne",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat",
        "core vocabulary",
        "animal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24807,
      "keyword": "carne",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6976,
      "keyword": "carne",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6961,
      "keyword": "carne",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7000,
      "keyword": "carne",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7001,
      "keyword": "carne",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24809,
      "keyword": "carne",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24811,
      "keyword": "carne",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24813,
      "keyword": "carne",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carnes": [
    {
      "id": 2316,
      "keyword": "carne",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat",
        "core vocabulary",
        "animal"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24807,
      "keyword": "carne",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6976,
      "keyword": "carne",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6961,
      "keyword": "carnes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7000,
      "keyword": "carne",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7001,
      "keyword": "carne",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24809,
      "keyword": "carne",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24811,
      "keyword": "carne",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24813,
      "keyword": "carne",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "café": [
    {
      "id": 32512,
      "keyword": "café",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24479,
      "keyword": "café",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2296,
      "keyword": "café",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9094,
      "keyword": "café",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25564,
      "keyword": "café",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cafés": [
    {
      "id": 32512,
      "keyword": "café",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24479,
      "keyword": "café",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2296,
      "keyword": "café",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25564,
      "keyword": "café",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caballo": [
    {
      "id": 34205,
      "keyword": "caballo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "chess"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2294,
      "keyword": "caballo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic",
        "core vocabulary",
        "leisure",
        "sport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9200,
      "keyword": "caballo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "sport event",
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy",
        "event",
        "olympic games"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caballos": [
    {
      "id": 34205,
      "keyword": "caballo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "chess"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2294,
      "keyword": "caballo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic",
        "core vocabulary",
        "leisure",
        "sport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9200,
      "keyword": "caballo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "sport event",
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy",
        "event",
        "olympic games"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "yegua": [
    {
      "id": 2294,
      "keyword": "yegua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic",
        "core vocabulary",
        "leisure",
        "sport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9200,
      "keyword": "yegua",
      "keywords": 3,
      "type": 2,
      "tags": [
        "sport event",
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy",
        "event",
        "olympic games"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yeguas": [
    {
      "id": 2294,
      "keyword": "yegua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic",
        "core vocabulary",
        "leisure",
        "sport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9200,
      "keyword": "yegua",
      "keywords": 3,
      "type": 2,
      "tags": [
        "sport event",
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy",
        "event",
        "olympic games"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cangrejo": [
    {
      "id": 2312,
      "keyword": "cangrejo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11200,
      "keyword": "cangrejo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cangrejos": [
    {
      "id": 2312,
      "keyword": "cangrejo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11200,
      "keyword": "cangrejo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casa": [
    {
      "id": 6964,
      "keyword": "casa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "core vocabulary",
        "document"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 6964,
      "keyword": "casa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "core vocabulary",
        "document"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2317,
      "keyword": "casa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casas": [
    {
      "id": 6964,
      "keyword": "casa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "core vocabulary",
        "document"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 6964,
      "keyword": "casa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "core vocabulary",
        "document"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2317,
      "keyword": "casa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "castañuelas": [
    {
      "id": 2318,
      "keyword": "castañuelas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "event",
        "popular event",
        "fiestas del pilar"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8340,
      "keyword": "castañuela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "event",
        "popular event",
        "fiestas del pilar"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cazadora": [
    {
      "id": 2319,
      "keyword": "cazadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11209,
      "keyword": "cazadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23921,
      "keyword": "cazadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cazadoras": [
    {
      "id": 2319,
      "keyword": "cazadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11209,
      "keyword": "cazadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23921,
      "keyword": "cazadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "canguro": [
    {
      "id": 2313,
      "keyword": "canguro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canguros": [
    {
      "id": 2313,
      "keyword": "canguro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cepillar los dientes": [
    {
      "id": 6971,
      "keyword": "cepillar los dientes",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2326,
      "keyword": "cepillar los dientes",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27489,
      "keyword": "cepillar los dientes",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31880,
      "keyword": "cepillar los dientes",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cebra": [
    {
      "id": 2324,
      "keyword": "cebra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cebras": [
    {
      "id": 2324,
      "keyword": "cebra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cereales": [
    {
      "id": 2328,
      "keyword": "cereales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34749,
      "keyword": "cereal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "cereal",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34749,
      "keyword": "cereales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "cereal",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerdo": [
    {
      "id": 25622,
      "keyword": "cerdo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24972,
      "keyword": "cerdo",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37365,
      "keyword": "cerdo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2327,
      "keyword": "cerdo",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerdos": [
    {
      "id": 25622,
      "keyword": "cerdo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24972,
      "keyword": "cerdo",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37365,
      "keyword": "cerdo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2327,
      "keyword": "cerdo",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tocino": [
    {
      "id": 24972,
      "keyword": "tocino",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37595,
      "keyword": "tocino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2327,
      "keyword": "tocino",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tocinos": [
    {
      "id": 24972,
      "keyword": "tocino",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37595,
      "keyword": "tocino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2327,
      "keyword": "tocino",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cochino": [
    {
      "id": 24972,
      "keyword": "cochino",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2327,
      "keyword": "cochino",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cochinos": [
    {
      "id": 24972,
      "keyword": "cochino",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2327,
      "keyword": "cochino",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gorrino": [
    {
      "id": 24972,
      "keyword": "gorrino",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2327,
      "keyword": "gorrino",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gorrinos": [
    {
      "id": 24972,
      "keyword": "gorrino",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2327,
      "keyword": "gorrino",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chancho": [
    {
      "id": 25622,
      "keyword": "chancho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24972,
      "keyword": "chancho",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2327,
      "keyword": "chancho",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chanchos": [
    {
      "id": 25622,
      "keyword": "chancho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24972,
      "keyword": "chancho",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2327,
      "keyword": "chancho",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerda": [
    {
      "id": 24972,
      "keyword": "cerda",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2327,
      "keyword": "cerda",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerdas": [
    {
      "id": 24972,
      "keyword": "cerda",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2327,
      "keyword": "cerda",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cochina": [
    {
      "id": 24972,
      "keyword": "cochina",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2327,
      "keyword": "cochina",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cochinas": [
    {
      "id": 24972,
      "keyword": "cochina",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2327,
      "keyword": "cochina",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gorrina": [
    {
      "id": 24972,
      "keyword": "gorrina",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2327,
      "keyword": "gorrina",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gorrinas": [
    {
      "id": 24972,
      "keyword": "gorrina",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2327,
      "keyword": "gorrina",
      "keywords": 8,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerezas": [
    {
      "id": 2329,
      "keyword": "cerezas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8303,
      "keyword": "cereza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cebolla": [
    {
      "id": 2323,
      "keyword": "cebolla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35157,
      "keyword": "cebolla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cebollas": [
    {
      "id": 2323,
      "keyword": "cebolla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35157,
      "keyword": "cebolla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerveza": [
    {
      "id": 2330,
      "keyword": "cerveza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10223,
      "keyword": "cerveza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cervezas": [
    {
      "id": 2330,
      "keyword": "cerveza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10223,
      "keyword": "cerveza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chocolate": [
    {
      "id": 25940,
      "keyword": "chocolate",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2334,
      "keyword": "chocolate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6448,
      "keyword": "chocolate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chocolates": [
    {
      "id": 25940,
      "keyword": "chocolate",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2334,
      "keyword": "chocolate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6448,
      "keyword": "chocolate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chimenea": [
    {
      "id": 2333,
      "keyword": "chimenea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8072,
      "keyword": "chimenea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "event",
        "popular event",
        "christmas",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37023,
      "keyword": "chimenea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chimeneas": [
    {
      "id": 2333,
      "keyword": "chimenea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8072,
      "keyword": "chimenea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "event",
        "popular event",
        "christmas",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37023,
      "keyword": "chimenea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chándal": [
    {
      "id": 2332,
      "keyword": "chándal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing",
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2332,
      "keyword": "chándal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing",
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chándales": [
    {
      "id": 2332,
      "keyword": "chándal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing",
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2332,
      "keyword": "chándal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing",
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jogging": [
    {
      "id": 2332,
      "keyword": "jogging",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing",
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2332,
      "keyword": "jogging",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing",
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "joggings": [
    {
      "id": 2332,
      "keyword": "jogging",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing",
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2332,
      "keyword": "jogging",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing",
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cisne": [
    {
      "id": 2337,
      "keyword": "cisne",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "aquatic animal",
        "freshwater animal",
        "river",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cisnes": [
    {
      "id": 2337,
      "keyword": "cisne",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "aquatic animal",
        "freshwater animal",
        "river",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chorizo": [
    {
      "id": 2335,
      "keyword": "chorizo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4674,
      "keyword": "chorizo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chorizos": [
    {
      "id": 2335,
      "keyword": "chorizo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4674,
      "keyword": "chorizo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coca-cola": [
    {
      "id": 2338,
      "keyword": "Coca-Cola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coca-colas": [
    {
      "id": 2338,
      "keyword": "Coca-Cola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cinturón": [
    {
      "id": 38763,
      "keyword": "cinturón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing",
        "karate"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2336,
      "keyword": "cinturón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cinturones": [
    {
      "id": 38763,
      "keyword": "cinturón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing",
        "karate"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2336,
      "keyword": "cinturón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "correa": [
    {
      "id": 25996,
      "keyword": "correa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2336,
      "keyword": "correa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "correas": [
    {
      "id": 25996,
      "keyword": "correa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2336,
      "keyword": "correa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coche de juguete": [
    {
      "id": 2340,
      "keyword": "coche de juguete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coches de juguete": [
    {
      "id": 2340,
      "keyword": "coche de juguete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coche": [
    {
      "id": 6981,
      "keyword": "coche",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2339,
      "keyword": "coche",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2339,
      "keyword": "coche",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coches": [
    {
      "id": 6981,
      "keyword": "coche",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2339,
      "keyword": "coche",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2339,
      "keyword": "coche",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "automóvil": [
    {
      "id": 6981,
      "keyword": "automóvil",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2339,
      "keyword": "automóvil",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2339,
      "keyword": "automóvil",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "automóviles": [
    {
      "id": 6981,
      "keyword": "automóvil",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2339,
      "keyword": "automóvil",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2339,
      "keyword": "automóvil",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "auto": [
    {
      "id": 6981,
      "keyword": "auto",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2339,
      "keyword": "auto",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2339,
      "keyword": "auto",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autos": [
    {
      "id": 6981,
      "keyword": "auto",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2339,
      "keyword": "auto",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2339,
      "keyword": "auto",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carro": [
    {
      "id": 6981,
      "keyword": "carro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30618,
      "keyword": "carro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2339,
      "keyword": "carro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2339,
      "keyword": "carro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21506,
      "keyword": "carro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6077,
      "keyword": "carro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6962,
      "keyword": "carro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26732,
      "keyword": "carro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5948,
      "keyword": "carro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade",
        "feeding",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6281,
      "keyword": "carro",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carros": [
    {
      "id": 6981,
      "keyword": "carro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30618,
      "keyword": "carro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2339,
      "keyword": "carro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2339,
      "keyword": "carro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21506,
      "keyword": "carro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6077,
      "keyword": "carro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6962,
      "keyword": "carro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26732,
      "keyword": "carro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "feeding"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5948,
      "keyword": "carro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade",
        "feeding",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6281,
      "keyword": "carro",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cocina": [
    {
      "id": 10752,
      "keyword": "cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2341,
      "keyword": "cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10753,
      "keyword": "cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33070,
      "keyword": "cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cocinas": [
    {
      "id": 10752,
      "keyword": "cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2341,
      "keyword": "cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10753,
      "keyword": "cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33070,
      "keyword": "cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cocodrilo": [
    {
      "id": 2343,
      "keyword": "cocodrilo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "marine animal",
        "sea",
        "terrestrial animal",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34433,
      "keyword": "cocodrilo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cocodrilos": [
    {
      "id": 2343,
      "keyword": "cocodrilo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "marine animal",
        "sea",
        "terrestrial animal",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34433,
      "keyword": "cocodrilo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cd": [
    {
      "id": 2322,
      "keyword": "CD",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "core vocabulary",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15349,
      "keyword": "CD",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39044,
      "keyword": "CD",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cds": [
    {
      "id": 2322,
      "keyword": "CD",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "core vocabulary",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15349,
      "keyword": "CD",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device",
        "music"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39044,
      "keyword": "CD",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device",
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cucharón": [
    {
      "id": 2320,
      "keyword": "cucharón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2363,
      "keyword": "cucharón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cucharones": [
    {
      "id": 2320,
      "keyword": "cucharón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2363,
      "keyword": "cucharón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "celo": [
    {
      "id": 2325,
      "keyword": "celo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "celos": [
    {
      "id": 2325,
      "keyword": "celo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cohete": [
    {
      "id": 2344,
      "keyword": "cohete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2344,
      "keyword": "cohete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11221,
      "keyword": "cohete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cohetes": [
    {
      "id": 2344,
      "keyword": "cohete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2344,
      "keyword": "cohete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11221,
      "keyword": "cohete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cocinar": [
    {
      "id": 6984,
      "keyword": "cocinar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2342,
      "keyword": "cocinar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guisar": [
    {
      "id": 6984,
      "keyword": "guisar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2342,
      "keyword": "guisar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colchoneta": [
    {
      "id": 2346,
      "keyword": "colchoneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4607,
      "keyword": "colchoneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36630,
      "keyword": "colchoneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colchonetas": [
    {
      "id": 2346,
      "keyword": "colchoneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4607,
      "keyword": "colchoneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36630,
      "keyword": "colchoneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colador": [
    {
      "id": 2345,
      "keyword": "colador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coladores": [
    {
      "id": 2345,
      "keyword": "colador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "collar": [
    {
      "id": 2347,
      "keyword": "collar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6987,
      "keyword": "collar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6988,
      "keyword": "collar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "collares": [
    {
      "id": 2347,
      "keyword": "collar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6987,
      "keyword": "collar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6988,
      "keyword": "collar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conserje": [
    {
      "id": 37423,
      "keyword": "conserje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37823,
      "keyword": "conserje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2353,
      "keyword": "conserje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6995,
      "keyword": "conserje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32957,
      "keyword": "conserje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32956,
      "keyword": "conserje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conserjes": [
    {
      "id": 37423,
      "keyword": "conserje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37823,
      "keyword": "conserje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2353,
      "keyword": "conserje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6995,
      "keyword": "conserje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32957,
      "keyword": "conserje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32956,
      "keyword": "conserje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "portero": [
    {
      "id": 37823,
      "keyword": "portero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2353,
      "keyword": "portero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3431,
      "keyword": "portero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9015,
      "keyword": "portero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "person",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porteros": [
    {
      "id": 37823,
      "keyword": "portero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2353,
      "keyword": "portero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3431,
      "keyword": "portero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9015,
      "keyword": "portero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "person",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "confuso": [
    {
      "id": 35541,
      "keyword": "confuso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31855,
      "keyword": "confuso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2352,
      "keyword": "confuso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "confusos": [
    {
      "id": 35541,
      "keyword": "confuso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31855,
      "keyword": "confuso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2352,
      "keyword": "confuso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "confusa": [
    {
      "id": 35541,
      "keyword": "confusa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35521,
      "keyword": "confusa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2352,
      "keyword": "confusa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "confusas": [
    {
      "id": 35541,
      "keyword": "confusa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35521,
      "keyword": "confusa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2352,
      "keyword": "confusa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conejo": [
    {
      "id": 25624,
      "keyword": "conejo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26547,
      "keyword": "conejo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2351,
      "keyword": "conejo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "hunting",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conejos": [
    {
      "id": 25624,
      "keyword": "conejo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26547,
      "keyword": "conejo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2351,
      "keyword": "conejo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "hunting",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coneja": [
    {
      "id": 2351,
      "keyword": "coneja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "hunting",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conejas": [
    {
      "id": 2351,
      "keyword": "coneja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "hunting",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contenedor": [
    {
      "id": 2355,
      "keyword": "contenedor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5575,
      "keyword": "contenedor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6501,
      "keyword": "contenedor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15911,
      "keyword": "contenedor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36378,
      "keyword": "contenedor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38208,
      "keyword": "contenedor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38205,
      "keyword": "contenedor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contenedores": [
    {
      "id": 2355,
      "keyword": "contenedor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5575,
      "keyword": "contenedor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6501,
      "keyword": "contenedor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15911,
      "keyword": "contenedor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36378,
      "keyword": "contenedor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38208,
      "keyword": "contenedor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38205,
      "keyword": "contenedor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "consola": [
    {
      "id": 2354,
      "keyword": "consola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "consolas": [
    {
      "id": 2354,
      "keyword": "consola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cortinas": [
    {
      "id": 2357,
      "keyword": "cortinas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8344,
      "keyword": "cortina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37949,
      "keyword": "cortinas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "copa": [
    {
      "id": 2356,
      "keyword": "copa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3162,
      "keyword": "copa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38002,
      "keyword": "copa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "tree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "copas": [
    {
      "id": 2356,
      "keyword": "copa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3162,
      "keyword": "copa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38002,
      "keyword": "copa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "tree"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "croissant": [
    {
      "id": 2358,
      "keyword": "croissant",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "croissants": [
    {
      "id": 2358,
      "keyword": "croissant",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cruasán": [
    {
      "id": 2358,
      "keyword": "cruasán",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cruasanes": [
    {
      "id": 2358,
      "keyword": "cruasán",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "medialuna": [
    {
      "id": 2358,
      "keyword": "medialuna",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medialunas": [
    {
      "id": 2358,
      "keyword": "medialuna",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cubo y pala": [
    {
      "id": 2361,
      "keyword": "cubo y pala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2361,
      "keyword": "cubo y pala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubos y palas": [
    {
      "id": 2361,
      "keyword": "cubo y pala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2361,
      "keyword": "cubo y pala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuaderno": [
    {
      "id": 2359,
      "keyword": "cuaderno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuadernos": [
    {
      "id": 2359,
      "keyword": "cuaderno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuadro": [
    {
      "id": 2360,
      "keyword": "cuadro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "painting",
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuadros": [
    {
      "id": 2360,
      "keyword": "cuadro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "painting",
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuchara": [
    {
      "id": 2362,
      "keyword": "cuchara",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home",
        "feeding",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cucharas": [
    {
      "id": 2362,
      "keyword": "cuchara",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home",
        "feeding",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "delantal": [
    {
      "id": 2366,
      "keyword": "delantal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2366,
      "keyword": "delantal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "delantales": [
    {
      "id": 2366,
      "keyword": "delantal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2366,
      "keyword": "delantal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mandil": [
    {
      "id": 2366,
      "keyword": "mandil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2366,
      "keyword": "mandil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mandiles": [
    {
      "id": 2366,
      "keyword": "mandil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2366,
      "keyword": "mandil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolor": [
    {
      "id": 30620,
      "keyword": "dolor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "human body",
        "anatomy",
        "human anatomy",
        "animal",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2367,
      "keyword": "dolor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolores": [
    {
      "id": 30620,
      "keyword": "dolor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "human body",
        "anatomy",
        "human anatomy",
        "animal",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2367,
      "keyword": "dolor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuento": [
    {
      "id": 2364,
      "keyword": "cuento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature",
        "literacy genre",
        "library science",
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6469,
      "keyword": "cuento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6470,
      "keyword": "cuento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6471,
      "keyword": "cuento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8346,
      "keyword": "cuento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature",
        "literacy genre",
        "library science",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6472,
      "keyword": "cuento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "literature",
        "library science",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuentos": [
    {
      "id": 2364,
      "keyword": "cuento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature",
        "literacy genre",
        "library science",
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6469,
      "keyword": "cuento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6470,
      "keyword": "cuento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6471,
      "keyword": "cuento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8346,
      "keyword": "cuento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature",
        "literacy genre",
        "library science",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6472,
      "keyword": "cuento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "literature",
        "library science",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6472,
      "keyword": "cuentos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "literature",
        "library science",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dónut": [
    {
      "id": 2368,
      "keyword": "dónut",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36025,
      "keyword": "dónut",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36095,
      "keyword": "dónut",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "donuts": [
    {
      "id": 2368,
      "keyword": "dónut",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36025,
      "keyword": "dónut",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36095,
      "keyword": "dónut",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ducha": [
    {
      "id": 32426,
      "keyword": "ducha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38582,
      "keyword": "ducha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38587,
      "keyword": "ducha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38588,
      "keyword": "ducha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2370,
      "keyword": "ducha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11244,
      "keyword": "ducha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15904,
      "keyword": "ducha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15907,
      "keyword": "ducha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "duchas": [
    {
      "id": 32426,
      "keyword": "ducha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38582,
      "keyword": "ducha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38587,
      "keyword": "ducha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38588,
      "keyword": "ducha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2370,
      "keyword": "ducha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11244,
      "keyword": "ducha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15904,
      "keyword": "ducha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15907,
      "keyword": "ducha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pintar": [
    {
      "id": 6595,
      "keyword": "pintar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25415,
      "keyword": "pintar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2348,
      "keyword": "pintar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5574,
      "keyword": "pintar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7207,
      "keyword": "pintar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "work",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colorear": [
    {
      "id": 2348,
      "keyword": "colorear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comer": [
    {
      "id": 6456,
      "keyword": "comer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "person",
        "basic needs",
        "core vocabulary",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6990,
      "keyword": "comer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38057,
      "keyword": "comer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4609,
      "keyword": "comer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28669,
      "keyword": "comer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2349,
      "keyword": "comer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28641,
      "keyword": "comer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cometa": [
    {
      "id": 2711,
      "keyword": "cometa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2350,
      "keyword": "cometa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cometas": [
    {
      "id": 2711,
      "keyword": "cometa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2350,
      "keyword": "cometa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barrilete": [
    {
      "id": 2350,
      "keyword": "barrilete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barriletes": [
    {
      "id": 2350,
      "keyword": "barrilete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "duchar": [
    {
      "id": 26803,
      "keyword": "duchar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2371,
      "keyword": "duchar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27728,
      "keyword": "duchar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32162,
      "keyword": "duchar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dormir": [
    {
      "id": 6479,
      "keyword": "dormir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "basic needs",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2369,
      "keyword": "dormir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28623,
      "keyword": "dormir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enchufe": [
    {
      "id": 2373,
      "keyword": "enchufe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32888,
      "keyword": "enchufe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enchufes": [
    {
      "id": 2373,
      "keyword": "enchufe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32888,
      "keyword": "enchufe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enfadado": [
    {
      "id": 35539,
      "keyword": "enfadado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38936,
      "keyword": "enfadado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31884,
      "keyword": "enfadado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2374,
      "keyword": "enfadado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21820,
      "keyword": "enfadado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfadados": [
    {
      "id": 35539,
      "keyword": "enfadado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38936,
      "keyword": "enfadado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31884,
      "keyword": "enfadado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2374,
      "keyword": "enfadado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21820,
      "keyword": "enfadado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enfadada": [
    {
      "id": 35539,
      "keyword": "enfadada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38936,
      "keyword": "enfadada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28671,
      "keyword": "enfadada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31101,
      "keyword": "enfadada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2374,
      "keyword": "enfadada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21820,
      "keyword": "enfadada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfadadas": [
    {
      "id": 35539,
      "keyword": "enfadada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38936,
      "keyword": "enfadada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28671,
      "keyword": "enfadada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31101,
      "keyword": "enfadada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2374,
      "keyword": "enfadada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21820,
      "keyword": "enfadada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "elefante": [
    {
      "id": 2372,
      "keyword": "elefante",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "elefantes": [
    {
      "id": 2372,
      "keyword": "elefante",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "elefanta": [
    {
      "id": 2372,
      "keyword": "elefanta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "elefantas": [
    {
      "id": 2372,
      "keyword": "elefanta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escribir": [
    {
      "id": 2380,
      "keyword": "escribir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "education",
        "educational task",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8107,
      "keyword": "escribir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21851,
      "keyword": "escribir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escritura": [
    {
      "id": 2380,
      "keyword": "escritura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "education",
        "educational task",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8107,
      "keyword": "escritura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escrituras": [
    {
      "id": 2380,
      "keyword": "escritura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "education",
        "educational task",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8107,
      "keyword": "escritura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escalera": [
    {
      "id": 27491,
      "keyword": "escalera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "architecture",
        "architectural element",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2379,
      "keyword": "escalera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2379,
      "keyword": "escalera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2743,
      "keyword": "escalera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35489,
      "keyword": "escalera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37931,
      "keyword": "escalera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escaleras": [
    {
      "id": 27491,
      "keyword": "escalera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "architecture",
        "architectural element",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2379,
      "keyword": "escalera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2379,
      "keyword": "escalera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2743,
      "keyword": "escalera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35489,
      "keyword": "escalera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37931,
      "keyword": "escalera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escalones": [
    {
      "id": 27491,
      "keyword": "escalones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "architecture",
        "architectural element",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2379,
      "keyword": "escalones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2379,
      "keyword": "escalones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oir": [
    {
      "id": 6572,
      "keyword": "oir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29720,
      "keyword": "oir",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "event",
        "popular event",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37486,
      "keyword": "oir",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "mass media",
        "object",
        "appliance",
        "mass media device",
        "computing",
        "hardware",
        "music device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2381,
      "keyword": "oir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28659,
      "keyword": "oir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escuchar": [
    {
      "id": 6572,
      "keyword": "escuchar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39157,
      "keyword": "escuchar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "culture",
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29720,
      "keyword": "escuchar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "event",
        "popular event",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37486,
      "keyword": "escuchar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "mass media",
        "object",
        "appliance",
        "mass media device",
        "computing",
        "hardware",
        "music device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2381,
      "keyword": "escuchar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28659,
      "keyword": "escuchar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escurridor": [
    {
      "id": 2382,
      "keyword": "escurridor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37061,
      "keyword": "escurridor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escurridores": [
    {
      "id": 2382,
      "keyword": "escurridor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37061,
      "keyword": "escurridor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espaguetis": [
    {
      "id": 2383,
      "keyword": "espaguetis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25580,
      "keyword": "espaguetis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29012,
      "keyword": "espaguetis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espárragos": [
    {
      "id": 2384,
      "keyword": "espárragos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8347,
      "keyword": "espárrago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "equipo de música": [
    {
      "id": 2378,
      "keyword": "equipo de música",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "music device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equipos de música": [
    {
      "id": 2378,
      "keyword": "equipo de música",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "music device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espejo": [
    {
      "id": 37922,
      "keyword": "espejo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8573,
      "keyword": "espejo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2385,
      "keyword": "espejo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35221,
      "keyword": "espejo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espejos": [
    {
      "id": 37922,
      "keyword": "espejo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8573,
      "keyword": "espejo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2385,
      "keyword": "espejo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35221,
      "keyword": "espejo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estantería": [
    {
      "id": 2386,
      "keyword": "estantería",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2386,
      "keyword": "estantería",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "estanterías": [
    {
      "id": 2386,
      "keyword": "estantería",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2386,
      "keyword": "estantería",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "excavadora": [
    {
      "id": 2390,
      "keyword": "excavadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "excavadoras": [
    {
      "id": 2390,
      "keyword": "excavadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estufa": [
    {
      "id": 2389,
      "keyword": "estufa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estufas": [
    {
      "id": 2389,
      "keyword": "estufa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "falda": [
    {
      "id": 2391,
      "keyword": "falda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2391,
      "keyword": "falda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "faldas": [
    {
      "id": 2391,
      "keyword": "falda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2391,
      "keyword": "falda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pollera": [
    {
      "id": 2391,
      "keyword": "pollera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2391,
      "keyword": "pollera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11347,
      "keyword": "pollera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "polleras": [
    {
      "id": 2391,
      "keyword": "pollera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2391,
      "keyword": "pollera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11347,
      "keyword": "pollera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "farola": [
    {
      "id": 2393,
      "keyword": "farola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3314,
      "keyword": "farola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "farolas": [
    {
      "id": 2393,
      "keyword": "farola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3314,
      "keyword": "farola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "familia": [
    {
      "id": 38351,
      "keyword": "familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2392,
      "keyword": "familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2392,
      "keyword": "familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24515,
      "keyword": "familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24523,
      "keyword": "familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24525,
      "keyword": "familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30245,
      "keyword": "familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36920,
      "keyword": "familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38600,
      "keyword": "familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38601,
      "keyword": "familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11728,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11729,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11731,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11733,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11735,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31466,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31467,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37346,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37352,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37353,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37354,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "familias": [
    {
      "id": 2392,
      "keyword": "familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2392,
      "keyword": "familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24515,
      "keyword": "familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24523,
      "keyword": "familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24525,
      "keyword": "familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30245,
      "keyword": "familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36920,
      "keyword": "familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38600,
      "keyword": "familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38601,
      "keyword": "familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11728,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11729,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11731,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11733,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11735,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31466,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31467,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37346,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37352,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37353,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37354,
      "keyword": "familia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estudiar": [
    {
      "id": 6495,
      "keyword": "estudiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "education",
        "educational task",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2387,
      "keyword": "estudiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35979,
      "keyword": "estudiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "figuritas": [
    {
      "id": 2394,
      "keyword": "figuritas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ensalada": [
    {
      "id": 2377,
      "keyword": "ensalada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ensaladas": [
    {
      "id": 2377,
      "keyword": "ensalada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "folios": [
    {
      "id": 8349,
      "keyword": "folio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2398,
      "keyword": "folios",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papeles": [
    {
      "id": 8349,
      "keyword": "papel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2398,
      "keyword": "papeles",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfermera": [
    {
      "id": 6050,
      "keyword": "enfermera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38883,
      "keyword": "enfermera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35301,
      "keyword": "enfermera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35307,
      "keyword": "enfermera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2375,
      "keyword": "enfermera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31390,
      "keyword": "enfermera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfermeras": [
    {
      "id": 6050,
      "keyword": "enfermera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38883,
      "keyword": "enfermera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35301,
      "keyword": "enfermera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35307,
      "keyword": "enfermera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2375,
      "keyword": "enfermera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31390,
      "keyword": "enfermera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ats": [
    {
      "id": 6050,
      "keyword": "ATS",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2375,
      "keyword": "ATS",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9196,
      "keyword": "ATS",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31390,
      "keyword": "ATS",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "champiñones": [
    {
      "id": 2331,
      "keyword": "champiñones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "fungus"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10220,
      "keyword": "champiñón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "fungus",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enfermar": [
    {
      "id": 7040,
      "keyword": "enfermar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "disease",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30622,
      "keyword": "enfermar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2376,
      "keyword": "enfermar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flauta": [
    {
      "id": 2396,
      "keyword": "flauta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flautas": [
    {
      "id": 2396,
      "keyword": "flauta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fregadero": [
    {
      "id": 2399,
      "keyword": "fregadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "feeding",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fregaderos": [
    {
      "id": 2399,
      "keyword": "fregadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "feeding",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fresa": [
    {
      "id": 2400,
      "keyword": "fresa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fresas": [
    {
      "id": 2400,
      "keyword": "fresa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37495,
      "keyword": "fresas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frutilla": [
    {
      "id": 2400,
      "keyword": "frutilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frutillas": [
    {
      "id": 2400,
      "keyword": "frutilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "friolero": [
    {
      "id": 35577,
      "keyword": "friolero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31886,
      "keyword": "friolero",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2401,
      "keyword": "friolero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frioleros": [
    {
      "id": 35577,
      "keyword": "friolero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31886,
      "keyword": "friolero",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2401,
      "keyword": "friolero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "friolera": [
    {
      "id": 35577,
      "keyword": "friolera",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28653,
      "keyword": "friolera",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2401,
      "keyword": "friolera",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frioleras": [
    {
      "id": 35577,
      "keyword": "friolera",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28653,
      "keyword": "friolera",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2401,
      "keyword": "friolera",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "galletas": [
    {
      "id": 2402,
      "keyword": "galletas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2402,
      "keyword": "galletas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8312,
      "keyword": "galleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6525,
      "keyword": "galletas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6525,
      "keyword": "galletas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25568,
      "keyword": "galletas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25568,
      "keyword": "galletas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gallo": [
    {
      "id": 25125,
      "keyword": "gallo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25664,
      "keyword": "gallo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2404,
      "keyword": "gallo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21884,
      "keyword": "gallo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gallos": [
    {
      "id": 25125,
      "keyword": "gallo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25664,
      "keyword": "gallo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2404,
      "keyword": "gallo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21884,
      "keyword": "gallo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "globo": [
    {
      "id": 2408,
      "keyword": "globo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2408,
      "keyword": "globo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2407,
      "keyword": "globo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8313,
      "keyword": "globo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "globos": [
    {
      "id": 2408,
      "keyword": "globo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2408,
      "keyword": "globo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2407,
      "keyword": "globo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8313,
      "keyword": "globo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "goma": [
    {
      "id": 2409,
      "keyword": "goma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gomas": [
    {
      "id": 2409,
      "keyword": "goma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "borrador": [
    {
      "id": 16341,
      "keyword": "borrador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2409,
      "keyword": "borrador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "borradores": [
    {
      "id": 16341,
      "keyword": "borrador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2409,
      "keyword": "borrador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gorra": [
    {
      "id": 2411,
      "keyword": "gorra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21910,
      "keyword": "gorra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gorras": [
    {
      "id": 2411,
      "keyword": "gorra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21910,
      "keyword": "gorra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gorila": [
    {
      "id": 2410,
      "keyword": "gorila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gorilas": [
    {
      "id": 2410,
      "keyword": "gorila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gorro": [
    {
      "id": 2412,
      "keyword": "gorro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2412,
      "keyword": "gorro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39395,
      "keyword": "gorro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 39395,
      "keyword": "gorro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gorros": [
    {
      "id": 2412,
      "keyword": "gorro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2412,
      "keyword": "gorro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39395,
      "keyword": "gorro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 39395,
      "keyword": "gorro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grapadora": [
    {
      "id": 2413,
      "keyword": "grapadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grapadoras": [
    {
      "id": 2413,
      "keyword": "grapadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abrochadora": [
    {
      "id": 2413,
      "keyword": "abrochadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrochadoras": [
    {
      "id": 2413,
      "keyword": "abrochadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "garbanzos": [
    {
      "id": 2405,
      "keyword": "garbanzos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8351,
      "keyword": "garbanzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38594,
      "keyword": "garbanzos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cocido": [
    {
      "id": 2405,
      "keyword": "cocido",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15359,
      "keyword": "cocido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cocidos": [
    {
      "id": 2405,
      "keyword": "cocido",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15359,
      "keyword": "cocido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guitarra": [
    {
      "id": 2417,
      "keyword": "guitarra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument",
        "event",
        "popular event",
        "fiestas del pilar",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guitarras": [
    {
      "id": 2417,
      "keyword": "guitarra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument",
        "event",
        "popular event",
        "fiestas del pilar",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gustar": [
    {
      "id": 7124,
      "keyword": "gustar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "feeding",
        "food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37721,
      "keyword": "gustar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "core vocabulary",
        "object",
        "place",
        "leisure",
        "sport",
        "event",
        "movement",
        "traffic",
        "mode of transport",
        "usual verbs",
        "education",
        "toy",
        "traditional game",
        "game",
        "show",
        "work",
        "outdoor activity",
        "facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37826,
      "keyword": "gustar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression",
        "core vocabulary",
        "leisure",
        "sport",
        "traditional game",
        "game",
        "show",
        "work",
        "education",
        "teaching activity",
        "outdoor activity",
        "object",
        "place",
        "event",
        "movement",
        "traffic",
        "mode of transport",
        "usual verbs",
        "toy",
        "facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32816,
      "keyword": "gustar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2418,
      "keyword": "gustar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31861,
      "keyword": "gustar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37758,
      "keyword": "gustar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21917,
      "keyword": "gustar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38889,
      "keyword": "gustar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38891,
      "keyword": "gustar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hamburguesa": [
    {
      "id": 2419,
      "keyword": "hamburguesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "core vocabulary",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26122,
      "keyword": "hamburguesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hamburguesas": [
    {
      "id": 2419,
      "keyword": "hamburguesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "core vocabulary",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26122,
      "keyword": "hamburguesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guantes": [
    {
      "id": 2415,
      "keyword": "guantes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7122,
      "keyword": "guantes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7123,
      "keyword": "guantes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8353,
      "keyword": "guante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cucurucho de helado": [
    {
      "id": 2420,
      "keyword": "cucurucho de helado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "core vocabulary",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cucuruchos de helado": [
    {
      "id": 2420,
      "keyword": "cucurucho de helado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "core vocabulary",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "helicóptero": [
    {
      "id": 7126,
      "keyword": "helicóptero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 7126,
      "keyword": "helicóptero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2421,
      "keyword": "helicóptero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "helicópteros": [
    {
      "id": 7126,
      "keyword": "helicóptero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 7126,
      "keyword": "helicóptero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2421,
      "keyword": "helicóptero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hermana": [
    {
      "id": 2422,
      "keyword": "hermana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2422,
      "keyword": "hermana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37966,
      "keyword": "hermana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hermanas": [
    {
      "id": 2422,
      "keyword": "hermana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2422,
      "keyword": "hermana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37966,
      "keyword": "hermana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hipopótamo": [
    {
      "id": 2424,
      "keyword": "hipopótamo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hipopótamos": [
    {
      "id": 2424,
      "keyword": "hipopótamo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hipopótama": [
    {
      "id": 2424,
      "keyword": "hipopótama",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hipopótamas": [
    {
      "id": 2424,
      "keyword": "hipopótama",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grifo": [
    {
      "id": 38766,
      "keyword": "grifo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2414,
      "keyword": "grifo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32650,
      "keyword": "grifo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3339,
      "keyword": "grifo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grifos": [
    {
      "id": 38766,
      "keyword": "grifo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2414,
      "keyword": "grifo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32650,
      "keyword": "grifo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3339,
      "keyword": "grifo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "canilla": [
    {
      "id": 2414,
      "keyword": "canilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32650,
      "keyword": "canilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3339,
      "keyword": "canilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canillas": [
    {
      "id": 2414,
      "keyword": "canilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32650,
      "keyword": "canilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3339,
      "keyword": "canilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fisioterapeuta": [
    {
      "id": 26094,
      "keyword": "fisioterapeuta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34292,
      "keyword": "fisioterapeuta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2395,
      "keyword": "fisioterapeuta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31943,
      "keyword": "fisioterapeuta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fisioterapeutas": [
    {
      "id": 26094,
      "keyword": "fisioterapeuta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34292,
      "keyword": "fisioterapeuta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2395,
      "keyword": "fisioterapeuta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31943,
      "keyword": "fisioterapeuta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gallina": [
    {
      "id": 2403,
      "keyword": "gallina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gallinas": [
    {
      "id": 2403,
      "keyword": "gallina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "foca": [
    {
      "id": 2397,
      "keyword": "foca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "focas": [
    {
      "id": 2397,
      "keyword": "foca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "horno": [
    {
      "id": 2426,
      "keyword": "horno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10135,
      "keyword": "horno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hornos": [
    {
      "id": 2426,
      "keyword": "horno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10135,
      "keyword": "horno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hormiga": [
    {
      "id": 2425,
      "keyword": "hormiga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hormigas": [
    {
      "id": 2425,
      "keyword": "hormiga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "infusión": [
    {
      "id": 2429,
      "keyword": "infusión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "infusiones": [
    {
      "id": 2429,
      "keyword": "infusión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huevo frito": [
    {
      "id": 2428,
      "keyword": "huevo frito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huevos fritos": [
    {
      "id": 2428,
      "keyword": "huevo frito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29548,
      "keyword": "huevos fritos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hermano": [
    {
      "id": 2423,
      "keyword": "hermano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37967,
      "keyword": "hermano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hermanos": [
    {
      "id": 2423,
      "keyword": "hermano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34510,
      "keyword": "hermanos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34511,
      "keyword": "hermanos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37967,
      "keyword": "hermano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jardín": [
    {
      "id": 30608,
      "keyword": "jardín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30609,
      "keyword": "jardín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2434,
      "keyword": "jardín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37986,
      "keyword": "jardín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jardines": [
    {
      "id": 30608,
      "keyword": "jardín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30609,
      "keyword": "jardín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2434,
      "keyword": "jardín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37986,
      "keyword": "jardín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ir": [
    {
      "id": 8142,
      "keyword": "ir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2432,
      "keyword": "ir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31758,
      "keyword": "ir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35093,
      "keyword": "ir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jamón": [
    {
      "id": 2433,
      "keyword": "jamón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2963,
      "keyword": "jamón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jamones": [
    {
      "id": 2433,
      "keyword": "jamón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2963,
      "keyword": "jamón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jamón serrano": [
    {
      "id": 2433,
      "keyword": "jamón serrano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jarra": [
    {
      "id": 2435,
      "keyword": "jarra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "food",
        "beverage",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jarras": [
    {
      "id": 2435,
      "keyword": "jarra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "food",
        "beverage",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jirafa": [
    {
      "id": 2437,
      "keyword": "jirafa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jirafas": [
    {
      "id": 2437,
      "keyword": "jirafa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jersey": [
    {
      "id": 2436,
      "keyword": "jersey",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2436,
      "keyword": "jersey",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39029,
      "keyword": "jersey",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jerséis": [
    {
      "id": 2436,
      "keyword": "jersey",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2436,
      "keyword": "jersey",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39029,
      "keyword": "jersey",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "suéter": [
    {
      "id": 2436,
      "keyword": "suéter",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2436,
      "keyword": "suéter",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39029,
      "keyword": "suéter",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suéteres": [
    {
      "id": 2436,
      "keyword": "suéter",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2436,
      "keyword": "suéter",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39029,
      "keyword": "suéter",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pulover": [
    {
      "id": 2436,
      "keyword": "pulover",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2436,
      "keyword": "pulover",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39029,
      "keyword": "pulover",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puloveres": [
    {
      "id": 2436,
      "keyword": "pulover",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2436,
      "keyword": "pulover",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39029,
      "keyword": "pulover",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pulóver": [
    {
      "id": 2436,
      "keyword": "pulóver",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2436,
      "keyword": "pulóver",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39029,
      "keyword": "pulóver",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulóveres": [
    {
      "id": 2436,
      "keyword": "pulóver",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2436,
      "keyword": "pulóver",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39029,
      "keyword": "pulóver",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gato": [
    {
      "id": 7114,
      "keyword": "gato",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3333,
      "keyword": "gato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2406,
      "keyword": "gato",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9881,
      "keyword": "gato",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "halloween",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9879,
      "keyword": "gato",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gatos": [
    {
      "id": 7114,
      "keyword": "gato",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3333,
      "keyword": "gato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry",
        "object"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2406,
      "keyword": "gato",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9881,
      "keyword": "gato",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "halloween",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9879,
      "keyword": "gato",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "minino": [
    {
      "id": 7114,
      "keyword": "minino",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2406,
      "keyword": "minino",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mininos": [
    {
      "id": 7114,
      "keyword": "minino",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2406,
      "keyword": "minino",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gata": [
    {
      "id": 7114,
      "keyword": "gata",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2406,
      "keyword": "gata",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9881,
      "keyword": "gata",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "halloween",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9879,
      "keyword": "gata",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gatas": [
    {
      "id": 7114,
      "keyword": "gata",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2406,
      "keyword": "gata",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9881,
      "keyword": "gata",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "halloween",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9879,
      "keyword": "gata",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "minina": [
    {
      "id": 7114,
      "keyword": "minina",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2406,
      "keyword": "minina",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mininas": [
    {
      "id": 7114,
      "keyword": "minina",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2406,
      "keyword": "minina",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugar": [
    {
      "id": 6537,
      "keyword": "jugar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23392,
      "keyword": "jugar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "usual verbs",
        "core vocabulary",
        "game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35723,
      "keyword": "jugar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37068,
      "keyword": "jugar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37952,
      "keyword": "jugar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2439,
      "keyword": "jugar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35717,
      "keyword": "jugar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36884,
      "keyword": "jugar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36885,
      "keyword": "jugar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "judías verdes": [
    {
      "id": 2438,
      "keyword": "judías verdes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8354,
      "keyword": "judía verde",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "poroto": [
    {
      "id": 2438,
      "keyword": "poroto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3294,
      "keyword": "poroto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8354,
      "keyword": "poroto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8354,
      "keyword": "poroto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8337,
      "keyword": "poroto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porotos": [
    {
      "id": 2438,
      "keyword": "poroto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3294,
      "keyword": "poroto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8337,
      "keyword": "poroto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lavabo": [
    {
      "id": 2441,
      "keyword": "lavabo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15919,
      "keyword": "lavabo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavabos": [
    {
      "id": 2441,
      "keyword": "lavabo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15919,
      "keyword": "lavabo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lavatorio": [
    {
      "id": 2441,
      "keyword": "lavatorio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15919,
      "keyword": "lavatorio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavatorios": [
    {
      "id": 2441,
      "keyword": "lavatorio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15919,
      "keyword": "lavatorio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lápiz": [
    {
      "id": 2440,
      "keyword": "lápiz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2440,
      "keyword": "lápiz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lápices": [
    {
      "id": 2440,
      "keyword": "lápiz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2440,
      "keyword": "lápiz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lapicero": [
    {
      "id": 2440,
      "keyword": "lapicero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2440,
      "keyword": "lapicero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lapiceros": [
    {
      "id": 2440,
      "keyword": "lapicero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2440,
      "keyword": "lapicero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "interruptor": [
    {
      "id": 2431,
      "keyword": "interruptor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "interruptores": [
    {
      "id": 2431,
      "keyword": "interruptor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "váter": [
    {
      "id": 15927,
      "keyword": "váter",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2430,
      "keyword": "váter",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38603,
      "keyword": "váter",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "váteres": [
    {
      "id": 15927,
      "keyword": "váter",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2430,
      "keyword": "váter",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38603,
      "keyword": "váter",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inodoro": [
    {
      "id": 2430,
      "keyword": "inodoro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38603,
      "keyword": "inodoro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inodoros": [
    {
      "id": 2430,
      "keyword": "inodoro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38603,
      "keyword": "inodoro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "water": [
    {
      "id": 2430,
      "keyword": "water",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38603,
      "keyword": "water",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "wateres": [
    {
      "id": 2430,
      "keyword": "water",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38603,
      "keyword": "water",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "retrete": [
    {
      "id": 27475,
      "keyword": "retrete",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37331,
      "keyword": "retrete",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37904,
      "keyword": "retrete",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2430,
      "keyword": "retrete",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38603,
      "keyword": "retrete",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "retretes": [
    {
      "id": 27475,
      "keyword": "retrete",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37331,
      "keyword": "retrete",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37904,
      "keyword": "retrete",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2430,
      "keyword": "retrete",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38603,
      "keyword": "retrete",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lavadora": [
    {
      "id": 2442,
      "keyword": "lavadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavadoras": [
    {
      "id": 2442,
      "keyword": "lavadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lavarropas": [
    {
      "id": 2442,
      "keyword": "lavarropas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2442,
      "keyword": "lavarropas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enjabonar las manos": [
    {
      "id": 30506,
      "keyword": "enjabonar las manos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29210,
      "keyword": "enjabonar las manos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2443,
      "keyword": "enjabonar las manos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35977,
      "keyword": "enjabonar las manos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavado de manos": [
    {
      "id": 8977,
      "keyword": "lavado de manos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2443,
      "keyword": "lavado de manos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8975,
      "keyword": "lavado de manos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35729,
      "keyword": "lavado de manos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35977,
      "keyword": "lavado de manos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36525,
      "keyword": "lavado de manos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37409,
      "keyword": "lavado de manos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37049,
      "keyword": "lavado de manos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36860,
      "keyword": "lavado de manos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36918,
      "keyword": "lavado de manos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37030,
      "keyword": "lavado de manos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37031,
      "keyword": "lavado de manos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37032,
      "keyword": "lavado de manos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37033,
      "keyword": "lavado de manos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leche": [
    {
      "id": 2445,
      "keyword": "leche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "animal-based food",
        "dairy product",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leches": [
    {
      "id": 2445,
      "keyword": "leche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "animal-based food",
        "dairy product",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "libro": [
    {
      "id": 25191,
      "keyword": "libro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "library science",
        "literature",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2450,
      "keyword": "libro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "library science",
        "literature"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6641,
      "keyword": "libro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "libros": [
    {
      "id": 25191,
      "keyword": "libro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "library science",
        "literature",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2450,
      "keyword": "libro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "library science",
        "literature"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6641,
      "keyword": "libros",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavavajillas": [
    {
      "id": 2444,
      "keyword": "lavavajillas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7143,
      "keyword": "lavavajillas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "household",
        "crockery",
        "home",
        "cutlery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16311,
      "keyword": "lavavajillas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30936,
      "keyword": "lavavajillas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llaves": [
    {
      "id": 8153,
      "keyword": "llave",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "object"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2451,
      "keyword": "llaves",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21943,
      "keyword": "llave",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "logopeda": [
    {
      "id": 23396,
      "keyword": "logopeda",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37355,
      "keyword": "logopeda",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2454,
      "keyword": "logopeda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6141,
      "keyword": "logopeda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32911,
      "keyword": "logopeda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32910,
      "keyword": "logopeda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "logopedas": [
    {
      "id": 23396,
      "keyword": "logopeda",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37355,
      "keyword": "logopeda",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2454,
      "keyword": "logopeda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6141,
      "keyword": "logopeda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32911,
      "keyword": "logopeda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32910,
      "keyword": "logopeda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fonoaudióloga": [
    {
      "id": 23396,
      "keyword": "fonoaudióloga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37355,
      "keyword": "fonoaudióloga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2454,
      "keyword": "fonoaudióloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2454,
      "keyword": "fonoaudióloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32911,
      "keyword": "fonoaudióloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maestra": [
    {
      "id": 6556,
      "keyword": "maestra",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6555,
      "keyword": "maestra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2456,
      "keyword": "maestra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28003,
      "keyword": "maestra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maestras": [
    {
      "id": 6556,
      "keyword": "maestra",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6555,
      "keyword": "maestra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2456,
      "keyword": "maestra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28003,
      "keyword": "maestra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "profesora": [
    {
      "id": 6556,
      "keyword": "profesora",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6555,
      "keyword": "profesora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2456,
      "keyword": "profesora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28003,
      "keyword": "profesora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "profesoras": [
    {
      "id": 6556,
      "keyword": "profesora",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6555,
      "keyword": "profesora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2456,
      "keyword": "profesora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28003,
      "keyword": "profesora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lechuga": [
    {
      "id": 2446,
      "keyword": "lechuga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lechugas": [
    {
      "id": 2446,
      "keyword": "lechuga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "macarrones": [
    {
      "id": 2455,
      "keyword": "macarrones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8357,
      "keyword": "macarrón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25572,
      "keyword": "macarrones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manta": [
    {
      "id": 2459,
      "keyword": "manta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2459,
      "keyword": "manta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6146,
      "keyword": "manta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "ovoviviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mantas": [
    {
      "id": 2459,
      "keyword": "manta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2459,
      "keyword": "manta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6146,
      "keyword": "manta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "ovoviviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frazada": [
    {
      "id": 2459,
      "keyword": "frazada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2459,
      "keyword": "frazada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frazadas": [
    {
      "id": 2459,
      "keyword": "frazada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2459,
      "keyword": "frazada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mamá": [
    {
      "id": 2458,
      "keyword": "mamá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2458,
      "keyword": "mamá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mamás": [
    {
      "id": 2458,
      "keyword": "mamá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2458,
      "keyword": "mamá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maestro": [
    {
      "id": 6556,
      "keyword": "maestro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2457,
      "keyword": "maestro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28002,
      "keyword": "maestro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maestros": [
    {
      "id": 6556,
      "keyword": "maestro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2457,
      "keyword": "maestro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28002,
      "keyword": "maestro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "profesor": [
    {
      "id": 6556,
      "keyword": "profesor",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2457,
      "keyword": "profesor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7796,
      "keyword": "profesor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28002,
      "keyword": "profesor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "profesores": [
    {
      "id": 6556,
      "keyword": "profesor",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2457,
      "keyword": "profesor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7796,
      "keyword": "profesor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28002,
      "keyword": "profesor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mantel": [
    {
      "id": 2460,
      "keyword": "mantel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manteles": [
    {
      "id": 2460,
      "keyword": "mantel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mantequilla": [
    {
      "id": 2461,
      "keyword": "mantequilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mantequillas": [
    {
      "id": 2461,
      "keyword": "mantequilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manteca": [
    {
      "id": 2461,
      "keyword": "manteca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mantecas": [
    {
      "id": 2461,
      "keyword": "manteca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huevo": [
    {
      "id": 2427,
      "keyword": "huevo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38868,
      "keyword": "huevo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product",
        "animal",
        "animal reproduction",
        "oviparous"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huevos": [
    {
      "id": 2427,
      "keyword": "huevo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34039,
      "keyword": "huevos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38868,
      "keyword": "huevo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product",
        "animal",
        "animal reproduction",
        "oviparous"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manzana": [
    {
      "id": 2462,
      "keyword": "manzana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2462,
      "keyword": "manzana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13645,
      "keyword": "manzana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13644,
      "keyword": "manzana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manzanas": [
    {
      "id": 2462,
      "keyword": "manzana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2462,
      "keyword": "manzana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 13645,
      "keyword": "manzana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 13644,
      "keyword": "manzana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mareado": [
    {
      "id": 35543,
      "keyword": "mareado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31795,
      "keyword": "mareado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2464,
      "keyword": "mareado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mareados": [
    {
      "id": 35543,
      "keyword": "mareado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31795,
      "keyword": "mareado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2464,
      "keyword": "mareado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mareada": [
    {
      "id": 35543,
      "keyword": "mareada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30924,
      "keyword": "mareada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2464,
      "keyword": "mareada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mareadas": [
    {
      "id": 35543,
      "keyword": "mareada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30924,
      "keyword": "mareada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2464,
      "keyword": "mareada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "medias": [
    {
      "id": 2466,
      "keyword": "medias",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2466,
      "keyword": "medias",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8358,
      "keyword": "media",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mariposa": [
    {
      "id": 26200,
      "keyword": "mariposa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 26200,
      "keyword": "mariposa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8158,
      "keyword": "mariposa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2465,
      "keyword": "mariposa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mariposas": [
    {
      "id": 26200,
      "keyword": "mariposa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 26200,
      "keyword": "mariposa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8158,
      "keyword": "mariposa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2465,
      "keyword": "mariposa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "médico": [
    {
      "id": 6561,
      "keyword": "médico",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6561,
      "keyword": "médico",
      "keywords": 5,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38446,
      "keyword": "médico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38857,
      "keyword": "médico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2467,
      "keyword": "médico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "médicos": [
    {
      "id": 6561,
      "keyword": "médico",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6561,
      "keyword": "médico",
      "keywords": 5,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38446,
      "keyword": "médico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38857,
      "keyword": "médico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2467,
      "keyword": "médico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "doctor": [
    {
      "id": 6561,
      "keyword": "doctor",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38446,
      "keyword": "doctor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38857,
      "keyword": "doctor",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2467,
      "keyword": "doctor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "doctores": [
    {
      "id": 6561,
      "keyword": "doctor",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38446,
      "keyword": "doctor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38857,
      "keyword": "doctor",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2467,
      "keyword": "doctor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maracas": [
    {
      "id": 2463,
      "keyword": "maracas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2463,
      "keyword": "maracas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8315,
      "keyword": "maraca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "melocotón": [
    {
      "id": 2468,
      "keyword": "melocotón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "melocotones": [
    {
      "id": 2468,
      "keyword": "melocotón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "durazno": [
    {
      "id": 2468,
      "keyword": "durazno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "duraznos": [
    {
      "id": 2468,
      "keyword": "durazno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "melón": [
    {
      "id": 2469,
      "keyword": "melón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36153,
      "keyword": "melón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "melones": [
    {
      "id": 2469,
      "keyword": "melón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36153,
      "keyword": "melón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mermelada": [
    {
      "id": 2470,
      "keyword": "mermelada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mermeladas": [
    {
      "id": 2470,
      "keyword": "mermelada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lectura": [
    {
      "id": 2447,
      "keyword": "lectura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lecturas": [
    {
      "id": 2447,
      "keyword": "lectura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "león": [
    {
      "id": 25187,
      "keyword": "león",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2449,
      "keyword": "león",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14772,
      "keyword": "León",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leones": [
    {
      "id": 25187,
      "keyword": "león",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2449,
      "keyword": "león",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lentejas": [
    {
      "id": 2448,
      "keyword": "lentejas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38593,
      "keyword": "lentejas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesa de ping pong": [
    {
      "id": 2471,
      "keyword": "mesa de ping pong",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas de ping pong": [
    {
      "id": 2471,
      "keyword": "mesa de ping pong",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "metro": [
    {
      "id": 26925,
      "keyword": "metro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29074,
      "keyword": "metro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2913,
      "keyword": "metro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2914,
      "keyword": "metro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2472,
      "keyword": "metro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "metros": [
    {
      "id": 26925,
      "keyword": "metro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29074,
      "keyword": "metro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2913,
      "keyword": "metro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2914,
      "keyword": "metro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2472,
      "keyword": "metro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "subte": [
    {
      "id": 26925,
      "keyword": "subte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2472,
      "keyword": "subte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subtes": [
    {
      "id": 26925,
      "keyword": "subte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2472,
      "keyword": "subte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mosca": [
    {
      "id": 25261,
      "keyword": "mosca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2478,
      "keyword": "mosca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "moscas": [
    {
      "id": 25261,
      "keyword": "mosca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2478,
      "keyword": "mosca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ver": [
    {
      "id": 6564,
      "keyword": "ver",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "person",
        "basic needs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2474,
      "keyword": "ver",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28673,
      "keyword": "ver",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mirar": [
    {
      "id": 6564,
      "keyword": "mirar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "person",
        "basic needs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2474,
      "keyword": "mirar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28673,
      "keyword": "mirar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "observar": [
    {
      "id": 6564,
      "keyword": "observar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "person",
        "basic needs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39155,
      "keyword": "observar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2474,
      "keyword": "observar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28673,
      "keyword": "observar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mosquito": [
    {
      "id": 2479,
      "keyword": "mosquito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mosquitos": [
    {
      "id": 2479,
      "keyword": "mosquito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "microondas": [
    {
      "id": 2473,
      "keyword": "microondas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "naranja": [
    {
      "id": 2483,
      "keyword": "naranja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2888,
      "keyword": "naranja",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "naranjas": [
    {
      "id": 2483,
      "keyword": "naranja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2888,
      "keyword": "naranja",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "muñeca": [
    {
      "id": 2482,
      "keyword": "muñeca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26238,
      "keyword": "muñeca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 26238,
      "keyword": "muñeca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2904,
      "keyword": "muñeca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "joint system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3063,
      "keyword": "muñeca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muñecas": [
    {
      "id": 2482,
      "keyword": "muñeca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "toy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26238,
      "keyword": "muñeca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 26238,
      "keyword": "muñeca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2904,
      "keyword": "muñeca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "joint system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3063,
      "keyword": "muñeca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "niño": [
    {
      "id": 7176,
      "keyword": "niño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 7176,
      "keyword": "niño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10363,
      "keyword": "niño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37871,
      "keyword": "niño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32842,
      "keyword": "niño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32841,
      "keyword": "niño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32843,
      "keyword": "niño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32840,
      "keyword": "niño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2485,
      "keyword": "niño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28287,
      "keyword": "niño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niños": [
    {
      "id": 7176,
      "keyword": "niño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 7176,
      "keyword": "niño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36560,
      "keyword": "niños",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10363,
      "keyword": "niño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31462,
      "keyword": "niños",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37871,
      "keyword": "niño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6975,
      "keyword": "niños",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7178,
      "keyword": "niños",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32842,
      "keyword": "niño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32841,
      "keyword": "niño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32843,
      "keyword": "niño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32840,
      "keyword": "niño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2485,
      "keyword": "niño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28287,
      "keyword": "niño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chico": [
    {
      "id": 4673,
      "keyword": "chico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 4673,
      "keyword": "chico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7176,
      "keyword": "chico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 7176,
      "keyword": "chico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37871,
      "keyword": "chico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32842,
      "keyword": "chico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32841,
      "keyword": "chico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32843,
      "keyword": "chico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32840,
      "keyword": "chico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2485,
      "keyword": "chico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28287,
      "keyword": "chico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chicos": [
    {
      "id": 4673,
      "keyword": "chico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 4673,
      "keyword": "chico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7176,
      "keyword": "chico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 7176,
      "keyword": "chico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31462,
      "keyword": "chicos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37871,
      "keyword": "chico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6975,
      "keyword": "chicos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7178,
      "keyword": "chicos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32842,
      "keyword": "chico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32841,
      "keyword": "chico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32843,
      "keyword": "chico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32840,
      "keyword": "chico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2485,
      "keyword": "chico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28287,
      "keyword": "chico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "crío": [
    {
      "id": 7176,
      "keyword": "crío",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 7176,
      "keyword": "crío",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32842,
      "keyword": "crío",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32841,
      "keyword": "crío",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32843,
      "keyword": "crío",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32840,
      "keyword": "crío",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2485,
      "keyword": "crío",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28287,
      "keyword": "crío",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "críos": [
    {
      "id": 7176,
      "keyword": "crío",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 7176,
      "keyword": "crío",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6975,
      "keyword": "críos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7178,
      "keyword": "críos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32842,
      "keyword": "crío",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32841,
      "keyword": "crío",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32843,
      "keyword": "crío",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32840,
      "keyword": "crío",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2485,
      "keyword": "crío",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28287,
      "keyword": "crío",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chango": [
    {
      "id": 7176,
      "keyword": "chango",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 7176,
      "keyword": "chango",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10363,
      "keyword": "chango",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2485,
      "keyword": "chango",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28287,
      "keyword": "chango",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "changos": [
    {
      "id": 7176,
      "keyword": "chango",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 7176,
      "keyword": "chango",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10363,
      "keyword": "chango",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2485,
      "keyword": "chango",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28287,
      "keyword": "chango",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ordenador": [
    {
      "id": 7190,
      "keyword": "ordenador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2487,
      "keyword": "ordenador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7214,
      "keyword": "ordenador",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ordenadores": [
    {
      "id": 7190,
      "keyword": "ordenador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2487,
      "keyword": "ordenador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7214,
      "keyword": "ordenador",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "computador": [
    {
      "id": 7190,
      "keyword": "computador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2487,
      "keyword": "computador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7214,
      "keyword": "computador",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "computadores": [
    {
      "id": 7190,
      "keyword": "computador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2487,
      "keyword": "computador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7214,
      "keyword": "computador",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "computadora": [
    {
      "id": 7190,
      "keyword": "computadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2487,
      "keyword": "computadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7214,
      "keyword": "computadora",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "computadoras": [
    {
      "id": 7190,
      "keyword": "computadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2487,
      "keyword": "computadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7214,
      "keyword": "computadora",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oler": [
    {
      "id": 25275,
      "keyword": "oler",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6574,
      "keyword": "oler",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25274,
      "keyword": "oler",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30132,
      "keyword": "oler",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2486,
      "keyword": "oler",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30650,
      "keyword": "oler",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "olfatear": [
    {
      "id": 6574,
      "keyword": "olfatear",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2486,
      "keyword": "olfatear",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30650,
      "keyword": "olfatear",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "husmear": [
    {
      "id": 6574,
      "keyword": "husmear",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2486,
      "keyword": "husmear",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30650,
      "keyword": "husmear",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niña": [
    {
      "id": 32845,
      "keyword": "niña",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 32845,
      "keyword": "niña",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10362,
      "keyword": "niña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2484,
      "keyword": "niña",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27509,
      "keyword": "niña",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28283,
      "keyword": "niña",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32846,
      "keyword": "niña",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32847,
      "keyword": "niña",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32844,
      "keyword": "niña",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niñas": [
    {
      "id": 32845,
      "keyword": "niña",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 32845,
      "keyword": "niña",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10362,
      "keyword": "niña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2484,
      "keyword": "niña",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6974,
      "keyword": "niñas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27509,
      "keyword": "niña",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28283,
      "keyword": "niña",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32846,
      "keyword": "niña",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32847,
      "keyword": "niña",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32844,
      "keyword": "niña",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chica": [
    {
      "id": 32845,
      "keyword": "chica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 32845,
      "keyword": "chica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10206,
      "keyword": "chica",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 10206,
      "keyword": "chica",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2484,
      "keyword": "chica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27509,
      "keyword": "chica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28283,
      "keyword": "chica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32846,
      "keyword": "chica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32847,
      "keyword": "chica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32844,
      "keyword": "chica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39065,
      "keyword": "chica",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chicas": [
    {
      "id": 32845,
      "keyword": "chica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 32845,
      "keyword": "chica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10206,
      "keyword": "chica",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 10206,
      "keyword": "chica",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2484,
      "keyword": "chica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6974,
      "keyword": "chicas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27509,
      "keyword": "chica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28283,
      "keyword": "chica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32846,
      "keyword": "chica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32847,
      "keyword": "chica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32844,
      "keyword": "chica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39065,
      "keyword": "chica",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cría": [
    {
      "id": 34072,
      "keyword": "cría",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal reproduction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32845,
      "keyword": "cría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 32845,
      "keyword": "cría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34041,
      "keyword": "cría",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2484,
      "keyword": "cría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27509,
      "keyword": "cría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28283,
      "keyword": "cría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32846,
      "keyword": "cría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32847,
      "keyword": "cría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32844,
      "keyword": "cría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crías": [
    {
      "id": 34072,
      "keyword": "cría",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal reproduction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32845,
      "keyword": "cría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 32845,
      "keyword": "cría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34041,
      "keyword": "cría",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2484,
      "keyword": "cría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6974,
      "keyword": "crías",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27509,
      "keyword": "cría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28283,
      "keyword": "cría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32846,
      "keyword": "cría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32847,
      "keyword": "cría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32844,
      "keyword": "cría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "motocicleta": [
    {
      "id": 7166,
      "keyword": "motocicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 7166,
      "keyword": "motocicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2480,
      "keyword": "motocicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28167,
      "keyword": "motocicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "motocicletas": [
    {
      "id": 7166,
      "keyword": "motocicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 7166,
      "keyword": "motocicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2480,
      "keyword": "motocicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28167,
      "keyword": "motocicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "moto": [
    {
      "id": 7166,
      "keyword": "moto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 7166,
      "keyword": "moto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2480,
      "keyword": "moto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5084,
      "keyword": "moto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "motos": [
    {
      "id": 7166,
      "keyword": "moto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 7166,
      "keyword": "moto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2480,
      "keyword": "moto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5084,
      "keyword": "moto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oso": [
    {
      "id": 2488,
      "keyword": "oso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2868,
      "keyword": "oso",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2869,
      "keyword": "oso",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "osos": [
    {
      "id": 2488,
      "keyword": "oso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2868,
      "keyword": "oso",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2869,
      "keyword": "oso",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "osa": [
    {
      "id": 2488,
      "keyword": "osa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2868,
      "keyword": "osa",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2869,
      "keyword": "osa",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "osas": [
    {
      "id": 2488,
      "keyword": "osa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2868,
      "keyword": "osa",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2869,
      "keyword": "osa",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paloma": [
    {
      "id": 2493,
      "keyword": "paloma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25293,
      "keyword": "paloma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palomas": [
    {
      "id": 2493,
      "keyword": "paloma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25293,
      "keyword": "paloma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palomo": [
    {
      "id": 2493,
      "keyword": "palomo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palomos": [
    {
      "id": 2493,
      "keyword": "palomo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oveja": [
    {
      "id": 2489,
      "keyword": "oveja",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ovejas": [
    {
      "id": 2489,
      "keyword": "oveja",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cordero": [
    {
      "id": 25626,
      "keyword": "cordero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2489,
      "keyword": "cordero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34078,
      "keyword": "cordero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corderos": [
    {
      "id": 25626,
      "keyword": "cordero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2489,
      "keyword": "cordero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34078,
      "keyword": "cordero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cordera": [
    {
      "id": 2489,
      "keyword": "cordera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34078,
      "keyword": "cordera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corderas": [
    {
      "id": 2489,
      "keyword": "cordera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34078,
      "keyword": "cordera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pájaro": [
    {
      "id": 2490,
      "keyword": "pájaro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26270,
      "keyword": "pájaro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "herbivorous",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26271,
      "keyword": "pájaro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "herbivorous",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pájaros": [
    {
      "id": 2490,
      "keyword": "pájaro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26270,
      "keyword": "pájaro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "herbivorous",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26271,
      "keyword": "pájaro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "herbivorous",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pájara": [
    {
      "id": 2490,
      "keyword": "pájara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26270,
      "keyword": "pájara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "herbivorous",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26271,
      "keyword": "pájara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "herbivorous",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pájaras": [
    {
      "id": 2490,
      "keyword": "pájara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26270,
      "keyword": "pájara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "herbivorous",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26271,
      "keyword": "pájara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "herbivorous",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paño de cocina": [
    {
      "id": 2496,
      "keyword": "paño de cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paños de cocina": [
    {
      "id": 2496,
      "keyword": "paño de cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "padre": [
    {
      "id": 2497,
      "keyword": "padre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "padres": [
    {
      "id": 2497,
      "keyword": "padre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35059,
      "keyword": "padres",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35060,
      "keyword": "padres",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35061,
      "keyword": "padres",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35062,
      "keyword": "padres",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35201,
      "keyword": "padres",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "raqueta de ping-pong": [
    {
      "id": 2492,
      "keyword": "raqueta de ping-pong",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "raquetas de ping-pong": [
    {
      "id": 2492,
      "keyword": "raqueta de ping-pong",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pan": [
    {
      "id": 2494,
      "keyword": "pan",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10230,
      "keyword": "pan",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38732,
      "keyword": "pan",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38965,
      "keyword": "pan",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panes": [
    {
      "id": 2494,
      "keyword": "pan",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10230,
      "keyword": "pan",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38965,
      "keyword": "pan",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barra de pan": [
    {
      "id": 2494,
      "keyword": "barra de pan",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barras de pan": [
    {
      "id": 2494,
      "keyword": "barra de pan",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mochila": [
    {
      "id": 2475,
      "keyword": "mochila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2475,
      "keyword": "mochila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4696,
      "keyword": "mochila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34743,
      "keyword": "mochila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mochilas": [
    {
      "id": 2475,
      "keyword": "mochila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2475,
      "keyword": "mochila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4696,
      "keyword": "mochila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34743,
      "keyword": "mochila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pandero": [
    {
      "id": 2495,
      "keyword": "pandero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panderos": [
    {
      "id": 2495,
      "keyword": "pandero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "monitora": [
    {
      "id": 38543,
      "keyword": "monitora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38411,
      "keyword": "monitora",
      "keywords": 6,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39199,
      "keyword": "monitora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27006,
      "keyword": "monitora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2476,
      "keyword": "monitora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3267,
      "keyword": "monitora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monitoras": [
    {
      "id": 38543,
      "keyword": "monitora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38411,
      "keyword": "monitora",
      "keywords": 6,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39199,
      "keyword": "monitora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27006,
      "keyword": "monitora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2476,
      "keyword": "monitora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3267,
      "keyword": "monitora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuidadora": [
    {
      "id": 38411,
      "keyword": "cuidadora",
      "keywords": 6,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14663,
      "keyword": "cuidadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2476,
      "keyword": "cuidadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3267,
      "keyword": "cuidadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuidadoras": [
    {
      "id": 38411,
      "keyword": "cuidadora",
      "keywords": 6,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 14663,
      "keyword": "cuidadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2476,
      "keyword": "cuidadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3267,
      "keyword": "cuidadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "auxiliar": [
    {
      "id": 38411,
      "keyword": "auxiliar",
      "keywords": 6,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32982,
      "keyword": "auxiliar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32983,
      "keyword": "auxiliar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2476,
      "keyword": "auxiliar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3267,
      "keyword": "auxiliar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7163,
      "keyword": "auxiliar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10141,
      "keyword": "auxiliar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15992,
      "keyword": "auxiliar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37538,
      "keyword": "auxiliar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37539,
      "keyword": "auxiliar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "auxiliares": [
    {
      "id": 38411,
      "keyword": "auxiliar",
      "keywords": 6,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32982,
      "keyword": "auxiliar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32983,
      "keyword": "auxiliar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2476,
      "keyword": "auxiliar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3267,
      "keyword": "auxiliar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7163,
      "keyword": "auxiliar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15992,
      "keyword": "auxiliar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parada": [
    {
      "id": 35407,
      "keyword": "parada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2499,
      "keyword": "parada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "movement",
        "traffic",
        "mode of transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29155,
      "keyword": "parada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36839,
      "keyword": "parada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paradas": [
    {
      "id": 35407,
      "keyword": "parada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2499,
      "keyword": "parada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "movement",
        "traffic",
        "mode of transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29155,
      "keyword": "parada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36839,
      "keyword": "parada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parada de autobús": [
    {
      "id": 35407,
      "keyword": "parada de autobús",
      "keywords": 2,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2499,
      "keyword": "parada de autobús",
      "keywords": 2,
      "type": 3,
      "tags": [
        "urban area",
        "street furniture",
        "movement",
        "traffic",
        "mode of transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paradas de autobús": [
    {
      "id": 2499,
      "keyword": "parada de autobús",
      "keywords": 2,
      "type": 3,
      "tags": [
        "urban area",
        "street furniture",
        "movement",
        "traffic",
        "mode of transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paraguas": [
    {
      "id": 2500,
      "keyword": "paraguas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2500,
      "keyword": "paraguas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37456,
      "keyword": "paraguas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mono": [
    {
      "id": 2477,
      "keyword": "mono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8281,
      "keyword": "mono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24276,
      "keyword": "mono",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monos": [
    {
      "id": 2477,
      "keyword": "mono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8281,
      "keyword": "mono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24276,
      "keyword": "mono",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mona": [
    {
      "id": 2477,
      "keyword": "mona",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monas": [
    {
      "id": 2477,
      "keyword": "mona",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pastel": [
    {
      "id": 2502,
      "keyword": "pastel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasteles": [
    {
      "id": 2502,
      "keyword": "pastel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26304,
      "keyword": "pasteles",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torta": [
    {
      "id": 2502,
      "keyword": "torta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10234,
      "keyword": "torta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortas": [
    {
      "id": 2502,
      "keyword": "torta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10234,
      "keyword": "torta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26304,
      "keyword": "tortas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parchís": [
    {
      "id": 2501,
      "keyword": "parchís",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ludo": [
    {
      "id": 2501,
      "keyword": "ludo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patinete": [
    {
      "id": 2508,
      "keyword": "patinete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "sport",
        "toy",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patinetes": [
    {
      "id": 2508,
      "keyword": "patinete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "sport",
        "toy",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "patatas fritas": [
    {
      "id": 2505,
      "keyword": "patatas fritas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8653,
      "keyword": "patatas fritas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5400,
      "keyword": "patatas fritas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papas fritas": [
    {
      "id": 2505,
      "keyword": "papas fritas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8653,
      "keyword": "papas fritas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pegamento": [
    {
      "id": 2510,
      "keyword": "pegamento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37499,
      "keyword": "pegamento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pegamentos": [
    {
      "id": 2510,
      "keyword": "pegamento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37499,
      "keyword": "pegamento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "papelera": [
    {
      "id": 2498,
      "keyword": "papelera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2861,
      "keyword": "papelera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24236,
      "keyword": "papelera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38256,
      "keyword": "papelera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papeleras": [
    {
      "id": 2498,
      "keyword": "papelera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2861,
      "keyword": "papelera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24236,
      "keyword": "papelera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38256,
      "keyword": "papelera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "patines": [
    {
      "id": 2506,
      "keyword": "patines",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "sport material",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8318,
      "keyword": "patín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "sport material",
        "skating"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9204,
      "keyword": "patines",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "sport material",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30448,
      "keyword": "patín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "skating"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30602,
      "keyword": "patín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "sport material",
        "skating"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30600,
      "keyword": "patines",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "sport material",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22022,
      "keyword": "patines",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30450,
      "keyword": "patines",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "skating"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pavo": [
    {
      "id": 25628,
      "keyword": "pavo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2509,
      "keyword": "pavo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "terrestrial animal",
        "oviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pavos": [
    {
      "id": 25628,
      "keyword": "pavo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2509,
      "keyword": "pavo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "terrestrial animal",
        "oviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pava": [
    {
      "id": 2509,
      "keyword": "pava",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "terrestrial animal",
        "oviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7276,
      "keyword": "pava",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pavas": [
    {
      "id": 2509,
      "keyword": "pava",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "terrestrial animal",
        "oviparous",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7276,
      "keyword": "pava",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "patata": [
    {
      "id": 2503,
      "keyword": "patata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patatas": [
    {
      "id": 2503,
      "keyword": "patata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "papa": [
    {
      "id": 2503,
      "keyword": "papa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24234,
      "keyword": "Papa",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "person",
        "christianity",
        "leader"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papas": [
    {
      "id": 2503,
      "keyword": "papa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pelota de tenis": [
    {
      "id": 2514,
      "keyword": "pelota de tenis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelotas de tenis": [
    {
      "id": 2514,
      "keyword": "pelota de tenis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pegar": [
    {
      "id": 24749,
      "keyword": "pegar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9000,
      "keyword": "pegar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2511,
      "keyword": "pegar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24757,
      "keyword": "pegar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24828,
      "keyword": "pegar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31793,
      "keyword": "pegar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34555,
      "keyword": "pegar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pendientes": [
    {
      "id": 2515,
      "keyword": "pendientes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2515,
      "keyword": "pendientes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8363,
      "keyword": "pendiente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aretes": [
    {
      "id": 2515,
      "keyword": "aretes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2515,
      "keyword": "aretes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8363,
      "keyword": "arete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aros": [
    {
      "id": 2515,
      "keyword": "aros",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2515,
      "keyword": "aros",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3253,
      "keyword": "aro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "gymnastics",
        "rhythmic gymnastics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "persiana": [
    {
      "id": 2518,
      "keyword": "persiana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "persianas": [
    {
      "id": 2518,
      "keyword": "persiana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pescado": [
    {
      "id": 2519,
      "keyword": "pescado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6502,
      "keyword": "pescado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35661,
      "keyword": "pescado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6646,
      "keyword": "pescado",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pescados": [
    {
      "id": 2519,
      "keyword": "pescado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6502,
      "keyword": "pescado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35661,
      "keyword": "pescados",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6646,
      "keyword": "pescado",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pijama": [
    {
      "id": 2522,
      "keyword": "pijama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2522,
      "keyword": "pijama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pijamas": [
    {
      "id": 2522,
      "keyword": "pijama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2522,
      "keyword": "pijama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perro": [
    {
      "id": 7202,
      "keyword": "perro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38967,
      "keyword": "perro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2517,
      "keyword": "perro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perros": [
    {
      "id": 7202,
      "keyword": "perro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38967,
      "keyword": "perro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2517,
      "keyword": "perro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "can": [
    {
      "id": 7202,
      "keyword": "can",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2517,
      "keyword": "can",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canes": [
    {
      "id": 7202,
      "keyword": "can",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2517,
      "keyword": "can",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perra": [
    {
      "id": 7202,
      "keyword": "perra",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38967,
      "keyword": "perra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2517,
      "keyword": "perra",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perras": [
    {
      "id": 7202,
      "keyword": "perra",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38967,
      "keyword": "perra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2517,
      "keyword": "perra",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "piña": [
    {
      "id": 8668,
      "keyword": "piña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2525,
      "keyword": "piña",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piñas": [
    {
      "id": 8668,
      "keyword": "piña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2525,
      "keyword": "piña",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ananá": [
    {
      "id": 2525,
      "keyword": "ananá",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ananás": [
    {
      "id": 2525,
      "keyword": "ananá",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "monopatín": [
    {
      "id": 2507,
      "keyword": "monopatín",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "movement",
        "traffic",
        "road safety",
        "skating"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monopatines": [
    {
      "id": 2507,
      "keyword": "monopatín",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "movement",
        "traffic",
        "road safety",
        "skating"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "skateboard": [
    {
      "id": 2507,
      "keyword": "skateboard",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "movement",
        "traffic",
        "road safety",
        "skating"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "skateboards": [
    {
      "id": 2507,
      "keyword": "skateboard",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "movement",
        "traffic",
        "road safety",
        "skating"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pizza": [
    {
      "id": 2527,
      "keyword": "pizza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pizzas": [
    {
      "id": 2527,
      "keyword": "pizza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pizarra": [
    {
      "id": 2526,
      "keyword": "pizarra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36659,
      "keyword": "pizarra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pizarras": [
    {
      "id": 2526,
      "keyword": "pizarra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36659,
      "keyword": "pizarra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pizarrón": [
    {
      "id": 2526,
      "keyword": "pizarrón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36659,
      "keyword": "pizarrón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pizarrones": [
    {
      "id": 2526,
      "keyword": "pizarrón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36659,
      "keyword": "pizarrón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peinar": [
    {
      "id": 26947,
      "keyword": "peinar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "person",
        "routine",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2512,
      "keyword": "peinar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22029,
      "keyword": "peinar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plastilina": [
    {
      "id": 2529,
      "keyword": "plastilina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2529,
      "keyword": "plastilina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plastilinas": [
    {
      "id": 2529,
      "keyword": "plastilina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2529,
      "keyword": "plastilina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plancha": [
    {
      "id": 2528,
      "keyword": "plancha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "planchas": [
    {
      "id": 2528,
      "keyword": "plancha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "piano": [
    {
      "id": 2521,
      "keyword": "piano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument",
        "keyboard instrument",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pianos": [
    {
      "id": 2521,
      "keyword": "piano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument",
        "keyboard instrument",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pollo": [
    {
      "id": 25343,
      "keyword": "pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25632,
      "keyword": "pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2533,
      "keyword": "pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4952,
      "keyword": "pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat",
        "core vocabulary",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24815,
      "keyword": "pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pollos": [
    {
      "id": 25343,
      "keyword": "pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25632,
      "keyword": "pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2533,
      "keyword": "pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4952,
      "keyword": "pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat",
        "core vocabulary",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24815,
      "keyword": "pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pollito": [
    {
      "id": 2533,
      "keyword": "pollito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34076,
      "keyword": "pollito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pollitos": [
    {
      "id": 2533,
      "keyword": "pollito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34076,
      "keyword": "pollito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pez": [
    {
      "id": 2520,
      "keyword": "pez",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "herbivorous",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "ovoviviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "marine animal",
        "sea",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7199,
      "keyword": "pez",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peces": [
    {
      "id": 2520,
      "keyword": "pez",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "herbivorous",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "ovoviviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "marine animal",
        "sea",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7199,
      "keyword": "peces",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muslo de pollo": [
    {
      "id": 2534,
      "keyword": "muslo de pollo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24817,
      "keyword": "muslo de pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muslos de pollo": [
    {
      "id": 2534,
      "keyword": "muslo de pollo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24817,
      "keyword": "muslo de pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "portería": [
    {
      "id": 5972,
      "keyword": "portería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2535,
      "keyword": "portería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9149,
      "keyword": "portería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27226,
      "keyword": "portería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27234,
      "keyword": "portería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27230,
      "keyword": "portería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37095,
      "keyword": "portería",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porterías": [
    {
      "id": 5972,
      "keyword": "portería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2535,
      "keyword": "portería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9149,
      "keyword": "portería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27226,
      "keyword": "portería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27234,
      "keyword": "portería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27230,
      "keyword": "portería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37095,
      "keyword": "portería",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arco": [
    {
      "id": 5386,
      "keyword": "arco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28495,
      "keyword": "arco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility",
        "geography",
        "history"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2535,
      "keyword": "arco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arcos": [
    {
      "id": 5386,
      "keyword": "arco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28495,
      "keyword": "arco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility",
        "geography",
        "history"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2535,
      "keyword": "arco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "puré": [
    {
      "id": 2539,
      "keyword": "puré",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "purés": [
    {
      "id": 2539,
      "keyword": "puré",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pincel": [
    {
      "id": 2523,
      "keyword": "pincel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2837,
      "keyword": "pincel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinceles": [
    {
      "id": 2523,
      "keyword": "pincel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2837,
      "keyword": "pincel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "punzón": [
    {
      "id": 2538,
      "keyword": "punzón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "punzones": [
    {
      "id": 2538,
      "keyword": "punzón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pulsera": [
    {
      "id": 2537,
      "keyword": "pulsera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8203,
      "keyword": "pulsera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulseras": [
    {
      "id": 2537,
      "keyword": "pulsera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8203,
      "keyword": "pulsera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "puzzle": [
    {
      "id": 2540,
      "keyword": "puzzle",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puzzles": [
    {
      "id": 2540,
      "keyword": "puzzle",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plátano": [
    {
      "id": 2530,
      "keyword": "plátano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9054,
      "keyword": "plátano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plátanos": [
    {
      "id": 2530,
      "keyword": "plátano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9054,
      "keyword": "plátano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34045,
      "keyword": "plátanos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rana": [
    {
      "id": 28473,
      "keyword": "rana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "amphibian",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "terrestrial animal",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2543,
      "keyword": "rana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "amphibian",
        "aquatic animal",
        "freshwater animal",
        "river",
        "terrestrial animal",
        "oviparous"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ranas": [
    {
      "id": 28473,
      "keyword": "rana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "amphibian",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "terrestrial animal",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2543,
      "keyword": "rana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "amphibian",
        "aquatic animal",
        "freshwater animal",
        "river",
        "terrestrial animal",
        "oviparous"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rasgar": [
    {
      "id": 2545,
      "keyword": "rasgar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rampa": [
    {
      "id": 22799,
      "keyword": "rampa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "architecture",
        "architectural element",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2542,
      "keyword": "rampa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rampas": [
    {
      "id": 22799,
      "keyword": "rampa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "architecture",
        "architectural element",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2542,
      "keyword": "rampa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "raqueta": [
    {
      "id": 2544,
      "keyword": "raqueta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28023,
      "keyword": "raqueta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "raquetas": [
    {
      "id": 2544,
      "keyword": "raqueta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28023,
      "keyword": "raqueta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37308,
      "keyword": "raquetas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "raqueta de tenis": [
    {
      "id": 2544,
      "keyword": "raqueta de tenis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "raquetas de tenis": [
    {
      "id": 2544,
      "keyword": "raqueta de tenis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plato": [
    {
      "id": 16857,
      "keyword": "plato",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2532,
      "keyword": "plato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "platos": [
    {
      "id": 16857,
      "keyword": "plato",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2532,
      "keyword": "plato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37947,
      "keyword": "platos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "platillos": [
    {
      "id": 2531,
      "keyword": "platillos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8364,
      "keyword": "platillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "queso": [
    {
      "id": 25363,
      "keyword": "queso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29144,
      "keyword": "queso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2541,
      "keyword": "queso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4881,
      "keyword": "queso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quesos": [
    {
      "id": 25363,
      "keyword": "queso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29144,
      "keyword": "queso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2541,
      "keyword": "queso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4881,
      "keyword": "queso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ratón": [
    {
      "id": 2546,
      "keyword": "ratón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2820,
      "keyword": "ratón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28845,
      "keyword": "ratón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ratones": [
    {
      "id": 2546,
      "keyword": "ratón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2820,
      "keyword": "ratón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28845,
      "keyword": "ratón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ratona": [
    {
      "id": 2546,
      "keyword": "ratona",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28845,
      "keyword": "ratona",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ratonas": [
    {
      "id": 2546,
      "keyword": "ratona",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28845,
      "keyword": "ratona",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cortar": [
    {
      "id": 25020,
      "keyword": "cortar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "cutlery",
        "home",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27696,
      "keyword": "cortar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5975,
      "keyword": "cortar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "cutlery",
        "home",
        "usual verbs",
        "core vocabulary",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2547,
      "keyword": "cortar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "usual verbs",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25022,
      "keyword": "cortar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39429,
      "keyword": "cortar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39428,
      "keyword": "cortar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "work accident",
        "psychology",
        "disruptive behavior",
        "health",
        "medicine",
        "symptom",
        "human body"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recortar": [
    {
      "id": 2547,
      "keyword": "recortar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "usual verbs",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25379,
      "keyword": "recortar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sábanas": [
    {
      "id": 8367,
      "keyword": "sábana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 8367,
      "keyword": "sábana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2551,
      "keyword": "sábanas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17304,
      "keyword": "sábana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rinoceronte": [
    {
      "id": 2550,
      "keyword": "rinoceronte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rinocerontes": [
    {
      "id": 2550,
      "keyword": "rinoceronte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salero": [
    {
      "id": 2554,
      "keyword": "salero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saleros": [
    {
      "id": 2554,
      "keyword": "salero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sacapuntas": [
    {
      "id": 2553,
      "keyword": "sacapuntas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacaminas": [
    {
      "id": 2553,
      "keyword": "sacaminas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salchichas": [
    {
      "id": 6647,
      "keyword": "salchicha",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2555,
      "keyword": "salchichas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8326,
      "keyword": "salchicha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reloj": [
    {
      "id": 7230,
      "keyword": "reloj",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "time",
        "chronological device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2549,
      "keyword": "reloj",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "appliance",
        "time",
        "chronological device",
        "core vocabulary",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2549,
      "keyword": "reloj",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "appliance",
        "time",
        "chronological device",
        "core vocabulary",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5561,
      "keyword": "reloj",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "time",
        "chronological device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7229,
      "keyword": "reloj",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "time",
        "chronological device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5560,
      "keyword": "reloj",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "time",
        "chronological device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "relojes": [
    {
      "id": 7230,
      "keyword": "reloj",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "time",
        "chronological device"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2549,
      "keyword": "reloj",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "appliance",
        "time",
        "chronological device",
        "core vocabulary",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2549,
      "keyword": "reloj",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "appliance",
        "time",
        "chronological device",
        "core vocabulary",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5561,
      "keyword": "reloj",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "time",
        "chronological device"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7229,
      "keyword": "reloj",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "time",
        "chronological device"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5560,
      "keyword": "reloj",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "time",
        "chronological device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sandalias": [
    {
      "id": 2556,
      "keyword": "sandalias",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8368,
      "keyword": "sandalia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37574,
      "keyword": "sandalias",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "red": [
    {
      "id": 2548,
      "keyword": "red",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6205,
      "keyword": "red",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "fishing",
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "redes": [
    {
      "id": 2548,
      "keyword": "red",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6205,
      "keyword": "red",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "fishing",
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sacacorchos": [
    {
      "id": 2552,
      "keyword": "sacacorchos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sandía": [
    {
      "id": 2557,
      "keyword": "sandía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sandías": [
    {
      "id": 2557,
      "keyword": "sandía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pera": [
    {
      "id": 2561,
      "keyword": "pera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peras": [
    {
      "id": 2561,
      "keyword": "pera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sartén": [
    {
      "id": 5965,
      "keyword": "sartén",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2558,
      "keyword": "sartén",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sartenes": [
    {
      "id": 5965,
      "keyword": "sartén",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2558,
      "keyword": "sartén",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "periquito": [
    {
      "id": 2562,
      "keyword": "periquito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "periquitos": [
    {
      "id": 2562,
      "keyword": "periquito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "periquita": [
    {
      "id": 2562,
      "keyword": "periquita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "periquitas": [
    {
      "id": 2562,
      "keyword": "periquita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pandereta": [
    {
      "id": 2564,
      "keyword": "pandereta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "event",
        "popular event",
        "christmas",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panderetas": [
    {
      "id": 2564,
      "keyword": "pandereta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "event",
        "popular event",
        "christmas",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "semáforo": [
    {
      "id": 2567,
      "keyword": "semáforo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "semáforos": [
    {
      "id": 2567,
      "keyword": "semáforo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "serpiente": [
    {
      "id": 2568,
      "keyword": "serpiente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "ovoviviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2568,
      "keyword": "serpiente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "ovoviviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "serpientes": [
    {
      "id": 2568,
      "keyword": "serpiente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "ovoviviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2568,
      "keyword": "serpiente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "ovoviviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "secar": [
    {
      "id": 34715,
      "keyword": "secar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25437,
      "keyword": "secar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22106,
      "keyword": "secar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16887,
      "keyword": "secar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27485,
      "keyword": "secar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30520,
      "keyword": "secar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37835,
      "keyword": "secar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38471,
      "keyword": "secar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2566,
      "keyword": "secar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22105,
      "keyword": "secar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22104,
      "keyword": "secar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7239,
      "keyword": "secar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8688,
      "keyword": "secar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9035,
      "keyword": "secar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27486,
      "keyword": "secar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28507,
      "keyword": "secar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28503,
      "keyword": "secar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37777,
      "keyword": "secar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37049,
      "keyword": "secar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secar las manos": [
    {
      "id": 30520,
      "keyword": "secar las manos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2566,
      "keyword": "secar las manos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37049,
      "keyword": "secar las manos",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "servilleta": [
    {
      "id": 36303,
      "keyword": "servilleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2569,
      "keyword": "servilleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "servilletas": [
    {
      "id": 36303,
      "keyword": "servilleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2569,
      "keyword": "servilleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saxofón": [
    {
      "id": 2559,
      "keyword": "saxofón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saxofones": [
    {
      "id": 2559,
      "keyword": "saxofón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sillón": [
    {
      "id": 25475,
      "keyword": "sillón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2570,
      "keyword": "sillón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillones": [
    {
      "id": 25475,
      "keyword": "sillón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2570,
      "keyword": "sillón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sorprendido": [
    {
      "id": 35529,
      "keyword": "sorprendido",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32170,
      "keyword": "sorprendido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2574,
      "keyword": "sorprendido",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sorprendidos": [
    {
      "id": 35529,
      "keyword": "sorprendido",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32170,
      "keyword": "sorprendido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2574,
      "keyword": "sorprendido",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sorprendida": [
    {
      "id": 35529,
      "keyword": "sorprendida",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31099,
      "keyword": "sorprendida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2574,
      "keyword": "sorprendida",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sorprendidas": [
    {
      "id": 35529,
      "keyword": "sorprendida",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31099,
      "keyword": "sorprendida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2574,
      "keyword": "sorprendida",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "impresionado": [
    {
      "id": 35529,
      "keyword": "impresionado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32170,
      "keyword": "impresionado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2574,
      "keyword": "impresionado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "impresionados": [
    {
      "id": 35529,
      "keyword": "impresionado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32170,
      "keyword": "impresionado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2574,
      "keyword": "impresionado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "impresionada": [
    {
      "id": 35529,
      "keyword": "impresionada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31099,
      "keyword": "impresionada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2574,
      "keyword": "impresionada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "impresionadas": [
    {
      "id": 35529,
      "keyword": "impresionada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31099,
      "keyword": "impresionada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2574,
      "keyword": "impresionada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "suelo": [
    {
      "id": 2575,
      "keyword": "suelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suelos": [
    {
      "id": 2575,
      "keyword": "suelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "piso": [
    {
      "id": 11343,
      "keyword": "piso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2575,
      "keyword": "piso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37864,
      "keyword": "piso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "architecture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pisos": [
    {
      "id": 11343,
      "keyword": "piso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2575,
      "keyword": "piso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37864,
      "keyword": "piso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "architecture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sopa": [
    {
      "id": 2573,
      "keyword": "sopa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sopas": [
    {
      "id": 2573,
      "keyword": "sopa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "secador": [
    {
      "id": 2560,
      "keyword": "secador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secadores": [
    {
      "id": 2560,
      "keyword": "secador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sujetador": [
    {
      "id": 2576,
      "keyword": "sujetador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2576,
      "keyword": "sujetador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sujetadores": [
    {
      "id": 2576,
      "keyword": "sujetador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2576,
      "keyword": "sujetador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "corpiño": [
    {
      "id": 2576,
      "keyword": "corpiño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2576,
      "keyword": "corpiño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31362,
      "keyword": "corpiño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corpiños": [
    {
      "id": 2576,
      "keyword": "corpiño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2576,
      "keyword": "corpiño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31362,
      "keyword": "corpiño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tabla de planchar": [
    {
      "id": 2577,
      "keyword": "tabla de planchar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tablas de planchar": [
    {
      "id": 2577,
      "keyword": "tabla de planchar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pantalón": [
    {
      "id": 2565,
      "keyword": "pantalón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2565,
      "keyword": "pantalón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7193,
      "keyword": "pantalón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29933,
      "keyword": "pantalón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24222,
      "keyword": "pantalón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13638,
      "keyword": "pantalón",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pantalones": [
    {
      "id": 2565,
      "keyword": "pantalón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2565,
      "keyword": "pantalón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7193,
      "keyword": "pantalón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29933,
      "keyword": "pantalón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24222,
      "keyword": "pantalón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 13638,
      "keyword": "pantalones",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13638,
      "keyword": "pantalón",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tambor": [
    {
      "id": 2578,
      "keyword": "tambor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tambores": [
    {
      "id": 2578,
      "keyword": "tambor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarta": [
    {
      "id": 2579,
      "keyword": "tarta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25488,
      "keyword": "tarta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8706,
      "keyword": "tarta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9057,
      "keyword": "tarta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16651,
      "keyword": "tarta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tartas": [
    {
      "id": 2579,
      "keyword": "tarta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25488,
      "keyword": "tarta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8706,
      "keyword": "tarta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9057,
      "keyword": "tarta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16651,
      "keyword": "tarta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pato": [
    {
      "id": 28479,
      "keyword": "pato",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "flying animal",
        "work",
        "primary sector",
        "hunting",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2563,
      "keyword": "pato",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "flying animal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28477,
      "keyword": "pato",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "aquatic animal",
        "freshwater animal",
        "river",
        "oviparous",
        "flying animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patos": [
    {
      "id": 28479,
      "keyword": "pato",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "flying animal",
        "work",
        "primary sector",
        "hunting",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2563,
      "keyword": "pato",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "flying animal"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28477,
      "keyword": "pato",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "aquatic animal",
        "freshwater animal",
        "river",
        "oviparous",
        "flying animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pata": [
    {
      "id": 28479,
      "keyword": "pata",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "flying animal",
        "work",
        "primary sector",
        "hunting",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16833,
      "keyword": "pata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27953,
      "keyword": "pata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2563,
      "keyword": "pata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "flying animal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28477,
      "keyword": "pata",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "aquatic animal",
        "freshwater animal",
        "river",
        "oviparous",
        "flying animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patas": [
    {
      "id": 28479,
      "keyword": "pata",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "flying animal",
        "work",
        "primary sector",
        "hunting",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16833,
      "keyword": "pata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27953,
      "keyword": "pata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2563,
      "keyword": "pata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "flying animal"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28477,
      "keyword": "pata",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "aquatic animal",
        "freshwater animal",
        "river",
        "oviparous",
        "flying animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taza de café": [
    {
      "id": 2581,
      "keyword": "taza de café",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tazas de café": [
    {
      "id": 2581,
      "keyword": "taza de café",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sombrero": [
    {
      "id": 2572,
      "keyword": "sombrero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6216,
      "keyword": "sombrero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sombreros": [
    {
      "id": 2572,
      "keyword": "sombrero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6216,
      "keyword": "sombrero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "teléfono de disco": [
    {
      "id": 2585,
      "keyword": "teléfono de disco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "communication"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teléfonos de disco": [
    {
      "id": 2585,
      "keyword": "teléfono de disco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "communication"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "teléfono de rueda": [
    {
      "id": 2585,
      "keyword": "teléfono de rueda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "communication"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teléfonos de rueda": [
    {
      "id": 2585,
      "keyword": "teléfono de rueda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "communication"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taza": [
    {
      "id": 2582,
      "keyword": "taza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2582,
      "keyword": "taza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tazas": [
    {
      "id": 2582,
      "keyword": "taza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2582,
      "keyword": "taza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sofá": [
    {
      "id": 25479,
      "keyword": "sofá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 25479,
      "keyword": "sofá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2571,
      "keyword": "sofá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sofás": [
    {
      "id": 25479,
      "keyword": "sofá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 25479,
      "keyword": "sofá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2571,
      "keyword": "sofá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "techo": [
    {
      "id": 2583,
      "keyword": "techo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "techos": [
    {
      "id": 2583,
      "keyword": "techo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tiburón": [
    {
      "id": 2589,
      "keyword": "tiburón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "ovoviviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiburones": [
    {
      "id": 2589,
      "keyword": "tiburón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "ovoviviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taxi": [
    {
      "id": 2580,
      "keyword": "taxi",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taxis": [
    {
      "id": 2580,
      "keyword": "taxi",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tejado": [
    {
      "id": 2584,
      "keyword": "tejado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tejados": [
    {
      "id": 2584,
      "keyword": "tejado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tigre": [
    {
      "id": 2590,
      "keyword": "tigre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tigres": [
    {
      "id": 2590,
      "keyword": "tigre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tigresa": [
    {
      "id": 2590,
      "keyword": "tigresa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tigresas": [
    {
      "id": 2590,
      "keyword": "tigresa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tijeras": [
    {
      "id": 6664,
      "keyword": "tijeras",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6664,
      "keyword": "tijera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2591,
      "keyword": "tijeras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "secondary sector",
        "clothing industry",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28135,
      "keyword": "tijeras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4964,
      "keyword": "tijeras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4964,
      "keyword": "tijera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "toalla": [
    {
      "id": 2593,
      "keyword": "toalla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2593,
      "keyword": "toalla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4758,
      "keyword": "toalla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toallas": [
    {
      "id": 2593,
      "keyword": "toalla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2593,
      "keyword": "toalla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4758,
      "keyword": "toalla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tenedor": [
    {
      "id": 2588,
      "keyword": "tenedor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home",
        "feeding",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tenedores": [
    {
      "id": 2588,
      "keyword": "tenedor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home",
        "feeding",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "timbre": [
    {
      "id": 2592,
      "keyword": "timbre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6230,
      "keyword": "timbre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2802,
      "keyword": "timbre",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "timbres": [
    {
      "id": 2592,
      "keyword": "timbre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6230,
      "keyword": "timbre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2802,
      "keyword": "timbre",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tomate": [
    {
      "id": 2594,
      "keyword": "tomate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomates": [
    {
      "id": 2594,
      "keyword": "tomate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "teléfono": [
    {
      "id": 26479,
      "keyword": "teléfono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "communication",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 26479,
      "keyword": "teléfono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "communication",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2791,
      "keyword": "teléfono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "communication",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2586,
      "keyword": "teléfono",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teléfonos": [
    {
      "id": 26479,
      "keyword": "teléfono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "communication",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 26479,
      "keyword": "teléfono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "communication",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2791,
      "keyword": "teléfono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "communication",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2586,
      "keyword": "teléfono",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "móvil": [
    {
      "id": 25269,
      "keyword": "móvil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware",
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2586,
      "keyword": "móvil",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "móviles": [
    {
      "id": 25269,
      "keyword": "móvil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware",
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2586,
      "keyword": "móvil",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "teléfono móvil": [
    {
      "id": 25269,
      "keyword": "teléfono móvil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware",
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2586,
      "keyword": "teléfono móvil",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teléfonos móviles": [
    {
      "id": 25269,
      "keyword": "teléfono móvil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware",
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2586,
      "keyword": "teléfono móvil",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "celular": [
    {
      "id": 2586,
      "keyword": "celular",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "celulares": [
    {
      "id": 2586,
      "keyword": "celular",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tostadora": [
    {
      "id": 2598,
      "keyword": "tostadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tostadoras": [
    {
      "id": 2598,
      "keyword": "tostadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tranvía": [
    {
      "id": 27082,
      "keyword": "tranvía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2602,
      "keyword": "tranvía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27081,
      "keyword": "tranvía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tranvías": [
    {
      "id": 27082,
      "keyword": "tranvía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2602,
      "keyword": "tranvía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27081,
      "keyword": "tranvía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trabajar": [
    {
      "id": 6624,
      "keyword": "trabajar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "work",
        "professional",
        "education",
        "educational task",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22147,
      "keyword": "trabajar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2599,
      "keyword": "trabajar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34393,
      "keyword": "trabajar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "triciclo": [
    {
      "id": 2605,
      "keyword": "triciclo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28153,
      "keyword": "triciclo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "triciclos": [
    {
      "id": 2605,
      "keyword": "triciclo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28153,
      "keyword": "triciclo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tractor": [
    {
      "id": 2600,
      "keyword": "tractor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "primary sector",
        "agriculture",
        "movement",
        "core vocabulary",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2600,
      "keyword": "tractor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "primary sector",
        "agriculture",
        "movement",
        "core vocabulary",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tractores": [
    {
      "id": 2600,
      "keyword": "tractor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "primary sector",
        "agriculture",
        "movement",
        "core vocabulary",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2600,
      "keyword": "tractor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "primary sector",
        "agriculture",
        "movement",
        "core vocabulary",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "triste": [
    {
      "id": 35545,
      "keyword": "triste",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2606,
      "keyword": "triste",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11959,
      "keyword": "triste",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31939,
      "keyword": "triste",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tristes": [
    {
      "id": 35545,
      "keyword": "triste",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2606,
      "keyword": "triste",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11959,
      "keyword": "triste",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31939,
      "keyword": "triste",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tú": [
    {
      "id": 6625,
      "keyword": "tú",
      "keywords": 5,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7290,
      "keyword": "tú",
      "keywords": 5,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2608,
      "keyword": "tú",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7289,
      "keyword": "tú",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31801,
      "keyword": "tú",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "usted": [
    {
      "id": 6625,
      "keyword": "usted",
      "keywords": 5,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7290,
      "keyword": "usted",
      "keywords": 5,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2608,
      "keyword": "usted",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7289,
      "keyword": "usted",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31801,
      "keyword": "usted",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tú te": [
    {
      "id": 6625,
      "keyword": "tú te",
      "keywords": 5,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7290,
      "keyword": "tú te",
      "keywords": 5,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2608,
      "keyword": "tú te",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7289,
      "keyword": "tú te",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31801,
      "keyword": "tú te",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortuga": [
    {
      "id": 26503,
      "keyword": "tortuga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "terrestrial animal",
        "aquatic animal",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2596,
      "keyword": "tortuga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10241,
      "keyword": "tortuga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortugas": [
    {
      "id": 26503,
      "keyword": "tortuga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "terrestrial animal",
        "aquatic animal",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2596,
      "keyword": "tortuga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10241,
      "keyword": "tortuga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "toro": [
    {
      "id": 2595,
      "keyword": "toro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "scenic art",
        "bullfighting"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10355,
      "keyword": "toro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toros": [
    {
      "id": 2595,
      "keyword": "toro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "scenic art",
        "bullfighting"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10355,
      "keyword": "toro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trompeta": [
    {
      "id": 2607,
      "keyword": "trompeta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trompetas": [
    {
      "id": 2607,
      "keyword": "trompeta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tren": [
    {
      "id": 7282,
      "keyword": "tren",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5094,
      "keyword": "tren",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21399,
      "keyword": "tren",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 21399,
      "keyword": "tren",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2603,
      "keyword": "tren",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trenes": [
    {
      "id": 7282,
      "keyword": "tren",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5094,
      "keyword": "tren",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21399,
      "keyword": "tren",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 21399,
      "keyword": "tren",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2603,
      "keyword": "tren",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vaca": [
    {
      "id": 2609,
      "keyword": "vaca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vacas": [
    {
      "id": 2609,
      "keyword": "vaca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vaso": [
    {
      "id": 2610,
      "keyword": "vaso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vasos": [
    {
      "id": 2610,
      "keyword": "vaso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ventana": [
    {
      "id": 2611,
      "keyword": "ventana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2611,
      "keyword": "ventana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32918,
      "keyword": "ventana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24465,
      "keyword": "ventana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ventanas": [
    {
      "id": 2611,
      "keyword": "ventana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2611,
      "keyword": "ventana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32918,
      "keyword": "ventana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24465,
      "keyword": "ventana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ventanal": [
    {
      "id": 2611,
      "keyword": "ventanal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2611,
      "keyword": "ventanal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ventanales": [
    {
      "id": 2611,
      "keyword": "ventanal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2611,
      "keyword": "ventanal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vestido": [
    {
      "id": 2613,
      "keyword": "vestido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34737,
      "keyword": "vestido",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34739,
      "keyword": "vestido",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vestidos": [
    {
      "id": 2613,
      "keyword": "vestido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34737,
      "keyword": "vestido",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34739,
      "keyword": "vestido",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34739,
      "keyword": "vestidos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ventilador": [
    {
      "id": 2612,
      "keyword": "ventilador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2612,
      "keyword": "ventilador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ventiladores": [
    {
      "id": 2612,
      "keyword": "ventilador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2612,
      "keyword": "ventilador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vino": [
    {
      "id": 2614,
      "keyword": "vino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vinos": [
    {
      "id": 2614,
      "keyword": "vino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vino tinto": [
    {
      "id": 2614,
      "keyword": "vino tinto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vinos tintos": [
    {
      "id": 2614,
      "keyword": "vino tinto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "triángulo": [
    {
      "id": 4763,
      "keyword": "triángulo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2604,
      "keyword": "triángulo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "triángulos": [
    {
      "id": 4763,
      "keyword": "triángulo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2604,
      "keyword": "triángulo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "yo": [
    {
      "id": 6632,
      "keyword": "yo",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7310,
      "keyword": "yo",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2617,
      "keyword": "yo",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7309,
      "keyword": "yo",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31807,
      "keyword": "yo",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "me": [
    {
      "id": 6632,
      "keyword": "me",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7310,
      "keyword": "me",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2617,
      "keyword": "me",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7309,
      "keyword": "me",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31807,
      "keyword": "me",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mí": [
    {
      "id": 6632,
      "keyword": "mí",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7310,
      "keyword": "mí",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2617,
      "keyword": "mí",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7309,
      "keyword": "mí",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31807,
      "keyword": "mí",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yo me": [
    {
      "id": 6632,
      "keyword": "yo me",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7310,
      "keyword": "yo me",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2617,
      "keyword": "yo me",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7309,
      "keyword": "yo me",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31807,
      "keyword": "yo me",
      "keywords": 4,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yogur": [
    {
      "id": 2618,
      "keyword": "yogur",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "ultra-processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34012,
      "keyword": "yogur",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yogures": [
    {
      "id": 2618,
      "keyword": "yogur",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "ultra-processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34012,
      "keyword": "yogur",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zapatos": [
    {
      "id": 2622,
      "keyword": "zapatos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2622,
      "keyword": "zapatos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2775,
      "keyword": "zapatos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2775,
      "keyword": "zapatos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32923,
      "keyword": "zapato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32922,
      "keyword": "zapato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zapatillas": [
    {
      "id": 2620,
      "keyword": "zapatillas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8333,
      "keyword": "zapatilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2621,
      "keyword": "zapatillas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sportswear",
        "clothing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8332,
      "keyword": "zapatilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sportswear",
        "clothing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36679,
      "keyword": "zapatilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36680,
      "keyword": "zapatillas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "deportivas": [
    {
      "id": 2621,
      "keyword": "deportivas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sportswear",
        "clothing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36680,
      "keyword": "deportivas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zanahoria": [
    {
      "id": 2619,
      "keyword": "zanahoria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zanahorias": [
    {
      "id": 2619,
      "keyword": "zanahoria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "violín": [
    {
      "id": 2615,
      "keyword": "violín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "violines": [
    {
      "id": 2615,
      "keyword": "violín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "xilófono": [
    {
      "id": 2616,
      "keyword": "xilófono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6249,
      "keyword": "xilófono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "xilófonos": [
    {
      "id": 2616,
      "keyword": "xilófono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2616,
      "keyword": "xilofón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6249,
      "keyword": "xilófono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6249,
      "keyword": "xilofón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "xilofón": [
    {
      "id": 2616,
      "keyword": "xilofón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6249,
      "keyword": "xilofón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zumo de piña": [
    {
      "id": 2625,
      "keyword": "zumo de piña",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zumos de piña": [
    {
      "id": 2625,
      "keyword": "zumo de piña",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zumo de ananá": [
    {
      "id": 2625,
      "keyword": "zumo de ananá",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zumos de ananá": [
    {
      "id": 2625,
      "keyword": "zumo de ananá",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zorro": [
    {
      "id": 2623,
      "keyword": "zorro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zorros": [
    {
      "id": 2623,
      "keyword": "zorro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "raposo": [
    {
      "id": 2623,
      "keyword": "raposo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "raposos": [
    {
      "id": 2623,
      "keyword": "raposo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zorra": [
    {
      "id": 8712,
      "keyword": "zorra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "mining",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work machine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2623,
      "keyword": "zorra",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zorras": [
    {
      "id": 8712,
      "keyword": "zorra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "mining",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work machine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2623,
      "keyword": "zorra",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "raposa": [
    {
      "id": 2623,
      "keyword": "raposa",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "raposas": [
    {
      "id": 2623,
      "keyword": "raposa",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zumo de naranja": [
    {
      "id": 2624,
      "keyword": "zumo de naranja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zumos de naranja": [
    {
      "id": 2624,
      "keyword": "zumo de naranja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuatro": [
    {
      "id": 39301,
      "keyword": "cuatro",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39316,
      "keyword": "cuatro",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29488,
      "keyword": "cuatro",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2630,
      "keyword": "cuatro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4892,
      "keyword": "cuatro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7005,
      "keyword": "cuatro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35665,
      "keyword": "cuatro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cero": [
    {
      "id": 2626,
      "keyword": "cero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6972,
      "keyword": "cero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35693,
      "keyword": "cero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dos": [
    {
      "id": 39327,
      "keyword": "dos",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29476,
      "keyword": "dos",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2628,
      "keyword": "dos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4890,
      "keyword": "dos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7027,
      "keyword": "dos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35679,
      "keyword": "dos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cinco": [
    {
      "id": 39311,
      "keyword": "cinco",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39359,
      "keyword": "cinco",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29494,
      "keyword": "cinco",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2631,
      "keyword": "cinco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4893,
      "keyword": "cinco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6979,
      "keyword": "cinco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35631,
      "keyword": "cinco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tres": [
    {
      "id": 29482,
      "keyword": "tres",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2629,
      "keyword": "tres",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4891,
      "keyword": "tres",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7283,
      "keyword": "tres",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35681,
      "keyword": "tres",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seis": [
    {
      "id": 39355,
      "keyword": "seis",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39376,
      "keyword": "seis",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29500,
      "keyword": "seis",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2632,
      "keyword": "seis",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4894,
      "keyword": "seis",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7241,
      "keyword": "seis",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35683,
      "keyword": "seis",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ocho": [
    {
      "id": 39346,
      "keyword": "ocho",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39379,
      "keyword": "ocho",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29512,
      "keyword": "ocho",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2634,
      "keyword": "ocho",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4896,
      "keyword": "ocho",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7189,
      "keyword": "ocho",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35687,
      "keyword": "ocho",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "siete": [
    {
      "id": 39351,
      "keyword": "siete",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39383,
      "keyword": "siete",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29506,
      "keyword": "siete",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2633,
      "keyword": "siete",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4895,
      "keyword": "siete",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7248,
      "keyword": "siete",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35685,
      "keyword": "siete",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "uno": [
    {
      "id": 4889,
      "keyword": "uno",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7291,
      "keyword": "uno",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35677,
      "keyword": "uno",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2627,
      "keyword": "uno",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "un": [
    {
      "id": 8474,
      "keyword": "un",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "article"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2627,
      "keyword": "un",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "una": [
    {
      "id": 8474,
      "keyword": "una",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "article"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39296,
      "keyword": "una",
      "keywords": 3,
      "type": 2,
      "tags": [
        "time",
        "unit of time",
        "day hours",
        "communication",
        "language",
        "adverb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29452,
      "keyword": "una",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours",
        "communication",
        "language",
        "adverb",
        "adverb of time"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2627,
      "keyword": "una",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "águila": [
    {
      "id": 2638,
      "keyword": "águila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "águilas": [
    {
      "id": 2638,
      "keyword": "águila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "albañil": [
    {
      "id": 6038,
      "keyword": "albañil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2642,
      "keyword": "albañil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11171,
      "keyword": "albañil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "albañiles": [
    {
      "id": 6038,
      "keyword": "albañil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2642,
      "keyword": "albañil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11171,
      "keyword": "albañil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nueve": [
    {
      "id": 39364,
      "keyword": "nueve",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29518,
      "keyword": "nueve",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2635,
      "keyword": "nueve",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4897,
      "keyword": "nueve",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7188,
      "keyword": "nueve",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35689,
      "keyword": "nueve",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39343,
      "keyword": "nueve",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aire acondicionado": [
    {
      "id": 2640,
      "keyword": "aire acondicionado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aires acondicionados": [
    {
      "id": 2640,
      "keyword": "aire acondicionado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aguja": [
    {
      "id": 11166,
      "keyword": "aguja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2639,
      "keyword": "aguja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agujas": [
    {
      "id": 11166,
      "keyword": "aguja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2639,
      "keyword": "aguja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3353,
      "keyword": "agujas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aguja e hilo": [
    {
      "id": 33904,
      "keyword": "aguja e hilo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2639,
      "keyword": "aguja e hilo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agujas e hilos": [
    {
      "id": 33904,
      "keyword": "aguja e hilo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2639,
      "keyword": "aguja e hilo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abogado": [
    {
      "id": 39079,
      "keyword": "abogado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2636,
      "keyword": "abogado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abogados": [
    {
      "id": 39079,
      "keyword": "abogado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2636,
      "keyword": "abogado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ajo": [
    {
      "id": 2641,
      "keyword": "ajo",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "ajos": [
    {
      "id": 2641,
      "keyword": "ajo",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "abrir la caja": [
    {
      "id": 2637,
      "keyword": "abrir la caja",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alicate": [
    {
      "id": 2644,
      "keyword": "alicate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alicates": [
    {
      "id": 2644,
      "keyword": "alicate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alfileres": [
    {
      "id": 2643,
      "keyword": "alfileres",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8291,
      "keyword": "alfiler",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29788,
      "keyword": "alfiler",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "jewelry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "azada": [
    {
      "id": 2651,
      "keyword": "azada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "gardening",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "azadas": [
    {
      "id": 2651,
      "keyword": "azada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "gardening",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "altavoces": [
    {
      "id": 2647,
      "keyword": "altavoces",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8336,
      "keyword": "altavoz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26628,
      "keyword": "altavoz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almendras": [
    {
      "id": 2646,
      "keyword": "almendras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8292,
      "keyword": "almendra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35143,
      "keyword": "almendra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "avestruz": [
    {
      "id": 2650,
      "keyword": "avestruz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "avestruces": [
    {
      "id": 2650,
      "keyword": "avestruz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "baile": [
    {
      "id": 35747,
      "keyword": "baile",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "scenic art",
        "dance",
        "show",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2652,
      "keyword": "baile",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32562,
      "keyword": "baile",
      "keywords": 4,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bailes": [
    {
      "id": 35747,
      "keyword": "baile",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "scenic art",
        "dance",
        "show",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2652,
      "keyword": "baile",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32562,
      "keyword": "baile",
      "keywords": 4,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bailar": [
    {
      "id": 6052,
      "keyword": "bailar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "scenic art",
        "dance",
        "show",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35747,
      "keyword": "bailar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "scenic art",
        "dance",
        "show",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31434,
      "keyword": "bailar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31435,
      "keyword": "bailar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31436,
      "keyword": "bailar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31437,
      "keyword": "bailar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2652,
      "keyword": "bailar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bailarina": [
    {
      "id": 2653,
      "keyword": "bailarina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bailarinas": [
    {
      "id": 2653,
      "keyword": "bailarina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arquitecto": [
    {
      "id": 28211,
      "keyword": "arquitecto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "architecture",
        "building",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2649,
      "keyword": "arquitecto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "architecture",
        "building",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arquitectos": [
    {
      "id": 28211,
      "keyword": "arquitecto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "architecture",
        "building",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2649,
      "keyword": "arquitecto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "architecture",
        "building",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aparejador": [
    {
      "id": 28211,
      "keyword": "aparejador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "architecture",
        "building",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2649,
      "keyword": "aparejador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "architecture",
        "building",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aparejadores": [
    {
      "id": 28211,
      "keyword": "aparejador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "architecture",
        "building",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2649,
      "keyword": "aparejador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "architecture",
        "building",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bajar las escaleras": [
    {
      "id": 2654,
      "keyword": "bajar las escaleras",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28451,
      "keyword": "bajar las escaleras",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bandeja": [
    {
      "id": 2656,
      "keyword": "bandeja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6928,
      "keyword": "bandeja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39254,
      "keyword": "bandeja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bandejas": [
    {
      "id": 2656,
      "keyword": "bandeja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6928,
      "keyword": "bandeja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39254,
      "keyword": "bandeja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barrer": [
    {
      "id": 6059,
      "keyword": "barrer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product",
        "place"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2658,
      "keyword": "barrer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product",
        "place"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29742,
      "keyword": "barrer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "báscula": [
    {
      "id": 2659,
      "keyword": "báscula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31284,
      "keyword": "báscula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2655,
      "keyword": "báscula",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "básculas": [
    {
      "id": 2659,
      "keyword": "báscula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31284,
      "keyword": "báscula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2655,
      "keyword": "báscula",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almeja": [
    {
      "id": 2645,
      "keyword": "almeja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almejas": [
    {
      "id": 2645,
      "keyword": "almeja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "berenjena": [
    {
      "id": 2660,
      "keyword": "berenjena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "berenjenas": [
    {
      "id": 2660,
      "keyword": "berenjena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bigote": [
    {
      "id": 2661,
      "keyword": "bigote",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bigotes": [
    {
      "id": 27601,
      "keyword": "bigotes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2661,
      "keyword": "bigote",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mostacho": [
    {
      "id": 2661,
      "keyword": "mostacho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mostachos": [
    {
      "id": 2661,
      "keyword": "mostacho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "blanco": [
    {
      "id": 8043,
      "keyword": "blanco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2662,
      "keyword": "blanco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "blancos": [
    {
      "id": 8043,
      "keyword": "blanco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2662,
      "keyword": "blanco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "blanca": [
    {
      "id": 8043,
      "keyword": "blanca",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2662,
      "keyword": "blanca",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9123,
      "keyword": "blanca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "blancas": [
    {
      "id": 8043,
      "keyword": "blanca",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2662,
      "keyword": "blanca",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9123,
      "keyword": "blanca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "balanza": [
    {
      "id": 36883,
      "keyword": "balanza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2655,
      "keyword": "balanza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balanzas": [
    {
      "id": 36883,
      "keyword": "balanza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2655,
      "keyword": "balanza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barba": [
    {
      "id": 2657,
      "keyword": "barba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barbas": [
    {
      "id": 2657,
      "keyword": "barba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bosque": [
    {
      "id": 2666,
      "keyword": "bosque",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "natural habitat",
        "plant",
        "tree",
        "leisure",
        "outdoor activity",
        "mountain",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bosques": [
    {
      "id": 2666,
      "keyword": "bosque",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "natural habitat",
        "plant",
        "tree",
        "leisure",
        "outdoor activity",
        "mountain",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bombones": [
    {
      "id": 2665,
      "keyword": "bombones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8298,
      "keyword": "bombón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amarillo": [
    {
      "id": 2648,
      "keyword": "amarillo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "amarillos": [
    {
      "id": 2648,
      "keyword": "amarillo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amarilla": [
    {
      "id": 2648,
      "keyword": "amarilla",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "amarillas": [
    {
      "id": 2648,
      "keyword": "amarilla",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "boca": [
    {
      "id": 2663,
      "keyword": "boca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system",
        "respiratory system",
        "covid-19",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bocas": [
    {
      "id": 2663,
      "keyword": "boca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system",
        "respiratory system",
        "covid-19",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bombero": [
    {
      "id": 6066,
      "keyword": "bombero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2664,
      "keyword": "bombero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bomberos": [
    {
      "id": 6066,
      "keyword": "bombero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2664,
      "keyword": "bombero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caballito de mar": [
    {
      "id": 2672,
      "keyword": "caballito de mar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "ovoviviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caballitos de mar": [
    {
      "id": 2672,
      "keyword": "caballito de mar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "ovoviviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hipocampo": [
    {
      "id": 2672,
      "keyword": "hipocampo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "ovoviviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hipocampos": [
    {
      "id": 2672,
      "keyword": "hipocampo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "ovoviviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cabeza": [
    {
      "id": 2673,
      "keyword": "cabeza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cabezas": [
    {
      "id": 2673,
      "keyword": "cabeza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "búho": [
    {
      "id": 24905,
      "keyword": "búho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "event",
        "popular event",
        "halloween",
        "wild"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2671,
      "keyword": "búho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "búhos": [
    {
      "id": 24905,
      "keyword": "búho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "event",
        "popular event",
        "halloween",
        "wild"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2671,
      "keyword": "búho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "brazo": [
    {
      "id": 2669,
      "keyword": "brazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2669,
      "keyword": "brazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38901,
      "keyword": "brazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brazos": [
    {
      "id": 2669,
      "keyword": "brazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2669,
      "keyword": "brazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38901,
      "keyword": "brazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "brocha": [
    {
      "id": 2670,
      "keyword": "brocha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2837,
      "keyword": "brocha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brochas": [
    {
      "id": 2670,
      "keyword": "brocha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2837,
      "keyword": "brocha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cacahuetes": [
    {
      "id": 2674,
      "keyword": "cacahuetes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit",
        "legume"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8338,
      "keyword": "cacahuete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maníes": [
    {
      "id": 2674,
      "keyword": "maníes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit",
        "legume"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8338,
      "keyword": "maní",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dejar caer el vaso": [
    {
      "id": 2675,
      "keyword": "dejar caer el vaso",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soltar el vaso": [
    {
      "id": 2675,
      "keyword": "soltar el vaso",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caja de herramientas": [
    {
      "id": 2676,
      "keyword": "caja de herramientas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajas de herramientas": [
    {
      "id": 2676,
      "keyword": "caja de herramientas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caja registradora": [
    {
      "id": 2677,
      "keyword": "caja registradora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajas registradoras": [
    {
      "id": 2677,
      "keyword": "caja registradora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calabaza": [
    {
      "id": 2679,
      "keyword": "calabaza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6951,
      "keyword": "calabaza",
      "keywords": 6,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calabazas": [
    {
      "id": 2679,
      "keyword": "calabaza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6951,
      "keyword": "calabaza",
      "keywords": 6,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zapallo": [
    {
      "id": 2679,
      "keyword": "zapallo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6951,
      "keyword": "zapallo",
      "keywords": 6,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zapallos": [
    {
      "id": 2679,
      "keyword": "zapallo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6951,
      "keyword": "zapallo",
      "keywords": 6,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón": [
    {
      "id": 2668,
      "keyword": "botón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2668,
      "keyword": "botón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones": [
    {
      "id": 38760,
      "keyword": "botones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2668,
      "keyword": "botón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2668,
      "keyword": "botón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camarero": [
    {
      "id": 6072,
      "keyword": "camarero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33038,
      "keyword": "camarero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2681,
      "keyword": "camarero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camareros": [
    {
      "id": 6072,
      "keyword": "camarero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33038,
      "keyword": "camarero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2681,
      "keyword": "camarero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barman": [
    {
      "id": 2681,
      "keyword": "barman",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bármanes": [
    {
      "id": 2681,
      "keyword": "barman",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesero": [
    {
      "id": 2681,
      "keyword": "mesero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meseros": [
    {
      "id": 2681,
      "keyword": "mesero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calabacín": [
    {
      "id": 2678,
      "keyword": "calabacín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calabacines": [
    {
      "id": 2678,
      "keyword": "calabacín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hormigonera": [
    {
      "id": 2976,
      "keyword": "hormigonera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2682,
      "keyword": "hormigonera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "work machine",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hormigoneras": [
    {
      "id": 2976,
      "keyword": "hormigonera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2682,
      "keyword": "hormigonera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "work machine",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camión hormigonera": [
    {
      "id": 2682,
      "keyword": "camión hormigonera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "work machine",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camiones hormigonera": [
    {
      "id": 2682,
      "keyword": "camión hormigonera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "work machine",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "campo": [
    {
      "id": 25916,
      "keyword": "campo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "workplace",
        "place",
        "rural area"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2683,
      "keyword": "campo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "work",
        "primary sector",
        "agriculture",
        "cattle farming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3073,
      "keyword": "campo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "football",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campos": [
    {
      "id": 25916,
      "keyword": "campo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "workplace",
        "place",
        "rural area"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2683,
      "keyword": "campo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "work",
        "primary sector",
        "agriculture",
        "cattle farming"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3073,
      "keyword": "campo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "football",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cara": [
    {
      "id": 2684,
      "keyword": "cara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2684,
      "keyword": "cara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4589,
      "keyword": "cara",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31915,
      "keyword": "cara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37138,
      "keyword": "cara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caras": [
    {
      "id": 2684,
      "keyword": "cara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2684,
      "keyword": "cara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4589,
      "keyword": "cara",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31915,
      "keyword": "cara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37138,
      "keyword": "cara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rostro": [
    {
      "id": 2684,
      "keyword": "rostro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2684,
      "keyword": "rostro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31915,
      "keyword": "rostro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37138,
      "keyword": "rostro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rostros": [
    {
      "id": 2684,
      "keyword": "rostro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2684,
      "keyword": "rostro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31915,
      "keyword": "rostro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37138,
      "keyword": "rostro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caracol": [
    {
      "id": 8061,
      "keyword": "caracol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "terrestrial animal",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2685,
      "keyword": "caracol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caracoles": [
    {
      "id": 8061,
      "keyword": "caracol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "terrestrial animal",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2685,
      "keyword": "caracol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cámara": [
    {
      "id": 24925,
      "keyword": "cámara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "visual art",
        "photography",
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25904,
      "keyword": "cámara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "visual art",
        "photography",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2680,
      "keyword": "cámara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "visual art",
        "photography",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cámaras": [
    {
      "id": 24925,
      "keyword": "cámara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "visual art",
        "photography",
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25904,
      "keyword": "cámara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "visual art",
        "photography",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2680,
      "keyword": "cámara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "visual art",
        "photography",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cámara de fotos": [
    {
      "id": 24925,
      "keyword": "cámara de fotos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "visual art",
        "photography",
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25904,
      "keyword": "cámara de fotos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "visual art",
        "photography",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2680,
      "keyword": "cámara de fotos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "visual art",
        "photography",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cámaras de fotos": [
    {
      "id": 24925,
      "keyword": "cámara de fotos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "visual art",
        "photography",
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25904,
      "keyword": "cámara de fotos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "visual art",
        "photography",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2680,
      "keyword": "cámara de fotos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "visual art",
        "photography",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cemento": [
    {
      "id": 2692,
      "keyword": "cemento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cementos": [
    {
      "id": 2692,
      "keyword": "cemento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carta": [
    {
      "id": 2688,
      "keyword": "carta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6963,
      "keyword": "carta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36356,
      "keyword": "carta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cartas": [
    {
      "id": 2688,
      "keyword": "carta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6963,
      "keyword": "carta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3181,
      "keyword": "cartas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "card game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36356,
      "keyword": "carta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3182,
      "keyword": "cartas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "card game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "correspondencia": [
    {
      "id": 2688,
      "keyword": "correspondencia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "correspondencias": [
    {
      "id": 2688,
      "keyword": "correspondencia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casco": [
    {
      "id": 2691,
      "keyword": "casco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21518,
      "keyword": "casco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3076,
      "keyword": "casco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3075,
      "keyword": "casco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10354,
      "keyword": "casco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28195,
      "keyword": "casco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "horse riding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28191,
      "keyword": "casco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36103,
      "keyword": "casco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36509,
      "keyword": "casco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "history",
        "civilization",
        "Rome",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37536,
      "keyword": "casco",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "karate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cascos": [
    {
      "id": 2691,
      "keyword": "casco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21518,
      "keyword": "casco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3076,
      "keyword": "casco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3075,
      "keyword": "casco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "cycling"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10354,
      "keyword": "casco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11208,
      "keyword": "cascos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28195,
      "keyword": "casco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "horse riding"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28191,
      "keyword": "casco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "skating"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36103,
      "keyword": "casco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36509,
      "keyword": "casco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "history",
        "civilization",
        "Rome",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37536,
      "keyword": "casco",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "karate"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cartero": [
    {
      "id": 38546,
      "keyword": "cartero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2690,
      "keyword": "cartero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carteros": [
    {
      "id": 38546,
      "keyword": "cartero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2690,
      "keyword": "cartero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cepillo": [
    {
      "id": 2694,
      "keyword": "cepillo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary",
        "health",
        "odontology"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2694,
      "keyword": "cepillo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary",
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2695,
      "keyword": "cepillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2693,
      "keyword": "cepillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5953,
      "keyword": "cepillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38813,
      "keyword": "cepillo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "health",
        "odontology",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cepillos": [
    {
      "id": 2694,
      "keyword": "cepillo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary",
        "health",
        "odontology"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2694,
      "keyword": "cepillo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary",
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2695,
      "keyword": "cepillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2693,
      "keyword": "cepillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5953,
      "keyword": "cepillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38813,
      "keyword": "cepillo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "health",
        "odontology",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cepillo de pelo": [
    {
      "id": 2695,
      "keyword": "cepillo de pelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cepillos de pelo": [
    {
      "id": 2695,
      "keyword": "cepillo de pelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escoba": [
    {
      "id": 2745,
      "keyword": "escoba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8563,
      "keyword": "escoba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2693,
      "keyword": "escoba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escobas": [
    {
      "id": 2745,
      "keyword": "escoba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8563,
      "keyword": "escoba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2693,
      "keyword": "escoba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cepillo de dientes": [
    {
      "id": 2694,
      "keyword": "cepillo de dientes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary",
        "health",
        "odontology"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2694,
      "keyword": "cepillo de dientes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary",
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38813,
      "keyword": "cepillo de dientes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "health",
        "odontology",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cepillos de dientes": [
    {
      "id": 2694,
      "keyword": "cepillo de dientes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary",
        "health",
        "odontology"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2694,
      "keyword": "cepillo de dientes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary",
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38813,
      "keyword": "cepillo de dientes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "health",
        "odontology",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cepillo dental": [
    {
      "id": 2694,
      "keyword": "cepillo dental",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary",
        "health",
        "odontology"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2694,
      "keyword": "cepillo dental",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary",
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38813,
      "keyword": "cepillo dental",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "health",
        "odontology",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cepillos dentales": [
    {
      "id": 2694,
      "keyword": "cepillo dental",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary",
        "health",
        "odontology"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2694,
      "keyword": "cepillo dental",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary",
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38813,
      "keyword": "cepillo dental",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "health",
        "odontology",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerebro": [
    {
      "id": 2696,
      "keyword": "cerebro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerebros": [
    {
      "id": 2696,
      "keyword": "cerebro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "seso": [
    {
      "id": 2696,
      "keyword": "seso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sesos": [
    {
      "id": 2696,
      "keyword": "seso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerrar": [
    {
      "id": 24976,
      "keyword": "cerrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2697,
      "keyword": "cerrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6973,
      "keyword": "cerrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "literature",
        "library science"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7056,
      "keyword": "cerrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10146,
      "keyword": "cerrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "visual system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carpintero": [
    {
      "id": 6076,
      "keyword": "carpintero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "carpentry",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2687,
      "keyword": "carpintero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "carpentry",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carpinteros": [
    {
      "id": 6076,
      "keyword": "carpintero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "carpentry",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2687,
      "keyword": "carpintero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "carpentry",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chaleco": [
    {
      "id": 2698,
      "keyword": "chaleco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2698,
      "keyword": "chaleco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chalecos": [
    {
      "id": 2698,
      "keyword": "chaleco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2698,
      "keyword": "chaleco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "champú": [
    {
      "id": 2699,
      "keyword": "champú",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "champús": [
    {
      "id": 2699,
      "keyword": "champú",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "charcutería": [
    {
      "id": 6446,
      "keyword": "charcutería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35705,
      "keyword": "charcutería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2700,
      "keyword": "charcutería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "charcuterías": [
    {
      "id": 6446,
      "keyword": "charcutería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35705,
      "keyword": "charcutería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2700,
      "keyword": "charcutería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ciruelas": [
    {
      "id": 2703,
      "keyword": "ciruelas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8305,
      "keyword": "ciruela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chupar": [
    {
      "id": 39016,
      "keyword": "chupar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6449,
      "keyword": "chupar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16611,
      "keyword": "chupar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29610,
      "keyword": "chupar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16609,
      "keyword": "chupar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28231,
      "keyword": "chupar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2702,
      "keyword": "chupar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15355,
      "keyword": "chupar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29608,
      "keyword": "chupar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29609,
      "keyword": "chupar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37025,
      "keyword": "chupar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37026,
      "keyword": "chupar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15353,
      "keyword": "chupar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "billetera": [
    {
      "id": 2689,
      "keyword": "billetera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "billeteras": [
    {
      "id": 2689,
      "keyword": "billetera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cartera": [
    {
      "id": 38546,
      "keyword": "cartera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11207,
      "keyword": "cartera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2689,
      "keyword": "cartera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7053,
      "keyword": "cartera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carteras": [
    {
      "id": 38546,
      "keyword": "cartera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11207,
      "keyword": "cartera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2689,
      "keyword": "cartera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7053,
      "keyword": "cartera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ciudad": [
    {
      "id": 5963,
      "keyword": "ciudad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2704,
      "keyword": "ciudad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2704,
      "keyword": "ciudad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciudades": [
    {
      "id": 5963,
      "keyword": "ciudad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2704,
      "keyword": "ciudad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2704,
      "keyword": "ciudad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clavos": [
    {
      "id": 2706,
      "keyword": "clavos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8306,
      "keyword": "clavo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "codo": [
    {
      "id": 2707,
      "keyword": "codo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "joint system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "codos": [
    {
      "id": 2707,
      "keyword": "codo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "joint system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cola": [
    {
      "id": 2709,
      "keyword": "cola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "work",
        "tool",
        "secondary sector",
        "carpentry",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2709,
      "keyword": "cola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "work",
        "tool",
        "secondary sector",
        "carpentry",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5967,
      "keyword": "cola",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colas": [
    {
      "id": 2709,
      "keyword": "cola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "work",
        "tool",
        "secondary sector",
        "carpentry",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2709,
      "keyword": "cola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "work",
        "tool",
        "secondary sector",
        "carpentry",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5967,
      "keyword": "cola",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perfume": [
    {
      "id": 35673,
      "keyword": "perfume",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2710,
      "keyword": "perfume",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perfumes": [
    {
      "id": 35673,
      "keyword": "perfume",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2710,
      "keyword": "perfume",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colonia": [
    {
      "id": 25974,
      "keyword": "colonia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "leisure",
        "facility",
        "recreational facility",
        "core vocabulary",
        "summer"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25976,
      "keyword": "colonia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "leisure",
        "facility",
        "recreational facility",
        "summer"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32416,
      "keyword": "colonia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "leisure",
        "facility",
        "recreational facility",
        "summer"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35673,
      "keyword": "colonia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2710,
      "keyword": "colonia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11222,
      "keyword": "colonia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "leisure",
        "facility",
        "recreational facility",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colonias": [
    {
      "id": 25974,
      "keyword": "colonia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "leisure",
        "facility",
        "recreational facility",
        "core vocabulary",
        "summer"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25976,
      "keyword": "colonia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "leisure",
        "facility",
        "recreational facility",
        "summer"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32416,
      "keyword": "colonia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "leisure",
        "facility",
        "recreational facility",
        "summer"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32416,
      "keyword": "colonias",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "leisure",
        "facility",
        "recreational facility",
        "summer"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35673,
      "keyword": "colonia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2710,
      "keyword": "colonia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11222,
      "keyword": "colonia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "leisure",
        "facility",
        "recreational facility",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conducir": [
    {
      "id": 6458,
      "keyword": "conducir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2712,
      "keyword": "conducir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manejar": [
    {
      "id": 6458,
      "keyword": "manejar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2712,
      "keyword": "manejar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contar": [
    {
      "id": 6461,
      "keyword": "contar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "literature"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2714,
      "keyword": "contar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "usual verbs",
        "core vocabulary",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5973,
      "keyword": "contar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "construir": [
    {
      "id": 25988,
      "keyword": "construir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2713,
      "keyword": "construir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35739,
      "keyword": "construir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corazón": [
    {
      "id": 4613,
      "keyword": "corazón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2715,
      "keyword": "corazón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6996,
      "keyword": "corazón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corazones": [
    {
      "id": 4613,
      "keyword": "corazón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2715,
      "keyword": "corazón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6996,
      "keyword": "corazón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "corbata": [
    {
      "id": 4614,
      "keyword": "corbata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 4614,
      "keyword": "corbata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2716,
      "keyword": "corbata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corbatas": [
    {
      "id": 4614,
      "keyword": "corbata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 4614,
      "keyword": "corbata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2716,
      "keyword": "corbata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coro": [
    {
      "id": 2717,
      "keyword": "coro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "music",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coros": [
    {
      "id": 39268,
      "keyword": " coro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "music",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2717,
      "keyword": "coro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "music",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coral": [
    {
      "id": 35269,
      "keyword": "coral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "aquatic animal",
        "marine animal",
        "sea",
        "carnivorous",
        "oceanography",
        "geography",
        "physical geography",
        "landform",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2717,
      "keyword": "coral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "music",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corales": [
    {
      "id": 35269,
      "keyword": "coral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "aquatic animal",
        "marine animal",
        "sea",
        "carnivorous",
        "oceanography",
        "geography",
        "physical geography",
        "landform",
        "ocean"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2717,
      "keyword": "coral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "music",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "corona": [
    {
      "id": 25016,
      "keyword": "corona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume",
        "event",
        "popular event",
        "christmas",
        "history",
        "character",
        "historical character",
        "social event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2718,
      "keyword": "corona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3085,
      "keyword": "corona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25992,
      "keyword": "corona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36231,
      "keyword": "corona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coronas": [
    {
      "id": 25016,
      "keyword": "corona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume",
        "event",
        "popular event",
        "christmas",
        "history",
        "character",
        "historical character",
        "social event"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2718,
      "keyword": "corona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3085,
      "keyword": "corona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25992,
      "keyword": "corona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36231,
      "keyword": "corona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chupa-chups": [
    {
      "id": 2701,
      "keyword": "chupa-chups",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chupachup": [
    {
      "id": 2701,
      "keyword": "chupachup",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chupachups": [
    {
      "id": 2701,
      "keyword": "chupachup",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "correr": [
    {
      "id": 6465,
      "keyword": "correr",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "leisure",
        "sport",
        "physical exercise",
        "core vocabulary",
        "animal",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32093,
      "keyword": "correr",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "adapted sport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39403,
      "keyword": "correr",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "adapted sport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2719,
      "keyword": "correr",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28439,
      "keyword": "correr",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28921,
      "keyword": "correr",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31841,
      "keyword": "correr",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "adapted sport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8544,
      "keyword": "correr",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortar el pollo": [
    {
      "id": 2720,
      "keyword": "cortar el pollo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "animal-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortauñas": [
    {
      "id": 2721,
      "keyword": "cortauñas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coser": [
    {
      "id": 2722,
      "keyword": "coser",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "clothing industry",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7068,
      "keyword": "coser",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cremallera": [
    {
      "id": 2723,
      "keyword": "cremallera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cremalleras": [
    {
      "id": 2723,
      "keyword": "cremallera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cierre": [
    {
      "id": 2723,
      "keyword": "cierre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cierres": [
    {
      "id": 2723,
      "keyword": "cierre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuello": [
    {
      "id": 2727,
      "keyword": "cuello",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2727,
      "keyword": "cuello",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25040,
      "keyword": "cuello",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuellos": [
    {
      "id": 2727,
      "keyword": "cuello",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2727,
      "keyword": "cuello",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25040,
      "keyword": "cuello",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cubo": [
    {
      "id": 34363,
      "keyword": "cubo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "summer",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9115,
      "keyword": "cubo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2725,
      "keyword": "cubo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "container"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8308,
      "keyword": "cubo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubos": [
    {
      "id": 34363,
      "keyword": "cubo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "summer",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9115,
      "keyword": "cubo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2725,
      "keyword": "cubo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "container"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8308,
      "keyword": "cubo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "balde": [
    {
      "id": 2725,
      "keyword": "balde",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baldes": [
    {
      "id": 2725,
      "keyword": "balde",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuerpo": [
    {
      "id": 6473,
      "keyword": "cuerpo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 6473,
      "keyword": "cuerpo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17018,
      "keyword": "cuerpo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17022,
      "keyword": "cuerpo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2728,
      "keyword": "cuerpo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuerpos": [
    {
      "id": 6473,
      "keyword": "cuerpo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 6473,
      "keyword": "cuerpo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 17018,
      "keyword": "cuerpo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "position"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 17022,
      "keyword": "cuerpo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "position"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2728,
      "keyword": "cuerpo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cueva": [
    {
      "id": 2729,
      "keyword": "cueva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuevas": [
    {
      "id": 2729,
      "keyword": "cueva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caverna": [
    {
      "id": 2729,
      "keyword": "caverna",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cavernas": [
    {
      "id": 2729,
      "keyword": "caverna",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "culo": [
    {
      "id": 26030,
      "keyword": "culo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 26030,
      "keyword": "culo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2730,
      "keyword": "culo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "culos": [
    {
      "id": 26030,
      "keyword": "culo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 26030,
      "keyword": "culo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2730,
      "keyword": "culo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nalgas": [
    {
      "id": 26030,
      "keyword": "nalgas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 26030,
      "keyword": "nalgas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2730,
      "keyword": "nalgas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dado": [
    {
      "id": 2731,
      "keyword": "dado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dados": [
    {
      "id": 2731,
      "keyword": "dado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3089,
      "keyword": "dados",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "gambling",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "delfín": [
    {
      "id": 2732,
      "keyword": "delfín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "delfines": [
    {
      "id": 2732,
      "keyword": "delfín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cubo de basura": [
    {
      "id": 2724,
      "keyword": "cubo de basura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37417,
      "keyword": "cubo de basura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture",
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39032,
      "keyword": "cubo de basura",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39033,
      "keyword": "cubo de basura",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39034,
      "keyword": "cubo de basura",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39035,
      "keyword": "cubo de basura",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubos de basura": [
    {
      "id": 2724,
      "keyword": "cubo de basura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37417,
      "keyword": "cubo de basura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture",
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39032,
      "keyword": "cubo de basura",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39033,
      "keyword": "cubo de basura",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39034,
      "keyword": "cubo de basura",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39035,
      "keyword": "cubo de basura",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuchilla": [
    {
      "id": 2726,
      "keyword": "cuchilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuchillas": [
    {
      "id": 2726,
      "keyword": "cuchilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuchilla de afeitar": [
    {
      "id": 2726,
      "keyword": "cuchilla de afeitar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuchillas de afeitar": [
    {
      "id": 2726,
      "keyword": "cuchilla de afeitar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dentista": [
    {
      "id": 38834,
      "keyword": "dentista",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38886,
      "keyword": "dentista",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39141,
      "keyword": "dentista",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2733,
      "keyword": "dentista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11229,
      "keyword": "dentista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dentistas": [
    {
      "id": 38834,
      "keyword": "dentista",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38886,
      "keyword": "dentista",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39141,
      "keyword": "dentista",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2733,
      "keyword": "dentista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11229,
      "keyword": "dentista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "odontóloga": [
    {
      "id": 38834,
      "keyword": "odontóloga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38886,
      "keyword": "odontóloga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39141,
      "keyword": "odontóloga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2733,
      "keyword": "odontóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "odontólogas": [
    {
      "id": 38834,
      "keyword": "odontóloga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38886,
      "keyword": "odontóloga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39141,
      "keyword": "odontóloga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2733,
      "keyword": "odontóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desierto": [
    {
      "id": 2734,
      "keyword": "desierto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "natural habitat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desiertos": [
    {
      "id": 2734,
      "keyword": "desierto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "natural habitat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dinosaurio": [
    {
      "id": 25058,
      "keyword": "dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2738,
      "keyword": "dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dinosaurios": [
    {
      "id": 25058,
      "keyword": "dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2738,
      "keyword": "dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dientes": [
    {
      "id": 2737,
      "keyword": "dientes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system",
        "health",
        "odontology",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10267,
      "keyword": "diente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system",
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dentadura": [
    {
      "id": 2737,
      "keyword": "dentadura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system",
        "health",
        "odontology",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dentaduras": [
    {
      "id": 2737,
      "keyword": "dentadura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system",
        "health",
        "odontology",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desodorante": [
    {
      "id": 2735,
      "keyword": "desodorante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2735,
      "keyword": "desodorante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desodorantes": [
    {
      "id": 2735,
      "keyword": "desodorante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2735,
      "keyword": "desodorante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "destornillador": [
    {
      "id": 2736,
      "keyword": "destornillador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "destornilladores": [
    {
      "id": 2736,
      "keyword": "destornillador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "electricista": [
    {
      "id": 6482,
      "keyword": "electricista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2740,
      "keyword": "electricista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11249,
      "keyword": "electricista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "electricistas": [
    {
      "id": 6482,
      "keyword": "electricista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2740,
      "keyword": "electricista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11249,
      "keyword": "electricista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "embudo": [
    {
      "id": 2741,
      "keyword": "embudo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "embudos": [
    {
      "id": 2741,
      "keyword": "embudo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dorado": [
    {
      "id": 2739,
      "keyword": "dorado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dorados": [
    {
      "id": 2739,
      "keyword": "dorado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dorada": [
    {
      "id": 25662,
      "keyword": "dorada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21806,
      "keyword": "dorada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "feeding",
        "food",
        "animal-based food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2739,
      "keyword": "dorada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "doradas": [
    {
      "id": 25662,
      "keyword": "dorada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21806,
      "keyword": "dorada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "feeding",
        "food",
        "animal-based food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2739,
      "keyword": "dorada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "entrar": [
    {
      "id": 6491,
      "keyword": "entrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26811,
      "keyword": "entrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2742,
      "keyword": "entrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28687,
      "keyword": "entrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acceder": [
    {
      "id": 6491,
      "keyword": "acceder",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26811,
      "keyword": "acceder",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2742,
      "keyword": "acceder",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28687,
      "keyword": "acceder",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esmalte de uñas": [
    {
      "id": 2747,
      "keyword": "esmalte de uñas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esmaltes de uñas": [
    {
      "id": 2747,
      "keyword": "esmalte de uñas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pintaúñas": [
    {
      "id": 2747,
      "keyword": "pintaúñas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esmalte": [
    {
      "id": 2747,
      "keyword": "esmalte",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esmaltes": [
    {
      "id": 2747,
      "keyword": "esmalte",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "laca de uñas": [
    {
      "id": 2747,
      "keyword": "laca de uñas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lacas de uñas": [
    {
      "id": 2747,
      "keyword": "laca de uñas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espalda": [
    {
      "id": 2748,
      "keyword": "espalda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2748,
      "keyword": "espalda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25075,
      "keyword": "espalda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espaldas": [
    {
      "id": 2748,
      "keyword": "espalda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2748,
      "keyword": "espalda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esponja": [
    {
      "id": 2749,
      "keyword": "esponja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary",
        "human body"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2749,
      "keyword": "esponja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary",
        "human body"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7098,
      "keyword": "esponja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "household",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esponjas": [
    {
      "id": 2749,
      "keyword": "esponja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary",
        "human body"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2749,
      "keyword": "esponja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary",
        "human body"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7098,
      "keyword": "esponja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "household",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espuma de afeitar": [
    {
      "id": 2750,
      "keyword": "espuma de afeitar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espumas de afeitar": [
    {
      "id": 2750,
      "keyword": "espuma de afeitar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estanco": [
    {
      "id": 2751,
      "keyword": "estanco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estancos": [
    {
      "id": 2751,
      "keyword": "estanco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estrella": [
    {
      "id": 4644,
      "keyword": "estrella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2752,
      "keyword": "estrella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3100,
      "keyword": "estrella",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estrellas": [
    {
      "id": 4644,
      "keyword": "estrella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2752,
      "keyword": "estrella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3100,
      "keyword": "estrella",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6978,
      "keyword": "estrellas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escarpia": [
    {
      "id": 2744,
      "keyword": "escarpia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escarpias": [
    {
      "id": 2744,
      "keyword": "escarpia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alcayata": [
    {
      "id": 2744,
      "keyword": "alcayata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alcayatas": [
    {
      "id": 2744,
      "keyword": "alcayata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zapatería": [
    {
      "id": 6633,
      "keyword": "zapatería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "footwear",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2776,
      "keyword": "zapatería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zapaterías": [
    {
      "id": 6633,
      "keyword": "zapatería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "footwear",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2776,
      "keyword": "zapatería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vomitar": [
    {
      "id": 7303,
      "keyword": "vomitar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2777,
      "keyword": "vomitar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28739,
      "keyword": "vomitar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "potar": [
    {
      "id": 7303,
      "keyword": "potar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2777,
      "keyword": "potar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28739,
      "keyword": "potar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "villancico": [
    {
      "id": 2778,
      "keyword": "villancico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "villancicos": [
    {
      "id": 2778,
      "keyword": "villancico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ventoso": [
    {
      "id": 2779,
      "keyword": "ventoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35107,
      "keyword": "ventoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ventosos": [
    {
      "id": 2779,
      "keyword": "ventoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35107,
      "keyword": "ventoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ventosa": [
    {
      "id": 2779,
      "keyword": "ventosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35107,
      "keyword": "ventosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ventosas": [
    {
      "id": 2779,
      "keyword": "ventosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35107,
      "keyword": "ventosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escuchar música": [
    {
      "id": 35741,
      "keyword": "escuchar música",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "mass media",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "mass media device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29720,
      "keyword": "escuchar música",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "event",
        "popular event",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37486,
      "keyword": "escuchar música",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "mass media",
        "object",
        "appliance",
        "mass media device",
        "computing",
        "hardware",
        "music device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2746,
      "keyword": "escuchar música",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "mass media",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "mass media device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29718,
      "keyword": "escuchar música",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29719,
      "keyword": "escuchar música",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32131,
      "keyword": "escuchar música",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "mass media",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "mass media device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35719,
      "keyword": "escuchar música",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "mass media",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "mass media device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oír música": [
    {
      "id": 35741,
      "keyword": "oír música",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "mass media",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "mass media device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29720,
      "keyword": "oír música",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "event",
        "popular event",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37486,
      "keyword": "oír música",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "mass media",
        "object",
        "appliance",
        "mass media device",
        "computing",
        "hardware",
        "music device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2746,
      "keyword": "oír música",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "mass media",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "mass media device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29718,
      "keyword": "oír música",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29719,
      "keyword": "oír música",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35719,
      "keyword": "oír música",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "mass media",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "mass media device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "col": [
    {
      "id": 2708,
      "keyword": "col",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coles": [
    {
      "id": 2708,
      "keyword": "col",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "repollo": [
    {
      "id": 2708,
      "keyword": "repollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "repollos": [
    {
      "id": 2708,
      "keyword": "repollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caramelo": [
    {
      "id": 2686,
      "keyword": "caramelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15347,
      "keyword": "caramelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caramelos": [
    {
      "id": 2686,
      "keyword": "caramelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15347,
      "keyword": "caramelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clavar": [
    {
      "id": 6451,
      "keyword": "clavar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2705,
      "keyword": "clavar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ver la televisión": [
    {
      "id": 29123,
      "keyword": "ver la televisión",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6626,
      "keyword": "ver la televisión",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7296,
      "keyword": "ver la televisión",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16905,
      "keyword": "ver la televisión",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2782,
      "keyword": "ver la televisión",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28661,
      "keyword": "ver la televisión",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29124,
      "keyword": "ver la televisión",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29125,
      "keyword": "ver la televisión",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ver la tele": [
    {
      "id": 29123,
      "keyword": "ver la tele",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6626,
      "keyword": "ver la tele",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7296,
      "keyword": "ver la tele",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16905,
      "keyword": "ver la tele",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2782,
      "keyword": "ver la tele",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28661,
      "keyword": "ver la tele",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29124,
      "keyword": "ver la tele",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29125,
      "keyword": "ver la tele",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veterinaria": [
    {
      "id": 2780,
      "keyword": "veterinaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "veterinary medicine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veterinarias": [
    {
      "id": 2780,
      "keyword": "veterinaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "veterinary medicine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "uña": [
    {
      "id": 2783,
      "keyword": "uña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "uñas": [
    {
      "id": 2783,
      "keyword": "uña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tostada": [
    {
      "id": 2787,
      "keyword": "tostada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tostadas": [
    {
      "id": 2787,
      "keyword": "tostada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "turrón": [
    {
      "id": 2784,
      "keyword": "turrón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36474,
      "keyword": "turrón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36475,
      "keyword": "turrón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "turrones": [
    {
      "id": 2784,
      "keyword": "turrón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36474,
      "keyword": "turrón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36475,
      "keyword": "turrón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tornillo": [
    {
      "id": 2788,
      "keyword": "tornillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35161,
      "keyword": "tornillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tornillos": [
    {
      "id": 2788,
      "keyword": "tornillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35161,
      "keyword": "tornillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24280,
      "keyword": "tornillos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tenaza": [
    {
      "id": 2790,
      "keyword": "tenaza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24292,
      "keyword": "tenaza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tenazas": [
    {
      "id": 2790,
      "keyword": "tenaza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24292,
      "keyword": "tenaza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tripa": [
    {
      "id": 2786,
      "keyword": "tripa",
      "keywords": 4,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2786,
      "keyword": "tripa",
      "keywords": 4,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tripas": [
    {
      "id": 2786,
      "keyword": "tripa",
      "keywords": 4,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2786,
      "keyword": "tripa",
      "keywords": 4,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barriga": [
    {
      "id": 2786,
      "keyword": "barriga",
      "keywords": 4,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2786,
      "keyword": "barriga",
      "keywords": 4,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barrigas": [
    {
      "id": 2786,
      "keyword": "barriga",
      "keywords": 4,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2786,
      "keyword": "barriga",
      "keywords": 4,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "panza": [
    {
      "id": 2786,
      "keyword": "panza",
      "keywords": 4,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2786,
      "keyword": "panza",
      "keywords": 4,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panzas": [
    {
      "id": 2786,
      "keyword": "panza",
      "keywords": 4,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2786,
      "keyword": "panza",
      "keywords": 4,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vientre": [
    {
      "id": 2786,
      "keyword": "vientre",
      "keywords": 4,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2786,
      "keyword": "vientre",
      "keywords": 4,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vientres": [
    {
      "id": 2786,
      "keyword": "vientre",
      "keywords": 4,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2786,
      "keyword": "vientre",
      "keywords": 4,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "termómetro": [
    {
      "id": 32051,
      "keyword": "termómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 32051,
      "keyword": "termómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2789,
      "keyword": "termómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36848,
      "keyword": "termómetro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37478,
      "keyword": "termómetro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "atmospheric device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "termómetros": [
    {
      "id": 32051,
      "keyword": "termómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 32051,
      "keyword": "termómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2789,
      "keyword": "termómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36848,
      "keyword": "termómetro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37478,
      "keyword": "termómetro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "atmospheric device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vestir": [
    {
      "id": 6627,
      "keyword": "vestir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "object",
        "fashion",
        "clothes",
        "person",
        "basic needs",
        "routine",
        "core vocabulary",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2781,
      "keyword": "vestir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "basic needs",
        "routine",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32135,
      "keyword": "vestir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teja": [
    {
      "id": 2792,
      "keyword": "teja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tejas": [
    {
      "id": 2792,
      "keyword": "teja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "teclado": [
    {
      "id": 7270,
      "keyword": "teclado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "keyboard instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38209,
      "keyword": "teclado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2793,
      "keyword": "teclado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teclados": [
    {
      "id": 7270,
      "keyword": "teclado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "keyboard instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38209,
      "keyword": "teclado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2793,
      "keyword": "teclado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "serrucho": [
    {
      "id": 2799,
      "keyword": "serrucho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "serruchos": [
    {
      "id": 2799,
      "keyword": "serrucho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sentar en la silla": [
    {
      "id": 30050,
      "keyword": "sentar en la silla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35781,
      "keyword": "sentar en la silla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38036,
      "keyword": "sentar en la silla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2801,
      "keyword": "sentar en la silla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30051,
      "keyword": "sentar en la silla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30052,
      "keyword": "sentar en la silla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35033,
      "keyword": "sentar en la silla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soleado": [
    {
      "id": 2796,
      "keyword": "soleado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soleados": [
    {
      "id": 2796,
      "keyword": "soleado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "soleada": [
    {
      "id": 2796,
      "keyword": "soleada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soleadas": [
    {
      "id": 2796,
      "keyword": "soleada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tuerca": [
    {
      "id": 2785,
      "keyword": "tuerca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tuercas": [
    {
      "id": 2785,
      "keyword": "tuerca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "serrar": [
    {
      "id": 2800,
      "keyword": "serrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25447,
      "keyword": "serrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25448,
      "keyword": "serrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25449,
      "keyword": "serrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "militar": [
    {
      "id": 36656,
      "keyword": "militar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36657,
      "keyword": "militar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2797,
      "keyword": "militar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11379,
      "keyword": "militar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36726,
      "keyword": "militar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36727,
      "keyword": "militar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "militares": [
    {
      "id": 36635,
      "keyword": "militares",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36656,
      "keyword": "militar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36657,
      "keyword": "militar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2797,
      "keyword": "militar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11379,
      "keyword": "militar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36726,
      "keyword": "militar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36727,
      "keyword": "militar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11246,
      "keyword": "militares",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "person",
        "group",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soldado": [
    {
      "id": 2797,
      "keyword": "soldado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11379,
      "keyword": "soldado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36726,
      "keyword": "soldado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36727,
      "keyword": "soldado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soldados": [
    {
      "id": 2797,
      "keyword": "soldado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11379,
      "keyword": "soldado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36726,
      "keyword": "soldado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36727,
      "keyword": "soldado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11246,
      "keyword": "soldados",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "person",
        "group",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sangre": [
    {
      "id": 2803,
      "keyword": "sangre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "circulatory system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sol": [
    {
      "id": 7252,
      "keyword": "Sol",
      "keywords": 1,
      "type": 1,
      "tags": [
        "astronomy",
        "meteorology",
        "atmospheric phenomena",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2798,
      "keyword": "Sol",
      "keywords": 1,
      "type": 1,
      "tags": [
        "astronomy",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sello": [
    {
      "id": 2802,
      "keyword": "sello",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sellos": [
    {
      "id": 2802,
      "keyword": "sello",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estampilla": [
    {
      "id": 2802,
      "keyword": "estampilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estampillas": [
    {
      "id": 2802,
      "keyword": "estampilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saltamontes": [
    {
      "id": 25407,
      "keyword": "saltamontes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2805,
      "keyword": "saltamontes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodilla": [
    {
      "id": 2810,
      "keyword": "rodilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "joint system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodillas": [
    {
      "id": 2810,
      "keyword": "rodilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "joint system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saltar": [
    {
      "id": 6607,
      "keyword": "saltar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39052,
      "keyword": "saltar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2804,
      "keyword": "saltar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28447,
      "keyword": "saltar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodillo": [
    {
      "id": 2809,
      "keyword": "rodillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8211,
      "keyword": "rodillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodillos": [
    {
      "id": 2809,
      "keyword": "rodillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8211,
      "keyword": "rodillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "subir las escaleras": [
    {
      "id": 2795,
      "keyword": "subir las escaleras",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28453,
      "keyword": "subir las escaleras",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "río": [
    {
      "id": 2811,
      "keyword": "río",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "river",
        "natural habitat",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ríos": [
    {
      "id": 2811,
      "keyword": "río",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "river",
        "natural habitat",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10306,
      "keyword": "ríos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "riñones": [
    {
      "id": 2812,
      "keyword": "riñones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8325,
      "keyword": "riñón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salir": [
    {
      "id": 6606,
      "keyword": "salir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27067,
      "keyword": "salir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2806,
      "keyword": "salir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28689,
      "keyword": "salir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tormentoso": [
    {
      "id": 2814,
      "keyword": "tormentoso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tormentosos": [
    {
      "id": 2814,
      "keyword": "tormentoso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rojo": [
    {
      "id": 2808,
      "keyword": "rojo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rojos": [
    {
      "id": 2808,
      "keyword": "rojo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "roja": [
    {
      "id": 2808,
      "keyword": "roja",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rojas": [
    {
      "id": 2808,
      "keyword": "roja",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "revista": [
    {
      "id": 24364,
      "keyword": "revista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "publication",
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2813,
      "keyword": "revista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "publication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "revistas": [
    {
      "id": 24364,
      "keyword": "revista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "publication",
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2813,
      "keyword": "revista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "publication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "regadera": [
    {
      "id": 2817,
      "keyword": "regadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "regaderas": [
    {
      "id": 2817,
      "keyword": "regadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recogedor": [
    {
      "id": 2818,
      "keyword": "recogedor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recogedores": [
    {
      "id": 2818,
      "keyword": "recogedor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pala de basura": [
    {
      "id": 2818,
      "keyword": "pala de basura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palas de basura": [
    {
      "id": 2818,
      "keyword": "pala de basura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rata": [
    {
      "id": 2821,
      "keyword": "rata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ratas": [
    {
      "id": 2821,
      "keyword": "rata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "laucha": [
    {
      "id": 2821,
      "keyword": "laucha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lauchas": [
    {
      "id": 2821,
      "keyword": "laucha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pulmones": [
    {
      "id": 2822,
      "keyword": "pulmones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "respiratory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8365,
      "keyword": "pulmón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "respiratory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "policía": [
    {
      "id": 37367,
      "keyword": "policía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2824,
      "keyword": "policía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11345,
      "keyword": "policía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38231,
      "keyword": "policía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38233,
      "keyword": "policía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12353,
      "keyword": "policía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5547,
      "keyword": "policía",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11280,
      "keyword": "policía",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36948,
      "keyword": "policía",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36949,
      "keyword": "policía",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "policías": [
    {
      "id": 37367,
      "keyword": "policía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2824,
      "keyword": "policía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11345,
      "keyword": "policía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38231,
      "keyword": "policía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38233,
      "keyword": "policía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 12353,
      "keyword": "policía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5547,
      "keyword": "policía",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11280,
      "keyword": "policía",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plumero": [
    {
      "id": 2825,
      "keyword": "plumero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plumeros": [
    {
      "id": 2825,
      "keyword": "plumero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pueblo": [
    {
      "id": 2823,
      "keyword": "pueblo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38586,
      "keyword": "pueblo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pueblos": [
    {
      "id": 2823,
      "keyword": "pueblo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38586,
      "keyword": "pueblo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "población": [
    {
      "id": 2823,
      "keyword": "población",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38586,
      "keyword": "población",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poblaciones": [
    {
      "id": 2823,
      "keyword": "población",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38586,
      "keyword": "población",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "municipio": [
    {
      "id": 2823,
      "keyword": "municipio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38586,
      "keyword": "municipio",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "municipios": [
    {
      "id": 2823,
      "keyword": "municipio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38586,
      "keyword": "municipio",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rosa": [
    {
      "id": 3151,
      "keyword": "rosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3151,
      "keyword": "rosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2807,
      "keyword": "rosa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rosas": [
    {
      "id": 3151,
      "keyword": "rosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 3151,
      "keyword": "rosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2807,
      "keyword": "rosa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "regar": [
    {
      "id": 2816,
      "keyword": "regar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "gardening",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22082,
      "keyword": "regar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24354,
      "keyword": "regar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24355,
      "keyword": "regar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34173,
      "keyword": "regar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plantar": [
    {
      "id": 2828,
      "keyword": "plantar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "playa": [
    {
      "id": 30518,
      "keyword": "playa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "tertiary sector",
        "tourism",
        "leisure",
        "outdoor activity",
        "communication",
        "signaling system",
        "core vocabulary",
        "summer"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2826,
      "keyword": "playa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "tertiary sector",
        "tourism",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "playas": [
    {
      "id": 30518,
      "keyword": "playa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "tertiary sector",
        "tourism",
        "leisure",
        "outdoor activity",
        "communication",
        "signaling system",
        "core vocabulary",
        "summer"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2826,
      "keyword": "playa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "tertiary sector",
        "tourism",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "costa": [
    {
      "id": 30518,
      "keyword": "costa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "tertiary sector",
        "tourism",
        "leisure",
        "outdoor activity",
        "communication",
        "signaling system",
        "core vocabulary",
        "summer"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2826,
      "keyword": "costa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "tertiary sector",
        "tourism",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8007,
      "keyword": "costa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "costas": [
    {
      "id": 30518,
      "keyword": "costa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "tertiary sector",
        "tourism",
        "leisure",
        "outdoor activity",
        "communication",
        "signaling system",
        "core vocabulary",
        "summer"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2826,
      "keyword": "costa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "tertiary sector",
        "tourism",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8007,
      "keyword": "costa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "regla": [
    {
      "id": 32490,
      "keyword": "regla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2815,
      "keyword": "regla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8165,
      "keyword": "regla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reglas": [
    {
      "id": 32490,
      "keyword": "regla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2815,
      "keyword": "regla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8165,
      "keyword": "regla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plateado": [
    {
      "id": 2827,
      "keyword": "plateado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plateados": [
    {
      "id": 2827,
      "keyword": "plateado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plateada": [
    {
      "id": 2827,
      "keyword": "plateada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plateadas": [
    {
      "id": 2827,
      "keyword": "plateada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "relámpago": [
    {
      "id": 7288,
      "keyword": "relámpago",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena",
        "communication",
        "language",
        "verb",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2819,
      "keyword": "relámpago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "relámpagos": [
    {
      "id": 7288,
      "keyword": "relámpago",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena",
        "communication",
        "language",
        "verb",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2819,
      "keyword": "relámpago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "planchar": [
    {
      "id": 26331,
      "keyword": "planchar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2830,
      "keyword": "planchar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26330,
      "keyword": "planchar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8192,
      "keyword": "planchar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piruleta": [
    {
      "id": 2832,
      "keyword": "piruleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piruletas": [
    {
      "id": 2832,
      "keyword": "piruleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chupetín": [
    {
      "id": 2832,
      "keyword": "chupetín",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chupetines": [
    {
      "id": 2832,
      "keyword": "chupetín",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pintar la pared": [
    {
      "id": 2836,
      "keyword": "pintar la pared",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pintora": [
    {
      "id": 2835,
      "keyword": "pintora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2834,
      "keyword": "pintora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pintoras": [
    {
      "id": 2835,
      "keyword": "pintora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2834,
      "keyword": "pintora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "planeta": [
    {
      "id": 2829,
      "keyword": "planeta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy",
        "planet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "planetas": [
    {
      "id": 2829,
      "keyword": "planeta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy",
        "planet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pinzas": [
    {
      "id": 2833,
      "keyword": "pinzas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6178,
      "keyword": "pinza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8466,
      "keyword": "pinza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9088,
      "keyword": "pinzas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30767,
      "keyword": "pinzas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34110,
      "keyword": "pinzas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35191,
      "keyword": "pinza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24292,
      "keyword": "pinza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pimiento": [
    {
      "id": 2838,
      "keyword": "pimiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2839,
      "keyword": "pimiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39388,
      "keyword": "pimiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pimientos": [
    {
      "id": 2838,
      "keyword": "pimiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2839,
      "keyword": "pimiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39388,
      "keyword": "pimiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pimiento verde": [
    {
      "id": 2838,
      "keyword": "pimiento verde",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pimientos verdes": [
    {
      "id": 2838,
      "keyword": "pimiento verde",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pistola": [
    {
      "id": 2831,
      "keyword": "pistola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9137,
      "keyword": "pistola",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pistolas": [
    {
      "id": 2831,
      "keyword": "pistola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9137,
      "keyword": "pistola",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "piel": [
    {
      "id": 2840,
      "keyword": "piel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "integumentary system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2840,
      "keyword": "piel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "integumentary system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7205,
      "keyword": "piel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "animal material",
        "animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pieles": [
    {
      "id": 2840,
      "keyword": "piel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "integumentary system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2840,
      "keyword": "piel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "integumentary system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7205,
      "keyword": "piel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "animal material",
        "animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pimiento rojo": [
    {
      "id": 2839,
      "keyword": "pimiento rojo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pimientos rojos": [
    {
      "id": 2839,
      "keyword": "pimiento rojo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pez espada": [
    {
      "id": 2843,
      "keyword": "pez espada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peces espada": [
    {
      "id": 2843,
      "keyword": "pez espada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pico": [
    {
      "id": 2842,
      "keyword": "pico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5538,
      "keyword": "pico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 20391,
      "keyword": "pico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "picos": [
    {
      "id": 2842,
      "keyword": "pico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5538,
      "keyword": "pico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 20391,
      "keyword": "pico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38770,
      "keyword": "picos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pepinillos": [
    {
      "id": 2848,
      "keyword": "pepinillos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36567,
      "keyword": "pepinillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pepino": [
    {
      "id": 2847,
      "keyword": "pepino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pepinos": [
    {
      "id": 2847,
      "keyword": "pepino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peluquero": [
    {
      "id": 6588,
      "keyword": "peluquero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 6588,
      "keyword": "peluquero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2849,
      "keyword": "peluquero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peluqueros": [
    {
      "id": 6588,
      "keyword": "peluquero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 6588,
      "keyword": "peluquero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2849,
      "keyword": "peluquero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peluquería": [
    {
      "id": 6587,
      "keyword": "peluquería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2850,
      "keyword": "peluquería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peluquerías": [
    {
      "id": 6587,
      "keyword": "peluquería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2850,
      "keyword": "peluquería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pestañas": [
    {
      "id": 2844,
      "keyword": "pestañas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "visual system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8319,
      "keyword": "pestaña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "visual system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pie": [
    {
      "id": 25327,
      "keyword": "pie",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "locomotor system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 25327,
      "keyword": "pie",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "locomotor system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2841,
      "keyword": "pie",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pies": [
    {
      "id": 25327,
      "keyword": "pie",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "locomotor system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 25327,
      "keyword": "pie",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "locomotor system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2841,
      "keyword": "pie",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37227,
      "keyword": "pies",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "percha": [
    {
      "id": 2846,
      "keyword": "percha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3242,
      "keyword": "percha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3286,
      "keyword": "percha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "education",
        "educational equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39259,
      "keyword": "percha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perchas": [
    {
      "id": 2846,
      "keyword": "percha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3242,
      "keyword": "percha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3286,
      "keyword": "percha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "education",
        "educational equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39259,
      "keyword": "percha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "periódico": [
    {
      "id": 2845,
      "keyword": "periódico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "publication",
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "periódicos": [
    {
      "id": 2845,
      "keyword": "periódico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "publication",
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diario": [
    {
      "id": 2845,
      "keyword": "diario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "publication",
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diarios": [
    {
      "id": 2845,
      "keyword": "diario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "publication",
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pastelera": [
    {
      "id": 2856,
      "keyword": "pastelera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11329,
      "keyword": "pastelera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasteleras": [
    {
      "id": 2856,
      "keyword": "pastelera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11329,
      "keyword": "pastelera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "payaso": [
    {
      "id": 2854,
      "keyword": "payaso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31426,
      "keyword": "payaso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "payasos": [
    {
      "id": 2854,
      "keyword": "payaso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31426,
      "keyword": "payaso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pelo": [
    {
      "id": 2851,
      "keyword": "pelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2851,
      "keyword": "pelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24256,
      "keyword": "pelo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelos": [
    {
      "id": 2851,
      "keyword": "pelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2851,
      "keyword": "pelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24256,
      "keyword": "pelo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cabello": [
    {
      "id": 2851,
      "keyword": "cabello",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2851,
      "keyword": "cabello",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cabellos": [
    {
      "id": 2851,
      "keyword": "cabello",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2851,
      "keyword": "cabello",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parque": [
    {
      "id": 2859,
      "keyword": "parque",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parques": [
    {
      "id": 2859,
      "keyword": "parque",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peine": [
    {
      "id": 2852,
      "keyword": "peine",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2852,
      "keyword": "peine",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peines": [
    {
      "id": 2852,
      "keyword": "peine",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2852,
      "keyword": "peine",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pared": [
    {
      "id": 2860,
      "keyword": "pared",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paredes": [
    {
      "id": 2860,
      "keyword": "pared",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pastelero": [
    {
      "id": 6584,
      "keyword": "pastelero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2857,
      "keyword": "pastelero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11330,
      "keyword": "pastelero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasteleros": [
    {
      "id": 6584,
      "keyword": "pastelero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2857,
      "keyword": "pastelero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11330,
      "keyword": "pastelero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dentífrico": [
    {
      "id": 2858,
      "keyword": "dentífrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2858,
      "keyword": "dentífrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dentífricos": [
    {
      "id": 2858,
      "keyword": "dentífrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2858,
      "keyword": "dentífrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pasta dental": [
    {
      "id": 2858,
      "keyword": "pasta dental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2858,
      "keyword": "pasta dental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pastillas": [
    {
      "id": 2855,
      "keyword": "pastillas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "blíster": [
    {
      "id": 2855,
      "keyword": "blíster",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papel higiénico": [
    {
      "id": 2862,
      "keyword": "papel higiénico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37261,
      "keyword": "papel higiénico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papeles higiénicos": [
    {
      "id": 2862,
      "keyword": "papel higiénico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pan de molde": [
    {
      "id": 2865,
      "keyword": "pan de molde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panes de molde": [
    {
      "id": 2865,
      "keyword": "pan de molde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pañal": [
    {
      "id": 22017,
      "keyword": "pañal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 22017,
      "keyword": "pañal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2863,
      "keyword": "pañal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pañales": [
    {
      "id": 22017,
      "keyword": "pañal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 22017,
      "keyword": "pañal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2863,
      "keyword": "pañal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pala": [
    {
      "id": 34543,
      "keyword": "pala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2867,
      "keyword": "pala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palas": [
    {
      "id": 34543,
      "keyword": "pala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2867,
      "keyword": "pala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5100,
      "keyword": "palas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orquesta": [
    {
      "id": 2870,
      "keyword": "orquesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38296,
      "keyword": "orquesta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orquestas": [
    {
      "id": 2870,
      "keyword": "orquesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "music"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38296,
      "keyword": "orquesta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oso panda": [
    {
      "id": 2869,
      "keyword": "oso panda",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "osos panda": [
    {
      "id": 2869,
      "keyword": "oso panda",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "panda": [
    {
      "id": 2869,
      "keyword": "panda",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pandas": [
    {
      "id": 2869,
      "keyword": "panda",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "osa panda": [
    {
      "id": 2869,
      "keyword": "osa panda",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "osas panda": [
    {
      "id": 2869,
      "keyword": "osa panda",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "panadería": [
    {
      "id": 6576,
      "keyword": "panadería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2864,
      "keyword": "panadería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panaderías": [
    {
      "id": 6576,
      "keyword": "panadería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2864,
      "keyword": "panadería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ordenar": [
    {
      "id": 2872,
      "keyword": "ordenar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pecho": [
    {
      "id": 2853,
      "keyword": "pecho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37164,
      "keyword": "pecho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8372,
      "keyword": "pecho",
      "keywords": 3,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pechos": [
    {
      "id": 2853,
      "keyword": "pecho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37164,
      "keyword": "pecho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7275,
      "keyword": "pechos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8372,
      "keyword": "pecho",
      "keywords": 3,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ombligo": [
    {
      "id": 2873,
      "keyword": "ombligo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ombligos": [
    {
      "id": 2873,
      "keyword": "ombligo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pupo": [
    {
      "id": 2873,
      "keyword": "pupo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pupos": [
    {
      "id": 2873,
      "keyword": "pupo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paleta": [
    {
      "id": 2866,
      "keyword": "paleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8644,
      "keyword": "paleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paletas": [
    {
      "id": 2866,
      "keyword": "paleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8644,
      "keyword": "paleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aceitunas": [
    {
      "id": 2874,
      "keyword": "aceitunas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2875,
      "keyword": "aceitunas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8317,
      "keyword": "aceituna",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8316,
      "keyword": "aceituna",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "olivas": [
    {
      "id": 2874,
      "keyword": "olivas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2875,
      "keyword": "olivas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8317,
      "keyword": "oliva",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8316,
      "keyword": "oliva",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "olivas verdes": [
    {
      "id": 2874,
      "keyword": "olivas verdes",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8317,
      "keyword": "oliva verde",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aceitunas verdes": [
    {
      "id": 2874,
      "keyword": "aceitunas verdes",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8317,
      "keyword": "aceituna verde",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "olivas negras": [
    {
      "id": 2875,
      "keyword": "olivas negras",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8316,
      "keyword": "oliva negra",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aceitunas negras": [
    {
      "id": 2875,
      "keyword": "aceitunas negras",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8316,
      "keyword": "aceituna negra",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nuez": [
    {
      "id": 2880,
      "keyword": "nuez",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nueces": [
    {
      "id": 2880,
      "keyword": "nuez",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oso polar": [
    {
      "id": 2868,
      "keyword": "oso polar",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "osos polares": [
    {
      "id": 2868,
      "keyword": "oso polar",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "osa polar": [
    {
      "id": 2868,
      "keyword": "osa polar",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "osas polares": [
    {
      "id": 2868,
      "keyword": "osa polar",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "números": [
    {
      "id": 2879,
      "keyword": "números",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34771,
      "keyword": "números",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "número": [
    {
      "id": 2879,
      "keyword": "número",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34771,
      "keyword": "número",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ojos": [
    {
      "id": 2876,
      "keyword": "ojos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses",
        "visual system",
        "covid-19",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2876,
      "keyword": "ojos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses",
        "visual system",
        "covid-19",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6573,
      "keyword": "ojo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses",
        "visual system",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "optometrista": [
    {
      "id": 2877,
      "keyword": "optometrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11320,
      "keyword": "optometrista",
      "keywords": 1,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37625,
      "keyword": "optometrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37626,
      "keyword": "optometrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "optometristas": [
    {
      "id": 2877,
      "keyword": "optometrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11320,
      "keyword": "optometrista",
      "keywords": 1,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37625,
      "keyword": "optometrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37626,
      "keyword": "optometrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nube": [
    {
      "id": 2883,
      "keyword": "nube",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nubes": [
    {
      "id": 2883,
      "keyword": "nube",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nublado": [
    {
      "id": 34383,
      "keyword": "nublado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2882,
      "keyword": "nublado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nublados": [
    {
      "id": 2882,
      "keyword": "nublado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nublada": [
    {
      "id": 2882,
      "keyword": "nublada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nubladas": [
    {
      "id": 2882,
      "keyword": "nublada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oreja": [
    {
      "id": 2871,
      "keyword": "oreja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses",
        "auditory system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2871,
      "keyword": "oreja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses",
        "auditory system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orejas": [
    {
      "id": 2871,
      "keyword": "oreja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses",
        "auditory system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2871,
      "keyword": "oreja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses",
        "auditory system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nevada": [
    {
      "id": 2884,
      "keyword": "nevada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nevadas": [
    {
      "id": 2884,
      "keyword": "nevada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nevado": [
    {
      "id": 2884,
      "keyword": "nevado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nevados": [
    {
      "id": 2884,
      "keyword": "nevado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nuca": [
    {
      "id": 2881,
      "keyword": "nuca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nucas": [
    {
      "id": 2881,
      "keyword": "nuca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "neblinoso": [
    {
      "id": 2885,
      "keyword": "neblinoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "neblinosos": [
    {
      "id": 2885,
      "keyword": "neblinoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "neblinosa": [
    {
      "id": 2885,
      "keyword": "neblinosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "neblinosas": [
    {
      "id": 2885,
      "keyword": "neblinosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nadadora": [
    {
      "id": 2889,
      "keyword": "nadadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27013,
      "keyword": "nadadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nadadoras": [
    {
      "id": 2889,
      "keyword": "nadadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27013,
      "keyword": "nadadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "músculo": [
    {
      "id": 2891,
      "keyword": "músculo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "muscular system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "músculos": [
    {
      "id": 2891,
      "keyword": "músculo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "muscular system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24196,
      "keyword": "músculos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "muscular system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "murciélago": [
    {
      "id": 2903,
      "keyword": "murciélago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "mammal",
        "viviparous",
        "flying animal",
        "carnivorous",
        "herbivorous",
        "omnivorous",
        "event",
        "popular event",
        "halloween",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "murciélagos": [
    {
      "id": 2903,
      "keyword": "murciélago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "mammal",
        "viviparous",
        "flying animal",
        "carnivorous",
        "herbivorous",
        "omnivorous",
        "event",
        "popular event",
        "halloween",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "músico": [
    {
      "id": 6567,
      "keyword": "músico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2890,
      "keyword": "músico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "músicos": [
    {
      "id": 6567,
      "keyword": "músico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2890,
      "keyword": "músico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "negro": [
    {
      "id": 2886,
      "keyword": "negro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "negros": [
    {
      "id": 2886,
      "keyword": "negro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "negra": [
    {
      "id": 2886,
      "keyword": "negra",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9124,
      "keyword": "negra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "negras": [
    {
      "id": 2886,
      "keyword": "negra",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9124,
      "keyword": "negra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oca": [
    {
      "id": 2878,
      "keyword": "oca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ocas": [
    {
      "id": 2878,
      "keyword": "oca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "muela": [
    {
      "id": 2905,
      "keyword": "muela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system",
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muelas": [
    {
      "id": 2905,
      "keyword": "muela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system",
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "moras": [
    {
      "id": 2906,
      "keyword": "moras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8360,
      "keyword": "mora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "morado": [
    {
      "id": 2907,
      "keyword": "morado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "morados": [
    {
      "id": 2907,
      "keyword": "morado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "morada": [
    {
      "id": 2907,
      "keyword": "morada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "moradas": [
    {
      "id": 2907,
      "keyword": "morada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "montaña": [
    {
      "id": 2909,
      "keyword": "montaña",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "place",
        "rural area",
        "core vocabulary",
        "traffic accident",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "montañas": [
    {
      "id": 2909,
      "keyword": "montaña",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "place",
        "rural area",
        "core vocabulary",
        "traffic accident",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "monte": [
    {
      "id": 2909,
      "keyword": "monte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "place",
        "rural area",
        "core vocabulary",
        "traffic accident",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "montes": [
    {
      "id": 2909,
      "keyword": "monte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "place",
        "rural area",
        "core vocabulary",
        "traffic accident",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "monitor": [
    {
      "id": 25498,
      "keyword": "monitor",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media",
        "mass media device",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38543,
      "keyword": "monitor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38411,
      "keyword": "monitor",
      "keywords": 6,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2910,
      "keyword": "monitor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24789,
      "keyword": "monitor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11651,
      "keyword": "monitor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27005,
      "keyword": "monitor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7163,
      "keyword": "monitor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15992,
      "keyword": "monitor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monitores": [
    {
      "id": 25498,
      "keyword": "monitor",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media",
        "mass media device",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38543,
      "keyword": "monitor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38411,
      "keyword": "monitor",
      "keywords": 6,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2910,
      "keyword": "monitor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24789,
      "keyword": "monitor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11651,
      "keyword": "monitor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15994,
      "keyword": "monitores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27005,
      "keyword": "monitor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7163,
      "keyword": "monitor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15992,
      "keyword": "monitor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mopa": [
    {
      "id": 2908,
      "keyword": "mopa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mopas": [
    {
      "id": 2908,
      "keyword": "mopa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "miel": [
    {
      "id": 2911,
      "keyword": "miel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mieles": [
    {
      "id": 2911,
      "keyword": "miel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "micrófono": [
    {
      "id": 37404,
      "keyword": "micrófono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2912,
      "keyword": "micrófono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "micrófonos": [
    {
      "id": 37404,
      "keyword": "micrófono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2912,
      "keyword": "micrófono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nariz": [
    {
      "id": 2887,
      "keyword": "nariz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses",
        "respiratory system",
        "covid-19",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 2887,
      "keyword": "nariz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses",
        "respiratory system",
        "covid-19",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "narices": [
    {
      "id": 2887,
      "keyword": "nariz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses",
        "respiratory system",
        "covid-19",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 2887,
      "keyword": "nariz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses",
        "respiratory system",
        "covid-19",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesa de estudio": [
    {
      "id": 2916,
      "keyword": "mesa de estudio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas de estudio": [
    {
      "id": 2916,
      "keyword": "mesa de estudio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesa camilla": [
    {
      "id": 2917,
      "keyword": "mesa camilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas camilla": [
    {
      "id": 2917,
      "keyword": "mesa camilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mejillón": [
    {
      "id": 2918,
      "keyword": "mejillón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mejillones": [
    {
      "id": 2918,
      "keyword": "mejillón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "martillo": [
    {
      "id": 2922,
      "keyword": "martillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "martillos": [
    {
      "id": 2922,
      "keyword": "martillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "metro de carpintero": [
    {
      "id": 2915,
      "keyword": "metro de carpintero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "metros de carpintero": [
    {
      "id": 2915,
      "keyword": "metro de carpintero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mariquita": [
    {
      "id": 2924,
      "keyword": "mariquita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mariquitas": [
    {
      "id": 2924,
      "keyword": "mariquita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mejilla": [
    {
      "id": 2919,
      "keyword": "mejilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mejillas": [
    {
      "id": 2919,
      "keyword": "mejilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cachete": [
    {
      "id": 2919,
      "keyword": "cachete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cachetes": [
    {
      "id": 2919,
      "keyword": "cachete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "marrón": [
    {
      "id": 2923,
      "keyword": "marrón",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marrones": [
    {
      "id": 2923,
      "keyword": "marrón",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mecánico": [
    {
      "id": 6560,
      "keyword": "mecánico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2921,
      "keyword": "mecánico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mecánicos": [
    {
      "id": 6560,
      "keyword": "mecánico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2921,
      "keyword": "mecánico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "máquina de coser": [
    {
      "id": 2926,
      "keyword": "máquina de coser",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máquinas de coser": [
    {
      "id": 2926,
      "keyword": "máquina de coser",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manoplas": [
    {
      "id": 25227,
      "keyword": "manopla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2927,
      "keyword": "manoplas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8314,
      "keyword": "manopla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mar": [
    {
      "id": 2925,
      "keyword": "mar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean",
        "natural habitat",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mares": [
    {
      "id": 2925,
      "keyword": "mar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean",
        "natural habitat",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "océano": [
    {
      "id": 2925,
      "keyword": "océano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean",
        "natural habitat",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32699,
      "keyword": "océano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "oceanography",
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "océanos": [
    {
      "id": 2925,
      "keyword": "océano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean",
        "natural habitat",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32699,
      "keyword": "océano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "oceanography",
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botiquín": [
    {
      "id": 27545,
      "keyword": "botiquín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2930,
      "keyword": "botiquín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5930,
      "keyword": "botiquín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botiquines": [
    {
      "id": 27545,
      "keyword": "botiquín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2930,
      "keyword": "botiquín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5930,
      "keyword": "botiquín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mano": [
    {
      "id": 2928,
      "keyword": "mano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manos": [
    {
      "id": 9830,
      "keyword": "manos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2928,
      "keyword": "mano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mano derecha": [
    {
      "id": 2928,
      "keyword": "mano derecha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4624,
      "keyword": "mano derecha",
      "keywords": 5,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manos derechas": [
    {
      "id": 2928,
      "keyword": "mano derecha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4624,
      "keyword": "mano derecha",
      "keywords": 5,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "luna": [
    {
      "id": 2933,
      "keyword": "Luna",
      "keywords": 1,
      "type": 1,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manguera": [
    {
      "id": 2929,
      "keyword": "manguera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "gardening",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mangueras": [
    {
      "id": 2929,
      "keyword": "manguera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "gardening",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mago": [
    {
      "id": 2932,
      "keyword": "mago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38024,
      "keyword": "mago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10157,
      "keyword": "mago",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "scenic art",
        "visual art",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "magos": [
    {
      "id": 2932,
      "keyword": "mago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38024,
      "keyword": "mago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10157,
      "keyword": "mago",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "scenic art",
        "visual art",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "medusa": [
    {
      "id": 2920,
      "keyword": "medusa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "coelenterata",
        "carnivorous",
        "aquatic animal",
        "marine animal",
        "sea",
        "oviparous",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medusas": [
    {
      "id": 2920,
      "keyword": "medusa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "coelenterata",
        "carnivorous",
        "aquatic animal",
        "marine animal",
        "sea",
        "oviparous",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "loro": [
    {
      "id": 2934,
      "keyword": "loro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "domestic",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "loros": [
    {
      "id": 2934,
      "keyword": "loro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "domestic",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llave fija": [
    {
      "id": 2938,
      "keyword": "llave fija",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llaves fijas": [
    {
      "id": 2938,
      "keyword": "llave fija",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lluvioso": [
    {
      "id": 2936,
      "keyword": "lluvioso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lluviosos": [
    {
      "id": 2936,
      "keyword": "lluvioso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lluviosa": [
    {
      "id": 2936,
      "keyword": "lluviosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lluviosas": [
    {
      "id": 2936,
      "keyword": "lluviosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lombriz": [
    {
      "id": 2935,
      "keyword": "lombriz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "annelid",
        "omnivorous",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lombrices": [
    {
      "id": 2935,
      "keyword": "lombriz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "annelid",
        "omnivorous",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maleta": [
    {
      "id": 2931,
      "keyword": "maleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11297,
      "keyword": "maleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maletas": [
    {
      "id": 2931,
      "keyword": "maleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11297,
      "keyword": "maleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "valija": [
    {
      "id": 2931,
      "keyword": "valija",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11297,
      "keyword": "valija",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "valijas": [
    {
      "id": 2931,
      "keyword": "valija",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11297,
      "keyword": "valija",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "litera": [
    {
      "id": 26893,
      "keyword": "litera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2939,
      "keyword": "litera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "literas": [
    {
      "id": 26893,
      "keyword": "litera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2939,
      "keyword": "litera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "leñador": [
    {
      "id": 2943,
      "keyword": "leñador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "forestry",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leñadores": [
    {
      "id": 2943,
      "keyword": "leñador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "forestry",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lengua": [
    {
      "id": 2944,
      "keyword": "lengua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses",
        "digestive system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lenguas": [
    {
      "id": 2944,
      "keyword": "lengua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses",
        "digestive system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lila": [
    {
      "id": 2940,
      "keyword": "lila",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39389,
      "keyword": "lila",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lilas": [
    {
      "id": 2940,
      "keyword": "lila",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39389,
      "keyword": "lila",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llave inglesa": [
    {
      "id": 2937,
      "keyword": "llave inglesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llaves inglesas": [
    {
      "id": 2937,
      "keyword": "llave inglesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lazo": [
    {
      "id": 2946,
      "keyword": "lazo",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "lazos": [
    {
      "id": 2946,
      "keyword": "lazo",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "lana": [
    {
      "id": 2948,
      "keyword": "lana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "animal material",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lanas": [
    {
      "id": 2948,
      "keyword": "lana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "animal material",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lagartija": [
    {
      "id": 2950,
      "keyword": "lagartija",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lagartijas": [
    {
      "id": 2950,
      "keyword": "lagartija",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lagarto": [
    {
      "id": 2949,
      "keyword": "lagarto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lagartos": [
    {
      "id": 2949,
      "keyword": "lagarto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lagarta": [
    {
      "id": 2949,
      "keyword": "lagarta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lagartas": [
    {
      "id": 2949,
      "keyword": "lagarta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "librería": [
    {
      "id": 6550,
      "keyword": "librería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "literature",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2941,
      "keyword": "librería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "literature"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3279,
      "keyword": "librería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "librerías": [
    {
      "id": 6550,
      "keyword": "librería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "literature",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2941,
      "keyword": "librería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "literature"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3279,
      "keyword": "librería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "leopardo": [
    {
      "id": 2942,
      "keyword": "leopardo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leopardos": [
    {
      "id": 2942,
      "keyword": "leopardo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "leoparda": [
    {
      "id": 2942,
      "keyword": "leoparda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leopardas": [
    {
      "id": 2942,
      "keyword": "leoparda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ladrillo": [
    {
      "id": 2951,
      "keyword": "ladrillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ladrillos": [
    {
      "id": 2951,
      "keyword": "ladrillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lechuza": [
    {
      "id": 2945,
      "keyword": "lechuza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lechuzas": [
    {
      "id": 2945,
      "keyword": "lechuza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "kiwi": [
    {
      "id": 2955,
      "keyword": "kiwi",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kiwis": [
    {
      "id": 2955,
      "keyword": "kiwi",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "langosta": [
    {
      "id": 2947,
      "keyword": "langosta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "aquatic animal",
        "marine animal",
        "sea",
        "oviparous",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "crustacean"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "langostas": [
    {
      "id": 2947,
      "keyword": "langosta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "aquatic animal",
        "marine animal",
        "sea",
        "oviparous",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "crustacean"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "laca": [
    {
      "id": 2952,
      "keyword": "laca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lacas": [
    {
      "id": 2952,
      "keyword": "laca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "joyero": [
    {
      "id": 6535,
      "keyword": "joyero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2958,
      "keyword": "joyero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37930,
      "keyword": "joyero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "joyeros": [
    {
      "id": 6535,
      "keyword": "joyero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2958,
      "keyword": "joyero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37930,
      "keyword": "joyero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "joyería": [
    {
      "id": 6534,
      "keyword": "joyería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "jewelry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2959,
      "keyword": "joyería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "joyerías": [
    {
      "id": 6534,
      "keyword": "joyería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "jewelry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2959,
      "keyword": "joyería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jeringuilla": [
    {
      "id": 31732,
      "keyword": "jeringuilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2960,
      "keyword": "jeringuilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jeringuillas": [
    {
      "id": 31732,
      "keyword": "jeringuilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2960,
      "keyword": "jeringuilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jeringa": [
    {
      "id": 2960,
      "keyword": "jeringa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jeringas": [
    {
      "id": 2960,
      "keyword": "jeringa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "labios": [
    {
      "id": 2953,
      "keyword": "labios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "koala": [
    {
      "id": 2954,
      "keyword": "koala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "koalas": [
    {
      "id": 2954,
      "keyword": "koala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jardinera": [
    {
      "id": 37765,
      "keyword": "jardinera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2961,
      "keyword": "jardinera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39094,
      "keyword": "jardinera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jardineras": [
    {
      "id": 37765,
      "keyword": "jardinera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2961,
      "keyword": "jardinera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39094,
      "keyword": "jardinera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jueza": [
    {
      "id": 2957,
      "keyword": "jueza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juezas": [
    {
      "id": 2957,
      "keyword": "jueza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quiosco": [
    {
      "id": 6541,
      "keyword": "quiosco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "publication",
        "communication",
        "mass media",
        "signaling system",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2956,
      "keyword": "quiosco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "communication",
        "mass media",
        "object",
        "publication",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36406,
      "keyword": "quiosco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quioscos": [
    {
      "id": 6541,
      "keyword": "quiosco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "publication",
        "communication",
        "mass media",
        "signaling system",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2956,
      "keyword": "quiosco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "communication",
        "mass media",
        "object",
        "publication",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36406,
      "keyword": "quiosco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "kiosco": [
    {
      "id": 6541,
      "keyword": "kiosco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "publication",
        "communication",
        "mass media",
        "signaling system",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2956,
      "keyword": "kiosco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "communication",
        "mass media",
        "object",
        "publication",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36406,
      "keyword": "kiosco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kioscos": [
    {
      "id": 6541,
      "keyword": "kiosco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "publication",
        "communication",
        "mass media",
        "signaling system",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2956,
      "keyword": "kiosco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "communication",
        "mass media",
        "object",
        "publication",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36406,
      "keyword": "kiosco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "isla": [
    {
      "id": 24127,
      "keyword": "isla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2966,
      "keyword": "isla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "islas": [
    {
      "id": 24127,
      "keyword": "isla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2966,
      "keyword": "isla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "islote": [
    {
      "id": 2966,
      "keyword": "islote",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "islotes": [
    {
      "id": 2966,
      "keyword": "islote",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jabalí": [
    {
      "id": 2965,
      "keyword": "jabalí",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "hunting",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jabalís": [
    {
      "id": 2965,
      "keyword": "jabalí",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "hunting",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jabalina": [
    {
      "id": 2965,
      "keyword": "jabalina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "hunting",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jabalinas": [
    {
      "id": 2965,
      "keyword": "jabalina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "hunting",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jabón": [
    {
      "id": 25171,
      "keyword": "jabón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8094,
      "keyword": "jabón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 8094,
      "keyword": "jabón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2964,
      "keyword": "jabón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jabones": [
    {
      "id": 25171,
      "keyword": "jabón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8094,
      "keyword": "jabón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 8094,
      "keyword": "jabón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2964,
      "keyword": "jabón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "intestino": [
    {
      "id": 2967,
      "keyword": "intestino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intestinos": [
    {
      "id": 2967,
      "keyword": "intestino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jarabe": [
    {
      "id": 2962,
      "keyword": "jarabe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jarabes": [
    {
      "id": 2962,
      "keyword": "jarabe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ingeniero": [
    {
      "id": 28349,
      "keyword": "ingeniero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "engineering",
        "tertiary sector",
        "professional services",
        "secondary sector",
        "industry",
        "manufacturing industry",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2968,
      "keyword": "ingeniero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "engineering",
        "tertiary sector",
        "professional services",
        "secondary sector",
        "industry",
        "manufacturing industry",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ingenieros": [
    {
      "id": 28349,
      "keyword": "ingeniero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "engineering",
        "tertiary sector",
        "professional services",
        "secondary sector",
        "industry",
        "manufacturing industry",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2968,
      "keyword": "ingeniero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "engineering",
        "tertiary sector",
        "professional services",
        "secondary sector",
        "industry",
        "manufacturing industry",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jamón de york": [
    {
      "id": 2963,
      "keyword": "jamón de york",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "horquilla": [
    {
      "id": 2975,
      "keyword": "horquilla",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "horquillas": [
    {
      "id": 2975,
      "keyword": "horquilla",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "informático": [
    {
      "id": 2969,
      "keyword": "informático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "computing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29114,
      "keyword": "informático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "computing",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "informáticos": [
    {
      "id": 2969,
      "keyword": "informático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "computing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29114,
      "keyword": "informático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "computing",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "impresora": [
    {
      "id": 26138,
      "keyword": "impresora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2970,
      "keyword": "impresora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "impresoras": [
    {
      "id": 26138,
      "keyword": "impresora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2970,
      "keyword": "impresora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hombro": [
    {
      "id": 2977,
      "keyword": "hombro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "joint system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hombros": [
    {
      "id": 2977,
      "keyword": "hombro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "joint system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "imperdible": [
    {
      "id": 2971,
      "keyword": "imperdible",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "imperdibles": [
    {
      "id": 2971,
      "keyword": "imperdible",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alfiler de gancho": [
    {
      "id": 2971,
      "keyword": "alfiler de gancho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alfileres de gancho": [
    {
      "id": 2971,
      "keyword": "alfiler de gancho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huerto": [
    {
      "id": 2974,
      "keyword": "huerto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "primary sector",
        "agriculture",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37576,
      "keyword": "huerto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huertos": [
    {
      "id": 2974,
      "keyword": "huerto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "primary sector",
        "agriculture",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37576,
      "keyword": "huerto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huerta": [
    {
      "id": 2974,
      "keyword": "huerta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "primary sector",
        "agriculture",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37576,
      "keyword": "huerta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huertas": [
    {
      "id": 2974,
      "keyword": "huerta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "primary sector",
        "agriculture",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37576,
      "keyword": "huerta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hilo": [
    {
      "id": 2978,
      "keyword": "hilo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hilos": [
    {
      "id": 2978,
      "keyword": "hilo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bobina": [
    {
      "id": 2978,
      "keyword": "bobina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bobinas": [
    {
      "id": 2978,
      "keyword": "bobina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hoz": [
    {
      "id": 2973,
      "keyword": "hoz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hoces": [
    {
      "id": 2973,
      "keyword": "hoz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hígado": [
    {
      "id": 26569,
      "keyword": "hígado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2980,
      "keyword": "hígado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hígados": [
    {
      "id": 26569,
      "keyword": "hígado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2980,
      "keyword": "hígado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "algodón": [
    {
      "id": 2985,
      "keyword": "algodón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "algodones": [
    {
      "id": 2985,
      "keyword": "algodón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alcohol": [
    {
      "id": 2984,
      "keyword": "alcohol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hueso": [
    {
      "id": 6528,
      "keyword": "hueso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2972,
      "keyword": "hueso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huesos": [
    {
      "id": 6528,
      "keyword": "hueso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2972,
      "keyword": "hueso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acelga": [
    {
      "id": 2981,
      "keyword": "acelga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acelgas": [
    {
      "id": 2981,
      "keyword": "acelga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "albaricoque": [
    {
      "id": 2983,
      "keyword": "albaricoque",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "albaricoques": [
    {
      "id": 2983,
      "keyword": "albaricoque",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "damasco": [
    {
      "id": 2983,
      "keyword": "damasco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "damascos": [
    {
      "id": 2983,
      "keyword": "damasco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arco iris": [
    {
      "id": 2986,
      "keyword": "arco iris",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena",
        "spring"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "higo": [
    {
      "id": 2979,
      "keyword": "higo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "higos": [
    {
      "id": 2979,
      "keyword": "higo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atornillar": [
    {
      "id": 2987,
      "keyword": "atornillar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agricultor": [
    {
      "id": 6035,
      "keyword": "agricultor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2982,
      "keyword": "agricultor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agricultores": [
    {
      "id": 6035,
      "keyword": "agricultor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2982,
      "keyword": "agricultor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "campesino": [
    {
      "id": 6035,
      "keyword": "campesino",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2982,
      "keyword": "campesino",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campesinos": [
    {
      "id": 6035,
      "keyword": "campesino",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2982,
      "keyword": "campesino",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "labriego": [
    {
      "id": 6035,
      "keyword": "labriego",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2982,
      "keyword": "labriego",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "labriegos": [
    {
      "id": 6035,
      "keyword": "labriego",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2982,
      "keyword": "labriego",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "axila": [
    {
      "id": 37137,
      "keyword": "axila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2989,
      "keyword": "axila",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "axilas": [
    {
      "id": 37137,
      "keyword": "axila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2989,
      "keyword": "axila",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sobaco": [
    {
      "id": 2989,
      "keyword": "sobaco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sobacos": [
    {
      "id": 2989,
      "keyword": "sobaco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "azafata": [
    {
      "id": 2990,
      "keyword": "azafata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "azafatas": [
    {
      "id": 2990,
      "keyword": "azafata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "avellana": [
    {
      "id": 2988,
      "keyword": "avellana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "avellanas": [
    {
      "id": 2988,
      "keyword": "avellana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barrendero": [
    {
      "id": 2993,
      "keyword": "barrendero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barrenderos": [
    {
      "id": 2993,
      "keyword": "barrendero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "basurero": [
    {
      "id": 8500,
      "keyword": "basurero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 2993,
      "keyword": "basurero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "basureros": [
    {
      "id": 8500,
      "keyword": "basurero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 2993,
      "keyword": "basurero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "borraja": [
    {
      "id": 2996,
      "keyword": "borraja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "borrajas": [
    {
      "id": 2996,
      "keyword": "borraja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barbilla": [
    {
      "id": 2991,
      "keyword": "barbilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barbillas": [
    {
      "id": 2991,
      "keyword": "barbilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pintalabios": [
    {
      "id": 2992,
      "keyword": "pintalabios",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lápiz de labios": [
    {
      "id": 2992,
      "keyword": "lápiz de labios",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lápices de labios": [
    {
      "id": 2992,
      "keyword": "lápiz de labios",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barra de labios": [
    {
      "id": 2992,
      "keyword": "barra de labios",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barras de labios": [
    {
      "id": 2992,
      "keyword": "barra de labios",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lejía": [
    {
      "id": 2997,
      "keyword": "lejía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lejías": [
    {
      "id": 2997,
      "keyword": "lejía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "buitre": [
    {
      "id": 2998,
      "keyword": "buitre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buitres": [
    {
      "id": 2998,
      "keyword": "buitre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "buzo": [
    {
      "id": 2999,
      "keyword": "buzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "diving"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3068,
      "keyword": "buzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31447,
      "keyword": "buzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31446,
      "keyword": "buzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31448,
      "keyword": "buzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31449,
      "keyword": "buzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31450,
      "keyword": "buzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31456,
      "keyword": "buzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buzos": [
    {
      "id": 2999,
      "keyword": "buzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "diving"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3068,
      "keyword": "buzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31447,
      "keyword": "buzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31446,
      "keyword": "buzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31448,
      "keyword": "buzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31449,
      "keyword": "buzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31450,
      "keyword": "buzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31456,
      "keyword": "buzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cadera": [
    {
      "id": 3000,
      "keyword": "cadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "joint system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3000,
      "keyword": "cadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "joint system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caderas": [
    {
      "id": 3000,
      "keyword": "cadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "joint system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 3000,
      "keyword": "cadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "joint system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cajera": [
    {
      "id": 6069,
      "keyword": "cajera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3001,
      "keyword": "cajera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajeras": [
    {
      "id": 6069,
      "keyword": "cajera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3001,
      "keyword": "cajera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bizcochos": [
    {
      "id": 2995,
      "keyword": "bizcochos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8295,
      "keyword": "bizcocho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8042,
      "keyword": "bizcocho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "canario": [
    {
      "id": 3004,
      "keyword": "canario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canarios": [
    {
      "id": 3004,
      "keyword": "canario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "canaria": [
    {
      "id": 3004,
      "keyword": "canaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canarias": [
    {
      "id": 8058,
      "keyword": "Canarias",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8525,
      "keyword": "Canarias",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3004,
      "keyword": "canaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cápsula": [
    {
      "id": 3006,
      "keyword": "cápsula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cápsulas": [
    {
      "id": 3006,
      "keyword": "cápsula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "panceta": [
    {
      "id": 2994,
      "keyword": "panceta",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pancetas": [
    {
      "id": 2994,
      "keyword": "panceta",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bacón": [
    {
      "id": 2994,
      "keyword": "bacón",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bacones": [
    {
      "id": 2994,
      "keyword": "bacón",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "beicon": [
    {
      "id": 2994,
      "keyword": "beicon",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "béicones": [
    {
      "id": 2994,
      "keyword": "beicon",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "panceta ahumada": [
    {
      "id": 2994,
      "keyword": "panceta ahumada",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pancetas ahumadas": [
    {
      "id": 2994,
      "keyword": "panceta ahumada",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camaleón": [
    {
      "id": 3003,
      "keyword": "camaleón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "ovoviviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camaleones": [
    {
      "id": 3003,
      "keyword": "camaleón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "ovoviviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camaleona": [
    {
      "id": 3003,
      "keyword": "camaleona",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "ovoviviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camaleonas": [
    {
      "id": 3003,
      "keyword": "camaleona",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "ovoviviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cazador": [
    {
      "id": 3010,
      "keyword": "cazador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cazadores": [
    {
      "id": 3010,
      "keyword": "cazador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "canelones": [
    {
      "id": 3005,
      "keyword": "canelones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8301,
      "keyword": "canelón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carnicero": [
    {
      "id": 6075,
      "keyword": "carnicero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3008,
      "keyword": "carnicero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carniceros": [
    {
      "id": 6075,
      "keyword": "carnicero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3008,
      "keyword": "carnicero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ceja": [
    {
      "id": 3011,
      "keyword": "ceja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cejas": [
    {
      "id": 3011,
      "keyword": "ceja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "charcutero": [
    {
      "id": 6447,
      "keyword": "charcutero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3013,
      "keyword": "charcutero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "charcuteros": [
    {
      "id": 6447,
      "keyword": "charcutero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3013,
      "keyword": "charcutero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cesta": [
    {
      "id": 3012,
      "keyword": "cesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3012,
      "keyword": "cesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26748,
      "keyword": "cesta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22175,
      "keyword": "cesta",
      "keywords": 3,
      "type": 1,
      "tags": [
        "object",
        "container",
        "fashion",
        "clothes",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cestas": [
    {
      "id": 3012,
      "keyword": "cesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 3012,
      "keyword": "cesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26748,
      "keyword": "cesta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22175,
      "keyword": "cesta",
      "keywords": 3,
      "type": 1,
      "tags": [
        "object",
        "container",
        "fashion",
        "clothes",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cigala": [
    {
      "id": 3014,
      "keyword": "cigala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cigalas": [
    {
      "id": 3014,
      "keyword": "cigala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coletero": [
    {
      "id": 3016,
      "keyword": "coletero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coleteros": [
    {
      "id": 3016,
      "keyword": "coletero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colorete": [
    {
      "id": 3017,
      "keyword": "colorete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coloretes": [
    {
      "id": 3017,
      "keyword": "colorete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conductor": [
    {
      "id": 6459,
      "keyword": "conductor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28435,
      "keyword": "conductor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3019,
      "keyword": "conductor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32916,
      "keyword": "conductor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conductores": [
    {
      "id": 6459,
      "keyword": "conductor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28435,
      "keyword": "conductor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3019,
      "keyword": "conductor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32916,
      "keyword": "conductor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chófer": [
    {
      "id": 6459,
      "keyword": "chófer",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28435,
      "keyword": "chófer",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3019,
      "keyword": "chófer",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11223,
      "keyword": "chófer",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32916,
      "keyword": "chófer",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "choféres": [
    {
      "id": 3019,
      "keyword": "chófer",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carnicería": [
    {
      "id": 6074,
      "keyword": "carnicería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35663,
      "keyword": "carnicería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3007,
      "keyword": "carnicería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carnicerías": [
    {
      "id": 6074,
      "keyword": "carnicería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35663,
      "keyword": "carnicería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3007,
      "keyword": "carnicería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "compresa": [
    {
      "id": 3018,
      "keyword": "compresa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body",
        "intimate hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31981,
      "keyword": "compresa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body",
        "intimate hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36631,
      "keyword": "compresa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body",
        "intimate hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compresas": [
    {
      "id": 3018,
      "keyword": "compresa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body",
        "intimate hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31981,
      "keyword": "compresa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body",
        "intimate hygiene"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36631,
      "keyword": "compresa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body",
        "intimate hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "compresa higiénica": [
    {
      "id": 35825,
      "keyword": "compresa higiénica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body",
        "intimate hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3018,
      "keyword": "compresa higiénica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body",
        "intimate hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31981,
      "keyword": "compresa higiénica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body",
        "intimate hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36631,
      "keyword": "compresa higiénica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body",
        "intimate hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compresas higiénicas": [
    {
      "id": 35825,
      "keyword": "compresa higiénica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body",
        "intimate hygiene"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3018,
      "keyword": "compresa higiénica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body",
        "intimate hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31981,
      "keyword": "compresa higiénica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body",
        "intimate hygiene"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36631,
      "keyword": "compresa higiénica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body",
        "intimate hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "croquetas": [
    {
      "id": 3020,
      "keyword": "croquetas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8307,
      "keyword": "croqueta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "a": [
    {
      "id": 7041,
      "keyword": "a",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3021,
      "keyword": "a",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3049,
      "keyword": "A",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cigüeña": [
    {
      "id": 3015,
      "keyword": "cigüeña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cigüeñas": [
    {
      "id": 3015,
      "keyword": "cigüeña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calamares a la romana": [
    {
      "id": 3002,
      "keyword": "calamares a la romana",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calamares": [
    {
      "id": 5418,
      "keyword": "calamar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3002,
      "keyword": "calamares",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calamares rebozados": [
    {
      "id": 3002,
      "keyword": "calamares rebozados",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limón": [
    {
      "id": 3022,
      "keyword": "limón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limones": [
    {
      "id": 3022,
      "keyword": "limón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "c": [
    {
      "id": 3024,
      "keyword": "c",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3069,
      "keyword": "C",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "d": [
    {
      "id": 3025,
      "keyword": "d",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3088,
      "keyword": "D",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "e": [
    {
      "id": 11399,
      "keyword": "e",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "conjunction",
        "copulative conjunction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3026,
      "keyword": "e",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3096,
      "keyword": "E",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "f": [
    {
      "id": 3027,
      "keyword": "f",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3101,
      "keyword": "F",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "b": [
    {
      "id": 3023,
      "keyword": "b",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3061,
      "keyword": "B",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "g": [
    {
      "id": 3028,
      "keyword": "g",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3104,
      "keyword": "G",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "champán": [
    {
      "id": 3009,
      "keyword": "champán",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cava": [
    {
      "id": 3009,
      "keyword": "cava",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cavas": [
    {
      "id": 3009,
      "keyword": "cava",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "i": [
    {
      "id": 3030,
      "keyword": "i",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3117,
      "keyword": "I",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "o": [
    {
      "id": 3037,
      "keyword": "o",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter",
        "conjunction",
        "copulative conjunction",
        "disjunctive conjunction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3136,
      "keyword": "O",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter",
        "conjunction",
        "copulative conjunction",
        "disjunctive conjunction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11317,
      "keyword": "o",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "conjunction",
        "copulative conjunction",
        "disjunctive conjunction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "j": [
    {
      "id": 3031,
      "keyword": "j",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3119,
      "keyword": "J",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "p": [
    {
      "id": 3038,
      "keyword": "p",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3137,
      "keyword": "P",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "k": [
    {
      "id": 3032,
      "keyword": "k",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3120,
      "keyword": "K",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "l": [
    {
      "id": 3033,
      "keyword": "l",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3121,
      "keyword": "L",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "h": [
    {
      "id": 3029,
      "keyword": "h",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3112,
      "keyword": "H",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "r": [
    {
      "id": 3040,
      "keyword": "r",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3147,
      "keyword": "R",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "q": [
    {
      "id": 3039,
      "keyword": "q",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3146,
      "keyword": "Q",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "s": [
    {
      "id": 3041,
      "keyword": "s",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3152,
      "keyword": "S",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "t": [
    {
      "id": 3042,
      "keyword": "t",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3158,
      "keyword": "T",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "n": [
    {
      "id": 3036,
      "keyword": "n",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3133,
      "keyword": "N",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "x": [
    {
      "id": 3046,
      "keyword": "x",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3168,
      "keyword": "X",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "m": [
    {
      "id": 3035,
      "keyword": "m",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3125,
      "keyword": "M",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "z": [
    {
      "id": 3048,
      "keyword": "z",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3173,
      "keyword": "Z",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "v": [
    {
      "id": 3044,
      "keyword": "v",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3165,
      "keyword": "V",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "u": [
    {
      "id": 3043,
      "keyword": "u",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3164,
      "keyword": "U",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "w": [
    {
      "id": 3045,
      "keyword": "w",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3167,
      "keyword": "W",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abeto": [
    {
      "id": 3051,
      "keyword": "abeto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abetos": [
    {
      "id": 3051,
      "keyword": "abeto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "y": [
    {
      "id": 11399,
      "keyword": "y",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "conjunction",
        "copulative conjunction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3047,
      "keyword": "y",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter",
        "conjunction",
        "copulative conjunction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3171,
      "keyword": "Y",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acebo": [
    {
      "id": 3052,
      "keyword": "acebo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "bush"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acebos": [
    {
      "id": 3052,
      "keyword": "acebo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "bush"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abecedario": [
    {
      "id": 3050,
      "keyword": "abecedario",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alfabeto": [
    {
      "id": 3050,
      "keyword": "alfabeto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ajedrez": [
    {
      "id": 3054,
      "keyword": "ajedrez",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game",
        "sport",
        "chess"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aletas": [
    {
      "id": 3055,
      "keyword": "aletas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sport material",
        "diving",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5373,
      "keyword": "aletas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "vertebrate",
        "fish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6895,
      "keyword": "aleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "vertebrate",
        "fish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "avioneta": [
    {
      "id": 3059,
      "keyword": "avioneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "avionetas": [
    {
      "id": 3059,
      "keyword": "avioneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ayuntamiento": [
    {
      "id": 24382,
      "keyword": "ayuntamiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36589,
      "keyword": "ayuntamiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3060,
      "keyword": "ayuntamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ayuntamientos": [
    {
      "id": 24382,
      "keyword": "ayuntamiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36589,
      "keyword": "ayuntamiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3060,
      "keyword": "ayuntamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alcaldía": [
    {
      "id": 3060,
      "keyword": "alcaldía",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alcaldías": [
    {
      "id": 3060,
      "keyword": "alcaldía",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "intendencia": [
    {
      "id": 3060,
      "keyword": "intendencia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intendencias": [
    {
      "id": 3060,
      "keyword": "intendencia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aeropuerto": [
    {
      "id": 6031,
      "keyword": "aeropuerto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "communication",
        "signaling system",
        "work",
        "tertiary sector",
        "transport services",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32506,
      "keyword": "aeropuerto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "communication",
        "signaling system",
        "work",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3053,
      "keyword": "aeropuerto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "facility",
        "work",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aeropuertos": [
    {
      "id": 6031,
      "keyword": "aeropuerto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "communication",
        "signaling system",
        "work",
        "tertiary sector",
        "transport services",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32506,
      "keyword": "aeropuerto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "communication",
        "signaling system",
        "work",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3053,
      "keyword": "aeropuerto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "facility",
        "work",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "árbol de navidad": [
    {
      "id": 24859,
      "keyword": "árbol de Navidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3058,
      "keyword": "árbol de Navidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "árboles de navidad": [
    {
      "id": 24859,
      "keyword": "árbol de Navidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3058,
      "keyword": "árbol de Navidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ángel": [
    {
      "id": 3056,
      "keyword": "ángel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "character",
        "christianity",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36141,
      "keyword": "ángel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "character",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ángeles": [
    {
      "id": 3056,
      "keyword": "ángel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "character",
        "christianity",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36141,
      "keyword": "ángel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "character",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "angelito": [
    {
      "id": 3056,
      "keyword": "angelito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "character",
        "christianity",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "angelitos": [
    {
      "id": 3056,
      "keyword": "angelito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "character",
        "christianity",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "banco": [
    {
      "id": 6055,
      "keyword": "banco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "financial services",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36831,
      "keyword": "banco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "financial services",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36832,
      "keyword": "banco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "financial services",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3062,
      "keyword": "banco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3255,
      "keyword": "banco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36828,
      "keyword": "banco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36830,
      "keyword": "banco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4919,
      "keyword": "banco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "education",
        "educational equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10242,
      "keyword": "banco",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "group",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bancos": [
    {
      "id": 6055,
      "keyword": "banco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "financial services",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36831,
      "keyword": "banco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "financial services",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36832,
      "keyword": "banco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "financial services",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3062,
      "keyword": "banco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3255,
      "keyword": "banco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36828,
      "keyword": "banco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36830,
      "keyword": "banco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4919,
      "keyword": "banco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "education",
        "educational equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10242,
      "keyword": "banco",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "group",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barbie": [
    {
      "id": 3063,
      "keyword": "Barbie",
      "keywords": 2,
      "type": 1,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cactus": [
    {
      "id": 3070,
      "keyword": "cactus",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "cactus"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cacto": [
    {
      "id": 3070,
      "keyword": "cacto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "cactus"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cactos": [
    {
      "id": 3070,
      "keyword": "cacto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "cactus"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "campanas": [
    {
      "id": 3072,
      "keyword": "campanas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5938,
      "keyword": "campana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23897,
      "keyword": "campanas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "biblioteca": [
    {
      "id": 6063,
      "keyword": "biblioteca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "library science",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 6063,
      "keyword": "biblioteca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "library science",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5926,
      "keyword": "biblioteca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32450,
      "keyword": "biblioteca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "library science",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3065,
      "keyword": "biblioteca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science",
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bibliotecas": [
    {
      "id": 6063,
      "keyword": "biblioteca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "library science",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 6063,
      "keyword": "biblioteca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "library science",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5926,
      "keyword": "biblioteca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32450,
      "keyword": "biblioteca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "library science",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3065,
      "keyword": "biblioteca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science",
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "campo de fútbol": [
    {
      "id": 3073,
      "keyword": "campo de fútbol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "football",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5993,
      "keyword": "campo de fútbol",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campos de fútbol": [
    {
      "id": 3073,
      "keyword": "campo de fútbol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "football",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5993,
      "keyword": "campo de fútbol",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bautizo": [
    {
      "id": 3064,
      "keyword": "bautizo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bautizos": [
    {
      "id": 3064,
      "keyword": "bautizo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bautizar": [
    {
      "id": 3064,
      "keyword": "bautizar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolas del árbol de navidad": [
    {
      "id": 3067,
      "keyword": "bolas del árbol de navidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8296,
      "keyword": "bola del árbol de navidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calendario": [
    {
      "id": 32488,
      "keyword": "calendario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3071,
      "keyword": "calendario",
      "keywords": 3,
      "type": 2,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calendarios": [
    {
      "id": 32488,
      "keyword": "calendario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3071,
      "keyword": "calendario",
      "keywords": 3,
      "type": 2,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anuario": [
    {
      "id": 3071,
      "keyword": "anuario",
      "keywords": 3,
      "type": 2,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anuarios": [
    {
      "id": 3071,
      "keyword": "anuario",
      "keywords": 3,
      "type": 2,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almanaque": [
    {
      "id": 3071,
      "keyword": "almanaque",
      "keywords": 3,
      "type": 2,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almanaques": [
    {
      "id": 3071,
      "keyword": "almanaque",
      "keywords": 3,
      "type": 2,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chancletas": [
    {
      "id": 3077,
      "keyword": "chancletas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8343,
      "keyword": "chancleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chanclas": [
    {
      "id": 3077,
      "keyword": "chanclas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8343,
      "keyword": "chancla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ciprés": [
    {
      "id": 3079,
      "keyword": "ciprés",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cipreses": [
    {
      "id": 3079,
      "keyword": "ciprés",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clavel": [
    {
      "id": 3080,
      "keyword": "clavel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "claveles": [
    {
      "id": 3080,
      "keyword": "clavel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casco de piloto": [
    {
      "id": 3076,
      "keyword": "casco de piloto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cascos de piloto": [
    {
      "id": 3076,
      "keyword": "casco de piloto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carnaval": [
    {
      "id": 25924,
      "keyword": "carnaval",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "carnival",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3074,
      "keyword": "carnaval",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "carnival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carnavales": [
    {
      "id": 25924,
      "keyword": "carnaval",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "carnival",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3074,
      "keyword": "carnaval",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "carnival"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colegio": [
    {
      "id": 32446,
      "keyword": "colegio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6454,
      "keyword": "colegio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3082,
      "keyword": "colegio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colegios": [
    {
      "id": 32446,
      "keyword": "colegio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6454,
      "keyword": "colegio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3082,
      "keyword": "colegio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escuela": [
    {
      "id": 32446,
      "keyword": "escuela",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6454,
      "keyword": "escuela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3082,
      "keyword": "escuela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escuelas": [
    {
      "id": 32446,
      "keyword": "escuela",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6454,
      "keyword": "escuela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3082,
      "keyword": "escuela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coche deportivo": [
    {
      "id": 3081,
      "keyword": "coche deportivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coches deportivos": [
    {
      "id": 3081,
      "keyword": "coche deportivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casco de ciclista": [
    {
      "id": 3075,
      "keyword": "casco de ciclista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cascos de ciclista": [
    {
      "id": 3075,
      "keyword": "casco de ciclista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "cycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "correo": [
    {
      "id": 32540,
      "keyword": "correo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "computing",
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3086,
      "keyword": "correo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5432,
      "keyword": "correo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "correos": [
    {
      "id": 6464,
      "keyword": "correos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32540,
      "keyword": "correo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "computing",
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36233,
      "keyword": "correos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3086,
      "keyword": "correo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3086,
      "keyword": "correos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5432,
      "keyword": "correo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ciclista": [
    {
      "id": 3078,
      "keyword": "ciclista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciclistas": [
    {
      "id": 3078,
      "keyword": "ciclista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "cycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cumpleaños": [
    {
      "id": 37363,
      "keyword": "cumpleaños",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "birthday",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3087,
      "keyword": "cumpleaños",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26781,
      "keyword": "cumpleaños",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28491,
      "keyword": "cumpleaños",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28492,
      "keyword": "cumpleaños",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dardos": [
    {
      "id": 3090,
      "keyword": "dardos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "sport material",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8309,
      "keyword": "dardo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comisaría": [
    {
      "id": 32332,
      "keyword": "comisaría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32334,
      "keyword": "comisaría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32333,
      "keyword": "comisaría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32414,
      "keyword": "comisaría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3083,
      "keyword": "comisaría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3083,
      "keyword": "comisaría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36900,
      "keyword": "comisaría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comisarías": [
    {
      "id": 32332,
      "keyword": "comisaría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32334,
      "keyword": "comisaría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32333,
      "keyword": "comisaría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32414,
      "keyword": "comisaría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3083,
      "keyword": "comisaría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 3083,
      "keyword": "comisaría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36900,
      "keyword": "comisaría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "día de la madre": [
    {
      "id": 3091,
      "keyword": "Día de la Madre",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "día del padre": [
    {
      "id": 3093,
      "keyword": "Día del Padre",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comunión": [
    {
      "id": 38777,
      "keyword": "comunión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3084,
      "keyword": "comunión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27687,
      "keyword": "comunión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comuniones": [
    {
      "id": 38777,
      "keyword": "comunión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3084,
      "keyword": "comunión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27687,
      "keyword": "comunión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "primera comunión": [
    {
      "id": 38777,
      "keyword": "primera comunión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3084,
      "keyword": "primera comunión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27687,
      "keyword": "primera comunión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "primeras comuniones": [
    {
      "id": 38777,
      "keyword": "primera comunión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3084,
      "keyword": "primera comunión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27687,
      "keyword": "primera comunión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "día de navidad": [
    {
      "id": 3092,
      "keyword": "Día de Navidad",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "christmas",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estación de tren": [
    {
      "id": 29905,
      "keyword": "estación de tren",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 29905,
      "keyword": "estación de tren",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6494,
      "keyword": "estación de tren",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3099,
      "keyword": "estación de tren",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estaciones de tren": [
    {
      "id": 29905,
      "keyword": "estación de tren",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 29905,
      "keyword": "estación de tren",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6494,
      "keyword": "estación de tren",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3099,
      "keyword": "estación de tren",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estación": [
    {
      "id": 29905,
      "keyword": "estación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 29905,
      "keyword": "estación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6494,
      "keyword": "estación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3099,
      "keyword": "estación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5464,
      "keyword": "estación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "season",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estaciones": [
    {
      "id": 29905,
      "keyword": "estación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 29905,
      "keyword": "estación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6494,
      "keyword": "estación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3099,
      "keyword": "estación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5464,
      "keyword": "estaciones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "season",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5464,
      "keyword": "estación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "season",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dominó": [
    {
      "id": 3095,
      "keyword": "dominó",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dominós": [
    {
      "id": 3095,
      "keyword": "dominó",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esquiador": [
    {
      "id": 3097,
      "keyword": "esquiador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esquiadores": [
    {
      "id": 3097,
      "keyword": "esquiador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estrella de navidad": [
    {
      "id": 3100,
      "keyword": "Estrella de Navidad",
      "keywords": 2,
      "type": 1,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salvavidas": [
    {
      "id": 3103,
      "keyword": "salvavidas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flor": [
    {
      "id": 7104,
      "keyword": "flor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "plant anatomy",
        "anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3102,
      "keyword": "flor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flores": [
    {
      "id": 7104,
      "keyword": "flor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "plant anatomy",
        "anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3102,
      "keyword": "flor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7105,
      "keyword": "flores",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "spring"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esquís": [
    {
      "id": 3098,
      "keyword": "esquís",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8348,
      "keyword": "esquí",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "directora de orquesta": [
    {
      "id": 3094,
      "keyword": "directora de orquesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "directoras de orquesta": [
    {
      "id": 3094,
      "keyword": "directora de orquesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gimnasta": [
    {
      "id": 3106,
      "keyword": "gimnasta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "gymnastics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3107,
      "keyword": "gimnasta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "gymnastics",
        "rhythmic gymnastics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gimnastas": [
    {
      "id": 3106,
      "keyword": "gimnasta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "gymnastics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3107,
      "keyword": "gimnasta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "gymnastics",
        "rhythmic gymnastics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "granizo": [
    {
      "id": 3110,
      "keyword": "granizo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "granizos": [
    {
      "id": 3110,
      "keyword": "granizo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gorro de natación": [
    {
      "id": 3108,
      "keyword": "gorro de natación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33984,
      "keyword": "gorro de natación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gorros de natación": [
    {
      "id": 3108,
      "keyword": "gorro de natación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33984,
      "keyword": "gorro de natación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gorro de papá noel": [
    {
      "id": 3109,
      "keyword": "gorro de papá noel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gorros de papá noel": [
    {
      "id": 3109,
      "keyword": "gorro de papá noel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guirnalda": [
    {
      "id": 3111,
      "keyword": "guirnalda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guirnaldas": [
    {
      "id": 3111,
      "keyword": "guirnalda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hierba": [
    {
      "id": 3113,
      "keyword": "hierba",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant",
        "core vocabulary",
        "animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hierbas": [
    {
      "id": 3113,
      "keyword": "hierba",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant",
        "core vocabulary",
        "animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pasto": [
    {
      "id": 3113,
      "keyword": "pasto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant",
        "core vocabulary",
        "animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pastos": [
    {
      "id": 3113,
      "keyword": "pasto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant",
        "core vocabulary",
        "animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "yuyo": [
    {
      "id": 3113,
      "keyword": "yuyo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant",
        "core vocabulary",
        "animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yuyos ": [
    {
      "id": 3113,
      "keyword": "yuyo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant",
        "core vocabulary",
        "animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hospital": [
    {
      "id": 6523,
      "keyword": "hospital",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37408,
      "keyword": "hospital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "communication",
        "signaling system",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38083,
      "keyword": "hospital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3116,
      "keyword": "hospital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36209,
      "keyword": "hospital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36207,
      "keyword": "hospital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hospitales": [
    {
      "id": 6523,
      "keyword": "hospital",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37408,
      "keyword": "hospital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "communication",
        "signaling system",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38083,
      "keyword": "hospital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3116,
      "keyword": "hospital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36209,
      "keyword": "hospital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36207,
      "keyword": "hospital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hoja": [
    {
      "id": 5077,
      "keyword": "hoja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 5077,
      "keyword": "hoja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3114,
      "keyword": "hoja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5076,
      "keyword": "hoja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hojas": [
    {
      "id": 5077,
      "keyword": "hoja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 5077,
      "keyword": "hoja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3114,
      "keyword": "hoja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5076,
      "keyword": "hoja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gafas de agua": [
    {
      "id": 3105,
      "keyword": "gafas de agua",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming",
        "outdoor activity",
        "swimming pool",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lentes de agua": [
    {
      "id": 3105,
      "keyword": "lentes de agua",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming",
        "outdoor activity",
        "swimming pool",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anteojos de agua": [
    {
      "id": 3105,
      "keyword": "anteojos de agua",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming",
        "outdoor activity",
        "swimming pool",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limonero": [
    {
      "id": 3122,
      "keyword": "limonero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limoneros": [
    {
      "id": 3122,
      "keyword": "limonero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lluvia": [
    {
      "id": 7148,
      "keyword": "lluvia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3123,
      "keyword": "lluvia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena",
        "spring"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lluvias": [
    {
      "id": 7148,
      "keyword": "lluvia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3123,
      "keyword": "lluvia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena",
        "spring"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "margarita": [
    {
      "id": 3127,
      "keyword": "margarita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "hervaceouos plant",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "margaritas": [
    {
      "id": 3127,
      "keyword": "margarita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "hervaceouos plant",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesa": [
    {
      "id": 6562,
      "keyword": "mesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3129,
      "keyword": "mesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3129,
      "keyword": "mesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas": [
    {
      "id": 6562,
      "keyword": "mesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3129,
      "keyword": "mesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 3129,
      "keyword": "mesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "muñeco": [
    {
      "id": 3130,
      "keyword": "muñeco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8728,
      "keyword": "muñeco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muñecos": [
    {
      "id": 3130,
      "keyword": "muñeco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8728,
      "keyword": "muñeco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "muñeco de nieve": [
    {
      "id": 3131,
      "keyword": "muñeco de nieve",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muñecos de nieve": [
    {
      "id": 3131,
      "keyword": "muñeco de nieve",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "iglesia": [
    {
      "id": 30903,
      "keyword": "iglesia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6530,
      "keyword": "iglesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3118,
      "keyword": "iglesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3118,
      "keyword": "iglesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "iglesias": [
    {
      "id": 30903,
      "keyword": "iglesia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6530,
      "keyword": "iglesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3118,
      "keyword": "iglesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 3118,
      "keyword": "iglesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "templo": [
    {
      "id": 6530,
      "keyword": "templo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3118,
      "keyword": "templo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3118,
      "keyword": "templo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8231,
      "keyword": "templo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "building",
        "religion",
        "history",
        "civilization",
        "Rome",
        "Greece"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "templos": [
    {
      "id": 6530,
      "keyword": "templo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3118,
      "keyword": "templo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 3118,
      "keyword": "templo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8231,
      "keyword": "templo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "building",
        "religion",
        "history",
        "civilization",
        "Rome",
        "Greece"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "medalla": [
    {
      "id": 3128,
      "keyword": "medalla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medallas": [
    {
      "id": 3128,
      "keyword": "medalla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "medalla de oro": [
    {
      "id": 3128,
      "keyword": "medalla de oro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medallas de oro": [
    {
      "id": 3128,
      "keyword": "medalla de oro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maceta": [
    {
      "id": 3126,
      "keyword": "maceta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "macetas": [
    {
      "id": 3126,
      "keyword": "maceta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reyes magos": [
    {
      "id": 26390,
      "keyword": "Reyes Magos",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "christianity",
        "event",
        "popular event",
        "christmas",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3124,
      "keyword": "Reyes Magos",
      "keywords": 2,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "christianity",
        "event",
        "popular event",
        "christmas",
        "religious event",
        "social event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reyes": [
    {
      "id": 34244,
      "keyword": "rey",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "chess"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3124,
      "keyword": "Reyes",
      "keywords": 2,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "christianity",
        "event",
        "popular event",
        "christmas",
        "religious event",
        "social event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5072,
      "keyword": "Reyes",
      "keywords": 3,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "christmas",
        "religious event",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5563,
      "keyword": "rey",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "character",
        "book character",
        "literature",
        "tale character",
        "history",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palmera": [
    {
      "id": 3138,
      "keyword": "palmera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10356,
      "keyword": "palmera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palmeras": [
    {
      "id": 3138,
      "keyword": "palmera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10356,
      "keyword": "palmera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "papá noel": [
    {
      "id": 25298,
      "keyword": "Papá Noel",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "event",
        "popular event",
        "christmas",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32454,
      "keyword": "Papá Noel",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25297,
      "keyword": "Papá Noel",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3139,
      "keyword": "Papá Noel",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "santa claus": [
    {
      "id": 25298,
      "keyword": "Santa Claus",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "event",
        "popular event",
        "christmas",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25297,
      "keyword": "Santa Claus",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3139,
      "keyword": "Santa Claus",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pilas": [
    {
      "id": 3141,
      "keyword": "pilas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3141,
      "keyword": "pilas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8320,
      "keyword": "pila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24282,
      "keyword": "pila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30834,
      "keyword": "pila",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "event",
        "religious event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nieve": [
    {
      "id": 7172,
      "keyword": "nieve",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3135,
      "keyword": "nieve",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena",
        "event",
        "popular event",
        "christmas",
        "winter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nieves": [
    {
      "id": 7172,
      "keyword": "nieve",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3135,
      "keyword": "nieve",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena",
        "event",
        "popular event",
        "christmas",
        "winter"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parque de bomberos": [
    {
      "id": 6578,
      "keyword": "parque de bomberos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3140,
      "keyword": "parque de bomberos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parques de bomberos": [
    {
      "id": 6578,
      "keyword": "parque de bomberos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3140,
      "keyword": "parque de bomberos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "navidad": [
    {
      "id": 3134,
      "keyword": "Navidad",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "christmas",
        "religious event",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "planta": [
    {
      "id": 11343,
      "keyword": "planta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3143,
      "keyword": "planta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "core vocabulary",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38613,
      "keyword": "planta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37864,
      "keyword": "planta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "architecture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plantas": [
    {
      "id": 11343,
      "keyword": "planta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3143,
      "keyword": "planta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "core vocabulary",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11572,
      "keyword": "plantas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38613,
      "keyword": "planta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37864,
      "keyword": "planta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "architecture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "platanero": [
    {
      "id": 3144,
      "keyword": "platanero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "hervaceouos plant",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plataneros": [
    {
      "id": 3144,
      "keyword": "platanero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "hervaceouos plant",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "platanera": [
    {
      "id": 3144,
      "keyword": "platanera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "hervaceouos plant",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plataneras": [
    {
      "id": 3144,
      "keyword": "platanera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "hervaceouos plant",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "museo": [
    {
      "id": 32406,
      "keyword": "museo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6566,
      "keyword": "museo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3132,
      "keyword": "museo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "museos": [
    {
      "id": 32406,
      "keyword": "museo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6566,
      "keyword": "museo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3132,
      "keyword": "museo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "piscina": [
    {
      "id": 30516,
      "keyword": "piscina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "swimming",
        "outdoor activity",
        "swimming pool",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3142,
      "keyword": "piscina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piscinas": [
    {
      "id": 30516,
      "keyword": "piscina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "swimming",
        "outdoor activity",
        "swimming pool",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3142,
      "keyword": "piscina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pileta": [
    {
      "id": 30516,
      "keyword": "pileta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "swimming",
        "outdoor activity",
        "swimming pool",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3142,
      "keyword": "pileta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piletas": [
    {
      "id": 30516,
      "keyword": "pileta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "swimming",
        "outdoor activity",
        "swimming pool",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3142,
      "keyword": "pileta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "raíz": [
    {
      "id": 3148,
      "keyword": "raíz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "raíces": [
    {
      "id": 3148,
      "keyword": "raíz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rodolfo el reno": [
    {
      "id": 3150,
      "keyword": "Rodolfo el Reno",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reno de papá noel": [
    {
      "id": 3150,
      "keyword": "reno de Papá Noel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "renos de papá noel": [
    {
      "id": 3150,
      "keyword": "reno de Papá Noel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "regalo": [
    {
      "id": 25381,
      "keyword": "regalo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "christmas",
        "social event",
        "birthday",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3149,
      "keyword": "regalo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "regalos": [
    {
      "id": 25381,
      "keyword": "regalo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "christmas",
        "social event",
        "birthday",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3149,
      "keyword": "regalo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "semana santa": [
    {
      "id": 25441,
      "keyword": "Semana Santa",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "easter week",
        "religious event",
        "religion",
        "christianity",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32538,
      "keyword": "Semana Santa",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "easter week",
        "religious event",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3153,
      "keyword": "Semana Santa",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "easter week",
        "religious event",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puerto": [
    {
      "id": 32410,
      "keyword": "puerto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "communication",
        "signaling system",
        "work",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3145,
      "keyword": "puerto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15535,
      "keyword": "puerto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31326,
      "keyword": "puerto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puertos": [
    {
      "id": 32410,
      "keyword": "puerto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "communication",
        "signaling system",
        "work",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3145,
      "keyword": "puerto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15535,
      "keyword": "puerto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31326,
      "keyword": "puerto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "submarino": [
    {
      "id": 3157,
      "keyword": "submarino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "submarinos": [
    {
      "id": 3157,
      "keyword": "submarino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tierra": [
    {
      "id": 3160,
      "keyword": "tierra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "primary sector",
        "agriculture",
        "gardening",
        "work",
        "cattle farming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30014,
      "keyword": "Tierra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "astronomy",
        "planet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tierras": [
    {
      "id": 3160,
      "keyword": "tierra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "primary sector",
        "agriculture",
        "gardening",
        "work",
        "cattle farming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silla": [
    {
      "id": 3155,
      "keyword": "silla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3155,
      "keyword": "silla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6614,
      "keyword": "silla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25459,
      "keyword": "silla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25460,
      "keyword": "silla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6281,
      "keyword": "silla",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas": [
    {
      "id": 3155,
      "keyword": "silla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 3155,
      "keyword": "silla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6614,
      "keyword": "silla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25459,
      "keyword": "silla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25460,
      "keyword": "silla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6281,
      "keyword": "silla",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tallo": [
    {
      "id": 3159,
      "keyword": "tallo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37009,
      "keyword": "tallo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17183,
      "keyword": "tallo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant physiology",
        "plant anatomy",
        "anatomy",
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tallos": [
    {
      "id": 3159,
      "keyword": "tallo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37009,
      "keyword": "tallo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 17183,
      "keyword": "tallo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant physiology",
        "plant anatomy",
        "anatomy",
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tulipán": [
    {
      "id": 3163,
      "keyword": "tulipán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tulipanes": [
    {
      "id": 3163,
      "keyword": "tulipán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34043,
      "keyword": "tulipanes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "setas": [
    {
      "id": 3154,
      "keyword": "setas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3386,
      "keyword": "setas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "plant",
        "fungus"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8328,
      "keyword": "seta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "plant",
        "fungus"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vacaciones": [
    {
      "id": 32442,
      "keyword": "vacaciones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "teaching activity",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39447,
      "keyword": "vacaciones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39446,
      "keyword": "vacaciones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "movement",
        "traffic",
        "mode of transport",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3166,
      "keyword": "vacaciones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39112,
      "keyword": "vacaciones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trofeo": [
    {
      "id": 3162,
      "keyword": "trofeo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trofeos": [
    {
      "id": 3162,
      "keyword": "trofeo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alcalde": [
    {
      "id": 3170,
      "keyword": "alcalde",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "person",
        "leader"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alcaldes": [
    {
      "id": 3170,
      "keyword": "alcalde",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "person",
        "leader"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "intendente": [
    {
      "id": 3170,
      "keyword": "intendente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "person",
        "leader"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intendentes": [
    {
      "id": 3170,
      "keyword": "intendente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "person",
        "leader"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "yate": [
    {
      "id": 3172,
      "keyword": "yate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yates": [
    {
      "id": 3172,
      "keyword": "yate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trineo de papá noel": [
    {
      "id": 3161,
      "keyword": "trineo de Papá Noel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trineos de papá noel": [
    {
      "id": 3161,
      "keyword": "trineo de Papá Noel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "socorrista": [
    {
      "id": 29117,
      "keyword": "socorrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29118,
      "keyword": "socorrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29119,
      "keyword": "socorrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3156,
      "keyword": "socorrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11378,
      "keyword": "socorrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "socorristas": [
    {
      "id": 29117,
      "keyword": "socorrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29118,
      "keyword": "socorrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29119,
      "keyword": "socorrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool",
        "beach"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3156,
      "keyword": "socorrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11378,
      "keyword": "socorrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amanecer": [
    {
      "id": 3175,
      "keyword": "amanecer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11477,
      "keyword": "amanecer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almendro": [
    {
      "id": 3174,
      "keyword": "almendro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almendros": [
    {
      "id": 3174,
      "keyword": "almendro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atardecer": [
    {
      "id": 3176,
      "keyword": "atardecer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baraja": [
    {
      "id": 3181,
      "keyword": "baraja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "card game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3182,
      "keyword": "baraja",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "card game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barajas": [
    {
      "id": 3181,
      "keyword": "baraja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "card game",
        "board game"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3182,
      "keyword": "baraja",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "card game",
        "board game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asterisco": [
    {
      "id": 3178,
      "keyword": "asterisco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asteriscos": [
    {
      "id": 3178,
      "keyword": "asterisco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "*": [
    {
      "id": 3178,
      "keyword": "*",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arroba": [
    {
      "id": 3177,
      "keyword": "arroba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arrobas": [
    {
      "id": 3177,
      "keyword": "arroba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "@": [
    {
      "id": 3177,
      "keyword": "@",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baraja de poker": [
    {
      "id": 3182,
      "keyword": "baraja de poker",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "card game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barajas de poker": [
    {
      "id": 3182,
      "keyword": "baraja de poker",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "card game",
        "board game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "castañas": [
    {
      "id": 3183,
      "keyword": "castañas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8302,
      "keyword": "castaña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "autocaravana": [
    {
      "id": 3180,
      "keyword": "autocaravana",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary",
        "leisure",
        "outdoor activity"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3180,
      "keyword": "autocaravana",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38243,
      "keyword": "autocaravana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autocaravanas": [
    {
      "id": 3180,
      "keyword": "autocaravana",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary",
        "leisure",
        "outdoor activity"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 3180,
      "keyword": "autocaravana",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38243,
      "keyword": "autocaravana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caravana": [
    {
      "id": 3180,
      "keyword": "caravana",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary",
        "leisure",
        "outdoor activity"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3180,
      "keyword": "caravana",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38741,
      "keyword": "caravana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caravanas": [
    {
      "id": 3180,
      "keyword": "caravana",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary",
        "leisure",
        "outdoor activity"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 3180,
      "keyword": "caravana",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38741,
      "keyword": "caravana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casa rodante": [
    {
      "id": 3180,
      "keyword": "casa rodante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary",
        "leisure",
        "outdoor activity"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3180,
      "keyword": "casa rodante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casas rodantes": [
    {
      "id": 3180,
      "keyword": "casa rodante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary",
        "leisure",
        "outdoor activity"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 3180,
      "keyword": "casa rodante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atleta": [
    {
      "id": 3179,
      "keyword": "atleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atletas": [
    {
      "id": 3179,
      "keyword": "atleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jinete": [
    {
      "id": 3169,
      "keyword": "jinete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "horse riding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jinetes": [
    {
      "id": 3169,
      "keyword": "jinete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "horse riding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ciruelo": [
    {
      "id": 3186,
      "keyword": "ciruelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciruelos": [
    {
      "id": 3186,
      "keyword": "ciruelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cirujano": [
    {
      "id": 38887,
      "keyword": "cirujano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38863,
      "keyword": "cirujano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38884,
      "keyword": "cirujano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3187,
      "keyword": "cirujano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35304,
      "keyword": "cirujano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cirujanos": [
    {
      "id": 38887,
      "keyword": "cirujano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38863,
      "keyword": "cirujano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38884,
      "keyword": "cirujano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3187,
      "keyword": "cirujano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35304,
      "keyword": "cirujano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cocotero": [
    {
      "id": 3188,
      "keyword": "cocotero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cocoteros": [
    {
      "id": 3188,
      "keyword": "cocotero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chopo": [
    {
      "id": 3185,
      "keyword": "chopo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chopos": [
    {
      "id": 3185,
      "keyword": "chopo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerezo": [
    {
      "id": 3184,
      "keyword": "cerezo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerezos": [
    {
      "id": 3184,
      "keyword": "cerezo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "damas": [
    {
      "id": 3192,
      "keyword": "damas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coma": [
    {
      "id": 3189,
      "keyword": "coma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comas": [
    {
      "id": 3189,
      "keyword": "coma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  ",": [
    {
      "id": 3189,
      "keyword": ",",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fotógrafa": [
    {
      "id": 38540,
      "keyword": "fotógrafa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3197,
      "keyword": "fotógrafa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fotógrafas": [
    {
      "id": 3197,
      "keyword": "fotógrafa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cosechadora": [
    {
      "id": 3191,
      "keyword": "cosechadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cosechadoras": [
    {
      "id": 3191,
      "keyword": "cosechadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guión": [
    {
      "id": 3200,
      "keyword": "guión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guiones": [
    {
      "id": 3200,
      "keyword": "guión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "-": [
    {
      "id": 3200,
      "keyword": "-",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "futbolista": [
    {
      "id": 3199,
      "keyword": "futbolista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 19530,
      "keyword": "futbolista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36229,
      "keyword": "futbolista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "futbolistas": [
    {
      "id": 3199,
      "keyword": "futbolista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "football"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 19530,
      "keyword": "futbolista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "football"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36229,
      "keyword": "futbolista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugador de fútbol": [
    {
      "id": 3199,
      "keyword": "jugador de fútbol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 19530,
      "keyword": "jugador de fútbol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadores de fútbol": [
    {
      "id": 3199,
      "keyword": "jugador de fútbol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "football"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 19530,
      "keyword": "jugador de fútbol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escaladora": [
    {
      "id": 3196,
      "keyword": "escaladora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27740,
      "keyword": "escaladora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escaladoras": [
    {
      "id": 3196,
      "keyword": "escaladora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27740,
      "keyword": "escaladora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "judoka": [
    {
      "id": 3202,
      "keyword": "judoka",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "judokas": [
    {
      "id": 3202,
      "keyword": "judoka",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manzano": [
    {
      "id": 3203,
      "keyword": "manzano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manzanos": [
    {
      "id": 3203,
      "keyword": "manzano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "melocotonero": [
    {
      "id": 3205,
      "keyword": "melocotonero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "melocotoneros": [
    {
      "id": 3205,
      "keyword": "melocotonero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "higuera": [
    {
      "id": 3201,
      "keyword": "higuera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "higueras": [
    {
      "id": 3201,
      "keyword": "higuera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "matasuegras": [
    {
      "id": 3204,
      "keyword": "matasuegras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entierro": [
    {
      "id": 3195,
      "keyword": "entierro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entierros": [
    {
      "id": 3195,
      "keyword": "entierro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nadador": [
    {
      "id": 3208,
      "keyword": "nadador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28703,
      "keyword": "nadador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nadadores": [
    {
      "id": 3208,
      "keyword": "nadador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28703,
      "keyword": "nadador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "patinadora": [
    {
      "id": 3212,
      "keyword": "patinadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35971,
      "keyword": "patinadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3213,
      "keyword": "patinadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patinadoras": [
    {
      "id": 3212,
      "keyword": "patinadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35971,
      "keyword": "patinadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3213,
      "keyword": "patinadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "patinaje": [
    {
      "id": 7198,
      "keyword": "patinaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30572,
      "keyword": "patinaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30577,
      "keyword": "patinaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30573,
      "keyword": "patinaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30576,
      "keyword": "patinaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3213,
      "keyword": "patinaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36017,
      "keyword": "patinaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comillas": [
    {
      "id": 3190,
      "keyword": "comillas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "\"": [
    {
      "id": 3190,
      "keyword": "\"",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peral": [
    {
      "id": 3214,
      "keyword": "peral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perales": [
    {
      "id": 3214,
      "keyword": "peral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "monovolumen": [
    {
      "id": 3206,
      "keyword": "monovolumen",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monovolúmenes": [
    {
      "id": 3206,
      "keyword": "monovolumen",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "punto": [
    {
      "id": 3218,
      "keyword": "punto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puntos": [
    {
      "id": 3218,
      "keyword": "punto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  ".": [
    {
      "id": 3218,
      "keyword": ".",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "olivo": [
    {
      "id": 3211,
      "keyword": "olivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34175,
      "keyword": "olivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "olivos": [
    {
      "id": 3211,
      "keyword": "olivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34175,
      "keyword": "olivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pino": [
    {
      "id": 3216,
      "keyword": "pino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinos": [
    {
      "id": 3216,
      "keyword": "pino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "montañero": [
    {
      "id": 3207,
      "keyword": "montañero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "montañeros": [
    {
      "id": 3207,
      "keyword": "montañero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pódium": [
    {
      "id": 3217,
      "keyword": "pódium",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pódiums": [
    {
      "id": 3217,
      "keyword": "pódium",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "podio": [
    {
      "id": 3217,
      "keyword": "podio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "podios": [
    {
      "id": 3217,
      "keyword": "podio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sauce": [
    {
      "id": 3219,
      "keyword": "sauce",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sauces": [
    {
      "id": 3219,
      "keyword": "sauce",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "más": [
    {
      "id": 26913,
      "keyword": "más",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3220,
      "keyword": "más",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5508,
      "keyword": "más",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree",
        "mathematics",
        "basic concepts",
        "core vocabulary",
        "adverb of addition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "+": [
    {
      "id": 3220,
      "keyword": "+",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "día parcialmente soleado": [
    {
      "id": 3210,
      "keyword": "día parcialmente soleado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "días parcialmente soleados": [
    {
      "id": 3210,
      "keyword": "día parcialmente soleado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parcialmente soleado": [
    {
      "id": 3210,
      "keyword": "parcialmente soleado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39218,
      "keyword": "parcialmente soleado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trampolín": [
    {
      "id": 3224,
      "keyword": "trampolín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22151,
      "keyword": "trampolín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trampolines": [
    {
      "id": 3224,
      "keyword": "trampolín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22151,
      "keyword": "trampolín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trueno": [
    {
      "id": 11389,
      "keyword": "trueno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena",
        "communication",
        "language",
        "verb",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3225,
      "keyword": "trueno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "truenos": [
    {
      "id": 11389,
      "keyword": "trueno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena",
        "communication",
        "language",
        "verb",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3225,
      "keyword": "trueno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abrebotellas": [
    {
      "id": 3226,
      "keyword": "abrebotellas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aspiradora": [
    {
      "id": 3227,
      "keyword": "aspiradora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aspiradoras": [
    {
      "id": 3227,
      "keyword": "aspiradora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "todoterreno": [
    {
      "id": 3223,
      "keyword": "todoterreno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "todoterrenos": [
    {
      "id": 3223,
      "keyword": "todoterreno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taxista": [
    {
      "id": 3221,
      "keyword": "taxista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11383,
      "keyword": "taxista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "transport services",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taxistas": [
    {
      "id": 3221,
      "keyword": "taxista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11383,
      "keyword": "taxista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "transport services",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "naranjo": [
    {
      "id": 3209,
      "keyword": "naranjo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "naranjos": [
    {
      "id": 3209,
      "keyword": "naranjo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bata": [
    {
      "id": 8038,
      "keyword": "bata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36499,
      "keyword": "bata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36500,
      "keyword": "bata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3229,
      "keyword": "bata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "batas": [
    {
      "id": 8038,
      "keyword": "bata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36499,
      "keyword": "bata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36500,
      "keyword": "bata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3229,
      "keyword": "bata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "babi": [
    {
      "id": 3229,
      "keyword": "babi",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "babis": [
    {
      "id": 3229,
      "keyword": "babi",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cacerola": [
    {
      "id": 3231,
      "keyword": "cacerola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cacerolas": [
    {
      "id": 3231,
      "keyword": "cacerola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camión de obras": [
    {
      "id": 3232,
      "keyword": "camión de obras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camiones de obras": [
    {
      "id": 3232,
      "keyword": "camión de obras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "volquete": [
    {
      "id": 3232,
      "keyword": "volquete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "volquetes": [
    {
      "id": 3232,
      "keyword": "volquete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tenista": [
    {
      "id": 6514,
      "keyword": "tenista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3222,
      "keyword": "tenista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6513,
      "keyword": "tenista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tenistas": [
    {
      "id": 6514,
      "keyword": "tenista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3222,
      "keyword": "tenista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6513,
      "keyword": "tenista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carpeta": [
    {
      "id": 3233,
      "keyword": "carpeta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3233,
      "keyword": "carpeta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carpetas": [
    {
      "id": 3233,
      "keyword": "carpeta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 3233,
      "keyword": "carpeta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cocinera": [
    {
      "id": 30526,
      "keyword": "cocinera",
      "keywords": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3235,
      "keyword": "cocinera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15712,
      "keyword": "cocinera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cocineras": [
    {
      "id": 30526,
      "keyword": "cocinera",
      "keywords": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3235,
      "keyword": "cocinera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15712,
      "keyword": "cocinera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuchillo": [
    {
      "id": 4931,
      "keyword": "cuchillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3237,
      "keyword": "cuchillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuchillos": [
    {
      "id": 4931,
      "keyword": "cuchillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3237,
      "keyword": "cuchillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chinchetas": [
    {
      "id": 3234,
      "keyword": "chinchetas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8304,
      "keyword": "chincheta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cazo": [
    {
      "id": 3230,
      "keyword": "cazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cazos": [
    {
      "id": 3230,
      "keyword": "cazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "puerta": [
    {
      "id": 3244,
      "keyword": "puerta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "architecture",
        "architectural element",
        "work",
        "secondary sector",
        "construction",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3244,
      "keyword": "puerta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "architecture",
        "architectural element",
        "work",
        "secondary sector",
        "construction",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37619,
      "keyword": "puerta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37623,
      "keyword": "puerta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38750,
      "keyword": "puerta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "architecture",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puertas": [
    {
      "id": 3244,
      "keyword": "puerta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "architecture",
        "architectural element",
        "work",
        "secondary sector",
        "construction",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 3244,
      "keyword": "puerta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "architecture",
        "architectural element",
        "work",
        "secondary sector",
        "construction",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37619,
      "keyword": "puerta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37623,
      "keyword": "puerta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38750,
      "keyword": "puerta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "architecture",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pelota": [
    {
      "id": 3241,
      "keyword": "pelota",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3241,
      "keyword": "pelota",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelotas": [
    {
      "id": 3241,
      "keyword": "pelota",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 3241,
      "keyword": "pelota",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pelota de playa": [
    {
      "id": 3241,
      "keyword": "pelota de playa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3241,
      "keyword": "pelota de playa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelotas de playa": [
    {
      "id": 3241,
      "keyword": "pelota de playa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 3241,
      "keyword": "pelota de playa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "uvas": [
    {
      "id": 3247,
      "keyword": "uvas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34120,
      "keyword": "uvas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "racimo de uvas": [
    {
      "id": 3247,
      "keyword": "racimo de uvas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "racimos de uvas": [
    {
      "id": 3247,
      "keyword": "racimo de uvas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "uva": [
    {
      "id": 3247,
      "keyword": "uva",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34120,
      "keyword": "uva",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zumo de melocotón": [
    {
      "id": 3248,
      "keyword": "zumo de melocotón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zumos de melocotón": [
    {
      "id": 3248,
      "keyword": "zumo de melocotón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zumo de durazno": [
    {
      "id": 3248,
      "keyword": "zumo de durazno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zumos de durazno": [
    {
      "id": 3248,
      "keyword": "zumo de durazno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rotulador": [
    {
      "id": 3246,
      "keyword": "rotulador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7807,
      "keyword": "rotulador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rotuladores": [
    {
      "id": 3246,
      "keyword": "rotulador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7807,
      "keyword": "rotulador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39103,
      "keyword": "rotuladores",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fibra": [
    {
      "id": 3246,
      "keyword": "fibra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fibras": [
    {
      "id": 3246,
      "keyword": "fibra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39103,
      "keyword": "fibras",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contento": [
    {
      "id": 35547,
      "keyword": "contento",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31923,
      "keyword": "contento",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3245,
      "keyword": "contento",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32123,
      "keyword": "contento",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9907,
      "keyword": "contento",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contentos": [
    {
      "id": 35547,
      "keyword": "contento",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31923,
      "keyword": "contento",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3245,
      "keyword": "contento",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32123,
      "keyword": "contento",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9907,
      "keyword": "contento",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contenta": [
    {
      "id": 35547,
      "keyword": "contenta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28647,
      "keyword": "contenta",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3245,
      "keyword": "contenta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9907,
      "keyword": "contenta",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contentas": [
    {
      "id": 35547,
      "keyword": "contenta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28647,
      "keyword": "contenta",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3245,
      "keyword": "contenta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9907,
      "keyword": "contenta",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llorar": [
    {
      "id": 7147,
      "keyword": "llorar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3239,
      "keyword": "llorar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28645,
      "keyword": "llorar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32298,
      "keyword": "llorar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiadora": [
    {
      "id": 3238,
      "keyword": "limpiadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiadoras": [
    {
      "id": 3238,
      "keyword": "limpiadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maestranza": [
    {
      "id": 34411,
      "keyword": "maestranza",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3238,
      "keyword": "maestranza",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15744,
      "keyword": "maestranza",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maestranzas": [
    {
      "id": 34411,
      "keyword": "maestranza",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3238,
      "keyword": "maestranza",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15744,
      "keyword": "maestranza",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ordenanza": [
    {
      "id": 37423,
      "keyword": "ordenanza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34411,
      "keyword": "ordenanza",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32957,
      "keyword": "ordenanza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32956,
      "keyword": "ordenanza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3238,
      "keyword": "ordenanza",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15744,
      "keyword": "ordenanza",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ordenanzas": [
    {
      "id": 37423,
      "keyword": "ordenanza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34411,
      "keyword": "ordenanza",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32957,
      "keyword": "ordenanza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32956,
      "keyword": "ordenanza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3238,
      "keyword": "ordenanza",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15744,
      "keyword": "ordenanza",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "albóndigas": [
    {
      "id": 3249,
      "keyword": "albóndigas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8335,
      "keyword": "albóndiga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alegre": [
    {
      "id": 35533,
      "keyword": "alegre",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3250,
      "keyword": "alegre",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10192,
      "keyword": "alegre",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31849,
      "keyword": "alegre",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alegres": [
    {
      "id": 35533,
      "keyword": "alegre",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3250,
      "keyword": "alegre",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10192,
      "keyword": "alegre",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31849,
      "keyword": "alegre",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aro": [
    {
      "id": 3253,
      "keyword": "aro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "gymnastics",
        "rhythmic gymnastics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arrugar": [
    {
      "id": 32763,
      "keyword": "arrugar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3254,
      "keyword": "arrugar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pingüino": [
    {
      "id": 3243,
      "keyword": "pingüino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pingüinos": [
    {
      "id": 3243,
      "keyword": "pingüino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pingüina": [
    {
      "id": 3243,
      "keyword": "pingüina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pingüinas": [
    {
      "id": 3243,
      "keyword": "pingüina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerradura": [
    {
      "id": 3261,
      "keyword": "cerradura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerraduras": [
    {
      "id": 3261,
      "keyword": "cerradura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bol": [
    {
      "id": 3257,
      "keyword": "bol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boles": [
    {
      "id": 3257,
      "keyword": "bol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bandurria": [
    {
      "id": 3256,
      "keyword": "bandurria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument",
        "event",
        "popular event",
        "fiestas del pilar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bandurrias": [
    {
      "id": 3256,
      "keyword": "bandurria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument",
        "event",
        "popular event",
        "fiestas del pilar"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caminar": [
    {
      "id": 6044,
      "keyword": "caminar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "basic needs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3251,
      "keyword": "caminar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31917,
      "keyword": "caminar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32214,
      "keyword": "caminar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32908,
      "keyword": "caminar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "andar": [
    {
      "id": 6044,
      "keyword": "andar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "basic needs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37685,
      "keyword": "andar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37964,
      "keyword": "andar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16461,
      "keyword": "andar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3251,
      "keyword": "andar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21357,
      "keyword": "andar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31917,
      "keyword": "andar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32214,
      "keyword": "andar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32908,
      "keyword": "andar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canasta": [
    {
      "id": 3260,
      "keyword": "canasta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5940,
      "keyword": "canasta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canastas": [
    {
      "id": 3260,
      "keyword": "canasta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "basketball"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5940,
      "keyword": "canasta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "basketball"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ciervo": [
    {
      "id": 3263,
      "keyword": "ciervo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciervos": [
    {
      "id": 3263,
      "keyword": "ciervo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "crótalos": [
    {
      "id": 3266,
      "keyword": "crótalos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8345,
      "keyword": "crótalo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comba": [
    {
      "id": 3265,
      "keyword": "comba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3427,
      "keyword": "comba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "combas": [
    {
      "id": 3265,
      "keyword": "comba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3427,
      "keyword": "comba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "churros": [
    {
      "id": 3262,
      "keyword": "churros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5960,
      "keyword": "churro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8455,
      "keyword": "churro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15724,
      "keyword": "churro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cabina de teléfono": [
    {
      "id": 3258,
      "keyword": "cabina de teléfono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cabinas de teléfono": [
    {
      "id": 3258,
      "keyword": "cabina de teléfono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caldera de gas": [
    {
      "id": 3259,
      "keyword": "caldera de gas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calderas de gas": [
    {
      "id": 3259,
      "keyword": "caldera de gas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caldera": [
    {
      "id": 3259,
      "keyword": "caldera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calderas": [
    {
      "id": 3259,
      "keyword": "caldera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "exprimidor": [
    {
      "id": 3270,
      "keyword": "exprimidor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exprimidores": [
    {
      "id": 3270,
      "keyword": "exprimidor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cojín": [
    {
      "id": 3264,
      "keyword": "cojín",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cojines": [
    {
      "id": 3264,
      "keyword": "cojín",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almohadón": [
    {
      "id": 3264,
      "keyword": "almohadón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almohadones": [
    {
      "id": 3264,
      "keyword": "almohadón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nevera": [
    {
      "id": 3272,
      "keyword": "nevera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4876,
      "keyword": "nevera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "neveras": [
    {
      "id": 3272,
      "keyword": "nevera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4876,
      "keyword": "nevera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frigorifico": [
    {
      "id": 3272,
      "keyword": "frigorifico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4876,
      "keyword": "frigorifico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frigorificos": [
    {
      "id": 3272,
      "keyword": "frigorifico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4876,
      "keyword": "frigorifico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "furgoneta": [
    {
      "id": 21878,
      "keyword": "furgoneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "transport services",
        "core vocabulary",
        "trade"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 21878,
      "keyword": "furgoneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "transport services",
        "core vocabulary",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35600,
      "keyword": "furgoneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 35600,
      "keyword": "furgoneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3275,
      "keyword": "furgoneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35598,
      "keyword": "furgoneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "furgonetas": [
    {
      "id": 21878,
      "keyword": "furgoneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "transport services",
        "core vocabulary",
        "trade"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 21878,
      "keyword": "furgoneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "transport services",
        "core vocabulary",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35600,
      "keyword": "furgoneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 35600,
      "keyword": "furgoneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3275,
      "keyword": "furgoneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35598,
      "keyword": "furgoneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fuente": [
    {
      "id": 3273,
      "keyword": "fuente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37015,
      "keyword": "fuente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3274,
      "keyword": "fuente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26678,
      "keyword": "fuente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37065,
      "keyword": "fuente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "utensil",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fuentes": [
    {
      "id": 3273,
      "keyword": "fuente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37015,
      "keyword": "fuente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3274,
      "keyword": "fuente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26678,
      "keyword": "fuente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37065,
      "keyword": "fuente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "utensil",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fuente ornamental": [
    {
      "id": 3274,
      "keyword": "fuente ornamental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fuentes ornamentales": [
    {
      "id": 3274,
      "keyword": "fuente ornamental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jarrón de flores": [
    {
      "id": 3271,
      "keyword": "jarrón de flores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jarrones de flores": [
    {
      "id": 3271,
      "keyword": "jarrón de flores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "florero": [
    {
      "id": 3271,
      "keyword": "florero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "floreros": [
    {
      "id": 3271,
      "keyword": "florero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gambas": [
    {
      "id": 3276,
      "keyword": "gambas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8350,
      "keyword": "gamba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9050,
      "keyword": "gambas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "seafood"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "elevadora": [
    {
      "id": 3268,
      "keyword": "elevadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "elevadoras": [
    {
      "id": 3268,
      "keyword": "elevadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lancha": [
    {
      "id": 3277,
      "keyword": "lancha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lanchas": [
    {
      "id": 3277,
      "keyword": "lancha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "marco": [
    {
      "id": 36934,
      "keyword": "marco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3281,
      "keyword": "marco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marcos": [
    {
      "id": 36934,
      "keyword": "marco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "visual art"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3281,
      "keyword": "marco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "marco con foto": [
    {
      "id": 3281,
      "keyword": "marco con foto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marcos con foto": [
    {
      "id": 3281,
      "keyword": "marco con foto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "títere": [
    {
      "id": 26897,
      "keyword": "títere",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 26897,
      "keyword": "títere",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3282,
      "keyword": "títere",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "títeres": [
    {
      "id": 26897,
      "keyword": "títere",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 26897,
      "keyword": "títere",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3282,
      "keyword": "títere",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "marioneta": [
    {
      "id": 26897,
      "keyword": "marioneta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 26897,
      "keyword": "marioneta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3282,
      "keyword": "marioneta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marionetas": [
    {
      "id": 26897,
      "keyword": "marioneta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 26897,
      "keyword": "marioneta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3282,
      "keyword": "marioneta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espaldera": [
    {
      "id": 3269,
      "keyword": "espaldera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espalderas": [
    {
      "id": 3269,
      "keyword": "espaldera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "longaniza": [
    {
      "id": 3280,
      "keyword": "longaniza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "longanizas": [
    {
      "id": 3280,
      "keyword": "longaniza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "petanca": [
    {
      "id": 3287,
      "keyword": "petanca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3287,
      "keyword": "petanca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17257,
      "keyword": "petanca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35385,
      "keyword": "petanca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38549,
      "keyword": "petanca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "petancas": [
    {
      "id": 3287,
      "keyword": "petanca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 3287,
      "keyword": "petanca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 17257,
      "keyword": "petanca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35385,
      "keyword": "petanca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolas": [
    {
      "id": 3287,
      "keyword": "bolas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3287,
      "keyword": "bolas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leotardo": [
    {
      "id": 3278,
      "keyword": "leotardo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leotardos": [
    {
      "id": 3278,
      "keyword": "leotardo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3278,
      "keyword": "leotardos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salchichón": [
    {
      "id": 3290,
      "keyword": "salchichón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salchichones": [
    {
      "id": 3290,
      "keyword": "salchichón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rasera": [
    {
      "id": 3289,
      "keyword": "rasera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "raseras": [
    {
      "id": 3289,
      "keyword": "rasera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taburete": [
    {
      "id": 3291,
      "keyword": "taburete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taburetes": [
    {
      "id": 3291,
      "keyword": "taburete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "modelar": [
    {
      "id": 3283,
      "keyword": "modelar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "craftsmanship",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toallero": [
    {
      "id": 3292,
      "keyword": "toallero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36603,
      "keyword": "toallero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toalleros": [
    {
      "id": 3292,
      "keyword": "toallero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36603,
      "keyword": "toallero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "morcilla": [
    {
      "id": 3284,
      "keyword": "morcilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "morcillas": [
    {
      "id": 3284,
      "keyword": "morcilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "americana": [
    {
      "id": 3296,
      "keyword": "americana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "americanas": [
    {
      "id": 3296,
      "keyword": "americana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saco": [
    {
      "id": 6210,
      "keyword": "saco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3296,
      "keyword": "saco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacos": [
    {
      "id": 6210,
      "keyword": "saco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3296,
      "keyword": "saco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "radiador": [
    {
      "id": 3288,
      "keyword": "radiador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "radiadores": [
    {
      "id": 3288,
      "keyword": "radiador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paragüero": [
    {
      "id": 3285,
      "keyword": "paragüero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paragüeros": [
    {
      "id": 3285,
      "keyword": "paragüero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "empanadillas": [
    {
      "id": 3300,
      "keyword": "empanadillas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8310,
      "keyword": "empanadilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesilla": [
    {
      "id": 3295,
      "keyword": "mesilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesillas": [
    {
      "id": 3295,
      "keyword": "mesilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dedal": [
    {
      "id": 3303,
      "keyword": "dedal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dedales": [
    {
      "id": 3303,
      "keyword": "dedal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "descansar": [
    {
      "id": 16643,
      "keyword": "descansar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 16643,
      "keyword": "descansar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3299,
      "keyword": "descansar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28649,
      "keyword": "descansar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31937,
      "keyword": "descansar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reposar": [
    {
      "id": 16643,
      "keyword": "reposar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 16643,
      "keyword": "reposar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3299,
      "keyword": "reposar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28649,
      "keyword": "reposar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31937,
      "keyword": "reposar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escarabajo": [
    {
      "id": 3301,
      "keyword": "escarabajo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escarabajos": [
    {
      "id": 3301,
      "keyword": "escarabajo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tocar": [
    {
      "id": 3293,
      "keyword": "tocar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34098,
      "keyword": "tocar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palpar": [
    {
      "id": 3293,
      "keyword": "palpar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "curar": [
    {
      "id": 3302,
      "keyword": "curar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sanar": [
    {
      "id": 3302,
      "keyword": "sanar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dedo": [
    {
      "id": 3298,
      "keyword": "dedo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3298,
      "keyword": "dedo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dedos": [
    {
      "id": 3298,
      "keyword": "dedo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 3298,
      "keyword": "dedo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9826,
      "keyword": "dedos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26035,
      "keyword": "dedos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diadema": [
    {
      "id": 3304,
      "keyword": "diadema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diademas": [
    {
      "id": 3304,
      "keyword": "diadema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enferma": [
    {
      "id": 7040,
      "keyword": "enferma",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "disease",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38481,
      "keyword": "enferma",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39142,
      "keyword": "enferma",
      "keywords": 4,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3308,
      "keyword": "enferma",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28741,
      "keyword": "enferma",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfermas": [
    {
      "id": 7040,
      "keyword": "enferma",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "disease",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38481,
      "keyword": "enferma",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39142,
      "keyword": "enferma",
      "keywords": 4,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3308,
      "keyword": "enferma",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28741,
      "keyword": "enferma",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "judías": [
    {
      "id": 3294,
      "keyword": "judías",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38595,
      "keyword": "judías",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8337,
      "keyword": "judía",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alubias": [
    {
      "id": 3294,
      "keyword": "alubias",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8337,
      "keyword": "alubia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estrella de mar": [
    {
      "id": 3310,
      "keyword": "estrella de mar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "echinoderm",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estrellas de mar": [
    {
      "id": 3310,
      "keyword": "estrella de mar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "echinoderm",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estómago": [
    {
      "id": 3309,
      "keyword": "estómago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estómagos": [
    {
      "id": 3309,
      "keyword": "estómago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "extintor": [
    {
      "id": 3311,
      "keyword": "extintor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "extintores": [
    {
      "id": 3311,
      "keyword": "extintor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "farmacia": [
    {
      "id": 6497,
      "keyword": "farmacia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "health",
        "medicine",
        "medicament",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37368,
      "keyword": "farmacia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "health",
        "medicine",
        "medicament",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36836,
      "keyword": "farmacia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "health",
        "medicine",
        "medicament",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36837,
      "keyword": "farmacia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "health",
        "medicine",
        "medicament",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38352,
      "keyword": "farmacia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "medicament",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3313,
      "keyword": "farmacia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36835,
      "keyword": "farmacia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36838,
      "keyword": "farmacia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "farmacias": [
    {
      "id": 6497,
      "keyword": "farmacia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "health",
        "medicine",
        "medicament",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37368,
      "keyword": "farmacia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "health",
        "medicine",
        "medicament",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36836,
      "keyword": "farmacia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "health",
        "medicine",
        "medicament",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36837,
      "keyword": "farmacia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "health",
        "medicine",
        "medicament",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38352,
      "keyword": "farmacia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "medicament",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3313,
      "keyword": "farmacia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36835,
      "keyword": "farmacia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36838,
      "keyword": "farmacia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "flamenco": [
    {
      "id": 3316,
      "keyword": "flamenco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24049,
      "keyword": "flamenco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "regional dance",
        "show",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flamencos": [
    {
      "id": 3316,
      "keyword": "flamenco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24049,
      "keyword": "flamenco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "regional dance",
        "show",
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "florista": [
    {
      "id": 6503,
      "keyword": "florista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "plant",
        "flower",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3318,
      "keyword": "florista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "gardening",
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11265,
      "keyword": "florista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "plant",
        "flower",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "floristas": [
    {
      "id": 6503,
      "keyword": "florista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "plant",
        "flower",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3318,
      "keyword": "florista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "gardening",
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11265,
      "keyword": "florista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "plant",
        "flower",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esparadrapo": [
    {
      "id": 3306,
      "keyword": "esparadrapo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esparadrapos": [
    {
      "id": 3306,
      "keyword": "esparadrapo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esposas": [
    {
      "id": 3307,
      "keyword": "esposas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8110,
      "keyword": "esposa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11552,
      "keyword": "esposa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fontanería": [
    {
      "id": 6505,
      "keyword": "fontanería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "construction",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3320,
      "keyword": "fontanería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16723,
      "keyword": "fontanería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "secondary sector",
        "construction",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fontanerías": [
    {
      "id": 3320,
      "keyword": "fontanería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16723,
      "keyword": "fontanería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "secondary sector",
        "construction",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plomería": [
    {
      "id": 6505,
      "keyword": "plomería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "construction",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3320,
      "keyword": "plomería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16723,
      "keyword": "plomería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "secondary sector",
        "construction",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plomerías": [
    {
      "id": 6505,
      "keyword": "plomería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "construction",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3320,
      "keyword": "plomería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16723,
      "keyword": "plomería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "secondary sector",
        "construction",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ferretería": [
    {
      "id": 6500,
      "keyword": "ferretería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tool",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7101,
      "keyword": "ferretería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tool",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3315,
      "keyword": "ferretería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7100,
      "keyword": "ferretería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ferreterías": [
    {
      "id": 6500,
      "keyword": "ferretería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tool",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7101,
      "keyword": "ferretería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tool",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3315,
      "keyword": "ferretería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7100,
      "keyword": "ferretería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "farmacéutica": [
    {
      "id": 38858,
      "keyword": "farmacéutica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine",
        "health",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3312,
      "keyword": "farmacéutica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine",
        "health",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "farmacéuticas": [
    {
      "id": 38858,
      "keyword": "farmacéutica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine",
        "health",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3312,
      "keyword": "farmacéutica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine",
        "health",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fontanero": [
    {
      "id": 6506,
      "keyword": "fontanero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3321,
      "keyword": "fontanero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fontaneros": [
    {
      "id": 6506,
      "keyword": "fontanero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3321,
      "keyword": "fontanero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plomero": [
    {
      "id": 6506,
      "keyword": "plomero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3321,
      "keyword": "plomero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plomeros": [
    {
      "id": 6506,
      "keyword": "plomero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3321,
      "keyword": "plomero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plomera": [
    {
      "id": 6506,
      "keyword": "plomera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11266,
      "keyword": "plomera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3321,
      "keyword": "plomera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plomeras": [
    {
      "id": 6506,
      "keyword": "plomera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11266,
      "keyword": "plomera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3321,
      "keyword": "plomera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frasco": [
    {
      "id": 3322,
      "keyword": "frasco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frascos": [
    {
      "id": 3322,
      "keyword": "frasco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bote": [
    {
      "id": 39114,
      "keyword": "bote",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "container"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3322,
      "keyword": "bote",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botes": [
    {
      "id": 39114,
      "keyword": "bote",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "container"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3322,
      "keyword": "bote",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "flan": [
    {
      "id": 25111,
      "keyword": "flan",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3317,
      "keyword": "flan",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flanes": [
    {
      "id": 25111,
      "keyword": "flan",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3317,
      "keyword": "flan",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "floristería": [
    {
      "id": 6504,
      "keyword": "floristería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "plant",
        "flower",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3319,
      "keyword": "floristería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "floristerías": [
    {
      "id": 6504,
      "keyword": "floristería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "plant",
        "flower",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3319,
      "keyword": "floristería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fregar": [
    {
      "id": 6507,
      "keyword": "fregar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3323,
      "keyword": "fregar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8617,
      "keyword": "fregar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29744,
      "keyword": "fregar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30967,
      "keyword": "fregar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "crockery",
        "home",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fregona": [
    {
      "id": 3324,
      "keyword": "fregona",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fregonas": [
    {
      "id": 3324,
      "keyword": "fregona",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lampazo": [
    {
      "id": 3324,
      "keyword": "lampazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3324,
      "keyword": "lampazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frutería": [
    {
      "id": 6508,
      "keyword": "frutería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35657,
      "keyword": "frutería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3327,
      "keyword": "frutería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fruterías": [
    {
      "id": 6508,
      "keyword": "frutería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35657,
      "keyword": "frutería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3327,
      "keyword": "frutería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frutera": [
    {
      "id": 3328,
      "keyword": "frutera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fruteras": [
    {
      "id": 3328,
      "keyword": "frutera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frente": [
    {
      "id": 3326,
      "keyword": "frente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frentes": [
    {
      "id": 3326,
      "keyword": "frente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "garganta": [
    {
      "id": 3332,
      "keyword": "garganta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gargantas": [
    {
      "id": 3332,
      "keyword": "garganta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gafas": [
    {
      "id": 3329,
      "keyword": "gafas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3329,
      "keyword": "gafas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lentes": [
    {
      "id": 3329,
      "keyword": "lentes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3329,
      "keyword": "lentes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anteojos": [
    {
      "id": 3329,
      "keyword": "anteojos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3329,
      "keyword": "anteojos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gel": [
    {
      "id": 3335,
      "keyword": "gel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "geles": [
    {
      "id": 3335,
      "keyword": "gel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "granja": [
    {
      "id": 32482,
      "keyword": "granja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing",
        "work",
        "primary sector",
        "cattle farming",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3337,
      "keyword": "granja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing",
        "work",
        "primary sector",
        "cattle farming",
        "geography",
        "physical geography",
        "natural habitat",
        "place",
        "rural area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "granjas": [
    {
      "id": 32482,
      "keyword": "granja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing",
        "work",
        "primary sector",
        "cattle farming",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3337,
      "keyword": "granja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing",
        "work",
        "primary sector",
        "cattle farming",
        "geography",
        "physical geography",
        "natural habitat",
        "place",
        "rural area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "golondrina": [
    {
      "id": 3336,
      "keyword": "golondrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28913,
      "keyword": "golondrina",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "golondrinas": [
    {
      "id": 3336,
      "keyword": "golondrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28913,
      "keyword": "golondrina",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "granjero": [
    {
      "id": 6515,
      "keyword": "granjero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3338,
      "keyword": "granjero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "granjeros": [
    {
      "id": 6515,
      "keyword": "granjero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3338,
      "keyword": "granjero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gafas de sol": [
    {
      "id": 3330,
      "keyword": "gafas de sol",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lentes de sol": [
    {
      "id": 3330,
      "keyword": "lentes de sol",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anteojos de sol": [
    {
      "id": 3330,
      "keyword": "anteojos de sol",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gaviota": [
    {
      "id": 3334,
      "keyword": "gaviota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gaviotas": [
    {
      "id": 3334,
      "keyword": "gaviota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "galleta de chocolate": [
    {
      "id": 3331,
      "keyword": "galleta de chocolate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "galletas de chocolate": [
    {
      "id": 3331,
      "keyword": "galleta de chocolate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38502,
      "keyword": "galletas de chocolate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6525,
      "keyword": "galletas de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "freír un huevo": [
    {
      "id": 3325,
      "keyword": "freír un huevo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gusano": [
    {
      "id": 28485,
      "keyword": "gusano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "annelid",
        "omnivorous",
        "oviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3344,
      "keyword": "gusano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "annelid",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16727,
      "keyword": "gusano",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "terrestrial animal",
        "oviparous",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gusanos": [
    {
      "id": 28485,
      "keyword": "gusano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "annelid",
        "omnivorous",
        "oviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3344,
      "keyword": "gusano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "annelid",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16727,
      "keyword": "gusano",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "terrestrial animal",
        "oviparous",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grúa": [
    {
      "id": 3341,
      "keyword": "grúa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21545,
      "keyword": "grúa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25590,
      "keyword": "grúa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grúas": [
    {
      "id": 3341,
      "keyword": "grúa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21545,
      "keyword": "grúa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25590,
      "keyword": "grúa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vigilante de seguridad": [
    {
      "id": 38262,
      "keyword": "vigilante de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38263,
      "keyword": "vigilante de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3343,
      "keyword": "vigilante de seguridad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11278,
      "keyword": "vigilante de seguridad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36478,
      "keyword": "vigilante de seguridad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36479,
      "keyword": "vigilante de seguridad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vigilantes de seguridad": [
    {
      "id": 38262,
      "keyword": "vigilante de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38263,
      "keyword": "vigilante de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3343,
      "keyword": "vigilante de seguridad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11278,
      "keyword": "vigilante de seguridad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36478,
      "keyword": "vigilante de seguridad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36479,
      "keyword": "vigilante de seguridad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guarda jurado": [
    {
      "id": 3343,
      "keyword": "guarda jurado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11278,
      "keyword": "guarda jurado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36478,
      "keyword": "guarda jurado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36479,
      "keyword": "guarda jurado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guardas jurados": [
    {
      "id": 3343,
      "keyword": "guarda jurado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11278,
      "keyword": "guarda jurado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36478,
      "keyword": "guarda jurado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36479,
      "keyword": "guarda jurado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vigilante": [
    {
      "id": 38262,
      "keyword": "vigilante",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38263,
      "keyword": "vigilante",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3343,
      "keyword": "vigilante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11278,
      "keyword": "vigilante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36478,
      "keyword": "vigilante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36479,
      "keyword": "vigilante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vigilantes": [
    {
      "id": 38262,
      "keyword": "vigilante",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38263,
      "keyword": "vigilante",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3343,
      "keyword": "vigilante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11278,
      "keyword": "vigilante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36478,
      "keyword": "vigilante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36479,
      "keyword": "vigilante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hámster": [
    {
      "id": 3346,
      "keyword": "hámster",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hámsters": [
    {
      "id": 3346,
      "keyword": "hámster",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  " cobaya": [
    {
      "id": 3346,
      "keyword": " cobaya",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  " cobayas": [
    {
      "id": 3346,
      "keyword": " cobaya",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "monomando": [
    {
      "id": 3339,
      "keyword": "monomando",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monomandos": [
    {
      "id": 3339,
      "keyword": "monomando",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guardia civil": [
    {
      "id": 3342,
      "keyword": "guardia civil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11279,
      "keyword": "guardia civil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38386,
      "keyword": "guardia civil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38387,
      "keyword": "guardia civil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guardias civiles": [
    {
      "id": 3342,
      "keyword": "guardia civil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11279,
      "keyword": "guardia civil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38386,
      "keyword": "guardia civil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38387,
      "keyword": "guardia civil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "polo": [
    {
      "id": 3348,
      "keyword": "polo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "summer"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24308,
      "keyword": "polo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "polos": [
    {
      "id": 3348,
      "keyword": "polo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "summer"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24308,
      "keyword": "polo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lima de uñas": [
    {
      "id": 3349,
      "keyword": "lima de uñas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limas de uñas": [
    {
      "id": 3349,
      "keyword": "lima de uñas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lima": [
    {
      "id": 5501,
      "keyword": "lima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15453,
      "keyword": "lima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3349,
      "keyword": "lima",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limas": [
    {
      "id": 5501,
      "keyword": "lima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15453,
      "keyword": "lima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3349,
      "keyword": "lima",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "limpiacristales": [
    {
      "id": 3350,
      "keyword": "limpiacristales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiar": [
    {
      "id": 16803,
      "keyword": "limpiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3351,
      "keyword": "limpiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "object",
        "cleaning product",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17269,
      "keyword": "limpiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bastoncillos": [
    {
      "id": 3356,
      "keyword": "bastoncillos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8294,
      "keyword": "bastoncillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33116,
      "keyword": "bastoncillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "azul": [
    {
      "id": 4869,
      "keyword": "azul",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3355,
      "keyword": "azul",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "azules": [
    {
      "id": 4869,
      "keyword": "azul",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3355,
      "keyword": "azul",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "heladería": [
    {
      "id": 6520,
      "keyword": "heladería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3347,
      "keyword": "heladería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "heladerías": [
    {
      "id": 6520,
      "keyword": "heladería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3347,
      "keyword": "heladería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "panadera": [
    {
      "id": 3359,
      "keyword": "panadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11323,
      "keyword": "panadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panaderas": [
    {
      "id": 3359,
      "keyword": "panadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11323,
      "keyword": "panadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agujas de lana": [
    {
      "id": 3353,
      "keyword": "agujas de lana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "óptica": [
    {
      "id": 6575,
      "keyword": "óptica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "accessories",
        "communication",
        "signaling system",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3357,
      "keyword": "óptica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15489,
      "keyword": "óptica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ópticas": [
    {
      "id": 6575,
      "keyword": "óptica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "accessories",
        "communication",
        "signaling system",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3357,
      "keyword": "óptica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15489,
      "keyword": "óptica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pene": [
    {
      "id": 26306,
      "keyword": "pene",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system",
        "excretory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3362,
      "keyword": "pene",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system",
        "excretory system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37165,
      "keyword": "pene",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system",
        "excretory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "penes": [
    {
      "id": 26306,
      "keyword": "pene",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system",
        "excretory system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3362,
      "keyword": "pene",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system",
        "excretory system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37165,
      "keyword": "pene",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system",
        "excretory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perfumería": [
    {
      "id": 6589,
      "keyword": "perfumería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35701,
      "keyword": "perfumería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3363,
      "keyword": "perfumería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perfumerías": [
    {
      "id": 6589,
      "keyword": "perfumería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35701,
      "keyword": "perfumería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3363,
      "keyword": "perfumería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pastelería": [
    {
      "id": 6583,
      "keyword": "pastelería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3361,
      "keyword": "pastelería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pastelerías": [
    {
      "id": 6583,
      "keyword": "pastelería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3361,
      "keyword": "pastelería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pescadería": [
    {
      "id": 6590,
      "keyword": "pescadería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35699,
      "keyword": "pescadería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3364,
      "keyword": "pescadería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pescaderías": [
    {
      "id": 6590,
      "keyword": "pescadería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35699,
      "keyword": "pescadería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3364,
      "keyword": "pescadería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pescadera": [
    {
      "id": 3365,
      "keyword": "pescadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pescaderas": [
    {
      "id": 3365,
      "keyword": "pescadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pescador": [
    {
      "id": 3367,
      "keyword": "pescador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4718,
      "keyword": "pescador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3366,
      "keyword": "pescador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pescadores": [
    {
      "id": 3367,
      "keyword": "pescador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3366,
      "keyword": "pescador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "marinero": [
    {
      "id": 3366,
      "keyword": "marinero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5507,
      "keyword": "marinero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marineros": [
    {
      "id": 3366,
      "keyword": "marinero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5507,
      "keyword": "marinero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "panadero": [
    {
      "id": 6577,
      "keyword": "panadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3358,
      "keyword": "panadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11324,
      "keyword": "panadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panaderos": [
    {
      "id": 6577,
      "keyword": "panadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3358,
      "keyword": "panadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11324,
      "keyword": "panadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gris": [
    {
      "id": 3340,
      "keyword": "gris",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grises": [
    {
      "id": 3340,
      "keyword": "gris",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "picar": [
    {
      "id": 6593,
      "keyword": "picar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3369,
      "keyword": "picar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8665,
      "keyword": "picar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "animal physiology",
        "invertebrate",
        "arthropod",
        "insect",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34553,
      "keyword": "picar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4949,
      "keyword": "picar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11356,
      "keyword": "picar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pipas": [
    {
      "id": 3371,
      "keyword": "pipas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4722,
      "keyword": "pipa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8321,
      "keyword": "pipa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pistachos": [
    {
      "id": 3372,
      "keyword": "pistachos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8322,
      "keyword": "pistacho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "placa vitrocerámica": [
    {
      "id": 3373,
      "keyword": "placa vitrocerámica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "placas vitrocerámicas": [
    {
      "id": 3373,
      "keyword": "placa vitrocerámica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vitrocerámica": [
    {
      "id": 3373,
      "keyword": "vitrocerámica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vitrocerámicas": [
    {
      "id": 3373,
      "keyword": "vitrocerámica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pollería": [
    {
      "id": 6597,
      "keyword": "pollería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3374,
      "keyword": "pollería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pollerías": [
    {
      "id": 6597,
      "keyword": "pollería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3374,
      "keyword": "pollería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pollero": [
    {
      "id": 6598,
      "keyword": "pollero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3375,
      "keyword": "pollero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "polleros": [
    {
      "id": 6598,
      "keyword": "pollero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3375,
      "keyword": "pollero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pez martillo": [
    {
      "id": 3368,
      "keyword": "pez martillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peces martillo": [
    {
      "id": 3368,
      "keyword": "pez martillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "piloto": [
    {
      "id": 3370,
      "keyword": "piloto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 19552,
      "keyword": "piloto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pilotos": [
    {
      "id": 3370,
      "keyword": "piloto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 19552,
      "keyword": "piloto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pomada": [
    {
      "id": 32204,
      "keyword": "pomada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3376,
      "keyword": "pomada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pomadas": [
    {
      "id": 32204,
      "keyword": "pomada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3376,
      "keyword": "pomada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament",
        "treatment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "crema": [
    {
      "id": 32204,
      "keyword": "crema",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35637,
      "keyword": "crema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3376,
      "keyword": "crema",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4873,
      "keyword": "crema",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21568,
      "keyword": "crema",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cremas": [
    {
      "id": 32204,
      "keyword": "crema",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35637,
      "keyword": "crema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3376,
      "keyword": "crema",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament",
        "treatment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4873,
      "keyword": "crema",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21568,
      "keyword": "crema",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pulpo": [
    {
      "id": 3379,
      "keyword": "pulpo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26350,
      "keyword": "pulpo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulpos": [
    {
      "id": 3379,
      "keyword": "pulpo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26350,
      "keyword": "pulpo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "puerro": [
    {
      "id": 3378,
      "keyword": "puerro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puerros": [
    {
      "id": 3378,
      "keyword": "puerro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34059,
      "keyword": "puerros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quiosquero": [
    {
      "id": 6601,
      "keyword": "quiosquero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "publication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3381,
      "keyword": "quiosquero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "publication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quiosqueros": [
    {
      "id": 6601,
      "keyword": "quiosquero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "publication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3381,
      "keyword": "quiosquero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "publication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "kioskero": [
    {
      "id": 6601,
      "keyword": "kioskero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "publication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3381,
      "keyword": "kioskero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "publication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kioskeros": [
    {
      "id": 6601,
      "keyword": "kioskero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "publication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3381,
      "keyword": "kioskero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "publication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quesitos": [
    {
      "id": 3380,
      "keyword": "quesitos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8366,
      "keyword": "quesito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "animal-based food",
        "dairy product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rincón": [
    {
      "id": 3382,
      "keyword": "rincón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rincones": [
    {
      "id": 32176,
      "keyword": "rincones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32178,
      "keyword": "rincones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3382,
      "keyword": "rincón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sándwich": [
    {
      "id": 3383,
      "keyword": "sándwich",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38504,
      "keyword": "sándwich",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "sándwiches": [
    {
      "id": 3383,
      "keyword": "sándwich",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38504,
      "keyword": "sándwich",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "psicólogo": [
    {
      "id": 38924,
      "keyword": "psicólogo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32976,
      "keyword": "psicólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3377,
      "keyword": "psicólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "psicólogos": [
    {
      "id": 38924,
      "keyword": "psicólogo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32976,
      "keyword": "psicólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3377,
      "keyword": "psicólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sicólogo": [
    {
      "id": 38924,
      "keyword": "sicólogo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3377,
      "keyword": "sicólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sicólogos": [
    {
      "id": 38924,
      "keyword": "sicólogo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3377,
      "keyword": "sicólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pasador": [
    {
      "id": 3360,
      "keyword": "pasador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasadores": [
    {
      "id": 3360,
      "keyword": "pasador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "supermercado": [
    {
      "id": 6618,
      "keyword": "supermercado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3389,
      "keyword": "supermercado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "supermercados": [
    {
      "id": 6618,
      "keyword": "supermercado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3389,
      "keyword": "supermercado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "súper": [
    {
      "id": 6618,
      "keyword": "súper",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3389,
      "keyword": "súper",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sombra de ojos": [
    {
      "id": 3388,
      "keyword": "sombra de ojos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sombras de ojos": [
    {
      "id": 3388,
      "keyword": "sombra de ojos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taco": [
    {
      "id": 3390,
      "keyword": "taco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22013,
      "keyword": "taco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tacos": [
    {
      "id": 3390,
      "keyword": "taco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22013,
      "keyword": "taco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taladrar": [
    {
      "id": 3391,
      "keyword": "taladrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "construction",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taladro": [
    {
      "id": 3392,
      "keyword": "taladro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taladros": [
    {
      "id": 3392,
      "keyword": "taladro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "talón": [
    {
      "id": 3399,
      "keyword": "talón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talones": [
    {
      "id": 3399,
      "keyword": "talón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sapo": [
    {
      "id": 3384,
      "keyword": "sapo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "amphibian",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sapos": [
    {
      "id": 3384,
      "keyword": "sapo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "amphibian",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "selva": [
    {
      "id": 3385,
      "keyword": "selva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "natural habitat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "selvas": [
    {
      "id": 3385,
      "keyword": "selva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "natural habitat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tela": [
    {
      "id": 3402,
      "keyword": "tela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "telas": [
    {
      "id": 3402,
      "keyword": "tela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tirita": [
    {
      "id": 3404,
      "keyword": "tirita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8331,
      "keyword": "tirita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiritas": [
    {
      "id": 3404,
      "keyword": "tirita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8331,
      "keyword": "tirita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "curita": [
    {
      "id": 3404,
      "keyword": "curita",
      "keywords": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8331,
      "keyword": "curita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "curitas": [
    {
      "id": 3404,
      "keyword": "curita",
      "keywords": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8331,
      "keyword": "curita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tebeo": [
    {
      "id": 3401,
      "keyword": "tebeo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "publication",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tebeos": [
    {
      "id": 3401,
      "keyword": "tebeo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "publication",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cómic": [
    {
      "id": 3401,
      "keyword": "cómic",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "publication",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cómics": [
    {
      "id": 3401,
      "keyword": "cómic",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "publication",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tobillo": [
    {
      "id": 3405,
      "keyword": "tobillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "joint system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tobillos": [
    {
      "id": 3405,
      "keyword": "tobillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "joint system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "toser": [
    {
      "id": 26508,
      "keyword": "toser",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3406,
      "keyword": "toser",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26507,
      "keyword": "toser",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vejiga": [
    {
      "id": 3407,
      "keyword": "vejiga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vejigas": [
    {
      "id": 3407,
      "keyword": "vejiga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tanque": [
    {
      "id": 3400,
      "keyword": "tanque",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16285,
      "keyword": "tanque",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tanques": [
    {
      "id": 3400,
      "keyword": "tanque",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16285,
      "keyword": "tanque",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zapatero": [
    {
      "id": 6634,
      "keyword": "zapatero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3411,
      "keyword": "zapatero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38579,
      "keyword": "zapatero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "craftsmanship",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zapateros": [
    {
      "id": 6634,
      "keyword": "zapatero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3411,
      "keyword": "zapatero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38579,
      "keyword": "zapatero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "craftsmanship",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "velcro": [
    {
      "id": 3408,
      "keyword": "velcro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "velcros": [
    {
      "id": 3408,
      "keyword": "velcro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cámara de vídeo": [
    {
      "id": 25524,
      "keyword": "cámara de vídeo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "communication",
        "mass media",
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3409,
      "keyword": "cámara de vídeo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "communication",
        "mass media",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cámaras de vídeo": [
    {
      "id": 25524,
      "keyword": "cámara de vídeo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "communication",
        "mass media",
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3409,
      "keyword": "cámara de vídeo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "communication",
        "mass media",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "videocámara": [
    {
      "id": 25524,
      "keyword": "videocámara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "communication",
        "mass media",
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3409,
      "keyword": "videocámara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "communication",
        "mass media",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "videocámaras": [
    {
      "id": 25524,
      "keyword": "videocámara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "communication",
        "mass media",
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3409,
      "keyword": "videocámara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "communication",
        "mass media",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tijeras para podar": [
    {
      "id": 3403,
      "keyword": "tijeras para podar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tijera de podar": [
    {
      "id": 3403,
      "keyword": "tijera de podar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tijeras de podar": [
    {
      "id": 3403,
      "keyword": "tijera de podar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ñ": [
    {
      "id": 3412,
      "keyword": "ñ",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5085,
      "keyword": "Ñ",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡": [
    {
      "id": 3414,
      "keyword": "¡",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exclamación": [
    {
      "id": 3414,
      "keyword": "exclamación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3417,
      "keyword": "exclamación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exclamaciones": [
    {
      "id": 3414,
      "keyword": "exclamación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3417,
      "keyword": "exclamación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "admiración": [
    {
      "id": 3414,
      "keyword": "admiración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3417,
      "keyword": "admiración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "admiraciones": [
    {
      "id": 3414,
      "keyword": "admiración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3417,
      "keyword": "admiración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "\\": [
    {
      "id": 3413,
      "keyword": "\\",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "signo de la barra": [
    {
      "id": 3413,
      "keyword": "signo de la barra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paréntesis": [
    {
      "id": 3416,
      "keyword": "paréntesis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3419,
      "keyword": "paréntesis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "(": [
    {
      "id": 3416,
      "keyword": "(",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿": [
    {
      "id": 3415,
      "keyword": "¿",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "interrogación": [
    {
      "id": 3415,
      "keyword": "interrogación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3418,
      "keyword": "interrogación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "interrogaciones": [
    {
      "id": 3415,
      "keyword": "interrogación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3418,
      "keyword": "interrogación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vagina": [
    {
      "id": 3410,
      "keyword": "vagina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3410,
      "keyword": "vagina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32121,
      "keyword": "vagina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32119,
      "keyword": "vagina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37173,
      "keyword": "vagina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vaginas": [
    {
      "id": 3410,
      "keyword": "vagina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 3410,
      "keyword": "vagina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32121,
      "keyword": "vagina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32119,
      "keyword": "vagina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37173,
      "keyword": "vagina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vulva": [
    {
      "id": 3410,
      "keyword": "vulva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 3410,
      "keyword": "vulva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37173,
      "keyword": "vulva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vulvas": [
    {
      "id": 3410,
      "keyword": "vulva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 3410,
      "keyword": "vulva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37173,
      "keyword": "vulva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  ")": [
    {
      "id": 3419,
      "keyword": ")",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "!": [
    {
      "id": 3417,
      "keyword": "!",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juego de la oca": [
    {
      "id": 3421,
      "keyword": "juego de la Oca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos de la oca": [
    {
      "id": 3421,
      "keyword": "juego de la Oca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "punto y coma": [
    {
      "id": 3422,
      "keyword": "punto y coma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puntos y comas": [
    {
      "id": 3422,
      "keyword": "punto y coma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  ";": [
    {
      "id": 3422,
      "keyword": ";",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "igual": [
    {
      "id": 32392,
      "keyword": "igual",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4667,
      "keyword": "igual",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4667,
      "keyword": "igual",
      "keywords": 6,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3423,
      "keyword": "igual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "=": [
    {
      "id": 3423,
      "keyword": "=",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "/": [
    {
      "id": 3424,
      "keyword": "/",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barra invertida": [
    {
      "id": 3424,
      "keyword": "barra invertida",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barras invertidas": [
    {
      "id": 3424,
      "keyword": "barra invertida",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barra oblicua": [
    {
      "id": 3424,
      "keyword": "barra oblicua",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barras oblicuas": [
    {
      "id": 3424,
      "keyword": "barra oblicua",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "?": [
    {
      "id": 3418,
      "keyword": "?",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dos puntos": [
    {
      "id": 3420,
      "keyword": "dos puntos",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  ":": [
    {
      "id": 3420,
      "keyword": ":",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer caca": [
    {
      "id": 35347,
      "keyword": "hacer caca",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "basic needs",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16709,
      "keyword": "hacer caca",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21919,
      "keyword": "hacer caca",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21921,
      "keyword": "hacer caca",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3428,
      "keyword": "hacer caca",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35348,
      "keyword": "hacer caca",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35349,
      "keyword": "hacer caca",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4880,
      "keyword": "hacer caca",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cagar": [
    {
      "id": 35347,
      "keyword": "cagar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "basic needs",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16709,
      "keyword": "cagar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3428,
      "keyword": "cagar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35348,
      "keyword": "cagar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35349,
      "keyword": "cagar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4880,
      "keyword": "cagar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer pis": [
    {
      "id": 16713,
      "keyword": "hacer pis",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "basic needs",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37457,
      "keyword": "hacer pis",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37686,
      "keyword": "hacer pis",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3429,
      "keyword": "hacer pis",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31927,
      "keyword": "hacer pis",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32264,
      "keyword": "hacer pis",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34141,
      "keyword": "hacer pis",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "animal physiology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36640,
      "keyword": "hacer pis",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37458,
      "keyword": "hacer pis",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37687,
      "keyword": "hacer pis",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4880,
      "keyword": "hacer pis",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orinar": [
    {
      "id": 16713,
      "keyword": "orinar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "basic needs",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37457,
      "keyword": "orinar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37686,
      "keyword": "orinar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3429,
      "keyword": "orinar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31927,
      "keyword": "orinar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32264,
      "keyword": "orinar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34141,
      "keyword": "orinar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "animal physiology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36640,
      "keyword": "orinar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37458,
      "keyword": "orinar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37687,
      "keyword": "orinar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4880,
      "keyword": "orinar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paso de cebra": [
    {
      "id": 7197,
      "keyword": "paso de cebra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3430,
      "keyword": "paso de cebra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasos de cebra": [
    {
      "id": 3430,
      "keyword": "paso de cebra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "senda peatonal": [
    {
      "id": 3430,
      "keyword": "senda peatonal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sendas peatonales": [
    {
      "id": 3430,
      "keyword": "senda peatonal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "portero automático": [
    {
      "id": 3431,
      "keyword": "portero automático",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porteros automáticos": [
    {
      "id": 3431,
      "keyword": "portero automático",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abrazo": [
    {
      "id": 4550,
      "keyword": "abrazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrazos": [
    {
      "id": 4550,
      "keyword": "abrazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "accidente": [
    {
      "id": 4551,
      "keyword": "accidente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "traffic accident",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30965,
      "keyword": "accidente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "traffic accident",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15830,
      "keyword": "accidente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "traffic accident"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15828,
      "keyword": "accidente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "traffic accident"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "accidentes": [
    {
      "id": 4551,
      "keyword": "accidente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "traffic accident",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30965,
      "keyword": "accidente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "traffic accident",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15830,
      "keyword": "accidente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "traffic accident"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15828,
      "keyword": "accidente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "traffic accident"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chocar": [
    {
      "id": 4551,
      "keyword": "chocar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "traffic accident",
        "road safety",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abierta": [
    {
      "id": 36309,
      "keyword": "abierta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "place",
        "building",
        "signaling system",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4549,
      "keyword": "abierta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abiertas": [
    {
      "id": 36309,
      "keyword": "abierta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "place",
        "building",
        "signaling system",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4549,
      "keyword": "abierta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abierto": [
    {
      "id": 36309,
      "keyword": "abierto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "place",
        "building",
        "signaling system",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4549,
      "keyword": "abierto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abiertos": [
    {
      "id": 36309,
      "keyword": "abierto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "place",
        "building",
        "signaling system",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4549,
      "keyword": "abierto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coche de policía": [
    {
      "id": 6983,
      "keyword": "coche de policía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3426,
      "keyword": "coche de policía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coches de policía": [
    {
      "id": 6983,
      "keyword": "coche de policía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 3426,
      "keyword": "coche de policía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hablar": [
    {
      "id": 6517,
      "keyword": "hablar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3345,
      "keyword": "hablar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36544,
      "keyword": "hablar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conversar": [
    {
      "id": 6517,
      "keyword": "conversar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37217,
      "keyword": "conversar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "healthy habit",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3345,
      "keyword": "conversar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36544,
      "keyword": "conversar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "charlar": [
    {
      "id": 6517,
      "keyword": "charlar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3345,
      "keyword": "charlar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36544,
      "keyword": "charlar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dialogar": [
    {
      "id": 6517,
      "keyword": "dialogar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3345,
      "keyword": "dialogar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36544,
      "keyword": "dialogar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comunicar": [
    {
      "id": 38412,
      "keyword": "comunicar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27685,
      "keyword": "comunicar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37415,
      "keyword": "comunicar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37416,
      "keyword": "comunicar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11754,
      "keyword": "comunicar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 3345,
      "keyword": "comunicar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36544,
      "keyword": "comunicar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "actriz": [
    {
      "id": 4555,
      "keyword": "actriz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "scenic art",
        "visual art",
        "theater",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "actrices": [
    {
      "id": 4555,
      "keyword": "actriz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "scenic art",
        "visual art",
        "theater",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enamorados": [
    {
      "id": 30389,
      "keyword": "enamorado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38799,
      "keyword": "enamorados",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4558,
      "keyword": "enamorados",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11521,
      "keyword": "enamorados",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31995,
      "keyword": "enamorado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11529,
      "keyword": "enamorados",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7232,
      "keyword": "enamorado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8995,
      "keyword": "enamorados",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "novios": [
    {
      "id": 38939,
      "keyword": "novio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38940,
      "keyword": "novio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38799,
      "keyword": "novios",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8641,
      "keyword": "novio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4558,
      "keyword": "novios",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10344,
      "keyword": "novios",
      "keywords": 2,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11521,
      "keyword": "novios",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11529,
      "keyword": "novios",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8256,
      "keyword": "novios",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding",
        "religious event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8995,
      "keyword": "novios",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11546,
      "keyword": "novios",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ahorrar": [
    {
      "id": 4556,
      "keyword": "ahorrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ácido": [
    {
      "id": 37833,
      "keyword": "ácido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4552,
      "keyword": "ácido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31754,
      "keyword": "ácido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37757,
      "keyword": "ácido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ácidos": [
    {
      "id": 37833,
      "keyword": "ácido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4552,
      "keyword": "ácido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31754,
      "keyword": "ácido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37757,
      "keyword": "ácido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ácida": [
    {
      "id": 37833,
      "keyword": "ácida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4552,
      "keyword": "ácida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31754,
      "keyword": "ácida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37757,
      "keyword": "ácida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ácidas": [
    {
      "id": 37833,
      "keyword": "ácida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4552,
      "keyword": "ácida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31754,
      "keyword": "ácida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37757,
      "keyword": "ácida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acostar": [
    {
      "id": 6027,
      "keyword": "acostar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4553,
      "keyword": "acostar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37222,
      "keyword": "acostar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apagar la vela": [
    {
      "id": 6047,
      "keyword": "apagar la vela",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "event",
        "social event",
        "birthday",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4562,
      "keyword": "apagar la vela",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39424,
      "keyword": "apagar la vela",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alto": [
    {
      "id": 25782,
      "keyword": "alto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4557,
      "keyword": "alto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "altos": [
    {
      "id": 25782,
      "keyword": "alto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4557,
      "keyword": "alto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mayor": [
    {
      "id": 4658,
      "keyword": "mayor",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "size",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25796,
      "keyword": "mayor",
      "keywords": 2,
      "type": 4,
      "tags": [
        "person",
        "elderly",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16119,
      "keyword": "mayor",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34894,
      "keyword": "mayor",
      "keywords": 3,
      "type": 4,
      "tags": [
        "person",
        "elderly"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4557,
      "keyword": "mayor",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10193,
      "keyword": "mayor",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mayores": [
    {
      "id": 4658,
      "keyword": "mayor",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "size",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25796,
      "keyword": "mayor",
      "keywords": 2,
      "type": 4,
      "tags": [
        "person",
        "elderly",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16119,
      "keyword": "mayor",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34894,
      "keyword": "mayor",
      "keywords": 3,
      "type": 4,
      "tags": [
        "person",
        "elderly"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4557,
      "keyword": "mayor",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10193,
      "keyword": "mayor",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arena": [
    {
      "id": 4565,
      "keyword": "arena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arenas": [
    {
      "id": 4565,
      "keyword": "arena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "actor": [
    {
      "id": 36075,
      "keyword": "actor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "scenic art",
        "visual art",
        "theater",
        "show",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4554,
      "keyword": "actor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "scenic art",
        "visual art",
        "theater",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "actores": [
    {
      "id": 36075,
      "keyword": "actor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "scenic art",
        "visual art",
        "theater",
        "show",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4554,
      "keyword": "actor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "scenic art",
        "visual art",
        "theater",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "áspero": [
    {
      "id": 4568,
      "keyword": "áspero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ásperos": [
    {
      "id": 4568,
      "keyword": "áspero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "áspera": [
    {
      "id": 4568,
      "keyword": "áspera",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ásperas": [
    {
      "id": 4568,
      "keyword": "áspera",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "árbitro": [
    {
      "id": 4564,
      "keyword": "árbitro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport rules",
        "work",
        "professional",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "árbitros": [
    {
      "id": 4564,
      "keyword": "árbitro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport rules",
        "work",
        "professional",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "astronauta": [
    {
      "id": 4569,
      "keyword": "astronauta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "astronautas": [
    {
      "id": 4569,
      "keyword": "astronauta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cosmonauta": [
    {
      "id": 4569,
      "keyword": "cosmonauta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cosmonautas": [
    {
      "id": 4569,
      "keyword": "cosmonauta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ayudar": [
    {
      "id": 32648,
      "keyword": "ayudar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4570,
      "keyword": "ayudar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10141,
      "keyword": "ayudar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37538,
      "keyword": "ayudar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37539,
      "keyword": "ayudar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apoyar": [
    {
      "id": 21375,
      "keyword": "apoyar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39437,
      "keyword": "apoyar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21377,
      "keyword": "apoyar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21373,
      "keyword": "apoyar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39435,
      "keyword": "apoyar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39436,
      "keyword": "apoyar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4570,
      "keyword": "apoyar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cooperar": [
    {
      "id": 4570,
      "keyword": "cooperar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajo": [
    {
      "id": 7047,
      "keyword": "bajo",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25839,
      "keyword": "bajo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27477,
      "keyword": "bajo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4571,
      "keyword": "bajo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36115,
      "keyword": "bajo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajos": [
    {
      "id": 25839,
      "keyword": "bajo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27477,
      "keyword": "bajo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4571,
      "keyword": "bajo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36115,
      "keyword": "bajo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "menor": [
    {
      "id": 4716,
      "keyword": "menor",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "size",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16121,
      "keyword": "menor",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4571,
      "keyword": "menor",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10196,
      "keyword": "menor",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "menores": [
    {
      "id": 4716,
      "keyword": "menor",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "size",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16121,
      "keyword": "menor",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4571,
      "keyword": "menor",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10196,
      "keyword": "menor",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31843,
      "keyword": "menores",
      "keywords": 4,
      "type": 4,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31843,
      "keyword": "menores",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balancín": [
    {
      "id": 36893,
      "keyword": "balancín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4572,
      "keyword": "balancín",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balancines": [
    {
      "id": 36893,
      "keyword": "balancín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4572,
      "keyword": "balancín",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sube y baja": [
    {
      "id": 4572,
      "keyword": "sube y baja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arreglado": [
    {
      "id": 4566,
      "keyword": "arreglado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arreglados": [
    {
      "id": 4566,
      "keyword": "arreglado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arreglada": [
    {
      "id": 4566,
      "keyword": "arreglada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arregladas": [
    {
      "id": 4566,
      "keyword": "arreglada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bar": [
    {
      "id": 32398,
      "keyword": "bar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 32398,
      "keyword": "bar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6931,
      "keyword": "bar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35707,
      "keyword": "bar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4573,
      "keyword": "bar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bares": [
    {
      "id": 32398,
      "keyword": "bar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 32398,
      "keyword": "bar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6931,
      "keyword": "bar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35707,
      "keyword": "bar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4573,
      "keyword": "bar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bebida": [
    {
      "id": 4575,
      "keyword": "bebida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30403,
      "keyword": "bebida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bebidas": [
    {
      "id": 4575,
      "keyword": "bebida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4575,
      "keyword": "bebidas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30403,
      "keyword": "bebida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30403,
      "keyword": "bebidas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "biberón": [
    {
      "id": 4577,
      "keyword": "biberón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "biberones": [
    {
      "id": 4577,
      "keyword": "biberón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mamadera": [
    {
      "id": 4577,
      "keyword": "mamadera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mamaderas": [
    {
      "id": 4577,
      "keyword": "mamadera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aplaudir": [
    {
      "id": 36682,
      "keyword": "aplaudir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4563,
      "keyword": "aplaudir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dar palmas": [
    {
      "id": 36682,
      "keyword": "dar palmas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4563,
      "keyword": "dar palmas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botas de montaña": [
    {
      "id": 4580,
      "keyword": "botas de montaña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36502,
      "keyword": "bota de montaña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolera": [
    {
      "id": 4579,
      "keyword": "bolera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boleras": [
    {
      "id": 4579,
      "keyword": "bolera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "blando": [
    {
      "id": 4578,
      "keyword": "blando",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "blandos": [
    {
      "id": 4578,
      "keyword": "blando",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "blanda": [
    {
      "id": 4578,
      "keyword": "blanda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "blandas": [
    {
      "id": 4578,
      "keyword": "blanda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barato": [
    {
      "id": 4574,
      "keyword": "barato",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baratos": [
    {
      "id": 4574,
      "keyword": "barato",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "económico": [
    {
      "id": 4574,
      "keyword": "económico",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "económicos": [
    {
      "id": 4574,
      "keyword": "económico",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barata": [
    {
      "id": 4574,
      "keyword": "barata",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baratas": [
    {
      "id": 4574,
      "keyword": "barata",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caliente": [
    {
      "id": 26716,
      "keyword": "caliente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "physics",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4583,
      "keyword": "caliente",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calientes": [
    {
      "id": 26716,
      "keyword": "caliente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "physics",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4583,
      "keyword": "caliente",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bueno": [
    {
      "id": 13630,
      "keyword": "bueno",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32432,
      "keyword": "bueno",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4581,
      "keyword": "bueno",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buenos": [
    {
      "id": 13630,
      "keyword": "bueno",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32432,
      "keyword": "bueno",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4581,
      "keyword": "bueno",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "buen": [
    {
      "id": 32432,
      "keyword": "buen",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4581,
      "keyword": "buen",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ancho": [
    {
      "id": 4559,
      "keyword": "ancho",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8022,
      "keyword": "ancho",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anchos": [
    {
      "id": 4559,
      "keyword": "ancho",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8022,
      "keyword": "ancho",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ancha": [
    {
      "id": 4559,
      "keyword": "ancha",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8022,
      "keyword": "ancha",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anchas": [
    {
      "id": 4559,
      "keyword": "ancha",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8022,
      "keyword": "ancha",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cantante": [
    {
      "id": 4585,
      "keyword": "cantante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11201,
      "keyword": "cantante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cantantes": [
    {
      "id": 4585,
      "keyword": "cantante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11201,
      "keyword": "cantante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cárcel": [
    {
      "id": 32430,
      "keyword": "cárcel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "law",
        "justice",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4588,
      "keyword": "cárcel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cárceles": [
    {
      "id": 32430,
      "keyword": "cárcel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "law",
        "justice",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4588,
      "keyword": "cárcel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prisión": [
    {
      "id": 32430,
      "keyword": "prisión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "law",
        "justice",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4588,
      "keyword": "prisión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prisiones": [
    {
      "id": 32430,
      "keyword": "prisión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "law",
        "justice",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4588,
      "keyword": "prisión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caro": [
    {
      "id": 4589,
      "keyword": "caro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caros": [
    {
      "id": 4589,
      "keyword": "caro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cementerio": [
    {
      "id": 4591,
      "keyword": "cementerio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "event",
        "social event",
        "death",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35455,
      "keyword": "cementerio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "event",
        "social event",
        "death",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36289,
      "keyword": "cementerio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "event",
        "social event",
        "death",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cementerios": [
    {
      "id": 4591,
      "keyword": "cementerio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "event",
        "social event",
        "death",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35455,
      "keyword": "cementerio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "event",
        "social event",
        "death",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36289,
      "keyword": "cementerio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "event",
        "social event",
        "death",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cena": [
    {
      "id": 4592,
      "keyword": "cena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "feeding",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cenas": [
    {
      "id": 4592,
      "keyword": "cena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "feeding",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caer": [
    {
      "id": 6067,
      "keyword": "caer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "work",
        "work accident",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39440,
      "keyword": "caer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4582,
      "keyword": "caer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "work accident"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29674,
      "keyword": "caer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "work accident"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chaleco salvavidas": [
    {
      "id": 4597,
      "keyword": "chaleco salvavidas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34876,
      "keyword": "chaleco salvavidas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chalecos salvavidas": [
    {
      "id": 4597,
      "keyword": "chaleco salvavidas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34876,
      "keyword": "chaleco salvavidas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cenar": [
    {
      "id": 6970,
      "keyword": "cenar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4593,
      "keyword": "cenar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28675,
      "keyword": "cenar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chiringuito": [
    {
      "id": 37323,
      "keyword": "chiringuito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4598,
      "keyword": "chiringuito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chiringuitos": [
    {
      "id": 37323,
      "keyword": "chiringuito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4598,
      "keyword": "chiringuito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerillas": [
    {
      "id": 4595,
      "keyword": "cerillas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8342,
      "keyword": "cerilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fósforos": [
    {
      "id": 4595,
      "keyword": "fósforos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8342,
      "keyword": "fósforo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cantimplora": [
    {
      "id": 4587,
      "keyword": "cantimplora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "beverage",
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cantimploras": [
    {
      "id": 4587,
      "keyword": "cantimplora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "beverage",
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerrado": [
    {
      "id": 36311,
      "keyword": "cerrado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "place",
        "building",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4596,
      "keyword": "cerrado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerrados": [
    {
      "id": 36311,
      "keyword": "cerrado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "place",
        "building",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4596,
      "keyword": "cerrado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerrada": [
    {
      "id": 36311,
      "keyword": "cerrada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "place",
        "building",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4596,
      "keyword": "cerrada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerradas": [
    {
      "id": 36311,
      "keyword": "cerrada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "place",
        "building",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4596,
      "keyword": "cerrada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cenicero": [
    {
      "id": 4594,
      "keyword": "cenicero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ceniceros": [
    {
      "id": 4594,
      "keyword": "cenicero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cigarrillo": [
    {
      "id": 4601,
      "keyword": "cigarrillo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cigarrillos": [
    {
      "id": 4601,
      "keyword": "cigarrillo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5101,
      "keyword": "cigarrillos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cigarro": [
    {
      "id": 4601,
      "keyword": "cigarro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cigarros": [
    {
      "id": 4601,
      "keyword": "cigarro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pucho": [
    {
      "id": 4601,
      "keyword": "pucho",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puchos": [
    {
      "id": 4601,
      "keyword": "pucho",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5101,
      "keyword": "puchos",
      "keywords": 4,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "beso": [
    {
      "id": 4576,
      "keyword": "beso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11525,
      "keyword": "beso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11527,
      "keyword": "beso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21435,
      "keyword": "beso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21439,
      "keyword": "beso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21437,
      "keyword": "beso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32886,
      "keyword": "beso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "besos": [
    {
      "id": 4576,
      "keyword": "beso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11525,
      "keyword": "beso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11527,
      "keyword": "beso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21435,
      "keyword": "beso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21439,
      "keyword": "beso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21437,
      "keyword": "beso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32886,
      "keyword": "beso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "círculo": [
    {
      "id": 4603,
      "keyword": "círculo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34053,
      "keyword": "círculo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "círculos": [
    {
      "id": 4603,
      "keyword": "círculo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34053,
      "keyword": "círculo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "redondo": [
    {
      "id": 4603,
      "keyword": "redondo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "shape",
        "mathematics",
        "geometry",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "redondos": [
    {
      "id": 4603,
      "keyword": "redondo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "shape",
        "mathematics",
        "geometry",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "redonda": [
    {
      "id": 4603,
      "keyword": "redonda",
      "keywords": 3,
      "type": 4,
      "tags": [
        "shape",
        "mathematics",
        "geometry",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9125,
      "keyword": "redonda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "redondas": [
    {
      "id": 4603,
      "keyword": "redonda",
      "keywords": 3,
      "type": 4,
      "tags": [
        "shape",
        "mathematics",
        "geometry",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9125,
      "keyword": "redonda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cine": [
    {
      "id": 32484,
      "keyword": "cine",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "cinema",
        "show",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30387,
      "keyword": "cine",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "cinema",
        "show",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4602,
      "keyword": "cine",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cines": [
    {
      "id": 32484,
      "keyword": "cine",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "cinema",
        "show",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30387,
      "keyword": "cine",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "cinema",
        "show",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4602,
      "keyword": "cine",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "invidente": [
    {
      "id": 37790,
      "keyword": "invidente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4600,
      "keyword": "invidente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10198,
      "keyword": "invidente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11574,
      "keyword": "invidente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11615,
      "keyword": "invidente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "invidentes": [
    {
      "id": 37790,
      "keyword": "invidente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4600,
      "keyword": "invidente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10198,
      "keyword": "invidente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11574,
      "keyword": "invidente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11615,
      "keyword": "invidente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ciega": [
    {
      "id": 37790,
      "keyword": "ciega",
      "keywords": 3,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4600,
      "keyword": "ciega",
      "keywords": 2,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11574,
      "keyword": "ciega",
      "keywords": 2,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciegas": [
    {
      "id": 37790,
      "keyword": "ciega",
      "keywords": 3,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4600,
      "keyword": "ciega",
      "keywords": 2,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11574,
      "keyword": "ciega",
      "keywords": 2,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "claro": [
    {
      "id": 4604,
      "keyword": "claro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "color",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25958,
      "keyword": "claro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "claros": [
    {
      "id": 4604,
      "keyword": "claro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "color",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25958,
      "keyword": "claro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clara": [
    {
      "id": 4604,
      "keyword": "clara",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "color",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6980,
      "keyword": "clara",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36899,
      "keyword": "clara",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25958,
      "keyword": "clara",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "claras": [
    {
      "id": 4604,
      "keyword": "clara",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "color",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6980,
      "keyword": "clara",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36899,
      "keyword": "clara",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25958,
      "keyword": "clara",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chupete": [
    {
      "id": 4599,
      "keyword": "chupete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chupetes": [
    {
      "id": 4599,
      "keyword": "chupete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "autos de choque": [
    {
      "id": 4605,
      "keyword": "autos de choque",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comida": [
    {
      "id": 38057,
      "keyword": "comida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4611,
      "keyword": "comida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "feeding",
        "food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4610,
      "keyword": "comida",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comidas": [
    {
      "id": 4611,
      "keyword": "comida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "feeding",
        "food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4610,
      "keyword": "comidas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conchas marinas": [
    {
      "id": 4612,
      "keyword": "conchas marinas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conchas": [
    {
      "id": 4612,
      "keyword": "conchas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34625,
      "keyword": "concha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34625,
      "keyword": "conchas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corto": [
    {
      "id": 26002,
      "keyword": "corto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4615,
      "keyword": "corto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortos": [
    {
      "id": 26002,
      "keyword": "corto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4615,
      "keyword": "corto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "corta": [
    {
      "id": 26002,
      "keyword": "corta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4615,
      "keyword": "corta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortas": [
    {
      "id": 26002,
      "keyword": "corta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4615,
      "keyword": "corta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuadrado": [
    {
      "id": 4616,
      "keyword": "cuadrado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuadrados": [
    {
      "id": 4616,
      "keyword": "cuadrado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cucaracha": [
    {
      "id": 4617,
      "keyword": "cucaracha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cucarachas": [
    {
      "id": 4617,
      "keyword": "cucaracha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuerda de escalar": [
    {
      "id": 4618,
      "keyword": "cuerda de escalar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuerdas de escalar": [
    {
      "id": 4618,
      "keyword": "cuerda de escalar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alimentos": [
    {
      "id": 4610,
      "keyword": "alimentos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alimento": [
    {
      "id": 4610,
      "keyword": "alimento",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuervo": [
    {
      "id": 4619,
      "keyword": "cuervo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuervos": [
    {
      "id": 4619,
      "keyword": "cuervo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "derecha": [
    {
      "id": 9202,
      "keyword": "derecha",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4624,
      "keyword": "derecha",
      "keywords": 5,
      "type": 4,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4624,
      "keyword": "derecha",
      "keywords": 5,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "derechas": [
    {
      "id": 9202,
      "keyword": "derecha",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4624,
      "keyword": "derecha",
      "keywords": 5,
      "type": 4,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4624,
      "keyword": "derecha",
      "keywords": 5,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diestro": [
    {
      "id": 38274,
      "keyword": "diestro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4624,
      "keyword": "diestro",
      "keywords": 5,
      "type": 4,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diestros": [
    {
      "id": 38274,
      "keyword": "diestro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4624,
      "keyword": "diestro",
      "keywords": 5,
      "type": 4,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diestra": [
    {
      "id": 38274,
      "keyword": "diestra",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4624,
      "keyword": "diestra",
      "keywords": 5,
      "type": 4,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diestras": [
    {
      "id": 38274,
      "keyword": "diestra",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4624,
      "keyword": "diestra",
      "keywords": 5,
      "type": 4,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "décimo de lotería": [
    {
      "id": 4621,
      "keyword": "décimo de lotería",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "gambling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "décimos de lotería": [
    {
      "id": 4621,
      "keyword": "décimo de lotería",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "gambling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lotería": [
    {
      "id": 4621,
      "keyword": "lotería",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "gambling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "loterías": [
    {
      "id": 4621,
      "keyword": "lotería",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "gambling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lotería nacional": [
    {
      "id": 4621,
      "keyword": "lotería nacional",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "gambling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "loterías nacionales": [
    {
      "id": 4621,
      "keyword": "lotería nacional",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "gambling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desayunar": [
    {
      "id": 7012,
      "keyword": "desayunar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4625,
      "keyword": "desayunar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28667,
      "keyword": "desayunar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desayuno": [
    {
      "id": 4626,
      "keyword": "desayuno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "feeding",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desayunos": [
    {
      "id": 4626,
      "keyword": "desayuno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "feeding",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "débil": [
    {
      "id": 25044,
      "keyword": "débil",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10199,
      "keyword": "débil",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4620,
      "keyword": "débil",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "débiles": [
    {
      "id": 25044,
      "keyword": "débil",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10199,
      "keyword": "débil",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4620,
      "keyword": "débil",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "flojo": [
    {
      "id": 25044,
      "keyword": "flojo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4620,
      "keyword": "flojo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flojos": [
    {
      "id": 25044,
      "keyword": "flojo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4620,
      "keyword": "flojo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "columpio": [
    {
      "id": 4608,
      "keyword": "columpio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 4608,
      "keyword": "columpio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36101,
      "keyword": "columpio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25000,
      "keyword": "columpio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "columpios": [
    {
      "id": 4608,
      "keyword": "columpio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 4608,
      "keyword": "columpio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36101,
      "keyword": "columpio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25000,
      "keyword": "columpio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desigual": [
    {
      "id": 4628,
      "keyword": "desigual",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32394,
      "keyword": "desigual",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32386,
      "keyword": "desigual",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desiguales": [
    {
      "id": 4628,
      "keyword": "desigual",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32394,
      "keyword": "desigual",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32386,
      "keyword": "desigual",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diferente": [
    {
      "id": 4628,
      "keyword": "diferente",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32394,
      "keyword": "diferente",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32386,
      "keyword": "diferente",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diferentes": [
    {
      "id": 4628,
      "keyword": "diferente",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32394,
      "keyword": "diferente",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32386,
      "keyword": "diferente",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "distinto": [
    {
      "id": 4628,
      "keyword": "distinto",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32394,
      "keyword": "distinto",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32386,
      "keyword": "distinto",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "distintos": [
    {
      "id": 4628,
      "keyword": "distinto",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32394,
      "keyword": "distinto",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32386,
      "keyword": "distinto",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "distinta": [
    {
      "id": 4628,
      "keyword": "distinta",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32394,
      "keyword": "distinta",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32386,
      "keyword": "distinta",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "distintas": [
    {
      "id": 4628,
      "keyword": "distinta",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32394,
      "keyword": "distinta",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32386,
      "keyword": "distinta",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dinero": [
    {
      "id": 4630,
      "keyword": "dinero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "core vocabulary",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 4630,
      "keyword": "dinero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "core vocabulary",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dineros": [
    {
      "id": 4630,
      "keyword": "dinero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "core vocabulary",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 4630,
      "keyword": "dinero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "core vocabulary",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "director": [
    {
      "id": 22757,
      "keyword": "director",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4631,
      "keyword": "director",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22755,
      "keyword": "director",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8990,
      "keyword": "director",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art",
        "musical notation",
        "musical composition",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "directores": [
    {
      "id": 22757,
      "keyword": "director",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4631,
      "keyword": "director",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22755,
      "keyword": "director",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8990,
      "keyword": "director",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art",
        "musical notation",
        "musical composition",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desordenado": [
    {
      "id": 4627,
      "keyword": "desordenado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36633,
      "keyword": "desordenado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desordenados": [
    {
      "id": 4627,
      "keyword": "desordenado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36633,
      "keyword": "desordenado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desordenada": [
    {
      "id": 4627,
      "keyword": "desordenada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36633,
      "keyword": "desordenada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desordenadas": [
    {
      "id": 4627,
      "keyword": "desordenada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36633,
      "keyword": "desordenada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "difícil": [
    {
      "id": 32436,
      "keyword": "difícil",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31888,
      "keyword": "difícil",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4629,
      "keyword": "difícil",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "difíciles": [
    {
      "id": 32436,
      "keyword": "difícil",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31888,
      "keyword": "difícil",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4629,
      "keyword": "difícil",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "complicado": [
    {
      "id": 32436,
      "keyword": "complicado",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31888,
      "keyword": "complicado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4629,
      "keyword": "complicado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "complicados": [
    {
      "id": 32436,
      "keyword": "complicado",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31888,
      "keyword": "complicado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4629,
      "keyword": "complicado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "complicada": [
    {
      "id": 32436,
      "keyword": "complicada",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4629,
      "keyword": "complicada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "complicadas": [
    {
      "id": 32436,
      "keyword": "complicada",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4629,
      "keyword": "complicada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "directora": [
    {
      "id": 22757,
      "keyword": "directora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4632,
      "keyword": "directora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22759,
      "keyword": "directora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9700,
      "keyword": "directora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art",
        "musical notation",
        "musical composition",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "directoras": [
    {
      "id": 22757,
      "keyword": "directora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4632,
      "keyword": "directora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22759,
      "keyword": "directora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9700,
      "keyword": "directora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art",
        "musical notation",
        "musical composition",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "domador": [
    {
      "id": 4635,
      "keyword": "domador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "discutir": [
    {
      "id": 6477,
      "keyword": "discutir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37786,
      "keyword": "discutir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4634,
      "keyword": "discutir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dulce": [
    {
      "id": 32440,
      "keyword": "dulce",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4636,
      "keyword": "dulce",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10201,
      "keyword": "dulce",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31837,
      "keyword": "dulce",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dulces": [
    {
      "id": 32440,
      "keyword": "dulce",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4636,
      "keyword": "dulce",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10201,
      "keyword": "dulce",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31837,
      "keyword": "dulce",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35769,
      "keyword": "dulces",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "duro": [
    {
      "id": 4637,
      "keyword": "duro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "duros": [
    {
      "id": 4637,
      "keyword": "duro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dura": [
    {
      "id": 4637,
      "keyword": "dura",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "duras": [
    {
      "id": 4637,
      "keyword": "dura",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "delgado": [
    {
      "id": 25048,
      "keyword": "delgado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary",
        "mathematics",
        "basic concepts",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38589,
      "keyword": "delgado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37064,
      "keyword": "delgado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4623,
      "keyword": "delgado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "delgados": [
    {
      "id": 25048,
      "keyword": "delgado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary",
        "mathematics",
        "basic concepts",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38589,
      "keyword": "delgado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37064,
      "keyword": "delgado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "object"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4623,
      "keyword": "delgado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "flaco": [
    {
      "id": 25048,
      "keyword": "flaco",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary",
        "mathematics",
        "basic concepts",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38589,
      "keyword": "flaco",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4623,
      "keyword": "flaco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flacos": [
    {
      "id": 25048,
      "keyword": "flaco",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary",
        "mathematics",
        "basic concepts",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38589,
      "keyword": "flaco",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4623,
      "keyword": "flaco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encender una vela": [
    {
      "id": 6486,
      "keyword": "encender una vela",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4639,
      "keyword": "encender una vela",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equilibrista": [
    {
      "id": 4641,
      "keyword": "equilibrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11257,
      "keyword": "equilibrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equilibristas": [
    {
      "id": 4641,
      "keyword": "equilibrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11257,
      "keyword": "equilibrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desaparecer": [
    {
      "id": 6493,
      "keyword": "desaparecer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4642,
      "keyword": "desaparecer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esconder": [
    {
      "id": 6493,
      "keyword": "esconder",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4642,
      "keyword": "esconder",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "discoteca": [
    {
      "id": 4633,
      "keyword": "discoteca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "discotecas": [
    {
      "id": 4633,
      "keyword": "discoteca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility",
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estrecho": [
    {
      "id": 37064,
      "keyword": "estrecho",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4643,
      "keyword": "estrecho",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8116,
      "keyword": "estrecho",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estrechos": [
    {
      "id": 37064,
      "keyword": "estrecho",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "object"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4643,
      "keyword": "estrecho",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8116,
      "keyword": "estrecho",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "angosto": [
    {
      "id": 4643,
      "keyword": "angosto",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8116,
      "keyword": "angosto",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "angostos": [
    {
      "id": 4643,
      "keyword": "angosto",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8116,
      "keyword": "angosto",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estrecha": [
    {
      "id": 37064,
      "keyword": "estrecha",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4643,
      "keyword": "estrecha",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8116,
      "keyword": "estrecha",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estrechas": [
    {
      "id": 37064,
      "keyword": "estrecha",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "object"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4643,
      "keyword": "estrecha",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8116,
      "keyword": "estrecha",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "angosta": [
    {
      "id": 4643,
      "keyword": "angosta",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8116,
      "keyword": "angosta",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "angostas": [
    {
      "id": 4643,
      "keyword": "angosta",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8116,
      "keyword": "angosta",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sencillo": [
    {
      "id": 32434,
      "keyword": "sencillo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32302,
      "keyword": "sencillo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4645,
      "keyword": "sencillo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sencillos": [
    {
      "id": 32434,
      "keyword": "sencillo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32302,
      "keyword": "sencillo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4645,
      "keyword": "sencillo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fácil": [
    {
      "id": 32434,
      "keyword": "fácil",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32302,
      "keyword": "fácil",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4645,
      "keyword": "fácil",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fáciles": [
    {
      "id": 32434,
      "keyword": "fácil",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32302,
      "keyword": "fácil",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4645,
      "keyword": "fácil",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sencilla": [
    {
      "id": 32434,
      "keyword": "sencilla",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4645,
      "keyword": "sencilla",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sencillas": [
    {
      "id": 32434,
      "keyword": "sencilla",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4645,
      "keyword": "sencilla",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "faro": [
    {
      "id": 4646,
      "keyword": "faro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5996,
      "keyword": "faro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "faros": [
    {
      "id": 4646,
      "keyword": "faro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10328,
      "keyword": "faros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5996,
      "keyword": "faro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "feria": [
    {
      "id": 38297,
      "keyword": "feria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "tertiary sector",
        "trade",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37741,
      "keyword": "feria",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "tertiary sector",
        "trade",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4649,
      "keyword": "feria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "core vocabulary",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ferias": [
    {
      "id": 38297,
      "keyword": "feria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "tertiary sector",
        "trade",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37741,
      "keyword": "feria",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "tertiary sector",
        "trade",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4649,
      "keyword": "feria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "core vocabulary",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encendida": [
    {
      "id": 26753,
      "keyword": "encendida",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4640,
      "keyword": "encendida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encendidas": [
    {
      "id": 26753,
      "keyword": "encendida",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4640,
      "keyword": "encendida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encendido": [
    {
      "id": 26753,
      "keyword": "encendido",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4640,
      "keyword": "encendido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encendidos": [
    {
      "id": 26753,
      "keyword": "encendido",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4640,
      "keyword": "encendido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frío": [
    {
      "id": 35557,
      "keyword": "frío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "body sensation",
        "meteorology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35589,
      "keyword": "frío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26865,
      "keyword": "frío",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "physics",
        "feeding",
        "cookery",
        "meteorology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4652,
      "keyword": "frío",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fríos": [
    {
      "id": 35557,
      "keyword": "frío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "body sensation",
        "meteorology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26865,
      "keyword": "frío",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "physics",
        "feeding",
        "cookery",
        "meteorology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4652,
      "keyword": "frío",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fría": [
    {
      "id": 26865,
      "keyword": "fría",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "physics",
        "feeding",
        "cookery",
        "meteorology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4652,
      "keyword": "fría",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frías": [
    {
      "id": 26865,
      "keyword": "fría",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "physics",
        "feeding",
        "cookery",
        "meteorology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4652,
      "keyword": "fría",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "empujar": [
    {
      "id": 6485,
      "keyword": "empujar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16655,
      "keyword": "empujar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4638,
      "keyword": "empujar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39442,
      "keyword": "empujar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15375,
      "keyword": "empujar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39441,
      "keyword": "empujar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flotador": [
    {
      "id": 32900,
      "keyword": "flotador",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4650,
      "keyword": "flotador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "swimming pool",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30036,
      "keyword": "flotador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "swimming pool",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36187,
      "keyword": "flotador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flotadores": [
    {
      "id": 32900,
      "keyword": "flotador",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4650,
      "keyword": "flotador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "swimming pool",
        "beach"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30036,
      "keyword": "flotador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "swimming pool",
        "beach"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36187,
      "keyword": "flotador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fuerte": [
    {
      "id": 25121,
      "keyword": "fuerte",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10204,
      "keyword": "fuerte",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4655,
      "keyword": "fuerte",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37621,
      "keyword": "fuerte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "middle ages",
        "building"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fuertes": [
    {
      "id": 25121,
      "keyword": "fuerte",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10204,
      "keyword": "fuerte",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4655,
      "keyword": "fuerte",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37621,
      "keyword": "fuerte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "middle ages",
        "building"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "robusto": [
    {
      "id": 4655,
      "keyword": "robusto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "robustos": [
    {
      "id": 4655,
      "keyword": "robusto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fruta": [
    {
      "id": 28339,
      "keyword": "fruta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4653,
      "keyword": "fruta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frutas": [
    {
      "id": 28339,
      "keyword": "fruta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28339,
      "keyword": "frutas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4653,
      "keyword": "fruta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4653,
      "keyword": "frutas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "feo": [
    {
      "id": 26090,
      "keyword": "feo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4648,
      "keyword": "feo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "feos": [
    {
      "id": 26090,
      "keyword": "feo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4648,
      "keyword": "feo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gordo": [
    {
      "id": 25133,
      "keyword": "gordo",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4656,
      "keyword": "gordo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gordos": [
    {
      "id": 25133,
      "keyword": "gordo",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4656,
      "keyword": "gordo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "obeso": [
    {
      "id": 25133,
      "keyword": "obeso",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4656,
      "keyword": "obeso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obesos": [
    {
      "id": 25133,
      "keyword": "obeso",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4656,
      "keyword": "obeso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gorrión": [
    {
      "id": 4657,
      "keyword": "gorrión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gorriones": [
    {
      "id": 4657,
      "keyword": "gorrión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gorriona": [
    {
      "id": 4657,
      "keyword": "gorriona",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gorrionas": [
    {
      "id": 4657,
      "keyword": "gorriona",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coger la botella": [
    {
      "id": 4606,
      "keyword": "coger la botella",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agarrar la botella": [
    {
      "id": 4606,
      "keyword": "agarrar la botella",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sostener la botella": [
    {
      "id": 4606,
      "keyword": "sostener la botella",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asir la botella": [
    {
      "id": 4606,
      "keyword": "asir la botella",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomar la botella": [
    {
      "id": 4606,
      "keyword": "tomar la botella",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grande": [
    {
      "id": 4658,
      "keyword": "grande",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "size",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6886,
      "keyword": "grande",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28201,
      "keyword": "grande",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grandes": [
    {
      "id": 4658,
      "keyword": "grande",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "size",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6886,
      "keyword": "grande",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28201,
      "keyword": "grande",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fea": [
    {
      "id": 26090,
      "keyword": "fea",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4647,
      "keyword": "fea",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "feas": [
    {
      "id": 26090,
      "keyword": "fea",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4647,
      "keyword": "fea",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guindilla": [
    {
      "id": 4661,
      "keyword": "guindilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guindillas": [
    {
      "id": 4661,
      "keyword": "guindilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aji": [
    {
      "id": 4661,
      "keyword": "aji",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ajies": [
    {
      "id": 4661,
      "keyword": "aji",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "formas": [
    {
      "id": 4651,
      "keyword": "formas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "categorization",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hoguera": [
    {
      "id": 4664,
      "keyword": "hoguera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hogueras": [
    {
      "id": 4664,
      "keyword": "hoguera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fuego": [
    {
      "id": 4654,
      "keyword": "fuego",
      "keywords": 1,
      "type": 2,
      "tags": [
        "chemistry",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4664,
      "keyword": "fuego",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fuegos": [
    {
      "id": 4654,
      "keyword": "fuego",
      "keywords": 1,
      "type": 2,
      "tags": [
        "chemistry",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4664,
      "keyword": "fuego",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hombre": [
    {
      "id": 4665,
      "keyword": "hombre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10360,
      "keyword": "hombre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38788,
      "keyword": "hombre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39005,
      "keyword": "hombre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6010,
      "keyword": "hombre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37526,
      "keyword": "hombre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hombres": [
    {
      "id": 4665,
      "keyword": "hombre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10360,
      "keyword": "hombre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38788,
      "keyword": "hombre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39005,
      "keyword": "hombre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6010,
      "keyword": "hombre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32362,
      "keyword": "hombres",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37526,
      "keyword": "hombre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hexágono": [
    {
      "id": 4663,
      "keyword": "hexágono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hexágonos": [
    {
      "id": 4663,
      "keyword": "hexágono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hucha": [
    {
      "id": 4666,
      "keyword": "hucha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huchas": [
    {
      "id": 4666,
      "keyword": "hucha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alcancía": [
    {
      "id": 4666,
      "keyword": "alcancía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alcancías": [
    {
      "id": 4666,
      "keyword": "alcancía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "incendio": [
    {
      "id": 4668,
      "keyword": "incendio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21929,
      "keyword": "incendio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21933,
      "keyword": "incendio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "traffic accident",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "incendios": [
    {
      "id": 4668,
      "keyword": "incendio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21929,
      "keyword": "incendio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21933,
      "keyword": "incendio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "traffic accident",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guapo": [
    {
      "id": 26114,
      "keyword": "guapo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4660,
      "keyword": "guapo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guapos": [
    {
      "id": 26114,
      "keyword": "guapo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4660,
      "keyword": "guapo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bello": [
    {
      "id": 26114,
      "keyword": "bello",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11194,
      "keyword": "bello",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4660,
      "keyword": "bello",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bellos": [
    {
      "id": 26114,
      "keyword": "bello",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11194,
      "keyword": "bello",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4660,
      "keyword": "bello",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inundación": [
    {
      "id": 4669,
      "keyword": "inundación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inundaciones": [
    {
      "id": 4669,
      "keyword": "inundación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tsunami": [
    {
      "id": 4669,
      "keyword": "tsunami",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tsunamis": [
    {
      "id": 4669,
      "keyword": "tsunami",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hablar por teléfono": [
    {
      "id": 6518,
      "keyword": "hablar por teléfono",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4662,
      "keyword": "hablar por teléfono",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34405,
      "keyword": "hablar por teléfono",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "iguales": [
    {
      "id": 32392,
      "keyword": "igual",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4667,
      "keyword": "igual",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4667,
      "keyword": "iguales",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mismo": [
    {
      "id": 32392,
      "keyword": "mismo",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4667,
      "keyword": "mismo",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mismos": [
    {
      "id": 32392,
      "keyword": "mismo",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4667,
      "keyword": "mismo",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "misma": [
    {
      "id": 32392,
      "keyword": "misma",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4667,
      "keyword": "misma",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mismas": [
    {
      "id": 32392,
      "keyword": "misma",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4667,
      "keyword": "misma",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tales": [
    {
      "id": 4667,
      "keyword": "tales",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guapa": [
    {
      "id": 26114,
      "keyword": "guapa",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4659,
      "keyword": "guapa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guapas": [
    {
      "id": 26114,
      "keyword": "guapa",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4659,
      "keyword": "guapa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bella": [
    {
      "id": 26114,
      "keyword": "bella",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11194,
      "keyword": "bella",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4659,
      "keyword": "bella",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bellas": [
    {
      "id": 26114,
      "keyword": "bella",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11194,
      "keyword": "bella",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4659,
      "keyword": "bella",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "excursión": [
    {
      "id": 6532,
      "keyword": "excursión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "healthy habit",
        "leisure",
        "outdoor activity",
        "mountain",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4670,
      "keyword": "excursión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "excursiones": [
    {
      "id": 6532,
      "keyword": "excursión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "healthy habit",
        "leisure",
        "outdoor activity",
        "mountain",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4670,
      "keyword": "excursión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ir de excursión": [
    {
      "id": 6532,
      "keyword": "ir de excursión",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "healthy habit",
        "leisure",
        "outdoor activity",
        "mountain",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4670,
      "keyword": "ir de excursión",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4671,
      "keyword": "ir de excursión",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "izquierda": [
    {
      "id": 9203,
      "keyword": "izquierda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4672,
      "keyword": "izquierda",
      "keywords": 5,
      "type": 4,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4672,
      "keyword": "izquierda",
      "keywords": 5,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "izquierdas": [
    {
      "id": 9203,
      "keyword": "izquierda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4672,
      "keyword": "izquierda",
      "keywords": 5,
      "type": 4,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4672,
      "keyword": "izquierda",
      "keywords": 5,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zurdo": [
    {
      "id": 38273,
      "keyword": "zurdo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4672,
      "keyword": "zurdo",
      "keywords": 5,
      "type": 4,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zurdos": [
    {
      "id": 38273,
      "keyword": "zurdo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4672,
      "keyword": "zurdo",
      "keywords": 5,
      "type": 4,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zurda": [
    {
      "id": 38273,
      "keyword": "zurda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4672,
      "keyword": "zurda",
      "keywords": 5,
      "type": 4,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zurdas": [
    {
      "id": 38273,
      "keyword": "zurda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4672,
      "keyword": "zurda",
      "keywords": 5,
      "type": 4,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mano izquierda": [
    {
      "id": 30168,
      "keyword": "mano izquierda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4672,
      "keyword": "mano izquierda",
      "keywords": 5,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manos izquierdas": [
    {
      "id": 30168,
      "keyword": "mano izquierda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4672,
      "keyword": "mano izquierda",
      "keywords": 5,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "joven": [
    {
      "id": 26146,
      "keyword": "joven",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4673,
      "keyword": "joven",
      "keywords": 4,
      "type": 4,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 4673,
      "keyword": "joven",
      "keywords": 4,
      "type": 4,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10206,
      "keyword": "joven",
      "keywords": 4,
      "type": 4,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 10206,
      "keyword": "joven",
      "keywords": 4,
      "type": 4,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39065,
      "keyword": "joven",
      "keywords": 4,
      "type": 4,
      "tags": [
        "person",
        "teenager"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jóvenes": [
    {
      "id": 26146,
      "keyword": "joven",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4673,
      "keyword": "joven",
      "keywords": 4,
      "type": 4,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 4673,
      "keyword": "joven",
      "keywords": 4,
      "type": 4,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10206,
      "keyword": "joven",
      "keywords": 4,
      "type": 4,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 10206,
      "keyword": "joven",
      "keywords": 4,
      "type": 4,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38817,
      "keyword": "jóvenes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "teenager"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39065,
      "keyword": "joven",
      "keywords": 4,
      "type": 4,
      "tags": [
        "person",
        "teenager"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adolescente": [
    {
      "id": 4673,
      "keyword": "adolescente",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 4673,
      "keyword": "adolescente",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10206,
      "keyword": "adolescente",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 10206,
      "keyword": "adolescente",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39065,
      "keyword": "adolescente",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adolescentes": [
    {
      "id": 4673,
      "keyword": "adolescente",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 4673,
      "keyword": "adolescente",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10206,
      "keyword": "adolescente",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 10206,
      "keyword": "adolescente",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38817,
      "keyword": "adolescentes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "teenager"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39065,
      "keyword": "adolescente",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "muchacho": [
    {
      "id": 4673,
      "keyword": "muchacho",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 4673,
      "keyword": "muchacho",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muchachos": [
    {
      "id": 4673,
      "keyword": "muchacho",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 4673,
      "keyword": "muchacho",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "largo": [
    {
      "id": 26162,
      "keyword": "largo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4675,
      "keyword": "largo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "largos": [
    {
      "id": 26162,
      "keyword": "largo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4675,
      "keyword": "largo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "larga": [
    {
      "id": 26162,
      "keyword": "larga",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4675,
      "keyword": "larga",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "largas": [
    {
      "id": 26162,
      "keyword": "larga",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4675,
      "keyword": "larga",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ladrón": [
    {
      "id": 4674,
      "keyword": "ladrón",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ladrones": [
    {
      "id": 4674,
      "keyword": "ladrón",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caco": [
    {
      "id": 11292,
      "keyword": "caco",
      "keywords": 4,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4674,
      "keyword": "caco",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cacos": [
    {
      "id": 11292,
      "keyword": "caco",
      "keywords": 4,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4674,
      "keyword": "caco",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "delincuente": [
    {
      "id": 11292,
      "keyword": "delincuente",
      "keywords": 4,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4674,
      "keyword": "delincuente",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "delincuentes": [
    {
      "id": 11292,
      "keyword": "delincuente",
      "keywords": 4,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4674,
      "keyword": "delincuente",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bandido": [
    {
      "id": 4674,
      "keyword": "bandido",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bandidos": [
    {
      "id": 4674,
      "keyword": "bandido",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "limpio": [
    {
      "id": 26172,
      "keyword": "limpio",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4680,
      "keyword": "limpio",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpios": [
    {
      "id": 26172,
      "keyword": "limpio",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4680,
      "keyword": "limpio",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "limpia": [
    {
      "id": 26172,
      "keyword": "limpia",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4680,
      "keyword": "limpia",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpias": [
    {
      "id": 26172,
      "keyword": "limpia",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4680,
      "keyword": "limpia",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "viajar": [
    {
      "id": 28173,
      "keyword": "viajar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "tourism",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39445,
      "keyword": "viajar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36974,
      "keyword": "viajar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4671,
      "keyword": "viajar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "línea curva": [
    {
      "id": 4681,
      "keyword": "línea curva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "líneas curvas": [
    {
      "id": 4681,
      "keyword": "línea curva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "línea ondulada": [
    {
      "id": 4682,
      "keyword": "línea ondulada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "líneas onduladas": [
    {
      "id": 4682,
      "keyword": "línea ondulada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ligero": [
    {
      "id": 26889,
      "keyword": "ligero",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4679,
      "keyword": "ligero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ligeros": [
    {
      "id": 26889,
      "keyword": "ligero",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4679,
      "keyword": "ligero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ligera": [
    {
      "id": 26889,
      "keyword": "ligera",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4679,
      "keyword": "ligera",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ligeras": [
    {
      "id": 26889,
      "keyword": "ligera",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4679,
      "keyword": "ligera",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "línea quebrada": [
    {
      "id": 4683,
      "keyword": "línea quebrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "líneas quebradas": [
    {
      "id": 4683,
      "keyword": "línea quebrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lento": [
    {
      "id": 4676,
      "keyword": "lento",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lentos": [
    {
      "id": 4676,
      "keyword": "lento",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "despacio": [
    {
      "id": 4676,
      "keyword": "despacio",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lenta": [
    {
      "id": 4676,
      "keyword": "lenta",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lentas": [
    {
      "id": 4676,
      "keyword": "lenta",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "levantar de la silla": [
    {
      "id": 30044,
      "keyword": "levantar de la silla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35783,
      "keyword": "levantar de la silla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4677,
      "keyword": "levantar de la silla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30046,
      "keyword": "levantar de la silla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30045,
      "keyword": "levantar de la silla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34523,
      "keyword": "levantar de la silla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "liso": [
    {
      "id": 25195,
      "keyword": "liso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4685,
      "keyword": "liso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lisos": [
    {
      "id": 25195,
      "keyword": "liso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4685,
      "keyword": "liso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lisa": [
    {
      "id": 4685,
      "keyword": "lisa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lisas": [
    {
      "id": 4685,
      "keyword": "lisa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "línea": [
    {
      "id": 4684,
      "keyword": "línea",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "líneas": [
    {
      "id": 4684,
      "keyword": "línea",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "línea recta": [
    {
      "id": 4684,
      "keyword": "línea recta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "líneas rectas": [
    {
      "id": 4684,
      "keyword": "línea recta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llamar a la puerta": [
    {
      "id": 4687,
      "keyword": "llamar a la puerta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llamar": [
    {
      "id": 32669,
      "keyword": "llamar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6552,
      "keyword": "llamar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "disruptive behavior",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36305,
      "keyword": "llamar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36306,
      "keyword": "llamar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27632,
      "keyword": "llamar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39519,
      "keyword": "llamar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4687,
      "keyword": "llamar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10171,
      "keyword": "llamar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27631,
      "keyword": "llamar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27630,
      "keyword": "llamar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4686,
      "keyword": "llamar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36137,
      "keyword": "llamar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gritar": [
    {
      "id": 6552,
      "keyword": "gritar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "disruptive behavior",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7120,
      "keyword": "gritar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4686,
      "keyword": "gritar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31125,
      "keyword": "gritar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31127,
      "keyword": "gritar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36137,
      "keyword": "gritar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vociferar": [
    {
      "id": 6552,
      "keyword": "vociferar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "disruptive behavior",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7120,
      "keyword": "vociferar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4686,
      "keyword": "vociferar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31125,
      "keyword": "vociferar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31127,
      "keyword": "vociferar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36137,
      "keyword": "vociferar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "malo": [
    {
      "id": 37182,
      "keyword": "malo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32652,
      "keyword": "malo",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32526,
      "keyword": "malo",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32192,
      "keyword": "malo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4690,
      "keyword": "malo",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "malos": [
    {
      "id": 37182,
      "keyword": "malo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32652,
      "keyword": "malo",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32526,
      "keyword": "malo",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32192,
      "keyword": "malo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4690,
      "keyword": "malo",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "malvado": [
    {
      "id": 32652,
      "keyword": "malvado",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32526,
      "keyword": "malvado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32192,
      "keyword": "malvado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4690,
      "keyword": "malvado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "malvados": [
    {
      "id": 32652,
      "keyword": "malvado",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32526,
      "keyword": "malvado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32192,
      "keyword": "malvado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4690,
      "keyword": "malvado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mala": [
    {
      "id": 37182,
      "keyword": "mala",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32652,
      "keyword": "mala",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32526,
      "keyword": "mala",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10207,
      "keyword": "mala",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4690,
      "keyword": "mala",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "malas": [
    {
      "id": 37182,
      "keyword": "mala",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32652,
      "keyword": "mala",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32526,
      "keyword": "mala",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10207,
      "keyword": "mala",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4690,
      "keyword": "mala",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "malvada": [
    {
      "id": 32652,
      "keyword": "malvada",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32526,
      "keyword": "malvada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10207,
      "keyword": "malvada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4690,
      "keyword": "malvada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "malvadas": [
    {
      "id": 32652,
      "keyword": "malvada",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32526,
      "keyword": "malvada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10207,
      "keyword": "malvada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4690,
      "keyword": "malvada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diabólico": [
    {
      "id": 32526,
      "keyword": "diabólico",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4690,
      "keyword": "diabólico",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diabólicos": [
    {
      "id": 32526,
      "keyword": "diabólico",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4690,
      "keyword": "diabólico",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diabólica": [
    {
      "id": 32526,
      "keyword": "diabólica",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4690,
      "keyword": "diabólica",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diabólicas": [
    {
      "id": 32526,
      "keyword": "diabólica",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4690,
      "keyword": "diabólica",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "telefonear": [
    {
      "id": 4691,
      "keyword": "telefonear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21980,
      "keyword": "telefonear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marcar": [
    {
      "id": 39451,
      "keyword": "marcar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "document",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4691,
      "keyword": "marcar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5506,
      "keyword": "marcar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21980,
      "keyword": "marcar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38375,
      "keyword": "marcar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6007,
      "keyword": "marcar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ludoteca": [
    {
      "id": 4689,
      "keyword": "ludoteca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ludotecas": [
    {
      "id": 4689,
      "keyword": "ludoteca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "libreta": [
    {
      "id": 4678,
      "keyword": "libreta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7142,
      "keyword": "libreta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "libretas": [
    {
      "id": 4678,
      "keyword": "libreta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7142,
      "keyword": "libreta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encendedor": [
    {
      "id": 4692,
      "keyword": "encendedor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking",
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encendedores": [
    {
      "id": 4692,
      "keyword": "encendedor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking",
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mechero": [
    {
      "id": 4692,
      "keyword": "mechero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking",
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mecheros": [
    {
      "id": 4692,
      "keyword": "mechero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking",
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mojado": [
    {
      "id": 25253,
      "keyword": "mojado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4697,
      "keyword": "mojado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36559,
      "keyword": "mojado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mojados": [
    {
      "id": 25253,
      "keyword": "mojado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4697,
      "keyword": "mojado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36559,
      "keyword": "mojado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mojar": [
    {
      "id": 37364,
      "keyword": "mojar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38397,
      "keyword": "mojar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4697,
      "keyword": "mojar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6149,
      "keyword": "mojar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36559,
      "keyword": "mojar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calar": [
    {
      "id": 4697,
      "keyword": "calar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6149,
      "keyword": "calar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36559,
      "keyword": "calar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "merendar": [
    {
      "id": 7160,
      "keyword": "merendar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4694,
      "keyword": "merendar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28835,
      "keyword": "merendar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "merienda": [
    {
      "id": 4695,
      "keyword": "merienda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "feeding",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37841,
      "keyword": "merienda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "feeding",
        "health",
        "lifestyle",
        "healthy habit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meriendas": [
    {
      "id": 4695,
      "keyword": "merienda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "feeding",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37841,
      "keyword": "merienda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "feeding",
        "health",
        "lifestyle",
        "healthy habit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "monedero": [
    {
      "id": 4698,
      "keyword": "monedero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monederos": [
    {
      "id": 4698,
      "keyword": "monedero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "montaña rusa": [
    {
      "id": 4699,
      "keyword": "montaña rusa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "montañas rusas": [
    {
      "id": 4699,
      "keyword": "montaña rusa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mediano": [
    {
      "id": 4693,
      "keyword": "mediano",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "size",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medianos": [
    {
      "id": 4693,
      "keyword": "mediano",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "size",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mediana": [
    {
      "id": 4693,
      "keyword": "mediana",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "size",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medianas": [
    {
      "id": 4693,
      "keyword": "mediana",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "size",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lleno": [
    {
      "id": 26176,
      "keyword": "lleno",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31190,
      "keyword": "lleno",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4688,
      "keyword": "lleno",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llenos": [
    {
      "id": 26176,
      "keyword": "lleno",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31190,
      "keyword": "lleno",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4688,
      "keyword": "lleno",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llena": [
    {
      "id": 26176,
      "keyword": "llena",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31190,
      "keyword": "llena",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4688,
      "keyword": "llena",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llenas": [
    {
      "id": 26176,
      "keyword": "llena",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31190,
      "keyword": "llena",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4688,
      "keyword": "llena",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nuevo": [
    {
      "id": 11316,
      "keyword": "nuevo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4705,
      "keyword": "nuevo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nuevos": [
    {
      "id": 11316,
      "keyword": "nuevo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4705,
      "keyword": "nuevo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nueva": [
    {
      "id": 11316,
      "keyword": "nueva",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4705,
      "keyword": "nueva",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nuevas": [
    {
      "id": 11316,
      "keyword": "nueva",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4705,
      "keyword": "nueva",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ola": [
    {
      "id": 4706,
      "keyword": "ola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "olas": [
    {
      "id": 4706,
      "keyword": "ola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ordenado": [
    {
      "id": 4707,
      "keyword": "ordenado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ordenados": [
    {
      "id": 4707,
      "keyword": "ordenado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ordenada": [
    {
      "id": 4707,
      "keyword": "ordenada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ordenadas": [
    {
      "id": 4707,
      "keyword": "ordenada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "orientador": [
    {
      "id": 34707,
      "keyword": "orientador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4708,
      "keyword": "orientador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orientadores": [
    {
      "id": 34707,
      "keyword": "orientador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4708,
      "keyword": "orientador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "morder": [
    {
      "id": 7165,
      "keyword": "morder",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39075,
      "keyword": "morder",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4700,
      "keyword": "morder",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15461,
      "keyword": "morder",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31863,
      "keyword": "morder",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11307,
      "keyword": "morder",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37761,
      "keyword": "morder",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37762,
      "keyword": "morder",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mudo": [
    {
      "id": 37796,
      "keyword": "mudo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4702,
      "keyword": "mudo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mudos": [
    {
      "id": 37796,
      "keyword": "mudo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4702,
      "keyword": "mudo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "orientadora": [
    {
      "id": 34707,
      "keyword": "orientadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4709,
      "keyword": "orientadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orientadoras": [
    {
      "id": 34707,
      "keyword": "orientadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4709,
      "keyword": "orientadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mosquetón": [
    {
      "id": 4701,
      "keyword": "mosquetón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mosquetones": [
    {
      "id": 4701,
      "keyword": "mosquetón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "óvalo": [
    {
      "id": 4711,
      "keyword": "óvalo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "óvalos": [
    {
      "id": 4711,
      "keyword": "óvalo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "elipse": [
    {
      "id": 4711,
      "keyword": "elipse",
      "keywords": 4,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "elipses": [
    {
      "id": 4711,
      "keyword": "elipse",
      "keywords": 4,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ovalado": [
    {
      "id": 4711,
      "keyword": "ovalado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ovalados": [
    {
      "id": 4711,
      "keyword": "ovalado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ovalada": [
    {
      "id": 4711,
      "keyword": "ovalada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ovaladas": [
    {
      "id": 4711,
      "keyword": "ovalada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agredir con un palo": [
    {
      "id": 4714,
      "keyword": "agredir con un palo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34501,
      "keyword": "agredir con un palo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34498,
      "keyword": "agredir con un palo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34500,
      "keyword": "agredir con un palo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pentágono": [
    {
      "id": 4715,
      "keyword": "pentágono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pentágonos": [
    {
      "id": 4715,
      "keyword": "pentágono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pajarita": [
    {
      "id": 4712,
      "keyword": "pajarita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8895,
      "keyword": "pajarita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9099,
      "keyword": "pajarita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "hobby",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pajaritas": [
    {
      "id": 4712,
      "keyword": "pajarita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8895,
      "keyword": "pajarita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9099,
      "keyword": "pajarita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "hobby",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "patín de pedales": [
    {
      "id": 4713,
      "keyword": "patín de pedales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patines de pedales": [
    {
      "id": 4713,
      "keyword": "patín de pedales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mujer": [
    {
      "id": 24621,
      "keyword": "mujer",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 24621,
      "keyword": "mujer",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4703,
      "keyword": "mujer",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10361,
      "keyword": "mujer",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38791,
      "keyword": "mujer",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39006,
      "keyword": "mujer",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6150,
      "keyword": "mujer",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37525,
      "keyword": "mujer",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mujeres": [
    {
      "id": 24621,
      "keyword": "mujer",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 24621,
      "keyword": "mujer",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4703,
      "keyword": "mujer",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10361,
      "keyword": "mujer",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32364,
      "keyword": "mujeres",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38791,
      "keyword": "mujer",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39006,
      "keyword": "mujer",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6150,
      "keyword": "mujer",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37525,
      "keyword": "mujer",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oscuro": [
    {
      "id": 26993,
      "keyword": "oscuro",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "light fixture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4710,
      "keyword": "oscuro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "color",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26266,
      "keyword": "oscuro",
      "keywords": 1,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "oscuros": [
    {
      "id": 26993,
      "keyword": "oscuro",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "light fixture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4710,
      "keyword": "oscuro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "color",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26266,
      "keyword": "oscuro",
      "keywords": 1,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "oscura": [
    {
      "id": 26993,
      "keyword": "oscura",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "light fixture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4710,
      "keyword": "oscura",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "color",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oscuras": [
    {
      "id": 26993,
      "keyword": "oscura",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "light fixture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4710,
      "keyword": "oscura",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "color",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "noria": [
    {
      "id": 4704,
      "keyword": "noria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "norias": [
    {
      "id": 4704,
      "keyword": "noria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pesar": [
    {
      "id": 33126,
      "keyword": "pesar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4717,
      "keyword": "pesar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31344,
      "keyword": "pesar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pobre": [
    {
      "id": 16843,
      "keyword": "pobre",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4723,
      "keyword": "pobre",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10209,
      "keyword": "pobre",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pobres": [
    {
      "id": 16843,
      "keyword": "pobre",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4723,
      "keyword": "pobre",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10209,
      "keyword": "pobre",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mendigo": [
    {
      "id": 16843,
      "keyword": "mendigo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4723,
      "keyword": "mendigo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mendigos": [
    {
      "id": 16843,
      "keyword": "mendigo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4723,
      "keyword": "mendigo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "indigente": [
    {
      "id": 16843,
      "keyword": "indigente",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4723,
      "keyword": "indigente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10209,
      "keyword": "indigente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "indigentes": [
    {
      "id": 16843,
      "keyword": "indigente",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4723,
      "keyword": "indigente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10209,
      "keyword": "indigente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "picante": [
    {
      "id": 37834,
      "keyword": "picante",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4719,
      "keyword": "picante",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32013,
      "keyword": "picante",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37756,
      "keyword": "picante",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "picantes": [
    {
      "id": 37834,
      "keyword": "picante",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4719,
      "keyword": "picante",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32013,
      "keyword": "picante",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37756,
      "keyword": "picante",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pipa": [
    {
      "id": 4722,
      "keyword": "pipa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8321,
      "keyword": "pipa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carrusel de ponis": [
    {
      "id": 4724,
      "keyword": "carrusel de ponis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8323,
      "keyword": "carrusel de ponis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carruseles de ponis": [
    {
      "id": 4724,
      "keyword": "carrusel de ponis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8323,
      "keyword": "carrusel de ponis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "piolet": [
    {
      "id": 4721,
      "keyword": "piolet",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piolets": [
    {
      "id": 4721,
      "keyword": "piolet",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pequeño": [
    {
      "id": 4716,
      "keyword": "pequeño",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "size",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pequeños": [
    {
      "id": 4716,
      "keyword": "pequeño",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "size",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pequeña": [
    {
      "id": 4716,
      "keyword": "pequeña",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "size",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pequeñas": [
    {
      "id": 4716,
      "keyword": "pequeña",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "size",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "puro": [
    {
      "id": 4728,
      "keyword": "puro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puros": [
    {
      "id": 4728,
      "keyword": "puro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quiniela": [
    {
      "id": 4729,
      "keyword": "quiniela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quinielas": [
    {
      "id": 4729,
      "keyword": "quiniela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apuesta": [
    {
      "id": 4729,
      "keyword": "apuesta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apuestas": [
    {
      "id": 4729,
      "keyword": "apuesta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rectángulo": [
    {
      "id": 4731,
      "keyword": "rectángulo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rectángulos": [
    {
      "id": 4731,
      "keyword": "rectángulo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "primero": [
    {
      "id": 32129,
      "keyword": "primero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37753,
      "keyword": "primero",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4726,
      "keyword": "primero",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27993,
      "keyword": "primero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27992,
      "keyword": "primero",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "primeros": [
    {
      "id": 32129,
      "keyword": "primero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37753,
      "keyword": "primero",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4726,
      "keyword": "primero",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27993,
      "keyword": "primero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27992,
      "keyword": "primero",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "refresco": [
    {
      "id": 4732,
      "keyword": "refresco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "refrescos": [
    {
      "id": 4732,
      "keyword": "refresco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "preso": [
    {
      "id": 4725,
      "keyword": "preso",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presos": [
    {
      "id": 4725,
      "keyword": "preso",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recluso": [
    {
      "id": 4725,
      "keyword": "recluso",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reclusos": [
    {
      "id": 4725,
      "keyword": "recluso",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prisionero": [
    {
      "id": 4725,
      "keyword": "prisionero",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prisioneros": [
    {
      "id": 4725,
      "keyword": "prisionero",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "convicto": [
    {
      "id": 4725,
      "keyword": "convicto",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "convictos": [
    {
      "id": 4725,
      "keyword": "convicto",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "presidiario": [
    {
      "id": 4725,
      "keyword": "presidiario",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presidiarios": [
    {
      "id": 4725,
      "keyword": "presidiario",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "piojo": [
    {
      "id": 4720,
      "keyword": "piojo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piojos": [
    {
      "id": 4720,
      "keyword": "piojo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "liendre": [
    {
      "id": 4720,
      "keyword": "liendre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "liendres": [
    {
      "id": 4720,
      "keyword": "liendre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saco de dormir": [
    {
      "id": 4738,
      "keyword": "saco de dormir",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "outdoor activity",
        "mountain"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 4738,
      "keyword": "saco de dormir",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacos de dormir": [
    {
      "id": 4738,
      "keyword": "saco de dormir",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "outdoor activity",
        "mountain"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 4738,
      "keyword": "saco de dormir",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salado": [
    {
      "id": 32524,
      "keyword": "salado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4739,
      "keyword": "salado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32152,
      "keyword": "salado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37759,
      "keyword": "salado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salados": [
    {
      "id": 32524,
      "keyword": "salado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4739,
      "keyword": "salado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32152,
      "keyword": "salado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37759,
      "keyword": "salado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salada": [
    {
      "id": 32524,
      "keyword": "salada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4739,
      "keyword": "salada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32152,
      "keyword": "salada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37759,
      "keyword": "salada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saladas": [
    {
      "id": 32524,
      "keyword": "salada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4739,
      "keyword": "salada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32152,
      "keyword": "salada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37759,
      "keyword": "salada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "roto": [
    {
      "id": 32388,
      "keyword": "roto",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4736,
      "keyword": "roto",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rotos": [
    {
      "id": 32388,
      "keyword": "roto",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4736,
      "keyword": "roto",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rota": [
    {
      "id": 32388,
      "keyword": "rota",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4736,
      "keyword": "rota",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rotas": [
    {
      "id": 32388,
      "keyword": "rota",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4736,
      "keyword": "rota",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fracturado": [
    {
      "id": 4736,
      "keyword": "fracturado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fracturados": [
    {
      "id": 4736,
      "keyword": "fracturado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fracturada": [
    {
      "id": 4736,
      "keyword": "fracturada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fracturadas": [
    {
      "id": 4736,
      "keyword": "fracturada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rombo": [
    {
      "id": 4734,
      "keyword": "rombo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rombos": [
    {
      "id": 4734,
      "keyword": "rombo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saludo": [
    {
      "id": 39136,
      "keyword": "saludo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4740,
      "keyword": "saludo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6609,
      "keyword": "saludo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saludos": [
    {
      "id": 39136,
      "keyword": "saludo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4740,
      "keyword": "saludo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6609,
      "keyword": "saludo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rico": [
    {
      "id": 37803,
      "keyword": "rico",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32340,
      "keyword": "rico",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4733,
      "keyword": "rico",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ricos": [
    {
      "id": 37803,
      "keyword": "rico",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32340,
      "keyword": "rico",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4733,
      "keyword": "rico",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acaudalado": [
    {
      "id": 37803,
      "keyword": "acaudalado",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4733,
      "keyword": "acaudalado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acaudalados": [
    {
      "id": 37803,
      "keyword": "acaudalado",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4733,
      "keyword": "acaudalado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "millonario": [
    {
      "id": 37803,
      "keyword": "millonario",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4733,
      "keyword": "millonario",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "millonarios": [
    {
      "id": 37803,
      "keyword": "millonario",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4733,
      "keyword": "millonario",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adinerado": [
    {
      "id": 37803,
      "keyword": "adinerado",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4733,
      "keyword": "adinerado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adinerados": [
    {
      "id": 37803,
      "keyword": "adinerado",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4733,
      "keyword": "adinerado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "seco": [
    {
      "id": 25437,
      "keyword": "seco",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4741,
      "keyword": "seco",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secos": [
    {
      "id": 25437,
      "keyword": "seco",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4741,
      "keyword": "seco",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "secar la ropa": [
    {
      "id": 4741,
      "keyword": "secar la ropa",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seca": [
    {
      "id": 25437,
      "keyword": "seca",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4741,
      "keyword": "seca",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secas": [
    {
      "id": 25437,
      "keyword": "seca",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4741,
      "keyword": "seca",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rugoso": [
    {
      "id": 4737,
      "keyword": "rugoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rugosos": [
    {
      "id": 4737,
      "keyword": "rugoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rugosa": [
    {
      "id": 4737,
      "keyword": "rugosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rugosas": [
    {
      "id": 4737,
      "keyword": "rugosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "secretaria": [
    {
      "id": 34784,
      "keyword": "secretaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4742,
      "keyword": "secretaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secretarias": [
    {
      "id": 34784,
      "keyword": "secretaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4742,
      "keyword": "secretaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "secretario": [
    {
      "id": 34784,
      "keyword": "secretario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4743,
      "keyword": "secretario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secretarios": [
    {
      "id": 34784,
      "keyword": "secretario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4743,
      "keyword": "secretario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "soplar": [
    {
      "id": 7258,
      "keyword": "soplar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6615,
      "keyword": "soplar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16895,
      "keyword": "soplar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4747,
      "keyword": "soplar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34365,
      "keyword": "soplar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34504,
      "keyword": "soplar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10179,
      "keyword": "soplar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34506,
      "keyword": "soplar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sordo": [
    {
      "id": 37795,
      "keyword": "sordo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4748,
      "keyword": "sordo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4749,
      "keyword": "sordo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sordos": [
    {
      "id": 37795,
      "keyword": "sordo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4748,
      "keyword": "sordo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4749,
      "keyword": "sordo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "señor": [
    {
      "id": 4744,
      "keyword": "señor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "señores": [
    {
      "id": 4744,
      "keyword": "señor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silueta": [
    {
      "id": 4744,
      "keyword": "silueta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4745,
      "keyword": "silueta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "siluetas": [
    {
      "id": 4744,
      "keyword": "silueta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4745,
      "keyword": "silueta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "romper": [
    {
      "id": 6604,
      "keyword": "romper",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32388,
      "keyword": "romper",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30002,
      "keyword": "romper",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4735,
      "keyword": "romper",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31752,
      "keyword": "romper",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37773,
      "keyword": "romper",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "partir": [
    {
      "id": 6604,
      "keyword": "partir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4735,
      "keyword": "partir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31752,
      "keyword": "partir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37773,
      "keyword": "partir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarjeta de crédito": [
    {
      "id": 4751,
      "keyword": "tarjeta de crédito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarjetas de crédito": [
    {
      "id": 4751,
      "keyword": "tarjeta de crédito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarjeta": [
    {
      "id": 4751,
      "keyword": "tarjeta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarjetas": [
    {
      "id": 6226,
      "keyword": "tarjetas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4751,
      "keyword": "tarjeta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "señora": [
    {
      "id": 4745,
      "keyword": "señora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "señoras": [
    {
      "id": 4745,
      "keyword": "señora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tabla de surf": [
    {
      "id": 4752,
      "keyword": "tabla de surf",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tablas de surf": [
    {
      "id": 4752,
      "keyword": "tabla de surf",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sombrilla": [
    {
      "id": 4746,
      "keyword": "sombrilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sombrillas": [
    {
      "id": 4746,
      "keyword": "sombrilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sombrilla de playa": [
    {
      "id": 4746,
      "keyword": "sombrilla de playa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sombrillas de playa": [
    {
      "id": 4746,
      "keyword": "sombrilla de playa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de campaña": [
    {
      "id": 4756,
      "keyword": "tienda de campaña",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de campaña": [
    {
      "id": 4756,
      "keyword": "tienda de campaña",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carpa": [
    {
      "id": 24943,
      "keyword": "carpa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4756,
      "keyword": "carpa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carpas": [
    {
      "id": 24943,
      "keyword": "carpa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4756,
      "keyword": "carpa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sucio": [
    {
      "id": 26459,
      "keyword": "sucio",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4750,
      "keyword": "sucio",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sucios": [
    {
      "id": 26459,
      "keyword": "sucio",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4750,
      "keyword": "sucio",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manchado": [
    {
      "id": 26459,
      "keyword": "manchado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4750,
      "keyword": "manchado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manchados": [
    {
      "id": 26459,
      "keyword": "manchado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4750,
      "keyword": "manchado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mugriento": [
    {
      "id": 4750,
      "keyword": "mugriento",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mugrientos": [
    {
      "id": 4750,
      "keyword": "mugriento",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sucia": [
    {
      "id": 26459,
      "keyword": "sucia",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4750,
      "keyword": "sucia",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sucias": [
    {
      "id": 26459,
      "keyword": "sucia",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4750,
      "keyword": "sucia",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manchada": [
    {
      "id": 26459,
      "keyword": "manchada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4750,
      "keyword": "manchada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manchadas": [
    {
      "id": 26459,
      "keyword": "manchada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4750,
      "keyword": "manchada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mugrienta": [
    {
      "id": 4750,
      "keyword": "mugrienta",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mugrientas": [
    {
      "id": 4750,
      "keyword": "mugrienta",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pulga": [
    {
      "id": 4727,
      "keyword": "pulga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulgas": [
    {
      "id": 4727,
      "keyword": "pulga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "terremoto": [
    {
      "id": 4755,
      "keyword": "terremoto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37580,
      "keyword": "terremoto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "secondary sector",
        "construction",
        "place",
        "building",
        "home",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terremotos": [
    {
      "id": 4755,
      "keyword": "terremoto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37580,
      "keyword": "terremoto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "secondary sector",
        "construction",
        "place",
        "building",
        "home",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "seísmo": [
    {
      "id": 4755,
      "keyword": "seísmo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seísmos": [
    {
      "id": 4755,
      "keyword": "seísmo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "temblor": [
    {
      "id": 4755,
      "keyword": "temblor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "temblores": [
    {
      "id": 4755,
      "keyword": "temblor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tobogán": [
    {
      "id": 4759,
      "keyword": "tobogán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26495,
      "keyword": "tobogán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toboganes": [
    {
      "id": 4759,
      "keyword": "tobogán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26495,
      "keyword": "tobogán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tómbola": [
    {
      "id": 4760,
      "keyword": "tómbola",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tómbolas": [
    {
      "id": 4760,
      "keyword": "tómbola",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barraca de feria": [
    {
      "id": 5102,
      "keyword": "barraca de feria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4760,
      "keyword": "barraca de feria",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barracas de feria": [
    {
      "id": 5102,
      "keyword": "barraca de feria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4760,
      "keyword": "barraca de feria",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caseta de feria": [
    {
      "id": 5102,
      "keyword": "caseta de feria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4760,
      "keyword": "caseta de feria",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casetas de feria": [
    {
      "id": 5102,
      "keyword": "caseta de feria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4760,
      "keyword": "caseta de feria",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trapecio": [
    {
      "id": 4761,
      "keyword": "trapecio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25514,
      "keyword": "trapecio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "muscular system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trapecios": [
    {
      "id": 4761,
      "keyword": "trapecio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25514,
      "keyword": "trapecio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "muscular system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tabla de windsurf": [
    {
      "id": 4753,
      "keyword": "tabla de windsurf",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tablas de windsurf": [
    {
      "id": 4753,
      "keyword": "tabla de windsurf",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tabla": [
    {
      "id": 6143,
      "keyword": "tabla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "vegetal origin material",
        "work",
        "secondary sector",
        "carpentry",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9090,
      "keyword": "tabla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4753,
      "keyword": "tabla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tablas": [
    {
      "id": 6143,
      "keyword": "tabla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "vegetal origin material",
        "work",
        "secondary sector",
        "carpentry",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9090,
      "keyword": "tabla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4753,
      "keyword": "tabla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "windsurf": [
    {
      "id": 4753,
      "keyword": "windsurf",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trapecista": [
    {
      "id": 4762,
      "keyword": "trapecista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11388,
      "keyword": "trapecista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trapecistas": [
    {
      "id": 4762,
      "keyword": "trapecista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11388,
      "keyword": "trapecista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acróbata": [
    {
      "id": 4762,
      "keyword": "acróbata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11388,
      "keyword": "acróbata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acróbatas": [
    {
      "id": 4762,
      "keyword": "acróbata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11388,
      "keyword": "acróbata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hamaca": [
    {
      "id": 26917,
      "keyword": "hamaca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30229,
      "keyword": "hamaca",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4764,
      "keyword": "hamaca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hamacas": [
    {
      "id": 26917,
      "keyword": "hamaca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30229,
      "keyword": "hamaca",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4764,
      "keyword": "hamaca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tumbona": [
    {
      "id": 4764,
      "keyword": "tumbona",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tumbonas": [
    {
      "id": 4764,
      "keyword": "tumbona",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reposera": [
    {
      "id": 4764,
      "keyword": "reposera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reposeras": [
    {
      "id": 4764,
      "keyword": "reposera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "toalla de playa": [
    {
      "id": 4758,
      "keyword": "toalla de playa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toallas de playa": [
    {
      "id": 4758,
      "keyword": "toalla de playa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "teatro de marionetas": [
    {
      "id": 4754,
      "keyword": "teatro de marionetas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "theater",
        "show",
        "leisure",
        "work",
        "place",
        "facility",
        "recreational facility",
        "playground"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11270,
      "keyword": "teatro de marionetas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "theater",
        "show",
        "leisure",
        "work",
        "place",
        "facility",
        "recreational facility",
        "playground"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teatros de marionetas": [
    {
      "id": 4754,
      "keyword": "teatro de marionetas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "theater",
        "show",
        "leisure",
        "work",
        "place",
        "facility",
        "recreational facility",
        "playground"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11270,
      "keyword": "teatro de marionetas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "theater",
        "show",
        "leisure",
        "work",
        "place",
        "facility",
        "recreational facility",
        "playground"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "último": [
    {
      "id": 32069,
      "keyword": "último",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37751,
      "keyword": "último",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4765,
      "keyword": "último",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "últimos": [
    {
      "id": 32069,
      "keyword": "último",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37751,
      "keyword": "último",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4765,
      "keyword": "último",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carrusel": [
    {
      "id": 17204,
      "keyword": "carrusel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38554,
      "keyword": "carrusel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4757,
      "keyword": "carrusel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carruseles": [
    {
      "id": 17204,
      "keyword": "carrusel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38554,
      "keyword": "carrusel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4757,
      "keyword": "carrusel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tiovivo": [
    {
      "id": 17204,
      "keyword": "tiovivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4757,
      "keyword": "tiovivo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiovivos": [
    {
      "id": 17204,
      "keyword": "tiovivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4757,
      "keyword": "tiovivo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calesita": [
    {
      "id": 4757,
      "keyword": "calesita",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calesitas": [
    {
      "id": 4757,
      "keyword": "calesita",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "urraca": [
    {
      "id": 4766,
      "keyword": "urraca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "urracas": [
    {
      "id": 4766,
      "keyword": "urraca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vacío": [
    {
      "id": 26527,
      "keyword": "vacío",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4767,
      "keyword": "vacío",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vacíos": [
    {
      "id": 26527,
      "keyword": "vacío",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4767,
      "keyword": "vacío",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vacía": [
    {
      "id": 26527,
      "keyword": "vacía",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4767,
      "keyword": "vacía",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vacías": [
    {
      "id": 26527,
      "keyword": "vacía",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4767,
      "keyword": "vacía",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "violonchelo": [
    {
      "id": 4771,
      "keyword": "violonchelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "violonchelos": [
    {
      "id": 4771,
      "keyword": "violonchelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chelo": [
    {
      "id": 4771,
      "keyword": "chelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chelos": [
    {
      "id": 4771,
      "keyword": "chelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "viejo": [
    {
      "id": 11394,
      "keyword": "viejo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4770,
      "keyword": "viejo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viejos": [
    {
      "id": 11394,
      "keyword": "viejo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4770,
      "keyword": "viejo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desgastado": [
    {
      "id": 4770,
      "keyword": "desgastado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desgastados": [
    {
      "id": 4770,
      "keyword": "desgastado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vieja": [
    {
      "id": 11394,
      "keyword": "vieja",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4770,
      "keyword": "vieja",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viejas": [
    {
      "id": 11394,
      "keyword": "vieja",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4770,
      "keyword": "vieja",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desgastada": [
    {
      "id": 4770,
      "keyword": "desgastada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desgastadas": [
    {
      "id": 4770,
      "keyword": "desgastada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "visita": [
    {
      "id": 27125,
      "keyword": "visita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27126,
      "keyword": "visita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35439,
      "keyword": "visita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4772,
      "keyword": "visita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "visitas": [
    {
      "id": 27125,
      "keyword": "visita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27126,
      "keyword": "visita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35439,
      "keyword": "visita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4772,
      "keyword": "visita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "visitar": [
    {
      "id": 27125,
      "keyword": "visitar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27126,
      "keyword": "visitar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4772,
      "keyword": "visitar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vaso de leche": [
    {
      "id": 4769,
      "keyword": "vaso de leche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "animal-based food",
        "dairy product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vasos de leche": [
    {
      "id": 4769,
      "keyword": "vaso de leche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "animal-based food",
        "dairy product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "1 euro": [
    {
      "id": 4776,
      "keyword": "1 euro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "coin"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zoológico": [
    {
      "id": 32418,
      "keyword": "zoológico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4773,
      "keyword": "zoológico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zoológicos": [
    {
      "id": 32418,
      "keyword": "zoológico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4773,
      "keyword": "zoológico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zoo": [
    {
      "id": 32418,
      "keyword": "zoo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4773,
      "keyword": "zoo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zoos": [
    {
      "id": 32418,
      "keyword": "zoo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4773,
      "keyword": "zoo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "1 céntimo": [
    {
      "id": 4775,
      "keyword": "1 céntimo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "coin"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "céntimo": [
    {
      "id": 4775,
      "keyword": "céntimo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "coin"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "céntimos": [
    {
      "id": 35117,
      "keyword": "céntimos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "coin",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 35117,
      "keyword": "céntimos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "coin",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4775,
      "keyword": "céntimo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "coin"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "2 céntimos": [
    {
      "id": 4777,
      "keyword": "2 céntimos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "coin"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "20 euros": [
    {
      "id": 4784,
      "keyword": "20 euros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "bill"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "50 céntimos": [
    {
      "id": 4785,
      "keyword": "50 céntimos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "coin"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "50 euros": [
    {
      "id": 4786,
      "keyword": "50 euros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "bill"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "100 euros": [
    {
      "id": 4787,
      "keyword": "100 euros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "bill"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vaso de agua": [
    {
      "id": 4768,
      "keyword": "vaso de agua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vasos de agua": [
    {
      "id": 4768,
      "keyword": "vaso de agua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "200 euros": [
    {
      "id": 4788,
      "keyword": "200 euros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "bill"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "10 euros": [
    {
      "id": 4782,
      "keyword": "10 euros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "bill"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "castillo de arena": [
    {
      "id": 4790,
      "keyword": "castillo de arena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "castillos de arena": [
    {
      "id": 4790,
      "keyword": "castillo de arena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "10 céntimos": [
    {
      "id": 4781,
      "keyword": "10 céntimos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "coin"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "500 euros": [
    {
      "id": 4789,
      "keyword": "500 euros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "bill"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "explosión": [
    {
      "id": 4791,
      "keyword": "explosión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35003,
      "keyword": "explosión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30954,
      "keyword": "explosión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "work accident"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30956,
      "keyword": "explosión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "work accident",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30955,
      "keyword": "explosión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "work accident"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "explosiones": [
    {
      "id": 4791,
      "keyword": "explosión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35003,
      "keyword": "explosión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30954,
      "keyword": "explosión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "work accident"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30956,
      "keyword": "explosión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "work accident",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30955,
      "keyword": "explosión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "work accident"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "5 céntimos": [
    {
      "id": 4779,
      "keyword": "5 céntimos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "coin"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sobaos": [
    {
      "id": 4792,
      "keyword": "sobaos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8369,
      "keyword": "sobao",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esterilla": [
    {
      "id": 4793,
      "keyword": "esterilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esterillas": [
    {
      "id": 4793,
      "keyword": "esterilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pintura": [
    {
      "id": 4870,
      "keyword": "pintura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4950,
      "keyword": "pintura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25413,
      "keyword": "pintura",
      "keywords": 3,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinturas": [
    {
      "id": 4870,
      "keyword": "pintura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4950,
      "keyword": "pintura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16855,
      "keyword": "pinturas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25413,
      "keyword": "pintura",
      "keywords": 3,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bote de pintura": [
    {
      "id": 4870,
      "keyword": "bote de pintura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botes de pintura": [
    {
      "id": 4870,
      "keyword": "bote de pintura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "20 céntimos": [
    {
      "id": 4783,
      "keyword": "20 céntimos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "coin"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "5 euros": [
    {
      "id": 4780,
      "keyword": "5 euros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "bill"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubo de fregar": [
    {
      "id": 4874,
      "keyword": "cubo de fregar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubos de fregar": [
    {
      "id": 4874,
      "keyword": "cubo de fregar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cubo de pintura": [
    {
      "id": 4875,
      "keyword": "cubo de pintura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubos de pintura": [
    {
      "id": 4875,
      "keyword": "cubo de pintura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "crema de manos": [
    {
      "id": 4873,
      "keyword": "crema de manos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cremas de manos": [
    {
      "id": 4873,
      "keyword": "crema de manos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "limpiar el polvo": [
    {
      "id": 4878,
      "keyword": "limpiar el polvo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiador": [
    {
      "id": 34411,
      "keyword": "limpiador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4871,
      "keyword": "limpiador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11231,
      "keyword": "limpiador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15744,
      "keyword": "limpiador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiadores": [
    {
      "id": 34411,
      "keyword": "limpiador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4871,
      "keyword": "limpiador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11231,
      "keyword": "limpiador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15744,
      "keyword": "limpiador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aspirar": [
    {
      "id": 16443,
      "keyword": "aspirar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4877,
      "keyword": "aspirar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29740,
      "keyword": "aspirar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maíz": [
    {
      "id": 36287,
      "keyword": "maíz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "cereal",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4879,
      "keyword": "maíz",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maices": [
    {
      "id": 36287,
      "keyword": "maíz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "cereal",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4879,
      "keyword": "maíz",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maíz tostado": [
    {
      "id": 4879,
      "keyword": "maíz tostado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maíces tostados": [
    {
      "id": 4879,
      "keyword": "maíz tostado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "choclo": [
    {
      "id": 36287,
      "keyword": "choclo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "cereal",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4879,
      "keyword": "choclo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7150,
      "keyword": "choclo",
      "keywords": 3,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "work",
        "primary sector",
        "agriculture",
        "cereal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "choclos": [
    {
      "id": 36287,
      "keyword": "choclo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "cereal",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4879,
      "keyword": "choclo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7150,
      "keyword": "choclo",
      "keywords": 3,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "work",
        "primary sector",
        "agriculture",
        "cereal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chaqueta": [
    {
      "id": 4872,
      "keyword": "chaqueta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 4872,
      "keyword": "chaqueta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chaquetas": [
    {
      "id": 4872,
      "keyword": "chaqueta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 4872,
      "keyword": "chaqueta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "campera": [
    {
      "id": 4872,
      "keyword": "campera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 4872,
      "keyword": "campera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camperas": [
    {
      "id": 4872,
      "keyword": "campera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 4872,
      "keyword": "campera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de coches": [
    {
      "id": 4883,
      "keyword": "tienda de coches",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de coches": [
    {
      "id": 4883,
      "keyword": "tienda de coches",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "concesionario": [
    {
      "id": 4883,
      "keyword": "concesionario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "concesionarios": [
    {
      "id": 4883,
      "keyword": "concesionario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de ropa": [
    {
      "id": 6623,
      "keyword": "tienda de ropa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30424,
      "keyword": "tienda de ropa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30425,
      "keyword": "tienda de ropa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30426,
      "keyword": "tienda de ropa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30427,
      "keyword": "tienda de ropa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30436,
      "keyword": "tienda de ropa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30437,
      "keyword": "tienda de ropa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4885,
      "keyword": "tienda de ropa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de ropa": [
    {
      "id": 6623,
      "keyword": "tienda de ropa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30424,
      "keyword": "tienda de ropa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30425,
      "keyword": "tienda de ropa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30426,
      "keyword": "tienda de ropa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30427,
      "keyword": "tienda de ropa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30436,
      "keyword": "tienda de ropa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30437,
      "keyword": "tienda de ropa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4885,
      "keyword": "tienda de ropa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "boutique": [
    {
      "id": 6623,
      "keyword": "boutique",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4885,
      "keyword": "boutique",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boutiques": [
    {
      "id": 6623,
      "keyword": "boutique",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4885,
      "keyword": "boutique",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "verde": [
    {
      "id": 4887,
      "keyword": "verde",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4886,
      "keyword": "verde",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "verdes": [
    {
      "id": 4887,
      "keyword": "verde",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4886,
      "keyword": "verde",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "verde claro": [
    {
      "id": 4886,
      "keyword": "verde claro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "verdes claros": [
    {
      "id": 4886,
      "keyword": "verde claro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de caramelos": [
    {
      "id": 6621,
      "keyword": "tienda de caramelos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4882,
      "keyword": "tienda de caramelos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de caramelos": [
    {
      "id": 6621,
      "keyword": "tienda de caramelos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4882,
      "keyword": "tienda de caramelos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "verde oscuro": [
    {
      "id": 4887,
      "keyword": "verde oscuro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "verdes oscuros": [
    {
      "id": 4887,
      "keyword": "verde oscuro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frigorífico combi": [
    {
      "id": 4876,
      "keyword": "frigorífico combi",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frigoríficos combi": [
    {
      "id": 4876,
      "keyword": "frigorífico combi",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de muebles": [
    {
      "id": 6622,
      "keyword": "tienda de muebles",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "furniture",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4884,
      "keyword": "tienda de muebles",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de muebles": [
    {
      "id": 6622,
      "keyword": "tienda de muebles",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "furniture",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4884,
      "keyword": "tienda de muebles",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "queso en lonchas": [
    {
      "id": 4881,
      "keyword": "queso en lonchas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quesos en lonchas": [
    {
      "id": 4881,
      "keyword": "queso en lonchas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "balón de baloncesto": [
    {
      "id": 4918,
      "keyword": "balón de baloncesto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balones de baloncesto": [
    {
      "id": 4918,
      "keyword": "balón de baloncesto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "basketball"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "banco sueco": [
    {
      "id": 4919,
      "keyword": "banco sueco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "education",
        "educational equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bancos suecos": [
    {
      "id": 4919,
      "keyword": "banco sueco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "education",
        "educational equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barca de remos": [
    {
      "id": 4920,
      "keyword": "barca de remos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barcas de remos": [
    {
      "id": 4920,
      "keyword": "barca de remos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barca": [
    {
      "id": 4920,
      "keyword": "barca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barcas": [
    {
      "id": 4920,
      "keyword": "barca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bloques": [
    {
      "id": 4935,
      "keyword": "bloques",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4921,
      "keyword": "bloques",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8508,
      "keyword": "bloques",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bloques de psicomotricidad": [
    {
      "id": 4921,
      "keyword": "bloques de psicomotricidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bongós": [
    {
      "id": 4922,
      "keyword": "bongós",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8341,
      "keyword": "bongó",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caballito mecedor": [
    {
      "id": 4923,
      "keyword": "caballito mecedor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caballitos mecedores": [
    {
      "id": 4923,
      "keyword": "caballito mecedor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caballito de madera": [
    {
      "id": 4923,
      "keyword": "caballito de madera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caballitos de madera": [
    {
      "id": 4923,
      "keyword": "caballito de madera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caballito": [
    {
      "id": 4923,
      "keyword": "caballito",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caballitos": [
    {
      "id": 4923,
      "keyword": "caballito",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caja china": [
    {
      "id": 4924,
      "keyword": "caja china",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajas chinas": [
    {
      "id": 4924,
      "keyword": "caja china",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gomets": [
    {
      "id": 35425,
      "keyword": "gomet",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4932,
      "keyword": "gomets",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camión trailer": [
    {
      "id": 4926,
      "keyword": "camión trailer",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camiones trailer": [
    {
      "id": 4926,
      "keyword": "camión trailer",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tráiler": [
    {
      "id": 4926,
      "keyword": "tráiler",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guante de horno": [
    {
      "id": 4933,
      "keyword": "guante de horno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guantes de horno": [
    {
      "id": 4933,
      "keyword": "guante de horno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lámpara": [
    {
      "id": 4936,
      "keyword": "lámpara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 4936,
      "keyword": "lámpara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4937,
      "keyword": "lámpara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4938,
      "keyword": "lámpara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9178,
      "keyword": "lámpara",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lámparas": [
    {
      "id": 4936,
      "keyword": "lámpara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 4936,
      "keyword": "lámpara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4937,
      "keyword": "lámpara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4938,
      "keyword": "lámpara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9178,
      "keyword": "lámpara",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lámpara de mesilla": [
    {
      "id": 4936,
      "keyword": "lámpara de mesilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 4936,
      "keyword": "lámpara de mesilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lámparas de mesilla": [
    {
      "id": 4936,
      "keyword": "lámpara de mesilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 4936,
      "keyword": "lámpara de mesilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bloques de construcción": [
    {
      "id": 4935,
      "keyword": "bloques de construcción",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "construcciones": [
    {
      "id": 4935,
      "keyword": "construcciones",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35859,
      "keyword": "construcción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction",
        "architecture",
        "building",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juego de construcciones": [
    {
      "id": 4935,
      "keyword": "juego de construcciones",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos construcciones": [
    {
      "id": 4935,
      "keyword": "juego de construcciones",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camión de bomberos": [
    {
      "id": 6982,
      "keyword": "camión de bomberos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4925,
      "keyword": "camión de bomberos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camiones de bomberos": [
    {
      "id": 6982,
      "keyword": "camión de bomberos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4925,
      "keyword": "camión de bomberos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lámpara de pie": [
    {
      "id": 4937,
      "keyword": "lámpara de pie",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lámparas de pie": [
    {
      "id": 4937,
      "keyword": "lámpara de pie",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cubos apilables": [
    {
      "id": 4930,
      "keyword": "cubos apilables",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14544,
      "keyword": "cubos apilables",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máquina de afeitar": [
    {
      "id": 4941,
      "keyword": "máquina de afeitar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máquinas de afeitar": [
    {
      "id": 4941,
      "keyword": "máquina de afeitar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cola-cao": [
    {
      "id": 4940,
      "keyword": "Cola-Cao",
      "keywords": 2,
      "type": 1,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leche con cacao": [
    {
      "id": 4940,
      "keyword": "leche con cacao",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chubasquero": [
    {
      "id": 4927,
      "keyword": "chubasquero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 4927,
      "keyword": "chubasquero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chubasqueros": [
    {
      "id": 4927,
      "keyword": "chubasquero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 4927,
      "keyword": "chubasquero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "impermeable": [
    {
      "id": 4927,
      "keyword": "impermeable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 4927,
      "keyword": "impermeable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "impermeables": [
    {
      "id": 4927,
      "keyword": "impermeable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 4927,
      "keyword": "impermeable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesa baja de salón": [
    {
      "id": 4942,
      "keyword": "mesa baja de salón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas bajas de salón": [
    {
      "id": 4942,
      "keyword": "mesa baja de salón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pala de frontón": [
    {
      "id": 4946,
      "keyword": "pala de frontón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palas de frontón": [
    {
      "id": 4946,
      "keyword": "pala de frontón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesa de cocina": [
    {
      "id": 4943,
      "keyword": "mesa de cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas de cocina": [
    {
      "id": 4943,
      "keyword": "mesa de cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enjabonar la cara": [
    {
      "id": 6546,
      "keyword": "enjabonar la cara",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4939,
      "keyword": "enjabonar la cara",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28621,
      "keyword": "enjabonar la cara",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31991,
      "keyword": "enjabonar la cara",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lámpara de techo": [
    {
      "id": 4938,
      "keyword": "lámpara de techo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lámparas de techo": [
    {
      "id": 4938,
      "keyword": "lámpara de techo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "picar con punzón": [
    {
      "id": 4949,
      "keyword": "picar con punzón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pintura de dedos": [
    {
      "id": 4950,
      "keyword": "pintura de dedos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinturas de dedos": [
    {
      "id": 4950,
      "keyword": "pintura de dedos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pica de gimnasia": [
    {
      "id": 4948,
      "keyword": "pica de gimnasia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "picas de gimnasia": [
    {
      "id": 4948,
      "keyword": "pica de gimnasia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pica": [
    {
      "id": 4948,
      "keyword": "pica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "picas": [
    {
      "id": 4948,
      "keyword": "pica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palo de hockey": [
    {
      "id": 4947,
      "keyword": "palo de hockey",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24416,
      "keyword": "palo de hockey",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palos de hockey": [
    {
      "id": 4947,
      "keyword": "palo de hockey",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24416,
      "keyword": "palo de hockey",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesa de salón": [
    {
      "id": 4944,
      "keyword": "mesa de salón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas de salón": [
    {
      "id": 4944,
      "keyword": "mesa de salón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pollo asado": [
    {
      "id": 25343,
      "keyword": "pollo asado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4952,
      "keyword": "pollo asado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat",
        "core vocabulary",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24815,
      "keyword": "pollo asado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pollos asados": [
    {
      "id": 25343,
      "keyword": "pollo asado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4952,
      "keyword": "pollo asado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat",
        "core vocabulary",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24815,
      "keyword": "pollo asado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "osito": [
    {
      "id": 4945,
      "keyword": "osito",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ositos": [
    {
      "id": 4945,
      "keyword": "osito",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peluche": [
    {
      "id": 4945,
      "keyword": "peluche",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peluches": [
    {
      "id": 4945,
      "keyword": "peluche",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "osito de peluche": [
    {
      "id": 4945,
      "keyword": "osito de peluche",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ositos de peluche": [
    {
      "id": 4945,
      "keyword": "osito de peluche",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oso de peluche": [
    {
      "id": 4945,
      "keyword": "oso de peluche",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "osos de peluche": [
    {
      "id": 4945,
      "keyword": "oso de peluche",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "poner gomets": [
    {
      "id": 4953,
      "keyword": "poner gomets",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reproductor dvd": [
    {
      "id": 4957,
      "keyword": "reproductor dvd",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reproductores dvd": [
    {
      "id": 4957,
      "keyword": "reproductor dvd",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cono de señalización": [
    {
      "id": 4928,
      "keyword": "cono de señalización",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment",
        "movement",
        "traffic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conos de señalización": [
    {
      "id": 4928,
      "keyword": "cono de señalización",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment",
        "movement",
        "traffic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cono": [
    {
      "id": 9112,
      "keyword": "cono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4928,
      "keyword": "cono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment",
        "movement",
        "traffic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conos": [
    {
      "id": 9112,
      "keyword": "cono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4928,
      "keyword": "cono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment",
        "movement",
        "traffic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "semáforo rojo": [
    {
      "id": 37187,
      "keyword": "semáforo rojo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36223,
      "keyword": "semáforo rojo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36446,
      "keyword": "semáforo rojo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37106,
      "keyword": "semáforo rojo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37107,
      "keyword": "semáforo rojo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4959,
      "keyword": "semáforo rojo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "no cruzar con semáforo en rojo": [
    {
      "id": 37187,
      "keyword": "no cruzar con semáforo en rojo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4959,
      "keyword": "no cruzar con semáforo en rojo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "silla de salón": [
    {
      "id": 4961,
      "keyword": "silla de salón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas de salón": [
    {
      "id": 4961,
      "keyword": "silla de salón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hambriento": [
    {
      "id": 35579,
      "keyword": "hambriento",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31890,
      "keyword": "hambriento",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4962,
      "keyword": "hambriento",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hambrientos": [
    {
      "id": 35579,
      "keyword": "hambriento",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31890,
      "keyword": "hambriento",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4962,
      "keyword": "hambriento",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hambrienta": [
    {
      "id": 35579,
      "keyword": "hambrienta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35525,
      "keyword": "hambrienta",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4962,
      "keyword": "hambrienta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hambrientas": [
    {
      "id": 35579,
      "keyword": "hambrienta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35525,
      "keyword": "hambrienta",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4962,
      "keyword": "hambrienta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "profesora de taller": [
    {
      "id": 4956,
      "keyword": "profesora de taller",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "profesoras de taller": [
    {
      "id": 4956,
      "keyword": "profesora de taller",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silla de cocina": [
    {
      "id": 4960,
      "keyword": "silla de cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas de cocina": [
    {
      "id": 4960,
      "keyword": "silla de cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sediento": [
    {
      "id": 7273,
      "keyword": "sediento",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32140,
      "keyword": "sediento",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4963,
      "keyword": "sediento",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sedientos": [
    {
      "id": 7273,
      "keyword": "sediento",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32140,
      "keyword": "sediento",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4963,
      "keyword": "sediento",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sedienta": [
    {
      "id": 35523,
      "keyword": "sedienta",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4963,
      "keyword": "sedienta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sedientas": [
    {
      "id": 35523,
      "keyword": "sedienta",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4963,
      "keyword": "sedienta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tiza y borrador": [
    {
      "id": 4965,
      "keyword": "tiza y borrador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tizas y borradores": [
    {
      "id": 4965,
      "keyword": "tiza y borrador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pinturas de cera": [
    {
      "id": 4951,
      "keyword": "pinturas de cera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ceras": [
    {
      "id": 4951,
      "keyword": "ceras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortilla": [
    {
      "id": 4967,
      "keyword": "tortilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4966,
      "keyword": "tortilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortillas": [
    {
      "id": 4967,
      "keyword": "tortilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4966,
      "keyword": "tortilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tortilla francesa": [
    {
      "id": 4967,
      "keyword": "tortilla francesa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortillas francesas": [
    {
      "id": 4967,
      "keyword": "tortilla francesa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "profesora de música": [
    {
      "id": 4955,
      "keyword": "profesora de música",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "profesoras de música": [
    {
      "id": 4955,
      "keyword": "profesora de música",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tijera": [
    {
      "id": 6664,
      "keyword": "tijera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4964,
      "keyword": "tijera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortilla de patata": [
    {
      "id": 4966,
      "keyword": "tortilla de patata",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortillas de patata": [
    {
      "id": 4966,
      "keyword": "tortilla de patata",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tortilla española": [
    {
      "id": 4966,
      "keyword": "tortilla española",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortillas españolas": [
    {
      "id": 4966,
      "keyword": "tortilla española",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "árbol de otoño": [
    {
      "id": 5063,
      "keyword": "árbol de otoño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "autumn",
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "árboles de otoño": [
    {
      "id": 5063,
      "keyword": "árbol de otoño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "autumn",
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calcetín de papá noel": [
    {
      "id": 5065,
      "keyword": "calcetín de Papá Noel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calcetines de papá noel": [
    {
      "id": 5065,
      "keyword": "calcetín de Papá Noel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manija": [
    {
      "id": 5060,
      "keyword": "manija",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25219,
      "keyword": "manija",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25220,
      "keyword": "manija",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manijas": [
    {
      "id": 5060,
      "keyword": "manija",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25219,
      "keyword": "manija",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25220,
      "keyword": "manija",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manilla": [
    {
      "id": 5060,
      "keyword": "manilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25219,
      "keyword": "manilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25220,
      "keyword": "manilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manillas": [
    {
      "id": 5060,
      "keyword": "manilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25219,
      "keyword": "manilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25220,
      "keyword": "manilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tirador": [
    {
      "id": 5060,
      "keyword": "tirador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25219,
      "keyword": "tirador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25220,
      "keyword": "tirador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiradores": [
    {
      "id": 16901,
      "keyword": "tiradores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5060,
      "keyword": "tirador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25219,
      "keyword": "tirador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25220,
      "keyword": "tirador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bádminton": [
    {
      "id": 26658,
      "keyword": "bádminton",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event",
        "olympic games"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4969,
      "keyword": "bádminton",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "volante": [
    {
      "id": 6245,
      "keyword": "volante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4969,
      "keyword": "volante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "volantes": [
    {
      "id": 6245,
      "keyword": "volante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4969,
      "keyword": "volante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "volante de badminton": [
    {
      "id": 4969,
      "keyword": "volante de badminton",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "volantes de badminton": [
    {
      "id": 4969,
      "keyword": "volante de badminton",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "campo de balonmano": [
    {
      "id": 5067,
      "keyword": "campo de balonmano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campos de balonmano": [
    {
      "id": 5067,
      "keyword": "campo de balonmano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juegos olímpicos": [
    {
      "id": 5064,
      "keyword": "juegos olímpicos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aros olímpicos": [
    {
      "id": 5064,
      "keyword": "aros olímpicos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "olimpiada": [
    {
      "id": 5064,
      "keyword": "olimpiada",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "olimpiadas": [
    {
      "id": 5064,
      "keyword": "olimpiada",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "campo de baloncesto": [
    {
      "id": 5066,
      "keyword": "campo de baloncesto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "basketball",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campos de baloncesto": [
    {
      "id": 5066,
      "keyword": "campo de baloncesto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "basketball",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "campo de tenis": [
    {
      "id": 5068,
      "keyword": "campo de tenis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campos de tenis": [
    {
      "id": 5068,
      "keyword": "campo de tenis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pista de tenis": [
    {
      "id": 5068,
      "keyword": "pista de tenis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pistas de tenis": [
    {
      "id": 5068,
      "keyword": "pista de tenis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "árbol de invierno": [
    {
      "id": 5062,
      "keyword": "árbol de invierno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "winter",
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "árboles de invierno": [
    {
      "id": 5062,
      "keyword": "árbol de invierno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "winter",
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "año nuevo": [
    {
      "id": 32536,
      "keyword": "Año Nuevo",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "new year"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5071,
      "keyword": "Año Nuevo",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "new year"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "día de año nuevo": [
    {
      "id": 5071,
      "keyword": "Día de Año nuevo",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "new year"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coche de carreras": [
    {
      "id": 5070,
      "keyword": "coche de carreras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coches de carreras": [
    {
      "id": 5070,
      "keyword": "coche de carreras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bólido": [
    {
      "id": 5070,
      "keyword": "bólido",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bólidos": [
    {
      "id": 5070,
      "keyword": "bólido",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gafas de bucear": [
    {
      "id": 5074,
      "keyword": "gafas de bucear",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "diving",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lentes de buceo": [
    {
      "id": 5074,
      "keyword": "lentes de buceo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "diving",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hoja verde": [
    {
      "id": 5077,
      "keyword": "hoja verde",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 5077,
      "keyword": "hoja verde",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hojas verdes": [
    {
      "id": 5077,
      "keyword": "hoja verde",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 5077,
      "keyword": "hoja verde",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hoja marrón": [
    {
      "id": 5076,
      "keyword": "hoja marrón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hojas marrones": [
    {
      "id": 5076,
      "keyword": "hoja marrón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugador de baloncesto": [
    {
      "id": 5078,
      "keyword": "jugador de baloncesto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27292,
      "keyword": "jugador de baloncesto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadores de baloncesto": [
    {
      "id": 5078,
      "keyword": "jugador de baloncesto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "basketball"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27292,
      "keyword": "jugador de baloncesto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "basketball"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "semáforo verde": [
    {
      "id": 37188,
      "keyword": "semáforo verde",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36221,
      "keyword": "semáforo verde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36448,
      "keyword": "semáforo verde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37108,
      "keyword": "semáforo verde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37110,
      "keyword": "semáforo verde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4958,
      "keyword": "semáforo verde",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "semáforos verdes": [
    {
      "id": 37188,
      "keyword": "semáforo verde",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 4958,
      "keyword": "semáforo verde",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cruzar con semáforo en verde": [
    {
      "id": 37188,
      "keyword": "cruzar con semáforo en verde",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 4958,
      "keyword": "cruzar con semáforo en verde",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugador de balonmano": [
    {
      "id": 5079,
      "keyword": "jugador de balonmano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadores de balonmano": [
    {
      "id": 5079,
      "keyword": "jugador de balonmano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugador de hockey hielo": [
    {
      "id": 5080,
      "keyword": "jugador de hockey hielo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadores de hockey hielo": [
    {
      "id": 5080,
      "keyword": "jugador de hockey hielo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugador de hockey hierba": [
    {
      "id": 5081,
      "keyword": "jugador de hockey hierba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadores de hockey hierba": [
    {
      "id": 5081,
      "keyword": "jugador de hockey hierba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "campo de voleibol": [
    {
      "id": 5069,
      "keyword": "campo de voleibol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campos de voleibol": [
    {
      "id": 5069,
      "keyword": "campo de voleibol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "día del pilar": [
    {
      "id": 5073,
      "keyword": "Día del Pilar",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fiestas del pilar": [
    {
      "id": 5073,
      "keyword": "Fiestas del Pilar",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pista de esquí": [
    {
      "id": 5087,
      "keyword": "pista de esquí",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "winter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pistas de esquí": [
    {
      "id": 5087,
      "keyword": "pista de esquí",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "winter"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pista": [
    {
      "id": 5086,
      "keyword": "pista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5088,
      "keyword": "pista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5087,
      "keyword": "pista",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "winter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pistas": [
    {
      "id": 5086,
      "keyword": "pista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5088,
      "keyword": "pista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "skating"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5087,
      "keyword": "pista",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "winter"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estación de esquí": [
    {
      "id": 5087,
      "keyword": "estación de esquí",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "winter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estaciones de esquí": [
    {
      "id": 5087,
      "keyword": "estación de esquí",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "winter"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pista de atletismo": [
    {
      "id": 5086,
      "keyword": "pista de atletismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pistas de atletismo": [
    {
      "id": 5086,
      "keyword": "pista de atletismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pista de hielo": [
    {
      "id": 5088,
      "keyword": "pista de hielo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "skating"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pistas de hielo": [
    {
      "id": 5088,
      "keyword": "pista de hielo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "skating"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "belén": [
    {
      "id": 5089,
      "keyword": "belén",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "place",
        "christianity",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "belenes": [
    {
      "id": 5089,
      "keyword": "belén",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "place",
        "christianity",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "día de reyes": [
    {
      "id": 5072,
      "keyword": "Día de Reyes",
      "keywords": 3,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "christmas",
        "religious event",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "epifanía": [
    {
      "id": 5072,
      "keyword": "Epifanía",
      "keywords": 3,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "christmas",
        "religious event",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rocódromo": [
    {
      "id": 5090,
      "keyword": "rocódromo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37256,
      "keyword": "rocódromo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "recreational facility",
        "playground"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rocódromos": [
    {
      "id": 5090,
      "keyword": "rocódromo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37256,
      "keyword": "rocódromo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "recreational facility",
        "playground"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "moto de carreras": [
    {
      "id": 5084,
      "keyword": "moto de carreras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "motos de carreras": [
    {
      "id": 5084,
      "keyword": "moto de carreras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dólar": [
    {
      "id": 5091,
      "keyword": "dólar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "foreign currency",
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dólares": [
    {
      "id": 5091,
      "keyword": "dólar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "foreign currency",
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "$": [
    {
      "id": 5091,
      "keyword": "$",
      "keywords": 3,
      "type": 6,
      "tags": [
        "economy",
        "money",
        "foreign currency",
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "signo del dólar": [
    {
      "id": 5091,
      "keyword": "signo del dólar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "foreign currency",
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "euro": [
    {
      "id": 5092,
      "keyword": "euro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "foreign currency",
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "euros": [
    {
      "id": 5092,
      "keyword": "euro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "foreign currency",
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35165,
      "keyword": "euros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "foreign currency",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tanto por ciento": [
    {
      "id": 5093,
      "keyword": "tanto por ciento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tantos por ciento": [
    {
      "id": 5093,
      "keyword": "tanto por ciento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "%": [
    {
      "id": 5093,
      "keyword": "%",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tren de juguete": [
    {
      "id": 5094,
      "keyword": "tren de juguete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trenes de juguete": [
    {
      "id": 5094,
      "keyword": "tren de juguete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "levantar de la cama": [
    {
      "id": 5099,
      "keyword": "levantar de la cama",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34525,
      "keyword": "levantar de la cama",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almohadilla": [
    {
      "id": 5095,
      "keyword": "almohadilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almohadillas": [
    {
      "id": 5095,
      "keyword": "almohadilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "#": [
    {
      "id": 5095,
      "keyword": "#",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugador de voleibol": [
    {
      "id": 5082,
      "keyword": "jugador de voleibol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadores de voleibol": [
    {
      "id": 5082,
      "keyword": "jugador de voleibol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paquete de tabaco": [
    {
      "id": 5101,
      "keyword": "paquete de tabaco",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paquetes de tabaco": [
    {
      "id": 5101,
      "keyword": "paquete de tabaco",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tabaco": [
    {
      "id": 5101,
      "keyword": "tabaco",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tabacos": [
    {
      "id": 5101,
      "keyword": "tabaco",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jefe de estudios": [
    {
      "id": 34786,
      "keyword": "jefe de estudios",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5098,
      "keyword": "jefe de estudios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jefes de estudios": [
    {
      "id": 34786,
      "keyword": "jefe de estudios",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5098,
      "keyword": "jefe de estudios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trabajador social": [
    {
      "id": 37577,
      "keyword": "trabajador social",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5103,
      "keyword": "trabajador social",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trabajadores sociales": [
    {
      "id": 37577,
      "keyword": "trabajador social",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5103,
      "keyword": "trabajador social",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asistente social": [
    {
      "id": 37577,
      "keyword": "asistente social",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5103,
      "keyword": "asistente social",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asistentes sociales": [
    {
      "id": 37577,
      "keyword": "asistente social",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5103,
      "keyword": "asistente social",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "luces de navidad": [
    {
      "id": 5083,
      "keyword": "luces de Navidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trabajadora social": [
    {
      "id": 5104,
      "keyword": "trabajadora social",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trabajadoras sociales": [
    {
      "id": 5104,
      "keyword": "trabajadora social",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asistenta social": [
    {
      "id": 5104,
      "keyword": "asistenta social",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asistentas sociales": [
    {
      "id": 5104,
      "keyword": "asistenta social",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tren de la bruja": [
    {
      "id": 5105,
      "keyword": "tren de la bruja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trenes de la bruja": [
    {
      "id": 5105,
      "keyword": "tren de la bruja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "darse crema": [
    {
      "id": 5096,
      "keyword": "darse crema",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21585,
      "keyword": "darse crema",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jefa de estudios": [
    {
      "id": 34786,
      "keyword": "jefa de estudios",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5097,
      "keyword": "jefa de estudios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jefas de estudios": [
    {
      "id": 34786,
      "keyword": "jefa de estudios",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5097,
      "keyword": "jefa de estudios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abajo": [
    {
      "id": 5355,
      "keyword": "abajo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palas de playa": [
    {
      "id": 5100,
      "keyword": "palas de playa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rápido": [
    {
      "id": 37850,
      "keyword": "rápido",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physiology",
        "human physiology",
        "leisure",
        "sport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5306,
      "keyword": "rápido",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rápidos": [
    {
      "id": 37850,
      "keyword": "rápido",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physiology",
        "human physiology",
        "leisure",
        "sport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5306,
      "keyword": "rápido",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "veloz": [
    {
      "id": 37850,
      "keyword": "veloz",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physiology",
        "human physiology",
        "leisure",
        "sport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5306,
      "keyword": "veloz",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veloces": [
    {
      "id": 37850,
      "keyword": "veloz",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physiology",
        "human physiology",
        "leisure",
        "sport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5306,
      "keyword": "veloz",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pronto": [
    {
      "id": 5306,
      "keyword": "pronto",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "deprisa": [
    {
      "id": 5306,
      "keyword": "deprisa",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rápida": [
    {
      "id": 37850,
      "keyword": "rápida",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physiology",
        "human physiology",
        "leisure",
        "sport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5306,
      "keyword": "rápida",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rápidas": [
    {
      "id": 37850,
      "keyword": "rápida",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physiology",
        "human physiology",
        "leisure",
        "sport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5306,
      "keyword": "rápida",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ágil": [
    {
      "id": 5306,
      "keyword": "ágil",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ágiles": [
    {
      "id": 5306,
      "keyword": "ágil",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rápidamente": [
    {
      "id": 37850,
      "keyword": "rápidamente",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physiology",
        "human physiology",
        "leisure",
        "sport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5306,
      "keyword": "rápidamente",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "afeitar": [
    {
      "id": 6032,
      "keyword": "afeitar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5361,
      "keyword": "afeitar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37056,
      "keyword": "afeitar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terminar": [
    {
      "id": 5358,
      "keyword": "terminar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28429,
      "keyword": "terminar",
      "keywords": 8,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fin": [
    {
      "id": 5358,
      "keyword": "fin",
      "keywords": 5,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acabar": [
    {
      "id": 5358,
      "keyword": "acabar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28429,
      "keyword": "acabar",
      "keywords": 8,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "finalizar": [
    {
      "id": 5358,
      "keyword": "finalizar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28429,
      "keyword": "finalizar",
      "keywords": 8,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "final": [
    {
      "id": 5358,
      "keyword": "final",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "finales": [
    {
      "id": 5358,
      "keyword": "final",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aflojar": [
    {
      "id": 5363,
      "keyword": "aflojar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "afilar": [
    {
      "id": 5362,
      "keyword": "afilar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "afilado": [
    {
      "id": 5362,
      "keyword": "afilado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "afilados": [
    {
      "id": 5362,
      "keyword": "afilado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abrochar": [
    {
      "id": 5357,
      "keyword": "abrochar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5380,
      "keyword": "abrochar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32317,
      "keyword": "abrochar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32316,
      "keyword": "abrochar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abotonar": [
    {
      "id": 5357,
      "keyword": "abotonar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "áfrica": [
    {
      "id": 5364,
      "keyword": "África",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "continent",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abalorios": [
    {
      "id": 5356,
      "keyword": "abalorios",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "work",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8334,
      "keyword": "abalorio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "craftsmanship",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuentas": [
    {
      "id": 5739,
      "keyword": "cuenta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics",
        "education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5356,
      "keyword": "cuentas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "work",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5995,
      "keyword": "cuenta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8334,
      "keyword": "cuenta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "craftsmanship",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38971,
      "keyword": "cuenta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "building",
        "catering establishment",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38974,
      "keyword": "cuenta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "building",
        "catering establishment",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15517,
      "keyword": "cuenta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acercar": [
    {
      "id": 5359,
      "keyword": "acercar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6879,
      "keyword": "acercar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6878,
      "keyword": "acercar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aproximar": [
    {
      "id": 5359,
      "keyword": "aproximar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6879,
      "keyword": "aproximar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6878,
      "keyword": "aproximar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acuario": [
    {
      "id": 26618,
      "keyword": "acuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6882,
      "keyword": "acuario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing",
        "pet"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5360,
      "keyword": "acuario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acuarios": [
    {
      "id": 26618,
      "keyword": "acuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6882,
      "keyword": "acuario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing",
        "pet"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5360,
      "keyword": "acuario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pecera": [
    {
      "id": 6882,
      "keyword": "pecera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing",
        "pet"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5360,
      "keyword": "pecera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peceras": [
    {
      "id": 6882,
      "keyword": "pecera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing",
        "pet"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5360,
      "keyword": "pecera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "al lado de": [
    {
      "id": 5367,
      "keyword": "al lado de",
      "keywords": 7,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "junto a": [
    {
      "id": 5367,
      "keyword": "junto a",
      "keywords": 7,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "junto": [
    {
      "id": 5367,
      "keyword": "junto",
      "keywords": 7,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juntos": [
    {
      "id": 5367,
      "keyword": "junto",
      "keywords": 7,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ambos": [
    {
      "id": 5367,
      "keyword": "ambos",
      "keywords": 7,
      "type": 6,
      "tags": [
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conjunto": [
    {
      "id": 5367,
      "keyword": "conjunto",
      "keywords": 7,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conjuntos": [
    {
      "id": 5367,
      "keyword": "conjunto",
      "keywords": 7,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "junta": [
    {
      "id": 5367,
      "keyword": "junta",
      "keywords": 7,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juntas": [
    {
      "id": 5367,
      "keyword": "junta",
      "keywords": 7,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lado": [
    {
      "id": 5367,
      "keyword": "lado",
      "keywords": 7,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lados": [
    {
      "id": 5367,
      "keyword": "lado",
      "keywords": 7,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "albornoz": [
    {
      "id": 5369,
      "keyword": "albornoz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "albornoces": [
    {
      "id": 5369,
      "keyword": "albornoz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agitar": [
    {
      "id": 5365,
      "keyword": "agitar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ala": [
    {
      "id": 6890,
      "keyword": "ala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5368,
      "keyword": "ala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11169,
      "keyword": "ala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alas": [
    {
      "id": 6890,
      "keyword": "ala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5368,
      "keyword": "ala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11169,
      "keyword": "ala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ahogar": [
    {
      "id": 6037,
      "keyword": "ahogar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "swimming pool",
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean",
        "river"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11168,
      "keyword": "ahogar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5366,
      "keyword": "ahogar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "swimming pool",
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean",
        "river"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39423,
      "keyword": "ahogar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "swimming pool",
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean",
        "river"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11167,
      "keyword": "ahogar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31913,
      "keyword": "ahogar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36484,
      "keyword": "ahogar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alcachofa": [
    {
      "id": 5370,
      "keyword": "alcachofa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alcachofas": [
    {
      "id": 5370,
      "keyword": "alcachofa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alcaucil": [
    {
      "id": 5370,
      "keyword": "alcaucil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alcauciles": [
    {
      "id": 5370,
      "keyword": "alcaucil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "américa": [
    {
      "id": 5377,
      "keyword": "América",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "continent",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alrededor": [
    {
      "id": 5376,
      "keyword": "alrededor",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anguila": [
    {
      "id": 5378,
      "keyword": "anguila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anguilas": [
    {
      "id": 5378,
      "keyword": "anguila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apretar la tuerca": [
    {
      "id": 5381,
      "keyword": "apretar la tuerca",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aparcar": [
    {
      "id": 5379,
      "keyword": "aparcar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estacionar": [
    {
      "id": 5379,
      "keyword": "estacionar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrochar el cinturón": [
    {
      "id": 27566,
      "keyword": "abrochar el cinturón",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34669,
      "keyword": "abrochar el cinturón",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34691,
      "keyword": "abrochar el cinturón",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5380,
      "keyword": "abrochar el cinturón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32317,
      "keyword": "abrochar el cinturón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32316,
      "keyword": "abrochar el cinturón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34663,
      "keyword": "abrochar el cinturón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "algunos": [
    {
      "id": 11175,
      "keyword": "algunos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5374,
      "keyword": "algunos",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alguna": [
    {
      "id": 5374,
      "keyword": "alguna",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alguno": [
    {
      "id": 5374,
      "keyword": "alguno",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "algún": [
    {
      "id": 5374,
      "keyword": "algún",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "varios": [
    {
      "id": 11175,
      "keyword": "varios",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5374,
      "keyword": "varios",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "varias": [
    {
      "id": 5374,
      "keyword": "varias",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "algunas": [
    {
      "id": 5374,
      "keyword": "algunas",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ahí": [
    {
      "id": 5375,
      "keyword": "ahí",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "allí": [
    {
      "id": 5375,
      "keyword": "allí",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "allá": [
    {
      "id": 5375,
      "keyword": "allá",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aquí": [
    {
      "id": 5382,
      "keyword": "aquí",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acá": [
    {
      "id": 5382,
      "keyword": "acá",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aragón": [
    {
      "id": 5384,
      "keyword": "Aragón",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region",
        "Aragon"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5383,
      "keyword": "Aragón",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region",
        "Aragon"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5608,
      "keyword": "Aragón",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region",
        "Aragon"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5610,
      "keyword": "Aragón",
      "keywords": 4,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region",
        "Aragon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arquero": [
    {
      "id": 5387,
      "keyword": "arquero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "event",
        "sport event",
        "olympic games"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9015,
      "keyword": "arquero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "person",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arqueros": [
    {
      "id": 5387,
      "keyword": "arquero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "event",
        "sport event",
        "olympic games"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9015,
      "keyword": "arquero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "person",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asado": [
    {
      "id": 5389,
      "keyword": "asado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asados": [
    {
      "id": 5389,
      "keyword": "asado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asia": [
    {
      "id": 5390,
      "keyword": "Asia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "continent",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alergia": [
    {
      "id": 36071,
      "keyword": "alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39432,
      "keyword": "alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5372,
      "keyword": "alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31662,
      "keyword": "alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31823,
      "keyword": "alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31987,
      "keyword": "alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35957,
      "keyword": "alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alergias": [
    {
      "id": 36071,
      "keyword": "alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39432,
      "keyword": "alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5372,
      "keyword": "alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31662,
      "keyword": "alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31823,
      "keyword": "alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31987,
      "keyword": "alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35957,
      "keyword": "alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "azucarar": [
    {
      "id": 5392,
      "keyword": "azucarar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alejar": [
    {
      "id": 36107,
      "keyword": "alejar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5371,
      "keyword": "alejar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6894,
      "keyword": "alejar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "basic concepts",
        "character",
        "book character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6893,
      "keyword": "alejar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32154,
      "keyword": "alejar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "distanciar": [
    {
      "id": 5371,
      "keyword": "distanciar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6894,
      "keyword": "distanciar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "basic concepts",
        "character",
        "book character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6893,
      "keyword": "distanciar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32154,
      "keyword": "distanciar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "separar": [
    {
      "id": 5371,
      "keyword": "separar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6894,
      "keyword": "separar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "basic concepts",
        "character",
        "book character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27070,
      "keyword": "separar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6893,
      "keyword": "separar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27069,
      "keyword": "separar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32154,
      "keyword": "separar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anudar": [
    {
      "id": 5391,
      "keyword": "anudar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atar": [
    {
      "id": 39212,
      "keyword": "atar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32276,
      "keyword": "atar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5391,
      "keyword": "atar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "amarrar": [
    {
      "id": 32276,
      "keyword": "amarrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5391,
      "keyword": "amarrar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arandela": [
    {
      "id": 5385,
      "keyword": "arandela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arandelas": [
    {
      "id": 5385,
      "keyword": "arandela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barbacoa": [
    {
      "id": 5393,
      "keyword": "barbacoa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36039,
      "keyword": "barbacoa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barbacoas": [
    {
      "id": 5393,
      "keyword": "barbacoa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36039,
      "keyword": "barbacoa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "baturra": [
    {
      "id": 5395,
      "keyword": "baturra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "dance",
        "regional dance",
        "show",
        "Aragon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baturras": [
    {
      "id": 5395,
      "keyword": "baturra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "dance",
        "regional dance",
        "show",
        "Aragon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jotera": [
    {
      "id": 36644,
      "keyword": "jotera",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5395,
      "keyword": "jotera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "dance",
        "regional dance",
        "show",
        "Aragon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "joteras": [
    {
      "id": 36644,
      "keyword": "jotera",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5395,
      "keyword": "jotera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "dance",
        "regional dance",
        "show",
        "Aragon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolsa de ganchitos": [
    {
      "id": 5399,
      "keyword": "bolsa de ganchitos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas de ganchitos": [
    {
      "id": 5399,
      "keyword": "bolsa de ganchitos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ganchitos": [
    {
      "id": 5399,
      "keyword": "ganchitos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "billar": [
    {
      "id": 21951,
      "keyword": "billar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35267,
      "keyword": "billar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5398,
      "keyword": "billar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "billares": [
    {
      "id": 21951,
      "keyword": "billar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35267,
      "keyword": "billar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5398,
      "keyword": "billar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesa de billar": [
    {
      "id": 5398,
      "keyword": "mesa de billar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas de billar": [
    {
      "id": 5398,
      "keyword": "mesa de billar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "broncear": [
    {
      "id": 26500,
      "keyword": "broncear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5402,
      "keyword": "broncear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26499,
      "keyword": "broncear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomar el sol": [
    {
      "id": 26500,
      "keyword": "tomar el sol",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5402,
      "keyword": "tomar el sol",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26499,
      "keyword": "tomar el sol",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "basílica": [
    {
      "id": 5394,
      "keyword": "basílica",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "building",
        "religion",
        "event",
        "popular event",
        "fiestas del pilar",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "basílicas": [
    {
      "id": 5394,
      "keyword": "basílica",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "building",
        "religion",
        "event",
        "popular event",
        "fiestas del pilar",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "basílica del pilar": [
    {
      "id": 5394,
      "keyword": "Basílica del Pilar",
      "keywords": 4,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "building",
        "religion",
        "event",
        "popular event",
        "fiestas del pilar",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pilar": [
    {
      "id": 5606,
      "keyword": "Pilar",
      "keywords": 3,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "christianity",
        "event",
        "popular event",
        "fiestas del pilar",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5394,
      "keyword": "Pilar",
      "keywords": 4,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "building",
        "religion",
        "event",
        "popular event",
        "fiestas del pilar",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "el pilar": [
    {
      "id": 5394,
      "keyword": "el Pilar",
      "keywords": 4,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "building",
        "religion",
        "event",
        "popular event",
        "fiestas del pilar",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baturro": [
    {
      "id": 5396,
      "keyword": "baturro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "regional dance",
        "show",
        "Aragon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baturros": [
    {
      "id": 5396,
      "keyword": "baturro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "regional dance",
        "show",
        "Aragon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jotero": [
    {
      "id": 36645,
      "keyword": "jotero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "regional dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5396,
      "keyword": "jotero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "regional dance",
        "show",
        "Aragon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "joteros": [
    {
      "id": 36645,
      "keyword": "jotero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "regional dance",
        "show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36646,
      "keyword": "joteros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "regional dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5396,
      "keyword": "jotero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "regional dance",
        "show",
        "Aragon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bronquitis": [
    {
      "id": 5403,
      "keyword": "bronquitis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37736,
      "keyword": "bronquitis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bruja": [
    {
      "id": 5404,
      "keyword": "bruja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature",
        "event",
        "popular event",
        "halloween",
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brujas": [
    {
      "id": 5404,
      "keyword": "bruja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature",
        "event",
        "popular event",
        "halloween",
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bufón": [
    {
      "id": 5405,
      "keyword": "bufón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bufones": [
    {
      "id": 5405,
      "keyword": "bufón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bien": [
    {
      "id": 5397,
      "keyword": "bien",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of manner",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 5397,
      "keyword": "bien",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of manner",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cabezudo": [
    {
      "id": 8300,
      "keyword": "cabezudo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5410,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5411,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5412,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5413,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5414,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5409,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5407,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5415,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5461,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36175,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36173,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cabezudos": [
    {
      "id": 5416,
      "keyword": "cabezudos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8300,
      "keyword": "cabezudo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5410,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5411,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5412,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5413,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5414,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5409,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5407,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5415,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5461,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36175,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36173,
      "keyword": "cabezudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "forano": [
    {
      "id": 5410,
      "keyword": "Forano",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bota": [
    {
      "id": 8299,
      "keyword": "bota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5401,
      "keyword": "bota",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36503,
      "keyword": "bota",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bota de vino": [
    {
      "id": 5401,
      "keyword": "bota de vino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botas de vino": [
    {
      "id": 5401,
      "keyword": "bota de vino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arriba": [
    {
      "id": 5388,
      "keyword": "arriba",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "morico": [
    {
      "id": 5411,
      "keyword": "Morico",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pilara": [
    {
      "id": 5412,
      "keyword": "Pilara",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "robaculeros": [
    {
      "id": 5413,
      "keyword": "Robaculeros",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torero": [
    {
      "id": 5597,
      "keyword": "torero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "bullfighting"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5414,
      "keyword": "Torero",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "forana": [
    {
      "id": 5409,
      "keyword": "Forana",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "berrugón": [
    {
      "id": 5407,
      "keyword": "Berrugón",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsa de fritos": [
    {
      "id": 5400,
      "keyword": "bolsa de fritos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas de fritos": [
    {
      "id": 5400,
      "keyword": "bolsa de fritos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolsa de patatas fritas": [
    {
      "id": 5400,
      "keyword": "bolsa de patatas fritas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas de patatas fritas": [
    {
      "id": 5400,
      "keyword": "bolsa de patatas fritas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caballero": [
    {
      "id": 5406,
      "keyword": "caballero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "book character",
        "literature",
        "middle ages"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caballeros": [
    {
      "id": 5406,
      "keyword": "caballero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "book character",
        "literature",
        "middle ages"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "armadura": [
    {
      "id": 5406,
      "keyword": "armadura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "book character",
        "literature",
        "middle ages"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "armaduras": [
    {
      "id": 5406,
      "keyword": "armadura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "book character",
        "literature",
        "middle ages"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calvo": [
    {
      "id": 5420,
      "keyword": "calvo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calvos": [
    {
      "id": 5420,
      "keyword": "calvo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calva": [
    {
      "id": 5420,
      "keyword": "calva",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calvas": [
    {
      "id": 5420,
      "keyword": "calva",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pañuelo": [
    {
      "id": 33046,
      "keyword": "pañuelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17288,
      "keyword": "pañuelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary",
        "clothes"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 17288,
      "keyword": "pañuelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17233,
      "keyword": "pañuelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17284,
      "keyword": "pañuelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5417,
      "keyword": "pañuelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "event",
        "popular event",
        "fiestas del pilar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pañuelos": [
    {
      "id": 33046,
      "keyword": "pañuelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 17288,
      "keyword": "pañuelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary",
        "clothes"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 17288,
      "keyword": "pañuelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "core vocabulary",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8647,
      "keyword": "pañuelos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17233,
      "keyword": "pañuelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 17284,
      "keyword": "pañuelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5417,
      "keyword": "pañuelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "event",
        "popular event",
        "fiestas del pilar"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cachirulo": [
    {
      "id": 5417,
      "keyword": "cachirulo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "event",
        "popular event",
        "fiestas del pilar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cachirulos": [
    {
      "id": 5417,
      "keyword": "cachirulo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "event",
        "popular event",
        "fiestas del pilar"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calculadora": [
    {
      "id": 5419,
      "keyword": "calculadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calculadoras": [
    {
      "id": 5419,
      "keyword": "calculadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "castillo": [
    {
      "id": 5950,
      "keyword": "castillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "literature",
        "history"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5422,
      "keyword": "castillo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "Aragon",
        "Huesca"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25411,
      "keyword": "castillo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5421,
      "keyword": "castillo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "castillos": [
    {
      "id": 5950,
      "keyword": "castillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "literature",
        "history"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5422,
      "keyword": "castillo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "Aragon",
        "Huesca"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25411,
      "keyword": "castillo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5421,
      "keyword": "castillo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "castillo de la aljafería": [
    {
      "id": 5421,
      "keyword": "Castillo de la Aljafería",
      "keywords": 4,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alfajería": [
    {
      "id": 5421,
      "keyword": "Alfajería",
      "keywords": 4,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortes de aragón": [
    {
      "id": 5421,
      "keyword": "Cortes de Aragón",
      "keywords": 4,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centro": [
    {
      "id": 5424,
      "keyword": "centro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15748,
      "keyword": "centro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros": [
    {
      "id": 5424,
      "keyword": "centro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15748,
      "keyword": "centro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "catedral de la seo": [
    {
      "id": 5423,
      "keyword": "Catedral de la Seo",
      "keywords": 3,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "building",
        "religion",
        "christianity",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "catedral": [
    {
      "id": 5423,
      "keyword": "catedral",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "building",
        "religion",
        "christianity",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "catedrales": [
    {
      "id": 5423,
      "keyword": "catedral",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "building",
        "religion",
        "christianity",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "la seo": [
    {
      "id": 5423,
      "keyword": "La Seo",
      "keywords": 3,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "building",
        "religion",
        "christianity",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cicatriz": [
    {
      "id": 5428,
      "keyword": "cicatriz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32144,
      "keyword": "cicatriz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cicatrices": [
    {
      "id": 5428,
      "keyword": "cicatriz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32144,
      "keyword": "cicatriz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tuerto": [
    {
      "id": 5415,
      "keyword": "Tuerto",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "castillo de loarre": [
    {
      "id": 5422,
      "keyword": "Castillo de Loarre",
      "keywords": 3,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "Aragon",
        "Huesca"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "loarre": [
    {
      "id": 5422,
      "keyword": "Loarre",
      "keywords": 3,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "Aragon",
        "Huesca"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "columpiar": [
    {
      "id": 6455,
      "keyword": "columpiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37720,
      "keyword": "columpiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5430,
      "keyword": "columpiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37014,
      "keyword": "columpiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coleta": [
    {
      "id": 5429,
      "keyword": "coleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coletas": [
    {
      "id": 5429,
      "keyword": "coleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chichón": [
    {
      "id": 5427,
      "keyword": "chichón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chichones": [
    {
      "id": 5427,
      "keyword": "chichón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "debajo": [
    {
      "id": 5437,
      "keyword": "debajo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comenzar": [
    {
      "id": 5431,
      "keyword": "comenzar",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empezar": [
    {
      "id": 5431,
      "keyword": "empezar",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "iniciar": [
    {
      "id": 5431,
      "keyword": "iniciar",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "principio": [
    {
      "id": 5431,
      "keyword": "principio",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "principios": [
    {
      "id": 5431,
      "keyword": "principio",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38146,
      "keyword": "principios",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inicio": [
    {
      "id": 5431,
      "keyword": "inicio",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9861,
      "keyword": "inicio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inicios": [
    {
      "id": 5431,
      "keyword": "inicio",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9861,
      "keyword": "inicio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comienzo": [
    {
      "id": 5431,
      "keyword": "comienzo",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comienzos": [
    {
      "id": 5431,
      "keyword": "comienzo",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "delante": [
    {
      "id": 5438,
      "keyword": "delante",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "1/4": [
    {
      "id": 5436,
      "keyword": "1/4",
      "keywords": 3,
      "type": 6,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuarto": [
    {
      "id": 34475,
      "keyword": "cuarto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37750,
      "keyword": "cuarto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5436,
      "keyword": "cuarto",
      "keywords": 3,
      "type": 4,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15549,
      "keyword": "cuarto",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuartos": [
    {
      "id": 34475,
      "keyword": "cuarto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37750,
      "keyword": "cuarto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5436,
      "keyword": "cuarto",
      "keywords": 3,
      "type": 4,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15549,
      "keyword": "cuarto",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "un cuarto": [
    {
      "id": 5436,
      "keyword": "un cuarto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dentro": [
    {
      "id": 5439,
      "keyword": "dentro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contenido": [
    {
      "id": 5439,
      "keyword": "contenido",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contenidos": [
    {
      "id": 5439,
      "keyword": "contenido",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desabrochar": [
    {
      "id": 32321,
      "keyword": "desabrochar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32320,
      "keyword": "desabrochar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5440,
      "keyword": "desabrochar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desabotonar": [
    {
      "id": 5440,
      "keyword": "desabotonar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calamar": [
    {
      "id": 5418,
      "keyword": "calamar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cepillar": [
    {
      "id": 5425,
      "keyword": "cepillar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39427,
      "keyword": "cepillar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "costillas": [
    {
      "id": 28223,
      "keyword": "costillas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5433,
      "keyword": "costillas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7000,
      "keyword": "costilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7001,
      "keyword": "costilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24811,
      "keyword": "costilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24813,
      "keyword": "costillas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "detrás": [
    {
      "id": 5443,
      "keyword": "detrás",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ebro": [
    {
      "id": 5446,
      "keyword": "Ebro",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "río ebro": [
    {
      "id": 5446,
      "keyword": "río Ebro",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "echar": [
    {
      "id": 8998,
      "keyword": "echar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5447,
      "keyword": "echar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8997,
      "keyword": "echar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39037,
      "keyword": "echar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39039,
      "keyword": "echar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39040,
      "keyword": "echar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "en medio": [
    {
      "id": 5449,
      "keyword": "en medio",
      "keywords": 1,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32007,
      "keyword": "en medio",
      "keywords": 1,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gnomo": [
    {
      "id": 5450,
      "keyword": "gnomo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gnomos": [
    {
      "id": 5450,
      "keyword": "gnomo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enano": [
    {
      "id": 5450,
      "keyword": "enano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enanos": [
    {
      "id": 5450,
      "keyword": "enano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "echar gasolina": [
    {
      "id": 5448,
      "keyword": "echar gasolina",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "repostar": [
    {
      "id": 5448,
      "keyword": "repostar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "duende": [
    {
      "id": 5445,
      "keyword": "duende",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "duendes": [
    {
      "id": 5445,
      "keyword": "duende",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encima": [
    {
      "id": 5451,
      "keyword": "encima",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ensartar": [
    {
      "id": 5454,
      "keyword": "ensartar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6490,
      "keyword": "ensartar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36390,
      "keyword": "ensartar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "endibia": [
    {
      "id": 5452,
      "keyword": "endibia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "endibias": [
    {
      "id": 5452,
      "keyword": "endibia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "entero": [
    {
      "id": 5455,
      "keyword": "entero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enteros": [
    {
      "id": 5455,
      "keyword": "entero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "4/4": [
    {
      "id": 5455,
      "keyword": "4/4",
      "keywords": 2,
      "type": 6,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desmayo": [
    {
      "id": 5442,
      "keyword": "desmayo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36520,
      "keyword": "desmayo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desmayos": [
    {
      "id": 5442,
      "keyword": "desmayo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36520,
      "keyword": "desmayo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desmayar": [
    {
      "id": 37523,
      "keyword": "desmayar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5442,
      "keyword": "desmayar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36520,
      "keyword": "desmayar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desmayarse": [
    {
      "id": 5442,
      "keyword": "desmayarse",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36520,
      "keyword": "desmayarse",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escamas": [
    {
      "id": 5456,
      "keyword": "escamas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7085,
      "keyword": "escamas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39214,
      "keyword": "escamas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espina": [
    {
      "id": 5459,
      "keyword": "espina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39007,
      "keyword": "espina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espinas": [
    {
      "id": 5459,
      "keyword": "espina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39007,
      "keyword": "espina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "querer": [
    {
      "id": 6600,
      "keyword": "querer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "person"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 6600,
      "keyword": "querer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11536,
      "keyword": "querer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "core vocabulary",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11538,
      "keyword": "querer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "core vocabulary",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36518,
      "keyword": "querer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "object",
        "feeding",
        "movement",
        "traffic",
        "mode of transport",
        "education",
        "educational material",
        "leisure",
        "sport",
        "sport material",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31141,
      "keyword": "querer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5441,
      "keyword": "querer",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "psychology",
        "human response",
        "feeding",
        "movement",
        "traffic",
        "mode of transport",
        "education",
        "educational material",
        "leisure",
        "sport",
        "sport material",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desear": [
    {
      "id": 32816,
      "keyword": "desear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36518,
      "keyword": "desear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "object",
        "feeding",
        "movement",
        "traffic",
        "mode of transport",
        "education",
        "educational material",
        "leisure",
        "sport",
        "sport material",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31141,
      "keyword": "desear",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5441,
      "keyword": "desear",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "psychology",
        "human response",
        "feeding",
        "movement",
        "traffic",
        "mode of transport",
        "education",
        "educational material",
        "leisure",
        "sport",
        "sport material",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pedir": [
    {
      "id": 31141,
      "keyword": "pedir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16843,
      "keyword": "pedir",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37822,
      "keyword": "pedir",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5441,
      "keyword": "pedir",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "psychology",
        "human response",
        "feeding",
        "movement",
        "traffic",
        "mode of transport",
        "education",
        "educational material",
        "leisure",
        "sport",
        "sport material",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11251,
      "keyword": "pedir",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yo quiero": [
    {
      "id": 5441,
      "keyword": "yo quiero",
      "keywords": 4,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "psychology",
        "human response",
        "feeding",
        "movement",
        "traffic",
        "mode of transport",
        "education",
        "educational material",
        "leisure",
        "sport",
        "sport material",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "correo electrónico": [
    {
      "id": 32540,
      "keyword": "correo electrónico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "computing",
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27355,
      "keyword": "correo electrónico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5432,
      "keyword": "correo electrónico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "correos electrónicos": [
    {
      "id": 32540,
      "keyword": "correo electrónico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "computing",
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27355,
      "keyword": "correo electrónico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5432,
      "keyword": "correo electrónico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escayola": [
    {
      "id": 5457,
      "keyword": "escayola",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escayolas": [
    {
      "id": 5457,
      "keyword": "escayola",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escayolado": [
    {
      "id": 5457,
      "keyword": "escayolado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escayolados": [
    {
      "id": 5457,
      "keyword": "escayolado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "yeso": [
    {
      "id": 5457,
      "keyword": "yeso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yesos": [
    {
      "id": 5457,
      "keyword": "yeso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enhebrar": [
    {
      "id": 5453,
      "keyword": "enhebrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6489,
      "keyword": "enhebrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esquina": [
    {
      "id": 38985,
      "keyword": "esquina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5463,
      "keyword": "esquina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esquinas": [
    {
      "id": 38985,
      "keyword": "esquina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5463,
      "keyword": "esquina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estar": [
    {
      "id": 5466,
      "keyword": "estar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "object",
        "feeding",
        "food",
        "movement",
        "traffic",
        "mode of transport",
        "education",
        "educational material",
        "leisure",
        "sport",
        "sport material",
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36392,
      "keyword": "estar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "character",
        "book character",
        "literature",
        "health",
        "medicine",
        "professional",
        "religion",
        "person",
        "leader",
        "work",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5465,
      "keyword": "estar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "europa": [
    {
      "id": 5468,
      "keyword": "Europa",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "continent"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8117,
      "keyword": "Europa",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boticario": [
    {
      "id": 5461,
      "keyword": "Boticario",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estofado": [
    {
      "id": 5467,
      "keyword": "estofado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estofados": [
    {
      "id": 5467,
      "keyword": "estofado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guiso de carne": [
    {
      "id": 5467,
      "keyword": "guiso de carne",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guisos de carne": [
    {
      "id": 5467,
      "keyword": "guiso de carne",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fantasma": [
    {
      "id": 5469,
      "keyword": "fantasma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature",
        "event",
        "popular event",
        "halloween",
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fantasmas": [
    {
      "id": 5469,
      "keyword": "fantasma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature",
        "event",
        "popular event",
        "halloween",
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espinacas": [
    {
      "id": 5460,
      "keyword": "espinacas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8311,
      "keyword": "espinaca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fiebre": [
    {
      "id": 32530,
      "keyword": "fiebre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5470,
      "keyword": "fiebre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28729,
      "keyword": "fiebre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fiebres": [
    {
      "id": 32530,
      "keyword": "fiebre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5470,
      "keyword": "fiebre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28729,
      "keyword": "fiebre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fuegos artificiales": [
    {
      "id": 5474,
      "keyword": "fuegos artificiales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flecha": [
    {
      "id": 5471,
      "keyword": "flecha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flechas": [
    {
      "id": 5471,
      "keyword": "flecha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "formón": [
    {
      "id": 5472,
      "keyword": "formón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "formones": [
    {
      "id": 5472,
      "keyword": "formón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gaita de boto": [
    {
      "id": 5476,
      "keyword": "gaita de boto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gaitas de boto": [
    {
      "id": 5476,
      "keyword": "gaita de boto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "garra": [
    {
      "id": 5477,
      "keyword": "garra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27787,
      "keyword": "garra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27786,
      "keyword": "garra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "garras": [
    {
      "id": 5477,
      "keyword": "garra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27787,
      "keyword": "garra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27786,
      "keyword": "garra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gigantes": [
    {
      "id": 5478,
      "keyword": "gigantes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8375,
      "keyword": "gigante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11273,
      "keyword": "gigante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fuera": [
    {
      "id": 5475,
      "keyword": "fuera",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hada": [
    {
      "id": 5482,
      "keyword": "hada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8131,
      "keyword": "hada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26118,
      "keyword": "hada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hadas": [
    {
      "id": 5482,
      "keyword": "hada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8131,
      "keyword": "hada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26118,
      "keyword": "hada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hervir": [
    {
      "id": 5485,
      "keyword": "hervir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hilvanar": [
    {
      "id": 5486,
      "keyword": "hilvanar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hornear": [
    {
      "id": 5487,
      "keyword": "hornear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cosquillas": [
    {
      "id": 5480,
      "keyword": "cosquillas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27833,
      "keyword": "cosquillas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer cosquillas": [
    {
      "id": 5480,
      "keyword": "hacer cosquillas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27833,
      "keyword": "hacer cosquillas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huesca": [
    {
      "id": 5488,
      "keyword": "Huesca",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14680,
      "keyword": "Huesca",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38923,
      "keyword": "Huesca",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "Aragon",
        "Huesca"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "herida": [
    {
      "id": 5484,
      "keyword": "herida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "heridas": [
    {
      "id": 5484,
      "keyword": "herida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "corte": [
    {
      "id": 5484,
      "keyword": "corte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortes": [
    {
      "id": 5484,
      "keyword": "corte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "heladero": [
    {
      "id": 5483,
      "keyword": "heladero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "heladeros": [
    {
      "id": 5483,
      "keyword": "heladero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ingletadora": [
    {
      "id": 5491,
      "keyword": "ingletadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ingletadoras": [
    {
      "id": 5491,
      "keyword": "ingletadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gripe": [
    {
      "id": 5479,
      "keyword": "gripe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28749,
      "keyword": "gripe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gripes": [
    {
      "id": 5479,
      "keyword": "gripe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28749,
      "keyword": "gripe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "internet": [
    {
      "id": 37366,
      "keyword": "internet",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5492,
      "keyword": "internet",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavar la ropa": [
    {
      "id": 5496,
      "keyword": "lavar la ropa",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavar": [
    {
      "id": 34826,
      "keyword": "lavar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8977,
      "keyword": "lavar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5496,
      "keyword": "lavar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer la cama": [
    {
      "id": 16711,
      "keyword": "hacer la cama",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5481,
      "keyword": "hacer la cama",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35727,
      "keyword": "hacer la cama",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jota": [
    {
      "id": 5495,
      "keyword": "jota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "regional dance",
        "show",
        "event",
        "popular event",
        "fiestas del pilar",
        "Aragon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jotas": [
    {
      "id": 5495,
      "keyword": "jota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "regional dance",
        "show",
        "event",
        "popular event",
        "fiestas del pilar",
        "Aragon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "infarto": [
    {
      "id": 5490,
      "keyword": "infarto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "infartos": [
    {
      "id": 5490,
      "keyword": "infarto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "invierno": [
    {
      "id": 5493,
      "keyword": "invierno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "season",
        "winter",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inviernos": [
    {
      "id": 5493,
      "keyword": "invierno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "season",
        "winter",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lija": [
    {
      "id": 5498,
      "keyword": "lija",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lijas": [
    {
      "id": 5498,
      "keyword": "lija",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lijadora": [
    {
      "id": 5499,
      "keyword": "lijadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lijadoras": [
    {
      "id": 5499,
      "keyword": "lijadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lijadora eléctrica": [
    {
      "id": 5499,
      "keyword": "lijadora eléctrica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lijadoras eléctricas": [
    {
      "id": 5499,
      "keyword": "lijadora eléctrica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jaula": [
    {
      "id": 7136,
      "keyword": "jaula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16097,
      "keyword": "jaula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5494,
      "keyword": "jaula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jaulas": [
    {
      "id": 7136,
      "keyword": "jaula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16097,
      "keyword": "jaula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5494,
      "keyword": "jaula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "limar": [
    {
      "id": 5502,
      "keyword": "limar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10169,
      "keyword": "limar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36553,
      "keyword": "limar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "los amantes": [
    {
      "id": 5503,
      "keyword": "Los Amantes",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "Aragon",
        "Teruel"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mal": [
    {
      "id": 5504,
      "keyword": "mal",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of manner",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 5504,
      "keyword": "mal",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of manner",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mapa": [
    {
      "id": 5505,
      "keyword": "mapa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "political geography"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24161,
      "keyword": "mapa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "geography",
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mapas": [
    {
      "id": 5505,
      "keyword": "mapa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "political geography"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24161,
      "keyword": "mapa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "geography",
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "marcar patrón": [
    {
      "id": 5506,
      "keyword": "marcar patrón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medir": [
    {
      "id": 33100,
      "keyword": "medir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "human body"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5510,
      "keyword": "medir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38712,
      "keyword": "medir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38718,
      "keyword": "medir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "human body"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mayonesa": [
    {
      "id": 5509,
      "keyword": "mayonesa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product",
        "ultra-processed food",
        "condiment",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mayonesas": [
    {
      "id": 5509,
      "keyword": "mayonesa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product",
        "ultra-processed food",
        "condiment",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mahonesa": [
    {
      "id": 5509,
      "keyword": "mahonesa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product",
        "ultra-processed food",
        "condiment",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mahonesas": [
    {
      "id": 5509,
      "keyword": "mahonesa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product",
        "ultra-processed food",
        "condiment",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lijar": [
    {
      "id": 5500,
      "keyword": "lijar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guardar": [
    {
      "id": 5514,
      "keyword": "guardar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recoger": [
    {
      "id": 32663,
      "keyword": "recoger",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5514,
      "keyword": "recoger",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meter": [
    {
      "id": 5514,
      "keyword": "meter",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dos cuartos": [
    {
      "id": 5516,
      "keyword": "dos cuartos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "2/4": [
    {
      "id": 5516,
      "keyword": "2/4",
      "keywords": 2,
      "type": 6,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "menestra": [
    {
      "id": 5511,
      "keyword": "menestra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "menestras": [
    {
      "id": 5511,
      "keyword": "menestra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "menos": [
    {
      "id": 26915,
      "keyword": "menos",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5512,
      "keyword": "menos",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "montar en bici": [
    {
      "id": 6045,
      "keyword": "montar en bici",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "leisure",
        "outdoor activity",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "health",
        "lifestyle",
        "healthy habit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36945,
      "keyword": "montar en bici",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5517,
      "keyword": "montar en bici",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monasterio de san juan de la peña": [
    {
      "id": 5519,
      "keyword": "Monasterio de San Juan de la Peña",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "religion",
        "christianity",
        "Aragon",
        "Huesca"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monasterio de piedra": [
    {
      "id": 5518,
      "keyword": "Monasterio de Piedra",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "geography",
        "physical geography",
        "landform",
        "river",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "menú": [
    {
      "id": 32514,
      "keyword": "menú",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector",
        "hospitality industry",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5513,
      "keyword": "menú",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34221,
      "keyword": "menú",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "menús": [
    {
      "id": 32514,
      "keyword": "menú",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector",
        "hospitality industry",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5513,
      "keyword": "menú",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34221,
      "keyword": "menú",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "marino": [
    {
      "id": 5507,
      "keyword": "marino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marinos": [
    {
      "id": 5507,
      "keyword": "marino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "moncayo": [
    {
      "id": 5520,
      "keyword": "Moncayo",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "negar": [
    {
      "id": 39149,
      "keyword": "negar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of denial"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5525,
      "keyword": "negar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31859,
      "keyword": "negar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34341,
      "keyword": "negar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nata": [
    {
      "id": 5523,
      "keyword": "nata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "natas": [
    {
      "id": 5523,
      "keyword": "nata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mezclar": [
    {
      "id": 5515,
      "keyword": "mezclar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7162,
      "keyword": "mezclar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "persona indígena de américa": [
    {
      "id": 6137,
      "keyword": "persona indígena de América",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6153,
      "keyword": "persona indígena de América",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5489,
      "keyword": "persona indígena de América",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "character",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10339,
      "keyword": "persona indígena de América",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "character",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "indio": [
    {
      "id": 5489,
      "keyword": "indio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "character",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "indios": [
    {
      "id": 5489,
      "keyword": "indio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "character",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "operar": [
    {
      "id": 5530,
      "keyword": "operar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ofrenda de flores": [
    {
      "id": 5529,
      "keyword": "Ofrenda de flores",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "religion",
        "christianity",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ofrenda": [
    {
      "id": 5529,
      "keyword": "ofrenda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "religion",
        "christianity",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ofrendas": [
    {
      "id": 5529,
      "keyword": "ofrenda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "religion",
        "christianity",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mucho": [
    {
      "id": 7168,
      "keyword": "mucho",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5521,
      "keyword": "mucho",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "otoño": [
    {
      "id": 5531,
      "keyword": "otoño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "season",
        "autumn",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "otoños": [
    {
      "id": 5531,
      "keyword": "otoño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "season",
        "autumn",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nunca": [
    {
      "id": 5527,
      "keyword": "nunca",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jamás": [
    {
      "id": 5527,
      "keyword": "jamás",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oceanía": [
    {
      "id": 5528,
      "keyword": "Oceanía",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "continent",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palillos": [
    {
      "id": 5533,
      "keyword": "palillos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8362,
      "keyword": "palillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32090,
      "keyword": "palillos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36564,
      "keyword": "palillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palomitas": [
    {
      "id": 5534,
      "keyword": "palomitas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pochoclo": [
    {
      "id": 5534,
      "keyword": "pochoclo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pochoclos": [
    {
      "id": 5534,
      "keyword": "pochoclo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "no": [
    {
      "id": 5526,
      "keyword": "no",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of denial",
        "education",
        "core vocabulary",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39149,
      "keyword": "no",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of denial"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pediatra": [
    {
      "id": 27957,
      "keyword": "pediatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38856,
      "keyword": "pediatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5536,
      "keyword": "pediatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11331,
      "keyword": "pediatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31668,
      "keyword": "pediatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31827,
      "keyword": "pediatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pediatras": [
    {
      "id": 27957,
      "keyword": "pediatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38856,
      "keyword": "pediatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5536,
      "keyword": "pediatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11331,
      "keyword": "pediatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31668,
      "keyword": "pediatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31827,
      "keyword": "pediatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paella": [
    {
      "id": 5532,
      "keyword": "paella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27945,
      "keyword": "paella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paellas": [
    {
      "id": 5532,
      "keyword": "paella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27945,
      "keyword": "paella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pelar": [
    {
      "id": 5537,
      "keyword": "pelar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38982,
      "keyword": "pelar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pirineos": [
    {
      "id": 5541,
      "keyword": "Pirineos",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pintar las uñas": [
    {
      "id": 5540,
      "keyword": "pintar las uñas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36569,
      "keyword": "pintar las uñas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "cosmetic",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinchar": [
    {
      "id": 5539,
      "keyword": "pinchar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39069,
      "keyword": "pinchar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39277,
      "keyword": "pinchar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27972,
      "keyword": "pinchar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "road safety",
        "land transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plancha de pelo": [
    {
      "id": 5542,
      "keyword": "plancha de pelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "planchas de pelo": [
    {
      "id": 5542,
      "keyword": "plancha de pelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plegar": [
    {
      "id": 5544,
      "keyword": "plegar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16861,
      "keyword": "plegar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "doblar": [
    {
      "id": 5544,
      "keyword": "doblar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16861,
      "keyword": "doblar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guardia urbano": [
    {
      "id": 5547,
      "keyword": "guardia urbano",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11280,
      "keyword": "guardia urbano",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36948,
      "keyword": "guardia urbano",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36949,
      "keyword": "guardia urbano",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guardias urbanos": [
    {
      "id": 5547,
      "keyword": "guardia urbano",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11280,
      "keyword": "guardia urbano",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36948,
      "keyword": "guardia urbano",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36949,
      "keyword": "guardia urbano",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "policía local": [
    {
      "id": 35659,
      "keyword": "policía local",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5547,
      "keyword": "policía local",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11280,
      "keyword": "policía local",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36948,
      "keyword": "policía local",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36949,
      "keyword": "policía local",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "policías locales": [
    {
      "id": 35659,
      "keyword": "policía local",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5547,
      "keyword": "policía local",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11280,
      "keyword": "policía local",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36948,
      "keyword": "policía local",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36949,
      "keyword": "policía local",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guardia": [
    {
      "id": 5547,
      "keyword": "guardia",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11280,
      "keyword": "guardia",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36948,
      "keyword": "guardia",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36948,
      "keyword": "guardia",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36949,
      "keyword": "guardia",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guardias": [
    {
      "id": 5547,
      "keyword": "guardia",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11280,
      "keyword": "guardia",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36949,
      "keyword": "guardia",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apretar": [
    {
      "id": 32866,
      "keyword": "apretar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5552,
      "keyword": "apretar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37858,
      "keyword": "apretar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apretar con gato": [
    {
      "id": 5552,
      "keyword": "apretar con gato",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "primavera": [
    {
      "id": 5553,
      "keyword": "primavera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "season",
        "spring",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "primaveras": [
    {
      "id": 5553,
      "keyword": "primavera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "season",
        "spring",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "político": [
    {
      "id": 5548,
      "keyword": "político",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "políticos": [
    {
      "id": 5548,
      "keyword": "político",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "princesa": [
    {
      "id": 5554,
      "keyword": "princesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "princesas": [
    {
      "id": 5554,
      "keyword": "princesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "premiar": [
    {
      "id": 7218,
      "keyword": "premiar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5551,
      "keyword": "premiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "príncipe": [
    {
      "id": 5555,
      "keyword": "príncipe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "book character",
        "tale character",
        "literature",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "príncipes": [
    {
      "id": 5555,
      "keyword": "príncipe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "book character",
        "tale character",
        "literature",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "poco": [
    {
      "id": 7209,
      "keyword": "poco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5546,
      "keyword": "poco",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pocos": [
    {
      "id": 7209,
      "keyword": "pocos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7209,
      "keyword": "poco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5546,
      "keyword": "poco",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quitar la mesa": [
    {
      "id": 5558,
      "keyword": "quitar la mesa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puente": [
    {
      "id": 6194,
      "keyword": "puente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37257,
      "keyword": "puente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture",
        "infrastructure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5557,
      "keyword": "puente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puentes": [
    {
      "id": 6194,
      "keyword": "puente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37257,
      "keyword": "puente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture",
        "infrastructure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5557,
      "keyword": "puente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "puente de piedra": [
    {
      "id": 5557,
      "keyword": "Puente de Piedra",
      "keywords": 3,
      "type": 1,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puente romano": [
    {
      "id": 5557,
      "keyword": "puente romano",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reina": [
    {
      "id": 34171,
      "keyword": "reina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "chess"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5559,
      "keyword": "reina",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "character",
        "book character",
        "literature",
        "tale character",
        "movie character",
        "cinema",
        "history",
        "historical character"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reinas": [
    {
      "id": 34171,
      "keyword": "reina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "chess"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5559,
      "keyword": "reina",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "character",
        "book character",
        "literature",
        "tale character",
        "movie character",
        "cinema",
        "history",
        "historical character"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "emperatriz": [
    {
      "id": 5559,
      "keyword": "emperatriz",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "character",
        "book character",
        "literature",
        "tale character",
        "movie character",
        "cinema",
        "history",
        "historical character"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "emperatrices": [
    {
      "id": 5559,
      "keyword": "emperatriz",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "character",
        "book character",
        "literature",
        "tale character",
        "movie character",
        "cinema",
        "history",
        "historical character"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "majestad": [
    {
      "id": 5559,
      "keyword": "majestad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "character",
        "book character",
        "literature",
        "tale character",
        "movie character",
        "cinema",
        "history",
        "historical character"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5563,
      "keyword": "majestad",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "character",
        "book character",
        "literature",
        "tale character",
        "history",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "majestades": [
    {
      "id": 5559,
      "keyword": "majestad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "character",
        "book character",
        "literature",
        "tale character",
        "movie character",
        "cinema",
        "history",
        "historical character"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5563,
      "keyword": "majestad",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "character",
        "book character",
        "literature",
        "tale character",
        "history",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "despertador": [
    {
      "id": 5560,
      "keyword": "despertador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "time",
        "chronological device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despertadores": [
    {
      "id": 5560,
      "keyword": "despertador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "time",
        "chronological device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reloj despertador": [
    {
      "id": 5560,
      "keyword": "reloj despertador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "time",
        "chronological device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "relojes despertador": [
    {
      "id": 5560,
      "keyword": "reloj despertador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "time",
        "chronological device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "problema": [
    {
      "id": 5556,
      "keyword": "problema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32304,
      "keyword": "problema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "problemas": [
    {
      "id": 5556,
      "keyword": "problema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32304,
      "keyword": "problema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "poner la mesa": [
    {
      "id": 5549,
      "keyword": "poner la mesa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rueda": [
    {
      "id": 6209,
      "keyword": "rueda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5566,
      "keyword": "rueda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ruedas": [
    {
      "id": 6209,
      "keyword": "rueda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5566,
      "keyword": "rueda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rueda de bicicleta": [
    {
      "id": 5566,
      "keyword": "rueda de bicicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ruedas de bicicleta": [
    {
      "id": 5566,
      "keyword": "rueda de bicicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sabana": [
    {
      "id": 5567,
      "keyword": "sabana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "natural habitat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sabanas": [
    {
      "id": 5567,
      "keyword": "sabana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "natural habitat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plaza del torico": [
    {
      "id": 5543,
      "keyword": "Plaza del Torico",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "Aragon",
        "Teruel"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pluma": [
    {
      "id": 5545,
      "keyword": "pluma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7208,
      "keyword": "pluma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10313,
      "keyword": "pluma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plumas": [
    {
      "id": 5545,
      "keyword": "pluma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7208,
      "keyword": "pluma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10313,
      "keyword": "pluma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "roscón": [
    {
      "id": 5565,
      "keyword": "roscón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "gastronomy",
        "traditional dish",
        "event",
        "popular event",
        "christmas",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "roscones": [
    {
      "id": 5565,
      "keyword": "roscón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "gastronomy",
        "traditional dish",
        "event",
        "popular event",
        "christmas",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "roscón de san valero": [
    {
      "id": 5565,
      "keyword": "Roscón de San Valero",
      "keywords": 3,
      "type": 1,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "gastronomy",
        "traditional dish",
        "event",
        "popular event",
        "christmas",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "roscón de reyes": [
    {
      "id": 5565,
      "keyword": "Roscón de Reyes",
      "keywords": 3,
      "type": 1,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "gastronomy",
        "traditional dish",
        "event",
        "popular event",
        "christmas",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacar": [
    {
      "id": 5568,
      "keyword": "sacar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11751,
      "keyword": "sacar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desclavar": [
    {
      "id": 5569,
      "keyword": "desclavar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar clavo": [
    {
      "id": 5569,
      "keyword": "quitar clavo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar clavos": [
    {
      "id": 5569,
      "keyword": "quitar clavos",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saltar a la comba": [
    {
      "id": 6608,
      "keyword": "saltar a la comba",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "toy",
        "sport material",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37928,
      "keyword": "saltar a la comba",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28441,
      "keyword": "saltar a la comba",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "toy",
        "sport material",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5570,
      "keyword": "saltar a la comba",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "toy",
        "sport material",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saltar a la cuerda": [
    {
      "id": 6608,
      "keyword": "saltar a la cuerda",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "toy",
        "sport material",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37928,
      "keyword": "saltar a la cuerda",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5570,
      "keyword": "saltar a la cuerda",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "toy",
        "sport material",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dragón": [
    {
      "id": 5572,
      "keyword": "dragón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dragones": [
    {
      "id": 5572,
      "keyword": "dragón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rey": [
    {
      "id": 34244,
      "keyword": "rey",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "chess"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5563,
      "keyword": "rey",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "character",
        "book character",
        "literature",
        "tale character",
        "history",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "emperador": [
    {
      "id": 5563,
      "keyword": "emperador",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "character",
        "book character",
        "literature",
        "tale character",
        "history",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "emperadores": [
    {
      "id": 5563,
      "keyword": "emperador",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "character",
        "book character",
        "literature",
        "tale character",
        "history",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "monarca": [
    {
      "id": 5563,
      "keyword": "monarca",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "character",
        "book character",
        "literature",
        "tale character",
        "history",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monarcas": [
    {
      "id": 5563,
      "keyword": "monarca",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "character",
        "book character",
        "literature",
        "tale character",
        "history",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rizos": [
    {
      "id": 26392,
      "keyword": "rizo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5564,
      "keyword": "rizos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rulos": [
    {
      "id": 26392,
      "keyword": "rulo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5564,
      "keyword": "rulos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14260,
      "keyword": "rulo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sarpullido": [
    {
      "id": 5578,
      "keyword": "sarpullido",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sarpullidos": [
    {
      "id": 5578,
      "keyword": "sarpullido",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "eccema": [
    {
      "id": 5578,
      "keyword": "eccema",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "eccemas": [
    {
      "id": 5578,
      "keyword": "eccema",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "eczema": [
    {
      "id": 5578,
      "keyword": "eczema",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "eczemas": [
    {
      "id": 5578,
      "keyword": "eczema",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "san lorenzo": [
    {
      "id": 5577,
      "keyword": "San Lorenzo",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "historical character",
        "history",
        "christianity",
        "Aragon",
        "Huesca"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sazonar": [
    {
      "id": 5579,
      "keyword": "sazonar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salar": [
    {
      "id": 5579,
      "keyword": "salar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contenedor de papel": [
    {
      "id": 5575,
      "keyword": "contenedor de papel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contenedores de papel": [
    {
      "id": 5575,
      "keyword": "contenedor de papel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ser": [
    {
      "id": 36480,
      "keyword": "ser",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5858,
      "keyword": "ser",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5581,
      "keyword": "ser",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "san jorge": [
    {
      "id": 25427,
      "keyword": "San Jorge",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12309,
      "keyword": "San Jorge",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5576,
      "keyword": "San Jorge",
      "keywords": 2,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "historical character",
        "history",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "san jorge y el dragón": [
    {
      "id": 5576,
      "keyword": "San Jorge y el Dragón",
      "keywords": 2,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "historical character",
        "history",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "afirmar": [
    {
      "id": 31973,
      "keyword": "afirmar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34521,
      "keyword": "afirmar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5583,
      "keyword": "afirmar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asentir": [
    {
      "id": 5583,
      "keyword": "asentir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sierra": [
    {
      "id": 24404,
      "keyword": "sierra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5586,
      "keyword": "sierra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5587,
      "keyword": "sierra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5588,
      "keyword": "sierra",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sierras": [
    {
      "id": 24404,
      "keyword": "sierra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5586,
      "keyword": "sierra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5587,
      "keyword": "sierra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5588,
      "keyword": "sierra",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sierra caladora": [
    {
      "id": 5586,
      "keyword": "sierra caladora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sierras caladoras": [
    {
      "id": 5586,
      "keyword": "sierra caladora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sueño": [
    {
      "id": 7257,
      "keyword": "sueño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5590,
      "keyword": "sueño",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "sueños": [
    {
      "id": 5590,
      "keyword": "sueño",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "sirena": [
    {
      "id": 5589,
      "keyword": "sirena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6214,
      "keyword": "sirena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "object",
        "appliance",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6891,
      "keyword": "sirena",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sirenas": [
    {
      "id": 5589,
      "keyword": "sirena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6214,
      "keyword": "sirena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "object",
        "appliance",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6891,
      "keyword": "sirena",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tender": [
    {
      "id": 26487,
      "keyword": "tender",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5593,
      "keyword": "tender",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teruel": [
    {
      "id": 5594,
      "keyword": "Teruel",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "province"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14681,
      "keyword": "Teruel",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "todo": [
    {
      "id": 5596,
      "keyword": "todo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "indefinite pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27091,
      "keyword": "todo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32438,
      "keyword": "todo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "todos": [
    {
      "id": 5596,
      "keyword": "todos",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "indefinite pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36081,
      "keyword": "todos",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun",
        "object",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27091,
      "keyword": "todos",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32438,
      "keyword": "todos",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "todas": [
    {
      "id": 5596,
      "keyword": "todas",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "indefinite pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27091,
      "keyword": "todas",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32438,
      "keyword": "todas",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toda": [
    {
      "id": 5596,
      "keyword": "toda",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "indefinite pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27091,
      "keyword": "toda",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32438,
      "keyword": "toda",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toreros": [
    {
      "id": 5597,
      "keyword": "torero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "bullfighting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sierra de mesa": [
    {
      "id": 5587,
      "keyword": "sierra de mesa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sierras de mesa": [
    {
      "id": 5587,
      "keyword": "sierra de mesa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sidra": [
    {
      "id": 5585,
      "keyword": "sidra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sidras": [
    {
      "id": 5585,
      "keyword": "sidra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "segueta": [
    {
      "id": 5588,
      "keyword": "segueta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seguetas": [
    {
      "id": 5588,
      "keyword": "segueta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sierra de marquetería": [
    {
      "id": 5588,
      "keyword": "sierra de marquetería",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sierras de marquetería": [
    {
      "id": 5588,
      "keyword": "sierra de marquetería",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inyectar": [
    {
      "id": 5601,
      "keyword": "inyectar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31702,
      "keyword": "inyectar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinchar el brazo": [
    {
      "id": 5601,
      "keyword": "pinchar el brazo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inyección": [
    {
      "id": 5601,
      "keyword": "inyección",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31702,
      "keyword": "inyección",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inyecciones": [
    {
      "id": 5601,
      "keyword": "inyección",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31702,
      "keyword": "inyección",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tamborrada": [
    {
      "id": 28944,
      "keyword": "Tamborrada",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28952,
      "keyword": "Tamborrada",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5592,
      "keyword": "tamborrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "easter week",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tamborradas": [
    {
      "id": 5592,
      "keyword": "tamborrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "easter week",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sequía": [
    {
      "id": 5580,
      "keyword": "sequía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sequías": [
    {
      "id": 5580,
      "keyword": "sequía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trenza": [
    {
      "id": 5599,
      "keyword": "trenza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trenzas": [
    {
      "id": 5599,
      "keyword": "trenza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vendedor de chuches": [
    {
      "id": 5603,
      "keyword": "vendedor de chuches",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vendedores de chuches": [
    {
      "id": 5603,
      "keyword": "vendedor de chuches",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vinagre": [
    {
      "id": 5605,
      "keyword": "vinagre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vinagres": [
    {
      "id": 5605,
      "keyword": "vinagre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "verano": [
    {
      "id": 5604,
      "keyword": "verano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "season",
        "summer",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veranos": [
    {
      "id": 5604,
      "keyword": "verano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "season",
        "summer",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tubillones": [
    {
      "id": 5600,
      "keyword": "tubillones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36604,
      "keyword": "tubillón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sí": [
    {
      "id": 5584,
      "keyword": "sí",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of affirmation",
        "education",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6481,
      "keyword": "sí",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7029,
      "keyword": "sí",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7031,
      "keyword": "sí",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7033,
      "keyword": "sí",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31670,
      "keyword": "sí",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31906,
      "keyword": "sí",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vaquero": [
    {
      "id": 5602,
      "keyword": "vaquero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vaqueros": [
    {
      "id": 5602,
      "keyword": "vaquero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24222,
      "keyword": "vaqueros",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pistolero": [
    {
      "id": 5602,
      "keyword": "pistolero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pistoleros": [
    {
      "id": 5602,
      "keyword": "pistolero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "virgen del pilar": [
    {
      "id": 5606,
      "keyword": "Virgen del Pilar",
      "keywords": 3,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "christianity",
        "event",
        "popular event",
        "fiestas del pilar",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "virgen": [
    {
      "id": 5606,
      "keyword": "virgen",
      "keywords": 3,
      "type": 2,
      "tags": [
        "religion",
        "character",
        "christianity",
        "event",
        "popular event",
        "fiestas del pilar",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7301,
      "keyword": "virgen",
      "keywords": 3,
      "type": 2,
      "tags": [
        "religion",
        "character",
        "christianity",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vírgenes": [
    {
      "id": 5606,
      "keyword": "virgen",
      "keywords": 3,
      "type": 2,
      "tags": [
        "religion",
        "character",
        "christianity",
        "event",
        "popular event",
        "fiestas del pilar",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7301,
      "keyword": "virgen",
      "keywords": 3,
      "type": 2,
      "tags": [
        "religion",
        "character",
        "christianity",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tornado": [
    {
      "id": 5598,
      "keyword": "tornado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tornados": [
    {
      "id": 5598,
      "keyword": "tornado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escudo de aragón": [
    {
      "id": 5610,
      "keyword": "Escudo de Aragón",
      "keywords": 4,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region",
        "Aragon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escudo de armas": [
    {
      "id": 5610,
      "keyword": "escudo de armas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "geography",
        "political geography",
        "spain region",
        "Aragon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escudos de armas": [
    {
      "id": 5610,
      "keyword": "escudo de armas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "geography",
        "political geography",
        "spain region",
        "Aragon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escudo": [
    {
      "id": 7089,
      "keyword": "escudo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "history",
        "middle ages",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34197,
      "keyword": "escudo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "history",
        "middle ages"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37118,
      "keyword": "escudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "history",
        "civilization",
        "Iberians",
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5610,
      "keyword": "escudo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "geography",
        "political geography",
        "spain region",
        "Aragon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escudos": [
    {
      "id": 7089,
      "keyword": "escudo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "history",
        "middle ages",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34197,
      "keyword": "escudo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "history",
        "middle ages"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37118,
      "keyword": "escudo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "history",
        "civilization",
        "Iberians",
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5610,
      "keyword": "escudo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "geography",
        "political geography",
        "spain region",
        "Aragon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cráneo": [
    {
      "id": 5697,
      "keyword": "cráneo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cráneos": [
    {
      "id": 5697,
      "keyword": "cráneo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fracción": [
    {
      "id": 5739,
      "keyword": "fracción",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics",
        "education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9877,
      "keyword": "fracción",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fracciones": [
    {
      "id": 5739,
      "keyword": "fracción",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics",
        "education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9877,
      "keyword": "fracciones",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9877,
      "keyword": "fracción",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuenta": [
    {
      "id": 5739,
      "keyword": "cuenta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics",
        "education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5995,
      "keyword": "cuenta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8334,
      "keyword": "cuenta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "craftsmanship",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38971,
      "keyword": "cuenta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "building",
        "catering establishment",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38974,
      "keyword": "cuenta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "building",
        "catering establishment",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15517,
      "keyword": "cuenta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "razón": [
    {
      "id": 5739,
      "keyword": "razón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics",
        "education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "razones": [
    {
      "id": 5739,
      "keyword": "razón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics",
        "education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ninguno": [
    {
      "id": 5800,
      "keyword": "ninguno",
      "keywords": 4,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26941,
      "keyword": "ninguno",
      "keywords": 4,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11314,
      "keyword": "ninguno",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "core vocabulary",
        "pronoun",
        "indefinite pronoun",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ningunos": [
    {
      "id": 5800,
      "keyword": "ninguno",
      "keywords": 4,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26941,
      "keyword": "ningún",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11314,
      "keyword": "ninguno",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "core vocabulary",
        "pronoun",
        "indefinite pronoun",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ningún": [
    {
      "id": 5800,
      "keyword": "ningún",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26941,
      "keyword": "ningún",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ninguna": [
    {
      "id": 5800,
      "keyword": "ninguna",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5800,
      "keyword": "ninguna",
      "keywords": 4,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26941,
      "keyword": "ninguna",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26941,
      "keyword": "ninguna",
      "keywords": 4,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11314,
      "keyword": "ninguna",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "core vocabulary",
        "pronoun",
        "indefinite pronoun",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parrilla": [
    {
      "id": 5811,
      "keyword": "parrilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parrillas": [
    {
      "id": 5811,
      "keyword": "parrilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "crucigrama": [
    {
      "id": 5698,
      "keyword": "crucigrama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "hobby",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crucigramas": [
    {
      "id": 5698,
      "keyword": "crucigrama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "hobby",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "multiplicar": [
    {
      "id": 5798,
      "keyword": "multiplicar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37318,
      "keyword": "multiplicar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "multiplicación": [
    {
      "id": 5798,
      "keyword": "multiplicación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37318,
      "keyword": "multiplicación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "multiplicaciones": [
    {
      "id": 5798,
      "keyword": "multiplicación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37318,
      "keyword": "multiplicación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "restar": [
    {
      "id": 5841,
      "keyword": "restar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37321,
      "keyword": "restar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "resta": [
    {
      "id": 5841,
      "keyword": "resta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37321,
      "keyword": "resta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "restas": [
    {
      "id": 5841,
      "keyword": "resta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37321,
      "keyword": "resta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sustraer": [
    {
      "id": 5841,
      "keyword": "sustraer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37321,
      "keyword": "sustraer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "división": [
    {
      "id": 5707,
      "keyword": "división",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "communication"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37320,
      "keyword": "división",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "divisiones": [
    {
      "id": 5707,
      "keyword": "división",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "communication"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37320,
      "keyword": "división",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esqueleto": [
    {
      "id": 5727,
      "keyword": "esqueleto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system",
        "locomotor system",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esqueletos": [
    {
      "id": 5727,
      "keyword": "esqueleto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system",
        "locomotor system",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lobo": [
    {
      "id": 5892,
      "keyword": "lobo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lobos": [
    {
      "id": 5892,
      "keyword": "lobo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "loba": [
    {
      "id": 5892,
      "keyword": "loba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37933,
      "keyword": "loba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lobas": [
    {
      "id": 5892,
      "keyword": "loba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37933,
      "keyword": "loba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cepillo de mano": [
    {
      "id": 5609,
      "keyword": "cepillo de mano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5953,
      "keyword": "cepillo de mano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cepillos de mano": [
    {
      "id": 5609,
      "keyword": "cepillo de mano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5953,
      "keyword": "cepillo de mano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agencia de viajes": [
    {
      "id": 5897,
      "keyword": "agencia de viajes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agencias de viajes": [
    {
      "id": 5897,
      "keyword": "agencia de viajes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agenda": [
    {
      "id": 5898,
      "keyword": "agenda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agendas": [
    {
      "id": 5898,
      "keyword": "agenda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alumna": [
    {
      "id": 6041,
      "keyword": "alumna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5899,
      "keyword": "alumna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alumnas": [
    {
      "id": 6041,
      "keyword": "alumna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5899,
      "keyword": "alumna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adiós": [
    {
      "id": 6028,
      "keyword": "adiós",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5896,
      "keyword": "adiós",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34467,
      "keyword": "adiós",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hasta luego": [
    {
      "id": 6028,
      "keyword": "hasta luego",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5896,
      "keyword": "hasta luego",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34467,
      "keyword": "hasta luego",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hasta la vista": [
    {
      "id": 6028,
      "keyword": "hasta la vista",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5896,
      "keyword": "hasta la vista",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34467,
      "keyword": "hasta la vista",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alumno": [
    {
      "id": 6042,
      "keyword": "alumno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5900,
      "keyword": "alumno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alumnos": [
    {
      "id": 6042,
      "keyword": "alumno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5900,
      "keyword": "alumno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "análisis de sangre": [
    {
      "id": 5901,
      "keyword": "análisis de sangre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30084,
      "keyword": "análisis de sangre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33093,
      "keyword": "análisis de sangre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33094,
      "keyword": "análisis de sangre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33092,
      "keyword": "análisis de sangre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31354,
      "keyword": "análisis de sangre",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sumar": [
    {
      "id": 5868,
      "keyword": "sumar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37319,
      "keyword": "sumar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suma": [
    {
      "id": 5868,
      "keyword": "suma",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37319,
      "keyword": "suma",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sumas": [
    {
      "id": 5868,
      "keyword": "suma",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37319,
      "keyword": "suma",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adición": [
    {
      "id": 5868,
      "keyword": "adición",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37319,
      "keyword": "adición",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adiciones": [
    {
      "id": 5868,
      "keyword": "adición",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37319,
      "keyword": "adición",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acordeón": [
    {
      "id": 5895,
      "keyword": "acordeón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "keyboard instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acordeones": [
    {
      "id": 5895,
      "keyword": "acordeón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "keyboard instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frontón": [
    {
      "id": 5893,
      "keyword": "frontón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frontones": [
    {
      "id": 5893,
      "keyword": "frontón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "andador": [
    {
      "id": 24850,
      "keyword": "andador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "core vocabulary",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25800,
      "keyword": "andador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5902,
      "keyword": "andador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32730,
      "keyword": "andador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23741,
      "keyword": "andador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39198,
      "keyword": "andador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "andadores": [
    {
      "id": 24850,
      "keyword": "andador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "core vocabulary",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25800,
      "keyword": "andador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5902,
      "keyword": "andador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32730,
      "keyword": "andador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23741,
      "keyword": "andador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "babycare"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39198,
      "keyword": "andador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zaragoza": [
    {
      "id": 5607,
      "keyword": "Zaragoza",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14682,
      "keyword": "Zaragoza",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "animar": [
    {
      "id": 6046,
      "keyword": "animar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5903,
      "keyword": "animar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31799,
      "keyword": "animar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37774,
      "keyword": "animar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "armónica": [
    {
      "id": 5909,
      "keyword": "armónica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "armónicas": [
    {
      "id": 5909,
      "keyword": "armónica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "residencia de ancianos": [
    {
      "id": 25725,
      "keyword": "residencia de ancianos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5910,
      "keyword": "residencia de ancianos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25724,
      "keyword": "residencia de ancianos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "residencias de ancianos": [
    {
      "id": 25725,
      "keyword": "residencia de ancianos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5910,
      "keyword": "residencia de ancianos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25724,
      "keyword": "residencia de ancianos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asilo de ancianos": [
    {
      "id": 25725,
      "keyword": "asilo de ancianos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5910,
      "keyword": "asilo de ancianos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25724,
      "keyword": "asilo de ancianos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asilos de ancianos": [
    {
      "id": 25725,
      "keyword": "asilo de ancianos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5910,
      "keyword": "asilo de ancianos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25724,
      "keyword": "asilo de ancianos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aterrizaje": [
    {
      "id": 5911,
      "keyword": "aterrizaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aterrizajes": [
    {
      "id": 5911,
      "keyword": "aterrizaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "audífono": [
    {
      "id": 5912,
      "keyword": "audífono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "audífonos": [
    {
      "id": 5912,
      "keyword": "audífono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aula": [
    {
      "id": 9815,
      "keyword": "aula",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5913,
      "keyword": "aula",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15734,
      "keyword": "aula",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9814,
      "keyword": "aula",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33072,
      "keyword": "aula",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aulas": [
    {
      "id": 9815,
      "keyword": "aula",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5913,
      "keyword": "aula",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15734,
      "keyword": "aula",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9814,
      "keyword": "aula",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33072,
      "keyword": "aula",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clase": [
    {
      "id": 9815,
      "keyword": "clase",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5913,
      "keyword": "clase",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15734,
      "keyword": "clase",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9814,
      "keyword": "clase",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33072,
      "keyword": "clase",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases": [
    {
      "id": 9815,
      "keyword": "clase",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5913,
      "keyword": "clase",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15734,
      "keyword": "clase",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9814,
      "keyword": "clase",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33072,
      "keyword": "clase",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anzuelo": [
    {
      "id": 5906,
      "keyword": "anzuelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anzuelos": [
    {
      "id": 5906,
      "keyword": "anzuelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apagar": [
    {
      "id": 21365,
      "keyword": "apagar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5907,
      "keyword": "apagar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37716,
      "keyword": "apagar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "antifaz": [
    {
      "id": 5904,
      "keyword": "antifaz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "antifaces": [
    {
      "id": 5904,
      "keyword": "antifaz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "careta": [
    {
      "id": 5904,
      "keyword": "careta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5944,
      "keyword": "careta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume",
        "scenic art",
        "document",
        "event",
        "popular event",
        "carnival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caretas": [
    {
      "id": 5904,
      "keyword": "careta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5944,
      "keyword": "careta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume",
        "scenic art",
        "document",
        "event",
        "popular event",
        "carnival"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "antorcha": [
    {
      "id": 5905,
      "keyword": "antorcha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "antorchas": [
    {
      "id": 5905,
      "keyword": "antorcha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llama": [
    {
      "id": 9067,
      "keyword": "llama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5905,
      "keyword": "llama",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llamas": [
    {
      "id": 9067,
      "keyword": "llama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5905,
      "keyword": "llama",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barro": [
    {
      "id": 34118,
      "keyword": "barro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "derived material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5908,
      "keyword": "barro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material",
        "work",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barros": [
    {
      "id": 34118,
      "keyword": "barro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "derived material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5908,
      "keyword": "barro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material",
        "work",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arcilla": [
    {
      "id": 5908,
      "keyword": "arcilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material",
        "work",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arcillas": [
    {
      "id": 5908,
      "keyword": "arcilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material",
        "work",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bajar el volumen": [
    {
      "id": 5916,
      "keyword": "bajar el volumen",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar la potencia": [
    {
      "id": 5916,
      "keyword": "bajar la potencia",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baja el volumen": [
    {
      "id": 5916,
      "keyword": "baja el volumen",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "banquillo": [
    {
      "id": 5920,
      "keyword": "banquillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "banquillos": [
    {
      "id": 5920,
      "keyword": "banquillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuarto de baño": [
    {
      "id": 5921,
      "keyword": "cuarto de baño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27555,
      "keyword": "cuarto de baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27557,
      "keyword": "cuarto de baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27553,
      "keyword": "cuarto de baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33935,
      "keyword": "cuarto de baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33954,
      "keyword": "cuarto de baño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6929,
      "keyword": "cuarto de baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6930,
      "keyword": "cuarto de baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39122,
      "keyword": "cuarto de baño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33936,
      "keyword": "cuarto de baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33934,
      "keyword": "cuarto de baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38625,
      "keyword": "cuarto de baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38626,
      "keyword": "cuarto de baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38627,
      "keyword": "cuarto de baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuartos de baño": [
    {
      "id": 5921,
      "keyword": "cuarto de baño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27555,
      "keyword": "cuarto de baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27557,
      "keyword": "cuarto de baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27553,
      "keyword": "cuarto de baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33935,
      "keyword": "cuarto de baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33954,
      "keyword": "cuarto de baño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6929,
      "keyword": "cuarto de baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6930,
      "keyword": "cuarto de baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28213,
      "keyword": "cuartos de baño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39122,
      "keyword": "cuarto de baño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33936,
      "keyword": "cuarto de baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33934,
      "keyword": "cuarto de baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38625,
      "keyword": "cuarto de baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38626,
      "keyword": "cuarto de baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38627,
      "keyword": "cuarto de baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "banderín": [
    {
      "id": 5919,
      "keyword": "banderín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "political geography",
        "flag"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "banderines": [
    {
      "id": 5919,
      "keyword": "banderín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "political geography",
        "flag"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bastón": [
    {
      "id": 39130,
      "keyword": "bastón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39131,
      "keyword": "bastón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5922,
      "keyword": "bastón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bastones": [
    {
      "id": 39130,
      "keyword": "bastón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39131,
      "keyword": "bastón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5922,
      "keyword": "bastón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cayado": [
    {
      "id": 5922,
      "keyword": "cayado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cayados": [
    {
      "id": 5922,
      "keyword": "cayado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "batería": [
    {
      "id": 5923,
      "keyword": "batería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "leisure",
        "show",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23823,
      "keyword": "batería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baterías": [
    {
      "id": 5923,
      "keyword": "batería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "leisure",
        "show",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23823,
      "keyword": "batería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "batir": [
    {
      "id": 26684,
      "keyword": "batir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37288,
      "keyword": "batir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5924,
      "keyword": "batir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5925,
      "keyword": "batir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "cutlery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26682,
      "keyword": "batir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26683,
      "keyword": "batir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32926,
      "keyword": "batir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aula de música": [
    {
      "id": 5914,
      "keyword": "aula de música",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aulas de música": [
    {
      "id": 5914,
      "keyword": "aula de música",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "auriculares": [
    {
      "id": 5915,
      "keyword": "auriculares",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8293,
      "keyword": "auricular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39238,
      "keyword": "auriculares",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11208,
      "keyword": "auriculares",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balón de rugby": [
    {
      "id": 5917,
      "keyword": "balón de rugby",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balones de rugby": [
    {
      "id": 5917,
      "keyword": "balón de rugby",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botar": [
    {
      "id": 21462,
      "keyword": "botar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39402,
      "keyword": "botar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "adapted sport",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5929,
      "keyword": "botar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21460,
      "keyword": "botar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bandera": [
    {
      "id": 5918,
      "keyword": "bandera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "political geography",
        "flag"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "banderas": [
    {
      "id": 5918,
      "keyword": "bandera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "political geography",
        "flag"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bronce": [
    {
      "id": 5933,
      "keyword": "bronce",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cadena": [
    {
      "id": 5934,
      "keyword": "cadena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8051,
      "keyword": "cadena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cadenas": [
    {
      "id": 5934,
      "keyword": "cadena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8051,
      "keyword": "cadena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "brocheta mixta": [
    {
      "id": 5932,
      "keyword": "brocheta mixta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brochetas mixtas": [
    {
      "id": 5932,
      "keyword": "brocheta mixta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "brocheta": [
    {
      "id": 5932,
      "keyword": "brocheta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5931,
      "keyword": "brocheta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28221,
      "keyword": "brocheta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brochetas": [
    {
      "id": 5932,
      "keyword": "brocheta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5931,
      "keyword": "brocheta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28221,
      "keyword": "brocheta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "suero": [
    {
      "id": 6220,
      "keyword": "suero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5927,
      "keyword": "suero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sueros": [
    {
      "id": 6220,
      "keyword": "suero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5927,
      "keyword": "suero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolsa de suero": [
    {
      "id": 5927,
      "keyword": "bolsa de suero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas de suero": [
    {
      "id": 5927,
      "keyword": "bolsa de suero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "brocheta de fruta": [
    {
      "id": 5931,
      "keyword": "brocheta de fruta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brochetas de fruta": [
    {
      "id": 5931,
      "keyword": "brocheta de fruta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caja": [
    {
      "id": 7054,
      "keyword": "caja",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "object",
        "core vocabulary",
        "container"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5935,
      "keyword": "caja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 5935,
      "keyword": "caja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37948,
      "keyword": "caja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajas": [
    {
      "id": 7054,
      "keyword": "caja",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "object",
        "core vocabulary",
        "container"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5935,
      "keyword": "caja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 5935,
      "keyword": "caja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37948,
      "keyword": "caja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camping": [
    {
      "id": 32420,
      "keyword": "camping",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 32420,
      "keyword": "camping",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5939,
      "keyword": "camping",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campings": [
    {
      "id": 32420,
      "keyword": "camping",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 32420,
      "keyword": "camping",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5939,
      "keyword": "camping",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "campana": [
    {
      "id": 5938,
      "keyword": "campana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caña": [
    {
      "id": 5941,
      "keyword": "caña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35467,
      "keyword": "caña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cañas": [
    {
      "id": 5941,
      "keyword": "caña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35467,
      "keyword": "caña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bombín": [
    {
      "id": 5928,
      "keyword": "bombín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bombines": [
    {
      "id": 5928,
      "keyword": "bombín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caperucita roja": [
    {
      "id": 5942,
      "keyword": "Caperucita Roja",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caperucita": [
    {
      "id": 5942,
      "keyword": "Caperucita",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carbón": [
    {
      "id": 5943,
      "keyword": "carbón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "fossil origin material",
        "work",
        "primary sector",
        "mining",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cascabel": [
    {
      "id": 5949,
      "keyword": "cascabel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cascabeles": [
    {
      "id": 5949,
      "keyword": "cascabel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carrito de la compra": [
    {
      "id": 30618,
      "keyword": "carrito de la compra",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5948,
      "keyword": "carrito de la compra",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade",
        "feeding",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carritos de la compra": [
    {
      "id": 30618,
      "keyword": "carrito de la compra",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5948,
      "keyword": "carrito de la compra",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade",
        "feeding",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carrito": [
    {
      "id": 30618,
      "keyword": "carrito",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5948,
      "keyword": "carrito",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade",
        "feeding",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6281,
      "keyword": "carrito",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carritos": [
    {
      "id": 30618,
      "keyword": "carrito",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5948,
      "keyword": "carrito",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade",
        "feeding",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6281,
      "keyword": "carrito",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "changuito": [
    {
      "id": 30618,
      "keyword": "changuito",
      "keywords": 4,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5948,
      "keyword": "changuito",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade",
        "feeding",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "changuitos": [
    {
      "id": 30618,
      "keyword": "changuito",
      "keywords": 4,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5948,
      "keyword": "changuito",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade",
        "feeding",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cascada": [
    {
      "id": 5951,
      "keyword": "cascada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cascadas": [
    {
      "id": 5951,
      "keyword": "cascada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "catarata": [
    {
      "id": 5951,
      "keyword": "catarata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cataratas": [
    {
      "id": 5951,
      "keyword": "catarata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cavar": [
    {
      "id": 6078,
      "keyword": "cavar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5952,
      "keyword": "cavar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camilla": [
    {
      "id": 24933,
      "keyword": "camilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5937,
      "keyword": "camilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camillas": [
    {
      "id": 24933,
      "keyword": "camilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5937,
      "keyword": "camilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "máscara": [
    {
      "id": 5944,
      "keyword": "máscara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume",
        "scenic art",
        "document",
        "event",
        "popular event",
        "carnival"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27881,
      "keyword": "máscara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máscaras": [
    {
      "id": 24165,
      "keyword": "máscaras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5944,
      "keyword": "máscara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume",
        "scenic art",
        "document",
        "event",
        "popular event",
        "carnival"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27881,
      "keyword": "máscara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carretilla": [
    {
      "id": 5947,
      "keyword": "carretilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21502,
      "keyword": "carretilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10355,
      "keyword": "carretilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carretillas": [
    {
      "id": 5947,
      "keyword": "carretilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21502,
      "keyword": "carretilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10355,
      "keyword": "carretilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carnet": [
    {
      "id": 6073,
      "keyword": "carnet",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5945,
      "keyword": "carnet",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5987,
      "keyword": "carnet",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carnets": [
    {
      "id": 6073,
      "keyword": "carnet",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5945,
      "keyword": "carnet",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5987,
      "keyword": "carnet",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carnet de conducir": [
    {
      "id": 5945,
      "keyword": "carnet de conducir",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carnets de conducir": [
    {
      "id": 5945,
      "keyword": "carnet de conducir",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "permiso de conducir": [
    {
      "id": 5945,
      "keyword": "permiso de conducir",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "permisos de conducir": [
    {
      "id": 5945,
      "keyword": "permiso de conducir",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerdito": [
    {
      "id": 5956,
      "keyword": "cerdito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5955,
      "keyword": "cerdito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5954,
      "keyword": "cerdito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerditos": [
    {
      "id": 5956,
      "keyword": "cerdito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5955,
      "keyword": "cerdito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5954,
      "keyword": "cerdito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerdito pequeño": [
    {
      "id": 5956,
      "keyword": "Cerdito pequeño",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "persona indígena de asia": [
    {
      "id": 5958,
      "keyword": "persona indígena de Asia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5959,
      "keyword": "persona indígena de Asia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerdito mediano": [
    {
      "id": 5955,
      "keyword": "Cerdito mediano",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "churro": [
    {
      "id": 5960,
      "keyword": "churro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8455,
      "keyword": "churro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15724,
      "keyword": "churro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "golpear el balón": [
    {
      "id": 5961,
      "keyword": "golpear el balón",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chutar": [
    {
      "id": 6977,
      "keyword": "chutar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5961,
      "keyword": "chutar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "disparar": [
    {
      "id": 16645,
      "keyword": "disparar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37553,
      "keyword": "disparar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38344,
      "keyword": "disparar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "war",
        "history",
        "middle ages"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5961,
      "keyword": "disparar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerdito mayor": [
    {
      "id": 5954,
      "keyword": "Cerdito mayor",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cinturón de seguridad": [
    {
      "id": 34655,
      "keyword": "cinturón de seguridad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37299,
      "keyword": "cinturón de seguridad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5962,
      "keyword": "cinturón de seguridad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34671,
      "keyword": "cinturón de seguridad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cinturones de seguridad": [
    {
      "id": 34655,
      "keyword": "cinturón de seguridad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37299,
      "keyword": "cinturón de seguridad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5962,
      "keyword": "cinturón de seguridad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34671,
      "keyword": "cinturón de seguridad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comadreja": [
    {
      "id": 5969,
      "keyword": "comadreja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comadrejas": [
    {
      "id": 5969,
      "keyword": "comadreja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cofre": [
    {
      "id": 5966,
      "keyword": "cofre",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "container",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cofres": [
    {
      "id": 5966,
      "keyword": "cofre",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "container",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arca": [
    {
      "id": 5966,
      "keyword": "arca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "container",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arcas": [
    {
      "id": 5966,
      "keyword": "arca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "container",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "baúl": [
    {
      "id": 5966,
      "keyword": "baúl",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "container",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baúles": [
    {
      "id": 5966,
      "keyword": "baúl",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "container",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clarinete": [
    {
      "id": 5964,
      "keyword": "clarinete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clarinetes": [
    {
      "id": 5964,
      "keyword": "clarinete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comedor": [
    {
      "id": 5970,
      "keyword": "comedor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9824,
      "keyword": "comedor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comedores": [
    {
      "id": 5970,
      "keyword": "comedor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9824,
      "keyword": "comedor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comunicador": [
    {
      "id": 25982,
      "keyword": "comunicador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5971,
      "keyword": "comunicador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37418,
      "keyword": "comunicador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comunicadores": [
    {
      "id": 25982,
      "keyword": "comunicador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5971,
      "keyword": "comunicador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37418,
      "keyword": "comunicador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colores": [
    {
      "id": 7075,
      "keyword": "color",
      "keywords": 2,
      "type": 2,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5968,
      "keyword": "colores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "color",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "color": [
    {
      "id": 7075,
      "keyword": "color",
      "keywords": 2,
      "type": 2,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5968,
      "keyword": "color",
      "keywords": 2,
      "type": 2,
      "tags": [
        "color",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conserjería": [
    {
      "id": 5972,
      "keyword": "conserjería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conserjerías": [
    {
      "id": 5972,
      "keyword": "conserjería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "narrar": [
    {
      "id": 6461,
      "keyword": "narrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "literature"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38631,
      "keyword": "narrar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5973,
      "keyword": "narrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chalet": [
    {
      "id": 5957,
      "keyword": "chalet",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chalets": [
    {
      "id": 5957,
      "keyword": "chalet",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "corneta": [
    {
      "id": 5974,
      "keyword": "corneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cornetas": [
    {
      "id": 5974,
      "keyword": "corneta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuna": [
    {
      "id": 5980,
      "keyword": "cuna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cunas": [
    {
      "id": 5980,
      "keyword": "cuna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cruzar": [
    {
      "id": 6466,
      "keyword": "cruzar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37087,
      "keyword": "cruzar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5976,
      "keyword": "cruzar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37344,
      "keyword": "cruzar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "remover": [
    {
      "id": 5981,
      "keyword": "remover",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "cutlery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25738,
      "keyword": "remover",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dar vueltas": [
    {
      "id": 31790,
      "keyword": "dar vueltas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5981,
      "keyword": "dar vueltas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "cutlery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rabo": [
    {
      "id": 5967,
      "keyword": "rabo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rabos": [
    {
      "id": 5967,
      "keyword": "rabo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "despacho": [
    {
      "id": 5983,
      "keyword": "despacho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despachos": [
    {
      "id": 5983,
      "keyword": "despacho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "despegue": [
    {
      "id": 5984,
      "keyword": "despegue",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despegues": [
    {
      "id": 5984,
      "keyword": "despegue",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuentakilómetros": [
    {
      "id": 5977,
      "keyword": "cuentakilómetros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "derramar": [
    {
      "id": 5982,
      "keyword": "derramar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dormitorio": [
    {
      "id": 5988,
      "keyword": "dormitorio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "core vocabulary",
        "building facility",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 5988,
      "keyword": "dormitorio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "core vocabulary",
        "building facility",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15732,
      "keyword": "dormitorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32422,
      "keyword": "dormitorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33068,
      "keyword": "dormitorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dormitorios": [
    {
      "id": 5988,
      "keyword": "dormitorio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "core vocabulary",
        "building facility",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 5988,
      "keyword": "dormitorio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "core vocabulary",
        "building facility",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15732,
      "keyword": "dormitorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32422,
      "keyword": "dormitorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33068,
      "keyword": "dormitorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "habitación": [
    {
      "id": 5988,
      "keyword": "habitación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "core vocabulary",
        "building facility",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 5988,
      "keyword": "habitación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "core vocabulary",
        "building facility",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35325,
      "keyword": "habitación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32234,
      "keyword": "habitación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "habitaciones": [
    {
      "id": 5988,
      "keyword": "habitación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "core vocabulary",
        "building facility",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 5988,
      "keyword": "habitación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "core vocabulary",
        "building facility",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35325,
      "keyword": "habitación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32234,
      "keyword": "habitación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "disfrazar": [
    {
      "id": 5986,
      "keyword": "disfrazar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "costume",
        "event",
        "popular event",
        "carnival",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encontrar": [
    {
      "id": 24742,
      "keyword": "encontrar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24773,
      "keyword": "encontrar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39519,
      "keyword": "encontrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5990,
      "keyword": "encontrar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24741,
      "keyword": "encontrar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24774,
      "keyword": "encontrar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37246,
      "keyword": "encontrar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hallar": [
    {
      "id": 24742,
      "keyword": "hallar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24773,
      "keyword": "hallar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5990,
      "keyword": "hallar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24741,
      "keyword": "hallar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24774,
      "keyword": "hallar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37246,
      "keyword": "hallar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aparecer": [
    {
      "id": 24742,
      "keyword": "aparecer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24773,
      "keyword": "aparecer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5990,
      "keyword": "aparecer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24741,
      "keyword": "aparecer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24774,
      "keyword": "aparecer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37246,
      "keyword": "aparecer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "edificio": [
    {
      "id": 24739,
      "keyword": "edificio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5989,
      "keyword": "edificio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35655,
      "keyword": "edificio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "edificios": [
    {
      "id": 24739,
      "keyword": "edificio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5989,
      "keyword": "edificio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35655,
      "keyword": "edificio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inmueble": [
    {
      "id": 5989,
      "keyword": "inmueble",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inmuebles": [
    {
      "id": 5989,
      "keyword": "inmueble",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "documento nacional de identidad": [
    {
      "id": 5987,
      "keyword": "Documento Nacional de Identidad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "documentos nacionales de identidad": [
    {
      "id": 5987,
      "keyword": "Documento Nacional de Identidad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dni": [
    {
      "id": 5987,
      "keyword": "DNI",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entrenador": [
    {
      "id": 38542,
      "keyword": "entrenador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport rules",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5991,
      "keyword": "entrenador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport rules",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entrenadores": [
    {
      "id": 38542,
      "keyword": "entrenador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport rules",
        "football"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5991,
      "keyword": "entrenador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport rules",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escaparate": [
    {
      "id": 5992,
      "keyword": "escaparate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escaparates": [
    {
      "id": 5992,
      "keyword": "escaparate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "exprimir": [
    {
      "id": 5994,
      "keyword": "exprimir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25089,
      "keyword": "exprimir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuero": [
    {
      "id": 5979,
      "keyword": "cuero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "animal material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cueros": [
    {
      "id": 5979,
      "keyword": "cuero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "animal material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "disfraz": [
    {
      "id": 5985,
      "keyword": "disfraz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 5985,
      "keyword": "disfraz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "disfraces": [
    {
      "id": 5985,
      "keyword": "disfraz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 5985,
      "keyword": "disfraz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silencio": [
    {
      "id": 6071,
      "keyword": "silencio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5936,
      "keyword": "silencio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25453,
      "keyword": "silencio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "silencios": [
    {
      "id": 6071,
      "keyword": "silencio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 5936,
      "keyword": "silencio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "callar": [
    {
      "id": 6071,
      "keyword": "callar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5936,
      "keyword": "callar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25453,
      "keyword": "callar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "silenciar": [
    {
      "id": 6071,
      "keyword": "silenciar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5936,
      "keyword": "silenciar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25453,
      "keyword": "silenciar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pedir silencio": [
    {
      "id": 6071,
      "keyword": "pedir silencio",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5936,
      "keyword": "pedir silencio",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25453,
      "keyword": "pedir silencio",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estadio de futbol": [
    {
      "id": 5993,
      "keyword": "estadio de futbol",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estadios de futbol": [
    {
      "id": 5993,
      "keyword": "estadio de futbol",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estadio": [
    {
      "id": 5993,
      "keyword": "estadio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estadios": [
    {
      "id": 5993,
      "keyword": "estadio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "factura": [
    {
      "id": 5995,
      "keyword": "factura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38971,
      "keyword": "factura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "building",
        "catering establishment",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38974,
      "keyword": "factura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "building",
        "catering establishment",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15517,
      "keyword": "factura",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "facturas": [
    {
      "id": 5995,
      "keyword": "factura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38971,
      "keyword": "factura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "building",
        "catering establishment",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38974,
      "keyword": "factura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "building",
        "catering establishment",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15517,
      "keyword": "factura",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "faro de bicicleta": [
    {
      "id": 5996,
      "keyword": "faro de bicicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "faros de bicicleta": [
    {
      "id": 5996,
      "keyword": "faro de bicicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¡feliz cumpleaños!": [
    {
      "id": 6499,
      "keyword": "¡Feliz Cumpleaños!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16635,
      "keyword": "¡Feliz Cumpleaños!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26788,
      "keyword": "¡Feliz Cumpleaños!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5997,
      "keyword": "¡Feliz Cumpleaños!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26786,
      "keyword": "¡Feliz Cumpleaños!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "feliz cumpleaños": [
    {
      "id": 6499,
      "keyword": "Feliz Cumpleaños",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16635,
      "keyword": "Feliz Cumpleaños",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26788,
      "keyword": "Feliz Cumpleaños",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 5997,
      "keyword": "Feliz Cumpleaños",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26786,
      "keyword": "Feliz Cumpleaños",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "freno de bicicleta": [
    {
      "id": 6001,
      "keyword": "freno de bicicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frenos de bicicleta": [
    {
      "id": 6001,
      "keyword": "freno de bicicleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "freno": [
    {
      "id": 10329,
      "keyword": "freno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6001,
      "keyword": "freno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frenos": [
    {
      "id": 10329,
      "keyword": "freno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6001,
      "keyword": "freno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuerno": [
    {
      "id": 5978,
      "keyword": "cuerno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuernos": [
    {
      "id": 5978,
      "keyword": "cuerno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asta": [
    {
      "id": 5978,
      "keyword": "asta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "astas": [
    {
      "id": 5978,
      "keyword": "asta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "garaje": [
    {
      "id": 6003,
      "keyword": "garaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24747,
      "keyword": "garaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "garajes": [
    {
      "id": 6003,
      "keyword": "garaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24747,
      "keyword": "garaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gasolinera": [
    {
      "id": 32404,
      "keyword": "gasolinera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 32404,
      "keyword": "gasolinera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6002,
      "keyword": "gasolinera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30504,
      "keyword": "gasolinera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gasolineras": [
    {
      "id": 32404,
      "keyword": "gasolinera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 32404,
      "keyword": "gasolinera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6002,
      "keyword": "gasolinera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30504,
      "keyword": "gasolinera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "genio": [
    {
      "id": 6004,
      "keyword": "genio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "genios": [
    {
      "id": 6004,
      "keyword": "genio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gimnasio": [
    {
      "id": 24785,
      "keyword": "gimnasio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6005,
      "keyword": "gimnasio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30952,
      "keyword": "gimnasio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33076,
      "keyword": "gimnasio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36397,
      "keyword": "gimnasio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38476,
      "keyword": "gimnasio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39113,
      "keyword": "gimnasio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gimnasios": [
    {
      "id": 24785,
      "keyword": "gimnasio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6005,
      "keyword": "gimnasio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30952,
      "keyword": "gimnasio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33076,
      "keyword": "gimnasio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36397,
      "keyword": "gimnasio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "physical exercise"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38476,
      "keyword": "gimnasio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39113,
      "keyword": "gimnasio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estetoscopio": [
    {
      "id": 6000,
      "keyword": "estetoscopio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estetoscopios": [
    {
      "id": 6000,
      "keyword": "estetoscopio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fonendoscopio": [
    {
      "id": 6000,
      "keyword": "fonendoscopio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fonendoscopios": [
    {
      "id": 6000,
      "keyword": "fonendoscopio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "girar": [
    {
      "id": 6006,
      "keyword": "girar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26728,
      "keyword": "girar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "position",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fisioterapia": [
    {
      "id": 5998,
      "keyword": "fisioterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "physiotherapy",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8725,
      "keyword": "fisioterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24745,
      "keyword": "fisioterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34292,
      "keyword": "fisioterapia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gol": [
    {
      "id": 6007,
      "keyword": "gol",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "goles": [
    {
      "id": 6007,
      "keyword": "gol",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "marcar gol": [
    {
      "id": 6007,
      "keyword": "marcar gol",
      "keywords": 3,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "signar": [
    {
      "id": 38428,
      "keyword": "signar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6008,
      "keyword": "signar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33978,
      "keyword": "signar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26989,
      "keyword": "signar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27963,
      "keyword": "signar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11754,
      "keyword": "signar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "iceberg": [
    {
      "id": 6014,
      "keyword": "iceberg",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "icebergs": [
    {
      "id": 6014,
      "keyword": "iceberg",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "iluminar": [
    {
      "id": 6015,
      "keyword": "iluminar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alumbrar": [
    {
      "id": 34535,
      "keyword": "alumbrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6015,
      "keyword": "alumbrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "horario": [
    {
      "id": 6012,
      "keyword": "horario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "organization",
        "work",
        "chronological device",
        "time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "horarios": [
    {
      "id": 6012,
      "keyword": "horario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "organization",
        "work",
        "chronological device",
        "time"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inaugurar": [
    {
      "id": 6016,
      "keyword": "inaugurar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inhalador": [
    {
      "id": 6017,
      "keyword": "inhalador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inhaladores": [
    {
      "id": 6017,
      "keyword": "inhalador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "flautista": [
    {
      "id": 5999,
      "keyword": "flautista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flautistas": [
    {
      "id": 5999,
      "keyword": "flautista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "el flautista de hamelín": [
    {
      "id": 5999,
      "keyword": "El flautista de Hamelín",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intermitente": [
    {
      "id": 6018,
      "keyword": "intermitente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intermitentes": [
    {
      "id": 6018,
      "keyword": "intermitente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jorobado": [
    {
      "id": 6020,
      "keyword": "jorobado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "literature",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jorobados": [
    {
      "id": 6020,
      "keyword": "jorobado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "literature",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tener una idea": [
    {
      "id": 6531,
      "keyword": "tener una idea",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6019,
      "keyword": "tener una idea",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35479,
      "keyword": "tener una idea",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inventar": [
    {
      "id": 6531,
      "keyword": "inventar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6019,
      "keyword": "inventar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35479,
      "keyword": "inventar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "descubrir": [
    {
      "id": 6531,
      "keyword": "descubrir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33062,
      "keyword": "descubrir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "history",
        "middle ages"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6019,
      "keyword": "descubrir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35479,
      "keyword": "descubrir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hola": [
    {
      "id": 6522,
      "keyword": "hola",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6009,
      "keyword": "hola",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34567,
      "keyword": "hola",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "persona indígena de áfrica": [
    {
      "id": 6011,
      "keyword": "persona indígena de África",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6282,
      "keyword": "persona indígena de África",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "africano": [
    {
      "id": 6011,
      "keyword": "africano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrazar": [
    {
      "id": 6023,
      "keyword": "abrazar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34369,
      "keyword": "abrazar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abril": [
    {
      "id": 35935,
      "keyword": "abril",
      "keywords": 1,
      "type": 6,
      "tags": [
        "time",
        "calendar",
        "month"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6024,
      "keyword": "abril",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "month",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acampar": [
    {
      "id": 6025,
      "keyword": "acampar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lago": [
    {
      "id": 6022,
      "keyword": "lago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lagos": [
    {
      "id": 6022,
      "keyword": "lago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "árabe": [
    {
      "id": 6010,
      "keyword": "árabe",
      "keywords": 2,
      "type": 4,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6150,
      "keyword": "árabe",
      "keywords": 2,
      "type": 4,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "árabes": [
    {
      "id": 6010,
      "keyword": "árabe",
      "keywords": 2,
      "type": 4,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6150,
      "keyword": "árabe",
      "keywords": 2,
      "type": 4,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugador de waterpolo": [
    {
      "id": 6021,
      "keyword": "jugador de waterpolo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadores de waterpolo": [
    {
      "id": 6021,
      "keyword": "jugador de waterpolo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agujero": [
    {
      "id": 6036,
      "keyword": "agujero",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "agujeros": [
    {
      "id": 6036,
      "keyword": "agujero",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "agachado": [
    {
      "id": 6033,
      "keyword": "agachado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agosto": [
    {
      "id": 35941,
      "keyword": "agosto",
      "keywords": 1,
      "type": 6,
      "tags": [
        "time",
        "calendar",
        "month"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6034,
      "keyword": "agosto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "month",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "álbum fotográfico": [
    {
      "id": 6039,
      "keyword": "álbum fotográfico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "álbumes fotográficos": [
    {
      "id": 6039,
      "keyword": "álbum fotográfico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "álbum": [
    {
      "id": 6039,
      "keyword": "álbum",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "álbumes": [
    {
      "id": 6039,
      "keyword": "álbum",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pasear en bicicleta": [
    {
      "id": 6045,
      "keyword": "pasear en bicicleta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "leisure",
        "outdoor activity",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "health",
        "lifestyle",
        "healthy habit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36945,
      "keyword": "pasear en bicicleta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ancla": [
    {
      "id": 6043,
      "keyword": "ancla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anclas": [
    {
      "id": 6043,
      "keyword": "ancla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "archivar": [
    {
      "id": 6908,
      "keyword": "archivar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "document",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6048,
      "keyword": "archivar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "furniture",
        "document"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25151,
      "keyword": "archivar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "document"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39431,
      "keyword": "archivar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "document",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajón de arena": [
    {
      "id": 6049,
      "keyword": "cajón de arena",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajones de arena": [
    {
      "id": 6049,
      "keyword": "cajón de arena",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arenero": [
    {
      "id": 6049,
      "keyword": "arenero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "areneros": [
    {
      "id": 6049,
      "keyword": "arenero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enfermero": [
    {
      "id": 6050,
      "keyword": "enfermero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38883,
      "keyword": "enfermero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35239,
      "keyword": "enfermero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35271,
      "keyword": "enfermero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9196,
      "keyword": "enfermero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfermeros": [
    {
      "id": 6050,
      "keyword": "enfermero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38883,
      "keyword": "enfermero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35239,
      "keyword": "enfermero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35271,
      "keyword": "enfermero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9196,
      "keyword": "enfermero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alga": [
    {
      "id": 6040,
      "keyword": "alga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "oceanography",
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "algas": [
    {
      "id": 6040,
      "keyword": "alga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "oceanography",
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paellera": [
    {
      "id": 6057,
      "keyword": "paellera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paelleras": [
    {
      "id": 6057,
      "keyword": "paellera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bajar": [
    {
      "id": 24723,
      "keyword": "bajar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6053,
      "keyword": "bajar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 19557,
      "keyword": "bajar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baldosa": [
    {
      "id": 6054,
      "keyword": "baldosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baldosas": [
    {
      "id": 6054,
      "keyword": "baldosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "besar": [
    {
      "id": 6062,
      "keyword": "besar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34699,
      "keyword": "besar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajero": [
    {
      "id": 6069,
      "keyword": "cajero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11197,
      "keyword": "cajero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajeros": [
    {
      "id": 6069,
      "keyword": "cajero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11197,
      "keyword": "cajero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cajón": [
    {
      "id": 24921,
      "keyword": "cajón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6070,
      "keyword": "cajón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23867,
      "keyword": "cajón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajones": [
    {
      "id": 24921,
      "keyword": "cajón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6070,
      "keyword": "cajón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23867,
      "keyword": "cajón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caja fuerte": [
    {
      "id": 6068,
      "keyword": "caja fuerte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajas fuertes": [
    {
      "id": 6068,
      "keyword": "caja fuerte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mozo": [
    {
      "id": 6072,
      "keyword": "mozo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38760,
      "keyword": "mozo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mozos": [
    {
      "id": 6072,
      "keyword": "mozo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38760,
      "keyword": "mozo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bombera": [
    {
      "id": 6066,
      "keyword": "bombera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11193,
      "keyword": "bombera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bomberas": [
    {
      "id": 6066,
      "keyword": "bombera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11193,
      "keyword": "bombera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolsa de basura": [
    {
      "id": 6065,
      "keyword": "bolsa de basura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 6065,
      "keyword": "bolsa de basura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas de basura": [
    {
      "id": 6065,
      "keyword": "bolsa de basura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 6065,
      "keyword": "bolsa de basura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carrito de bebidas": [
    {
      "id": 6077,
      "keyword": "carrito de bebidas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carritos de bebidas": [
    {
      "id": 6077,
      "keyword": "carrito de bebidas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "linterna": [
    {
      "id": 6138,
      "keyword": "linterna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "linternas": [
    {
      "id": 6138,
      "keyword": "linterna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llevar": [
    {
      "id": 6553,
      "keyword": "llevar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6139,
      "keyword": "llevar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37223,
      "keyword": "llevar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lobo feroz": [
    {
      "id": 6140,
      "keyword": "Lobo Feroz",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36608,
      "keyword": "Lobo Feroz",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fonoaudiólogo": [
    {
      "id": 23396,
      "keyword": "fonoaudiólogo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23396,
      "keyword": "fonoaudiólogo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37355,
      "keyword": "fonoaudiólogo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6141,
      "keyword": "fonoaudiólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32910,
      "keyword": "fonoaudiólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32910,
      "keyword": "fonoaudiólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fonoaudiólogos": [
    {
      "id": 37355,
      "keyword": "fonoaudiólogo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6141,
      "keyword": "fonoaudiólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "logopedia": [
    {
      "id": 32428,
      "keyword": "logopedia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "speech therapy",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6142,
      "keyword": "logopedia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "speech therapy",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fonoaudiología": [
    {
      "id": 32428,
      "keyword": "fonoaudiología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "speech therapy",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6142,
      "keyword": "fonoaudiología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "speech therapy",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "madera": [
    {
      "id": 6143,
      "keyword": "madera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "vegetal origin material",
        "work",
        "secondary sector",
        "carpentry",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maderas": [
    {
      "id": 6143,
      "keyword": "madera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "vegetal origin material",
        "work",
        "secondary sector",
        "carpentry",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tablón": [
    {
      "id": 6143,
      "keyword": "tablón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "vegetal origin material",
        "work",
        "secondary sector",
        "carpentry",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6997,
      "keyword": "tablón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tablones": [
    {
      "id": 6143,
      "keyword": "tablón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "vegetal origin material",
        "work",
        "secondary sector",
        "carpentry",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6997,
      "keyword": "tablón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "persona indígena de ártico": [
    {
      "id": 6135,
      "keyword": "persona indígena de Ártico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "character",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6151,
      "keyword": "persona indígena de Ártico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "character",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esquimal": [
    {
      "id": 6135,
      "keyword": "esquimal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "character",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6151,
      "keyword": "esquimal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "character",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esquimales": [
    {
      "id": 6135,
      "keyword": "esquimal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "character",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6151,
      "keyword": "esquimal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "character",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "marcador": [
    {
      "id": 6147,
      "keyword": "marcador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7807,
      "keyword": "marcador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marcadores": [
    {
      "id": 6147,
      "keyword": "marcador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "basketball"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7807,
      "keyword": "marcador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "resultado": [
    {
      "id": 32802,
      "keyword": "resultado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6147,
      "keyword": "resultado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 19531,
      "keyword": "resultado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 19533,
      "keyword": "resultado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "resultados": [
    {
      "id": 32802,
      "keyword": "resultado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6147,
      "keyword": "resultado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "basketball"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 19531,
      "keyword": "resultado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event",
        "football"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 19533,
      "keyword": "resultado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "metal": [
    {
      "id": 6148,
      "keyword": "metal",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "metales": [
    {
      "id": 6148,
      "keyword": "metal",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "metálico": [
    {
      "id": 6148,
      "keyword": "metálico",
      "keywords": 3,
      "type": 4,
      "tags": [
        "material",
        "derived material",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "metálicos": [
    {
      "id": 6148,
      "keyword": "metálico",
      "keywords": 3,
      "type": 4,
      "tags": [
        "material",
        "derived material",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "metálica": [
    {
      "id": 6148,
      "keyword": "metálica",
      "keywords": 3,
      "type": 4,
      "tags": [
        "material",
        "derived material",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "metálicas": [
    {
      "id": 6148,
      "keyword": "metálica",
      "keywords": 3,
      "type": 4,
      "tags": [
        "material",
        "derived material",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mojada": [
    {
      "id": 25253,
      "keyword": "mojada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6149,
      "keyword": "mojada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mojadas": [
    {
      "id": 25253,
      "keyword": "mojada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6149,
      "keyword": "mojada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mamá osa": [
    {
      "id": 6144,
      "keyword": "Mamá Osa",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "persona indígena de india": [
    {
      "id": 6152,
      "keyword": "persona indígena de India",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "india": [
    {
      "id": 25165,
      "keyword": "India",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6152,
      "keyword": "india",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10339,
      "keyword": "india",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "character",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25484,
      "keyword": "India",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manillar": [
    {
      "id": 6145,
      "keyword": "manillar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manillares": [
    {
      "id": 6145,
      "keyword": "manillar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "muletas": [
    {
      "id": 6154,
      "keyword": "muletas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8361,
      "keyword": "muleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nutria": [
    {
      "id": 6158,
      "keyword": "nutria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nutrias": [
    {
      "id": 6158,
      "keyword": "nutria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "faquir": [
    {
      "id": 6136,
      "keyword": "faquir",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "character",
        "book character",
        "literature",
        "tale character"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "faquires": [
    {
      "id": 6136,
      "keyword": "faquir",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "character",
        "book character",
        "literature",
        "tale character"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ogro": [
    {
      "id": 6160,
      "keyword": "ogro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ogros": [
    {
      "id": 6160,
      "keyword": "ogro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oasis": [
    {
      "id": 6159,
      "keyword": "oasis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oso pequeño": [
    {
      "id": 6162,
      "keyword": "Oso Pequeño",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oso pequeños": [
    {
      "id": 6162,
      "keyword": "Oso Pequeño",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oro": [
    {
      "id": 6161,
      "keyword": "oro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "semicorchea": [
    {
      "id": 6157,
      "keyword": "semicorchea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "semicorcheas": [
    {
      "id": 6157,
      "keyword": "semicorchea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paja": [
    {
      "id": 6163,
      "keyword": "paja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "cattle farming",
        "animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6164,
      "keyword": "paja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pajas": [
    {
      "id": 6163,
      "keyword": "paja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "cattle farming",
        "animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6164,
      "keyword": "paja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paca": [
    {
      "id": 6163,
      "keyword": "paca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "cattle farming",
        "animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pacas": [
    {
      "id": 6163,
      "keyword": "paca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "cattle farming",
        "animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "yo no quiero": [
    {
      "id": 6156,
      "keyword": "yo no quiero",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary",
        "object",
        "feeding",
        "movement",
        "traffic",
        "mode of transport",
        "education",
        "educational material",
        "leisure",
        "sport",
        "sport material",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "no querer": [
    {
      "id": 6156,
      "keyword": "no querer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary",
        "object",
        "feeding",
        "movement",
        "traffic",
        "mode of transport",
        "education",
        "educational material",
        "leisure",
        "sport",
        "sport material",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "no quiero": [
    {
      "id": 6156,
      "keyword": "no quiero",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary",
        "object",
        "feeding",
        "movement",
        "traffic",
        "mode of transport",
        "education",
        "educational material",
        "leisure",
        "sport",
        "sport material",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paracaidista": [
    {
      "id": 6167,
      "keyword": "paracaidista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paracaidistas": [
    {
      "id": 6167,
      "keyword": "paracaidista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "papel de cocina": [
    {
      "id": 6166,
      "keyword": "papel de cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papeles de cocina": [
    {
      "id": 6166,
      "keyword": "papel de cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pasaporte": [
    {
      "id": 6171,
      "keyword": "pasaporte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasaportes": [
    {
      "id": 6171,
      "keyword": "pasaporte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "partido": [
    {
      "id": 6170,
      "keyword": "partido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show",
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "partidos": [
    {
      "id": 6170,
      "keyword": "partido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show",
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "no gustar": [
    {
      "id": 37825,
      "keyword": "no gustar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression",
        "core vocabulary",
        "object",
        "place",
        "leisure",
        "sport",
        "event",
        "movement",
        "traffic",
        "mode of transport",
        "usual verbs",
        "education",
        "toy",
        "traditional game",
        "game",
        "show",
        "work",
        "outdoor activity",
        "facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7179,
      "keyword": "no gustar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "core vocabulary",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22005,
      "keyword": "no gustar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38888,
      "keyword": "no gustar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38890,
      "keyword": "no gustar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6155,
      "keyword": "no gustar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31760,
      "keyword": "no gustar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "no me gusta eso": [
    {
      "id": 37825,
      "keyword": "no me gusta eso",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression",
        "core vocabulary",
        "object",
        "place",
        "leisure",
        "sport",
        "event",
        "movement",
        "traffic",
        "mode of transport",
        "usual verbs",
        "education",
        "toy",
        "traditional game",
        "game",
        "show",
        "work",
        "outdoor activity",
        "facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7179,
      "keyword": "no me gusta eso",
      "keywords": 4,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "core vocabulary",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22005,
      "keyword": "no me gusta eso",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38888,
      "keyword": "no me gusta eso",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38890,
      "keyword": "no me gusta eso",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6155,
      "keyword": "no me gusta eso",
      "keywords": 4,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31760,
      "keyword": "no me gusta eso",
      "keywords": 4,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desagradable": [
    {
      "id": 7179,
      "keyword": "desagradable",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "core vocabulary",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32338,
      "keyword": "desagradable",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37801,
      "keyword": "desagradable",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8548,
      "keyword": "desagradable",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31867,
      "keyword": "desagradable",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10195,
      "keyword": "desagradable",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32150,
      "keyword": "desagradable",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6155,
      "keyword": "desagradable",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6902,
      "keyword": "desagradable",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31760,
      "keyword": "desagradable",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desagradables": [
    {
      "id": 7179,
      "keyword": "desagradable",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "core vocabulary",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32338,
      "keyword": "desagradable",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37801,
      "keyword": "desagradable",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8548,
      "keyword": "desagradable",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31867,
      "keyword": "desagradable",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10195,
      "keyword": "desagradable",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32150,
      "keyword": "desagradable",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6155,
      "keyword": "desagradable",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6902,
      "keyword": "desagradable",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31760,
      "keyword": "desagradable",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desagradar": [
    {
      "id": 7179,
      "keyword": "desagradar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "core vocabulary",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37801,
      "keyword": "desagradar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10195,
      "keyword": "desagradar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32150,
      "keyword": "desagradar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6155,
      "keyword": "desagradar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6902,
      "keyword": "desagradar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31760,
      "keyword": "desagradar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pedal": [
    {
      "id": 6172,
      "keyword": "pedal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pedales": [
    {
      "id": 6172,
      "keyword": "pedal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parachoques": [
    {
      "id": 6168,
      "keyword": "parachoques",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papá oso": [
    {
      "id": 6165,
      "keyword": "Papá Oso",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papás oso": [
    {
      "id": 6165,
      "keyword": "Papá Oso",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pajita": [
    {
      "id": 6164,
      "keyword": "pajita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pajitas": [
    {
      "id": 6164,
      "keyword": "pajita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pedalear": [
    {
      "id": 6173,
      "keyword": "pedalear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parapente": [
    {
      "id": 6169,
      "keyword": "parapente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parapentes": [
    {
      "id": 6169,
      "keyword": "parapente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pinocho": [
    {
      "id": 6177,
      "keyword": "Pinocho",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinza": [
    {
      "id": 6178,
      "keyword": "pinza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8466,
      "keyword": "pinza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35191,
      "keyword": "pinza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24292,
      "keyword": "pinza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pesas": [
    {
      "id": 35493,
      "keyword": "pesas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6176,
      "keyword": "pesas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piscina cubierta": [
    {
      "id": 30514,
      "keyword": "piscina cubierta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6181,
      "keyword": "piscina cubierta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piscinas cubiertas": [
    {
      "id": 30514,
      "keyword": "piscina cubierta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6181,
      "keyword": "piscina cubierta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "swimming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pileta  cubierta": [
    {
      "id": 6181,
      "keyword": "pileta  cubierta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piletas cubiertas": [
    {
      "id": 30514,
      "keyword": "pileta cubierta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6181,
      "keyword": "pileta  cubierta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "swimming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silbato": [
    {
      "id": 6182,
      "keyword": "silbato",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "silbatos": [
    {
      "id": 6182,
      "keyword": "silbato",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pito": [
    {
      "id": 6182,
      "keyword": "pito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pitos": [
    {
      "id": 6182,
      "keyword": "pito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plaza": [
    {
      "id": 6185,
      "keyword": "plaza",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "bullfighting",
        "communication",
        "signaling system",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6184,
      "keyword": "plaza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plazas": [
    {
      "id": 6185,
      "keyword": "plaza",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "bullfighting",
        "communication",
        "signaling system",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6184,
      "keyword": "plaza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plata": [
    {
      "id": 6183,
      "keyword": "plata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelicano": [
    {
      "id": 6174,
      "keyword": "pelicano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelicanos": [
    {
      "id": 6174,
      "keyword": "pelicano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perder": [
    {
      "id": 24779,
      "keyword": "perder",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24760,
      "keyword": "perder",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26314,
      "keyword": "perder",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38987,
      "keyword": "perder",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6175,
      "keyword": "perder",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22031,
      "keyword": "perder",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22033,
      "keyword": "perder",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24759,
      "keyword": "perder",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24780,
      "keyword": "perder",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31894,
      "keyword": "perder",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 19533,
      "keyword": "perder",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plaza de toros": [
    {
      "id": 6185,
      "keyword": "plaza de toros",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "bullfighting",
        "communication",
        "signaling system",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plazas de toros": [
    {
      "id": 6185,
      "keyword": "plaza de toros",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "bullfighting",
        "communication",
        "signaling system",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ruedo": [
    {
      "id": 6185,
      "keyword": "ruedo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "bullfighting",
        "communication",
        "signaling system",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ruedos": [
    {
      "id": 6185,
      "keyword": "ruedo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "bullfighting",
        "communication",
        "signaling system",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pabellón": [
    {
      "id": 6186,
      "keyword": "pabellón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pabellones": [
    {
      "id": 6186,
      "keyword": "pabellón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "polideportivo": [
    {
      "id": 32504,
      "keyword": "polideportivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6186,
      "keyword": "polideportivo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "polideportivos": [
    {
      "id": 32504,
      "keyword": "polideportivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6186,
      "keyword": "polideportivo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cancha": [
    {
      "id": 6186,
      "keyword": "cancha",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canchas": [
    {
      "id": 6186,
      "keyword": "cancha",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pirata": [
    {
      "id": 6180,
      "keyword": "pirata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature",
        "movie character",
        "cinema",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piratas": [
    {
      "id": 6180,
      "keyword": "pirata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature",
        "movie character",
        "cinema",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "polo norte": [
    {
      "id": 6187,
      "keyword": "Polo Norte",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "polo sur": [
    {
      "id": 6188,
      "keyword": "Polo Sur",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piragua": [
    {
      "id": 6179,
      "keyword": "piragua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piraguas": [
    {
      "id": 6179,
      "keyword": "piragua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "canoa": [
    {
      "id": 8526,
      "keyword": "canoa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6179,
      "keyword": "canoa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canoas": [
    {
      "id": 8526,
      "keyword": "canoa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6179,
      "keyword": "canoa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aula de psicomotricidad": [
    {
      "id": 27321,
      "keyword": "aula de psicomotricidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6193,
      "keyword": "aula de psicomotricidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10346,
      "keyword": "aula de psicomotricidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31048,
      "keyword": "aula de psicomotricidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aulas de psicomotricidad": [
    {
      "id": 27321,
      "keyword": "aula de psicomotricidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6193,
      "keyword": "aula de psicomotricidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10346,
      "keyword": "aula de psicomotricidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31048,
      "keyword": "aula de psicomotricidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "`psicomotricidad": [
    {
      "id": 6193,
      "keyword": "`psicomotricidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "radio": [
    {
      "id": 26358,
      "keyword": "radio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media",
        "mass media device",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 20119,
      "keyword": "radio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31199,
      "keyword": "radio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "telecommunication",
        "communication",
        "signaling system",
        "mass media",
        "workplace"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38211,
      "keyword": "radio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6197,
      "keyword": "radio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11354,
      "keyword": "radio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media",
        "mass media device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24336,
      "keyword": "radio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "radios": [
    {
      "id": 26358,
      "keyword": "radio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media",
        "mass media device",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 20119,
      "keyword": "radio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31199,
      "keyword": "radio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "telecommunication",
        "communication",
        "signaling system",
        "mass media",
        "workplace"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38211,
      "keyword": "radio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6197,
      "keyword": "radio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11354,
      "keyword": "radio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media",
        "mass media device"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24336,
      "keyword": "radio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rascacielos": [
    {
      "id": 6199,
      "keyword": "rascacielos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rayos x": [
    {
      "id": 33104,
      "keyword": "rayos x",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33105,
      "keyword": "rayos x",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6198,
      "keyword": "rayos x",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "radiografía": [
    {
      "id": 6198,
      "keyword": "radiografía",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "radiografías": [
    {
      "id": 6198,
      "keyword": "radiografía",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rx": [
    {
      "id": 6198,
      "keyword": "rx",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rastrillo": [
    {
      "id": 6200,
      "keyword": "rastrillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37537,
      "keyword": "rastrillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9120,
      "keyword": "rastrillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rastrillos": [
    {
      "id": 6200,
      "keyword": "rastrillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37537,
      "keyword": "rastrillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9120,
      "keyword": "rastrillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "joystick": [
    {
      "id": 6201,
      "keyword": "joystick",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "joysticks": [
    {
      "id": 6201,
      "keyword": "joystick",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ratón de joystick": [
    {
      "id": 6201,
      "keyword": "ratón de joystick",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ratones de joystick": [
    {
      "id": 6201,
      "keyword": "ratón de joystick",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quemar": [
    {
      "id": 6196,
      "keyword": "quemar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rebajas": [
    {
      "id": 6202,
      "keyword": "rebajas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recibidor": [
    {
      "id": 6203,
      "keyword": "recibidor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38432,
      "keyword": "recibidor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recibidores": [
    {
      "id": 6203,
      "keyword": "recibidor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38432,
      "keyword": "recibidor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "remo": [
    {
      "id": 6206,
      "keyword": "remo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "remos": [
    {
      "id": 6206,
      "keyword": "remo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "robot": [
    {
      "id": 6208,
      "keyword": "robot",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "character",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "robots": [
    {
      "id": 6208,
      "keyword": "robot",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "character",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recreo": [
    {
      "id": 6204,
      "keyword": "recreo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33064,
      "keyword": "recreo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "core vocabulary",
        "place",
        "facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8681,
      "keyword": "recreo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27339,
      "keyword": "recreo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "teaching activity",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33065,
      "keyword": "recreo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recreos": [
    {
      "id": 6204,
      "keyword": "recreo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33064,
      "keyword": "recreo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "core vocabulary",
        "place",
        "facility"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8681,
      "keyword": "recreo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27339,
      "keyword": "recreo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "teaching activity",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33065,
      "keyword": "recreo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "patio": [
    {
      "id": 6204,
      "keyword": "patio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33064,
      "keyword": "patio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "core vocabulary",
        "place",
        "facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33065,
      "keyword": "patio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patios": [
    {
      "id": 6204,
      "keyword": "patio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33064,
      "keyword": "patio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "core vocabulary",
        "place",
        "facility"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33065,
      "keyword": "patio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ricitos de oro": [
    {
      "id": 6207,
      "keyword": "Ricitos de Oro",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presa": [
    {
      "id": 39190,
      "keyword": "presa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "animal behavior",
        "wild"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6191,
      "keyword": "presa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11349,
      "keyword": "presa",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presas": [
    {
      "id": 39190,
      "keyword": "presa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "animal behavior",
        "wild"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6191,
      "keyword": "presa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11349,
      "keyword": "presa",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dique": [
    {
      "id": 6191,
      "keyword": "dique",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diques": [
    {
      "id": 6191,
      "keyword": "dique",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "preparar": [
    {
      "id": 6190,
      "keyword": "preparar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "defender": [
    {
      "id": 36516,
      "keyword": "defender",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36521,
      "keyword": "defender",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6599,
      "keyword": "defender",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "group",
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38809,
      "keyword": "defender",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "child",
        "family",
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6192,
      "keyword": "defender",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "sociology",
        "social movement",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "proteger": [
    {
      "id": 6599,
      "keyword": "proteger",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "group",
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38809,
      "keyword": "proteger",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "child",
        "family",
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6192,
      "keyword": "proteger",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "sociology",
        "social movement",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulsador": [
    {
      "id": 6195,
      "keyword": "pulsador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "communication",
        "augmentative communication",
        "communication aid",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 6195,
      "keyword": "pulsador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "communication",
        "augmentative communication",
        "communication aid",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27252,
      "keyword": "pulsador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulsadores": [
    {
      "id": 6195,
      "keyword": "pulsador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "communication",
        "augmentative communication",
        "communication aid",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 6195,
      "keyword": "pulsador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "communication",
        "augmentative communication",
        "communication aid",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27252,
      "keyword": "pulsador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conmutador": [
    {
      "id": 6195,
      "keyword": "conmutador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "communication",
        "augmentative communication",
        "communication aid",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 6195,
      "keyword": "conmutador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "communication",
        "augmentative communication",
        "communication aid",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27252,
      "keyword": "conmutador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conmutadores": [
    {
      "id": 6195,
      "keyword": "conmutador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "communication",
        "augmentative communication",
        "communication aid",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 6195,
      "keyword": "conmutador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "communication",
        "augmentative communication",
        "communication aid",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27252,
      "keyword": "conmutador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "soltar": [
    {
      "id": 6215,
      "keyword": "soltar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dejar": [
    {
      "id": 6215,
      "keyword": "dejar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sorber": [
    {
      "id": 6616,
      "keyword": "sorber",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6217,
      "keyword": "sorber",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sombrero de copa": [
    {
      "id": 6216,
      "keyword": "sombrero de copa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sombreros de copa": [
    {
      "id": 6216,
      "keyword": "sombrero de copa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "subrayar": [
    {
      "id": 6219,
      "keyword": "subrayar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salón": [
    {
      "id": 6211,
      "keyword": "salón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33074,
      "keyword": "salón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salones": [
    {
      "id": 6211,
      "keyword": "salón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33074,
      "keyword": "salón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silla de ruedas": [
    {
      "id": 25471,
      "keyword": "silla de ruedas",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9122,
      "keyword": "silla de ruedas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25467,
      "keyword": "silla de ruedas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6212,
      "keyword": "silla de ruedas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28085,
      "keyword": "silla de ruedas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9121,
      "keyword": "silla de ruedas",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas de ruedas": [
    {
      "id": 25471,
      "keyword": "silla de ruedas",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9122,
      "keyword": "silla de ruedas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25467,
      "keyword": "silla de ruedas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6212,
      "keyword": "silla de ruedas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28085,
      "keyword": "silla de ruedas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9121,
      "keyword": "silla de ruedas",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sillín": [
    {
      "id": 6213,
      "keyword": "sillín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillines": [
    {
      "id": 6213,
      "keyword": "sillín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taller": [
    {
      "id": 24507,
      "keyword": "taller",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6225,
      "keyword": "taller",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "workplace",
        "work",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11655,
      "keyword": "taller",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32424,
      "keyword": "taller",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9805,
      "keyword": "taller",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35393,
      "keyword": "taller",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talleres": [
    {
      "id": 24507,
      "keyword": "taller",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6225,
      "keyword": "taller",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "workplace",
        "work",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11655,
      "keyword": "taller",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32424,
      "keyword": "taller",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9805,
      "keyword": "taller",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35393,
      "keyword": "taller",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tatuaje": [
    {
      "id": 6227,
      "keyword": "tatuaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tatuajes": [
    {
      "id": 6227,
      "keyword": "tatuaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tendedero": [
    {
      "id": 6228,
      "keyword": "tendedero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11384,
      "keyword": "tendedero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "object",
        "fashion",
        "clothes",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tendederos": [
    {
      "id": 6228,
      "keyword": "tendedero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11384,
      "keyword": "tendedero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "object",
        "fashion",
        "clothes",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "talar": [
    {
      "id": 6224,
      "keyword": "talar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "forestry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir el volumen": [
    {
      "id": 6218,
      "keyword": "subir el volumen",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir la potencia": [
    {
      "id": 6218,
      "keyword": "subir la potencia",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sube el volumen": [
    {
      "id": 6218,
      "keyword": "sube el volumen",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tesoro": [
    {
      "id": 6229,
      "keyword": "tesoro",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "tesoros": [
    {
      "id": 6229,
      "keyword": "tesoro",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "surtidor": [
    {
      "id": 6221,
      "keyword": "surtidor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "surtidores": [
    {
      "id": 6221,
      "keyword": "surtidor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "torre": [
    {
      "id": 34165,
      "keyword": "torre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "chess"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6232,
      "keyword": "torre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38648,
      "keyword": "torre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torres": [
    {
      "id": 34165,
      "keyword": "torre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "chess"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6232,
      "keyword": "torre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38648,
      "keyword": "torre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "toallitas húmedas": [
    {
      "id": 6231,
      "keyword": "toallitas húmedas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toallitas": [
    {
      "id": 6231,
      "keyword": "toallitas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trombón": [
    {
      "id": 6233,
      "keyword": "trombón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trombones": [
    {
      "id": 6233,
      "keyword": "trombón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tachar": [
    {
      "id": 6223,
      "keyword": "tachar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30851,
      "keyword": "tachar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trompa": [
    {
      "id": 6234,
      "keyword": "trompa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7287,
      "keyword": "trompa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trompas": [
    {
      "id": 6234,
      "keyword": "trompa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7287,
      "keyword": "trompa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vampiro": [
    {
      "id": 6239,
      "keyword": "vampiro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "literature",
        "movie character",
        "cinema",
        "event",
        "popular event",
        "halloween",
        "object",
        "fashion",
        "clothes",
        "costume",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vampiros": [
    {
      "id": 6239,
      "keyword": "vampiro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "literature",
        "movie character",
        "cinema",
        "event",
        "popular event",
        "halloween",
        "object",
        "fashion",
        "clothes",
        "costume",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "valle": [
    {
      "id": 6238,
      "keyword": "valle",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "place",
        "rural area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "valles": [
    {
      "id": 6238,
      "keyword": "valle",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "place",
        "rural area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vecinos": [
    {
      "id": 26529,
      "keyword": "vecinos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "group",
        "core vocabulary",
        "place",
        "building"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 26529,
      "keyword": "vecinos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "group",
        "core vocabulary",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26529,
      "keyword": "vecino",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "group",
        "core vocabulary",
        "place",
        "building"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 26529,
      "keyword": "vecino",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "group",
        "core vocabulary",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37228,
      "keyword": "vecino",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6241,
      "keyword": "vecinos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vecindario": [
    {
      "id": 26529,
      "keyword": "vecindario",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "group",
        "core vocabulary",
        "place",
        "building"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 26529,
      "keyword": "vecindario",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "group",
        "core vocabulary",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6241,
      "keyword": "vecindario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vecindarios": [
    {
      "id": 26529,
      "keyword": "vecindario",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "group",
        "core vocabulary",
        "place",
        "building"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 26529,
      "keyword": "vecindario",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "group",
        "core vocabulary",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6241,
      "keyword": "vecindario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vela": [
    {
      "id": 6242,
      "keyword": "vela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7294,
      "keyword": "vela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37302,
      "keyword": "vela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "religion",
        "christianity",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "velas": [
    {
      "id": 6242,
      "keyword": "vela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7294,
      "keyword": "vela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37302,
      "keyword": "vela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "religion",
        "christianity",
        "judaism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "unicornio": [
    {
      "id": 6237,
      "keyword": "unicornio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "unicornios": [
    {
      "id": 6237,
      "keyword": "unicornio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "venda": [
    {
      "id": 6243,
      "keyword": "venda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vendas": [
    {
      "id": 6243,
      "keyword": "venda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hortalizas": [
    {
      "id": 28343,
      "keyword": "hortalizas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6244,
      "keyword": "hortalizas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7130,
      "keyword": "hortalizas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "volar": [
    {
      "id": 6246,
      "keyword": "volar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "animal",
        "animal physiology",
        "core vocabulary",
        "vertebrate",
        "bird",
        "flying animal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16113,
      "keyword": "volar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tuba": [
    {
      "id": 6235,
      "keyword": "tuba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tubas": [
    {
      "id": 6235,
      "keyword": "tuba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "brazo articulado": [
    {
      "id": 6280,
      "keyword": "brazo articulado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brazos articulados": [
    {
      "id": 6280,
      "keyword": "brazo articulado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "varita mágica": [
    {
      "id": 6240,
      "keyword": "varita mágica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "varitas mágicas": [
    {
      "id": 6240,
      "keyword": "varita mágica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "varita": [
    {
      "id": 6240,
      "keyword": "varita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "varitas": [
    {
      "id": 6240,
      "keyword": "varita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "volcán": [
    {
      "id": 6247,
      "keyword": "volcán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "volcanes": [
    {
      "id": 6247,
      "keyword": "volcán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "volver": [
    {
      "id": 6630,
      "keyword": "volver",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6248,
      "keyword": "volver",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31748,
      "keyword": "volver",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vuelta": [
    {
      "id": 6630,
      "keyword": "vuelta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6248,
      "keyword": "vuelta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31748,
      "keyword": "vuelta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28833,
      "keyword": "vuelta",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vueltas": [
    {
      "id": 6630,
      "keyword": "vuelta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6248,
      "keyword": "vuelta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31748,
      "keyword": "vuelta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28833,
      "keyword": "vuelta",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silla de niños": [
    {
      "id": 6281,
      "keyword": "silla de niños",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas de niños": [
    {
      "id": 6281,
      "keyword": "silla de niños",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silla de paseo": [
    {
      "id": 6281,
      "keyword": "silla de paseo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas de paseo": [
    {
      "id": 6281,
      "keyword": "silla de paseo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tablero de comunicación": [
    {
      "id": 26475,
      "keyword": "tablero de comunicación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6222,
      "keyword": "tablero de comunicación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24707,
      "keyword": "tablero de comunicación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31882,
      "keyword": "tablero de comunicación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tableros de comunicación": [
    {
      "id": 26475,
      "keyword": "tablero de comunicación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6222,
      "keyword": "tablero de comunicación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24707,
      "keyword": "tablero de comunicación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31882,
      "keyword": "tablero de comunicación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tablero": [
    {
      "id": 26475,
      "keyword": "tablero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6222,
      "keyword": "tablero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31882,
      "keyword": "tablero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tableros": [
    {
      "id": 26475,
      "keyword": "tablero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6222,
      "keyword": "tablero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31882,
      "keyword": "tablero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "turista": [
    {
      "id": 28386,
      "keyword": "turista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6236,
      "keyword": "turista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28385,
      "keyword": "turista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29644,
      "keyword": "turista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "turistas": [
    {
      "id": 28386,
      "keyword": "turista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6236,
      "keyword": "turista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28385,
      "keyword": "turista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29644,
      "keyword": "turista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "africana": [
    {
      "id": 6282,
      "keyword": "africana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodear": [
    {
      "id": 26396,
      "keyword": "rodear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6285,
      "keyword": "rodear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tela de araña": [
    {
      "id": 6286,
      "keyword": "tela de araña",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "telas de araña": [
    {
      "id": 6286,
      "keyword": "tela de araña",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "telaraña": [
    {
      "id": 6286,
      "keyword": "telaraña",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "telarañas": [
    {
      "id": 6286,
      "keyword": "telaraña",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coger": [
    {
      "id": 6453,
      "keyword": "coger",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32773,
      "keyword": "coger",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17044,
      "keyword": "coger",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10148,
      "keyword": "coger",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6452,
      "keyword": "coger",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35019,
      "keyword": "coger",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17042,
      "keyword": "coger",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carpa de circo": [
    {
      "id": 6450,
      "keyword": "carpa de circo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "scenic art",
        "circus",
        "show",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carpas de circo": [
    {
      "id": 6450,
      "keyword": "carpa de circo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "scenic art",
        "circus",
        "show",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "circo": [
    {
      "id": 6450,
      "keyword": "circo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "scenic art",
        "circus",
        "show",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "circos": [
    {
      "id": 6450,
      "keyword": "circo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "scenic art",
        "circus",
        "show",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aparcamiento": [
    {
      "id": 6283,
      "keyword": "aparcamiento",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aparcamientos": [
    {
      "id": 6283,
      "keyword": "aparcamiento",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parking": [
    {
      "id": 24755,
      "keyword": "parking",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6283,
      "keyword": "parking",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parkings": [
    {
      "id": 24755,
      "keyword": "parking",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6283,
      "keyword": "parking",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parquing": [
    {
      "id": 24755,
      "keyword": "parquing",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6283,
      "keyword": "parquing",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aparcadero": [
    {
      "id": 24755,
      "keyword": "aparcadero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6283,
      "keyword": "aparcadero",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aparcaderos": [
    {
      "id": 24755,
      "keyword": "aparcadero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6283,
      "keyword": "aparcadero",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estacionamiento": [
    {
      "id": 24755,
      "keyword": "estacionamiento",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6283,
      "keyword": "estacionamiento",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estacionamientos": [
    {
      "id": 24755,
      "keyword": "estacionamiento",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6283,
      "keyword": "estacionamiento",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chóferes": [
    {
      "id": 6459,
      "keyword": "chófer",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28435,
      "keyword": "chófer",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11223,
      "keyword": "chófer",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32916,
      "keyword": "chófer",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chofer": [
    {
      "id": 6459,
      "keyword": "chofer",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28435,
      "keyword": "chofer",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "choferes": [
    {
      "id": 6459,
      "keyword": "chofer",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28435,
      "keyword": "chofer",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comprar": [
    {
      "id": 8986,
      "keyword": "comprar",
      "keywords": 8,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "work",
        "tertiary sector",
        "trade",
        "core vocabulary",
        "place",
        "building",
        "feeding",
        "food",
        "object",
        "cleaning product",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6457,
      "keyword": "comprar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money",
        "usual verbs",
        "core vocabulary",
        "object",
        "movement",
        "traffic",
        "mode of transport",
        "leisure",
        "sport",
        "toy",
        "game",
        "education",
        "educational material",
        "sport material",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8985,
      "keyword": "comprar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28665,
      "keyword": "comprar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pagar": [
    {
      "id": 6457,
      "keyword": "pagar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money",
        "usual verbs",
        "core vocabulary",
        "object",
        "movement",
        "traffic",
        "mode of transport",
        "leisure",
        "sport",
        "toy",
        "game",
        "education",
        "educational material",
        "sport material",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9014,
      "keyword": "pagar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29070,
      "keyword": "pagar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adquirir": [
    {
      "id": 6457,
      "keyword": "adquirir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money",
        "usual verbs",
        "core vocabulary",
        "object",
        "movement",
        "traffic",
        "mode of transport",
        "leisure",
        "sport",
        "toy",
        "game",
        "education",
        "educational material",
        "sport material",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "devolver un libro": [
    {
      "id": 24771,
      "keyword": "devolver un libro",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "library science"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6474,
      "keyword": "devolver un libro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "devolver": [
    {
      "id": 9026,
      "keyword": "devolver",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24771,
      "keyword": "devolver",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "library science"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6474,
      "keyword": "devolver",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ordenar los libros": [
    {
      "id": 6474,
      "keyword": "ordenar los libros",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "domingo": [
    {
      "id": 37725,
      "keyword": "domingo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6478,
      "keyword": "domingo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "él": [
    {
      "id": 6481,
      "keyword": "él",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31670,
      "keyword": "él",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6480,
      "keyword": "él",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "él se": [
    {
      "id": 6481,
      "keyword": "él se",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31670,
      "keyword": "él se",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6480,
      "keyword": "él se",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diciembre": [
    {
      "id": 35937,
      "keyword": "diciembre",
      "keywords": 1,
      "type": 6,
      "tags": [
        "time",
        "calendar",
        "month"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6476,
      "keyword": "diciembre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "month",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brillante": [
    {
      "id": 6475,
      "keyword": "brillante",
      "keywords": 4,
      "type": 4,
      "tags": [
        "material",
        "raw material",
        "mineral origin material",
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6475,
      "keyword": "brillante",
      "keywords": 4,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material",
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brillantes": [
    {
      "id": 6475,
      "keyword": "brillante",
      "keywords": 4,
      "type": 4,
      "tags": [
        "material",
        "raw material",
        "mineral origin material",
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6475,
      "keyword": "brillante",
      "keywords": 4,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material",
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diamante": [
    {
      "id": 6475,
      "keyword": "diamante",
      "keywords": 4,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material",
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diamantes": [
    {
      "id": 6475,
      "keyword": "diamante",
      "keywords": 4,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material",
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "brillar": [
    {
      "id": 6475,
      "keyword": "brillar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "material",
        "raw material",
        "mineral origin material",
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enero": [
    {
      "id": 35923,
      "keyword": "enero",
      "keywords": 1,
      "type": 6,
      "tags": [
        "time",
        "calendar",
        "month"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6488,
      "keyword": "enero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "month",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escoger": [
    {
      "id": 11694,
      "keyword": "escoger",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30510,
      "keyword": "escoger",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6483,
      "keyword": "escoger",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "literature",
        "literacy genre",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "elegir": [
    {
      "id": 11694,
      "keyword": "elegir",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30510,
      "keyword": "elegir",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6483,
      "keyword": "elegir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "literature",
        "literacy genre",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mujer embarazada": [
    {
      "id": 6484,
      "keyword": "mujer embarazada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "adult",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mujeres embarazadas": [
    {
      "id": 6484,
      "keyword": "mujer embarazada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "adult",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "embarazada": [
    {
      "id": 33900,
      "keyword": "embarazada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6484,
      "keyword": "embarazada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "adult",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "embarazadas": [
    {
      "id": 33900,
      "keyword": "embarazada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6484,
      "keyword": "embarazada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "adult",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "entrevistar": [
    {
      "id": 7083,
      "keyword": "entrevistar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6492,
      "keyword": "entrevistar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36531,
      "keyword": "entrevistar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anotar": [
    {
      "id": 6487,
      "keyword": "anotar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8490,
      "keyword": "anotar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encestar": [
    {
      "id": 6487,
      "keyword": "encestar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "le": [
    {
      "id": 6481,
      "keyword": "le",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31670,
      "keyword": "le",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lo": [
    {
      "id": 6481,
      "keyword": "lo",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7029,
      "keyword": "lo",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31670,
      "keyword": "lo",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "se": [
    {
      "id": 6481,
      "keyword": "se",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7029,
      "keyword": "se",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7031,
      "keyword": "se",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7033,
      "keyword": "se",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31670,
      "keyword": "se",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31906,
      "keyword": "se",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "farmacéutico": [
    {
      "id": 6496,
      "keyword": "farmacéutico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine",
        "health",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38858,
      "keyword": "farmacéutico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine",
        "health",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11261,
      "keyword": "farmacéutico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine",
        "health",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "farmacéuticos": [
    {
      "id": 6496,
      "keyword": "farmacéutico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine",
        "health",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38858,
      "keyword": "farmacéutico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine",
        "health",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11261,
      "keyword": "farmacéutico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine",
        "health",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "febrero": [
    {
      "id": 35945,
      "keyword": "febrero",
      "keywords": 1,
      "type": 6,
      "tags": [
        "time",
        "calendar",
        "month"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6498,
      "keyword": "febrero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "month",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pescado rebozado": [
    {
      "id": 6502,
      "keyword": "pescado rebozado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6653,
      "keyword": "pescado rebozado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pescados rebozados": [
    {
      "id": 6502,
      "keyword": "pescado rebozado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6653,
      "keyword": "pescado rebozado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contenedor de vidrio": [
    {
      "id": 6501,
      "keyword": "contenedor de vidrio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36378,
      "keyword": "contenedor de vidrio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contenedores de vidrio": [
    {
      "id": 6501,
      "keyword": "contenedor de vidrio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36378,
      "keyword": "contenedor de vidrio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frutero": [
    {
      "id": 6509,
      "keyword": "frutero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11269,
      "keyword": "frutero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16303,
      "keyword": "frutero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fruteros": [
    {
      "id": 6509,
      "keyword": "frutero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11269,
      "keyword": "frutero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16303,
      "keyword": "frutero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gaseosa": [
    {
      "id": 6510,
      "keyword": "gaseosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gaseosas": [
    {
      "id": 6510,
      "keyword": "gaseosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "soda": [
    {
      "id": 6510,
      "keyword": "soda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sodas": [
    {
      "id": 6510,
      "keyword": "soda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugar al tenis": [
    {
      "id": 6514,
      "keyword": "jugar al tenis",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6513,
      "keyword": "jugar al tenis",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacha": [
    {
      "id": 32611,
      "keyword": "hacha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32610,
      "keyword": "hacha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6519,
      "keyword": "hacha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "forestry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hachas": [
    {
      "id": 32611,
      "keyword": "hacha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32610,
      "keyword": "hacha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6519,
      "keyword": "hacha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "forestry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gatear": [
    {
      "id": 6512,
      "keyword": "gatear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6511,
      "keyword": "gatear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "herradura": [
    {
      "id": 6521,
      "keyword": "herradura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8134,
      "keyword": "herradura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "herraduras": [
    {
      "id": 6521,
      "keyword": "herradura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8134,
      "keyword": "herradura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gafas de esquiar": [
    {
      "id": 6524,
      "keyword": "gafas de esquiar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clínica": [
    {
      "id": 6523,
      "keyword": "clínica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clínicas": [
    {
      "id": 6523,
      "keyword": "clínica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "humo": [
    {
      "id": 6529,
      "keyword": "humo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "pollution"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "humos": [
    {
      "id": 6529,
      "keyword": "humo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "pollution"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huella": [
    {
      "id": 6526,
      "keyword": "huella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6527,
      "keyword": "huella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9071,
      "keyword": "huella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34976,
      "keyword": "huella",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34973,
      "keyword": "huella",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8604,
      "keyword": "huella",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physical features",
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huellas": [
    {
      "id": 6526,
      "keyword": "huella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6527,
      "keyword": "huella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9071,
      "keyword": "huella",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26901,
      "keyword": "huellas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34976,
      "keyword": "huella",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34973,
      "keyword": "huella",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8604,
      "keyword": "huella",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physical features",
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8605,
      "keyword": "huellas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 20109,
      "keyword": "huellas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jueves": [
    {
      "id": 37728,
      "keyword": "jueves",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6536,
      "keyword": "jueves",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "junio": [
    {
      "id": 35933,
      "keyword": "junio",
      "keywords": 1,
      "type": 6,
      "tags": [
        "time",
        "calendar",
        "month"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6539,
      "keyword": "junio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "month",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jardinero": [
    {
      "id": 6533,
      "keyword": "jardinero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37765,
      "keyword": "jardinero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11288,
      "keyword": "jardinero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24276,
      "keyword": "jardinero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jardineros": [
    {
      "id": 6533,
      "keyword": "jardinero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37765,
      "keyword": "jardinero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11288,
      "keyword": "jardinero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24276,
      "keyword": "jardinero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salsa ketchup": [
    {
      "id": 6540,
      "keyword": "salsa ketchup",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salsas ketchup": [
    {
      "id": 6540,
      "keyword": "salsa ketchup",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ketchup": [
    {
      "id": 6540,
      "keyword": "ketchup",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ketchups": [
    {
      "id": 6540,
      "keyword": "ketchup",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tirar": [
    {
      "id": 6543,
      "keyword": "tirar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "leisure",
        "sport",
        "physical exercise",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36381,
      "keyword": "tirar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16655,
      "keyword": "tirar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36673,
      "keyword": "tirar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37533,
      "keyword": "tirar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15375,
      "keyword": "tirar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39441,
      "keyword": "tirar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6542,
      "keyword": "tirar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28449,
      "keyword": "tirar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arrojar": [
    {
      "id": 6543,
      "keyword": "arrojar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "leisure",
        "sport",
        "physical exercise",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6542,
      "keyword": "arrojar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28449,
      "keyword": "arrojar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lanzar": [
    {
      "id": 6543,
      "keyword": "lanzar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "leisure",
        "sport",
        "physical exercise",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37927,
      "keyword": "lanzar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39180,
      "keyword": "lanzar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6542,
      "keyword": "lanzar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28449,
      "keyword": "lanzar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lata": [
    {
      "id": 6544,
      "keyword": "lata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6545,
      "keyword": "lata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8280,
      "keyword": "lata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "latas": [
    {
      "id": 6544,
      "keyword": "lata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6545,
      "keyword": "lata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8280,
      "keyword": "lata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enjabonar": [
    {
      "id": 34846,
      "keyword": "enjabonar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6547,
      "keyword": "enjabonar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36910,
      "keyword": "enjabonar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "levantar": [
    {
      "id": 6549,
      "keyword": "levantar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "routine",
        "object",
        "furniture",
        "core vocabulary",
        "time",
        "calendar",
        "adverb",
        "adverb of time"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6548,
      "keyword": "levantar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "object",
        "furniture",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8152,
      "keyword": "levantar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "leisure",
        "sport",
        "physical exercise",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35101,
      "keyword": "levantar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36073,
      "keyword": "levantar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "julio": [
    {
      "id": 35931,
      "keyword": "julio",
      "keywords": 1,
      "type": 6,
      "tags": [
        "time",
        "calendar",
        "month"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6538,
      "keyword": "julio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "month",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limonada": [
    {
      "id": 6551,
      "keyword": "limonada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limonadas": [
    {
      "id": 6551,
      "keyword": "limonada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lunes": [
    {
      "id": 37723,
      "keyword": "lunes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6554,
      "keyword": "lunes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marzo": [
    {
      "id": 35939,
      "keyword": "marzo",
      "keywords": 1,
      "type": 6,
      "tags": [
        "time",
        "calendar",
        "month"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6558,
      "keyword": "marzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "month",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mayo": [
    {
      "id": 35925,
      "keyword": "mayo",
      "keywords": 1,
      "type": 6,
      "tags": [
        "time",
        "calendar",
        "month"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6559,
      "keyword": "mayo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "month",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "martes": [
    {
      "id": 37730,
      "keyword": "martes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6557,
      "keyword": "martes",
      "keywords": 1,
      "type": 6,
      "tags": [
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "médica": [
    {
      "id": 6561,
      "keyword": "médica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38446,
      "keyword": "médica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38857,
      "keyword": "médica",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8263,
      "keyword": "médica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "médicas": [
    {
      "id": 6561,
      "keyword": "médica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38446,
      "keyword": "médica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38857,
      "keyword": "médica",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8263,
      "keyword": "médica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "doctora": [
    {
      "id": 6561,
      "keyword": "doctora",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38857,
      "keyword": "doctora",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8263,
      "keyword": "doctora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "doctoras": [
    {
      "id": 6561,
      "keyword": "doctora",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38857,
      "keyword": "doctora",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8263,
      "keyword": "doctora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "miércoles": [
    {
      "id": 37729,
      "keyword": "miércoles",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6563,
      "keyword": "miércoles",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mostaza": [
    {
      "id": 25744,
      "keyword": "mostaza",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6565,
      "keyword": "mostaza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mostazas": [
    {
      "id": 6565,
      "keyword": "mostaza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ojo": [
    {
      "id": 6573,
      "keyword": "ojo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses",
        "visual system",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vista": [
    {
      "id": 6573,
      "keyword": "vista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses",
        "visual system",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vistas": [
    {
      "id": 6573,
      "keyword": "vista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses",
        "visual system",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nadar": [
    {
      "id": 6568,
      "keyword": "nadar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool",
        "beach",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "noviembre": [
    {
      "id": 35927,
      "keyword": "noviembre",
      "keywords": 1,
      "type": 6,
      "tags": [
        "time",
        "calendar",
        "month"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6570,
      "keyword": "noviembre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "month",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "octubre": [
    {
      "id": 35943,
      "keyword": "octubre",
      "keywords": 1,
      "type": 6,
      "tags": [
        "time",
        "calendar",
        "month"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6571,
      "keyword": "octubre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "month",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "naranjada": [
    {
      "id": 6569,
      "keyword": "naranjada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "naranjadas": [
    {
      "id": 6569,
      "keyword": "naranjada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pavo asado": [
    {
      "id": 6585,
      "keyword": "pavo asado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pavos asados": [
    {
      "id": 6585,
      "keyword": "pavo asado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "golpear": [
    {
      "id": 24084,
      "keyword": "golpear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39051,
      "keyword": "golpear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6586,
      "keyword": "golpear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30002,
      "keyword": "golpear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6977,
      "keyword": "golpear",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9000,
      "keyword": "golpear",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24083,
      "keyword": "golpear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agredir": [
    {
      "id": 6586,
      "keyword": "agredir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9000,
      "keyword": "agredir",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peluquera": [
    {
      "id": 6588,
      "keyword": "peluquera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 6588,
      "keyword": "peluquera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11333,
      "keyword": "peluquera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peluqueras": [
    {
      "id": 6588,
      "keyword": "peluquera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 6588,
      "keyword": "peluquera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11333,
      "keyword": "peluquera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pasar": [
    {
      "id": 6829,
      "keyword": "pasar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6581,
      "keyword": "pasar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39413,
      "keyword": "pasar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piedra": [
    {
      "id": 6594,
      "keyword": "piedra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piedras": [
    {
      "id": 6594,
      "keyword": "piedra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28585,
      "keyword": "piedras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "roca": [
    {
      "id": 6594,
      "keyword": "roca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rocas": [
    {
      "id": 6594,
      "keyword": "roca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pescadero": [
    {
      "id": 6591,
      "keyword": "pescadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11336,
      "keyword": "pescadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pescaderos": [
    {
      "id": 6591,
      "keyword": "pescadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11336,
      "keyword": "pescadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pintor": [
    {
      "id": 6596,
      "keyword": "pintor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25415,
      "keyword": "pintor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11341,
      "keyword": "pintor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11342,
      "keyword": "pintor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pintores": [
    {
      "id": 6596,
      "keyword": "pintor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25415,
      "keyword": "pintor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11341,
      "keyword": "pintor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11342,
      "keyword": "pintor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rodar": [
    {
      "id": 6603,
      "keyword": "rodar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37925,
      "keyword": "rodar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sábado": [
    {
      "id": 37726,
      "keyword": "sábado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6605,
      "keyword": "sábado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pescar": [
    {
      "id": 6592,
      "keyword": "pescar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11339,
      "keyword": "pescar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "septiembre": [
    {
      "id": 35929,
      "keyword": "septiembre",
      "keywords": 1,
      "type": 6,
      "tags": [
        "time",
        "calendar",
        "month"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6613,
      "keyword": "septiembre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "month",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inspirar": [
    {
      "id": 7231,
      "keyword": "inspirar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "respiratory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6602,
      "keyword": "inspirar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "respiratory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30106,
      "keyword": "inspirar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "respiratory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "indicar": [
    {
      "id": 36964,
      "keyword": "indicar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "human body"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6612,
      "keyword": "indicar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "señalar": [
    {
      "id": 36964,
      "keyword": "señalar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "human body"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6612,
      "keyword": "señalar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dar la mano": [
    {
      "id": 6610,
      "keyword": "dar la mano",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saludar": [
    {
      "id": 6610,
      "keyword": "saludar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tampón": [
    {
      "id": 6619,
      "keyword": "tampón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body",
        "intimate hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tampones": [
    {
      "id": 6619,
      "keyword": "tampón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body",
        "intimate hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "teñir": [
    {
      "id": 6620,
      "keyword": "teñir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8232,
      "keyword": "teñir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sentar": [
    {
      "id": 6611,
      "keyword": "sentar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "object",
        "furniture",
        "core vocabulary",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25083,
      "keyword": "sentar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "furniture",
        "person",
        "routine",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11370,
      "keyword": "sentar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "position",
        "education",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "te": [
    {
      "id": 6625,
      "keyword": "te",
      "keywords": 5,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7290,
      "keyword": "te",
      "keywords": 5,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ti": [
    {
      "id": 6625,
      "keyword": "ti",
      "keywords": 5,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7290,
      "keyword": "ti",
      "keywords": 5,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner": [
    {
      "id": 6627,
      "keyword": "poner",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "object",
        "fashion",
        "clothes",
        "person",
        "basic needs",
        "routine",
        "core vocabulary",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32757,
      "keyword": "poner",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6989,
      "keyword": "poner",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viajero": [
    {
      "id": 28173,
      "keyword": "viajero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "tourism",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28181,
      "keyword": "viajero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6628,
      "keyword": "viajero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16107,
      "keyword": "viajero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viajeros": [
    {
      "id": 28173,
      "keyword": "viajero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "tourism",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28181,
      "keyword": "viajero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6628,
      "keyword": "viajero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16107,
      "keyword": "viajero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desatornillar": [
    {
      "id": 6635,
      "keyword": "desatornillar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "destornillar": [
    {
      "id": 6635,
      "keyword": "destornillar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir": [
    {
      "id": 24725,
      "keyword": "subir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6617,
      "keyword": "subir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 19572,
      "keyword": "subir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfermedad": [
    {
      "id": 6637,
      "keyword": "enfermedad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8558,
      "keyword": "enfermedad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30622,
      "keyword": "enfermedad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11252,
      "keyword": "enfermedad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfermedades": [
    {
      "id": 6637,
      "keyword": "enfermedad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8558,
      "keyword": "enfermedad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30622,
      "keyword": "enfermedad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11252,
      "keyword": "enfermedades",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11252,
      "keyword": "enfermedad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "libros de ciencias naturales": [
    {
      "id": 6639,
      "keyword": "libros de ciencias naturales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9820,
      "keyword": "libro de ciencias naturales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "library science"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inflador": [
    {
      "id": 6638,
      "keyword": "inflador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "infladores": [
    {
      "id": 6638,
      "keyword": "inflador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "viernes": [
    {
      "id": 37727,
      "keyword": "viernes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6629,
      "keyword": "viernes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desinfectar": [
    {
      "id": 6636,
      "keyword": "desinfectar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33098,
      "keyword": "desinfectar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38913,
      "keyword": "desinfectar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36847,
      "keyword": "desinfectar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "furniture",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26688,
      "keyword": "desinfectar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37958,
      "keyword": "desinfectar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36760,
      "keyword": "desinfectar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37410,
      "keyword": "desinfectar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rincón de lectura": [
    {
      "id": 6645,
      "keyword": "rincón de lectura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rincones de lectura": [
    {
      "id": 6645,
      "keyword": "rincón de lectura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "library science"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "libros de juegos, deporte y ocio": [
    {
      "id": 6641,
      "keyword": "libros de juegos, deporte y ocio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "votar": [
    {
      "id": 6631,
      "keyword": "votar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salchicha": [
    {
      "id": 6647,
      "keyword": "salchicha",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8326,
      "keyword": "salchicha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salchicha de frankfurt": [
    {
      "id": 6647,
      "keyword": "salchicha de Frankfurt",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salchichas de frankfurt": [
    {
      "id": 6647,
      "keyword": "salchicha de Frankfurt",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frankfurt": [
    {
      "id": 6647,
      "keyword": "frankfurt",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frankfurts": [
    {
      "id": 6647,
      "keyword": "frankfurt",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sombra": [
    {
      "id": 6649,
      "keyword": "sombra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sombras": [
    {
      "id": 6649,
      "keyword": "sombra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rodaja de merluza": [
    {
      "id": 6646,
      "keyword": "rodaja de merluza",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodajas de merluza": [
    {
      "id": 6646,
      "keyword": "rodaja de merluza",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "merluza": [
    {
      "id": 37589,
      "keyword": "merluza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "oviparous",
        "vertebrate",
        "fish",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6646,
      "keyword": "merluza",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "merluzas": [
    {
      "id": 37589,
      "keyword": "merluza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "oviparous",
        "vertebrate",
        "fish",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6646,
      "keyword": "merluza",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rodaja": [
    {
      "id": 8684,
      "keyword": "rodaja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8730,
      "keyword": "rodaja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6646,
      "keyword": "rodaja",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodajas": [
    {
      "id": 8684,
      "keyword": "rodaja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8730,
      "keyword": "rodaja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6646,
      "keyword": "rodaja",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pescado en salsa verde": [
    {
      "id": 6646,
      "keyword": "pescado en salsa verde",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pescados en salsa verde": [
    {
      "id": 6646,
      "keyword": "pescado en salsa verde",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "urna": [
    {
      "id": 36293,
      "keyword": "urna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6650,
      "keyword": "urna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26523,
      "keyword": "urna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "urnas": [
    {
      "id": 36293,
      "keyword": "urna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6650,
      "keyword": "urna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26523,
      "keyword": "urna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "valla": [
    {
      "id": 6651,
      "keyword": "valla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vallas": [
    {
      "id": 6651,
      "keyword": "valla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vender": [
    {
      "id": 6652,
      "keyword": "vender",
      "keywords": 1,
      "type": 3,
      "tags": [
        "work",
        "tertiary sector",
        "trade",
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "libros de ciencias sociales": [
    {
      "id": 6640,
      "keyword": "libros de ciencias sociales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9823,
      "keyword": "libro de ciencias sociales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "library science"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "san jacobo": [
    {
      "id": 6648,
      "keyword": "San Jacobo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "san jacobos": [
    {
      "id": 6648,
      "keyword": "San Jacobo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sanjacobo": [
    {
      "id": 6648,
      "keyword": "sanjacobo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sanjacobos": [
    {
      "id": 6648,
      "keyword": "sanjacobo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "varita de merluza": [
    {
      "id": 6653,
      "keyword": "varita de merluza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "varitas de merluza": [
    {
      "id": 6653,
      "keyword": "varita de merluza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tijeras escolares": [
    {
      "id": 6664,
      "keyword": "tijeras escolares",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abanico": [
    {
      "id": 6871,
      "keyword": "abanico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abanicos": [
    {
      "id": 6871,
      "keyword": "abanico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abono": [
    {
      "id": 6872,
      "keyword": "abono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abonos": [
    {
      "id": 6872,
      "keyword": "abono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fertilizante": [
    {
      "id": 6872,
      "keyword": "fertilizante",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fertilizantes": [
    {
      "id": 6872,
      "keyword": "fertilizante",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aburrir": [
    {
      "id": 6873,
      "keyword": "aburrir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrir la puerta": [
    {
      "id": 24598,
      "keyword": "abrir la puerta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6875,
      "keyword": "abrir la puerta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24597,
      "keyword": "abrir la puerta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28455,
      "keyword": "abrir la puerta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aceitera": [
    {
      "id": 6877,
      "keyword": "aceitera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aceiteras": [
    {
      "id": 6877,
      "keyword": "aceitera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "libros de poesia y arte": [
    {
      "id": 6642,
      "keyword": "libros de poesia y arte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "montar a caballo": [
    {
      "id": 35483,
      "keyword": "montar a caballo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27627,
      "keyword": "montar a caballo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6643,
      "keyword": "montar a caballo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27626,
      "keyword": "montar a caballo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "natilla": [
    {
      "id": 6644,
      "keyword": "natilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37102,
      "keyword": "natilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "natillas": [
    {
      "id": 6644,
      "keyword": "natilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37102,
      "keyword": "natilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abrir el libro": [
    {
      "id": 6874,
      "keyword": "abrir el libro",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "literature",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adulto": [
    {
      "id": 6886,
      "keyword": "adulto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adultos": [
    {
      "id": 6887,
      "keyword": "adultos",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6886,
      "keyword": "adulto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acompañada": [
    {
      "id": 6880,
      "keyword": "acompañada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acompañadas": [
    {
      "id": 6880,
      "keyword": "acompañada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "compañía": [
    {
      "id": 6880,
      "keyword": "compañía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compañías": [
    {
      "id": 6880,
      "keyword": "compañía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alarma": [
    {
      "id": 36342,
      "keyword": "alarma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6891,
      "keyword": "alarma",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alarmas": [
    {
      "id": 36342,
      "keyword": "alarma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6891,
      "keyword": "alarma",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sonar": [
    {
      "id": 16893,
      "keyword": "sonar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7255,
      "keyword": "sonar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "time",
        "chronological device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6891,
      "keyword": "sonar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6891,
      "keyword": "sonar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7256,
      "keyword": "sonar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28793,
      "keyword": "sonar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28794,
      "keyword": "sonar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31746,
      "keyword": "sonar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34469,
      "keyword": "sonar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8731,
      "keyword": "sonar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acuarelas": [
    {
      "id": 6881,
      "keyword": "acuarelas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coger del brazo": [
    {
      "id": 6888,
      "keyword": "coger del brazo",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agarrar del brazo": [
    {
      "id": 6888,
      "keyword": "agarrar del brazo",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asir del brazo": [
    {
      "id": 6888,
      "keyword": "asir del brazo",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomar del brazo": [
    {
      "id": 6888,
      "keyword": "tomar del brazo",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alegrar": [
    {
      "id": 6892,
      "keyword": "alegrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almacén": [
    {
      "id": 6896,
      "keyword": "almacén",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "education",
        "educational space",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almacenes": [
    {
      "id": 6896,
      "keyword": "almacén",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "education",
        "educational space",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amapola": [
    {
      "id": 6897,
      "keyword": "amapola",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "amapolas": [
    {
      "id": 6897,
      "keyword": "amapola",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ababol": [
    {
      "id": 6897,
      "keyword": "ababol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ababoles": [
    {
      "id": 6897,
      "keyword": "ababol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amar": [
    {
      "id": 6898,
      "keyword": "amar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11519,
      "keyword": "amar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11517,
      "keyword": "amar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aleta": [
    {
      "id": 6895,
      "keyword": "aleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "vertebrate",
        "fish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "animales": [
    {
      "id": 8025,
      "keyword": "animal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6901,
      "keyword": "animales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6901,
      "keyword": "animal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "animal": [
    {
      "id": 8025,
      "keyword": "animal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6901,
      "keyword": "animal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "año": [
    {
      "id": 6903,
      "keyword": "año",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "unit of time",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "años": [
    {
      "id": 6903,
      "keyword": "año",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "unit of time",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "antipático": [
    {
      "id": 37801,
      "keyword": "antipático",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32150,
      "keyword": "antipático",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6902,
      "keyword": "antipático",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "antipáticos": [
    {
      "id": 37801,
      "keyword": "antipático",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32150,
      "keyword": "antipático",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6902,
      "keyword": "antipático",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "antipática": [
    {
      "id": 37801,
      "keyword": "antipática",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10195,
      "keyword": "antipática",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6902,
      "keyword": "antipática",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "antipáticas": [
    {
      "id": 37801,
      "keyword": "antipática",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10195,
      "keyword": "antipática",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6902,
      "keyword": "antipática",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apilar": [
    {
      "id": 6905,
      "keyword": "apilar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36379,
      "keyword": "apilar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6904,
      "keyword": "apilar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "amontonar": [
    {
      "id": 6905,
      "keyword": "amontonar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8016,
      "keyword": "amontonar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6904,
      "keyword": "amontonar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acunar": [
    {
      "id": 6883,
      "keyword": "acunar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29754,
      "keyword": "acunar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mecer": [
    {
      "id": 6883,
      "keyword": "mecer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29754,
      "keyword": "mecer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aquellos": [
    {
      "id": 6907,
      "keyword": "aquellos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "demonstrative adjective",
        "pronoun",
        "demonstrative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aquellas": [
    {
      "id": 6907,
      "keyword": "aquellas",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "demonstrative adjective",
        "pronoun",
        "demonstrative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aquel": [
    {
      "id": 6906,
      "keyword": "aquel",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "demonstrative adjective",
        "pronoun",
        "demonstrative pronoun",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aquella": [
    {
      "id": 6906,
      "keyword": "aquella",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "demonstrative adjective",
        "pronoun",
        "demonstrative pronoun",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aquello": [
    {
      "id": 6906,
      "keyword": "aquello",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "demonstrative adjective",
        "pronoun",
        "demonstrative pronoun",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adorno de navidad": [
    {
      "id": 6885,
      "keyword": "adorno de Navidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adornos de navidad": [
    {
      "id": 6885,
      "keyword": "adorno de Navidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aseo": [
    {
      "id": 30524,
      "keyword": "aseo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary",
        "human body"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27559,
      "keyword": "aseo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27561,
      "keyword": "aseo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15810,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27475,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33935,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37331,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37710,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37904,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15814,
      "keyword": "aseo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15812,
      "keyword": "aseo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6912,
      "keyword": "aseo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary",
        "human body"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33936,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33934,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38625,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38626,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38627,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aseos": [
    {
      "id": 30524,
      "keyword": "aseo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary",
        "human body"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27559,
      "keyword": "aseo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27561,
      "keyword": "aseo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15810,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27475,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33935,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37331,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37710,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37904,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15814,
      "keyword": "aseo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15812,
      "keyword": "aseo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6912,
      "keyword": "aseo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "core vocabulary",
        "human body"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33936,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33934,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38625,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38626,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38627,
      "keyword": "aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asomar": [
    {
      "id": 6914,
      "keyword": "asomar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6913,
      "keyword": "asomar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36493,
      "keyword": "asomar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aspersor": [
    {
      "id": 6915,
      "keyword": "aspersor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aspersores": [
    {
      "id": 6915,
      "keyword": "aspersor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adelgazar": [
    {
      "id": 37804,
      "keyword": "adelgazar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "dietetics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6884,
      "keyword": "adelgazar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "dietetics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28199,
      "keyword": "adelgazar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "dietetics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aullar": [
    {
      "id": 6919,
      "keyword": "aullar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "interjection",
        "onomatopoeia",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aumentar": [
    {
      "id": 6920,
      "keyword": "aumentar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agrandar": [
    {
      "id": 6920,
      "keyword": "agrandar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "avena": [
    {
      "id": 6921,
      "keyword": "avena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant",
        "feeding",
        "food",
        "plant-based food",
        "cereal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "avenas": [
    {
      "id": 6921,
      "keyword": "avena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant",
        "feeding",
        "food",
        "plant-based food",
        "cereal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atún": [
    {
      "id": 25660,
      "keyword": "atún",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6918,
      "keyword": "atún",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atunes": [
    {
      "id": 25660,
      "keyword": "atún",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6918,
      "keyword": "atún",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "avergonzado": [
    {
      "id": 31919,
      "keyword": "avergonzado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6922,
      "keyword": "avergonzado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "avergonzados": [
    {
      "id": 31919,
      "keyword": "avergonzado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6922,
      "keyword": "avergonzado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "avergonzada": [
    {
      "id": 11953,
      "keyword": "avergonzada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6922,
      "keyword": "avergonzada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "avergonzadas": [
    {
      "id": 11953,
      "keyword": "avergonzada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6922,
      "keyword": "avergonzada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aterrizar": [
    {
      "id": 6917,
      "keyword": "aterrizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31164,
      "keyword": "aterrizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31165,
      "keyword": "aterrizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "animal physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aves": [
    {
      "id": 6923,
      "keyword": "aves",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "bird",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6923,
      "keyword": "ave",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "bird",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ave": [
    {
      "id": 21399,
      "keyword": "AVE",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 21399,
      "keyword": "AVE",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6923,
      "keyword": "ave",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "bird",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asustar": [
    {
      "id": 6916,
      "keyword": "asustar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8980,
      "keyword": "asustar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8979,
      "keyword": "asustar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37772,
      "keyword": "asustar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baño": [
    {
      "id": 27555,
      "keyword": "baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27557,
      "keyword": "baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27559,
      "keyword": "baño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27561,
      "keyword": "baño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27553,
      "keyword": "baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33935,
      "keyword": "baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37331,
      "keyword": "baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37710,
      "keyword": "baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6929,
      "keyword": "baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6930,
      "keyword": "baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15905,
      "keyword": "baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39122,
      "keyword": "baño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33936,
      "keyword": "baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33934,
      "keyword": "baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38625,
      "keyword": "baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38626,
      "keyword": "baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38627,
      "keyword": "baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baños": [
    {
      "id": 27555,
      "keyword": "baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27557,
      "keyword": "baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27559,
      "keyword": "baño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27561,
      "keyword": "baño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27553,
      "keyword": "baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33935,
      "keyword": "baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37331,
      "keyword": "baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37710,
      "keyword": "baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6929,
      "keyword": "baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6930,
      "keyword": "baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15905,
      "keyword": "baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28213,
      "keyword": "baños",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39122,
      "keyword": "baño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33936,
      "keyword": "baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33934,
      "keyword": "baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38625,
      "keyword": "baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38626,
      "keyword": "baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38627,
      "keyword": "baño",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arreglar": [
    {
      "id": 6910,
      "keyword": "arreglar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15327,
      "keyword": "arreglar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reparar": [
    {
      "id": 6910,
      "keyword": "reparar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15327,
      "keyword": "reparar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arroz": [
    {
      "id": 6911,
      "keyword": "arroz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "cereal",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25556,
      "keyword": "arroz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "cereal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39387,
      "keyword": "arroz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arroces": [
    {
      "id": 6911,
      "keyword": "arroz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "cereal",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25556,
      "keyword": "arroz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "cereal"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39387,
      "keyword": "arroz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "avispa": [
    {
      "id": 6925,
      "keyword": "avispa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "avispas": [
    {
      "id": 6925,
      "keyword": "avispa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ayer": [
    {
      "id": 6926,
      "keyword": "ayer",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38279,
      "keyword": "ayer",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barrena": [
    {
      "id": 6933,
      "keyword": "barrena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8037,
      "keyword": "barrena",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barrenas": [
    {
      "id": 6933,
      "keyword": "barrena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8037,
      "keyword": "barrena",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barril": [
    {
      "id": 6934,
      "keyword": "barril",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barriles": [
    {
      "id": 6934,
      "keyword": "barril",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bomba": [
    {
      "id": 6938,
      "keyword": "bomba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bombas": [
    {
      "id": 6938,
      "keyword": "bomba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botijo": [
    {
      "id": 6940,
      "keyword": "botijo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botijos": [
    {
      "id": 6940,
      "keyword": "botijo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "branquias": [
    {
      "id": 6941,
      "keyword": "branquias",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buenas noches": [
    {
      "id": 6942,
      "keyword": "buenas noches",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38569,
      "keyword": "buenas noches",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balar": [
    {
      "id": 6927,
      "keyword": "balar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "interjection",
        "onomatopoeia",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26664,
      "keyword": "balar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "interjection",
        "onomatopoeia",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buenos días": [
    {
      "id": 6944,
      "keyword": "buenos días",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38568,
      "keyword": "buenos días",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buscar": [
    {
      "id": 6947,
      "keyword": "buscar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38136,
      "keyword": "buscar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6946,
      "keyword": "buscar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21468,
      "keyword": "buscar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27391,
      "keyword": "buscar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32156,
      "keyword": "buscar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37240,
      "keyword": "buscar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21466,
      "keyword": "buscar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37238,
      "keyword": "buscar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cable": [
    {
      "id": 6948,
      "keyword": "cable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cables": [
    {
      "id": 6948,
      "keyword": "cable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cacarear": [
    {
      "id": 6950,
      "keyword": "cacarear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "interjection",
        "onomatopoeia",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6949,
      "keyword": "cacarear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "interjection",
        "onomatopoeia",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buenas tardes": [
    {
      "id": 6943,
      "keyword": "buenas tardes",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38567,
      "keyword": "buenas tardes",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38592,
      "keyword": "buenas tardes",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "burbujas": [
    {
      "id": 6945,
      "keyword": "burbujas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8389,
      "keyword": "burbuja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36187,
      "keyword": "burbuja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pompas de jabón": [
    {
      "id": 6945,
      "keyword": "pompas de jabón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8389,
      "keyword": "pompa de jabón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tener calor": [
    {
      "id": 6952,
      "keyword": "tener calor",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "body sensation",
        "summer",
        "core vocabulary",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calabaza de halloween": [
    {
      "id": 6951,
      "keyword": "calabaza de halloween",
      "keywords": 6,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calabazas de halloween": [
    {
      "id": 6951,
      "keyword": "calabaza de halloween",
      "keywords": 6,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "halloween": [
    {
      "id": 6951,
      "keyword": "Halloween",
      "keywords": 6,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "todos los santos": [
    {
      "id": 6951,
      "keyword": "Todos los Santos",
      "keywords": 6,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "día de todos los santos": [
    {
      "id": 32460,
      "keyword": "Día de Todos los Santos",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6951,
      "keyword": "Día de Todos los Santos",
      "keywords": 6,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calzado": [
    {
      "id": 24801,
      "keyword": "calzado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6953,
      "keyword": "calzado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calzados": [
    {
      "id": 24801,
      "keyword": "calzado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6953,
      "keyword": "calzado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camino": [
    {
      "id": 6955,
      "keyword": "camino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "land transport",
        "rural area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caminos": [
    {
      "id": 6955,
      "keyword": "camino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "land transport",
        "rural area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vía": [
    {
      "id": 7299,
      "keyword": "vía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6955,
      "keyword": "vía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "land transport",
        "rural area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vías": [
    {
      "id": 7299,
      "keyword": "vía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6955,
      "keyword": "vía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "land transport",
        "rural area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "candado": [
    {
      "id": 6957,
      "keyword": "candado",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "candados": [
    {
      "id": 6957,
      "keyword": "candado",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "candelabro": [
    {
      "id": 6958,
      "keyword": "candelabro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23905,
      "keyword": "candelabro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "candelabros": [
    {
      "id": 6958,
      "keyword": "candelabro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23905,
      "keyword": "candelabro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cansar": [
    {
      "id": 6959,
      "keyword": "cansar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion",
        "human body",
        "body sensation",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsillo": [
    {
      "id": 6937,
      "keyword": "bolsillo",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": true,
      "plural": false
    },
    {
      "id": 6937,
      "keyword": "bolsillo",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsillos": [
    {
      "id": 6937,
      "keyword": "bolsillo",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": true,
      "plural": true
    },
    {
      "id": 6937,
      "keyword": "bolsillo",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "bienvenido": [
    {
      "id": 6936,
      "keyword": "bienvenido",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casar": [
    {
      "id": 6965,
      "keyword": "casar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casarse": [
    {
      "id": 6965,
      "keyword": "casarse",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "unir": [
    {
      "id": 8243,
      "keyword": "unir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6965,
      "keyword": "unir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "celebrar": [
    {
      "id": 16475,
      "keyword": "celebrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "popular event",
        "popular festival",
        "social event",
        "birthday",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16649,
      "keyword": "celebrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "popular event",
        "popular festival",
        "social event",
        "birthday",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6969,
      "keyword": "celebrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "celebración": [
    {
      "id": 24963,
      "keyword": "celebración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6969,
      "keyword": "celebración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7099,
      "keyword": "celebración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavar los dientes": [
    {
      "id": 6971,
      "keyword": "lavar los dientes",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27489,
      "keyword": "lavar los dientes",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31880,
      "keyword": "lavar los dientes",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cebada": [
    {
      "id": 6967,
      "keyword": "cebada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "cereal",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cebadas": [
    {
      "id": 6967,
      "keyword": "cebada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "cereal",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ceda el paso": [
    {
      "id": 6968,
      "keyword": "ceda el paso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cáscara": [
    {
      "id": 6966,
      "keyword": "cáscara",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17292,
      "keyword": "cáscara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cáscaras": [
    {
      "id": 6966,
      "keyword": "cáscara",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 17292,
      "keyword": "cáscara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chuleta": [
    {
      "id": 6976,
      "keyword": "chuleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24809,
      "keyword": "chuleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chuletas": [
    {
      "id": 6976,
      "keyword": "chuleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24809,
      "keyword": "chuleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "patear": [
    {
      "id": 6977,
      "keyword": "patear",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cielo": [
    {
      "id": 38270,
      "keyword": "cielo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6978,
      "keyword": "cielo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cielos": [
    {
      "id": 38270,
      "keyword": "cielo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6978,
      "keyword": "cielo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "firmamento": [
    {
      "id": 6978,
      "keyword": "firmamento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "firmamentos": [
    {
      "id": 6978,
      "keyword": "firmamento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cocinero": [
    {
      "id": 30526,
      "keyword": "cocinero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6985,
      "keyword": "cocinero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10348,
      "keyword": "cocinero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cocineros": [
    {
      "id": 30526,
      "keyword": "cocinero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6985,
      "keyword": "cocinero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10348,
      "keyword": "cocinero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carro de la compra": [
    {
      "id": 6962,
      "keyword": "carro de la compra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carros de la compra": [
    {
      "id": 6962,
      "keyword": "carro de la compra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conocer": [
    {
      "id": 8456,
      "keyword": "conocer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6993,
      "keyword": "conocer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "confundir": [
    {
      "id": 6992,
      "keyword": "confundir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corchera": [
    {
      "id": 26770,
      "keyword": "corchera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6997,
      "keyword": "corchera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corcheras": [
    {
      "id": 26770,
      "keyword": "corchera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 6997,
      "keyword": "corchera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tablón de anuncios": [
    {
      "id": 6997,
      "keyword": "tablón de anuncios",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tablones de anuncios": [
    {
      "id": 6997,
      "keyword": "tablón de anuncios",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "portera": [
    {
      "id": 6995,
      "keyword": "portera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porteras": [
    {
      "id": 6995,
      "keyword": "portera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comunicación aumentativa": [
    {
      "id": 6991,
      "keyword": "comunicación aumentativa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36723,
      "keyword": "comunicación aumentativa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corregir": [
    {
      "id": 6998,
      "keyword": "corregir",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "revisar": [
    {
      "id": 6998,
      "keyword": "revisar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encuesta": [
    {
      "id": 6998,
      "keyword": "encuesta",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encuestas": [
    {
      "id": 6998,
      "keyword": "encuesta",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chequear": [
    {
      "id": 6998,
      "keyword": "chequear",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "verificar": [
    {
      "id": 6998,
      "keyword": "verificar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "costilla": [
    {
      "id": 7000,
      "keyword": "costilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7001,
      "keyword": "costilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24811,
      "keyword": "costilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuaderno de comunicación": [
    {
      "id": 7004,
      "keyword": "cuaderno de comunicación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuadernos de comunicación": [
    {
      "id": 7004,
      "keyword": "cuaderno de comunicación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "croar": [
    {
      "id": 7003,
      "keyword": "croar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "interjection",
        "onomatopoeia",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuerda": [
    {
      "id": 7006,
      "keyword": "cuerda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26026,
      "keyword": "cuerda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuerdas": [
    {
      "id": 7006,
      "keyword": "cuerda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26026,
      "keyword": "cuerda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "depilar": [
    {
      "id": 7009,
      "keyword": "depilar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32691,
      "keyword": "depilar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32810,
      "keyword": "depilar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36005,
      "keyword": "depilar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36006,
      "keyword": "depilar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "decorar": [
    {
      "id": 16435,
      "keyword": "decorar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16641,
      "keyword": "decorar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32622,
      "keyword": "decorar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "craftsmanship",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7008,
      "keyword": "decorar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29670,
      "keyword": "decorar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "decoración": [
    {
      "id": 36905,
      "keyword": "decoración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7008,
      "keyword": "decoración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29670,
      "keyword": "decoración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "decoraciones": [
    {
      "id": 36905,
      "keyword": "decoración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7008,
      "keyword": "decoración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29670,
      "keyword": "decoración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adornar": [
    {
      "id": 16435,
      "keyword": "adornar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16641,
      "keyword": "adornar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7008,
      "keyword": "adornar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29670,
      "keyword": "adornar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "deporte": [
    {
      "id": 7010,
      "keyword": "deporte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "deportes": [
    {
      "id": 7010,
      "keyword": "deportes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crecer": [
    {
      "id": 16625,
      "keyword": "crecer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7002,
      "keyword": "crecer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23991,
      "keyword": "crecer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "plant",
        "plant physiology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37755,
      "keyword": "crecer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11683,
      "keyword": "crecer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39286,
      "keyword": "crecer",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "derretir": [
    {
      "id": 7011,
      "keyword": "derretir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38711,
      "keyword": "derretir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colgar": [
    {
      "id": 6986,
      "keyword": "colgar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10133,
      "keyword": "colgar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28691,
      "keyword": "colgar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36035,
      "keyword": "colgar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37895,
      "keyword": "colgar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "education",
        "teaching activity",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37896,
      "keyword": "colgar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39116,
      "keyword": "colgar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "descalzo": [
    {
      "id": 7014,
      "keyword": "descalzo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "descalzos": [
    {
      "id": 7014,
      "keyword": "descalzo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "descalza": [
    {
      "id": 7014,
      "keyword": "descalza",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "descalzas": [
    {
      "id": 7014,
      "keyword": "descalza",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desbrozar": [
    {
      "id": 7013,
      "keyword": "desbrozar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arrancar": [
    {
      "id": 7013,
      "keyword": "arrancar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "descolgar": [
    {
      "id": 7015,
      "keyword": "descolgar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "detergente": [
    {
      "id": 7021,
      "keyword": "detergente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "detergentes": [
    {
      "id": 7021,
      "keyword": "detergente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "detergente para ropa": [
    {
      "id": 7021,
      "keyword": "detergente para ropa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "detergentes para ropa": [
    {
      "id": 7021,
      "keyword": "detergente para ropa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colocar": [
    {
      "id": 32757,
      "keyword": "colocar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27511,
      "keyword": "colocar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6989,
      "keyword": "colocar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27514,
      "keyword": "colocar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "situar": [
    {
      "id": 32757,
      "keyword": "situar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 6989,
      "keyword": "situar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "día": [
    {
      "id": 26799,
      "keyword": "día",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37371,
      "keyword": "día",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37731,
      "keyword": "día",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7022,
      "keyword": "día",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diarrea": [
    {
      "id": 38314,
      "keyword": "diarrea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7023,
      "keyword": "diarrea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28732,
      "keyword": "diarrea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diarreas": [
    {
      "id": 38314,
      "keyword": "diarrea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7023,
      "keyword": "diarrea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28732,
      "keyword": "diarrea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diccionario": [
    {
      "id": 7024,
      "keyword": "diccionario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diccionarios": [
    {
      "id": 7024,
      "keyword": "diccionario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "destapar": [
    {
      "id": 7020,
      "keyword": "destapar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diez": [
    {
      "id": 39339,
      "keyword": "diez",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39371,
      "keyword": "diez",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29454,
      "keyword": "diez",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7025,
      "keyword": "diez",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29254,
      "keyword": "diez",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35691,
      "keyword": "diez",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ella": [
    {
      "id": 7029,
      "keyword": "ella",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7028,
      "keyword": "ella",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "la": [
    {
      "id": 7029,
      "keyword": "la",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8476,
      "keyword": "la",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "article"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8476,
      "keyword": "la",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "article"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ella se": [
    {
      "id": 7029,
      "keyword": "ella se",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7028,
      "keyword": "ella se",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ellas": [
    {
      "id": 7031,
      "keyword": "ellas",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7030,
      "keyword": "ellas",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ellas se": [
    {
      "id": 7031,
      "keyword": "ellas se",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7030,
      "keyword": "ellas se",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "les": [
    {
      "id": 7031,
      "keyword": "les",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7033,
      "keyword": "les",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31906,
      "keyword": "les",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "las": [
    {
      "id": 7031,
      "keyword": "las",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8477,
      "keyword": "las",
      "keywords": 2,
      "type": 6,
      "tags": [
        "article"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ellos": [
    {
      "id": 7033,
      "keyword": "ellos",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31906,
      "keyword": "ellos",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7032,
      "keyword": "ellos",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31805,
      "keyword": "ellos",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ellos se": [
    {
      "id": 7033,
      "keyword": "ellos se",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31906,
      "keyword": "ellos se",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7032,
      "keyword": "ellos se",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31805,
      "keyword": "ellos se",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "doméstico": [
    {
      "id": 7026,
      "keyword": "doméstico",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "primary sector",
        "cattle farming",
        "animal",
        "domestic",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "domésticos": [
    {
      "id": 7026,
      "keyword": "doméstico",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "primary sector",
        "cattle farming",
        "animal",
        "domestic",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "doméstica": [
    {
      "id": 7026,
      "keyword": "doméstica",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "primary sector",
        "cattle farming",
        "animal",
        "domestic",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "domésticas": [
    {
      "id": 7026,
      "keyword": "doméstica",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "primary sector",
        "cattle farming",
        "animal",
        "domestic",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "en": [
    {
      "id": 7034,
      "keyword": "en",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "los": [
    {
      "id": 7033,
      "keyword": "los",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31906,
      "keyword": "los",
      "keywords": 6,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8477,
      "keyword": "los",
      "keywords": 2,
      "type": 6,
      "tags": [
        "article"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "deslizar": [
    {
      "id": 7016,
      "keyword": "deslizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desmenuzar": [
    {
      "id": 7017,
      "keyword": "desmenuzar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despegar": [
    {
      "id": 7018,
      "keyword": "despegar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perseguir": [
    {
      "id": 7038,
      "keyword": "perseguir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7037,
      "keyword": "perseguir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encorrer": [
    {
      "id": 7038,
      "keyword": "encorrer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7037,
      "keyword": "encorrer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seguir": [
    {
      "id": 7038,
      "keyword": "seguir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27331,
      "keyword": "seguir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7037,
      "keyword": "seguir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enchufar": [
    {
      "id": 7035,
      "keyword": "enchufar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27515,
      "keyword": "enchufar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfadar": [
    {
      "id": 7039,
      "keyword": "enfadar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37420,
      "keyword": "enfadar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encolar": [
    {
      "id": 7036,
      "keyword": "encolar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfermo": [
    {
      "id": 7040,
      "keyword": "enfermo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "disease",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38481,
      "keyword": "enfermo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39142,
      "keyword": "enfermo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28742,
      "keyword": "enfermo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32296,
      "keyword": "enfermo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfermos": [
    {
      "id": 7040,
      "keyword": "enfermo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "disease",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38481,
      "keyword": "enfermo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39142,
      "keyword": "enfermo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28742,
      "keyword": "enfermo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32296,
      "keyword": "enfermo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alambre": [
    {
      "id": 7042,
      "keyword": "alambre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alambres": [
    {
      "id": 7042,
      "keyword": "alambre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "baltasar": [
    {
      "id": 7048,
      "keyword": "Baltasar",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "christianity",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autopista": [
    {
      "id": 7046,
      "keyword": "autopista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autopistas": [
    {
      "id": 7046,
      "keyword": "autopista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carril bici": [
    {
      "id": 7051,
      "keyword": "carril bici",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carriles bici": [
    {
      "id": 7051,
      "keyword": "carril bici",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caer un diente": [
    {
      "id": 7049,
      "keyword": "caer un diente",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "capucha": [
    {
      "id": 7050,
      "keyword": "capucha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "capuchas": [
    {
      "id": 7050,
      "keyword": "capucha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caperuza": [
    {
      "id": 7050,
      "keyword": "caperuza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caperuzas": [
    {
      "id": 7050,
      "keyword": "caperuza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cartón": [
    {
      "id": 7054,
      "keyword": "cartón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "object",
        "core vocabulary",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cartones": [
    {
      "id": 7054,
      "keyword": "cartón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "object",
        "core vocabulary",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caja abierta": [
    {
      "id": 7054,
      "keyword": "caja abierta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "object",
        "core vocabulary",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajas abiertas": [
    {
      "id": 7054,
      "keyword": "caja abierta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "object",
        "core vocabulary",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesa con ruedas": [
    {
      "id": 7052,
      "keyword": "mesa con ruedas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas con ruedas": [
    {
      "id": 7052,
      "keyword": "mesa con ruedas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maletín": [
    {
      "id": 7053,
      "keyword": "maletín",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maletines": [
    {
      "id": 7053,
      "keyword": "maletín",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "portafolios": [
    {
      "id": 7053,
      "keyword": "portafolios",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comida para gatos": [
    {
      "id": 7058,
      "keyword": "comida para gatos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comidas para gatos": [
    {
      "id": 7058,
      "keyword": "comida para gatos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comida para pájaros": [
    {
      "id": 7059,
      "keyword": "comida para pájaros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comidas para pájaros": [
    {
      "id": 7059,
      "keyword": "comida para pájaros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comida para peces": [
    {
      "id": 7060,
      "keyword": "comida para peces",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comidas para peces": [
    {
      "id": 7060,
      "keyword": "comida para peces",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿cómo te llamas?": [
    {
      "id": 7061,
      "keyword": "¿cómo te llamas?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38570,
      "keyword": "¿cómo te llamas?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compañeros": [
    {
      "id": 7063,
      "keyword": "compañeros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37658,
      "keyword": "compañeros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39421,
      "keyword": "compañero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7062,
      "keyword": "compañeros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ante": [
    {
      "id": 7044,
      "keyword": "ante",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "castor": [
    {
      "id": 7055,
      "keyword": "castor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "castores": [
    {
      "id": 7055,
      "keyword": "castor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "castora": [
    {
      "id": 7055,
      "keyword": "castora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "castoras": [
    {
      "id": 7055,
      "keyword": "castora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anular": [
    {
      "id": 27393,
      "keyword": "anular",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7045,
      "keyword": "anular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anulares": [
    {
      "id": 7045,
      "keyword": "anular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comida para perros": [
    {
      "id": 7057,
      "keyword": "comida para perros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comidas para perros": [
    {
      "id": 7057,
      "keyword": "comida para perros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "con": [
    {
      "id": 7064,
      "keyword": "con",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coser a máquina": [
    {
      "id": 7068,
      "keyword": "coser a máquina",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cresta": [
    {
      "id": 7069,
      "keyword": "cresta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crestas": [
    {
      "id": 7069,
      "keyword": "cresta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contra": [
    {
      "id": 7067,
      "keyword": "contra",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuadriculado": [
    {
      "id": 7070,
      "keyword": "cuadriculado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "pattern",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuadriculados": [
    {
      "id": 7070,
      "keyword": "cuadriculado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "pattern",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "a cuadros": [
    {
      "id": 7070,
      "keyword": "a cuadros",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "pattern",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuadriculada": [
    {
      "id": 7070,
      "keyword": "cuadriculada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "pattern",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuadriculadas": [
    {
      "id": 7070,
      "keyword": "cuadriculada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "pattern",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anfibios": [
    {
      "id": 7043,
      "keyword": "anfibios",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "amphibian",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anfibio": [
    {
      "id": 7043,
      "keyword": "anfibio",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "vertebrate",
        "amphibian",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿cuánto cuesta?": [
    {
      "id": 7071,
      "keyword": "¿cuánto cuesta?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contaminación": [
    {
      "id": 7065,
      "keyword": "contaminación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "pollution"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36902,
      "keyword": "contaminación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "pollution",
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7066,
      "keyword": "contaminación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "pollution"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26388,
      "keyword": "contaminación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "environmental science",
        "pollution"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contaminaciones": [
    {
      "id": 7065,
      "keyword": "contaminación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "pollution"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7066,
      "keyword": "contaminación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "pollution"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26388,
      "keyword": "contaminación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "environmental science",
        "pollution"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contaminar": [
    {
      "id": 7065,
      "keyword": "contaminar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "environmental science",
        "pollution"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7066,
      "keyword": "contaminar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "environmental science",
        "pollution"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26388,
      "keyword": "contaminar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "environmental science",
        "pollution"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "déjame solo": [
    {
      "id": 7076,
      "keyword": "déjame solo",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "déjame en paz": [
    {
      "id": 7076,
      "keyword": "déjame en paz",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "edad": [
    {
      "id": 7072,
      "keyword": "edad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿cuántos años tienes?": [
    {
      "id": 7072,
      "keyword": "¿cuántos años tienes?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿cuántos hay?": [
    {
      "id": 24731,
      "keyword": "¿cuántos hay?",
      "keywords": 5,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "core vocabulary",
        "adverb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7073,
      "keyword": "¿cuántos hay?",
      "keywords": 4,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuántos hay": [
    {
      "id": 24731,
      "keyword": "cuántos hay",
      "keywords": 5,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "core vocabulary",
        "adverb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7073,
      "keyword": "cuántos hay",
      "keywords": 4,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cantidad": [
    {
      "id": 24731,
      "keyword": "cantidad",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "core vocabulary",
        "adverb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7073,
      "keyword": "cantidad",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cantidades": [
    {
      "id": 24731,
      "keyword": "cantidad",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "core vocabulary",
        "adverb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7073,
      "keyword": "cantidad",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuántos": [
    {
      "id": 24731,
      "keyword": "cuánto",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "core vocabulary",
        "adverb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7073,
      "keyword": "cuántos",
      "keywords": 4,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿de qué color es?": [
    {
      "id": 7075,
      "keyword": "¿de qué color es?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "color",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dirección": [
    {
      "id": 7078,
      "keyword": "dirección",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30231,
      "keyword": "dirección",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "supporting document",
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38571,
      "keyword": "dirección",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "direcciones": [
    {
      "id": 7078,
      "keyword": "dirección",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30231,
      "keyword": "dirección",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "supporting document",
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38571,
      "keyword": "dirección",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "durante": [
    {
      "id": 7081,
      "keyword": "durante",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24737,
      "keyword": "durante",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mientras": [
    {
      "id": 7081,
      "keyword": "mientras",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24737,
      "keyword": "mientras",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "preposition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "de": [
    {
      "id": 7074,
      "keyword": "de",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "envolver": [
    {
      "id": 7084,
      "keyword": "envolver",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "engordar": [
    {
      "id": 37805,
      "keyword": "engordar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit",
        "dietetics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7082,
      "keyword": "engordar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit",
        "dietetics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28247,
      "keyword": "engordar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit",
        "dietetics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿dónde vamos?": [
    {
      "id": 7079,
      "keyword": "¿dónde vamos?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desde": [
    {
      "id": 7077,
      "keyword": "desde",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escupir": [
    {
      "id": 16693,
      "keyword": "escupir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16695,
      "keyword": "escupir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7090,
      "keyword": "escupir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15447,
      "keyword": "escupir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escayolar": [
    {
      "id": 7086,
      "keyword": "escayolar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15445,
      "keyword": "escayolar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enyesar": [
    {
      "id": 7086,
      "keyword": "enyesar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15445,
      "keyword": "enyesar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "eso": [
    {
      "id": 7091,
      "keyword": "eso",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "demonstrative adjective",
        "pronoun",
        "demonstrative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ese": [
    {
      "id": 7091,
      "keyword": "ese",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "demonstrative adjective",
        "pronoun",
        "demonstrative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esa": [
    {
      "id": 7091,
      "keyword": "esa",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "demonstrative adjective",
        "pronoun",
        "demonstrative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espada": [
    {
      "id": 7093,
      "keyword": "espada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espadas": [
    {
      "id": 7093,
      "keyword": "espada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espátula": [
    {
      "id": 7094,
      "keyword": "espátula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8572,
      "keyword": "espátula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espátulas": [
    {
      "id": 7094,
      "keyword": "espátula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8572,
      "keyword": "espátula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escopeta": [
    {
      "id": 7087,
      "keyword": "escopeta",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escopetas": [
    {
      "id": 7087,
      "keyword": "escopeta",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rifle": [
    {
      "id": 7087,
      "keyword": "rifle",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rifles": [
    {
      "id": 7087,
      "keyword": "rifle",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fusil": [
    {
      "id": 7087,
      "keyword": "fusil",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fusiles": [
    {
      "id": 7087,
      "keyword": "fusil",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arma": [
    {
      "id": 7087,
      "keyword": "arma",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "armas": [
    {
      "id": 7087,
      "keyword": "arma",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escuadra": [
    {
      "id": 7088,
      "keyword": "escuadra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escuadras": [
    {
      "id": 7088,
      "keyword": "escuadra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esos": [
    {
      "id": 7092,
      "keyword": "esos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "demonstrative adjective",
        "pronoun",
        "demonstrative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esas": [
    {
      "id": 7092,
      "keyword": "esas",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "demonstrative adjective",
        "pronoun",
        "demonstrative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estos": [
    {
      "id": 7096,
      "keyword": "estos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "demonstrative adjective",
        "pronoun",
        "demonstrative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estas": [
    {
      "id": 7096,
      "keyword": "estas",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "demonstrative adjective",
        "pronoun",
        "demonstrative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "este": [
    {
      "id": 8114,
      "keyword": "Este",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7095,
      "keyword": "este",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "demonstrative adjective",
        "pronoun",
        "demonstrative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esta": [
    {
      "id": 7095,
      "keyword": "esta",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "demonstrative adjective",
        "pronoun",
        "demonstrative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esto": [
    {
      "id": 7095,
      "keyword": "esto",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "demonstrative adjective",
        "pronoun",
        "demonstrative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estropajo": [
    {
      "id": 7098,
      "keyword": "estropajo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "household",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estropajos": [
    {
      "id": 7098,
      "keyword": "estropajo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "household",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fila": [
    {
      "id": 31803,
      "keyword": "fila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37764,
      "keyword": "fila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39146,
      "keyword": "fila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39148,
      "keyword": "fila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7102,
      "keyword": "fila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35123,
      "keyword": "fila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38596,
      "keyword": "fila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38597,
      "keyword": "fila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "filas": [
    {
      "id": 31803,
      "keyword": "fila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37764,
      "keyword": "fila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39146,
      "keyword": "fila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39148,
      "keyword": "fila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7102,
      "keyword": "fila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35123,
      "keyword": "fila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38596,
      "keyword": "fila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38597,
      "keyword": "fila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estreñimiento": [
    {
      "id": 37829,
      "keyword": "estreñimiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7097,
      "keyword": "estreñimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28737,
      "keyword": "estreñimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estreñimientos": [
    {
      "id": 7097,
      "keyword": "estreñimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28737,
      "keyword": "estreñimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "flexo": [
    {
      "id": 7103,
      "keyword": "flexo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flexos": [
    {
      "id": 7103,
      "keyword": "flexo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fiesta": [
    {
      "id": 16649,
      "keyword": "fiesta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "popular event",
        "popular festival",
        "social event",
        "birthday",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25107,
      "keyword": "fiesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24963,
      "keyword": "fiesta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7099,
      "keyword": "fiesta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fiestas": [
    {
      "id": 16649,
      "keyword": "fiesta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "popular event",
        "popular festival",
        "social event",
        "birthday",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25107,
      "keyword": "fiesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24963,
      "keyword": "fiesta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32800,
      "keyword": "fiestas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7099,
      "keyword": "fiesta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "celebraciones": [
    {
      "id": 24963,
      "keyword": "celebración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7099,
      "keyword": "celebración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "temblar": [
    {
      "id": 7109,
      "keyword": "temblar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiritar": [
    {
      "id": 7109,
      "keyword": "tiritar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fumar": [
    {
      "id": 7112,
      "keyword": "fumar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7111,
      "keyword": "fumar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28637,
      "keyword": "fumar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "foto": [
    {
      "id": 7107,
      "keyword": "foto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "photography",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28271,
      "keyword": "foto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fotos": [
    {
      "id": 7107,
      "keyword": "foto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "photography",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28271,
      "keyword": "foto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fotografía": [
    {
      "id": 7107,
      "keyword": "fotografía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "photography",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28271,
      "keyword": "fotografía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fotografías": [
    {
      "id": 7107,
      "keyword": "fotografía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "photography",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28271,
      "keyword": "fotografía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fumigar": [
    {
      "id": 38133,
      "keyword": "fumigar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "invertebrate",
        "arthropod",
        "insect"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7113,
      "keyword": "fumigar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gemelos": [
    {
      "id": 34094,
      "keyword": "gemelos",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "group",
        "baby",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32392,
      "keyword": "gemelo",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7115,
      "keyword": "gemelos",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "group",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24069,
      "keyword": "gemelos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "muscular system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26106,
      "keyword": "gemelos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fluorescente": [
    {
      "id": 7106,
      "keyword": "fluorescente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fluorescentes": [
    {
      "id": 7106,
      "keyword": "fluorescente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "graznar": [
    {
      "id": 7119,
      "keyword": "graznar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "interjection",
        "onomatopoeia",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chillar": [
    {
      "id": 7120,
      "keyword": "chillar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31125,
      "keyword": "chillar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31127,
      "keyword": "chillar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gruñir": [
    {
      "id": 7121,
      "keyword": "gruñir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "interjection",
        "onomatopoeia",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gominolas": [
    {
      "id": 7118,
      "keyword": "gominolas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8352,
      "keyword": "gominola",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gomitas": [
    {
      "id": 7118,
      "keyword": "gomitas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8352,
      "keyword": "gomita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fotografiar": [
    {
      "id": 37663,
      "keyword": "fotografiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "visual art",
        "photography",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37806,
      "keyword": "fotografiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "visual art",
        "photography",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7108,
      "keyword": "fotografiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "visual art",
        "photography",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28341,
      "keyword": "fotografiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "visual art",
        "photography",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacia": [
    {
      "id": 7125,
      "keyword": "hacia",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gente": [
    {
      "id": 7117,
      "keyword": "gente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38444,
      "keyword": "gente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7116,
      "keyword": "gente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7203,
      "keyword": "gente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gentes": [
    {
      "id": 7117,
      "keyword": "gente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38444,
      "keyword": "gente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7116,
      "keyword": "gente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7203,
      "keyword": "gente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "personas": [
    {
      "id": 34558,
      "keyword": "persona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 34558,
      "keyword": "persona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34560,
      "keyword": "persona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 34560,
      "keyword": "persona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7117,
      "keyword": "personas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38444,
      "keyword": "personas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34559,
      "keyword": "persona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34557,
      "keyword": "persona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7116,
      "keyword": "personas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7203,
      "keyword": "personas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hora": [
    {
      "id": 7129,
      "keyword": "hora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "unit of time",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hoy": [
    {
      "id": 7131,
      "keyword": "hoy",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "mathematics",
        "basic concepts",
        "core vocabulary",
        "education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38276,
      "keyword": "hoy",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "mathematics",
        "basic concepts",
        "education",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huevo duro": [
    {
      "id": 7132,
      "keyword": "huevo duro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huevos duros": [
    {
      "id": 7132,
      "keyword": "huevo duro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "herramientas": [
    {
      "id": 7127,
      "keyword": "herramientas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "herramienta": [
    {
      "id": 9883,
      "keyword": "herramienta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7127,
      "keyword": "herramienta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hundir": [
    {
      "id": 7133,
      "keyword": "hundir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "traffic accident"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "naufragar": [
    {
      "id": 7133,
      "keyword": "naufragar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "traffic accident"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fútbol": [
    {
      "id": 16743,
      "keyword": "fútbol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7137,
      "keyword": "fútbol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29116,
      "keyword": "fútbol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35256,
      "keyword": "fútbol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35255,
      "keyword": "fútbol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kilogramo": [
    {
      "id": 39481,
      "keyword": "kilogramo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7138,
      "keyword": "kilogramo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kilogramos": [
    {
      "id": 7138,
      "keyword": "kilogramo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "1 kilo": [
    {
      "id": 39481,
      "keyword": "1 kilo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7138,
      "keyword": "1 kilo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "1 kilogramo": [
    {
      "id": 7138,
      "keyword": "1 kilogramo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "1 kg": [
    {
      "id": 39481,
      "keyword": "1 kg",
      "keywords": 3,
      "type": null,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7138,
      "keyword": "1 kg",
      "keywords": 4,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hielo": [
    {
      "id": 7128,
      "keyword": "hielo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "derived material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hielos": [
    {
      "id": 7128,
      "keyword": "hielo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "derived material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cubito de hielo": [
    {
      "id": 7128,
      "keyword": "cubito de hielo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "derived material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubitos de hielo": [
    {
      "id": 7128,
      "keyword": "cubito de hielo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "derived material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cubito": [
    {
      "id": 7128,
      "keyword": "cubito",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "derived material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubitos": [
    {
      "id": 7128,
      "keyword": "cubito",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "derived material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "insectos": [
    {
      "id": 7134,
      "keyword": "insectos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "insecto": [
    {
      "id": 7134,
      "keyword": "insecto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ladrar": [
    {
      "id": 7139,
      "keyword": "ladrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "interjection",
        "onomatopoeia",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "invernadero": [
    {
      "id": 7135,
      "keyword": "invernadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "invernaderos": [
    {
      "id": 7135,
      "keyword": "invernadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lista": [
    {
      "id": 37794,
      "keyword": "lista",
      "keywords": 5,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7144,
      "keyword": "lista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "cookery",
        "document",
        "food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17000,
      "keyword": "lista",
      "keywords": 3,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30207,
      "keyword": "lista",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "listas": [
    {
      "id": 37794,
      "keyword": "lista",
      "keywords": 5,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7144,
      "keyword": "lista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "cookery",
        "document",
        "food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 17000,
      "keyword": "lista",
      "keywords": 3,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30207,
      "keyword": "lista",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lista de la compra": [
    {
      "id": 7144,
      "keyword": "lista de la compra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "cookery",
        "document",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "listas de la compra": [
    {
      "id": 7144,
      "keyword": "lista de la compra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "cookery",
        "document",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "litro": [
    {
      "id": 7145,
      "keyword": "litro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "litros": [
    {
      "id": 7145,
      "keyword": "litro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llover": [
    {
      "id": 7148,
      "keyword": "llover",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leer": [
    {
      "id": 7141,
      "keyword": "leer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "education",
        "educational task",
        "literature",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28643,
      "keyword": "leer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "literature"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31680,
      "keyword": "leer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavandera": [
    {
      "id": 7140,
      "keyword": "lavandera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35359,
      "keyword": "lavandera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavanderas": [
    {
      "id": 7140,
      "keyword": "lavandera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35359,
      "keyword": "lavandera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llenar": [
    {
      "id": 7146,
      "keyword": "llenar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38805,
      "keyword": "llenar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mazorca de maíz": [
    {
      "id": 7150,
      "keyword": "mazorca de maíz",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "work",
        "primary sector",
        "agriculture",
        "cereal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mazorcas de maíz": [
    {
      "id": 7150,
      "keyword": "mazorca de maíz",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "work",
        "primary sector",
        "agriculture",
        "cereal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "panocha": [
    {
      "id": 7150,
      "keyword": "panocha",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "work",
        "primary sector",
        "agriculture",
        "cereal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panochas": [
    {
      "id": 7150,
      "keyword": "panocha",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "work",
        "primary sector",
        "agriculture",
        "cereal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mañana": [
    {
      "id": 7152,
      "keyword": "mañana",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38278,
      "keyword": "mañana",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25704,
      "keyword": "mañana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "core vocabulary",
        "communication",
        "language",
        "adverb",
        "adverb of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marear": [
    {
      "id": 7155,
      "keyword": "marear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marciano": [
    {
      "id": 7154,
      "keyword": "marciano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marcianos": [
    {
      "id": 7154,
      "keyword": "marciano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "extraterrestre": [
    {
      "id": 7154,
      "keyword": "extraterrestre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "extraterrestres": [
    {
      "id": 7154,
      "keyword": "extraterrestre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maullar": [
    {
      "id": 7156,
      "keyword": "maullar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "interjection",
        "onomatopoeia",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hortaliza": [
    {
      "id": 7130,
      "keyword": "hortaliza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marchitar": [
    {
      "id": 7153,
      "keyword": "marchitar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "plant",
        "plant physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "melenudo": [
    {
      "id": 7159,
      "keyword": "melenudo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "melenudos": [
    {
      "id": 7159,
      "keyword": "melenudo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mes": [
    {
      "id": 37724,
      "keyword": "mes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "month",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7161,
      "keyword": "mes",
      "keywords": 1,
      "type": 6,
      "tags": [
        "time",
        "calendar",
        "month"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ruidoso": [
    {
      "id": 36165,
      "keyword": "ruidoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7157,
      "keyword": "ruidoso",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36047,
      "keyword": "ruidoso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ruidosos": [
    {
      "id": 36165,
      "keyword": "ruidoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7157,
      "keyword": "ruidoso",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36047,
      "keyword": "ruidoso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "me molesta el ruido": [
    {
      "id": 7157,
      "keyword": "me molesta el ruido",
      "keywords": 6,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "molestar": [
    {
      "id": 37824,
      "keyword": "molestar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7157,
      "keyword": "molestar",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28459,
      "keyword": "molestar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "molesto": [
    {
      "id": 7157,
      "keyword": "molesto",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "molestos": [
    {
      "id": 7157,
      "keyword": "molesto",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ruidosa": [
    {
      "id": 36165,
      "keyword": "ruidosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7157,
      "keyword": "ruidosa",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36091,
      "keyword": "ruidosa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ruidosas": [
    {
      "id": 36165,
      "keyword": "ruidosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7157,
      "keyword": "ruidosa",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36091,
      "keyword": "ruidosa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "molesta": [
    {
      "id": 7157,
      "keyword": "molesta",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "molestas": [
    {
      "id": 7157,
      "keyword": "molesta",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "madriguera": [
    {
      "id": 7149,
      "keyword": "madriguera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "madrigueras": [
    {
      "id": 7149,
      "keyword": "madriguera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guarida": [
    {
      "id": 7149,
      "keyword": "guarida",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guaridas": [
    {
      "id": 7149,
      "keyword": "guarida",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cado": [
    {
      "id": 7149,
      "keyword": "cado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cados": [
    {
      "id": 7149,
      "keyword": "cado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mordedor": [
    {
      "id": 7164,
      "keyword": "mordedor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare",
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mordedores": [
    {
      "id": 7164,
      "keyword": "mordedor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare",
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mi turno": [
    {
      "id": 7158,
      "keyword": "mi turno",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "leisure",
        "sport",
        "traditional game",
        "game",
        "card game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "me toca a mí": [
    {
      "id": 7158,
      "keyword": "me toca a mí",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "leisure",
        "sport",
        "traditional game",
        "game",
        "card game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "turno": [
    {
      "id": 7158,
      "keyword": "turno",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "leisure",
        "sport",
        "traditional game",
        "game",
        "card game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22190,
      "keyword": "turno",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "turnos": [
    {
      "id": 7158,
      "keyword": "turno",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "leisure",
        "sport",
        "traditional game",
        "game",
        "card game",
        "board game"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22190,
      "keyword": "turno",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mancha": [
    {
      "id": 7151,
      "keyword": "mancha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manchas": [
    {
      "id": 7151,
      "keyword": "mancha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desplazar": [
    {
      "id": 7167,
      "keyword": "desplazar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mover": [
    {
      "id": 39425,
      "keyword": "mover",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27371,
      "keyword": "mover",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21395,
      "keyword": "mover",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7167,
      "keyword": "mover",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "menear": [
    {
      "id": 7167,
      "keyword": "menear",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "necesito ayuda": [
    {
      "id": 7171,
      "keyword": "necesito ayuda",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muchos": [
    {
      "id": 7168,
      "keyword": "muchos",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muchas": [
    {
      "id": 7168,
      "keyword": "muchas",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mucha": [
    {
      "id": 7168,
      "keyword": "mucha",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diversos": [
    {
      "id": 7168,
      "keyword": "diversos",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diversas": [
    {
      "id": 7168,
      "keyword": "diversas",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aneblar": [
    {
      "id": 7174,
      "keyword": "aneblar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anieblar": [
    {
      "id": 7174,
      "keyword": "anieblar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nido": [
    {
      "id": 7173,
      "keyword": "nido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nidos": [
    {
      "id": 7173,
      "keyword": "nido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mugir": [
    {
      "id": 7169,
      "keyword": "mugir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "interjection",
        "onomatopoeia",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nevar": [
    {
      "id": 7172,
      "keyword": "nevar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "navegar": [
    {
      "id": 7170,
      "keyword": "navegar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nosotras": [
    {
      "id": 7184,
      "keyword": "nosotras",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7183,
      "keyword": "nosotras",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nosotras nos": [
    {
      "id": 7184,
      "keyword": "nosotras nos",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7183,
      "keyword": "nosotras nos",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nos": [
    {
      "id": 7184,
      "keyword": "nos",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7186,
      "keyword": "nos",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32306,
      "keyword": "nos",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "noche": [
    {
      "id": 7181,
      "keyword": "noche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26997,
      "keyword": "noche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "event",
        "popular event",
        "halloween",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35789,
      "keyword": "noche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nosotros": [
    {
      "id": 7186,
      "keyword": "nosotros",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32306,
      "keyword": "nosotros",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7185,
      "keyword": "nosotros",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31672,
      "keyword": "nosotros",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31674,
      "keyword": "nosotros",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nosotros nos": [
    {
      "id": 7186,
      "keyword": "nosotros nos",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32306,
      "keyword": "nosotros nos",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7185,
      "keyword": "nosotros nos",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31672,
      "keyword": "nosotros nos",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31674,
      "keyword": "nosotros nos",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nota": [
    {
      "id": 7187,
      "keyword": "nota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9127,
      "keyword": "nota",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9123,
      "keyword": "nota",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15517,
      "keyword": "nota",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "notas": [
    {
      "id": 7187,
      "keyword": "nota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9127,
      "keyword": "nota",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9123,
      "keyword": "nota",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15517,
      "keyword": "nota",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guisantes": [
    {
      "id": 7182,
      "keyword": "guisantes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23847,
      "keyword": "guisantes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arvejas": [
    {
      "id": 7182,
      "keyword": "arvejas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23847,
      "keyword": "arveja",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "platillo volador": [
    {
      "id": 7191,
      "keyword": "platillo volador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "platillos voladores": [
    {
      "id": 7191,
      "keyword": "platillo volador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ovni": [
    {
      "id": 7191,
      "keyword": "ovni",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ovnis": [
    {
      "id": 7191,
      "keyword": "ovni",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nave espacial": [
    {
      "id": 7191,
      "keyword": "nave espacial",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "naves espaciales": [
    {
      "id": 7191,
      "keyword": "nave espacial",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "panal": [
    {
      "id": 10247,
      "keyword": "panal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "apiculture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7192,
      "keyword": "panal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "apiculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panales": [
    {
      "id": 10247,
      "keyword": "panal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "apiculture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7192,
      "keyword": "panal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "apiculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "panal de abejas": [
    {
      "id": 7192,
      "keyword": "panal de abejas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "apiculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panales de abejas": [
    {
      "id": 7192,
      "keyword": "panal de abejas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "apiculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuidador": [
    {
      "id": 38411,
      "keyword": "cuidador",
      "keywords": 6,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14662,
      "keyword": "cuidador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7163,
      "keyword": "cuidador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15992,
      "keyword": "cuidador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuidadores": [
    {
      "id": 38411,
      "keyword": "cuidador",
      "keywords": 6,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 14662,
      "keyword": "cuidador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15994,
      "keyword": "cuidadores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7163,
      "keyword": "cuidador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15992,
      "keyword": "cuidador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parar": [
    {
      "id": 7196,
      "keyword": "parar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "movement",
        "traffic",
        "road safety",
        "core vocabulary",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37185,
      "keyword": "parar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7195,
      "keyword": "parar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36021,
      "keyword": "parar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9015,
      "keyword": "parar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "person",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "detener": [
    {
      "id": 7196,
      "keyword": "detener",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "movement",
        "traffic",
        "road safety",
        "core vocabulary",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37185,
      "keyword": "detener",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27393,
      "keyword": "detener",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7195,
      "keyword": "detener",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36021,
      "keyword": "detener",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8087,
      "keyword": "detener",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yo no sé": [
    {
      "id": 7180,
      "keyword": "yo no sé",
      "keywords": 6,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "no te entiendo": [
    {
      "id": 7180,
      "keyword": "no te entiendo",
      "keywords": 6,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "no lo sé": [
    {
      "id": 7180,
      "keyword": "no lo sé",
      "keywords": 6,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "incomprensible": [
    {
      "id": 7180,
      "keyword": "incomprensible",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15329,
      "keyword": "incomprensible",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "incomprensibles": [
    {
      "id": 7180,
      "keyword": "incomprensible",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15329,
      "keyword": "incomprensible",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "no lo entiendo": [
    {
      "id": 7180,
      "keyword": "no lo entiendo",
      "keywords": 6,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ups": [
    {
      "id": 7180,
      "keyword": "ups",
      "keywords": 6,
      "type": null,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tóxico": [
    {
      "id": 7200,
      "keyword": "tóxico",
      "keywords": 1,
      "type": 4,
      "tags": [
        "chemistry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34912,
      "keyword": "tóxico",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tóxicos": [
    {
      "id": 7200,
      "keyword": "tóxico",
      "keywords": 1,
      "type": 4,
      "tags": [
        "chemistry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34912,
      "keyword": "tóxico",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perrito caliente": [
    {
      "id": 7201,
      "keyword": "perrito caliente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perritos calientes": [
    {
      "id": 7201,
      "keyword": "perrito caliente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38618,
      "keyword": "perritos calientes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pancho": [
    {
      "id": 7201,
      "keyword": "pancho",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panchos": [
    {
      "id": 7201,
      "keyword": "pancho",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perro caliente": [
    {
      "id": 7201,
      "keyword": "perro caliente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perros calientes": [
    {
      "id": 7201,
      "keyword": "perro caliente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "para": [
    {
      "id": 7194,
      "keyword": "para",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niño jesús": [
    {
      "id": 7177,
      "keyword": "Niño Jesús",
      "keywords": 2,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "christianity",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jesús": [
    {
      "id": 7177,
      "keyword": "Jesús",
      "keywords": 2,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "christianity",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24135,
      "keyword": "Jesús",
      "keywords": 3,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "historical character",
        "history",
        "christianity",
        "event",
        "popular event",
        "easter week"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner un huevo": [
    {
      "id": 7211,
      "keyword": "poner un huevo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "animal",
        "animal physiology",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinchar el globo": [
    {
      "id": 7206,
      "keyword": "pinchar el globo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "postal": [
    {
      "id": 7215,
      "keyword": "postal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "postales": [
    {
      "id": 7215,
      "keyword": "postal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ganar": [
    {
      "id": 7218,
      "keyword": "ganar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38986,
      "keyword": "ganar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10155,
      "keyword": "ganar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36541,
      "keyword": "ganar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 19531,
      "keyword": "ganar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porrón": [
    {
      "id": 7213,
      "keyword": "porrón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porrones": [
    {
      "id": 7213,
      "keyword": "porrón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "por": [
    {
      "id": 7212,
      "keyword": "por",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "postre": [
    {
      "id": 7216,
      "keyword": "postre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "postres": [
    {
      "id": 7216,
      "keyword": "postre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "primer plato": [
    {
      "id": 7219,
      "keyword": "primer plato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "primeros platos": [
    {
      "id": 7219,
      "keyword": "primer plato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dirección prohibida": [
    {
      "id": 7220,
      "keyword": "dirección prohibida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "direcciones prohibidas": [
    {
      "id": 7220,
      "keyword": "dirección prohibida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "podar": [
    {
      "id": 7210,
      "keyword": "podar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ordenador portátil": [
    {
      "id": 7214,
      "keyword": "ordenador portátil",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ordenadores portátiles": [
    {
      "id": 7214,
      "keyword": "ordenador portátil",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "portátil": [
    {
      "id": 7214,
      "keyword": "portátil",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "portátiles": [
    {
      "id": 7214,
      "keyword": "portátil",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pregunta": [
    {
      "id": 7217,
      "keyword": "pregunta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "preguntas": [
    {
      "id": 7217,
      "keyword": "pregunta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿qué tiempo hace?": [
    {
      "id": 7223,
      "keyword": "¿qué tiempo hace?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena",
        "core vocabulary",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiempo": [
    {
      "id": 7223,
      "keyword": "tiempo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena",
        "core vocabulary",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22631,
      "keyword": "tiempo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulsar": [
    {
      "id": 7222,
      "keyword": "pulsar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26354,
      "keyword": "pulsar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31488,
      "keyword": "pulsar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rayado": [
    {
      "id": 7225,
      "keyword": "rayado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "pattern",
        "core vocabulary",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rayados": [
    {
      "id": 7225,
      "keyword": "rayado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "pattern",
        "core vocabulary",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rayada": [
    {
      "id": 7225,
      "keyword": "rayada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "pattern",
        "core vocabulary",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rayadas": [
    {
      "id": 7225,
      "keyword": "rayada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "pattern",
        "core vocabulary",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rayas": [
    {
      "id": 7225,
      "keyword": "rayas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "pattern",
        "core vocabulary",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34627,
      "keyword": "raya",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "ovoviviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recolectar": [
    {
      "id": 32663,
      "keyword": "recolectar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39444,
      "keyword": "recolectar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7227,
      "keyword": "recolectar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39443,
      "keyword": "recolectar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "relinchar": [
    {
      "id": 7228,
      "keyword": "relinchar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "interjection",
        "onomatopoeia",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ropa": [
    {
      "id": 7233,
      "keyword": "ropa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ropas": [
    {
      "id": 7233,
      "keyword": "ropas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rotonda": [
    {
      "id": 7234,
      "keyword": "rotonda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rotondas": [
    {
      "id": 7234,
      "keyword": "rotonda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rugir": [
    {
      "id": 7235,
      "keyword": "rugir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "interjection",
        "onomatopoeia",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puedo?": [
    {
      "id": 7221,
      "keyword": "puedo?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿puedo jugar?": [
    {
      "id": 7221,
      "keyword": "¿puedo jugar?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salamandra": [
    {
      "id": 7236,
      "keyword": "salamandra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "amphibian",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salamandras": [
    {
      "id": 7236,
      "keyword": "salamandra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "amphibian",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "segundo plato": [
    {
      "id": 7240,
      "keyword": "segundo plato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "segundos platos": [
    {
      "id": 7240,
      "keyword": "segundo plato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salvaje": [
    {
      "id": 7237,
      "keyword": "salvaje",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "geography",
        "physical geography",
        "natural habitat",
        "animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salvajes": [
    {
      "id": 7237,
      "keyword": "salvaje",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "geography",
        "physical geography",
        "natural habitat",
        "animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "romántico": [
    {
      "id": 31995,
      "keyword": "romántico",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7232,
      "keyword": "romántico",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "románticos": [
    {
      "id": 31995,
      "keyword": "romántico",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7232,
      "keyword": "romántico",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enamorado": [
    {
      "id": 30389,
      "keyword": "enamorado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31995,
      "keyword": "enamorado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7232,
      "keyword": "enamorado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "romántica": [
    {
      "id": 11957,
      "keyword": "romántica",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7232,
      "keyword": "romántica",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "románticas": [
    {
      "id": 11957,
      "keyword": "romántica",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7232,
      "keyword": "romántica",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enamorada": [
    {
      "id": 30389,
      "keyword": "enamorada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11957,
      "keyword": "enamorada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7232,
      "keyword": "enamorada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enamoradas": [
    {
      "id": 30389,
      "keyword": "enamorada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38799,
      "keyword": "enamoradas",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11523,
      "keyword": "enamoradas",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11531,
      "keyword": "enamoradas",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11957,
      "keyword": "enamorada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7232,
      "keyword": "enamorada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8995,
      "keyword": "enamoradas",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rama": [
    {
      "id": 7224,
      "keyword": "rama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ramas": [
    {
      "id": 7224,
      "keyword": "rama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "semana": [
    {
      "id": 37372,
      "keyword": "semana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37732,
      "keyword": "semana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7244,
      "keyword": "semana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24601,
      "keyword": "semana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "semanas": [
    {
      "id": 37372,
      "keyword": "semana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37732,
      "keyword": "semana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7244,
      "keyword": "semana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24601,
      "keyword": "semana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "secar el pelo": [
    {
      "id": 16887,
      "keyword": "secar el pelo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27485,
      "keyword": "secar el pelo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38471,
      "keyword": "secar el pelo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7239,
      "keyword": "secar el pelo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27486,
      "keyword": "secar el pelo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28503,
      "keyword": "secar el pelo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sembrar": [
    {
      "id": 7245,
      "keyword": "sembrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "siembra": [
    {
      "id": 7245,
      "keyword": "siembra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "siembras": [
    {
      "id": 7245,
      "keyword": "siembra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "semillero": [
    {
      "id": 7246,
      "keyword": "semillero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "semilleros": [
    {
      "id": 7246,
      "keyword": "semillero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "san josé": [
    {
      "id": 7238,
      "keyword": "San José",
      "keywords": 2,
      "type": 1,
      "tags": [
        "religion",
        "character"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "josé": [
    {
      "id": 7238,
      "keyword": "José",
      "keywords": 2,
      "type": 1,
      "tags": [
        "religion",
        "character"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sellar": [
    {
      "id": 7242,
      "keyword": "sellar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7243,
      "keyword": "sellar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "servir": [
    {
      "id": 7247,
      "keyword": "servir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36965,
      "keyword": "servir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38707,
      "keyword": "servir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "simpático": [
    {
      "id": 37800,
      "keyword": "simpático",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31764,
      "keyword": "simpático",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7251,
      "keyword": "simpático",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "simpáticos": [
    {
      "id": 37800,
      "keyword": "simpático",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31764,
      "keyword": "simpático",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7251,
      "keyword": "simpático",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agradable": [
    {
      "id": 37800,
      "keyword": "agradable",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32340,
      "keyword": "agradable",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8484,
      "keyword": "agradable",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31851,
      "keyword": "agradable",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10212,
      "keyword": "agradable",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31764,
      "keyword": "agradable",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7251,
      "keyword": "agradable",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agradables": [
    {
      "id": 37800,
      "keyword": "agradable",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32340,
      "keyword": "agradable",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8484,
      "keyword": "agradable",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31851,
      "keyword": "agradable",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10212,
      "keyword": "agradable",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31764,
      "keyword": "agradable",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7251,
      "keyword": "agradable",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "simpática": [
    {
      "id": 37800,
      "keyword": "simpática",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10212,
      "keyword": "simpática",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7251,
      "keyword": "simpática",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "simpáticas": [
    {
      "id": 37800,
      "keyword": "simpática",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10212,
      "keyword": "simpática",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7251,
      "keyword": "simpática",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silbar": [
    {
      "id": 16891,
      "keyword": "silbar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7249,
      "keyword": "silbar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35363,
      "keyword": "silbar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pitido": [
    {
      "id": 7250,
      "keyword": "pitido",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport rules"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35364,
      "keyword": "pitido",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport rules"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pitidos": [
    {
      "id": 7250,
      "keyword": "pitido",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport rules"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35364,
      "keyword": "pitido",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport rules"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pitar": [
    {
      "id": 31352,
      "keyword": "pitar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7250,
      "keyword": "pitar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport rules"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35364,
      "keyword": "pitar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport rules"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "solitario": [
    {
      "id": 25776,
      "keyword": "solitario",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7253,
      "keyword": "solitario",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "solitarios": [
    {
      "id": 25776,
      "keyword": "solitario",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7253,
      "keyword": "solitario",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "solo": [
    {
      "id": 39247,
      "keyword": "solo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25776,
      "keyword": "solo",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7253,
      "keyword": "solo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "solos": [
    {
      "id": 25776,
      "keyword": "solo",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7253,
      "keyword": "solo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sonarse la nariz": [
    {
      "id": 16893,
      "keyword": "sonarse la nariz",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7256,
      "keyword": "sonarse la nariz",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28793,
      "keyword": "sonarse la nariz",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28794,
      "keyword": "sonarse la nariz",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31746,
      "keyword": "sonarse la nariz",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34469,
      "keyword": "sonarse la nariz",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8731,
      "keyword": "sonarse la nariz",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sonar la nariz": [
    {
      "id": 16893,
      "keyword": "sonar la nariz",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7256,
      "keyword": "sonar la nariz",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28793,
      "keyword": "sonar la nariz",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28794,
      "keyword": "sonar la nariz",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31746,
      "keyword": "sonar la nariz",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34469,
      "keyword": "sonar la nariz",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8731,
      "keyword": "sonar la nariz",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soñar": [
    {
      "id": 7257,
      "keyword": "soñar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sonajero": [
    {
      "id": 7254,
      "keyword": "sonajero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sonajeros": [
    {
      "id": 7254,
      "keyword": "sonajero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sorprender": [
    {
      "id": 9038,
      "keyword": "sorprender",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7260,
      "keyword": "sorprender",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "impresionar": [
    {
      "id": 7260,
      "keyword": "impresionar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taller mecánico": [
    {
      "id": 7263,
      "keyword": "taller mecánico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16975,
      "keyword": "taller mecánico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "workplace",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talleres mecánicos": [
    {
      "id": 7263,
      "keyword": "taller mecánico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16975,
      "keyword": "taller mecánico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "workplace",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tapar el bote": [
    {
      "id": 7264,
      "keyword": "tapar el bote",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tapar la boca": [
    {
      "id": 7266,
      "keyword": "tapar la boca",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31797,
      "keyword": "tapar la boca",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tapar": [
    {
      "id": 39448,
      "keyword": "tapar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34465,
      "keyword": "tapar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7265,
      "keyword": "tapar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26024,
      "keyword": "tapar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34459,
      "keyword": "tapar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arropar": [
    {
      "id": 34465,
      "keyword": "arropar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7265,
      "keyword": "arropar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34459,
      "keyword": "arropar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viento": [
    {
      "id": 7259,
      "keyword": "viento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena",
        "autumn"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vientos": [
    {
      "id": 7259,
      "keyword": "viento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena",
        "autumn"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarde": [
    {
      "id": 7268,
      "keyword": "tarde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37780,
      "keyword": "tarde",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tardes": [
    {
      "id": 7268,
      "keyword": "tarde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tapón": [
    {
      "id": 7267,
      "keyword": "tapón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tapones": [
    {
      "id": 7267,
      "keyword": "tapón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarjeta de navidad": [
    {
      "id": 7269,
      "keyword": "tarjeta de Navidad",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarjetas de navidad": [
    {
      "id": 7269,
      "keyword": "tarjeta de Navidad",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "felicitación": [
    {
      "id": 7269,
      "keyword": "felicitación",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "felicitaciones": [
    {
      "id": 7269,
      "keyword": "felicitación",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "postal de navidad": [
    {
      "id": 7269,
      "keyword": "postal de Navidad",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "postales de navidad": [
    {
      "id": 7269,
      "keyword": "postal de Navidad",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "postal navideña": [
    {
      "id": 7269,
      "keyword": "postal Navideña",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "postales navideñas": [
    {
      "id": 7269,
      "keyword": "postal Navideña",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "teclas de piano": [
    {
      "id": 7270,
      "keyword": "teclas de piano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "keyboard instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tener hambre": [
    {
      "id": 7272,
      "keyword": "tener hambre",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tener sed": [
    {
      "id": 7273,
      "keyword": "tener sed",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sed": [
    {
      "id": 7273,
      "keyword": "sed",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suavizante": [
    {
      "id": 7262,
      "keyword": "suavizante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35823,
      "keyword": "suavizante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suavizantes": [
    {
      "id": 7262,
      "keyword": "suavizante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35823,
      "keyword": "suavizante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "termo": [
    {
      "id": 7274,
      "keyword": "termo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "termos": [
    {
      "id": 7274,
      "keyword": "termo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "senos": [
    {
      "id": 7275,
      "keyword": "senos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8372,
      "keyword": "seno",
      "keywords": 3,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tetas": [
    {
      "id": 7275,
      "keyword": "tetas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8372,
      "keyword": "teta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tirar a la papelera": [
    {
      "id": 38129,
      "keyword": "tirar a la papelera",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "person",
        "routine",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38226,
      "keyword": "tirar a la papelera",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "person",
        "routine",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38227,
      "keyword": "tirar a la papelera",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "person",
        "routine",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7278,
      "keyword": "tirar a la papelera",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tener": [
    {
      "id": 32761,
      "keyword": "tener",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7271,
      "keyword": "tener",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poseer": [
    {
      "id": 32761,
      "keyword": "poseer",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7271,
      "keyword": "poseer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "traer": [
    {
      "id": 7280,
      "keyword": "traer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7279,
      "keyword": "traer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32061,
      "keyword": "traer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37778,
      "keyword": "traer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aportar": [
    {
      "id": 7280,
      "keyword": "aportar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7279,
      "keyword": "aportar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32061,
      "keyword": "aportar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37778,
      "keyword": "aportar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "timón": [
    {
      "id": 33056,
      "keyword": "timón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7277,
      "keyword": "timón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "timones": [
    {
      "id": 33056,
      "keyword": "timón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7277,
      "keyword": "timón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trigo": [
    {
      "id": 7285,
      "keyword": "trigo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "cereal",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trigos": [
    {
      "id": 7285,
      "keyword": "trigo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "cereal",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tres en raya": [
    {
      "id": 7284,
      "keyword": "tres en raya",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ta te ti": [
    {
      "id": 7284,
      "keyword": "ta te ti",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entristecer": [
    {
      "id": 7286,
      "keyword": "entristecer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trébol": [
    {
      "id": 7281,
      "keyword": "trébol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tréboles": [
    {
      "id": 7281,
      "keyword": "trébol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tetera": [
    {
      "id": 7276,
      "keyword": "tetera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teteras": [
    {
      "id": 7276,
      "keyword": "tetera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vacunar": [
    {
      "id": 7293,
      "keyword": "vacunar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30703,
      "keyword": "vacunar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30073,
      "keyword": "vacunar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30074,
      "keyword": "vacunar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31714,
      "keyword": "vacunar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32057,
      "keyword": "vacunar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vendar": [
    {
      "id": 7295,
      "keyword": "vendar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30652,
      "keyword": "vendar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30653,
      "keyword": "vendar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30654,
      "keyword": "vendar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38064,
      "keyword": "vendar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "relampaguear": [
    {
      "id": 7288,
      "keyword": "relampaguear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "meteorology",
        "atmospheric phenomena",
        "communication",
        "language",
        "verb",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vivir": [
    {
      "id": 11605,
      "keyword": "vivir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "basic needs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7302,
      "keyword": "vivir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35103,
      "keyword": "vivir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38394,
      "keyword": "vivir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "aquatic animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vinagrera": [
    {
      "id": 7300,
      "keyword": "vinagrera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vinagreras": [
    {
      "id": 7300,
      "keyword": "vinagrera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "virgen maría": [
    {
      "id": 7301,
      "keyword": "Virgen María",
      "keywords": 3,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "christianity",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maría": [
    {
      "id": 7301,
      "keyword": "María",
      "keywords": 3,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "christianity",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vómito": [
    {
      "id": 7303,
      "keyword": "vómito",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vómitos": [
    {
      "id": 7303,
      "keyword": "vómito",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vosotras": [
    {
      "id": 7305,
      "keyword": "vosotras",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7304,
      "keyword": "vosotras",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vosotras os": [
    {
      "id": 7305,
      "keyword": "vosotras os",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7304,
      "keyword": "vosotras os",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "verter": [
    {
      "id": 7298,
      "keyword": "verter",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "os": [
    {
      "id": 7305,
      "keyword": "os",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7307,
      "keyword": "os",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "verbo": [
    {
      "id": 7297,
      "keyword": "verbo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32604,
      "keyword": "verbo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32067,
      "keyword": "verbo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "verbos": [
    {
      "id": 7297,
      "keyword": "verbos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32604,
      "keyword": "verbo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32067,
      "keyword": "verbos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acción": [
    {
      "id": 7297,
      "keyword": "acción",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32067,
      "keyword": "acción",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acciones": [
    {
      "id": 7297,
      "keyword": "acciones",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32067,
      "keyword": "acciones",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "untar": [
    {
      "id": 7292,
      "keyword": "untar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "cutlery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38397,
      "keyword": "untar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vosotros": [
    {
      "id": 7307,
      "keyword": "vosotros",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7306,
      "keyword": "vosotros",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vosotros os": [
    {
      "id": 7307,
      "keyword": "vosotros os",
      "keywords": 3,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7306,
      "keyword": "vosotros os",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yema": [
    {
      "id": 7308,
      "keyword": "yema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32906,
      "keyword": "yema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "integumentary system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36975,
      "keyword": "yema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yemas": [
    {
      "id": 7308,
      "keyword": "yema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32906,
      "keyword": "yema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "integumentary system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36975,
      "keyword": "yema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zumbar": [
    {
      "id": 7311,
      "keyword": "zumbar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "interjection",
        "onomatopoeia",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entre": [
    {
      "id": 7765,
      "keyword": "entre",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rebuznar": [
    {
      "id": 7702,
      "keyword": "rebuznar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "interjection",
        "onomatopoeia",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espumillón": [
    {
      "id": 7766,
      "keyword": "espumillón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espumillones": [
    {
      "id": 7766,
      "keyword": "espumillón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ferretero": [
    {
      "id": 7768,
      "keyword": "ferretero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7767,
      "keyword": "ferretero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ferreteros": [
    {
      "id": 7768,
      "keyword": "ferretero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tool"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7767,
      "keyword": "ferretero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lanza": [
    {
      "id": 7773,
      "keyword": "lanza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36551,
      "keyword": "lanza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lanzas": [
    {
      "id": 7773,
      "keyword": "lanza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36551,
      "keyword": "lanza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hasta": [
    {
      "id": 7771,
      "keyword": "hasta",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dónde": [
    {
      "id": 7764,
      "keyword": "dónde",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "core vocabulary",
        "adverb",
        "adverb of place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿dónde?": [
    {
      "id": 7764,
      "keyword": "¿dónde?",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "core vocabulary",
        "adverb",
        "adverb of place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "donde": [
    {
      "id": 7764,
      "keyword": "donde",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "core vocabulary",
        "adverb",
        "adverb of place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crema de cacao": [
    {
      "id": 7763,
      "keyword": "crema de cacao",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cremas de cacao": [
    {
      "id": 7763,
      "keyword": "crema de cacao",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dulce de leche": [
    {
      "id": 36988,
      "keyword": "dulce de leche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7763,
      "keyword": "dulce de leche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dulces de leche": [
    {
      "id": 36988,
      "keyword": "dulce de leche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7763,
      "keyword": "dulce de leche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "listón": [
    {
      "id": 7774,
      "keyword": "listón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "listones": [
    {
      "id": 7774,
      "keyword": "listón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lunares": [
    {
      "id": 7776,
      "keyword": "lunares",
      "keywords": 2,
      "type": 2,
      "tags": [
        "pattern",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "a topos": [
    {
      "id": 7776,
      "keyword": "a topos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "pattern",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gaspar": [
    {
      "id": 7769,
      "keyword": "Gaspar",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "christianity",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hocico": [
    {
      "id": 7772,
      "keyword": "hocico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hocicos": [
    {
      "id": 7772,
      "keyword": "hocico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mercera": [
    {
      "id": 7780,
      "keyword": "mercera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7779,
      "keyword": "mercera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "merceras": [
    {
      "id": 7780,
      "keyword": "mercera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7779,
      "keyword": "mercera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mamíferos": [
    {
      "id": 7777,
      "keyword": "mamíferos",
      "keywords": 1,
      "type": 4,
      "tags": [
        "animal",
        "vertebrate",
        "mammal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mercería": [
    {
      "id": 7782,
      "keyword": "mercería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7781,
      "keyword": "mercería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mercerías": [
    {
      "id": 7782,
      "keyword": "mercería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7781,
      "keyword": "mercería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gemelas": [
    {
      "id": 32392,
      "keyword": "gemela",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7770,
      "keyword": "gemelas",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolor de espalda": [
    {
      "id": 28785,
      "keyword": "dolor de espalda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28786,
      "keyword": "dolor de espalda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7775,
      "keyword": "dolor de espalda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolores de espalda": [
    {
      "id": 28785,
      "keyword": "dolor de espalda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28786,
      "keyword": "dolor de espalda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7775,
      "keyword": "dolor de espalda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lumbalgia": [
    {
      "id": 7775,
      "keyword": "lumbalgia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lumbalgias": [
    {
      "id": 7775,
      "keyword": "lumbalgia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parche": [
    {
      "id": 7786,
      "keyword": "parche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37611,
      "keyword": "parche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37836,
      "keyword": "parche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30710,
      "keyword": "parche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30711,
      "keyword": "parche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30709,
      "keyword": "parche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30712,
      "keyword": "parche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parches": [
    {
      "id": 7786,
      "keyword": "parche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37611,
      "keyword": "parche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37836,
      "keyword": "parche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30710,
      "keyword": "parche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30711,
      "keyword": "parche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30709,
      "keyword": "parche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30712,
      "keyword": "parche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "patilla": [
    {
      "id": 7789,
      "keyword": "patilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patillas": [
    {
      "id": 7789,
      "keyword": "patilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pastor": [
    {
      "id": 27536,
      "keyword": "pastor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7788,
      "keyword": "pastor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27535,
      "keyword": "pastor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pastores": [
    {
      "id": 27536,
      "keyword": "pastor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7788,
      "keyword": "pastor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27535,
      "keyword": "pastor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pezuña": [
    {
      "id": 7790,
      "keyword": "pezuña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pezuñas": [
    {
      "id": 7790,
      "keyword": "pezuña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mp3": [
    {
      "id": 7783,
      "keyword": "mp3",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "music device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "índice": [
    {
      "id": 32767,
      "keyword": "índice",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature",
        "library science"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7791,
      "keyword": "índice",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "índices": [
    {
      "id": 32767,
      "keyword": "índice",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature",
        "library science"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7791,
      "keyword": "índice",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "noticia": [
    {
      "id": 7784,
      "keyword": "noticia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "noticias": [
    {
      "id": 35389,
      "keyword": "noticias",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7784,
      "keyword": "noticia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8229,
      "keyword": "noticias",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meñique": [
    {
      "id": 7778,
      "keyword": "meñique",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meñiques": [
    {
      "id": 7778,
      "keyword": "meñique",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "profesor de música": [
    {
      "id": 7796,
      "keyword": "profesor de música",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "profesores de música": [
    {
      "id": 7796,
      "keyword": "profesor de música",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "potito": [
    {
      "id": 7793,
      "keyword": "potito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "potitos": [
    {
      "id": 7793,
      "keyword": "potito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "papilla": [
    {
      "id": 7785,
      "keyword": "papilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papillas": [
    {
      "id": 7785,
      "keyword": "papilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "profesora de educación física": [
    {
      "id": 7798,
      "keyword": "profesora de educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "profesoras de educación física": [
    {
      "id": 7798,
      "keyword": "profesora de educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maestra de educación física": [
    {
      "id": 7798,
      "keyword": "maestra de educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maestras de educación física": [
    {
      "id": 7798,
      "keyword": "maestra de educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿qué lees?": [
    {
      "id": 7800,
      "keyword": "¿qué lees?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "profesor de taller": [
    {
      "id": 7797,
      "keyword": "profesor de taller",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "profesores de taller": [
    {
      "id": 7797,
      "keyword": "profesor de taller",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pósit": [
    {
      "id": 7792,
      "keyword": "pósit",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pósits": [
    {
      "id": 7792,
      "keyword": "pósit",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿qué miras?": [
    {
      "id": 7801,
      "keyword": "¿qué miras?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trabajadores": [
    {
      "id": 20113,
      "keyword": "trabajador",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7795,
      "keyword": "trabajadores",
      "keywords": 8,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "profesionales": [
    {
      "id": 36950,
      "keyword": "profesionales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7795,
      "keyword": "profesionales",
      "keywords": 8,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trabajador": [
    {
      "id": 20113,
      "keyword": "trabajador",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7795,
      "keyword": "trabajador",
      "keywords": 8,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "profesional": [
    {
      "id": 7795,
      "keyword": "profesional",
      "keywords": 8,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "profesiones": [
    {
      "id": 7795,
      "keyword": "profesiones",
      "keywords": 8,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "profesión": [
    {
      "id": 7795,
      "keyword": "profesión",
      "keywords": 8,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oficio": [
    {
      "id": 7795,
      "keyword": "oficio",
      "keywords": 8,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oficios": [
    {
      "id": 7795,
      "keyword": "oficios",
      "keywords": 8,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manualidades": [
    {
      "id": 7794,
      "keyword": "manualidades",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16339,
      "keyword": "manualidades",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "craftsmanship",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24769,
      "keyword": "manualidades",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trabajos manuales": [
    {
      "id": 7794,
      "keyword": "trabajos manuales",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16339,
      "keyword": "trabajos manuales",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "craftsmanship",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24769,
      "keyword": "trabajos manuales",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plástica": [
    {
      "id": 7794,
      "keyword": "plástica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plásticas": [
    {
      "id": 7794,
      "keyword": "plástica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿quién llama?": [
    {
      "id": 7803,
      "keyword": "¿quién llama?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "resaltador": [
    {
      "id": 7807,
      "keyword": "resaltador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "resaltadores": [
    {
      "id": 7807,
      "keyword": "resaltador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿qué tienes?": [
    {
      "id": 7802,
      "keyword": "¿qué tienes?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulgar": [
    {
      "id": 7799,
      "keyword": "pulgar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulgares": [
    {
      "id": 7799,
      "keyword": "pulgar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salmón": [
    {
      "id": 25669,
      "keyword": "salmón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7808,
      "keyword": "salmón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26419,
      "keyword": "salmón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal-based food",
        "gastronomy",
        "feeding",
        "food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salmones": [
    {
      "id": 25669,
      "keyword": "salmón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7808,
      "keyword": "salmón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26419,
      "keyword": "salmón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal-based food",
        "gastronomy",
        "feeding",
        "food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sardina": [
    {
      "id": 25670,
      "keyword": "sardina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7809,
      "keyword": "sardina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sardinas": [
    {
      "id": 25670,
      "keyword": "sardina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7809,
      "keyword": "sardina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peligro colegio": [
    {
      "id": 7811,
      "keyword": "peligro colegio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reptiles": [
    {
      "id": 7806,
      "keyword": "reptiles",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "reptile"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reptil": [
    {
      "id": 7806,
      "keyword": "reptil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "reptile"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "según": [
    {
      "id": 7810,
      "keyword": "según",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "servilletero": [
    {
      "id": 7812,
      "keyword": "servilletero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "servilleteros": [
    {
      "id": 7812,
      "keyword": "servilletero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ramo": [
    {
      "id": 7804,
      "keyword": "ramo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ramos": [
    {
      "id": 7804,
      "keyword": "ramo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sin": [
    {
      "id": 7813,
      "keyword": "sin",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "receta": [
    {
      "id": 38606,
      "keyword": "receta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7805,
      "keyword": "receta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "cookery",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recetas": [
    {
      "id": 38606,
      "keyword": "receta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7805,
      "keyword": "receta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "cookery",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "testículos": [
    {
      "id": 7816,
      "keyword": "testículos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tras": [
    {
      "id": 7818,
      "keyword": "tras",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gorro de fiesta": [
    {
      "id": 7815,
      "keyword": "gorro de fiesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gorros de fiesta": [
    {
      "id": 7815,
      "keyword": "gorro de fiesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tumba": [
    {
      "id": 7821,
      "keyword": "tumba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tumbas": [
    {
      "id": 7821,
      "keyword": "tumba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trucha": [
    {
      "id": 25671,
      "keyword": "trucha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7820,
      "keyword": "trucha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "work",
        "primary sector",
        "fishing",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "truchas": [
    {
      "id": 25671,
      "keyword": "trucha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7820,
      "keyword": "trucha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "work",
        "primary sector",
        "fishing",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tortícolis": [
    {
      "id": 7817,
      "keyword": "tortícolis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "varicela": [
    {
      "id": 7822,
      "keyword": "varicela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "varicelas": [
    {
      "id": 7822,
      "keyword": "varicela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "profesor de educación física": [
    {
      "id": 7823,
      "keyword": "profesor de educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "profesores de educación física": [
    {
      "id": 7823,
      "keyword": "profesor de educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maestro de educación física": [
    {
      "id": 7823,
      "keyword": "maestro de educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maestros de educación física": [
    {
      "id": 7823,
      "keyword": "maestro de educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sobre": [
    {
      "id": 7814,
      "keyword": "sobre",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10325,
      "keyword": "sobre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "object",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "actividades": [
    {
      "id": 8008,
      "keyword": "actividades",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32212,
      "keyword": "actividades",
      "keywords": 2,
      "type": 2,
      "tags": [
        "categorization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38914,
      "keyword": "actividades",
      "keywords": 2,
      "type": 2,
      "tags": [
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "actividad": [
    {
      "id": 8008,
      "keyword": "actividad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32212,
      "keyword": "actividad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "categorization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38914,
      "keyword": "actividad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acantilado": [
    {
      "id": 8007,
      "keyword": "acantilado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acantilados": [
    {
      "id": 8007,
      "keyword": "acantilado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alemania": [
    {
      "id": 8011,
      "keyword": "Alemania",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28970,
      "keyword": "Alemania",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tronco": [
    {
      "id": 27343,
      "keyword": "tronco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29136,
      "keyword": "tronco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 7819,
      "keyword": "tronco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "vegetal origin material",
        "work",
        "secondary sector",
        "carpentry",
        "object",
        "core vocabulary",
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "troncos": [
    {
      "id": 27343,
      "keyword": "tronco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29136,
      "keyword": "tronco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 7819,
      "keyword": "tronco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "vegetal origin material",
        "work",
        "secondary sector",
        "carpentry",
        "object",
        "core vocabulary",
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "altura": [
    {
      "id": 31286,
      "keyword": "altura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31287,
      "keyword": "altura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8013,
      "keyword": "altura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alturas": [
    {
      "id": 31286,
      "keyword": "altura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31287,
      "keyword": "altura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8013,
      "keyword": "altura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estatura": [
    {
      "id": 8013,
      "keyword": "estatura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estaturas": [
    {
      "id": 8013,
      "keyword": "estatura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alquilar": [
    {
      "id": 8012,
      "keyword": "alquilar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arrendar": [
    {
      "id": 8012,
      "keyword": "arrendar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alce": [
    {
      "id": 8010,
      "keyword": "alce",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alces": [
    {
      "id": 8010,
      "keyword": "alce",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amasar": [
    {
      "id": 8015,
      "keyword": "amasar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21355,
      "keyword": "amasar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "amamantar": [
    {
      "id": 8014,
      "keyword": "amamantar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32028,
      "keyword": "amamantar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37608,
      "keyword": "amamantar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mamar": [
    {
      "id": 8014,
      "keyword": "mamar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32028,
      "keyword": "mamar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cariño": [
    {
      "id": 8020,
      "keyword": "cariño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cariños": [
    {
      "id": 8020,
      "keyword": "cariño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amor": [
    {
      "id": 8020,
      "keyword": "amor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37798,
      "keyword": "amor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37799,
      "keyword": "amor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11178,
      "keyword": "amor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11179,
      "keyword": "amor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "amores": [
    {
      "id": 8020,
      "keyword": "amor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human value"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37798,
      "keyword": "amor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11178,
      "keyword": "amor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11179,
      "keyword": "amor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anchura": [
    {
      "id": 8023,
      "keyword": "anchura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anchuras": [
    {
      "id": 8023,
      "keyword": "anchura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "andalucía": [
    {
      "id": 8024,
      "keyword": "Andalucía",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8489,
      "keyword": "Andalucía",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bicho": [
    {
      "id": 8025,
      "keyword": "bicho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bichos": [
    {
      "id": 8025,
      "keyword": "bicho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "añadir": [
    {
      "id": 32769,
      "keyword": "añadir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8026,
      "keyword": "añadir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agregar": [
    {
      "id": 8026,
      "keyword": "agregar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "análisis de orina": [
    {
      "id": 30079,
      "keyword": "análisis de orina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38780,
      "keyword": "análisis de orina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8021,
      "keyword": "análisis de orina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30080,
      "keyword": "análisis de orina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30078,
      "keyword": "análisis de orina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31725,
      "keyword": "análisis de orina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apagar la luz": [
    {
      "id": 8027,
      "keyword": "apagar la luz",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apestar": [
    {
      "id": 16439,
      "keyword": "apestar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31073,
      "keyword": "apestar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31775,
      "keyword": "apestar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32045,
      "keyword": "apestar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8028,
      "keyword": "apestar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31137,
      "keyword": "apestar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31138,
      "keyword": "apestar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31957,
      "keyword": "apestar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32046,
      "keyword": "apestar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oler mal": [
    {
      "id": 16439,
      "keyword": "oler mal",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31073,
      "keyword": "oler mal",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31775,
      "keyword": "oler mal",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32045,
      "keyword": "oler mal",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8028,
      "keyword": "oler mal",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31137,
      "keyword": "oler mal",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31138,
      "keyword": "oler mal",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31957,
      "keyword": "oler mal",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32046,
      "keyword": "oler mal",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aguacate": [
    {
      "id": 8009,
      "keyword": "aguacate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aguacates": [
    {
      "id": 8009,
      "keyword": "aguacate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palta": [
    {
      "id": 8009,
      "keyword": "palta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paltas": [
    {
      "id": 8009,
      "keyword": "palta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arrodillar": [
    {
      "id": 8033,
      "keyword": "arrodillar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8032,
      "keyword": "arrodillar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36492,
      "keyword": "arrodillar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estar de rodillas": [
    {
      "id": 8033,
      "keyword": "estar de rodillas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8032,
      "keyword": "estar de rodillas",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36492,
      "keyword": "estar de rodillas",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arrodillada": [
    {
      "id": 8032,
      "keyword": "arrodillada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arrodilladas": [
    {
      "id": 8032,
      "keyword": "arrodillada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "armadillo": [
    {
      "id": 8031,
      "keyword": "armadillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "armadillos": [
    {
      "id": 8031,
      "keyword": "armadillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "armadilla": [
    {
      "id": 8031,
      "keyword": "armadilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "armadillas": [
    {
      "id": 8031,
      "keyword": "armadilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asturias": [
    {
      "id": 8034,
      "keyword": "Asturias",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8494,
      "keyword": "Asturias",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14829,
      "keyword": "Asturias",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "descender": [
    {
      "id": 34807,
      "keyword": "descender",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37244,
      "keyword": "descender",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "place",
        "facility",
        "recreational facility",
        "playground"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8035,
      "keyword": "descender",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baleares": [
    {
      "id": 8036,
      "keyword": "Baleares",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8498,
      "keyword": "Baleares",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "broca": [
    {
      "id": 8037,
      "keyword": "broca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brocas": [
    {
      "id": 8037,
      "keyword": "broca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aprender": [
    {
      "id": 37810,
      "keyword": "aprender",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "education",
        "educational task",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26636,
      "keyword": "aprender",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8029,
      "keyword": "aprender",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37776,
      "keyword": "aprender",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bellota": [
    {
      "id": 8041,
      "keyword": "bellota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bellotas": [
    {
      "id": 8041,
      "keyword": "bellota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38969,
      "keyword": "bellotas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brasil": [
    {
      "id": 8044,
      "keyword": "Brasil",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29589,
      "keyword": "Brasil",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brújula": [
    {
      "id": 8045,
      "keyword": "brújula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brújulas": [
    {
      "id": 8045,
      "keyword": "brújula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bélgica": [
    {
      "id": 8040,
      "keyword": "Bélgica",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28972,
      "keyword": "Bélgica",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buhardilla": [
    {
      "id": 8047,
      "keyword": "buhardilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25879,
      "keyword": "buhardilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buhardillas": [
    {
      "id": 8047,
      "keyword": "buhardilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25879,
      "keyword": "buhardilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bucear": [
    {
      "id": 25166,
      "keyword": "bucear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31442,
      "keyword": "bucear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31443,
      "keyword": "bucear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8046,
      "keyword": "bucear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "diving"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31123,
      "keyword": "bucear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inmersión": [
    {
      "id": 8046,
      "keyword": "inmersión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "diving"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inmersiones": [
    {
      "id": 8046,
      "keyword": "inmersión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "diving"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "batman": [
    {
      "id": 8039,
      "keyword": "Batman",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "comic character",
        "comic",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bizcocho": [
    {
      "id": 8295,
      "keyword": "bizcocho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8042,
      "keyword": "bizcocho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bizcochuelo": [
    {
      "id": 8042,
      "keyword": "bizcochuelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bizcochuelos": [
    {
      "id": 8042,
      "keyword": "bizcochuelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cabaña": [
    {
      "id": 8049,
      "keyword": "cabaña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cabañas": [
    {
      "id": 8049,
      "keyword": "cabaña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caca": [
    {
      "id": 8050,
      "keyword": "caca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cacas": [
    {
      "id": 8050,
      "keyword": "caca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "excremento": [
    {
      "id": 8050,
      "keyword": "excremento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "excrementos": [
    {
      "id": 8050,
      "keyword": "excremento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cambiar la compresa": [
    {
      "id": 8054,
      "keyword": "cambiar la compresa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "intimate hygiene",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "butano": [
    {
      "id": 8048,
      "keyword": "butano",
      "keywords": 4,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bombona": [
    {
      "id": 10317,
      "keyword": "bombona",
      "keywords": 3,
      "type": 2,
      "tags": [
        "chemistry",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8048,
      "keyword": "bombona",
      "keywords": 4,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bombonas": [
    {
      "id": 10317,
      "keyword": "bombona",
      "keywords": 3,
      "type": 2,
      "tags": [
        "chemistry",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8048,
      "keyword": "bombona",
      "keywords": 4,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bombona de butano": [
    {
      "id": 8048,
      "keyword": "bombona de butano",
      "keywords": 4,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bombonas de butano": [
    {
      "id": 8048,
      "keyword": "bombona de butano",
      "keywords": 4,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "garrafa": [
    {
      "id": 8048,
      "keyword": "garrafa",
      "keywords": 4,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "garrafas": [
    {
      "id": 8048,
      "keyword": "garrafa",
      "keywords": 4,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "canadá": [
    {
      "id": 8057,
      "keyword": "Canadá",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29587,
      "keyword": "Canadá",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camerún": [
    {
      "id": 8055,
      "keyword": "Camerún",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cafetera exprés": [
    {
      "id": 8052,
      "keyword": "cafetera exprés",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cafeteras exprés": [
    {
      "id": 8052,
      "keyword": "cafetera exprés",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "canoso": [
    {
      "id": 8059,
      "keyword": "canoso",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canosos": [
    {
      "id": 8059,
      "keyword": "canoso",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "canas": [
    {
      "id": 8059,
      "keyword": "canas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canosa": [
    {
      "id": 8059,
      "keyword": "canosa",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canosas": [
    {
      "id": 8059,
      "keyword": "canosa",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cantabria": [
    {
      "id": 8060,
      "keyword": "Cantabria",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8527,
      "keyword": "Cantabria",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14836,
      "keyword": "Cantabria",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cambiar": [
    {
      "id": 37360,
      "keyword": "cambiar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8053,
      "keyword": "cambiar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31953,
      "keyword": "cambiar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intercambiar": [
    {
      "id": 37360,
      "keyword": "intercambiar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8053,
      "keyword": "intercambiar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31953,
      "keyword": "intercambiar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "argentina": [
    {
      "id": 8030,
      "keyword": "Argentina",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29590,
      "keyword": "Argentina",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campanilla": [
    {
      "id": 8056,
      "keyword": "campanilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campanillas": [
    {
      "id": 8056,
      "keyword": "campanilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carnívoro": [
    {
      "id": 8062,
      "keyword": "carnívoro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "carnivorous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carnívoros": [
    {
      "id": 8062,
      "keyword": "carnívoro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "carnivorous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carnívora": [
    {
      "id": 8062,
      "keyword": "carnívora",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "carnivorous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carnívoras": [
    {
      "id": 8062,
      "keyword": "carnívora",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "carnivorous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carroza": [
    {
      "id": 8063,
      "keyword": "carroza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carrozas": [
    {
      "id": 8063,
      "keyword": "carroza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "publicidad": [
    {
      "id": 8064,
      "keyword": "publicidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "publicidades": [
    {
      "id": 8064,
      "keyword": "publicidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cartel": [
    {
      "id": 8064,
      "keyword": "cartel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8065,
      "keyword": "cartel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "music",
        "leisure",
        "show",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12326,
      "keyword": "cartel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "scenic art",
        "leisure",
        "show",
        "work",
        "theater",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12325,
      "keyword": "cartel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "scenic art",
        "leisure",
        "show",
        "work",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carteles": [
    {
      "id": 8064,
      "keyword": "cartel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8065,
      "keyword": "cartel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "music",
        "leisure",
        "show",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 12326,
      "keyword": "cartel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "scenic art",
        "leisure",
        "show",
        "work",
        "theater",
        "music"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 12325,
      "keyword": "cartel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "scenic art",
        "leisure",
        "show",
        "work",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anuncio": [
    {
      "id": 8275,
      "keyword": "anuncio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8065,
      "keyword": "anuncio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "music",
        "leisure",
        "show",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12326,
      "keyword": "anuncio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "scenic art",
        "leisure",
        "show",
        "work",
        "theater",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12325,
      "keyword": "anuncio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "scenic art",
        "leisure",
        "show",
        "work",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anuncios": [
    {
      "id": 8275,
      "keyword": "anuncio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8065,
      "keyword": "anuncio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "music",
        "leisure",
        "show",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 12326,
      "keyword": "anuncio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "scenic art",
        "leisure",
        "show",
        "work",
        "theater",
        "music"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 12325,
      "keyword": "anuncio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "scenic art",
        "leisure",
        "show",
        "work",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chile": [
    {
      "id": 8071,
      "keyword": "Chile",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29598,
      "keyword": "Chile",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cataluña": [
    {
      "id": 8069,
      "keyword": "Cataluña",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8532,
      "keyword": "Cataluña",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ceuta": [
    {
      "id": 8070,
      "keyword": "Ceuta",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8535,
      "keyword": "Ceuta",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "city"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14837,
      "keyword": "Ceuta",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region",
        "city"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31330,
      "keyword": "Ceuta",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "city"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31331,
      "keyword": "Ceuta",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "city",
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chimpancé": [
    {
      "id": 8073,
      "keyword": "chimpancé",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chimpancés": [
    {
      "id": 8073,
      "keyword": "chimpancé",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "china": [
    {
      "id": 8074,
      "keyword": "China",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37647,
      "keyword": "China",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37525,
      "keyword": "china",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "castilla león": [
    {
      "id": 8068,
      "keyword": "Castilla León",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8530,
      "keyword": "Castilla León",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "choza": [
    {
      "id": 8075,
      "keyword": "choza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chozas": [
    {
      "id": 8075,
      "keyword": "choza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "castaño": [
    {
      "id": 8066,
      "keyword": "castaño",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28849,
      "keyword": "castaño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "castaños": [
    {
      "id": 8066,
      "keyword": "castaño",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28849,
      "keyword": "castaño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clasificar": [
    {
      "id": 37361,
      "keyword": "clasificar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "education",
        "educational task",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8077,
      "keyword": "clasificar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colchón de agua": [
    {
      "id": 8079,
      "keyword": "colchón de agua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colchones de agua": [
    {
      "id": 8079,
      "keyword": "colchón de agua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colombia": [
    {
      "id": 8080,
      "keyword": "Colombia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29593,
      "keyword": "Colombia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colorín colorado": [
    {
      "id": 8081,
      "keyword": "colorín colorado",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "set phrase",
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "columna de burbujas": [
    {
      "id": 8082,
      "keyword": "columna de burbujas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "columnas de burbujas": [
    {
      "id": 8082,
      "keyword": "columna de burbujas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colchón": [
    {
      "id": 8078,
      "keyword": "colchón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colchones": [
    {
      "id": 8078,
      "keyword": "colchón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cortar el pelo": [
    {
      "id": 27696,
      "keyword": "cortar el pelo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8084,
      "keyword": "cortar el pelo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27695,
      "keyword": "cortar el pelo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dibujar": [
    {
      "id": 8088,
      "keyword": "dibujar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "visual art",
        "drawing",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "concurso": [
    {
      "id": 37313,
      "keyword": "concurso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "scenic art",
        "visual art",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8083,
      "keyword": "concurso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "concursos": [
    {
      "id": 37313,
      "keyword": "concurso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "scenic art",
        "visual art",
        "music"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8083,
      "keyword": "concurso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "programa concurso": [
    {
      "id": 8083,
      "keyword": "programa concurso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "programas concursos": [
    {
      "id": 8083,
      "keyword": "programa concurso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "programa deportivo": [
    {
      "id": 8085,
      "keyword": "programa deportivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show",
        "leisure",
        "sport",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "programas deportivos": [
    {
      "id": 8085,
      "keyword": "programa deportivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show",
        "leisure",
        "sport",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "programa de deportes": [
    {
      "id": 8085,
      "keyword": "programa de deportes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show",
        "leisure",
        "sport",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "programas de deportes": [
    {
      "id": 8085,
      "keyword": "programa de deportes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show",
        "leisure",
        "sport",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desenchufar": [
    {
      "id": 8086,
      "keyword": "desenchufar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "discapacidad motriz": [
    {
      "id": 8091,
      "keyword": "discapacidad motriz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8092,
      "keyword": "discapacidad motriz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27101,
      "keyword": "discapacidad motriz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31324,
      "keyword": "discapacidad motriz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "discapacidades motrices": [
    {
      "id": 8091,
      "keyword": "discapacidad motriz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8092,
      "keyword": "discapacidad motriz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27101,
      "keyword": "discapacidad motriz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31324,
      "keyword": "discapacidad motriz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apresar": [
    {
      "id": 8087,
      "keyword": "apresar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arrestar": [
    {
      "id": 8087,
      "keyword": "arrestar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "científico": [
    {
      "id": 8076,
      "keyword": "científico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "chemistry",
        "biology",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "científicos": [
    {
      "id": 8076,
      "keyword": "científico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "chemistry",
        "biology",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "investigador": [
    {
      "id": 8076,
      "keyword": "investigador",
      "keywords": 2,
      "type": 4,
      "tags": [
        "work",
        "professional",
        "chemistry",
        "biology",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9191,
      "keyword": "investigador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38762,
      "keyword": "investigador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "investigadores": [
    {
      "id": 8076,
      "keyword": "investigador",
      "keywords": 2,
      "type": 4,
      "tags": [
        "work",
        "professional",
        "chemistry",
        "biology",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9191,
      "keyword": "investigador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38762,
      "keyword": "investigador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "documental": [
    {
      "id": 8093,
      "keyword": "documental",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "documentales": [
    {
      "id": 8093,
      "keyword": "documental",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dibujos animados": [
    {
      "id": 8089,
      "keyword": "dibujos animados",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "drogadicción": [
    {
      "id": 8095,
      "keyword": "drogadicción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "drogadicciones": [
    {
      "id": 8095,
      "keyword": "drogadicción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "drogar": [
    {
      "id": 8095,
      "keyword": "drogar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "egipto": [
    {
      "id": 8099,
      "keyword": "Egipto",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37648,
      "keyword": "Egipto",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "electrocardiograma": [
    {
      "id": 30802,
      "keyword": "electrocardiograma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30805,
      "keyword": "electrocardiograma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8100,
      "keyword": "electrocardiograma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "electrocardiogramas": [
    {
      "id": 30802,
      "keyword": "electrocardiograma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30805,
      "keyword": "electrocardiograma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8100,
      "keyword": "electrocardiograma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "electro": [
    {
      "id": 30249,
      "keyword": "electro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8100,
      "keyword": "electro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8101,
      "keyword": "electro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30090,
      "keyword": "electro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30091,
      "keyword": "electro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30170,
      "keyword": "electro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30171,
      "keyword": "electro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "electros": [
    {
      "id": 30249,
      "keyword": "electro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8100,
      "keyword": "electro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8101,
      "keyword": "electro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30090,
      "keyword": "electro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30091,
      "keyword": "electro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30170,
      "keyword": "electro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30171,
      "keyword": "electro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "educación": [
    {
      "id": 38021,
      "keyword": "educación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "communication",
        "language",
        "verb",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8098,
      "keyword": "educación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "formación": [
    {
      "id": 8098,
      "keyword": "formación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "formaciones": [
    {
      "id": 8098,
      "keyword": "formación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "eclipse": [
    {
      "id": 8097,
      "keyword": "eclipse",
      "keywords": 2,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8096,
      "keyword": "eclipse",
      "keywords": 2,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "eclipses": [
    {
      "id": 8097,
      "keyword": "eclipse",
      "keywords": 2,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8096,
      "keyword": "eclipse",
      "keywords": 2,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "eclipse de sol": [
    {
      "id": 8097,
      "keyword": "eclipse de sol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "eclipses de sol": [
    {
      "id": 8097,
      "keyword": "eclipse de sol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ensaladilla": [
    {
      "id": 8104,
      "keyword": "ensaladilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ensaladillas": [
    {
      "id": 8104,
      "keyword": "ensaladilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ensaladilla rusa": [
    {
      "id": 8104,
      "keyword": "ensaladilla rusa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ensaladillas rusas": [
    {
      "id": 8104,
      "keyword": "ensaladilla rusa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "personas con discapacidad": [
    {
      "id": 8090,
      "keyword": "personas con discapacidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24513,
      "keyword": "personas con discapacidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "electroencefalograma": [
    {
      "id": 30249,
      "keyword": "electroencefalograma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8101,
      "keyword": "electroencefalograma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30090,
      "keyword": "electroencefalograma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30091,
      "keyword": "electroencefalograma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30170,
      "keyword": "electroencefalograma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30171,
      "keyword": "electroencefalograma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "electroencefalogramas": [
    {
      "id": 30249,
      "keyword": "electroencefalograma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8101,
      "keyword": "electroencefalograma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30090,
      "keyword": "electroencefalograma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30091,
      "keyword": "electroencefalograma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30170,
      "keyword": "electroencefalograma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30171,
      "keyword": "electroencefalograma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "eclipse de luna": [
    {
      "id": 8096,
      "keyword": "eclipse de luna",
      "keywords": 2,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "eclipses de luna": [
    {
      "id": 8096,
      "keyword": "eclipse de luna",
      "keywords": 2,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escenario": [
    {
      "id": 8106,
      "keyword": "escenario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "scenic art",
        "music",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escenarios": [
    {
      "id": 8106,
      "keyword": "escenario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "scenic art",
        "music",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "entrevista": [
    {
      "id": 8105,
      "keyword": "entrevista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36530,
      "keyword": "entrevista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entrevistas": [
    {
      "id": 8105,
      "keyword": "entrevista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36530,
      "keyword": "entrevista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encajar": [
    {
      "id": 8102,
      "keyword": "encajar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encender la luz": [
    {
      "id": 8103,
      "keyword": "encender la luz",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esperar": [
    {
      "id": 16697,
      "keyword": "esperar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27547,
      "keyword": "esperar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36914,
      "keyword": "esperar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39049,
      "keyword": "esperar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8109,
      "keyword": "esperar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28677,
      "keyword": "esperar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39062,
      "keyword": "esperar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "castilla la mancha": [
    {
      "id": 8067,
      "keyword": "Castilla La Mancha",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8529,
      "keyword": "Castilla La Mancha",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estados unidos": [
    {
      "id": 8112,
      "keyword": "Estados Unidos",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29588,
      "keyword": "Estados Unidos",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estatua": [
    {
      "id": 8113,
      "keyword": "estatua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38044,
      "keyword": "estatua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estatuas": [
    {
      "id": 8113,
      "keyword": "estatua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38044,
      "keyword": "estatua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "españa": [
    {
      "id": 8108,
      "keyword": "España",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10476,
      "keyword": "España",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28967,
      "keyword": "España",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "experimento": [
    {
      "id": 8119,
      "keyword": "experimento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "chemistry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "experimentos": [
    {
      "id": 8119,
      "keyword": "experimento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "chemistry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "extremadura": [
    {
      "id": 8120,
      "keyword": "Extremadura",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8580,
      "keyword": "Extremadura",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "país vasco": [
    {
      "id": 8118,
      "keyword": "País Vasco",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8576,
      "keyword": "País Vasco",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "euskadi": [
    {
      "id": 8118,
      "keyword": "Euskadi",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8576,
      "keyword": "Euskadi",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "galicia": [
    {
      "id": 8123,
      "keyword": "Galicia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8588,
      "keyword": "Galicia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gambia": [
    {
      "id": 8124,
      "keyword": "Gambia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esposa": [
    {
      "id": 8110,
      "keyword": "esposa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11552,
      "keyword": "esposa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casada": [
    {
      "id": 8110,
      "keyword": "casada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11552,
      "keyword": "casada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casadas": [
    {
      "id": 8110,
      "keyword": "casada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11552,
      "keyword": "casada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esposo": [
    {
      "id": 8111,
      "keyword": "esposo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11550,
      "keyword": "esposo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esposos": [
    {
      "id": 8111,
      "keyword": "esposo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11550,
      "keyword": "esposo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "marido": [
    {
      "id": 8111,
      "keyword": "marido",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11550,
      "keyword": "marido",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maridos": [
    {
      "id": 8111,
      "keyword": "marido",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11550,
      "keyword": "marido",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casado": [
    {
      "id": 8111,
      "keyword": "casado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11550,
      "keyword": "casado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casados": [
    {
      "id": 8111,
      "keyword": "casado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11550,
      "keyword": "casado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "goloso": [
    {
      "id": 31971,
      "keyword": "goloso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8127,
      "keyword": "goloso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "golosos": [
    {
      "id": 31971,
      "keyword": "goloso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8127,
      "keyword": "goloso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "golosa": [
    {
      "id": 11955,
      "keyword": "golosa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8127,
      "keyword": "golosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "golosas": [
    {
      "id": 11955,
      "keyword": "golosa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8127,
      "keyword": "golosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "francia": [
    {
      "id": 8121,
      "keyword": "Francia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28968,
      "keyword": "Francia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gazpacho": [
    {
      "id": 8126,
      "keyword": "gazpacho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gazpachos": [
    {
      "id": 8126,
      "keyword": "gazpacho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gasolina": [
    {
      "id": 8125,
      "keyword": "gasolina",
      "keywords": 5,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gasolinas": [
    {
      "id": 8125,
      "keyword": "gasolina",
      "keywords": 5,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bidón de gasolina": [
    {
      "id": 8125,
      "keyword": "bidón de gasolina",
      "keywords": 5,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bidones de gasolina": [
    {
      "id": 8125,
      "keyword": "bidón de gasolina",
      "keywords": 5,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "garrafa de gasolina": [
    {
      "id": 8125,
      "keyword": "garrafa de gasolina",
      "keywords": 5,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "garrafas de gasolina": [
    {
      "id": 8125,
      "keyword": "garrafa de gasolina",
      "keywords": 5,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nafta": [
    {
      "id": 8125,
      "keyword": "nafta",
      "keywords": 5,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "naftas": [
    {
      "id": 8125,
      "keyword": "nafta",
      "keywords": 5,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "garrafa de nafta": [
    {
      "id": 8125,
      "keyword": "garrafa de nafta",
      "keywords": 5,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "garrafas de nafta": [
    {
      "id": 8125,
      "keyword": "garrafa de nafta",
      "keywords": 5,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hechizar": [
    {
      "id": 8132,
      "keyword": "hechizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gracias": [
    {
      "id": 8129,
      "keyword": "gracias",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "psychology",
        "human value",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8128,
      "keyword": "gracias",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31206,
      "keyword": "gracias",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36093,
      "keyword": "gracias",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "herbívoro": [
    {
      "id": 8133,
      "keyword": "herbívoro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "herbivorous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "herbívoros": [
    {
      "id": 8133,
      "keyword": "herbívoro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "herbivorous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "herbívora": [
    {
      "id": 8133,
      "keyword": "herbívora",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "herbivorous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "herbívoras": [
    {
      "id": 8133,
      "keyword": "herbívora",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "herbivorous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hombre lobo": [
    {
      "id": 8135,
      "keyword": "hombre lobo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature",
        "event",
        "popular event",
        "halloween",
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hombres lobo": [
    {
      "id": 8135,
      "keyword": "hombre lobo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature",
        "event",
        "popular event",
        "halloween",
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "este cuento se ha acabado": [
    {
      "id": 8115,
      "keyword": "este cuento se ha acabado",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "set phrase"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "iglú": [
    {
      "id": 8137,
      "keyword": "iglú",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "iglús": [
    {
      "id": 8137,
      "keyword": "iglú",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "imán": [
    {
      "id": 8138,
      "keyword": "imán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24113,
      "keyword": "imán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "islamism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "imanes": [
    {
      "id": 8138,
      "keyword": "imán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24113,
      "keyword": "imán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "islamism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "horchata": [
    {
      "id": 8136,
      "keyword": "horchata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "horchatas": [
    {
      "id": 8136,
      "keyword": "horchata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "insultar": [
    {
      "id": 8140,
      "keyword": "insultar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26611,
      "keyword": "insultar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8139,
      "keyword": "insultar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "japón": [
    {
      "id": 8144,
      "keyword": "Japón",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grecia": [
    {
      "id": 8130,
      "keyword": "Grecia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28973,
      "keyword": "Grecia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juguete adaptado": [
    {
      "id": 8146,
      "keyword": "juguete adaptado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juguetes adaptados": [
    {
      "id": 8146,
      "keyword": "juguete adaptado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juzgar": [
    {
      "id": 32990,
      "keyword": "juzgar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8148,
      "keyword": "juzgar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16103,
      "keyword": "juzgar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36548,
      "keyword": "juzgar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36549,
      "keyword": "juzgar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juzgado": [
    {
      "id": 8147,
      "keyword": "juzgado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juzgados": [
    {
      "id": 8147,
      "keyword": "juzgado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tribunal": [
    {
      "id": 37669,
      "keyword": "tribunal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "legal institution"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8147,
      "keyword": "tribunal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34479,
      "keyword": "tribunal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "legal institution"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34480,
      "keyword": "tribunal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "legal institution"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tribunales": [
    {
      "id": 37669,
      "keyword": "tribunal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "legal institution"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8147,
      "keyword": "tribunal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34479,
      "keyword": "tribunal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "legal institution"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34480,
      "keyword": "tribunal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "legal institution"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "la rioja": [
    {
      "id": 8149,
      "keyword": "La Rioja",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8613,
      "keyword": "La Rioja",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14839,
      "keyword": "La Rioja",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "laboratorio": [
    {
      "id": 8150,
      "keyword": "laboratorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "laboratorios": [
    {
      "id": 8150,
      "keyword": "laboratorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "levantar del suelo": [
    {
      "id": 8151,
      "keyword": "levantar del suelo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34367,
      "keyword": "levantar del suelo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llave": [
    {
      "id": 8153,
      "keyword": "llave",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21943,
      "keyword": "llave",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "distancia": [
    {
      "id": 8154,
      "keyword": "distancia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "distancias": [
    {
      "id": 8154,
      "keyword": "distancia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "luces": [
    {
      "id": 8619,
      "keyword": "luz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8155,
      "keyword": "luces",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "luces de colores": [
    {
      "id": 8155,
      "keyword": "luces de colores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8376,
      "keyword": "luz de color",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comunidad de madrid": [
    {
      "id": 8156,
      "keyword": "Comunidad de Madrid",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8622,
      "keyword": "Comunidad de Madrid",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "malva": [
    {
      "id": 8157,
      "keyword": "malva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9096,
      "keyword": "malva",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "malvas": [
    {
      "id": 8157,
      "keyword": "malva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9096,
      "keyword": "malva",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "marruecos": [
    {
      "id": 8159,
      "keyword": "Marruecos",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38139,
      "keyword": "Marruecos",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "matar": [
    {
      "id": 8161,
      "keyword": "matar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8160,
      "keyword": "matar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asesinar": [
    {
      "id": 8161,
      "keyword": "asesinar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8160,
      "keyword": "asesinar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jeroglífico": [
    {
      "id": 8145,
      "keyword": "jeroglífico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "civilization",
        "Egypt",
        "archaeology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jeroglíficos": [
    {
      "id": 8145,
      "keyword": "jeroglífico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "civilization",
        "Egypt",
        "archaeology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "italia": [
    {
      "id": 8143,
      "keyword": "Italia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28971,
      "keyword": "Italia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "invertebrado": [
    {
      "id": 8141,
      "keyword": "invertebrado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "invertebrate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "invertebrados": [
    {
      "id": 8141,
      "keyword": "invertebrado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "invertebrate"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "invertebrada": [
    {
      "id": 8141,
      "keyword": "invertebrada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "invertebradas": [
    {
      "id": 8141,
      "keyword": "invertebrada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mayordomo": [
    {
      "id": 8162,
      "keyword": "mayordomo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mayordomos": [
    {
      "id": 8162,
      "keyword": "mayordomo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "criado": [
    {
      "id": 8162,
      "keyword": "criado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "criados": [
    {
      "id": 8162,
      "keyword": "criado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "melilla": [
    {
      "id": 8164,
      "keyword": "Melilla",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8628,
      "keyword": "Melilla",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "city"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14838,
      "keyword": "Melilla",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region",
        "city"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medicinas": [
    {
      "id": 8163,
      "keyword": "medicinas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament",
        "covid-19",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medicamentos": [
    {
      "id": 8163,
      "keyword": "medicamentos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament",
        "covid-19",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medicina": [
    {
      "id": 8163,
      "keyword": "medicina",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament",
        "covid-19",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medicamento": [
    {
      "id": 8163,
      "keyword": "medicamento",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament",
        "covid-19",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "menstruación": [
    {
      "id": 32490,
      "keyword": "menstruación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8165,
      "keyword": "menstruación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "menstruaciones": [
    {
      "id": 32490,
      "keyword": "menstruación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8165,
      "keyword": "menstruación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "meter en la mochila": [
    {
      "id": 8166,
      "keyword": "meter en la mochila",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "moradura": [
    {
      "id": 8170,
      "keyword": "moradura",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "moraduras": [
    {
      "id": 8170,
      "keyword": "moradura",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cardenal": [
    {
      "id": 23909,
      "keyword": "cardenal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity",
        "event",
        "religious event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8170,
      "keyword": "cardenal",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cardenales": [
    {
      "id": 23909,
      "keyword": "cardenal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity",
        "event",
        "religious event"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8170,
      "keyword": "cardenal",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "moratón": [
    {
      "id": 8170,
      "keyword": "moratón",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "moratones": [
    {
      "id": 8170,
      "keyword": "moratón",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hematoma": [
    {
      "id": 8170,
      "keyword": "hematoma",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hematomas": [
    {
      "id": 8170,
      "keyword": "hematoma",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mundial": [
    {
      "id": 8173,
      "keyword": "mundial",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mundiales": [
    {
      "id": 8173,
      "keyword": "mundial",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "musical": [
    {
      "id": 8175,
      "keyword": "musical",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "musicales": [
    {
      "id": 8175,
      "keyword": "musical",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show",
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "murcia": [
    {
      "id": 8174,
      "keyword": "Murcia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8636,
      "keyword": "Murcia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14841,
      "keyword": "Murcia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nacer": [
    {
      "id": 8176,
      "keyword": "nacer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28409,
      "keyword": "nacer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "animal",
        "animal physiology",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28411,
      "keyword": "nacer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31158,
      "keyword": "nacer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "animal",
        "animal physiology",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34252,
      "keyword": "nacer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "animal",
        "animal physiology",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "navarra": [
    {
      "id": 8177,
      "keyword": "Navarra",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8639,
      "keyword": "Navarra",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14842,
      "keyword": "Navarra",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "norte": [
    {
      "id": 8178,
      "keyword": "Norte",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "moreno": [
    {
      "id": 8171,
      "keyword": "moreno",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "morenos": [
    {
      "id": 8171,
      "keyword": "moreno",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "morena": [
    {
      "id": 8171,
      "keyword": "morena",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "morenas": [
    {
      "id": 8171,
      "keyword": "morena",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "omnívoro": [
    {
      "id": 8180,
      "keyword": "omnívoro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "omnivorous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "omnívoros": [
    {
      "id": 8180,
      "keyword": "omnívoro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "omnivorous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "omnívora": [
    {
      "id": 8180,
      "keyword": "omnívora",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "omnivorous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "omnívoras": [
    {
      "id": 8180,
      "keyword": "omnívora",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "omnivorous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "muerto": [
    {
      "id": 36191,
      "keyword": "muerto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "judaism",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37693,
      "keyword": "muerto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29867,
      "keyword": "muerto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death",
        "person",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34203,
      "keyword": "muerto",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38054,
      "keyword": "muerto",
      "keywords": 4,
      "type": 4,
      "tags": [
        "document",
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8172,
      "keyword": "muerto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26234,
      "keyword": "muerto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muertos": [
    {
      "id": 36191,
      "keyword": "muerto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "judaism",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37693,
      "keyword": "muerto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29867,
      "keyword": "muerto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death",
        "person",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34203,
      "keyword": "muerto",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38054,
      "keyword": "muerto",
      "keywords": 4,
      "type": 4,
      "tags": [
        "document",
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8172,
      "keyword": "muerto",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26234,
      "keyword": "muerto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "muerta": [
    {
      "id": 29869,
      "keyword": "muerta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37693,
      "keyword": "muerta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34203,
      "keyword": "muerta",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38054,
      "keyword": "muerta",
      "keywords": 4,
      "type": 4,
      "tags": [
        "document",
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29861,
      "keyword": "muerta",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8172,
      "keyword": "muerta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29870,
      "keyword": "muerta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muertas": [
    {
      "id": 29869,
      "keyword": "muerta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37693,
      "keyword": "muerta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34203,
      "keyword": "muerta",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38054,
      "keyword": "muerta",
      "keywords": 4,
      "type": 4,
      "tags": [
        "document",
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8172,
      "keyword": "muerta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29870,
      "keyword": "muerta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paraguay": [
    {
      "id": 8181,
      "keyword": "Paraguay",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29599,
      "keyword": "Paraguay",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paz": [
    {
      "id": 8182,
      "keyword": "paz",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "pelirrojo": [
    {
      "id": 8184,
      "keyword": "pelirrojo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelirrojos": [
    {
      "id": 8184,
      "keyword": "pelirrojo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pelirroja": [
    {
      "id": 8184,
      "keyword": "pelirroja",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelirrojas": [
    {
      "id": 8184,
      "keyword": "pelirroja",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perú": [
    {
      "id": 8185,
      "keyword": "Perú",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29592,
      "keyword": "Perú",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "petróleo": [
    {
      "id": 8186,
      "keyword": "petróleo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "fossil origin material",
        "work",
        "primary sector",
        "mining"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oeste": [
    {
      "id": 8179,
      "keyword": "Oeste",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atrapar": [
    {
      "id": 8188,
      "keyword": "atrapar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8187,
      "keyword": "atrapar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pillar": [
    {
      "id": 8188,
      "keyword": "pillar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8187,
      "keyword": "pillar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alcanzar": [
    {
      "id": 8188,
      "keyword": "alcanzar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24208,
      "keyword": "alcanzar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8187,
      "keyword": "alcanzar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "microscopio": [
    {
      "id": 8168,
      "keyword": "microscopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "biology",
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "microscopios": [
    {
      "id": 8168,
      "keyword": "microscopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "biology",
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pintar con los dedos": [
    {
      "id": 8189,
      "keyword": "pintar con los dedos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "migas": [
    {
      "id": 8169,
      "keyword": "migas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "Aragon"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9053,
      "keyword": "miga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9053,
      "keyword": "migas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pirámide": [
    {
      "id": 8190,
      "keyword": "pirámide",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "civilization",
        "Egypt",
        "archaeology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25335,
      "keyword": "pirámide",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "place",
        "monument",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9110,
      "keyword": "pirámide",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pirámides": [
    {
      "id": 8190,
      "keyword": "pirámide",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "civilization",
        "Egypt",
        "archaeology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25335,
      "keyword": "pirámide",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "place",
        "monument",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9110,
      "keyword": "pirámide",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "piscina de bolas": [
    {
      "id": 8191,
      "keyword": "piscina de bolas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation",
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piscinas de bolas": [
    {
      "id": 8191,
      "keyword": "piscina de bolas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation",
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alisar": [
    {
      "id": 8192,
      "keyword": "alisar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pozo": [
    {
      "id": 8197,
      "keyword": "pozo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas",
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pozos": [
    {
      "id": 8197,
      "keyword": "pozo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas",
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prismáticos": [
    {
      "id": 8198,
      "keyword": "prismáticos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "polvorón": [
    {
      "id": 8193,
      "keyword": "polvorón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "polvorones": [
    {
      "id": 8193,
      "keyword": "polvorón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "programa de bricolaje": [
    {
      "id": 8199,
      "keyword": "programa de bricolaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "programas de bricolaje": [
    {
      "id": 8199,
      "keyword": "programa de bricolaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "programa de cocina": [
    {
      "id": 8200,
      "keyword": "programa de cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "programas de cocina": [
    {
      "id": 8200,
      "keyword": "programa de cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "proyección": [
    {
      "id": 8201,
      "keyword": "proyección",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "proyecciones": [
    {
      "id": 8201,
      "keyword": "proyección",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "proyectar": [
    {
      "id": 8201,
      "keyword": "proyectar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9870,
      "keyword": "proyectar",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "proyector": [
    {
      "id": 8202,
      "keyword": "proyector",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "communication"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "proyectores": [
    {
      "id": 8202,
      "keyword": "proyector",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "communication"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reino unido": [
    {
      "id": 8206,
      "keyword": "Reino Unido",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28974,
      "keyword": "Reino Unido",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulverizador": [
    {
      "id": 8204,
      "keyword": "pulverizador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38612,
      "keyword": "pulverizador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulverizadores": [
    {
      "id": 8204,
      "keyword": "pulverizador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38612,
      "keyword": "pulverizador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reunión": [
    {
      "id": 12289,
      "keyword": "reunión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30962,
      "keyword": "reunión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38789,
      "keyword": "reunión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8207,
      "keyword": "reunión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reuniones": [
    {
      "id": 12289,
      "keyword": "reunión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30962,
      "keyword": "reunión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38789,
      "keyword": "reunión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8207,
      "keyword": "reunión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rizar el pelo": [
    {
      "id": 8208,
      "keyword": "rizar el pelo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rizar": [
    {
      "id": 8208,
      "keyword": "rizar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "robar": [
    {
      "id": 31271,
      "keyword": "robar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8210,
      "keyword": "robar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22088,
      "keyword": "robar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8209,
      "keyword": "robar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atracar": [
    {
      "id": 8210,
      "keyword": "atracar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8209,
      "keyword": "atracar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "robo": [
    {
      "id": 8210,
      "keyword": "robo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8209,
      "keyword": "robo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "robos": [
    {
      "id": 8210,
      "keyword": "robo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8209,
      "keyword": "robo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rodillo de amasar": [
    {
      "id": 8211,
      "keyword": "rodillo de amasar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodillos de amasar": [
    {
      "id": 8211,
      "keyword": "rodillo de amasar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "méxico": [
    {
      "id": 8167,
      "keyword": "México",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29591,
      "keyword": "México",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reciclaje": [
    {
      "id": 8205,
      "keyword": "reciclaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rosquilla": [
    {
      "id": 8212,
      "keyword": "rosquilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38775,
      "keyword": "rosquilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rosquillas": [
    {
      "id": 8212,
      "keyword": "rosquilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38775,
      "keyword": "rosquilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "por favor": [
    {
      "id": 8195,
      "keyword": "por favor",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8194,
      "keyword": "por favor",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38907,
      "keyword": "por favor",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rogar": [
    {
      "id": 8195,
      "keyword": "rogar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8194,
      "keyword": "rogar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38907,
      "keyword": "rogar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "portugal": [
    {
      "id": 8196,
      "keyword": "Portugal",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28969,
      "keyword": "Portugal",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rusia": [
    {
      "id": 8215,
      "keyword": "Rusia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28976,
      "keyword": "Rusia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacar de la mochila ": [
    {
      "id": 8216,
      "keyword": "sacar de la mochila ",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sala de estimulación": [
    {
      "id": 8217,
      "keyword": "sala de estimulación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8219,
      "keyword": "sala de estimulación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8218,
      "keyword": "sala de estimulación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de estimulación": [
    {
      "id": 8217,
      "keyword": "sala de estimulación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8219,
      "keyword": "sala de estimulación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8218,
      "keyword": "sala de estimulación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aula multisensorial": [
    {
      "id": 8217,
      "keyword": "aula multisensorial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8219,
      "keyword": "aula multisensorial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8218,
      "keyword": "aula multisensorial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aulas multisensoriales": [
    {
      "id": 8217,
      "keyword": "aula multisensorial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8219,
      "keyword": "aula multisensorial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8218,
      "keyword": "aula multisensorial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rubio": [
    {
      "id": 8213,
      "keyword": "rubio",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rubios": [
    {
      "id": 8213,
      "keyword": "rubio",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rubia": [
    {
      "id": 8213,
      "keyword": "rubia",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rubias": [
    {
      "id": 8213,
      "keyword": "rubia",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rumanía": [
    {
      "id": 8214,
      "keyword": "Rumanía",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28975,
      "keyword": "Rumanía",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sótano": [
    {
      "id": 8223,
      "keyword": "sótano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27482,
      "keyword": "sótano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sótanos": [
    {
      "id": 8223,
      "keyword": "sótano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27482,
      "keyword": "sótano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "spiderman": [
    {
      "id": 8224,
      "keyword": "Spiderman",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "spray": [
    {
      "id": 8225,
      "keyword": "spray",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sprays": [
    {
      "id": 8225,
      "keyword": "spray",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "supermán": [
    {
      "id": 8227,
      "keyword": "Supermán",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "comic character",
        "comic",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ascender": [
    {
      "id": 37262,
      "keyword": "ascender",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "place",
        "facility",
        "recreational facility",
        "playground"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8226,
      "keyword": "ascender",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39022,
      "keyword": "ascender",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sur": [
    {
      "id": 8228,
      "keyword": "Sur",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "temperatura": [
    {
      "id": 8230,
      "keyword": "temperatura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34898,
      "keyword": "temperatura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "temperaturas": [
    {
      "id": 8230,
      "keyword": "temperatura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34898,
      "keyword": "temperatura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "telediario": [
    {
      "id": 35389,
      "keyword": "telediario",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8229,
      "keyword": "telediario",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "telediarios": [
    {
      "id": 35389,
      "keyword": "telediario",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8229,
      "keyword": "telediario",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "boletín informativo": [
    {
      "id": 8229,
      "keyword": "boletín informativo",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boletines informativos": [
    {
      "id": 8229,
      "keyword": "boletín informativo",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "programa": [
    {
      "id": 24320,
      "keyword": "programa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8229,
      "keyword": "programa",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "programas": [
    {
      "id": 24320,
      "keyword": "programa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8229,
      "keyword": "programa",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "informativo": [
    {
      "id": 35389,
      "keyword": "informativo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8229,
      "keyword": "informativo",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "informativos": [
    {
      "id": 35389,
      "keyword": "informativo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8229,
      "keyword": "informativo",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "boletín de noticias": [
    {
      "id": 35389,
      "keyword": "boletín de noticias",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8229,
      "keyword": "boletín de noticias",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boletines de noticias": [
    {
      "id": 35389,
      "keyword": "boletín de noticias",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8229,
      "keyword": "boletín de noticias",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "programa del tiempo": [
    {
      "id": 8233,
      "keyword": "programa del tiempo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "programas del tiempo": [
    {
      "id": 8233,
      "keyword": "programa del tiempo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tocar el piano": [
    {
      "id": 8234,
      "keyword": "tocar el piano",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "musical instrument",
        "keyboard instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomar la tensión": [
    {
      "id": 8235,
      "keyword": "tomar la tensión",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38855,
      "keyword": "tomar la tensión",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tensión": [
    {
      "id": 8235,
      "keyword": "tensión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38855,
      "keyword": "tensión",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tensiones": [
    {
      "id": 8235,
      "keyword": "tensión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tropezar": [
    {
      "id": 8239,
      "keyword": "tropezar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8238,
      "keyword": "tropezar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26519,
      "keyword": "tropezar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tubería": [
    {
      "id": 8240,
      "keyword": "tubería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tuberías": [
    {
      "id": 8240,
      "keyword": "tubería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sarcófago": [
    {
      "id": 8220,
      "keyword": "sarcófago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "civilization",
        "Egypt",
        "archaeology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26427,
      "keyword": "sarcófago",
      "keywords": 2,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "character",
        "book character",
        "literature",
        "movie character",
        "cinema",
        "event",
        "popular event",
        "halloween",
        "civilization",
        "Egypt"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sarcófagos": [
    {
      "id": 8220,
      "keyword": "sarcófago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "civilization",
        "Egypt",
        "archaeology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26427,
      "keyword": "sarcófago",
      "keywords": 2,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "character",
        "book character",
        "literature",
        "movie character",
        "cinema",
        "event",
        "popular event",
        "halloween",
        "civilization",
        "Egypt"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "senegal": [
    {
      "id": 8221,
      "keyword": "Senegal",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "síndrome de down": [
    {
      "id": 30233,
      "keyword": "Síndrome de Down",
      "keywords": 1,
      "type": 1,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8222,
      "keyword": "síndrome de Down",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "special education",
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37455,
      "keyword": "síndrome de Down",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "special education",
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niño con síndrome de down": [
    {
      "id": 8222,
      "keyword": "niño con síndrome de Down",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "special education",
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tumbar": [
    {
      "id": 8242,
      "keyword": "tumbar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13374,
      "keyword": "tumbar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37298,
      "keyword": "tumbar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31312,
      "keyword": "tumbar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8241,
      "keyword": "tumbar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29660,
      "keyword": "tumbar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trepar": [
    {
      "id": 8237,
      "keyword": "trepar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37262,
      "keyword": "trepar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "place",
        "facility",
        "recreational facility",
        "playground"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8236,
      "keyword": "trepar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29662,
      "keyword": "trepar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perezoso": [
    {
      "id": 37830,
      "keyword": "perezoso",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8245,
      "keyword": "perezoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22039,
      "keyword": "perezoso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32063,
      "keyword": "perezoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perezosos": [
    {
      "id": 37830,
      "keyword": "perezoso",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8245,
      "keyword": "perezoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22039,
      "keyword": "perezoso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32063,
      "keyword": "perezoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vago": [
    {
      "id": 37830,
      "keyword": "vago",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8245,
      "keyword": "vago",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32063,
      "keyword": "vago",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vagos": [
    {
      "id": 37830,
      "keyword": "vago",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8245,
      "keyword": "vago",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32063,
      "keyword": "vago",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vertebrado": [
    {
      "id": 8249,
      "keyword": "vertebrado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8249,
      "keyword": "vertebrado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "animal",
        "vertebrate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vertebrados": [
    {
      "id": 8249,
      "keyword": "vertebrado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8249,
      "keyword": "vertebrado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "animal",
        "vertebrate"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vertebrada": [
    {
      "id": 8249,
      "keyword": "vertebrada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "animal",
        "vertebrate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vertebradas": [
    {
      "id": 8249,
      "keyword": "vertebrada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "animal",
        "vertebrate"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "uruguay": [
    {
      "id": 8244,
      "keyword": "Uruguay",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29602,
      "keyword": "Uruguay",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papel de aluminio": [
    {
      "id": 8250,
      "keyword": "papel de aluminio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papeles de aluminio": [
    {
      "id": 8250,
      "keyword": "papel de aluminio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frotar": [
    {
      "id": 34371,
      "keyword": "frotar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8251,
      "keyword": "frotar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apagado": [
    {
      "id": 26993,
      "keyword": "apagado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "light fixture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8252,
      "keyword": "apagado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apagados": [
    {
      "id": 26993,
      "keyword": "apagado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "light fixture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8252,
      "keyword": "apagado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apagada": [
    {
      "id": 26993,
      "keyword": "apagada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "light fixture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8252,
      "keyword": "apagada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apagadas": [
    {
      "id": 26993,
      "keyword": "apagada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "light fixture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8252,
      "keyword": "apagada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "balcón": [
    {
      "id": 8254,
      "keyword": "balcón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balcones": [
    {
      "id": 8254,
      "keyword": "balcón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agua oxigenada": [
    {
      "id": 8255,
      "keyword": "agua oxigenada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39055,
      "keyword": "agua oxigenada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38451,
      "keyword": "agua oxigenada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "communication",
        "language",
        "verb",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nochebuena": [
    {
      "id": 8260,
      "keyword": "Nochebuena",
      "keywords": 3,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "christmas",
        "religious event",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "noche buena": [
    {
      "id": 8260,
      "keyword": "Noche Buena",
      "keywords": 3,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "christmas",
        "religious event",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "día de nochebuena": [
    {
      "id": 8260,
      "keyword": "Día de Nochebuena",
      "keywords": 3,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "christmas",
        "religious event",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nochevieja": [
    {
      "id": 32534,
      "keyword": "Nochevieja",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "new year"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39109,
      "keyword": "Nochevieja",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "new year"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8261,
      "keyword": "Nochevieja",
      "keywords": 3,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "new year"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "día de nochevieja": [
    {
      "id": 8261,
      "keyword": "Día de Nochevieja",
      "keywords": 3,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "new year"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fin de año": [
    {
      "id": 8261,
      "keyword": "Fin de Año",
      "keywords": 3,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "new year"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piar": [
    {
      "id": 8262,
      "keyword": "piar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "interjection",
        "onomatopoeia",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "melchor": [
    {
      "id": 8264,
      "keyword": "Melchor",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history",
        "religion",
        "christianity",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muro": [
    {
      "id": 39074,
      "keyword": "muro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8266,
      "keyword": "muro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muros": [
    {
      "id": 39074,
      "keyword": "muro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8266,
      "keyword": "muro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "muralla": [
    {
      "id": 37620,
      "keyword": "muralla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8266,
      "keyword": "muralla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "murallas": [
    {
      "id": 37620,
      "keyword": "muralla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8266,
      "keyword": "muralla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "boda": [
    {
      "id": 24887,
      "keyword": "boda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34207,
      "keyword": "boda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37362,
      "keyword": "boda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8256,
      "keyword": "boda",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding",
        "religious event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11546,
      "keyword": "boda",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11548,
      "keyword": "boda",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bodas": [
    {
      "id": 24887,
      "keyword": "boda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34207,
      "keyword": "boda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37362,
      "keyword": "boda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8256,
      "keyword": "boda",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding",
        "religious event"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11546,
      "keyword": "boda",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11548,
      "keyword": "boda",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "matrimonio": [
    {
      "id": 24887,
      "keyword": "matrimonio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34207,
      "keyword": "matrimonio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37362,
      "keyword": "matrimonio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8256,
      "keyword": "matrimonio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding",
        "religious event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11546,
      "keyword": "matrimonio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11548,
      "keyword": "matrimonio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "matrimonios": [
    {
      "id": 24887,
      "keyword": "matrimonio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34207,
      "keyword": "matrimonio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37362,
      "keyword": "matrimonio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8256,
      "keyword": "matrimonio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding",
        "religious event"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11546,
      "keyword": "matrimonio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11548,
      "keyword": "matrimonio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casamiento": [
    {
      "id": 8256,
      "keyword": "casamiento",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding",
        "religious event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11546,
      "keyword": "casamiento",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11548,
      "keyword": "casamiento",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubo de imágenes": [
    {
      "id": 8276,
      "keyword": "cubo de imágenes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubos de imágenes": [
    {
      "id": 8276,
      "keyword": "cubo de imágenes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "érase una vez": [
    {
      "id": 8277,
      "keyword": "Érase una vez",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "set phrase",
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frankenstein": [
    {
      "id": 8279,
      "keyword": "Frankenstein",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "literature",
        "movie character",
        "cinema",
        "event",
        "popular event",
        "halloween",
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comunidad valenciana": [
    {
      "id": 8246,
      "keyword": "Comunidad Valenciana",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8713,
      "keyword": "Comunidad Valenciana",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "velocidad": [
    {
      "id": 8247,
      "keyword": "velocidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "velocidades": [
    {
      "id": 8247,
      "keyword": "velocidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "veneno": [
    {
      "id": 8248,
      "keyword": "veneno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "chemistry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "venenos": [
    {
      "id": 8248,
      "keyword": "veneno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "chemistry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "a través de": [
    {
      "id": 8274,
      "keyword": "a través de",
      "keywords": 1,
      "type": 6,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almendra": [
    {
      "id": 8292,
      "keyword": "almendra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35143,
      "keyword": "almendra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bola del árbol de navidad": [
    {
      "id": 8296,
      "keyword": "bola del árbol de navidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alfiler": [
    {
      "id": 8291,
      "keyword": "alfiler",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29788,
      "keyword": "alfiler",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "jewelry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolo": [
    {
      "id": 8297,
      "keyword": "bolo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bombón": [
    {
      "id": 8298,
      "keyword": "bombón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canelón": [
    {
      "id": 8301,
      "keyword": "canelón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "stop": [
    {
      "id": 8289,
      "keyword": "stop",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "stops": [
    {
      "id": 8289,
      "keyword": "stop",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "castaña": [
    {
      "id": 8302,
      "keyword": "castaña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cereza": [
    {
      "id": 8303,
      "keyword": "cereza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chincheta": [
    {
      "id": 8304,
      "keyword": "chincheta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciruela": [
    {
      "id": 8305,
      "keyword": "ciruela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clavo": [
    {
      "id": 8306,
      "keyword": "clavo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37241,
      "keyword": "clavo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "spices"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "croqueta": [
    {
      "id": 8307,
      "keyword": "croqueta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hexaedro": [
    {
      "id": 9115,
      "keyword": "hexaedro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8308,
      "keyword": "hexaedro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hexaedros": [
    {
      "id": 9115,
      "keyword": "hexaedro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8308,
      "keyword": "hexaedro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "galleta": [
    {
      "id": 8312,
      "keyword": "galleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "auricular": [
    {
      "id": 8293,
      "keyword": "auricular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espinaca": [
    {
      "id": 8311,
      "keyword": "espinaca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bastoncillo": [
    {
      "id": 8294,
      "keyword": "bastoncillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33116,
      "keyword": "bastoncillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maraca": [
    {
      "id": 8315,
      "keyword": "maraca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patín": [
    {
      "id": 8318,
      "keyword": "patín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "sport material",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30448,
      "keyword": "patín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30602,
      "keyword": "patín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "sport material",
        "skating"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aceituna": [
    {
      "id": 8317,
      "keyword": "aceituna",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8316,
      "keyword": "aceituna",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oliva": [
    {
      "id": 8317,
      "keyword": "oliva",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8316,
      "keyword": "oliva",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oliva verde": [
    {
      "id": 8317,
      "keyword": "oliva verde",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aceituna verde": [
    {
      "id": 8317,
      "keyword": "aceituna verde",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dardo": [
    {
      "id": 8309,
      "keyword": "dardo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empanadilla": [
    {
      "id": 8310,
      "keyword": "empanadilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empanada": [
    {
      "id": 8310,
      "keyword": "empanada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16651,
      "keyword": "empanada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empanadas": [
    {
      "id": 8310,
      "keyword": "empanada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16651,
      "keyword": "empanada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pistacho": [
    {
      "id": 8322,
      "keyword": "pistacho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manopla": [
    {
      "id": 25227,
      "keyword": "manopla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8314,
      "keyword": "manopla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poni": [
    {
      "id": 8324,
      "keyword": "poni",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "animal-assisted therapy",
        "equine-assisted therapy",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ponis": [
    {
      "id": 8324,
      "keyword": "poni",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "animal-assisted therapy",
        "equine-assisted therapy",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "riñón": [
    {
      "id": 8325,
      "keyword": "riñón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pila": [
    {
      "id": 8320,
      "keyword": "pila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24282,
      "keyword": "pila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30834,
      "keyword": "pila",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "event",
        "religious event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pestaña": [
    {
      "id": 8319,
      "keyword": "pestaña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "visual system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hongo": [
    {
      "id": 8328,
      "keyword": "hongo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "plant",
        "fungus"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hongos": [
    {
      "id": 8328,
      "keyword": "hongo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "plant",
        "fungus"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "seta": [
    {
      "id": 8328,
      "keyword": "seta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "plant",
        "fungus"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abalorio": [
    {
      "id": 8334,
      "keyword": "abalorio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "craftsmanship",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zapatilla": [
    {
      "id": 8333,
      "keyword": "zapatilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8332,
      "keyword": "zapatilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sportswear",
        "clothing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36679,
      "keyword": "zapatilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "albóndiga": [
    {
      "id": 8335,
      "keyword": "albóndiga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "altavoz": [
    {
      "id": 8336,
      "keyword": "altavoz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26628,
      "keyword": "altavoz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zapatilla de deporte": [
    {
      "id": 8332,
      "keyword": "zapatilla de deporte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sportswear",
        "clothing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36679,
      "keyword": "zapatilla de deporte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zapatillas de deporte": [
    {
      "id": 8332,
      "keyword": "zapatilla de deporte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sportswear",
        "clothing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36679,
      "keyword": "zapatilla de deporte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oliva negra": [
    {
      "id": 8316,
      "keyword": "oliva negra",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aceituna negra": [
    {
      "id": 8316,
      "keyword": "aceituna negra",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cacahuete": [
    {
      "id": 8338,
      "keyword": "cacahuete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maní": [
    {
      "id": 8338,
      "keyword": "maní",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calcetín": [
    {
      "id": 8339,
      "keyword": "calcetín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "castañuela": [
    {
      "id": 8340,
      "keyword": "castañuela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "event",
        "popular event",
        "fiestas del pilar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bongó": [
    {
      "id": 8341,
      "keyword": "bongó",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alubia": [
    {
      "id": 8337,
      "keyword": "alubia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "judía": [
    {
      "id": 8337,
      "keyword": "judía",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espárrago": [
    {
      "id": 8347,
      "keyword": "espárrago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chancleta": [
    {
      "id": 8343,
      "keyword": "chancleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chancla": [
    {
      "id": 8343,
      "keyword": "chancla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papel": [
    {
      "id": 8349,
      "keyword": "papel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "folio": [
    {
      "id": 8349,
      "keyword": "folio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gamba": [
    {
      "id": 8350,
      "keyword": "gamba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerilla": [
    {
      "id": 8342,
      "keyword": "cerilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fósforo": [
    {
      "id": 8342,
      "keyword": "fósforo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortina": [
    {
      "id": 8344,
      "keyword": "cortina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crótalo": [
    {
      "id": 8345,
      "keyword": "crótalo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esquí": [
    {
      "id": 16701,
      "keyword": "esquí",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8348,
      "keyword": "esquí",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guía": [
    {
      "id": 27823,
      "keyword": "guía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38373,
      "keyword": "guía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "work",
        "tertiary sector",
        "tourism",
        "culture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8993,
      "keyword": "guía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27821,
      "keyword": "guía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27822,
      "keyword": "guía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30018,
      "keyword": "guía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34539,
      "keyword": "guía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34540,
      "keyword": "guía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8356,
      "keyword": "guía",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guías": [
    {
      "id": 27823,
      "keyword": "guía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38373,
      "keyword": "guía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "work",
        "tertiary sector",
        "tourism",
        "culture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8993,
      "keyword": "guía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27821,
      "keyword": "guía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27822,
      "keyword": "guía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30018,
      "keyword": "guía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34539,
      "keyword": "guía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34540,
      "keyword": "guía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8356,
      "keyword": "guía",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guía turística": [
    {
      "id": 38758,
      "keyword": "guía turística",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8356,
      "keyword": "guía turística",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guías turísticas": [
    {
      "id": 38758,
      "keyword": "guía turística",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8356,
      "keyword": "guía turística",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guía de viaje": [
    {
      "id": 8356,
      "keyword": "guía de viaje",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guías de viaje": [
    {
      "id": 8356,
      "keyword": "guía de viaje",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "macarrón": [
    {
      "id": 8357,
      "keyword": "macarrón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "media": [
    {
      "id": 8358,
      "keyword": "media",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sobres de medicina": [
    {
      "id": 8359,
      "keyword": "sobres de medicina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mora": [
    {
      "id": 8360,
      "keyword": "mora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palillo": [
    {
      "id": 8362,
      "keyword": "palillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36564,
      "keyword": "palillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "garbanzo": [
    {
      "id": 8351,
      "keyword": "garbanzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "platillo": [
    {
      "id": 8364,
      "keyword": "platillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pendiente": [
    {
      "id": 8363,
      "keyword": "pendiente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arete": [
    {
      "id": 8363,
      "keyword": "arete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulmón": [
    {
      "id": 8365,
      "keyword": "pulmón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "respiratory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quesito": [
    {
      "id": 8366,
      "keyword": "quesito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "animal-based food",
        "dairy product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sábana": [
    {
      "id": 8367,
      "keyword": "sábana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 8367,
      "keyword": "sábana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17304,
      "keyword": "sábana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sobao": [
    {
      "id": 8369,
      "keyword": "sobao",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarjeta amarilla": [
    {
      "id": 8370,
      "keyword": "tarjeta amarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarjetas amarillas": [
    {
      "id": 8370,
      "keyword": "tarjeta amarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarjeta roja": [
    {
      "id": 8371,
      "keyword": "tarjeta roja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarjetas rojas": [
    {
      "id": 8371,
      "keyword": "tarjeta roja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sandalia": [
    {
      "id": 8368,
      "keyword": "sandalia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gigante": [
    {
      "id": 8375,
      "keyword": "gigante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11273,
      "keyword": "gigante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teta": [
    {
      "id": 8372,
      "keyword": "teta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seno": [
    {
      "id": 8372,
      "keyword": "seno",
      "keywords": 3,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "judía verde": [
    {
      "id": 8354,
      "keyword": "judía verde",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guía de plantas": [
    {
      "id": 8355,
      "keyword": "guía de plantas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "biology",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guías de plantas": [
    {
      "id": 8355,
      "keyword": "guía de plantas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "biology",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guante": [
    {
      "id": 8353,
      "keyword": "guante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "luz de color": [
    {
      "id": 8376,
      "keyword": "luz de color",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "burbuja": [
    {
      "id": 8389,
      "keyword": "burbuja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36187,
      "keyword": "burbuja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pompa de jabón": [
    {
      "id": 8389,
      "keyword": "pompa de jabón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muleta": [
    {
      "id": 8361,
      "keyword": "muleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sudar": [
    {
      "id": 35721,
      "keyword": "sudar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8469,
      "keyword": "sudar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "unas": [
    {
      "id": 8475,
      "keyword": "unas",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "article"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "unos": [
    {
      "id": 8475,
      "keyword": "unos",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "article"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "forma singular": [
    {
      "id": 8476,
      "keyword": "la",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "article"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8476,
      "keyword": "el",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "article"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8476,
      "keyword": "la",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "article"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "el": [
    {
      "id": 8476,
      "keyword": "el",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "article"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gominola": [
    {
      "id": 8352,
      "keyword": "gominola",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gomita": [
    {
      "id": 8352,
      "keyword": "gomita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frontera": [
    {
      "id": 8483,
      "keyword": "frontera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "political geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fronteras": [
    {
      "id": 8483,
      "keyword": "frontera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "political geography"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aduana": [
    {
      "id": 8483,
      "keyword": "aduana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "political geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aduanas": [
    {
      "id": 8483,
      "keyword": "aduana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "political geography"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adelantar": [
    {
      "id": 34844,
      "keyword": "adelantar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8482,
      "keyword": "adelantar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agua no potable": [
    {
      "id": 24497,
      "keyword": "agua no potable",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8485,
      "keyword": "agua no potable",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "amiga": [
    {
      "id": 25786,
      "keyword": "amiga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8486,
      "keyword": "amiga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "amigas": [
    {
      "id": 25786,
      "keyword": "amiga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8486,
      "keyword": "amiga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amistad": [
    {
      "id": 8488,
      "keyword": "amistad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "amistades": [
    {
      "id": 8488,
      "keyword": "amistad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amigo": [
    {
      "id": 25790,
      "keyword": "amigo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8487,
      "keyword": "amigo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abanicar": [
    {
      "id": 8480,
      "keyword": "abanicar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aceite de girasol": [
    {
      "id": 8481,
      "keyword": "aceite de girasol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aceites de girasol": [
    {
      "id": 8481,
      "keyword": "aceite de girasol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apio": [
    {
      "id": 8492,
      "keyword": "apio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apios": [
    {
      "id": 8492,
      "keyword": "apio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arpa": [
    {
      "id": 8493,
      "keyword": "arpa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arpas": [
    {
      "id": 8493,
      "keyword": "arpa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apartamento": [
    {
      "id": 8491,
      "keyword": "apartamento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apartamentos": [
    {
      "id": 8491,
      "keyword": "apartamento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estudio": [
    {
      "id": 36055,
      "keyword": "estudio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8491,
      "keyword": "estudio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estudios": [
    {
      "id": 36055,
      "keyword": "estudio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8491,
      "keyword": "estudio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "procesión": [
    {
      "id": 31023,
      "keyword": "procesión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "easter week",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8470,
      "keyword": "procesión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "religious event",
        "religion",
        "christianity",
        "popular event",
        "easter week"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31024,
      "keyword": "procesión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "easter week",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "procesiones": [
    {
      "id": 31023,
      "keyword": "procesión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "easter week",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8470,
      "keyword": "procesión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "religious event",
        "religion",
        "christianity",
        "popular event",
        "easter week"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31024,
      "keyword": "procesión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "easter week",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "avión de papel": [
    {
      "id": 8495,
      "keyword": "avión de papel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "hobby"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aviones de papel": [
    {
      "id": 8495,
      "keyword": "avión de papel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "hobby"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bajo en calorías": [
    {
      "id": 8496,
      "keyword": "bajo en calorías",
      "keywords": 1,
      "type": 4,
      "tags": [
        "health",
        "dietetics",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajos en calorías": [
    {
      "id": 8496,
      "keyword": "bajo en calorías",
      "keywords": 1,
      "type": 4,
      "tags": [
        "health",
        "dietetics",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "proyectil": [
    {
      "id": 8497,
      "keyword": "proyectil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "proyectiles": [
    {
      "id": 8497,
      "keyword": "proyectil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bala": [
    {
      "id": 8497,
      "keyword": "bala",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balas": [
    {
      "id": 8497,
      "keyword": "bala",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "basura": [
    {
      "id": 8499,
      "keyword": "basura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "pollution"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "basuras": [
    {
      "id": 8499,
      "keyword": "basura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "pollution"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "batido": [
    {
      "id": 35795,
      "keyword": "batido",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8503,
      "keyword": "batido",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "batidos": [
    {
      "id": 35795,
      "keyword": "batido",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8503,
      "keyword": "batido",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "batido de chocolate": [
    {
      "id": 8503,
      "keyword": "batido de chocolate",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "batidos de chocolate": [
    {
      "id": 8503,
      "keyword": "batido de chocolate",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "licuado ": [
    {
      "id": 8503,
      "keyword": "licuado ",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "licuados": [
    {
      "id": 35795,
      "keyword": "licuado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8503,
      "keyword": "licuado ",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "licuado de chocolate": [
    {
      "id": 8503,
      "keyword": "licuado de chocolate",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "licuados de chocolate": [
    {
      "id": 8503,
      "keyword": "licuado de chocolate",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "batidor": [
    {
      "id": 8504,
      "keyword": "batidor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "batidores": [
    {
      "id": 8504,
      "keyword": "batidor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "varillas": [
    {
      "id": 8504,
      "keyword": "varillas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "búfalo": [
    {
      "id": 8507,
      "keyword": "búfalo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "búfalos": [
    {
      "id": 8507,
      "keyword": "búfalo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bisonte": [
    {
      "id": 8507,
      "keyword": "bisonte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bisontes": [
    {
      "id": 8507,
      "keyword": "bisonte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "búfala": [
    {
      "id": 8507,
      "keyword": "búfala",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "búfalas": [
    {
      "id": 8507,
      "keyword": "búfala",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "billetes": [
    {
      "id": 29208,
      "keyword": "billete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8506,
      "keyword": "billetes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "bill",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 8506,
      "keyword": "billetes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "bill",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11255,
      "keyword": "billete",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "scenic art",
        "cinema",
        "show",
        "theater",
        "event",
        "social event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bloques de lego": [
    {
      "id": 8508,
      "keyword": "bloques de lego",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boccia": [
    {
      "id": 24885,
      "keyword": "boccia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "adapted sport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8509,
      "keyword": "boccia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "adapted sport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39521,
      "keyword": "boccia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "adapted sport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bocina": [
    {
      "id": 8510,
      "keyword": "bocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bocinas": [
    {
      "id": 8510,
      "keyword": "bocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolsa de deporte": [
    {
      "id": 8511,
      "keyword": "bolsa de deporte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "sport",
        "sport material",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 8511,
      "keyword": "bolsa de deporte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "sport",
        "sport material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas de deporte": [
    {
      "id": 8511,
      "keyword": "bolsa de deporte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "sport",
        "sport material",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 8511,
      "keyword": "bolsa de deporte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "sport",
        "sport material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolso de deporte": [
    {
      "id": 8511,
      "keyword": "bolso de deporte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "sport",
        "sport material",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 8511,
      "keyword": "bolso de deporte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "sport",
        "sport material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsos de deporte": [
    {
      "id": 8511,
      "keyword": "bolso de deporte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "sport",
        "sport material",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 8511,
      "keyword": "bolso de deporte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "sport",
        "sport material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bonsai": [
    {
      "id": 8512,
      "keyword": "bonsai",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "gardening",
        "leisure",
        "hobby"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bonsais": [
    {
      "id": 8512,
      "keyword": "bonsai",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "gardening",
        "leisure",
        "hobby"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apuntar": [
    {
      "id": 8490,
      "keyword": "apuntar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bengala": [
    {
      "id": 8505,
      "keyword": "bengala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bengalas": [
    {
      "id": 8505,
      "keyword": "bengala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caber": [
    {
      "id": 8516,
      "keyword": "caber",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caja de sorpresas": [
    {
      "id": 8517,
      "keyword": "caja de sorpresas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajas de sorpresas": [
    {
      "id": 8517,
      "keyword": "caja de sorpresas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sorpresa": [
    {
      "id": 35565,
      "keyword": "sorpresa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8517,
      "keyword": "sorpresa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sorpresas": [
    {
      "id": 35565,
      "keyword": "sorpresa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8517,
      "keyword": "sorpresa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bronceador": [
    {
      "id": 8515,
      "keyword": "bronceador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bronceadores": [
    {
      "id": 8515,
      "keyword": "bronceador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calcular": [
    {
      "id": 8518,
      "keyword": "calcular",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caldero": [
    {
      "id": 8519,
      "keyword": "caldero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calderos": [
    {
      "id": 8519,
      "keyword": "caldero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calentar": [
    {
      "id": 36506,
      "keyword": "calentar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8520,
      "keyword": "calentar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8521,
      "keyword": "calentar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27644,
      "keyword": "calentar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bate de beisbol": [
    {
      "id": 8501,
      "keyword": "bate de beisbol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bates de beisbol": [
    {
      "id": 8501,
      "keyword": "bate de beisbol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bate": [
    {
      "id": 8501,
      "keyword": "bate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bates": [
    {
      "id": 8501,
      "keyword": "bate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "batear": [
    {
      "id": 8502,
      "keyword": "batear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camello": [
    {
      "id": 8522,
      "keyword": "camello",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camellos": [
    {
      "id": 8522,
      "keyword": "camello",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camella": [
    {
      "id": 8522,
      "keyword": "camella",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camellas": [
    {
      "id": 8522,
      "keyword": "camella",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bostezar": [
    {
      "id": 8514,
      "keyword": "bostezar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8513,
      "keyword": "bostezar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32174,
      "keyword": "bostezar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34463,
      "keyword": "bostezar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campo de golf": [
    {
      "id": 8524,
      "keyword": "campo de golf",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campos de golf": [
    {
      "id": 8524,
      "keyword": "campo de golf",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cazar": [
    {
      "id": 38590,
      "keyword": "cazar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39191,
      "keyword": "cazar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "carnivorous",
        "animal behavior",
        "wild"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8533,
      "keyword": "cazar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34993,
      "keyword": "cazar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34999,
      "keyword": "cazar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camión de la basura": [
    {
      "id": 8523,
      "keyword": "camión de la basura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camiones de la basura": [
    {
      "id": 8523,
      "keyword": "camión de la basura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chaqueta de payaso": [
    {
      "id": 8536,
      "keyword": "chaqueta de payaso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chaquetas de payaso": [
    {
      "id": 8536,
      "keyword": "chaqueta de payaso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chatear": [
    {
      "id": 8539,
      "keyword": "chatear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media",
        "computing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8537,
      "keyword": "chatear",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media",
        "computing",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37867,
      "keyword": "chatear",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "videollamada": [
    {
      "id": 8537,
      "keyword": "videollamada",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media",
        "computing",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "videollamadas": [
    {
      "id": 8537,
      "keyword": "videollamada",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media",
        "computing",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "videoconferencia": [
    {
      "id": 8537,
      "keyword": "videoconferencia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media",
        "computing",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "videoconferencias": [
    {
      "id": 8537,
      "keyword": "videoconferencia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media",
        "computing",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "central nuclear": [
    {
      "id": 8534,
      "keyword": "central nuclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centrales nucleares": [
    {
      "id": 8534,
      "keyword": "central nuclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chirimoya": [
    {
      "id": 8540,
      "keyword": "chirimoya",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chirimoyas": [
    {
      "id": 8540,
      "keyword": "chirimoya",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chistera": [
    {
      "id": 8541,
      "keyword": "chistera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chisteras": [
    {
      "id": 8541,
      "keyword": "chistera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "claqueta": [
    {
      "id": 8542,
      "keyword": "claqueta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "claquetas": [
    {
      "id": 8542,
      "keyword": "claqueta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "corredor": [
    {
      "id": 8544,
      "keyword": "corredor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corredores": [
    {
      "id": 8544,
      "keyword": "corredor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cubiertos": [
    {
      "id": 30624,
      "keyword": "cubiertos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8545,
      "keyword": "cubiertos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuentagotas": [
    {
      "id": 8547,
      "keyword": "cuentagotas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36890,
      "keyword": "cuentagotas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cucharada": [
    {
      "id": 8546,
      "keyword": "cucharada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cucharadas": [
    {
      "id": 8546,
      "keyword": "cucharada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diablo": [
    {
      "id": 8549,
      "keyword": "diablo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "religion",
        "christianity",
        "islamism",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diablos": [
    {
      "id": 8549,
      "keyword": "diablo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "religion",
        "christianity",
        "islamism",
        "judaism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "catalejo": [
    {
      "id": 8531,
      "keyword": "catalejo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "catalejos": [
    {
      "id": 8531,
      "keyword": "catalejo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "distraído": [
    {
      "id": 30926,
      "keyword": "distraído",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8553,
      "keyword": "distraído",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8551,
      "keyword": "distraído",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31762,
      "keyword": "distraído",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "distraídos": [
    {
      "id": 30926,
      "keyword": "distraído",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8553,
      "keyword": "distraído",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8551,
      "keyword": "distraído",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31762,
      "keyword": "distraído",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "distraída": [
    {
      "id": 28635,
      "keyword": "distraída",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8553,
      "keyword": "distraída",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8551,
      "keyword": "distraída",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "distraídas": [
    {
      "id": 28635,
      "keyword": "distraída",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8553,
      "keyword": "distraída",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8551,
      "keyword": "distraída",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "distraer": [
    {
      "id": 8552,
      "keyword": "distraer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "embutidos": [
    {
      "id": 8554,
      "keyword": "embutidos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10225,
      "keyword": "embutidos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "embutido": [
    {
      "id": 8554,
      "keyword": "embutido",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10225,
      "keyword": "embutido",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fiambre": [
    {
      "id": 8554,
      "keyword": "fiambre",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35047,
      "keyword": "fiambre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10225,
      "keyword": "fiambre",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fiambres": [
    {
      "id": 8554,
      "keyword": "fiambre",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35047,
      "keyword": "fiambre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10225,
      "keyword": "fiambre",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enjuagar la boca": [
    {
      "id": 8560,
      "keyword": "enjuagar la boca",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8559,
      "keyword": "enjuagar la boca",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30032,
      "keyword": "enjuagar la boca",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enjuagar": [
    {
      "id": 8560,
      "keyword": "enjuagar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8559,
      "keyword": "enjuagar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30032,
      "keyword": "enjuagar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enjuague bucal": [
    {
      "id": 8561,
      "keyword": "enjuague bucal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enjuagues bucales": [
    {
      "id": 8561,
      "keyword": "enjuague bucal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "equipaje": [
    {
      "id": 8562,
      "keyword": "equipaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "work",
        "tertiary sector",
        "tourism",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equipajes": [
    {
      "id": 8562,
      "keyword": "equipaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "work",
        "tertiary sector",
        "tourism",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escorpión": [
    {
      "id": 8564,
      "keyword": "escorpión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "arachnid",
        "ovoviviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escorpiones": [
    {
      "id": 8564,
      "keyword": "escorpión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "arachnid",
        "ovoviviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escritora": [
    {
      "id": 8565,
      "keyword": "escritora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escritoras": [
    {
      "id": 8565,
      "keyword": "escritora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esculpir": [
    {
      "id": 32786,
      "keyword": "esculpir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "visual art",
        "sculpture",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8566,
      "keyword": "esculpir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "visual art",
        "sculpture",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35084,
      "keyword": "esculpir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "visual art",
        "sculpture",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35083,
      "keyword": "esculpir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "visual art",
        "sculpture",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escurrir": [
    {
      "id": 8568,
      "keyword": "escurrir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17229,
      "keyword": "escurrir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17231,
      "keyword": "escurrir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25072,
      "keyword": "escurrir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sable": [
    {
      "id": 8569,
      "keyword": "sable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sables": [
    {
      "id": 8569,
      "keyword": "sable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espada láser": [
    {
      "id": 8570,
      "keyword": "espada láser",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espadas láser": [
    {
      "id": 8570,
      "keyword": "espada láser",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espantapájaros": [
    {
      "id": 8571,
      "keyword": "espantapájaros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dibujante": [
    {
      "id": 38092,
      "keyword": "dibujante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "visual art",
        "drawing",
        "artist"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8550,
      "keyword": "dibujante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "visual art",
        "drawing",
        "artist"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11237,
      "keyword": "dibujante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "visual art",
        "drawing",
        "artist"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dibujantes": [
    {
      "id": 38092,
      "keyword": "dibujante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "visual art",
        "drawing",
        "artist"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8550,
      "keyword": "dibujante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "visual art",
        "drawing",
        "artist"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11237,
      "keyword": "dibujante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "visual art",
        "drawing",
        "artist"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escultura": [
    {
      "id": 8567,
      "keyword": "escultura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "sculpture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esculturas": [
    {
      "id": 8567,
      "keyword": "escultura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "sculpture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enemigos": [
    {
      "id": 8556,
      "keyword": "enemigos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encender el monitor": [
    {
      "id": 8555,
      "keyword": "encender el monitor",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encender la tele": [
    {
      "id": 8555,
      "keyword": "encender la tele",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enemistad": [
    {
      "id": 8557,
      "keyword": "enemistad",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "enemistades": [
    {
      "id": 8557,
      "keyword": "enemistad",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "estirar": [
    {
      "id": 39053,
      "keyword": "estirar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "physical exercise",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8574,
      "keyword": "estirar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36637,
      "keyword": "estirar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36638,
      "keyword": "estirar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37205,
      "keyword": "estirar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "experimentar": [
    {
      "id": 8578,
      "keyword": "experimentar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "chemistry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "explicar": [
    {
      "id": 16705,
      "keyword": "explicar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8579,
      "keyword": "explicar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35669,
      "keyword": "explicar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "excursionista": [
    {
      "id": 8577,
      "keyword": "excursionista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34516,
      "keyword": "excursionista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "excursionistas": [
    {
      "id": 8577,
      "keyword": "excursionista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34516,
      "keyword": "excursionista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estuche": [
    {
      "id": 8575,
      "keyword": "estuche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estuches": [
    {
      "id": 8575,
      "keyword": "estuche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fideos": [
    {
      "id": 8584,
      "keyword": "fideos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sopa de fideos": [
    {
      "id": 8584,
      "keyword": "sopa de fideos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flor de loto": [
    {
      "id": 8585,
      "keyword": "flor de loto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flores de loto": [
    {
      "id": 8585,
      "keyword": "flor de loto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fotocopiadora": [
    {
      "id": 35383,
      "keyword": "fotocopiadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "document"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8586,
      "keyword": "fotocopiadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fotocopiadoras": [
    {
      "id": 35383,
      "keyword": "fotocopiadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "document"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8586,
      "keyword": "fotocopiadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fotocopiar": [
    {
      "id": 8587,
      "keyword": "fotocopiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "document",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "garfio": [
    {
      "id": 8589,
      "keyword": "garfio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "garfios": [
    {
      "id": 8589,
      "keyword": "garfio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "goalball": [
    {
      "id": 8590,
      "keyword": "goalball",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "golfista": [
    {
      "id": 8591,
      "keyword": "golfista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35249,
      "keyword": "golfista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "golfistas": [
    {
      "id": 8591,
      "keyword": "golfista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35249,
      "keyword": "golfista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guante de béisbol": [
    {
      "id": 8595,
      "keyword": "guante de béisbol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guantes de béisbol": [
    {
      "id": 8595,
      "keyword": "guante de béisbol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guardar en el cajón": [
    {
      "id": 8596,
      "keyword": "guardar en el cajón",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "document",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guiñar": [
    {
      "id": 8598,
      "keyword": "guiñar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8597,
      "keyword": "guiñar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32158,
      "keyword": "guiñar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34514,
      "keyword": "guiñar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "granada": [
    {
      "id": 8594,
      "keyword": "granada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14686,
      "keyword": "Granada",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26874,
      "keyword": "Granada",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29733,
      "keyword": "Granada",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "granadas": [
    {
      "id": 8594,
      "keyword": "granada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guitarra eléctrica": [
    {
      "id": 8599,
      "keyword": "guitarra eléctrica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guitarras eléctricas": [
    {
      "id": 8599,
      "keyword": "guitarra eléctrica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "harina": [
    {
      "id": 8600,
      "keyword": "harina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "harinas": [
    {
      "id": 8600,
      "keyword": "harina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "helecho": [
    {
      "id": 8601,
      "keyword": "helecho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "bush"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "helechos": [
    {
      "id": 8601,
      "keyword": "helecho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "bush"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "felicidad": [
    {
      "id": 8582,
      "keyword": "felicidad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "optimismo": [
    {
      "id": 8582,
      "keyword": "optimismo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "optimismos": [
    {
      "id": 8582,
      "keyword": "optimismo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alegría": [
    {
      "id": 8582,
      "keyword": "alegría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alegrías": [
    {
      "id": 8582,
      "keyword": "alegría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "empresa": [
    {
      "id": 24507,
      "keyword": "empresa",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8581,
      "keyword": "empresa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "workplace"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empresas": [
    {
      "id": 24507,
      "keyword": "empresa",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8581,
      "keyword": "empresa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "workplace"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fábrica": [
    {
      "id": 24507,
      "keyword": "fábrica",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35393,
      "keyword": "fábrica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8581,
      "keyword": "fábrica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "workplace"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fábricas": [
    {
      "id": 24507,
      "keyword": "fábrica",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35393,
      "keyword": "fábrica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8581,
      "keyword": "fábrica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "workplace"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "industria": [
    {
      "id": 24507,
      "keyword": "industria",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8581,
      "keyword": "industria",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "workplace"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "industrias": [
    {
      "id": 24507,
      "keyword": "industria",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8581,
      "keyword": "industria",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "workplace"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ficha de puzzle": [
    {
      "id": 8583,
      "keyword": "ficha de puzzle",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fichas de puzzle": [
    {
      "id": 8583,
      "keyword": "ficha de puzzle",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gota de agua": [
    {
      "id": 8592,
      "keyword": "gota de agua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "chemistry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gotas de agua": [
    {
      "id": 24605,
      "keyword": "gotas de agua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "chemistry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25137,
      "keyword": "gotas de agua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "chemistry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8592,
      "keyword": "gota de agua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "chemistry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gota": [
    {
      "id": 8592,
      "keyword": "gota",
      "keywords": 2,
      "type": 2,
      "tags": [
        "chemistry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gotas": [
    {
      "id": 24605,
      "keyword": "gotas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "chemistry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25137,
      "keyword": "gotas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "chemistry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8592,
      "keyword": "gota",
      "keywords": 2,
      "type": 2,
      "tags": [
        "chemistry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huella dactilar": [
    {
      "id": 8604,
      "keyword": "huella dactilar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physical features",
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huellas dactilares": [
    {
      "id": 8604,
      "keyword": "huella dactilar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physical features",
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pisadas": [
    {
      "id": 26901,
      "keyword": "pisadas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8605,
      "keyword": "pisadas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 20109,
      "keyword": "pisadas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "herrero": [
    {
      "id": 8603,
      "keyword": "herrero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "craftsmanship",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "herreros": [
    {
      "id": 8603,
      "keyword": "herrero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "craftsmanship",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huracán": [
    {
      "id": 8606,
      "keyword": "huracán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huracanes": [
    {
      "id": 8606,
      "keyword": "huracán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugador de fútbol americano": [
    {
      "id": 8610,
      "keyword": "jugador de fútbol americano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadores de fútbol americano": [
    {
      "id": 8610,
      "keyword": "jugador de fútbol americano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugador de rugby": [
    {
      "id": 8611,
      "keyword": "jugador de rugby",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadores de rugby": [
    {
      "id": 8611,
      "keyword": "jugador de rugby",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "justicia": [
    {
      "id": 8612,
      "keyword": "justicia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "laurel": [
    {
      "id": 8614,
      "keyword": "laurel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "laureles": [
    {
      "id": 8614,
      "keyword": "laurel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enjabonar el pelo": [
    {
      "id": 38555,
      "keyword": "enjabonar el pelo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8615,
      "keyword": "enjabonar el pelo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26945,
      "keyword": "enjabonar el pelo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavar el pelo": [
    {
      "id": 8616,
      "keyword": "lavar el pelo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36552,
      "keyword": "lavar el pelo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8976,
      "keyword": "lavar el pelo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35037,
      "keyword": "lavar el pelo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "femenino": [
    {
      "id": 8602,
      "keyword": "femenino",
      "keywords": 1,
      "type": 4,
      "tags": [
        "sexuality",
        "gender identity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "femeninos": [
    {
      "id": 8602,
      "keyword": "femenino",
      "keywords": 1,
      "type": 4,
      "tags": [
        "sexuality",
        "gender identity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gracioso": [
    {
      "id": 31977,
      "keyword": "gracioso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8593,
      "keyword": "gracioso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "graciosos": [
    {
      "id": 31977,
      "keyword": "gracioso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8593,
      "keyword": "gracioso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "graciosa": [
    {
      "id": 8593,
      "keyword": "graciosa",
      "keywords": 2,
      "type": null,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "masculino": [
    {
      "id": 8621,
      "keyword": "masculino",
      "keywords": 1,
      "type": 4,
      "tags": [
        "sexuality",
        "gender identity",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "masculinos": [
    {
      "id": 8621,
      "keyword": "masculino",
      "keywords": 1,
      "type": 4,
      "tags": [
        "sexuality",
        "gender identity",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "macedonia": [
    {
      "id": 8620,
      "keyword": "macedonia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "macedonias": [
    {
      "id": 8620,
      "keyword": "macedonia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ensalada de frutas": [
    {
      "id": 8620,
      "keyword": "ensalada de frutas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ensaladas de frutas": [
    {
      "id": 8620,
      "keyword": "ensalada de frutas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "magdalena": [
    {
      "id": 25211,
      "keyword": "magdalena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8623,
      "keyword": "magdalena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "magdalenas": [
    {
      "id": 25211,
      "keyword": "magdalena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8623,
      "keyword": "magdalena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mantis": [
    {
      "id": 8624,
      "keyword": "mantis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mantis religiosa": [
    {
      "id": 8624,
      "keyword": "mantis religiosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mapa del tesoro": [
    {
      "id": 8625,
      "keyword": "mapa del tesoro",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "mapas del tesoro": [
    {
      "id": 8625,
      "keyword": "mapa del tesoro",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "maquillaje": [
    {
      "id": 8626,
      "keyword": "maquillaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34745,
      "keyword": "maquillaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maquillajes": [
    {
      "id": 8626,
      "keyword": "maquillaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34745,
      "keyword": "maquillaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34745,
      "keyword": "maquillajes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marisco": [
    {
      "id": 20101,
      "keyword": "marisco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "seafood",
        "animal",
        "invertebrate",
        "arthropod",
        "crustacean"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8627,
      "keyword": "marisco",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "seafood",
        "animal",
        "invertebrate",
        "arthropod",
        "crustacean",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mariscos": [
    {
      "id": 20101,
      "keyword": "marisco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "seafood",
        "animal",
        "invertebrate",
        "arthropod",
        "crustacean"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8627,
      "keyword": "marisco",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "seafood",
        "animal",
        "invertebrate",
        "arthropod",
        "crustacean",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "crustáceo": [
    {
      "id": 8627,
      "keyword": "crustáceo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "seafood",
        "animal",
        "invertebrate",
        "arthropod",
        "crustacean",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crustáceos": [
    {
      "id": 20101,
      "keyword": "crustáceos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "seafood",
        "animal",
        "invertebrate",
        "arthropod",
        "crustacean"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8627,
      "keyword": "crustáceo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "seafood",
        "animal",
        "invertebrate",
        "arthropod",
        "crustacean",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8627,
      "keyword": "crustáceos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "seafood",
        "animal",
        "invertebrate",
        "arthropod",
        "crustacean",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "insecticida": [
    {
      "id": 8607,
      "keyword": "insecticida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "insecticidas": [
    {
      "id": 8607,
      "keyword": "insecticida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugador de béisbol": [
    {
      "id": 8609,
      "keyword": "jugador de béisbol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadores de béisbol": [
    {
      "id": 8609,
      "keyword": "jugador de béisbol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "instrumentos musicales": [
    {
      "id": 8608,
      "keyword": "instrumentos musicales",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical instrument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8608,
      "keyword": "instrumento musical",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical instrument"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38091,
      "keyword": "instrumentos musicales",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical instrument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38091,
      "keyword": "instrumento musical",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "instrumentos": [
    {
      "id": 8608,
      "keyword": "instrumentos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical instrument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38091,
      "keyword": "instrumentos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "instrumento musical": [
    {
      "id": 8608,
      "keyword": "instrumento musical",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical instrument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38091,
      "keyword": "instrumento musical",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "loco": [
    {
      "id": 8618,
      "keyword": "loco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "locos": [
    {
      "id": 8618,
      "keyword": "loco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "loca": [
    {
      "id": 36411,
      "keyword": "loca",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8618,
      "keyword": "loca",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "locas": [
    {
      "id": 36411,
      "keyword": "loca",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8618,
      "keyword": "loca",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "luz": [
    {
      "id": 8619,
      "keyword": "luz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mofeta": [
    {
      "id": 8632,
      "keyword": "mofeta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mofetas": [
    {
      "id": 8632,
      "keyword": "mofeta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "moneda": [
    {
      "id": 8633,
      "keyword": "moneda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "coin"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monedas": [
    {
      "id": 8633,
      "keyword": "monedas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "coin"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nariz de payaso": [
    {
      "id": 8637,
      "keyword": "nariz de payaso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "narices de payaso": [
    {
      "id": 8637,
      "keyword": "nariz de payaso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mentirosa": [
    {
      "id": 37792,
      "keyword": "mentirosa",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8629,
      "keyword": "mentirosa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mentirosas": [
    {
      "id": 37792,
      "keyword": "mentirosa",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8629,
      "keyword": "mentirosa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mina": [
    {
      "id": 8630,
      "keyword": "mina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "mining",
        "workplace",
        "place"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26220,
      "keyword": "mina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "mining",
        "workplace",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "minas": [
    {
      "id": 8630,
      "keyword": "mina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "mining",
        "workplace",
        "place"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26220,
      "keyword": "mina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "mining",
        "workplace",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "navaja": [
    {
      "id": 8638,
      "keyword": "navaja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26248,
      "keyword": "navaja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "navajas": [
    {
      "id": 8638,
      "keyword": "navaja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26248,
      "keyword": "navaja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "novio": [
    {
      "id": 38939,
      "keyword": "novio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38940,
      "keyword": "novio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8641,
      "keyword": "novio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palo de golf": [
    {
      "id": 8646,
      "keyword": "palo de golf",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palos de golf": [
    {
      "id": 8646,
      "keyword": "palo de golf",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oscuridad": [
    {
      "id": 8643,
      "keyword": "oscuridad",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10742,
      "keyword": "oscuridad",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "pasas": [
    {
      "id": 8648,
      "keyword": "pasas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasear": [
    {
      "id": 8649,
      "keyword": "pasear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29951,
      "keyword": "pasear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29952,
      "keyword": "pasear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8651,
      "keyword": "pasear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31839,
      "keyword": "pasear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37345,
      "keyword": "pasear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orca": [
    {
      "id": 8642,
      "keyword": "orca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orcas": [
    {
      "id": 8642,
      "keyword": "orca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paté": [
    {
      "id": 8654,
      "keyword": "paté",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patés": [
    {
      "id": 8654,
      "keyword": "paté",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pechuga de pollo": [
    {
      "id": 8655,
      "keyword": "pechuga de pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pechugas de pollo": [
    {
      "id": 8655,
      "keyword": "pechuga de pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pechuga": [
    {
      "id": 25632,
      "keyword": "pechuga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8655,
      "keyword": "pechuga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pechugas": [
    {
      "id": 25632,
      "keyword": "pechuga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8655,
      "keyword": "pechuga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "minero": [
    {
      "id": 8631,
      "keyword": "minero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "mining",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mineros": [
    {
      "id": 8631,
      "keyword": "minero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "mining",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mortadela": [
    {
      "id": 8634,
      "keyword": "mortadela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mortadelas": [
    {
      "id": 8634,
      "keyword": "mortadela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "motosierra": [
    {
      "id": 8635,
      "keyword": "motosierra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "forestry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "motosierras": [
    {
      "id": 8635,
      "keyword": "motosierra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "forestry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peligro electricidad": [
    {
      "id": 8656,
      "keyword": "peligro electricidad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "energy",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peligro eléctrico": [
    {
      "id": 8656,
      "keyword": "peligro eléctrico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "energy",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "riesgo eléctrico": [
    {
      "id": 8656,
      "keyword": "riesgo eléctrico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "energy",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peligro por radiaciones": [
    {
      "id": 8657,
      "keyword": "peligro por radiaciones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "riesgo por radiaciones": [
    {
      "id": 8657,
      "keyword": "riesgo por radiaciones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peligro por materiales inflamables": [
    {
      "id": 8659,
      "keyword": "peligro por materiales inflamables",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "riesgo por materiales inflamables": [
    {
      "id": 8659,
      "keyword": "riesgo por materiales inflamables",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasta": [
    {
      "id": 8652,
      "keyword": "pasta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pastas": [
    {
      "id": 8652,
      "keyword": "pasta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pensar": [
    {
      "id": 8661,
      "keyword": "pensar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38796,
      "keyword": "pensar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8662,
      "keyword": "pensar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31847,
      "keyword": "pensar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34403,
      "keyword": "pensar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pierna": [
    {
      "id": 8666,
      "keyword": "pierna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 8666,
      "keyword": "pierna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37166,
      "keyword": "pierna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piernas": [
    {
      "id": 8666,
      "keyword": "pierna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 8666,
      "keyword": "pierna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37166,
      "keyword": "pierna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "piñones": [
    {
      "id": 8667,
      "keyword": "piñones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelota de béisbol": [
    {
      "id": 8660,
      "keyword": "pelota de béisbol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelotas de béisbol": [
    {
      "id": 8660,
      "keyword": "pelota de béisbol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pipas de calabaza": [
    {
      "id": 8669,
      "keyword": "pipas de calabaza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plastificar": [
    {
      "id": 8672,
      "keyword": "plastificar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibido beber": [
    {
      "id": 8673,
      "keyword": "prohibido beber",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "signaling system",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29177,
      "keyword": "prohibido beber",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "signaling system",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibido tomar": [
    {
      "id": 8673,
      "keyword": "prohibido tomar",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "signaling system",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29177,
      "keyword": "prohibido tomar",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "signaling system",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plastificadora": [
    {
      "id": 8671,
      "keyword": "plastificadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plastificadoras": [
    {
      "id": 8671,
      "keyword": "plastificadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prohibido comer": [
    {
      "id": 8674,
      "keyword": "prohibido comer",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29179,
      "keyword": "prohibido comer",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibido fumar": [
    {
      "id": 8675,
      "keyword": "prohibido fumar",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "smoking",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibido móviles": [
    {
      "id": 8676,
      "keyword": "prohibido móviles",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibido tirar papeles": [
    {
      "id": 8677,
      "keyword": "prohibido tirar papeles",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rábano": [
    {
      "id": 8678,
      "keyword": "rábano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rábanos": [
    {
      "id": 8678,
      "keyword": "rábano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pizca": [
    {
      "id": 8670,
      "keyword": "pizca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pizcas": [
    {
      "id": 8670,
      "keyword": "pizca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recoger la basura": [
    {
      "id": 8679,
      "keyword": "recoger la basura",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peonza": [
    {
      "id": 8663,
      "keyword": "peonza",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peonzas": [
    {
      "id": 8663,
      "keyword": "peonza",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trompo": [
    {
      "id": 8663,
      "keyword": "trompo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trompos": [
    {
      "id": 8663,
      "keyword": "trompo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perinola": [
    {
      "id": 8663,
      "keyword": "perinola",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perinolas": [
    {
      "id": 8663,
      "keyword": "perinola",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pirulo": [
    {
      "id": 8663,
      "keyword": "pirulo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pirulos": [
    {
      "id": 8663,
      "keyword": "pirulo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reflejar": [
    {
      "id": 8683,
      "keyword": "reflejar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8682,
      "keyword": "reflejar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34551,
      "keyword": "reflejar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodaja de limón": [
    {
      "id": 8684,
      "keyword": "rodaja de limón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodajas de limón": [
    {
      "id": 8684,
      "keyword": "rodaja de limón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salida de emergencia": [
    {
      "id": 8687,
      "keyword": "salida de emergencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38245,
      "keyword": "salida de emergencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recoger los juguetes": [
    {
      "id": 8680,
      "keyword": "recoger los juguetes",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "serio": [
    {
      "id": 36449,
      "keyword": "serio",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32300,
      "keyword": "serio",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8690,
      "keyword": "serio",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "serios": [
    {
      "id": 36449,
      "keyword": "serio",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32300,
      "keyword": "serio",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8690,
      "keyword": "serio",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "seria": [
    {
      "id": 36449,
      "keyword": "seria",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37191,
      "keyword": "seria",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8690,
      "keyword": "seria",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "serias": [
    {
      "id": 36449,
      "keyword": "seria",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37191,
      "keyword": "seria",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8690,
      "keyword": "seria",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "semilla": [
    {
      "id": 8689,
      "keyword": "semilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant physiology",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "semillas": [
    {
      "id": 8689,
      "keyword": "semilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant physiology",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sobrasada": [
    {
      "id": 8692,
      "keyword": "sobrasada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sobrasadas": [
    {
      "id": 8692,
      "keyword": "sobrasada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sin gluten": [
    {
      "id": 8691,
      "keyword": "sin gluten",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "dietetics",
        "feeding",
        "food",
        "plant-based food",
        "cereal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sociedad": [
    {
      "id": 8693,
      "keyword": "sociedad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sociedades": [
    {
      "id": 8693,
      "keyword": "sociedad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "soldador": [
    {
      "id": 8694,
      "keyword": "soldador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24412,
      "keyword": "soldador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soldadores": [
    {
      "id": 8694,
      "keyword": "soldador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24412,
      "keyword": "soldador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sombrero de bruja": [
    {
      "id": 8697,
      "keyword": "sombrero de bruja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sombreros de bruja": [
    {
      "id": 8697,
      "keyword": "sombrero de bruja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "secar los platos": [
    {
      "id": 8688,
      "keyword": "secar los platos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "periodista": [
    {
      "id": 35373,
      "keyword": "periodista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8664,
      "keyword": "periodista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11335,
      "keyword": "periodista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "periodistas": [
    {
      "id": 35373,
      "keyword": "periodista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8664,
      "keyword": "periodista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11335,
      "keyword": "periodista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sacar punta": [
    {
      "id": 8685,
      "keyword": "sacar punta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soldar": [
    {
      "id": 8696,
      "keyword": "soldar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sortear": [
    {
      "id": 32520,
      "keyword": "sortear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31676,
      "keyword": "sortear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game",
        "game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8699,
      "keyword": "sortear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "game",
        "gambling",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11259,
      "keyword": "sortear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suela": [
    {
      "id": 8702,
      "keyword": "suela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suelas": [
    {
      "id": 8702,
      "keyword": "suela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tamaño": [
    {
      "id": 8704,
      "keyword": "tamaño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "size"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tamaños": [
    {
      "id": 8704,
      "keyword": "tamaño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "size"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sombrero de pirata": [
    {
      "id": 8698,
      "keyword": "sombrero de pirata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sombreros de pirata": [
    {
      "id": 8698,
      "keyword": "sombrero de pirata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tímido": [
    {
      "id": 37791,
      "keyword": "tímido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31750,
      "keyword": "tímido",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8707,
      "keyword": "tímido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tímidos": [
    {
      "id": 37791,
      "keyword": "tímido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31750,
      "keyword": "tímido",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8707,
      "keyword": "tímido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tímida": [
    {
      "id": 37791,
      "keyword": "tímida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37767,
      "keyword": "tímida",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8707,
      "keyword": "tímida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tímidas": [
    {
      "id": 37791,
      "keyword": "tímida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37767,
      "keyword": "tímida",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8707,
      "keyword": "tímida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tirar con arco": [
    {
      "id": 8708,
      "keyword": "tirar con arco",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarta nupcial": [
    {
      "id": 8706,
      "keyword": "tarta nupcial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tartas nupciales": [
    {
      "id": 8706,
      "keyword": "tarta nupcial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tocar la guitarra": [
    {
      "id": 8709,
      "keyword": "tocar la guitarra",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38041,
      "keyword": "tocar la guitarra",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trineo": [
    {
      "id": 8710,
      "keyword": "trineo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 8710,
      "keyword": "trineo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trineos": [
    {
      "id": 8710,
      "keyword": "trineo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 8710,
      "keyword": "trineo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tucán": [
    {
      "id": 8711,
      "keyword": "tucán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tucanes": [
    {
      "id": 8711,
      "keyword": "tucán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vagoneta": [
    {
      "id": 8712,
      "keyword": "vagoneta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "mining",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work machine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vagonetas": [
    {
      "id": 8712,
      "keyword": "vagoneta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "mining",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work machine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taquilla": [
    {
      "id": 34189,
      "keyword": "taquilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "culture",
        "scenic art",
        "cinema",
        "show",
        "theater",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8705,
      "keyword": "taquilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "leisure",
        "sport",
        "facility",
        "sports facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37907,
      "keyword": "taquilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24793,
      "keyword": "taquilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "culture",
        "scenic art",
        "cinema",
        "show",
        "theater",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taquillas": [
    {
      "id": 34189,
      "keyword": "taquilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "culture",
        "scenic art",
        "cinema",
        "show",
        "theater",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8705,
      "keyword": "taquilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "leisure",
        "sport",
        "facility",
        "sports facility"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37907,
      "keyword": "taquilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24793,
      "keyword": "taquilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "culture",
        "scenic art",
        "cinema",
        "show",
        "theater",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "víbora": [
    {
      "id": 8716,
      "keyword": "víbora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "ovoviviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "víboras": [
    {
      "id": 8716,
      "keyword": "víbora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "ovoviviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sudadera": [
    {
      "id": 8701,
      "keyword": "sudadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sudaderas": [
    {
      "id": 8701,
      "keyword": "sudadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "surfista": [
    {
      "id": 8703,
      "keyword": "surfista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34549,
      "keyword": "surfista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "surfistas": [
    {
      "id": 8703,
      "keyword": "surfista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34549,
      "keyword": "surfista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vida": [
    {
      "id": 8717,
      "keyword": "vida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vidas": [
    {
      "id": 8717,
      "keyword": "vida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vigilar": [
    {
      "id": 16907,
      "keyword": "vigilar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39155,
      "keyword": "vigilar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8718,
      "keyword": "vigilar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "otear": [
    {
      "id": 16907,
      "keyword": "otear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8718,
      "keyword": "otear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yunque": [
    {
      "id": 8719,
      "keyword": "yunque",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yunques": [
    {
      "id": 8719,
      "keyword": "yunque",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zapato de payaso": [
    {
      "id": 8720,
      "keyword": "zapato de payaso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zapatos de payaso": [
    {
      "id": 8720,
      "keyword": "zapato de payaso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "suciedad": [
    {
      "id": 8700,
      "keyword": "suciedad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "pollution"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "verdad": [
    {
      "id": 39287,
      "keyword": "verdad",
      "keywords": 7,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8715,
      "keyword": "verdad",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "verdades": [
    {
      "id": 39287,
      "keyword": "verdad",
      "keywords": 7,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8715,
      "keyword": "verdad",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cierto": [
    {
      "id": 39287,
      "keyword": "cierto",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8715,
      "keyword": "cierto",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciertos": [
    {
      "id": 39287,
      "keyword": "cierto",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8715,
      "keyword": "cierto",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cierta": [
    {
      "id": 39287,
      "keyword": "cierta",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8715,
      "keyword": "cierta",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciertas": [
    {
      "id": 39287,
      "keyword": "cierta",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8715,
      "keyword": "cierta",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "verdadero": [
    {
      "id": 39287,
      "keyword": "verdadero",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8715,
      "keyword": "verdadero",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "verdaderos": [
    {
      "id": 39287,
      "keyword": "verdadero",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8715,
      "keyword": "verdadero",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "verdadera": [
    {
      "id": 39287,
      "keyword": "verdadera",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8715,
      "keyword": "verdadera",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "verdaderas": [
    {
      "id": 39287,
      "keyword": "verdadera",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8715,
      "keyword": "verdadera",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sincera": [
    {
      "id": 39287,
      "keyword": "sincera",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8715,
      "keyword": "sincera",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sinceras": [
    {
      "id": 39287,
      "keyword": "sincera",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8715,
      "keyword": "sincera",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "velero": [
    {
      "id": 8714,
      "keyword": "velero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veleros": [
    {
      "id": 8714,
      "keyword": "velero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barco de vela": [
    {
      "id": 8714,
      "keyword": "barco de vela",
      "keywords": 3,
      "type": null,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barcos de vela": [
    {
      "id": 8714,
      "keyword": "barco de vela",
      "keywords": 3,
      "type": null,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chicle": [
    {
      "id": 8724,
      "keyword": "chicle",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chicles": [
    {
      "id": 8724,
      "keyword": "chicle",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8724,
      "keyword": "chicles",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiar las gafas": [
    {
      "id": 8726,
      "keyword": "limpiar las gafas",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29736,
      "keyword": "limpiar las gafas",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiar las lentes": [
    {
      "id": 8726,
      "keyword": "limpiar las lentes",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29736,
      "keyword": "limpiar las lentes",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiar los anteojos": [
    {
      "id": 8726,
      "keyword": "limpiar los anteojos",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29736,
      "keyword": "limpiar los anteojos",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiar los zapatos": [
    {
      "id": 8727,
      "keyword": "limpiar los zapatos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27871,
      "keyword": "limpiar los zapatos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36933,
      "keyword": "limpiar los zapatos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "covid-19",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pata de palo": [
    {
      "id": 8729,
      "keyword": "pata de palo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patas de palo": [
    {
      "id": 8729,
      "keyword": "pata de palo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caballete": [
    {
      "id": 8723,
      "keyword": "caballete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caballetes": [
    {
      "id": 8723,
      "keyword": "caballete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "boomerang": [
    {
      "id": 8722,
      "keyword": "boomerang",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boomerangs": [
    {
      "id": 8722,
      "keyword": "boomerang",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bumerán": [
    {
      "id": 8722,
      "keyword": "bumerán",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bumeranes": [
    {
      "id": 8722,
      "keyword": "bumerán",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "muñeco articulado": [
    {
      "id": 8728,
      "keyword": "muñeco articulado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muñecos articulados": [
    {
      "id": 8728,
      "keyword": "muñeco articulado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taller de bicicletas": [
    {
      "id": 8732,
      "keyword": "taller de bicicletas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talleres de bicicletas": [
    {
      "id": 8732,
      "keyword": "taller de bicicletas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taller de jardinería": [
    {
      "id": 8733,
      "keyword": "taller de jardinería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "primary sector",
        "gardening",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37209,
      "keyword": "taller de jardinería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "primary sector",
        "gardening",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talleres de jardinería": [
    {
      "id": 8733,
      "keyword": "taller de jardinería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "primary sector",
        "gardening",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37209,
      "keyword": "taller de jardinería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "primary sector",
        "gardening",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "yoyó": [
    {
      "id": 8734,
      "keyword": "yoyó",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yoyós": [
    {
      "id": 8734,
      "keyword": "yoyó",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mocarse": [
    {
      "id": 8731,
      "keyword": "mocarse",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mocar la nariz": [
    {
      "id": 8731,
      "keyword": "mocar la nariz",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carpeta de anillas": [
    {
      "id": 8828,
      "keyword": "carpeta de anillas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carpetas de anillas": [
    {
      "id": 8828,
      "keyword": "carpeta de anillas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "túnel": [
    {
      "id": 8972,
      "keyword": "túnel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "túneles": [
    {
      "id": 8972,
      "keyword": "túnel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aclarar el pelo": [
    {
      "id": 8978,
      "keyword": "aclarar el pelo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28505,
      "keyword": "aclarar el pelo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alfarera": [
    {
      "id": 8721,
      "keyword": "alfarera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alfareras": [
    {
      "id": 8721,
      "keyword": "alfarera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cascar": [
    {
      "id": 8984,
      "keyword": "cascar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "animal-based food",
        "egg product",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cargar": [
    {
      "id": 8983,
      "keyword": "cargar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21492,
      "keyword": "cargar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8982,
      "keyword": "cargar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cargado": [
    {
      "id": 8983,
      "keyword": "cargado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8982,
      "keyword": "cargado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cargados": [
    {
      "id": 8983,
      "keyword": "cargado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8982,
      "keyword": "cargado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "soportar": [
    {
      "id": 8983,
      "keyword": "soportar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8982,
      "keyword": "soportar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodaja de naranja": [
    {
      "id": 8730,
      "keyword": "rodaja de naranja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodajas de naranja": [
    {
      "id": 8730,
      "keyword": "rodaja de naranja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desordenar": [
    {
      "id": 36634,
      "keyword": "desordenar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8987,
      "keyword": "desordenar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ir de compras": [
    {
      "id": 8986,
      "keyword": "ir de compras",
      "keywords": 8,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "work",
        "tertiary sector",
        "trade",
        "core vocabulary",
        "place",
        "building",
        "feeding",
        "food",
        "object",
        "cleaning product",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8985,
      "keyword": "ir de compras",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28665,
      "keyword": "ir de compras",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer la compra": [
    {
      "id": 8986,
      "keyword": "hacer la compra",
      "keywords": 8,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "work",
        "tertiary sector",
        "trade",
        "core vocabulary",
        "place",
        "building",
        "feeding",
        "food",
        "object",
        "cleaning product",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8985,
      "keyword": "hacer la compra",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28665,
      "keyword": "hacer la compra",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ir a la compra": [
    {
      "id": 8986,
      "keyword": "ir a la compra",
      "keywords": 8,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "work",
        "tertiary sector",
        "trade",
        "core vocabulary",
        "place",
        "building",
        "feeding",
        "food",
        "object",
        "cleaning product",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8985,
      "keyword": "ir a la compra",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28665,
      "keyword": "ir a la compra",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comprador": [
    {
      "id": 8986,
      "keyword": "comprador",
      "keywords": 8,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "work",
        "tertiary sector",
        "trade",
        "core vocabulary",
        "place",
        "building",
        "feeding",
        "food",
        "object",
        "cleaning product",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8986,
      "keyword": "comprador",
      "keywords": 8,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "work",
        "tertiary sector",
        "trade",
        "core vocabulary",
        "place",
        "building",
        "feeding",
        "food",
        "object",
        "cleaning product",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compradores": [
    {
      "id": 8986,
      "keyword": "comprador",
      "keywords": 8,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "work",
        "tertiary sector",
        "trade",
        "core vocabulary",
        "place",
        "building",
        "feeding",
        "food",
        "object",
        "cleaning product",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "compradora": [
    {
      "id": 8986,
      "keyword": "comprador",
      "keywords": 8,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "work",
        "tertiary sector",
        "trade",
        "core vocabulary",
        "place",
        "building",
        "feeding",
        "food",
        "object",
        "cleaning product",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cliente": [
    {
      "id": 8986,
      "keyword": "cliente",
      "keywords": 8,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "work",
        "tertiary sector",
        "trade",
        "core vocabulary",
        "place",
        "building",
        "feeding",
        "food",
        "object",
        "cleaning product",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clientes": [
    {
      "id": 8986,
      "keyword": "cliente",
      "keywords": 8,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "work",
        "tertiary sector",
        "trade",
        "core vocabulary",
        "place",
        "building",
        "feeding",
        "food",
        "object",
        "cleaning product",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clienta": [
    {
      "id": 8986,
      "keyword": "clienta",
      "keywords": 8,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "work",
        "tertiary sector",
        "trade",
        "core vocabulary",
        "place",
        "building",
        "feeding",
        "food",
        "object",
        "cleaning product",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clientas": [
    {
      "id": 8986,
      "keyword": "clienta",
      "keywords": 8,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "work",
        "tertiary sector",
        "trade",
        "core vocabulary",
        "place",
        "building",
        "feeding",
        "food",
        "object",
        "cleaning product",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "boxeo": [
    {
      "id": 8981,
      "keyword": "boxeo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boxear": [
    {
      "id": 8981,
      "keyword": "boxear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despertar": [
    {
      "id": 8989,
      "keyword": "despertar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31857,
      "keyword": "despertar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8988,
      "keyword": "despertar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28625,
      "keyword": "despertar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despertarse": [
    {
      "id": 8989,
      "keyword": "despertarse",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31857,
      "keyword": "despertarse",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8988,
      "keyword": "despertarse",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28625,
      "keyword": "despertarse",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desperezar": [
    {
      "id": 8989,
      "keyword": "desperezar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8988,
      "keyword": "desperezar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28625,
      "keyword": "desperezar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desperezarse": [
    {
      "id": 8989,
      "keyword": "desperezarse",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31857,
      "keyword": "desperezarse",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8988,
      "keyword": "desperezarse",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28625,
      "keyword": "desperezarse",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavar las manos": [
    {
      "id": 8975,
      "keyword": "lavar las manos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dirigir": [
    {
      "id": 34443,
      "keyword": "dirigir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34527,
      "keyword": "dirigir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art",
        "musical notation",
        "musical composition",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8994,
      "keyword": "dirigir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "work",
        "tertiary sector",
        "tourism",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38642,
      "keyword": "dirigir",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8990,
      "keyword": "dirigir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art",
        "musical notation",
        "musical composition",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8991,
      "keyword": "dirigir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9700,
      "keyword": "dirigir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art",
        "musical notation",
        "musical composition",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34353,
      "keyword": "dirigir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guiar": [
    {
      "id": 8994,
      "keyword": "guiar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "work",
        "tertiary sector",
        "tourism",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38642,
      "keyword": "guiar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encaminar": [
    {
      "id": 8994,
      "keyword": "encaminar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "work",
        "tertiary sector",
        "tourism",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "divertir": [
    {
      "id": 16647,
      "keyword": "divertir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8992,
      "keyword": "divertir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "divertirse": [
    {
      "id": 8992,
      "keyword": "divertirse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dirigir el tráfico": [
    {
      "id": 8991,
      "keyword": "dirigir el tráfico",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34353,
      "keyword": "dirigir el tráfico",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enamorar": [
    {
      "id": 11531,
      "keyword": "enamorar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11529,
      "keyword": "enamorar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8995,
      "keyword": "enamorar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "golpear ": [
    {
      "id": 8999,
      "keyword": "golpear ",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puñetazo": [
    {
      "id": 9000,
      "keyword": "puñetazo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8999,
      "keyword": "puñetazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31793,
      "keyword": "puñetazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34555,
      "keyword": "puñetazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puñetazos": [
    {
      "id": 9000,
      "keyword": "puñetazo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8999,
      "keyword": "puñetazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31793,
      "keyword": "puñetazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34555,
      "keyword": "puñetazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "expulsar": [
    {
      "id": 29879,
      "keyword": "expulsar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8998,
      "keyword": "expulsar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11260,
      "keyword": "expulsar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport rules",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8997,
      "keyword": "expulsar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39037,
      "keyword": "expulsar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39039,
      "keyword": "expulsar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39040,
      "keyword": "expulsar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "expulsión": [
    {
      "id": 8998,
      "keyword": "expulsión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11260,
      "keyword": "expulsión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport rules",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8997,
      "keyword": "expulsión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39037,
      "keyword": "expulsión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39039,
      "keyword": "expulsión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39040,
      "keyword": "expulsión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "expulsiones": [
    {
      "id": 8998,
      "keyword": "expulsión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11260,
      "keyword": "expulsión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport rules",
        "football"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8997,
      "keyword": "expulsión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39039,
      "keyword": "expulsión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39040,
      "keyword": "expulsión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esposado": [
    {
      "id": 8996,
      "keyword": "esposado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esposados": [
    {
      "id": 8996,
      "keyword": "esposado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esposar": [
    {
      "id": 8996,
      "keyword": "esposar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esposada": [
    {
      "id": 8996,
      "keyword": "esposada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esposadas": [
    {
      "id": 8996,
      "keyword": "esposada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inclinar": [
    {
      "id": 9004,
      "keyword": "inclinar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39434,
      "keyword": "inclinar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39136,
      "keyword": "inclinar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9003,
      "keyword": "inclinar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35021,
      "keyword": "inclinar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "turismo": [
    {
      "id": 9002,
      "keyword": "turismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer turismo": [
    {
      "id": 9002,
      "keyword": "hacer turismo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "haber": [
    {
      "id": 9001,
      "keyword": "haber",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiar la ventana": [
    {
      "id": 37811,
      "keyword": "limpiar la ventana",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9008,
      "keyword": "limpiar la ventana",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29746,
      "keyword": "limpiar la ventana",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiar el cristal": [
    {
      "id": 9009,
      "keyword": "limpiar el cristal",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29748,
      "keyword": "limpiar el cristal",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "masajear": [
    {
      "id": 9010,
      "keyword": "masajear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9011,
      "keyword": "masajear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32200,
      "keyword": "masajear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "masaje": [
    {
      "id": 9010,
      "keyword": "masaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9011,
      "keyword": "masaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "masajes": [
    {
      "id": 9010,
      "keyword": "masaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9011,
      "keyword": "masaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inclinar la botella": [
    {
      "id": 9005,
      "keyword": "inclinar la botella",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orientarse": [
    {
      "id": 16825,
      "keyword": "orientarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9013,
      "keyword": "orientarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orientar": [
    {
      "id": 16825,
      "keyword": "orientar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37719,
      "keyword": "orientar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9013,
      "keyword": "orientar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavar el coche": [
    {
      "id": 9006,
      "keyword": "lavar el coche",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasear al perro": [
    {
      "id": 26302,
      "keyword": "pasear al perro",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "pet",
        "animal-assisted therapy",
        "dog-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36424,
      "keyword": "pasear al perro",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "pet",
        "animal-assisted therapy",
        "dog-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9016,
      "keyword": "pasear al perro",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "pet",
        "animal-assisted therapy",
        "dog-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29738,
      "keyword": "pasear al perro",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "pet",
        "animal-assisted therapy",
        "dog-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patalear": [
    {
      "id": 9018,
      "keyword": "patalear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9017,
      "keyword": "patalear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35095,
      "keyword": "patalear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "luchar": [
    {
      "id": 9007,
      "keyword": "luchar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelear": [
    {
      "id": 37373,
      "keyword": "pelear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24254,
      "keyword": "pelear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34492,
      "keyword": "pelear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34496,
      "keyword": "pelear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9007,
      "keyword": "pelear",
      "keywords": 3,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "combatir": [
    {
      "id": 39106,
      "keyword": "combatir",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9007,
      "keyword": "combatir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perfumarse": [
    {
      "id": 16849,
      "keyword": "perfumarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9021,
      "keyword": "perfumarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27961,
      "keyword": "perfumarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perfumar": [
    {
      "id": 16849,
      "keyword": "perfumar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9021,
      "keyword": "perfumar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27961,
      "keyword": "perfumar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibir": [
    {
      "id": 9022,
      "keyword": "prohibir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "novia": [
    {
      "id": 38937,
      "keyword": "novia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38938,
      "keyword": "novia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 8640,
      "keyword": "novia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "novias": [
    {
      "id": 38937,
      "keyword": "novia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38938,
      "keyword": "novia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 8640,
      "keyword": "novia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11523,
      "keyword": "novias",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11548,
      "keyword": "novias",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recoger el correo": [
    {
      "id": 9025,
      "keyword": "recoger el correo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recibir una carta": [
    {
      "id": 9025,
      "keyword": "recibir una carta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parar el balón": [
    {
      "id": 9015,
      "keyword": "parar el balón",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "person",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rallar": [
    {
      "id": 9023,
      "keyword": "rallar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rallar queso": [
    {
      "id": 9023,
      "keyword": "rallar queso",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "queso rallado": [
    {
      "id": 9023,
      "keyword": "queso rallado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quesos rallados": [
    {
      "id": 9023,
      "keyword": "queso rallado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recuperar": [
    {
      "id": 9026,
      "keyword": "recuperar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reducir": [
    {
      "id": 9027,
      "keyword": "reducir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36439,
      "keyword": "reducir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "resbalar": [
    {
      "id": 9029,
      "keyword": "resbalar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "work accident"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9028,
      "keyword": "resbalar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "work accident"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29676,
      "keyword": "resbalar",
      "keywords": 2,
      "type": 3,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "resbalarse": [
    {
      "id": 9029,
      "keyword": "resbalarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "work accident"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9028,
      "keyword": "resbalarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "work accident"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29676,
      "keyword": "resbalarse",
      "keywords": 2,
      "type": 3,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "responder": [
    {
      "id": 9031,
      "keyword": "responder",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10176,
      "keyword": "responder",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9030,
      "keyword": "responder",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28433,
      "keyword": "responder",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contestar": [
    {
      "id": 9031,
      "keyword": "contestar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9030,
      "keyword": "contestar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28433,
      "keyword": "contestar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reanimar": [
    {
      "id": 35327,
      "keyword": "reanimar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9024,
      "keyword": "reanimar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saber": [
    {
      "id": 16885,
      "keyword": "saber",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "education",
        "students",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9034,
      "keyword": "saber",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26405,
      "keyword": "saber",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "levantar la mano": [
    {
      "id": 16885,
      "keyword": "levantar la mano",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "education",
        "students",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28419,
      "keyword": "levantar la mano",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28420,
      "keyword": "levantar la mano",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28421,
      "keyword": "levantar la mano",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9034,
      "keyword": "levantar la mano",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26405,
      "keyword": "levantar la mano",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "romper el cristal": [
    {
      "id": 9033,
      "keyword": "romper el cristal",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38109,
      "keyword": "romper el cristal",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secar la mesa": [
    {
      "id": 9035,
      "keyword": "secar la mesa",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patinador": [
    {
      "id": 9020,
      "keyword": "patinador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36135,
      "keyword": "patinador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36017,
      "keyword": "patinador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patinadores": [
    {
      "id": 9020,
      "keyword": "patinador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36135,
      "keyword": "patinador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36017,
      "keyword": "patinador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tejer": [
    {
      "id": 9040,
      "keyword": "tejer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9039,
      "keyword": "tejer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "craftsmanship",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tricotar": [
    {
      "id": 9039,
      "keyword": "tricotar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "craftsmanship",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "romper las gafas ": [
    {
      "id": 9032,
      "keyword": "romper las gafas ",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "partir las gafas": [
    {
      "id": 9032,
      "keyword": "partir las gafas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "susurrar": [
    {
      "id": 16899,
      "keyword": "susurrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9037,
      "keyword": "susurrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12291,
      "keyword": "susurrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vallar": [
    {
      "id": 9042,
      "keyword": "vallar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "construction",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9041,
      "keyword": "vallar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "construction",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cercar": [
    {
      "id": 9042,
      "keyword": "cercar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "construction",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9041,
      "keyword": "cercar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "construction",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cosechar": [
    {
      "id": 26533,
      "keyword": "cosechar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9043,
      "keyword": "cosechar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vendimiar": [
    {
      "id": 26533,
      "keyword": "vendimiar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9043,
      "keyword": "vendimiar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ventilar": [
    {
      "id": 9044,
      "keyword": "ventilar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9045,
      "keyword": "ventilar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "covid-19",
        "place",
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "3/4": [
    {
      "id": 9047,
      "keyword": "3/4",
      "keywords": 2,
      "type": 6,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tres cuartos": [
    {
      "id": 9047,
      "keyword": "tres cuartos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rescatar": [
    {
      "id": 9046,
      "keyword": "rescatar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10178,
      "keyword": "rescatar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "socorrer": [
    {
      "id": 9046,
      "keyword": "socorrer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10178,
      "keyword": "socorrer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10141,
      "keyword": "socorrer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cucurucho": [
    {
      "id": 9048,
      "keyword": "cucurucho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9049,
      "keyword": "cucurucho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37911,
      "keyword": "cucurucho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "shape",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cucuruchos": [
    {
      "id": 9048,
      "keyword": "cucurucho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9049,
      "keyword": "cucurucho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37911,
      "keyword": "cucurucho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "shape",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cucurucho de chocolate": [
    {
      "id": 9049,
      "keyword": "cucurucho de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34092,
      "keyword": "cucurucho de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cucuruchos de chocolate": [
    {
      "id": 9049,
      "keyword": "cucurucho de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34092,
      "keyword": "cucurucho de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gambas peladas": [
    {
      "id": 9050,
      "keyword": "gambas peladas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "seafood"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lasagna": [
    {
      "id": 9051,
      "keyword": "lasagna",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lasagnas": [
    {
      "id": 9051,
      "keyword": "lasagna",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lasaña": [
    {
      "id": 9051,
      "keyword": "lasaña",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lasañas": [
    {
      "id": 9051,
      "keyword": "lasaña",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "levadura": [
    {
      "id": 9052,
      "keyword": "levadura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38709,
      "keyword": "levadura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "levaduras": [
    {
      "id": 9052,
      "keyword": "levadura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38709,
      "keyword": "levadura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rabanitos": [
    {
      "id": 9056,
      "keyword": "rabanitos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36583,
      "keyword": "rabanito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarta de manzana": [
    {
      "id": 9057,
      "keyword": "tarta de manzana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tartas de manzana": [
    {
      "id": 9057,
      "keyword": "tarta de manzana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "compra": [
    {
      "id": 9058,
      "keyword": "compra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16017,
      "keyword": "compra",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compras": [
    {
      "id": 9058,
      "keyword": "compra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16017,
      "keyword": "compra",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rebanada de pan": [
    {
      "id": 9059,
      "keyword": "rebanada de pan",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10232,
      "keyword": "rebanada de pan",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rebanadas de pan": [
    {
      "id": 9059,
      "keyword": "rebanada de pan",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10232,
      "keyword": "rebanada de pan",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36586,
      "keyword": "rebanadas de pan",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pudin": [
    {
      "id": 9055,
      "keyword": "pudin",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38498,
      "keyword": "pudin",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "púdines": [
    {
      "id": 9055,
      "keyword": "pudin",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carnero": [
    {
      "id": 9061,
      "keyword": "carnero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carneros": [
    {
      "id": 9061,
      "keyword": "carnero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "miga": [
    {
      "id": 9053,
      "keyword": "miga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recetario": [
    {
      "id": 9060,
      "keyword": "recetario",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recetarios": [
    {
      "id": 9060,
      "keyword": "recetario",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "libro de recetas": [
    {
      "id": 9060,
      "keyword": "libro de recetas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "libros de recetas": [
    {
      "id": 9060,
      "keyword": "libro de recetas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "libro de cocina": [
    {
      "id": 9060,
      "keyword": "libro de cocina",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "libros de cocina": [
    {
      "id": 9060,
      "keyword": "libro de cocina",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colibrí": [
    {
      "id": 9062,
      "keyword": "colibrí",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colibríes": [
    {
      "id": 9062,
      "keyword": "colibrí",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "libélula": [
    {
      "id": 9066,
      "keyword": "libélula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "libélulas": [
    {
      "id": 9066,
      "keyword": "libélula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reno": [
    {
      "id": 9069,
      "keyword": "reno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "renos": [
    {
      "id": 9069,
      "keyword": "reno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "puma": [
    {
      "id": 9068,
      "keyword": "puma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pumas": [
    {
      "id": 9068,
      "keyword": "puma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "leona": [
    {
      "id": 9065,
      "keyword": "leona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leonas": [
    {
      "id": 9065,
      "keyword": "leona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cormorán": [
    {
      "id": 9063,
      "keyword": "cormorán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cormoranes": [
    {
      "id": 9063,
      "keyword": "cormorán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "topo": [
    {
      "id": 9070,
      "keyword": "topo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "topos": [
    {
      "id": 9070,
      "keyword": "topo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recoger un paquete": [
    {
      "id": 9072,
      "keyword": "recoger un paquete",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "banco mundial": [
    {
      "id": 9074,
      "keyword": "Banco Mundial",
      "keywords": 1,
      "type": 1,
      "tags": [
        "international organization",
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cruz roja": [
    {
      "id": 9075,
      "keyword": "Cruz Roja",
      "keywords": 1,
      "type": 1,
      "tags": [
        "international organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30253,
      "keyword": "Cruz Roja",
      "keywords": 1,
      "type": 1,
      "tags": [
        "international organization",
        "work",
        "professional",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acnur": [
    {
      "id": 9073,
      "keyword": "ACNUR",
      "keywords": 1,
      "type": 1,
      "tags": [
        "international organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fmi": [
    {
      "id": 9077,
      "keyword": "FMI",
      "keywords": 1,
      "type": 1,
      "tags": [
        "international organization",
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fao": [
    {
      "id": 9076,
      "keyword": "FAO",
      "keywords": 1,
      "type": 1,
      "tags": [
        "international organization",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oit": [
    {
      "id": 9078,
      "keyword": "OIT",
      "keywords": 1,
      "type": 1,
      "tags": [
        "international organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "naciones unidas": [
    {
      "id": 9079,
      "keyword": "Naciones Unidas",
      "keywords": 2,
      "type": 1,
      "tags": [
        "international organization",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "onu": [
    {
      "id": 9079,
      "keyword": "ONU",
      "keywords": 2,
      "type": 1,
      "tags": [
        "international organization",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pma": [
    {
      "id": 9081,
      "keyword": "PMA",
      "keywords": 1,
      "type": 1,
      "tags": [
        "international organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oms": [
    {
      "id": 9080,
      "keyword": "OMS",
      "keywords": 1,
      "type": 1,
      "tags": [
        "international organization",
        "health"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "unesco": [
    {
      "id": 9082,
      "keyword": "UNESCO",
      "keywords": 1,
      "type": 1,
      "tags": [
        "international organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "unicef": [
    {
      "id": 9083,
      "keyword": "UNICEF",
      "keywords": 1,
      "type": 1,
      "tags": [
        "international organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "olla": [
    {
      "id": 9086,
      "keyword": "olla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ollas": [
    {
      "id": 9086,
      "keyword": "olla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rallador de queso": [
    {
      "id": 9089,
      "keyword": "rallador de queso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ralladores de queso": [
    {
      "id": 9089,
      "keyword": "rallador de queso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rallador": [
    {
      "id": 9089,
      "keyword": "rallador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ralladores": [
    {
      "id": 9089,
      "keyword": "rallador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tabla para cortar": [
    {
      "id": 9090,
      "keyword": "tabla para cortar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tablas para cortar": [
    {
      "id": 9090,
      "keyword": "tabla para cortar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "olla exprés": [
    {
      "id": 9087,
      "keyword": "olla exprés",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ollas exprés": [
    {
      "id": 9087,
      "keyword": "olla exprés",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "picadora": [
    {
      "id": 9084,
      "keyword": "picadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "picadoras": [
    {
      "id": 9084,
      "keyword": "picadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tazón": [
    {
      "id": 9091,
      "keyword": "tazón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tazones": [
    {
      "id": 9091,
      "keyword": "tazón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oficina": [
    {
      "id": 27533,
      "keyword": "oficina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "workplace",
        "work",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9092,
      "keyword": "oficina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36089,
      "keyword": "oficina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "workplace",
        "work",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oficinas": [
    {
      "id": 27533,
      "keyword": "oficina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "workplace",
        "work",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9092,
      "keyword": "oficina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36089,
      "keyword": "oficina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "workplace",
        "work",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "secretaría": [
    {
      "id": 9092,
      "keyword": "secretaría",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secretarías": [
    {
      "id": 9092,
      "keyword": "secretaría",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "beige": [
    {
      "id": 9093,
      "keyword": "beige",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "beiges": [
    {
      "id": 9093,
      "keyword": "beige",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "beis": [
    {
      "id": 9093,
      "keyword": "beis",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "color café": [
    {
      "id": 9094,
      "keyword": "color café",
      "keywords": 2,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tocadiscos": [
    {
      "id": 9085,
      "keyword": "tocadiscos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "music device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ocre": [
    {
      "id": 9097,
      "keyword": "ocre",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ocres": [
    {
      "id": 9097,
      "keyword": "ocre",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "córnea": [
    {
      "id": 9100,
      "keyword": "córnea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "visual system",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "córneas": [
    {
      "id": 9100,
      "keyword": "córnea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "visual system",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cristalino": [
    {
      "id": 9101,
      "keyword": "cristalino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "visual system",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cristalinos": [
    {
      "id": 9101,
      "keyword": "cristalino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "visual system",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esclerótica": [
    {
      "id": 9102,
      "keyword": "esclerótica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "visual system",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escleróticas": [
    {
      "id": 9102,
      "keyword": "esclerótica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "visual system",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "granate": [
    {
      "id": 9095,
      "keyword": "granate",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "granates": [
    {
      "id": 9095,
      "keyword": "granate",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "papiroflexia": [
    {
      "id": 9099,
      "keyword": "papiroflexia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "hobby",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papiroflexias": [
    {
      "id": 9099,
      "keyword": "papiroflexia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "hobby",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "iris": [
    {
      "id": 9103,
      "keyword": "iris",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "visual system",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37585,
      "keyword": "iris",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pupila": [
    {
      "id": 9105,
      "keyword": "pupila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "visual system",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pupilas": [
    {
      "id": 9105,
      "keyword": "pupila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "visual system",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perfil": [
    {
      "id": 9107,
      "keyword": "perfil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9108,
      "keyword": "perfil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36561,
      "keyword": "perfil",
      "keywords": 3,
      "type": 2,
      "tags": [
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perfiles": [
    {
      "id": 9107,
      "keyword": "perfil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9108,
      "keyword": "perfil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "position"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuerpo de perfil": [
    {
      "id": 9108,
      "keyword": "cuerpo de perfil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuerpos de perfil": [
    {
      "id": 9108,
      "keyword": "cuerpo de perfil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "position"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "yoga": [
    {
      "id": 38761,
      "keyword": "yoga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "religion",
        "hinduism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9098,
      "keyword": "yoga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "religion",
        "hinduism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37882,
      "keyword": "yoga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "religion",
        "hinduism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuerpos geométricos": [
    {
      "id": 9109,
      "keyword": "cuerpos geométricos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tetraedro": [
    {
      "id": 9110,
      "keyword": "tetraedro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tetraedros": [
    {
      "id": 9110,
      "keyword": "tetraedro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cilindro": [
    {
      "id": 9111,
      "keyword": "cilindro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cilindros": [
    {
      "id": 9111,
      "keyword": "cilindro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "párpado": [
    {
      "id": 9104,
      "keyword": "párpado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "visual system",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "párpados": [
    {
      "id": 9104,
      "keyword": "párpado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "visual system",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esfera": [
    {
      "id": 9113,
      "keyword": "esfera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esferas": [
    {
      "id": 9113,
      "keyword": "esfera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda": [
    {
      "id": 35695,
      "keyword": "tienda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 35695,
      "keyword": "tienda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9117,
      "keyword": "tienda",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9116,
      "keyword": "tienda",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas": [
    {
      "id": 35695,
      "keyword": "tienda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 35695,
      "keyword": "tienda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9117,
      "keyword": "tienda",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9116,
      "keyword": "tienda",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "negocio": [
    {
      "id": 9117,
      "keyword": "negocio",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9116,
      "keyword": "negocio",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puesto": [
    {
      "id": 38443,
      "keyword": "puesto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9117,
      "keyword": "puesto",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9116,
      "keyword": "puesto",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puestos": [
    {
      "id": 38443,
      "keyword": "puesto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9117,
      "keyword": "puesto",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9116,
      "keyword": "puesto",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comercio": [
    {
      "id": 35695,
      "keyword": "comercio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 35695,
      "keyword": "comercio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9117,
      "keyword": "comercio",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9116,
      "keyword": "comercio",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comercios": [
    {
      "id": 35695,
      "keyword": "comercio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 35695,
      "keyword": "comercio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9117,
      "keyword": "comercio",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9116,
      "keyword": "comercio",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "establecimiento": [
    {
      "id": 9117,
      "keyword": "establecimiento",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9116,
      "keyword": "establecimiento",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "establecimientos": [
    {
      "id": 9117,
      "keyword": "establecimiento",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9116,
      "keyword": "establecimiento",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "retina": [
    {
      "id": 9106,
      "keyword": "retina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "visual system",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "retinas": [
    {
      "id": 9106,
      "keyword": "retina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "visual system",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cizalla": [
    {
      "id": 9118,
      "keyword": "cizalla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cizallas": [
    {
      "id": 9118,
      "keyword": "cizalla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nivel": [
    {
      "id": 9119,
      "keyword": "nivel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niveles": [
    {
      "id": 9119,
      "keyword": "nivel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nivel de burbuja": [
    {
      "id": 9119,
      "keyword": "nivel de burbuja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niveles de burbuja": [
    {
      "id": 9119,
      "keyword": "nivel de burbuja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quitahojas": [
    {
      "id": 9120,
      "keyword": "quitahojas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prisma": [
    {
      "id": 9114,
      "keyword": "prisma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prismas": [
    {
      "id": 9114,
      "keyword": "prisma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silla motorizada": [
    {
      "id": 25471,
      "keyword": "silla motorizada",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9121,
      "keyword": "silla motorizada",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas motorizadas": [
    {
      "id": 25471,
      "keyword": "silla motorizada",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9121,
      "keyword": "silla motorizada",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silla de ruedas eléctrica": [
    {
      "id": 25471,
      "keyword": "silla de ruedas eléctrica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9121,
      "keyword": "silla de ruedas eléctrica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas de ruedas eléctricas": [
    {
      "id": 25471,
      "keyword": "silla de ruedas eléctrica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9121,
      "keyword": "silla de ruedas eléctrica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silla de ruedas con motor": [
    {
      "id": 25471,
      "keyword": "silla de ruedas con motor",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9121,
      "keyword": "silla de ruedas con motor",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas de ruedas con motor": [
    {
      "id": 25471,
      "keyword": "silla de ruedas con motor",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9121,
      "keyword": "silla de ruedas con motor",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silla de ruedas motorizada": [
    {
      "id": 25471,
      "keyword": "silla de ruedas motorizada",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9121,
      "keyword": "silla de ruedas motorizada",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas de ruedas motorizadas": [
    {
      "id": 25471,
      "keyword": "silla de ruedas motorizada",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9121,
      "keyword": "silla de ruedas motorizada",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "corchea": [
    {
      "id": 9126,
      "keyword": "corchea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corcheas": [
    {
      "id": 9126,
      "keyword": "corchea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nota musical": [
    {
      "id": 9127,
      "keyword": "nota musical",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9123,
      "keyword": "nota musical",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "notas musicales": [
    {
      "id": 9127,
      "keyword": "nota musical",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9123,
      "keyword": "nota musical",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clave de fa": [
    {
      "id": 9128,
      "keyword": "clave de fa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "claves de fa": [
    {
      "id": 9128,
      "keyword": "clave de fa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clave de do": [
    {
      "id": 9130,
      "keyword": "clave de do",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "claves de do": [
    {
      "id": 9130,
      "keyword": "clave de do",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clave de sol": [
    {
      "id": 9129,
      "keyword": "clave de sol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "claves de sol": [
    {
      "id": 9129,
      "keyword": "clave de sol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tetris": [
    {
      "id": 9132,
      "keyword": "tetris",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comecocos": [
    {
      "id": 9131,
      "keyword": "comecocos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubo de rubik": [
    {
      "id": 9134,
      "keyword": "cubo de rubik",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubos de rubik": [
    {
      "id": 9134,
      "keyword": "cubo de rubik",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cubilete": [
    {
      "id": 9133,
      "keyword": "cubilete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubiletes": [
    {
      "id": 9133,
      "keyword": "cubilete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fichas": [
    {
      "id": 10310,
      "keyword": "ficha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9135,
      "keyword": "fichas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9136,
      "keyword": "fichas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "gambling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11263,
      "keyword": "ficha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pistola de agua": [
    {
      "id": 9137,
      "keyword": "pistola de agua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pistolas de agua": [
    {
      "id": 9137,
      "keyword": "pistola de agua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cristal": [
    {
      "id": 9140,
      "keyword": "cristal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "work",
        "secondary sector",
        "construction",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cristales": [
    {
      "id": 9140,
      "keyword": "cristal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "work",
        "secondary sector",
        "construction",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vidrio": [
    {
      "id": 9140,
      "keyword": "vidrio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "work",
        "secondary sector",
        "construction",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vidrios": [
    {
      "id": 9140,
      "keyword": "vidrio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "work",
        "secondary sector",
        "construction",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silo": [
    {
      "id": 9138,
      "keyword": "silo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "silos": [
    {
      "id": 9138,
      "keyword": "silo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pergamino": [
    {
      "id": 9141,
      "keyword": "pergamino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pergaminos": [
    {
      "id": 9141,
      "keyword": "pergamino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vid": [
    {
      "id": 9142,
      "keyword": "vid",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "bush",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vides": [
    {
      "id": 9142,
      "keyword": "vid",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "bush",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cepillo eléctrico": [
    {
      "id": 9143,
      "keyword": "cepillo eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26744,
      "keyword": "cepillo eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cepillos eléctricos": [
    {
      "id": 9143,
      "keyword": "cepillo eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26744,
      "keyword": "cepillo eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cepillo de dientes eléctrico": [
    {
      "id": 9143,
      "keyword": "cepillo de dientes eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26744,
      "keyword": "cepillo de dientes eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cepillos de dientes eléctrico": [
    {
      "id": 9143,
      "keyword": "cepillo de dientes eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26744,
      "keyword": "cepillo de dientes eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hilo dental": [
    {
      "id": 9144,
      "keyword": "hilo dental",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hilos dentales": [
    {
      "id": 9144,
      "keyword": "hilo dental",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oficina de turismo": [
    {
      "id": 27527,
      "keyword": "oficina de turismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28347,
      "keyword": "oficina de turismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9139,
      "keyword": "oficina de turismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9897,
      "keyword": "oficina de turismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16037,
      "keyword": "oficina de turismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oficinas de turismo": [
    {
      "id": 27527,
      "keyword": "oficina de turismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28347,
      "keyword": "oficina de turismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9139,
      "keyword": "oficina de turismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9897,
      "keyword": "oficina de turismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16037,
      "keyword": "oficina de turismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "neceser": [
    {
      "id": 9145,
      "keyword": "neceser",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "neceseres": [
    {
      "id": 9145,
      "keyword": "neceser",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guantes de boxeo": [
    {
      "id": 9147,
      "keyword": "guantes de boxeo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34067,
      "keyword": "guante de boxeo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "luchacos": [
    {
      "id": 9148,
      "keyword": "luchacos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dvd": [
    {
      "id": 9152,
      "keyword": "dvd",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dvds": [
    {
      "id": 9152,
      "keyword": "dvd",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "disco duro": [
    {
      "id": 9151,
      "keyword": "disco duro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "discos duros": [
    {
      "id": 9151,
      "keyword": "disco duro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escáner": [
    {
      "id": 31088,
      "keyword": "escáner",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9153,
      "keyword": "escáner",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30705,
      "keyword": "escáner",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escaneres": [
    {
      "id": 9153,
      "keyword": "escáner",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gps": [
    {
      "id": 9154,
      "keyword": "gps",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "movement"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compás": [
    {
      "id": 9146,
      "keyword": "compás",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compases": [
    {
      "id": 9146,
      "keyword": "compás",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cpu": [
    {
      "id": 9150,
      "keyword": "cpu",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torre cpu": [
    {
      "id": 9150,
      "keyword": "torre cpu",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torres cpu": [
    {
      "id": 9150,
      "keyword": "torre cpu",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lector de cd": [
    {
      "id": 9156,
      "keyword": "lector de CD",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lectores de cd": [
    {
      "id": 9156,
      "keyword": "lector de CD",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lector": [
    {
      "id": 9156,
      "keyword": "lector",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lectores": [
    {
      "id": 9156,
      "keyword": "lector",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "microchip": [
    {
      "id": 9158,
      "keyword": "microchip",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "microchips": [
    {
      "id": 9158,
      "keyword": "microchip",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "módem": [
    {
      "id": 9159,
      "keyword": "módem",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "módems": [
    {
      "id": 9159,
      "keyword": "módem",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "portería de rugby": [
    {
      "id": 9149,
      "keyword": "portería de rugby",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porterías de rugby": [
    {
      "id": 9149,
      "keyword": "portería de rugby",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pda": [
    {
      "id": 9161,
      "keyword": "pda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pdas": [
    {
      "id": 9161,
      "keyword": "pda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pantalla táctil": [
    {
      "id": 9160,
      "keyword": "pantalla táctil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30225,
      "keyword": "pantalla táctil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pantallas táctiles": [
    {
      "id": 9160,
      "keyword": "pantalla táctil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30225,
      "keyword": "pantalla táctil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hub": [
    {
      "id": 9155,
      "keyword": "hub",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "punto de acceso": [
    {
      "id": 9163,
      "keyword": "punto de acceso",
      "keywords": 4,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puntos de acceso": [
    {
      "id": 9163,
      "keyword": "punto de acceso",
      "keywords": 4,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "router": [
    {
      "id": 9163,
      "keyword": "router",
      "keywords": 4,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "routers": [
    {
      "id": 9163,
      "keyword": "router",
      "keywords": 4,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "router wi-fi": [
    {
      "id": 9163,
      "keyword": "router wi-fi",
      "keywords": 4,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "routers wi-fi": [
    {
      "id": 9163,
      "keyword": "router wi-fi",
      "keywords": 4,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "wi-fi": [
    {
      "id": 9163,
      "keyword": "wi-fi",
      "keywords": 4,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pdi": [
    {
      "id": 30512,
      "keyword": "PDI",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9162,
      "keyword": "PDI",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pdis": [
    {
      "id": 30512,
      "keyword": "PDI",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9162,
      "keyword": "PDI",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pizarra digital interactiva": [
    {
      "id": 30512,
      "keyword": "Pizarra Digital Interactiva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9162,
      "keyword": "Pizarra Digital Interactiva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pizarras digitales interactivas": [
    {
      "id": 30512,
      "keyword": "Pizarra Digital Interactiva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9162,
      "keyword": "Pizarra Digital Interactiva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tablet pc": [
    {
      "id": 9165,
      "keyword": "tablet pc",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tablets pc": [
    {
      "id": 9165,
      "keyword": "tablet pc",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tablet": [
    {
      "id": 9165,
      "keyword": "tablet",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tablets": [
    {
      "id": 9165,
      "keyword": "tablet",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarjeta gráfica": [
    {
      "id": 9166,
      "keyword": "tarjeta gráfica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarjetas gráficas": [
    {
      "id": 9166,
      "keyword": "tarjeta gráfica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "memoria": [
    {
      "id": 9157,
      "keyword": "memoria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "memorias": [
    {
      "id": 9157,
      "keyword": "memoria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mascarilla": [
    {
      "id": 30737,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30748,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30751,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9169,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "covid-19",
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30738,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30740,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30739,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30749,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30750,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30752,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30753,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30771,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30754,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32202,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36787,
      "keyword": "mascarilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36789,
      "keyword": "mascarilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36791,
      "keyword": "mascarilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36793,
      "keyword": "mascarilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mascarillas": [
    {
      "id": 30737,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30748,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30751,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9169,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "covid-19",
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30738,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30740,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30739,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30749,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30750,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30752,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30753,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30771,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30754,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32202,
      "keyword": "mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36787,
      "keyword": "mascarilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36789,
      "keyword": "mascarilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36791,
      "keyword": "mascarilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36793,
      "keyword": "mascarilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escalpelo": [
    {
      "id": 9168,
      "keyword": "escalpelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escalpelos": [
    {
      "id": 9168,
      "keyword": "escalpelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "switch": [
    {
      "id": 9164,
      "keyword": "switch",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "switches": [
    {
      "id": 9164,
      "keyword": "switch",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "campanario": [
    {
      "id": 9171,
      "keyword": "campanario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campanarios": [
    {
      "id": 9171,
      "keyword": "campanario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "engranaje": [
    {
      "id": 9172,
      "keyword": "engranaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "engranajes": [
    {
      "id": 9172,
      "keyword": "engranaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "formulario": [
    {
      "id": 39176,
      "keyword": "formulario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9173,
      "keyword": "formulario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "formularios": [
    {
      "id": 39176,
      "keyword": "formulario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9173,
      "keyword": "formulario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "webcam": [
    {
      "id": 9167,
      "keyword": "webcam",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "webcams": [
    {
      "id": 9167,
      "keyword": "webcam",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hornillo": [
    {
      "id": 9176,
      "keyword": "hornillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9175,
      "keyword": "hornillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hornillos": [
    {
      "id": 9176,
      "keyword": "hornillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9175,
      "keyword": "hornillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hornillo de gas": [
    {
      "id": 9176,
      "keyword": "hornillo de gas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hornillos de gas": [
    {
      "id": 9176,
      "keyword": "hornillo de gas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jukebox": [
    {
      "id": 9177,
      "keyword": "jukebox",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jukeboxes": [
    {
      "id": 9177,
      "keyword": "jukebox",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gráfica": [
    {
      "id": 9174,
      "keyword": "gráfica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gráficas": [
    {
      "id": 9174,
      "keyword": "gráfica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gráfico": [
    {
      "id": 9174,
      "keyword": "gráfico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gráficos": [
    {
      "id": 9174,
      "keyword": "gráfico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "representación gráfica": [
    {
      "id": 9174,
      "keyword": "representación gráfica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "representaciones gráficas": [
    {
      "id": 9174,
      "keyword": "representación gráfica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vitaminas": [
    {
      "id": 32492,
      "keyword": "vitaminas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36504,
      "keyword": "vitamina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9170,
      "keyword": "vitaminas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "megáfono": [
    {
      "id": 9179,
      "keyword": "megáfono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26921,
      "keyword": "megáfono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "megáfonos": [
    {
      "id": 9179,
      "keyword": "megáfono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26921,
      "keyword": "megáfono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nudo": [
    {
      "id": 9180,
      "keyword": "nudo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nudos": [
    {
      "id": 9180,
      "keyword": "nudo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "óleo": [
    {
      "id": 9181,
      "keyword": "óleo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35137,
      "keyword": "óleo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "óleos": [
    {
      "id": 9181,
      "keyword": "óleo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35137,
      "keyword": "óleos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35137,
      "keyword": "óleo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hornillo eléctrico": [
    {
      "id": 9175,
      "keyword": "hornillo eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hornillos eléctricos": [
    {
      "id": 9175,
      "keyword": "hornillo eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rollo de película": [
    {
      "id": 9183,
      "keyword": "rollo de película",
      "keywords": 3,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rollos de película": [
    {
      "id": 9183,
      "keyword": "rollo de película",
      "keywords": 3,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "película": [
    {
      "id": 34320,
      "keyword": "película",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show",
        "core vocabulary",
        "leisure",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24797,
      "keyword": "película",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show",
        "scenic art",
        "cinema",
        "show",
        "object",
        "appliance",
        "mass media device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34319,
      "keyword": "película",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "scenic art",
        "cinema",
        "show",
        "leisure",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9183,
      "keyword": "película",
      "keywords": 3,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "películas": [
    {
      "id": 34320,
      "keyword": "película",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show",
        "core vocabulary",
        "leisure",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24797,
      "keyword": "película",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show",
        "scenic art",
        "cinema",
        "show",
        "object",
        "appliance",
        "mass media device"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34319,
      "keyword": "película",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "scenic art",
        "cinema",
        "show",
        "leisure",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9183,
      "keyword": "película",
      "keywords": 3,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "film": [
    {
      "id": 24797,
      "keyword": "film",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show",
        "scenic art",
        "cinema",
        "show",
        "object",
        "appliance",
        "mass media device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9183,
      "keyword": "film",
      "keywords": 3,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "films": [
    {
      "id": 24797,
      "keyword": "film",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "tertiary sector",
        "TV show",
        "scenic art",
        "cinema",
        "show",
        "object",
        "appliance",
        "mass media device"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9183,
      "keyword": "film",
      "keywords": 3,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tpv": [
    {
      "id": 9185,
      "keyword": "tpv",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tpvs": [
    {
      "id": 9185,
      "keyword": "tpv",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "terminal punto de venta": [
    {
      "id": 9185,
      "keyword": "Terminal Punto de Venta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terminales punto de venta": [
    {
      "id": 9185,
      "keyword": "Terminal Punto de Venta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ticket": [
    {
      "id": 38374,
      "keyword": "ticket",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "leisure",
        "show",
        "work",
        "tertiary sector",
        "culture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9184,
      "keyword": "ticket",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11255,
      "keyword": "ticket",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "scenic art",
        "cinema",
        "show",
        "theater",
        "event",
        "social event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tickets": [
    {
      "id": 38374,
      "keyword": "ticket",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "leisure",
        "show",
        "work",
        "tertiary sector",
        "culture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9184,
      "keyword": "ticket",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11255,
      "keyword": "ticket",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "scenic art",
        "cinema",
        "show",
        "theater",
        "event",
        "social event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tique": [
    {
      "id": 9184,
      "keyword": "tique",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiques": [
    {
      "id": 9184,
      "keyword": "tique",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lámpara de aceite": [
    {
      "id": 9178,
      "keyword": "lámpara de aceite",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lámparas de aceite": [
    {
      "id": 9178,
      "keyword": "lámpara de aceite",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "candil": [
    {
      "id": 9178,
      "keyword": "candil",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "candiles": [
    {
      "id": 9178,
      "keyword": "candil",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "disco": [
    {
      "id": 9187,
      "keyword": "disco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "discos": [
    {
      "id": 9187,
      "keyword": "disco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "disco de vinilo": [
    {
      "id": 9187,
      "keyword": "disco de vinilo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "discos de vinilo": [
    {
      "id": 9187,
      "keyword": "disco de vinilo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "probeta": [
    {
      "id": 9182,
      "keyword": "probeta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "chemistry",
        "biology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "probetas": [
    {
      "id": 9182,
      "keyword": "probeta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "chemistry",
        "biology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "boxeador": [
    {
      "id": 9188,
      "keyword": "boxeador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boxeadores": [
    {
      "id": 9188,
      "keyword": "boxeador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esquí acuático": [
    {
      "id": 9189,
      "keyword": "esquí acuático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36063,
      "keyword": "esquí acuático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "detective": [
    {
      "id": 9191,
      "keyword": "detective",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38762,
      "keyword": "detective",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "detectives": [
    {
      "id": 9191,
      "keyword": "detective",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38762,
      "keyword": "detective",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "teleoperadora": [
    {
      "id": 38798,
      "keyword": "teleoperadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9192,
      "keyword": "teleoperadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teleoperadoras": [
    {
      "id": 38798,
      "keyword": "teleoperadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9192,
      "keyword": "teleoperadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "operadora": [
    {
      "id": 9192,
      "keyword": "operadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "operadoras": [
    {
      "id": 9192,
      "keyword": "operadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "repartidor": [
    {
      "id": 9194,
      "keyword": "repartidor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "repartidores": [
    {
      "id": 9194,
      "keyword": "repartidor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pinchadiscos": [
    {
      "id": 9193,
      "keyword": "pinchadiscos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dj": [
    {
      "id": 9193,
      "keyword": "DJ",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "djs": [
    {
      "id": 9193,
      "keyword": "DJ",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tubo de ensayo": [
    {
      "id": 9186,
      "keyword": "tubo de ensayo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "chemistry",
        "biology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tubos de ensayo": [
    {
      "id": 9186,
      "keyword": "tubo de ensayo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "chemistry",
        "biology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugador de bádminton": [
    {
      "id": 9190,
      "keyword": "jugador de bádminton",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadores de bádminton": [
    {
      "id": 9190,
      "keyword": "jugador de bádminton",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "energía nuclear": [
    {
      "id": 9199,
      "keyword": "energía nuclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34914,
      "keyword": "energía nuclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caballo de carreras": [
    {
      "id": 9200,
      "keyword": "caballo de carreras",
      "keywords": 3,
      "type": 1,
      "tags": [
        "sport event",
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy",
        "event",
        "olympic games"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caballos de carreras": [
    {
      "id": 9200,
      "keyword": "caballo de carreras",
      "keywords": 3,
      "type": 1,
      "tags": [
        "sport event",
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy",
        "event",
        "olympic games"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "componer": [
    {
      "id": 9201,
      "keyword": "componer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jet": [
    {
      "id": 9205,
      "keyword": "jet",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jets": [
    {
      "id": 9205,
      "keyword": "jet",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reactor": [
    {
      "id": 9205,
      "keyword": "reactor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reactores": [
    {
      "id": 9205,
      "keyword": "reactor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "transbordador": [
    {
      "id": 9206,
      "keyword": "transbordador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "transbordadores": [
    {
      "id": 9206,
      "keyword": "transbordador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prohibido peatones": [
    {
      "id": 9207,
      "keyword": "prohibido peatones",
      "keywords": 2,
      "type": 5,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibido el paso a peatones": [
    {
      "id": 9207,
      "keyword": "prohibido el paso a peatones",
      "keywords": 2,
      "type": 5,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibido bicicletas": [
    {
      "id": 9208,
      "keyword": "prohibido bicicletas",
      "keywords": 2,
      "type": 5,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibido el paso a bicicletas": [
    {
      "id": 9208,
      "keyword": "prohibido el paso a bicicletas",
      "keywords": 2,
      "type": 5,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "decir": [
    {
      "id": 9693,
      "keyword": "decir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9692,
      "keyword": "decir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28663,
      "keyword": "decir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "expresar": [
    {
      "id": 9693,
      "keyword": "expresar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9692,
      "keyword": "expresar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28663,
      "keyword": "expresar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chaquetón": [
    {
      "id": 9197,
      "keyword": "chaquetón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chaquetones": [
    {
      "id": 9197,
      "keyword": "chaquetón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ciclismo": [
    {
      "id": 9698,
      "keyword": "ciclismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9699,
      "keyword": "ciclismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "datos personales": [
    {
      "id": 9702,
      "keyword": "datos personales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30010,
      "keyword": "Datos personales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39175,
      "keyword": "datos personales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "memoria flash": [
    {
      "id": 9800,
      "keyword": "memoria flash",
      "keywords": 5,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "memorias flash": [
    {
      "id": 9800,
      "keyword": "memoria flash",
      "keywords": 5,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pen": [
    {
      "id": 9800,
      "keyword": "pen",
      "keywords": 5,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pens": [
    {
      "id": 9800,
      "keyword": "pen",
      "keywords": 5,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "memoria usb": [
    {
      "id": 9800,
      "keyword": "memoria USB",
      "keywords": 5,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "memorias usb": [
    {
      "id": 9800,
      "keyword": "memoria USB",
      "keywords": 5,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pendrive": [
    {
      "id": 9800,
      "keyword": "pendrive",
      "keywords": 5,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pendrives": [
    {
      "id": 9800,
      "keyword": "pendrive",
      "keywords": 5,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lápiz de memoria": [
    {
      "id": 9800,
      "keyword": "lápiz de memoria",
      "keywords": 5,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lápices de memoria": [
    {
      "id": 9800,
      "keyword": "lápiz de memoria",
      "keywords": 5,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encender la televisión": [
    {
      "id": 9802,
      "keyword": "encender la televisión",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "mass media",
        "mass media device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taller de madera": [
    {
      "id": 9805,
      "keyword": "taller de madera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talleres de madera": [
    {
      "id": 9805,
      "keyword": "taller de madera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taller de textil": [
    {
      "id": 9806,
      "keyword": "taller de textil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9809,
      "keyword": "taller de textil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talleres de textil": [
    {
      "id": 9806,
      "keyword": "taller de textil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9809,
      "keyword": "taller de textil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juguetes": [
    {
      "id": 32568,
      "keyword": "juguetes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "event",
        "popular event",
        "christmas",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32568,
      "keyword": "juguete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "event",
        "popular event",
        "christmas",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9813,
      "keyword": "juguetes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "event",
        "popular event",
        "christmas",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9813,
      "keyword": "juguete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "event",
        "popular event",
        "christmas",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juguete": [
    {
      "id": 32568,
      "keyword": "juguete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "event",
        "popular event",
        "christmas",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9813,
      "keyword": "juguete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "event",
        "popular event",
        "christmas",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lugar": [
    {
      "id": 9819,
      "keyword": "lugar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32598,
      "keyword": "lugar",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lugares": [
    {
      "id": 9819,
      "keyword": "lugar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32598,
      "keyword": "lugares",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sitio": [
    {
      "id": 9819,
      "keyword": "sitio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sitios": [
    {
      "id": 9819,
      "keyword": "sitio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "emplazamiento": [
    {
      "id": 9819,
      "keyword": "emplazamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "emplazamientos": [
    {
      "id": 9819,
      "keyword": "emplazamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32598,
      "keyword": "emplazamientos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciencias de la naturaleza": [
    {
      "id": 32542,
      "keyword": "ciencias de la naturaleza",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "subject",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9820,
      "keyword": "ciencias de la naturaleza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "library science"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35437,
      "keyword": "ciencias de la naturaleza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "libro de ciencias naturales": [
    {
      "id": 9820,
      "keyword": "libro de ciencias naturales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "futuro": [
    {
      "id": 9829,
      "keyword": "futuro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "verb",
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9829,
      "keyword": "futuro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "verb",
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "menear el sonajero": [
    {
      "id": 9012,
      "keyword": "menear el sonajero",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agitar el sonajero ": [
    {
      "id": 9012,
      "keyword": "agitar el sonajero ",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palabra": [
    {
      "id": 9837,
      "keyword": "palabra",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "palabras": [
    {
      "id": 9837,
      "keyword": "palabra",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "pasado": [
    {
      "id": 9839,
      "keyword": "pasado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "verb",
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9839,
      "keyword": "pasado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "verb",
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasados": [
    {
      "id": 9839,
      "keyword": "pasado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "verb",
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "preguntar": [
    {
      "id": 9847,
      "keyword": "preguntar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9840,
      "keyword": "preguntar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9844,
      "keyword": "preguntar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36051,
      "keyword": "preguntar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36159,
      "keyword": "preguntar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9843,
      "keyword": "preguntar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "demandar": [
    {
      "id": 9840,
      "keyword": "demandar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9843,
      "keyword": "demandar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "longitud": [
    {
      "id": 9834,
      "keyword": "longitud",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9833,
      "keyword": "longitud",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11294,
      "keyword": "longitud",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "longitudes": [
    {
      "id": 9834,
      "keyword": "longitud",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9833,
      "keyword": "longitud",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11294,
      "keyword": "longitud",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "medida": [
    {
      "id": 9834,
      "keyword": "medida",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9833,
      "keyword": "medida",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11294,
      "keyword": "medida",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medidas": [
    {
      "id": 9834,
      "keyword": "medida",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9833,
      "keyword": "medida",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11294,
      "keyword": "medida",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿cuánto mide?": [
    {
      "id": 33102,
      "keyword": "¿cuánto mide?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9834,
      "keyword": "¿cuánto mide?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9833,
      "keyword": "¿cuánto mide?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11294,
      "keyword": "¿cuánto mide?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peligro por materias corrosivas": [
    {
      "id": 9198,
      "keyword": "peligro por materias corrosivas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos": [
    {
      "id": 9810,
      "keyword": "juegos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36405,
      "keyword": "juego",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "leisure",
        "game",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juego de mesa": [
    {
      "id": 9810,
      "keyword": "juego de mesa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos de mesa": [
    {
      "id": 9810,
      "keyword": "juego de mesa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32580,
      "keyword": "juegos de mesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciencias sociales": [
    {
      "id": 35402,
      "keyword": "ciencias sociales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35401,
      "keyword": "ciencias sociales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9823,
      "keyword": "ciencias sociales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "libro de ciencias sociales": [
    {
      "id": 9823,
      "keyword": "libro de ciencias sociales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "no tengo la palabra": [
    {
      "id": 9851,
      "keyword": "no tengo la palabra",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presente": [
    {
      "id": 9848,
      "keyword": "presente",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "verb",
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quiénes": [
    {
      "id": 9857,
      "keyword": "quiénes",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13358,
      "keyword": "quiénes",
      "keywords": 4,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿quiénes son?": [
    {
      "id": 9857,
      "keyword": "¿quiénes son?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13358,
      "keyword": "¿quiénes son?",
      "keywords": 4,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desconocidos": [
    {
      "id": 9853,
      "keyword": "desconocido",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9857,
      "keyword": "desconocidos",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quién": [
    {
      "id": 9853,
      "keyword": "quién",
      "keywords": 5,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13358,
      "keyword": "quién",
      "keywords": 4,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9854,
      "keyword": "quién",
      "keywords": 5,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10276,
      "keyword": "quién",
      "keywords": 5,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desconocido": [
    {
      "id": 9853,
      "keyword": "desconocido",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿quién es?": [
    {
      "id": 9853,
      "keyword": "¿quién es?",
      "keywords": 5,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9854,
      "keyword": "¿quién es?",
      "keywords": 5,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10276,
      "keyword": "¿quién es?",
      "keywords": 5,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿quién es él?": [
    {
      "id": 9853,
      "keyword": "¿quién es él?",
      "keywords": 5,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10276,
      "keyword": "¿quién es él?",
      "keywords": 5,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿quién?": [
    {
      "id": 9853,
      "keyword": "¿quién?",
      "keywords": 5,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13358,
      "keyword": "¿quién?",
      "keywords": 4,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9854,
      "keyword": "¿quién?",
      "keywords": 5,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10276,
      "keyword": "¿quién?",
      "keywords": 5,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿quién es ella?": [
    {
      "id": 9854,
      "keyword": "¿quién es ella?",
      "keywords": 5,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10276,
      "keyword": "¿quién es ella?",
      "keywords": 5,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desconocida": [
    {
      "id": 9854,
      "keyword": "desconocida",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desconocidas": [
    {
      "id": 9854,
      "keyword": "desconocida",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "congresista": [
    {
      "id": 9859,
      "keyword": "congresista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34457,
      "keyword": "congresista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "congresistas": [
    {
      "id": 9859,
      "keyword": "congresista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34457,
      "keyword": "congresista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conferenciante": [
    {
      "id": 9868,
      "keyword": "conferenciante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34471,
      "keyword": "conferenciante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conferenciantes": [
    {
      "id": 9868,
      "keyword": "conferenciante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34471,
      "keyword": "conferenciante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "precio": [
    {
      "id": 9874,
      "keyword": "precio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "precios": [
    {
      "id": 9874,
      "keyword": "precio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fotocopia": [
    {
      "id": 9876,
      "keyword": "fotocopia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fotocopias": [
    {
      "id": 9876,
      "keyword": "fotocopia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barcelona": [
    {
      "id": 9858,
      "keyword": "Barcelona",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "province"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14832,
      "keyword": "Barcelona",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clic": [
    {
      "id": 9860,
      "keyword": "clic",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9872,
      "keyword": "clic",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clics": [
    {
      "id": 9860,
      "keyword": "clic",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9872,
      "keyword": "clic",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clic de ratón": [
    {
      "id": 9860,
      "keyword": "clic de ratón",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9872,
      "keyword": "clic de ratón",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clics de ratón": [
    {
      "id": 9860,
      "keyword": "clic de ratón",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9872,
      "keyword": "clic de ratón",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clicar": [
    {
      "id": 9860,
      "keyword": "clicar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9872,
      "keyword": "clicar",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer clic": [
    {
      "id": 9860,
      "keyword": "hacer clic",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9872,
      "keyword": "hacer clic",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cliquear": [
    {
      "id": 9860,
      "keyword": "cliquear",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9872,
      "keyword": "cliquear",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de ayudas técnicas": [
    {
      "id": 9862,
      "keyword": "tienda de ayudas técnicas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de ayudas técnicas": [
    {
      "id": 9862,
      "keyword": "tienda de ayudas técnicas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "partes": [
    {
      "id": 9877,
      "keyword": "partes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exposición": [
    {
      "id": 21859,
      "keyword": "exposición",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24803,
      "keyword": "exposición",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "sculpture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9870,
      "keyword": "exposición",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exposiciones": [
    {
      "id": 21859,
      "keyword": "exposición",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24803,
      "keyword": "exposición",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "sculpture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9870,
      "keyword": "exposición",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "presentar": [
    {
      "id": 16823,
      "keyword": "presentar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11308,
      "keyword": "presentar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31902,
      "keyword": "presentar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39430,
      "keyword": "presentar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9870,
      "keyword": "presentar",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exponer": [
    {
      "id": 9870,
      "keyword": "exponer",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comunicación": [
    {
      "id": 34623,
      "keyword": "comunicación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "person",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9870,
      "keyword": "comunicación",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comunicaciones": [
    {
      "id": 34623,
      "keyword": "comunicación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "person",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9870,
      "keyword": "comunicación",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "presentación": [
    {
      "id": 9870,
      "keyword": "presentación",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presentaciones": [
    {
      "id": 9870,
      "keyword": "presentación",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pasar página": [
    {
      "id": 9889,
      "keyword": "pasar página",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "horizontal": [
    {
      "id": 9891,
      "keyword": "horizontal",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "horizontales": [
    {
      "id": 9891,
      "keyword": "horizontal",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gato negro": [
    {
      "id": 9881,
      "keyword": "gato negro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "halloween",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9879,
      "keyword": "gato negro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gatos negros": [
    {
      "id": 9881,
      "keyword": "gato negro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "halloween",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9879,
      "keyword": "gato negro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gata negra": [
    {
      "id": 9881,
      "keyword": "gata negra",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "halloween",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9879,
      "keyword": "gata negra",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gatas negras": [
    {
      "id": 9881,
      "keyword": "gata negra",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "halloween",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9879,
      "keyword": "gata negra",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vertical": [
    {
      "id": 9892,
      "keyword": "vertical",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "verticales": [
    {
      "id": 9892,
      "keyword": "vertical",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hotel": [
    {
      "id": 15730,
      "keyword": "hotel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15728,
      "keyword": "hotel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28345,
      "keyword": "hotel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9895,
      "keyword": "hotel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hoteles": [
    {
      "id": 15730,
      "keyword": "hotel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15728,
      "keyword": "hotel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28345,
      "keyword": "hotel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9895,
      "keyword": "hotel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "información": [
    {
      "id": 9899,
      "keyword": "información",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27527,
      "keyword": "información",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28347,
      "keyword": "información",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9897,
      "keyword": "información",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16037,
      "keyword": "información",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "informaciones": [
    {
      "id": 27527,
      "keyword": "información",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28347,
      "keyword": "información",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9897,
      "keyword": "información",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16037,
      "keyword": "información",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inscribir": [
    {
      "id": 9902,
      "keyword": "inscribir",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9901,
      "keyword": "inscribir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inscribirse": [
    {
      "id": 9902,
      "keyword": "inscribirse",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9901,
      "keyword": "inscribirse",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inscripción": [
    {
      "id": 9902,
      "keyword": "inscripción",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9901,
      "keyword": "inscripción",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inscripciones": [
    {
      "id": 9902,
      "keyword": "inscripción",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9901,
      "keyword": "inscripción",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "check-in": [
    {
      "id": 9902,
      "keyword": "check-in",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clic derecho": [
    {
      "id": 9872,
      "keyword": "clic derecho",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clics derechos": [
    {
      "id": 9872,
      "keyword": "clic derecho",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "feliz": [
    {
      "id": 32123,
      "keyword": "feliz",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9907,
      "keyword": "feliz",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "felices": [
    {
      "id": 32123,
      "keyword": "feliz",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9907,
      "keyword": "feliz",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salón de actos": [
    {
      "id": 9913,
      "keyword": "salón de actos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "room",
        "scenic art",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27495,
      "keyword": "salón de actos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salones de actos": [
    {
      "id": 9913,
      "keyword": "salón de actos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "room",
        "scenic art",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27495,
      "keyword": "salón de actos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de reuniones": [
    {
      "id": 24625,
      "keyword": "sala de reuniones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35955,
      "keyword": "sala de reuniones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36955,
      "keyword": "sala de reuniones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39230,
      "keyword": "sala de reuniones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32232,
      "keyword": "sala de reuniones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38873,
      "keyword": "sala de reuniones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9911,
      "keyword": "sala de reuniones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de reuniones": [
    {
      "id": 24625,
      "keyword": "sala de reuniones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35955,
      "keyword": "sala de reuniones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36955,
      "keyword": "sala de reuniones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32232,
      "keyword": "sala de reuniones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38873,
      "keyword": "sala de reuniones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9911,
      "keyword": "sala de reuniones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de profesores": [
    {
      "id": 34788,
      "keyword": "sala de profesores",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9911,
      "keyword": "sala de profesores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de profesores": [
    {
      "id": 34788,
      "keyword": "sala de profesores",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9911,
      "keyword": "sala de profesores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de ordenadores": [
    {
      "id": 9915,
      "keyword": "sala de ordenadores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de ordenadores": [
    {
      "id": 9915,
      "keyword": "sala de ordenadores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aula de informática": [
    {
      "id": 9915,
      "keyword": "aula de informática",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aulas de informática": [
    {
      "id": 9915,
      "keyword": "aula de informática",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enfermería": [
    {
      "id": 9918,
      "keyword": "enfermería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37311,
      "keyword": "enfermería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37341,
      "keyword": "enfermería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37400,
      "keyword": "enfermería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38878,
      "keyword": "enfermería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfermerías": [
    {
      "id": 9918,
      "keyword": "enfermería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37311,
      "keyword": "enfermería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37341,
      "keyword": "enfermería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37400,
      "keyword": "enfermería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38878,
      "keyword": "enfermería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hija": [
    {
      "id": 9885,
      "keyword": "hija",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10340,
      "keyword": "hija",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36977,
      "keyword": "hija",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hijas": [
    {
      "id": 9885,
      "keyword": "hija",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10340,
      "keyword": "hija",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36977,
      "keyword": "hija",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "etiqueta": [
    {
      "id": 9920,
      "keyword": "etiqueta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9925,
      "keyword": "etiqueta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 9919,
      "keyword": "etiqueta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27749,
      "keyword": "etiqueta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "etiquetas": [
    {
      "id": 9920,
      "keyword": "etiqueta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9925,
      "keyword": "etiqueta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 9919,
      "keyword": "etiqueta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27749,
      "keyword": "etiqueta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "talla": [
    {
      "id": 9923,
      "keyword": "talla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tallas": [
    {
      "id": 9923,
      "keyword": "talla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "talle": [
    {
      "id": 9923,
      "keyword": "talle",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talles": [
    {
      "id": 9923,
      "keyword": "talle",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lupa": [
    {
      "id": 9927,
      "keyword": "lupa",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "lupas": [
    {
      "id": 9927,
      "keyword": "lupa",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "hijo": [
    {
      "id": 9887,
      "keyword": "hijo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10341,
      "keyword": "hijo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36927,
      "keyword": "hijo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hijos": [
    {
      "id": 9887,
      "keyword": "hijo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10341,
      "keyword": "hijo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abrir las manos": [
    {
      "id": 10137,
      "keyword": "abrir las manos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar el calzoncillo": [
    {
      "id": 10142,
      "keyword": "bajar el calzoncillo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar la tapa": [
    {
      "id": 10144,
      "keyword": "bajar la tapa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cepillar al perro": [
    {
      "id": 10145,
      "keyword": "cepillar al perro",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "pet",
        "animal-assisted therapy",
        "dog-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar el pantalón": [
    {
      "id": 37817,
      "keyword": "bajar el pantalón",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10143,
      "keyword": "bajar el pantalón",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28219,
      "keyword": "bajar el pantalón",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asar": [
    {
      "id": 35441,
      "keyword": "asar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "animal-based food",
        "meat",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10140,
      "keyword": "asar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "animal-based food",
        "meat",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11184,
      "keyword": "asar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "animal-based food",
        "meat",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortar el pan": [
    {
      "id": 10150,
      "keyword": "cortar el pan",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10149,
      "keyword": "cortar el pan",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coger el papel": [
    {
      "id": 10147,
      "keyword": "coger el papel",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomar el papel": [
    {
      "id": 10147,
      "keyword": "tomar el papel",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortar el césped": [
    {
      "id": 26000,
      "keyword": "cortar el césped",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10151,
      "keyword": "cortar el césped",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "segar": [
    {
      "id": 26000,
      "keyword": "segar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37694,
      "keyword": "segar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38073,
      "keyword": "segar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10151,
      "keyword": "segar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortarse las uñas": [
    {
      "id": 10152,
      "keyword": "cortarse las uñas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortar las uñas": [
    {
      "id": 10153,
      "keyword": "cortar las uñas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38473,
      "keyword": "cortar las uñas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10152,
      "keyword": "cortar las uñas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dar paso": [
    {
      "id": 10154,
      "keyword": "dar paso",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vencer": [
    {
      "id": 10155,
      "keyword": "vencer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36541,
      "keyword": "vencer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agrupar": [
    {
      "id": 10139,
      "keyword": "agrupar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerrar los ojos": [
    {
      "id": 10146,
      "keyword": "cerrar los ojos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "visual system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer ejercicio": [
    {
      "id": 30606,
      "keyword": "hacer ejercicio",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10156,
      "keyword": "hacer ejercicio",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13040,
      "keyword": "hacer ejercicio",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "golf": [
    {
      "id": 38548,
      "keyword": "golf",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10160,
      "keyword": "golf",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35247,
      "keyword": "golf",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugar al golf": [
    {
      "id": 38548,
      "keyword": "jugar al golf",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10160,
      "keyword": "jugar al golf",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35247,
      "keyword": "jugar al golf",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hockey": [
    {
      "id": 39185,
      "keyword": "hockey",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10161,
      "keyword": "hockey",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27105,
      "keyword": "hockey",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27106,
      "keyword": "hockey",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35260,
      "keyword": "hockey",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35259,
      "keyword": "hockey",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hockey hierba": [
    {
      "id": 39185,
      "keyword": "hockey hierba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10161,
      "keyword": "hockey hierba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27105,
      "keyword": "hockey hierba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35260,
      "keyword": "hockey hierba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35259,
      "keyword": "hockey hierba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balonmano": [
    {
      "id": 10159,
      "keyword": "balonmano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugar a la videoconsola": [
    {
      "id": 10162,
      "keyword": "jugar a la videoconsola",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrir los ojos": [
    {
      "id": 10138,
      "keyword": "abrir los ojos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "visual system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baloncesto": [
    {
      "id": 10166,
      "keyword": "baloncesto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "magia": [
    {
      "id": 10157,
      "keyword": "magia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "scenic art",
        "visual art",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tenis": [
    {
      "id": 10158,
      "keyword": "tenis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35264,
      "keyword": "tenis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35263,
      "keyword": "tenis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "béisbol": [
    {
      "id": 10165,
      "keyword": "béisbol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "levantar la tapa": [
    {
      "id": 10168,
      "keyword": "levantar la tapa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "voleibol": [
    {
      "id": 10167,
      "keyword": "voleibol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balonvolea": [
    {
      "id": 10167,
      "keyword": "balonvolea",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limar las uñas": [
    {
      "id": 10169,
      "keyword": "limar las uñas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36553,
      "keyword": "limar las uñas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiar el culo": [
    {
      "id": 37402,
      "keyword": "limpiar el culo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10170,
      "keyword": "limpiar el culo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27869,
      "keyword": "limpiar el culo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29750,
      "keyword": "limpiar el culo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llamar al timbre": [
    {
      "id": 10171,
      "keyword": "llamar al timbre",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "regañar": [
    {
      "id": 31188,
      "keyword": "regañar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10175,
      "keyword": "regañar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39036,
      "keyword": "regañar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39038,
      "keyword": "regañar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39041,
      "keyword": "regañar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reprender": [
    {
      "id": 31188,
      "keyword": "reprender",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10175,
      "keyword": "reprender",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39036,
      "keyword": "reprender",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39038,
      "keyword": "reprender",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39041,
      "keyword": "reprender",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugar a los bolos": [
    {
      "id": 39438,
      "keyword": "jugar a los bolos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28295,
      "keyword": "jugar a los bolos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39439,
      "keyword": "jugar a los bolos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10163,
      "keyword": "jugar a los bolos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35245,
      "keyword": "jugar a los bolos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "multar": [
    {
      "id": 10172,
      "keyword": "multar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10173,
      "keyword": "multar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38773,
      "keyword": "multar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38774,
      "keyword": "multar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "multa": [
    {
      "id": 10173,
      "keyword": "multa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "multas": [
    {
      "id": 10173,
      "keyword": "multa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sentar en el váter": [
    {
      "id": 16889,
      "keyword": "sentar en el váter",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10177,
      "keyword": "sentar en el váter",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38919,
      "keyword": "sentar en el váter",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir el pantalón": [
    {
      "id": 37816,
      "keyword": "subir el pantalón",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10180,
      "keyword": "subir el pantalón",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31666,
      "keyword": "subir el pantalón",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ping-pong": [
    {
      "id": 10164,
      "keyword": "ping-pong",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35251,
      "keyword": "ping-pong",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35252,
      "keyword": "ping-pong",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rayar": [
    {
      "id": 10174,
      "keyword": "rayar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25377,
      "keyword": "rayar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trocear": [
    {
      "id": 10185,
      "keyword": "trocear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tirar de la cadena": [
    {
      "id": 36601,
      "keyword": "tirar de la cadena",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38602,
      "keyword": "tirar de la cadena",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10184,
      "keyword": "tirar de la cadena",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viajaren coche": [
    {
      "id": 10186,
      "keyword": "viajaren coche",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "route"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recorrer en coche": [
    {
      "id": 10186,
      "keyword": "recorrer en coche",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "route"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viajar en avión": [
    {
      "id": 10188,
      "keyword": "viajar en avión",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "route"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recorrer en avión ": [
    {
      "id": 10188,
      "keyword": "recorrer en avión ",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "route"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viajar en tren": [
    {
      "id": 10187,
      "keyword": "viajar en tren",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "route"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recorrer en tren": [
    {
      "id": 10187,
      "keyword": "recorrer en tren",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "route"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "volar en ala delta": [
    {
      "id": 10190,
      "keyword": "volar en ala delta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ala delta": [
    {
      "id": 10190,
      "keyword": "ala delta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alas delta": [
    {
      "id": 10190,
      "keyword": "ala delta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tirar el papel al váter": [
    {
      "id": 10183,
      "keyword": "tirar el papel al váter",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alta": [
    {
      "id": 25782,
      "keyword": "alta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10193,
      "keyword": "alta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "altas": [
    {
      "id": 25782,
      "keyword": "alta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10193,
      "keyword": "alta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "baja": [
    {
      "id": 25839,
      "keyword": "baja",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10196,
      "keyword": "baja",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajas": [
    {
      "id": 25839,
      "keyword": "baja",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10196,
      "keyword": "baja",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "viajar en barco": [
    {
      "id": 10189,
      "keyword": "viajar en barco",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "route"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recorrer en barco": [
    {
      "id": 10189,
      "keyword": "recorrer en barco",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "route"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buena": [
    {
      "id": 13630,
      "keyword": "buena",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32432,
      "keyword": "buena",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10197,
      "keyword": "buena",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buenas": [
    {
      "id": 13630,
      "keyword": "buena",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32432,
      "keyword": "buena",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10197,
      "keyword": "buena",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ciego": [
    {
      "id": 37790,
      "keyword": "ciego",
      "keywords": 3,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10198,
      "keyword": "ciego",
      "keywords": 2,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11615,
      "keyword": "ciego",
      "keywords": 3,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciegos": [
    {
      "id": 37790,
      "keyword": "ciego",
      "keywords": 3,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10198,
      "keyword": "ciego",
      "keywords": 2,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11615,
      "keyword": "ciego",
      "keywords": 3,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "subir el calzoncillo": [
    {
      "id": 10181,
      "keyword": "subir el calzoncillo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soplar las velas": [
    {
      "id": 16895,
      "keyword": "soplar las velas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10179,
      "keyword": "soplar las velas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34506,
      "keyword": "soplar las velas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tatuar": [
    {
      "id": 10182,
      "keyword": "tatuar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "famosa": [
    {
      "id": 37802,
      "keyword": "famosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "character",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10202,
      "keyword": "famosa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "character",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "famosas": [
    {
      "id": 37802,
      "keyword": "famosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "character",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10202,
      "keyword": "famosa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "character",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "famoso": [
    {
      "id": 37802,
      "keyword": "famoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "character",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10203,
      "keyword": "famoso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "character",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "famosos": [
    {
      "id": 37802,
      "keyword": "famoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "character",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10203,
      "keyword": "famoso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "character",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gorda": [
    {
      "id": 25133,
      "keyword": "gorda",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10205,
      "keyword": "gorda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gordas": [
    {
      "id": 25133,
      "keyword": "gorda",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10205,
      "keyword": "gorda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "obesa": [
    {
      "id": 25133,
      "keyword": "obesa",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10205,
      "keyword": "obesa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obesas": [
    {
      "id": 25133,
      "keyword": "obesa",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10205,
      "keyword": "obesa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "muchacha": [
    {
      "id": 10206,
      "keyword": "muchacha",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 10206,
      "keyword": "muchacha",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39065,
      "keyword": "muchacha",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muchachas": [
    {
      "id": 10206,
      "keyword": "muchacha",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 10206,
      "keyword": "muchacha",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39065,
      "keyword": "muchacha",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "teenager"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acompañado": [
    {
      "id": 10191,
      "keyword": "acompañado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acompañados": [
    {
      "id": 10191,
      "keyword": "acompañado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "compañia": [
    {
      "id": 10191,
      "keyword": "compañia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compañias": [
    {
      "id": 10191,
      "keyword": "compañia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rica": [
    {
      "id": 37803,
      "keyword": "rica",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32340,
      "keyword": "rica",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10211,
      "keyword": "rica",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ricas": [
    {
      "id": 37803,
      "keyword": "rica",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32340,
      "keyword": "rica",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10211,
      "keyword": "rica",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "millonaria": [
    {
      "id": 37803,
      "keyword": "millonaria",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10211,
      "keyword": "millonaria",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "millonarias": [
    {
      "id": 37803,
      "keyword": "millonaria",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10211,
      "keyword": "millonaria",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acaudalada": [
    {
      "id": 37803,
      "keyword": "acaudalada",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10211,
      "keyword": "acaudalada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acaudaladas": [
    {
      "id": 37803,
      "keyword": "acaudalada",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10211,
      "keyword": "acaudalada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adinerada": [
    {
      "id": 37803,
      "keyword": "adinerada",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10211,
      "keyword": "adinerada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adineradas": [
    {
      "id": 37803,
      "keyword": "adinerada",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10211,
      "keyword": "adinerada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sola": [
    {
      "id": 39247,
      "keyword": "sola",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25776,
      "keyword": "sola",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10213,
      "keyword": "sola",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "solas": [
    {
      "id": 25776,
      "keyword": "sola",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10213,
      "keyword": "sola",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "primera": [
    {
      "id": 32129,
      "keyword": "primera",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37753,
      "keyword": "primera",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27993,
      "keyword": "primera",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10210,
      "keyword": "primera",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27990,
      "keyword": "primera",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "primeras": [
    {
      "id": 32129,
      "keyword": "primera",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37753,
      "keyword": "primera",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27993,
      "keyword": "primera",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10210,
      "keyword": "primera",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27990,
      "keyword": "primera",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sorda": [
    {
      "id": 37795,
      "keyword": "sorda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10214,
      "keyword": "sorda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10215,
      "keyword": "sorda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sordas": [
    {
      "id": 37795,
      "keyword": "sorda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10214,
      "keyword": "sorda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10215,
      "keyword": "sorda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "miedoso": [
    {
      "id": 10208,
      "keyword": "miedoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "miedosos": [
    {
      "id": 10208,
      "keyword": "miedoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "temeroso": [
    {
      "id": 10208,
      "keyword": "temeroso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "temerosos": [
    {
      "id": 10208,
      "keyword": "temeroso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maligna": [
    {
      "id": 10207,
      "keyword": "maligna",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "malignas": [
    {
      "id": 10207,
      "keyword": "maligna",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "burrito": [
    {
      "id": 10219,
      "keyword": "burrito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "burritos": [
    {
      "id": 10219,
      "keyword": "burrito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "champiñón": [
    {
      "id": 10220,
      "keyword": "champiñón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "fungus",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mendiga": [
    {
      "id": 10209,
      "keyword": "mendiga",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mendigas": [
    {
      "id": 10209,
      "keyword": "mendiga",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caviar": [
    {
      "id": 10222,
      "keyword": "caviar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caviares": [
    {
      "id": 10222,
      "keyword": "caviar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "canapé": [
    {
      "id": 10221,
      "keyword": "canapé",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canapés": [
    {
      "id": 10221,
      "keyword": "canapé",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tapa": [
    {
      "id": 37940,
      "keyword": "tapa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10221,
      "keyword": "tapa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27395,
      "keyword": "tapa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29185,
      "keyword": "tapa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29187,
      "keyword": "tapa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30401,
      "keyword": "tapa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30409,
      "keyword": "tapa",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tapas": [
    {
      "id": 37940,
      "keyword": "tapa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10221,
      "keyword": "tapa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27395,
      "keyword": "tapa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29185,
      "keyword": "tapa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29187,
      "keyword": "tapa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30401,
      "keyword": "tapa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30409,
      "keyword": "tapa",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "última": [
    {
      "id": 37751,
      "keyword": "última",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10216,
      "keyword": "última",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "últimas": [
    {
      "id": 37751,
      "keyword": "última",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10216,
      "keyword": "última",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vaga": [
    {
      "id": 37830,
      "keyword": "vaga",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10217,
      "keyword": "vaga",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vagas": [
    {
      "id": 37830,
      "keyword": "vaga",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10217,
      "keyword": "vaga",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perezosa": [
    {
      "id": 37830,
      "keyword": "perezosa",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10217,
      "keyword": "perezosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22039,
      "keyword": "perezosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perezosas": [
    {
      "id": 37830,
      "keyword": "perezosa",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10217,
      "keyword": "perezosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22039,
      "keyword": "perezosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coco": [
    {
      "id": 10224,
      "keyword": "coco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cocos": [
    {
      "id": 10224,
      "keyword": "coco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hamburguesa y patatas fritas": [
    {
      "id": 10227,
      "keyword": "hamburguesa y patatas fritas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hamburguesas y patatas fritas": [
    {
      "id": 10227,
      "keyword": "hamburguesa y patatas fritas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hhamburguesa y papas fritas": [
    {
      "id": 10227,
      "keyword": "hhamburguesa y papas fritas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hhamburguesas y papas fritas": [
    {
      "id": 10227,
      "keyword": "hhamburguesa y papas fritas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fondue": [
    {
      "id": 10226,
      "keyword": "fondue",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fondues": [
    {
      "id": 10226,
      "keyword": "fondue",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "queso fundido": [
    {
      "id": 10226,
      "keyword": "queso fundido",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "delgada": [
    {
      "id": 25048,
      "keyword": "delgada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary",
        "mathematics",
        "basic concepts",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38589,
      "keyword": "delgada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37064,
      "keyword": "delgada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10200,
      "keyword": "delgada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "delgadas": [
    {
      "id": 25048,
      "keyword": "delgada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary",
        "mathematics",
        "basic concepts",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38589,
      "keyword": "delgada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37064,
      "keyword": "delgada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "object"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10200,
      "keyword": "delgada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "flaca": [
    {
      "id": 25048,
      "keyword": "flaca",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary",
        "mathematics",
        "basic concepts",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38589,
      "keyword": "flaca",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10200,
      "keyword": "flaca",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flacas": [
    {
      "id": 25048,
      "keyword": "flaca",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary",
        "mathematics",
        "basic concepts",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38589,
      "keyword": "flaca",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10200,
      "keyword": "flaca",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "banana": [
    {
      "id": 10218,
      "keyword": "banana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bananas": [
    {
      "id": 10218,
      "keyword": "banana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "leche y galletas": [
    {
      "id": 10228,
      "keyword": "leche y galletas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "melocotón en almíbar": [
    {
      "id": 10229,
      "keyword": "melocotón en almíbar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "melocotones en almíbar": [
    {
      "id": 10229,
      "keyword": "melocotón en almíbar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "durazno en almíbar": [
    {
      "id": 10229,
      "keyword": "durazno en almíbar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "duraznos en almíbar": [
    {
      "id": 10229,
      "keyword": "durazno en almíbar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sangría": [
    {
      "id": 10233,
      "keyword": "sangría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sangrías": [
    {
      "id": 10233,
      "keyword": "sangría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "picadita": [
    {
      "id": 10225,
      "keyword": "picadita",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30409,
      "keyword": "picadita",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "picaditas": [
    {
      "id": 10225,
      "keyword": "picadita",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30409,
      "keyword": "picadita",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tetrabrik": [
    {
      "id": 10237,
      "keyword": "tetrabrik",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tetrabriks": [
    {
      "id": 10237,
      "keyword": "tetrabrik",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "medio limón": [
    {
      "id": 10235,
      "keyword": "medio limón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medios limones": [
    {
      "id": 10235,
      "keyword": "medio limón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "buey": [
    {
      "id": 10238,
      "keyword": "buey",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "christmas",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bueyes": [
    {
      "id": 10238,
      "keyword": "buey",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "christmas",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cabestro": [
    {
      "id": 10238,
      "keyword": "cabestro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "christmas",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cabestros": [
    {
      "id": 10238,
      "keyword": "cabestro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "event",
        "popular event",
        "christmas",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "panecillo": [
    {
      "id": 10231,
      "keyword": "panecillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panecillos": [
    {
      "id": 10231,
      "keyword": "panecillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cardumen": [
    {
      "id": 10242,
      "keyword": "cardumen",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "group",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cardúmenes": [
    {
      "id": 10242,
      "keyword": "cardumen",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "group",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "banco de peces": [
    {
      "id": 10242,
      "keyword": "banco de peces",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "group",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bancos de peces": [
    {
      "id": 10242,
      "keyword": "banco de peces",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "group",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "picnic": [
    {
      "id": 10236,
      "keyword": "picnic",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28361,
      "keyword": "picnic",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enjambre": [
    {
      "id": 10244,
      "keyword": "enjambre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enjambres": [
    {
      "id": 10244,
      "keyword": "enjambre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manada": [
    {
      "id": 10246,
      "keyword": "manada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manadas": [
    {
      "id": 10246,
      "keyword": "manada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jauría": [
    {
      "id": 10245,
      "keyword": "jauría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jaurías": [
    {
      "id": 10245,
      "keyword": "jauría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rebaño": [
    {
      "id": 10249,
      "keyword": "rebaño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming",
        "animal",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rebaños": [
    {
      "id": 10249,
      "keyword": "rebaño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming",
        "animal",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mapache": [
    {
      "id": 10239,
      "keyword": "mapache",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mapaches": [
    {
      "id": 10239,
      "keyword": "mapache",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hungría": [
    {
      "id": 10251,
      "keyword": "Hungría",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29576,
      "keyword": "Hungría",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "noruega": [
    {
      "id": 10252,
      "keyword": "Noruega",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28982,
      "keyword": "Noruega",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pingüino emperador": [
    {
      "id": 10240,
      "keyword": "pingüino emperador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pingüinos emperadores": [
    {
      "id": 10240,
      "keyword": "pingüino emperador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pingüina emperador": [
    {
      "id": 10240,
      "keyword": "pingüina emperador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pingüinas emperadores": [
    {
      "id": 10240,
      "keyword": "pingüina emperador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "suecia": [
    {
      "id": 10253,
      "keyword": "Suecia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28977,
      "keyword": "Suecia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bandada": [
    {
      "id": 10243,
      "keyword": "bandada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bandadas": [
    {
      "id": 10243,
      "keyword": "bandada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "canalón": [
    {
      "id": 10254,
      "keyword": "canalón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canalones": [
    {
      "id": 10254,
      "keyword": "canalón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mango": [
    {
      "id": 10256,
      "keyword": "mango",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16813,
      "keyword": "mango",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mangos": [
    {
      "id": 10256,
      "keyword": "mango",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16813,
      "keyword": "mango",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "piara": [
    {
      "id": 10248,
      "keyword": "piara",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "group",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piaras": [
    {
      "id": 10248,
      "keyword": "piara",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "group",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "archivador": [
    {
      "id": 10255,
      "keyword": "archivador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11182,
      "keyword": "archivador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "archivadores": [
    {
      "id": 10255,
      "keyword": "archivador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11182,
      "keyword": "archivador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "seres vivos": [
    {
      "id": 10250,
      "keyword": "seres vivos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "categorization",
        "person",
        "animal",
        "plant",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11375,
      "keyword": "seres vivos",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32572,
      "keyword": "seres vivos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ser vivo": [
    {
      "id": 10250,
      "keyword": "ser vivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "categorization",
        "person",
        "animal",
        "plant",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11375,
      "keyword": "ser vivo",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32572,
      "keyword": "ser vivo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sopera": [
    {
      "id": 10257,
      "keyword": "sopera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soperas": [
    {
      "id": 10257,
      "keyword": "sopera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clase de matemáticas": [
    {
      "id": 32554,
      "keyword": "clase de matemáticas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36373,
      "keyword": "clase de matemáticas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10260,
      "keyword": "clase de matemáticas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "matemáticas": [
    {
      "id": 32554,
      "keyword": "matemáticas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36373,
      "keyword": "matemáticas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10260,
      "keyword": "matemáticas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolor de muela": [
    {
      "id": 10263,
      "keyword": "dolor de muela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28757,
      "keyword": "dolor de muela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28758,
      "keyword": "dolor de muela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolores de muela": [
    {
      "id": 10263,
      "keyword": "dolor de muela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28757,
      "keyword": "dolor de muela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28758,
      "keyword": "dolor de muela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gastritis": [
    {
      "id": 10264,
      "keyword": "gastritis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "otitis": [
    {
      "id": 10265,
      "keyword": "otitis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "miedo": [
    {
      "id": 39248,
      "keyword": "miedo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human response",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10261,
      "keyword": "miedo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human response",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "miedos": [
    {
      "id": 10261,
      "keyword": "miedo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human response",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "temor": [
    {
      "id": 10261,
      "keyword": "temor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human response",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "temores": [
    {
      "id": 10261,
      "keyword": "temor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human response",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quemadura": [
    {
      "id": 10266,
      "keyword": "quemadura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22064,
      "keyword": "quemadura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quemaduras": [
    {
      "id": 10266,
      "keyword": "quemadura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22064,
      "keyword": "quemadura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "educación física": [
    {
      "id": 31945,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38418,
      "keyword": "educación física",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32548,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38628,
      "keyword": "educación física",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38629,
      "keyword": "educación física",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38632,
      "keyword": "educación física",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10258,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10370,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10372,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10373,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10374,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10375,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10376,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10371,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10377,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10381,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10380,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10382,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10384,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10378,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10383,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10386,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10385,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10387,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10379,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11275,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13036,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13038,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13042,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13048,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13052,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13054,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13056,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13046,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13058,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13060,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13044,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13050,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13062,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13064,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13070,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13066,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13068,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13072,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38042,
      "keyword": "educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de educación física": [
    {
      "id": 32548,
      "keyword": "clase de educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10258,
      "keyword": "clase de educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de educación física": [
    {
      "id": 32548,
      "keyword": "clase de educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10258,
      "keyword": "clase de educación física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arteria": [
    {
      "id": 10269,
      "keyword": "arteria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arterias": [
    {
      "id": 10269,
      "keyword": "arteria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "torre eiffel": [
    {
      "id": 10271,
      "keyword": "torre Eiffel",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muralla china": [
    {
      "id": 10272,
      "keyword": "Muralla China",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿cómo estás?": [
    {
      "id": 10273,
      "keyword": "¿cómo estás?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿qué tal estás?": [
    {
      "id": 10273,
      "keyword": "¿qué tal estás?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vena": [
    {
      "id": 10270,
      "keyword": "vena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "venas": [
    {
      "id": 10270,
      "keyword": "vena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿de qué sexo es?": [
    {
      "id": 10274,
      "keyword": "¿de qué sexo es?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "sexuality",
        "gender identity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fecha de nacimiento": [
    {
      "id": 10275,
      "keyword": "fecha de nacimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "supporting document",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fechas de nacimiento": [
    {
      "id": 10275,
      "keyword": "fecha de nacimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "supporting document",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adn": [
    {
      "id": 10268,
      "keyword": "ADN",
      "keywords": 1,
      "type": 2,
      "tags": [
        "biology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viga": [
    {
      "id": 10277,
      "keyword": "viga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vigas": [
    {
      "id": 10277,
      "keyword": "viga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34074,
      "keyword": "vigas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diente": [
    {
      "id": 10267,
      "keyword": "diente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system",
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "2 euros": [
    {
      "id": 10279,
      "keyword": "2 euros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "coin"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canicas": [
    {
      "id": 32516,
      "keyword": "canicas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10281,
      "keyword": "canicas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36507,
      "keyword": "canica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolillas": [
    {
      "id": 32516,
      "keyword": "bolillas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10281,
      "keyword": "bolillas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36507,
      "keyword": "bolilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolitas": [
    {
      "id": 32516,
      "keyword": "bolitas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10281,
      "keyword": "bolitas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36507,
      "keyword": "bolita",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rayuela": [
    {
      "id": 10282,
      "keyword": "rayuela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rayuelas": [
    {
      "id": 10282,
      "keyword": "rayuela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "faringitis": [
    {
      "id": 10262,
      "keyword": "faringitis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teatro": [
    {
      "id": 32412,
      "keyword": "teatro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "theater",
        "show",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10284,
      "keyword": "teatro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "theater",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teatros": [
    {
      "id": 32412,
      "keyword": "teatro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "theater",
        "show",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10284,
      "keyword": "teatro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "theater",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lenguaje": [
    {
      "id": 32546,
      "keyword": "lenguaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10259,
      "keyword": "lenguaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lenguajes": [
    {
      "id": 32546,
      "keyword": "lenguaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10259,
      "keyword": "lenguaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clase de lenguaje": [
    {
      "id": 32546,
      "keyword": "clase de lenguaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10259,
      "keyword": "clase de lenguaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de lenguaje": [
    {
      "id": 32546,
      "keyword": "clase de lenguaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10259,
      "keyword": "clase de lenguaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hemisferio norte": [
    {
      "id": 10285,
      "keyword": "hemisferio norte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hemisferio sur": [
    {
      "id": 10286,
      "keyword": "hemisferio sur",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortacésped": [
    {
      "id": 10280,
      "keyword": "cortacésped",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortacéspedes": [
    {
      "id": 10280,
      "keyword": "cortacésped",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cobre": [
    {
      "id": 35953,
      "keyword": "cobre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10287,
      "keyword": "cobre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "restaurante": [
    {
      "id": 32408,
      "keyword": "restaurante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35391,
      "keyword": "restaurante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38477,
      "keyword": "restaurante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10283,
      "keyword": "restaurante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11361,
      "keyword": "restaurante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "restaurantes": [
    {
      "id": 32408,
      "keyword": "restaurante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35391,
      "keyword": "restaurante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38477,
      "keyword": "restaurante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10283,
      "keyword": "restaurante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11361,
      "keyword": "restaurante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuarto creciente": [
    {
      "id": 10290,
      "keyword": "cuarto creciente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuartos crecientes": [
    {
      "id": 10290,
      "keyword": "cuarto creciente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "júpiter": [
    {
      "id": 10293,
      "keyword": "Júpiter",
      "keywords": 1,
      "type": 1,
      "tags": [
        "astronomy",
        "planet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fases lunares": [
    {
      "id": 10292,
      "keyword": "fases lunares",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "luna llena": [
    {
      "id": 10294,
      "keyword": "luna llena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lunas llenas": [
    {
      "id": 10294,
      "keyword": "luna llena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "luna nueva": [
    {
      "id": 10295,
      "keyword": "luna nueva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lunas nuevas": [
    {
      "id": 10295,
      "keyword": "luna nueva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plástico": [
    {
      "id": 10288,
      "keyword": "plástico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plásticos": [
    {
      "id": 10288,
      "keyword": "plástico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "object",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "marte": [
    {
      "id": 10296,
      "keyword": "Marte",
      "keywords": 1,
      "type": 1,
      "tags": [
        "astronomy",
        "planet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atmósfera": [
    {
      "id": 10289,
      "keyword": "atmósfera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 20385,
      "keyword": "atmósfera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atmósferas": [
    {
      "id": 10289,
      "keyword": "atmósfera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 20385,
      "keyword": "atmósfera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuarto menguante": [
    {
      "id": 10291,
      "keyword": "cuarto menguante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuartos menguantes": [
    {
      "id": 10291,
      "keyword": "cuarto menguante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plutón": [
    {
      "id": 10299,
      "keyword": "Plutón",
      "keywords": 1,
      "type": 1,
      "tags": [
        "astronomy",
        "planet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "neptuno": [
    {
      "id": 10298,
      "keyword": "Neptuno",
      "keywords": 1,
      "type": 1,
      "tags": [
        "astronomy",
        "planet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paisaje": [
    {
      "id": 10304,
      "keyword": "paisaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paisajes": [
    {
      "id": 10304,
      "keyword": "paisaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "teide": [
    {
      "id": 10305,
      "keyword": "Teide",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mercurio": [
    {
      "id": 10297,
      "keyword": "Mercurio",
      "keywords": 1,
      "type": 1,
      "tags": [
        "astronomy",
        "planet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "urano": [
    {
      "id": 10302,
      "keyword": "Urano",
      "keywords": 1,
      "type": 1,
      "tags": [
        "astronomy",
        "planet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saturno": [
    {
      "id": 10300,
      "keyword": "Saturno",
      "keywords": 1,
      "type": 1,
      "tags": [
        "astronomy",
        "planet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "venus": [
    {
      "id": 10303,
      "keyword": "Venus",
      "keywords": 1,
      "type": 1,
      "tags": [
        "astronomy",
        "planet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ficha": [
    {
      "id": 10310,
      "keyword": "ficha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11263,
      "keyword": "ficha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fichero": [
    {
      "id": 10311,
      "keyword": "fichero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ficheros": [
    {
      "id": 10311,
      "keyword": "fichero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peine y tijeras": [
    {
      "id": 10308,
      "keyword": "peine y tijeras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peines y tijeras": [
    {
      "id": 10308,
      "keyword": "peine y tijeras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lapicera": [
    {
      "id": 10313,
      "keyword": "lapicera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lapiceras": [
    {
      "id": 10313,
      "keyword": "lapicera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lápiz y papel": [
    {
      "id": 10312,
      "keyword": "lápiz y papel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lápices y papeles": [
    {
      "id": 10312,
      "keyword": "lápiz y papel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "orinal": [
    {
      "id": 10307,
      "keyword": "orinal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30765,
      "keyword": "orinal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orinales": [
    {
      "id": 10307,
      "keyword": "orinal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30765,
      "keyword": "orinal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cubo y fregona": [
    {
      "id": 10314,
      "keyword": "cubo y fregona",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubos y fregonas": [
    {
      "id": 10314,
      "keyword": "cubo y fregona",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "balde lampazo": [
    {
      "id": 10314,
      "keyword": "balde lampazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ríos de españa": [
    {
      "id": 10306,
      "keyword": "ríos de España",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clip": [
    {
      "id": 10309,
      "keyword": "clip",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clips": [
    {
      "id": 10309,
      "keyword": "clip",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "brackets": [
    {
      "id": 10316,
      "keyword": "brackets",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "código de barras": [
    {
      "id": 10320,
      "keyword": "código de barras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "códigos de barras": [
    {
      "id": 10320,
      "keyword": "código de barras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adorno": [
    {
      "id": 10318,
      "keyword": "adorno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adornos": [
    {
      "id": 10318,
      "keyword": "adorno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gafas rotas": [
    {
      "id": 10322,
      "keyword": "gafas rotas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lentes rotas": [
    {
      "id": 10322,
      "keyword": "lentes rotas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anteojos rotos": [
    {
      "id": 10322,
      "keyword": "anteojos rotos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "foco": [
    {
      "id": 10321,
      "keyword": "foco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27764,
      "keyword": "foco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "focos": [
    {
      "id": 10321,
      "keyword": "foco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27764,
      "keyword": "foco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escoba y recogedor": [
    {
      "id": 10315,
      "keyword": "escoba y recogedor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escobas y recogedores": [
    {
      "id": 10315,
      "keyword": "escoba y recogedor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escoba y pala de basura": [
    {
      "id": 10315,
      "keyword": "escoba y pala de basura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escobas y palas de basura": [
    {
      "id": 10315,
      "keyword": "escoba y pala de basura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acelerador": [
    {
      "id": 10326,
      "keyword": "acelerador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aceleradores": [
    {
      "id": 10326,
      "keyword": "acelerador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sello de caucho": [
    {
      "id": 10324,
      "keyword": "sello de caucho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sellos de caucho": [
    {
      "id": 10324,
      "keyword": "sello de caucho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "embrague": [
    {
      "id": 10327,
      "keyword": "embrague",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "embragues": [
    {
      "id": 10327,
      "keyword": "embrague",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sobres": [
    {
      "id": 10325,
      "keyword": "sobre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "object",
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "katana": [
    {
      "id": 10319,
      "keyword": "katana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "katanas": [
    {
      "id": 10319,
      "keyword": "katana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "catana": [
    {
      "id": 10319,
      "keyword": "catana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "catanas": [
    {
      "id": 10319,
      "keyword": "catana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "freno de mano": [
    {
      "id": 10330,
      "keyword": "freno de mano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frenos de mano": [
    {
      "id": 10330,
      "keyword": "freno de mano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gramófono": [
    {
      "id": 10323,
      "keyword": "gramófono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gramófonos": [
    {
      "id": 10323,
      "keyword": "gramófono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "motor": [
    {
      "id": 10334,
      "keyword": "motor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "motores": [
    {
      "id": 10334,
      "keyword": "motor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parabrisas": [
    {
      "id": 10335,
      "keyword": "parabrisas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maletero": [
    {
      "id": 10332,
      "keyword": "maletero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37941,
      "keyword": "maletero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maleteros": [
    {
      "id": 10332,
      "keyword": "maletero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37941,
      "keyword": "maletero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "matrícula": [
    {
      "id": 10333,
      "keyword": "matrícula",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "matrículas": [
    {
      "id": 10333,
      "keyword": "matrícula",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "patente": [
    {
      "id": 10333,
      "keyword": "patente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patentes": [
    {
      "id": 10333,
      "keyword": "patente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "retrovisor interior": [
    {
      "id": 10336,
      "keyword": "retrovisor interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "retrovisores interiores": [
    {
      "id": 10336,
      "keyword": "retrovisor interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oxígeno": [
    {
      "id": 24216,
      "keyword": "oxígeno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10317,
      "keyword": "oxígeno",
      "keywords": 3,
      "type": 2,
      "tags": [
        "chemistry",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bombona de oxígeno": [
    {
      "id": 10317,
      "keyword": "bombona de oxígeno",
      "keywords": 3,
      "type": 2,
      "tags": [
        "chemistry",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bombonas de oxígeno": [
    {
      "id": 10317,
      "keyword": "bombona de oxígeno",
      "keywords": 3,
      "type": 2,
      "tags": [
        "chemistry",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nieta": [
    {
      "id": 10342,
      "keyword": "nieta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nietas": [
    {
      "id": 10342,
      "keyword": "nieta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nieto": [
    {
      "id": 10343,
      "keyword": "nieto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nietos": [
    {
      "id": 10343,
      "keyword": "nieto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "heterosexual": [
    {
      "id": 10344,
      "keyword": "heterosexual",
      "keywords": 2,
      "type": 4,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "heterosexuales": [
    {
      "id": 10344,
      "keyword": "heterosexual",
      "keywords": 2,
      "type": 4,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tubo de escape": [
    {
      "id": 10338,
      "keyword": "tubo de escape",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tubos de escape": [
    {
      "id": 10338,
      "keyword": "tubo de escape",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "animadora": [
    {
      "id": 10347,
      "keyword": "animadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "animadoras": [
    {
      "id": 10347,
      "keyword": "animadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "limpiaparabrisas": [
    {
      "id": 10331,
      "keyword": "limpiaparabrisas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "retrovisor": [
    {
      "id": 10337,
      "keyword": "retrovisor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "retrovisores": [
    {
      "id": 10337,
      "keyword": "retrovisor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sexo": [
    {
      "id": 10345,
      "keyword": "sexo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "gender identity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sexos": [
    {
      "id": 10345,
      "keyword": "sexo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "gender identity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "limpiaventanas": [
    {
      "id": 10349,
      "keyword": "limpiaventanas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34451,
      "keyword": "limpiaventanas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "transportes": [
    {
      "id": 10351,
      "keyword": "transportes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10351,
      "keyword": "transporte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "transporte": [
    {
      "id": 10351,
      "keyword": "transporte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pamela": [
    {
      "id": 10352,
      "keyword": "pamela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "outdoor activity",
        "beach",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pamelas": [
    {
      "id": 10352,
      "keyword": "pamela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "outdoor activity",
        "beach",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bandera pirata": [
    {
      "id": 10353,
      "keyword": "bandera pirata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "carnival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "banderas piratas": [
    {
      "id": 10353,
      "keyword": "bandera pirata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "carnival"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ostra": [
    {
      "id": 10358,
      "keyword": "ostra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "mollusc",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ostras": [
    {
      "id": 10358,
      "keyword": "ostra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "mollusc",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casco vikingo": [
    {
      "id": 10354,
      "keyword": "casco vikingo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cascos vikingos": [
    {
      "id": 10354,
      "keyword": "casco vikingo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "malabarista": [
    {
      "id": 10350,
      "keyword": "malabarista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35963,
      "keyword": "malabarista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38299,
      "keyword": "malabarista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38301,
      "keyword": "malabarista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "malabaristas": [
    {
      "id": 10350,
      "keyword": "malabarista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35963,
      "keyword": "malabarista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38299,
      "keyword": "malabarista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38301,
      "keyword": "malabarista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "don quijote": [
    {
      "id": 10359,
      "keyword": "Don Quijote",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muda": [
    {
      "id": 37796,
      "keyword": "muda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10365,
      "keyword": "muda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mudas": [
    {
      "id": 37796,
      "keyword": "muda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 10365,
      "keyword": "muda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chef": [
    {
      "id": 10348,
      "keyword": "chef",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15712,
      "keyword": "chef",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chefs": [
    {
      "id": 10348,
      "keyword": "chef",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15712,
      "keyword": "chef",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jefe de cocina": [
    {
      "id": 10348,
      "keyword": "jefe de cocina",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jefes de cocina": [
    {
      "id": 10348,
      "keyword": "jefe de cocina",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "napolitana": [
    {
      "id": 10357,
      "keyword": "napolitana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "napolitanas": [
    {
      "id": 10357,
      "keyword": "napolitana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿lo has escuchado?": [
    {
      "id": 11609,
      "keyword": "¿lo has escuchado?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10364,
      "keyword": "¿lo has escuchado?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿lo oyes?": [
    {
      "id": 11609,
      "keyword": "¿lo oyes?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10364,
      "keyword": "¿lo oyes?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿lo has oído?": [
    {
      "id": 11609,
      "keyword": "¿lo has oído?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10364,
      "keyword": "¿lo has oído?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brazos en cruz": [
    {
      "id": 31945,
      "keyword": "brazos en cruz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37161,
      "keyword": "brazos en cruz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37197,
      "keyword": "brazos en cruz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10370,
      "keyword": "brazos en cruz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10371,
      "keyword": "brazos en cruz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13036,
      "keyword": "brazos en cruz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13038,
      "keyword": "brazos en cruz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38042,
      "keyword": "brazos en cruz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿qué es eso?": [
    {
      "id": 10366,
      "keyword": "¿qué es eso?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manos a la cintura": [
    {
      "id": 10372,
      "keyword": "manos a la cintura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10373,
      "keyword": "manos a la cintura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13042,
      "keyword": "manos a la cintura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13044,
      "keyword": "manos a la cintura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manos en la tripa": [
    {
      "id": 10374,
      "keyword": "manos en la tripa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10375,
      "keyword": "manos en la tripa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13048,
      "keyword": "manos en la tripa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13046,
      "keyword": "manos en la tripa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿qué programa quieres ver?": [
    {
      "id": 10369,
      "keyword": "¿qué programa quieres ver?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "mass media",
        "tertiary sector",
        "TV show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manos a los hombros": [
    {
      "id": 10376,
      "keyword": "manos a los hombros",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10377,
      "keyword": "manos a los hombros",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10378,
      "keyword": "manos a los hombros",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10379,
      "keyword": "manos a los hombros",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13052,
      "keyword": "manos a los hombros",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13054,
      "keyword": "manos a los hombros",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13056,
      "keyword": "manos a los hombros",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13050,
      "keyword": "manos a los hombros",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manos al culo": [
    {
      "id": 10381,
      "keyword": "manos al culo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13060,
      "keyword": "manos al culo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manos a los pies": [
    {
      "id": 39053,
      "keyword": "manos a los pies",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10380,
      "keyword": "manos a los pies",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13058,
      "keyword": "manos a los pies",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿qué has hecho?": [
    {
      "id": 38482,
      "keyword": "¿qué has hecho?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10367,
      "keyword": "¿qué has hecho?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38483,
      "keyword": "¿qué has hecho?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manos arriba": [
    {
      "id": 10382,
      "keyword": "manos arriba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10383,
      "keyword": "manos arriba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13062,
      "keyword": "manos arriba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13064,
      "keyword": "manos arriba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manos detrás de la cabeza": [
    {
      "id": 10384,
      "keyword": "manos detrás de la cabeza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10385,
      "keyword": "manos detrás de la cabeza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13066,
      "keyword": "manos detrás de la cabeza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13068,
      "keyword": "manos detrás de la cabeza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manos en la cabeza": [
    {
      "id": 10386,
      "keyword": "manos en la cabeza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 10387,
      "keyword": "manos en la cabeza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13070,
      "keyword": "manos en la cabeza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13072,
      "keyword": "manos en la cabeza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿llueve?": [
    {
      "id": 10722,
      "keyword": "¿llueve?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿está lloviendo?": [
    {
      "id": 10722,
      "keyword": "¿está lloviendo?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿nieva?": [
    {
      "id": 10723,
      "keyword": "¿nieva?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿está nevando?": [
    {
      "id": 10723,
      "keyword": "¿está nevando?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿hay viento?": [
    {
      "id": 10726,
      "keyword": "¿hay viento?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿hace aire?": [
    {
      "id": 10726,
      "keyword": "¿hace aire?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿sopla el viento?": [
    {
      "id": 10726,
      "keyword": "¿sopla el viento?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿hay nubes?": [
    {
      "id": 10724,
      "keyword": "¿hay nubes?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿está nublado?": [
    {
      "id": 10724,
      "keyword": "¿está nublado?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡hace sol!": [
    {
      "id": 10735,
      "keyword": "¡hace sol!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38560,
      "keyword": "¡hace sol!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡está soleado!": [
    {
      "id": 10735,
      "keyword": "¡está soleado!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38560,
      "keyword": "¡está soleado!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡hay viento!": [
    {
      "id": 10736,
      "keyword": "¡hay viento!",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38559,
      "keyword": "¡hay viento!",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡sopla el viento!": [
    {
      "id": 10736,
      "keyword": "¡sopla el viento!",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38559,
      "keyword": "¡sopla el viento!",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡hace aire!": [
    {
      "id": 10736,
      "keyword": "¡hace aire!",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38559,
      "keyword": "¡hace aire!",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿estás contento?": [
    {
      "id": 10744,
      "keyword": "¿estás contento?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿qué juego quieres?": [
    {
      "id": 10368,
      "keyword": "¿qué juego quieres?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡hay nubes!": [
    {
      "id": 10734,
      "keyword": "¡hay nubes!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38561,
      "keyword": "¡hay nubes!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡está nublado!": [
    {
      "id": 10734,
      "keyword": "¡está nublado!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38561,
      "keyword": "¡está nublado!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡nieva!": [
    {
      "id": 10733,
      "keyword": "¡nieva!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38562,
      "keyword": "¡nieva!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡está nevando!": [
    {
      "id": 10733,
      "keyword": "¡está nevando!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38562,
      "keyword": "¡está nevando!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿estás triste?": [
    {
      "id": 10750,
      "keyword": "¿estás triste?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿estás enfadado?": [
    {
      "id": 10748,
      "keyword": "¿estás enfadado?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿hace sol?": [
    {
      "id": 10725,
      "keyword": "¿hace sol?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿está soleado?": [
    {
      "id": 10725,
      "keyword": "¿está soleado?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ovillo": [
    {
      "id": 11008,
      "keyword": "ovillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ovillos": [
    {
      "id": 11008,
      "keyword": "ovillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abogada": [
    {
      "id": 39079,
      "keyword": "abogada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11160,
      "keyword": "abogada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abogadas": [
    {
      "id": 39079,
      "keyword": "abogada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11160,
      "keyword": "abogada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plural": [
    {
      "id": 11100,
      "keyword": "plural",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11098,
      "keyword": "plural",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "plurales": [
    {
      "id": 11100,
      "keyword": "plural",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11100,
      "keyword": "plurales",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11098,
      "keyword": "plural",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11098,
      "keyword": "plurales",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "abrir la cerradura": [
    {
      "id": 11161,
      "keyword": "abrir la cerradura",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrir con llave": [
    {
      "id": 11161,
      "keyword": "abrir con llave",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrir la ventana": [
    {
      "id": 11162,
      "keyword": "abrir la ventana",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adivinar": [
    {
      "id": 11163,
      "keyword": "adivinar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36151,
      "keyword": "adivinar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "predecir": [
    {
      "id": 11163,
      "keyword": "predecir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36151,
      "keyword": "predecir",
      "keywords": 4,
      "type": 3,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adivino": [
    {
      "id": 11163,
      "keyword": "adivino",
      "keywords": 3,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adivinos": [
    {
      "id": 11163,
      "keyword": "adivino",
      "keywords": 3,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "afortunado": [
    {
      "id": 11164,
      "keyword": "afortunado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suerte": [
    {
      "id": 11164,
      "keyword": "suerte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suertes": [
    {
      "id": 11164,
      "keyword": "suerte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fortuna": [
    {
      "id": 11164,
      "keyword": "fortuna",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fortunas": [
    {
      "id": 11164,
      "keyword": "fortuna",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estrangular": [
    {
      "id": 11168,
      "keyword": "estrangular",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11167,
      "keyword": "estrangular",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31913,
      "keyword": "estrangular",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36484,
      "keyword": "estrangular",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alargadera": [
    {
      "id": 11170,
      "keyword": "alargadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alargaderas": [
    {
      "id": 11170,
      "keyword": "alargadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alcaldesa": [
    {
      "id": 11172,
      "keyword": "alcaldesa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "person",
        "leader"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alcaldesas": [
    {
      "id": 11172,
      "keyword": "alcaldesa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "person",
        "leader"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "intendenta": [
    {
      "id": 11172,
      "keyword": "intendenta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "person",
        "leader"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intendentas": [
    {
      "id": 11172,
      "keyword": "intendenta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "person",
        "leader"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alfarero": [
    {
      "id": 11173,
      "keyword": "alfarero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alfareros": [
    {
      "id": 11173,
      "keyword": "alfarero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agricultora": [
    {
      "id": 11165,
      "keyword": "agricultora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agricultoras": [
    {
      "id": 11165,
      "keyword": "agricultora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "campesina": [
    {
      "id": 11165,
      "keyword": "campesina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campesinas": [
    {
      "id": 11165,
      "keyword": "campesina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alimentar": [
    {
      "id": 38431,
      "keyword": "alimentar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11176,
      "keyword": "alimentar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "altamira": [
    {
      "id": 11177,
      "keyword": "Altamira",
      "keywords": 3,
      "type": 1,
      "tags": [
        "history",
        "prehistory",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cueva rupestre": [
    {
      "id": 11177,
      "keyword": "cueva rupestre",
      "keywords": 3,
      "type": 2,
      "tags": [
        "history",
        "prehistory",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuevas rupestres": [
    {
      "id": 11177,
      "keyword": "cueva rupestre",
      "keywords": 3,
      "type": 2,
      "tags": [
        "history",
        "prehistory",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pintura rupestre": [
    {
      "id": 11177,
      "keyword": "pintura rupestre",
      "keywords": 3,
      "type": 2,
      "tags": [
        "history",
        "prehistory",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinturas rupestres": [
    {
      "id": 11177,
      "keyword": "pintura rupestre",
      "keywords": 3,
      "type": 2,
      "tags": [
        "history",
        "prehistory",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amado": [
    {
      "id": 37799,
      "keyword": "amado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11178,
      "keyword": "amado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "amados": [
    {
      "id": 37799,
      "keyword": "amado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human value"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11178,
      "keyword": "amado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amada": [
    {
      "id": 37798,
      "keyword": "amada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11179,
      "keyword": "amada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "amadas": [
    {
      "id": 37798,
      "keyword": "amada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11179,
      "keyword": "amada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "árbitra": [
    {
      "id": 11181,
      "keyword": "árbitra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport rules",
        "work",
        "professional",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "árbitras": [
    {
      "id": 11181,
      "keyword": "árbitra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport rules",
        "work",
        "professional",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arquitecta": [
    {
      "id": 11183,
      "keyword": "arquitecta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "architecture",
        "building",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arquitectas": [
    {
      "id": 11183,
      "keyword": "arquitecta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "architecture",
        "building",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aparejadora": [
    {
      "id": 11183,
      "keyword": "aparejadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "architecture",
        "building",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aparejadoras": [
    {
      "id": 11183,
      "keyword": "aparejadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "architecture",
        "building",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aunque": [
    {
      "id": 11185,
      "keyword": "aunque",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "conjunction",
        "concessive conjunction",
        "adversative conjunction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11377,
      "keyword": "aunque",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "conjunction",
        "adversative conjunction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bailarín": [
    {
      "id": 11186,
      "keyword": "bailarín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bailarines": [
    {
      "id": 11186,
      "keyword": "bailarín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "baloncesto adaptado": [
    {
      "id": 11187,
      "keyword": "baloncesto adaptado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "adapted sport",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34473,
      "keyword": "baloncesto adaptado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "adapted sport",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barrendera": [
    {
      "id": 11188,
      "keyword": "barrendera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barrenderas": [
    {
      "id": 11188,
      "keyword": "barrendera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "basurera": [
    {
      "id": 11189,
      "keyword": "basurera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11188,
      "keyword": "basurera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "basureras": [
    {
      "id": 11189,
      "keyword": "basurera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11188,
      "keyword": "basurera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "biblioteca adaptada": [
    {
      "id": 11190,
      "keyword": "biblioteca adaptada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23837,
      "keyword": "biblioteca adaptada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "library science"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36049,
      "keyword": "biblioteca adaptada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bibliotecas adaptadas": [
    {
      "id": 11190,
      "keyword": "biblioteca adaptada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23837,
      "keyword": "biblioteca adaptada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "library science"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36049,
      "keyword": "biblioteca adaptada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "library science"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bingo": [
    {
      "id": 11191,
      "keyword": "bingo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "gambling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bingos": [
    {
      "id": 11191,
      "keyword": "bingo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "gambling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bipedestador": [
    {
      "id": 24877,
      "keyword": "bipedestador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11192,
      "keyword": "bipedestador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bipedestadores": [
    {
      "id": 24877,
      "keyword": "bipedestador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11192,
      "keyword": "bipedestador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "algodón de azúcar": [
    {
      "id": 11174,
      "keyword": "algodón de azúcar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "algodones de azúcar": [
    {
      "id": 11174,
      "keyword": "algodón de azúcar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aplastar": [
    {
      "id": 13032,
      "keyword": "aplastar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11180,
      "keyword": "aplastar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38694,
      "keyword": "aplastar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estrujar": [
    {
      "id": 11180,
      "keyword": "estrujar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿estás asustado?": [
    {
      "id": 10746,
      "keyword": "¿estás asustado?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bonito": [
    {
      "id": 11194,
      "keyword": "bonito",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25857,
      "keyword": "bonito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "feeding",
        "food",
        "animal-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bonitos": [
    {
      "id": 11194,
      "keyword": "bonito",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25857,
      "keyword": "bonito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "feeding",
        "food",
        "animal-based food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bonita": [
    {
      "id": 11194,
      "keyword": "bonita",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bonitas": [
    {
      "id": 11194,
      "keyword": "bonita",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hermoso": [
    {
      "id": 11194,
      "keyword": "hermoso",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hermosos": [
    {
      "id": 11194,
      "keyword": "hermoso",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hermosa": [
    {
      "id": 11194,
      "keyword": "hermosa",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hermosas": [
    {
      "id": 11194,
      "keyword": "hermosa",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lindo": [
    {
      "id": 11194,
      "keyword": "lindo",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lindos": [
    {
      "id": 11194,
      "keyword": "lindo",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "linda": [
    {
      "id": 11194,
      "keyword": "linda",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lindas": [
    {
      "id": 11194,
      "keyword": "linda",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "precioso": [
    {
      "id": 11194,
      "keyword": "precioso",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "preciosos": [
    {
      "id": 11194,
      "keyword": "precioso",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "preciosa": [
    {
      "id": 11194,
      "keyword": "preciosa",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "preciosas": [
    {
      "id": 11194,
      "keyword": "preciosa",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cambiar de tema": [
    {
      "id": 11199,
      "keyword": "cambiar de tema",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cambio de tema": [
    {
      "id": 11199,
      "keyword": "cambio de tema",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cambios de tema": [
    {
      "id": 11199,
      "keyword": "cambio de tema",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "capullo": [
    {
      "id": 11202,
      "keyword": "capullo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "flower"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carnicera": [
    {
      "id": 11203,
      "keyword": "carnicera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carniceras": [
    {
      "id": 11203,
      "keyword": "carnicera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carpintera": [
    {
      "id": 11204,
      "keyword": "carpintera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "carpentry",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carpinteras": [
    {
      "id": 11204,
      "keyword": "carpintera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "carpentry",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carrera": [
    {
      "id": 34830,
      "keyword": "carrera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "event",
        "sport event",
        "animal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11205,
      "keyword": "carrera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37424,
      "keyword": "carrera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11206,
      "keyword": "carrera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "sport modality",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21498,
      "keyword": "carrera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carreras": [
    {
      "id": 34830,
      "keyword": "carrera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "event",
        "sport event",
        "animal"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11205,
      "keyword": "carrera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37424,
      "keyword": "carrera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11206,
      "keyword": "carrera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "sport modality",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21498,
      "keyword": "carrera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cazuela": [
    {
      "id": 11210,
      "keyword": "cazuela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cazuelas": [
    {
      "id": 11210,
      "keyword": "cazuela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro comercial": [
    {
      "id": 11211,
      "keyword": "centro comercial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15551,
      "keyword": "centro comercial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros comerciales": [
    {
      "id": 11211,
      "keyword": "centro comercial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15551,
      "keyword": "centro comercial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerrar la ventana": [
    {
      "id": 11212,
      "keyword": "cerrar la ventana",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "certificado de nacimiento": [
    {
      "id": 11213,
      "keyword": "certificado de nacimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "certificados de nacimiento": [
    {
      "id": 11213,
      "keyword": "certificado de nacimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camarera": [
    {
      "id": 33036,
      "keyword": "camarera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11198,
      "keyword": "camarera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camareras": [
    {
      "id": 33036,
      "keyword": "camarera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11198,
      "keyword": "camarera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesera": [
    {
      "id": 11198,
      "keyword": "mesera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meseras": [
    {
      "id": 11198,
      "keyword": "mesera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "científica": [
    {
      "id": 11217,
      "keyword": "científica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "chemistry",
        "biology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "científicas": [
    {
      "id": 11217,
      "keyword": "científica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "chemistry",
        "biology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "investigadora": [
    {
      "id": 11217,
      "keyword": "investigadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "chemistry",
        "biology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "investigadoras": [
    {
      "id": 11217,
      "keyword": "investigadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "chemistry",
        "biology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cinta aislante": [
    {
      "id": 11218,
      "keyword": "cinta aislante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cintas aislantes": [
    {
      "id": 11218,
      "keyword": "cinta aislante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cinta de vídeo": [
    {
      "id": 11219,
      "keyword": "cinta de vídeo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25950,
      "keyword": "cinta de vídeo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cintas de vídeo": [
    {
      "id": 11219,
      "keyword": "cinta de vídeo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25950,
      "keyword": "cinta de vídeo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cirujana": [
    {
      "id": 38863,
      "keyword": "cirujana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38884,
      "keyword": "cirujana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11220,
      "keyword": "cirujana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35303,
      "keyword": "cirujana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cirujanas": [
    {
      "id": 38863,
      "keyword": "cirujana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38884,
      "keyword": "cirujana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11220,
      "keyword": "cirujana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35303,
      "keyword": "cirujana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "charcutera": [
    {
      "id": 11215,
      "keyword": "charcutera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "charcuteras": [
    {
      "id": 11215,
      "keyword": "charcutera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chasquear": [
    {
      "id": 11216,
      "keyword": "chasquear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "albergue": [
    {
      "id": 38658,
      "keyword": "albergue",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11222,
      "keyword": "albergue",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "leisure",
        "facility",
        "recreational facility",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "albergues": [
    {
      "id": 38658,
      "keyword": "albergue",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11222,
      "keyword": "albergue",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "leisure",
        "facility",
        "recreational facility",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dar golpes con los pies": [
    {
      "id": 11225,
      "keyword": "dar golpes con los pies",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cristalería": [
    {
      "id": 11224,
      "keyword": "cristalería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29973,
      "keyword": "cristalería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "workplace",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cristalerías": [
    {
      "id": 11224,
      "keyword": "cristalería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29973,
      "keyword": "cristalería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "workplace",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "césped": [
    {
      "id": 11214,
      "keyword": "césped",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dar palmas en las rodillas": [
    {
      "id": 11226,
      "keyword": "dar palmas en las rodillas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palmear": [
    {
      "id": 11226,
      "keyword": "palmear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dátiles": [
    {
      "id": 11227,
      "keyword": "dátiles",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36515,
      "keyword": "dátil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "deberes": [
    {
      "id": 32556,
      "keyword": "deberes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11228,
      "keyword": "deberes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "odontólogo": [
    {
      "id": 38834,
      "keyword": "odontólogo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38886,
      "keyword": "odontólogo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39141,
      "keyword": "odontólogo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11229,
      "keyword": "odontólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "odontólogos": [
    {
      "id": 38834,
      "keyword": "odontólogo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38886,
      "keyword": "odontólogo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39141,
      "keyword": "odontólogo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11229,
      "keyword": "odontólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "derribar": [
    {
      "id": 36381,
      "keyword": "derribar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11230,
      "keyword": "derribar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "construction",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "demoler": [
    {
      "id": 11230,
      "keyword": "demoler",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "construction",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carrera de coches": [
    {
      "id": 11206,
      "keyword": "carrera de coches",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "sport modality",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carreras de coches": [
    {
      "id": 11206,
      "keyword": "carrera de coches",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "sport modality",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desnudo": [
    {
      "id": 11234,
      "keyword": "desnudo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "adult",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31250,
      "keyword": "desnudo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "child",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31251,
      "keyword": "desnudo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "teenager",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31264,
      "keyword": "desnudo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "adult",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34637,
      "keyword": "desnudo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desnudos": [
    {
      "id": 11234,
      "keyword": "desnudo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "adult",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31250,
      "keyword": "desnudo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "child",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31251,
      "keyword": "desnudo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "teenager",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31264,
      "keyword": "desnudo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "adult",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34637,
      "keyword": "desnudo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "despierto": [
    {
      "id": 11235,
      "keyword": "despierto",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despiertos": [
    {
      "id": 11235,
      "keyword": "despierto",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diana": [
    {
      "id": 11236,
      "keyword": "diana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dianas": [
    {
      "id": 11236,
      "keyword": "diana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dibujo": [
    {
      "id": 32518,
      "keyword": "dibujo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11238,
      "keyword": "dibujo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task",
        "visual art",
        "drawing",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dibujos": [
    {
      "id": 32518,
      "keyword": "dibujo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11238,
      "keyword": "dibujo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task",
        "visual art",
        "drawing",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desnudar": [
    {
      "id": 11233,
      "keyword": "desnudar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "basic needs",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11232,
      "keyword": "desnudar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15371,
      "keyword": "desnudar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34019,
      "keyword": "desnudar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desvestir": [
    {
      "id": 11233,
      "keyword": "desvestir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "basic needs",
        "routine",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11232,
      "keyword": "desvestir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15371,
      "keyword": "desvestir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34019,
      "keyword": "desvestir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dieta": [
    {
      "id": 11239,
      "keyword": "dieta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "dietetics",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dietas": [
    {
      "id": 11239,
      "keyword": "dieta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "dietetics",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolor en el culo": [
    {
      "id": 11242,
      "keyword": "dolor en el culo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolores en el culo": [
    {
      "id": 11242,
      "keyword": "dolor en el culo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolor en el trasero": [
    {
      "id": 11242,
      "keyword": "dolor en el trasero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolores en el trasero": [
    {
      "id": 11242,
      "keyword": "dolor en el trasero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolor en la cola": [
    {
      "id": 11242,
      "keyword": "dolor en la cola",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolores en la cola": [
    {
      "id": 11242,
      "keyword": "dolor en la cola",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolor de pecho": [
    {
      "id": 28782,
      "keyword": "dolor de pecho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28781,
      "keyword": "dolor de pecho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11241,
      "keyword": "dolor de pecho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolores de pecho": [
    {
      "id": 28782,
      "keyword": "dolor de pecho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28781,
      "keyword": "dolor de pecho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11241,
      "keyword": "dolor de pecho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolor en el pecho": [
    {
      "id": 11241,
      "keyword": "dolor en el pecho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolores en el pecho": [
    {
      "id": 11241,
      "keyword": "dolor en el pecho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "domadora": [
    {
      "id": 11243,
      "keyword": "domadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "domadoras": [
    {
      "id": 11243,
      "keyword": "domadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "educación artística": [
    {
      "id": 32550,
      "keyword": "educación artística",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11245,
      "keyword": "educación artística",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de educación artística": [
    {
      "id": 32550,
      "keyword": "clase de educación artística",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11245,
      "keyword": "clase de educación artística",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de educación artística": [
    {
      "id": 32550,
      "keyword": "clase de educación artística",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11245,
      "keyword": "clase de educación artística",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ejército": [
    {
      "id": 35973,
      "keyword": "ejército",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "history",
        "middle ages",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11246,
      "keyword": "ejército",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "person",
        "group",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ejércitos": [
    {
      "id": 35973,
      "keyword": "ejército",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "history",
        "middle ages",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11246,
      "keyword": "ejército",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "person",
        "group",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "derechos": [
    {
      "id": 11247,
      "keyword": "derechos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "work",
        "tertiary sector",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "director de orquesta": [
    {
      "id": 34527,
      "keyword": "director de orquesta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art",
        "musical notation",
        "musical composition",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11240,
      "keyword": "director de orquesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "directores de orquesta": [
    {
      "id": 34527,
      "keyword": "director de orquesta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art",
        "musical notation",
        "musical composition",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11240,
      "keyword": "director de orquesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cómodo": [
    {
      "id": 37793,
      "keyword": "cómodo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11248,
      "keyword": "cómodo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cómodos": [
    {
      "id": 37793,
      "keyword": "cómodo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11248,
      "keyword": "cómodo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "embarazo": [
    {
      "id": 11250,
      "keyword": "embarazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "embarazos": [
    {
      "id": 11250,
      "keyword": "embarazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gestación": [
    {
      "id": 11250,
      "keyword": "gestación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gestaciones": [
    {
      "id": 11250,
      "keyword": "gestación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encargo": [
    {
      "id": 25062,
      "keyword": "encargo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37822,
      "keyword": "encargo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11251,
      "keyword": "encargo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encargos": [
    {
      "id": 25062,
      "keyword": "encargo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37822,
      "keyword": "encargo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11251,
      "keyword": "encargo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encargar": [
    {
      "id": 25062,
      "keyword": "encargar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16657,
      "keyword": "encargar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37822,
      "keyword": "encargar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15377,
      "keyword": "encargar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11251,
      "keyword": "encargar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mandar": [
    {
      "id": 25062,
      "keyword": "mandar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37822,
      "keyword": "mandar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11251,
      "keyword": "mandar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conductora": [
    {
      "id": 11223,
      "keyword": "conductora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conductoras": [
    {
      "id": 11223,
      "keyword": "conductora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desatascador": [
    {
      "id": 28603,
      "keyword": "desatascador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11231,
      "keyword": "desatascador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desatascadores": [
    {
      "id": 28603,
      "keyword": "desatascador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11231,
      "keyword": "desatascador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desatascador químico": [
    {
      "id": 11231,
      "keyword": "desatascador químico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desatascadores químicos": [
    {
      "id": 11231,
      "keyword": "desatascador químico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ensaimada": [
    {
      "id": 11253,
      "keyword": "ensaimada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ensaimadas": [
    {
      "id": 11253,
      "keyword": "ensaimada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "entrada": [
    {
      "id": 27240,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27241,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "building",
        "place",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29616,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "educational space",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37334,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38374,
      "keyword": "entrada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "leisure",
        "show",
        "work",
        "tertiary sector",
        "culture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11254,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26063,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29614,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29615,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "educational space",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35015,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35016,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37091,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11255,
      "keyword": "entrada",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "scenic art",
        "cinema",
        "show",
        "theater",
        "event",
        "social event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entradas": [
    {
      "id": 27240,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27241,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "building",
        "place",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29616,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "educational space",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37334,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38374,
      "keyword": "entrada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "leisure",
        "show",
        "work",
        "tertiary sector",
        "culture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11254,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26063,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29614,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29615,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "educational space",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35015,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35016,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37091,
      "keyword": "entrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11255,
      "keyword": "entrada",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "scenic art",
        "cinema",
        "show",
        "theater",
        "event",
        "social event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "billete": [
    {
      "id": 29208,
      "keyword": "billete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11255,
      "keyword": "billete",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "scenic art",
        "cinema",
        "show",
        "theater",
        "event",
        "social event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ferretera": [
    {
      "id": 11262,
      "keyword": "ferretera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ferreteras": [
    {
      "id": 11262,
      "keyword": "ferretera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escritor": [
    {
      "id": 11258,
      "keyword": "escritor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escritores": [
    {
      "id": 11258,
      "keyword": "escritor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ejercicio": [
    {
      "id": 11263,
      "keyword": "ejercicio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ejercicios": [
    {
      "id": 11263,
      "keyword": "ejercicio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "floreado": [
    {
      "id": 11264,
      "keyword": "floreado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "pattern",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "floreados": [
    {
      "id": 11264,
      "keyword": "floreado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "pattern",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "floreada": [
    {
      "id": 11264,
      "keyword": "floreada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "pattern",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "floreadas": [
    {
      "id": 11264,
      "keyword": "floreada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "pattern",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fontanera": [
    {
      "id": 11266,
      "keyword": "fontanera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fontaneras": [
    {
      "id": 11266,
      "keyword": "fontanera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fotógrafo": [
    {
      "id": 38540,
      "keyword": "fotógrafo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11267,
      "keyword": "fotógrafo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fotógrafos": [
    {
      "id": 38540,
      "keyword": "fotógrafo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11267,
      "keyword": "fotógrafo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ganadora": [
    {
      "id": 11271,
      "keyword": "ganadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ganadoras": [
    {
      "id": 11271,
      "keyword": "ganadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "geranio": [
    {
      "id": 11272,
      "keyword": "geranio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "geranios": [
    {
      "id": 11272,
      "keyword": "geranio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "girasol": [
    {
      "id": 11274,
      "keyword": "girasol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "girasoles": [
    {
      "id": 11274,
      "keyword": "girasol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "giro": [
    {
      "id": 11275,
      "keyword": "giro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "giros": [
    {
      "id": 11275,
      "keyword": "giro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frutas de aragón": [
    {
      "id": 11268,
      "keyword": "frutas de Aragón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking",
        "Aragon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "granjera": [
    {
      "id": 11276,
      "keyword": "granjera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "granjeras": [
    {
      "id": 11276,
      "keyword": "granjera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "equilibrio": [
    {
      "id": 37976,
      "keyword": "equilibrio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39153,
      "keyword": "equilibrio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39154,
      "keyword": "equilibrio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11256,
      "keyword": "equilibrio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equilibrios": [
    {
      "id": 39154,
      "keyword": "equilibrio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11256,
      "keyword": "equilibrio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "eslalon": [
    {
      "id": 32520,
      "keyword": "eslalon",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11259,
      "keyword": "eslalon",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grapar": [
    {
      "id": 11277,
      "keyword": "grapar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hamburguesería": [
    {
      "id": 32402,
      "keyword": "hamburguesería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11281,
      "keyword": "hamburguesería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hamburgueserías": [
    {
      "id": 32402,
      "keyword": "hamburguesería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11281,
      "keyword": "hamburguesería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "informática": [
    {
      "id": 11284,
      "keyword": "informática",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "computing",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29112,
      "keyword": "informática",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "computing",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "informáticas": [
    {
      "id": 11284,
      "keyword": "informática",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "computing",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29112,
      "keyword": "informática",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "computing",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "herrera": [
    {
      "id": 11283,
      "keyword": "herrera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "craftsmanship",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "herreras": [
    {
      "id": 11283,
      "keyword": "herrera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "craftsmanship",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "heladera": [
    {
      "id": 11282,
      "keyword": "heladera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "heladeras": [
    {
      "id": 11282,
      "keyword": "heladera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "integración": [
    {
      "id": 22785,
      "keyword": "integración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22787,
      "keyword": "integración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11286,
      "keyword": "integración",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "invitar": [
    {
      "id": 16717,
      "keyword": "invitar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11287,
      "keyword": "invitar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "joyera": [
    {
      "id": 11289,
      "keyword": "joyera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "joyeras": [
    {
      "id": 11289,
      "keyword": "joyera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ingeniera": [
    {
      "id": 11285,
      "keyword": "ingeniera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "engineering",
        "tertiary sector",
        "professional services",
        "secondary sector",
        "industry",
        "manufacturing industry",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ingenieras": [
    {
      "id": 11285,
      "keyword": "ingeniera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "engineering",
        "tertiary sector",
        "professional services",
        "secondary sector",
        "industry",
        "manufacturing industry",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¡llueve!": [
    {
      "id": 10732,
      "keyword": "¡llueve!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38563,
      "keyword": "¡llueve!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡está lloviendo!": [
    {
      "id": 10732,
      "keyword": "¡está lloviendo!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38563,
      "keyword": "¡está lloviendo!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juez": [
    {
      "id": 37666,
      "keyword": "juez",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11291,
      "keyword": "juez",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jueces": [
    {
      "id": 37666,
      "keyword": "juez",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11291,
      "keyword": "juez",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "magistrado": [
    {
      "id": 37666,
      "keyword": "magistrado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11291,
      "keyword": "magistrado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "magistrados": [
    {
      "id": 37666,
      "keyword": "magistrado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11291,
      "keyword": "magistrado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "leñadora": [
    {
      "id": 11293,
      "keyword": "leñadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "forestry",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leñadoras": [
    {
      "id": 11293,
      "keyword": "leñadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "forestry",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ladrona": [
    {
      "id": 11292,
      "keyword": "ladrona",
      "keywords": 4,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ladronas": [
    {
      "id": 11292,
      "keyword": "ladrona",
      "keywords": 4,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bandida": [
    {
      "id": 11292,
      "keyword": "bandida",
      "keywords": 4,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bandidas": [
    {
      "id": 11292,
      "keyword": "bandida",
      "keywords": 4,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juego del pañuelo": [
    {
      "id": 25179,
      "keyword": "juego del pañuelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11290,
      "keyword": "juego del pañuelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marinera": [
    {
      "id": 11300,
      "keyword": "marinera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11338,
      "keyword": "marinera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marineras": [
    {
      "id": 11300,
      "keyword": "marinera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11338,
      "keyword": "marinera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mando a distancia": [
    {
      "id": 26182,
      "keyword": "mando a distancia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11299,
      "keyword": "mando a distancia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mandos a distancia": [
    {
      "id": 26182,
      "keyword": "mando a distancia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11299,
      "keyword": "mando a distancia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mando": [
    {
      "id": 26182,
      "keyword": "mando",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11299,
      "keyword": "mando",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mandos": [
    {
      "id": 26182,
      "keyword": "mando",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11299,
      "keyword": "mando",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mecánica": [
    {
      "id": 11301,
      "keyword": "mecánica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mecánicas": [
    {
      "id": 11301,
      "keyword": "mecánica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "loto": [
    {
      "id": 11295,
      "keyword": "loto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lotos": [
    {
      "id": 11295,
      "keyword": "loto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesa de colegio": [
    {
      "id": 11302,
      "keyword": "mesa de colegio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational equipment",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36285,
      "keyword": "mesa de colegio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational equipment",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas de colegio": [
    {
      "id": 11302,
      "keyword": "mesa de colegio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational equipment",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36285,
      "keyword": "mesa de colegio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational equipment",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huevo de chocolate": [
    {
      "id": 11304,
      "keyword": "huevo de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huevos de chocolate": [
    {
      "id": 11304,
      "keyword": "huevo de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mona de pascua": [
    {
      "id": 32478,
      "keyword": "mona de Pascua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12307,
      "keyword": "mona de Pascua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29678,
      "keyword": "mona de Pascua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11304,
      "keyword": "mona de Pascua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monas de pascua": [
    {
      "id": 32478,
      "keyword": "mona de Pascua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 12307,
      "keyword": "mona de Pascua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29678,
      "keyword": "mona de Pascua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11304,
      "keyword": "mona de Pascua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mandarina": [
    {
      "id": 11298,
      "keyword": "mandarina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mandarinas": [
    {
      "id": 11298,
      "keyword": "mandarina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maga": [
    {
      "id": 11296,
      "keyword": "maga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36299,
      "keyword": "maga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "scenic art",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "magas": [
    {
      "id": 11296,
      "keyword": "maga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36299,
      "keyword": "maga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "scenic art",
        "visual art"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "minera": [
    {
      "id": 11303,
      "keyword": "minera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "mining",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mineras": [
    {
      "id": 11303,
      "keyword": "minera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "mining",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bocado": [
    {
      "id": 11307,
      "keyword": "bocado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bocados": [
    {
      "id": 11307,
      "keyword": "bocado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mostrar": [
    {
      "id": 16823,
      "keyword": "mostrar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11308,
      "keyword": "mostrar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31902,
      "keyword": "mostrar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39430,
      "keyword": "mostrar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enseñar": [
    {
      "id": 16823,
      "keyword": "enseñar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26809,
      "keyword": "enseñar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11308,
      "keyword": "enseñar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31902,
      "keyword": "enseñar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39430,
      "keyword": "enseñar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muérdago": [
    {
      "id": 11590,
      "keyword": "muérdago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11309,
      "keyword": "muérdago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muérdagos": [
    {
      "id": 11590,
      "keyword": "muérdago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11309,
      "keyword": "muérdago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ni": [
    {
      "id": 11313,
      "keyword": "ni",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "conjunction",
        "copulative conjunction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "no nos entendemos": [
    {
      "id": 11315,
      "keyword": "no nos entendemos",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marchito": [
    {
      "id": 11310,
      "keyword": "marchito",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "plant",
        "plant physiology",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marchitos": [
    {
      "id": 11310,
      "keyword": "marchito",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "plant",
        "plant physiology",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "marchita": [
    {
      "id": 11310,
      "keyword": "marchita",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "plant",
        "plant physiology",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marchitas": [
    {
      "id": 11310,
      "keyword": "marchita",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "plant",
        "plant physiology",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ningunas": [
    {
      "id": 26941,
      "keyword": "ninguna",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11314,
      "keyword": "ninguna",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "core vocabulary",
        "pronoun",
        "indefinite pronoun",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nadie": [
    {
      "id": 11314,
      "keyword": "nadie",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "core vocabulary",
        "pronoun",
        "indefinite pronoun",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nervios": [
    {
      "id": 11312,
      "keyword": "nervios",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31095,
      "keyword": "nervios",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nervioso": [
    {
      "id": 30391,
      "keyword": "nervioso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "human response",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38930,
      "keyword": "nervioso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11312,
      "keyword": "nervioso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nerviosos": [
    {
      "id": 30391,
      "keyword": "nervioso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "human response",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38930,
      "keyword": "nervioso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11312,
      "keyword": "nervioso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "monstruo": [
    {
      "id": 11306,
      "keyword": "monstruo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature",
        "event",
        "popular event",
        "halloween",
        "object",
        "fashion",
        "clothes",
        "costume",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monstruos": [
    {
      "id": 11306,
      "keyword": "monstruo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature",
        "event",
        "popular event",
        "halloween",
        "object",
        "fashion",
        "clothes",
        "costume",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "objeto": [
    {
      "id": 11318,
      "keyword": "objeto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32582,
      "keyword": "objeto",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "objetos": [
    {
      "id": 11318,
      "keyword": "objetos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32582,
      "keyword": "objetos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "música": [
    {
      "id": 24791,
      "keyword": "música",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24795,
      "keyword": "música",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11311,
      "keyword": "música",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "músicas": [
    {
      "id": 24791,
      "keyword": "música",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24795,
      "keyword": "música",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11311,
      "keyword": "música",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palo": [
    {
      "id": 11322,
      "keyword": "palo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "material",
        "raw material",
        "vegetal origin material",
        "work",
        "secondary sector",
        "carpentry",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palos": [
    {
      "id": 11322,
      "keyword": "palo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "material",
        "raw material",
        "vegetal origin material",
        "work",
        "secondary sector",
        "carpentry",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vara": [
    {
      "id": 11322,
      "keyword": "vara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "material",
        "raw material",
        "vegetal origin material",
        "work",
        "secondary sector",
        "carpentry",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "varas": [
    {
      "id": 11322,
      "keyword": "vara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "material",
        "raw material",
        "vegetal origin material",
        "work",
        "secondary sector",
        "carpentry",
        "core vocabulary",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "monja": [
    {
      "id": 11305,
      "keyword": "monja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30824,
      "keyword": "monja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monjas": [
    {
      "id": 11305,
      "keyword": "monja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30824,
      "keyword": "monja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parado": [
    {
      "id": 11325,
      "keyword": "parado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parados": [
    {
      "id": 11325,
      "keyword": "parado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24505,
      "keyword": "parados",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desempleado": [
    {
      "id": 11325,
      "keyword": "desempleado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desempleados": [
    {
      "id": 11325,
      "keyword": "desempleado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24505,
      "keyword": "desempleados",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paro": [
    {
      "id": 11326,
      "keyword": "paro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paros": [
    {
      "id": 11326,
      "keyword": "paro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pasar lista": [
    {
      "id": 25301,
      "keyword": "pasar lista",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "students",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11328,
      "keyword": "pasar lista",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11327,
      "keyword": "pasar lista",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orquídea": [
    {
      "id": 11321,
      "keyword": "orquídea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orquídeas": [
    {
      "id": 11321,
      "keyword": "orquídea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "obra de teatro": [
    {
      "id": 11319,
      "keyword": "obra de teatro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "theater",
        "show",
        "leisure",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obras de teatro": [
    {
      "id": 11319,
      "keyword": "obra de teatro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "theater",
        "show",
        "leisure",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peludo": [
    {
      "id": 11332,
      "keyword": "peludo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peludos": [
    {
      "id": 11332,
      "keyword": "peludo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perejil": [
    {
      "id": 11334,
      "keyword": "perejil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perejiles": [
    {
      "id": 11334,
      "keyword": "perejil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pilota": [
    {
      "id": 11340,
      "keyword": "pilota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pilotas": [
    {
      "id": 11340,
      "keyword": "pilota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pescadora": [
    {
      "id": 11337,
      "keyword": "pescadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35235,
      "keyword": "pescadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11338,
      "keyword": "pescadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pescadoras": [
    {
      "id": 11337,
      "keyword": "pescadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11338,
      "keyword": "pescadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "política": [
    {
      "id": 11346,
      "keyword": "política",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11725,
      "keyword": "política",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "políticas": [
    {
      "id": 11346,
      "keyword": "política",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11725,
      "keyword": "política",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "psicóloga": [
    {
      "id": 38924,
      "keyword": "psicóloga",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32974,
      "keyword": "psicóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11350,
      "keyword": "psicóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "psicólogas": [
    {
      "id": 38924,
      "keyword": "psicóloga",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32974,
      "keyword": "psicóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11350,
      "keyword": "psicóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sicóloga": [
    {
      "id": 38924,
      "keyword": "sicóloga",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11350,
      "keyword": "sicóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sicólogas": [
    {
      "id": 38924,
      "keyword": "sicóloga",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11350,
      "keyword": "sicóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "que": [
    {
      "id": 11351,
      "keyword": "que",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "conjunction",
        "copulative conjunction",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "punto de lectura": [
    {
      "id": 11352,
      "keyword": "punto de lectura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 11352,
      "keyword": "punto de lectura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puntos de lectura": [
    {
      "id": 11352,
      "keyword": "punto de lectura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 11352,
      "keyword": "punto de lectura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prisionera": [
    {
      "id": 11349,
      "keyword": "prisionera",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prisioneras": [
    {
      "id": 11349,
      "keyword": "prisionera",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reclusa": [
    {
      "id": 11349,
      "keyword": "reclusa",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reclusas": [
    {
      "id": 11349,
      "keyword": "reclusa",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "convicta": [
    {
      "id": 11349,
      "keyword": "convicta",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "convictas": [
    {
      "id": 11349,
      "keyword": "convicta",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "presidiaria": [
    {
      "id": 11349,
      "keyword": "presidiaria",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presidiarias": [
    {
      "id": 11349,
      "keyword": "presidiaria",
      "keywords": 5,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quiosquera": [
    {
      "id": 11353,
      "keyword": "quiosquera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "publication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quiosqueras": [
    {
      "id": 11353,
      "keyword": "quiosquera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "publication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "kioskera": [
    {
      "id": 11353,
      "keyword": "kioskera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "publication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kioskeras": [
    {
      "id": 11353,
      "keyword": "kioskera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "publication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pizzería": [
    {
      "id": 32448,
      "keyword": "pizzería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11344,
      "keyword": "pizzería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pizzerías": [
    {
      "id": 32448,
      "keyword": "pizzería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11344,
      "keyword": "pizzería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rascar": [
    {
      "id": 37315,
      "keyword": "rascar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11356,
      "keyword": "rascar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "picor": [
    {
      "id": 11356,
      "keyword": "picor",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "picores": [
    {
      "id": 11356,
      "keyword": "picor",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "picazón": [
    {
      "id": 11356,
      "keyword": "picazón",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porque": [
    {
      "id": 11348,
      "keyword": "porque",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "conjunction",
        "causal conjunction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recordar": [
    {
      "id": 37369,
      "keyword": "recordar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11358,
      "keyword": "recordar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11357,
      "keyword": "recordar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acordarse": [
    {
      "id": 11358,
      "keyword": "acordarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11357,
      "keyword": "acordarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vídeo": [
    {
      "id": 26535,
      "keyword": "vídeo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11360,
      "keyword": "vídeo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vídeos": [
    {
      "id": 26535,
      "keyword": "vídeo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11360,
      "keyword": "vídeo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saco de juguetes": [
    {
      "id": 11363,
      "keyword": "saco de juguetes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacos de juguetes": [
    {
      "id": 11363,
      "keyword": "saco de juguetes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pesca": [
    {
      "id": 11339,
      "keyword": "pesca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ruleta": [
    {
      "id": 11362,
      "keyword": "ruleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "gambling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37961,
      "keyword": "ruleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "gambling",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ruletas": [
    {
      "id": 11362,
      "keyword": "ruleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "gambling"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37961,
      "keyword": "ruleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "gambling",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saltar a la pata coja": [
    {
      "id": 11366,
      "keyword": "saltar a la pata coja",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11365,
      "keyword": "saltar a la pata coja",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28445,
      "keyword": "saltar a la pata coja",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saltar con los pies juntos": [
    {
      "id": 11368,
      "keyword": "saltar con los pies juntos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11367,
      "keyword": "saltar con los pies juntos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28443,
      "keyword": "saltar con los pies juntos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sentar en el suelo": [
    {
      "id": 11370,
      "keyword": "sentar en el suelo",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "position",
        "education",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11369,
      "keyword": "sentar en el suelo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35031,
      "keyword": "sentar en el suelo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reloj de arena": [
    {
      "id": 11359,
      "keyword": "reloj de arena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "time",
        "chronological device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "relojes de arena": [
    {
      "id": 11359,
      "keyword": "reloj de arena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "time",
        "chronological device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salida": [
    {
      "id": 26412,
      "keyword": "salida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27248,
      "keyword": "salida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29622,
      "keyword": "salida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "educational space",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37332,
      "keyword": "salida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37684,
      "keyword": "salida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11364,
      "keyword": "salida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26411,
      "keyword": "salida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29621,
      "keyword": "salida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29620,
      "keyword": "salida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salidas": [
    {
      "id": 26412,
      "keyword": "salida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27248,
      "keyword": "salida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29622,
      "keyword": "salida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "educational space",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37332,
      "keyword": "salida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37684,
      "keyword": "salida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11364,
      "keyword": "salida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26411,
      "keyword": "salida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29621,
      "keyword": "salida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29620,
      "keyword": "salida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "raro": [
    {
      "id": 11355,
      "keyword": "raro",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32390,
      "keyword": "raro",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "raros": [
    {
      "id": 11355,
      "keyword": "raro",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32390,
      "keyword": "raro",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "extraño": [
    {
      "id": 11355,
      "keyword": "extraño",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32390,
      "keyword": "extraño",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "extraños": [
    {
      "id": 11355,
      "keyword": "extraño",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32390,
      "keyword": "extraño",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "extraña": [
    {
      "id": 11355,
      "keyword": "extraña",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32390,
      "keyword": "extraña",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "extrañas": [
    {
      "id": 11355,
      "keyword": "extraña",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32390,
      "keyword": "extraña",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rara": [
    {
      "id": 11355,
      "keyword": "rara",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32390,
      "keyword": "rara",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "raras": [
    {
      "id": 11355,
      "keyword": "rara",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32390,
      "keyword": "rara",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sentar en círculo": [
    {
      "id": 11372,
      "keyword": "sentar en círculo",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11371,
      "keyword": "sentar en círculo",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sentarse en círculo": [
    {
      "id": 11372,
      "keyword": "sentarse en círculo",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11371,
      "keyword": "sentarse en círculo",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sentarse en corro": [
    {
      "id": 11372,
      "keyword": "sentarse en corro",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11371,
      "keyword": "sentarse en corro",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sentados": [
    {
      "id": 11372,
      "keyword": "sentados",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11370,
      "keyword": "sentado",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "position",
        "education",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25082,
      "keyword": "sentado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "human body",
        "position",
        "person",
        "routine",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11371,
      "keyword": "sentados",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sentar en corro": [
    {
      "id": 11372,
      "keyword": "sentar en corro",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11371,
      "keyword": "sentar en corro",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "silla de colegio": [
    {
      "id": 11376,
      "keyword": "silla de colegio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational equipment",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas de colegio": [
    {
      "id": 11376,
      "keyword": "silla de colegio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational equipment",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pero": [
    {
      "id": 11377,
      "keyword": "pero",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "conjunction",
        "adversative conjunction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sin embargo": [
    {
      "id": 11377,
      "keyword": "sin embargo",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "conjunction",
        "adversative conjunction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soplete": [
    {
      "id": 11380,
      "keyword": "soplete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sopletes": [
    {
      "id": 11380,
      "keyword": "soplete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taquillero": [
    {
      "id": 11381,
      "keyword": "taquillero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taquilleros": [
    {
      "id": 11381,
      "keyword": "taquillero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarrina de helado": [
    {
      "id": 11382,
      "keyword": "tarrina de helado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarrinas de helado": [
    {
      "id": 11382,
      "keyword": "tarrina de helado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vasito": [
    {
      "id": 11382,
      "keyword": "vasito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vasitos": [
    {
      "id": 11382,
      "keyword": "vasito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sentar en el banco": [
    {
      "id": 11374,
      "keyword": "sentar en el banco",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30826,
      "keyword": "sentar en el banco",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11373,
      "keyword": "sentar en el banco",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35029,
      "keyword": "sentar en el banco",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de juguetes": [
    {
      "id": 11386,
      "keyword": "tienda de juguetes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "sport",
        "toy",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11385,
      "keyword": "tienda de juguetes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de juguetes": [
    {
      "id": 11386,
      "keyword": "tienda de juguetes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "sport",
        "toy",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11385,
      "keyword": "tienda de juguetes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juguetería": [
    {
      "id": 35697,
      "keyword": "juguetería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11386,
      "keyword": "juguetería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "sport",
        "toy",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11385,
      "keyword": "juguetería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugueterías": [
    {
      "id": 35697,
      "keyword": "juguetería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11386,
      "keyword": "juguetería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "sport",
        "toy",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11385,
      "keyword": "juguetería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sentado": [
    {
      "id": 11370,
      "keyword": "sentado",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "position",
        "education",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25082,
      "keyword": "sentado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "human body",
        "position",
        "person",
        "routine",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sentar en el piso": [
    {
      "id": 11370,
      "keyword": "sentar en el piso",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "position",
        "education",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sentada": [
    {
      "id": 11370,
      "keyword": "sentada",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "position",
        "education",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25081,
      "keyword": "sentada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "human body",
        "position",
        "person",
        "routine",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sentadas": [
    {
      "id": 11370,
      "keyword": "sentada",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "position",
        "education",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25081,
      "keyword": "sentada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "human body",
        "position",
        "person",
        "routine",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "torera": [
    {
      "id": 11387,
      "keyword": "torera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "bullfighting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toreras": [
    {
      "id": 11387,
      "keyword": "torera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "bullfighting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tronar": [
    {
      "id": 11389,
      "keyword": "tronar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "meteorology",
        "atmospheric phenomena",
        "communication",
        "language",
        "verb",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vajilla": [
    {
      "id": 11390,
      "keyword": "vajilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vajillas": [
    {
      "id": 11390,
      "keyword": "vajilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "veterinario": [
    {
      "id": 11392,
      "keyword": "veterinario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "veterinary medicine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veterinarios": [
    {
      "id": 11392,
      "keyword": "veterinario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "veterinary medicine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vendedora de chuches": [
    {
      "id": 11391,
      "keyword": "vendedora de chuches",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vendedoras de chuches": [
    {
      "id": 11391,
      "keyword": "vendedora de chuches",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "violeta": [
    {
      "id": 11395,
      "keyword": "violeta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34483,
      "keyword": "violeta",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "violetas": [
    {
      "id": 11395,
      "keyword": "violeta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34483,
      "keyword": "violeta",
      "keywords": 1,
      "type": 4,
      "tags": [
        "color"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "visita escolar": [
    {
      "id": 11396,
      "keyword": "visita escolar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "visitas escolares": [
    {
      "id": 11396,
      "keyword": "visita escolar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vivo": [
    {
      "id": 11397,
      "keyword": "vivo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "plant",
        "plant physiology",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vivos": [
    {
      "id": 11397,
      "keyword": "vivo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "plant",
        "plant physiology",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "viva": [
    {
      "id": 11397,
      "keyword": "viva",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "plant",
        "plant physiology",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vivas": [
    {
      "id": 11397,
      "keyword": "viva",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "plant",
        "plant physiology",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "viaje": [
    {
      "id": 32508,
      "keyword": "viaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "route",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11393,
      "keyword": "viaje",
      "keywords": 5,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viajes": [
    {
      "id": 32508,
      "keyword": "viaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "route",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11393,
      "keyword": "viaje",
      "keywords": 5,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trayecto": [
    {
      "id": 25648,
      "keyword": "trayecto",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11393,
      "keyword": "trayecto",
      "keywords": 5,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trayectos": [
    {
      "id": 25648,
      "keyword": "trayecto",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11393,
      "keyword": "trayecto",
      "keywords": 5,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recorrido": [
    {
      "id": 25648,
      "keyword": "recorrido",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11393,
      "keyword": "recorrido",
      "keywords": 5,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27406,
      "keyword": "recorrido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy",
        "leisure",
        "sport",
        "horse riding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recorridos": [
    {
      "id": 25648,
      "keyword": "recorrido",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11393,
      "keyword": "recorrido",
      "keywords": 5,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27406,
      "keyword": "recorrido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy",
        "leisure",
        "sport",
        "horse riding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "itinerario": [
    {
      "id": 25648,
      "keyword": "itinerario",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11393,
      "keyword": "itinerario",
      "keywords": 5,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "itinerarios": [
    {
      "id": 25648,
      "keyword": "itinerario",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11393,
      "keyword": "itinerario",
      "keywords": 5,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ruta": [
    {
      "id": 25648,
      "keyword": "ruta",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11393,
      "keyword": "ruta",
      "keywords": 5,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rutas": [
    {
      "id": 25648,
      "keyword": "ruta",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11393,
      "keyword": "ruta",
      "keywords": 5,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zambomba": [
    {
      "id": 11400,
      "keyword": "zambomba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zambombas": [
    {
      "id": 11400,
      "keyword": "zambomba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zapatera": [
    {
      "id": 11401,
      "keyword": "zapatera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38577,
      "keyword": "zapatera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "craftsmanship",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zapateras": [
    {
      "id": 11401,
      "keyword": "zapatera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38577,
      "keyword": "zapatera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "craftsmanship",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zuecos": [
    {
      "id": 11402,
      "keyword": "zuecos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35639,
      "keyword": "zuecos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36606,
      "keyword": "zueco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38693,
      "keyword": "zueco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zumo de tomate": [
    {
      "id": 11404,
      "keyword": "zumo de tomate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zumos de tomate": [
    {
      "id": 11404,
      "keyword": "zumo de tomate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zumo de manzana": [
    {
      "id": 11403,
      "keyword": "zumo de manzana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zumos de manzana": [
    {
      "id": 11403,
      "keyword": "zumo de manzana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "voltereta": [
    {
      "id": 11398,
      "keyword": "voltereta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "volteretas": [
    {
      "id": 11398,
      "keyword": "voltereta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "igualdad de oportunidades": [
    {
      "id": 11455,
      "keyword": "igualdad de oportunidades",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11468,
      "keyword": "igualdad de oportunidades",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11701,
      "keyword": "igualdad de oportunidades",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mercado laboral": [
    {
      "id": 11457,
      "keyword": "mercado laboral",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mercados laborales": [
    {
      "id": 11457,
      "keyword": "mercado laboral",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mercado de trabajo": [
    {
      "id": 11457,
      "keyword": "mercado de trabajo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mercadoz de trabajo": [
    {
      "id": 11457,
      "keyword": "mercado de trabajo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "empleo": [
    {
      "id": 11457,
      "keyword": "empleo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empleos": [
    {
      "id": 11457,
      "keyword": "empleo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tecnología": [
    {
      "id": 36375,
      "keyword": "tecnología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11459,
      "keyword": "tecnología",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tecnologías": [
    {
      "id": 11459,
      "keyword": "tecnología",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "computing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zumo": [
    {
      "id": 11461,
      "keyword": "zumo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11463,
      "keyword": "zumo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zumos": [
    {
      "id": 11461,
      "keyword": "zumo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11463,
      "keyword": "zumo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugo": [
    {
      "id": 11461,
      "keyword": "jugo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11463,
      "keyword": "jugo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugos": [
    {
      "id": 11461,
      "keyword": "jugo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11463,
      "keyword": "jugo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "accesible": [
    {
      "id": 11465,
      "keyword": "accesible",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "accesibles": [
    {
      "id": 11465,
      "keyword": "accesible",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llevar en silla de ruedas": [
    {
      "id": 11467,
      "keyword": "llevar en silla de ruedas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11466,
      "keyword": "llevar en silla de ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32288,
      "keyword": "llevar en silla de ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33930,
      "keyword": "llevar en silla de ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33931,
      "keyword": "llevar en silla de ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zumo de uva": [
    {
      "id": 11405,
      "keyword": "zumo de uva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zumos de uva": [
    {
      "id": 11405,
      "keyword": "zumo de uva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zapatillas de ballet": [
    {
      "id": 11406,
      "keyword": "zapatillas de ballet",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "dependiente": [
    {
      "id": 11467,
      "keyword": "dependiente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34878,
      "keyword": "dependiente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 20123,
      "keyword": "dependiente",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37808,
      "keyword": "dependiente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dependientes": [
    {
      "id": 11467,
      "keyword": "dependiente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34878,
      "keyword": "dependiente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 20123,
      "keyword": "dependiente",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37808,
      "keyword": "dependiente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comunidad educativa": [
    {
      "id": 11453,
      "keyword": "comunidad educativa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ley": [
    {
      "id": 11473,
      "keyword": "ley",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "work",
        "tertiary sector",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leyes": [
    {
      "id": 11473,
      "keyword": "ley",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "work",
        "tertiary sector",
        "justice"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "legal": [
    {
      "id": 11473,
      "keyword": "legal",
      "keywords": 2,
      "type": 4,
      "tags": [
        "law",
        "work",
        "tertiary sector",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "legales": [
    {
      "id": 11473,
      "keyword": "legal",
      "keywords": 2,
      "type": 4,
      "tags": [
        "law",
        "work",
        "tertiary sector",
        "justice"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mejor": [
    {
      "id": 11470,
      "keyword": "mejor",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion",
        "character",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22627,
      "keyword": "mejor",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39515,
      "keyword": "mejor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mejores": [
    {
      "id": 11470,
      "keyword": "mejor",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion",
        "character",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22627,
      "keyword": "mejor",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "importante": [
    {
      "id": 11470,
      "keyword": "importante",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion",
        "character",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22627,
      "keyword": "importante",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion",
        "object"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11471,
      "keyword": "importante",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "importantes": [
    {
      "id": 11470,
      "keyword": "importante",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion",
        "character",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22627,
      "keyword": "importante",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion",
        "object"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11471,
      "keyword": "importante",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "admirar": [
    {
      "id": 11470,
      "keyword": "admirar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion",
        "character",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22627,
      "keyword": "admirar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "participar": [
    {
      "id": 11475,
      "keyword": "participar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "libre": [
    {
      "id": 11474,
      "keyword": "libre",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "libres": [
    {
      "id": 11474,
      "keyword": "libre",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "liberar": [
    {
      "id": 37783,
      "keyword": "liberar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "wild",
        "pet"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11474,
      "keyword": "liberar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sentimientos": [
    {
      "id": 11476,
      "keyword": "sentimientos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12359,
      "keyword": "sentimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "resaltado": [
    {
      "id": 11471,
      "keyword": "resaltado",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "resaltados": [
    {
      "id": 11471,
      "keyword": "resaltado",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "resaltada": [
    {
      "id": 11471,
      "keyword": "resaltada",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "resaltadas": [
    {
      "id": 11471,
      "keyword": "resaltada",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "destacado": [
    {
      "id": 11471,
      "keyword": "destacado",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "destacados": [
    {
      "id": 11471,
      "keyword": "destacado",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "destacada": [
    {
      "id": 11471,
      "keyword": "destacada",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "destacadas": [
    {
      "id": 11471,
      "keyword": "destacada",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alborada": [
    {
      "id": 11477,
      "keyword": "alborada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alboradas": [
    {
      "id": 11477,
      "keyword": "alborada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "independiente": [
    {
      "id": 11703,
      "keyword": "independiente",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30251,
      "keyword": "independiente",
      "keywords": 3,
      "type": 4,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35893,
      "keyword": "independiente",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11472,
      "keyword": "independiente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "independientes": [
    {
      "id": 11703,
      "keyword": "independiente",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30251,
      "keyword": "independiente",
      "keywords": 3,
      "type": 4,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35893,
      "keyword": "independiente",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11472,
      "keyword": "independiente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "autónomo": [
    {
      "id": 11703,
      "keyword": "autónomo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11472,
      "keyword": "autónomo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autónomos": [
    {
      "id": 11703,
      "keyword": "autónomo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11472,
      "keyword": "autónomo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "independencia": [
    {
      "id": 11484,
      "keyword": "independencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dependencia": [
    {
      "id": 11481,
      "keyword": "dependencia",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "participación": [
    {
      "id": 11486,
      "keyword": "participación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "participaciones": [
    {
      "id": 11486,
      "keyword": "participación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estados parte": [
    {
      "id": 11469,
      "keyword": "estados parte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "international organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "accesibilidad": [
    {
      "id": 11478,
      "keyword": "accesibilidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "española": [
    {
      "id": 11535,
      "keyword": "española",
      "keywords": 1,
      "type": 4,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "españolas": [
    {
      "id": 11535,
      "keyword": "española",
      "keywords": 1,
      "type": 4,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "libertad": [
    {
      "id": 11488,
      "keyword": "libertad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "libertades": [
    {
      "id": 11488,
      "keyword": "libertad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "liberación": [
    {
      "id": 11488,
      "keyword": "liberación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "liberaciones": [
    {
      "id": 11488,
      "keyword": "liberación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "español": [
    {
      "id": 11534,
      "keyword": "español",
      "keywords": 1,
      "type": 4,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11533,
      "keyword": "español",
      "keywords": 1,
      "type": 4,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "españoles": [
    {
      "id": 11534,
      "keyword": "español",
      "keywords": 1,
      "type": 4,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11533,
      "keyword": "español",
      "keywords": 1,
      "type": 4,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "viajar en cohete ": [
    {
      "id": 11544,
      "keyword": "viajar en cohete ",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "route"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recorrer en cohete ": [
    {
      "id": 11544,
      "keyword": "recorrer en cohete ",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "route"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viajar en bici": [
    {
      "id": 11542,
      "keyword": "viajar en bici",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recorrer en bici": [
    {
      "id": 11542,
      "keyword": "recorrer en bici",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bisexual": [
    {
      "id": 11562,
      "keyword": "bisexual",
      "keywords": 2,
      "type": 4,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11563,
      "keyword": "bisexual",
      "keywords": 2,
      "type": 4,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11558,
      "keyword": "bisexual",
      "keywords": 2,
      "type": 4,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11559,
      "keyword": "bisexual",
      "keywords": 2,
      "type": 4,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bisexuales": [
    {
      "id": 11562,
      "keyword": "bisexual",
      "keywords": 2,
      "type": 4,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11563,
      "keyword": "bisexual",
      "keywords": 2,
      "type": 4,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11558,
      "keyword": "bisexual",
      "keywords": 2,
      "type": 4,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11559,
      "keyword": "bisexual",
      "keywords": 2,
      "type": 4,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bisexualidad": [
    {
      "id": 11562,
      "keyword": "bisexualidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11563,
      "keyword": "bisexualidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11558,
      "keyword": "bisexualidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11559,
      "keyword": "bisexualidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "transexualidad": [
    {
      "id": 11566,
      "keyword": "transexualidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "sexuality",
        "gender identity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11568,
      "keyword": "transexualidad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "sexuality",
        "gender identity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11570,
      "keyword": "transexualidad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "sexuality",
        "gender identity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "transexuales": [
    {
      "id": 11566,
      "keyword": "transexuales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "sexuality",
        "gender identity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11568,
      "keyword": "transexual",
      "keywords": 3,
      "type": 4,
      "tags": [
        "sexuality",
        "gender identity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11568,
      "keyword": "transexual",
      "keywords": 3,
      "type": 2,
      "tags": [
        "sexuality",
        "gender identity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11570,
      "keyword": "transexual",
      "keywords": 3,
      "type": 4,
      "tags": [
        "sexuality",
        "gender identity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11570,
      "keyword": "transexual",
      "keywords": 3,
      "type": 2,
      "tags": [
        "sexuality",
        "gender identity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "transexual": [
    {
      "id": 11568,
      "keyword": "transexual",
      "keywords": 3,
      "type": 4,
      "tags": [
        "sexuality",
        "gender identity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11568,
      "keyword": "transexual",
      "keywords": 3,
      "type": 2,
      "tags": [
        "sexuality",
        "gender identity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11570,
      "keyword": "transexual",
      "keywords": 3,
      "type": 4,
      "tags": [
        "sexuality",
        "gender identity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11570,
      "keyword": "transexual",
      "keywords": 3,
      "type": 2,
      "tags": [
        "sexuality",
        "gender identity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "homosexual": [
    {
      "id": 11556,
      "keyword": "homosexual",
      "keywords": 5,
      "type": 4,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11554,
      "keyword": "homosexual",
      "keywords": 6,
      "type": 4,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11554,
      "keyword": "homosexual",
      "keywords": 6,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "homosexuales": [
    {
      "id": 11556,
      "keyword": "homosexual",
      "keywords": 5,
      "type": 4,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11554,
      "keyword": "homosexual",
      "keywords": 6,
      "type": 4,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11554,
      "keyword": "homosexual",
      "keywords": 6,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11554,
      "keyword": "homosexuales",
      "keywords": 6,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "homosexualidad": [
    {
      "id": 11556,
      "keyword": "homosexualidad",
      "keywords": 5,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11554,
      "keyword": "homosexualidad",
      "keywords": 6,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gay": [
    {
      "id": 11554,
      "keyword": "gay",
      "keywords": 6,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gays": [
    {
      "id": 11554,
      "keyword": "gay",
      "keywords": 6,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11554,
      "keyword": "gays",
      "keywords": 6,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "elecciones": [
    {
      "id": 14670,
      "keyword": "elección",
      "keywords": 4,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11580,
      "keyword": "elecciones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gratis": [
    {
      "id": 11582,
      "keyword": "gratis",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11699,
      "keyword": "gratis",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gratuito": [
    {
      "id": 11582,
      "keyword": "gratuito",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11699,
      "keyword": "gratuito",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gratuitos": [
    {
      "id": 11582,
      "keyword": "gratuito",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11699,
      "keyword": "gratuito",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gratuita": [
    {
      "id": 11582,
      "keyword": "gratuita",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11699,
      "keyword": "gratuita",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gratuitas": [
    {
      "id": 11582,
      "keyword": "gratuita",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11699,
      "keyword": "gratuita",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lesbianismo": [
    {
      "id": 11556,
      "keyword": "lesbianismo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lesbiana": [
    {
      "id": 11556,
      "keyword": "lesbiana",
      "keywords": 5,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lesbianas": [
    {
      "id": 11556,
      "keyword": "lesbiana",
      "keywords": 5,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11556,
      "keyword": "lesbianas",
      "keywords": 5,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "concierto": [
    {
      "id": 11586,
      "keyword": "concierto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11584,
      "keyword": "concierto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11588,
      "keyword": "concierto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14532,
      "keyword": "concierto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38296,
      "keyword": "concierto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conciertos": [
    {
      "id": 11586,
      "keyword": "concierto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11584,
      "keyword": "concierto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11588,
      "keyword": "concierto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 14532,
      "keyword": "concierto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38296,
      "keyword": "concierto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "viajar en autobús": [
    {
      "id": 36903,
      "keyword": "viajar en autobús",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36962,
      "keyword": "viajar en autobús",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36963,
      "keyword": "viajar en autobús",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11540,
      "keyword": "viajar en autobús",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36960,
      "keyword": "viajar en autobús",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36961,
      "keyword": "viajar en autobús",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recorrer en autobús": [
    {
      "id": 11540,
      "keyword": "recorrer en autobús",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "no tocar": [
    {
      "id": 11595,
      "keyword": "no tocar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡no toques!": [
    {
      "id": 11595,
      "keyword": "¡no toques!",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "no toques": [
    {
      "id": 11595,
      "keyword": "no toques",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡yo, tampoco!": [
    {
      "id": 11593,
      "keyword": "¡yo, tampoco!",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary",
        "adverb",
        "adverb of denial"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yo, tampoco": [
    {
      "id": 11593,
      "keyword": "yo, tampoco",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary",
        "adverb",
        "adverb of denial"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tampoco": [
    {
      "id": 11593,
      "keyword": "tampoco",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary",
        "adverb",
        "adverb of denial"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡yo, también!": [
    {
      "id": 11591,
      "keyword": "¡yo, también!",
      "keywords": 4,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yo, también": [
    {
      "id": 11591,
      "keyword": "yo, también",
      "keywords": 4,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "también": [
    {
      "id": 11591,
      "keyword": "también",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "además": [
    {
      "id": 11591,
      "keyword": "además",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿cómo te va?": [
    {
      "id": 11597,
      "keyword": "¿cómo te va?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿qué tal?": [
    {
      "id": 11597,
      "keyword": "¿qué tal?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "éxito": [
    {
      "id": 11599,
      "keyword": "éxito",
      "keywords": 8,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38564,
      "keyword": "éxito",
      "keywords": 8,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23371,
      "keyword": "éxito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "éxitos": [
    {
      "id": 11599,
      "keyword": "éxito",
      "keywords": 8,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23371,
      "keyword": "éxito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¡muy guay!": [
    {
      "id": 11599,
      "keyword": "¡muy guay!",
      "keywords": 8,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38564,
      "keyword": "¡muy guay!",
      "keywords": 8,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡fantástico!": [
    {
      "id": 11599,
      "keyword": "¡fantástico!",
      "keywords": 8,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38564,
      "keyword": "¡fantástico!",
      "keywords": 8,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡genial!": [
    {
      "id": 11599,
      "keyword": "¡genial!",
      "keywords": 8,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38564,
      "keyword": "¡genial!",
      "keywords": 8,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "genial": [
    {
      "id": 11599,
      "keyword": "genial",
      "keywords": 8,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38564,
      "keyword": "genial",
      "keywords": 8,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fantástico": [
    {
      "id": 11599,
      "keyword": "fantástico",
      "keywords": 8,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38564,
      "keyword": "fantástico",
      "keywords": 8,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muy bien": [
    {
      "id": 11599,
      "keyword": "muy bien",
      "keywords": 8,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38564,
      "keyword": "muy bien",
      "keywords": 8,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡muy bien!": [
    {
      "id": 11599,
      "keyword": "¡muy bien!",
      "keywords": 8,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38564,
      "keyword": "¡muy bien!",
      "keywords": 8,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "proponer": [
    {
      "id": 39150,
      "keyword": "proponer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11576,
      "keyword": "proponer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sugerir": [
    {
      "id": 39150,
      "keyword": "sugerir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11576,
      "keyword": "sugerir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sugerencia": [
    {
      "id": 39150,
      "keyword": "sugerencia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11576,
      "keyword": "sugerencia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sugerencias": [
    {
      "id": 39150,
      "keyword": "sugerencia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11576,
      "keyword": "sugerencia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿qué estudias?": [
    {
      "id": 11607,
      "keyword": "¿qué estudias?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿lo ves?": [
    {
      "id": 11617,
      "keyword": "¿lo ves?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11619,
      "keyword": "¿lo ves?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿lo has visto?": [
    {
      "id": 11617,
      "keyword": "¿lo has visto?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11619,
      "keyword": "¿lo has visto?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "respetar": [
    {
      "id": 11621,
      "keyword": "respetar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36720,
      "keyword": "respetar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿cuál es tu profesión?": [
    {
      "id": 11601,
      "keyword": "¿cuál es tu profesión?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿en qué trabajas?": [
    {
      "id": 37330,
      "keyword": "¿en qué trabajas?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11601,
      "keyword": "¿en qué trabajas?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿cuál es tu trabajo?": [
    {
      "id": 11601,
      "keyword": "¿cuál es tu trabajo?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lo siento": [
    {
      "id": 11625,
      "keyword": "lo siento",
      "keywords": 6,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "psychology",
        "human value",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38360,
      "keyword": "lo siento",
      "keywords": 6,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38361,
      "keyword": "lo siento",
      "keywords": 6,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perdonar": [
    {
      "id": 11625,
      "keyword": "perdonar",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "psychology",
        "human value",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38360,
      "keyword": "perdonar",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38361,
      "keyword": "perdonar",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡lo siento!": [
    {
      "id": 11625,
      "keyword": "¡lo siento!",
      "keywords": 6,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "psychology",
        "human value",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38360,
      "keyword": "¡lo siento!",
      "keywords": 6,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38361,
      "keyword": "¡lo siento!",
      "keywords": 6,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡perdón!": [
    {
      "id": 11625,
      "keyword": "¡perdón!",
      "keywords": 6,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "psychology",
        "human value",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38360,
      "keyword": "¡perdón!",
      "keywords": 6,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38361,
      "keyword": "¡perdón!",
      "keywords": 6,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perdón": [
    {
      "id": 11625,
      "keyword": "perdón",
      "keywords": 6,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "psychology",
        "human value",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38360,
      "keyword": "perdón",
      "keywords": 6,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38361,
      "keyword": "perdón",
      "keywords": 6,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pedir perdón": [
    {
      "id": 11625,
      "keyword": "pedir perdón",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "psychology",
        "human value",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38360,
      "keyword": "pedir perdón",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38361,
      "keyword": "pedir perdón",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡buen provecho!": [
    {
      "id": 11627,
      "keyword": "¡buen provecho!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡que aproveche!": [
    {
      "id": 11627,
      "keyword": "¡que aproveche!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soltera": [
    {
      "id": 37787,
      "keyword": "soltera",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11629,
      "keyword": "soltera",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11631,
      "keyword": "soltera",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "solteras": [
    {
      "id": 37787,
      "keyword": "soltera",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11629,
      "keyword": "soltera",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11631,
      "keyword": "soltera",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ganador": [
    {
      "id": 11578,
      "keyword": "ganador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ganadores": [
    {
      "id": 11578,
      "keyword": "ganador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿dónde vives?": [
    {
      "id": 11603,
      "keyword": "¿dónde vives?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30231,
      "keyword": "¿dónde vives?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "document",
        "supporting document",
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38571,
      "keyword": "¿dónde vives?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿cuál es tu dirección?": [
    {
      "id": 11603,
      "keyword": "¿cuál es tu dirección?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30231,
      "keyword": "¿cuál es tu dirección?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "document",
        "supporting document",
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38571,
      "keyword": "¿cuál es tu dirección?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soltero": [
    {
      "id": 37788,
      "keyword": "soltero",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11633,
      "keyword": "soltero",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11635,
      "keyword": "soltero",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "solteros": [
    {
      "id": 37788,
      "keyword": "soltero",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11633,
      "keyword": "soltero",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11635,
      "keyword": "soltero",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "viuda": [
    {
      "id": 11637,
      "keyword": "viuda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11639,
      "keyword": "viuda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viudas": [
    {
      "id": 11637,
      "keyword": "viuda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11639,
      "keyword": "viuda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "viudo": [
    {
      "id": 11641,
      "keyword": "viudo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11643,
      "keyword": "viudo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viudos": [
    {
      "id": 11641,
      "keyword": "viudo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11643,
      "keyword": "viudo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¡es gracioso!": [
    {
      "id": 11645,
      "keyword": "¡es gracioso!",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿cuál es tu email?": [
    {
      "id": 11613,
      "keyword": "¿cuál es tu email?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "computing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27351,
      "keyword": "¿cuál es tu email?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "computing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38574,
      "keyword": "¿cuál es tu email?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿cuál es tu dirección de correo electrónico?": [
    {
      "id": 11613,
      "keyword": "¿cuál es tu dirección de correo electrónico?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "computing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27351,
      "keyword": "¿cuál es tu dirección de correo electrónico?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "computing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38574,
      "keyword": "¿cuál es tu dirección de correo electrónico?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "material de educación física": [
    {
      "id": 11649,
      "keyword": "material de educación física",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "leisure",
        "sport",
        "sport material",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "materiales de educación física": [
    {
      "id": 11649,
      "keyword": "material de educación física",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "leisure",
        "sport",
        "sport material",
        "physical exercise"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ceguera": [
    {
      "id": 11615,
      "keyword": "ceguera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cegueras": [
    {
      "id": 11615,
      "keyword": "ceguera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esplai": [
    {
      "id": 11647,
      "keyword": "ESPLAI",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monitor de taller": [
    {
      "id": 11651,
      "keyword": "monitor de taller",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monitores de taller": [
    {
      "id": 11651,
      "keyword": "monitor de taller",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "voz digitalizada": [
    {
      "id": 11685,
      "keyword": "voz digitalizada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "voces digitalizadas": [
    {
      "id": 11685,
      "keyword": "voz digitalizada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "voz sintetizada": [
    {
      "id": 11685,
      "keyword": "voz sintetizada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "voces sintetizadas": [
    {
      "id": 11685,
      "keyword": "voz sintetizada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adaptar": [
    {
      "id": 11687,
      "keyword": "adaptar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "special education",
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "censurar": [
    {
      "id": 11688,
      "keyword": "censurar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31921,
      "keyword": "censurar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desarrollar": [
    {
      "id": 11683,
      "keyword": "desarrollar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39286,
      "keyword": "desarrollar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiempo libre": [
    {
      "id": 11653,
      "keyword": "tiempo libre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiempos libres": [
    {
      "id": 11653,
      "keyword": "tiempo libre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ocio": [
    {
      "id": 11653,
      "keyword": "ocio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuidar": [
    {
      "id": 16633,
      "keyword": "cuidar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11691,
      "keyword": "cuidar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11692,
      "keyword": "cuidar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soi": [
    {
      "id": 11657,
      "keyword": "SOI",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "servicio ocupacional de inserción": [
    {
      "id": 11657,
      "keyword": "Servicio Ocupacional de Inserción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "servicios ocupacionales de inserción": [
    {
      "id": 11657,
      "keyword": "Servicio Ocupacional de Inserción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿qué dices?": [
    {
      "id": 11611,
      "keyword": "¿qué dices?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿qué has dicho?": [
    {
      "id": 11611,
      "keyword": "¿qué has dicho?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿qué dice?": [
    {
      "id": 11611,
      "keyword": "¿qué dice?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "duda": [
    {
      "id": 11696,
      "keyword": "duda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39420,
      "keyword": "duda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dudas": [
    {
      "id": 11696,
      "keyword": "duda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39420,
      "keyword": "duda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dudar": [
    {
      "id": 11696,
      "keyword": "dudar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "psychology",
        "human response",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39420,
      "keyword": "dudar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "psychology",
        "human response",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "convención": [
    {
      "id": 11689,
      "keyword": "convención",
      "keywords": 1,
      "type": 2,
      "tags": [
        "international organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "convenciones": [
    {
      "id": 11689,
      "keyword": "convención",
      "keywords": 1,
      "type": 2,
      "tags": [
        "international organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dignidad": [
    {
      "id": 11695,
      "keyword": "dignidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entender": [
    {
      "id": 16659,
      "keyword": "entender",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11697,
      "keyword": "entender",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comprender": [
    {
      "id": 16659,
      "keyword": "comprender",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11697,
      "keyword": "comprender",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comprensible": [
    {
      "id": 16659,
      "keyword": "comprensible",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11697,
      "keyword": "comprensible",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comprensibles": [
    {
      "id": 16659,
      "keyword": "comprensible",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11697,
      "keyword": "comprensible",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "entendible": [
    {
      "id": 16659,
      "keyword": "entendible",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11697,
      "keyword": "entendible",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entendibles": [
    {
      "id": 16659,
      "keyword": "entendible",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11697,
      "keyword": "entendible",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inteligible": [
    {
      "id": 16659,
      "keyword": "inteligible",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11697,
      "keyword": "inteligible",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inteligibles": [
    {
      "id": 16659,
      "keyword": "inteligible",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11697,
      "keyword": "inteligible",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "seleccionar": [
    {
      "id": 11694,
      "keyword": "seleccionar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30510,
      "keyword": "seleccionar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "decidir": [
    {
      "id": 11694,
      "keyword": "decidir",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30510,
      "keyword": "decidir",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37861,
      "keyword": "decidir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "preferir": [
    {
      "id": 11694,
      "keyword": "preferir",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30510,
      "keyword": "preferir",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "producir": [
    {
      "id": 11698,
      "keyword": "producir",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crear": [
    {
      "id": 11698,
      "keyword": "crear",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "elaborar": [
    {
      "id": 11698,
      "keyword": "elaborar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fabricar": [
    {
      "id": 11698,
      "keyword": "fabricar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "montar": [
    {
      "id": 35205,
      "keyword": "montar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11698,
      "keyword": "montar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "heredar": [
    {
      "id": 16715,
      "keyword": "heredar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11700,
      "keyword": "heredar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "herencia": [
    {
      "id": 16715,
      "keyword": "herencia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11700,
      "keyword": "herencia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "herencias": [
    {
      "id": 16715,
      "keyword": "herencia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11700,
      "keyword": "herencia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cultura": [
    {
      "id": 11693,
      "keyword": "cultura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "culture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "culturas": [
    {
      "id": 11693,
      "keyword": "cultura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "culture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mejorar": [
    {
      "id": 11705,
      "keyword": "mejorar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rehabilitar": [
    {
      "id": 32796,
      "keyword": "rehabilitar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11707,
      "keyword": "rehabilitar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "planificar": [
    {
      "id": 35671,
      "keyword": "planificar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11706,
      "keyword": "planificar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35651,
      "keyword": "planificar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "incluir": [
    {
      "id": 22783,
      "keyword": "incluir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35041,
      "keyword": "incluir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11702,
      "keyword": "incluir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "integrar": [
    {
      "id": 22783,
      "keyword": "integrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35041,
      "keyword": "integrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11702,
      "keyword": "integrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sto": [
    {
      "id": 11659,
      "keyword": "STO",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "occupational therapy",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "servicio de terapia ocupacional": [
    {
      "id": 11659,
      "keyword": "Servicio de Terapia Ocupacional",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "occupational therapy",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16061,
      "keyword": "Servicio de Terapia Ocupacional",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "occupational therapy",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "servicios de terapia ocupacional": [
    {
      "id": 11659,
      "keyword": "Servicio de Terapia Ocupacional",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "occupational therapy",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16061,
      "keyword": "Servicio de Terapia Ocupacional",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "occupational therapy",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jubilar": [
    {
      "id": 16719,
      "keyword": "jubilar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11704,
      "keyword": "jubilar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39111,
      "keyword": "jubilar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jubilarse": [
    {
      "id": 16719,
      "keyword": "jubilarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11704,
      "keyword": "jubilarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39111,
      "keyword": "jubilarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "venir": [
    {
      "id": 32669,
      "keyword": "venir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13356,
      "keyword": "venir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11708,
      "keyword": "venir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acudir": [
    {
      "id": 13356,
      "keyword": "acudir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11708,
      "keyword": "acudir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llegar": [
    {
      "id": 16807,
      "keyword": "llegar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13356,
      "keyword": "llegar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16805,
      "keyword": "llegar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11708,
      "keyword": "llegar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "al": [
    {
      "id": 11709,
      "keyword": "al",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "article"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "del": [
    {
      "id": 11712,
      "keyword": "del",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "preposition",
        "article"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "descripción": [
    {
      "id": 11713,
      "keyword": "descripción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11715,
      "keyword": "descripción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11717,
      "keyword": "descripción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11719,
      "keyword": "descripción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "descripciones": [
    {
      "id": 11713,
      "keyword": "descripción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11715,
      "keyword": "descripción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11717,
      "keyword": "descripción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11719,
      "keyword": "descripción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "autónoma": [
    {
      "id": 11703,
      "keyword": "autónoma",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autónomas": [
    {
      "id": 11703,
      "keyword": "autónoma",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "discapacidad": [
    {
      "id": 11721,
      "keyword": "discapacidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24513,
      "keyword": "discapacidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "discapacidades": [
    {
      "id": 11721,
      "keyword": "discapacidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24513,
      "keyword": "discapacidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "familia adoptiva": [
    {
      "id": 24517,
      "keyword": "familia adoptiva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11728,
      "keyword": "familia adoptiva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "familias adoptivas": [
    {
      "id": 24517,
      "keyword": "familia adoptiva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11728,
      "keyword": "familia adoptiva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "familia monoparental": [
    {
      "id": 24521,
      "keyword": "familia monoparental",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24519,
      "keyword": "familia monoparental",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11729,
      "keyword": "familia monoparental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11731,
      "keyword": "familia monoparental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37346,
      "keyword": "familia monoparental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37352,
      "keyword": "familia monoparental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37353,
      "keyword": "familia monoparental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37354,
      "keyword": "familia monoparental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "familias monoparentales": [
    {
      "id": 24521,
      "keyword": "familia monoparental",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24519,
      "keyword": "familia monoparental",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11729,
      "keyword": "familia monoparental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11731,
      "keyword": "familia monoparental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37346,
      "keyword": "familia monoparental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37352,
      "keyword": "familia monoparental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37353,
      "keyword": "familia monoparental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37354,
      "keyword": "familia monoparental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "familia homoparental": [
    {
      "id": 11733,
      "keyword": "familia homoparental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11735,
      "keyword": "familia homoparental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "familias homoparentales": [
    {
      "id": 11733,
      "keyword": "familia homoparental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 11735,
      "keyword": "familia homoparental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "economía": [
    {
      "id": 36364,
      "keyword": "economía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11723,
      "keyword": "economía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrir el grifo": [
    {
      "id": 11737,
      "keyword": "abrir el grifo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21341,
      "keyword": "abrir el grifo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36265,
      "keyword": "abrir el grifo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36868,
      "keyword": "abrir el grifo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37017,
      "keyword": "abrir el grifo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrir la canilla": [
    {
      "id": 11737,
      "keyword": "abrir la canilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21341,
      "keyword": "abrir la canilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36265,
      "keyword": "abrir la canilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36868,
      "keyword": "abrir la canilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37017,
      "keyword": "abrir la canilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coger del lavabo": [
    {
      "id": 11741,
      "keyword": "coger del lavabo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner el cepillo": [
    {
      "id": 11744,
      "keyword": "poner el cepillo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colocar el cepillo": [
    {
      "id": 11744,
      "keyword": "colocar el cepillo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner la toalla": [
    {
      "id": 11745,
      "keyword": "poner la toalla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colocar la toalla": [
    {
      "id": 11745,
      "keyword": "colocar la toalla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dejar en el lavabo": [
    {
      "id": 11748,
      "keyword": "dejar en el lavabo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer": [
    {
      "id": 32751,
      "keyword": "hacer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11749,
      "keyword": "hacer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poder": [
    {
      "id": 35949,
      "keyword": "poder",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11750,
      "keyword": "poder",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "braille": [
    {
      "id": 11753,
      "keyword": "braille",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar": [
    {
      "id": 16869,
      "keyword": "quitar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39450,
      "keyword": "quitar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15469,
      "keyword": "quitar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11751,
      "keyword": "quitar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "extraer": [
    {
      "id": 11751,
      "keyword": "extraer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lengua de signos": [
    {
      "id": 38428,
      "keyword": "lengua de signos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 11754,
      "keyword": "lengua de signos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lenguas de signos": [
    {
      "id": 11754,
      "keyword": "lengua de signos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerrar el grifo": [
    {
      "id": 11739,
      "keyword": "cerrar el grifo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37022,
      "keyword": "cerrar el grifo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerrar la canilla": [
    {
      "id": 11739,
      "keyword": "cerrar la canilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37022,
      "keyword": "cerrar la canilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "repetir": [
    {
      "id": 11752,
      "keyword": "repetir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiar el cepillo de dientes": [
    {
      "id": 11963,
      "keyword": "limpiar el cepillo de dientes",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adaptación": [
    {
      "id": 12242,
      "keyword": "adaptación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adaptaciones": [
    {
      "id": 12242,
      "keyword": "adaptación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acceso": [
    {
      "id": 12246,
      "keyword": "acceso",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "accesos": [
    {
      "id": 12246,
      "keyword": "acceso",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "apoyo": [
    {
      "id": 12252,
      "keyword": "apoyo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "education",
        "core vocabulary",
        "special education",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apoyos": [
    {
      "id": 12252,
      "keyword": "apoyo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "education",
        "core vocabulary",
        "special education",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ayuda": [
    {
      "id": 25620,
      "keyword": "ayuda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33998,
      "keyword": "ayuda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 19524,
      "keyword": "ayuda",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "core vocabulary",
        "education",
        "special education",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12252,
      "keyword": "ayuda",
      "keywords": 4,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "education",
        "core vocabulary",
        "special education",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ayudas": [
    {
      "id": 25620,
      "keyword": "ayudas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25620,
      "keyword": "ayuda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33998,
      "keyword": "ayuda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 19524,
      "keyword": "ayuda",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "core vocabulary",
        "education",
        "special education",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 12252,
      "keyword": "ayuda",
      "keywords": 4,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "education",
        "core vocabulary",
        "special education",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colaboración": [
    {
      "id": 19524,
      "keyword": "colaboración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "core vocabulary",
        "education",
        "special education",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12252,
      "keyword": "colaboración",
      "keywords": 4,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "education",
        "core vocabulary",
        "special education",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colaboraciones": [
    {
      "id": 19524,
      "keyword": "colaboración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "core vocabulary",
        "education",
        "special education",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 12252,
      "keyword": "colaboración",
      "keywords": 4,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "education",
        "core vocabulary",
        "special education",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cooperación": [
    {
      "id": 19524,
      "keyword": "cooperación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "core vocabulary",
        "education",
        "special education",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12252,
      "keyword": "cooperación",
      "keywords": 4,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "education",
        "core vocabulary",
        "special education",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cooperaciones": [
    {
      "id": 19524,
      "keyword": "cooperación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "core vocabulary",
        "education",
        "special education",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 12252,
      "keyword": "cooperación",
      "keywords": 4,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "education",
        "core vocabulary",
        "special education",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mío": [
    {
      "id": 12264,
      "keyword": "mío",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mi": [
    {
      "id": 12264,
      "keyword": "mi",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mía": [
    {
      "id": 12264,
      "keyword": "mía",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guerra": [
    {
      "id": 12256,
      "keyword": "guerra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guerras": [
    {
      "id": 12256,
      "keyword": "guerra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "protección": [
    {
      "id": 12261,
      "keyword": "protección",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12260,
      "keyword": "protección",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "protecciones": [
    {
      "id": 12261,
      "keyword": "protección",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 12260,
      "keyword": "protección",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "seguridad": [
    {
      "id": 34856,
      "keyword": "seguridad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12261,
      "keyword": "seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12260,
      "keyword": "seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seguridades": [
    {
      "id": 34856,
      "keyword": "seguridad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 12261,
      "keyword": "seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 12260,
      "keyword": "seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mis": [
    {
      "id": 12266,
      "keyword": "mis",
      "keywords": 3,
      "type": 4,
      "tags": [
        "possessive adjective",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "míos": [
    {
      "id": 12266,
      "keyword": "míos",
      "keywords": 3,
      "type": 4,
      "tags": [
        "possessive adjective",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mías": [
    {
      "id": 12266,
      "keyword": "mías",
      "keywords": 3,
      "type": 4,
      "tags": [
        "possessive adjective",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nuestro": [
    {
      "id": 12268,
      "keyword": "nuestro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nuestra": [
    {
      "id": 12268,
      "keyword": "nuestra",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nuestros": [
    {
      "id": 12270,
      "keyword": "nuestros",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nuestras": [
    {
      "id": 12270,
      "keyword": "nuestras",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "echar pasta de dientes": [
    {
      "id": 11961,
      "keyword": "echar pasta de dientes",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30086,
      "keyword": "echar pasta de dientes",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30087,
      "keyword": "echar pasta de dientes",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "su": [
    {
      "id": 12272,
      "keyword": "su",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12274,
      "keyword": "su",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suyo": [
    {
      "id": 12272,
      "keyword": "suyo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12274,
      "keyword": "suyo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suya": [
    {
      "id": 12272,
      "keyword": "suya",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12274,
      "keyword": "suya",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tus": [
    {
      "id": 12283,
      "keyword": "tus",
      "keywords": 3,
      "type": 6,
      "tags": [
        "possessive adjective",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tuyos": [
    {
      "id": 12283,
      "keyword": "tuyos",
      "keywords": 3,
      "type": 6,
      "tags": [
        "possessive adjective",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tuyas": [
    {
      "id": 12283,
      "keyword": "tuyas",
      "keywords": 3,
      "type": 6,
      "tags": [
        "possessive adjective",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sus": [
    {
      "id": 12276,
      "keyword": "sus",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12278,
      "keyword": "sus",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suyos": [
    {
      "id": 12276,
      "keyword": "suyos",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12278,
      "keyword": "suyos",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suyas": [
    {
      "id": 12276,
      "keyword": "suyas",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12278,
      "keyword": "suyas",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tu": [
    {
      "id": 12281,
      "keyword": "tu",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "possessive adjective",
        "possessive pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tuyo": [
    {
      "id": 12281,
      "keyword": "tuyo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "possessive adjective",
        "possessive pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tuya": [
    {
      "id": 12281,
      "keyword": "tuya",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "possessive adjective",
        "possessive pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vuestro": [
    {
      "id": 12285,
      "keyword": "vuestro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vuestra": [
    {
      "id": 12285,
      "keyword": "vuestra",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vuestros": [
    {
      "id": 12287,
      "keyword": "vuestros",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vuestras": [
    {
      "id": 12287,
      "keyword": "vuestras",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "possessive adjective",
        "pronoun",
        "possessive pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sano": [
    {
      "id": 37797,
      "keyword": "sano",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39515,
      "keyword": "sano",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12293,
      "keyword": "sano",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sanos": [
    {
      "id": 37797,
      "keyword": "sano",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39515,
      "keyword": "sano",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 12293,
      "keyword": "sano",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "causa": [
    {
      "id": 12295,
      "keyword": "causa",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "causas": [
    {
      "id": 12295,
      "keyword": "causa",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "origen": [
    {
      "id": 12295,
      "keyword": "origen",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "orígenes": [
    {
      "id": 12295,
      "keyword": "origen",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "caganer": [
    {
      "id": 12301,
      "keyword": "caganer",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caganers": [
    {
      "id": 12301,
      "keyword": "caganer",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tió de nadal": [
    {
      "id": 12303,
      "keyword": "Tió de Nadal",
      "keywords": 2,
      "type": 1,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tronca de nadal": [
    {
      "id": 12303,
      "keyword": "Tronca de Nadal",
      "keywords": 2,
      "type": 1,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tronca de navidad": [
    {
      "id": 12305,
      "keyword": "Tronca de Navidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "troncas de navidad": [
    {
      "id": 12305,
      "keyword": "Tronca de Navidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "popular event",
        "christmas",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "leer braille": [
    {
      "id": 12297,
      "keyword": "leer braille",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coca": [
    {
      "id": 12311,
      "keyword": "coca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cocas": [
    {
      "id": 12311,
      "keyword": "coca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "firmar": [
    {
      "id": 12317,
      "keyword": "firmar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cumplir": [
    {
      "id": 26784,
      "keyword": "cumplir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12315,
      "keyword": "cumplir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "creatividad": [
    {
      "id": 11690,
      "keyword": "creatividad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conciencia": [
    {
      "id": 12319,
      "keyword": "conciencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conciencias": [
    {
      "id": 12319,
      "keyword": "conciencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "discriminar": [
    {
      "id": 22779,
      "keyword": "discriminar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12321,
      "keyword": "discriminar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "excluir": [
    {
      "id": 22779,
      "keyword": "excluir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12321,
      "keyword": "excluir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panellets": [
    {
      "id": 12299,
      "keyword": "panellets",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "evento": [
    {
      "id": 12326,
      "keyword": "evento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "scenic art",
        "leisure",
        "show",
        "work",
        "theater",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12325,
      "keyword": "evento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "scenic art",
        "leisure",
        "show",
        "work",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "eventos": [
    {
      "id": 12326,
      "keyword": "evento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "scenic art",
        "leisure",
        "show",
        "work",
        "theater",
        "music"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 12325,
      "keyword": "evento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "scenic art",
        "leisure",
        "show",
        "work",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "como": [
    {
      "id": 12313,
      "keyword": "como",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of manner",
        "conjunction",
        "comparative conjunction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "organización": [
    {
      "id": 12333,
      "keyword": "organización",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "organizaciones": [
    {
      "id": 12333,
      "keyword": "organización",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asociación": [
    {
      "id": 12333,
      "keyword": "asociación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asociaciones": [
    {
      "id": 12333,
      "keyword": "asociación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "testigo": [
    {
      "id": 12339,
      "keyword": "testigo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34351,
      "keyword": "testigo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "testigos": [
    {
      "id": 12339,
      "keyword": "testigo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34351,
      "keyword": "testigo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "señalización": [
    {
      "id": 12345,
      "keyword": "señalización",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "señalizaciones": [
    {
      "id": 12345,
      "keyword": "señalización",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "medios de comunicación": [
    {
      "id": 12347,
      "keyword": "medios de comunicación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "discriminación": [
    {
      "id": 22781,
      "keyword": "discriminación",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 12323,
      "keyword": "discriminación",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22761,
      "keyword": "discriminación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "discriminaciones": [
    {
      "id": 22781,
      "keyword": "discriminación",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    },
    {
      "id": 12323,
      "keyword": "discriminación",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22761,
      "keyword": "discriminación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tomar conciencia": [
    {
      "id": 12351,
      "keyword": "tomar conciencia",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31975,
      "keyword": "tomar conciencia",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "funcionario de prisiones": [
    {
      "id": 12353,
      "keyword": "funcionario de prisiones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "funcionarios de prisiones": [
    {
      "id": 12353,
      "keyword": "funcionario de prisiones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sentimiento": [
    {
      "id": 12359,
      "keyword": "sentimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sistemas auditivos": [
    {
      "id": 12361,
      "keyword": "sistemas auditivos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "considerar": [
    {
      "id": 12349,
      "keyword": "considerar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tener en cuenta": [
    {
      "id": 12349,
      "keyword": "tener en cuenta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ayudas para la movilidad": [
    {
      "id": 12355,
      "keyword": "ayudas para la movilidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "felicidades": [
    {
      "id": 13018,
      "keyword": "felicidades",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38566,
      "keyword": "felicidades",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡felicidades!": [
    {
      "id": 13018,
      "keyword": "¡felicidades!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38566,
      "keyword": "¡felicidades!",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abonar": [
    {
      "id": 25751,
      "keyword": "abonar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25750,
      "keyword": "abonar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "gardening",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29664,
      "keyword": "abonar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "gardening",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13020,
      "keyword": "abonar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fertilizar": [
    {
      "id": 13020,
      "keyword": "fertilizar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abubilla": [
    {
      "id": 13022,
      "keyword": "abubilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abubillas": [
    {
      "id": 13022,
      "keyword": "abubilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sensibilización": [
    {
      "id": 12366,
      "keyword": "sensibilización",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sensibilizaciones": [
    {
      "id": 12366,
      "keyword": "sensibilización",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nacionalidad": [
    {
      "id": 12338,
      "keyword": "nacionalidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nacionalidades": [
    {
      "id": 12338,
      "keyword": "nacionalidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "antes": [
    {
      "id": 32745,
      "keyword": "antes",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13028,
      "keyword": "antes",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aparato": [
    {
      "id": 13030,
      "keyword": "aparato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aparatos": [
    {
      "id": 13030,
      "keyword": "aparato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ahora": [
    {
      "id": 32747,
      "keyword": "ahora",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13026,
      "keyword": "ahora",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arándanos": [
    {
      "id": 13034,
      "keyword": "arándanos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36488,
      "keyword": "arándano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sensibilizar": [
    {
      "id": 12364,
      "keyword": "sensibilizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coger de la mano": [
    {
      "id": 13024,
      "keyword": "coger de la mano",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agarrar de la mano": [
    {
      "id": 13024,
      "keyword": "agarrar de la mano",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "completar": [
    {
      "id": 15816,
      "keyword": "completar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13078,
      "keyword": "completar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rellenar": [
    {
      "id": 16883,
      "keyword": "rellenar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13078,
      "keyword": "rellenar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "después": [
    {
      "id": 32749,
      "keyword": "después",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13080,
      "keyword": "después",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "luego": [
    {
      "id": 32749,
      "keyword": "luego",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13080,
      "keyword": "luego",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ensaladera": [
    {
      "id": 13082,
      "keyword": "ensaladera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ensaladeras": [
    {
      "id": 13082,
      "keyword": "ensaladera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frambuesas": [
    {
      "id": 13084,
      "keyword": "frambuesas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36540,
      "keyword": "frambuesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cúter": [
    {
      "id": 13076,
      "keyword": "cúter",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cúters": [
    {
      "id": 13076,
      "keyword": "cúter",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "observatorio": [
    {
      "id": 13088,
      "keyword": "observatorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "observatorios": [
    {
      "id": 13088,
      "keyword": "observatorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ortopedia": [
    {
      "id": 13092,
      "keyword": "ortopedia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31360,
      "keyword": "ortopedia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ortopedias": [
    {
      "id": 13092,
      "keyword": "ortopedia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31360,
      "keyword": "ortopedia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "buñuelos": [
    {
      "id": 13344,
      "keyword": "buñuelos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caqui": [
    {
      "id": 13074,
      "keyword": "caqui",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caquis": [
    {
      "id": 13074,
      "keyword": "caqui",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pomelo": [
    {
      "id": 13352,
      "keyword": "pomelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pomelos": [
    {
      "id": 13352,
      "keyword": "pomelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "toronja": [
    {
      "id": 13352,
      "keyword": "toronja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toronjas": [
    {
      "id": 13352,
      "keyword": "toronja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reír": [
    {
      "id": 13354,
      "keyword": "reír",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30393,
      "keyword": "reír",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sonreír": [
    {
      "id": 13354,
      "keyword": "sonreír",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sonrisa": [
    {
      "id": 13354,
      "keyword": "sonrisa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sonrisas": [
    {
      "id": 13354,
      "keyword": "sonrisa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mazapán": [
    {
      "id": 13346,
      "keyword": "mazapán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mazapanes": [
    {
      "id": 13346,
      "keyword": "mazapán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ornitorrinco": [
    {
      "id": 13090,
      "keyword": "ornitorrinco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "mammal",
        "ovoviviparous",
        "terrestrial animal",
        "aquatic animal",
        "freshwater animal",
        "river",
        "carnivorous",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ornitorrincos": [
    {
      "id": 13090,
      "keyword": "ornitorrinco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "mammal",
        "ovoviviparous",
        "terrestrial animal",
        "aquatic animal",
        "freshwater animal",
        "river",
        "carnivorous",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quad": [
    {
      "id": 13360,
      "keyword": "quad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quads": [
    {
      "id": 13360,
      "keyword": "quad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quitanieves": [
    {
      "id": 13362,
      "keyword": "quitanieves",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "molino": [
    {
      "id": 13086,
      "keyword": "molino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "molinos": [
    {
      "id": 13086,
      "keyword": "molino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "molino de viento": [
    {
      "id": 13086,
      "keyword": "molino de viento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "molinos de viento": [
    {
      "id": 13086,
      "keyword": "molino de viento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pavo real": [
    {
      "id": 13348,
      "keyword": "pavo real",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pavos reales": [
    {
      "id": 13348,
      "keyword": "pavo real",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sandwichera": [
    {
      "id": 13364,
      "keyword": "sandwichera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sandwicheras": [
    {
      "id": 13364,
      "keyword": "sandwichera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estar de pie": [
    {
      "id": 13370,
      "keyword": "estar de pie",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "human body",
        "position",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24036,
      "keyword": "estar de pie",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13368,
      "keyword": "estar de pie",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24035,
      "keyword": "estar de pie",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26075,
      "keyword": "estar de pie",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tumbada": [
    {
      "id": 22205,
      "keyword": "tumbada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38640,
      "keyword": "tumbada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38641,
      "keyword": "tumbada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13372,
      "keyword": "tumbada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tumbadas": [
    {
      "id": 22205,
      "keyword": "tumbada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38640,
      "keyword": "tumbada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38641,
      "keyword": "tumbada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 13372,
      "keyword": "tumbada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nata líquida": [
    {
      "id": 13376,
      "keyword": "nata líquida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "natas líquidas": [
    {
      "id": 13376,
      "keyword": "nata líquida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mala suerte": [
    {
      "id": 13378,
      "keyword": "mala suerte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estoy bien": [
    {
      "id": 13630,
      "keyword": "estoy bien",
      "keywords": 4,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡estoy bien!": [
    {
      "id": 13630,
      "keyword": "¡estoy bien!",
      "keywords": 4,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huesos de santo": [
    {
      "id": 13366,
      "keyword": "huesos de santo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "easter week"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conocimiento del medio": [
    {
      "id": 32542,
      "keyword": "conocimiento del medio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "subject",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13632,
      "keyword": "conocimiento del medio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pantalones cortos": [
    {
      "id": 13638,
      "keyword": "pantalones cortos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 13638,
      "keyword": "pantalón corto",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pantalón corto": [
    {
      "id": 13638,
      "keyword": "pantalón corto",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tipi": [
    {
      "id": 13636,
      "keyword": "tipi",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tipis": [
    {
      "id": 13636,
      "keyword": "tipi",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "denunciar": [
    {
      "id": 14006,
      "keyword": "denunciar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34695,
      "keyword": "denunciar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38773,
      "keyword": "denunciar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38774,
      "keyword": "denunciar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espliego": [
    {
      "id": 14242,
      "keyword": "espliego",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espliegos": [
    {
      "id": 14242,
      "keyword": "espliego",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lavanda": [
    {
      "id": 14242,
      "keyword": "lavanda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavandas": [
    {
      "id": 14242,
      "keyword": "lavanda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "educación plástica y visual": [
    {
      "id": 13634,
      "keyword": "educación plástica y visual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de educación plástica": [
    {
      "id": 13634,
      "keyword": "clase de educación plástica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de educación plástica": [
    {
      "id": 13634,
      "keyword": "clase de educación plástica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "orégano": [
    {
      "id": 14244,
      "keyword": "orégano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oréganos": [
    {
      "id": 14244,
      "keyword": "orégano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "residencia para discapacitados": [
    {
      "id": 25733,
      "keyword": "residencia para discapacitados",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "personal services",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14010,
      "keyword": "residencia para discapacitados",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25732,
      "keyword": "residencia para discapacitados",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "residencias para discapacitados": [
    {
      "id": 25733,
      "keyword": "residencia para discapacitados",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "personal services",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 14010,
      "keyword": "residencia para discapacitados",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25732,
      "keyword": "residencia para discapacitados",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tomillo": [
    {
      "id": 14248,
      "keyword": "tomillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomillos": [
    {
      "id": 14248,
      "keyword": "tomillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "romero": [
    {
      "id": 14246,
      "keyword": "romero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "romeros": [
    {
      "id": 14246,
      "keyword": "romero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anginas": [
    {
      "id": 14250,
      "keyword": "anginas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lágrima": [
    {
      "id": 14252,
      "keyword": "lágrima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lágrimas": [
    {
      "id": 14252,
      "keyword": "lágrima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rulo": [
    {
      "id": 26392,
      "keyword": "rulo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14260,
      "keyword": "rulo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rulero": [
    {
      "id": 14260,
      "keyword": "rulero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ruleros": [
    {
      "id": 14260,
      "keyword": "rulero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saliva": [
    {
      "id": 14254,
      "keyword": "saliva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salivas": [
    {
      "id": 14254,
      "keyword": "saliva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rímel": [
    {
      "id": 14262,
      "keyword": "rímel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salud": [
    {
      "id": 14264,
      "keyword": "salud",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36591,
      "keyword": "salud",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14664,
      "keyword": "salud",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peluca": [
    {
      "id": 14258,
      "keyword": "peluca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36566,
      "keyword": "peluca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelucas": [
    {
      "id": 14258,
      "keyword": "peluca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36566,
      "keyword": "peluca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calzar": [
    {
      "id": 14534,
      "keyword": "calzar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39026,
      "keyword": "calzar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talco para bebé": [
    {
      "id": 14256,
      "keyword": "talco para bebé",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talcos para bebé": [
    {
      "id": 14256,
      "keyword": "talco para bebé",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "talco": [
    {
      "id": 14256,
      "keyword": "talco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talcos": [
    {
      "id": 14256,
      "keyword": "talco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "descalzar": [
    {
      "id": 14536,
      "keyword": "descalzar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27519,
      "keyword": "descalzar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodillera": [
    {
      "id": 14540,
      "keyword": "rodillera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30680,
      "keyword": "rodillera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodilleras": [
    {
      "id": 14540,
      "keyword": "rodillera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30680,
      "keyword": "rodillera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "orejeras": [
    {
      "id": 14542,
      "keyword": "orejeras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27929,
      "keyword": "orejeras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prevenir": [
    {
      "id": 14008,
      "keyword": "prevenir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "chemistry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuadrícula": [
    {
      "id": 14546,
      "keyword": "cuadrícula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "pattern"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuadrículas": [
    {
      "id": 14546,
      "keyword": "cuadrícula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "pattern"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pasamontañas": [
    {
      "id": 14548,
      "keyword": "pasamontañas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "codera": [
    {
      "id": 14538,
      "keyword": "codera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30682,
      "keyword": "codera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coderas": [
    {
      "id": 14538,
      "keyword": "codera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30682,
      "keyword": "codera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jubilación": [
    {
      "id": 14666,
      "keyword": "jubilación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jubilaciones": [
    {
      "id": 14666,
      "keyword": "jubilación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "censura": [
    {
      "id": 14668,
      "keyword": "censura",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "censuras": [
    {
      "id": 14668,
      "keyword": "censura",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "rehabilitación": [
    {
      "id": 14672,
      "keyword": "rehabilitación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rehabilitaciones": [
    {
      "id": 14672,
      "keyword": "rehabilitación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "entorno": [
    {
      "id": 14552,
      "keyword": "entorno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entornos": [
    {
      "id": 14552,
      "keyword": "entorno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "honor": [
    {
      "id": 14660,
      "keyword": "honor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "honores": [
    {
      "id": 14660,
      "keyword": "honor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "respeto": [
    {
      "id": 14660,
      "keyword": "respeto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "respetos": [
    {
      "id": 14660,
      "keyword": "respeto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reputación": [
    {
      "id": 14660,
      "keyword": "reputación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reputaciones": [
    {
      "id": 14660,
      "keyword": "reputación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vieja cuaresma": [
    {
      "id": 14550,
      "keyword": "Vieja Cuaresma",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "easter week",
        "religion",
        "christianity",
        "character",
        "mythological character",
        "mythology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patrocinador": [
    {
      "id": 14674,
      "keyword": "patrocinador",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "patrocinadores": [
    {
      "id": 14674,
      "keyword": "patrocinador",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "almería": [
    {
      "id": 14683,
      "keyword": "Almería",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cádiz": [
    {
      "id": 14684,
      "keyword": "Cádiz",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "córdoba": [
    {
      "id": 14685,
      "keyword": "Córdoba",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huelva": [
    {
      "id": 14687,
      "keyword": "Huelva",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diseño universal": [
    {
      "id": 14678,
      "keyword": "diseño universal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sevilla": [
    {
      "id": 14690,
      "keyword": "Sevilla",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vestuario": [
    {
      "id": 33948,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14691,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14693,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14697,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14695,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14701,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14699,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15533,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27550,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27549,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33950,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33949,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vestuarios": [
    {
      "id": 33948,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 14691,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 14693,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 14697,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 14695,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 14701,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 14699,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15533,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27550,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27549,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33950,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33949,
      "keyword": "vestuario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jaén": [
    {
      "id": 14688,
      "keyword": "Jaén",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lugo": [
    {
      "id": 14756,
      "keyword": "Lugo",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "la coruña": [
    {
      "id": 14755,
      "keyword": "La Coruña",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orense": [
    {
      "id": 14757,
      "keyword": "Orense",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pontevedra": [
    {
      "id": 14758,
      "keyword": "Pontevedra",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "málaga": [
    {
      "id": 14689,
      "keyword": "Málaga",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24153,
      "keyword": "Málaga",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "city"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "álava": [
    {
      "id": 14759,
      "keyword": "Álava",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guipúzcoa": [
    {
      "id": 14760,
      "keyword": "Guipúzcoa",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vizcaya": [
    {
      "id": 14761,
      "keyword": "Vizcaya",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciudad real": [
    {
      "id": 14763,
      "keyword": "Ciudad Real",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuenca": [
    {
      "id": 14764,
      "keyword": "Cuenca",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alicante": [
    {
      "id": 14767,
      "keyword": "Alicante",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guadalajara": [
    {
      "id": 14765,
      "keyword": "Guadalajara",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "valencia": [
    {
      "id": 14769,
      "keyword": "Valencia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "burgos": [
    {
      "id": 14771,
      "keyword": "Burgos",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "castellón": [
    {
      "id": 14768,
      "keyword": "Castellón",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palencia": [
    {
      "id": 14773,
      "keyword": "Palencia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salamanca": [
    {
      "id": 14774,
      "keyword": "Salamanca",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "albacete": [
    {
      "id": 14762,
      "keyword": "Albacete",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "segovia": [
    {
      "id": 14775,
      "keyword": "Segovia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soria": [
    {
      "id": 14776,
      "keyword": "Soria",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "badajoz": [
    {
      "id": 14830,
      "keyword": "Badajoz",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25357,
      "keyword": "Badajoz",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "valladolid": [
    {
      "id": 14777,
      "keyword": "Valladolid",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cáceres": [
    {
      "id": 14831,
      "keyword": "Cáceres",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "decisión": [
    {
      "id": 37861,
      "keyword": "decisión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14670,
      "keyword": "decisión",
      "keywords": 4,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "decisiones": [
    {
      "id": 37861,
      "keyword": "decisión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 14670,
      "keyword": "decisión",
      "keywords": 4,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "elección": [
    {
      "id": 14670,
      "keyword": "elección",
      "keywords": 4,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "selección": [
    {
      "id": 14670,
      "keyword": "selección",
      "keywords": 4,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "selecciones": [
    {
      "id": 14670,
      "keyword": "selección",
      "keywords": 4,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "preferencia": [
    {
      "id": 14670,
      "keyword": "preferencia",
      "keywords": 4,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "preferencias": [
    {
      "id": 14670,
      "keyword": "preferencia",
      "keywords": 4,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "gerona": [
    {
      "id": 14833,
      "keyword": "Gerona",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lérida": [
    {
      "id": 14834,
      "keyword": "Lérida",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ávila": [
    {
      "id": 14770,
      "keyword": "Ávila",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "madrid": [
    {
      "id": 14840,
      "keyword": "Madrid",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarragona": [
    {
      "id": 14835,
      "keyword": "Tarragona",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "la gomera": [
    {
      "id": 14845,
      "keyword": "La Gomera",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "el hierro": [
    {
      "id": 14843,
      "keyword": "El Hierro",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "la palma": [
    {
      "id": 14846,
      "keyword": "La Palma",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tenerife": [
    {
      "id": 14849,
      "keyword": "Tenerife",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ibiza": [
    {
      "id": 14850,
      "keyword": "Ibiza",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "formentera": [
    {
      "id": 14848,
      "keyword": "Formentera",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mallorca": [
    {
      "id": 14851,
      "keyword": "Mallorca",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "menorca": [
    {
      "id": 14852,
      "keyword": "Menorca",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clítoris": [
    {
      "id": 14976,
      "keyword": "clítoris",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "embrión": [
    {
      "id": 14980,
      "keyword": "embrión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31202,
      "keyword": "embrión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "embriones": [
    {
      "id": 14980,
      "keyword": "embrión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31202,
      "keyword": "embrión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal physiology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espermatozoide": [
    {
      "id": 14982,
      "keyword": "espermatozoide",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espermatozoides": [
    {
      "id": 14982,
      "keyword": "espermatozoide",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lanzarote": [
    {
      "id": 14847,
      "keyword": "Lanzarote",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toledo": [
    {
      "id": 14766,
      "keyword": "Toledo",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coito": [
    {
      "id": 34519,
      "keyword": "coito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34537,
      "keyword": "coito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34533,
      "keyword": "coito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14991,
      "keyword": "coito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14992,
      "keyword": "coito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 14994,
      "keyword": "coito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coitos": [
    {
      "id": 34519,
      "keyword": "coito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34537,
      "keyword": "coito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34533,
      "keyword": "coito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 14991,
      "keyword": "coito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 14992,
      "keyword": "coito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 14994,
      "keyword": "coito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zamora": [
    {
      "id": 14778,
      "keyword": "Zamora",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ovarios": [
    {
      "id": 14996,
      "keyword": "ovarios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37151,
      "keyword": "ovario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "óvulo": [
    {
      "id": 14999,
      "keyword": "óvulo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "óvulos": [
    {
      "id": 14999,
      "keyword": "óvulo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fecundación": [
    {
      "id": 14984,
      "keyword": "fecundación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37149,
      "keyword": "fecundación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fecundaciones": [
    {
      "id": 14984,
      "keyword": "fecundación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37149,
      "keyword": "fecundación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant physiology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "feto": [
    {
      "id": 14988,
      "keyword": "feto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33902,
      "keyword": "feto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fetos": [
    {
      "id": 14988,
      "keyword": "feto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33902,
      "keyword": "feto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fecundación in vitro": [
    {
      "id": 14986,
      "keyword": "fecundación in vitro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fecundaciones in vitro": [
    {
      "id": 14986,
      "keyword": "fecundación in vitro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fiv": [
    {
      "id": 14986,
      "keyword": "fiv",
      "keywords": 3,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reproducción asistida": [
    {
      "id": 14986,
      "keyword": "reproducción asistida",
      "keywords": 3,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "divorciar": [
    {
      "id": 15010,
      "keyword": "divorciar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15008,
      "keyword": "divorciar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15006,
      "keyword": "divorciar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "divorcio": [
    {
      "id": 15012,
      "keyword": "divorcio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15016,
      "keyword": "divorcio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15014,
      "keyword": "divorcio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "divorcios": [
    {
      "id": 15012,
      "keyword": "divorcio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15016,
      "keyword": "divorcio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15014,
      "keyword": "divorcio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "marital status"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aborto": [
    {
      "id": 14974,
      "keyword": "aborto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abortos": [
    {
      "id": 14974,
      "keyword": "aborto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "píldora": [
    {
      "id": 34565,
      "keyword": "píldora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15000,
      "keyword": "píldora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32041,
      "keyword": "píldora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "píldoras": [
    {
      "id": 34565,
      "keyword": "píldora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15000,
      "keyword": "píldora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32041,
      "keyword": "píldora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sentencia de divorcio": [
    {
      "id": 15026,
      "keyword": "sentencia de divorcio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice",
        "work",
        "tertiary sector",
        "law"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15028,
      "keyword": "sentencia de divorcio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice",
        "work",
        "tertiary sector",
        "law"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15024,
      "keyword": "sentencia de divorcio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice",
        "work",
        "tertiary sector",
        "law"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sentencias de divorcio": [
    {
      "id": 15026,
      "keyword": "sentencia de divorcio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice",
        "work",
        "tertiary sector",
        "law"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15028,
      "keyword": "sentencia de divorcio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice",
        "work",
        "tertiary sector",
        "law"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15024,
      "keyword": "sentencia de divorcio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice",
        "work",
        "tertiary sector",
        "law"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "demanda de divorcio": [
    {
      "id": 15030,
      "keyword": "demanda de divorcio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice",
        "work",
        "tertiary sector",
        "law"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15032,
      "keyword": "demanda de divorcio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice",
        "work",
        "tertiary sector",
        "law"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15034,
      "keyword": "demanda de divorcio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice",
        "work",
        "tertiary sector",
        "law"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "demandas de divorcio": [
    {
      "id": 15030,
      "keyword": "demanda de divorcio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice",
        "work",
        "tertiary sector",
        "law"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15032,
      "keyword": "demanda de divorcio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice",
        "work",
        "tertiary sector",
        "law"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15034,
      "keyword": "demanda de divorcio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice",
        "work",
        "tertiary sector",
        "law"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "san juan": [
    {
      "id": 32452,
      "keyword": "San Juan",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "religion",
        "christianity",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15036,
      "keyword": "San Juan",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24386,
      "keyword": "San Juan",
      "keywords": 2,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equipo": [
    {
      "id": 15262,
      "keyword": "equipo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "leisure",
        "sport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15264,
      "keyword": "equipo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "leisure",
        "sport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26821,
      "keyword": "equipo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equipos": [
    {
      "id": 15262,
      "keyword": "equipo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "leisure",
        "sport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15264,
      "keyword": "equipo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "leisure",
        "sport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26821,
      "keyword": "equipo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "investigación": [
    {
      "id": 32138,
      "keyword": "investigación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15322,
      "keyword": "investigación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "investigaciones": [
    {
      "id": 32138,
      "keyword": "investigación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15322,
      "keyword": "investigación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "investigar": [
    {
      "id": 39288,
      "keyword": "investigar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "biology",
        "chemistry",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15320,
      "keyword": "investigar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comprensión": [
    {
      "id": 15331,
      "keyword": "comprensión",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "comprensiones": [
    {
      "id": 15331,
      "keyword": "comprensión",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "incomprensión": [
    {
      "id": 15333,
      "keyword": "incomprensión",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "incomprensiones": [
    {
      "id": 15333,
      "keyword": "incomprensión",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "arañar": [
    {
      "id": 16441,
      "keyword": "arañar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39206,
      "keyword": "arañar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15335,
      "keyword": "arañar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34407,
      "keyword": "arañar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arañazo": [
    {
      "id": 16441,
      "keyword": "arañazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15335,
      "keyword": "arañazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34407,
      "keyword": "arañazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arañazos": [
    {
      "id": 16441,
      "keyword": "arañazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15335,
      "keyword": "arañazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34407,
      "keyword": "arañazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ininteligible": [
    {
      "id": 15329,
      "keyword": "ininteligible",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ininteligibles": [
    {
      "id": 15329,
      "keyword": "ininteligible",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "presidente": [
    {
      "id": 15326,
      "keyword": "presidente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "work",
        "tertiary sector",
        "political representation",
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16373,
      "keyword": "presidente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "financial services",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16375,
      "keyword": "presidente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "industry",
        "manufacturing industry",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16378,
      "keyword": "presidente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "work",
        "tertiary sector",
        "political representation",
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presidentes": [
    {
      "id": 15326,
      "keyword": "presidente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "work",
        "tertiary sector",
        "political representation",
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16373,
      "keyword": "presidente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "financial services",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16375,
      "keyword": "presidente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "industry",
        "manufacturing industry",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16378,
      "keyword": "presidente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "work",
        "tertiary sector",
        "political representation",
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "astrónomo": [
    {
      "id": 15339,
      "keyword": "astrónomo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "astrónomos": [
    {
      "id": 15339,
      "keyword": "astrónomo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pictogramas": [
    {
      "id": 15018,
      "keyword": "pictogramas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27337,
      "keyword": "pictogramas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ajuste razonable": [
    {
      "id": 15020,
      "keyword": "ajuste razonable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ajustes razonables": [
    {
      "id": 15020,
      "keyword": "ajuste razonable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "banquero": [
    {
      "id": 15341,
      "keyword": "banquero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "financial services",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "banqueros": [
    {
      "id": 15341,
      "keyword": "banquero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "financial services",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "spa": [
    {
      "id": 15337,
      "keyword": "spa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28203,
      "keyword": "spa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "spas": [
    {
      "id": 15337,
      "keyword": "spa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28203,
      "keyword": "spa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hidroterapia": [
    {
      "id": 16172,
      "keyword": "hidroterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15337,
      "keyword": "hidroterapia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hidroterapias": [
    {
      "id": 16172,
      "keyword": "hidroterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15337,
      "keyword": "hidroterapia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aguas termales": [
    {
      "id": 15337,
      "keyword": "aguas termales",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28203,
      "keyword": "aguas termales",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "candidato": [
    {
      "id": 15345,
      "keyword": "candidato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15718,
      "keyword": "candidato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "candidatos": [
    {
      "id": 15345,
      "keyword": "candidato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15720,
      "keyword": "candidatos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15718,
      "keyword": "candidato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bayeta": [
    {
      "id": 15343,
      "keyword": "bayeta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bayetas": [
    {
      "id": 15343,
      "keyword": "bayeta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trapo rejilla": [
    {
      "id": 15343,
      "keyword": "trapo rejilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trapos rejilla": [
    {
      "id": 15343,
      "keyword": "trapo rejilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trapo de rejilla": [
    {
      "id": 15343,
      "keyword": "trapo de rejilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trapos de rejilla": [
    {
      "id": 15343,
      "keyword": "trapo de rejilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cocida": [
    {
      "id": 15359,
      "keyword": "cocida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cocidas": [
    {
      "id": 15359,
      "keyword": "cocida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cinta": [
    {
      "id": 15357,
      "keyword": "cinta",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "cintas": [
    {
      "id": 15357,
      "keyword": "cinta",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "cinta de pelo": [
    {
      "id": 15357,
      "keyword": "cinta de pelo",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "cintas de pelo": [
    {
      "id": 15357,
      "keyword": "cinta de pelo",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "cd de música": [
    {
      "id": 15349,
      "keyword": "cd de música",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39044,
      "keyword": "cd de música",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cds de música": [
    {
      "id": 15349,
      "keyword": "cd de música",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device",
        "music"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39044,
      "keyword": "cd de música",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device",
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "verter la masa ": [
    {
      "id": 15347,
      "keyword": "verter la masa ",
      "keywords": 2,
      "type": 3,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compartir": [
    {
      "id": 38900,
      "keyword": "compartir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16623,
      "keyword": "compartir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15361,
      "keyword": "compartir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cordón": [
    {
      "id": 15363,
      "keyword": "cordón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cordones": [
    {
      "id": 15363,
      "keyword": "cordón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "crudo": [
    {
      "id": 15365,
      "keyword": "crudo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crudos": [
    {
      "id": 15365,
      "keyword": "crudo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cruda": [
    {
      "id": 15365,
      "keyword": "cruda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crudas": [
    {
      "id": 15365,
      "keyword": "cruda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuajada": [
    {
      "id": 15367,
      "keyword": "cuajada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuajadas": [
    {
      "id": 15367,
      "keyword": "cuajada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "deshilachar": [
    {
      "id": 15369,
      "keyword": "deshilachar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "praxia": [
    {
      "id": 15379,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15382,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15383,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15385,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15387,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15389,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15391,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15393,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15395,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15397,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15399,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15401,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15403,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15411,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15413,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15409,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15415,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15417,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15419,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15407,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15431,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15433,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15435,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15429,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15437,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15439,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15443,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15441,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15427,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15425,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15421,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15423,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15405,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32256,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32254,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "praxias": [
    {
      "id": 15379,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15382,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15383,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15385,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15387,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15389,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15391,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15393,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15395,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15397,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15399,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15401,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15403,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15411,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15413,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15409,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15415,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15417,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15419,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15407,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15431,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15433,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15435,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15429,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15437,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15439,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15443,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15441,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15427,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15425,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15421,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15423,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15405,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32256,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32254,
      "keyword": "praxia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "orofacial praxis"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chuparse el dedo": [
    {
      "id": 16609,
      "keyword": "chuparse el dedo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28231,
      "keyword": "chuparse el dedo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28232,
      "keyword": "chuparse el dedo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28233,
      "keyword": "chuparse el dedo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15353,
      "keyword": "chuparse el dedo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chupar el dedo": [
    {
      "id": 16609,
      "keyword": "chupar el dedo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28231,
      "keyword": "chupar el dedo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28232,
      "keyword": "chupar el dedo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28233,
      "keyword": "chupar el dedo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15353,
      "keyword": "chupar el dedo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cervantes": [
    {
      "id": 15351,
      "keyword": "Cervantes",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "miguel de cervantes": [
    {
      "id": 15351,
      "keyword": "Miguel de Cervantes",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dulcinea": [
    {
      "id": 15373,
      "keyword": "Dulcinea",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dulcinea del toboso": [
    {
      "id": 15373,
      "keyword": "Dulcinea del Toboso",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frito": [
    {
      "id": 15451,
      "keyword": "frito",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15451,
      "keyword": "frito",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fritos": [
    {
      "id": 15451,
      "keyword": "frito",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15451,
      "keyword": "frito",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frita": [
    {
      "id": 15451,
      "keyword": "frita",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fritas": [
    {
      "id": 15451,
      "keyword": "frita",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "autoagresión": [
    {
      "id": 16707,
      "keyword": "autoagresión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35587,
      "keyword": "autoagresión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38922,
      "keyword": "autoagresión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15449,
      "keyword": "autoagresión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35499,
      "keyword": "autoagresión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35593,
      "keyword": "autoagresión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35594,
      "keyword": "autoagresión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autoagresiones": [
    {
      "id": 16707,
      "keyword": "autoagresión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35587,
      "keyword": "autoagresión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38922,
      "keyword": "autoagresión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15449,
      "keyword": "autoagresión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35499,
      "keyword": "autoagresión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35593,
      "keyword": "autoagresión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35594,
      "keyword": "autoagresión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "molde": [
    {
      "id": 15459,
      "keyword": "molde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15457,
      "keyword": "molde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26929,
      "keyword": "molde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27893,
      "keyword": "molde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32470,
      "keyword": "molde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32532,
      "keyword": "molde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "moldes": [
    {
      "id": 15459,
      "keyword": "molde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15457,
      "keyword": "molde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26929,
      "keyword": "molde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27893,
      "keyword": "molde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32470,
      "keyword": "molde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32532,
      "keyword": "molde",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manguitos": [
    {
      "id": 15455,
      "keyword": "manguitos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38069,
      "keyword": "manguito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quitar la comida": [
    {
      "id": 16871,
      "keyword": "quitar la comida",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15471,
      "keyword": "quitar la comida",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "remendar": [
    {
      "id": 15473,
      "keyword": "remendar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "promover": [
    {
      "id": 15467,
      "keyword": "promover",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29927,
      "keyword": "promover",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39285,
      "keyword": "promover",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "impulsar": [
    {
      "id": 15467,
      "keyword": "impulsar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39285,
      "keyword": "impulsar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tirar la basura": [
    {
      "id": 27208,
      "keyword": "tirar la basura",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38206,
      "keyword": "tirar la basura",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15479,
      "keyword": "tirar la basura",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arrojar la basura": [
    {
      "id": 15479,
      "keyword": "arrojar la basura",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desechar": [
    {
      "id": 15479,
      "keyword": "desechar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "repasar": [
    {
      "id": 15475,
      "keyword": "repasar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34607,
      "keyword": "repasar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39182,
      "keyword": "repasar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pegar una patada": [
    {
      "id": 16845,
      "keyword": "pegar una patada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15463,
      "keyword": "pegar una patada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34349,
      "keyword": "pegar una patada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34488,
      "keyword": "pegar una patada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34489,
      "keyword": "pegar una patada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patada": [
    {
      "id": 16845,
      "keyword": "patada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15463,
      "keyword": "patada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34349,
      "keyword": "patada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34488,
      "keyword": "patada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34489,
      "keyword": "patada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patadas": [
    {
      "id": 16845,
      "keyword": "patada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15463,
      "keyword": "patada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34349,
      "keyword": "patada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34488,
      "keyword": "patada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34489,
      "keyword": "patada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pellizcar": [
    {
      "id": 16847,
      "keyword": "pellizcar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15465,
      "keyword": "pellizcar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tontería": [
    {
      "id": 15483,
      "keyword": "tontería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tonterías": [
    {
      "id": 15483,
      "keyword": "tontería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "es una tontería": [
    {
      "id": 15483,
      "keyword": "es una tontería",
      "keywords": 2,
      "type": 5,
      "tags": [
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "utilizar": [
    {
      "id": 15485,
      "keyword": "utilizar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "usar": [
    {
      "id": 15485,
      "keyword": "usar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sancho panza": [
    {
      "id": 15495,
      "keyword": "Sancho Panza",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "goya": [
    {
      "id": 15493,
      "keyword": "Goya",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "francisco de goya y lucientes": [
    {
      "id": 15493,
      "keyword": "Francisco de Goya y Lucientes",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "óptico": [
    {
      "id": 15491,
      "keyword": "óptico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ópticos": [
    {
      "id": 15491,
      "keyword": "óptico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "poner el sujetador": [
    {
      "id": 15497,
      "keyword": "poner el sujetador",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner el corpiño": [
    {
      "id": 15497,
      "keyword": "poner el corpiño",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "telescopio": [
    {
      "id": 15477,
      "keyword": "telescopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "telescopios": [
    {
      "id": 15477,
      "keyword": "telescopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estirón": [
    {
      "id": 15481,
      "keyword": "estirón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estirones": [
    {
      "id": 15481,
      "keyword": "estirón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estirón de pelo": [
    {
      "id": 15481,
      "keyword": "estirón de pelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estirones de pelo": [
    {
      "id": 15481,
      "keyword": "estirón de pelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caducidad": [
    {
      "id": 15503,
      "keyword": "caducidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caducidades": [
    {
      "id": 15503,
      "keyword": "caducidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fecha de caducidad": [
    {
      "id": 15503,
      "keyword": "fecha de caducidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fechas de caducidad": [
    {
      "id": 15503,
      "keyword": "fecha de caducidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "crema de queso": [
    {
      "id": 15505,
      "keyword": "crema de queso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cremas de queso": [
    {
      "id": 15505,
      "keyword": "crema de queso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "castañada": [
    {
      "id": 24951,
      "keyword": "Castañada",
      "keywords": 3,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15501,
      "keyword": "Castañada",
      "keywords": 3,
      "type": 1,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "plant-based food",
        "dried fruit",
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "castañera": [
    {
      "id": 24951,
      "keyword": "castañera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15501,
      "keyword": "castañera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "plant-based food",
        "dried fruit",
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "castañeras": [
    {
      "id": 24951,
      "keyword": "castañera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15501,
      "keyword": "castañera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "plant-based food",
        "dried fruit",
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "magosto": [
    {
      "id": 24951,
      "keyword": "Magosto",
      "keywords": 3,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15501,
      "keyword": "Magosto",
      "keywords": 3,
      "type": 1,
      "tags": [
        "work",
        "professional",
        "seller",
        "feeding",
        "food",
        "plant-based food",
        "dried fruit",
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugar con el agua": [
    {
      "id": 16745,
      "keyword": "jugar con el agua",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15507,
      "keyword": "jugar con el agua",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tabla de natación": [
    {
      "id": 15509,
      "keyword": "tabla de natación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tablas de natación": [
    {
      "id": 15509,
      "keyword": "tabla de natación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "subir la braga": [
    {
      "id": 15511,
      "keyword": "subir la braga",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir la bombacha": [
    {
      "id": 15511,
      "keyword": "subir la bombacha",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pobreza": [
    {
      "id": 15519,
      "keyword": "pobreza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vaciar": [
    {
      "id": 15487,
      "keyword": "vaciar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obligación": [
    {
      "id": 15523,
      "keyword": "obligación",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "obligaciones": [
    {
      "id": 15523,
      "keyword": "obligación",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "obligar": [
    {
      "id": 15525,
      "keyword": "obligar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibición": [
    {
      "id": 15527,
      "keyword": "prohibición",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibiciones": [
    {
      "id": 15527,
      "keyword": "prohibición",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reclamación": [
    {
      "id": 15529,
      "keyword": "reclamación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reclamaciones": [
    {
      "id": 15529,
      "keyword": "reclamación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quitarse el sujetador": [
    {
      "id": 15499,
      "keyword": "quitarse el sujetador",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar el corpiño": [
    {
      "id": 15499,
      "keyword": "quitar el corpiño",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar el sujetador": [
    {
      "id": 15499,
      "keyword": "quitar el sujetador",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "universidad": [
    {
      "id": 15537,
      "keyword": "universidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "universidades": [
    {
      "id": 15537,
      "keyword": "universidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "responsable": [
    {
      "id": 15531,
      "keyword": "responsable",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35133,
      "keyword": "responsable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16071,
      "keyword": "responsable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16073,
      "keyword": "responsable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16074,
      "keyword": "responsable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16076,
      "keyword": "responsable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "responsables": [
    {
      "id": 15531,
      "keyword": "responsable",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35133,
      "keyword": "responsable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16071,
      "keyword": "responsable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16073,
      "keyword": "responsable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16074,
      "keyword": "responsable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16076,
      "keyword": "responsable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "consecuente": [
    {
      "id": 15531,
      "keyword": "consecuente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "consecuentes": [
    {
      "id": 15531,
      "keyword": "consecuente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "subir la falda": [
    {
      "id": 15513,
      "keyword": "subir la falda",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38239,
      "keyword": "subir la falda",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir la pollera": [
    {
      "id": 15513,
      "keyword": "subir la pollera",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38239,
      "keyword": "subir la pollera",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "segundo": [
    {
      "id": 28320,
      "keyword": "segundo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34477,
      "keyword": "segundo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37748,
      "keyword": "segundo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15539,
      "keyword": "segundo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28319,
      "keyword": "segundo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tercero": [
    {
      "id": 28330,
      "keyword": "tercero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34447,
      "keyword": "tercero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37749,
      "keyword": "tercero",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15545,
      "keyword": "tercero",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28329,
      "keyword": "tercero",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terceros": [
    {
      "id": 28330,
      "keyword": "tercero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34447,
      "keyword": "tercero",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37749,
      "keyword": "tercero",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15545,
      "keyword": "tercero",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28329,
      "keyword": "tercero",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "instituto": [
    {
      "id": 32446,
      "keyword": "instituto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15515,
      "keyword": "instituto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "institutos": [
    {
      "id": 32446,
      "keyword": "instituto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15515,
      "keyword": "instituto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prostitución": [
    {
      "id": 15553,
      "keyword": "prostitución",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15555,
      "keyword": "prostitución",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15557,
      "keyword": "prostitución",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tercera": [
    {
      "id": 28330,
      "keyword": "tercera",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34447,
      "keyword": "tercera",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37749,
      "keyword": "tercera",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15543,
      "keyword": "tercera",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28327,
      "keyword": "tercera",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terceras": [
    {
      "id": 28330,
      "keyword": "tercera",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34447,
      "keyword": "tercera",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37749,
      "keyword": "tercera",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15543,
      "keyword": "tercera",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28327,
      "keyword": "tercera",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jefa de cocina": [
    {
      "id": 15712,
      "keyword": "jefa de cocina",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jefas de cocina": [
    {
      "id": 15712,
      "keyword": "jefa de cocina",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuarta": [
    {
      "id": 34475,
      "keyword": "cuarta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37750,
      "keyword": "cuarta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15547,
      "keyword": "cuarta",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuartas": [
    {
      "id": 34475,
      "keyword": "cuarta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37750,
      "keyword": "cuarta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15547,
      "keyword": "cuarta",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "banquera": [
    {
      "id": 15714,
      "keyword": "banquera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "financial services",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "banqueras": [
    {
      "id": 15714,
      "keyword": "banquera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "financial services",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vertedero": [
    {
      "id": 15726,
      "keyword": "vertedero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "environmental science",
        "recycling",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vertederos": [
    {
      "id": 15726,
      "keyword": "vertedero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "environmental science",
        "recycling",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hurgar": [
    {
      "id": 16821,
      "keyword": "hurgar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15722,
      "keyword": "hurgar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hurgarse la nariz": [
    {
      "id": 16821,
      "keyword": "hurgarse la nariz",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15722,
      "keyword": "hurgarse la nariz",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hurgar la nariz": [
    {
      "id": 16821,
      "keyword": "hurgar la nariz",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15722,
      "keyword": "hurgar la nariz",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavandería": [
    {
      "id": 15736,
      "keyword": "lavandería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29841,
      "keyword": "lavandería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavanderías": [
    {
      "id": 15736,
      "keyword": "lavandería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29841,
      "keyword": "lavandería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "candidata": [
    {
      "id": 15716,
      "keyword": "candidata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "candidatas": [
    {
      "id": 15716,
      "keyword": "candidata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "segunda": [
    {
      "id": 28320,
      "keyword": "segunda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34477,
      "keyword": "segunda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37748,
      "keyword": "segunda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15541,
      "keyword": "segunda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28315,
      "keyword": "segunda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "segundas": [
    {
      "id": 28320,
      "keyword": "segunda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34477,
      "keyword": "segunda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37748,
      "keyword": "segunda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15541,
      "keyword": "segunda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28315,
      "keyword": "segunda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "finalistas": [
    {
      "id": 15742,
      "keyword": "finalistas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15740,
      "keyword": "finalista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15738,
      "keyword": "finalista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "finalista": [
    {
      "id": 15740,
      "keyword": "finalista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15738,
      "keyword": "finalista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "electroterapia": [
    {
      "id": 15746,
      "keyword": "electroterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "electroterapias": [
    {
      "id": 15746,
      "keyword": "electroterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "servicio": [
    {
      "id": 24657,
      "keyword": "servicio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27559,
      "keyword": "servicio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27561,
      "keyword": "servicio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15810,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27475,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33935,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37331,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37710,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37904,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15814,
      "keyword": "servicio",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15812,
      "keyword": "servicio",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33936,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33934,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38625,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38626,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38627,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "servicios": [
    {
      "id": 24657,
      "keyword": "servicio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27559,
      "keyword": "servicio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27561,
      "keyword": "servicio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15810,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27475,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33935,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37331,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37710,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37904,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15814,
      "keyword": "servicio",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15812,
      "keyword": "servicio",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39122,
      "keyword": "servicios",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33936,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33934,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38625,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38626,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38627,
      "keyword": "servicio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuarto de aseo": [
    {
      "id": 15810,
      "keyword": "cuarto de aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37710,
      "keyword": "cuarto de aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15814,
      "keyword": "cuarto de aseo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15812,
      "keyword": "cuarto de aseo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuartos de aseo": [
    {
      "id": 15810,
      "keyword": "cuarto de aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37710,
      "keyword": "cuarto de aseo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15814,
      "keyword": "cuarto de aseo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15812,
      "keyword": "cuarto de aseo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28213,
      "keyword": "cuartos de aseo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aseo adaptado": [
    {
      "id": 15810,
      "keyword": "aseo adaptado",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27475,
      "keyword": "aseo adaptado",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37904,
      "keyword": "aseo adaptado",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15814,
      "keyword": "aseo adaptado",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15812,
      "keyword": "aseo adaptado",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aseo adaptados": [
    {
      "id": 15810,
      "keyword": "aseo adaptado",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27475,
      "keyword": "aseo adaptado",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15814,
      "keyword": "aseo adaptado",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15812,
      "keyword": "aseo adaptado",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "serie": [
    {
      "id": 15818,
      "keyword": "serie",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29552,
      "keyword": "serie",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29553,
      "keyword": "serie",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 19548,
      "keyword": "serie",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "series": [
    {
      "id": 15818,
      "keyword": "serie",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29552,
      "keyword": "serie",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29553,
      "keyword": "serie",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 19548,
      "keyword": "serie",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "naufragio": [
    {
      "id": 35801,
      "keyword": "naufragio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15820,
      "keyword": "naufragio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "traffic accident"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26244,
      "keyword": "naufragio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "traffic accident"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "naufragios": [
    {
      "id": 35801,
      "keyword": "naufragio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15820,
      "keyword": "naufragio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "traffic accident"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26244,
      "keyword": "naufragio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "traffic accident"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bajar la falda": [
    {
      "id": 15808,
      "keyword": "bajar la falda",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar la pollera": [
    {
      "id": 15808,
      "keyword": "bajar la pollera",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vegetariano": [
    {
      "id": 15822,
      "keyword": "vegetariano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "dietetics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vegetarianos": [
    {
      "id": 15822,
      "keyword": "vegetariano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "dietetics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bajar la braga": [
    {
      "id": 15806,
      "keyword": "bajar la braga",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar la bombacha": [
    {
      "id": 15806,
      "keyword": "bajar la bombacha",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vegetariana": [
    {
      "id": 15824,
      "keyword": "vegetariana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "dietetics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vegetarianas": [
    {
      "id": 15824,
      "keyword": "vegetariana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "dietetics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "baño de mujeres": [
    {
      "id": 15814,
      "keyword": "baño de mujeres",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baños de mujeres": [
    {
      "id": 15814,
      "keyword": "baño de mujeres",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "accidente de tren": [
    {
      "id": 15830,
      "keyword": "accidente de tren",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "traffic accident"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "accidentes de tren": [
    {
      "id": 15830,
      "keyword": "accidente de tren",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "traffic accident"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almacén de alimentación": [
    {
      "id": 15832,
      "keyword": "almacén de alimentación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almacenes de alimentación": [
    {
      "id": 15832,
      "keyword": "almacén de alimentación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almacén de lencería": [
    {
      "id": 15834,
      "keyword": "almacén de lencería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almacenes de lencería": [
    {
      "id": 15834,
      "keyword": "almacén de lencería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almacén de limpieza": [
    {
      "id": 15836,
      "keyword": "almacén de limpieza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almacenes de limpieza": [
    {
      "id": 15836,
      "keyword": "almacén de limpieza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almacén de papelería": [
    {
      "id": 15838,
      "keyword": "almacén de papelería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almacenes de papelería": [
    {
      "id": 15838,
      "keyword": "almacén de papelería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almacén de la plancha": [
    {
      "id": 15840,
      "keyword": "almacén de la plancha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almacenes de la plancha": [
    {
      "id": 15840,
      "keyword": "almacén de la plancha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ascensor montacamillas": [
    {
      "id": 15826,
      "keyword": "ascensor montacamillas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "health",
        "medicine",
        "medical center",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ascensores montacamillas": [
    {
      "id": 15826,
      "keyword": "ascensor montacamillas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "health",
        "medicine",
        "medical center",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "baño de hombres": [
    {
      "id": 15812,
      "keyword": "baño de hombres",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baños de hombres": [
    {
      "id": 15812,
      "keyword": "baño de hombres",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centralita": [
    {
      "id": 15897,
      "keyword": "centralita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15895,
      "keyword": "centralita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centralitas": [
    {
      "id": 15897,
      "keyword": "centralita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15895,
      "keyword": "centralita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "accidente aéreo": [
    {
      "id": 15828,
      "keyword": "accidente aéreo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "traffic accident"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "accidentes aéreos": [
    {
      "id": 15828,
      "keyword": "accidente aéreo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "traffic accident"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "depuradora": [
    {
      "id": 24300,
      "keyword": "depuradora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15899,
      "keyword": "depuradora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "depuradoras": [
    {
      "id": 24300,
      "keyword": "depuradora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15899,
      "keyword": "depuradora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuadro eléctrico": [
    {
      "id": 15901,
      "keyword": "cuadro eléctrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuadros eléctricos": [
    {
      "id": 15901,
      "keyword": "cuadro eléctrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ducha adaptada": [
    {
      "id": 38588,
      "keyword": "ducha adaptada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15907,
      "keyword": "ducha adaptada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "duchas adaptadas": [
    {
      "id": 38588,
      "keyword": "ducha adaptada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15907,
      "keyword": "ducha adaptada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contenedor de envases": [
    {
      "id": 15911,
      "keyword": "contenedor de envases",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contenedores de envases": [
    {
      "id": 15911,
      "keyword": "contenedor de envases",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almacén de ropa": [
    {
      "id": 15842,
      "keyword": "almacén de ropa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almacenes de ropa": [
    {
      "id": 15842,
      "keyword": "almacén de ropa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grupo de presión": [
    {
      "id": 15913,
      "keyword": "grupo de presión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grupos de presión": [
    {
      "id": 15913,
      "keyword": "grupo de presión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "generador": [
    {
      "id": 15917,
      "keyword": "generador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15916,
      "keyword": "generador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "generadores": [
    {
      "id": 15917,
      "keyword": "generador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15916,
      "keyword": "generador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grupo electrógeno": [
    {
      "id": 15917,
      "keyword": "grupo electrógeno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15916,
      "keyword": "grupo electrógeno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grupos electrógenos": [
    {
      "id": 15917,
      "keyword": "grupo electrógeno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15916,
      "keyword": "grupo electrógeno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "teléfono inalámbrico": [
    {
      "id": 15923,
      "keyword": "teléfono inalámbrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "communication"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teléfonos inalámbricos": [
    {
      "id": 15923,
      "keyword": "teléfono inalámbrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "communication"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manga de evacuación": [
    {
      "id": 15921,
      "keyword": "manga de evacuación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mangas de evacuación": [
    {
      "id": 15921,
      "keyword": "manga de evacuación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "terapia de grupo": [
    {
      "id": 25552,
      "keyword": "terapia de grupo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15925,
      "keyword": "terapia de grupo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terapias de grupo": [
    {
      "id": 25552,
      "keyword": "terapia de grupo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15925,
      "keyword": "terapia de grupo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "váter adaptado": [
    {
      "id": 27553,
      "keyword": "váter adaptado",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15927,
      "keyword": "váter adaptado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "váteres adaptados": [
    {
      "id": 27553,
      "keyword": "váter adaptado",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15927,
      "keyword": "váter adaptado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "baño adaptado": [
    {
      "id": 27553,
      "keyword": "baño adaptado",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15905,
      "keyword": "baño adaptado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baños adaptados": [
    {
      "id": 27553,
      "keyword": "baño adaptado",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15905,
      "keyword": "baño adaptado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fax": [
    {
      "id": 15909,
      "keyword": "fax",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "faxes": [
    {
      "id": 15909,
      "keyword": "fax",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "representante de alumnos": [
    {
      "id": 39262,
      "keyword": "representante de alumnos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15929,
      "keyword": "representante de alumnos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15931,
      "keyword": "representante de alumnos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "representantes de alumnos": [
    {
      "id": 39262,
      "keyword": "representante de alumnos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15929,
      "keyword": "representante de alumnos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15931,
      "keyword": "representante de alumnos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16123,
      "keyword": "representantes de alumnos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "representante": [
    {
      "id": 39262,
      "keyword": "representante",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15929,
      "keyword": "representante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15931,
      "keyword": "representante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "representantes": [
    {
      "id": 39262,
      "keyword": "representante",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15929,
      "keyword": "representante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15931,
      "keyword": "representante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16123,
      "keyword": "representantes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "delegada": [
    {
      "id": 39262,
      "keyword": "delegada",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15929,
      "keyword": "delegada",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "delegadas": [
    {
      "id": 39262,
      "keyword": "delegada",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15929,
      "keyword": "delegada",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "crisis": [
    {
      "id": 15990,
      "keyword": "crisis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crisis económica": [
    {
      "id": 15990,
      "keyword": "crisis económica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cobro": [
    {
      "id": 15988,
      "keyword": "cobro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cobros": [
    {
      "id": 15988,
      "keyword": "cobro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cobrar": [
    {
      "id": 15986,
      "keyword": "cobrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despensa": [
    {
      "id": 15996,
      "keyword": "despensa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despensas": [
    {
      "id": 15996,
      "keyword": "despensa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oponerse": [
    {
      "id": 16000,
      "keyword": "oponerse",
      "keywords": 1,
      "type": 3,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16004,
      "keyword": "oponerse",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24751,
      "keyword": "oponerse",
      "keywords": 2,
      "type": 3,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16002,
      "keyword": "oponerse",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16007,
      "keyword": "oponerse",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "delegado": [
    {
      "id": 39262,
      "keyword": "delegado",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15931,
      "keyword": "delegado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "delegados": [
    {
      "id": 39262,
      "keyword": "delegado",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 15931,
      "keyword": "delegado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16123,
      "keyword": "delegados",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavabo adaptado": [
    {
      "id": 15919,
      "keyword": "lavabo adaptado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavabos adaptados": [
    {
      "id": 15919,
      "keyword": "lavabo adaptado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oposición": [
    {
      "id": 16013,
      "keyword": "oposición",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33006,
      "keyword": "oposición",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16009,
      "keyword": "oposición",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24751,
      "keyword": "oposición",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "oposiciones": [
    {
      "id": 16013,
      "keyword": "oposición",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16009,
      "keyword": "oposición",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24751,
      "keyword": "oposición",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "oponer": [
    {
      "id": 16009,
      "keyword": "oponer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "psychology",
        "human response",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24753,
      "keyword": "oponer",
      "keywords": 7,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acusado": [
    {
      "id": 37667,
      "keyword": "acusado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 15984,
      "keyword": "acusado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acusados": [
    {
      "id": 15984,
      "keyword": "acusado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pago": [
    {
      "id": 16017,
      "keyword": "pago",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pagos": [
    {
      "id": 16017,
      "keyword": "pago",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adquisición": [
    {
      "id": 16017,
      "keyword": "adquisición",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adquisiciones": [
    {
      "id": 16017,
      "keyword": "adquisición",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asegurar": [
    {
      "id": 16021,
      "keyword": "asegurar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "document",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37860,
      "keyword": "asegurar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seguro": [
    {
      "id": 16027,
      "keyword": "seguro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16029,
      "keyword": "seguro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16031,
      "keyword": "seguro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16035,
      "keyword": "seguro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "event",
        "social event",
        "death",
        "work",
        "work accident",
        "movement",
        "traffic",
        "traffic accident"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16033,
      "keyword": "seguro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seguros": [
    {
      "id": 16027,
      "keyword": "seguro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16029,
      "keyword": "seguro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16031,
      "keyword": "seguro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16035,
      "keyword": "seguro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "event",
        "social event",
        "death",
        "work",
        "work accident",
        "movement",
        "traffic",
        "traffic accident"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16033,
      "keyword": "seguro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "seguro de coche": [
    {
      "id": 16029,
      "keyword": "seguro de coche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seguros de coche": [
    {
      "id": 16029,
      "keyword": "seguro de coche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "seguro del hogar": [
    {
      "id": 16031,
      "keyword": "seguro del hogar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seguros del hogar": [
    {
      "id": 16031,
      "keyword": "seguro del hogar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "regalar": [
    {
      "id": 16881,
      "keyword": "regalar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16025,
      "keyword": "regalar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16879,
      "keyword": "regalar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16877,
      "keyword": "regalar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dar un regalo": [
    {
      "id": 16881,
      "keyword": "dar un regalo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16025,
      "keyword": "dar un regalo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16879,
      "keyword": "dar un regalo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16877,
      "keyword": "dar un regalo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seguro de vida": [
    {
      "id": 16035,
      "keyword": "seguro de vida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "event",
        "social event",
        "death",
        "work",
        "work accident",
        "movement",
        "traffic",
        "traffic accident"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seguros de vida": [
    {
      "id": 16035,
      "keyword": "seguro de vida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "event",
        "social event",
        "death",
        "work",
        "work accident",
        "movement",
        "traffic",
        "traffic accident"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sopa de carne": [
    {
      "id": 16043,
      "keyword": "sopa de carne",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sopas de carne": [
    {
      "id": 16043,
      "keyword": "sopa de carne",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gerente": [
    {
      "id": 16039,
      "keyword": "gerente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16041,
      "keyword": "gerente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gerentes": [
    {
      "id": 16039,
      "keyword": "gerente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16041,
      "keyword": "gerente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sopa de marisco": [
    {
      "id": 16045,
      "keyword": "sopa de marisco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sopas de marisco": [
    {
      "id": 16045,
      "keyword": "sopa de marisco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sopa de pescado": [
    {
      "id": 16047,
      "keyword": "sopa de pescado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sopas de pescado": [
    {
      "id": 16047,
      "keyword": "sopa de pescado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sopa de pollo": [
    {
      "id": 16049,
      "keyword": "sopa de pollo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sopas de pollo": [
    {
      "id": 16049,
      "keyword": "sopa de pollo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jefa de mantenimiento": [
    {
      "id": 16051,
      "keyword": "jefa de mantenimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jefas de mantenimiento": [
    {
      "id": 16051,
      "keyword": "jefa de mantenimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encargado": [
    {
      "id": 16057,
      "keyword": "encargado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encargados": [
    {
      "id": 16057,
      "keyword": "encargado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almacenero": [
    {
      "id": 16057,
      "keyword": "almacenero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almaceneros": [
    {
      "id": 16057,
      "keyword": "almacenero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encargado del almacén": [
    {
      "id": 16057,
      "keyword": "encargado del almacén",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encargados del almacén": [
    {
      "id": 16057,
      "keyword": "encargado del almacén",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "servicio de limpieza": [
    {
      "id": 16059,
      "keyword": "servicio de limpieza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "servicios de limpieza": [
    {
      "id": 16059,
      "keyword": "servicio de limpieza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jefe de mantenimiento": [
    {
      "id": 16053,
      "keyword": "jefe de mantenimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jefes de mantenimiento": [
    {
      "id": 16053,
      "keyword": "jefe de mantenimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "seguro de salud": [
    {
      "id": 16033,
      "keyword": "seguro de salud",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seguros de salud": [
    {
      "id": 16033,
      "keyword": "seguro de salud",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "servicio de orientación": [
    {
      "id": 16063,
      "keyword": "servicio de orientación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "organization",
        "special education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16065,
      "keyword": "servicio de orientación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "organization",
        "special education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "servicios de orientación": [
    {
      "id": 16063,
      "keyword": "servicio de orientación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "organization",
        "special education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16065,
      "keyword": "servicio de orientación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "organization",
        "special education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almacén de la vajilla": [
    {
      "id": 16067,
      "keyword": "almacén de la vajilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almacenes de la vajilla": [
    {
      "id": 16067,
      "keyword": "almacén de la vajilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encargada": [
    {
      "id": 16055,
      "keyword": "encargada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encargadas": [
    {
      "id": 16055,
      "keyword": "encargada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encargada del almacén": [
    {
      "id": 16055,
      "keyword": "encargada del almacén",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encargadas del almacén": [
    {
      "id": 16055,
      "keyword": "encargada del almacén",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "responsable de administración": [
    {
      "id": 16074,
      "keyword": "responsable de administración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16076,
      "keyword": "responsable de administración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "responsables de administración": [
    {
      "id": 16074,
      "keyword": "responsable de administración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16076,
      "keyword": "responsable de administración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "productos de apoyo": [
    {
      "id": 16023,
      "keyword": "productos de apoyo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid",
        "object",
        "orthopedic product",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comité de empresa": [
    {
      "id": 16080,
      "keyword": "comité de empresa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comités de empresa": [
    {
      "id": 16080,
      "keyword": "comité de empresa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comité": [
    {
      "id": 16080,
      "keyword": "comité",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16161,
      "keyword": "comité",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comités": [
    {
      "id": 16080,
      "keyword": "comité",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16161,
      "keyword": "comité",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "archivo general": [
    {
      "id": 16078,
      "keyword": "archivo general",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "archivos generales": [
    {
      "id": 16078,
      "keyword": "archivo general",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "terapeuta ocupacional": [
    {
      "id": 38778,
      "keyword": "terapeuta ocupacional",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "health",
        "occupational therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16082,
      "keyword": "terapeuta ocupacional",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "occupational therapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16084,
      "keyword": "terapeuta ocupacional",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "occupational therapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32971,
      "keyword": "terapeuta ocupacional",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "occupational therapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32970,
      "keyword": "terapeuta ocupacional",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "occupational therapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terapeutas ocupacionales": [
    {
      "id": 38778,
      "keyword": "terapeuta ocupacional",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "health",
        "occupational therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16082,
      "keyword": "terapeuta ocupacional",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "occupational therapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16084,
      "keyword": "terapeuta ocupacional",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "occupational therapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32971,
      "keyword": "terapeuta ocupacional",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "occupational therapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32970,
      "keyword": "terapeuta ocupacional",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "occupational therapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espera": [
    {
      "id": 16091,
      "keyword": "espera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esperas": [
    {
      "id": 16091,
      "keyword": "espera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "autoestima": [
    {
      "id": 16095,
      "keyword": "autoestima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human value",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autoestimas": [
    {
      "id": 16095,
      "keyword": "autoestima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human value",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ilegal": [
    {
      "id": 16100,
      "keyword": "ilegal",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "tertiary sector",
        "law",
        "justice",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ilegales": [
    {
      "id": 16100,
      "keyword": "ilegal",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "tertiary sector",
        "law",
        "justice",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pasajera": [
    {
      "id": 16105,
      "keyword": "pasajera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28179,
      "keyword": "pasajera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasajeras": [
    {
      "id": 16105,
      "keyword": "pasajera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28179,
      "keyword": "pasajera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "viajera": [
    {
      "id": 28173,
      "keyword": "viajera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "tourism",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28171,
      "keyword": "viajera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16105,
      "keyword": "viajera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28179,
      "keyword": "viajera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viajeras": [
    {
      "id": 28173,
      "keyword": "viajera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "tourism",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28171,
      "keyword": "viajera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16105,
      "keyword": "viajera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28179,
      "keyword": "viajera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pasajero": [
    {
      "id": 28181,
      "keyword": "pasajero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16107,
      "keyword": "pasajero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasajeros": [
    {
      "id": 28181,
      "keyword": "pasajero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16107,
      "keyword": "pasajero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "terrorista": [
    {
      "id": 16111,
      "keyword": "terrorista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terroristas": [
    {
      "id": 16111,
      "keyword": "terrorista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trabajo": [
    {
      "id": 16087,
      "keyword": "trabajo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trabajos": [
    {
      "id": 16087,
      "keyword": "trabajo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "profesionalidad": [
    {
      "id": 16087,
      "keyword": "profesionalidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acusada": [
    {
      "id": 16093,
      "keyword": "acusada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acusadas": [
    {
      "id": 16093,
      "keyword": "acusada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuarto de la limpieza": [
    {
      "id": 16117,
      "keyword": "cuarto de la limpieza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuartos de la limpieza": [
    {
      "id": 16117,
      "keyword": "cuarto de la limpieza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mayor que": [
    {
      "id": 16119,
      "keyword": "mayor que",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "menor que": [
    {
      "id": 16121,
      "keyword": "menor que",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taller de mantenimiento": [
    {
      "id": 16127,
      "keyword": "taller de mantenimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talleres de mantenimiento": [
    {
      "id": 16127,
      "keyword": "taller de mantenimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿puedo ayudarte?": [
    {
      "id": 16125,
      "keyword": "¿puedo ayudarte?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿necesitas ayuda?": [
    {
      "id": 16125,
      "keyword": "¿necesitas ayuda?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sección": [
    {
      "id": 16129,
      "keyword": "sección",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secciones": [
    {
      "id": 16129,
      "keyword": "sección",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de juegos": [
    {
      "id": 16133,
      "keyword": "sala de juegos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system",
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de juegos": [
    {
      "id": 16133,
      "keyword": "sala de juegos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system",
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de musculación": [
    {
      "id": 16135,
      "keyword": "sala de musculación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de musculación": [
    {
      "id": 16135,
      "keyword": "sala de musculación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de curas": [
    {
      "id": 16131,
      "keyword": "sala de curas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de curas": [
    {
      "id": 16131,
      "keyword": "sala de curas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de rehabilitación": [
    {
      "id": 16137,
      "keyword": "sala de rehabilitación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de rehabilitación": [
    {
      "id": 16137,
      "keyword": "sala de rehabilitación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "terrorismo": [
    {
      "id": 16109,
      "keyword": "terrorismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terrorismos": [
    {
      "id": 16109,
      "keyword": "terrorismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "baño geriátrico": [
    {
      "id": 16143,
      "keyword": "baño geriátrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16145,
      "keyword": "baño geriátrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baños geriátricos": [
    {
      "id": 16143,
      "keyword": "baño geriátrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16145,
      "keyword": "baño geriátrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de la televisión": [
    {
      "id": 16139,
      "keyword": "sala de la televisión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de la televisión": [
    {
      "id": 16139,
      "keyword": "sala de la televisión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cocina de la cafetería": [
    {
      "id": 16147,
      "keyword": "cocina de la cafetería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "catering establishment",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cocinas de la cafetería": [
    {
      "id": 16147,
      "keyword": "cocina de la cafetería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "catering establishment",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuarto de calderas": [
    {
      "id": 16115,
      "keyword": "cuarto de calderas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuartos de calderas": [
    {
      "id": 16115,
      "keyword": "cuarto de calderas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuarto de cuidadores": [
    {
      "id": 16153,
      "keyword": "cuarto de cuidadores",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuartos de cuidadores": [
    {
      "id": 16153,
      "keyword": "cuarto de cuidadores",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de yesos": [
    {
      "id": 16141,
      "keyword": "sala de yesos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de yesos": [
    {
      "id": 16141,
      "keyword": "sala de yesos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "crmf": [
    {
      "id": 16151,
      "keyword": "CRMF",
      "keywords": 2,
      "type": 1,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centro de recuperación de minusválidos físicos": [
    {
      "id": 16151,
      "keyword": "Centro de Recuperación de Minusválidos Físicos",
      "keywords": 2,
      "type": 1,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "utilizar el cuaderno de comunicación": [
    {
      "id": 16155,
      "keyword": "utilizar el cuaderno de comunicación",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "padrón municipal": [
    {
      "id": 16163,
      "keyword": "padrón municipal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "supporting document",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "padrones municipales": [
    {
      "id": 16163,
      "keyword": "padrón municipal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "supporting document",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comité sindical": [
    {
      "id": 16161,
      "keyword": "comité sindical",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comités sindicales": [
    {
      "id": 16161,
      "keyword": "comité sindical",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cita": [
    {
      "id": 16165,
      "keyword": "cita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "citas": [
    {
      "id": 16165,
      "keyword": "cita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "citar": [
    {
      "id": 16167,
      "keyword": "citar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "documentos": [
    {
      "id": 16169,
      "keyword": "documentos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21802,
      "keyword": "documento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comedor del personal": [
    {
      "id": 16149,
      "keyword": "comedor del personal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comedores del personal": [
    {
      "id": 16149,
      "keyword": "comedor del personal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "otro color": [
    {
      "id": 16171,
      "keyword": "otro color",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "color"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "administración": [
    {
      "id": 37653,
      "keyword": "administración",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16174,
      "keyword": "administración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16176,
      "keyword": "administración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "administraciones": [
    {
      "id": 16174,
      "keyword": "administración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16176,
      "keyword": "administración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "técnico de administración": [
    {
      "id": 16174,
      "keyword": "técnico de administración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnicos de administración": [
    {
      "id": 16174,
      "keyword": "técnico de administración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "técnica superior de actividades específicas": [
    {
      "id": 16178,
      "keyword": "técnica superior de actividades específicas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnicas superiores de actividades específicas": [
    {
      "id": 16178,
      "keyword": "técnica superior de actividades específicas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "técnica de animación sociocultural": [
    {
      "id": 16178,
      "keyword": "técnica de animación sociocultural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnicas de animación sociocultural": [
    {
      "id": 16178,
      "keyword": "técnica de animación sociocultural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "técnica de administración": [
    {
      "id": 16176,
      "keyword": "técnica de administración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnicas de administración": [
    {
      "id": 16176,
      "keyword": "técnica de administración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "técnico superior de actividades específicas": [
    {
      "id": 24701,
      "keyword": "técnico superior de actividades específicas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24699,
      "keyword": "técnico superior de actividades específicas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16180,
      "keyword": "técnico superior de actividades específicas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnicos superiores de actividades específicas": [
    {
      "id": 24701,
      "keyword": "técnico superior de actividades específicas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24699,
      "keyword": "técnico superior de actividades específicas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16180,
      "keyword": "técnico superior de actividades específicas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "técnico de animación sociocultural": [
    {
      "id": 24701,
      "keyword": "técnico de animación sociocultural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24699,
      "keyword": "técnico de animación sociocultural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16180,
      "keyword": "técnico de animación sociocultural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnicos de animación sociocultural": [
    {
      "id": 24701,
      "keyword": "técnico de animación sociocultural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24699,
      "keyword": "técnico de animación sociocultural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16180,
      "keyword": "técnico de animación sociocultural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "unidad de empleo, igualdad, cooperación y comunicación": [
    {
      "id": 16182,
      "keyword": "Unidad de Empleo, Igualdad, Cooperación y Comunicación",
      "keywords": 1,
      "type": 1,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "unifor": [
    {
      "id": 16184,
      "keyword": "UNIFOR",
      "keywords": 1,
      "type": 1,
      "tags": [
        "international organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "médico rehabilitador": [
    {
      "id": 38844,
      "keyword": "médico rehabilitador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16188,
      "keyword": "médico rehabilitador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "médicos rehabilitadores": [
    {
      "id": 38844,
      "keyword": "médico rehabilitador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16188,
      "keyword": "médico rehabilitador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rehabilitador": [
    {
      "id": 38844,
      "keyword": "rehabilitador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16188,
      "keyword": "rehabilitador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rehabilitadores": [
    {
      "id": 38844,
      "keyword": "rehabilitador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16188,
      "keyword": "rehabilitador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "médica rehabilitadora": [
    {
      "id": 16186,
      "keyword": "médica rehabilitadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "médicas rehabilitadoras": [
    {
      "id": 16186,
      "keyword": "médica rehabilitadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rehabilitadora": [
    {
      "id": 38844,
      "keyword": "rehabilitadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16186,
      "keyword": "rehabilitadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rehabilitadoras": [
    {
      "id": 38844,
      "keyword": "rehabilitadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16186,
      "keyword": "rehabilitadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "despacho de los representantes de los alumnos": [
    {
      "id": 16190,
      "keyword": "despacho de los representantes de los alumnos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "students",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despachos de los representantes de los alumnos": [
    {
      "id": 16190,
      "keyword": "despacho de los representantes de los alumnos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "students",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "despeinada": [
    {
      "id": 16289,
      "keyword": "despeinada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despeinadas": [
    {
      "id": 16289,
      "keyword": "despeinada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "depósito": [
    {
      "id": 16285,
      "keyword": "depósito",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "depósitos": [
    {
      "id": 16285,
      "keyword": "depósito",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "depósito de agua": [
    {
      "id": 16285,
      "keyword": "depósito de agua",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "depósitos de agua": [
    {
      "id": 16285,
      "keyword": "depósito de agua",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "edredón": [
    {
      "id": 16297,
      "keyword": "edredón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "edredones": [
    {
      "id": 16297,
      "keyword": "edredón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "despeinado": [
    {
      "id": 16293,
      "keyword": "despeinado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despeinados": [
    {
      "id": 16293,
      "keyword": "despeinado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cómoda": [
    {
      "id": 37793,
      "keyword": "cómoda",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16281,
      "keyword": "cómoda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37771,
      "keyword": "cómoda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21474,
      "keyword": "cómoda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cómodas": [
    {
      "id": 37793,
      "keyword": "cómoda",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16281,
      "keyword": "cómoda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37771,
      "keyword": "cómoda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21474,
      "keyword": "cómoda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encuadernar": [
    {
      "id": 16301,
      "keyword": "encuadernar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gobernante": [
    {
      "id": 16307,
      "keyword": "gobernante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27505,
      "keyword": "gobernante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32980,
      "keyword": "gobernante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gobernantes": [
    {
      "id": 16307,
      "keyword": "gobernante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27505,
      "keyword": "gobernante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32980,
      "keyword": "gobernante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cardióloga": [
    {
      "id": 38825,
      "keyword": "cardióloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16319,
      "keyword": "cardióloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cardiólogas": [
    {
      "id": 38825,
      "keyword": "cardióloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16319,
      "keyword": "cardióloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arrugado": [
    {
      "id": 16323,
      "keyword": "arrugado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arrugados": [
    {
      "id": 16323,
      "keyword": "arrugado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arrugada": [
    {
      "id": 16323,
      "keyword": "arrugada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arrugadas": [
    {
      "id": 16323,
      "keyword": "arrugada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peinada": [
    {
      "id": 16327,
      "keyword": "peinada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peinadas": [
    {
      "id": 16327,
      "keyword": "peinada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peinado": [
    {
      "id": 16331,
      "keyword": "peinado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peinados": [
    {
      "id": 16331,
      "keyword": "peinado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "objetos perdidos": [
    {
      "id": 16159,
      "keyword": "objetos perdidos",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "objeto perdido": [
    {
      "id": 16159,
      "keyword": "objeto perdido",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "utilizar el tablero de comunicación": [
    {
      "id": 16157,
      "keyword": "utilizar el tablero de comunicación",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasillo": [
    {
      "id": 16315,
      "keyword": "pasillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasillos": [
    {
      "id": 16315,
      "keyword": "pasillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cardiólogo": [
    {
      "id": 38825,
      "keyword": "cardiólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16321,
      "keyword": "cardiólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cardiólogos": [
    {
      "id": 38825,
      "keyword": "cardiólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16321,
      "keyword": "cardiólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "duplicar": [
    {
      "id": 16345,
      "keyword": "duplicar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tizas": [
    {
      "id": 16343,
      "keyword": "tizas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36602,
      "keyword": "tiza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aportación": [
    {
      "id": 16351,
      "keyword": "aportación",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "aportaciones": [
    {
      "id": 16351,
      "keyword": "aportación",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "entrega": [
    {
      "id": 16351,
      "keyword": "entrega",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "entregas": [
    {
      "id": 16351,
      "keyword": "entrega",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "impulso": [
    {
      "id": 16355,
      "keyword": "impulso",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17034,
      "keyword": "impulso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "impulsos": [
    {
      "id": 16355,
      "keyword": "impulso",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    },
    {
      "id": 17034,
      "keyword": "impulso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enfermedad de alzheimer": [
    {
      "id": 16349,
      "keyword": "enfermedad de Alzheimer",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alzheimer": [
    {
      "id": 16349,
      "keyword": "Alzheimer",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "planchado": [
    {
      "id": 16335,
      "keyword": "planchado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "planchados": [
    {
      "id": 16335,
      "keyword": "planchado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "planchada": [
    {
      "id": 16335,
      "keyword": "planchada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "planchadas": [
    {
      "id": 16335,
      "keyword": "planchada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "artes gráficas": [
    {
      "id": 16339,
      "keyword": "artes gráficas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "craftsmanship",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muerte": [
    {
      "id": 34203,
      "keyword": "muerte",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38054,
      "keyword": "muerte",
      "keywords": 4,
      "type": 2,
      "tags": [
        "document",
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16359,
      "keyword": "muerte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16363,
      "keyword": "muerte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muertes": [
    {
      "id": 16359,
      "keyword": "muerte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16363,
      "keyword": "muerte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "morir": [
    {
      "id": 29863,
      "keyword": "morir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "event",
        "social event",
        "death",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32250,
      "keyword": "morir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29862,
      "keyword": "morir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16359,
      "keyword": "morir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "event",
        "social event",
        "death",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "demencia": [
    {
      "id": 16347,
      "keyword": "demencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "demencias": [
    {
      "id": 16347,
      "keyword": "demencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asesinato": [
    {
      "id": 16363,
      "keyword": "asesinato",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asesinatos": [
    {
      "id": 16363,
      "keyword": "asesinato",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oculista": [
    {
      "id": 38824,
      "keyword": "oculista",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16367,
      "keyword": "oculista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16365,
      "keyword": "oculista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oculistas": [
    {
      "id": 38824,
      "keyword": "oculista",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16367,
      "keyword": "oculista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16365,
      "keyword": "oculista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oftalmólogo": [
    {
      "id": 38824,
      "keyword": "oftalmólogo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16367,
      "keyword": "oftalmólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oftalmólogos": [
    {
      "id": 38824,
      "keyword": "oftalmólogo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16367,
      "keyword": "oftalmólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oftalmóloga": [
    {
      "id": 38824,
      "keyword": "oftalmóloga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16365,
      "keyword": "oftalmóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oftalmólogas": [
    {
      "id": 38824,
      "keyword": "oftalmóloga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16365,
      "keyword": "oftalmóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agachar": [
    {
      "id": 16437,
      "keyword": "agachar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pesimismo": [
    {
      "id": 16371,
      "keyword": "pesimismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pesimismos": [
    {
      "id": 16371,
      "keyword": "pesimismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tristeza": [
    {
      "id": 16371,
      "keyword": "tristeza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aupar": [
    {
      "id": 16445,
      "keyword": "aupar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29752,
      "keyword": "aupar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "afilador": [
    {
      "id": 16449,
      "keyword": "afilador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25772,
      "keyword": "afilador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "object",
        "household",
        "cutlery",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "afiladores": [
    {
      "id": 16449,
      "keyword": "afilador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25772,
      "keyword": "afilador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "object",
        "household",
        "cutlery",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pisar": [
    {
      "id": 39092,
      "keyword": "pisar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16380,
      "keyword": "pisar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pisotón": [
    {
      "id": 16380,
      "keyword": "pisotón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pisotones": [
    {
      "id": 16380,
      "keyword": "pisotón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "banderilla": [
    {
      "id": 16463,
      "keyword": "banderilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29090,
      "keyword": "banderilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "banderillas": [
    {
      "id": 16463,
      "keyword": "banderilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29090,
      "keyword": "banderilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pegar una bofetada": [
    {
      "id": 17179,
      "keyword": "pegar una bofetada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16467,
      "keyword": "pegar una bofetada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25215,
      "keyword": "pegar una bofetada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime",
        "gender violence"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34344,
      "keyword": "pegar una bofetada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34345,
      "keyword": "pegar una bofetada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bofetada": [
    {
      "id": 17179,
      "keyword": "bofetada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16467,
      "keyword": "bofetada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25215,
      "keyword": "bofetada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime",
        "gender violence"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34343,
      "keyword": "bofetada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34344,
      "keyword": "bofetada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34345,
      "keyword": "bofetada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bofetadas": [
    {
      "id": 17179,
      "keyword": "bofetada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16467,
      "keyword": "bofetada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25215,
      "keyword": "bofetada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime",
        "gender violence"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34343,
      "keyword": "bofetada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34344,
      "keyword": "bofetada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34345,
      "keyword": "bofetada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carpintería": [
    {
      "id": 16471,
      "keyword": "carpintería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "secondary sector",
        "carpentry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carpinterías": [
    {
      "id": 16471,
      "keyword": "carpintería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "secondary sector",
        "carpentry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alfarería": [
    {
      "id": 16453,
      "keyword": "alfarería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "workplace",
        "secondary sector",
        "craftsmanship",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alfarerías": [
    {
      "id": 16453,
      "keyword": "alfarería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "workplace",
        "secondary sector",
        "craftsmanship",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "blog": [
    {
      "id": 16577,
      "keyword": "blog",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "blogs": [
    {
      "id": 16577,
      "keyword": "blog",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bitácora": [
    {
      "id": 16577,
      "keyword": "bitácora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bitácoras": [
    {
      "id": 16577,
      "keyword": "bitácora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bocadillo de calamares": [
    {
      "id": 16581,
      "keyword": "bocadillo de calamares",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bocadillos de calamares": [
    {
      "id": 16581,
      "keyword": "bocadillo de calamares",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botas de fútbol": [
    {
      "id": 16585,
      "keyword": "botas de fútbol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27274,
      "keyword": "botas de fútbol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36503,
      "keyword": "bota de fútbol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bote de pepinillos": [
    {
      "id": 16587,
      "keyword": "bote de pepinillos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botes de pepinillos": [
    {
      "id": 16587,
      "keyword": "bote de pepinillos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botines": [
    {
      "id": 16595,
      "keyword": "botines",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16591,
      "keyword": "botín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cargador": [
    {
      "id": 16597,
      "keyword": "cargador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27651,
      "keyword": "cargador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31819,
      "keyword": "cargador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cargadores": [
    {
      "id": 16597,
      "keyword": "cargador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27651,
      "keyword": "cargador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31819,
      "keyword": "cargador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cheque": [
    {
      "id": 16605,
      "keyword": "cheque",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cheques": [
    {
      "id": 16605,
      "keyword": "cheque",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cigarra": [
    {
      "id": 16613,
      "keyword": "cigarra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cigarras": [
    {
      "id": 16613,
      "keyword": "cigarra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cocear": [
    {
      "id": 39082,
      "keyword": "cocear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "animal",
        "animal behavior",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16617,
      "keyword": "cocear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "columna vertebral": [
    {
      "id": 16619,
      "keyword": "columna vertebral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system",
        "nervous system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23959,
      "keyword": "columna vertebral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system",
        "nervous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "columnas vertebrales": [
    {
      "id": 16619,
      "keyword": "columna vertebral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system",
        "nervous system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23959,
      "keyword": "columna vertebral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system",
        "nervous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desarrollo": [
    {
      "id": 16629,
      "keyword": "desarrollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39286,
      "keyword": "desarrollo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desarrollo infantil": [
    {
      "id": 16629,
      "keyword": "desarrollo infantil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39286,
      "keyword": "desarrollo infantil",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botín": [
    {
      "id": 16591,
      "keyword": "botín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presidente de aragón": [
    {
      "id": 16377,
      "keyword": "presidente de Aragón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "work",
        "tertiary sector",
        "political representation",
        "Aragon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presidentes de aragón": [
    {
      "id": 16377,
      "keyword": "presidente de Aragón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "work",
        "tertiary sector",
        "political representation",
        "Aragon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cupido": [
    {
      "id": 16637,
      "keyword": "Cupido",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crecimiento": [
    {
      "id": 16631,
      "keyword": "crecimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crecimientos": [
    {
      "id": 16631,
      "keyword": "crecimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "disfrutar": [
    {
      "id": 16647,
      "keyword": "disfrutar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chapa": [
    {
      "id": 16601,
      "keyword": "chapa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chapas": [
    {
      "id": 16601,
      "keyword": "chapa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "erección": [
    {
      "id": 16661,
      "keyword": "erección",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "erecciones": [
    {
      "id": 16661,
      "keyword": "erección",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "eyaculación": [
    {
      "id": 16665,
      "keyword": "eyaculación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "human reproduction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "eyaculaciones": [
    {
      "id": 16665,
      "keyword": "eyaculación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "human reproduction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vasectomía": [
    {
      "id": 16681,
      "keyword": "vasectomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vasectomías": [
    {
      "id": 16681,
      "keyword": "vasectomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "empujón": [
    {
      "id": 16655,
      "keyword": "empujón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esquiar": [
    {
      "id": 16701,
      "keyword": "esquiar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38425,
      "keyword": "esquiar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38715,
      "keyword": "esquiar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38720,
      "keyword": "esquiar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "adapted sport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estornudo": [
    {
      "id": 16703,
      "keyword": "estornudo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35965,
      "keyword": "estornudo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36535,
      "keyword": "estornudo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "prevention measure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36536,
      "keyword": "estornudo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "prevention measure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estornudos": [
    {
      "id": 16703,
      "keyword": "estornudo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35965,
      "keyword": "estornudo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36535,
      "keyword": "estornudo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "prevention measure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36536,
      "keyword": "estornudo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "prevention measure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espolvorear": [
    {
      "id": 16699,
      "keyword": "espolvorear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autolesionar": [
    {
      "id": 16707,
      "keyword": "autolesionar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35587,
      "keyword": "autolesionar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38922,
      "keyword": "autolesionar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oruga": [
    {
      "id": 16727,
      "keyword": "oruga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "terrestrial animal",
        "oviparous",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orugas": [
    {
      "id": 16727,
      "keyword": "oruga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "terrestrial animal",
        "oviparous",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gusano de seda": [
    {
      "id": 16727,
      "keyword": "gusano de seda",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "terrestrial animal",
        "oviparous",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gusanos de seda": [
    {
      "id": 16727,
      "keyword": "gusano de seda",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "terrestrial animal",
        "oviparous",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dinamita": [
    {
      "id": 16721,
      "keyword": "dinamita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "work",
        "primary sector",
        "mining",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dinamitas": [
    {
      "id": 16721,
      "keyword": "dinamita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "work",
        "primary sector",
        "mining",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "explosivo": [
    {
      "id": 16721,
      "keyword": "explosivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "work",
        "primary sector",
        "mining",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "explosivos": [
    {
      "id": 16721,
      "keyword": "explosivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "work",
        "primary sector",
        "mining",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ligadura de trompas": [
    {
      "id": 16669,
      "keyword": "ligadura de trompas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ligaduras de trompas": [
    {
      "id": 16669,
      "keyword": "ligadura de trompas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "masturbación": [
    {
      "id": 16673,
      "keyword": "masturbación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16675,
      "keyword": "masturbación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "masturbaciones": [
    {
      "id": 16673,
      "keyword": "masturbación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16675,
      "keyword": "masturbación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "herrería": [
    {
      "id": 16731,
      "keyword": "herrería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "workplace",
        "secondary sector",
        "craftsmanship",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "herrerías": [
    {
      "id": 16731,
      "keyword": "herrería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "workplace",
        "secondary sector",
        "craftsmanship",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "informe médico": [
    {
      "id": 16735,
      "keyword": "informe médico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "medicine",
        "health"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "informes médicos": [
    {
      "id": 16735,
      "keyword": "informe médico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "medicine",
        "health"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugar al corro": [
    {
      "id": 16741,
      "keyword": "jugar al corro",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37768,
      "keyword": "jugar al corro",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16739,
      "keyword": "jugar al corro",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corro": [
    {
      "id": 16741,
      "keyword": "corro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37768,
      "keyword": "corro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16739,
      "keyword": "corro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corros": [
    {
      "id": 16741,
      "keyword": "corro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37768,
      "keyword": "corro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16739,
      "keyword": "corro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugar al fútbol": [
    {
      "id": 16743,
      "keyword": "jugar al fútbol",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36545,
      "keyword": "jugar al fútbol",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lata de atún": [
    {
      "id": 16759,
      "keyword": "lata de atún",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "latas de atún": [
    {
      "id": 16759,
      "keyword": "lata de atún",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lata de berberechos": [
    {
      "id": 16763,
      "keyword": "lata de berberechos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "seafood",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "latas de berberechos": [
    {
      "id": 16763,
      "keyword": "lata de berberechos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "seafood",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lata de espárragos": [
    {
      "id": 16767,
      "keyword": "lata de espárragos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "latas de espárragos": [
    {
      "id": 16767,
      "keyword": "lata de espárragos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lata de anchoas": [
    {
      "id": 16755,
      "keyword": "lata de anchoas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "latas de anchoas": [
    {
      "id": 16755,
      "keyword": "lata de anchoas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lata de mejillones": [
    {
      "id": 16771,
      "keyword": "lata de mejillones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "seafood",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "latas de mejillones": [
    {
      "id": 16771,
      "keyword": "lata de mejillones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "seafood",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lata de olivas negras": [
    {
      "id": 16775,
      "keyword": "lata de olivas negras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "latas de olivas negras": [
    {
      "id": 16775,
      "keyword": "lata de olivas negras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lata de olivas": [
    {
      "id": 16775,
      "keyword": "lata de olivas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16779,
      "keyword": "lata de olivas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16781,
      "keyword": "lata de olivas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "latas de olivas": [
    {
      "id": 16775,
      "keyword": "lata de olivas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16779,
      "keyword": "lata de olivas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16781,
      "keyword": "lata de olivas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lata de olivas rellenas": [
    {
      "id": 16779,
      "keyword": "lata de olivas rellenas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "latas de olivas rellenas": [
    {
      "id": 16779,
      "keyword": "lata de olivas rellenas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lata de aceite": [
    {
      "id": 16747,
      "keyword": "lata de aceite",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "latas de aceite": [
    {
      "id": 16747,
      "keyword": "lata de aceite",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "derived material",
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lata de almejas": [
    {
      "id": 16751,
      "keyword": "lata de almejas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "seafood",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "latas de almejas": [
    {
      "id": 16751,
      "keyword": "lata de almejas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "seafood",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lata de olivas verdes": [
    {
      "id": 16781,
      "keyword": "lata de olivas verdes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "latas de olivas verdes": [
    {
      "id": 16781,
      "keyword": "lata de olivas verdes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lata de sardinas": [
    {
      "id": 16787,
      "keyword": "lata de sardinas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "latas de sardinas": [
    {
      "id": 16787,
      "keyword": "lata de sardinas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "librera": [
    {
      "id": 16791,
      "keyword": "librera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "libreras": [
    {
      "id": 16791,
      "keyword": "librera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "librero": [
    {
      "id": 28513,
      "keyword": "librero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "literature"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16795,
      "keyword": "librero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "libreros": [
    {
      "id": 28513,
      "keyword": "librero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "literature"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 16795,
      "keyword": "librero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "libro de familia": [
    {
      "id": 16799,
      "keyword": "libro de familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "libros de familia": [
    {
      "id": 16799,
      "keyword": "libro de familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "meta": [
    {
      "id": 16817,
      "keyword": "meta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "metas": [
    {
      "id": 16817,
      "keyword": "meta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manga pastelera": [
    {
      "id": 16809,
      "keyword": "manga pastelera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mangas pasteleras": [
    {
      "id": 16809,
      "keyword": "manga pastelera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "papaya": [
    {
      "id": 16829,
      "keyword": "papaya",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papayas": [
    {
      "id": 16829,
      "keyword": "papaya",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "patatas bravas": [
    {
      "id": 16827,
      "keyword": "patatas bravas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papas bravas": [
    {
      "id": 16827,
      "keyword": "papas bravas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patinar": [
    {
      "id": 16841,
      "keyword": "patinar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30578,
      "keyword": "patinar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30598,
      "keyword": "patinar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16837,
      "keyword": "patinar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "petardo": [
    {
      "id": 16851,
      "keyword": "petardo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "petardos": [
    {
      "id": 16851,
      "keyword": "petardo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plato hondo": [
    {
      "id": 16857,
      "keyword": "plato hondo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "platos hondos": [
    {
      "id": 16857,
      "keyword": "plato hondo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pinturas de colores": [
    {
      "id": 17016,
      "keyword": "pinturas de colores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16855,
      "keyword": "pinturas de colores",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plastidecors": [
    {
      "id": 16855,
      "keyword": "plastidecors",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patinar sobre hielo": [
    {
      "id": 30552,
      "keyword": "patinar sobre hielo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30556,
      "keyword": "patinar sobre hielo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30557,
      "keyword": "patinar sobre hielo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30558,
      "keyword": "patinar sobre hielo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30553,
      "keyword": "patinar sobre hielo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30555,
      "keyword": "patinar sobre hielo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30559,
      "keyword": "patinar sobre hielo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30561,
      "keyword": "patinar sobre hielo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30560,
      "keyword": "patinar sobre hielo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16837,
      "keyword": "patinar sobre hielo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plegar la ropa": [
    {
      "id": 16861,
      "keyword": "plegar la ropa",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulir": [
    {
      "id": 16863,
      "keyword": "pulir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puño": [
    {
      "id": 16865,
      "keyword": "puño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puños": [
    {
      "id": 16865,
      "keyword": "puño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recibo": [
    {
      "id": 16873,
      "keyword": "recibo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recibos": [
    {
      "id": 16873,
      "keyword": "recibo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "transferencia bancaria": [
    {
      "id": 16909,
      "keyword": "transferencia bancaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "transferencias bancarias": [
    {
      "id": 16909,
      "keyword": "transferencia bancaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perfumera": [
    {
      "id": 16917,
      "keyword": "perfumera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perfumeras": [
    {
      "id": 16917,
      "keyword": "perfumera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vendedora de colonia": [
    {
      "id": 16917,
      "keyword": "vendedora de colonia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vendedoras de colonia": [
    {
      "id": 16917,
      "keyword": "vendedora de colonia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "web": [
    {
      "id": 16913,
      "keyword": "web",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "webs": [
    {
      "id": 16913,
      "keyword": "web",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "página web": [
    {
      "id": 16913,
      "keyword": "página web",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "páginas web": [
    {
      "id": 16913,
      "keyword": "página web",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perfumero": [
    {
      "id": 16921,
      "keyword": "perfumero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perfumeros": [
    {
      "id": 16921,
      "keyword": "perfumero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vendedor de colonia": [
    {
      "id": 16921,
      "keyword": "vendedor de colonia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vendedores de colonia": [
    {
      "id": 16921,
      "keyword": "vendedor de colonia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de deportes": [
    {
      "id": 16984,
      "keyword": "tienda de deportes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de deportes": [
    {
      "id": 16984,
      "keyword": "tienda de deportes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de animales": [
    {
      "id": 16980,
      "keyword": "tienda de animales",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de animales": [
    {
      "id": 16980,
      "keyword": "tienda de animales",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pajarería": [
    {
      "id": 16980,
      "keyword": "pajarería",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pajarerías": [
    {
      "id": 16980,
      "keyword": "pajarería",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de mascotas": [
    {
      "id": 16980,
      "keyword": "tienda de mascotas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de mascotas": [
    {
      "id": 16980,
      "keyword": "tienda de mascotas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de informática": [
    {
      "id": 16988,
      "keyword": "tienda de informática",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de informática": [
    {
      "id": 16988,
      "keyword": "tienda de informática",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de música": [
    {
      "id": 16992,
      "keyword": "tienda de música",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de música": [
    {
      "id": 16992,
      "keyword": "tienda de música",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prepararse": [
    {
      "id": 37794,
      "keyword": "prepararse",
      "keywords": 5,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17000,
      "keyword": "prepararse",
      "keywords": 3,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17004,
      "keyword": "prepararse",
      "keywords": 3,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "preparada": [
    {
      "id": 37794,
      "keyword": "preparada",
      "keywords": 5,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17000,
      "keyword": "preparada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "preparadas": [
    {
      "id": 37794,
      "keyword": "preparada",
      "keywords": 5,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 17000,
      "keyword": "preparada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tomate frito": [
    {
      "id": 17008,
      "keyword": "tomate frito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomates fritos": [
    {
      "id": 17008,
      "keyword": "tomate frito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manzana de caramelo": [
    {
      "id": 17010,
      "keyword": "manzana de caramelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manzanas de caramelo": [
    {
      "id": 17010,
      "keyword": "manzana de caramelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "listo": [
    {
      "id": 37794,
      "keyword": "listo",
      "keywords": 5,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17004,
      "keyword": "listo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "listos": [
    {
      "id": 37794,
      "keyword": "listo",
      "keywords": 5,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 17004,
      "keyword": "listo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "preparado": [
    {
      "id": 37794,
      "keyword": "preparado",
      "keywords": 5,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17004,
      "keyword": "preparado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "preparados": [
    {
      "id": 37794,
      "keyword": "preparado",
      "keywords": 5,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 17004,
      "keyword": "preparado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lápices de colores": [
    {
      "id": 17016,
      "keyword": "lápices de colores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tirantes": [
    {
      "id": 16901,
      "keyword": "tirantes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tirar del pelo": [
    {
      "id": 16903,
      "keyword": "tirar del pelo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30658,
      "keyword": "tirar del pelo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estirar el pelo": [
    {
      "id": 16903,
      "keyword": "estirar el pelo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuerpo de espaldas": [
    {
      "id": 17018,
      "keyword": "cuerpo de espaldas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuerpos de espaldas": [
    {
      "id": 17018,
      "keyword": "cuerpo de espaldas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "position"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuerpo de frente": [
    {
      "id": 17022,
      "keyword": "cuerpo de frente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuerpos de frente": [
    {
      "id": 17022,
      "keyword": "cuerpo de frente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "position"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cumplimiento": [
    {
      "id": 17030,
      "keyword": "cumplimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "public administration",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cumplimientos": [
    {
      "id": 17030,
      "keyword": "cumplimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "public administration",
        "justice"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atarse las zapatillas": [
    {
      "id": 17026,
      "keyword": "atarse las zapatillas",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atarse los zapatos": [
    {
      "id": 17026,
      "keyword": "atarse los zapatos",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer una lazada": [
    {
      "id": 17026,
      "keyword": "hacer una lazada",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atar las zapatillas": [
    {
      "id": 17026,
      "keyword": "atar las zapatillas",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atar los zapatos": [
    {
      "id": 17026,
      "keyword": "atar los zapatos",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir la cremallera": [
    {
      "id": 37430,
      "keyword": "subir la cremallera",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 16897,
      "keyword": "subir la cremallera",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir el cierre": [
    {
      "id": 16897,
      "keyword": "subir el cierre",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dar": [
    {
      "id": 17040,
      "keyword": "dar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28431,
      "keyword": "dar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17038,
      "keyword": "dar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ofrecer": [
    {
      "id": 17040,
      "keyword": "ofrecer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28431,
      "keyword": "ofrecer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17038,
      "keyword": "ofrecer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entregar": [
    {
      "id": 17040,
      "keyword": "entregar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17038,
      "keyword": "entregar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mantener": [
    {
      "id": 17050,
      "keyword": "mantener",
      "keywords": 2,
      "type": 3,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "durar": [
    {
      "id": 17050,
      "keyword": "durar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "duración": [
    {
      "id": 17052,
      "keyword": "duración",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "otro": [
    {
      "id": 17054,
      "keyword": "otro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "otros": [
    {
      "id": 17054,
      "keyword": "otro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 17056,
      "keyword": "otros",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "otra": [
    {
      "id": 17054,
      "keyword": "otra",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "otras": [
    {
      "id": 17056,
      "keyword": "otras",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tener tiempo": [
    {
      "id": 17058,
      "keyword": "tener tiempo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "propiedad intelectual": [
    {
      "id": 17060,
      "keyword": "propiedad intelectual",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "alcantarilla": [
    {
      "id": 17161,
      "keyword": "alcantarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17163,
      "keyword": "alcantarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alcantarillas": [
    {
      "id": 17161,
      "keyword": "alcantarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 17163,
      "keyword": "alcantarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atropellar": [
    {
      "id": 38389,
      "keyword": "atropellar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "traffic accident",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17169,
      "keyword": "atropellar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "traffic accident",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atropello": [
    {
      "id": 38389,
      "keyword": "atropello",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "traffic accident",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17169,
      "keyword": "atropello",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "traffic accident",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bastidor": [
    {
      "id": 17171,
      "keyword": "bastidor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bastidores": [
    {
      "id": 17171,
      "keyword": "bastidor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "uso": [
    {
      "id": 17036,
      "keyword": "uso",
      "keywords": 3,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "usos": [
    {
      "id": 17036,
      "keyword": "uso",
      "keywords": 3,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "utilización": [
    {
      "id": 17036,
      "keyword": "utilización",
      "keywords": 3,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "utilizaciones": [
    {
      "id": 17036,
      "keyword": "utilización",
      "keywords": 3,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "utilidad": [
    {
      "id": 17036,
      "keyword": "utilidad",
      "keywords": 3,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "utilidades": [
    {
      "id": 17036,
      "keyword": "utilidad",
      "keywords": 3,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "promoción": [
    {
      "id": 17034,
      "keyword": "promoción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "promociones": [
    {
      "id": 17034,
      "keyword": "promoción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recibir": [
    {
      "id": 17044,
      "keyword": "recibir",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17042,
      "keyword": "recibir",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aceptar": [
    {
      "id": 25752,
      "keyword": "aceptar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "expression",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17044,
      "keyword": "aceptar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25757,
      "keyword": "aceptar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "expression",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37609,
      "keyword": "aceptar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "expression",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17042,
      "keyword": "aceptar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "admitir": [
    {
      "id": 17044,
      "keyword": "admitir",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17042,
      "keyword": "admitir",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "licuadora": [
    {
      "id": 17175,
      "keyword": "licuadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25688,
      "keyword": "licuadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "licuadoras": [
    {
      "id": 17175,
      "keyword": "licuadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25688,
      "keyword": "licuadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fabricación": [
    {
      "id": 17032,
      "keyword": "fabricación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "elaboración": [
    {
      "id": 17032,
      "keyword": "elaboración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "elaboraciones": [
    {
      "id": 17032,
      "keyword": "elaboración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "producción": [
    {
      "id": 17032,
      "keyword": "producción",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "producciones": [
    {
      "id": 17032,
      "keyword": "producción",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bulgaria": [
    {
      "id": 17185,
      "keyword": "Bulgaria",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28984,
      "keyword": "Bulgaria",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brotar": [
    {
      "id": 17183,
      "keyword": "brotar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "plant",
        "plant physiology",
        "plant anatomy",
        "anatomy",
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajero automático": [
    {
      "id": 17190,
      "keyword": "cajero automático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajeros automáticos": [
    {
      "id": 17190,
      "keyword": "cajero automático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carrete": [
    {
      "id": 17200,
      "keyword": "carrete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carretes": [
    {
      "id": 17200,
      "keyword": "carrete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carretel": [
    {
      "id": 17200,
      "keyword": "carretel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carreteles": [
    {
      "id": 17200,
      "keyword": "carretel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contrabajo": [
    {
      "id": 17214,
      "keyword": "contrabajo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contrabajos": [
    {
      "id": 17214,
      "keyword": "contrabajo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dispensador": [
    {
      "id": 17219,
      "keyword": "dispensador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36031,
      "keyword": "dispensador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dispensadores": [
    {
      "id": 17219,
      "keyword": "dispensador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36031,
      "keyword": "dispensador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cartulina": [
    {
      "id": 17208,
      "keyword": "cartulina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cartulinas": [
    {
      "id": 17208,
      "keyword": "cartulina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27659,
      "keyword": "cartulinas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carracla": [
    {
      "id": 17196,
      "keyword": "carracla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carraclas": [
    {
      "id": 17196,
      "keyword": "carracla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carraca": [
    {
      "id": 17196,
      "keyword": "carraca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carracas": [
    {
      "id": 17196,
      "keyword": "carraca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "matraca": [
    {
      "id": 17196,
      "keyword": "matraca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "matracas": [
    {
      "id": 17196,
      "keyword": "matraca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuba": [
    {
      "id": 17218,
      "keyword": "Cuba",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29607,
      "keyword": "Cuba",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cancelar": [
    {
      "id": 27393,
      "keyword": "cancelar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17194,
      "keyword": "cancelar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enroscar": [
    {
      "id": 17227,
      "keyword": "enroscar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22117,
      "keyword": "enroscar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cepillar las uñas": [
    {
      "id": 17212,
      "keyword": "cepillar las uñas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29040,
      "keyword": "cepillar las uñas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "funda": [
    {
      "id": 17237,
      "keyword": "funda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24065,
      "keyword": "funda",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fundas": [
    {
      "id": 17237,
      "keyword": "funda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24065,
      "keyword": "funda",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "güisqui": [
    {
      "id": 17249,
      "keyword": "güisqui",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "güisquis": [
    {
      "id": 17249,
      "keyword": "güisqui",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "whisky": [
    {
      "id": 17249,
      "keyword": "whisky",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "whiskys": [
    {
      "id": 17249,
      "keyword": "whisky",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hiena": [
    {
      "id": 17253,
      "keyword": "hiena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hienas": [
    {
      "id": 17253,
      "keyword": "hiena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grulla": [
    {
      "id": 17245,
      "keyword": "grulla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grullas": [
    {
      "id": 17245,
      "keyword": "grulla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dulzaina": [
    {
      "id": 17223,
      "keyword": "dulzaina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dulzainas": [
    {
      "id": 17223,
      "keyword": "dulzaina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lanzamiento": [
    {
      "id": 17259,
      "keyword": "lanzamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17261,
      "keyword": "lanzamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event",
        "olympic games",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17263,
      "keyword": "lanzamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37301,
      "keyword": "lanzamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37305,
      "keyword": "lanzamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lanzamientos": [
    {
      "id": 17259,
      "keyword": "lanzamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 17261,
      "keyword": "lanzamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event",
        "olympic games",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 17263,
      "keyword": "lanzamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37301,
      "keyword": "lanzamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37305,
      "keyword": "lanzamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lanzamiento de disco": [
    {
      "id": 17259,
      "keyword": "lanzamiento de disco",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37301,
      "keyword": "lanzamiento de disco",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lanzamientos de disco": [
    {
      "id": 17259,
      "keyword": "lanzamiento de disco",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37301,
      "keyword": "lanzamiento de disco",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lanzador": [
    {
      "id": 17259,
      "keyword": "lanzador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17263,
      "keyword": "lanzador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37301,
      "keyword": "lanzador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lanzadores": [
    {
      "id": 17259,
      "keyword": "lanzador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 17263,
      "keyword": "lanzador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37301,
      "keyword": "lanzador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lanzamiento de jabalina": [
    {
      "id": 38010,
      "keyword": "lanzamiento de jabalina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event",
        "olympic games",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17261,
      "keyword": "lanzamiento de jabalina",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event",
        "olympic games",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lanzamientos de jabalina": [
    {
      "id": 17261,
      "keyword": "lanzamiento de jabalina",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event",
        "olympic games",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lanzadora": [
    {
      "id": 17261,
      "keyword": "lanzadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event",
        "olympic games",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37305,
      "keyword": "lanzadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lanzadoras": [
    {
      "id": 17261,
      "keyword": "lanzadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event",
        "olympic games",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37305,
      "keyword": "lanzadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "liebre": [
    {
      "id": 17265,
      "keyword": "liebre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "hunting",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "liebres": [
    {
      "id": 17265,
      "keyword": "liebre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "hunting",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palacio": [
    {
      "id": 17279,
      "keyword": "palacio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38882,
      "keyword": "palacio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38653,
      "keyword": "palacio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palacios": [
    {
      "id": 17279,
      "keyword": "palacio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38882,
      "keyword": "palacio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38653,
      "keyword": "palacio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mortero": [
    {
      "id": 17275,
      "keyword": "mortero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "morteros": [
    {
      "id": 17275,
      "keyword": "mortero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "majar": [
    {
      "id": 17273,
      "keyword": "majar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "machacar": [
    {
      "id": 17273,
      "keyword": "machacar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lanzamiento de peso": [
    {
      "id": 17263,
      "keyword": "lanzamiento de peso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37305,
      "keyword": "lanzamiento de peso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lanzamientos de peso": [
    {
      "id": 17263,
      "keyword": "lanzamiento de peso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37305,
      "keyword": "lanzamiento de peso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "limpiar la boca": [
    {
      "id": 17271,
      "keyword": "limpiar la boca",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peladura": [
    {
      "id": 17292,
      "keyword": "peladura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peladuras": [
    {
      "id": 17292,
      "keyword": "peladura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recoger los platos": [
    {
      "id": 17298,
      "keyword": "recoger los platos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recoger los vasos": [
    {
      "id": 17300,
      "keyword": "recoger los vasos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recoger los cubiertos": [
    {
      "id": 17302,
      "keyword": "recoger los cubiertos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "cutlery",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panamá": [
    {
      "id": 17283,
      "keyword": "Panamá",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29725,
      "keyword": "Panamá",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puerto rico": [
    {
      "id": 17296,
      "keyword": "Puerto Rico",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sábana bajera": [
    {
      "id": 17308,
      "keyword": "sábana bajera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sábanas bajeras": [
    {
      "id": 17308,
      "keyword": "sábana bajera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salto de altura": [
    {
      "id": 17314,
      "keyword": "salto de altura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37300,
      "keyword": "salto de altura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saltos de altura": [
    {
      "id": 17314,
      "keyword": "salto de altura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salto con pértiga": [
    {
      "id": 17318,
      "keyword": "salto con pértiga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37306,
      "keyword": "salto con pértiga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saltos con pértiga": [
    {
      "id": 17318,
      "keyword": "salto con pértiga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37306,
      "keyword": "salto con pértiga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salto de longitud": [
    {
      "id": 17316,
      "keyword": "salto de longitud",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37303,
      "keyword": "salto de longitud",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saltos de longitud": [
    {
      "id": 17316,
      "keyword": "salto de longitud",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37303,
      "keyword": "salto de longitud",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "siempre": [
    {
      "id": 17322,
      "keyword": "siempre",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sultán": [
    {
      "id": 17324,
      "keyword": "sultán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sultanes": [
    {
      "id": 17324,
      "keyword": "sultán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tacos de salida": [
    {
      "id": 17328,
      "keyword": "tacos de salida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tostar": [
    {
      "id": 17330,
      "keyword": "tostar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacar dinero": [
    {
      "id": 17312,
      "keyword": "sacar dinero",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrelatas": [
    {
      "id": 17342,
      "keyword": "abrelatas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17338,
      "keyword": "abrelatas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 17346,
      "keyword": "abrelatas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrelatas eléctrico": [
    {
      "id": 17346,
      "keyword": "abrelatas eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asiento": [
    {
      "id": 19520,
      "keyword": "asiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34677,
      "keyword": "asiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36505,
      "keyword": "asiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "scenic art",
        "theater",
        "show",
        "cinema",
        "event",
        "social event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asientos": [
    {
      "id": 19520,
      "keyword": "asiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34677,
      "keyword": "asiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36505,
      "keyword": "asiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "scenic art",
        "theater",
        "show",
        "cinema",
        "event",
        "social event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cubertera": [
    {
      "id": 17350,
      "keyword": "cubertera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuberteras": [
    {
      "id": 17350,
      "keyword": "cubertera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salto de vallas": [
    {
      "id": 17320,
      "keyword": "salto de vallas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saltos de vallas": [
    {
      "id": 17320,
      "keyword": "salto de vallas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bordillo": [
    {
      "id": 19526,
      "keyword": "bordillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bordillos": [
    {
      "id": 19526,
      "keyword": "bordillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caja de ahorros": [
    {
      "id": 19528,
      "keyword": "caja de ahorros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajas de ahorros": [
    {
      "id": 19528,
      "keyword": "caja de ahorros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "financial services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "viola": [
    {
      "id": 17332,
      "keyword": "viola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "violas": [
    {
      "id": 17332,
      "keyword": "viola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "victoria": [
    {
      "id": 23371,
      "keyword": "victoria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 19531,
      "keyword": "victoria",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "victorias": [
    {
      "id": 23371,
      "keyword": "victoria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 19531,
      "keyword": "victoria",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "obra": [
    {
      "id": 19537,
      "keyword": "obra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction",
        "workplace",
        "place"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24204,
      "keyword": "obra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction",
        "workplace",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obras": [
    {
      "id": 19537,
      "keyword": "obra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction",
        "workplace",
        "place"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24204,
      "keyword": "obra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction",
        "workplace",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llanta": [
    {
      "id": 19535,
      "keyword": "llanta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llantas": [
    {
      "id": 19535,
      "keyword": "llanta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "derrota": [
    {
      "id": 19533,
      "keyword": "derrota",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "derrotas": [
    {
      "id": 19533,
      "keyword": "derrota",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comité de honor": [
    {
      "id": 19539,
      "keyword": "comité de honor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comités de honor": [
    {
      "id": 19539,
      "keyword": "comité de honor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "san valentín": [
    {
      "id": 19541,
      "keyword": "San Valentín",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 19543,
      "keyword": "San Valentín",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 19545,
      "keyword": "San Valentín",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "día de los enamorados": [
    {
      "id": 19541,
      "keyword": "Día de los enamorados",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 19543,
      "keyword": "Día de los enamorados",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 19545,
      "keyword": "Día de los enamorados",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "revisión": [
    {
      "id": 19553,
      "keyword": "revisión",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "revisiones": [
    {
      "id": 19553,
      "keyword": "revisión",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "corrección": [
    {
      "id": 19553,
      "keyword": "corrección",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "correcciones": [
    {
      "id": 19553,
      "keyword": "corrección",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "solicitud": [
    {
      "id": 19555,
      "keyword": "solicitud",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39176,
      "keyword": "solicitud",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "solicitudes": [
    {
      "id": 19555,
      "keyword": "solicitud",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39176,
      "keyword": "solicitud",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huelga": [
    {
      "id": 19561,
      "keyword": "huelga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huelgas": [
    {
      "id": 19561,
      "keyword": "huelga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ecuador": [
    {
      "id": 19550,
      "keyword": "Ecuador",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29600,
      "keyword": "Ecuador",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "moción": [
    {
      "id": 19565,
      "keyword": "moción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 19566,
      "keyword": "moción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mociones": [
    {
      "id": 19565,
      "keyword": "moción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 19566,
      "keyword": "moción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "moción de censura": [
    {
      "id": 19565,
      "keyword": "moción de censura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 19566,
      "keyword": "moción de censura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mociones de censura": [
    {
      "id": 19565,
      "keyword": "moción de censura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 19566,
      "keyword": "moción de censura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "medio": [
    {
      "id": 19570,
      "keyword": "medio",
      "keywords": 3,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medios": [
    {
      "id": 19570,
      "keyword": "medio",
      "keywords": 3,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mitad": [
    {
      "id": 19570,
      "keyword": "mitad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mitades": [
    {
      "id": 19570,
      "keyword": "mitad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "1/2": [
    {
      "id": 19570,
      "keyword": "1/2",
      "keywords": 3,
      "type": 6,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "holanda": [
    {
      "id": 29568,
      "keyword": "Holanda",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 19547,
      "keyword": "Holanda",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "países bajos": [
    {
      "id": 19547,
      "keyword": "Países Bajos",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "1-2-3": [
    {
      "id": 19548,
      "keyword": "1-2-3",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sucesión": [
    {
      "id": 19548,
      "keyword": "sucesión",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sucesiones": [
    {
      "id": 19548,
      "keyword": "sucesión",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "examinar": [
    {
      "id": 31904,
      "keyword": "examinar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28801,
      "keyword": "examinar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28751,
      "keyword": "examinar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 20097,
      "keyword": "examinar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 20095,
      "keyword": "examinar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reconocer": [
    {
      "id": 31904,
      "keyword": "reconocer",
      "keywords": 4,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 20097,
      "keyword": "reconocer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 20095,
      "keyword": "reconocer",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "auscultar": [
    {
      "id": 30692,
      "keyword": "auscultar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31904,
      "keyword": "auscultar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28801,
      "keyword": "auscultar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28751,
      "keyword": "auscultar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 20097,
      "keyword": "auscultar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 20095,
      "keyword": "auscultar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apagar el monitor": [
    {
      "id": 20093,
      "keyword": "apagar el monitor",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apagar la televisión": [
    {
      "id": 20093,
      "keyword": "apagar la televisión",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diámetro": [
    {
      "id": 20103,
      "keyword": "diámetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diámetros": [
    {
      "id": 20103,
      "keyword": "diámetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agresión": [
    {
      "id": 20091,
      "keyword": "agresión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agresiones": [
    {
      "id": 20091,
      "keyword": "agresión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "daño": [
    {
      "id": 20091,
      "keyword": "daño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "daños": [
    {
      "id": 20091,
      "keyword": "daño",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maltrato": [
    {
      "id": 24713,
      "keyword": "maltrato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24717,
      "keyword": "maltrato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24715,
      "keyword": "maltrato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30640,
      "keyword": "maltrato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 20091,
      "keyword": "maltrato",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34858,
      "keyword": "maltrato",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maltratos": [
    {
      "id": 24713,
      "keyword": "maltrato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24717,
      "keyword": "maltrato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24715,
      "keyword": "maltrato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30640,
      "keyword": "maltrato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 20091,
      "keyword": "maltrato",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34858,
      "keyword": "maltrato",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34858,
      "keyword": "maltratos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "circunferencia": [
    {
      "id": 20099,
      "keyword": "circunferencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "circunferencias": [
    {
      "id": 20099,
      "keyword": "circunferencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "funcionario": [
    {
      "id": 20107,
      "keyword": "funcionario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "funcionarios": [
    {
      "id": 20107,
      "keyword": "funcionario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frutos secos": [
    {
      "id": 20105,
      "keyword": "frutos secos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 20105,
      "keyword": "fruto seco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fruto seco": [
    {
      "id": 20105,
      "keyword": "fruto seco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "molusco": [
    {
      "id": 20111,
      "keyword": "molusco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "mollusc"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "moluscos": [
    {
      "id": 20111,
      "keyword": "molusco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "mollusc"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 20111,
      "keyword": "moluscos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "mollusc"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prensa": [
    {
      "id": 20117,
      "keyword": "prensa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "publication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vendedor": [
    {
      "id": 20121,
      "keyword": "vendedor",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 20123,
      "keyword": "vendedor",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37808,
      "keyword": "vendedor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vendedores": [
    {
      "id": 20121,
      "keyword": "vendedor",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 20123,
      "keyword": "vendedor",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37808,
      "keyword": "vendedor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tendero": [
    {
      "id": 20121,
      "keyword": "tendero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37808,
      "keyword": "tendero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tenderos": [
    {
      "id": 20121,
      "keyword": "tendero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37808,
      "keyword": "tendero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vendedora": [
    {
      "id": 20121,
      "keyword": "vendedora",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 20123,
      "keyword": "vendedora",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37809,
      "keyword": "vendedora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vendedoras": [
    {
      "id": 20121,
      "keyword": "vendedora",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 20123,
      "keyword": "vendedora",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37809,
      "keyword": "vendedora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tendera": [
    {
      "id": 20121,
      "keyword": "tendera",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37809,
      "keyword": "tendera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obrero": [
    {
      "id": 20113,
      "keyword": "obrero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obreros": [
    {
      "id": 20113,
      "keyword": "obrero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "obrera": [
    {
      "id": 20113,
      "keyword": "obrera",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obreras": [
    {
      "id": 20113,
      "keyword": "obrera",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trabajadora": [
    {
      "id": 20113,
      "keyword": "trabajadora",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trabajadoras": [
    {
      "id": 20113,
      "keyword": "trabajadora",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dependienta": [
    {
      "id": 34878,
      "keyword": "dependienta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 20123,
      "keyword": "dependienta",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37809,
      "keyword": "dependienta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dependientas": [
    {
      "id": 34878,
      "keyword": "dependienta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 20123,
      "keyword": "dependienta",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37809,
      "keyword": "dependienta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "verdulería": [
    {
      "id": 35703,
      "keyword": "verdulería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 20126,
      "keyword": "verdulería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "verdulerías": [
    {
      "id": 35703,
      "keyword": "verdulería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 20126,
      "keyword": "verdulería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "página": [
    {
      "id": 20115,
      "keyword": "página",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "páginas": [
    {
      "id": 20115,
      "keyword": "página",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "medio ambiente": [
    {
      "id": 20389,
      "keyword": "medio ambiente",
      "keywords": 4,
      "type": 2,
      "tags": [
        "environmental science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "biosfera": [
    {
      "id": 20389,
      "keyword": "biosfera",
      "keywords": 4,
      "type": 2,
      "tags": [
        "environmental science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "biosferas": [
    {
      "id": 20389,
      "keyword": "biosfera",
      "keywords": 4,
      "type": 2,
      "tags": [
        "environmental science"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "biósfera": [
    {
      "id": 20389,
      "keyword": "biósfera",
      "keywords": 4,
      "type": 2,
      "tags": [
        "environmental science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "naturaleza": [
    {
      "id": 20389,
      "keyword": "naturaleza",
      "keywords": 4,
      "type": 2,
      "tags": [
        "environmental science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "naturalezas": [
    {
      "id": 20389,
      "keyword": "naturaleza",
      "keywords": 4,
      "type": 2,
      "tags": [
        "environmental science"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "madurez": [
    {
      "id": 20397,
      "keyword": "madurez",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meseta": [
    {
      "id": 20399,
      "keyword": "meseta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "place",
        "rural area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesetas": [
    {
      "id": 20399,
      "keyword": "meseta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "place",
        "rural area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "horizonte": [
    {
      "id": 20393,
      "keyword": "horizonte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "horizontes": [
    {
      "id": 20393,
      "keyword": "horizonte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "península": [
    {
      "id": 21006,
      "keyword": "península",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "penínsulas": [
    {
      "id": 21006,
      "keyword": "península",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llanura": [
    {
      "id": 20395,
      "keyword": "llanura",
      "keywords": 3,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llanuras": [
    {
      "id": 20395,
      "keyword": "llanura",
      "keywords": 3,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llano": [
    {
      "id": 20395,
      "keyword": "llano",
      "keywords": 3,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llanos": [
    {
      "id": 20395,
      "keyword": "llano",
      "keywords": 3,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pampa": [
    {
      "id": 20395,
      "keyword": "pampa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pampas": [
    {
      "id": 20395,
      "keyword": "pampa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cima": [
    {
      "id": 20391,
      "keyword": "cima",
      "keywords": 3,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cimas": [
    {
      "id": 20391,
      "keyword": "cima",
      "keywords": 3,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cumbre": [
    {
      "id": 20391,
      "keyword": "cumbre",
      "keywords": 3,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cumbres": [
    {
      "id": 20391,
      "keyword": "cumbre",
      "keywords": 3,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "niñez": [
    {
      "id": 20401,
      "keyword": "niñez",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "infancia": [
    {
      "id": 20401,
      "keyword": "infancia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adolescencia": [
    {
      "id": 20387,
      "keyword": "adolescencia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "teenager"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juventud": [
    {
      "id": 20387,
      "keyword": "juventud",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "teenager"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juventudes": [
    {
      "id": 20387,
      "keyword": "juventud",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "teenager"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "puntos cardinales": [
    {
      "id": 21016,
      "keyword": "puntos cardinales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "día y noche": [
    {
      "id": 21018,
      "keyword": "día y noche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "días y noches": [
    {
      "id": 21018,
      "keyword": "día y noche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "permitir": [
    {
      "id": 21014,
      "keyword": "permitir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21012,
      "keyword": "permitir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21010,
      "keyword": "permitir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "profesor de pedagogía terapéutica": [
    {
      "id": 32938,
      "keyword": "profesor de pedagogía terapéutica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36274,
      "keyword": "profesor de pedagogía terapéutica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21020,
      "keyword": "profesor de pedagogía terapéutica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36273,
      "keyword": "profesor de pedagogía terapéutica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "profesores de pedagogía terapéutica": [
    {
      "id": 32938,
      "keyword": "profesor de pedagogía terapéutica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36274,
      "keyword": "profesor de pedagogía terapéutica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21020,
      "keyword": "profesor de pedagogía terapéutica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36273,
      "keyword": "profesor de pedagogía terapéutica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pt": [
    {
      "id": 32938,
      "keyword": "PT",
      "keywords": 5,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36274,
      "keyword": "PT",
      "keywords": 5,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21020,
      "keyword": "PT",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21022,
      "keyword": "PT",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36275,
      "keyword": "PT",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36273,
      "keyword": "PT",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maestro de pedagogía terapeútica": [
    {
      "id": 32938,
      "keyword": "maestro de pedagogía terapeútica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36274,
      "keyword": "maestro de pedagogía terapeútica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21020,
      "keyword": "maestro de pedagogía terapeútica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36273,
      "keyword": "maestro de pedagogía terapeútica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maestros de pedagogía terapeútica": [
    {
      "id": 32938,
      "keyword": "maestro de pedagogía terapeútica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36274,
      "keyword": "maestro de pedagogía terapeútica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21020,
      "keyword": "maestro de pedagogía terapeútica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36273,
      "keyword": "maestro de pedagogía terapeútica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maestra de pedagogía terapeútica": [
    {
      "id": 32938,
      "keyword": "maestra de pedagogía terapeútica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36274,
      "keyword": "maestra de pedagogía terapeútica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21022,
      "keyword": "maestra de pedagogía terapeútica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36275,
      "keyword": "maestra de pedagogía terapeútica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maestras de pedagogía terapeútica": [
    {
      "id": 32938,
      "keyword": "maestra de pedagogía terapeútica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36274,
      "keyword": "maestra de pedagogía terapeútica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21022,
      "keyword": "maestra de pedagogía terapeútica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36275,
      "keyword": "maestra de pedagogía terapeútica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "profesora de pedagogía terapeútica": [
    {
      "id": 32938,
      "keyword": "profesora de pedagogía terapeútica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36274,
      "keyword": "profesora de pedagogía terapeútica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21022,
      "keyword": "profesora de pedagogía terapeútica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36275,
      "keyword": "profesora de pedagogía terapeútica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "profesoras de pedagogía terapeútica": [
    {
      "id": 32938,
      "keyword": "profesora de pedagogía terapeútica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36274,
      "keyword": "profesora de pedagogía terapeútica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21022,
      "keyword": "profesora de pedagogía terapeútica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36275,
      "keyword": "profesora de pedagogía terapeútica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chocolate a la taza": [
    {
      "id": 21326,
      "keyword": "chocolate a la taza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chocolates a la taza": [
    {
      "id": 21326,
      "keyword": "chocolate a la taza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abandonar": [
    {
      "id": 21328,
      "keyword": "abandonar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vejez": [
    {
      "id": 21008,
      "keyword": "vejez",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "elderly"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gacela": [
    {
      "id": 17241,
      "keyword": "gacela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gacelas": [
    {
      "id": 17241,
      "keyword": "gacela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abrir la lavadora": [
    {
      "id": 21334,
      "keyword": "abrir la lavadora",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrir el lavarropas": [
    {
      "id": 21334,
      "keyword": "abrir el lavarropas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrir el cajetín de la lavadora": [
    {
      "id": 21336,
      "keyword": "abrir el cajetín de la lavadora",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrir el cajetín del lavarropas": [
    {
      "id": 21336,
      "keyword": "abrir el cajetín del lavarropas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aclarar": [
    {
      "id": 34824,
      "keyword": "aclarar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21347,
      "keyword": "aclarar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21345,
      "keyword": "aclarar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21343,
      "keyword": "aclarar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrir la nevera": [
    {
      "id": 21339,
      "keyword": "abrir la nevera",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23707,
      "keyword": "abrir la nevera",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adoptar": [
    {
      "id": 37702,
      "keyword": "adoptar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21353,
      "keyword": "adoptar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acondicionador": [
    {
      "id": 21349,
      "keyword": "acondicionador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acondicionadores": [
    {
      "id": 21349,
      "keyword": "acondicionador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abolladura": [
    {
      "id": 21330,
      "keyword": "abolladura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "traffic accident",
        "road safety",
        "mode of transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abolladuras": [
    {
      "id": 21330,
      "keyword": "abolladura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "traffic accident",
        "road safety",
        "mode of transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bollo": [
    {
      "id": 36501,
      "keyword": "bollo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21330,
      "keyword": "bollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "traffic accident",
        "road safety",
        "mode of transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bollos": [
    {
      "id": 29935,
      "keyword": "bollos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36501,
      "keyword": "bollo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21330,
      "keyword": "bollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "traffic accident",
        "road safety",
        "mode of transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "andar sobre zancos": [
    {
      "id": 37685,
      "keyword": "andar sobre zancos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37964,
      "keyword": "andar sobre zancos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21357,
      "keyword": "andar sobre zancos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ánfora": [
    {
      "id": 21359,
      "keyword": "ánfora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ánforas": [
    {
      "id": 21359,
      "keyword": "ánfora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apisonadora": [
    {
      "id": 21367,
      "keyword": "apisonadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apisonadoras": [
    {
      "id": 21367,
      "keyword": "apisonadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aplanadora": [
    {
      "id": 21367,
      "keyword": "aplanadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aplanadoras": [
    {
      "id": 21367,
      "keyword": "aplanadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apostar": [
    {
      "id": 21371,
      "keyword": "apostar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "game",
        "gambling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "correcto": [
    {
      "id": 21381,
      "keyword": "correcto",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34641,
      "keyword": "correcto",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "correctos": [
    {
      "id": 21381,
      "keyword": "correcto",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34641,
      "keyword": "correcto",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "correcta": [
    {
      "id": 21381,
      "keyword": "correcta",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34641,
      "keyword": "correcta",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "correctas": [
    {
      "id": 21381,
      "keyword": "correcta",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34641,
      "keyword": "correcta",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acertado": [
    {
      "id": 21381,
      "keyword": "acertado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34641,
      "keyword": "acertado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acertados": [
    {
      "id": 21381,
      "keyword": "acertado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34641,
      "keyword": "acertado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acertada": [
    {
      "id": 21381,
      "keyword": "acertada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34641,
      "keyword": "acertada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acertadas": [
    {
      "id": 21381,
      "keyword": "acertada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34641,
      "keyword": "acertada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aprobar": [
    {
      "id": 21379,
      "keyword": "aprobar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29635,
      "keyword": "aprobar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21383,
      "keyword": "aprobar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29634,
      "keyword": "aprobar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21549,
      "keyword": "aprobar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asistir": [
    {
      "id": 21385,
      "keyword": "asistir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "culture",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37538,
      "keyword": "asistir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37539,
      "keyword": "asistir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "antártida": [
    {
      "id": 21363,
      "keyword": "Antártida",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "continent"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atascar": [
    {
      "id": 21387,
      "keyword": "atascar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obstruir": [
    {
      "id": 21387,
      "keyword": "obstruir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atasco": [
    {
      "id": 21389,
      "keyword": "atasco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atascos": [
    {
      "id": 21389,
      "keyword": "atasco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "retención": [
    {
      "id": 21389,
      "keyword": "retención",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "retenciones": [
    {
      "id": 21389,
      "keyword": "retención",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "australia": [
    {
      "id": 21393,
      "keyword": "Australia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37646,
      "keyword": "Australia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "austria": [
    {
      "id": 21394,
      "keyword": "Austria",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28980,
      "keyword": "Austria",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "avanzar": [
    {
      "id": 39425,
      "keyword": "avanzar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21395,
      "keyword": "avanzar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39496,
      "keyword": "avanzar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caza": [
    {
      "id": 21409,
      "keyword": "caza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cazas": [
    {
      "id": 21409,
      "keyword": "caza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "avanzar la ficha": [
    {
      "id": 21397,
      "keyword": "avanzar la ficha",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39496,
      "keyword": "avanzar la ficha",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mover la ficha": [
    {
      "id": 21397,
      "keyword": "mover la ficha",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39494,
      "keyword": "mover la ficha",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39496,
      "keyword": "mover la ficha",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barbo": [
    {
      "id": 21417,
      "keyword": "barbo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barbos": [
    {
      "id": 21417,
      "keyword": "barbo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aventura": [
    {
      "id": 21401,
      "keyword": "aventura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30616,
      "keyword": "aventura",
      "keywords": 3,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "literature",
        "scenic art",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aventuras": [
    {
      "id": 21401,
      "keyword": "aventura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30616,
      "keyword": "aventura",
      "keywords": 3,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "literature",
        "scenic art",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bambú": [
    {
      "id": 21413,
      "keyword": "bambú",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bambús": [
    {
      "id": 21413,
      "keyword": "bambú",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pesquero": [
    {
      "id": 21423,
      "keyword": "pesquero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pesqueros": [
    {
      "id": 21423,
      "keyword": "pesquero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barco pesquero": [
    {
      "id": 21423,
      "keyword": "barco pesquero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barcos pesqueros": [
    {
      "id": 21423,
      "keyword": "barco pesquero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barco pirata": [
    {
      "id": 38401,
      "keyword": "barco pirata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21425,
      "keyword": "barco pirata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barcos piratas": [
    {
      "id": 21425,
      "keyword": "barco pirata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "la bella durmiente": [
    {
      "id": 21433,
      "keyword": "La Bella Durmiente",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aventurero": [
    {
      "id": 21405,
      "keyword": "aventurero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "literature",
        "scenic art",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aventureros": [
    {
      "id": 21405,
      "keyword": "aventurero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "literature",
        "scenic art",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "intrépido": [
    {
      "id": 21405,
      "keyword": "intrépido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "literature",
        "scenic art",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intrépidos": [
    {
      "id": 21405,
      "keyword": "intrépido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "literature",
        "scenic art",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "buque mercante": [
    {
      "id": 21421,
      "keyword": "buque mercante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buques mercantes": [
    {
      "id": 21421,
      "keyword": "buque mercante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mercante": [
    {
      "id": 21421,
      "keyword": "mercante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mercantes": [
    {
      "id": 21421,
      "keyword": "mercante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "buque": [
    {
      "id": 21421,
      "keyword": "buque",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buques": [
    {
      "id": 21421,
      "keyword": "buque",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "blancanieves": [
    {
      "id": 21447,
      "keyword": "Blancanieves",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tren de alta velocidad": [
    {
      "id": 21399,
      "keyword": "tren de alta velocidad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 21399,
      "keyword": "tren de alta velocidad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trenes de alta velocidad": [
    {
      "id": 21399,
      "keyword": "tren de alta velocidad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 21399,
      "keyword": "tren de alta velocidad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "boquete": [
    {
      "id": 21455,
      "keyword": "boquete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boquetes": [
    {
      "id": 21455,
      "keyword": "boquete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bosnia y herzegovina": [
    {
      "id": 21459,
      "keyword": "Bosnia y Herzegovina",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28966,
      "keyword": "Bosnia y Herzegovina",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "besugo": [
    {
      "id": 21441,
      "keyword": "besugo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "besugos": [
    {
      "id": 21441,
      "keyword": "besugo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "big ben": [
    {
      "id": 21445,
      "keyword": "Big Ben",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajetín": [
    {
      "id": 21470,
      "keyword": "cajetín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "appliance",
        "electrical appliance",
        "home",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajetines": [
    {
      "id": 21470,
      "keyword": "cajetín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "appliance",
        "electrical appliance",
        "home",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camarote": [
    {
      "id": 21478,
      "keyword": "camarote",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camarotes": [
    {
      "id": 21478,
      "keyword": "camarote",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bola de billar": [
    {
      "id": 21449,
      "keyword": "bola de billar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolas de billar": [
    {
      "id": 21449,
      "keyword": "bola de billar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rebuscar": [
    {
      "id": 21466,
      "keyword": "rebuscar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37238,
      "keyword": "rebuscar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsa": [
    {
      "id": 21453,
      "keyword": "bolsa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "financial services",
        "economy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23849,
      "keyword": "bolsa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27616,
      "keyword": "bolsa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas": [
    {
      "id": 21453,
      "keyword": "bolsa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "financial services",
        "economy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23849,
      "keyword": "bolsa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27616,
      "keyword": "bolsa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carromato": [
    {
      "id": 21488,
      "keyword": "carromato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carromatos": [
    {
      "id": 21488,
      "keyword": "carromato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caries": [
    {
      "id": 21494,
      "keyword": "caries",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canela": [
    {
      "id": 21486,
      "keyword": "canela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "spices"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajonera": [
    {
      "id": 21474,
      "keyword": "cajonera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajoneras": [
    {
      "id": 21474,
      "keyword": "cajonera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "campo de rugby": [
    {
      "id": 21482,
      "keyword": "campo de rugby",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campos de rugby": [
    {
      "id": 21482,
      "keyword": "campo de rugby",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carrera de motos": [
    {
      "id": 21498,
      "keyword": "carrera de motos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carreras de motos": [
    {
      "id": 21498,
      "keyword": "carrera de motos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carrocería": [
    {
      "id": 21510,
      "keyword": "carrocería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carrocerías": [
    {
      "id": 21510,
      "keyword": "carrocería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carta certificada": [
    {
      "id": 21514,
      "keyword": "carta certificada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cartas certificadas": [
    {
      "id": 21514,
      "keyword": "carta certificada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "certificada": [
    {
      "id": 21514,
      "keyword": "certificada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "certificadas": [
    {
      "id": 21514,
      "keyword": "certificada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casillero": [
    {
      "id": 21522,
      "keyword": "casillero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casilleros": [
    {
      "id": 21522,
      "keyword": "casillero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cenicienta": [
    {
      "id": 21527,
      "keyword": "Cenicienta",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chiste": [
    {
      "id": 21537,
      "keyword": "chiste",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "chistes": [
    {
      "id": 21537,
      "keyword": "chiste",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "cepillar el pelo": [
    {
      "id": 21529,
      "keyword": "cepillar el pelo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coche de rally": [
    {
      "id": 21541,
      "keyword": "coche de rally",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coches de rally": [
    {
      "id": 21541,
      "keyword": "coche de rally",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "despedir": [
    {
      "id": 21589,
      "keyword": "despedir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21533,
      "keyword": "despedir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37807,
      "keyword": "despedir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21531,
      "keyword": "despedir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21793,
      "keyword": "despedir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cesar": [
    {
      "id": 21533,
      "keyword": "cesar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21531,
      "keyword": "cesar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conceder": [
    {
      "id": 21549,
      "keyword": "conceder",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contenedor de pilas": [
    {
      "id": 21553,
      "keyword": "contenedor de pilas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "congreso": [
    {
      "id": 21551,
      "keyword": "congreso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "congresos": [
    {
      "id": 21551,
      "keyword": "congreso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contratar": [
    {
      "id": 21557,
      "keyword": "contratar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "copiar": [
    {
      "id": 21559,
      "keyword": "copiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21561,
      "keyword": "copiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cornear": [
    {
      "id": 38283,
      "keyword": "cornear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "animal behavior",
        "scenic art",
        "bullfighting"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21563,
      "keyword": "cornear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "animal behavior",
        "scenic art",
        "bullfighting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "herir": [
    {
      "id": 31273,
      "keyword": "herir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21565,
      "keyword": "herir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39428,
      "keyword": "herir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "work accident",
        "psychology",
        "disruptive behavior",
        "health",
        "medicine",
        "symptom",
        "human body"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortar la mano": [
    {
      "id": 21565,
      "keyword": "cortar la mano",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crucero": [
    {
      "id": 21573,
      "keyword": "crucero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cruceros": [
    {
      "id": 21573,
      "keyword": "crucero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cubierta": [
    {
      "id": 21577,
      "keyword": "cubierta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubiertas": [
    {
      "id": 21577,
      "keyword": "cubierta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dalí": [
    {
      "id": 21581,
      "keyword": "Dalí",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salvador dalí": [
    {
      "id": 21581,
      "keyword": "Salvador Dalí",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dar crema": [
    {
      "id": 21583,
      "keyword": "dar crema",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "cosmetic",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38585,
      "keyword": "dar crema",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39274,
      "keyword": "dar crema",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "cosmetic",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "protector solar": [
    {
      "id": 21568,
      "keyword": "protector solar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "protectores solares": [
    {
      "id": 21568,
      "keyword": "protector solar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "crema solar": [
    {
      "id": 21568,
      "keyword": "crema solar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cremas solares": [
    {
      "id": 21568,
      "keyword": "crema solar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "denegar": [
    {
      "id": 21587,
      "keyword": "denegar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "costa rica": [
    {
      "id": 21567,
      "keyword": "Costa Rica",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29726,
      "keyword": "Costa Rica",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "croacia": [
    {
      "id": 21572,
      "keyword": "Croacia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28986,
      "keyword": "Croacia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diseñar": [
    {
      "id": 21800,
      "keyword": "diseñar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "engineering"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "documento": [
    {
      "id": 21802,
      "keyword": "documento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dinamarca": [
    {
      "id": 21799,
      "keyword": "Dinamarca",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28981,
      "keyword": "Dinamarca",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empresaria": [
    {
      "id": 21810,
      "keyword": "empresaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization",
        "secondary sector",
        "industry",
        "manufacturing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empresarias": [
    {
      "id": 21810,
      "keyword": "empresaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization",
        "secondary sector",
        "industry",
        "manufacturing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "empresario": [
    {
      "id": 21814,
      "keyword": "empresario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization",
        "secondary sector",
        "industry",
        "manufacturing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empresarios": [
    {
      "id": 21814,
      "keyword": "empresario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization",
        "secondary sector",
        "industry",
        "manufacturing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encender": [
    {
      "id": 21818,
      "keyword": "encender",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enjabonar el cuerpo": [
    {
      "id": 21826,
      "keyword": "enjabonar el cuerpo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21824,
      "keyword": "enjabonar el cuerpo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21822,
      "keyword": "enjabonar el cuerpo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enviar": [
    {
      "id": 27359,
      "keyword": "enviar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21828,
      "keyword": "enviar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "telecommunication"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mandar una carta": [
    {
      "id": 21828,
      "keyword": "mandar una carta",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "telecommunication"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "remitir": [
    {
      "id": 21828,
      "keyword": "remitir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "telecommunication"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escalera mecánica": [
    {
      "id": 21830,
      "keyword": "escalera mecánica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escaleras mecánicas": [
    {
      "id": 21830,
      "keyword": "escalera mecánica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escapar": [
    {
      "id": 38017,
      "keyword": "escapar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31015,
      "keyword": "escapar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21834,
      "keyword": "escapar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escarbar": [
    {
      "id": 21838,
      "keyword": "escarbar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "animal",
        "animal physiology",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21836,
      "keyword": "escarbar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despedirse": [
    {
      "id": 37807,
      "keyword": "despedirse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21793,
      "keyword": "despedirse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escondite": [
    {
      "id": 21845,
      "keyword": "escondite",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escondites": [
    {
      "id": 21845,
      "keyword": "escondite",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escotilla": [
    {
      "id": 21847,
      "keyword": "escotilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escotillas": [
    {
      "id": 21847,
      "keyword": "escotilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escocia": [
    {
      "id": 21844,
      "keyword": "Escocia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teclear": [
    {
      "id": 21851,
      "keyword": "teclear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "eslovaquia": [
    {
      "id": 21853,
      "keyword": "Eslovaquia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29572,
      "keyword": "Eslovaquia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estatua de la libertad": [
    {
      "id": 21854,
      "keyword": "Estatua de la Libertad",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estonia": [
    {
      "id": 21856,
      "keyword": "Estonia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29574,
      "keyword": "Estonia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diligencia": [
    {
      "id": 21795,
      "keyword": "diligencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diligencias": [
    {
      "id": 21795,
      "keyword": "diligencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "exportar": [
    {
      "id": 21857,
      "keyword": "exportar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escobilla de baño": [
    {
      "id": 21840,
      "keyword": "escobilla de baño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escobillas de baño": [
    {
      "id": 21840,
      "keyword": "escobilla de baño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "férula": [
    {
      "id": 21863,
      "keyword": "férula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21867,
      "keyword": "férula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36419,
      "keyword": "férula",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "férulas": [
    {
      "id": 21863,
      "keyword": "férula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21867,
      "keyword": "férula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "financiar": [
    {
      "id": 21871,
      "keyword": "financiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "financial services",
        "secondary sector",
        "industry",
        "manufacturing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flotar": [
    {
      "id": 32904,
      "keyword": "flotar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21876,
      "keyword": "flotar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21874,
      "keyword": "flotar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gallinita ciega": [
    {
      "id": 28695,
      "keyword": "Gallinita ciega",
      "keywords": 2,
      "type": 1,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21882,
      "keyword": "Gallinita ciega",
      "keywords": 1,
      "type": 1,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28693,
      "keyword": "Gallinita ciega",
      "keywords": 2,
      "type": 1,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "finlandia": [
    {
      "id": 21873,
      "keyword": "Finlandia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28983,
      "keyword": "Finlandia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gladiolo": [
    {
      "id": 21894,
      "keyword": "gladiolo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gladiolos": [
    {
      "id": 21894,
      "keyword": "gladiolo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "el gato con botas": [
    {
      "id": 21888,
      "keyword": "El gato con botas",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gelatina": [
    {
      "id": 21890,
      "keyword": "gelatina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gelatinas": [
    {
      "id": 21890,
      "keyword": "gelatina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guardar el peine": [
    {
      "id": 21914,
      "keyword": "guardar el peine",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "container"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36543,
      "keyword": "guardar el peine",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gobierno": [
    {
      "id": 21906,
      "keyword": "gobierno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gobiernos": [
    {
      "id": 21906,
      "keyword": "gobierno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guatemala": [
    {
      "id": 21916,
      "keyword": "Guatemala",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29724,
      "keyword": "Guatemala",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "me gusta eso": [
    {
      "id": 37826,
      "keyword": "me gusta eso",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression",
        "core vocabulary",
        "leisure",
        "sport",
        "traditional game",
        "game",
        "show",
        "work",
        "education",
        "teaching activity",
        "outdoor activity",
        "object",
        "place",
        "event",
        "movement",
        "traffic",
        "mode of transport",
        "usual verbs",
        "toy",
        "facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21917,
      "keyword": "me gusta eso",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38889,
      "keyword": "me gusta eso",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38891,
      "keyword": "me gusta eso",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hansel y gretel": [
    {
      "id": 21923,
      "keyword": "Hansel y Gretel",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "glotón": [
    {
      "id": 37789,
      "keyword": "glotón",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21898,
      "keyword": "glotón",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "glotones": [
    {
      "id": 37789,
      "keyword": "glotón",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21898,
      "keyword": "glotón",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comilón": [
    {
      "id": 37789,
      "keyword": "comilón",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21898,
      "keyword": "comilón",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comilones": [
    {
      "id": 37789,
      "keyword": "comilón",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21898,
      "keyword": "comilón",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tragón": [
    {
      "id": 37789,
      "keyword": "tragón",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21898,
      "keyword": "tragón",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tragones": [
    {
      "id": 37789,
      "keyword": "tragón",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21898,
      "keyword": "tragón",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "importar": [
    {
      "id": 21927,
      "keyword": "importar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "incienso": [
    {
      "id": 21937,
      "keyword": "incienso",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "inciensos": [
    {
      "id": 21937,
      "keyword": "incienso",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "irlanda": [
    {
      "id": 21941,
      "keyword": "Irlanda",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37651,
      "keyword": "Irlanda",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hemiciclo": [
    {
      "id": 21925,
      "keyword": "hemiciclo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hemiciclos": [
    {
      "id": 21925,
      "keyword": "hemiciclo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "islandia": [
    {
      "id": 21942,
      "keyword": "Islandia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "glotona": [
    {
      "id": 37789,
      "keyword": "glotona",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21902,
      "keyword": "glotona",
      "keywords": 1,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "glotonas": [
    {
      "id": 37789,
      "keyword": "glotona",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21902,
      "keyword": "glotona",
      "keywords": 1,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "judo": [
    {
      "id": 21943,
      "keyword": "judo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yudo": [
    {
      "id": 21943,
      "keyword": "yudo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rugby": [
    {
      "id": 21949,
      "keyword": "rugby",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27160,
      "keyword": "rugby",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37437,
      "keyword": "rugby",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lenguado": [
    {
      "id": 25666,
      "keyword": "lenguado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21957,
      "keyword": "lenguado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lenguados": [
    {
      "id": 25666,
      "keyword": "lenguado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21957,
      "keyword": "lenguado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "letonia": [
    {
      "id": 21961,
      "keyword": "Letonia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29577,
      "keyword": "Letonia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "karate": [
    {
      "id": 21955,
      "keyword": "karate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "karate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos paralímpicos": [
    {
      "id": 21953,
      "keyword": "juegos paralímpicos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "videojuego": [
    {
      "id": 21945,
      "keyword": "videojuego",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25614,
      "keyword": "videojuego",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "videojuegos": [
    {
      "id": 21945,
      "keyword": "videojuego",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25614,
      "keyword": "videojuego",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lituania": [
    {
      "id": 21968,
      "keyword": "Lituania",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lubina": [
    {
      "id": 25667,
      "keyword": "lubina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 21969,
      "keyword": "lubina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lubinas": [
    {
      "id": 25667,
      "keyword": "lubina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 21969,
      "keyword": "lubina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "luxemburgo": [
    {
      "id": 21973,
      "keyword": "Luxemburgo",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "macedonia del norte": [
    {
      "id": 21974,
      "keyword": "Macedonia del Norte",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "malta": [
    {
      "id": 21975,
      "keyword": "Malta",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29579,
      "keyword": "Malta",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manifestación": [
    {
      "id": 21976,
      "keyword": "manifestación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manifestaciones": [
    {
      "id": 21976,
      "keyword": "manifestación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "limpiar el peine": [
    {
      "id": 21962,
      "keyword": "limpiar el peine",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "menta": [
    {
      "id": 21982,
      "keyword": "menta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mentas": [
    {
      "id": 21982,
      "keyword": "menta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hierbabuena": [
    {
      "id": 21982,
      "keyword": "hierbabuena",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hierbabuenas": [
    {
      "id": 21982,
      "keyword": "hierbabuena",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesa adaptada": [
    {
      "id": 21984,
      "keyword": "mesa adaptada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas adaptadas": [
    {
      "id": 21984,
      "keyword": "mesa adaptada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ministro": [
    {
      "id": 21992,
      "keyword": "ministro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "person",
        "leader"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ministros": [
    {
      "id": 21992,
      "keyword": "ministro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "person",
        "leader"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "motorista": [
    {
      "id": 22000,
      "keyword": "motorista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "motoristas": [
    {
      "id": 22000,
      "keyword": "motorista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "modista": [
    {
      "id": 21996,
      "keyword": "modista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "modistas": [
    {
      "id": 21996,
      "keyword": "modista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sastre": [
    {
      "id": 21996,
      "keyword": "sastre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22100,
      "keyword": "sastre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sastres": [
    {
      "id": 21996,
      "keyword": "sastre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22100,
      "keyword": "sastre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ministra": [
    {
      "id": 21988,
      "keyword": "ministra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "person",
        "leader"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ministras": [
    {
      "id": 21988,
      "keyword": "ministra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "person",
        "leader"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nicaragua": [
    {
      "id": 22004,
      "keyword": "Nicaragua",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29604,
      "keyword": "Nicaragua",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lince": [
    {
      "id": 21964,
      "keyword": "lince",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "linces": [
    {
      "id": 21964,
      "keyword": "lince",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cambio de marchas": [
    {
      "id": 22009,
      "keyword": "cambio de marchas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cambios de marchas": [
    {
      "id": 22009,
      "keyword": "cambio de marchas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palanca de cambio": [
    {
      "id": 22009,
      "keyword": "palanca de cambio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palancas de cambio": [
    {
      "id": 22009,
      "keyword": "palanca de cambio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "obedecer": [
    {
      "id": 22007,
      "keyword": "obedecer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obediente": [
    {
      "id": 22007,
      "keyword": "obediente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obedientes": [
    {
      "id": 22007,
      "keyword": "obediente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "patronal": [
    {
      "id": 22025,
      "keyword": "patronal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patronales": [
    {
      "id": 22025,
      "keyword": "patronal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "patines de hielo": [
    {
      "id": 22022,
      "keyword": "patines de hielo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30450,
      "keyword": "patines de hielo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "skating"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palo de billar": [
    {
      "id": 22013,
      "keyword": "palo de billar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palos de billar": [
    {
      "id": 22013,
      "keyword": "palo de billar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peregrino": [
    {
      "id": 22035,
      "keyword": "peregrino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peregrinos": [
    {
      "id": 35869,
      "keyword": "peregrinos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22035,
      "keyword": "peregrino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "periscopio": [
    {
      "id": 22043,
      "keyword": "periscopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "periscopios": [
    {
      "id": 22043,
      "keyword": "periscopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "presidenta": [
    {
      "id": 22052,
      "keyword": "presidenta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "person",
        "leader",
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presidentas": [
    {
      "id": 22052,
      "keyword": "presidenta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "person",
        "leader",
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "polonia": [
    {
      "id": 22051,
      "keyword": "Polonia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28985,
      "keyword": "Polonia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piragüista": [
    {
      "id": 22047,
      "keyword": "piragüista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piragüistas": [
    {
      "id": 22047,
      "keyword": "piragüista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "puerta de alcalá": [
    {
      "id": 22056,
      "keyword": "Puerta de Alcalá",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puerta de brandeburgo": [
    {
      "id": 22058,
      "keyword": "Puerta de Brandeburgo",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puerta del carmen": [
    {
      "id": 22060,
      "keyword": "Puerta del Carmen",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulgarcito": [
    {
      "id": 22062,
      "keyword": "Pulgarcito",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recepcionista": [
    {
      "id": 22072,
      "keyword": "recepcionista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22073,
      "keyword": "recepcionista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recepcionistas": [
    {
      "id": 22072,
      "keyword": "recepcionista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22073,
      "keyword": "recepcionista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry",
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ratonera": [
    {
      "id": 22068,
      "keyword": "ratonera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ratoneras": [
    {
      "id": 22068,
      "keyword": "ratonera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "repartidora": [
    {
      "id": 22084,
      "keyword": "repartidora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "repartidoras": [
    {
      "id": 22084,
      "keyword": "repartidora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sacudir": [
    {
      "id": 26408,
      "keyword": "sacudir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22096,
      "keyword": "sacudir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26407,
      "keyword": "sacudir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "roncar": [
    {
      "id": 22094,
      "keyword": "roncar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodaballo": [
    {
      "id": 25668,
      "keyword": "rodaballo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22090,
      "keyword": "rodaballo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodaballos": [
    {
      "id": 25668,
      "keyword": "rodaballo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22090,
      "keyword": "rodaballo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "la sagrada familia": [
    {
      "id": 22098,
      "keyword": "La Sagrada Familia",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "building",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sagrada familia": [
    {
      "id": 22098,
      "keyword": "Sagrada Familia",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "building",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meter la ropa": [
    {
      "id": 39449,
      "keyword": "meter la ropa",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22110,
      "keyword": "meter la ropa",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36724,
      "keyword": "meter la ropa",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seleccionar la ropa": [
    {
      "id": 39449,
      "keyword": "seleccionar la ropa",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22110,
      "keyword": "seleccionar la ropa",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36724,
      "keyword": "seleccionar la ropa",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "serbia": [
    {
      "id": 22112,
      "keyword": "Serbia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27311,
      "keyword": "Serbia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28987,
      "keyword": "Serbia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sudáfrica": [
    {
      "id": 22113,
      "keyword": "Sudáfrica",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suiza": [
    {
      "id": 22114,
      "keyword": "Suiza",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28978,
      "keyword": "Suiza",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suspender": [
    {
      "id": 29640,
      "keyword": "suspender",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27393,
      "keyword": "suspender",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22115,
      "keyword": "suspender",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29638,
      "keyword": "suspender",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29639,
      "keyword": "suspender",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taponar": [
    {
      "id": 22117,
      "keyword": "taponar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "telecabina": [
    {
      "id": 22119,
      "keyword": "telecabina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "telecabinas": [
    {
      "id": 22119,
      "keyword": "telecabina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "teleférico": [
    {
      "id": 22119,
      "keyword": "teleférico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teleféricos": [
    {
      "id": 22119,
      "keyword": "teleférico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "telesilla": [
    {
      "id": 22123,
      "keyword": "telesilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "telesillas": [
    {
      "id": 22123,
      "keyword": "telesilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "modisto": [
    {
      "id": 22100,
      "keyword": "modisto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "modistos": [
    {
      "id": 22100,
      "keyword": "modisto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tener hipo": [
    {
      "id": 22127,
      "keyword": "tener hipo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hipo": [
    {
      "id": 22127,
      "keyword": "hipo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hipos": [
    {
      "id": 22127,
      "keyword": "hipo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "terraza": [
    {
      "id": 22129,
      "keyword": "terraza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28131,
      "keyword": "terraza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "urban area"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38461,
      "keyword": "terraza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terrazas": [
    {
      "id": 22129,
      "keyword": "terraza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28131,
      "keyword": "terraza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "urban area"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38461,
      "keyword": "terraza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colín": [
    {
      "id": 22133,
      "keyword": "colín",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colines": [
    {
      "id": 22133,
      "keyword": "colín",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22133,
      "keyword": "colines",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38770,
      "keyword": "colines",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grisín": [
    {
      "id": 22133,
      "keyword": "grisín",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grisines": [
    {
      "id": 22133,
      "keyword": "grisín",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38770,
      "keyword": "grisines",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torre del agua": [
    {
      "id": 22145,
      "keyword": "Torre del Agua",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torre de control": [
    {
      "id": 22141,
      "keyword": "torre de control",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torres de control": [
    {
      "id": 22141,
      "keyword": "torre de control",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tocar el claxon": [
    {
      "id": 22139,
      "keyword": "tocar el claxon",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tramitar": [
    {
      "id": 22149,
      "keyword": "tramitar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "document",
        "public administration",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "verja": [
    {
      "id": 22162,
      "keyword": "verja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "verjas": [
    {
      "id": 22162,
      "keyword": "verja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trasatlántico": [
    {
      "id": 22155,
      "keyword": "trasatlántico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trasatlánticos": [
    {
      "id": 22155,
      "keyword": "trasatlántico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22155,
      "keyword": "transatlántico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "transatlántico": [
    {
      "id": 22155,
      "keyword": "transatlántico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "turquía": [
    {
      "id": 22161,
      "keyword": "Turquía",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29582,
      "keyword": "Turquía",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tirarse": [
    {
      "id": 26493,
      "keyword": "tirarse",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22137,
      "keyword": "tirarse",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31458,
      "keyword": "tirarse",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tirarse de cabeza": [
    {
      "id": 35199,
      "keyword": "tirarse de cabeza",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26493,
      "keyword": "tirarse de cabeza",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22137,
      "keyword": "tirarse de cabeza",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31458,
      "keyword": "tirarse de cabeza",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tirar de cabeza": [
    {
      "id": 35199,
      "keyword": "tirar de cabeza",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26493,
      "keyword": "tirar de cabeza",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22137,
      "keyword": "tirar de cabeza",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31458,
      "keyword": "tirar de cabeza",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carril": [
    {
      "id": 22178,
      "keyword": "carril",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carriles": [
    {
      "id": 22178,
      "keyword": "carril",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esternón": [
    {
      "id": 22180,
      "keyword": "esternón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esternones": [
    {
      "id": 22180,
      "keyword": "esternón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "golosinas": [
    {
      "id": 22182,
      "keyword": "golosinas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chucherías": [
    {
      "id": 22182,
      "keyword": "chucherías",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cesta de la ropa": [
    {
      "id": 22175,
      "keyword": "cesta de la ropa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "container",
        "fashion",
        "clothes",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cestas de la ropa": [
    {
      "id": 22175,
      "keyword": "cesta de la ropa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "container",
        "fashion",
        "clothes",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cesto de la ropa": [
    {
      "id": 22175,
      "keyword": "cesto de la ropa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "container",
        "fashion",
        "clothes",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cestos de la ropa": [
    {
      "id": 22175,
      "keyword": "cesto de la ropa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "container",
        "fashion",
        "clothes",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "muslo": [
    {
      "id": 22185,
      "keyword": "muslo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muslos": [
    {
      "id": 22185,
      "keyword": "muslo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peatón": [
    {
      "id": 22187,
      "keyword": "peatón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22186,
      "keyword": "peatón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peatones": [
    {
      "id": 22187,
      "keyword": "peatón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22186,
      "keyword": "peatón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "verter el detergente": [
    {
      "id": 22166,
      "keyword": "verter el detergente",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coger turno": [
    {
      "id": 22190,
      "keyword": "coger turno",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomar turno": [
    {
      "id": 22190,
      "keyword": "tomar turno",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelota terapéutica": [
    {
      "id": 22194,
      "keyword": "pelota terapéutica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelotas terapéuticas": [
    {
      "id": 22194,
      "keyword": "pelota terapéutica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "meterse la mano en el pantalón": [
    {
      "id": 22192,
      "keyword": "meterse la mano en el pantalón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meter la mano en el pantalón": [
    {
      "id": 22192,
      "keyword": "meter la mano en el pantalón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plataforma": [
    {
      "id": 22200,
      "keyword": "plataforma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plataformas": [
    {
      "id": 22200,
      "keyword": "plataforma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "incorrecto": [
    {
      "id": 22198,
      "keyword": "incorrecto",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34639,
      "keyword": "incorrecto",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "incorrectos": [
    {
      "id": 22198,
      "keyword": "incorrecto",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34639,
      "keyword": "incorrecto",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "incorrecta": [
    {
      "id": 22198,
      "keyword": "incorrecta",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34639,
      "keyword": "incorrecta",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "incorrectas": [
    {
      "id": 22198,
      "keyword": "incorrecta",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34639,
      "keyword": "incorrecta",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "erróneo": [
    {
      "id": 22198,
      "keyword": "erróneo",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34639,
      "keyword": "erróneo",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "erróneos": [
    {
      "id": 22198,
      "keyword": "erróneo",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34639,
      "keyword": "erróneo",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "errónea": [
    {
      "id": 22198,
      "keyword": "errónea",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34639,
      "keyword": "errónea",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "erróneas": [
    {
      "id": 22198,
      "keyword": "errónea",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34639,
      "keyword": "errónea",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "equivocado": [
    {
      "id": 22198,
      "keyword": "equivocado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34639,
      "keyword": "equivocado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equivocados": [
    {
      "id": 22198,
      "keyword": "equivocado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34639,
      "keyword": "equivocado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "equivocada": [
    {
      "id": 22198,
      "keyword": "equivocada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34639,
      "keyword": "equivocada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equivocadas": [
    {
      "id": 22198,
      "keyword": "equivocada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34639,
      "keyword": "equivocada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tumbado bocarriba": [
    {
      "id": 22204,
      "keyword": "tumbado bocarriba",
      "keywords": 1,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tumbado bocabajo": [
    {
      "id": 22208,
      "keyword": "tumbado bocabajo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tumbado": [
    {
      "id": 22205,
      "keyword": "tumbado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38640,
      "keyword": "tumbado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38641,
      "keyword": "tumbado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36534,
      "keyword": "tumbado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tumbados": [
    {
      "id": 22205,
      "keyword": "tumbado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38640,
      "keyword": "tumbado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38641,
      "keyword": "tumbado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36534,
      "keyword": "tumbado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zambullir": [
    {
      "id": 31162,
      "keyword": "zambullir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37289,
      "keyword": "zambullir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37290,
      "keyword": "zambullir",
      "keywords": 1,
      "type": 3,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22170,
      "keyword": "zambullir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25932,
      "keyword": "zambullir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26425,
      "keyword": "zambullir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tumbar bocabajo": [
    {
      "id": 22209,
      "keyword": "tumbar bocabajo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juego de los pinchitos": [
    {
      "id": 22212,
      "keyword": "juego de los pinchitos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos de los pinchitos": [
    {
      "id": 22212,
      "keyword": "juego de los pinchitos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pinchitos": [
    {
      "id": 22212,
      "keyword": "pinchitos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cómo": [
    {
      "id": 22619,
      "keyword": "cómo",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "core vocabulary",
        "adverb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿cómo?": [
    {
      "id": 22619,
      "keyword": "¿cómo?",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "core vocabulary",
        "adverb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "qué": [
    {
      "id": 22620,
      "keyword": "qué",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22624,
      "keyword": "qué",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuándo": [
    {
      "id": 32874,
      "keyword": "cuándo",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "core vocabulary",
        "adverb",
        "adverb of time"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22621,
      "keyword": "cuándo",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "adverb",
        "adverb of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿cuándo?": [
    {
      "id": 32874,
      "keyword": "¿cuándo?",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "core vocabulary",
        "adverb",
        "adverb of time"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22621,
      "keyword": "¿cuándo?",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "adverb",
        "adverb of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿qué?": [
    {
      "id": 22620,
      "keyword": "¿qué?",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿qué": [
    {
      "id": 22620,
      "keyword": "¿qué",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "privacidad": [
    {
      "id": 39147,
      "keyword": "privacidad",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22635,
      "keyword": "privacidad",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "privacidades": [
    {
      "id": 22635,
      "keyword": "privacidad",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "momento": [
    {
      "id": 29107,
      "keyword": "momento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29106,
      "keyword": "momento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29104,
      "keyword": "momento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29105,
      "keyword": "momento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22633,
      "keyword": "momento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "momentos": [
    {
      "id": 29107,
      "keyword": "momento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29106,
      "keyword": "momento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29104,
      "keyword": "momento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29105,
      "keyword": "momento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22633,
      "keyword": "momento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rato": [
    {
      "id": 22633,
      "keyword": "rato",
      "keywords": 3,
      "type": 2,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ratos": [
    {
      "id": 22633,
      "keyword": "rato",
      "keywords": 3,
      "type": 2,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "instante": [
    {
      "id": 22633,
      "keyword": "instante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "instantes": [
    {
      "id": 22633,
      "keyword": "instante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "privado": [
    {
      "id": 22637,
      "keyword": "privado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "privados": [
    {
      "id": 22637,
      "keyword": "privado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "privada": [
    {
      "id": 22637,
      "keyword": "privada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "privadas": [
    {
      "id": 22637,
      "keyword": "privada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "muchísimo": [
    {
      "id": 22629,
      "keyword": "muchísimo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muchísima": [
    {
      "id": 22629,
      "keyword": "muchísima",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muchísimos": [
    {
      "id": 22629,
      "keyword": "muchísimos",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muchísimas": [
    {
      "id": 22629,
      "keyword": "muchísimas",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciberaula": [
    {
      "id": 22751,
      "keyword": "ciberaula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciberaulas": [
    {
      "id": 22751,
      "keyword": "ciberaula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "burla": [
    {
      "id": 22761,
      "keyword": "burla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "burlas": [
    {
      "id": 22761,
      "keyword": "burla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "poesía": [
    {
      "id": 22763,
      "keyword": "poesía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature",
        "literacy genre"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poesías": [
    {
      "id": 22763,
      "keyword": "poesía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature",
        "literacy genre"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "concejalía": [
    {
      "id": 22753,
      "keyword": "concejalía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "person",
        "leader"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "concejalías": [
    {
      "id": 22753,
      "keyword": "concejalía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "person",
        "leader"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "concejal": [
    {
      "id": 22753,
      "keyword": "concejal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "person",
        "leader"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "concejales": [
    {
      "id": 22753,
      "keyword": "concejal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "person",
        "leader"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "biografía": [
    {
      "id": 22749,
      "keyword": "biografía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature",
        "literacy genre",
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "biografías": [
    {
      "id": 22749,
      "keyword": "biografía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature",
        "literacy genre",
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "podóloga": [
    {
      "id": 38823,
      "keyword": "podóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22765,
      "keyword": "podóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "podólogas": [
    {
      "id": 38823,
      "keyword": "podóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22765,
      "keyword": "podóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arteterapia": [
    {
      "id": 22771,
      "keyword": "arteterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arteterapias": [
    {
      "id": 22771,
      "keyword": "arteterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "artesanía": [
    {
      "id": 22769,
      "keyword": "artesanía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "artesanías": [
    {
      "id": 22769,
      "keyword": "artesanía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atletismo": [
    {
      "id": 22773,
      "keyword": "atletismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34484,
      "keyword": "atletismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "podólogo": [
    {
      "id": 38823,
      "keyword": "podólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22767,
      "keyword": "podólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "podólogos": [
    {
      "id": 38823,
      "keyword": "podólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22767,
      "keyword": "podólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "danzaterapia": [
    {
      "id": 22777,
      "keyword": "danzaterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "danzaterapias": [
    {
      "id": 22777,
      "keyword": "danzaterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ayuda a domicilio": [
    {
      "id": 22775,
      "keyword": "ayuda a domicilio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ayudas a domicilio": [
    {
      "id": 22775,
      "keyword": "ayuda a domicilio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inclusión": [
    {
      "id": 35039,
      "keyword": "inclusión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22785,
      "keyword": "inclusión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 22787,
      "keyword": "inclusión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inclusiones": [
    {
      "id": 35039,
      "keyword": "inclusión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22785,
      "keyword": "inclusión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 22787,
      "keyword": "inclusión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "exclusión social": [
    {
      "id": 22781,
      "keyword": "exclusión social",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "exclusiones sociales": [
    {
      "id": 22781,
      "keyword": "exclusión social",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "lectoescritura": [
    {
      "id": 22789,
      "keyword": "lectoescritura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lectoescrituras": [
    {
      "id": 22789,
      "keyword": "lectoescritura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "integración social": [
    {
      "id": 22787,
      "keyword": "integración social",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "integraciones sociales": [
    {
      "id": 22787,
      "keyword": "integración social",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "registro": [
    {
      "id": 22797,
      "keyword": "registro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "registros": [
    {
      "id": 22797,
      "keyword": "registro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "islam": [
    {
      "id": 22793,
      "keyword": "islam",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "islamism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estrella judia": [
    {
      "id": 22795,
      "keyword": "estrella judia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estrella de david": [
    {
      "id": 22795,
      "keyword": "Estrella de David",
      "keywords": 3,
      "type": 1,
      "tags": [
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "judaísmo": [
    {
      "id": 22795,
      "keyword": "judaísmo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpieza": [
    {
      "id": 22791,
      "keyword": "limpieza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiezas": [
    {
      "id": 22791,
      "keyword": "limpieza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trabajar en el ordenador": [
    {
      "id": 22801,
      "keyword": "trabajar en el ordenador",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "interculturalidad": [
    {
      "id": 23398,
      "keyword": "interculturalidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23935,
      "keyword": "interculturalidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "interculturalidades": [
    {
      "id": 23398,
      "keyword": "interculturalidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23935,
      "keyword": "interculturalidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "musicoterapia": [
    {
      "id": 23400,
      "keyword": "musicoterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "musicoterapias": [
    {
      "id": 23400,
      "keyword": "musicoterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diálogo": [
    {
      "id": 23402,
      "keyword": "diálogo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diálogos": [
    {
      "id": 23402,
      "keyword": "diálogo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conversación": [
    {
      "id": 23402,
      "keyword": "conversación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conversaciones": [
    {
      "id": 23402,
      "keyword": "conversación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tertulia": [
    {
      "id": 23402,
      "keyword": "tertulia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tertulias": [
    {
      "id": 23402,
      "keyword": "tertulia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "curso": [
    {
      "id": 23404,
      "keyword": "curso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30030,
      "keyword": "curso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cursos": [
    {
      "id": 23404,
      "keyword": "curso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30030,
      "keyword": "curso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aseo personal": [
    {
      "id": 23406,
      "keyword": "aseo personal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aseos personales": [
    {
      "id": 23406,
      "keyword": "aseo personal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "higiene personal": [
    {
      "id": 23406,
      "keyword": "higiene personal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "higienes personales": [
    {
      "id": 23406,
      "keyword": "higiene personal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lectura fácil": [
    {
      "id": 23394,
      "keyword": "lectura fácil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lecturas fáciles": [
    {
      "id": 23394,
      "keyword": "lectura fácil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature",
        "library science"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reloj digital": [
    {
      "id": 23408,
      "keyword": "reloj digital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "time",
        "chronological device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "relojes digitales": [
    {
      "id": 23408,
      "keyword": "reloj digital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "time",
        "chronological device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "brindar": [
    {
      "id": 25873,
      "keyword": "brindar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37264,
      "keyword": "brindar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23414,
      "keyword": "brindar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ábaco": [
    {
      "id": 23699,
      "keyword": "ábaco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ábacos": [
    {
      "id": 23699,
      "keyword": "ábaco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abdominal": [
    {
      "id": 23703,
      "keyword": "abdominal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abdominales": [
    {
      "id": 23703,
      "keyword": "abdominal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23703,
      "keyword": "abdominales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fonoaudiólogas": [
    {
      "id": 23396,
      "keyword": "fonoaudióloga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37355,
      "keyword": "fonoaudióloga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32911,
      "keyword": "fonoaudióloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "speech therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acuífero": [
    {
      "id": 23725,
      "keyword": "acuífero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acuíferos": [
    {
      "id": 23725,
      "keyword": "acuífero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adán y eva": [
    {
      "id": 23729,
      "keyword": "Adán y Eva",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "christianity",
        "judaism",
        "islamism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alicatador": [
    {
      "id": 23733,
      "keyword": "alicatador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alicatadores": [
    {
      "id": 23733,
      "keyword": "alicatador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "altar": [
    {
      "id": 23737,
      "keyword": "altar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "place",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "altares": [
    {
      "id": 23737,
      "keyword": "altar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "place",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aire": [
    {
      "id": 23731,
      "keyword": "aire",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aires": [
    {
      "id": 23731,
      "keyword": "aire",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tacatá": [
    {
      "id": 23741,
      "keyword": "tacatá",
      "keywords": 2,
      "type": 2,
      "tags": [
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tacatás": [
    {
      "id": 23741,
      "keyword": "tacatá",
      "keywords": 2,
      "type": 2,
      "tags": [
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apóstol": [
    {
      "id": 23745,
      "keyword": "apóstol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "character",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apóstoles": [
    {
      "id": 23745,
      "keyword": "apóstol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "character",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23746,
      "keyword": "apóstoles",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "character",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "armario de cocina": [
    {
      "id": 23753,
      "keyword": "armario de cocina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36765,
      "keyword": "armario de cocina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "armarios de cocina": [
    {
      "id": 23753,
      "keyword": "armario de cocina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36765,
      "keyword": "armario de cocina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alacena": [
    {
      "id": 23753,
      "keyword": "alacena",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36765,
      "keyword": "alacena",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alacenas": [
    {
      "id": 23753,
      "keyword": "alacena",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36765,
      "keyword": "alacena",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arroyo": [
    {
      "id": 23757,
      "keyword": "arroyo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arroyos": [
    {
      "id": 23757,
      "keyword": "arroyo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "relacionar": [
    {
      "id": 37217,
      "keyword": "relacionar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "healthy habit",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23763,
      "keyword": "relacionar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34812,
      "keyword": "relacionar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asma": [
    {
      "id": 23761,
      "keyword": "asma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asmas": [
    {
      "id": 23761,
      "keyword": "asma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ateo": [
    {
      "id": 38518,
      "keyword": "ateo",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38518,
      "keyword": "ateo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23765,
      "keyword": "ateo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23765,
      "keyword": "ateo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ateos": [
    {
      "id": 38518,
      "keyword": "ateo",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38518,
      "keyword": "ateo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23765,
      "keyword": "ateo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23765,
      "keyword": "ateo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atraer": [
    {
      "id": 23771,
      "keyword": "atraer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "physics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arca de noé": [
    {
      "id": 23751,
      "keyword": "Arca de Noé",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "christianity",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atomium": [
    {
      "id": 23769,
      "keyword": "Atomium",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bache": [
    {
      "id": 23783,
      "keyword": "bache",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baches": [
    {
      "id": 23783,
      "keyword": "bache",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bacteria": [
    {
      "id": 23787,
      "keyword": "bacteria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "biology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bacterias": [
    {
      "id": 23787,
      "keyword": "bacteria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "biology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atril": [
    {
      "id": 23777,
      "keyword": "atril",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23773,
      "keyword": "atril",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30891,
      "keyword": "atril",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "event",
        "religious event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atriles": [
    {
      "id": 23777,
      "keyword": "atril",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23773,
      "keyword": "atril",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30891,
      "keyword": "atril",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "event",
        "religious event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bajar la cabeza": [
    {
      "id": 23796,
      "keyword": "bajar la cabeza",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "azafrán": [
    {
      "id": 23781,
      "keyword": "azafrán",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "feeding",
        "food",
        "plant-based food",
        "aromatic plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "azafranes": [
    {
      "id": 23781,
      "keyword": "azafrán",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "feeding",
        "food",
        "plant-based food",
        "aromatic plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "flor de azafrán": [
    {
      "id": 23781,
      "keyword": "flor de azafrán",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "feeding",
        "food",
        "plant-based food",
        "aromatic plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flores de azafrán": [
    {
      "id": 23781,
      "keyword": "flor de azafrán",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "feeding",
        "food",
        "plant-based food",
        "aromatic plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bahía": [
    {
      "id": 23792,
      "keyword": "bahía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bahías": [
    {
      "id": 23792,
      "keyword": "bahía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "banda": [
    {
      "id": 32701,
      "keyword": "banda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "music",
        "work",
        "professional",
        "artist",
        "leisure",
        "show",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23806,
      "keyword": "banda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37504,
      "keyword": "banda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23811,
      "keyword": "banda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "music",
        "work",
        "professional",
        "artist",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38948,
      "keyword": "banda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "music",
        "work",
        "professional",
        "artist",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bandas": [
    {
      "id": 32701,
      "keyword": "banda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "music",
        "work",
        "professional",
        "artist",
        "leisure",
        "show",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23806,
      "keyword": "banda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37504,
      "keyword": "banda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23811,
      "keyword": "banda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "music",
        "work",
        "professional",
        "artist",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38948,
      "keyword": "banda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "music",
        "work",
        "professional",
        "artist",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bajar la cama": [
    {
      "id": 26660,
      "keyword": "bajar la cama",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26661,
      "keyword": "bajar la cama",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23810,
      "keyword": "bajar la cama",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grupo musical": [
    {
      "id": 23811,
      "keyword": "grupo musical",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "music",
        "work",
        "professional",
        "artist",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38948,
      "keyword": "grupo musical",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "music",
        "work",
        "professional",
        "artist",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grupos musicales": [
    {
      "id": 23811,
      "keyword": "grupo musical",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "music",
        "work",
        "professional",
        "artist",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38948,
      "keyword": "grupo musical",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "music",
        "work",
        "professional",
        "artist",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bendición": [
    {
      "id": 23827,
      "keyword": "bendición",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23828,
      "keyword": "bendición",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30894,
      "keyword": "bendición",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30895,
      "keyword": "bendición",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30896,
      "keyword": "bendición",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30897,
      "keyword": "bendición",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bendiciones": [
    {
      "id": 23827,
      "keyword": "bendición",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23828,
      "keyword": "bendición",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30894,
      "keyword": "bendición",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30895,
      "keyword": "bendición",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30896,
      "keyword": "bendición",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30897,
      "keyword": "bendición",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "biblia": [
    {
      "id": 26539,
      "keyword": "Biblia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23833,
      "keyword": "Biblia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "biblias": [
    {
      "id": 26539,
      "keyword": "Biblia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23833,
      "keyword": "Biblia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bendición pontifical": [
    {
      "id": 23828,
      "keyword": "bendición pontifical",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bendiciones pontificales": [
    {
      "id": 23828,
      "keyword": "bendición pontifical",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barranco": [
    {
      "id": 23815,
      "keyword": "barranco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barrancos": [
    {
      "id": 23815,
      "keyword": "barranco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bíceps": [
    {
      "id": 23841,
      "keyword": "bíceps",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "muscular system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tocar la batería": [
    {
      "id": 23819,
      "keyword": "tocar la batería",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buceadora": [
    {
      "id": 21464,
      "keyword": "buceadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buceadoras": [
    {
      "id": 21464,
      "keyword": "buceadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bisalto": [
    {
      "id": 23847,
      "keyword": "bisalto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bisaltos": [
    {
      "id": 23847,
      "keyword": "bisalto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arveja": [
    {
      "id": 23847,
      "keyword": "arveja",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chequia": [
    {
      "id": 21535,
      "keyword": "Chequia",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "república checa": [
    {
      "id": 21535,
      "keyword": "República Checa",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caimán": [
    {
      "id": 23863,
      "keyword": "caimán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caimanes": [
    {
      "id": 23863,
      "keyword": "caimán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chipre": [
    {
      "id": 21536,
      "keyword": "Chipre",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cala": [
    {
      "id": 23871,
      "keyword": "cala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25894,
      "keyword": "cala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calas": [
    {
      "id": 23871,
      "keyword": "cala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25894,
      "keyword": "cala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cajón flamenco": [
    {
      "id": 23867,
      "keyword": "cajón flamenco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajones flamencos": [
    {
      "id": 23867,
      "keyword": "cajón flamenco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolsa de papel": [
    {
      "id": 23849,
      "keyword": "bolsa de papel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas de papel": [
    {
      "id": 23849,
      "keyword": "bolsa de papel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "buda": [
    {
      "id": 23857,
      "keyword": "Buda",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "buddhism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cabo": [
    {
      "id": 23859,
      "keyword": "cabo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cabos": [
    {
      "id": 23859,
      "keyword": "cabo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cama elástica": [
    {
      "id": 38022,
      "keyword": "cama elástica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23891,
      "keyword": "cama elástica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23887,
      "keyword": "cama elástica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35611,
      "keyword": "cama elástica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camas elásticas": [
    {
      "id": 38022,
      "keyword": "cama elástica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23891,
      "keyword": "cama elástica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23887,
      "keyword": "cama elástica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35611,
      "keyword": "cama elástica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calentadores": [
    {
      "id": 23879,
      "keyword": "calentadores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "polainas": [
    {
      "id": 25339,
      "keyword": "polainas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23879,
      "keyword": "polainas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camerino": [
    {
      "id": 23893,
      "keyword": "camerino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "scenic art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camerinos": [
    {
      "id": 23893,
      "keyword": "camerino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "scenic art"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caleidoscopio": [
    {
      "id": 23875,
      "keyword": "caleidoscopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caleidoscopios": [
    {
      "id": 23875,
      "keyword": "caleidoscopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "brócoli": [
    {
      "id": 23853,
      "keyword": "brócoli",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brócolis": [
    {
      "id": 23853,
      "keyword": "brócoli",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "menorá": [
    {
      "id": 23901,
      "keyword": "menorá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "menorás": [
    {
      "id": 23901,
      "keyword": "menorá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "judaism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cardo": [
    {
      "id": 23913,
      "keyword": "cardo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23915,
      "keyword": "cardo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cardos": [
    {
      "id": 23913,
      "keyword": "cardo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23915,
      "keyword": "cardo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "circuito": [
    {
      "id": 26543,
      "keyword": "circuito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23925,
      "keyword": "circuito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychomotor equipment",
        "sport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28263,
      "keyword": "circuito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36001,
      "keyword": "circuito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25954,
      "keyword": "circuito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "circuitos": [
    {
      "id": 26543,
      "keyword": "circuito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23925,
      "keyword": "circuito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychomotor equipment",
        "sport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28263,
      "keyword": "circuito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36001,
      "keyword": "circuito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25954,
      "keyword": "circuito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "circular": [
    {
      "id": 23929,
      "keyword": "circular",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "circulación": [
    {
      "id": 23929,
      "keyword": "circulación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tráfico": [
    {
      "id": 23929,
      "keyword": "tráfico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cazadora vaquera": [
    {
      "id": 23921,
      "keyword": "cazadora vaquera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cazadoras vaqueras": [
    {
      "id": 23921,
      "keyword": "cazadora vaquera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cóctel": [
    {
      "id": 23941,
      "keyword": "cóctel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cócteles": [
    {
      "id": 23941,
      "keyword": "cóctel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cáliz": [
    {
      "id": 23884,
      "keyword": "cáliz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37145,
      "keyword": "cáliz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cálices": [
    {
      "id": 23884,
      "keyword": "cáliz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37145,
      "keyword": "cáliz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cirio": [
    {
      "id": 23931,
      "keyword": "cirio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cirios": [
    {
      "id": 23931,
      "keyword": "cirio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coliflor": [
    {
      "id": 23953,
      "keyword": "coliflor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coliflores": [
    {
      "id": 23953,
      "keyword": "coliflor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coliseo de roma": [
    {
      "id": 23957,
      "keyword": "Coliseo de Roma",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coliseo": [
    {
      "id": 23957,
      "keyword": "Coliseo",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coctelera": [
    {
      "id": 23945,
      "keyword": "coctelera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cocteleras": [
    {
      "id": 23945,
      "keyword": "coctelera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "col de bruselas": [
    {
      "id": 23949,
      "keyword": "col de Bruselas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coles de bruselas": [
    {
      "id": 23949,
      "keyword": "col de Bruselas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "corán": [
    {
      "id": 23973,
      "keyword": "Corán",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "object",
        "islamism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corral": [
    {
      "id": 23979,
      "keyword": "corral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31394,
      "keyword": "corral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31404,
      "keyword": "corral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corrales": [
    {
      "id": 23979,
      "keyword": "corral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31394,
      "keyword": "corral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31404,
      "keyword": "corral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cortafríos": [
    {
      "id": 23983,
      "keyword": "cortafríos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conectar": [
    {
      "id": 23967,
      "keyword": "conectar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31356,
      "keyword": "conectar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27515,
      "keyword": "conectar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clave": [
    {
      "id": 23937,
      "keyword": "clave",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27691,
      "keyword": "clave",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "claves": [
    {
      "id": 23937,
      "keyword": "clave",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27691,
      "keyword": "clave",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conducción": [
    {
      "id": 23963,
      "keyword": "conducción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conducciones": [
    {
      "id": 23963,
      "keyword": "conducción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cordillera": [
    {
      "id": 23975,
      "keyword": "cordillera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38261,
      "keyword": "cordillera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cordilleras": [
    {
      "id": 23975,
      "keyword": "cordillera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38261,
      "keyword": "cordillera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuádriceps": [
    {
      "id": 23997,
      "keyword": "cuádriceps",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "muscular system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "confesión": [
    {
      "id": 30870,
      "keyword": "confesión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23969,
      "keyword": "confesión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "confesiones": [
    {
      "id": 30870,
      "keyword": "confesión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23969,
      "keyword": "confesión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cristiano": [
    {
      "id": 25033,
      "keyword": "cristiano",
      "keywords": 3,
      "type": 4,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25033,
      "keyword": "cristiano",
      "keywords": 3,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 23993,
      "keyword": "cristiano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cristianos": [
    {
      "id": 25033,
      "keyword": "cristiano",
      "keywords": 3,
      "type": 4,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25033,
      "keyword": "cristiano",
      "keywords": 3,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 23993,
      "keyword": "cristiano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dar limosna": [
    {
      "id": 24010,
      "keyword": "dar limosna",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24009,
      "keyword": "dar limosna",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortezas": [
    {
      "id": 23987,
      "keyword": "cortezas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dios": [
    {
      "id": 35069,
      "keyword": "Dios",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24013,
      "keyword": "Dios",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25948,
      "keyword": "Dios",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerrar la puerta": [
    {
      "id": 24022,
      "keyword": "cerrar la puerta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24021,
      "keyword": "cerrar la puerta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28457,
      "keyword": "cerrar la puerta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encimera": [
    {
      "id": 24025,
      "keyword": "encimera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encimeras": [
    {
      "id": 24025,
      "keyword": "encimera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espíritu santo": [
    {
      "id": 24029,
      "keyword": "Espíritu Santo",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "evitar": [
    {
      "id": 24032,
      "keyword": "evitar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24031,
      "keyword": "evitar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esquivar": [
    {
      "id": 24032,
      "keyword": "esquivar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24031,
      "keyword": "esquivar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuenco": [
    {
      "id": 24005,
      "keyword": "cuenco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuencos": [
    {
      "id": 24005,
      "keyword": "cuenco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "evangelio": [
    {
      "id": 24039,
      "keyword": "Evangelio",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30845,
      "keyword": "Evangelio",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30847,
      "keyword": "Evangelio",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30846,
      "keyword": "Evangelio",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30848,
      "keyword": "Evangelio",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cúbito": [
    {
      "id": 24001,
      "keyword": "cúbito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cúbitos": [
    {
      "id": 24001,
      "keyword": "cúbito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dióxido de carbono": [
    {
      "id": 24015,
      "keyword": "dióxido de carbono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "pollution"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "elástico": [
    {
      "id": 24017,
      "keyword": "elástico",
      "keywords": 1,
      "type": 4,
      "tags": [
        "texture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "elásticos": [
    {
      "id": 24017,
      "keyword": "elástico",
      "keywords": 1,
      "type": 4,
      "tags": [
        "texture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "flexible": [
    {
      "id": 24055,
      "keyword": "flexible",
      "keywords": 1,
      "type": 4,
      "tags": [
        "texture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flexibles": [
    {
      "id": 24055,
      "keyword": "flexible",
      "keywords": 1,
      "type": 4,
      "tags": [
        "texture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuando": [
    {
      "id": 24053,
      "keyword": "cuando",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "conjunction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frágil": [
    {
      "id": 38734,
      "keyword": "frágil",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24061,
      "keyword": "frágil",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frágiles": [
    {
      "id": 38734,
      "keyword": "frágil",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24061,
      "keyword": "frágil",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "delicado": [
    {
      "id": 24061,
      "keyword": "delicado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "delicados": [
    {
      "id": 24061,
      "keyword": "delicado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "delicada": [
    {
      "id": 24061,
      "keyword": "delicada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "delicadas": [
    {
      "id": 24061,
      "keyword": "delicada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estuche de gafas": [
    {
      "id": 24065,
      "keyword": "estuche de gafas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estuches de gafas": [
    {
      "id": 24065,
      "keyword": "estuche de gafas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estuche de lentes": [
    {
      "id": 24065,
      "keyword": "estuche de lentes",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estuches de lentes": [
    {
      "id": 24065,
      "keyword": "estuche de lentes",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estuche de anteojos": [
    {
      "id": 24065,
      "keyword": "estuche de anteojos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estuches de anteojos": [
    {
      "id": 24065,
      "keyword": "estuche de anteojos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fémur": [
    {
      "id": 24045,
      "keyword": "fémur",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fémures": [
    {
      "id": 24045,
      "keyword": "fémur",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "geosfera": [
    {
      "id": 24073,
      "keyword": "geosfera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geology",
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "glúteo": [
    {
      "id": 24075,
      "keyword": "glúteo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "muscular system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "glúteos": [
    {
      "id": 24075,
      "keyword": "glúteo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "muscular system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "falanges": [
    {
      "id": 24041,
      "keyword": "falanges",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37475,
      "keyword": "falanges",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guitarrista": [
    {
      "id": 24091,
      "keyword": "guitarrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24095,
      "keyword": "guitarrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guitarristas": [
    {
      "id": 24091,
      "keyword": "guitarrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24095,
      "keyword": "guitarrista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "haba": [
    {
      "id": 24099,
      "keyword": "haba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "habas": [
    {
      "id": 24099,
      "keyword": "haba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hostia": [
    {
      "id": 24105,
      "keyword": "hostia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hostias": [
    {
      "id": 24105,
      "keyword": "hostia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guirlache": [
    {
      "id": 24087,
      "keyword": "guirlache",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guirlaches": [
    {
      "id": 24087,
      "keyword": "guirlache",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hidrosfera": [
    {
      "id": 24103,
      "keyword": "hidrosfera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "golfo": [
    {
      "id": 24079,
      "keyword": "golfo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "golfos": [
    {
      "id": 24079,
      "keyword": "golfo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ingredientes": [
    {
      "id": 24119,
      "keyword": "ingredientes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inspector de vía pública": [
    {
      "id": 24121,
      "keyword": "inspector de vía pública",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inspectores de vía pública": [
    {
      "id": 24121,
      "keyword": "inspector de vía pública",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inspector": [
    {
      "id": 39145,
      "keyword": "inspector",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24121,
      "keyword": "inspector",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inspectores": [
    {
      "id": 39145,
      "keyword": "inspector",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24121,
      "keyword": "inspector",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "húmero": [
    {
      "id": 24109,
      "keyword": "húmero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "húmeros": [
    {
      "id": 24109,
      "keyword": "húmero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inyectar insulina": [
    {
      "id": 24125,
      "keyword": "inyectar insulina",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kipá": [
    {
      "id": 24139,
      "keyword": "kipá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "judaism",
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kipás": [
    {
      "id": 24139,
      "keyword": "kipá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "judaism",
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lanceta": [
    {
      "id": 24146,
      "keyword": "lanceta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lancetas": [
    {
      "id": 24146,
      "keyword": "lanceta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "balón prisionero": [
    {
      "id": 37552,
      "keyword": "balón prisionero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24137,
      "keyword": "balón prisionero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "incubar": [
    {
      "id": 24117,
      "keyword": "incubar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "animal",
        "animal physiology",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38869,
      "keyword": "incubar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "animal physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ligamento": [
    {
      "id": 24149,
      "keyword": "ligamento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "joint system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ligamentos": [
    {
      "id": 24149,
      "keyword": "ligamento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "joint system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "istmo": [
    {
      "id": 24131,
      "keyword": "istmo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "istmos": [
    {
      "id": 24131,
      "keyword": "istmo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cristo": [
    {
      "id": 24135,
      "keyword": "Cristo",
      "keywords": 3,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "historical character",
        "history",
        "christianity",
        "event",
        "popular event",
        "easter week"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jesucristo": [
    {
      "id": 24135,
      "keyword": "Jesucristo",
      "keywords": 3,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "historical character",
        "history",
        "christianity",
        "event",
        "popular event",
        "easter week"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mecedora": [
    {
      "id": 24169,
      "keyword": "mecedora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mecedoras": [
    {
      "id": 24169,
      "keyword": "mecedora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "milagro": [
    {
      "id": 24181,
      "keyword": "milagro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "milagros": [
    {
      "id": 24181,
      "keyword": "milagro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "minarete": [
    {
      "id": 24185,
      "keyword": "minarete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "islamism",
        "architecture",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "minaretes": [
    {
      "id": 24185,
      "keyword": "minarete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "islamism",
        "architecture",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alminar": [
    {
      "id": 24185,
      "keyword": "alminar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "islamism",
        "architecture",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alminares": [
    {
      "id": 24185,
      "keyword": "alminar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "islamism",
        "architecture",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "misa": [
    {
      "id": 24189,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30905,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30906,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30907,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30908,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30915,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30914,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30916,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30913,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30917,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30920,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30921,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30919,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "misas": [
    {
      "id": 24189,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30905,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30906,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30907,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30908,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30915,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30914,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30916,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30913,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30917,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30920,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30921,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30919,
      "keyword": "misa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "moisés": [
    {
      "id": 24194,
      "keyword": "Moisés",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "historical character",
        "history",
        "christianity",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jamsa": [
    {
      "id": 24158,
      "keyword": "Jamsa",
      "keywords": 2,
      "type": 1,
      "tags": [
        "religion",
        "islamism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mano de fátima": [
    {
      "id": 24158,
      "keyword": "Mano de Fátima",
      "keywords": 2,
      "type": 1,
      "tags": [
        "religion",
        "islamism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "noé": [
    {
      "id": 24198,
      "keyword": "Noé",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "historical character",
        "history",
        "christianity",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obispo": [
    {
      "id": 24200,
      "keyword": "obispo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obispos": [
    {
      "id": 24200,
      "keyword": "obispo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "medidor de glucosa": [
    {
      "id": 24173,
      "keyword": "medidor de glucosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medidores de glucosa": [
    {
      "id": 24173,
      "keyword": "medidor de glucosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mezquita": [
    {
      "id": 30395,
      "keyword": "mezquita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "islamism",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24177,
      "keyword": "mezquita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "islamism",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 24177,
      "keyword": "mezquita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "islamism",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mezquitas": [
    {
      "id": 30395,
      "keyword": "mezquita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "islamism",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24177,
      "keyword": "mezquita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "islamism",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 24177,
      "keyword": "mezquita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "islamism",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conseguir": [
    {
      "id": 24208,
      "keyword": "conseguir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obtener": [
    {
      "id": 24208,
      "keyword": "obtener",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manantial": [
    {
      "id": 24154,
      "keyword": "manantial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manantiales": [
    {
      "id": 24154,
      "keyword": "manantial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "opaco": [
    {
      "id": 24210,
      "keyword": "opaco",
      "keywords": 1,
      "type": 4,
      "tags": [
        "material",
        "raw material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "opacos": [
    {
      "id": 24210,
      "keyword": "opaco",
      "keywords": 1,
      "type": 4,
      "tags": [
        "material",
        "raw material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "órgano": [
    {
      "id": 26262,
      "keyword": "órgano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "keyboard instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24214,
      "keyword": "órgano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "órganos": [
    {
      "id": 26262,
      "keyword": "órgano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "keyboard instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24214,
      "keyword": "órgano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24214,
      "keyword": "órganos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pantera": [
    {
      "id": 24226,
      "keyword": "pantera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panteras": [
    {
      "id": 24226,
      "keyword": "pantera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pantuflas": [
    {
      "id": 24230,
      "keyword": "pantuflas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botella de oxígeno": [
    {
      "id": 24216,
      "keyword": "botella de oxígeno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botellas de oxígeno": [
    {
      "id": 24216,
      "keyword": "botella de oxígeno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "partículas": [
    {
      "id": 24240,
      "keyword": "partículas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patena": [
    {
      "id": 24242,
      "keyword": "patena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patenas": [
    {
      "id": 24242,
      "keyword": "patena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pectorales": [
    {
      "id": 24246,
      "keyword": "pectorales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "muscular system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelador": [
    {
      "id": 24250,
      "keyword": "pelador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37821,
      "keyword": "pelador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peladores": [
    {
      "id": 24250,
      "keyword": "pelador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37821,
      "keyword": "pelador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pera en almíbar": [
    {
      "id": 24264,
      "keyword": "pera en almíbar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peras en almíbar": [
    {
      "id": 24264,
      "keyword": "pera en almíbar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pesadilla": [
    {
      "id": 24272,
      "keyword": "pesadilla",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "pesadillas": [
    {
      "id": 24272,
      "keyword": "pesadilla",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "peto": [
    {
      "id": 24276,
      "keyword": "peto",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "petos": [
    {
      "id": 37889,
      "keyword": "petos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24276,
      "keyword": "peto",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enterito": [
    {
      "id": 24276,
      "keyword": "enterito",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enteritos": [
    {
      "id": 24276,
      "keyword": "enterito",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "piezas": [
    {
      "id": 24280,
      "keyword": "piezas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tornillería": [
    {
      "id": 24280,
      "keyword": "tornillería",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinchar el dedo": [
    {
      "id": 24286,
      "keyword": "pinchar el dedo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37008,
      "keyword": "pinchar el dedo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piña en almíbar": [
    {
      "id": 24288,
      "keyword": "piña en almíbar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piñas en almíbar": [
    {
      "id": 24288,
      "keyword": "piña en almíbar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ananá en almíbar": [
    {
      "id": 24288,
      "keyword": "ananá en almíbar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ananás en almíbar": [
    {
      "id": 24288,
      "keyword": "ananá en almíbar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pelvis": [
    {
      "id": 24260,
      "keyword": "pelvis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palanca": [
    {
      "id": 26279,
      "keyword": "palanca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24218,
      "keyword": "palanca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26278,
      "keyword": "palanca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palancas": [
    {
      "id": 26279,
      "keyword": "palanca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24218,
      "keyword": "palanca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26278,
      "keyword": "palanca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plano": [
    {
      "id": 38240,
      "keyword": "plano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "architecture",
        "building",
        "work",
        "secondary sector",
        "construction",
        "place",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24296,
      "keyword": "plano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "planos": [
    {
      "id": 38240,
      "keyword": "plano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "architecture",
        "building",
        "work",
        "secondary sector",
        "construction",
        "place",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24296,
      "keyword": "plano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peroné": [
    {
      "id": 24268,
      "keyword": "peroné",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peronés": [
    {
      "id": 24268,
      "keyword": "peroné",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reñir": [
    {
      "id": 37373,
      "keyword": "reñir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24254,
      "keyword": "reñir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34492,
      "keyword": "reñir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34496,
      "keyword": "reñir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelo de animal": [
    {
      "id": 24256,
      "keyword": "pelo de animal",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelos de animal": [
    {
      "id": 24256,
      "keyword": "pelo de animal",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pelaje": [
    {
      "id": 24256,
      "keyword": "pelaje",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelajes": [
    {
      "id": 24256,
      "keyword": "pelaje",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "poncho": [
    {
      "id": 26342,
      "keyword": "poncho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24316,
      "keyword": "poncho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ponchos": [
    {
      "id": 26342,
      "keyword": "poncho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24316,
      "keyword": "poncho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "polvo": [
    {
      "id": 24312,
      "keyword": "polvo",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "polvos": [
    {
      "id": 24312,
      "keyword": "polvo",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "pompones": [
    {
      "id": 24314,
      "keyword": "pompones",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35409,
      "keyword": "pompón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "software": [
    {
      "id": 24320,
      "keyword": "software",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puerta batiente": [
    {
      "id": 24325,
      "keyword": "puerta batiente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24324,
      "keyword": "puerta batiente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puertas batientes": [
    {
      "id": 24325,
      "keyword": "puerta batiente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24324,
      "keyword": "puerta batiente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recipiente": [
    {
      "id": 24344,
      "keyword": "recipiente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34759,
      "keyword": "recipiente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recipientes": [
    {
      "id": 24344,
      "keyword": "recipientes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34759,
      "keyword": "recipiente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34759,
      "keyword": "recipientes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "potabilizadora": [
    {
      "id": 24304,
      "keyword": "potabilizadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "potabilizadoras": [
    {
      "id": 24304,
      "keyword": "potabilizadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "radio despertador": [
    {
      "id": 24340,
      "keyword": "radio despertador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media",
        "mass media device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "radio despertadores": [
    {
      "id": 24340,
      "keyword": "radio despertador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media",
        "mass media device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "regaliz": [
    {
      "id": 24351,
      "keyword": "regaliz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "regalices": [
    {
      "id": 24351,
      "keyword": "regaliz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "puerta oscilobatiente": [
    {
      "id": 24332,
      "keyword": "puerta oscilobatiente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puertas oscilobatientes": [
    {
      "id": 24332,
      "keyword": "puerta oscilobatiente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "relieve costero": [
    {
      "id": 24362,
      "keyword": "relieve costero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "relieves costeros": [
    {
      "id": 24362,
      "keyword": "relieve costero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rezar": [
    {
      "id": 36033,
      "keyword": "rezar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24369,
      "keyword": "rezar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38074,
      "keyword": "rezar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30861,
      "keyword": "rezar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30889,
      "keyword": "rezar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30901,
      "keyword": "rezar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24372,
      "keyword": "rezar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "islamism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24368,
      "keyword": "rezar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30850,
      "keyword": "rezar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30863,
      "keyword": "rezar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30899,
      "keyword": "rezar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rosario": [
    {
      "id": 24374,
      "keyword": "rosario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24766,
      "keyword": "rosario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rosarios": [
    {
      "id": 24374,
      "keyword": "rosario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24766,
      "keyword": "rosario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recorrer": [
    {
      "id": 24348,
      "keyword": "recorrer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sagrario": [
    {
      "id": 24378,
      "keyword": "sagrario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "place",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sagrarios": [
    {
      "id": 24378,
      "keyword": "sagrario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "place",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salón de plenos": [
    {
      "id": 24382,
      "keyword": "salón de plenos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36589,
      "keyword": "salón de plenos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salones de plenos": [
    {
      "id": 24382,
      "keyword": "salón de plenos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36589,
      "keyword": "salón de plenos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "relieve": [
    {
      "id": 24360,
      "keyword": "relieve",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "relieves": [
    {
      "id": 24360,
      "keyword": "relieve",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "santa": [
    {
      "id": 24388,
      "keyword": "santa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "character",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "santas": [
    {
      "id": 24388,
      "keyword": "santa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "character",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "santo": [
    {
      "id": 35155,
      "keyword": "santo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "religious event",
        "religion",
        "christianity",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24392,
      "keyword": "santo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "character",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39222,
      "keyword": "santo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "character"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "santos": [
    {
      "id": 35155,
      "keyword": "santo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "religious event",
        "religion",
        "christianity",
        "popular event"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24392,
      "keyword": "santo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "character",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39222,
      "keyword": "santo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "character"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saxofonista": [
    {
      "id": 24396,
      "keyword": "saxofonista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saxofonistas": [
    {
      "id": 24396,
      "keyword": "saxofonista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "orar": [
    {
      "id": 24369,
      "keyword": "orar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38074,
      "keyword": "orar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30861,
      "keyword": "orar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30889,
      "keyword": "orar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30901,
      "keyword": "orar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24368,
      "keyword": "orar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30850,
      "keyword": "orar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30863,
      "keyword": "orar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30899,
      "keyword": "orar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "shivá": [
    {
      "id": 24400,
      "keyword": "Shivá",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "hinduism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sinagoga": [
    {
      "id": 30405,
      "keyword": "sinagoga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "judaism",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24408,
      "keyword": "sinagoga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "judaism",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 24408,
      "keyword": "sinagoga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "judaism",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sinagogas": [
    {
      "id": 30405,
      "keyword": "sinagoga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "judaism",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24408,
      "keyword": "sinagoga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "judaism",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 24408,
      "keyword": "sinagoga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "judaism",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sida": [
    {
      "id": 24402,
      "keyword": "sida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vih": [
    {
      "id": 24402,
      "keyword": "VIH",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juan el bautista": [
    {
      "id": 24386,
      "keyword": "Juan el Bautista",
      "keywords": 2,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teclista": [
    {
      "id": 24424,
      "keyword": "teclista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art",
        "musical instrument",
        "keyboard instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teclistas": [
    {
      "id": 24424,
      "keyword": "teclista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "music",
        "visual art",
        "musical instrument",
        "keyboard instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tendón": [
    {
      "id": 24432,
      "keyword": "tendón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "joint system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tendones": [
    {
      "id": 24432,
      "keyword": "tendón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "joint system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tibia": [
    {
      "id": 24436,
      "keyword": "tibia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tibias": [
    {
      "id": 24436,
      "keyword": "tibia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "teleoperador": [
    {
      "id": 38798,
      "keyword": "teleoperador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24428,
      "keyword": "teleoperador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teleoperadores": [
    {
      "id": 38798,
      "keyword": "teleoperador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24428,
      "keyword": "teleoperador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "transparente": [
    {
      "id": 24440,
      "keyword": "transparente",
      "keywords": 1,
      "type": 4,
      "tags": [
        "material",
        "raw material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "transparentes": [
    {
      "id": 24440,
      "keyword": "transparente",
      "keywords": 1,
      "type": 4,
      "tags": [
        "material",
        "raw material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tríceps": [
    {
      "id": 24450,
      "keyword": "tríceps",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "muscular system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "traslación": [
    {
      "id": 24448,
      "keyword": "traslación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "traslaciónes": [
    {
      "id": 24448,
      "keyword": "traslación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "movimiento de traslación": [
    {
      "id": 24448,
      "keyword": "movimiento de traslación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "movimientos de traslación": [
    {
      "id": 24448,
      "keyword": "movimiento de traslación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "virus": [
    {
      "id": 24459,
      "keyword": "virus",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease",
        "biology",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vaquilla": [
    {
      "id": 24455,
      "keyword": "vaquilla",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vaquillas": [
    {
      "id": 24455,
      "keyword": "vaquilla",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "becerro": [
    {
      "id": 24455,
      "keyword": "becerro",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "becerros": [
    {
      "id": 24455,
      "keyword": "becerro",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "becerra": [
    {
      "id": 24455,
      "keyword": "becerra",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "becerras": [
    {
      "id": 24455,
      "keyword": "becerra",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "novillo": [
    {
      "id": 26489,
      "keyword": "novillo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34080,
      "keyword": "novillo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24455,
      "keyword": "novillo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "novillos": [
    {
      "id": 26489,
      "keyword": "novillo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34080,
      "keyword": "novillo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24455,
      "keyword": "novillo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "novilla": [
    {
      "id": 26489,
      "keyword": "novilla",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34080,
      "keyword": "novilla",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24455,
      "keyword": "novilla",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "novillas": [
    {
      "id": 26489,
      "keyword": "novilla",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34080,
      "keyword": "novilla",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24455,
      "keyword": "novilla",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taladradora": [
    {
      "id": 24420,
      "keyword": "taladradora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taladradoras": [
    {
      "id": 24420,
      "keyword": "taladradora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perforadora": [
    {
      "id": 24420,
      "keyword": "perforadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perforadoras": [
    {
      "id": 24420,
      "keyword": "perforadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "religión": [
    {
      "id": 27059,
      "keyword": "religión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32544,
      "keyword": "religión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24471,
      "keyword": "religión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39178,
      "keyword": "religión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de religión": [
    {
      "id": 24471,
      "keyword": "clase de religión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39178,
      "keyword": "clase de religión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de religión": [
    {
      "id": 24471,
      "keyword": "clase de religión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39178,
      "keyword": "clase de religión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fuerteventura": [
    {
      "id": 24478,
      "keyword": "Fuerteventura",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toráh": [
    {
      "id": 24463,
      "keyword": "toráh",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tora": [
    {
      "id": 24463,
      "keyword": "tora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gran canaria": [
    {
      "id": 24477,
      "keyword": "Gran Canaria",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "spain province"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "café descafeinado": [
    {
      "id": 24487,
      "keyword": "café descafeinado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cafés descafeinados": [
    {
      "id": 24487,
      "keyword": "café descafeinado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "café moca": [
    {
      "id": 24491,
      "keyword": "café moca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cafés moca": [
    {
      "id": 24491,
      "keyword": "café moca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "café capuchino": [
    {
      "id": 24483,
      "keyword": "café capuchino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cafés capuchinos": [
    {
      "id": 24483,
      "keyword": "café capuchino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agua dulce": [
    {
      "id": 24495,
      "keyword": "agua dulce",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aguas dulces": [
    {
      "id": 24495,
      "keyword": "agua dulce",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ventana oscilobatiente": [
    {
      "id": 24465,
      "keyword": "ventana oscilobatiente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ventanas oscilobatientes": [
    {
      "id": 24465,
      "keyword": "ventana oscilobatiente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "descanso": [
    {
      "id": 24503,
      "keyword": "descanso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36109,
      "keyword": "descanso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "descansos": [
    {
      "id": 24503,
      "keyword": "descanso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36109,
      "keyword": "descanso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reproductor de cd": [
    {
      "id": 24509,
      "keyword": "reproductor de CD",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "music device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reproductores de cd": [
    {
      "id": 24509,
      "keyword": "reproductor de CD",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "music device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agua salada": [
    {
      "id": 24501,
      "keyword": "agua salada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "signaling system",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aguas saladas": [
    {
      "id": 24501,
      "keyword": "agua salada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "signaling system",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agua de mar": [
    {
      "id": 24501,
      "keyword": "agua de mar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "signaling system",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aguas de mar": [
    {
      "id": 24501,
      "keyword": "agua de mar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "signaling system",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clase de idiomas": [
    {
      "id": 24469,
      "keyword": "clase de idiomas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de idiomas": [
    {
      "id": 24469,
      "keyword": "clase de idiomas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agua potable": [
    {
      "id": 24499,
      "keyword": "agua potable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aguas potables": [
    {
      "id": 24499,
      "keyword": "agua potable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ajustar dosis": [
    {
      "id": 24535,
      "keyword": "ajustar dosis",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "display": [
    {
      "id": 24529,
      "keyword": "display",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24530,
      "keyword": "display",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24531,
      "keyword": "display",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "displays": [
    {
      "id": 24529,
      "keyword": "display",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24530,
      "keyword": "display",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24531,
      "keyword": "display",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dar tiempo": [
    {
      "id": 24527,
      "keyword": "dar tiempo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "árbol de primavera": [
    {
      "id": 24537,
      "keyword": "árbol de primavera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "spring",
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "árboles de primavera": [
    {
      "id": 24537,
      "keyword": "árbol de primavera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "spring",
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atención al público": [
    {
      "id": 24541,
      "keyword": "atención al público",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24642,
      "keyword": "atención al público",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24641,
      "keyword": "atención al público",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolígrafo de insulina": [
    {
      "id": 24543,
      "keyword": "bolígrafo de insulina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolígrafos de insulina": [
    {
      "id": 24543,
      "keyword": "bolígrafo de insulina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pluma de insulina": [
    {
      "id": 24543,
      "keyword": "pluma de insulina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plumas de insulina": [
    {
      "id": 24543,
      "keyword": "pluma de insulina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "correr de la mano": [
    {
      "id": 24552,
      "keyword": "correr de la mano",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24551,
      "keyword": "correr de la mano",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colchoneta de vibración": [
    {
      "id": 24547,
      "keyword": "colchoneta de vibración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colchonetas de vibración": [
    {
      "id": 24547,
      "keyword": "colchoneta de vibración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colchoneta vibradora": [
    {
      "id": 24547,
      "keyword": "colchoneta vibradora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colchonetas vibradoras": [
    {
      "id": 24547,
      "keyword": "colchoneta vibradora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colchoneta con vibración": [
    {
      "id": 24547,
      "keyword": "colchoneta con vibración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colchonetas con vibración": [
    {
      "id": 24547,
      "keyword": "colchoneta con vibración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plataforma oscilante": [
    {
      "id": 24567,
      "keyword": "plataforma oscilante",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plataformas oscilantes": [
    {
      "id": 24567,
      "keyword": "plataforma oscilante",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plataforma colgante": [
    {
      "id": 24567,
      "keyword": "plataforma colgante",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plataformas colgantes": [
    {
      "id": 24567,
      "keyword": "plataforma colgante",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gusanitos": [
    {
      "id": 24555,
      "keyword": "gusanitos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsa de gusanitos": [
    {
      "id": 24555,
      "keyword": "bolsa de gusanitos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas de gusanitos": [
    {
      "id": 24555,
      "keyword": "bolsa de gusanitos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saquitos": [
    {
      "id": 24581,
      "keyword": "saquitos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rueda de psicomotricidad": [
    {
      "id": 24573,
      "keyword": "rueda de psicomotricidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ruedas de psicomotricidad": [
    {
      "id": 24573,
      "keyword": "rueda de psicomotricidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silla de ruedas de carreras": [
    {
      "id": 24587,
      "keyword": "silla de ruedas de carreras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "adapted sport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas de ruedas de carreras": [
    {
      "id": 24587,
      "keyword": "silla de ruedas de carreras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "adapted sport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silla de playa adaptada": [
    {
      "id": 24583,
      "keyword": "silla de playa adaptada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas de playa adaptada": [
    {
      "id": 24583,
      "keyword": "silla de playa adaptada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recoger sangre": [
    {
      "id": 24595,
      "keyword": "recoger sangre",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tira de medición de glucosa": [
    {
      "id": 24591,
      "keyword": "tira de medición de glucosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiras de medición de glucosa": [
    {
      "id": 24591,
      "keyword": "tira de medición de glucosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tira reactiva para glucosa": [
    {
      "id": 24591,
      "keyword": "tira reactiva para glucosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiras reactivas para glucosa": [
    {
      "id": 24591,
      "keyword": "tira reactiva para glucosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de juntas": [
    {
      "id": 24577,
      "keyword": "sala de juntas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de juntas": [
    {
      "id": 24577,
      "keyword": "sala de juntas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rotación": [
    {
      "id": 24571,
      "keyword": "rotación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rotaciones": [
    {
      "id": 24571,
      "keyword": "rotación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cita previa": [
    {
      "id": 24609,
      "keyword": "cita previa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "health",
        "medicine",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24610,
      "keyword": "cita previa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "health",
        "medicine",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "citas previas": [
    {
      "id": 24609,
      "keyword": "cita previa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "health",
        "medicine",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24610,
      "keyword": "cita previa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "health",
        "medicine",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pedir cita": [
    {
      "id": 24609,
      "keyword": "pedir cita",
      "keywords": 2,
      "type": 3,
      "tags": [
        "event",
        "health",
        "medicine",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24610,
      "keyword": "pedir cita",
      "keywords": 2,
      "type": 3,
      "tags": [
        "event",
        "health",
        "medicine",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hamaca colgante": [
    {
      "id": 24563,
      "keyword": "hamaca colgante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31050,
      "keyword": "hamaca colgante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30229,
      "keyword": "hamaca colgante",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "hamacas colgantes": [
    {
      "id": 24563,
      "keyword": "hamaca colgante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31050,
      "keyword": "hamaca colgante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30229,
      "keyword": "hamaca colgante",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "fibra óptica": [
    {
      "id": 24559,
      "keyword": "fibra óptica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fibras ópticas": [
    {
      "id": 24559,
      "keyword": "fibra óptica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "haz de luz": [
    {
      "id": 24559,
      "keyword": "haz de luz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "haces de luz": [
    {
      "id": 24559,
      "keyword": "haz de luz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "voto": [
    {
      "id": 24603,
      "keyword": "voto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "votos": [
    {
      "id": 24603,
      "keyword": "voto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "papeleta": [
    {
      "id": 24603,
      "keyword": "papeleta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papeletas": [
    {
      "id": 24603,
      "keyword": "papeleta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "papeleta electoral": [
    {
      "id": 24603,
      "keyword": "papeleta electoral",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papeletas electorales": [
    {
      "id": 24603,
      "keyword": "papeleta electoral",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "formación profesional": [
    {
      "id": 24613,
      "keyword": "formación profesional",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "formaciones profesionales": [
    {
      "id": 24613,
      "keyword": "formación profesional",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "formación online": [
    {
      "id": 24617,
      "keyword": "formación online",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "methodology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "formaciones online": [
    {
      "id": 24617,
      "keyword": "formación online",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "methodology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aprendizaje electrónico": [
    {
      "id": 24617,
      "keyword": "aprendizaje electrónico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "methodology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aprendizajes electrónicos": [
    {
      "id": 24617,
      "keyword": "aprendizaje electrónico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "methodology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "e-learning": [
    {
      "id": 24617,
      "keyword": "e-learning",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "methodology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intérprete": [
    {
      "id": 24619,
      "keyword": "intérprete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intérpretes": [
    {
      "id": 24619,
      "keyword": "intérprete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "intérprete de lengua de signos": [
    {
      "id": 24619,
      "keyword": "intérprete de lengua de signos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intérpretes de lengua de signos": [
    {
      "id": 24619,
      "keyword": "intérprete de lengua de signos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "precipitaciones": [
    {
      "id": 24623,
      "keyword": "precipitaciones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escuela taller": [
    {
      "id": 24615,
      "keyword": "escuela taller",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escuelas taller": [
    {
      "id": 24615,
      "keyword": "escuela taller",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taller de empleo": [
    {
      "id": 24615,
      "keyword": "taller de empleo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talleres de empleo": [
    {
      "id": 24615,
      "keyword": "taller de empleo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de entrevistas": [
    {
      "id": 24629,
      "keyword": "sala de entrevistas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24628,
      "keyword": "sala de entrevistas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24627,
      "keyword": "sala de entrevistas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de entrevistas": [
    {
      "id": 24629,
      "keyword": "sala de entrevistas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24628,
      "keyword": "sala de entrevistas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24627,
      "keyword": "sala de entrevistas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de espera": [
    {
      "id": 24634,
      "keyword": "sala de espera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27473,
      "keyword": "sala de espera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24633,
      "keyword": "sala de espera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de espera": [
    {
      "id": 24634,
      "keyword": "sala de espera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27473,
      "keyword": "sala de espera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24633,
      "keyword": "sala de espera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oficina de empleo": [
    {
      "id": 24637,
      "keyword": "oficina de empleo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24638,
      "keyword": "oficina de empleo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oficinas de empleo": [
    {
      "id": 24637,
      "keyword": "oficina de empleo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24638,
      "keyword": "oficina de empleo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "no utilizar el ascensor en caso de incendio": [
    {
      "id": 24653,
      "keyword": "no utilizar el ascensor en caso de incendio",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿bien o mal?": [
    {
      "id": 24607,
      "keyword": "¿bien o mal?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sala polivalente": [
    {
      "id": 24649,
      "keyword": "sala polivalente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas polivalentes": [
    {
      "id": 24649,
      "keyword": "sala polivalente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuarto del café": [
    {
      "id": 24655,
      "keyword": "cuarto del café",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuartos del café": [
    {
      "id": 24655,
      "keyword": "cuarto del café",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "respiro laboral": [
    {
      "id": 24655,
      "keyword": "respiro laboral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "respiros laborales": [
    {
      "id": 24655,
      "keyword": "respiro laboral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prohibido usar el ascensor": [
    {
      "id": 24651,
      "keyword": "prohibido usar el ascensor",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sala taller": [
    {
      "id": 24645,
      "keyword": "sala taller",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24647,
      "keyword": "sala taller",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas taller": [
    {
      "id": 24645,
      "keyword": "sala taller",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24647,
      "keyword": "sala taller",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aula de manualidades": [
    {
      "id": 24645,
      "keyword": "aula de manualidades",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aulas de manualidades": [
    {
      "id": 24645,
      "keyword": "aula de manualidades",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "orientador laboral": [
    {
      "id": 24661,
      "keyword": "orientador laboral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24673,
      "keyword": "orientador laboral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24659,
      "keyword": "orientador laboral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orientadores laborales": [
    {
      "id": 24661,
      "keyword": "orientador laboral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24673,
      "keyword": "orientador laboral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24659,
      "keyword": "orientador laboral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de actividades": [
    {
      "id": 24647,
      "keyword": "sala de actividades",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de actividades": [
    {
      "id": 24647,
      "keyword": "sala de actividades",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "equipo de intervención social": [
    {
      "id": 24666,
      "keyword": "equipo de intervención social",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24665,
      "keyword": "equipo de intervención social",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24667,
      "keyword": "equipo de intervención social",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equipos de intervención social": [
    {
      "id": 24666,
      "keyword": "equipo de intervención social",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24665,
      "keyword": "equipo de intervención social",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24667,
      "keyword": "equipo de intervención social",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taller de baile": [
    {
      "id": 24676,
      "keyword": "taller de baile",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system",
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24675,
      "keyword": "taller de baile",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system",
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talleres de baile": [
    {
      "id": 24676,
      "keyword": "taller de baile",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system",
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24675,
      "keyword": "taller de baile",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system",
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "orientadora laboral": [
    {
      "id": 24660,
      "keyword": "orientadora laboral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orientadoras laborales": [
    {
      "id": 24660,
      "keyword": "orientadora laboral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taller de memoria": [
    {
      "id": 24679,
      "keyword": "taller de memoria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24680,
      "keyword": "taller de memoria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talleres de memoria": [
    {
      "id": 24679,
      "keyword": "taller de memoria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24680,
      "keyword": "taller de memoria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almacén de ludoteca": [
    {
      "id": 24683,
      "keyword": "almacén de ludoteca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almacenes de ludoteca": [
    {
      "id": 24683,
      "keyword": "almacén de ludoteca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "deporte adaptado": [
    {
      "id": 24671,
      "keyword": "deporte adaptado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "adapted sport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "deportes adaptados": [
    {
      "id": 24671,
      "keyword": "deporte adaptado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "adapted sport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conservación y mantenimiento": [
    {
      "id": 24685,
      "keyword": "conservación y mantenimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monitor de prevención": [
    {
      "id": 34201,
      "keyword": "monitor de prevención",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24688,
      "keyword": "monitor de prevención",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24687,
      "keyword": "monitor de prevención",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monitores de prevención": [
    {
      "id": 34201,
      "keyword": "monitor de prevención",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24688,
      "keyword": "monitor de prevención",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24687,
      "keyword": "monitor de prevención",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "itinerario personalizado de inserción": [
    {
      "id": 24673,
      "keyword": "itinerario personalizado de inserción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "itinerarios personalizados de inserción": [
    {
      "id": 24673,
      "keyword": "itinerario personalizado de inserción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "técnico de actividades deportivas": [
    {
      "id": 24694,
      "keyword": "técnico de actividades deportivas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24695,
      "keyword": "técnico de actividades deportivas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24693,
      "keyword": "técnico de actividades deportivas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnicos de actividades deportivas": [
    {
      "id": 24694,
      "keyword": "técnico de actividades deportivas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24695,
      "keyword": "técnico de actividades deportivas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24693,
      "keyword": "técnico de actividades deportivas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pluma y papel": [
    {
      "id": 24703,
      "keyword": "pluma y papel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plumas y papeles": [
    {
      "id": 24703,
      "keyword": "pluma y papel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salida dependientes": [
    {
      "id": 24705,
      "keyword": "salida dependientes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salidas dependientes": [
    {
      "id": 24705,
      "keyword": "salida dependientes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trámite": [
    {
      "id": 24709,
      "keyword": "trámite",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "public administration",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trámites": [
    {
      "id": 24709,
      "keyword": "trámite",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "public administration",
        "justice"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atender": [
    {
      "id": 25355,
      "keyword": "atender",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24711,
      "keyword": "atender",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24863,
      "keyword": "atender",
      "keywords": 2,
      "type": 3,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "tratar bien": [
    {
      "id": 24711,
      "keyword": "tratar bien",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prestar atención": [
    {
      "id": 25355,
      "keyword": "prestar atención",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24711,
      "keyword": "prestar atención",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "software de comunicación": [
    {
      "id": 24707,
      "keyword": "software de comunicación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "softwares de comunicación": [
    {
      "id": 24707,
      "keyword": "software de comunicación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ignorar": [
    {
      "id": 24719,
      "keyword": "ignorar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clima": [
    {
      "id": 24721,
      "keyword": "clima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "climas": [
    {
      "id": 24721,
      "keyword": "clima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bailadora": [
    {
      "id": 24728,
      "keyword": "bailadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "dance",
        "regional dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bailadoras": [
    {
      "id": 24728,
      "keyword": "bailadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "dance",
        "regional dance",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿cuántos?": [
    {
      "id": 24731,
      "keyword": "¿cuántos?",
      "keywords": 5,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "core vocabulary",
        "adverb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuánto": [
    {
      "id": 24731,
      "keyword": "cuánto",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics",
        "core vocabulary",
        "adverb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "divertido": [
    {
      "id": 24733,
      "keyword": "divertido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36481,
      "keyword": "divertido",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24735,
      "keyword": "divertido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "divertidos": [
    {
      "id": 24733,
      "keyword": "divertido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36481,
      "keyword": "divertido",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24735,
      "keyword": "divertido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "divertida": [
    {
      "id": 24733,
      "keyword": "divertida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36482,
      "keyword": "divertida",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24735,
      "keyword": "divertida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "divertidas": [
    {
      "id": 24733,
      "keyword": "divertida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36482,
      "keyword": "divertida",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24735,
      "keyword": "divertida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "laboratorio de aguas": [
    {
      "id": 24691,
      "keyword": "laboratorio de aguas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "chemistry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "laboratorios de aguas": [
    {
      "id": 24691,
      "keyword": "laboratorio de aguas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "chemistry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bailador": [
    {
      "id": 24727,
      "keyword": "bailador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "dance",
        "regional dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bailadores": [
    {
      "id": 24727,
      "keyword": "bailador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "dance",
        "regional dance",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maltratar": [
    {
      "id": 24749,
      "keyword": "maltratar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "opuesto": [
    {
      "id": 32386,
      "keyword": "opuesto",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24753,
      "keyword": "opuesto",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "opuestos": [
    {
      "id": 32386,
      "keyword": "opuesto",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24753,
      "keyword": "opuesto",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "opuesta": [
    {
      "id": 32386,
      "keyword": "opuesta",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24753,
      "keyword": "opuesta",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "opuestas": [
    {
      "id": 32386,
      "keyword": "opuesta",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24753,
      "keyword": "opuesta",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contrario": [
    {
      "id": 24753,
      "keyword": "contrario",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contrarios": [
    {
      "id": 24753,
      "keyword": "contrario",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contraria": [
    {
      "id": 24753,
      "keyword": "contraria",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contrarias": [
    {
      "id": 24753,
      "keyword": "contraria",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enfrentado": [
    {
      "id": 24753,
      "keyword": "enfrentado",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfrentados": [
    {
      "id": 24753,
      "keyword": "enfrentado",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enfrentada": [
    {
      "id": 24753,
      "keyword": "enfrentada",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfrentadas": [
    {
      "id": 24753,
      "keyword": "enfrentada",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rezar el rosario": [
    {
      "id": 24765,
      "keyword": "rezar el rosario",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "por qué": [
    {
      "id": 36719,
      "keyword": "por qué",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24763,
      "keyword": "por qué",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manipulados": [
    {
      "id": 24769,
      "keyword": "manipulados",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "público": [
    {
      "id": 36699,
      "keyword": "público",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24783,
      "keyword": "público",
      "keywords": 3,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "asistentes": [
    {
      "id": 38378,
      "keyword": "asistente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "tourism",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38379,
      "keyword": "asistente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "tourism",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24783,
      "keyword": "asistentes",
      "keywords": 3,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "espectadores": [
    {
      "id": 24783,
      "keyword": "espectadores",
      "keywords": 3,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "percusión": [
    {
      "id": 24777,
      "keyword": "percusión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25658,
      "keyword": "percusión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "percusiones": [
    {
      "id": 24777,
      "keyword": "percusión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25658,
      "keyword": "percusión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grada": [
    {
      "id": 24787,
      "keyword": "grada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gradas": [
    {
      "id": 24787,
      "keyword": "grada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "boletería": [
    {
      "id": 34189,
      "keyword": "boletería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "culture",
        "scenic art",
        "cinema",
        "show",
        "theater",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24793,
      "keyword": "boletería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "culture",
        "scenic art",
        "cinema",
        "show",
        "theater",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boleterías": [
    {
      "id": 34189,
      "keyword": "boletería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "culture",
        "scenic art",
        "cinema",
        "show",
        "theater",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24793,
      "keyword": "boletería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "culture",
        "scenic art",
        "cinema",
        "show",
        "theater",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "composición": [
    {
      "id": 24791,
      "keyword": "composición",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24795,
      "keyword": "composición",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "composiciones": [
    {
      "id": 24791,
      "keyword": "composición",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24795,
      "keyword": "composición",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "partitura": [
    {
      "id": 24791,
      "keyword": "partitura",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24795,
      "keyword": "partitura",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "partituras": [
    {
      "id": 24791,
      "keyword": "partitura",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24795,
      "keyword": "partitura",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pentagrama": [
    {
      "id": 24791,
      "keyword": "pentagrama",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24795,
      "keyword": "pentagrama",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pentagramas": [
    {
      "id": 24791,
      "keyword": "pentagrama",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24795,
      "keyword": "pentagrama",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "canción": [
    {
      "id": 24791,
      "keyword": "canción",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38000,
      "keyword": "canción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24795,
      "keyword": "canción",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canciones": [
    {
      "id": 24791,
      "keyword": "canción",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38000,
      "keyword": "canción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24795,
      "keyword": "canción",
      "keywords": 5,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "legumbre": [
    {
      "id": 24805,
      "keyword": "legumbre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "legumbres": [
    {
      "id": 24805,
      "keyword": "legumbre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24805,
      "keyword": "legumbres",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trasladarse": [
    {
      "id": 24819,
      "keyword": "trasladarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "movement"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36473,
      "keyword": "trasladarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "education",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desplazarse": [
    {
      "id": 24819,
      "keyword": "desplazarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "movement"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "electricidad": [
    {
      "id": 24798,
      "keyword": "electricidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39134,
      "keyword": "electricidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pollo frito": [
    {
      "id": 24817,
      "keyword": "pollo frito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pollos fritos": [
    {
      "id": 24817,
      "keyword": "pollo frito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acueducto": [
    {
      "id": 24826,
      "keyword": "acueducto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acueductos": [
    {
      "id": 24826,
      "keyword": "acueducto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "terapia ocupacional": [
    {
      "id": 24821,
      "keyword": "terapia ocupacional",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "occupational therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrir": [
    {
      "id": 24825,
      "keyword": "abrir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adherir": [
    {
      "id": 24828,
      "keyword": "adherir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alborotar": [
    {
      "id": 24833,
      "keyword": "alborotar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24832,
      "keyword": "alborotar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alboroto": [
    {
      "id": 24833,
      "keyword": "alboroto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24832,
      "keyword": "alboroto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alborotos": [
    {
      "id": 24833,
      "keyword": "alboroto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24832,
      "keyword": "alboroto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alfombrilla": [
    {
      "id": 24834,
      "keyword": "alfombrilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36612,
      "keyword": "alfombrilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39003,
      "keyword": "alfombrilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alfombrillas": [
    {
      "id": 24834,
      "keyword": "alfombrilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36612,
      "keyword": "alfombrilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39003,
      "keyword": "alfombrilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "afganistán": [
    {
      "id": 24831,
      "keyword": "Afganistán",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arabia saudí": [
    {
      "id": 24858,
      "keyword": "Arabia Saudí",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alzar": [
    {
      "id": 24836,
      "keyword": "alzar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aperitivo": [
    {
      "id": 30488,
      "keyword": "aperitivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30489,
      "keyword": "aperitivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24854,
      "keyword": "aperitivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aperitivos": [
    {
      "id": 30488,
      "keyword": "aperitivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30489,
      "keyword": "aperitivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24854,
      "keyword": "aperitivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "averío": [
    {
      "id": 24865,
      "keyword": "averío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "group",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24866,
      "keyword": "averío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "group",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "averíos": [
    {
      "id": 24865,
      "keyword": "averío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "group",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24866,
      "keyword": "averío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "group",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atención": [
    {
      "id": 24863,
      "keyword": "atención",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "adivinanza": [
    {
      "id": 24829,
      "keyword": "adivinanza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adivinanzas": [
    {
      "id": 24829,
      "keyword": "adivinanza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acertijo": [
    {
      "id": 24829,
      "keyword": "acertijo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acertijos": [
    {
      "id": 24829,
      "keyword": "acertijo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "portal de belén": [
    {
      "id": 24873,
      "keyword": "Portal de Belén",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "place",
        "christianity",
        "event",
        "popular event",
        "christmas",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "borracho": [
    {
      "id": 24895,
      "keyword": "borracho",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "borrachos": [
    {
      "id": 24895,
      "keyword": "borracho",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "emborrachar": [
    {
      "id": 24896,
      "keyword": "emborrachar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24930,
      "keyword": "emborrachar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nadar a braza": [
    {
      "id": 24903,
      "keyword": "nadar a braza",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "braza": [
    {
      "id": 24903,
      "keyword": "braza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brazas": [
    {
      "id": 24903,
      "keyword": "braza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "blusón": [
    {
      "id": 24881,
      "keyword": "blusón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "blusones": [
    {
      "id": 24881,
      "keyword": "blusón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "borrachera": [
    {
      "id": 24929,
      "keyword": "borrachera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26053,
      "keyword": "borrachera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "borracheras": [
    {
      "id": 24929,
      "keyword": "borrachera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26053,
      "keyword": "borrachera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "capitolio": [
    {
      "id": 24941,
      "keyword": "Capitolio",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24941,
      "keyword": "capitolio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "capitolios": [
    {
      "id": 24941,
      "keyword": "capitolio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bola de nieve": [
    {
      "id": 24891,
      "keyword": "bola de nieve",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "bolas de nieve": [
    {
      "id": 24891,
      "keyword": "bola de nieve",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "casal": [
    {
      "id": 24947,
      "keyword": "casal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casales": [
    {
      "id": 24947,
      "keyword": "casal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casa de labranza": [
    {
      "id": 24947,
      "keyword": "casa de labranza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casas de labranza": [
    {
      "id": 24947,
      "keyword": "casa de labranza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "capitán": [
    {
      "id": 24937,
      "keyword": "capitán",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39107,
      "keyword": "capitán",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "capitanes": [
    {
      "id": 24937,
      "keyword": "capitán",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39107,
      "keyword": "capitán",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "capitán de navío": [
    {
      "id": 24937,
      "keyword": "capitán de navío",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "capitanes de navío": [
    {
      "id": 24937,
      "keyword": "capitán de navío",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cedazo": [
    {
      "id": 24956,
      "keyword": "cedazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24955,
      "keyword": "cedazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cedazos": [
    {
      "id": 24956,
      "keyword": "cedazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24955,
      "keyword": "cedazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "criba": [
    {
      "id": 24956,
      "keyword": "criba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 24955,
      "keyword": "criba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cribas": [
    {
      "id": 24956,
      "keyword": "criba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 24955,
      "keyword": "criba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cabina electoral accesible": [
    {
      "id": 24917,
      "keyword": "cabina electoral accesible",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cabinas electorales accesibles": [
    {
      "id": 24917,
      "keyword": "cabina electoral accesible",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "butrón": [
    {
      "id": 24909,
      "keyword": "butrón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alicatado": [
    {
      "id": 24968,
      "keyword": "alicatado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alicatados": [
    {
      "id": 24968,
      "keyword": "alicatado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "azulejo": [
    {
      "id": 24968,
      "keyword": "azulejo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "azulejos": [
    {
      "id": 24968,
      "keyword": "azulejo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "césar augusto": [
    {
      "id": 24978,
      "keyword": "César Augusto",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "character",
        "historical character",
        "history",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chistorra": [
    {
      "id": 24980,
      "keyword": "chistorra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chistorras": [
    {
      "id": 24980,
      "keyword": "chistorra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ciclo": [
    {
      "id": 24984,
      "keyword": "ciclo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciclos": [
    {
      "id": 24984,
      "keyword": "ciclo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal physiology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fases": [
    {
      "id": 24984,
      "keyword": "fases",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciempiés": [
    {
      "id": 24986,
      "keyword": "ciempiés",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "continuar": [
    {
      "id": 24998,
      "keyword": "continuar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "confeti": [
    {
      "id": 24990,
      "keyword": "confeti",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "confetis": [
    {
      "id": 24990,
      "keyword": "confeti",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "constelación": [
    {
      "id": 24994,
      "keyword": "constelación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "constelaciones": [
    {
      "id": 24994,
      "keyword": "constelación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "compostaje": [
    {
      "id": 25004,
      "keyword": "compostaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compostajes": [
    {
      "id": 25004,
      "keyword": "compostaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "compost": [
    {
      "id": 25004,
      "keyword": "compost",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "composts": [
    {
      "id": 25004,
      "keyword": "compost",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "corea del sur": [
    {
      "id": 25015,
      "keyword": "Corea del Sur",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corea del norte": [
    {
      "id": 25014,
      "keyword": "Corea del Norte",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conjuntivitis": [
    {
      "id": 25010,
      "keyword": "conjuntivitis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conducto auditivo": [
    {
      "id": 25006,
      "keyword": "conducto auditivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conductos auditivos": [
    {
      "id": 25006,
      "keyword": "conducto auditivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "columpio adaptado": [
    {
      "id": 25000,
      "keyword": "columpio adaptado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "columpios adaptados": [
    {
      "id": 25000,
      "keyword": "columpio adaptado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cremà": [
    {
      "id": 25024,
      "keyword": "Cremà",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "criar": [
    {
      "id": 25026,
      "keyword": "criar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "natación": [
    {
      "id": 25038,
      "keyword": "natación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "swimming",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crol": [
    {
      "id": 25038,
      "keyword": "crol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "swimming",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "floja": [
    {
      "id": 25044,
      "keyword": "floja",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flojas": [
    {
      "id": 25044,
      "keyword": "floja",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cristo redentor": [
    {
      "id": 25036,
      "keyword": "Cristo Redentor",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "río de janeiro": [
    {
      "id": 25036,
      "keyword": "Río de Janeiro",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desastre": [
    {
      "id": 25052,
      "keyword": "desastre",
      "keywords": 3,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desastres": [
    {
      "id": 25052,
      "keyword": "desastre",
      "keywords": 3,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "derrumbe": [
    {
      "id": 25052,
      "keyword": "derrumbe",
      "keywords": 3,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "derrumbes": [
    {
      "id": 25052,
      "keyword": "derrumbe",
      "keywords": 3,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "derrumbamiento": [
    {
      "id": 25052,
      "keyword": "derrumbamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "derrumbamientos": [
    {
      "id": 25052,
      "keyword": "derrumbamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cristiana": [
    {
      "id": 25033,
      "keyword": "cristiana",
      "keywords": 3,
      "type": 4,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25028,
      "keyword": "cristiana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cristianas": [
    {
      "id": 25033,
      "keyword": "cristiana",
      "keywords": 3,
      "type": 4,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25028,
      "keyword": "cristiana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espacio": [
    {
      "id": 25074,
      "keyword": "espacio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espacios": [
    {
      "id": 32598,
      "keyword": "espacios",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25074,
      "keyword": "espacio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nadar a espalda": [
    {
      "id": 25075,
      "keyword": "nadar a espalda",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esperar en la parada": [
    {
      "id": 25078,
      "keyword": "esperar en la parada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36913,
      "keyword": "esperar en la parada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36917,
      "keyword": "esperar en la parada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38406,
      "keyword": "esperar en la parada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38408,
      "keyword": "esperar en la parada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38410,
      "keyword": "esperar en la parada",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25077,
      "keyword": "esperar en la parada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37194,
      "keyword": "esperar en la parada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36845,
      "keyword": "esperar en la parada",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esperar al autobús": [
    {
      "id": 25078,
      "keyword": "esperar al autobús",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36913,
      "keyword": "esperar al autobús",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36917,
      "keyword": "esperar al autobús",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38410,
      "keyword": "esperar al autobús",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25077,
      "keyword": "esperar al autobús",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37194,
      "keyword": "esperar al autobús",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36845,
      "keyword": "esperar al autobús",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "destrozar": [
    {
      "id": 25056,
      "keyword": "destrozar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estar sentada": [
    {
      "id": 25081,
      "keyword": "estar sentada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "human body",
        "position",
        "person",
        "routine",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equipos de tratamiento familiar": [
    {
      "id": 25064,
      "keyword": "Equipos de Tratamiento Familiar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "eructar": [
    {
      "id": 25069,
      "keyword": "eructar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36833,
      "keyword": "eructar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36834,
      "keyword": "eructar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25068,
      "keyword": "eructar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28249,
      "keyword": "eructar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "regoldar": [
    {
      "id": 25069,
      "keyword": "regoldar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25068,
      "keyword": "regoldar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28249,
      "keyword": "regoldar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "etiquetar": [
    {
      "id": 25087,
      "keyword": "etiquetar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27754,
      "keyword": "etiquetar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "falla": [
    {
      "id": 25091,
      "keyword": "falla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fallas": [
    {
      "id": 25091,
      "keyword": "falla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fallera": [
    {
      "id": 25095,
      "keyword": "fallera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "falleras": [
    {
      "id": 25095,
      "keyword": "fallera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estar sentado": [
    {
      "id": 25083,
      "keyword": "estar sentado",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "furniture",
        "person",
        "routine",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25082,
      "keyword": "estar sentado",
      "keywords": 2,
      "type": 3,
      "tags": [
        "human body",
        "position",
        "person",
        "routine",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "festival": [
    {
      "id": 25103,
      "keyword": "festival",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "festivales": [
    {
      "id": 25103,
      "keyword": "festival",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fallero": [
    {
      "id": 25099,
      "keyword": "fallero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "falleros": [
    {
      "id": 25099,
      "keyword": "fallero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "flauta travesera": [
    {
      "id": 25115,
      "keyword": "flauta travesera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flautas traveseras": [
    {
      "id": 25115,
      "keyword": "flauta travesera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "freír un filete": [
    {
      "id": 25119,
      "keyword": "freír un filete",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "freír carne": [
    {
      "id": 25119,
      "keyword": "freír carne",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "regordete": [
    {
      "id": 25133,
      "keyword": "regordete",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "regordetes": [
    {
      "id": 25133,
      "keyword": "regordete",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "regordeta": [
    {
      "id": 25133,
      "keyword": "regordeta",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "regordetas": [
    {
      "id": 25133,
      "keyword": "regordeta",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "health",
        "dietetics",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grafitero": [
    {
      "id": 25139,
      "keyword": "grafitero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grafiteros": [
    {
      "id": 25139,
      "keyword": "grafitero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grafiti": [
    {
      "id": 25143,
      "keyword": "grafiti",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "painting",
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grafitis": [
    {
      "id": 25143,
      "keyword": "grafiti",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "painting",
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grafito": [
    {
      "id": 25143,
      "keyword": "grafito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "painting",
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grafitos": [
    {
      "id": 25143,
      "keyword": "grafito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "painting",
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "horca": [
    {
      "id": 25159,
      "keyword": "horca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "horcas": [
    {
      "id": 25159,
      "keyword": "horca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huesecillos": [
    {
      "id": 25163,
      "keyword": "huesecillos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system",
        "auditory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hipnotizar": [
    {
      "id": 25157,
      "keyword": "hipnotizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "irak": [
    {
      "id": 25168,
      "keyword": "Irak",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "israel": [
    {
      "id": 25170,
      "keyword": "Israel",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "helada": [
    {
      "id": 34323,
      "keyword": "helada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25153,
      "keyword": "helada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "heladas": [
    {
      "id": 34323,
      "keyword": "helada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25153,
      "keyword": "helada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jacuzzi": [
    {
      "id": 25175,
      "keyword": "jacuzzi",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jacuzzis": [
    {
      "id": 25175,
      "keyword": "jacuzzi",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grillo": [
    {
      "id": 25147,
      "keyword": "grillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grillos": [
    {
      "id": 25147,
      "keyword": "grillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugar al ajedrez": [
    {
      "id": 25182,
      "keyword": "jugar al ajedrez",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "chess"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25181,
      "keyword": "jugar al ajedrez",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "chess"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35361,
      "keyword": "jugar al ajedrez",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "chess"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35428,
      "keyword": "jugar al ajedrez",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "chess"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "irán": [
    {
      "id": 25169,
      "keyword": "Irán",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gas": [
    {
      "id": 25129,
      "keyword": "gas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics",
        "chemistry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36321,
      "keyword": "gas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gases": [
    {
      "id": 25129,
      "keyword": "gas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics",
        "chemistry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36321,
      "keyword": "gas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "luciérnaga": [
    {
      "id": 25203,
      "keyword": "luciérnaga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "luciérnagas": [
    {
      "id": 25203,
      "keyword": "luciérnaga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "madrugar": [
    {
      "id": 28618,
      "keyword": "madrugar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25209,
      "keyword": "madrugar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28617,
      "keyword": "madrugar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "machu picchu": [
    {
      "id": 25207,
      "keyword": "Machu Picchu",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "melena": [
    {
      "id": 25233,
      "keyword": "melena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "melenas": [
    {
      "id": 25233,
      "keyword": "melena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lomo adobado": [
    {
      "id": 25199,
      "keyword": "lomo adobado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lomos adobados": [
    {
      "id": 25199,
      "keyword": "lomo adobado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mascletá": [
    {
      "id": 25231,
      "keyword": "mascletá",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mascletás": [
    {
      "id": 25231,
      "keyword": "mascletá",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "traca": [
    {
      "id": 25231,
      "keyword": "traca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tracas": [
    {
      "id": 25231,
      "keyword": "traca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "leche condensada": [
    {
      "id": 25185,
      "keyword": "leche condensada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leches condensadas": [
    {
      "id": 25185,
      "keyword": "leche condensada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bote de leche condensada": [
    {
      "id": 25185,
      "keyword": "bote de leche condensada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botes de leche condensada": [
    {
      "id": 25185,
      "keyword": "bote de leche condensada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "membrillo": [
    {
      "id": 25237,
      "keyword": "membrillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "membrillos": [
    {
      "id": 25237,
      "keyword": "membrillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "molinillo": [
    {
      "id": 25257,
      "keyword": "molinillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "molinillos": [
    {
      "id": 25257,
      "keyword": "molinillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "moco": [
    {
      "id": 25249,
      "keyword": "moco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mocos": [
    {
      "id": 25249,
      "keyword": "moco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cultivador": [
    {
      "id": 25265,
      "keyword": "cultivador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cultivadores": [
    {
      "id": 25265,
      "keyword": "cultivador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "motocultor": [
    {
      "id": 25265,
      "keyword": "motocultor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "motocultores": [
    {
      "id": 25265,
      "keyword": "motocultor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nueva zelanda": [
    {
      "id": 25273,
      "keyword": "Nueva Zelanda",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesa electoral": [
    {
      "id": 25242,
      "keyword": "mesa electoral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25241,
      "keyword": "mesa electoral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas electorales": [
    {
      "id": 25242,
      "keyword": "mesa electoral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25241,
      "keyword": "mesa electoral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manopla de baño": [
    {
      "id": 25227,
      "keyword": "manopla de baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manoplas de baño": [
    {
      "id": 25227,
      "keyword": "manopla de baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ordenar secuencia": [
    {
      "id": 25282,
      "keyword": "ordenar secuencia",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ovíparo": [
    {
      "id": 25284,
      "keyword": "ovíparo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "oviparous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ovíparos": [
    {
      "id": 25284,
      "keyword": "ovíparo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "oviparous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ovípara": [
    {
      "id": 25284,
      "keyword": "ovípara",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "oviparous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ovíparas": [
    {
      "id": 25284,
      "keyword": "ovípara",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "oviparous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pakistán": [
    {
      "id": 25288,
      "keyword": "Pakistán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38140,
      "keyword": "Pakistán",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paladar": [
    {
      "id": 25289,
      "keyword": "paladar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paladares": [
    {
      "id": 25289,
      "keyword": "paladar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "omoplato": [
    {
      "id": 25278,
      "keyword": "omoplato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "omoplatos": [
    {
      "id": 25278,
      "keyword": "omoplato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peligro": [
    {
      "id": 25315,
      "keyword": "peligro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peligros": [
    {
      "id": 25315,
      "keyword": "peligro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "petra": [
    {
      "id": 25319,
      "keyword": "Petra",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jordania": [
    {
      "id": 27857,
      "keyword": "Jordania",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25319,
      "keyword": "Jordania",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peca": [
    {
      "id": 25303,
      "keyword": "peca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features",
        "human physiology",
        "physiology",
        "integumentary system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pecas": [
    {
      "id": 25303,
      "keyword": "peca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features",
        "human physiology",
        "physiology",
        "integumentary system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pablo picasso": [
    {
      "id": 25325,
      "keyword": "Pablo Picasso",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "picasso": [
    {
      "id": 25325,
      "keyword": "Picasso",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25413,
      "keyword": "Picasso",
      "keywords": 3,
      "type": 1,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "picaporte": [
    {
      "id": 25321,
      "keyword": "picaporte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "picaportes": [
    {
      "id": 25321,
      "keyword": "picaporte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llamador": [
    {
      "id": 25321,
      "keyword": "llamador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llamadores": [
    {
      "id": 25321,
      "keyword": "llamador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aldaba": [
    {
      "id": 25321,
      "keyword": "aldaba",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aldabas": [
    {
      "id": 25321,
      "keyword": "aldaba",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pegajoso": [
    {
      "id": 25307,
      "keyword": "pegajoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pegajosos": [
    {
      "id": 25307,
      "keyword": "pegajoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pegajosa": [
    {
      "id": 25307,
      "keyword": "pegajosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pegajosas": [
    {
      "id": 25307,
      "keyword": "pegajosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peine para caballos": [
    {
      "id": 25311,
      "keyword": "peine para caballos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peines para caballos": [
    {
      "id": 25311,
      "keyword": "peine para caballos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "posar": [
    {
      "id": 25349,
      "keyword": "posar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25347,
      "keyword": "posar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25348,
      "keyword": "posar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pimienta": [
    {
      "id": 25331,
      "keyword": "pimienta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "spices"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pimientas": [
    {
      "id": 25331,
      "keyword": "pimienta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "spices"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "posarse": [
    {
      "id": 25353,
      "keyword": "posarse",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "animal physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "queimada": [
    {
      "id": 25359,
      "keyword": "queimada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "queimadas": [
    {
      "id": 25359,
      "keyword": "queimada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "porción de queso": [
    {
      "id": 25363,
      "keyword": "porción de queso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29144,
      "keyword": "porción de queso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porciones de queso": [
    {
      "id": 25363,
      "keyword": "porción de queso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29144,
      "keyword": "porción de queso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "puerta de palmas": [
    {
      "id": 25357,
      "keyword": "Puerta de Palmas",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cepo": [
    {
      "id": 25373,
      "keyword": "cepo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25506,
      "keyword": "cepo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cepos": [
    {
      "id": 25373,
      "keyword": "cepo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25506,
      "keyword": "cepo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ratón adaptado": [
    {
      "id": 25369,
      "keyword": "ratón adaptado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ratones adaptados": [
    {
      "id": 25369,
      "keyword": "ratón adaptado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "renacuajo": [
    {
      "id": 25389,
      "keyword": "renacuajo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "amphibian",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "renacuajos": [
    {
      "id": 25389,
      "keyword": "renacuajo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "amphibian",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rasqueta": [
    {
      "id": 25365,
      "keyword": "rasqueta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rasquetas": [
    {
      "id": 25365,
      "keyword": "rasqueta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almohaza": [
    {
      "id": 25365,
      "keyword": "almohaza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almohazas": [
    {
      "id": 25365,
      "keyword": "almohaza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rubí": [
    {
      "id": 25397,
      "keyword": "rubí",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material",
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rubís": [
    {
      "id": 25397,
      "keyword": "rubí",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material",
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sacar de la sartén ": [
    {
      "id": 25405,
      "keyword": "sacar de la sartén ",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "retirar de la sartén": [
    {
      "id": 25405,
      "keyword": "retirar de la sartén",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "remolque": [
    {
      "id": 26372,
      "keyword": "remolque",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28035,
      "keyword": "remolque",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28499,
      "keyword": "remolque",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25385,
      "keyword": "remolque",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "remolques": [
    {
      "id": 26372,
      "keyword": "remolque",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28035,
      "keyword": "remolque",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28499,
      "keyword": "remolque",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25385,
      "keyword": "remolque",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "remolque para caballos": [
    {
      "id": 25385,
      "keyword": "remolque para caballos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "remolques para caballos": [
    {
      "id": 25385,
      "keyword": "remolque para caballos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "roer": [
    {
      "id": 25394,
      "keyword": "roer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25393,
      "keyword": "roer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26398,
      "keyword": "roer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "animal",
        "animal physiology",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alcazaba": [
    {
      "id": 38651,
      "keyword": "alcazaba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25411,
      "keyword": "alcazaba",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alcazabas": [
    {
      "id": 38651,
      "keyword": "alcazaba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25411,
      "keyword": "alcazaba",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alcazaba de málaga": [
    {
      "id": 25411,
      "keyword": "Alcazaba de Málaga",
      "keywords": 3,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubismo": [
    {
      "id": 25413,
      "keyword": "cubismo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacarina": [
    {
      "id": 25401,
      "keyword": "sacarina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacarinas": [
    {
      "id": 25401,
      "keyword": "sacarina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carruaje": [
    {
      "id": 25420,
      "keyword": "carruaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25419,
      "keyword": "carruaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carruajes": [
    {
      "id": 25420,
      "keyword": "carruaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25419,
      "keyword": "carruaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coche de caballos": [
    {
      "id": 25420,
      "keyword": "coche de caballos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25419,
      "keyword": "coche de caballos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coches de caballos": [
    {
      "id": 25420,
      "keyword": "coche de caballos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25419,
      "keyword": "coche de caballos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sauna": [
    {
      "id": 25429,
      "keyword": "sauna",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25433,
      "keyword": "sauna",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saunas": [
    {
      "id": 25429,
      "keyword": "sauna",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25433,
      "keyword": "sauna",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sauna húmeda": [
    {
      "id": 25429,
      "keyword": "sauna húmeda",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saunas húmedas": [
    {
      "id": 25429,
      "keyword": "sauna húmeda",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "baño turco": [
    {
      "id": 25429,
      "keyword": "baño turco",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baños turcos": [
    {
      "id": 25429,
      "keyword": "baño turco",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sentidos": [
    {
      "id": 30196,
      "keyword": "sentidos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25445,
      "keyword": "sentidos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30194,
      "keyword": "sentidos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30198,
      "keyword": "sentidos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30197,
      "keyword": "sentidos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30195,
      "keyword": "sentidos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "silla adaptada": [
    {
      "id": 25455,
      "keyword": "silla adaptada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas adaptadas": [
    {
      "id": 25455,
      "keyword": "silla adaptada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sauna seca": [
    {
      "id": 25433,
      "keyword": "sauna seca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saunas secas": [
    {
      "id": 25433,
      "keyword": "sauna seca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sauna finlandesa": [
    {
      "id": 25433,
      "keyword": "sauna finlandesa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saunas finlandesas": [
    {
      "id": 25433,
      "keyword": "sauna finlandesa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silla de montar": [
    {
      "id": 25459,
      "keyword": "silla de montar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25460,
      "keyword": "silla de montar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas de montar": [
    {
      "id": 25459,
      "keyword": "silla de montar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25460,
      "keyword": "silla de montar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tailandia": [
    {
      "id": 25483,
      "keyword": "Tailandia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taj mahal": [
    {
      "id": 25484,
      "keyword": "Taj Mahal",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tallarines": [
    {
      "id": 25486,
      "keyword": "tallarines",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarta de cumpleaños": [
    {
      "id": 25488,
      "keyword": "tarta de cumpleaños",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tartas de cumpleaños": [
    {
      "id": 25488,
      "keyword": "tarta de cumpleaños",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "teatro romano de mérida": [
    {
      "id": 25494,
      "keyword": "Teatro romano de Mérida",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mérida": [
    {
      "id": 25494,
      "keyword": "Mérida",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trampa": [
    {
      "id": 25507,
      "keyword": "trampa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25506,
      "keyword": "trampa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31414,
      "keyword": "trampa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior",
        "communication",
        "language",
        "verb",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trampas": [
    {
      "id": 25507,
      "keyword": "trampa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25506,
      "keyword": "trampa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31414,
      "keyword": "trampa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior",
        "communication",
        "language",
        "verb",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tantos": [
    {
      "id": 25492,
      "keyword": "tantos",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "tele": [
    {
      "id": 25498,
      "keyword": "tele",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media",
        "mass media device",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teles": [
    {
      "id": 25498,
      "keyword": "tele",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media",
        "mass media device",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "televisión": [
    {
      "id": 25498,
      "keyword": "televisión",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media",
        "mass media device",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "televisiones": [
    {
      "id": 25498,
      "keyword": "televisión",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media",
        "mass media device",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pantalla lcd": [
    {
      "id": 25498,
      "keyword": "pantalla LCD",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media",
        "mass media device",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pantallas lcd": [
    {
      "id": 25498,
      "keyword": "pantalla LCD",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media",
        "mass media device",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "televisor": [
    {
      "id": 25498,
      "keyword": "televisor",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media",
        "mass media device",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "televisores": [
    {
      "id": 25498,
      "keyword": "televisor",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "communication",
        "mass media",
        "mass media device",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vértebras": [
    {
      "id": 25522,
      "keyword": "vértebras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tenia": [
    {
      "id": 25502,
      "keyword": "tenia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tenias": [
    {
      "id": 25502,
      "keyword": "tenia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palacio de congresos": [
    {
      "id": 25542,
      "keyword": "palacio de congresos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25545,
      "keyword": "palacio de congresos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "public administration",
        "monument",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palacios de congresos": [
    {
      "id": 25542,
      "keyword": "palacio de congresos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25545,
      "keyword": "palacio de congresos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "public administration",
        "monument",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palacio de ferias y congresos de málaga": [
    {
      "id": 25544,
      "keyword": "Palacio de Ferias y Congresos de Málaga",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "building",
        "culture",
        "public administration",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ubre": [
    {
      "id": 25518,
      "keyword": "ubre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ubres": [
    {
      "id": 25518,
      "keyword": "ubre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dar la vuelta": [
    {
      "id": 25532,
      "keyword": "dar la vuelta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palacio de congresos de zaragoza": [
    {
      "id": 25545,
      "keyword": "Palacio de Congresos de Zaragoza",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "building",
        "culture",
        "public administration",
        "monument",
        "Aragon",
        "Saragossa"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "azúcar": [
    {
      "id": 25560,
      "keyword": "azúcar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "azúcares": [
    {
      "id": 25560,
      "keyword": "azúcar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "voluntaria": [
    {
      "id": 25534,
      "keyword": "voluntaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36283,
      "keyword": "voluntaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "voluntarias": [
    {
      "id": 25534,
      "keyword": "voluntaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36283,
      "keyword": "voluntaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "catedral de málaga": [
    {
      "id": 25550,
      "keyword": "Catedral de Málaga",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "building",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paquete de café": [
    {
      "id": 25564,
      "keyword": "paquete de café",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paquetes de café": [
    {
      "id": 25564,
      "keyword": "paquete de café",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sal": [
    {
      "id": 25576,
      "keyword": "sal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "mineral rich food",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sales": [
    {
      "id": 25576,
      "keyword": "sal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "mineral rich food",
        "cookery",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paquete de espaguetis": [
    {
      "id": 25580,
      "keyword": "paquete de espaguetis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paquetes de espaguetis": [
    {
      "id": 25580,
      "keyword": "paquete de espaguetis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paquete de galletas": [
    {
      "id": 25568,
      "keyword": "paquete de galletas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paquetes de galletas": [
    {
      "id": 25568,
      "keyword": "paquete de galletas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paquete de macarrones": [
    {
      "id": 25572,
      "keyword": "paquete de macarrones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paquetes de macarrones": [
    {
      "id": 25572,
      "keyword": "paquete de macarrones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grúa hospitalaria": [
    {
      "id": 25590,
      "keyword": "grúa hospitalaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grúas hospitalarias": [
    {
      "id": 25590,
      "keyword": "grúa hospitalaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pederse": [
    {
      "id": 25603,
      "keyword": "pederse",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ventosear": [
    {
      "id": 25603,
      "keyword": "ventosear",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peder": [
    {
      "id": 25603,
      "keyword": "peder",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torta de maíz": [
    {
      "id": 25606,
      "keyword": "torta de maíz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28145,
      "keyword": "torta de maíz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortas de maíz": [
    {
      "id": 25606,
      "keyword": "torta de maíz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28145,
      "keyword": "torta de maíz",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "torta de choclo": [
    {
      "id": 25606,
      "keyword": "torta de choclo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28145,
      "keyword": "torta de choclo",
      "keywords": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortas de choclo": [
    {
      "id": 25606,
      "keyword": "torta de choclo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vivíparo": [
    {
      "id": 25528,
      "keyword": "vivíparo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "viviparous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vivíparos": [
    {
      "id": 25528,
      "keyword": "vivíparo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "viviparous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vivípara": [
    {
      "id": 25528,
      "keyword": "vivípara",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "viviparous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vivíparas": [
    {
      "id": 25528,
      "keyword": "vivípara",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "viviparous",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "voluntario": [
    {
      "id": 35153,
      "keyword": "voluntario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36280,
      "keyword": "voluntario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25536,
      "keyword": "voluntario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36279,
      "keyword": "voluntario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "voluntarios": [
    {
      "id": 35153,
      "keyword": "voluntario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36280,
      "keyword": "voluntario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25536,
      "keyword": "voluntario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36279,
      "keyword": "voluntario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zapato de goma": [
    {
      "id": 25610,
      "keyword": "zapato de goma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zapatos de goma": [
    {
      "id": 25610,
      "keyword": "zapato de goma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cenachero": [
    {
      "id": 25588,
      "keyword": "cenachero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cenacheros": [
    {
      "id": 25588,
      "keyword": "cenachero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "motobomba": [
    {
      "id": 25594,
      "keyword": "motobomba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "motobombas": [
    {
      "id": 25594,
      "keyword": "motobomba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "work machine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cd rom": [
    {
      "id": 25614,
      "keyword": "CD Rom",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cd roms": [
    {
      "id": 25614,
      "keyword": "CD Rom",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cederrón": [
    {
      "id": 25614,
      "keyword": "cederrón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cederrones": [
    {
      "id": 25614,
      "keyword": "cederrón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pedo": [
    {
      "id": 25602,
      "keyword": "pedo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29666,
      "keyword": "pedo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pedos": [
    {
      "id": 25602,
      "keyword": "pedo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29666,
      "keyword": "pedo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ternera": [
    {
      "id": 25630,
      "keyword": "ternera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26489,
      "keyword": "ternera",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34080,
      "keyword": "ternera",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terneras": [
    {
      "id": 25630,
      "keyword": "ternera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26489,
      "keyword": "ternera",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34080,
      "keyword": "ternera",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fuerza": [
    {
      "id": 25638,
      "keyword": "fuerza",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "fuerzas": [
    {
      "id": 25638,
      "keyword": "fuerza",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "ganado": [
    {
      "id": 25640,
      "keyword": "ganado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ganados": [
    {
      "id": 25640,
      "keyword": "ganado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "geriatría": [
    {
      "id": 25642,
      "keyword": "geriatría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "geriatrías": [
    {
      "id": 25642,
      "keyword": "geriatría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inmigrante": [
    {
      "id": 25644,
      "keyword": "inmigrante",
      "keywords": 5,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25644,
      "keyword": "inmigrante",
      "keywords": 5,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25645,
      "keyword": "inmigrante",
      "keywords": 5,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25645,
      "keyword": "inmigrante",
      "keywords": 5,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "inmigrantes": [
    {
      "id": 25644,
      "keyword": "inmigrante",
      "keywords": 5,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25644,
      "keyword": "inmigrante",
      "keywords": 5,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25645,
      "keyword": "inmigrante",
      "keywords": 5,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25645,
      "keyword": "inmigrante",
      "keywords": 5,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "emigrar": [
    {
      "id": 25644,
      "keyword": "emigrar",
      "keywords": 5,
      "type": 3,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25645,
      "keyword": "emigrar",
      "keywords": 5,
      "type": 3,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "emigrante": [
    {
      "id": 25644,
      "keyword": "emigrante",
      "keywords": 5,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25644,
      "keyword": "emigrante",
      "keywords": 5,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25645,
      "keyword": "emigrante",
      "keywords": 5,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25645,
      "keyword": "emigrante",
      "keywords": 5,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "emigrantes": [
    {
      "id": 25644,
      "keyword": "emigrante",
      "keywords": 5,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25644,
      "keyword": "emigrante",
      "keywords": 5,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25645,
      "keyword": "emigrante",
      "keywords": 5,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25645,
      "keyword": "emigrante",
      "keywords": 5,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "lechal": [
    {
      "id": 25626,
      "keyword": "lechal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lechales": [
    {
      "id": 25626,
      "keyword": "lechal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "complementos": [
    {
      "id": 25634,
      "keyword": "complementos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27325,
      "keyword": "complementos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29072,
      "keyword": "complementos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máquina": [
    {
      "id": 25652,
      "keyword": "máquina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máquinas": [
    {
      "id": 25652,
      "keyword": "máquina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25652,
      "keyword": "máquinas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mascotas": [
    {
      "id": 25654,
      "keyword": "mascotas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "pet",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25654,
      "keyword": "mascota",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "pet",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mascota": [
    {
      "id": 25654,
      "keyword": "mascota",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "pet",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "movimiento": [
    {
      "id": 25656,
      "keyword": "movimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "movimientos": [
    {
      "id": 25656,
      "keyword": "movimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuidado": [
    {
      "id": 25618,
      "keyword": "cuidado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25618,
      "keyword": "cuidado",
      "keywords": 3,
      "type": 5,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuidados": [
    {
      "id": 25618,
      "keyword": "cuidado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¡cuidado!": [
    {
      "id": 25618,
      "keyword": "¡cuidado!",
      "keywords": 3,
      "type": 5,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sala de estudio": [
    {
      "id": 25682,
      "keyword": "sala de estudio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de estudio": [
    {
      "id": 25682,
      "keyword": "sala de estudio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de lectura": [
    {
      "id": 25684,
      "keyword": "sala de lectura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de lectura": [
    {
      "id": 25684,
      "keyword": "sala de lectura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nuboso": [
    {
      "id": 25636,
      "keyword": "nuboso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34061,
      "keyword": "nuboso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nubosos": [
    {
      "id": 25636,
      "keyword": "nuboso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34061,
      "keyword": "nuboso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nubosa": [
    {
      "id": 25636,
      "keyword": "nubosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34061,
      "keyword": "nubosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nubosas": [
    {
      "id": 25636,
      "keyword": "nubosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34061,
      "keyword": "nubosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de estudio y lectura": [
    {
      "id": 25686,
      "keyword": "sala de estudio y lectura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de estudio y lectura": [
    {
      "id": 25686,
      "keyword": "sala de estudio y lectura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "batidora adaptada": [
    {
      "id": 25688,
      "keyword": "batidora adaptada",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "batidoras adaptadasd": [
    {
      "id": 25688,
      "keyword": "batidora adaptada",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro de día": [
    {
      "id": 25693,
      "keyword": "centro de día",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "personal services",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25692,
      "keyword": "centro de día",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros de día": [
    {
      "id": 25693,
      "keyword": "centro de día",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "personal services",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25692,
      "keyword": "centro de día",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "civivox": [
    {
      "id": 25693,
      "keyword": "CIVIVOX",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "personal services",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "consentimiento informado": [
    {
      "id": 25698,
      "keyword": "consentimiento informado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "consentimientos informados": [
    {
      "id": 25698,
      "keyword": "consentimiento informado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fiambre de pavo": [
    {
      "id": 25700,
      "keyword": "fiambre de pavo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fiambres de pavo": [
    {
      "id": 25700,
      "keyword": "fiambre de pavo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "intimidad": [
    {
      "id": 39147,
      "keyword": "intimidad",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25702,
      "keyword": "intimidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intimidades": [
    {
      "id": 25702,
      "keyword": "intimidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mañanas": [
    {
      "id": 25704,
      "keyword": "mañana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "core vocabulary",
        "communication",
        "language",
        "adverb",
        "adverb of time"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "temprano": [
    {
      "id": 25704,
      "keyword": "temprano",
      "keywords": 2,
      "type": 4,
      "tags": [
        "time",
        "calendar",
        "core vocabulary",
        "communication",
        "language",
        "adverb",
        "adverb of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "media pensión": [
    {
      "id": 25706,
      "keyword": "media pensión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medias pensiones": [
    {
      "id": 25706,
      "keyword": "media pensión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "muy": [
    {
      "id": 25708,
      "keyword": "muy",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of manner"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "neuropsicóloga": [
    {
      "id": 25710,
      "keyword": "neuropsicóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "neuropsicólogas": [
    {
      "id": 25710,
      "keyword": "neuropsicóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "neuropsicólogo": [
    {
      "id": 25713,
      "keyword": "neuropsicólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "neuropsicólogos": [
    {
      "id": 25713,
      "keyword": "neuropsicólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prohibido curiosear": [
    {
      "id": 25714,
      "keyword": "prohibido curiosear",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibido mirar": [
    {
      "id": 25716,
      "keyword": "prohibido mirar",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diagnosticar": [
    {
      "id": 25678,
      "keyword": "diagnosticar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "symptom",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ropa interior": [
    {
      "id": 25680,
      "keyword": "ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibido molestar": [
    {
      "id": 25718,
      "keyword": "prohibido molestar",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "proyecto de vida": [
    {
      "id": 25720,
      "keyword": "proyecto de vida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25721,
      "keyword": "proyecto de vida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "proyectos de vida": [
    {
      "id": 25720,
      "keyword": "proyecto de vida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25721,
      "keyword": "proyecto de vida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "consentimiento": [
    {
      "id": 25696,
      "keyword": "consentimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "consentimientos": [
    {
      "id": 25696,
      "keyword": "consentimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ya": [
    {
      "id": 25736,
      "keyword": "ya",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "remover con varilla batidora": [
    {
      "id": 25738,
      "keyword": "remover con varilla batidora",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tirar con manga pastelera": [
    {
      "id": 25740,
      "keyword": "tirar con manga pastelera",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sobre de gelatina": [
    {
      "id": 25742,
      "keyword": "sobre de gelatina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sobres de gelatina": [
    {
      "id": 25742,
      "keyword": "sobre de gelatina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manga": [
    {
      "id": 25746,
      "keyword": "manga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mangas": [
    {
      "id": 25746,
      "keyword": "manga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "araword": [
    {
      "id": 25748,
      "keyword": "AraWord",
      "keywords": 1,
      "type": 1,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid",
        "computing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25749,
      "keyword": "AraWord",
      "keywords": 1,
      "type": 1,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid",
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡acertaste!": [
    {
      "id": 25752,
      "keyword": "¡Acertaste!",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25757,
      "keyword": "¡Acertaste!",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37609,
      "keyword": "¡Acertaste!",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asumir": [
    {
      "id": 25752,
      "keyword": "asumir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "expression",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25757,
      "keyword": "asumir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "expression",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37609,
      "keyword": "asumir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "expression",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acequia": [
    {
      "id": 25758,
      "keyword": "acequia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acequias": [
    {
      "id": 25758,
      "keyword": "acequia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acompañar": [
    {
      "id": 25762,
      "keyword": "acompañar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37485,
      "keyword": "acompañar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27568,
      "keyword": "acompañar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28187,
      "keyword": "acompañar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adosado": [
    {
      "id": 25764,
      "keyword": "adosado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adosados": [
    {
      "id": 25764,
      "keyword": "adosado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aerogenerador": [
    {
      "id": 25768,
      "keyword": "aerogenerador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aerogeneradores": [
    {
      "id": 25768,
      "keyword": "aerogenerador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "residencia": [
    {
      "id": 25729,
      "keyword": "residencia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25728,
      "keyword": "residencia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "residencias": [
    {
      "id": 25729,
      "keyword": "residencia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25728,
      "keyword": "residencia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "internado": [
    {
      "id": 25729,
      "keyword": "internado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25728,
      "keyword": "internado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "internados": [
    {
      "id": 25729,
      "keyword": "internado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "communication",
        "signaling system",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25728,
      "keyword": "internado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aislar": [
    {
      "id": 25776,
      "keyword": "aislar",
      "keywords": 10,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aislamiento": [
    {
      "id": 31742,
      "keyword": "aislamiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25776,
      "keyword": "aislamiento",
      "keywords": 10,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aislamientos": [
    {
      "id": 31742,
      "keyword": "aislamiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 25776,
      "keyword": "aislamiento",
      "keywords": 10,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aislado": [
    {
      "id": 25776,
      "keyword": "aislado",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aislados": [
    {
      "id": 25776,
      "keyword": "aislado",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aislada": [
    {
      "id": 25776,
      "keyword": "aislada",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aisladas": [
    {
      "id": 25776,
      "keyword": "aislada",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "solitaria": [
    {
      "id": 25776,
      "keyword": "solitaria",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "solitarias": [
    {
      "id": 25776,
      "keyword": "solitaria",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "separado": [
    {
      "id": 25776,
      "keyword": "separado",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "separados": [
    {
      "id": 25776,
      "keyword": "separado",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "separada": [
    {
      "id": 25776,
      "keyword": "separada",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "separadas": [
    {
      "id": 25776,
      "keyword": "separada",
      "keywords": 10,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alpargatas": [
    {
      "id": 25778,
      "keyword": "alpargatas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36487,
      "keyword": "alpargata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anciano": [
    {
      "id": 25796,
      "keyword": "anciano",
      "keywords": 2,
      "type": 4,
      "tags": [
        "person",
        "elderly",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34894,
      "keyword": "anciano",
      "keywords": 3,
      "type": 4,
      "tags": [
        "person",
        "elderly"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36217,
      "keyword": "anciano",
      "keywords": 1,
      "type": 4,
      "tags": [
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ancianos": [
    {
      "id": 25796,
      "keyword": "anciano",
      "keywords": 2,
      "type": 4,
      "tags": [
        "person",
        "elderly",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34894,
      "keyword": "anciano",
      "keywords": 3,
      "type": 4,
      "tags": [
        "person",
        "elderly"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36217,
      "keyword": "anciano",
      "keywords": 1,
      "type": 4,
      "tags": [
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anorak": [
    {
      "id": 25804,
      "keyword": "anorak",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anoraks": [
    {
      "id": 25804,
      "keyword": "anorak",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arado": [
    {
      "id": 25808,
      "keyword": "arado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arados": [
    {
      "id": 25808,
      "keyword": "arado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "work machine",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arar": [
    {
      "id": 25812,
      "keyword": "arar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26154,
      "keyword": "arar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ático": [
    {
      "id": 25819,
      "keyword": "ático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "áticos": [
    {
      "id": 25819,
      "keyword": "ático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vergüenza": [
    {
      "id": 25823,
      "keyword": "vergüenza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vergüenzas": [
    {
      "id": 25823,
      "keyword": "vergüenza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jardín botánico": [
    {
      "id": 25650,
      "keyword": "jardín botánico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jardines botánicos": [
    {
      "id": 25650,
      "keyword": "jardín botánico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "babosa": [
    {
      "id": 25827,
      "keyword": "babosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "mollusc",
        "terrestrial animal",
        "oviparous"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "babosas": [
    {
      "id": 25827,
      "keyword": "babosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "mollusc",
        "terrestrial animal",
        "oviparous"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "baca": [
    {
      "id": 25831,
      "keyword": "baca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bacas": [
    {
      "id": 25831,
      "keyword": "baca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "portaequipajes": [
    {
      "id": 34617,
      "keyword": "portaequipajes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "air transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25831,
      "keyword": "portaequipajes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bacalao": [
    {
      "id": 25835,
      "keyword": "bacalao",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bacalaos": [
    {
      "id": 25835,
      "keyword": "bacalao",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "boj": [
    {
      "id": 25853,
      "keyword": "boj",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "bush"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bojs": [
    {
      "id": 25853,
      "keyword": "boj",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "bush"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barrio": [
    {
      "id": 25849,
      "keyword": "barrio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barrios": [
    {
      "id": 25849,
      "keyword": "barrio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "boquerones": [
    {
      "id": 25861,
      "keyword": "boquerones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28958,
      "keyword": "boquerones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "borracha": [
    {
      "id": 25863,
      "keyword": "borracha",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "borrachas": [
    {
      "id": 25863,
      "keyword": "borracha",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs",
        "alcohol"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "butifarra": [
    {
      "id": 25883,
      "keyword": "butifarra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "butifarras": [
    {
      "id": 25883,
      "keyword": "butifarra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calcio": [
    {
      "id": 25898,
      "keyword": "calcio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "chemistry",
        "health",
        "medicine",
        "medicament",
        "human body",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brujo": [
    {
      "id": 25875,
      "keyword": "brujo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature",
        "event",
        "popular event",
        "halloween",
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brujos": [
    {
      "id": 25875,
      "keyword": "brujo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature",
        "event",
        "popular event",
        "halloween",
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bosque talado": [
    {
      "id": 25869,
      "keyword": "bosque talado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "forestry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bosques talados": [
    {
      "id": 25869,
      "keyword": "bosque talado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "forestry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "canal": [
    {
      "id": 25920,
      "keyword": "canal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canales": [
    {
      "id": 25920,
      "keyword": "canal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cavernícola": [
    {
      "id": 25928,
      "keyword": "cavernícola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34258,
      "keyword": "cavernícola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34259,
      "keyword": "cavernícola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cavernícolas": [
    {
      "id": 25928,
      "keyword": "cavernícola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34258,
      "keyword": "cavernícola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34259,
      "keyword": "cavernícola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camiseta de manga larga": [
    {
      "id": 25908,
      "keyword": "camiseta de manga larga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camisetas de manga larga": [
    {
      "id": 25908,
      "keyword": "camiseta de manga larga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "charco": [
    {
      "id": 25936,
      "keyword": "charco",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "charcos": [
    {
      "id": 25936,
      "keyword": "charco",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "saltar al agua": [
    {
      "id": 25932,
      "keyword": "saltar al agua",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26425,
      "keyword": "saltar al agua",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tableta": [
    {
      "id": 25940,
      "keyword": "tableta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28099,
      "keyword": "tableta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tabletas": [
    {
      "id": 25940,
      "keyword": "tableta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28099,
      "keyword": "tableta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tableta de chocolate": [
    {
      "id": 25940,
      "keyword": "tableta de chocolate",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tabletas de chocolate": [
    {
      "id": 25940,
      "keyword": "tableta de chocolate",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chupinazo": [
    {
      "id": 25944,
      "keyword": "chupinazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chupinazos": [
    {
      "id": 25944,
      "keyword": "chupinazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coche fúnebre": [
    {
      "id": 25962,
      "keyword": "coche fúnebre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coches fúnebres": [
    {
      "id": 25962,
      "keyword": "coche fúnebre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cacao": [
    {
      "id": 25891,
      "keyword": "cacao",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "vegetal origin material",
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38737,
      "keyword": "cacao",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cacaos": [
    {
      "id": 25891,
      "keyword": "cacao",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "vegetal origin material",
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38737,
      "keyword": "cacao",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cocinita": [
    {
      "id": 25966,
      "keyword": "cocinita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cocinitas": [
    {
      "id": 25966,
      "keyword": "cocinita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "circuito eléctrico": [
    {
      "id": 25954,
      "keyword": "circuito eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "circuitos eléctricos": [
    {
      "id": 25954,
      "keyword": "circuito eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "codorniz": [
    {
      "id": 25970,
      "keyword": "codorniz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "hunting",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "codornices": [
    {
      "id": 25970,
      "keyword": "codorniz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "hunting",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "control de entorno": [
    {
      "id": 25990,
      "keyword": "control de entorno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "controles de entorno": [
    {
      "id": 25990,
      "keyword": "control de entorno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "costurero": [
    {
      "id": 26004,
      "keyword": "costurero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "costureros": [
    {
      "id": 26004,
      "keyword": "costurero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "consolar": [
    {
      "id": 31209,
      "keyword": "consolar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 25986,
      "keyword": "consolar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cromos": [
    {
      "id": 26016,
      "keyword": "cromos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "hobby"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cronómetro": [
    {
      "id": 26018,
      "keyword": "cronómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "time",
        "chronological device",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cronómetros": [
    {
      "id": 26018,
      "keyword": "cronómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "time",
        "chronological device",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿cuál?": [
    {
      "id": 26022,
      "keyword": "¿cuál?",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "adverb",
        "adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuál": [
    {
      "id": 26022,
      "keyword": "cuál",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "adverb",
        "adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuáles": [
    {
      "id": 26022,
      "keyword": "cuál",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "adverb",
        "adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cubrir": [
    {
      "id": 26024,
      "keyword": "cubrir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crematorio": [
    {
      "id": 26008,
      "keyword": "crematorio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crematorios": [
    {
      "id": 26008,
      "keyword": "crematorio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "incinerar": [
    {
      "id": 26008,
      "keyword": "incinerar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soga": [
    {
      "id": 26026,
      "keyword": "soga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sogas": [
    {
      "id": 26026,
      "keyword": "soga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "egoísta": [
    {
      "id": 26037,
      "keyword": "egoísta",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26038,
      "keyword": "egoísta",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26039,
      "keyword": "egoísta",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "egoístas": [
    {
      "id": 26037,
      "keyword": "egoísta",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26038,
      "keyword": "egoísta",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26039,
      "keyword": "egoísta",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "crisálida": [
    {
      "id": 26012,
      "keyword": "crisálida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crisálidas": [
    {
      "id": 26012,
      "keyword": "crisálida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal physiology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "embalse": [
    {
      "id": 26049,
      "keyword": "embalse",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "embalses": [
    {
      "id": 26049,
      "keyword": "embalse",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pantano": [
    {
      "id": 26049,
      "keyword": "pantano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26290,
      "keyword": "pantano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "natural habitat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pantanos": [
    {
      "id": 26049,
      "keyword": "pantano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26290,
      "keyword": "pantano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "natural habitat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acaparador": [
    {
      "id": 26037,
      "keyword": "acaparador",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acaparadores": [
    {
      "id": 26037,
      "keyword": "acaparador",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acaparadora": [
    {
      "id": 26037,
      "keyword": "acaparadora",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acaparadoras": [
    {
      "id": 26037,
      "keyword": "acaparadora",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ávaro": [
    {
      "id": 26037,
      "keyword": "ávaro",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ávaros": [
    {
      "id": 26037,
      "keyword": "ávaro",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ávara": [
    {
      "id": 26037,
      "keyword": "ávara",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ávaras": [
    {
      "id": 26037,
      "keyword": "ávara",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "energía eólica": [
    {
      "id": 26061,
      "keyword": "energía eólica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "energías eólicas": [
    {
      "id": 26061,
      "keyword": "energía eólica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escarola": [
    {
      "id": 26067,
      "keyword": "escarola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escarolas": [
    {
      "id": 26067,
      "keyword": "escarola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escritorio": [
    {
      "id": 26071,
      "keyword": "escritorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escritorios": [
    {
      "id": 26071,
      "keyword": "escritorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "campana extractora": [
    {
      "id": 26077,
      "keyword": "campana extractora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campanas extractoras": [
    {
      "id": 26077,
      "keyword": "campana extractora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "extractor": [
    {
      "id": 26077,
      "keyword": "extractor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "extractores": [
    {
      "id": 26077,
      "keyword": "extractor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "faja": [
    {
      "id": 26081,
      "keyword": "faja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fajas": [
    {
      "id": 26081,
      "keyword": "faja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acampada": [
    {
      "id": 25912,
      "keyword": "acampada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acampadas": [
    {
      "id": 25912,
      "keyword": "acampada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "campamento": [
    {
      "id": 25912,
      "keyword": "campamento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campamentos": [
    {
      "id": 25912,
      "keyword": "campamento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "faraón": [
    {
      "id": 26086,
      "keyword": "faraón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "civilization",
        "Egypt",
        "archaeology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "faraones": [
    {
      "id": 26086,
      "keyword": "faraón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "civilization",
        "Egypt",
        "archaeology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fósil": [
    {
      "id": 26098,
      "keyword": "fósil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "extinct being",
        "fossil",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26102,
      "keyword": "fósil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "extinct being",
        "fossil",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fosiles": [
    {
      "id": 26098,
      "keyword": "fósil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "extinct being",
        "fossil",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26102,
      "keyword": "fósil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "extinct being",
        "fossil",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encierro": [
    {
      "id": 26055,
      "keyword": "encierro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival",
        "scenic art",
        "bullfighting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encierros": [
    {
      "id": 26055,
      "keyword": "encierro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival",
        "scenic art",
        "bullfighting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "energía": [
    {
      "id": 26059,
      "keyword": "energía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "energías": [
    {
      "id": 26059,
      "keyword": "energía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "intentar": [
    {
      "id": 26144,
      "keyword": "intentar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veo veo": [
    {
      "id": 26150,
      "keyword": "Veo veo",
      "keywords": 2,
      "type": 1,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juego del veo veo": [
    {
      "id": 26150,
      "keyword": "juego del Veo Veo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos del veo veo": [
    {
      "id": 26150,
      "keyword": "juego del Veo Veo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "labrar": [
    {
      "id": 26153,
      "keyword": "labrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26152,
      "keyword": "labrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26154,
      "keyword": "labrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grasa": [
    {
      "id": 26110,
      "keyword": "grasa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "biology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grasas": [
    {
      "id": 26110,
      "keyword": "grasa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "biology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lápida": [
    {
      "id": 26158,
      "keyword": "lápida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lápidas": [
    {
      "id": 26158,
      "keyword": "lápida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "larva": [
    {
      "id": 26164,
      "keyword": "larva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "terrestrial animal",
        "herbivorous",
        "oviparous"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "larvas": [
    {
      "id": 26164,
      "keyword": "larva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "terrestrial animal",
        "herbivorous",
        "oviparous"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lavadero": [
    {
      "id": 26168,
      "keyword": "lavadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "urban area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavaderos": [
    {
      "id": 26168,
      "keyword": "lavadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "urban area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "completo": [
    {
      "id": 26176,
      "keyword": "completo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31190,
      "keyword": "completo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "completos": [
    {
      "id": 26176,
      "keyword": "completo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31190,
      "keyword": "completo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "completa": [
    {
      "id": 26176,
      "keyword": "completa",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31190,
      "keyword": "completa",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "completas": [
    {
      "id": 26176,
      "keyword": "completa",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31190,
      "keyword": "completa",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lomo": [
    {
      "id": 26178,
      "keyword": "lomo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26451,
      "keyword": "lomo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lomos": [
    {
      "id": 26178,
      "keyword": "lomo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26451,
      "keyword": "lomo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "infierno": [
    {
      "id": 26142,
      "keyword": "infierno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "infiernos": [
    {
      "id": 26142,
      "keyword": "infierno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mover el ratón": [
    {
      "id": 26186,
      "keyword": "mover el ratón",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28561,
      "keyword": "mover el ratón",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "luto": [
    {
      "id": 26180,
      "keyword": "luto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lutos": [
    {
      "id": 26180,
      "keyword": "luto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hidrato de carbono": [
    {
      "id": 26130,
      "keyword": "hidrato de carbono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "biology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hidratos de carbono": [
    {
      "id": 26130,
      "keyword": "hidrato de carbono",
      "keywords": 1,
      "type": 2,
      "tags": [
        "biology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "iguana": [
    {
      "id": 26134,
      "keyword": "iguana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "iguanas": [
    {
      "id": 26134,
      "keyword": "iguana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "impresora láser": [
    {
      "id": 26138,
      "keyword": "impresora láser",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "impresoras láser": [
    {
      "id": 26138,
      "keyword": "impresora láser",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mantón": [
    {
      "id": 26192,
      "keyword": "mantón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mantones": [
    {
      "id": 26192,
      "keyword": "mantón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "herboristería": [
    {
      "id": 26126,
      "keyword": "herboristería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "plant-based food",
        "aromatic plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "herboristerías": [
    {
      "id": 26126,
      "keyword": "herboristería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "plant-based food",
        "aromatic plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manivela": [
    {
      "id": 26188,
      "keyword": "manivela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manivelas": [
    {
      "id": 26188,
      "keyword": "manivela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "margarina": [
    {
      "id": 26196,
      "keyword": "margarina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "margarinas": [
    {
      "id": 26196,
      "keyword": "margarina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mineral": [
    {
      "id": 26224,
      "keyword": "mineral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "minerales": [
    {
      "id": 26224,
      "keyword": "mineral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26226,
      "keyword": "minerales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "materia elaborada": [
    {
      "id": 26208,
      "keyword": "materia elaborada",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "derived material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "materias elaboradas": [
    {
      "id": 26208,
      "keyword": "materia elaborada",
      "keywords": 3,
      "type": 2,
      "tags": [
        "material",
        "derived material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "elaborado": [
    {
      "id": 26208,
      "keyword": "elaborado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "material",
        "derived material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "elaborados": [
    {
      "id": 26208,
      "keyword": "elaborado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "material",
        "derived material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "elaborada": [
    {
      "id": 26208,
      "keyword": "elaborada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "material",
        "derived material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "elaboradas": [
    {
      "id": 26208,
      "keyword": "elaborada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "material",
        "derived material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "materia prima": [
    {
      "id": 26204,
      "keyword": "materia prima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "materias primas": [
    {
      "id": 26204,
      "keyword": "materia prima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "difunto": [
    {
      "id": 36191,
      "keyword": "difunto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "judaism",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29867,
      "keyword": "difunto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death",
        "person",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26234,
      "keyword": "difunto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "difuntos": [
    {
      "id": 36191,
      "keyword": "difunto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "judaism",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29867,
      "keyword": "difunto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death",
        "person",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26234,
      "keyword": "difunto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "música de órgano": [
    {
      "id": 26242,
      "keyword": "música de órgano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument",
        "keyboard instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "músicas de órgano": [
    {
      "id": 26242,
      "keyword": "música de órgano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument",
        "keyboard instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "moño": [
    {
      "id": 26230,
      "keyword": "moño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "moños": [
    {
      "id": 26230,
      "keyword": "moño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nidada": [
    {
      "id": 26254,
      "keyword": "nidada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal physiology",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nidadas": [
    {
      "id": 26254,
      "keyword": "nidada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal physiology",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "olvidar": [
    {
      "id": 26258,
      "keyword": "olvidar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "olvidarse": [
    {
      "id": 26258,
      "keyword": "olvidarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ordeñar": [
    {
      "id": 26260,
      "keyword": "ordeñar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apalancar": [
    {
      "id": 26279,
      "keyword": "apalancar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26278,
      "keyword": "apalancar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mercromina": [
    {
      "id": 26212,
      "keyword": "mercromina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mercrominas": [
    {
      "id": 26212,
      "keyword": "mercromina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "milpiés": [
    {
      "id": 26216,
      "keyword": "milpiés",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palo de lluvia": [
    {
      "id": 26286,
      "keyword": "palo de lluvia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palos de lluvia": [
    {
      "id": 26286,
      "keyword": "palo de lluvia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pantanoso": [
    {
      "id": 26290,
      "keyword": "pantanoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "natural habitat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pantanosos": [
    {
      "id": 26290,
      "keyword": "pantanoso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "natural habitat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "papilas": [
    {
      "id": 26294,
      "keyword": "papilas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papilas gustativas": [
    {
      "id": 26294,
      "keyword": "papilas gustativas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parque temático": [
    {
      "id": 26296,
      "keyword": "parque temático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parques temáticos": [
    {
      "id": 26296,
      "keyword": "parque temático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pasear al bebé": [
    {
      "id": 26300,
      "keyword": "pasear al bebé",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nefertiti": [
    {
      "id": 26252,
      "keyword": "Nefertiti",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history",
        "civilization",
        "Egypt"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pensamiento": [
    {
      "id": 26310,
      "keyword": "pensamiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pensamientos": [
    {
      "id": 26310,
      "keyword": "pensamiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pescadilla": [
    {
      "id": 26316,
      "keyword": "pescadilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pescadillas": [
    {
      "id": 26316,
      "keyword": "pescadilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nacimiento": [
    {
      "id": 26320,
      "keyword": "nacimiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37980,
      "keyword": "nacimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37981,
      "keyword": "nacimiento",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nacimientos": [
    {
      "id": 26320,
      "keyword": "nacimiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pesebre": [
    {
      "id": 26320,
      "keyword": "pesebre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pesebres": [
    {
      "id": 26320,
      "keyword": "pesebre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "polea": [
    {
      "id": 26334,
      "keyword": "polea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poleas": [
    {
      "id": 26334,
      "keyword": "polea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pomo": [
    {
      "id": 26338,
      "keyword": "pomo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pomos": [
    {
      "id": 26338,
      "keyword": "pomo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "proteína": [
    {
      "id": 26346,
      "keyword": "proteína",
      "keywords": 1,
      "type": 2,
      "tags": [
        "biology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "proteínas": [
    {
      "id": 26346,
      "keyword": "proteína",
      "keywords": 1,
      "type": 2,
      "tags": [
        "biology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plaga": [
    {
      "id": 26326,
      "keyword": "plaga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plagas": [
    {
      "id": 26326,
      "keyword": "plaga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "work",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rape": [
    {
      "id": 26362,
      "keyword": "rape",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29173,
      "keyword": "rape",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rapes": [
    {
      "id": 26362,
      "keyword": "rape",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29173,
      "keyword": "rape",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recetar": [
    {
      "id": 26366,
      "keyword": "recetar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prescribir": [
    {
      "id": 26366,
      "keyword": "prescribir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "remolacha": [
    {
      "id": 26370,
      "keyword": "remolacha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "remolachas": [
    {
      "id": 26370,
      "keyword": "remolacha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "purgatorio": [
    {
      "id": 26356,
      "keyword": "purgatorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "purgatorios": [
    {
      "id": 26356,
      "keyword": "purgatorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "repartir": [
    {
      "id": 26376,
      "keyword": "repartir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27070,
      "keyword": "repartir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26377,
      "keyword": "repartir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27069,
      "keyword": "repartir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reproducción": [
    {
      "id": 26380,
      "keyword": "reproducción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal physiology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26381,
      "keyword": "reproducción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant physiology",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reproducirse": [
    {
      "id": 26380,
      "keyword": "reproducirse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "animal",
        "animal physiology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26381,
      "keyword": "reproducirse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "plant",
        "plant physiology",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "resfriado": [
    {
      "id": 26384,
      "keyword": "resfriado",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "resfriados": [
    {
      "id": 26384,
      "keyword": "resfriado",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "catarro": [
    {
      "id": 26384,
      "keyword": "catarro",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "catarros": [
    {
      "id": 26384,
      "keyword": "catarro",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enfriamiento": [
    {
      "id": 26384,
      "keyword": "enfriamiento",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfriamientos": [
    {
      "id": 26384,
      "keyword": "enfriamiento",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "congestión": [
    {
      "id": 26384,
      "keyword": "congestión",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "congestiones": [
    {
      "id": 26384,
      "keyword": "congestión",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "congestión nasal": [
    {
      "id": 26384,
      "keyword": "congestión nasal",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pintar la pared ": [
    {
      "id": 26324,
      "keyword": "pintar la pared ",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "residuos": [
    {
      "id": 26388,
      "keyword": "residuos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "environmental science",
        "pollution"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rizado": [
    {
      "id": 26392,
      "keyword": "rizado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38534,
      "keyword": "rizado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38538,
      "keyword": "rizado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rizados": [
    {
      "id": 26392,
      "keyword": "rizado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38534,
      "keyword": "rizado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rizo": [
    {
      "id": 26392,
      "keyword": "rizo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rizada": [
    {
      "id": 26392,
      "keyword": "rizada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rizadas": [
    {
      "id": 26392,
      "keyword": "rizada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rodaja de salmón": [
    {
      "id": 26419,
      "keyword": "rodaja de salmón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal-based food",
        "gastronomy",
        "feeding",
        "food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodajas de salmón": [
    {
      "id": 26419,
      "keyword": "rodaja de salmón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal-based food",
        "gastronomy",
        "feeding",
        "food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "momia": [
    {
      "id": 26427,
      "keyword": "momia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "character",
        "book character",
        "literature",
        "movie character",
        "cinema",
        "event",
        "popular event",
        "halloween",
        "civilization",
        "Egypt"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "momias": [
    {
      "id": 26427,
      "keyword": "momia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "character",
        "book character",
        "literature",
        "movie character",
        "cinema",
        "event",
        "popular event",
        "halloween",
        "civilization",
        "Egypt"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "secadora": [
    {
      "id": 26431,
      "keyword": "secadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secadoras": [
    {
      "id": 26431,
      "keyword": "secadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sémola": [
    {
      "id": 26435,
      "keyword": "sémola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sémolas": [
    {
      "id": 26435,
      "keyword": "sémola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "séquito": [
    {
      "id": 26439,
      "keyword": "séquito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26440,
      "keyword": "séquito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "séquitos": [
    {
      "id": 26439,
      "keyword": "séquito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26440,
      "keyword": "séquito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salpicar": [
    {
      "id": 27063,
      "keyword": "salpicar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37903,
      "keyword": "salpicar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26423,
      "keyword": "salpicar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soja": [
    {
      "id": 26447,
      "keyword": "soja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sojas": [
    {
      "id": 26447,
      "keyword": "soja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "semillas de soja": [
    {
      "id": 26447,
      "keyword": "semillas de soja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suave": [
    {
      "id": 26455,
      "keyword": "suave",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suaves": [
    {
      "id": 26455,
      "keyword": "suave",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "suicidio": [
    {
      "id": 26465,
      "keyword": "suicidio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26463,
      "keyword": "suicidio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26464,
      "keyword": "suicidio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suicidios": [
    {
      "id": 26465,
      "keyword": "suicidio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26463,
      "keyword": "suicidio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26464,
      "keyword": "suicidio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rompecabezas": [
    {
      "id": 26403,
      "keyword": "rompecabezas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suicidar": [
    {
      "id": 26465,
      "keyword": "suicidar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "temerosa": [
    {
      "id": 26483,
      "keyword": "temerosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "temerosas": [
    {
      "id": 26483,
      "keyword": "temerosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "miedosa": [
    {
      "id": 26483,
      "keyword": "miedosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "miedosas": [
    {
      "id": 26483,
      "keyword": "miedosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tirarse al agua": [
    {
      "id": 26493,
      "keyword": "tirarse al agua",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tirar al agua": [
    {
      "id": 26493,
      "keyword": "tirar al agua",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "solomillo": [
    {
      "id": 26451,
      "keyword": "solomillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "solomillos": [
    {
      "id": 26451,
      "keyword": "solomillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ternero": [
    {
      "id": 26489,
      "keyword": "ternero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34080,
      "keyword": "ternero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terneros": [
    {
      "id": 26489,
      "keyword": "ternero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34080,
      "keyword": "ternero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "galápago": [
    {
      "id": 26503,
      "keyword": "galápago",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "terrestrial animal",
        "aquatic animal",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "galápagos": [
    {
      "id": 26503,
      "keyword": "galápago",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "terrestrial animal",
        "aquatic animal",
        "domestic",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trastero": [
    {
      "id": 26511,
      "keyword": "trastero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trasteros": [
    {
      "id": 26511,
      "keyword": "trastero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "baulera": [
    {
      "id": 26511,
      "keyword": "baulera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bauleras": [
    {
      "id": 26511,
      "keyword": "baulera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "deposito": [
    {
      "id": 26511,
      "keyword": "deposito",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "depositos": [
    {
      "id": 26511,
      "keyword": "deposito",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trono": [
    {
      "id": 26515,
      "keyword": "trono",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "tronos": [
    {
      "id": 26515,
      "keyword": "trono",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "tutankhamon": [
    {
      "id": 26521,
      "keyword": "Tutankhamon",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history",
        "civilization",
        "Egypt"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuchara adaptada": [
    {
      "id": 26549,
      "keyword": "cuchara adaptada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "household",
        "cutlery",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cucharas adaptadas": [
    {
      "id": 26549,
      "keyword": "cuchara adaptada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "household",
        "cutlery",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vecino": [
    {
      "id": 26529,
      "keyword": "vecino",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "group",
        "core vocabulary",
        "place",
        "building"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 26529,
      "keyword": "vecino",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "group",
        "core vocabulary",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37228,
      "keyword": "vecino",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vecina": [
    {
      "id": 26529,
      "keyword": "vecina",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "group",
        "core vocabulary",
        "place",
        "building"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 26529,
      "keyword": "vecina",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "group",
        "core vocabulary",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37229,
      "keyword": "vecina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vecinas": [
    {
      "id": 26529,
      "keyword": "vecina",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "group",
        "core vocabulary",
        "place",
        "building"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 26529,
      "keyword": "vecina",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "group",
        "core vocabulary",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37229,
      "keyword": "vecina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "circuito electrónico": [
    {
      "id": 26543,
      "keyword": "circuito electrónico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "circuitos electrónicos": [
    {
      "id": 26543,
      "keyword": "circuito electrónico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "empleado de funeraria": [
    {
      "id": 26563,
      "keyword": "empleado de funeraria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empleados de funeraria": [
    {
      "id": 26563,
      "keyword": "empleado de funeraria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "derrumbar": [
    {
      "id": 26561,
      "keyword": "derrumbar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nebulizador": [
    {
      "id": 26571,
      "keyword": "nebulizador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nebulizadores": [
    {
      "id": 26571,
      "keyword": "nebulizador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "spray nasal": [
    {
      "id": 26571,
      "keyword": "spray nasal",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30707,
      "keyword": "spray nasal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sprays nasales": [
    {
      "id": 26571,
      "keyword": "spray nasal",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30707,
      "keyword": "spray nasal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espray nasal": [
    {
      "id": 26571,
      "keyword": "espray nasal",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30707,
      "keyword": "espray nasal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espráis nsales": [
    {
      "id": 26571,
      "keyword": "espray nasal",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30707,
      "keyword": "espray nasal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pastor luterano": [
    {
      "id": 26575,
      "keyword": "pastor luterano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pastores luteranos": [
    {
      "id": 26575,
      "keyword": "pastor luterano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "electrodoméstico": [
    {
      "id": 26587,
      "keyword": "electrodoméstico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tenedor adaptado": [
    {
      "id": 26557,
      "keyword": "tenedor adaptado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "household",
        "cutlery",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tenedores adaptados": [
    {
      "id": 26557,
      "keyword": "tenedor adaptado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "household",
        "cutlery",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "visitar la tumba": [
    {
      "id": 26585,
      "keyword": "visitar la tumba",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escuela de familias": [
    {
      "id": 26589,
      "keyword": "escuela de familias",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escuelas de familias": [
    {
      "id": 26589,
      "keyword": "escuela de familias",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "niño con autismo": [
    {
      "id": 26606,
      "keyword": "niño con autismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37446,
      "keyword": "niño con autismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26594,
      "keyword": "niño con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37444,
      "keyword": "niño con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niños con autismo": [
    {
      "id": 26606,
      "keyword": "niño con autismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26594,
      "keyword": "niño con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26591,
      "keyword": "niños con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37444,
      "keyword": "niño con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37445,
      "keyword": "niños con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niña con autismo": [
    {
      "id": 26606,
      "keyword": "niña con autismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37446,
      "keyword": "niña con autismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26595,
      "keyword": "niña con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37443,
      "keyword": "niña con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niñas con autismo": [
    {
      "id": 26606,
      "keyword": "niña con autismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26595,
      "keyword": "niña con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "persona con autismo": [
    {
      "id": 26603,
      "keyword": "persona con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37439,
      "keyword": "persona con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26598,
      "keyword": "persona con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26599,
      "keyword": "persona con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37441,
      "keyword": "persona con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37442,
      "keyword": "persona con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "personas con autismo": [
    {
      "id": 26603,
      "keyword": "persona con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37439,
      "keyword": "persona con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26598,
      "keyword": "persona con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26599,
      "keyword": "persona con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26602,
      "keyword": "personas con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37440,
      "keyword": "personas con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37441,
      "keyword": "persona con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37442,
      "keyword": "persona con autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vibrador": [
    {
      "id": 26581,
      "keyword": "vibrador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vibradores": [
    {
      "id": 26581,
      "keyword": "vibrador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "masajeador": [
    {
      "id": 26581,
      "keyword": "masajeador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "masajeadores": [
    {
      "id": 26581,
      "keyword": "masajeador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aclamar": [
    {
      "id": 26615,
      "keyword": "aclamar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ovacionar": [
    {
      "id": 26615,
      "keyword": "ovacionar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "event",
        "sport event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abuchear": [
    {
      "id": 26611,
      "keyword": "abuchear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "advertir": [
    {
      "id": 26623,
      "keyword": "advertir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26622,
      "keyword": "advertir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autismo": [
    {
      "id": 26607,
      "keyword": "autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37447,
      "keyword": "autismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bebida con alcohol": [
    {
      "id": 26626,
      "keyword": "bebida con alcohol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bebidas con alcohol": [
    {
      "id": 26626,
      "keyword": "bebida con alcohol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aparcamiento de bicicletas": [
    {
      "id": 26632,
      "keyword": "aparcamiento de bicicletas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aparcamientos de bicicletas": [
    {
      "id": 26632,
      "keyword": "aparcamiento de bicicletas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aprender a nadar": [
    {
      "id": 26638,
      "keyword": "aprender a nadar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26641,
      "keyword": "aprender a nadar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26639,
      "keyword": "aprender a nadar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26640,
      "keyword": "aprender a nadar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39127,
      "keyword": "aprender a nadar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39128,
      "keyword": "aprender a nadar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39159,
      "keyword": "aprender a nadar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39160,
      "keyword": "aprender a nadar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "granos": [
    {
      "id": 26616,
      "keyword": "granos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29668,
      "keyword": "granos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acné": [
    {
      "id": 26616,
      "keyword": "acné",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29668,
      "keyword": "acné",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acnés": [
    {
      "id": 26616,
      "keyword": "acné",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29668,
      "keyword": "acné",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ataúd": [
    {
      "id": 26646,
      "keyword": "ataúd",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32194,
      "keyword": "ataúd",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ataudes": [
    {
      "id": 26646,
      "keyword": "ataúd",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32194,
      "keyword": "ataúd",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "féretro": [
    {
      "id": 26646,
      "keyword": "féretro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32194,
      "keyword": "féretro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "féretros": [
    {
      "id": 26646,
      "keyword": "féretro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32194,
      "keyword": "féretro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "andorra": [
    {
      "id": 26666,
      "keyword": "Andorra",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28979,
      "keyword": "Andorra",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "angola": [
    {
      "id": 26667,
      "keyword": "Angola",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "azerbaiyán": [
    {
      "id": 26670,
      "keyword": "Azerbaiyán",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29570,
      "keyword": "Azerbaiyán",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "armenia": [
    {
      "id": 26669,
      "keyword": "Armenia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29569,
      "keyword": "Armenia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bahamas": [
    {
      "id": 26671,
      "keyword": "Bahamas",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29730,
      "keyword": "Bahamas",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barbados": [
    {
      "id": 26672,
      "keyword": "Barbados",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29732,
      "keyword": "Barbados",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bielorrusia": [
    {
      "id": 26673,
      "keyword": "Bielorrusia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29571,
      "keyword": "Bielorrusia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botsuana": [
    {
      "id": 26674,
      "keyword": "Botsuana",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "audiolibro": [
    {
      "id": 26650,
      "keyword": "audiolibro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "audiolibros": [
    {
      "id": 26650,
      "keyword": "audiolibro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "burkina faso": [
    {
      "id": 26675,
      "keyword": "Burkina Faso",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "argelia": [
    {
      "id": 26668,
      "keyword": "Argelia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "burundi": [
    {
      "id": 26676,
      "keyword": "Burundi",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fuente de horno": [
    {
      "id": 26678,
      "keyword": "fuente de horno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fuentes de horno": [
    {
      "id": 26678,
      "keyword": "fuente de horno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bicicleta de alquiler": [
    {
      "id": 26692,
      "keyword": "bicicleta de alquiler",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bicicletas de alquiler": [
    {
      "id": 26692,
      "keyword": "bicicleta de alquiler",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cabo verde": [
    {
      "id": 26677,
      "keyword": "Cabo Verde",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desinfectante": [
    {
      "id": 26688,
      "keyword": "desinfectante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37958,
      "keyword": "desinfectante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36761,
      "keyword": "desinfectante",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "medicine",
        "medical equipment",
        "covid-19",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desinfectantes": [
    {
      "id": 26688,
      "keyword": "desinfectante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37958,
      "keyword": "desinfectante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36761,
      "keyword": "desinfectante",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "medicine",
        "medical equipment",
        "covid-19",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "antiséptico": [
    {
      "id": 26688,
      "keyword": "antiséptico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37958,
      "keyword": "antiséptico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "antisépticos": [
    {
      "id": 26688,
      "keyword": "antiséptico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37958,
      "keyword": "antiséptico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "boya": [
    {
      "id": 26696,
      "keyword": "boya",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boyas": [
    {
      "id": 26696,
      "keyword": "boya",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "burlar": [
    {
      "id": 26705,
      "keyword": "burlar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34781,
      "keyword": "burlar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26704,
      "keyword": "burlar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37770,
      "keyword": "burlar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caballeriza": [
    {
      "id": 26712,
      "keyword": "caballeriza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caballerizas": [
    {
      "id": 26712,
      "keyword": "caballeriza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cabalgata": [
    {
      "id": 26708,
      "keyword": "cabalgata",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "cabalgatas": [
    {
      "id": 26708,
      "keyword": "cabalgata",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "brazalete": [
    {
      "id": 26700,
      "keyword": "brazalete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brazaletes": [
    {
      "id": 26700,
      "keyword": "brazalete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cambiar de canal": [
    {
      "id": 26730,
      "keyword": "cambiar de canal",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cama de gatos": [
    {
      "id": 26724,
      "keyword": "cama de gatos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camas de gatos": [
    {
      "id": 26724,
      "keyword": "cama de gatos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ardiente": [
    {
      "id": 26716,
      "keyword": "ardiente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "physics",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ardientes": [
    {
      "id": 26716,
      "keyword": "ardiente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "physics",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carro de servicio": [
    {
      "id": 26732,
      "keyword": "carro de servicio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carros de servicio": [
    {
      "id": 26732,
      "keyword": "carro de servicio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "feeding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cucha": [
    {
      "id": 26736,
      "keyword": "cucha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuchas": [
    {
      "id": 26736,
      "keyword": "cucha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caseta para perros": [
    {
      "id": 26736,
      "keyword": "caseta para perros",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casetas para perros": [
    {
      "id": 26736,
      "keyword": "caseta para perros",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "central": [
    {
      "id": 26740,
      "keyword": "central",
      "keywords": 1,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centrales": [
    {
      "id": 26740,
      "keyword": "central",
      "keywords": 1,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cesta de la compra": [
    {
      "id": 26748,
      "keyword": "cesta de la compra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cestas de la compra": [
    {
      "id": 26748,
      "keyword": "cesta de la compra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "voltear": [
    {
      "id": 26728,
      "keyword": "voltear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "position",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37230,
      "keyword": "voltear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chad": [
    {
      "id": 26752,
      "keyword": "Chad",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colmena": [
    {
      "id": 26761,
      "keyword": "colmena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26765,
      "keyword": "colmena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colmenas": [
    {
      "id": 26761,
      "keyword": "colmena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26765,
      "keyword": "colmena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "república democrática del congo": [
    {
      "id": 26769,
      "keyword": "República Democrática del Congo",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortapizza": [
    {
      "id": 26774,
      "keyword": "cortapizza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortapizzas": [
    {
      "id": 26774,
      "keyword": "cortapizza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colirio": [
    {
      "id": 26757,
      "keyword": "colirio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colirios": [
    {
      "id": 26757,
      "keyword": "colirio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "iluminado": [
    {
      "id": 26753,
      "keyword": "iluminado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "iluminados": [
    {
      "id": 26753,
      "keyword": "iluminado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "iluminada": [
    {
      "id": 26753,
      "keyword": "iluminada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "iluminadas": [
    {
      "id": 26753,
      "keyword": "iluminada",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "costa de marfil": [
    {
      "id": 26778,
      "keyword": "Costa de Marfil",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuchillo adaptado": [
    {
      "id": 26553,
      "keyword": "cuchillo adaptado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "household",
        "cutlery",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuchillos adaptados": [
    {
      "id": 26553,
      "keyword": "cuchillo adaptado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "household",
        "cutlery",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "descorchar": [
    {
      "id": 26797,
      "keyword": "descorchar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32658,
      "keyword": "descorchar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "instruir": [
    {
      "id": 26809,
      "keyword": "instruir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enharinar": [
    {
      "id": 26807,
      "keyword": "enharinar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35737,
      "keyword": "enharinar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "días": [
    {
      "id": 26799,
      "keyword": "día",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37371,
      "keyword": "día",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37731,
      "keyword": "día",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alpinista": [
    {
      "id": 26813,
      "keyword": "alpinista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alpinistas": [
    {
      "id": 26813,
      "keyword": "alpinista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juntar": [
    {
      "id": 26818,
      "keyword": "juntar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26817,
      "keyword": "juntar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escalar": [
    {
      "id": 37248,
      "keyword": "escalar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "facility",
        "sports facility",
        "place",
        "recreational facility",
        "playground"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26814,
      "keyword": "escalar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27741,
      "keyword": "escalar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alpinismo": [
    {
      "id": 26814,
      "keyword": "alpinismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "erizo": [
    {
      "id": 26829,
      "keyword": "erizo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "erizos": [
    {
      "id": 26829,
      "keyword": "erizo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "eriza": [
    {
      "id": 26829,
      "keyword": "eriza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "erizas": [
    {
      "id": 26829,
      "keyword": "eriza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "terrestrial animal",
        "viviparous",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "eritrea": [
    {
      "id": 26833,
      "keyword": "Eritrea",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "erupción": [
    {
      "id": 26834,
      "keyword": "erupción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37838,
      "keyword": "erupción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "erupciones": [
    {
      "id": 26834,
      "keyword": "erupción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37838,
      "keyword": "erupción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esgrima": [
    {
      "id": 26838,
      "keyword": "esgrima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esgrimas": [
    {
      "id": 26838,
      "keyword": "esgrima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "establo": [
    {
      "id": 26840,
      "keyword": "establo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "establos": [
    {
      "id": 26840,
      "keyword": "establo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "empanar": [
    {
      "id": 26805,
      "keyword": "empanar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "etiopía": [
    {
      "id": 26844,
      "keyword": "Etiopía",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flor de lis": [
    {
      "id": 26853,
      "keyword": "flor de lis",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "flores de lis": [
    {
      "id": 26853,
      "keyword": "flor de lis",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "fractura": [
    {
      "id": 31180,
      "keyword": "fractura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26861,
      "keyword": "fractura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fracturas": [
    {
      "id": 31180,
      "keyword": "fractura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26861,
      "keyword": "fractura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rotura": [
    {
      "id": 26861,
      "keyword": "rotura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "roturas": [
    {
      "id": 26861,
      "keyword": "rotura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ammonite": [
    {
      "id": 26857,
      "keyword": "ammonite",
      "keywords": 1,
      "type": 2,
      "tags": [
        "extinct being",
        "fossil",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34055,
      "keyword": "ammonite",
      "keywords": 1,
      "type": 2,
      "tags": [
        "extinct being",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34056,
      "keyword": "ammonite",
      "keywords": 1,
      "type": 2,
      "tags": [
        "extinct being",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ammonites": [
    {
      "id": 26857,
      "keyword": "ammonite",
      "keywords": 1,
      "type": 2,
      "tags": [
        "extinct being",
        "fossil",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34055,
      "keyword": "ammonite",
      "keywords": 1,
      "type": 2,
      "tags": [
        "extinct being",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34056,
      "keyword": "ammonite",
      "keywords": 1,
      "type": 2,
      "tags": [
        "extinct being",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "equilibrar": [
    {
      "id": 26825,
      "keyword": "equilibrar",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equilibrado": [
    {
      "id": 26825,
      "keyword": "equilibrado",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26825,
      "keyword": "equilibrado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equilibrados": [
    {
      "id": 26825,
      "keyword": "equilibrado",
      "keywords": 6,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26825,
      "keyword": "equilibrado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "equilibrada": [
    {
      "id": 26825,
      "keyword": "equilibrada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equilibradas": [
    {
      "id": 26825,
      "keyword": "equilibrada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nivelado": [
    {
      "id": 26825,
      "keyword": "nivelado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nivelados": [
    {
      "id": 26825,
      "keyword": "nivelado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nivelada": [
    {
      "id": 26825,
      "keyword": "nivelada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niveladas": [
    {
      "id": 26825,
      "keyword": "nivelada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gallinero": [
    {
      "id": 26867,
      "keyword": "gallinero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gallineros": [
    {
      "id": 26867,
      "keyword": "gallinero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gabón": [
    {
      "id": 26871,
      "keyword": "Gabón",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fresco": [
    {
      "id": 26865,
      "keyword": "fresco",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "physics",
        "feeding",
        "cookery",
        "meteorology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frescos": [
    {
      "id": 26865,
      "keyword": "fresco",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "physics",
        "feeding",
        "cookery",
        "meteorology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fresca": [
    {
      "id": 26865,
      "keyword": "fresca",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "physics",
        "feeding",
        "cookery",
        "meteorology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frescas": [
    {
      "id": 26865,
      "keyword": "fresca",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "physics",
        "feeding",
        "cookery",
        "meteorology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ghana": [
    {
      "id": 26873,
      "keyword": "Ghana",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "georgia": [
    {
      "id": 26872,
      "keyword": "Georgia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29575,
      "keyword": "Georgia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "premio": [
    {
      "id": 26845,
      "keyword": "premio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "premios": [
    {
      "id": 26845,
      "keyword": "premio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "galardón": [
    {
      "id": 26845,
      "keyword": "galardón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "galardones": [
    {
      "id": 26845,
      "keyword": "galardón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guinea": [
    {
      "id": 26876,
      "keyword": "Guinea",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guinea ecuatorial": [
    {
      "id": 26877,
      "keyword": "Guinea Ecuatorial",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fisura": [
    {
      "id": 26849,
      "keyword": "fisura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fisuras": [
    {
      "id": 26849,
      "keyword": "fisura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jamaica": [
    {
      "id": 26880,
      "keyword": "Jamaica",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29731,
      "keyword": "Jamaica",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guayana francesa": [
    {
      "id": 26879,
      "keyword": "Guayana Francesa",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "groenlandia": [
    {
      "id": 26875,
      "keyword": "Groenlandia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maqueta": [
    {
      "id": 26881,
      "keyword": "maqueta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38345,
      "keyword": "maqueta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maquetas": [
    {
      "id": 26881,
      "keyword": "maqueta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38345,
      "keyword": "maqueta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jurado": [
    {
      "id": 26885,
      "keyword": "jurado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36546,
      "keyword": "jurado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36547,
      "keyword": "jurado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jurados": [
    {
      "id": 26885,
      "keyword": "jurado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36546,
      "keyword": "jurado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36547,
      "keyword": "jurado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "broma": [
    {
      "id": 26905,
      "keyword": "broma",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "bromas": [
    {
      "id": 26905,
      "keyword": "broma",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "inocentada": [
    {
      "id": 26905,
      "keyword": "inocentada",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "inocentadas": [
    {
      "id": 26905,
      "keyword": "inocentada",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "liviano": [
    {
      "id": 26889,
      "keyword": "liviano",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "livianos": [
    {
      "id": 26889,
      "keyword": "liviano",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "liviana": [
    {
      "id": 26889,
      "keyword": "liviana",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "livianas": [
    {
      "id": 26889,
      "keyword": "liviana",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "himnario": [
    {
      "id": 26933,
      "keyword": "himnario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity",
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "himnarios": [
    {
      "id": 26933,
      "keyword": "himnario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity",
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "negativo": [
    {
      "id": 26937,
      "keyword": "negativo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "negativos": [
    {
      "id": 26937,
      "keyword": "negativo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "negativa": [
    {
      "id": 26937,
      "keyword": "negativa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "negativas": [
    {
      "id": 26937,
      "keyword": "negativa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inocente": [
    {
      "id": 26909,
      "keyword": "inocente",
      "keywords": 1,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "inocentes": [
    {
      "id": 26909,
      "keyword": "inocente",
      "keywords": 1,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "guyana": [
    {
      "id": 26878,
      "keyword": "Guyana",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29601,
      "keyword": "Guyana",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "persona con movilidad reducida": [
    {
      "id": 26951,
      "keyword": "persona con movilidad reducida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26957,
      "keyword": "persona con movilidad reducida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26954,
      "keyword": "persona con movilidad reducida",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26949,
      "keyword": "persona con movilidad reducida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26950,
      "keyword": "persona con movilidad reducida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26955,
      "keyword": "persona con movilidad reducida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26956,
      "keyword": "persona con movilidad reducida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26953,
      "keyword": "persona con movilidad reducida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26952,
      "keyword": "persona con movilidad reducida",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "personas con movilidad reducida": [
    {
      "id": 26951,
      "keyword": "persona con movilidad reducida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26957,
      "keyword": "persona con movilidad reducida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26954,
      "keyword": "persona con movilidad reducida",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26949,
      "keyword": "persona con movilidad reducida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26950,
      "keyword": "persona con movilidad reducida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26955,
      "keyword": "persona con movilidad reducida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26956,
      "keyword": "persona con movilidad reducida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26953,
      "keyword": "persona con movilidad reducida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26952,
      "keyword": "persona con movilidad reducida",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coja": [
    {
      "id": 26954,
      "keyword": "coja",
      "keywords": 4,
      "type": 4,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26953,
      "keyword": "coja",
      "keywords": 2,
      "type": 4,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cojas": [
    {
      "id": 26954,
      "keyword": "coja",
      "keywords": 4,
      "type": 4,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26953,
      "keyword": "coja",
      "keywords": 2,
      "type": 4,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cojo": [
    {
      "id": 26954,
      "keyword": "cojo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26954,
      "keyword": "cojo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26952,
      "keyword": "cojo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26952,
      "keyword": "cojo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cojos": [
    {
      "id": 26954,
      "keyword": "cojo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26954,
      "keyword": "cojo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26952,
      "keyword": "cojo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26952,
      "keyword": "cojo",
      "keywords": 3,
      "type": 4,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "preocupado": [
    {
      "id": 26986,
      "keyword": "preocupado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26985,
      "keyword": "preocupado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "preocupados": [
    {
      "id": 26986,
      "keyword": "preocupado",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 26985,
      "keyword": "preocupado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "preocupar": [
    {
      "id": 26986,
      "keyword": "preocupar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26985,
      "keyword": "preocupar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28713,
      "keyword": "preocupar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "preocuparse": [
    {
      "id": 26986,
      "keyword": "preocuparse",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26985,
      "keyword": "preocuparse",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28713,
      "keyword": "preocuparse",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "persona signando": [
    {
      "id": 26989,
      "keyword": "persona signando",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27963,
      "keyword": "persona signando",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "personas signando": [
    {
      "id": 26989,
      "keyword": "persona signando",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27963,
      "keyword": "persona signando",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "temer": [
    {
      "id": 26986,
      "keyword": "temer",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "noches": [
    {
      "id": 26997,
      "keyword": "noche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "event",
        "popular event",
        "halloween",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35789,
      "keyword": "noche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "otoscopio": [
    {
      "id": 27001,
      "keyword": "otoscopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "otoscopios": [
    {
      "id": 27001,
      "keyword": "otoscopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "monitora de natación": [
    {
      "id": 27006,
      "keyword": "monitora de natación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monitoras de natación": [
    {
      "id": 27006,
      "keyword": "monitora de natación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "monitor de natación": [
    {
      "id": 27005,
      "keyword": "monitor de natación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monitores de natación": [
    {
      "id": 27005,
      "keyword": "monitor de natación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "olentzero": [
    {
      "id": 27017,
      "keyword": "Olentzero",
      "keywords": 3,
      "type": 1,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carbonero": [
    {
      "id": 27017,
      "keyword": "carbonero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carboneros": [
    {
      "id": 27017,
      "keyword": "carbonero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apalpador": [
    {
      "id": 27017,
      "keyword": "Apalpador",
      "keywords": 3,
      "type": 1,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "penalti": [
    {
      "id": 27021,
      "keyword": "penalti",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport rules",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "penaltis": [
    {
      "id": 27021,
      "keyword": "penalti",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport rules",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pesado": [
    {
      "id": 27025,
      "keyword": "pesado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pesados": [
    {
      "id": 27025,
      "keyword": "pesado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pesada": [
    {
      "id": 27025,
      "keyword": "pesada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pesadas": [
    {
      "id": 27025,
      "keyword": "pesada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "portalámparas": [
    {
      "id": 27029,
      "keyword": "portalámparas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secuestro": [
    {
      "id": 27039,
      "keyword": "secuestro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27037,
      "keyword": "secuestro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27038,
      "keyword": "secuestro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secuestros": [
    {
      "id": 27039,
      "keyword": "secuestro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27037,
      "keyword": "secuestro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27038,
      "keyword": "secuestro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "secuestrado": [
    {
      "id": 27039,
      "keyword": "secuestrado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27037,
      "keyword": "secuestrado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secuestrados": [
    {
      "id": 27039,
      "keyword": "secuestrado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27037,
      "keyword": "secuestrado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "poner el abrigo": [
    {
      "id": 27052,
      "keyword": "poner el abrigo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34494,
      "keyword": "poner el abrigo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner la bata": [
    {
      "id": 34569,
      "keyword": "poner la bata",
      "keywords": 2,
      "type": null,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27052,
      "keyword": "poner la bata",
      "keywords": 2,
      "type": null,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32282,
      "keyword": "poner la bata",
      "keywords": 2,
      "type": null,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34494,
      "keyword": "poner la bata",
      "keywords": 2,
      "type": null,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36574,
      "keyword": "poner la bata",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secuestrada": [
    {
      "id": 27039,
      "keyword": "secuestrada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27038,
      "keyword": "secuestrada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar el abrigo": [
    {
      "id": 37421,
      "keyword": "quitar el abrigo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27049,
      "keyword": "quitar el abrigo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35099,
      "keyword": "quitar el abrigo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar la bata": [
    {
      "id": 37421,
      "keyword": "quitar la bata",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27049,
      "keyword": "quitar la bata",
      "keywords": 2,
      "type": null,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35099,
      "keyword": "quitar la bata",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secuestrador": [
    {
      "id": 38370,
      "keyword": "secuestrador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27033,
      "keyword": "secuestrador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secuestradores": [
    {
      "id": 38370,
      "keyword": "secuestrador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27033,
      "keyword": "secuestrador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "secuestrar": [
    {
      "id": 38368,
      "keyword": "secuestrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27033,
      "keyword": "secuestrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rebozar": [
    {
      "id": 27057,
      "keyword": "rebozar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35643,
      "keyword": "rebozar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "templado": [
    {
      "id": 27053,
      "keyword": "templado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "physics",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "templados": [
    {
      "id": 27053,
      "keyword": "templado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "physics",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "templada": [
    {
      "id": 27053,
      "keyword": "templada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "physics",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "templadas": [
    {
      "id": 27053,
      "keyword": "templada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "physics",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cualquiera": [
    {
      "id": 26779,
      "keyword": "cualquiera",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26779,
      "keyword": "cualquiera",
      "keywords": 4,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36513,
      "keyword": "cualquiera",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36513,
      "keyword": "cualquiera",
      "keywords": 4,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cualquier": [
    {
      "id": 26779,
      "keyword": "cualquier",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 26779,
      "keyword": "cualquier",
      "keywords": 4,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36513,
      "keyword": "cualquier",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36513,
      "keyword": "cualquier",
      "keywords": 4,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sonido": [
    {
      "id": 27073,
      "keyword": "sonido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sonidos": [
    {
      "id": 27073,
      "keyword": "sonido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dividir": [
    {
      "id": 27070,
      "keyword": "dividir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27069,
      "keyword": "dividir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de bicicletas": [
    {
      "id": 27077,
      "keyword": "tienda de bicicletas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de bicicletas": [
    {
      "id": 27077,
      "keyword": "tienda de bicicletas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "religiones": [
    {
      "id": 27059,
      "keyword": "religión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "resucitar": [
    {
      "id": 27065,
      "keyword": "resucitar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trozo": [
    {
      "id": 27093,
      "keyword": "trozo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trozos": [
    {
      "id": 27093,
      "keyword": "trozo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pedazo": [
    {
      "id": 27093,
      "keyword": "pedazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pedazos": [
    {
      "id": 27093,
      "keyword": "pedazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tragar": [
    {
      "id": 27099,
      "keyword": "tragar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tragarse": [
    {
      "id": 27099,
      "keyword": "tragarse",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "deglutir": [
    {
      "id": 27099,
      "keyword": "deglutir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trillar": [
    {
      "id": 27089,
      "keyword": "trillar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gimnasia rítmica": [
    {
      "id": 27109,
      "keyword": "gimnasia rítmica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "gymnastics",
        "rhythmic gymnastics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pullboy": [
    {
      "id": 27117,
      "keyword": "pullboy",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pullboys": [
    {
      "id": 27117,
      "keyword": "pullboy",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jaula de viaje": [
    {
      "id": 27113,
      "keyword": "jaula de viaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jaulas de viaje": [
    {
      "id": 27113,
      "keyword": "jaula de viaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pulso": [
    {
      "id": 27121,
      "keyword": "pulso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27122,
      "keyword": "pulso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulsos": [
    {
      "id": 27121,
      "keyword": "pulso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27122,
      "keyword": "pulso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tomar el pulso": [
    {
      "id": 27121,
      "keyword": "tomar el pulso",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27122,
      "keyword": "tomar el pulso",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "regleta": [
    {
      "id": 27097,
      "keyword": "regleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "regletas": [
    {
      "id": 27097,
      "keyword": "regleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38112,
      "keyword": "regletas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vino blanco": [
    {
      "id": 27129,
      "keyword": "vino blanco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vinos blancos": [
    {
      "id": 27129,
      "keyword": "vino blanco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mozzarella": [
    {
      "id": 27136,
      "keyword": "mozzarella",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mozzarellas": [
    {
      "id": 27136,
      "keyword": "mozzarella",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "queso mozzarella": [
    {
      "id": 27136,
      "keyword": "queso mozzarella",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quesos mozzarella": [
    {
      "id": 27136,
      "keyword": "queso mozzarella",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vino rosado": [
    {
      "id": 27131,
      "keyword": "vino rosado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vinos rosados": [
    {
      "id": 27131,
      "keyword": "vino rosado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "día de los santos inocentes": [
    {
      "id": 27152,
      "keyword": "Día de los Santos Inocentes",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner un dvd": [
    {
      "id": 27140,
      "keyword": "poner un DVD",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reconocimiento médico": [
    {
      "id": 33114,
      "keyword": "reconocimiento médico",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27142,
      "keyword": "reconocimiento médico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27143,
      "keyword": "reconocimiento médico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reconocimientos médicos": [
    {
      "id": 33114,
      "keyword": "reconocimiento médico",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27142,
      "keyword": "reconocimiento médico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27143,
      "keyword": "reconocimiento médico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "revisión médica": [
    {
      "id": 33114,
      "keyword": "revisión médica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27142,
      "keyword": "revisión médica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27143,
      "keyword": "revisión médica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "revisiones médicas": [
    {
      "id": 33114,
      "keyword": "revisión médica",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27142,
      "keyword": "revisión médica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27143,
      "keyword": "revisión médica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "examen médico": [
    {
      "id": 33114,
      "keyword": "examen médico",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27142,
      "keyword": "examen médico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27143,
      "keyword": "examen médico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exámenes médicos": [
    {
      "id": 33114,
      "keyword": "examen médico",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27142,
      "keyword": "examen médico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27143,
      "keyword": "examen médico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vino espumoso": [
    {
      "id": 27130,
      "keyword": "vino espumoso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vinos espumosos": [
    {
      "id": 27130,
      "keyword": "vino espumoso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "waterpolo": [
    {
      "id": 27111,
      "keyword": "waterpolo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32312,
      "keyword": "waterpolo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32313,
      "keyword": "waterpolo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "judías verdes con patatas": [
    {
      "id": 27156,
      "keyword": "judías verdes con patatas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porotos con papas": [
    {
      "id": 27156,
      "keyword": "porotos con papas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tutor": [
    {
      "id": 27164,
      "keyword": "tutor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27165,
      "keyword": "tutor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27168,
      "keyword": "tutor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39166,
      "keyword": "tutor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27162,
      "keyword": "tutor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27163,
      "keyword": "tutor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27166,
      "keyword": "tutor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27167,
      "keyword": "tutor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tutores": [
    {
      "id": 27164,
      "keyword": "tutor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27165,
      "keyword": "tutor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27168,
      "keyword": "tutor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39166,
      "keyword": "tutor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27162,
      "keyword": "tutor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27163,
      "keyword": "tutor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27166,
      "keyword": "tutor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27167,
      "keyword": "tutor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hockey hielo": [
    {
      "id": 27106,
      "keyword": "hockey hielo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acelga con patatas": [
    {
      "id": 27154,
      "keyword": "acelga con patatas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acelgas con patatas": [
    {
      "id": 27154,
      "keyword": "acelga con patatas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acelga con papas": [
    {
      "id": 27154,
      "keyword": "acelga con papas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acelgas con papas": [
    {
      "id": 27154,
      "keyword": "acelga con papas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "borraja con patatas": [
    {
      "id": 27155,
      "keyword": "borraja con patatas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "borrajas con patatas": [
    {
      "id": 27155,
      "keyword": "borraja con patatas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quedar": [
    {
      "id": 27206,
      "keyword": "quedar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tutora": [
    {
      "id": 39166,
      "keyword": "tutora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27172,
      "keyword": "tutora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27171,
      "keyword": "tutora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27169,
      "keyword": "tutora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27170,
      "keyword": "tutora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tutoras": [
    {
      "id": 39166,
      "keyword": "tutora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27172,
      "keyword": "tutora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27171,
      "keyword": "tutora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27169,
      "keyword": "tutora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27170,
      "keyword": "tutora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reciclar": [
    {
      "id": 27212,
      "keyword": "reciclar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27210,
      "keyword": "reciclar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27214,
      "keyword": "reciclar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27216,
      "keyword": "reciclar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27208,
      "keyword": "reciclar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38206,
      "keyword": "reciclar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "positivo": [
    {
      "id": 27222,
      "keyword": "positivo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "positivos": [
    {
      "id": 27222,
      "keyword": "positivo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "positiva": [
    {
      "id": 27222,
      "keyword": "positiva",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "positivas": [
    {
      "id": 27222,
      "keyword": "positiva",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pelota de ping-pong": [
    {
      "id": 27218,
      "keyword": "pelota de ping-pong",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelotas de ping-pong": [
    {
      "id": 27218,
      "keyword": "pelota de ping-pong",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saludo scout": [
    {
      "id": 27238,
      "keyword": "saludo Scout",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pincho": [
    {
      "id": 27260,
      "keyword": "pincho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29188,
      "keyword": "pincho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29187,
      "keyword": "pincho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29090,
      "keyword": "pincho",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30401,
      "keyword": "pincho",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30409,
      "keyword": "pincho",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinchos": [
    {
      "id": 27260,
      "keyword": "pincho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29188,
      "keyword": "pincho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29187,
      "keyword": "pincho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29090,
      "keyword": "pincho",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30401,
      "keyword": "pincho",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30409,
      "keyword": "pincho",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarjeta bus": [
    {
      "id": 28107,
      "keyword": "tarjeta bus",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27256,
      "keyword": "tarjeta bus",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarjetas bus": [
    {
      "id": 28107,
      "keyword": "tarjeta bus",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27256,
      "keyword": "tarjeta bus",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "portería de hockey hielo": [
    {
      "id": 27226,
      "keyword": "portería de hockey hielo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porterías de hockey hielo": [
    {
      "id": 27226,
      "keyword": "portería de hockey hielo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sentar en el borde": [
    {
      "id": 27270,
      "keyword": "sentar en el borde",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27268,
      "keyword": "sentar en el borde",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27269,
      "keyword": "sentar en el borde",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sentarse en el borde": [
    {
      "id": 27270,
      "keyword": "sentarse en el borde",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27268,
      "keyword": "sentarse en el borde",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27269,
      "keyword": "sentarse en el borde",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "portería de waterpolo": [
    {
      "id": 27234,
      "keyword": "portería de waterpolo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porterías de waterpolo": [
    {
      "id": 27234,
      "keyword": "portería de waterpolo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "respirar bajo el agua": [
    {
      "id": 27265,
      "keyword": "respirar bajo el agua",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27264,
      "keyword": "respirar bajo el agua",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir por la escalerilla": [
    {
      "id": 27279,
      "keyword": "subir por la escalerilla",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27278,
      "keyword": "subir por la escalerilla",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27280,
      "keyword": "subir por la escalerilla",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salir de la piscina": [
    {
      "id": 27279,
      "keyword": "salir de la piscina",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27278,
      "keyword": "salir de la piscina",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27280,
      "keyword": "salir de la piscina",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salir del agua": [
    {
      "id": 27279,
      "keyword": "salir del agua",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27278,
      "keyword": "salir del agua",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27280,
      "keyword": "salir del agua",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salir de la pileta": [
    {
      "id": 27279,
      "keyword": "salir de la pileta",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27278,
      "keyword": "salir de la pileta",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27280,
      "keyword": "salir de la pileta",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cinturón de flotación": [
    {
      "id": 27288,
      "keyword": "cinturón de flotación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cinturones de flotación": [
    {
      "id": 27288,
      "keyword": "cinturón de flotación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "traje de neopreno": [
    {
      "id": 27284,
      "keyword": "traje de neopreno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trajes de neopreno": [
    {
      "id": 27284,
      "keyword": "traje de neopreno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "subir la cama": [
    {
      "id": 27296,
      "keyword": "subir la cama",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "traje austríaco": [
    {
      "id": 27298,
      "keyword": "traje austríaco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trajes austríacos": [
    {
      "id": 27298,
      "keyword": "traje austríaco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "otan": [
    {
      "id": 27302,
      "keyword": "OTAN",
      "keywords": 1,
      "type": 1,
      "tags": [
        "international organization",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "portería de hockey hierba": [
    {
      "id": 27230,
      "keyword": "portería de hockey hierba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porterías de hockey hierba": [
    {
      "id": 27230,
      "keyword": "portería de hockey hierba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "san marino": [
    {
      "id": 27309,
      "keyword": "San Marino",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29581,
      "keyword": "San Marino",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mónaco": [
    {
      "id": 27306,
      "keyword": "Mónaco",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "república dominicana": [
    {
      "id": 27308,
      "keyword": "República Dominicana",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29727,
      "keyword": "República Dominicana",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "san vicente y las granadinas": [
    {
      "id": 27310,
      "keyword": "San Vicente y las Granadinas",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "surinam": [
    {
      "id": 27312,
      "keyword": "Surinam",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29603,
      "keyword": "Surinam",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ucrania": [
    {
      "id": 27313,
      "keyword": "Ucrania",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29583,
      "keyword": "Ucrania",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "liechtenstein": [
    {
      "id": 27303,
      "keyword": "Liechtenstein",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29578,
      "keyword": "Liechtenstein",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "moldavia": [
    {
      "id": 27305,
      "keyword": "Moldavia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29580,
      "keyword": "Moldavia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "martinica": [
    {
      "id": 27304,
      "keyword": "Martinica",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aleteo": [
    {
      "id": 27315,
      "keyword": "aleteo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27316,
      "keyword": "aleteo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aleteos": [
    {
      "id": 27315,
      "keyword": "aleteo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27316,
      "keyword": "aleteo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aletear": [
    {
      "id": 37636,
      "keyword": "aletear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27315,
      "keyword": "aletear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27316,
      "keyword": "aletear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31123,
      "keyword": "aletear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barrido": [
    {
      "id": 27323,
      "keyword": "barrido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barridos": [
    {
      "id": 27323,
      "keyword": "barrido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apellido": [
    {
      "id": 27327,
      "keyword": "apellido",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "supporting document",
        "person",
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apellidos": [
    {
      "id": 27327,
      "keyword": "apellido",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "supporting document",
        "person",
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿cuál es tu apellido?": [
    {
      "id": 27349,
      "keyword": "¿cuál es tu apellido?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27327,
      "keyword": "¿cuál es tu apellido?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "document",
        "supporting document",
        "person",
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vaticano": [
    {
      "id": 27314,
      "keyword": "Vaticano",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anterior": [
    {
      "id": 27319,
      "keyword": "anterior",
      "keywords": 3,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27389,
      "keyword": "anterior",
      "keywords": 3,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anteriores": [
    {
      "id": 27319,
      "keyword": "anterior",
      "keywords": 3,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27389,
      "keyword": "anterior",
      "keywords": 3,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "preceder": [
    {
      "id": 27319,
      "keyword": "preceder",
      "keywords": 3,
      "type": 3,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27389,
      "keyword": "preceder",
      "keywords": 3,
      "type": 3,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anteceder": [
    {
      "id": 27319,
      "keyword": "anteceder",
      "keywords": 3,
      "type": 3,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27389,
      "keyword": "anteceder",
      "keywords": 3,
      "type": 3,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "montenegro": [
    {
      "id": 27307,
      "keyword": "Montenegro",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "siguiente": [
    {
      "id": 27341,
      "keyword": "siguiente",
      "keywords": 1,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27331,
      "keyword": "siguiente",
      "keywords": 3,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "siguientes": [
    {
      "id": 27341,
      "keyword": "siguiente",
      "keywords": 1,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27331,
      "keyword": "siguiente",
      "keywords": 3,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "posterior": [
    {
      "id": 27331,
      "keyword": "posterior",
      "keywords": 3,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "posteriores": [
    {
      "id": 27331,
      "keyword": "posterior",
      "keywords": 3,
      "type": 4,
      "tags": [
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paciencia": [
    {
      "id": 36563,
      "keyword": "paciencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human value",
        "human response",
        "education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27333,
      "keyword": "paciencia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human value",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paciencias": [
    {
      "id": 27333,
      "keyword": "paciencia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human value",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tener paciencia": [
    {
      "id": 36600,
      "keyword": "tener paciencia",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "core vocabulary",
        "psychology",
        "human response",
        "education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27333,
      "keyword": "tener paciencia",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human value",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fin de semana": [
    {
      "id": 32396,
      "keyword": "fin de semana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36706,
      "keyword": "fin de semana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36706,
      "keyword": "fin de semana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27329,
      "keyword": "fin de semana",
      "keywords": 1,
      "type": 6,
      "tags": [
        "time",
        "calendar",
        "day",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "organigrama": [
    {
      "id": 27335,
      "keyword": "organigrama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "organigramas": [
    {
      "id": 27335,
      "keyword": "organigrama",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿cuál es tu nombre?": [
    {
      "id": 27353,
      "keyword": "¿cuál es tu nombre?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38575,
      "keyword": "¿cuál es tu nombre?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "email": [
    {
      "id": 27355,
      "keyword": "email",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "emails": [
    {
      "id": 27355,
      "keyword": "email",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recibir un email": [
    {
      "id": 27361,
      "keyword": "recibir un email",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nombre": [
    {
      "id": 27357,
      "keyword": "nombre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "supporting document",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nombres": [
    {
      "id": 27357,
      "keyword": "nombre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "supporting document",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frente a frente": [
    {
      "id": 27365,
      "keyword": "frente a frente",
      "keywords": 2,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "cara a cara": [
    {
      "id": 27365,
      "keyword": "cara a cara",
      "keywords": 2,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "mandar un email": [
    {
      "id": 27359,
      "keyword": "mandar un email",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enviar un email": [
    {
      "id": 27359,
      "keyword": "enviar un email",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vez": [
    {
      "id": 27385,
      "keyword": "vez",
      "keywords": 3,
      "type": 2,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veces": [
    {
      "id": 27385,
      "keyword": "vez",
      "keywords": 3,
      "type": 2,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27387,
      "keyword": "veces",
      "keywords": 4,
      "type": 2,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27564,
      "keyword": "veces",
      "keywords": 4,
      "type": 2,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "una vez": [
    {
      "id": 27385,
      "keyword": "una vez",
      "keywords": 3,
      "type": 4,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alguna vez": [
    {
      "id": 27385,
      "keyword": "alguna vez",
      "keywords": 3,
      "type": 4,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "no entiendo": [
    {
      "id": 37827,
      "keyword": "no entiendo",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27363,
      "keyword": "no entiendo",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "no comprendo lo que dices": [
    {
      "id": 37827,
      "keyword": "no comprendo lo que dices",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27363,
      "keyword": "no comprendo lo que dices",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "malentender": [
    {
      "id": 37827,
      "keyword": "malentender",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27363,
      "keyword": "malentender",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prestación municipal": [
    {
      "id": 27369,
      "keyword": "prestación municipal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prestaciones municipales": [
    {
      "id": 27369,
      "keyword": "prestación municipal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "a veces": [
    {
      "id": 27387,
      "keyword": "a veces",
      "keywords": 4,
      "type": 4,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27564,
      "keyword": "a veces",
      "keywords": 4,
      "type": 4,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "unas veces": [
    {
      "id": 27387,
      "keyword": "unas veces",
      "keywords": 4,
      "type": 4,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27564,
      "keyword": "unas veces",
      "keywords": 4,
      "type": 4,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "algunas veces": [
    {
      "id": 27387,
      "keyword": "algunas veces",
      "keywords": 4,
      "type": 4,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27564,
      "keyword": "algunas veces",
      "keywords": 4,
      "type": 4,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tapadera": [
    {
      "id": 27395,
      "keyword": "tapadera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tapaderas": [
    {
      "id": 27395,
      "keyword": "tapadera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "descargar": [
    {
      "id": 27397,
      "keyword": "descargar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "método": [
    {
      "id": 27403,
      "keyword": "método",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "métodos": [
    {
      "id": 27403,
      "keyword": "método",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "metodología": [
    {
      "id": 27403,
      "keyword": "metodología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31297,
      "keyword": "metodología",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "methodology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "metodologías": [
    {
      "id": 27403,
      "keyword": "metodología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31297,
      "keyword": "metodología",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "methodology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desconectar de internet": [
    {
      "id": 27402,
      "keyword": "desconectar de internet",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conectar a internet": [
    {
      "id": 27399,
      "keyword": "conectar a internet",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acariciar": [
    {
      "id": 27408,
      "keyword": "acariciar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37195,
      "keyword": "acariciar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35471,
      "keyword": "acariciar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "anatomy",
        "animal anatomy",
        "animal-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27407,
      "keyword": "acariciar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35469,
      "keyword": "acariciar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caricia": [
    {
      "id": 27408,
      "keyword": "caricia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27407,
      "keyword": "caricia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35469,
      "keyword": "caricia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caricias": [
    {
      "id": 27408,
      "keyword": "caricia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27407,
      "keyword": "caricia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35469,
      "keyword": "caricia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recordar la contraseña": [
    {
      "id": 27367,
      "keyword": "recordar la contraseña",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campaña": [
    {
      "id": 27467,
      "keyword": "campaña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campañas": [
    {
      "id": 27467,
      "keyword": "campaña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lecho postural": [
    {
      "id": 27345,
      "keyword": "lecho postural",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38246,
      "keyword": "lecho postural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lechos posturales": [
    {
      "id": 27345,
      "keyword": "lecho postural",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38246,
      "keyword": "lecho postural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conferencia": [
    {
      "id": 27465,
      "keyword": "conferencia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conferencias": [
    {
      "id": 27465,
      "keyword": "conferencia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "charla": [
    {
      "id": 27465,
      "keyword": "charla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "charlas": [
    {
      "id": 27465,
      "keyword": "charla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "protestar": [
    {
      "id": 27469,
      "keyword": "protestar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27471,
      "keyword": "protestar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quejarse": [
    {
      "id": 27469,
      "keyword": "quejarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27471,
      "keyword": "quejarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "planta baja": [
    {
      "id": 27477,
      "keyword": "planta baja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plantas bajas": [
    {
      "id": 27477,
      "keyword": "planta baja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "poner la fecha": [
    {
      "id": 27411,
      "keyword": "poner la fecha",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escribir una fecha": [
    {
      "id": 27411,
      "keyword": "escribir una fecha",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "planta superior": [
    {
      "id": 27483,
      "keyword": "planta superior",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plantas superiores": [
    {
      "id": 27483,
      "keyword": "planta superior",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "segunda planta": [
    {
      "id": 27483,
      "keyword": "segunda planta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "segundas plantas": [
    {
      "id": 27483,
      "keyword": "segunda planta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "planta intermedia": [
    {
      "id": 27480,
      "keyword": "planta intermedia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plantas intermedias": [
    {
      "id": 27480,
      "keyword": "planta intermedia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "primera planta": [
    {
      "id": 27480,
      "keyword": "primera planta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "primeras plantas": [
    {
      "id": 27480,
      "keyword": "primera planta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de exposiciones": [
    {
      "id": 27493,
      "keyword": "sala de exposiciones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "visual art",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de exposiciones": [
    {
      "id": 27493,
      "keyword": "sala de exposiciones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "visual art",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gobernanta": [
    {
      "id": 27504,
      "keyword": "gobernanta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27503,
      "keyword": "gobernanta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32978,
      "keyword": "gobernanta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gobernantas": [
    {
      "id": 27504,
      "keyword": "gobernanta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27503,
      "keyword": "gobernanta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32978,
      "keyword": "gobernanta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desconectar": [
    {
      "id": 27518,
      "keyword": "desconectar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almacenar": [
    {
      "id": 27511,
      "keyword": "almacenar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27514,
      "keyword": "almacenar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "león marino": [
    {
      "id": 27501,
      "keyword": "león marino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leones marinos": [
    {
      "id": 27501,
      "keyword": "león marino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "leona marina": [
    {
      "id": 27501,
      "keyword": "leona marina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leonas marinas": [
    {
      "id": 27501,
      "keyword": "leona marina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ganadera": [
    {
      "id": 27521,
      "keyword": "ganadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ganaderas": [
    {
      "id": 27521,
      "keyword": "ganadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ganadero": [
    {
      "id": 27524,
      "keyword": "ganadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27523,
      "keyword": "ganadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ganaderos": [
    {
      "id": 27524,
      "keyword": "ganadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27523,
      "keyword": "ganadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "obligatorio ducharse": [
    {
      "id": 27529,
      "keyword": "obligatorio ducharse",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ducha obligatoria": [
    {
      "id": 27529,
      "keyword": "ducha obligatoria",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obligatorio usar gorro de baño": [
    {
      "id": 27531,
      "keyword": "obligatorio usar gorro de baño",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bibliotecario": [
    {
      "id": 27499,
      "keyword": "bibliotecario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "library science"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34529,
      "keyword": "bibliotecario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bibliotecarios": [
    {
      "id": 27499,
      "keyword": "bibliotecario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "library science"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34529,
      "keyword": "bibliotecario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "library science"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pastora": [
    {
      "id": 27539,
      "keyword": "pastora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pastoras": [
    {
      "id": 27539,
      "keyword": "pastora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quedarse solo": [
    {
      "id": 27542,
      "keyword": "quedarse solo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27541,
      "keyword": "quedarse solo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quedarse solo en el baño": [
    {
      "id": 27542,
      "keyword": "quedarse solo en el baño",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27541,
      "keyword": "quedarse solo en el baño",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "visitar al paciente ": [
    {
      "id": 27568,
      "keyword": "visitar al paciente ",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asamblea": [
    {
      "id": 27574,
      "keyword": "asamblea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "teaching activity",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36592,
      "keyword": "asamblea",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27575,
      "keyword": "asamblea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34325,
      "keyword": "asamblea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asambleas": [
    {
      "id": 27574,
      "keyword": "asamblea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "teaching activity",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36592,
      "keyword": "asamblea",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27575,
      "keyword": "asamblea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34325,
      "keyword": "asamblea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "antílope": [
    {
      "id": 27570,
      "keyword": "antílope",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "antílopes": [
    {
      "id": 27570,
      "keyword": "antílope",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "autopsia": [
    {
      "id": 27586,
      "keyword": "autopsia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autopsias": [
    {
      "id": 27586,
      "keyword": "autopsia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "azúcar moreno": [
    {
      "id": 27590,
      "keyword": "azúcar moreno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "azúcares morenos": [
    {
      "id": 27590,
      "keyword": "azúcar moreno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barnizar": [
    {
      "id": 27596,
      "keyword": "barnizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barniz": [
    {
      "id": 27592,
      "keyword": "barniz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barnices": [
    {
      "id": 27592,
      "keyword": "barniz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "belice": [
    {
      "id": 27598,
      "keyword": "Belice",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29729,
      "keyword": "Belice",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "betún": [
    {
      "id": 27599,
      "keyword": "betún",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "betunes": [
    {
      "id": 27599,
      "keyword": "betún",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "baréin": [
    {
      "id": 27591,
      "keyword": "Baréin",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "birmania": [
    {
      "id": 27603,
      "keyword": "Birmania",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bloc": [
    {
      "id": 27604,
      "keyword": "bloc",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "blocs": [
    {
      "id": 27604,
      "keyword": "bloc",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolsa de la compra": [
    {
      "id": 27616,
      "keyword": "bolsa de la compra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas de la compra": [
    {
      "id": 27616,
      "keyword": "bolsa de la compra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bola de bolos": [
    {
      "id": 27612,
      "keyword": "bola de bolos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolas de bolos": [
    {
      "id": 27612,
      "keyword": "bola de bolos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bodega": [
    {
      "id": 27608,
      "keyword": "bodega",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bodegas": [
    {
      "id": 27608,
      "keyword": "bodega",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "equitación": [
    {
      "id": 27627,
      "keyword": "equitación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brunéi": [
    {
      "id": 27624,
      "keyword": "Brunéi",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toque": [
    {
      "id": 27632,
      "keyword": "toque",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27631,
      "keyword": "toque",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27630,
      "keyword": "toque",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34098,
      "keyword": "toque",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toques": [
    {
      "id": 27632,
      "keyword": "toque",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27631,
      "keyword": "toque",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27630,
      "keyword": "toque",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34098,
      "keyword": "toque",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camboya": [
    {
      "id": 27646,
      "keyword": "Camboya",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir la temperatura": [
    {
      "id": 27644,
      "keyword": "subir la temperatura",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campo de béisbol": [
    {
      "id": 27647,
      "keyword": "campo de béisbol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campos de béisbol": [
    {
      "id": 27647,
      "keyword": "campo de béisbol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cartucho": [
    {
      "id": 29710,
      "keyword": "cartucho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27655,
      "keyword": "cartucho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cartuchos": [
    {
      "id": 29710,
      "keyword": "cartucho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27655,
      "keyword": "cartucho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cartucho de tinta": [
    {
      "id": 27655,
      "keyword": "cartucho de tinta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cartuchos de tinta": [
    {
      "id": 27655,
      "keyword": "cartucho de tinta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bután": [
    {
      "id": 27625,
      "keyword": "Bután",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "celadora": [
    {
      "id": 38910,
      "keyword": "celadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27663,
      "keyword": "celadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35281,
      "keyword": "celadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "health"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "celadoras": [
    {
      "id": 27663,
      "keyword": "celadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35281,
      "keyword": "celadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "health"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "celador": [
    {
      "id": 27662,
      "keyword": "celador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38910,
      "keyword": "celador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27661,
      "keyword": "celador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35287,
      "keyword": "celador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "celadores": [
    {
      "id": 27662,
      "keyword": "celador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38910,
      "keyword": "celador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27661,
      "keyword": "celador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35287,
      "keyword": "celador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centollo": [
    {
      "id": 27673,
      "keyword": "centollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centollos": [
    {
      "id": 27673,
      "keyword": "centollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centolla": [
    {
      "id": 27673,
      "keyword": "centolla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centollas": [
    {
      "id": 27673,
      "keyword": "centolla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "certificado": [
    {
      "id": 27677,
      "keyword": "certificado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "certificados": [
    {
      "id": 27677,
      "keyword": "certificado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "certificación": [
    {
      "id": 27677,
      "keyword": "certificación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "certificaciones": [
    {
      "id": 27677,
      "keyword": "certificación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contraseña": [
    {
      "id": 27691,
      "keyword": "contraseña",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contraseñas": [
    {
      "id": 27691,
      "keyword": "contraseña",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cacatúa": [
    {
      "id": 27640,
      "keyword": "cacatúa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "domestic",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cacatúas": [
    {
      "id": 27640,
      "keyword": "cacatúa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "domestic",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "curioso": [
    {
      "id": 27706,
      "keyword": "curioso",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27705,
      "keyword": "curioso",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "curiosos": [
    {
      "id": 27706,
      "keyword": "curioso",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27705,
      "keyword": "curioso",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "curiosear": [
    {
      "id": 27706,
      "keyword": "curiosear",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27705,
      "keyword": "curiosear",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27703,
      "keyword": "curiosear",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cotilla": [
    {
      "id": 27706,
      "keyword": "cotilla",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27705,
      "keyword": "cotilla",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27703,
      "keyword": "cotilla",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cotillas": [
    {
      "id": 27706,
      "keyword": "cotilla",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27705,
      "keyword": "cotilla",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27703,
      "keyword": "cotilla",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "curiosa": [
    {
      "id": 27706,
      "keyword": "curiosa",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27703,
      "keyword": "curiosa",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "curiosas": [
    {
      "id": 27706,
      "keyword": "curiosa",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27703,
      "keyword": "curiosa",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fisgón": [
    {
      "id": 27706,
      "keyword": "fisgón",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fisgones": [
    {
      "id": 27706,
      "keyword": "fisgón",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fisgona": [
    {
      "id": 27706,
      "keyword": "fisgona",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fisgonas": [
    {
      "id": 27706,
      "keyword": "fisgona",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cinta adhesiva": [
    {
      "id": 27681,
      "keyword": "cinta adhesiva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cintas adhesivas": [
    {
      "id": 27681,
      "keyword": "cinta adhesiva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diploma": [
    {
      "id": 27724,
      "keyword": "diploma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diplomas": [
    {
      "id": 27724,
      "keyword": "diploma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "explorar la garganta": [
    {
      "id": 27719,
      "keyword": "explorar la garganta",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "examinar la garganta": [
    {
      "id": 27719,
      "keyword": "examinar la garganta",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "depresor": [
    {
      "id": 27719,
      "keyword": "depresor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "depresores": [
    {
      "id": 27719,
      "keyword": "depresor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cotorra": [
    {
      "id": 27699,
      "keyword": "cotorra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "domestic",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cotorras": [
    {
      "id": 27699,
      "keyword": "cotorra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "domestic",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diada": [
    {
      "id": 27723,
      "keyword": "Diada",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encalar": [
    {
      "id": 27732,
      "keyword": "encalar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38280,
      "keyword": "encalar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27731,
      "keyword": "encalar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dejar las llaves": [
    {
      "id": 27717,
      "keyword": "dejar las llaves",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "depositar las llaves": [
    {
      "id": 27717,
      "keyword": "depositar las llaves",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entierro de la sardina": [
    {
      "id": 27737,
      "keyword": "Entierro de la Sardina",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "carnival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escalador": [
    {
      "id": 27739,
      "keyword": "escalador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35421,
      "keyword": "escalador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escaladores": [
    {
      "id": 27739,
      "keyword": "escalador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35421,
      "keyword": "escalador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bajar la temperatura": [
    {
      "id": 27735,
      "keyword": "bajar la temperatura",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfriar": [
    {
      "id": 27735,
      "keyword": "enfriar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escalada": [
    {
      "id": 27741,
      "keyword": "escalada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escanciar": [
    {
      "id": 27746,
      "keyword": "escanciar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27745,
      "keyword": "escanciar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29246,
      "keyword": "escanciar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "decorar el árbol": [
    {
      "id": 27715,
      "keyword": "decorar el árbol",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adornar el árbol": [
    {
      "id": 27715,
      "keyword": "adornar el árbol",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fauces": [
    {
      "id": 27755,
      "keyword": "fauces",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "emiratos árabes unidos": [
    {
      "id": 27730,
      "keyword": "Emiratos Árabes Unidos",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frase": [
    {
      "id": 27768,
      "keyword": "frase",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frases": [
    {
      "id": 27768,
      "keyword": "frase",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fideuá": [
    {
      "id": 27757,
      "keyword": "fideuá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fideuás": [
    {
      "id": 27757,
      "keyword": "fideuá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maracuyá": [
    {
      "id": 27776,
      "keyword": "maracuyá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maracuyás": [
    {
      "id": 27776,
      "keyword": "maracuyá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "freidora eléctrica": [
    {
      "id": 27772,
      "keyword": "freidora eléctrica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "freidoras eléctricas": [
    {
      "id": 27772,
      "keyword": "freidora eléctrica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "freidora": [
    {
      "id": 27772,
      "keyword": "freidora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "freidoras": [
    {
      "id": 27772,
      "keyword": "freidora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gasa": [
    {
      "id": 27794,
      "keyword": "gasa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gasas": [
    {
      "id": 27794,
      "keyword": "gasa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "globo terráqueo": [
    {
      "id": 27798,
      "keyword": "globo terráqueo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "globos terráqueos": [
    {
      "id": 27798,
      "keyword": "globo terráqueo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gorro de ducha": [
    {
      "id": 27802,
      "keyword": "gorro de ducha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gorros de ducha": [
    {
      "id": 27802,
      "keyword": "gorro de ducha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gotero": [
    {
      "id": 27806,
      "keyword": "gotero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "goteros": [
    {
      "id": 27806,
      "keyword": "gotero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "granero": [
    {
      "id": 27810,
      "keyword": "granero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "graneros": [
    {
      "id": 27810,
      "keyword": "granero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grapas": [
    {
      "id": 27814,
      "keyword": "grapas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32894,
      "keyword": "grapa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ganso": [
    {
      "id": 27780,
      "keyword": "ganso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gansos": [
    {
      "id": 27780,
      "keyword": "ganso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gansa": [
    {
      "id": 27780,
      "keyword": "gansa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gansas": [
    {
      "id": 27780,
      "keyword": "gansa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "filipinas": [
    {
      "id": 27761,
      "keyword": "Filipinas",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "filmar": [
    {
      "id": 37250,
      "keyword": "filmar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27762,
      "keyword": "filmar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37249,
      "keyword": "filmar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grabar": [
    {
      "id": 37250,
      "keyword": "grabar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28893,
      "keyword": "grabar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36924,
      "keyword": "grabar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27762,
      "keyword": "grabar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37249,
      "keyword": "grabar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guantes de cirujano": [
    {
      "id": 27817,
      "keyword": "guantes de cirujano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "covid-19",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gárgaras": [
    {
      "id": 30038,
      "keyword": "gárgaras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27784,
      "keyword": "gárgaras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30039,
      "keyword": "gárgaras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer gárgaras": [
    {
      "id": 30038,
      "keyword": "hacer gárgaras",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27784,
      "keyword": "hacer gárgaras",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30039,
      "keyword": "hacer gárgaras",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "implante coclear": [
    {
      "id": 27842,
      "keyword": "implante coclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39281,
      "keyword": "implante coclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27840,
      "keyword": "implante coclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27841,
      "keyword": "implante coclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32902,
      "keyword": "implante coclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39280,
      "keyword": "implante coclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39283,
      "keyword": "implante coclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39284,
      "keyword": "implante coclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "implantes cocleares": [
    {
      "id": 27842,
      "keyword": "implante coclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39281,
      "keyword": "implante coclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27840,
      "keyword": "implante coclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27841,
      "keyword": "implante coclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32902,
      "keyword": "implante coclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39280,
      "keyword": "implante coclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39283,
      "keyword": "implante coclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39284,
      "keyword": "implante coclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "kazajistán": [
    {
      "id": 27858,
      "keyword": "Kazajistán",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kuwait": [
    {
      "id": 27860,
      "keyword": "Kuwait",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kirguistán": [
    {
      "id": 27859,
      "keyword": "Kirguistán",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "laos": [
    {
      "id": 27861,
      "keyword": "Laos",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "líbano": [
    {
      "id": 27862,
      "keyword": "Líbano",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "malasia": [
    {
      "id": 27863,
      "keyword": "Malasia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maldivas": [
    {
      "id": 27864,
      "keyword": "Maldivas",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "licencia": [
    {
      "id": 27865,
      "keyword": "licencia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "licencias": [
    {
      "id": 27865,
      "keyword": "licencia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "licencia de obras": [
    {
      "id": 27865,
      "keyword": "licencia de obras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "licencias de obras": [
    {
      "id": 27865,
      "keyword": "licencia de obras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lectura labial": [
    {
      "id": 27873,
      "keyword": "lectura labial",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "lecturas labiales": [
    {
      "id": 27873,
      "keyword": "lectura labial",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "maquillar": [
    {
      "id": 27875,
      "keyword": "maquillar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "cosmetic",
        "event",
        "popular event",
        "carnival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "haití": [
    {
      "id": 27835,
      "keyword": "Haití",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29728,
      "keyword": "Haití",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marcapasos": [
    {
      "id": 27877,
      "keyword": "marcapasos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mirador": [
    {
      "id": 27885,
      "keyword": "mirador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "rural area"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27889,
      "keyword": "mirador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38729,
      "keyword": "mirador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "miradores": [
    {
      "id": 27885,
      "keyword": "mirador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "rural area"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27889,
      "keyword": "mirador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38729,
      "keyword": "mirador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "monitorizar": [
    {
      "id": 27897,
      "keyword": "monitorizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "indonesia": [
    {
      "id": 27852,
      "keyword": "Indonesia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jilguero": [
    {
      "id": 27853,
      "keyword": "jilguero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "domestic",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jilgueros": [
    {
      "id": 27853,
      "keyword": "jilguero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "domestic",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jilguera": [
    {
      "id": 27853,
      "keyword": "jilguera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "domestic",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jilgueras": [
    {
      "id": 27853,
      "keyword": "jilguera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "domestic",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "montar en tándem": [
    {
      "id": 27900,
      "keyword": "montar en tándem",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27899,
      "keyword": "montar en tándem",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muffin": [
    {
      "id": 27903,
      "keyword": "muffin",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27904,
      "keyword": "muffin",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muffins": [
    {
      "id": 27903,
      "keyword": "muffin",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27904,
      "keyword": "muffin",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nécora": [
    {
      "id": 27909,
      "keyword": "nécora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nécoras": [
    {
      "id": 27909,
      "keyword": "nécora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "máscara antigás": [
    {
      "id": 27881,
      "keyword": "máscara antigás",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máscaras antigás": [
    {
      "id": 27881,
      "keyword": "máscara antigás",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "operación": [
    {
      "id": 27925,
      "keyword": "operación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "operaciones": [
    {
      "id": 36562,
      "keyword": "operaciones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27925,
      "keyword": "operación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "intervención": [
    {
      "id": 37325,
      "keyword": "intervención",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27925,
      "keyword": "intervención",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intervenciones": [
    {
      "id": 27925,
      "keyword": "intervención",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cirugía": [
    {
      "id": 27925,
      "keyword": "cirugía",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cirugías": [
    {
      "id": 27925,
      "keyword": "cirugía",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paciente": [
    {
      "id": 27935,
      "keyword": "paciente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38908,
      "keyword": "paciente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38912,
      "keyword": "paciente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27933,
      "keyword": "paciente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27934,
      "keyword": "paciente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33928,
      "keyword": "paciente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33926,
      "keyword": "paciente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pacientes": [
    {
      "id": 27935,
      "keyword": "paciente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38908,
      "keyword": "paciente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38912,
      "keyword": "paciente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27933,
      "keyword": "paciente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27934,
      "keyword": "paciente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33928,
      "keyword": "paciente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33926,
      "keyword": "paciente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huevera": [
    {
      "id": 27836,
      "keyword": "huevera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37936,
      "keyword": "huevera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "animal-based food",
        "egg product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hueveras": [
    {
      "id": 27836,
      "keyword": "huevera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37936,
      "keyword": "huevera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "animal-based food",
        "egg product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ópera": [
    {
      "id": 27921,
      "keyword": "ópera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "show",
        "opera",
        "leisure",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 27917,
      "keyword": "ópera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "show",
        "opera",
        "leisure",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "óperas": [
    {
      "id": 27921,
      "keyword": "ópera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "show",
        "opera",
        "leisure",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 27917,
      "keyword": "ópera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "show",
        "opera",
        "leisure",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pez payaso": [
    {
      "id": 27968,
      "keyword": "pez payaso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peces payaso": [
    {
      "id": 27968,
      "keyword": "pez payaso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paracaídas": [
    {
      "id": 27949,
      "keyword": "paracaídas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28697,
      "keyword": "paracaídas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinchazo": [
    {
      "id": 27972,
      "keyword": "pinchazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "road safety",
        "land transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38746,
      "keyword": "pinchazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "medical procedure",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinchazos": [
    {
      "id": 27972,
      "keyword": "pinchazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "road safety",
        "land transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38746,
      "keyword": "pinchazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "medical procedure",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plumífero": [
    {
      "id": 27978,
      "keyword": "plumífero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plumíferos": [
    {
      "id": 27978,
      "keyword": "plumífero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pintar con brocha": [
    {
      "id": 27976,
      "keyword": "pintar con brocha",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "polilla": [
    {
      "id": 27982,
      "keyword": "polilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "polillas": [
    {
      "id": 27982,
      "keyword": "polilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "preoperatorio": [
    {
      "id": 27986,
      "keyword": "preoperatorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "preoperatorios": [
    {
      "id": 27986,
      "keyword": "preoperatorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "noreste": [
    {
      "id": 27913,
      "keyword": "Noreste",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nordeste": [
    {
      "id": 27913,
      "keyword": "Nordeste",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "púas": [
    {
      "id": 28016,
      "keyword": "púas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "queso azul": [
    {
      "id": 28018,
      "keyword": "queso azul",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quesos azules": [
    {
      "id": 28018,
      "keyword": "queso azul",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quirófano": [
    {
      "id": 28019,
      "keyword": "quirófano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31989,
      "keyword": "quirófano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38063,
      "keyword": "quirófano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quirófanos": [
    {
      "id": 28019,
      "keyword": "quirófano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31989,
      "keyword": "quirófano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38063,
      "keyword": "quirófano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "remangarse": [
    {
      "id": 28029,
      "keyword": "remangarse",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "remar": [
    {
      "id": 28032,
      "keyword": "remar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35837,
      "keyword": "remar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "surf"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35838,
      "keyword": "remar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "surf"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28031,
      "keyword": "remar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reptar": [
    {
      "id": 28040,
      "keyword": "reptar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28039,
      "keyword": "reptar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35043,
      "keyword": "reptar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "raqueta de bádminton": [
    {
      "id": 28023,
      "keyword": "raqueta de bádminton",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "raquetas de bádminton": [
    {
      "id": 28023,
      "keyword": "raqueta de bádminton",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "regular": [
    {
      "id": 28027,
      "keyword": "regular",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "regular la temperatura": [
    {
      "id": 28027,
      "keyword": "regular la temperatura",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "noroeste": [
    {
      "id": 27915,
      "keyword": "Noroeste",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rizador": [
    {
      "id": 28045,
      "keyword": "rizador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rizadores": [
    {
      "id": 28045,
      "keyword": "rizador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "scout": [
    {
      "id": 28053,
      "keyword": "scout",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28054,
      "keyword": "scout",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "scouts": [
    {
      "id": 28053,
      "keyword": "scout",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28054,
      "keyword": "scout",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mongolia": [
    {
      "id": 28061,
      "keyword": "Mongolia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nepal": [
    {
      "id": 28062,
      "keyword": "Nepal",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37644,
      "keyword": "Nepal",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibido marcapasos": [
    {
      "id": 28010,
      "keyword": "prohibido marcapasos",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibido implantes cocleares": [
    {
      "id": 28013,
      "keyword": "prohibido implantes cocleares",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sala de observación": [
    {
      "id": 28049,
      "keyword": "sala de observación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30470,
      "keyword": "sala de observación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35615,
      "keyword": "sala de observación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38876,
      "keyword": "sala de observación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de observación": [
    {
      "id": 28049,
      "keyword": "sala de observación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30470,
      "keyword": "sala de observación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35615,
      "keyword": "sala de observación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38876,
      "keyword": "sala de observación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "respiración asistida": [
    {
      "id": 28043,
      "keyword": "respiración asistida",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "respiraciones asistidas": [
    {
      "id": 28043,
      "keyword": "respiración asistida",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ventilación mecánica": [
    {
      "id": 28043,
      "keyword": "ventilación mecánica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ventilaciones mecánicas": [
    {
      "id": 28043,
      "keyword": "ventilación mecánica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anestesiar": [
    {
      "id": 39215,
      "keyword": "anestesiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28043,
      "keyword": "anestesiar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "singapur": [
    {
      "id": 28065,
      "keyword": "Singapur",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "siria": [
    {
      "id": 28066,
      "keyword": "Siria",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38820,
      "keyword": "Siria",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sri lanka": [
    {
      "id": 28067,
      "keyword": "Sri Lanka",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vietnam": [
    {
      "id": 28071,
      "keyword": "Vietnam",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yemen": [
    {
      "id": 28072,
      "keyword": "Yemen",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "qatar": [
    {
      "id": 28064,
      "keyword": "Qatar",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir a la trona": [
    {
      "id": 28073,
      "keyword": "subir a la trona",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "furniture",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28074,
      "keyword": "subir a la trona",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "furniture",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "separador": [
    {
      "id": 28077,
      "keyword": "separador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28078,
      "keyword": "separador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "separadores": [
    {
      "id": 28077,
      "keyword": "separador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28078,
      "keyword": "separador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "solicitar la parada": [
    {
      "id": 28089,
      "keyword": "solicitar la parada",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39278,
      "keyword": "solicitar la parada",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subtítulo": [
    {
      "id": 28091,
      "keyword": "subtítulo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28301,
      "keyword": "subtítulo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subtítulos": [
    {
      "id": 28091,
      "keyword": "subtítulo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28301,
      "keyword": "subtítulo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sudeste": [
    {
      "id": 28095,
      "keyword": "Sudeste",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sureste": [
    {
      "id": 28095,
      "keyword": "Sureste",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sudoeste": [
    {
      "id": 28096,
      "keyword": "Sudoeste",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suroeste": [
    {
      "id": 28096,
      "keyword": "Suroeste",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "protección civil": [
    {
      "id": 28014,
      "keyword": "Protección Civil",
      "keywords": 1,
      "type": 1,
      "tags": [
        "international organization",
        "work",
        "professional",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tándem": [
    {
      "id": 28103,
      "keyword": "tándem",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tándems": [
    {
      "id": 28103,
      "keyword": "tándem",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarjeta de transporte": [
    {
      "id": 28111,
      "keyword": "tarjeta de transporte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28115,
      "keyword": "tarjeta de transporte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28119,
      "keyword": "tarjeta de transporte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "air transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarjetas de transporte": [
    {
      "id": 28111,
      "keyword": "tarjeta de transporte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28115,
      "keyword": "tarjeta de transporte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28119,
      "keyword": "tarjeta de transporte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "air transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "omán": [
    {
      "id": 28063,
      "keyword": "Omán",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "uzbekistán": [
    {
      "id": 28070,
      "keyword": "Uzbekistán",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tensiómetro": [
    {
      "id": 28127,
      "keyword": "tensiómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28123,
      "keyword": "tensiómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tensiómetros": [
    {
      "id": 28127,
      "keyword": "tensiómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28123,
      "keyword": "tensiómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "turkmenistan": [
    {
      "id": 28069,
      "keyword": "Turkmenistan",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corrector líquido": [
    {
      "id": 28139,
      "keyword": "corrector líquido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "correctores líquidos": [
    {
      "id": 28139,
      "keyword": "corrector líquido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tirolina": [
    {
      "id": 28141,
      "keyword": "tirolina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36077,
      "keyword": "tirolina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "outdoor activity",
        "mountain",
        "playground"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tirolinas": [
    {
      "id": 28141,
      "keyword": "tirolina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36077,
      "keyword": "tirolina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "outdoor activity",
        "mountain",
        "playground"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "urinario": [
    {
      "id": 28159,
      "keyword": "urinario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "urinarios": [
    {
      "id": 28159,
      "keyword": "urinario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "triturar": [
    {
      "id": 28157,
      "keyword": "triturar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chafar": [
    {
      "id": 28157,
      "keyword": "chafar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38694,
      "keyword": "chafar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "uvi móvil": [
    {
      "id": 28163,
      "keyword": "Uvi móvil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "uvis móviles": [
    {
      "id": 28163,
      "keyword": "Uvi móvil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tayikistan": [
    {
      "id": 28068,
      "keyword": "Tayikistan",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vespa": [
    {
      "id": 28167,
      "keyword": "vespa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vespas": [
    {
      "id": 28167,
      "keyword": "vespa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "borrar con corrector líquido": [
    {
      "id": 28189,
      "keyword": "borrar con corrector líquido",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "visitar al paciente": [
    {
      "id": 28187,
      "keyword": "visitar al paciente",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casco de hípica": [
    {
      "id": 28195,
      "keyword": "casco de hípica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "horse riding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cascos de hípica": [
    {
      "id": 28195,
      "keyword": "casco de hípica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "horse riding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casco de patinaje": [
    {
      "id": 28191,
      "keyword": "casco de patinaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "skating"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cascos de patinaje": [
    {
      "id": 28191,
      "keyword": "casco de patinaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "skating"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adulta": [
    {
      "id": 28201,
      "keyword": "adulta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adultas": [
    {
      "id": 28201,
      "keyword": "adulta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almuerzo": [
    {
      "id": 28205,
      "keyword": "almuerzo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37843,
      "keyword": "almuerzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "feeding",
        "health",
        "lifestyle",
        "healthy habit",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28207,
      "keyword": "almuerzo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28206,
      "keyword": "almuerzo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almuerzos": [
    {
      "id": 28205,
      "keyword": "almuerzo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37843,
      "keyword": "almuerzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "feeding",
        "health",
        "lifestyle",
        "healthy habit",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28207,
      "keyword": "almuerzo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28206,
      "keyword": "almuerzo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almorzar": [
    {
      "id": 28205,
      "keyword": "almorzar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28207,
      "keyword": "almorzar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28206,
      "keyword": "almorzar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balneario": [
    {
      "id": 28203,
      "keyword": "balneario",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balnearios": [
    {
      "id": 28203,
      "keyword": "balneario",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tortaa de choclo": [
    {
      "id": 28145,
      "keyword": "torta de choclo",
      "keywords": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "torta del casar": [
    {
      "id": 28149,
      "keyword": "Torta del Casar",
      "keywords": 1,
      "type": 1,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casino": [
    {
      "id": 28228,
      "keyword": "casino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28227,
      "keyword": "casino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casinos": [
    {
      "id": 28228,
      "keyword": "casino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28227,
      "keyword": "casino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recién nacido": [
    {
      "id": 28215,
      "keyword": "recién nacido",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28216,
      "keyword": "recién nacido",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recién nacidos": [
    {
      "id": 28215,
      "keyword": "recién nacido",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28216,
      "keyword": "recién nacido",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "neonato": [
    {
      "id": 28215,
      "keyword": "neonato",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28216,
      "keyword": "neonato",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "neonatos": [
    {
      "id": 28215,
      "keyword": "neonato",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28216,
      "keyword": "neonato",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "baby",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comentarista": [
    {
      "id": 28238,
      "keyword": "comentarista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28237,
      "keyword": "comentarista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37224,
      "keyword": "comentarista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comentaristas": [
    {
      "id": 28238,
      "keyword": "comentarista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28237,
      "keyword": "comentarista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37224,
      "keyword": "comentarista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuentacuentos": [
    {
      "id": 35951,
      "keyword": "cuentacuentos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28241,
      "keyword": "cuentacuentos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28242,
      "keyword": "cuentacuentos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casa rural": [
    {
      "id": 28225,
      "keyword": "casa rural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28926,
      "keyword": "casa rural",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casas rurales": [
    {
      "id": 28225,
      "keyword": "casa rural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28926,
      "keyword": "casa rural",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "turismo rural": [
    {
      "id": 28225,
      "keyword": "turismo rural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28926,
      "keyword": "turismo rural",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diabetes": [
    {
      "id": 28245,
      "keyword": "diabetes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brocheta de gambas": [
    {
      "id": 28221,
      "keyword": "brocheta de gambas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brochetas de gambas": [
    {
      "id": 28221,
      "keyword": "brocheta de gambas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gambas al ajillo": [
    {
      "id": 28221,
      "keyword": "gambas al ajillo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estrofa": [
    {
      "id": 28251,
      "keyword": "estrofa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estrofas": [
    {
      "id": 28251,
      "keyword": "estrofa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "autentificación": [
    {
      "id": 28253,
      "keyword": "autentificación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autentificaciones": [
    {
      "id": 28253,
      "keyword": "autentificación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carne de cordero": [
    {
      "id": 28223,
      "keyword": "carne de cordero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carnes de cordero": [
    {
      "id": 28223,
      "keyword": "carne de cordero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "costillas de cordero": [
    {
      "id": 28223,
      "keyword": "costillas de cordero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar de la trona": [
    {
      "id": 28256,
      "keyword": "bajar de la trona",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "furniture",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28255,
      "keyword": "bajar de la trona",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "furniture",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "castillo hinchable": [
    {
      "id": 28259,
      "keyword": "castillo hinchable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "castillos hinchables": [
    {
      "id": 28259,
      "keyword": "castillo hinchable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "día de san jorge": [
    {
      "id": 28267,
      "keyword": "Día de San Jorge",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empujar la camilla": [
    {
      "id": 28269,
      "keyword": "empujar la camilla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "validar": [
    {
      "id": 28291,
      "keyword": "validar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28292,
      "keyword": "validar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jueves graso": [
    {
      "id": 28279,
      "keyword": "Jueves Graso",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "carnival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pastilla de caldo": [
    {
      "id": 28297,
      "keyword": "pastilla de caldo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pastillas de caldo": [
    {
      "id": 28297,
      "keyword": "pastilla de caldo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jueves lardero": [
    {
      "id": 28281,
      "keyword": "Jueves Lardero",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "carnival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "edificio de oficinas": [
    {
      "id": 28311,
      "keyword": "edificio de oficinas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "edificios de oficinas": [
    {
      "id": 28311,
      "keyword": "edificio de oficinas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gafa de seguridad": [
    {
      "id": 28275,
      "keyword": "gafa de seguridad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gafas de seguridad": [
    {
      "id": 28275,
      "keyword": "gafa de seguridad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grageas de chocolate": [
    {
      "id": 28305,
      "keyword": "grageas de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lacasitos": [
    {
      "id": 28305,
      "keyword": "lacasitos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hotel accesible": [
    {
      "id": 28351,
      "keyword": "hotel accesible",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hoteles accesibles": [
    {
      "id": 28351,
      "keyword": "hotel accesible",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jurar": [
    {
      "id": 28353,
      "keyword": "jurar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28354,
      "keyword": "jurar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ingeniero técnico": [
    {
      "id": 28349,
      "keyword": "ingeniero técnico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "engineering",
        "tertiary sector",
        "professional services",
        "secondary sector",
        "industry",
        "manufacturing industry",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ingenieros técnicos": [
    {
      "id": 28349,
      "keyword": "ingeniero técnico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "engineering",
        "tertiary sector",
        "professional services",
        "secondary sector",
        "industry",
        "manufacturing industry",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "foto de perfil": [
    {
      "id": 28307,
      "keyword": "foto de perfil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "photography",
        "computing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36794,
      "keyword": "foto de perfil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "photography",
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fotos de perfil": [
    {
      "id": 28307,
      "keyword": "foto de perfil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "photography",
        "computing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36794,
      "keyword": "foto de perfil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "photography",
        "computing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "segundos": [
    {
      "id": 28320,
      "keyword": "segundo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34477,
      "keyword": "segundo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37748,
      "keyword": "segundo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carne de membrillo": [
    {
      "id": 28357,
      "keyword": "carne de membrillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carnes de membrillo": [
    {
      "id": 28357,
      "keyword": "carne de membrillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dulce de membrillo": [
    {
      "id": 28357,
      "keyword": "dulce de membrillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "si": [
    {
      "id": 28359,
      "keyword": "si",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "conjunction",
        "conditional conjunction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jamonero": [
    {
      "id": 28367,
      "keyword": "jamonero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jamoneros": [
    {
      "id": 28367,
      "keyword": "jamonero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clasificación decimal universal": [
    {
      "id": 28372,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28374,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28375,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28376,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28377,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28370,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28371,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28378,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28382,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28383,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28384,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28381,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28380,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28373,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28379,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28369,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38152,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38153,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38154,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38155,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38156,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38157,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38158,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38159,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38160,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38161,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38162,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38163,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38164,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38165,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38166,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38167,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38168,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38169,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38170,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38171,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38172,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38173,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38174,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38175,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38176,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38177,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38178,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38179,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38180,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38181,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38182,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38183,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38184,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38185,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38186,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38187,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38188,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38189,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38190,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38191,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38192,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38193,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38194,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38195,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38196,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38197,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38198,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38608,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38614,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38615,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38616,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33963,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 3,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33962,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 3,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33965,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 3,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33964,
      "keyword": "Clasificación Decimal Universal",
      "keywords": 3,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cdu": [
    {
      "id": 28372,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28374,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28375,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28376,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28377,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28370,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28371,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28378,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28382,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28383,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28384,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28381,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28380,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28373,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28379,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28369,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38152,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38153,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38154,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38155,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38156,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38157,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38158,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38159,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38160,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38161,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38162,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38163,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38164,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38165,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38166,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38167,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38168,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38169,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38170,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38171,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38172,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38173,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38174,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38175,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38176,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38177,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38178,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38179,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38180,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38181,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38182,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38183,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38184,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38185,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38186,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38187,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38188,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38189,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38190,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38191,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38192,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38193,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38194,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38195,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38196,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38197,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38198,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38608,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38614,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38615,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38616,
      "keyword": "CDU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33963,
      "keyword": "CDU",
      "keywords": 3,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33962,
      "keyword": "CDU",
      "keywords": 3,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33965,
      "keyword": "CDU",
      "keywords": 3,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33964,
      "keyword": "CDU",
      "keywords": 3,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pensión": [
    {
      "id": 28363,
      "keyword": "pensión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pensiones": [
    {
      "id": 28363,
      "keyword": "pensión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "microbús": [
    {
      "id": 28405,
      "keyword": "microbús",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "microbuses": [
    {
      "id": 28405,
      "keyword": "microbús",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comer un bocadillo": [
    {
      "id": 28413,
      "keyword": "comer un bocadillo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28414,
      "keyword": "comer un bocadillo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28415,
      "keyword": "comer un bocadillo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "páncreas": [
    {
      "id": 28407,
      "keyword": "páncreas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sestear": [
    {
      "id": 28425,
      "keyword": "sestear",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35891,
      "keyword": "sestear",
      "keywords": 3,
      "type": 3,
      "tags": [
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "siesta": [
    {
      "id": 28425,
      "keyword": "siesta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35891,
      "keyword": "siesta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28426,
      "keyword": "siesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36385,
      "keyword": "siesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36386,
      "keyword": "siesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "siestas": [
    {
      "id": 28425,
      "keyword": "siesta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35891,
      "keyword": "siesta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28426,
      "keyword": "siesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36385,
      "keyword": "siesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36386,
      "keyword": "siesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dormir la siesta": [
    {
      "id": 28425,
      "keyword": "dormir la siesta",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35891,
      "keyword": "dormir la siesta",
      "keywords": 3,
      "type": 3,
      "tags": [
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡se acabó!": [
    {
      "id": 28429,
      "keyword": "¡se acabó!",
      "keywords": 8,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "se acabó": [
    {
      "id": 28429,
      "keyword": "se acabó",
      "keywords": 8,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡basta ya!": [
    {
      "id": 28429,
      "keyword": "¡basta ya!",
      "keywords": 8,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "basta ya": [
    {
      "id": 28429,
      "keyword": "basta ya",
      "keywords": 8,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ya está": [
    {
      "id": 28429,
      "keyword": "ya está",
      "keywords": 8,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "berberecho": [
    {
      "id": 28461,
      "keyword": "berberecho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "berberechos": [
    {
      "id": 28461,
      "keyword": "berberecho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ánade": [
    {
      "id": 28479,
      "keyword": "ánade",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "flying animal",
        "work",
        "primary sector",
        "hunting",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28477,
      "keyword": "ánade",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "aquatic animal",
        "freshwater animal",
        "river",
        "oviparous",
        "flying animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ánades": [
    {
      "id": 28479,
      "keyword": "ánade",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "flying animal",
        "work",
        "primary sector",
        "hunting",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28477,
      "keyword": "ánade",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "aquatic animal",
        "freshwater animal",
        "river",
        "oviparous",
        "flying animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sepia": [
    {
      "id": 28465,
      "keyword": "sepia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28466,
      "keyword": "sepia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sepias": [
    {
      "id": 28465,
      "keyword": "sepia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28466,
      "keyword": "sepia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jibia": [
    {
      "id": 28465,
      "keyword": "jibia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28466,
      "keyword": "jibia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jibias": [
    {
      "id": 28465,
      "keyword": "jibia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28466,
      "keyword": "jibia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "izar": [
    {
      "id": 28489,
      "keyword": "izar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "geography",
        "political geography",
        "flag"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secar la cara": [
    {
      "id": 37835,
      "keyword": "secar la cara",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28507,
      "keyword": "secar la cara",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37777,
      "keyword": "secar la cara",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lentillas": [
    {
      "id": 28511,
      "keyword": "lentillas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lente de contacto": [
    {
      "id": 28511,
      "keyword": "lente de contacto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lentes de contacto": [
    {
      "id": 28511,
      "keyword": "lente de contacto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cascanueces": [
    {
      "id": 28517,
      "keyword": "cascanueces",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colgante": [
    {
      "id": 28525,
      "keyword": "colgante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colgantes": [
    {
      "id": 28525,
      "keyword": "colgante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llavero": [
    {
      "id": 28537,
      "keyword": "llavero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llaveros": [
    {
      "id": 28537,
      "keyword": "llavero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gajo": [
    {
      "id": 28521,
      "keyword": "gajo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gajos": [
    {
      "id": 28521,
      "keyword": "gajo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gancho": [
    {
      "id": 28529,
      "keyword": "gancho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ganchos": [
    {
      "id": 28529,
      "keyword": "gancho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jarrón": [
    {
      "id": 28541,
      "keyword": "jarrón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jarrones": [
    {
      "id": 28541,
      "keyword": "jarrón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maza": [
    {
      "id": 28545,
      "keyword": "maza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "gymnastics",
        "rhythmic gymnastics",
        "event",
        "sport event",
        "olympic games"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28549,
      "keyword": "maza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mazas": [
    {
      "id": 28545,
      "keyword": "maza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "gymnastics",
        "rhythmic gymnastics",
        "event",
        "sport event",
        "olympic games"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28549,
      "keyword": "maza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "metrónomo": [
    {
      "id": 28553,
      "keyword": "metrónomo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "metrónomos": [
    {
      "id": 28553,
      "keyword": "metrónomo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llave grifa": [
    {
      "id": 28533,
      "keyword": "llave grifa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llaves grifas": [
    {
      "id": 28533,
      "keyword": "llave grifa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "molinillo de café": [
    {
      "id": 28557,
      "keyword": "molinillo de café",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "molinillos de café": [
    {
      "id": 28557,
      "keyword": "molinillo de café",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hacha de carnicero": [
    {
      "id": 28573,
      "keyword": "hacha de carnicero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hachas de carnicero": [
    {
      "id": 28573,
      "keyword": "hacha de carnicero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "patito de goma": [
    {
      "id": 28577,
      "keyword": "patito de goma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patitos de goma": [
    {
      "id": 28577,
      "keyword": "patito de goma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peineta": [
    {
      "id": 28581,
      "keyword": "peineta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36426,
      "keyword": "peineta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peinetas": [
    {
      "id": 28581,
      "keyword": "peineta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ruejos": [
    {
      "id": 28585,
      "keyword": "ruejos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ponerse las gafas": [
    {
      "id": 28589,
      "keyword": "ponerse las gafas",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28587,
      "keyword": "ponerse las gafas",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28588,
      "keyword": "ponerse las gafas",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ponerse las lentes": [
    {
      "id": 28589,
      "keyword": "ponerse las lentes",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28587,
      "keyword": "ponerse las lentes",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28588,
      "keyword": "ponerse las lentes",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ponerse los anteojos": [
    {
      "id": 28589,
      "keyword": "ponerse los anteojos",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28587,
      "keyword": "ponerse los anteojos",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28588,
      "keyword": "ponerse los anteojos",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner las gafas": [
    {
      "id": 28589,
      "keyword": "poner las gafas",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28587,
      "keyword": "poner las gafas",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28588,
      "keyword": "poner las gafas",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner los anteojos": [
    {
      "id": 28589,
      "keyword": "poner los anteojos",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28587,
      "keyword": "poner los anteojos",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28588,
      "keyword": "poner los anteojos",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner las lentes": [
    {
      "id": 28589,
      "keyword": "poner las lentes",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28587,
      "keyword": "poner las lentes",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28588,
      "keyword": "poner las lentes",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitarse las gafas": [
    {
      "id": 28595,
      "keyword": "quitarse las gafas",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28593,
      "keyword": "quitarse las gafas",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28594,
      "keyword": "quitarse las gafas",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitarse las lentes": [
    {
      "id": 28595,
      "keyword": "quitarse las lentes",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28593,
      "keyword": "quitarse las lentes",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28594,
      "keyword": "quitarse las lentes",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitarse los anteojos": [
    {
      "id": 28595,
      "keyword": "quitarse los anteojos",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28593,
      "keyword": "quitarse los anteojos",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28594,
      "keyword": "quitarse los anteojos",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar las gafas": [
    {
      "id": 28595,
      "keyword": "quitar las gafas",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28593,
      "keyword": "quitar las gafas",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28594,
      "keyword": "quitar las gafas",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar las lentes": [
    {
      "id": 28595,
      "keyword": "quitar las lentes",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28593,
      "keyword": "quitar las lentes",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28594,
      "keyword": "quitar las lentes",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar los anteojos": [
    {
      "id": 28595,
      "keyword": "quitar los anteojos",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28593,
      "keyword": "quitar los anteojos",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28594,
      "keyword": "quitar los anteojos",
      "keywords": 6,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "health",
        "medicine",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cronometrar": [
    {
      "id": 28599,
      "keyword": "cronometrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport material",
        "object",
        "appliance",
        "time",
        "chronological device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patatas con chorizo": [
    {
      "id": 28601,
      "keyword": "patatas con chorizo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papas con chorizo": [
    {
      "id": 28601,
      "keyword": "papas con chorizo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hojas secas": [
    {
      "id": 28571,
      "keyword": "hojas secas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "autumn"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muelle": [
    {
      "id": 28563,
      "keyword": "muelle",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muelles": [
    {
      "id": 28563,
      "keyword": "muelle",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desatascar": [
    {
      "id": 28607,
      "keyword": "desatascar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desatancar": [
    {
      "id": 28607,
      "keyword": "desatancar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "narciso": [
    {
      "id": 28567,
      "keyword": "narciso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "narcisos": [
    {
      "id": 28567,
      "keyword": "narciso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tener ganas de hacer pis": [
    {
      "id": 28613,
      "keyword": "tener ganas de hacer pis",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "human body",
        "body sensation",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28614,
      "keyword": "tener ganas de hacer pis",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "human body",
        "body sensation",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pádel": [
    {
      "id": 28609,
      "keyword": "pádel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35241,
      "keyword": "pádel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35242,
      "keyword": "pádel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugar al pádel": [
    {
      "id": 28609,
      "keyword": "jugar al pádel",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35241,
      "keyword": "jugar al pádel",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35242,
      "keyword": "jugar al pádel",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empedrado": [
    {
      "id": 28627,
      "keyword": "empedrado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empedrados": [
    {
      "id": 28627,
      "keyword": "empedrado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barra española": [
    {
      "id": 28611,
      "keyword": "barra española",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barra aragonesa": [
    {
      "id": 28611,
      "keyword": "barra aragonesa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lanzamiento de barra": [
    {
      "id": 28611,
      "keyword": "lanzamiento de barra",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lanzamientos de barra": [
    {
      "id": 28611,
      "keyword": "lanzamiento de barra",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dosificar": [
    {
      "id": 28639,
      "keyword": "dosificar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despierta": [
    {
      "id": 28631,
      "keyword": "despierta",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despiertas": [
    {
      "id": 28631,
      "keyword": "despierta",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolor de cabeza": [
    {
      "id": 28651,
      "keyword": "dolor de cabeza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28754,
      "keyword": "dolor de cabeza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28753,
      "keyword": "dolor de cabeza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31871,
      "keyword": "dolor de cabeza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32160,
      "keyword": "dolor de cabeza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolores de cabeza": [
    {
      "id": 28651,
      "keyword": "dolor de cabeza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28754,
      "keyword": "dolor de cabeza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28753,
      "keyword": "dolor de cabeza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31871,
      "keyword": "dolor de cabeza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32160,
      "keyword": "dolor de cabeza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pelo largo": [
    {
      "id": 28681,
      "keyword": "pelo largo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38535,
      "keyword": "pelo largo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelos largos": [
    {
      "id": 28681,
      "keyword": "pelo largo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arroz al horno": [
    {
      "id": 28685,
      "keyword": "arroz al horno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arroces al horno": [
    {
      "id": 28685,
      "keyword": "arroz al horno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pelo corto": [
    {
      "id": 28683,
      "keyword": "pelo corto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelos cortos": [
    {
      "id": 28683,
      "keyword": "pelo corto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vainilla": [
    {
      "id": 28679,
      "keyword": "vainilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "spices"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vainillas": [
    {
      "id": 28679,
      "keyword": "vainilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "spices"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gallina ciega": [
    {
      "id": 28695,
      "keyword": "gallina ciega",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28693,
      "keyword": "gallina ciega",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "catálogo de juguetes": [
    {
      "id": 28721,
      "keyword": "catálogo de juguetes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "leisure",
        "sport",
        "toy",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "catálogos de juguetes": [
    {
      "id": 28721,
      "keyword": "catálogo de juguetes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "leisure",
        "sport",
        "toy",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "catálogo": [
    {
      "id": 28717,
      "keyword": "catálogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "catálogos": [
    {
      "id": 28717,
      "keyword": "catálogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hiedra": [
    {
      "id": 28725,
      "keyword": "hiedra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "bush"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hiedras": [
    {
      "id": 28725,
      "keyword": "hiedra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "bush"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lanzar un dardo": [
    {
      "id": 28727,
      "keyword": "lanzar un dardo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "preocupada": [
    {
      "id": 28713,
      "keyword": "preocupada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "preocupadas": [
    {
      "id": 28713,
      "keyword": "preocupada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolor de muelas": [
    {
      "id": 28757,
      "keyword": "dolor de muelas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28758,
      "keyword": "dolor de muelas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolores de muelas": [
    {
      "id": 28757,
      "keyword": "dolor de muelas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28758,
      "keyword": "dolor de muelas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolor de garganta": [
    {
      "id": 28761,
      "keyword": "dolor de garganta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28762,
      "keyword": "dolor de garganta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolores de garganta": [
    {
      "id": 28761,
      "keyword": "dolor de garganta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28762,
      "keyword": "dolor de garganta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolor de estómago": [
    {
      "id": 28765,
      "keyword": "dolor de estómago",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28766,
      "keyword": "dolor de estómago",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolores de estómago": [
    {
      "id": 28765,
      "keyword": "dolor de estómago",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28766,
      "keyword": "dolor de estómago",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolor de tripa": [
    {
      "id": 28765,
      "keyword": "dolor de tripa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28766,
      "keyword": "dolor de tripa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32148,
      "keyword": "dolor de tripa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolores de tripa": [
    {
      "id": 28765,
      "keyword": "dolor de tripa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28766,
      "keyword": "dolor de tripa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32148,
      "keyword": "dolor de tripa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolor de pierna": [
    {
      "id": 28770,
      "keyword": "dolor de pierna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28769,
      "keyword": "dolor de pierna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolores de pierna": [
    {
      "id": 28770,
      "keyword": "dolor de pierna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28769,
      "keyword": "dolor de pierna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolor de brazo": [
    {
      "id": 28773,
      "keyword": "dolor de brazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28774,
      "keyword": "dolor de brazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolores de brazo": [
    {
      "id": 28773,
      "keyword": "dolor de brazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28774,
      "keyword": "dolor de brazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolor de oído": [
    {
      "id": 28777,
      "keyword": "dolor de oído",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28778,
      "keyword": "dolor de oído",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolores de oído": [
    {
      "id": 28777,
      "keyword": "dolor de oído",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28778,
      "keyword": "dolor de oído",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolor de oídos": [
    {
      "id": 28777,
      "keyword": "dolor de oídos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28778,
      "keyword": "dolor de oídos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolores de oídos": [
    {
      "id": 28777,
      "keyword": "dolor de oídos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28778,
      "keyword": "dolor de oídos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oído dolorido": [
    {
      "id": 28777,
      "keyword": "oído dolorido",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28778,
      "keyword": "oído dolorido",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oídos doloridos": [
    {
      "id": 28777,
      "keyword": "oído dolorido",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28778,
      "keyword": "oído dolorido",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolor de culo": [
    {
      "id": 28789,
      "keyword": "dolor de culo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28790,
      "keyword": "dolor de culo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolores de culo": [
    {
      "id": 28789,
      "keyword": "dolor de culo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28790,
      "keyword": "dolor de culo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cansada": [
    {
      "id": 35537,
      "keyword": "cansada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "human body",
        "body sensation",
        "covid-19",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28709,
      "keyword": "cansada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "human body",
        "body sensation",
        "health",
        "medicine",
        "symptom",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cansadas": [
    {
      "id": 35537,
      "keyword": "cansada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "human body",
        "body sensation",
        "covid-19",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28709,
      "keyword": "cansada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion",
        "human body",
        "body sensation",
        "health",
        "medicine",
        "symptom",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "san valero": [
    {
      "id": 28701,
      "keyword": "San Valero",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "historical character",
        "history",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flequillo": [
    {
      "id": 28803,
      "keyword": "flequillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flequillos": [
    {
      "id": 28803,
      "keyword": "flequillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quebrantahuesos": [
    {
      "id": 28819,
      "keyword": "quebrantahuesos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "graduación de la vista": [
    {
      "id": 39489,
      "keyword": "graduación de la vista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39490,
      "keyword": "graduación de la vista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28823,
      "keyword": "graduación de la vista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28824,
      "keyword": "graduación de la vista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30660,
      "keyword": "graduación de la vista",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30661,
      "keyword": "graduación de la vista",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "graduar la vista": [
    {
      "id": 39489,
      "keyword": "graduar la vista",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39490,
      "keyword": "graduar la vista",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37627,
      "keyword": "graduar la vista",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37628,
      "keyword": "graduar la vista",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28823,
      "keyword": "graduar la vista",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28824,
      "keyword": "graduar la vista",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30660,
      "keyword": "graduar la vista",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30661,
      "keyword": "graduar la vista",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "optometría": [
    {
      "id": 28825,
      "keyword": "optometría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28826,
      "keyword": "optometría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30660,
      "keyword": "optometría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30661,
      "keyword": "optometría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "revisión oftalmológica": [
    {
      "id": 28825,
      "keyword": "revisión oftalmológica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28826,
      "keyword": "revisión oftalmológica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "revisar la vista": [
    {
      "id": 28825,
      "keyword": "revisar la vista",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28826,
      "keyword": "revisar la vista",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hibernar": [
    {
      "id": 28831,
      "keyword": "hibernar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "animal",
        "animal physiology",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cambio": [
    {
      "id": 31955,
      "keyword": "cambio",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28833,
      "keyword": "cambio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cambios": [
    {
      "id": 31955,
      "keyword": "cambio",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28833,
      "keyword": "cambio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dar el cambio": [
    {
      "id": 28833,
      "keyword": "dar el cambio",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "devolver el cambio": [
    {
      "id": 28833,
      "keyword": "devolver el cambio",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "trade",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suturar": [
    {
      "id": 28837,
      "keyword": "suturar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28838,
      "keyword": "suturar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nogal": [
    {
      "id": 28853,
      "keyword": "nogal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nogales": [
    {
      "id": 28853,
      "keyword": "nogal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "avellano": [
    {
      "id": 28857,
      "keyword": "avellano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "avellanos": [
    {
      "id": 28857,
      "keyword": "avellano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zarzas": [
    {
      "id": 28861,
      "keyword": "zarzas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "bush"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "explorador": [
    {
      "id": 28865,
      "keyword": "explorador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exploradores": [
    {
      "id": 28865,
      "keyword": "explorador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escultista": [
    {
      "id": 28865,
      "keyword": "escultista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28866,
      "keyword": "escultista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escultistas": [
    {
      "id": 28865,
      "keyword": "escultista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28866,
      "keyword": "escultista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desnuda": [
    {
      "id": 28873,
      "keyword": "desnuda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "adult",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31255,
      "keyword": "desnuda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "adult",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31266,
      "keyword": "desnuda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "child",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31254,
      "keyword": "desnuda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "teenager",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34635,
      "keyword": "desnuda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desnudas": [
    {
      "id": 28873,
      "keyword": "desnuda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "adult",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31255,
      "keyword": "desnuda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "adult",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31266,
      "keyword": "desnuda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "child",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31254,
      "keyword": "desnuda",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "teenager",
        "routine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34635,
      "keyword": "desnuda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chata": [
    {
      "id": 28809,
      "keyword": "chata",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chatas": [
    {
      "id": 28809,
      "keyword": "chata",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botas de esquí": [
    {
      "id": 28815,
      "keyword": "botas de esquí",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chato": [
    {
      "id": 28807,
      "keyword": "chato",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chatos": [
    {
      "id": 28807,
      "keyword": "chato",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estand": [
    {
      "id": 28877,
      "keyword": "estand",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estands": [
    {
      "id": 28877,
      "keyword": "estand",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "exploradora": [
    {
      "id": 28866,
      "keyword": "exploradora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exploradoras": [
    {
      "id": 28866,
      "keyword": "exploradora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "buffet libre": [
    {
      "id": 28885,
      "keyword": "buffet libre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buffets libres": [
    {
      "id": 28885,
      "keyword": "buffet libre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "póster": [
    {
      "id": 28881,
      "keyword": "póster",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pósteres": [
    {
      "id": 28881,
      "keyword": "póster",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cafetería": [
    {
      "id": 32400,
      "keyword": "cafetería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37337,
      "keyword": "cafetería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28889,
      "keyword": "cafetería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cafeterías": [
    {
      "id": 32400,
      "keyword": "cafetería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37337,
      "keyword": "cafetería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28889,
      "keyword": "cafetería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rueda de prensa": [
    {
      "id": 28895,
      "keyword": "rueda de prensa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ruedas de prensa": [
    {
      "id": 28895,
      "keyword": "rueda de prensa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "musgo": [
    {
      "id": 28843,
      "keyword": "musgo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "musgos": [
    {
      "id": 28843,
      "keyword": "musgo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barca turística": [
    {
      "id": 28913,
      "keyword": "barca turística",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barcas turísticas": [
    {
      "id": 28913,
      "keyword": "barca turística",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barco turístico": [
    {
      "id": 28913,
      "keyword": "barco turístico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barcos turísticos": [
    {
      "id": 28913,
      "keyword": "barco turístico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "outdoor activity",
        "beach",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aizcolari": [
    {
      "id": 28917,
      "keyword": "aizcolari",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aizcolaris": [
    {
      "id": 28917,
      "keyword": "aizcolari",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "funicular": [
    {
      "id": 28909,
      "keyword": "funicular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "funiculares": [
    {
      "id": 28909,
      "keyword": "funicular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arroz tres delicias": [
    {
      "id": 28923,
      "keyword": "arroz tres delicias",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arroces tres delicias": [
    {
      "id": 28923,
      "keyword": "arroz tres delicias",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anchoa": [
    {
      "id": 28930,
      "keyword": "anchoa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anchoas": [
    {
      "id": 28930,
      "keyword": "anchoa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hacienda": [
    {
      "id": 35449,
      "keyword": "hacienda",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28926,
      "keyword": "hacienda",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "haciendas": [
    {
      "id": 28926,
      "keyword": "hacienda",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bus turístico": [
    {
      "id": 28905,
      "keyword": "bus turístico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buses turísticos": [
    {
      "id": 28905,
      "keyword": "bus turístico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lata de chipirones": [
    {
      "id": 28938,
      "keyword": "lata de chipirones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "seafood",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "latas de chipirones": [
    {
      "id": 28938,
      "keyword": "lata de chipirones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "seafood",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "catamarán": [
    {
      "id": 28901,
      "keyword": "catamarán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "catamaranes": [
    {
      "id": 28901,
      "keyword": "catamarán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peine del viento": [
    {
      "id": 28899,
      "keyword": "Peine del Viento",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "visual art",
        "sculpture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chipirones en su tinta": [
    {
      "id": 28942,
      "keyword": "chipirones en su tinta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pacharán": [
    {
      "id": 28954,
      "keyword": "pacharán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pacharanes": [
    {
      "id": 28954,
      "keyword": "pacharán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "san sebastián": [
    {
      "id": 28960,
      "keyword": "San Sebastián",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "city"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "traineras": [
    {
      "id": 28962,
      "keyword": "traineras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sidrería": [
    {
      "id": 32164,
      "keyword": "sidrería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 28946,
      "keyword": "sidrería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sidrerías": [
    {
      "id": 32164,
      "keyword": "sidrería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 28946,
      "keyword": "sidrería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chipirón": [
    {
      "id": 28934,
      "keyword": "chipirón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chipirones": [
    {
      "id": 28934,
      "keyword": "chipirón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "toneles": [
    {
      "id": 28950,
      "keyword": "toneles",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "changurro": [
    {
      "id": 28988,
      "keyword": "changurro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "changurros": [
    {
      "id": 28988,
      "keyword": "changurro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "talo": [
    {
      "id": 28992,
      "keyword": "talo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talos": [
    {
      "id": 28992,
      "keyword": "talo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "brocheta de champiñones": [
    {
      "id": 28996,
      "keyword": "brocheta de champiñones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brochetas de champiñones": [
    {
      "id": 28996,
      "keyword": "brocheta de champiñones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sos": [
    {
      "id": 29016,
      "keyword": "SOS",
      "keywords": 1,
      "type": 1,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ponerse la lentilla": [
    {
      "id": 29018,
      "keyword": "ponerse la lentilla",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner la lentilla": [
    {
      "id": 29018,
      "keyword": "poner la lentilla",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ponerse las lentillas": [
    {
      "id": 29018,
      "keyword": "ponerse las lentillas",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner las lentillas": [
    {
      "id": 29018,
      "keyword": "poner las lentillas",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner las lentes de c ontacto": [
    {
      "id": 29018,
      "keyword": "poner las lentes de c ontacto",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ponerse el tampón": [
    {
      "id": 29020,
      "keyword": "ponerse el tampón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "intimate hygiene",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner el tampón": [
    {
      "id": 29020,
      "keyword": "poner el tampón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "intimate hygiene",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tren turístico": [
    {
      "id": 29008,
      "keyword": "tren turístico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trenes turísticos": [
    {
      "id": 29008,
      "keyword": "tren turístico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quitarse el tampón": [
    {
      "id": 29022,
      "keyword": "quitarse el tampón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "intimate hygiene",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar el tampón": [
    {
      "id": 29022,
      "keyword": "quitar el tampón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "intimate hygiene",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plato de espaguettis": [
    {
      "id": 29012,
      "keyword": "plato de espaguettis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "platos de espaguettis": [
    {
      "id": 29012,
      "keyword": "plato de espaguettis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "levantamiento de piedras": [
    {
      "id": 29006,
      "keyword": "levantamiento de piedras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "levantamientos de piedras": [
    {
      "id": 29006,
      "keyword": "levantamiento de piedras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "harrijasotze": [
    {
      "id": 29006,
      "keyword": "harrijasotze",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enrollar": [
    {
      "id": 29032,
      "keyword": "enrollar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "echar jabón": [
    {
      "id": 29034,
      "keyword": "echar jabón",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39211,
      "keyword": "echar jabón",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35729,
      "keyword": "echar jabón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36525,
      "keyword": "echar jabón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37409,
      "keyword": "echar jabón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cepillo de uñas": [
    {
      "id": 29036,
      "keyword": "cepillo de uñas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cepillos de uñas": [
    {
      "id": 29036,
      "keyword": "cepillo de uñas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enrollar la compresa": [
    {
      "id": 29026,
      "keyword": "enrollar la compresa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "intimate hygiene",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38670,
      "keyword": "enrollar la compresa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "intimate hygiene",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despegar la compresa": [
    {
      "id": 29030,
      "keyword": "despegar la compresa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "intimate hygiene",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pescado a la parrilla": [
    {
      "id": 29044,
      "keyword": "pescado a la parrilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pescados a la parrilla": [
    {
      "id": 29044,
      "keyword": "pescado a la parrilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "twister": [
    {
      "id": 29004,
      "keyword": "twister",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coger la toalla": [
    {
      "id": 29052,
      "keyword": "coger la toalla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomar la toalla": [
    {
      "id": 29052,
      "keyword": "tomar la toalla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner la comprensa": [
    {
      "id": 29028,
      "keyword": "poner la comprensa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "intimate hygiene",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar la compresa": [
    {
      "id": 29024,
      "keyword": "quitar la compresa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "intimate hygiene",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torno": [
    {
      "id": 29054,
      "keyword": "torno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tornos": [
    {
      "id": 29054,
      "keyword": "torno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "faltar": [
    {
      "id": 29064,
      "keyword": "faltar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29065,
      "keyword": "faltar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29062,
      "keyword": "faltar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29063,
      "keyword": "faltar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ausente": [
    {
      "id": 29064,
      "keyword": "ausente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29065,
      "keyword": "ausente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29062,
      "keyword": "ausente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29063,
      "keyword": "ausente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ausentes": [
    {
      "id": 29064,
      "keyword": "ausente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29065,
      "keyword": "ausente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29062,
      "keyword": "ausente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29063,
      "keyword": "ausente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juego de palmas": [
    {
      "id": 29048,
      "keyword": "juego de palmas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos de palmas": [
    {
      "id": 29048,
      "keyword": "juego de palmas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "kilómetro": [
    {
      "id": 29076,
      "keyword": "kilómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kilómetros": [
    {
      "id": 29076,
      "keyword": "kilómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ç": [
    {
      "id": 29080,
      "keyword": "ç",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29078,
      "keyword": "Ç",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "extremidades": [
    {
      "id": 29086,
      "keyword": "extremidades",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "duatlón": [
    {
      "id": 29082,
      "keyword": "duatlón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "joyas": [
    {
      "id": 29088,
      "keyword": "joyas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29088,
      "keyword": "joya",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "joya": [
    {
      "id": 29088,
      "keyword": "joya",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inhalar": [
    {
      "id": 29092,
      "keyword": "inhalar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33906,
      "keyword": "inhalar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30147,
      "keyword": "inhalar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30146,
      "keyword": "inhalar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gilda": [
    {
      "id": 29090,
      "keyword": "gilda",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gildas": [
    {
      "id": 29090,
      "keyword": "gilda",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "golpear la mesa": [
    {
      "id": 29094,
      "keyword": "golpear la mesa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29096,
      "keyword": "golpear la mesa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31046,
      "keyword": "golpear la mesa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29095,
      "keyword": "golpear la mesa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29097,
      "keyword": "golpear la mesa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31041,
      "keyword": "golpear la mesa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31042,
      "keyword": "golpear la mesa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "golpear la puerta": [
    {
      "id": 37139,
      "keyword": "golpear la puerta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29102,
      "keyword": "golpear la puerta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37140,
      "keyword": "golpear la puerta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37141,
      "keyword": "golpear la puerta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "azafato": [
    {
      "id": 29084,
      "keyword": "azafato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "azafatos": [
    {
      "id": 29084,
      "keyword": "azafato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rechazar": [
    {
      "id": 29129,
      "keyword": "rechazar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29640,
      "keyword": "rechazar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29638,
      "keyword": "rechazar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29639,
      "keyword": "rechazar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "verduras": [
    {
      "id": 29131,
      "keyword": "verduras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29131,
      "keyword": "verdura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "verdura": [
    {
      "id": 29131,
      "keyword": "verdura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torso": [
    {
      "id": 29136,
      "keyword": "torso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torsos": [
    {
      "id": 29136,
      "keyword": "torso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "triatlón": [
    {
      "id": 29138,
      "keyword": "triatlón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encender el aire acondicionado": [
    {
      "id": 29142,
      "keyword": "encender el aire acondicionado",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bar de tapas": [
    {
      "id": 29147,
      "keyword": "bar de tapas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bares de tapas": [
    {
      "id": 29147,
      "keyword": "bar de tapas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "partes del cuerpo": [
    {
      "id": 29145,
      "keyword": "partes del cuerpo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿cuántos días?": [
    {
      "id": 29149,
      "keyword": "¿cuántos días?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuántos días": [
    {
      "id": 29149,
      "keyword": "cuántos días",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apagar el aire acondicionado": [
    {
      "id": 29140,
      "keyword": "apagar el aire acondicionado",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pruebas diagnósticas": [
    {
      "id": 29133,
      "keyword": "pruebas diagnósticas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pruebas": [
    {
      "id": 29133,
      "keyword": "pruebas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugar con el ordenador": [
    {
      "id": 29153,
      "keyword": "jugar con el ordenador",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chuletón de buey": [
    {
      "id": 29161,
      "keyword": "chuletón de buey",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chuletones de buey": [
    {
      "id": 29161,
      "keyword": "chuletón de buey",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "síntomas": [
    {
      "id": 29165,
      "keyword": "síntomas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parada de taxis": [
    {
      "id": 29155,
      "keyword": "parada de taxis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paradas de taxis": [
    {
      "id": 29155,
      "keyword": "parada de taxis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llamar al 112": [
    {
      "id": 29167,
      "keyword": "llamar al 112",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugar con el tablet": [
    {
      "id": 29151,
      "keyword": "jugar con el tablet",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugar con la tableta": [
    {
      "id": 29151,
      "keyword": "jugar con la tableta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mojar los labios": [
    {
      "id": 29169,
      "keyword": "mojar los labios",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parking de autocaravanas": [
    {
      "id": 29157,
      "keyword": "parking de autocaravanas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parkings de autocaravanas": [
    {
      "id": 29157,
      "keyword": "parking de autocaravanas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pelota vasca": [
    {
      "id": 29171,
      "keyword": "pelota vasca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37074,
      "keyword": "pelota vasca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37076,
      "keyword": "pelota vasca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37077,
      "keyword": "pelota vasca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37079,
      "keyword": "pelota vasca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pedir un taxi": [
    {
      "id": 29159,
      "keyword": "pedir un taxi",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibido grabar": [
    {
      "id": 29183,
      "keyword": "prohibido grabar",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pincho de ensaladilla": [
    {
      "id": 29185,
      "keyword": "pincho de ensaladilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinchos de ensaladilla": [
    {
      "id": 29185,
      "keyword": "pincho de ensaladilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prohibido hacer fotos": [
    {
      "id": 29181,
      "keyword": "prohibido hacer fotos",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huevos fritos con patatas": [
    {
      "id": 29163,
      "keyword": "huevos fritos con patatas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huevos fritos con papas": [
    {
      "id": 29163,
      "keyword": "huevos fritos con papas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lomo de cerdo": [
    {
      "id": 29193,
      "keyword": "lomo de cerdo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lomos de cerdo": [
    {
      "id": 29193,
      "keyword": "lomo de cerdo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pollo con patatas": [
    {
      "id": 29195,
      "keyword": "pollo con patatas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pollos con patatas": [
    {
      "id": 29195,
      "keyword": "pollo con patatas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pollo con papas": [
    {
      "id": 29195,
      "keyword": "pollo con papas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pollos con papas": [
    {
      "id": 29195,
      "keyword": "pollo con papas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ver los fuegos artificiales": [
    {
      "id": 29198,
      "keyword": "ver los fuegos artificiales",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "show",
        "work",
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortilla de bacalao": [
    {
      "id": 29200,
      "keyword": "tortilla de bacalao",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortillas de bacalao": [
    {
      "id": 29200,
      "keyword": "tortilla de bacalao",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "terapia asistida con animales": [
    {
      "id": 36181,
      "keyword": "terapia asistida con animales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal-assisted therapy",
        "dog-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29202,
      "keyword": "terapia asistida con animales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal-assisted therapy",
        "dog-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29203,
      "keyword": "terapia asistida con animales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal-assisted therapy",
        "dog-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terapias asistidas con animales": [
    {
      "id": 36181,
      "keyword": "terapia asistida con animales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal-assisted therapy",
        "dog-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29202,
      "keyword": "terapia asistida con animales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal-assisted therapy",
        "dog-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29203,
      "keyword": "terapia asistida con animales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal-assisted therapy",
        "dog-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chacolí": [
    {
      "id": 29197,
      "keyword": "chacolí",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chacolís": [
    {
      "id": 29197,
      "keyword": "chacolí",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "viajar en transporte público ": [
    {
      "id": 29206,
      "keyword": "viajar en transporte público ",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recorrer en transporte público": [
    {
      "id": 29206,
      "keyword": "recorrer en transporte público",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plato de jamón": [
    {
      "id": 29191,
      "keyword": "plato de jamón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "platos de jamón": [
    {
      "id": 29191,
      "keyword": "plato de jamón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿qué hora es?": [
    {
      "id": 37370,
      "keyword": "¿qué hora es?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "time",
        "unit of time",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29175,
      "keyword": "¿qué hora es?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "time",
        "unit of time",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29175,
      "keyword": "¿qué hora es?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "time",
        "unit of time",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuchillo de pan": [
    {
      "id": 29220,
      "keyword": "cuchillo de pan",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuchillos de pan": [
    {
      "id": 29220,
      "keyword": "cuchillo de pan",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuchillo jamonero": [
    {
      "id": 29216,
      "keyword": "cuchillo jamonero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuchillos jamoneros": [
    {
      "id": 29216,
      "keyword": "cuchillo jamonero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pastel de chocolate": [
    {
      "id": 29226,
      "keyword": "pastel de chocolate",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasteles de chocolate": [
    {
      "id": 29226,
      "keyword": "pastel de chocolate",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarta de chocolate": [
    {
      "id": 29226,
      "keyword": "tarta de chocolate",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tartas de chocolate": [
    {
      "id": 29226,
      "keyword": "tarta de chocolate",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "torta de chocolate": [
    {
      "id": 29226,
      "keyword": "torta de chocolate",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortas de chocolate": [
    {
      "id": 29226,
      "keyword": "torta de chocolate",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juego del paracaídas": [
    {
      "id": 37604,
      "keyword": "juego del paracaídas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29234,
      "keyword": "juego del paracaídas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos del paracaídas": [
    {
      "id": 37604,
      "keyword": "juego del paracaídas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29234,
      "keyword": "juego del paracaídas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pastel de nata": [
    {
      "id": 29230,
      "keyword": "pastel de nata",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasteles de nata": [
    {
      "id": 29230,
      "keyword": "pastel de nata",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarta de nata": [
    {
      "id": 29230,
      "keyword": "tarta de nata",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tartas de nata": [
    {
      "id": 29230,
      "keyword": "tarta de nata",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "torta de nata": [
    {
      "id": 29230,
      "keyword": "torta de nata",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortaa de nata": [
    {
      "id": 29230,
      "keyword": "torta de nata",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juego de dar vueltas": [
    {
      "id": 29240,
      "keyword": "juego de dar vueltas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos de dar vueltas": [
    {
      "id": 29240,
      "keyword": "juego de dar vueltas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuchillo de carnicero": [
    {
      "id": 29212,
      "keyword": "cuchillo de carnicero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuchillos de carnicero": [
    {
      "id": 29212,
      "keyword": "cuchillo de carnicero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bacalao con pimientos": [
    {
      "id": 29248,
      "keyword": "bacalao con pimientos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bacalaos con pimientos": [
    {
      "id": 29248,
      "keyword": "bacalao con pimientos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "once": [
    {
      "id": 39337,
      "keyword": "once",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39367,
      "keyword": "once",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29460,
      "keyword": "once",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29260,
      "keyword": "once",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "doce": [
    {
      "id": 39300,
      "keyword": "doce",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39324,
      "keyword": "doce",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29262,
      "keyword": "doce",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mil": [
    {
      "id": 29258,
      "keyword": "mil",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trece": [
    {
      "id": 29264,
      "keyword": "trece",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arroz con almejas": [
    {
      "id": 29250,
      "keyword": "arroz con almejas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arroces con almejas": [
    {
      "id": 29250,
      "keyword": "arroz con almejas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diecisiete": [
    {
      "id": 29272,
      "keyword": "diecisiete",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dieciocho": [
    {
      "id": 29274,
      "keyword": "dieciocho",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cien": [
    {
      "id": 29256,
      "keyword": "cien",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "txotx!": [
    {
      "id": 29246,
      "keyword": "Txotx!",
      "keywords": 4,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mojón!": [
    {
      "id": 29246,
      "keyword": "Mojón!",
      "keywords": 4,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mojón": [
    {
      "id": 29246,
      "keyword": "mojón",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mojones": [
    {
      "id": 29246,
      "keyword": "mojón",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "veintiuno": [
    {
      "id": 29280,
      "keyword": "veintiuno",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diecinueve": [
    {
      "id": 29276,
      "keyword": "diecinueve",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veintidos": [
    {
      "id": 29282,
      "keyword": "veintidos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veintitres": [
    {
      "id": 29284,
      "keyword": "veintitres",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veinticinco": [
    {
      "id": 29288,
      "keyword": "veinticinco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veintiseis": [
    {
      "id": 29290,
      "keyword": "veintiseis",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veintisiete": [
    {
      "id": 29292,
      "keyword": "veintisiete",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veintiocho": [
    {
      "id": 29294,
      "keyword": "veintiocho",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "catorce": [
    {
      "id": 29266,
      "keyword": "catorce",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veintinueve": [
    {
      "id": 29296,
      "keyword": "veintinueve",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "doscientos": [
    {
      "id": 29278,
      "keyword": "doscientos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dieciseis": [
    {
      "id": 29270,
      "keyword": "dieciseis",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "treinta y tres": [
    {
      "id": 29306,
      "keyword": "treinta y tres",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "treinta y cuatro": [
    {
      "id": 29308,
      "keyword": "treinta y cuatro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "treinta y dos": [
    {
      "id": 29304,
      "keyword": "treinta y dos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quince": [
    {
      "id": 29268,
      "keyword": "quince",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veinticuatro": [
    {
      "id": 29286,
      "keyword": "veinticuatro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "treinta y cinco": [
    {
      "id": 29310,
      "keyword": "treinta y cinco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "treinta y seis": [
    {
      "id": 29312,
      "keyword": "treinta y seis",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "treinta y siete": [
    {
      "id": 29314,
      "keyword": "treinta y siete",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "treinta": [
    {
      "id": 29298,
      "keyword": "treinta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "treinta y uno": [
    {
      "id": 29302,
      "keyword": "treinta y uno",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trescientos": [
    {
      "id": 29300,
      "keyword": "trescientos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuarenta y dos": [
    {
      "id": 29326,
      "keyword": "cuarenta y dos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuarenta y tres": [
    {
      "id": 29328,
      "keyword": "cuarenta y tres",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuarenta y cuatro": [
    {
      "id": 29330,
      "keyword": "cuarenta y cuatro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuarenta y seis": [
    {
      "id": 29334,
      "keyword": "cuarenta y seis",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuarenta y cinco": [
    {
      "id": 29332,
      "keyword": "cuarenta y cinco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuarenta y ocho": [
    {
      "id": 29338,
      "keyword": "cuarenta y ocho",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "treinta y ocho": [
    {
      "id": 29316,
      "keyword": "treinta y ocho",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuarenta y nueve": [
    {
      "id": 29340,
      "keyword": "cuarenta y nueve",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cincuenta": [
    {
      "id": 29342,
      "keyword": "cincuenta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quinientos": [
    {
      "id": 29344,
      "keyword": "quinientos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cincuenta y uno": [
    {
      "id": 29346,
      "keyword": "cincuenta y uno",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cincuenta y dos": [
    {
      "id": 29348,
      "keyword": "cincuenta y dos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "treinta y nueve": [
    {
      "id": 29318,
      "keyword": "treinta y nueve",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuarenta y siete": [
    {
      "id": 29336,
      "keyword": "cuarenta y siete",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cincuenta y tres": [
    {
      "id": 29350,
      "keyword": "cincuenta y tres",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cincuenta y siete": [
    {
      "id": 29358,
      "keyword": "cincuenta y siete",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cincuenta y ocho": [
    {
      "id": 29360,
      "keyword": "cincuenta y ocho",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cincuenta y cuatro": [
    {
      "id": 29352,
      "keyword": "cincuenta y cuatro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuatrocientos": [
    {
      "id": 29322,
      "keyword": "cuatrocientos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuarenta y uno": [
    {
      "id": 29324,
      "keyword": "cuarenta y uno",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuarenta": [
    {
      "id": 29320,
      "keyword": "cuarenta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cincuenta y seis": [
    {
      "id": 29356,
      "keyword": "cincuenta y seis",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sesenta y uno": [
    {
      "id": 29366,
      "keyword": "sesenta y uno",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sesenta y dos": [
    {
      "id": 29368,
      "keyword": "sesenta y dos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sesenta y tres": [
    {
      "id": 29370,
      "keyword": "sesenta y tres",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sesenta": [
    {
      "id": 29364,
      "keyword": "sesenta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sesenta y cuatro": [
    {
      "id": 29372,
      "keyword": "sesenta y cuatro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sesenta y seis": [
    {
      "id": 29376,
      "keyword": "sesenta y seis",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sesenta y siete": [
    {
      "id": 29378,
      "keyword": "sesenta y siete",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sesenta y ocho": [
    {
      "id": 29380,
      "keyword": "sesenta y ocho",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sesenta y nueve": [
    {
      "id": 29382,
      "keyword": "sesenta y nueve",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seiscientos": [
    {
      "id": 29384,
      "keyword": "seiscientos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "setenta y dos": [
    {
      "id": 29392,
      "keyword": "setenta y dos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "setenta y tres": [
    {
      "id": 29394,
      "keyword": "setenta y tres",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "setenta y cuatro": [
    {
      "id": 29396,
      "keyword": "setenta y cuatro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "setenta y cinco": [
    {
      "id": 29398,
      "keyword": "setenta y cinco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "setenta y seis": [
    {
      "id": 29400,
      "keyword": "setenta y seis",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "setenta y siete": [
    {
      "id": 29402,
      "keyword": "setenta y siete",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "setenta y ocho": [
    {
      "id": 29404,
      "keyword": "setenta y ocho",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "setenta y nueve": [
    {
      "id": 29406,
      "keyword": "setenta y nueve",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ochocientos": [
    {
      "id": 29408,
      "keyword": "ochocientos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ochenta": [
    {
      "id": 29410,
      "keyword": "ochenta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ochenta y uno": [
    {
      "id": 29412,
      "keyword": "ochenta y uno",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ochenta y dos": [
    {
      "id": 29414,
      "keyword": "ochenta y dos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cincuenta y cinco": [
    {
      "id": 29354,
      "keyword": "cincuenta y cinco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cincuenta y nueve": [
    {
      "id": 29362,
      "keyword": "cincuenta y nueve",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sesenta y cinco": [
    {
      "id": 29374,
      "keyword": "sesenta y cinco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ochenta y tres": [
    {
      "id": 29416,
      "keyword": "ochenta y tres",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ochenta y cuatro": [
    {
      "id": 29418,
      "keyword": "ochenta y cuatro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ochenta y cinco": [
    {
      "id": 29420,
      "keyword": "ochenta y cinco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ochenta y seis": [
    {
      "id": 29422,
      "keyword": "ochenta y seis",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ochenta y siete": [
    {
      "id": 29424,
      "keyword": "ochenta y siete",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "setenta y uno": [
    {
      "id": 29390,
      "keyword": "setenta y uno",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ochenta y nueve": [
    {
      "id": 29428,
      "keyword": "ochenta y nueve",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "noventa": [
    {
      "id": 29430,
      "keyword": "noventa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "novecientos": [
    {
      "id": 29432,
      "keyword": "novecientos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "noventa y uno": [
    {
      "id": 29434,
      "keyword": "noventa y uno",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "noventa y dos": [
    {
      "id": 29436,
      "keyword": "noventa y dos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "noventa y seis": [
    {
      "id": 29444,
      "keyword": "noventa y seis",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "noventa y siete": [
    {
      "id": 29446,
      "keyword": "noventa y siete",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "noventa y ocho": [
    {
      "id": 29448,
      "keyword": "noventa y ocho",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "noventa y nueve": [
    {
      "id": 29450,
      "keyword": "noventa y nueve",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "1:00h": [
    {
      "id": 39296,
      "keyword": "1:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours",
        "communication",
        "language",
        "adverb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29452,
      "keyword": "1:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours",
        "communication",
        "language",
        "adverb",
        "adverb of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "13:00h": [
    {
      "id": 39330,
      "keyword": "13:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours",
        "communication",
        "language",
        "adverb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29452,
      "keyword": "13:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours",
        "communication",
        "language",
        "adverb",
        "adverb of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "10:00h": [
    {
      "id": 39339,
      "keyword": "10:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29454,
      "keyword": "10:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "22:00h": [
    {
      "id": 39371,
      "keyword": "22:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29454,
      "keyword": "22:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diez y cuarto": [
    {
      "id": 39352,
      "keyword": "diez y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39370,
      "keyword": "diez y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29456,
      "keyword": "diez y cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "10:15h": [
    {
      "id": 39352,
      "keyword": "10:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29456,
      "keyword": "10:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "22:15h": [
    {
      "id": 39370,
      "keyword": "22:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29456,
      "keyword": "22:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diez y media": [
    {
      "id": 39338,
      "keyword": "diez y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39369,
      "keyword": "diez y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29458,
      "keyword": "diez y media",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "10:30h": [
    {
      "id": 39338,
      "keyword": "10:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29458,
      "keyword": "10:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "22:30h": [
    {
      "id": 39369,
      "keyword": "22:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29458,
      "keyword": "22:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "11:00h": [
    {
      "id": 39337,
      "keyword": "11:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29460,
      "keyword": "11:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "23:00h": [
    {
      "id": 39367,
      "keyword": "23:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29460,
      "keyword": "23:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "once y cuarto": [
    {
      "id": 39335,
      "keyword": "once y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39365,
      "keyword": "once y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29462,
      "keyword": "once y cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "11:15h": [
    {
      "id": 39335,
      "keyword": "11:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29462,
      "keyword": "11:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "23:15h": [
    {
      "id": 29462,
      "keyword": "23:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "once y media": [
    {
      "id": 39334,
      "keyword": "once y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39366,
      "keyword": "once y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29464,
      "keyword": "once y media",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "11:30h": [
    {
      "id": 39334,
      "keyword": "11:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29464,
      "keyword": "11:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "23:30h": [
    {
      "id": 39366,
      "keyword": "23:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29464,
      "keyword": "23:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "una y cuarto": [
    {
      "id": 39295,
      "keyword": "una y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39325,
      "keyword": "una y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29466,
      "keyword": "una y cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "1:15h": [
    {
      "id": 39295,
      "keyword": "1:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29466,
      "keyword": "1:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "13:15h": [
    {
      "id": 39325,
      "keyword": "13:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29466,
      "keyword": "13:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ochenta y ocho": [
    {
      "id": 29426,
      "keyword": "ochenta y ocho",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "setecientos": [
    {
      "id": 29386,
      "keyword": "setecientos",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "setenta": [
    {
      "id": 29388,
      "keyword": "setenta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "doce en punto": [
    {
      "id": 29468,
      "keyword": "doce en punto",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "12:00h": [
    {
      "id": 39324,
      "keyword": "12:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29468,
      "keyword": "12:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "00:00h": [
    {
      "id": 39300,
      "keyword": "00:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29468,
      "keyword": "00:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "doce y cuarto": [
    {
      "id": 39299,
      "keyword": "doce y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39331,
      "keyword": "doce y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29470,
      "keyword": "doce y cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "12:15h": [
    {
      "id": 39331,
      "keyword": "12:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29470,
      "keyword": "12:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "00:15h": [
    {
      "id": 39299,
      "keyword": "00:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29470,
      "keyword": "00:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "doce y media": [
    {
      "id": 39298,
      "keyword": "doce y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39321,
      "keyword": "doce y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29472,
      "keyword": "doce y media",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "12:30h": [
    {
      "id": 39321,
      "keyword": "12:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29472,
      "keyword": "12:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "00:30h": [
    {
      "id": 39298,
      "keyword": "00:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29472,
      "keyword": "00:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "noventa y cuatro": [
    {
      "id": 29440,
      "keyword": "noventa y cuatro",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "una y media": [
    {
      "id": 39294,
      "keyword": "una y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29474,
      "keyword": "una y media",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39332,
      "keyword": "una y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "1:30h": [
    {
      "id": 39294,
      "keyword": "1:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29474,
      "keyword": "1:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "13:30h": [
    {
      "id": 29474,
      "keyword": "13:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39332,
      "keyword": "13:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "noventa y cinco": [
    {
      "id": 29442,
      "keyword": "noventa y cinco",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "2:30h": [
    {
      "id": 29480,
      "keyword": "2:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "14:30h": [
    {
      "id": 39322,
      "keyword": "14:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29480,
      "keyword": "14:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dos y media": [
    {
      "id": 39307,
      "keyword": "dos y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39322,
      "keyword": "dos y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29480,
      "keyword": "dos y media",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "3:00h": [
    {
      "id": 29482,
      "keyword": "3:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "15:00h": [
    {
      "id": 39320,
      "keyword": "15:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29482,
      "keyword": "15:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tres y cuarto": [
    {
      "id": 39304,
      "keyword": "tres y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29484,
      "keyword": "tres y cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39319,
      "keyword": "tres y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "3:15h": [
    {
      "id": 29484,
      "keyword": "3:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "15:15h": [
    {
      "id": 29484,
      "keyword": "15:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39319,
      "keyword": "15:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tres y media": [
    {
      "id": 39303,
      "keyword": "tres y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39318,
      "keyword": "tres y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29486,
      "keyword": "tres y media",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "3:30h": [
    {
      "id": 29486,
      "keyword": "3:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "15:30h": [
    {
      "id": 39318,
      "keyword": "15:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29486,
      "keyword": "15:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "4:00h": [
    {
      "id": 29488,
      "keyword": "4:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "16:00h": [
    {
      "id": 39316,
      "keyword": "16:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29488,
      "keyword": "16:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuatro y media": [
    {
      "id": 39314,
      "keyword": "cuatro y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39362,
      "keyword": "cuatro y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29492,
      "keyword": "cuatro y media",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "4:30h": [
    {
      "id": 29492,
      "keyword": "4:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "16:30h": [
    {
      "id": 39314,
      "keyword": "16:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29492,
      "keyword": "16:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cinco y cuarto": [
    {
      "id": 39310,
      "keyword": "cinco y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29496,
      "keyword": "cinco y cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "5:15h": [
    {
      "id": 29496,
      "keyword": "5:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "17:15h": [
    {
      "id": 39310,
      "keyword": "17:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29496,
      "keyword": "17:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cinco y media": [
    {
      "id": 39312,
      "keyword": "cinco y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39357,
      "keyword": "cinco y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29498,
      "keyword": "cinco y media",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "5:30h": [
    {
      "id": 29498,
      "keyword": "5:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "17:30h": [
    {
      "id": 39312,
      "keyword": "17:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29498,
      "keyword": "17:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "6:00h": [
    {
      "id": 29500,
      "keyword": "6:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "18:00h": [
    {
      "id": 39376,
      "keyword": "18:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29500,
      "keyword": "18:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuatro y cuarto": [
    {
      "id": 39315,
      "keyword": "cuatro y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39363,
      "keyword": "cuatro y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29490,
      "keyword": "cuatro y cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "4:15h": [
    {
      "id": 29490,
      "keyword": "4:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "16:15h": [
    {
      "id": 39315,
      "keyword": "16:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29490,
      "keyword": "16:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seis y cuarto": [
    {
      "id": 39354,
      "keyword": "seis y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39386,
      "keyword": "seis y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29502,
      "keyword": "seis y cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "6:15h": [
    {
      "id": 29502,
      "keyword": "6:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "18:15": [
    {
      "id": 29502,
      "keyword": "18:15",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seis y media": [
    {
      "id": 39353,
      "keyword": "seis y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39385,
      "keyword": "seis y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29504,
      "keyword": "seis y media",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "6:30h": [
    {
      "id": 29504,
      "keyword": "6:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "18:30h": [
    {
      "id": 39385,
      "keyword": "18:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29504,
      "keyword": "18:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "siete y cuarto": [
    {
      "id": 39350,
      "keyword": "siete y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39382,
      "keyword": "siete y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29508,
      "keyword": "siete y cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "7:15h": [
    {
      "id": 29508,
      "keyword": "7:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "19:15h": [
    {
      "id": 39382,
      "keyword": "19:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29508,
      "keyword": "19:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "7:00h": [
    {
      "id": 29506,
      "keyword": "7:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "19:00h": [
    {
      "id": 39383,
      "keyword": "19:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29506,
      "keyword": "19:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "siete y media": [
    {
      "id": 39348,
      "keyword": "siete y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39381,
      "keyword": "siete y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29510,
      "keyword": "siete y media",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "7:30h": [
    {
      "id": 39348,
      "keyword": "7:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29510,
      "keyword": "7:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "19:30h": [
    {
      "id": 39381,
      "keyword": "19:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29510,
      "keyword": "19:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ocho y media": [
    {
      "id": 39345,
      "keyword": "ocho y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39378,
      "keyword": "ocho y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29516,
      "keyword": "ocho y media",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "8:30h": [
    {
      "id": 29516,
      "keyword": "8:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "20:30h": [
    {
      "id": 39378,
      "keyword": "20:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29516,
      "keyword": "20:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "5:00h": [
    {
      "id": 29494,
      "keyword": "5:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "17:00h": [
    {
      "id": 39311,
      "keyword": "17:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29494,
      "keyword": "17:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "2:00h": [
    {
      "id": 39292,
      "keyword": "2:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29476,
      "keyword": "2:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "14:00h": [
    {
      "id": 39327,
      "keyword": "14:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29476,
      "keyword": "14:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dos y cuarto": [
    {
      "id": 39308,
      "keyword": "dos y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39329,
      "keyword": "dos y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29478,
      "keyword": "dos y cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "2:15h": [
    {
      "id": 29478,
      "keyword": "2:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "14:15h": [
    {
      "id": 39329,
      "keyword": "14:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29478,
      "keyword": "14:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "noventa y tres": [
    {
      "id": 29438,
      "keyword": "noventa y tres",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "8:00h": [
    {
      "id": 29512,
      "keyword": "8:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "20:00h": [
    {
      "id": 39379,
      "keyword": "20:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29512,
      "keyword": "20:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "doce menos cuarto": [
    {
      "id": 39333,
      "keyword": "doce menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39375,
      "keyword": "doce menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29526,
      "keyword": "doce menos cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "11:45h": [
    {
      "id": 39333,
      "keyword": "11:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29526,
      "keyword": "11:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "23:45h": [
    {
      "id": 39375,
      "keyword": "23:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29526,
      "keyword": "23:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "once menos cuarto": [
    {
      "id": 39336,
      "keyword": "once menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39368,
      "keyword": "once menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29524,
      "keyword": "once menos cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "10:45h": [
    {
      "id": 39336,
      "keyword": "10:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29524,
      "keyword": "10:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "22:45h": [
    {
      "id": 39368,
      "keyword": "22:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29524,
      "keyword": "22:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nueve y media": [
    {
      "id": 39341,
      "keyword": "nueve y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39373,
      "keyword": "nueve y media",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29522,
      "keyword": "nueve y media",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "9:30h": [
    {
      "id": 29522,
      "keyword": "9:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "21:30h": [
    {
      "id": 39373,
      "keyword": "21:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29522,
      "keyword": "21:30h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "una menos cuarto": [
    {
      "id": 39297,
      "keyword": "una menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39326,
      "keyword": "una menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29528,
      "keyword": "una menos cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "12:45h": [
    {
      "id": 39326,
      "keyword": "12:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29528,
      "keyword": "12:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "00:45h": [
    {
      "id": 39297,
      "keyword": "00:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29528,
      "keyword": "00:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "9:00h": [
    {
      "id": 29518,
      "keyword": "9:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "21:00h": [
    {
      "id": 39364,
      "keyword": "21:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29518,
      "keyword": "21:00h",
      "keywords": 4,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dos menos cuarto": [
    {
      "id": 39293,
      "keyword": "dos menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39328,
      "keyword": "dos menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29530,
      "keyword": "dos menos cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "1:45h": [
    {
      "id": 39293,
      "keyword": "1:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29530,
      "keyword": "1:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "13:45h": [
    {
      "id": 39328,
      "keyword": "13:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29530,
      "keyword": "13:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tres menos cuarto": [
    {
      "id": 39306,
      "keyword": "tres menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39323,
      "keyword": "tres menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29532,
      "keyword": "tres menos cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "2:45h": [
    {
      "id": 29532,
      "keyword": "2:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "14:45h": [
    {
      "id": 39323,
      "keyword": "14:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29532,
      "keyword": "14:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cinco menos cuarto": [
    {
      "id": 39313,
      "keyword": "cinco menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39361,
      "keyword": "cinco menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29536,
      "keyword": "cinco menos cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "4:45h": [
    {
      "id": 29536,
      "keyword": "4:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "16:45h": [
    {
      "id": 39313,
      "keyword": "16:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29536,
      "keyword": "16:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nueve y cuarto": [
    {
      "id": 39342,
      "keyword": "nueve y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39374,
      "keyword": "nueve y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29520,
      "keyword": "nueve y cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "9:15h": [
    {
      "id": 39342,
      "keyword": "9:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29520,
      "keyword": "9:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "21:15h": [
    {
      "id": 39374,
      "keyword": "21:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29520,
      "keyword": "21:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ocho menos cuarto": [
    {
      "id": 39349,
      "keyword": "ocho menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39380,
      "keyword": "ocho menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29542,
      "keyword": "ocho menos cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "7:45h": [
    {
      "id": 29542,
      "keyword": "7:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "19:45h": [
    {
      "id": 39380,
      "keyword": "19:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29542,
      "keyword": "19:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuatro menos cuarto": [
    {
      "id": 39302,
      "keyword": "cuatro menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39317,
      "keyword": "cuatro menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29534,
      "keyword": "cuatro menos cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "3:45h": [
    {
      "id": 29534,
      "keyword": "3:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "15:45h": [
    {
      "id": 39317,
      "keyword": "15:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29534,
      "keyword": "15:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nueve menos cuarto": [
    {
      "id": 39344,
      "keyword": "nueve menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39377,
      "keyword": "nueve menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29544,
      "keyword": "nueve menos cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "8:45h": [
    {
      "id": 29544,
      "keyword": "8:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "20:45h": [
    {
      "id": 39377,
      "keyword": "20:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29544,
      "keyword": "20:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veinte": [
    {
      "id": 29550,
      "keyword": "veinte",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics",
        "adjective",
        "numeral adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seriación": [
    {
      "id": 29552,
      "keyword": "seriación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29553,
      "keyword": "seriación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seriaciones": [
    {
      "id": 29552,
      "keyword": "seriación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29553,
      "keyword": "seriación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "siete menos cuarto": [
    {
      "id": 39360,
      "keyword": "siete menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39384,
      "keyword": "siete menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29540,
      "keyword": "siete menos cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "6:45h": [
    {
      "id": 29540,
      "keyword": "6:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "18:45h": [
    {
      "id": 39384,
      "keyword": "18:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29540,
      "keyword": "18:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seis menos cuarto": [
    {
      "id": 39309,
      "keyword": "seis menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39356,
      "keyword": "seis menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29538,
      "keyword": "seis menos cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "5:45h": [
    {
      "id": 29538,
      "keyword": "5:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "17:45h": [
    {
      "id": 39309,
      "keyword": "17:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29538,
      "keyword": "17:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fisioterapia pediátrica": [
    {
      "id": 29558,
      "keyword": "fisioterapia pediátrica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29556,
      "keyword": "fisioterapia pediátrica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29557,
      "keyword": "fisioterapia pediátrica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fisioterapias pediátricas": [
    {
      "id": 29558,
      "keyword": "fisioterapia pediátrica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29556,
      "keyword": "fisioterapia pediátrica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29557,
      "keyword": "fisioterapia pediátrica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fisioterapia infantil": [
    {
      "id": 29558,
      "keyword": "fisioterapia infantil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29556,
      "keyword": "fisioterapia infantil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29557,
      "keyword": "fisioterapia infantil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fisioterapias infantiles": [
    {
      "id": 29558,
      "keyword": "fisioterapia infantil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29556,
      "keyword": "fisioterapia infantil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29557,
      "keyword": "fisioterapia infantil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fisioterapia educativa": [
    {
      "id": 38581,
      "keyword": "fisioterapia educativa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29562,
      "keyword": "fisioterapia educativa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29563,
      "keyword": "fisioterapia educativa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32496,
      "keyword": "fisioterapia educativa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32497,
      "keyword": "fisioterapia educativa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fisioterapias educativas": [
    {
      "id": 38581,
      "keyword": "fisioterapia educativa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29562,
      "keyword": "fisioterapia educativa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29563,
      "keyword": "fisioterapia educativa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32496,
      "keyword": "fisioterapia educativa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32497,
      "keyword": "fisioterapia educativa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "kinesiología": [
    {
      "id": 38581,
      "keyword": "kinesiología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29562,
      "keyword": "kinesiología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29563,
      "keyword": "kinesiología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32496,
      "keyword": "kinesiología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32497,
      "keyword": "kinesiología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ocho y cuarto": [
    {
      "id": 29514,
      "keyword": "ocho y cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39347,
      "keyword": "ocho y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39393,
      "keyword": "ocho y cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "8:15h": [
    {
      "id": 29514,
      "keyword": "8:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "20:15h": [
    {
      "id": 29514,
      "keyword": "20:15h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39393,
      "keyword": "20:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diez menos cuarto": [
    {
      "id": 39340,
      "keyword": "diez menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39372,
      "keyword": "diez menos cuarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29546,
      "keyword": "diez menos cuarto",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "9:45h": [
    {
      "id": 29546,
      "keyword": "9:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "21:45h": [
    {
      "id": 39372,
      "keyword": "21:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29546,
      "keyword": "21:45h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llevar a cuestas": [
    {
      "id": 29566,
      "keyword": "llevar a cuestas",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llevar a corderetas": [
    {
      "id": 29566,
      "keyword": "llevar a corderetas",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llevar a horcajadas": [
    {
      "id": 29566,
      "keyword": "llevar a horcajadas",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "eslovenia": [
    {
      "id": 29573,
      "keyword": "Eslovenia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29586,
      "keyword": "Eslovenia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "albania": [
    {
      "id": 29584,
      "keyword": "Albania",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29585,
      "keyword": "Albania",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolivia": [
    {
      "id": 29594,
      "keyword": "Bolivia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29595,
      "keyword": "Bolivia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "venezuela": [
    {
      "id": 29596,
      "keyword": "Venezuela",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29597,
      "keyword": "Venezuela",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "honduras": [
    {
      "id": 29606,
      "keyword": "Honduras",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29605,
      "keyword": "Honduras",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "laberinto": [
    {
      "id": 29627,
      "keyword": "laberinto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29626,
      "keyword": "laberinto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "laberintos": [
    {
      "id": 29627,
      "keyword": "laberinto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29626,
      "keyword": "laberinto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sana": [
    {
      "id": 37797,
      "keyword": "sana",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39515,
      "keyword": "sana",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29648,
      "keyword": "sana",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sanas": [
    {
      "id": 37797,
      "keyword": "sana",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39515,
      "keyword": "sana",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29648,
      "keyword": "sana",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "el salvador": [
    {
      "id": 29652,
      "keyword": "El Salvador",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29653,
      "keyword": "El Salvador",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trinidad y tobago": [
    {
      "id": 29654,
      "keyword": "Trinidad y Tobago",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29655,
      "keyword": "Trinidad y Tobago",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tumbada bocabajo": [
    {
      "id": 29658,
      "keyword": "tumbada bocabajo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tumbada bocarriba": [
    {
      "id": 29656,
      "keyword": "tumbada bocarriba",
      "keywords": 1,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agachada": [
    {
      "id": 29672,
      "keyword": "agachada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agac": [
    {
      "id": 29672,
      "keyword": "agac",
      "keywords": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alud": [
    {
      "id": 29686,
      "keyword": "alud",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aludes": [
    {
      "id": 29686,
      "keyword": "alud",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "veleta": [
    {
      "id": 29698,
      "keyword": "veleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veletas": [
    {
      "id": 29698,
      "keyword": "veleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tinaja": [
    {
      "id": 29706,
      "keyword": "tinaja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tinajas": [
    {
      "id": 29706,
      "keyword": "tinaja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ñu": [
    {
      "id": 29694,
      "keyword": "ñu",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ñus": [
    {
      "id": 29694,
      "keyword": "ñu",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ñandú": [
    {
      "id": 29702,
      "keyword": "ñandú",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ñandús": [
    {
      "id": 29702,
      "keyword": "ñandú",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mamut": [
    {
      "id": 29682,
      "keyword": "mamut",
      "keywords": 1,
      "type": 2,
      "tags": [
        "extinct being",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mamuts": [
    {
      "id": 29682,
      "keyword": "mamut",
      "keywords": 1,
      "type": 2,
      "tags": [
        "extinct being",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "regresar": [
    {
      "id": 29714,
      "keyword": "regresar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "urogallo": [
    {
      "id": 29690,
      "keyword": "urogallo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "urogallos": [
    {
      "id": 29690,
      "keyword": "urogallo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "san cristóbal y nieves": [
    {
      "id": 29734,
      "keyword": "San Cristóbal y Nieves",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29735,
      "keyword": "San Cristóbal y Nieves",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiar las ventanas": [
    {
      "id": 29746,
      "keyword": "limpiar las ventanas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sonda nasogástrica": [
    {
      "id": 29758,
      "keyword": "sonda nasogástrica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29756,
      "keyword": "sonda nasogástrica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29757,
      "keyword": "sonda nasogástrica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sondas nasogástricas": [
    {
      "id": 29758,
      "keyword": "sonda nasogástrica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29756,
      "keyword": "sonda nasogástrica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29757,
      "keyword": "sonda nasogástrica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sonda gastronasal": [
    {
      "id": 29758,
      "keyword": "sonda gastronasal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29756,
      "keyword": "sonda gastronasal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29757,
      "keyword": "sonda gastronasal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sondas gastronasales": [
    {
      "id": 29758,
      "keyword": "sonda gastronasal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29756,
      "keyword": "sonda gastronasal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29757,
      "keyword": "sonda gastronasal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coyote": [
    {
      "id": 29768,
      "keyword": "coyote",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coyotes": [
    {
      "id": 29768,
      "keyword": "coyote",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "azucena": [
    {
      "id": 29772,
      "keyword": "azucena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "azucenas": [
    {
      "id": 29772,
      "keyword": "azucena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarzán": [
    {
      "id": 29800,
      "keyword": "Tarzán",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "comic character",
        "comic",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cañón": [
    {
      "id": 29792,
      "keyword": "cañón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "history",
        "middle ages",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cañones": [
    {
      "id": 29792,
      "keyword": "cañón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "history",
        "middle ages",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "té instantáneo": [
    {
      "id": 29802,
      "keyword": "té instantáneo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tés instantáneos": [
    {
      "id": 29802,
      "keyword": "té instantáneo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "té": [
    {
      "id": 29802,
      "keyword": "té",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tés": [
    {
      "id": 29802,
      "keyword": "té",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "piraña": [
    {
      "id": 29776,
      "keyword": "piraña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pirañas": [
    {
      "id": 29776,
      "keyword": "piraña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "biombo": [
    {
      "id": 29796,
      "keyword": "biombo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "biombos": [
    {
      "id": 29796,
      "keyword": "biombo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "orientación": [
    {
      "id": 29804,
      "keyword": "orientación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37459,
      "keyword": "orientación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orientaciones": [
    {
      "id": 29804,
      "keyword": "orientación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lucha grecorromana": [
    {
      "id": 29806,
      "keyword": "lucha grecorromana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colmillo": [
    {
      "id": 29784,
      "keyword": "colmillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colmillos": [
    {
      "id": 29784,
      "keyword": "colmillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pan de centeno": [
    {
      "id": 29808,
      "keyword": "pan de centeno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panes de centeno": [
    {
      "id": 29808,
      "keyword": "pan de centeno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "snowboarding": [
    {
      "id": 29810,
      "keyword": "Snowboarding",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "snowboard": [
    {
      "id": 29810,
      "keyword": "snowboard",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer snowboard": [
    {
      "id": 29810,
      "keyword": "hacer snowboard",
      "keywords": 3,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cencerro": [
    {
      "id": 29780,
      "keyword": "cencerro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cencerros": [
    {
      "id": 29780,
      "keyword": "cencerro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cambiar el pañal": [
    {
      "id": 29824,
      "keyword": "cambiar el pañal",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36892,
      "keyword": "cambiar el pañal",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner la sonda": [
    {
      "id": 29820,
      "keyword": "poner la sonda",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29818,
      "keyword": "poner la sonda",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29819,
      "keyword": "poner la sonda",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aspirar las flemas": [
    {
      "id": 29826,
      "keyword": "aspirar las flemas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "echar gotas": [
    {
      "id": 29828,
      "keyword": "echar gotas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medicament",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37309,
      "keyword": "echar gotas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ponerse el termómetro": [
    {
      "id": 29831,
      "keyword": "ponerse el termómetro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29830,
      "keyword": "ponerse el termómetro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38752,
      "keyword": "ponerse el termómetro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomar la fiebre": [
    {
      "id": 29831,
      "keyword": "tomar la fiebre",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29830,
      "keyword": "tomar la fiebre",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner el termómetro": [
    {
      "id": 29831,
      "keyword": "poner el termómetro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29830,
      "keyword": "poner el termómetro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38752,
      "keyword": "poner el termómetro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quimioterapia": [
    {
      "id": 34381,
      "keyword": "quimioterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38061,
      "keyword": "quimioterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29816,
      "keyword": "quimioterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quimioterapias": [
    {
      "id": 34381,
      "keyword": "quimioterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38061,
      "keyword": "quimioterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29816,
      "keyword": "quimioterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "broche": [
    {
      "id": 29788,
      "keyword": "broche",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "jewelry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "broches": [
    {
      "id": 29788,
      "keyword": "broche",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "jewelry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prendedor": [
    {
      "id": 29788,
      "keyword": "prendedor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "jewelry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prendedores": [
    {
      "id": 29788,
      "keyword": "prendedor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "jewelry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "limpiarse la oreja": [
    {
      "id": 29834,
      "keyword": "limpiarse la oreja",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29835,
      "keyword": "limpiarse la oreja",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiarse el oído": [
    {
      "id": 29834,
      "keyword": "limpiarse el oído",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29835,
      "keyword": "limpiarse el oído",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiar la oreja": [
    {
      "id": 29834,
      "keyword": "limpiar la oreja",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29835,
      "keyword": "limpiar la oreja",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiar el oído": [
    {
      "id": 29834,
      "keyword": "limpiar el oído",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29835,
      "keyword": "limpiar el oído",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiar oído": [
    {
      "id": 29834,
      "keyword": "limpiar oído",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29835,
      "keyword": "limpiar oído",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "human body"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nada": [
    {
      "id": 29839,
      "keyword": "nada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "indefinite pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32522,
      "keyword": "nada",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agencia de modelos": [
    {
      "id": 29843,
      "keyword": "agencia de modelos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agencias de modelos": [
    {
      "id": 29843,
      "keyword": "agencia de modelos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "clothing industry",
        "object",
        "fashion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vía intravenosa": [
    {
      "id": 29812,
      "keyword": "vía intravenosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vías intravenosas": [
    {
      "id": 29812,
      "keyword": "vía intravenosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro de interpretación de las murallas": [
    {
      "id": 29851,
      "keyword": "centro de interpretación de las murallas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros de interpretación de las murallas": [
    {
      "id": 29851,
      "keyword": "centro de interpretación de las murallas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro de salud mental": [
    {
      "id": 29857,
      "keyword": "centro de salud mental",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros de salud mental": [
    {
      "id": 29857,
      "keyword": "centro de salud mental",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casa de cultura": [
    {
      "id": 29845,
      "keyword": "casa de cultura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casas de cultura": [
    {
      "id": 29845,
      "keyword": "casa de cultura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casa de la cultura": [
    {
      "id": 29845,
      "keyword": "casa de la cultura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casas de la cultura": [
    {
      "id": 29845,
      "keyword": "casa de la cultura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jardín de los sentidos": [
    {
      "id": 29855,
      "keyword": "jardín de los sentidos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "urban area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centro de salud": [
    {
      "id": 29859,
      "keyword": "centro de salud",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32246,
      "keyword": "centro de salud",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros de salud": [
    {
      "id": 29859,
      "keyword": "centro de salud",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32246,
      "keyword": "centro de salud",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "expirar": [
    {
      "id": 29863,
      "keyword": "expirar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "event",
        "social event",
        "death",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29862,
      "keyword": "expirar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casa de juventud": [
    {
      "id": 29847,
      "keyword": "casa de juventud",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casas de juventud": [
    {
      "id": 29847,
      "keyword": "casa de juventud",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escuela infantil": [
    {
      "id": 29853,
      "keyword": "escuela infantil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escuelas infantiles": [
    {
      "id": 29853,
      "keyword": "escuela infantil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "patronato de deportes": [
    {
      "id": 29873,
      "keyword": "patronato de deportes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patronatos de deportes": [
    {
      "id": 29873,
      "keyword": "patronato de deportes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "planetario": [
    {
      "id": 29877,
      "keyword": "planetario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility",
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "planetarios": [
    {
      "id": 29877,
      "keyword": "planetario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility",
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de complementos": [
    {
      "id": 29881,
      "keyword": "tienda de complementos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de complementos": [
    {
      "id": 29881,
      "keyword": "tienda de complementos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "compraventa": [
    {
      "id": 29883,
      "keyword": "compraventa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compraventas": [
    {
      "id": 29883,
      "keyword": "compraventa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de caza y pesca": [
    {
      "id": 29885,
      "keyword": "tienda de caza y pesca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "primary sector",
        "hunting",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de caza y pesca": [
    {
      "id": 29885,
      "keyword": "tienda de caza y pesca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "primary sector",
        "hunting",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro de atención a la mujer": [
    {
      "id": 29849,
      "keyword": "centro de atención a la mujer",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros de atención a la mujer": [
    {
      "id": 29849,
      "keyword": "centro de atención a la mujer",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cadáver": [
    {
      "id": 29867,
      "keyword": "cadáver",
      "keywords": 3,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death",
        "person",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cadáveres": [
    {
      "id": 29867,
      "keyword": "cadáver",
      "keywords": 3,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death",
        "person",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hospital psiquiátrico": [
    {
      "id": 29875,
      "keyword": "hospital psiquiátrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hospitales psiquiátricos": [
    {
      "id": 29875,
      "keyword": "hospital psiquiátrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "difunta": [
    {
      "id": 29869,
      "keyword": "difunta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29870,
      "keyword": "difunta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "difuntas": [
    {
      "id": 29869,
      "keyword": "difunta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 29870,
      "keyword": "difunta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inmobiliaria": [
    {
      "id": 29893,
      "keyword": "inmobiliaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inmobiliarias": [
    {
      "id": 29893,
      "keyword": "inmobiliaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de telefonía": [
    {
      "id": 29894,
      "keyword": "tienda de telefonía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "telecommunication",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de telefonía": [
    {
      "id": 29894,
      "keyword": "tienda de telefonía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "telecommunication",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ascensor exterior": [
    {
      "id": 29901,
      "keyword": "ascensor exterior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ascensores exteriores": [
    {
      "id": 29901,
      "keyword": "ascensor exterior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hospital de día": [
    {
      "id": 29903,
      "keyword": "hospital de día",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36708,
      "keyword": "hospital de día",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36709,
      "keyword": "hospital de día",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hospitales de día": [
    {
      "id": 29903,
      "keyword": "hospital de día",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36708,
      "keyword": "hospital de día",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36709,
      "keyword": "hospital de día",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de estética": [
    {
      "id": 29889,
      "keyword": "tienda de estética",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de estética": [
    {
      "id": 29889,
      "keyword": "tienda de estética",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro de estética": [
    {
      "id": 29889,
      "keyword": "centro de estética",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros de estética": [
    {
      "id": 29889,
      "keyword": "centro de estética",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conservatorio": [
    {
      "id": 29907,
      "keyword": "conservatorio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution",
        "music",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conservatorios": [
    {
      "id": 29907,
      "keyword": "conservatorio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution",
        "music",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escuela de música": [
    {
      "id": 29907,
      "keyword": "escuela de música",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution",
        "music",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escuelas de música": [
    {
      "id": 29907,
      "keyword": "escuela de música",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution",
        "music",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de manualidades": [
    {
      "id": 29909,
      "keyword": "tienda de manualidades",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "hobby"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de manualidades": [
    {
      "id": 29909,
      "keyword": "tienda de manualidades",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "hobby"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escuela oficial de idiomas": [
    {
      "id": 29911,
      "keyword": "escuela oficial de idiomas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escuelas oficiales de idiomas": [
    {
      "id": 29911,
      "keyword": "escuela oficial de idiomas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "protectora de animales": [
    {
      "id": 29913,
      "keyword": "protectora de animales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "protectoras de animales": [
    {
      "id": 29913,
      "keyword": "protectora de animales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aula de educación de adultos": [
    {
      "id": 29915,
      "keyword": "aula de educación de adultos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aulas de educación de adultos": [
    {
      "id": 29915,
      "keyword": "aula de educación de adultos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de electrónica": [
    {
      "id": 29887,
      "keyword": "tienda de electrónica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de electrónica": [
    {
      "id": 29887,
      "keyword": "tienda de electrónica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carro de ropa sucia": [
    {
      "id": 29923,
      "keyword": "carro de ropa sucia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carros de ropa sucia": [
    {
      "id": 29923,
      "keyword": "carro de ropa sucia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quitaesmalte": [
    {
      "id": 29925,
      "keyword": "quitaesmalte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitaesmaltes": [
    {
      "id": 29925,
      "keyword": "quitaesmalte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "papelería": [
    {
      "id": 29897,
      "keyword": "papelería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papelerías": [
    {
      "id": 29897,
      "keyword": "papelería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fleco": [
    {
      "id": 29929,
      "keyword": "fleco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flecos": [
    {
      "id": 29929,
      "keyword": "fleco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "traje": [
    {
      "id": 29931,
      "keyword": "traje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trajes": [
    {
      "id": 29931,
      "keyword": "traje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escuela de arte": [
    {
      "id": 29917,
      "keyword": "escuela de arte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution",
        "scenic art",
        "music",
        "visual art",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escuelas de arte": [
    {
      "id": 29917,
      "keyword": "escuela de arte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution",
        "scenic art",
        "music",
        "visual art",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "club deportivo": [
    {
      "id": 29919,
      "keyword": "club deportivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clubes deportivos": [
    {
      "id": 29919,
      "keyword": "club deportivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lencería": [
    {
      "id": 29899,
      "keyword": "lencería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lencerías": [
    {
      "id": 29899,
      "keyword": "lencería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juego de las canicas": [
    {
      "id": 29937,
      "keyword": "juego de las canicas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos de las canicas": [
    {
      "id": 29937,
      "keyword": "juego de las canicas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juego de las bolillas": [
    {
      "id": 29937,
      "keyword": "juego de las bolillas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos de las bolillas": [
    {
      "id": 29937,
      "keyword": "juego de las bolillas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juego de las bolitas": [
    {
      "id": 29937,
      "keyword": "juego de las bolitas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 29937,
      "keyword": "juego de las bolitas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carrera de sacos": [
    {
      "id": 29939,
      "keyword": "carrera de sacos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carreras de sacos": [
    {
      "id": 29939,
      "keyword": "carrera de sacos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "volar cometas": [
    {
      "id": 29943,
      "keyword": "volar cometas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juego del pilla pilla": [
    {
      "id": 29945,
      "keyword": "juego del pilla pilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos del pilla pilla": [
    {
      "id": 29945,
      "keyword": "juego del pilla pilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juego del yo-yo": [
    {
      "id": 29947,
      "keyword": "juego del yo-yo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos del yo-yo": [
    {
      "id": 29947,
      "keyword": "juego del yo-yo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juego de la peonza": [
    {
      "id": 29949,
      "keyword": "juego de la peonza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos de la peonza": [
    {
      "id": 29949,
      "keyword": "juego de la peonza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de puericultura": [
    {
      "id": 29891,
      "keyword": "tienda de puericultura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32726,
      "keyword": "tienda de puericultura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32727,
      "keyword": "tienda de puericultura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de puericultura": [
    {
      "id": 29891,
      "keyword": "tienda de puericultura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32726,
      "keyword": "tienda de puericultura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32727,
      "keyword": "tienda de puericultura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anunciación": [
    {
      "id": 29957,
      "keyword": "Anunciación",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clínica de rehabilitación motriz": [
    {
      "id": 29921,
      "keyword": "clínica de rehabilitación motriz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clínicas de rehabilitación motriz": [
    {
      "id": 29921,
      "keyword": "clínica de rehabilitación motriz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juego del hula hoop": [
    {
      "id": 29941,
      "keyword": "juego del hula hoop",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos del hula hoop": [
    {
      "id": 29941,
      "keyword": "juego del hula hoop",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "autoescuela": [
    {
      "id": 29961,
      "keyword": "autoescuela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autoescuelas": [
    {
      "id": 29961,
      "keyword": "autoescuela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "capilla": [
    {
      "id": 29963,
      "keyword": "capilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "capillas": [
    {
      "id": 29963,
      "keyword": "capilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "autentificar": [
    {
      "id": 29955,
      "keyword": "autentificar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autenticar": [
    {
      "id": 29955,
      "keyword": "autenticar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asesorar": [
    {
      "id": 29959,
      "keyword": "asesorar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aceitería": [
    {
      "id": 29975,
      "keyword": "aceitería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aceiterías": [
    {
      "id": 29975,
      "keyword": "aceitería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de aceite": [
    {
      "id": 29975,
      "keyword": "tienda de aceite",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de aceite": [
    {
      "id": 29975,
      "keyword": "tienda de aceite",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de arreglos de ropa": [
    {
      "id": 29977,
      "keyword": "tienda de arreglos de ropa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de arreglos de ropa": [
    {
      "id": 29977,
      "keyword": "tienda de arreglos de ropa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de bricolaje": [
    {
      "id": 29979,
      "keyword": "tienda de bricolaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "hobby"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de bricolaje": [
    {
      "id": 29979,
      "keyword": "tienda de bricolaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "hobby"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de cartuchos de tinta": [
    {
      "id": 29981,
      "keyword": "tienda de cartuchos de tinta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de cartuchos de tinta": [
    {
      "id": 29981,
      "keyword": "tienda de cartuchos de tinta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "día mundial de concienciación sobre el autismo ": [
    {
      "id": 29927,
      "keyword": "Día Mundial de Concienciación sobre el Autismo ",
      "keywords": 2,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "verb",
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de cuadros": [
    {
      "id": 29983,
      "keyword": "tienda de cuadros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de cuadros": [
    {
      "id": 29983,
      "keyword": "tienda de cuadros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de máquinas de coser": [
    {
      "id": 29985,
      "keyword": "tienda de máquinas de coser",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de máquinas de coser": [
    {
      "id": 29985,
      "keyword": "tienda de máquinas de coser",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "copistería": [
    {
      "id": 29987,
      "keyword": "copistería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "document",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35445,
      "keyword": "copistería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "copisterías": [
    {
      "id": 29987,
      "keyword": "copistería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "document",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35445,
      "keyword": "copistería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de muebles de cocina": [
    {
      "id": 29989,
      "keyword": "tienda de muebles de cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de muebles de cocina": [
    {
      "id": 29989,
      "keyword": "tienda de muebles de cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "certificado de defunción": [
    {
      "id": 29969,
      "keyword": "certificado de defunción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "certificados de defunción": [
    {
      "id": 29969,
      "keyword": "certificado de defunción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de apicultura": [
    {
      "id": 29991,
      "keyword": "tienda de apicultura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "primary sector",
        "apiculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de apicultura": [
    {
      "id": 29991,
      "keyword": "tienda de apicultura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "primary sector",
        "apiculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de productos ecológicos": [
    {
      "id": 29993,
      "keyword": "tienda de productos ecológicos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de productos ecológicos": [
    {
      "id": 29993,
      "keyword": "tienda de productos ecológicos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "certificado de discapacidad": [
    {
      "id": 29971,
      "keyword": "certificado de discapacidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "certificados de discapacidad": [
    {
      "id": 29971,
      "keyword": "certificado de discapacidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro de reconociminento médico": [
    {
      "id": 29967,
      "keyword": "centro de reconociminento médico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros de reconociminentos médicos": [
    {
      "id": 29967,
      "keyword": "centro de reconociminento médico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de serigrafía": [
    {
      "id": 29996,
      "keyword": "tienda de serigrafía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36668,
      "keyword": "tienda de serigrafía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de serigrafía": [
    {
      "id": 29996,
      "keyword": "tienda de serigrafía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36668,
      "keyword": "tienda de serigrafía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sacristía": [
    {
      "id": 30004,
      "keyword": "sacristía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "place",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacristías": [
    {
      "id": 30004,
      "keyword": "sacristía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "place",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "objetos litúrgicos": [
    {
      "id": 29998,
      "keyword": "objetos litúrgicos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "objeto litúrgico": [
    {
      "id": 29998,
      "keyword": "objeto litúrgico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "favorito": [
    {
      "id": 30012,
      "keyword": "favorito",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "favoritos": [
    {
      "id": 30012,
      "keyword": "favorito",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "favorita": [
    {
      "id": 30012,
      "keyword": "favorita",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "favoritas": [
    {
      "id": 30012,
      "keyword": "favorita",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "preferido": [
    {
      "id": 30012,
      "keyword": "preferido",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "preferidos": [
    {
      "id": 30012,
      "keyword": "preferido",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "preferida": [
    {
      "id": 30012,
      "keyword": "preferida",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "preferidas": [
    {
      "id": 30012,
      "keyword": "preferida",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "predilecto": [
    {
      "id": 30012,
      "keyword": "predilecto",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "predilectos": [
    {
      "id": 30012,
      "keyword": "predilecto",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "predilecta": [
    {
      "id": 30012,
      "keyword": "predilecta",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "predilectas": [
    {
      "id": 30012,
      "keyword": "predilecta",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mundo": [
    {
      "id": 30015,
      "keyword": "mundo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30014,
      "keyword": "mundo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "astronomy",
        "planet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mundos": [
    {
      "id": 30015,
      "keyword": "mundo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolos catalanes": [
    {
      "id": 30020,
      "keyword": "bolos catalanes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dya": [
    {
      "id": 30000,
      "keyword": "DYA",
      "keywords": 1,
      "type": 1,
      "tags": [
        "international organization",
        "work",
        "professional",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de vinos": [
    {
      "id": 30027,
      "keyword": "tienda de vinos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de vinos": [
    {
      "id": 30027,
      "keyword": "tienda de vinos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vinatería": [
    {
      "id": 30027,
      "keyword": "vinatería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vinaterías": [
    {
      "id": 30027,
      "keyword": "vinatería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "embajada": [
    {
      "id": 30023,
      "keyword": "embajada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "embajadas": [
    {
      "id": 30023,
      "keyword": "embajada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "embajada española": [
    {
      "id": 30023,
      "keyword": "embajada española",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "embajadas españolas": [
    {
      "id": 30023,
      "keyword": "embajada española",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "galletería": [
    {
      "id": 30025,
      "keyword": "galletería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "galleterías": [
    {
      "id": 30025,
      "keyword": "galletería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "policía foral": [
    {
      "id": 30022,
      "keyword": "policía foral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "policías forales": [
    {
      "id": 30022,
      "keyword": "policía foral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "laico": [
    {
      "id": 30042,
      "keyword": "laico",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "laicos": [
    {
      "id": 30042,
      "keyword": "laico",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "laica": [
    {
      "id": 30042,
      "keyword": "laica",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "laicas": [
    {
      "id": 30042,
      "keyword": "laica",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "solidarizar": [
    {
      "id": 30008,
      "keyword": "solidarizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "evaluador": [
    {
      "id": 30006,
      "keyword": "evaluador",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "evaluadores": [
    {
      "id": 30006,
      "keyword": "evaluador",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "abuso sexual": [
    {
      "id": 31007,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30056,
      "keyword": "abuso sexual",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30057,
      "keyword": "abuso sexual",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30058,
      "keyword": "abuso sexual",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30989,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30990,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30993,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30992,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30991,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31002,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30999,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31005,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31003,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31006,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31001,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34262,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34263,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34264,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abusos sexuales": [
    {
      "id": 31007,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30056,
      "keyword": "abuso sexual",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30057,
      "keyword": "abuso sexual",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30058,
      "keyword": "abuso sexual",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30989,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30990,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30993,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30992,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30991,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31002,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30999,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31005,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31003,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31006,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31001,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34262,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34263,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34264,
      "keyword": "abuso sexual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sexo oral": [
    {
      "id": 30068,
      "keyword": "sexo oral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30069,
      "keyword": "sexo oral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vacunación": [
    {
      "id": 30072,
      "keyword": "vacunación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36476,
      "keyword": "vacunación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30703,
      "keyword": "vacunación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30073,
      "keyword": "vacunación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30074,
      "keyword": "vacunación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31714,
      "keyword": "vacunación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32057,
      "keyword": "vacunación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vacunaciones": [
    {
      "id": 30072,
      "keyword": "vacunación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36476,
      "keyword": "vacunación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30703,
      "keyword": "vacunación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30073,
      "keyword": "vacunación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30074,
      "keyword": "vacunación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31714,
      "keyword": "vacunación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32057,
      "keyword": "vacunación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vacuna": [
    {
      "id": 30073,
      "keyword": "vacuna",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30074,
      "keyword": "vacuna",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31714,
      "keyword": "vacuna",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32057,
      "keyword": "vacuna",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vacunas": [
    {
      "id": 30073,
      "keyword": "vacuna",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30074,
      "keyword": "vacuna",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31714,
      "keyword": "vacuna",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32057,
      "keyword": "vacuna",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espirometría": [
    {
      "id": 30094,
      "keyword": "espirometría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30095,
      "keyword": "espirometría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30096,
      "keyword": "espirometría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espirometrías": [
    {
      "id": 30094,
      "keyword": "espirometría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30095,
      "keyword": "espirometría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30096,
      "keyword": "espirometría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espirar": [
    {
      "id": 30102,
      "keyword": "espirar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "respiratory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30100,
      "keyword": "espirar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "respiratory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30101,
      "keyword": "espirar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "respiratory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "radiografiar": [
    {
      "id": 30109,
      "keyword": "radiografiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30108,
      "keyword": "radiografiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sonda vesical": [
    {
      "id": 30112,
      "keyword": "sonda vesical",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30113,
      "keyword": "sonda vesical",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sondas vesicales": [
    {
      "id": 30112,
      "keyword": "sonda vesical",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30113,
      "keyword": "sonda vesical",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "catéter de floley": [
    {
      "id": 30112,
      "keyword": "catéter de Floley",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30113,
      "keyword": "catéter de Floley",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "catéteres de floley": [
    {
      "id": 30112,
      "keyword": "catéter de Floley",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30113,
      "keyword": "catéter de Floley",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sonda": [
    {
      "id": 30112,
      "keyword": "sonda",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30113,
      "keyword": "sonda",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sondas": [
    {
      "id": 30112,
      "keyword": "sonda",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30113,
      "keyword": "sonda",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "medicación": [
    {
      "id": 30118,
      "keyword": "medicación",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30116,
      "keyword": "medicación",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30117,
      "keyword": "medicación",
      "keywords": 6,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30120,
      "keyword": "medicación",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30119,
      "keyword": "medicación",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medicaciones": [
    {
      "id": 30118,
      "keyword": "medicación",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30116,
      "keyword": "medicación",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30117,
      "keyword": "medicación",
      "keywords": 6,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30120,
      "keyword": "medicación",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30119,
      "keyword": "medicación",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "medicación oral": [
    {
      "id": 30118,
      "keyword": "medicación oral",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30116,
      "keyword": "medicación oral",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30117,
      "keyword": "medicación oral",
      "keywords": 6,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30120,
      "keyword": "medicación oral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30119,
      "keyword": "medicación oral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medicaciones orales": [
    {
      "id": 30118,
      "keyword": "medicación oral",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30116,
      "keyword": "medicación oral",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30117,
      "keyword": "medicación oral",
      "keywords": 6,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30120,
      "keyword": "medicación oral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30119,
      "keyword": "medicación oral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "medicar": [
    {
      "id": 30118,
      "keyword": "medicar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30116,
      "keyword": "medicar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30117,
      "keyword": "medicar",
      "keywords": 6,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30120,
      "keyword": "medicar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30119,
      "keyword": "medicar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medicarse": [
    {
      "id": 30118,
      "keyword": "medicarse",
      "keywords": 5,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30116,
      "keyword": "medicarse",
      "keywords": 5,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30117,
      "keyword": "medicarse",
      "keywords": 6,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30120,
      "keyword": "medicarse",
      "keywords": 4,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30119,
      "keyword": "medicarse",
      "keywords": 4,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "administrar": [
    {
      "id": 30118,
      "keyword": "administrar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30116,
      "keyword": "administrar",
      "keywords": 5,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30117,
      "keyword": "administrar",
      "keywords": 6,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomar medicación": [
    {
      "id": 30117,
      "keyword": "tomar medicación",
      "keywords": 6,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aerosol": [
    {
      "id": 30126,
      "keyword": "aerosol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30128,
      "keyword": "aerosol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30127,
      "keyword": "aerosol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aerosoles": [
    {
      "id": 30126,
      "keyword": "aerosol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30128,
      "keyword": "aerosol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30127,
      "keyword": "aerosol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "martillo de taylor": [
    {
      "id": 30134,
      "keyword": "martillo de Taylor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "martillos de taylor": [
    {
      "id": 30134,
      "keyword": "martillo de Taylor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "martillo para reflejos": [
    {
      "id": 30134,
      "keyword": "martillo para reflejos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "martillos para reflejos": [
    {
      "id": 30134,
      "keyword": "martillo para reflejos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prueba de reflejos": [
    {
      "id": 30136,
      "keyword": "prueba de reflejos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pruebas de reflejos": [
    {
      "id": 30136,
      "keyword": "prueba de reflejos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pulsioximetría": [
    {
      "id": 30138,
      "keyword": "pulsioximetría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulsioximetrías": [
    {
      "id": 30138,
      "keyword": "pulsioximetría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saturación de oxígeno": [
    {
      "id": 30138,
      "keyword": "saturación de oxígeno",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saturaciones de oxígeno": [
    {
      "id": 30138,
      "keyword": "saturación de oxígeno",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pulsioxímetro": [
    {
      "id": 38905,
      "keyword": "pulsioxímetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30138,
      "keyword": "pulsioxímetro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulsioxímetros": [
    {
      "id": 38905,
      "keyword": "pulsioxímetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30138,
      "keyword": "pulsioxímetro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perímetro craneal": [
    {
      "id": 30140,
      "keyword": "perímetro craneal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perímetros craneales": [
    {
      "id": 30140,
      "keyword": "perímetro craneal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cánula nasal": [
    {
      "id": 38911,
      "keyword": "cánula nasal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30142,
      "keyword": "cánula nasal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cánulas nasales": [
    {
      "id": 38911,
      "keyword": "cánula nasal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30142,
      "keyword": "cánula nasal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gafas nasales": [
    {
      "id": 38911,
      "keyword": "gafas nasales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30142,
      "keyword": "gafas nasales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torniquete": [
    {
      "id": 30144,
      "keyword": "torniquete",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torniquetes": [
    {
      "id": 30144,
      "keyword": "torniquete",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "compresor elástico": [
    {
      "id": 30144,
      "keyword": "compresor elástico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compresores elásticos": [
    {
      "id": 30144,
      "keyword": "compresor elástico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "banda elástica": [
    {
      "id": 30144,
      "keyword": "banda elástica",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bandas elásticas": [
    {
      "id": 30144,
      "keyword": "banda elástica",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "brazalete de presiones": [
    {
      "id": 30144,
      "keyword": "brazalete de presiones",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brazaletes de presiones": [
    {
      "id": 30144,
      "keyword": "brazalete de presiones",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mujer en ropa interior": [
    {
      "id": 30152,
      "keyword": "mujer en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mujeres en ropa interior": [
    {
      "id": 30152,
      "keyword": "mujer en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hombre en ropa interior": [
    {
      "id": 30154,
      "keyword": "hombre en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "teenager"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30155,
      "keyword": "hombre en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31268,
      "keyword": "hombre en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "teenager"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31262,
      "keyword": "hombre en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hombres en ropa interior": [
    {
      "id": 30154,
      "keyword": "hombre en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "teenager"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30155,
      "keyword": "hombre en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31268,
      "keyword": "hombre en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "teenager"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31262,
      "keyword": "hombre en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casulla": [
    {
      "id": 29965,
      "keyword": "casulla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casullas": [
    {
      "id": 29965,
      "keyword": "casulla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "niño en ropa interior": [
    {
      "id": 30158,
      "keyword": "niño en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31217,
      "keyword": "niño en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31258,
      "keyword": "niño en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niños en ropa interior": [
    {
      "id": 30158,
      "keyword": "niño en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31217,
      "keyword": "niño en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31258,
      "keyword": "niño en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "niña en ropa interior": [
    {
      "id": 30160,
      "keyword": "niña en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31213,
      "keyword": "niña en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31260,
      "keyword": "niña en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niñas en ropa interior": [
    {
      "id": 30160,
      "keyword": "niña en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31213,
      "keyword": "niña en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31260,
      "keyword": "niña en ropa interior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "poner sonda nasogástrica": [
    {
      "id": 30164,
      "keyword": "poner sonda nasogástrica",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30162,
      "keyword": "poner sonda nasogástrica",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30163,
      "keyword": "poner sonda nasogástrica",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colocar sonda nasogástrica": [
    {
      "id": 30164,
      "keyword": "colocar sonda nasogástrica",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30162,
      "keyword": "colocar sonda nasogástrica",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30163,
      "keyword": "colocar sonda nasogástrica",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiar con gasa": [
    {
      "id": 30150,
      "keyword": "limpiar con gasa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner esparadrapo": [
    {
      "id": 30174,
      "keyword": "poner esparadrapo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30175,
      "keyword": "poner esparadrapo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30176,
      "keyword": "poner esparadrapo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pegar esparadrapo": [
    {
      "id": 30174,
      "keyword": "pegar esparadrapo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30175,
      "keyword": "pegar esparadrapo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30176,
      "keyword": "pegar esparadrapo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medicación con cámara": [
    {
      "id": 30181,
      "keyword": "medicación con cámara",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30180,
      "keyword": "medicación con cámara",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30182,
      "keyword": "medicación con cámara",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medicaciones con cámara": [
    {
      "id": 30181,
      "keyword": "medicación con cámara",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30180,
      "keyword": "medicación con cámara",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30182,
      "keyword": "medicación con cámara",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "niño con gafas nasales": [
    {
      "id": 30188,
      "keyword": "niño con gafas nasales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niños con gafas nasales": [
    {
      "id": 30188,
      "keyword": "niño con gafas nasales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "niña con gafas nasales": [
    {
      "id": 30186,
      "keyword": "niña con gafas nasales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niñas con gafas nasales": [
    {
      "id": 30186,
      "keyword": "niña con gafas nasales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "persona con gafas nasales": [
    {
      "id": 30190,
      "keyword": "persona con gafas nasales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "personas con gafas nasales": [
    {
      "id": 30190,
      "keyword": "persona con gafas nasales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "técnico en radiología": [
    {
      "id": 38827,
      "keyword": "técnico en radiología",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30192,
      "keyword": "técnico en radiología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnicos en radiología": [
    {
      "id": 38827,
      "keyword": "técnico en radiología",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30192,
      "keyword": "técnico en radiología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "técnico de rayos x": [
    {
      "id": 38827,
      "keyword": "técnico de rayos X",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30192,
      "keyword": "técnico de rayos X",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnicos de rayos x": [
    {
      "id": 38827,
      "keyword": "técnico de rayos X",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30192,
      "keyword": "técnico de rayos X",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "percibir": [
    {
      "id": 30196,
      "keyword": "percibir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30194,
      "keyword": "percibir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30198,
      "keyword": "percibir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30197,
      "keyword": "percibir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30195,
      "keyword": "percibir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "madagascar": [
    {
      "id": 30204,
      "keyword": "Madagascar",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37645,
      "keyword": "Madagascar",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "categoría": [
    {
      "id": 30205,
      "keyword": "categoría",
      "keywords": 2,
      "type": 2,
      "tags": [
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "categorías": [
    {
      "id": 30205,
      "keyword": "categoría",
      "keywords": 2,
      "type": 2,
      "tags": [
        "categorization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30205,
      "keyword": "categorías",
      "keywords": 2,
      "type": 2,
      "tags": [
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "listado": [
    {
      "id": 30207,
      "keyword": "listado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "listados": [
    {
      "id": 30207,
      "keyword": "listado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "listar": [
    {
      "id": 30207,
      "keyword": "listar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "document",
        "information document",
        "education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quesería": [
    {
      "id": 30209,
      "keyword": "quesería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "dairy product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "queserías": [
    {
      "id": 30209,
      "keyword": "quesería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "dairy product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chocolatería": [
    {
      "id": 30211,
      "keyword": "chocolatería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chocolaterías": [
    {
      "id": 30211,
      "keyword": "chocolatería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "videoclub": [
    {
      "id": 30213,
      "keyword": "videoclub",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "videoclubs": [
    {
      "id": 30213,
      "keyword": "videoclub",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de motos": [
    {
      "id": 30215,
      "keyword": "tienda de motos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "movement",
        "traffic",
        "mode of transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de motos": [
    {
      "id": 30215,
      "keyword": "tienda de motos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "movement",
        "traffic",
        "mode of transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de esquís": [
    {
      "id": 30217,
      "keyword": "tienda de esquís",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de esquís": [
    {
      "id": 30217,
      "keyword": "tienda de esquís",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sentir": [
    {
      "id": 30196,
      "keyword": "sentir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de colchones": [
    {
      "id": 30222,
      "keyword": "tienda de colchones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de colchones": [
    {
      "id": 30222,
      "keyword": "tienda de colchones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de bolsos": [
    {
      "id": 30219,
      "keyword": "tienda de bolsos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de bolsos": [
    {
      "id": 30219,
      "keyword": "tienda de bolsos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pulsador para tableta": [
    {
      "id": 30223,
      "keyword": "pulsador para tableta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulsadores para tableta": [
    {
      "id": 30223,
      "keyword": "pulsador para tableta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "web accesible": [
    {
      "id": 30227,
      "keyword": "web accesible",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "webs accesibles": [
    {
      "id": 30227,
      "keyword": "web accesible",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "página web accesible": [
    {
      "id": 30227,
      "keyword": "página web accesible",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "páginas web accesibles": [
    {
      "id": 30227,
      "keyword": "página web accesible",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "síndrome de down apoyo": [
    {
      "id": 30235,
      "keyword": "Síndrome de Down apoyo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maullido de gato apoyo": [
    {
      "id": 30237,
      "keyword": "Maullido de gato apoyo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arbusto": [
    {
      "id": 30241,
      "keyword": "arbusto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "bush"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arbustos": [
    {
      "id": 30241,
      "keyword": "arbusto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "bush"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maullido de gato": [
    {
      "id": 30239,
      "keyword": "Maullido de gato",
      "keywords": 1,
      "type": 1,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rayo": [
    {
      "id": 30243,
      "keyword": "rayo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34545,
      "keyword": "rayo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rayos": [
    {
      "id": 30243,
      "keyword": "rayo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34545,
      "keyword": "rayo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rayo de sol": [
    {
      "id": 30243,
      "keyword": "rayo de sol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rayos de sol": [
    {
      "id": 30243,
      "keyword": "rayo de sol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "liberarse": [
    {
      "id": 30251,
      "keyword": "liberarse",
      "keywords": 3,
      "type": 3,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35893,
      "keyword": "liberarse",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "independizarse": [
    {
      "id": 30251,
      "keyword": "independizarse",
      "keywords": 3,
      "type": 3,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35893,
      "keyword": "independizarse",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tío": [
    {
      "id": 30255,
      "keyword": "tío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30256,
      "keyword": "tío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30259,
      "keyword": "tío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30258,
      "keyword": "tío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30260,
      "keyword": "tío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30261,
      "keyword": "tío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30257,
      "keyword": "tío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30262,
      "keyword": "tío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tíos": [
    {
      "id": 30255,
      "keyword": "tío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30256,
      "keyword": "tío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30259,
      "keyword": "tío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30258,
      "keyword": "tío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30260,
      "keyword": "tío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30261,
      "keyword": "tío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30257,
      "keyword": "tío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30262,
      "keyword": "tío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34841,
      "keyword": "tíos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34840,
      "keyword": "tíos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34851,
      "keyword": "tíos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34850,
      "keyword": "tíos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parlamento europeo": [
    {
      "id": 30247,
      "keyword": "parlamento europeo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parlamentos europeos": [
    {
      "id": 30247,
      "keyword": "parlamento europeo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "eurocámara": [
    {
      "id": 30247,
      "keyword": "Eurocámara",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tía": [
    {
      "id": 30271,
      "keyword": "tía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30273,
      "keyword": "tía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30272,
      "keyword": "tía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30275,
      "keyword": "tía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30276,
      "keyword": "tía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30274,
      "keyword": "tía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30277,
      "keyword": "tía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30278,
      "keyword": "tía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tías": [
    {
      "id": 30271,
      "keyword": "tía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30273,
      "keyword": "tía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30272,
      "keyword": "tía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30275,
      "keyword": "tía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30276,
      "keyword": "tía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30274,
      "keyword": "tía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30277,
      "keyword": "tía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30278,
      "keyword": "tía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sobrino": [
    {
      "id": 30288,
      "keyword": "sobrino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30287,
      "keyword": "sobrino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30290,
      "keyword": "sobrino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30291,
      "keyword": "sobrino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30292,
      "keyword": "sobrino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30293,
      "keyword": "sobrino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30286,
      "keyword": "sobrino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30289,
      "keyword": "sobrino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sobrinos": [
    {
      "id": 30288,
      "keyword": "sobrino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30287,
      "keyword": "sobrino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30290,
      "keyword": "sobrino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30291,
      "keyword": "sobrino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30292,
      "keyword": "sobrino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30293,
      "keyword": "sobrino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30286,
      "keyword": "sobrino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30289,
      "keyword": "sobrino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sobrina": [
    {
      "id": 30302,
      "keyword": "sobrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30303,
      "keyword": "sobrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30304,
      "keyword": "sobrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30308,
      "keyword": "sobrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30309,
      "keyword": "sobrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30306,
      "keyword": "sobrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30307,
      "keyword": "sobrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30305,
      "keyword": "sobrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sobrinas": [
    {
      "id": 30302,
      "keyword": "sobrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30303,
      "keyword": "sobrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30304,
      "keyword": "sobrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30308,
      "keyword": "sobrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30309,
      "keyword": "sobrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30306,
      "keyword": "sobrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30307,
      "keyword": "sobrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30305,
      "keyword": "sobrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "primos": [
    {
      "id": 30318,
      "keyword": "primos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30319,
      "keyword": "primos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30320,
      "keyword": "primos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30321,
      "keyword": "primos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30322,
      "keyword": "primos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30326,
      "keyword": "primos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30328,
      "keyword": "primos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30340,
      "keyword": "primo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30341,
      "keyword": "primo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30327,
      "keyword": "primos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30343,
      "keyword": "primo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30344,
      "keyword": "primo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30324,
      "keyword": "primos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30345,
      "keyword": "primo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30346,
      "keyword": "primo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30347,
      "keyword": "primo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30323,
      "keyword": "primos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30325,
      "keyword": "primos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30342,
      "keyword": "primo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30380,
      "keyword": "primos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "primo": [
    {
      "id": 30340,
      "keyword": "primo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30341,
      "keyword": "primo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30343,
      "keyword": "primo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30344,
      "keyword": "primo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30345,
      "keyword": "primo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30346,
      "keyword": "primo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30347,
      "keyword": "primo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30342,
      "keyword": "primo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prima": [
    {
      "id": 30357,
      "keyword": "prima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30359,
      "keyword": "prima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30360,
      "keyword": "prima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30356,
      "keyword": "prima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30358,
      "keyword": "prima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30361,
      "keyword": "prima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30362,
      "keyword": "prima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30363,
      "keyword": "prima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "primas": [
    {
      "id": 30357,
      "keyword": "prima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30359,
      "keyword": "prima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30360,
      "keyword": "prima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30356,
      "keyword": "prima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30358,
      "keyword": "prima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30361,
      "keyword": "prima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30362,
      "keyword": "prima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30363,
      "keyword": "prima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30372,
      "keyword": "primas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30373,
      "keyword": "primas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30374,
      "keyword": "primas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30375,
      "keyword": "primas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nerviosa": [
    {
      "id": 30391,
      "keyword": "nerviosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "human response",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38929,
      "keyword": "nerviosa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31095,
      "keyword": "nerviosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nerviosas": [
    {
      "id": 30391,
      "keyword": "nerviosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "human response",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38929,
      "keyword": "nerviosa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31095,
      "keyword": "nerviosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "partirse de risa": [
    {
      "id": 30393,
      "keyword": "partirse de risa",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llorar de la risa": [
    {
      "id": 30393,
      "keyword": "llorar de la risa",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "partir de risa": [
    {
      "id": 30393,
      "keyword": "partir de risa",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pincho de tortilla": [
    {
      "id": 30401,
      "keyword": "pincho de tortilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinchos de tortilla": [
    {
      "id": 30401,
      "keyword": "pincho de tortilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de decoración": [
    {
      "id": 30413,
      "keyword": "tienda de decoración",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de decoración": [
    {
      "id": 30413,
      "keyword": "tienda de decoración",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pincho de chorizo": [
    {
      "id": 30409,
      "keyword": "pincho de chorizo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinchos de chorizo": [
    {
      "id": 30409,
      "keyword": "pincho de chorizo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de electrodomésticos": [
    {
      "id": 30419,
      "keyword": "tienda de electrodomésticos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de electrodomésticos": [
    {
      "id": 30419,
      "keyword": "tienda de electrodomésticos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de fotografía": [
    {
      "id": 30422,
      "keyword": "tienda de fotografía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de fotografía": [
    {
      "id": 30422,
      "keyword": "tienda de fotografía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de electricidad": [
    {
      "id": 30417,
      "keyword": "tienda de electricidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de electricidad": [
    {
      "id": 30417,
      "keyword": "tienda de electricidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "appliance",
        "light fixture",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerca": [
    {
      "id": 30383,
      "keyword": "cerca",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts",
        "core vocabulary",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36758,
      "keyword": "cerca",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cercano": [
    {
      "id": 30383,
      "keyword": "cercano",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts",
        "core vocabulary",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36758,
      "keyword": "cercano",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cercanos": [
    {
      "id": 30383,
      "keyword": "cercano",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts",
        "core vocabulary",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36758,
      "keyword": "cercano",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cercana": [
    {
      "id": 30383,
      "keyword": "cercana",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts",
        "core vocabulary",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36758,
      "keyword": "cercana",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cercanas": [
    {
      "id": 30383,
      "keyword": "cercana",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts",
        "core vocabulary",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36758,
      "keyword": "cercana",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lejos": [
    {
      "id": 36759,
      "keyword": "lejos",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30385,
      "keyword": "lejos",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts",
        "core vocabulary",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lejano": [
    {
      "id": 36759,
      "keyword": "lejano",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30385,
      "keyword": "lejano",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts",
        "core vocabulary",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lejanos": [
    {
      "id": 36759,
      "keyword": "lejano",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30385,
      "keyword": "lejano",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts",
        "core vocabulary",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lejana": [
    {
      "id": 36759,
      "keyword": "lejana",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30385,
      "keyword": "lejana",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts",
        "core vocabulary",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lejanas": [
    {
      "id": 36759,
      "keyword": "lejana",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30385,
      "keyword": "lejana",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of place",
        "mathematics",
        "basic concepts",
        "core vocabulary",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala": [
    {
      "id": 30387,
      "keyword": "sala",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "cinema",
        "show",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas": [
    {
      "id": 30387,
      "keyword": "sala",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "cinema",
        "show",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de cine": [
    {
      "id": 30387,
      "keyword": "sala de cine",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "cinema",
        "show",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de bebidas": [
    {
      "id": 30444,
      "keyword": "tienda de bebidas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de bebidas": [
    {
      "id": 30444,
      "keyword": "tienda de bebidas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "golpear con la cabeza": [
    {
      "id": 30458,
      "keyword": "golpear con la cabeza",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31069,
      "keyword": "golpear con la cabeza",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "work accident"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "box": [
    {
      "id": 38861,
      "keyword": "box",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31742,
      "keyword": "box",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30466,
      "keyword": "box",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31358,
      "keyword": "box",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boxes": [
    {
      "id": 38861,
      "keyword": "box",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31742,
      "keyword": "box",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30466,
      "keyword": "box",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31358,
      "keyword": "box",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de congelados": [
    {
      "id": 30446,
      "keyword": "tienda de congelados",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de congelados": [
    {
      "id": 30446,
      "keyword": "tienda de congelados",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "box de críticos": [
    {
      "id": 30468,
      "keyword": "box de críticos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boxes de críticos": [
    {
      "id": 30468,
      "keyword": "box de críticos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "unidad de cuidados intensivos": [
    {
      "id": 30468,
      "keyword": "unidad de cuidados intensivos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "unidades de cuidados intensivos": [
    {
      "id": 30468,
      "keyword": "unidad de cuidados intensivos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "uci": [
    {
      "id": 30468,
      "keyword": "UCI",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ucis": [
    {
      "id": 30468,
      "keyword": "UCI",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cabestrillo": [
    {
      "id": 30472,
      "keyword": "cabestrillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cabestrillos": [
    {
      "id": 30472,
      "keyword": "cabestrillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón gástrico": [
    {
      "id": 30474,
      "keyword": "botón gástrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30475,
      "keyword": "botón gástrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30476,
      "keyword": "botón gástrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones gástricos": [
    {
      "id": 30474,
      "keyword": "botón gástrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30475,
      "keyword": "botón gástrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30476,
      "keyword": "botón gástrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dar dinero": [
    {
      "id": 30480,
      "keyword": "dar dinero",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "economy",
        "money"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30857,
      "keyword": "dar dinero",
      "keywords": 3,
      "type": 3,
      "tags": [
        "religion",
        "christianity",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ansioso": [
    {
      "id": 30485,
      "keyword": "ansioso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37176,
      "keyword": "ansioso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30484,
      "keyword": "ansioso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ansiosos": [
    {
      "id": 30485,
      "keyword": "ansioso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37176,
      "keyword": "ansioso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30484,
      "keyword": "ansioso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ansiosa": [
    {
      "id": 30485,
      "keyword": "ansiosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37175,
      "keyword": "ansiosa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30484,
      "keyword": "ansiosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ansiosas": [
    {
      "id": 30485,
      "keyword": "ansiosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37175,
      "keyword": "ansiosa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30484,
      "keyword": "ansiosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guardabosques": [
    {
      "id": 30494,
      "keyword": "guardabosques",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "forestry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30495,
      "keyword": "guardabosques",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "forestry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30496,
      "keyword": "guardabosques",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "forestry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agente forestal": [
    {
      "id": 30494,
      "keyword": "agente forestal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "forestry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30495,
      "keyword": "agente forestal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "forestry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30496,
      "keyword": "agente forestal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "forestry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agentes forestales": [
    {
      "id": 30494,
      "keyword": "agente forestal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "forestry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30495,
      "keyword": "agente forestal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "forestry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30496,
      "keyword": "agente forestal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "forestry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "archipiélago": [
    {
      "id": 30492,
      "keyword": "archipiélago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "archipiélagos": [
    {
      "id": 30492,
      "keyword": "archipiélago",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "control de enfermería": [
    {
      "id": 38867,
      "keyword": "control de enfermería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30460,
      "keyword": "control de enfermería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "controles de enfermería": [
    {
      "id": 38867,
      "keyword": "control de enfermería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30460,
      "keyword": "control de enfermería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de exploración": [
    {
      "id": 30462,
      "keyword": "sala de exploración",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "medical procedure",
        "medical test",
        "communication",
        "signaling system",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38875,
      "keyword": "sala de exploración",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "medical procedure",
        "medical test",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38357,
      "keyword": "sala de exploración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "medical procedure",
        "medical test",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de exploración": [
    {
      "id": 30462,
      "keyword": "sala de exploración",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "medical procedure",
        "medical test",
        "communication",
        "signaling system",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38875,
      "keyword": "sala de exploración",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "medical procedure",
        "medical test",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38357,
      "keyword": "sala de exploración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "medical procedure",
        "medical test",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "admisión": [
    {
      "id": 38356,
      "keyword": "admisión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "person",
        "patient",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30464,
      "keyword": "admisión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "person",
        "patient",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "admisiones": [
    {
      "id": 38356,
      "keyword": "admisión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "person",
        "patient",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30464,
      "keyword": "admisión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "person",
        "patient",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "admisión hospitalaria": [
    {
      "id": 38356,
      "keyword": "admisión hospitalaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "person",
        "patient",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30464,
      "keyword": "admisión hospitalaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "person",
        "patient",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "admisiones hospitalarias": [
    {
      "id": 38356,
      "keyword": "admisión hospitalaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "person",
        "patient",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30464,
      "keyword": "admisión hospitalaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "person",
        "patient",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cachopo": [
    {
      "id": 30508,
      "keyword": "cachopo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cachopos": [
    {
      "id": 30508,
      "keyword": "cachopo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gasolinero": [
    {
      "id": 30500,
      "keyword": "gasolinero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30501,
      "keyword": "gasolinero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gasolineros": [
    {
      "id": 30500,
      "keyword": "gasolinero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30501,
      "keyword": "gasolinero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "neurona": [
    {
      "id": 30533,
      "keyword": "neurona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "neuronas": [
    {
      "id": 30533,
      "keyword": "neurona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rosal": [
    {
      "id": 30522,
      "keyword": "rosal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "bush"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rosales": [
    {
      "id": 30522,
      "keyword": "rosal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "bush"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "patinar sobre ruedas": [
    {
      "id": 30554,
      "keyword": "patinar sobre ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30582,
      "keyword": "patinar sobre ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30583,
      "keyword": "patinar sobre ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30585,
      "keyword": "patinar sobre ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30584,
      "keyword": "patinar sobre ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30586,
      "keyword": "patinar sobre ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30587,
      "keyword": "patinar sobre ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30588,
      "keyword": "patinar sobre ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30589,
      "keyword": "patinar sobre ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30938,
      "keyword": "patinar sobre ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30942,
      "keyword": "patinar sobre ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30944,
      "keyword": "patinar sobre ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30943,
      "keyword": "patinar sobre ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30939,
      "keyword": "patinar sobre ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30941,
      "keyword": "patinar sobre ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30940,
      "keyword": "patinar sobre ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31144,
      "keyword": "patinar sobre ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31143,
      "keyword": "patinar sobre ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pileta cubierta": [
    {
      "id": 30514,
      "keyword": "pileta cubierta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ferry": [
    {
      "id": 30612,
      "keyword": "ferry",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ferrys": [
    {
      "id": 30612,
      "keyword": "ferry",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hacer deporte": [
    {
      "id": 30604,
      "keyword": "hacer deporte",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "doler": [
    {
      "id": 30620,
      "keyword": "doler",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "human body",
        "anatomy",
        "human anatomy",
        "animal",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chantajear": [
    {
      "id": 30626,
      "keyword": "chantajear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30627,
      "keyword": "chantajear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "extorsionar": [
    {
      "id": 30626,
      "keyword": "extorsionar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30627,
      "keyword": "extorsionar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aventurera": [
    {
      "id": 30616,
      "keyword": "aventurera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "literature",
        "scenic art",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aventureras": [
    {
      "id": 30616,
      "keyword": "aventurera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "literature",
        "scenic art",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "intrépida": [
    {
      "id": 30616,
      "keyword": "intrépida",
      "keywords": 3,
      "type": 4,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "literature",
        "scenic art",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intrépidas": [
    {
      "id": 30616,
      "keyword": "intrépida",
      "keywords": 3,
      "type": 4,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "literature",
        "scenic art",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "infiel": [
    {
      "id": 30630,
      "keyword": "infiel",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "law",
        "crime",
        "gender violence"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "infieles": [
    {
      "id": 30630,
      "keyword": "infiel",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "law",
        "crime",
        "gender violence"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "avergonzar": [
    {
      "id": 30632,
      "keyword": "avergonzar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cepillo y pasta de dientes": [
    {
      "id": 30614,
      "keyword": "cepillo y pasta de dientes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cepillos y pasta de dientes": [
    {
      "id": 30614,
      "keyword": "cepillo y pasta de dientes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "indiferencia": [
    {
      "id": 30634,
      "keyword": "indiferencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "menospreciar": [
    {
      "id": 30636,
      "keyword": "menospreciar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31004,
      "keyword": "menospreciar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ridiculizar": [
    {
      "id": 30638,
      "keyword": "ridiculizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "gender violence",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acoso": [
    {
      "id": 30644,
      "keyword": "acoso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30645,
      "keyword": "acoso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "culpabilizar": [
    {
      "id": 30642,
      "keyword": "culpabilizar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime",
        "gender violence"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "culpabilizarse": [
    {
      "id": 30642,
      "keyword": "culpabilizarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime",
        "gender violence"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estirar del pelo": [
    {
      "id": 30658,
      "keyword": "estirar del pelo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "optometrías": [
    {
      "id": 30660,
      "keyword": "optometría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30661,
      "keyword": "optometría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "foróptero": [
    {
      "id": 30664,
      "keyword": "foróptero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "forópteros": [
    {
      "id": 30664,
      "keyword": "foróptero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enema": [
    {
      "id": 30668,
      "keyword": "enema",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enemas": [
    {
      "id": 38051,
      "keyword": "poner un enema",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30668,
      "keyword": "enema",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "poner un enema": [
    {
      "id": 38051,
      "keyword": "poner un enema",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30668,
      "keyword": "poner un enema",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "supositorio de glicerina": [
    {
      "id": 30670,
      "keyword": "supositorio de glicerina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "supositorios de glicerina": [
    {
      "id": 30670,
      "keyword": "supositorio de glicerina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "microenema": [
    {
      "id": 30671,
      "keyword": "microenema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "microenemas": [
    {
      "id": 30671,
      "keyword": "microenema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colegio mayor": [
    {
      "id": 30674,
      "keyword": "colegio mayor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30675,
      "keyword": "colegio mayor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30676,
      "keyword": "colegio mayor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colegios mayores": [
    {
      "id": 30674,
      "keyword": "colegio mayor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30675,
      "keyword": "colegio mayor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30676,
      "keyword": "colegio mayor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trocar": [
    {
      "id": 30666,
      "keyword": "trocar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trocares": [
    {
      "id": 30666,
      "keyword": "trocar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "teacch": [
    {
      "id": 30648,
      "keyword": "Teacch",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task",
        "special education",
        "methodology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32869,
      "keyword": "Teacch",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32868,
      "keyword": "Teacch",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32967,
      "keyword": "Teacch",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32966,
      "keyword": "Teacch",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36971,
      "keyword": "Teacch",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task",
        "special education",
        "methodology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36976,
      "keyword": "Teacch",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task",
        "special education",
        "methodology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "collarín": [
    {
      "id": 30686,
      "keyword": "collarín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30687,
      "keyword": "collarín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "collarines": [
    {
      "id": 30686,
      "keyword": "collarín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30687,
      "keyword": "collarín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "auscultación": [
    {
      "id": 30692,
      "keyword": "auscultación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "auscultaciones": [
    {
      "id": 30692,
      "keyword": "auscultación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "exploración": [
    {
      "id": 30692,
      "keyword": "exploración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "protectores": [
    {
      "id": 30684,
      "keyword": "protectores",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "electrodos": [
    {
      "id": 30694,
      "keyword": "electrodos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ecografía": [
    {
      "id": 30696,
      "keyword": "ecografía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30697,
      "keyword": "ecografía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31730,
      "keyword": "ecografía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38350,
      "keyword": "ecografía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38862,
      "keyword": "ecografía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ecografías": [
    {
      "id": 30696,
      "keyword": "ecografía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30697,
      "keyword": "ecografía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31730,
      "keyword": "ecografía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38350,
      "keyword": "ecografía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38862,
      "keyword": "ecografía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escánereres": [
    {
      "id": 30705,
      "keyword": "escáner",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tomografía": [
    {
      "id": 30705,
      "keyword": "tomografía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38354,
      "keyword": "tomografía",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomografías": [
    {
      "id": 30705,
      "keyword": "tomografía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38354,
      "keyword": "tomografía",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "niño con parche": [
    {
      "id": 37813,
      "keyword": "niño con parche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30710,
      "keyword": "niño con parche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30709,
      "keyword": "niño con parche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niños con parche": [
    {
      "id": 37813,
      "keyword": "niño con parche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30710,
      "keyword": "niño con parche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30709,
      "keyword": "niño con parche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "niña con parche": [
    {
      "id": 37812,
      "keyword": "niña con parche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30711,
      "keyword": "niña con parche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30712,
      "keyword": "niña con parche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niñas con parche": [
    {
      "id": 37812,
      "keyword": "niña con parche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30711,
      "keyword": "niña con parche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30712,
      "keyword": "niña con parche",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "signo meníngeo": [
    {
      "id": 30717,
      "keyword": "signo meníngeo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30718,
      "keyword": "signo meníngeo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "signos meníngeos": [
    {
      "id": 30717,
      "keyword": "signo meníngeo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30718,
      "keyword": "signo meníngeo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolsa de agua caliente": [
    {
      "id": 30729,
      "keyword": "bolsa de agua caliente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30774,
      "keyword": "bolsa de agua caliente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas de agua caliente": [
    {
      "id": 30729,
      "keyword": "bolsa de agua caliente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30774,
      "keyword": "bolsa de agua caliente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "punción": [
    {
      "id": 30722,
      "keyword": "punción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31740,
      "keyword": "punción",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "punciones": [
    {
      "id": 30722,
      "keyword": "punción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31740,
      "keyword": "punción",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "punción lumbar": [
    {
      "id": 30722,
      "keyword": "punción lumbar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31740,
      "keyword": "punción lumbar",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "punciones lumbares": [
    {
      "id": 30722,
      "keyword": "punción lumbar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31740,
      "keyword": "punción lumbar",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oftalmoscopio": [
    {
      "id": 30735,
      "keyword": "oftalmoscopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39226,
      "keyword": "oftalmoscopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oftalmoscopios": [
    {
      "id": 30735,
      "keyword": "oftalmoscopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39226,
      "keyword": "oftalmoscopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sacerdote": [
    {
      "id": 30700,
      "keyword": "sacerdote",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30822,
      "keyword": "sacerdote",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacerdotes": [
    {
      "id": 30700,
      "keyword": "sacerdote",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30822,
      "keyword": "sacerdote",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cura": [
    {
      "id": 30700,
      "keyword": "cura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30822,
      "keyword": "cura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "curas": [
    {
      "id": 30700,
      "keyword": "cura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30822,
      "keyword": "cura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuña": [
    {
      "id": 35237,
      "keyword": "cuña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36433,
      "keyword": "cuña",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30701,
      "keyword": "cuña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37243,
      "keyword": "cuña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuñas": [
    {
      "id": 35237,
      "keyword": "cuña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36433,
      "keyword": "cuña",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30701,
      "keyword": "cuña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37243,
      "keyword": "cuña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "potencial evocado": [
    {
      "id": 30731,
      "keyword": "potencial evocado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "potenciales evocados": [
    {
      "id": 30731,
      "keyword": "potencial evocado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30731,
      "keyword": "potenciales evocados",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sonda rectal": [
    {
      "id": 30747,
      "keyword": "sonda rectal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sondas rectales": [
    {
      "id": 30747,
      "keyword": "sonda rectal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grapadora quirúrgica": [
    {
      "id": 30772,
      "keyword": "grapadora quirúrgica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grapadoras quirúrgicas": [
    {
      "id": 30772,
      "keyword": "grapadora quirúrgica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abrochadora quirúrgica": [
    {
      "id": 30772,
      "keyword": "abrochadora quirúrgica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrochadoras quirúrgica": [
    {
      "id": 30772,
      "keyword": "abrochadora quirúrgica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prueba de alergia": [
    {
      "id": 30776,
      "keyword": "prueba de alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30777,
      "keyword": "prueba de alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30778,
      "keyword": "prueba de alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30779,
      "keyword": "prueba de alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30780,
      "keyword": "prueba de alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pruebas de alergia": [
    {
      "id": 30776,
      "keyword": "prueba de alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30777,
      "keyword": "prueba de alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30778,
      "keyword": "prueba de alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30779,
      "keyword": "prueba de alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30780,
      "keyword": "prueba de alergia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grapar una herida": [
    {
      "id": 30786,
      "keyword": "grapar una herida",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exploración de reflejos": [
    {
      "id": 30787,
      "keyword": "exploración de reflejos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exploraciones de reflejos": [
    {
      "id": 30787,
      "keyword": "exploración de reflejos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "otoscopia": [
    {
      "id": 30769,
      "keyword": "otoscopia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "otoscopias": [
    {
      "id": 30769,
      "keyword": "otoscopia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "exploración abdominal": [
    {
      "id": 30788,
      "keyword": "exploración abdominal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exploraciones abdominales": [
    {
      "id": 30788,
      "keyword": "exploración abdominal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pulsera hospitalaria": [
    {
      "id": 30790,
      "keyword": "pulsera hospitalaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulseras hospitalarias": [
    {
      "id": 30790,
      "keyword": "pulsera hospitalaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "explorar mediante tac": [
    {
      "id": 30797,
      "keyword": "explorar mediante TAC",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer un tac": [
    {
      "id": 30797,
      "keyword": "hacer un TAC",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "audiometría": [
    {
      "id": 30799,
      "keyword": "audiometría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "audiometrías": [
    {
      "id": 30799,
      "keyword": "audiometría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "poner supositorio": [
    {
      "id": 30801,
      "keyword": "poner supositorio",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "electrocardiógrafo": [
    {
      "id": 30807,
      "keyword": "electrocardiógrafo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "electrocardiógrafos": [
    {
      "id": 30807,
      "keyword": "electrocardiógrafo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "santiguar": [
    {
      "id": 30809,
      "keyword": "santiguar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30811,
      "keyword": "santiguar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30812,
      "keyword": "santiguar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30841,
      "keyword": "santiguar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30813,
      "keyword": "santiguar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "persignar": [
    {
      "id": 30809,
      "keyword": "persignar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30811,
      "keyword": "persignar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30812,
      "keyword": "persignar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30841,
      "keyword": "persignar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30813,
      "keyword": "persignar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oftalmoscopia": [
    {
      "id": 30763,
      "keyword": "oftalmoscopia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39217,
      "keyword": "oftalmoscopia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oftalmoscopias": [
    {
      "id": 30763,
      "keyword": "oftalmoscopia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39217,
      "keyword": "oftalmoscopia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "religiosa": [
    {
      "id": 30824,
      "keyword": "religiosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "religiosas": [
    {
      "id": 30824,
      "keyword": "religiosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botella hospitalaria": [
    {
      "id": 30765,
      "keyword": "botella hospitalaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botellas hospitalarias": [
    {
      "id": 30765,
      "keyword": "botella hospitalaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salmo": [
    {
      "id": 30831,
      "keyword": "salmo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30830,
      "keyword": "salmo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salmos": [
    {
      "id": 30831,
      "keyword": "salmo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30830,
      "keyword": "salmo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salmo responsorial": [
    {
      "id": 30831,
      "keyword": "salmo responsorial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30830,
      "keyword": "salmo responsorial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salmos responsoriales": [
    {
      "id": 30831,
      "keyword": "salmo responsorial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30830,
      "keyword": "salmo responsorial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pila bautismal": [
    {
      "id": 30834,
      "keyword": "pila bautismal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "event",
        "religious event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pilas bautismales": [
    {
      "id": 30834,
      "keyword": "pila bautismal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "event",
        "religious event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "homilía": [
    {
      "id": 30836,
      "keyword": "homilía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30837,
      "keyword": "homilía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30838,
      "keyword": "homilía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30839,
      "keyword": "homilía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "homilías": [
    {
      "id": 30836,
      "keyword": "homilía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30837,
      "keyword": "homilía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30838,
      "keyword": "homilía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30839,
      "keyword": "homilía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comulgar": [
    {
      "id": 38777,
      "keyword": "comulgar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30828,
      "keyword": "comulgar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oración": [
    {
      "id": 30861,
      "keyword": "oración",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30889,
      "keyword": "oración",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30901,
      "keyword": "oración",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30850,
      "keyword": "oración",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30863,
      "keyword": "oración",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30899,
      "keyword": "oración",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oraciones": [
    {
      "id": 30861,
      "keyword": "oración",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30889,
      "keyword": "oración",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30901,
      "keyword": "oración",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30850,
      "keyword": "oración",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30863,
      "keyword": "oración",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30899,
      "keyword": "oración",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "padre nuestro": [
    {
      "id": 30889,
      "keyword": "padre nuestro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30850,
      "keyword": "padre nuestro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "padres nuestros": [
    {
      "id": 30889,
      "keyword": "padre nuestro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30850,
      "keyword": "padre nuestro",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "franciscano": [
    {
      "id": 30818,
      "keyword": "franciscano",
      "keywords": 1,
      "type": 4,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "franciscanos": [
    {
      "id": 30818,
      "keyword": "franciscano",
      "keywords": 1,
      "type": 4,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "franciscana": [
    {
      "id": 30820,
      "keyword": "franciscana",
      "keywords": 1,
      "type": 4,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "franciscanas": [
    {
      "id": 30820,
      "keyword": "franciscana",
      "keywords": 1,
      "type": 4,
      "tags": [
        "religion",
        "person",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ofertorio": [
    {
      "id": 30852,
      "keyword": "ofertorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30853,
      "keyword": "ofertorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30857,
      "keyword": "ofertorio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ofertorios": [
    {
      "id": 30852,
      "keyword": "ofertorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30853,
      "keyword": "ofertorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30857,
      "keyword": "ofertorio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "limosna": [
    {
      "id": 30857,
      "keyword": "limosna",
      "keywords": 3,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limosnas": [
    {
      "id": 30857,
      "keyword": "limosna",
      "keywords": 3,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "consagración": [
    {
      "id": 30868,
      "keyword": "consagración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "consagraciones": [
    {
      "id": 30868,
      "keyword": "consagración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "consagrar": [
    {
      "id": 30868,
      "keyword": "consagrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rezo": [
    {
      "id": 30861,
      "keyword": "rezo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30863,
      "keyword": "rezo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rezos": [
    {
      "id": 30861,
      "keyword": "rezo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30863,
      "keyword": "rezo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agua bendita": [
    {
      "id": 30859,
      "keyword": "agua bendita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aguas benditas": [
    {
      "id": 30859,
      "keyword": "agua bendita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lectura del santo evangelio": [
    {
      "id": 30872,
      "keyword": "lectura del Santo Evangelio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30873,
      "keyword": "lectura del Santo Evangelio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30874,
      "keyword": "lectura del Santo Evangelio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30875,
      "keyword": "lectura del Santo Evangelio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30876,
      "keyword": "lectura del Santo Evangelio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30877,
      "keyword": "lectura del Santo Evangelio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30878,
      "keyword": "lectura del Santo Evangelio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30879,
      "keyword": "lectura del Santo Evangelio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lecturas del santo evangelio": [
    {
      "id": 30872,
      "keyword": "lectura del Santo Evangelio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30873,
      "keyword": "lectura del Santo Evangelio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30874,
      "keyword": "lectura del Santo Evangelio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30875,
      "keyword": "lectura del Santo Evangelio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30876,
      "keyword": "lectura del Santo Evangelio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30877,
      "keyword": "lectura del Santo Evangelio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30878,
      "keyword": "lectura del Santo Evangelio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30879,
      "keyword": "lectura del Santo Evangelio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "leer el santo evangelio": [
    {
      "id": 30872,
      "keyword": "leer el Santo Evangelio",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30873,
      "keyword": "leer el Santo Evangelio",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30874,
      "keyword": "leer el Santo Evangelio",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30875,
      "keyword": "leer el Santo Evangelio",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30876,
      "keyword": "leer el Santo Evangelio",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30877,
      "keyword": "leer el Santo Evangelio",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30878,
      "keyword": "leer el Santo Evangelio",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30879,
      "keyword": "leer el Santo Evangelio",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bancos de iglesia": [
    {
      "id": 30887,
      "keyword": "bancos de iglesia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30885,
      "keyword": "banco de iglesia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "banco de iglesia": [
    {
      "id": 30885,
      "keyword": "banco de iglesia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "púlpito": [
    {
      "id": 30891,
      "keyword": "púlpito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "event",
        "religious event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "púlpitos": [
    {
      "id": 30891,
      "keyword": "púlpito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "christianity",
        "event",
        "religious event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bendecir": [
    {
      "id": 30894,
      "keyword": "bendecir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "religion",
        "christianity",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30895,
      "keyword": "bendecir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "religion",
        "christianity",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30896,
      "keyword": "bendecir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "religion",
        "christianity",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30897,
      "keyword": "bendecir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "confesar": [
    {
      "id": 30870,
      "keyword": "confesar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "religion",
        "christianity",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "credo": [
    {
      "id": 30901,
      "keyword": "credo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30899,
      "keyword": "credo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "credos": [
    {
      "id": 30901,
      "keyword": "credo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30899,
      "keyword": "credo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estola": [
    {
      "id": 30910,
      "keyword": "estola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30911,
      "keyword": "estola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30912,
      "keyword": "estola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estolas": [
    {
      "id": 30910,
      "keyword": "estola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30911,
      "keyword": "estola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30912,
      "keyword": "estola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amargo": [
    {
      "id": 37832,
      "keyword": "amargo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30928,
      "keyword": "amargo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37760,
      "keyword": "amargo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "amargos": [
    {
      "id": 37832,
      "keyword": "amargo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30928,
      "keyword": "amargo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37760,
      "keyword": "amargo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amarga": [
    {
      "id": 37832,
      "keyword": "amarga",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30928,
      "keyword": "amarga",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37760,
      "keyword": "amarga",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "amargas": [
    {
      "id": 37832,
      "keyword": "amarga",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30928,
      "keyword": "amarga",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37760,
      "keyword": "amarga",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "taste",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bebible": [
    {
      "id": 30932,
      "keyword": "bebible",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bebibles": [
    {
      "id": 30932,
      "keyword": "bebible",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "explotar": [
    {
      "id": 30954,
      "keyword": "explotar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "work",
        "work accident"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30956,
      "keyword": "explotar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "work",
        "work accident",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30955,
      "keyword": "explotar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "work",
        "work accident"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "explosionar": [
    {
      "id": 30954,
      "keyword": "explosionar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "work",
        "work accident"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30956,
      "keyword": "explosionar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "work",
        "work accident",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30955,
      "keyword": "explosionar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "work",
        "work accident"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escurrir los platos": [
    {
      "id": 30960,
      "keyword": "escurrir los platos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asco": [
    {
      "id": 30964,
      "keyword": "asco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ascos": [
    {
      "id": 30964,
      "keyword": "asco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escurreplatos": [
    {
      "id": 30934,
      "keyword": "escurreplatos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "droga": [
    {
      "id": 30971,
      "keyword": "droga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "drogas": [
    {
      "id": 30971,
      "keyword": "drogas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taller de cerámica": [
    {
      "id": 30975,
      "keyword": "taller de cerámica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talleres de cerámica": [
    {
      "id": 30975,
      "keyword": "taller de cerámica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taller de alfarería": [
    {
      "id": 30975,
      "keyword": "taller de alfarería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talleres de alfarería": [
    {
      "id": 30975,
      "keyword": "taller de alfarería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taller de cuero": [
    {
      "id": 30977,
      "keyword": "taller de cuero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talleres de cuero": [
    {
      "id": 30977,
      "keyword": "taller de cuero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "workplace",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sombrero mejicano": [
    {
      "id": 30973,
      "keyword": "sombrero mejicano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sombreros mejicanos": [
    {
      "id": 30973,
      "keyword": "sombrero mejicano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fregar con lavavajillas": [
    {
      "id": 30969,
      "keyword": "fregar con lavavajillas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "crockery",
        "home",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parque acuático": [
    {
      "id": 30979,
      "keyword": "parque acuático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parques acuáticos": [
    {
      "id": 30979,
      "keyword": "parque acuático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abuso": [
    {
      "id": 31007,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30989,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30990,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30993,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30992,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30991,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31002,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 30999,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31005,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31003,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31006,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31001,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34262,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34263,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34264,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abusos": [
    {
      "id": 31007,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30989,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30990,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30993,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30992,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30991,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31002,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 30999,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31005,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31003,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31006,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31001,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34262,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34263,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34264,
      "keyword": "abuso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "horno de alfarería": [
    {
      "id": 30985,
      "keyword": "horno de alfarería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hornos de alfarería": [
    {
      "id": 30985,
      "keyword": "horno de alfarería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bicicleta estática": [
    {
      "id": 30983,
      "keyword": "bicicleta estática",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bicicletas estáticas": [
    {
      "id": 30983,
      "keyword": "bicicleta estática",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "epidemia": [
    {
      "id": 30987,
      "keyword": "epidemia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "epidemias": [
    {
      "id": 30987,
      "keyword": "epidemia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cinta de correr": [
    {
      "id": 30981,
      "keyword": "cinta de correr",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cintas de correr": [
    {
      "id": 30981,
      "keyword": "cinta de correr",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cinta rodante": [
    {
      "id": 30981,
      "keyword": "cinta rodante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cintas rodantes": [
    {
      "id": 30981,
      "keyword": "cinta rodante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tapiz rodante": [
    {
      "id": 30981,
      "keyword": "tapiz rodante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tapices rodantes": [
    {
      "id": 30981,
      "keyword": "tapiz rodante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huir": [
    {
      "id": 31014,
      "keyword": "huir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31015,
      "keyword": "huir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiroteo": [
    {
      "id": 31018,
      "keyword": "tiroteo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiroteos": [
    {
      "id": 31018,
      "keyword": "tiroteo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tirotear": [
    {
      "id": 31018,
      "keyword": "tirotear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inka kola": [
    {
      "id": 31021,
      "keyword": "Inka Kola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "antequera": [
    {
      "id": 31029,
      "keyword": "Antequera",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31031,
      "keyword": "Antequera",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "geology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31131,
      "keyword": "Antequera",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31129,
      "keyword": "Antequera",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31133,
      "keyword": "Antequera",
      "keywords": 3,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31135,
      "keyword": "Antequera",
      "keywords": 3,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolmen": [
    {
      "id": 31029,
      "keyword": "dolmen",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31133,
      "keyword": "dolmen",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31135,
      "keyword": "dolmen",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dólmenes": [
    {
      "id": 31029,
      "keyword": "dolmen",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31133,
      "keyword": "dolmen",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31135,
      "keyword": "dolmen",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tornillo del torcal": [
    {
      "id": 31031,
      "keyword": "Tornillo del Torcal",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "geology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tereré": [
    {
      "id": 31033,
      "keyword": "Tereré",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mate": [
    {
      "id": 31035,
      "keyword": "mate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31036,
      "keyword": "mate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mates": [
    {
      "id": 31035,
      "keyword": "mate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31036,
      "keyword": "mate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mero": [
    {
      "id": 31039,
      "keyword": "mero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meros": [
    {
      "id": 31039,
      "keyword": "mero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chicharrones": [
    {
      "id": 31043,
      "keyword": "chicharrones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31081,
      "keyword": "chicharrones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31080,
      "keyword": "chicharrones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31082,
      "keyword": "chicharrones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "animal-based food",
        "seafood"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alhambra": [
    {
      "id": 31027,
      "keyword": "Alhambra",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "la alhambra de granada": [
    {
      "id": 31027,
      "keyword": "La Alhambra de Granada",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apretar el zapato": [
    {
      "id": 31053,
      "keyword": "apretar el zapato",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31052,
      "keyword": "apretar el zapato",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ritmo": [
    {
      "id": 31068,
      "keyword": "ritmo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39078,
      "keyword": "ritmo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31064,
      "keyword": "ritmo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31065,
      "keyword": "ritmo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ritmos": [
    {
      "id": 31068,
      "keyword": "ritmo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39078,
      "keyword": "ritmo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31064,
      "keyword": "ritmo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31065,
      "keyword": "ritmo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lanzar el dado": [
    {
      "id": 31071,
      "keyword": "lanzar el dado",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tirar el dado": [
    {
      "id": 31071,
      "keyword": "tirar el dado",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arco detector": [
    {
      "id": 31078,
      "keyword": "arco detector",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31076,
      "keyword": "arco detector",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arcos detectores": [
    {
      "id": 31078,
      "keyword": "arco detector",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31076,
      "keyword": "arco detector",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escáner de seguridad": [
    {
      "id": 31076,
      "keyword": "escáner de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31088,
      "keyword": "escáner de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escáneres de seguridad": [
    {
      "id": 31076,
      "keyword": "escáner de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31088,
      "keyword": "escáner de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tercera edad": [
    {
      "id": 31075,
      "keyword": "tercera edad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "elderly"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gambas rebozadas": [
    {
      "id": 31082,
      "keyword": "gambas rebozadas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "animal-based food",
        "seafood"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escáneres": [
    {
      "id": 31088,
      "keyword": "escáner",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diábolo": [
    {
      "id": 31093,
      "keyword": "diábolo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diábolos": [
    {
      "id": 31093,
      "keyword": "diábolo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "táper": [
    {
      "id": 31091,
      "keyword": "táper",
      "keywords": 6,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tápers": [
    {
      "id": 31091,
      "keyword": "táper",
      "keywords": 6,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fiambrera": [
    {
      "id": 31091,
      "keyword": "fiambrera",
      "keywords": 6,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39457,
      "keyword": "fiambrera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "container",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fiambreras": [
    {
      "id": 31091,
      "keyword": "fiambrera",
      "keywords": 6,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39457,
      "keyword": "fiambrera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "container",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tartera": [
    {
      "id": 31091,
      "keyword": "tartera",
      "keywords": 6,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarteras": [
    {
      "id": 31091,
      "keyword": "tartera",
      "keywords": 6,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lonchera": [
    {
      "id": 31091,
      "keyword": "lonchera",
      "keywords": 6,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39457,
      "keyword": "lonchera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "container",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "loncheras": [
    {
      "id": 31091,
      "keyword": "lonchera",
      "keywords": 6,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39457,
      "keyword": "lonchera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "container",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarrina": [
    {
      "id": 31091,
      "keyword": "tarrina",
      "keywords": 6,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarrinas": [
    {
      "id": 31091,
      "keyword": "tarrina",
      "keywords": 6,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "envase": [
    {
      "id": 31091,
      "keyword": "envase",
      "keywords": 6,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "envases": [
    {
      "id": 31091,
      "keyword": "envase",
      "keywords": 6,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "despistada": [
    {
      "id": 31103,
      "keyword": "despistada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despistadas": [
    {
      "id": 31103,
      "keyword": "despistada",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manómetro": [
    {
      "id": 31107,
      "keyword": "manómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manómetros": [
    {
      "id": 31107,
      "keyword": "manómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "regulador": [
    {
      "id": 31105,
      "keyword": "regulador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reguladores": [
    {
      "id": 31105,
      "keyword": "regulador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botella de buceo nitrox": [
    {
      "id": 31109,
      "keyword": "botella de buceo nitrox",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "diving"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botellas de buceo nitrox": [
    {
      "id": 31109,
      "keyword": "botella de buceo nitrox",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "diving"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botella de buceo": [
    {
      "id": 31111,
      "keyword": "botella de buceo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "diving"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botellas de buceo": [
    {
      "id": 31111,
      "keyword": "botella de buceo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "diving"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "octopus": [
    {
      "id": 31115,
      "keyword": "octopus",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "octopuses": [
    {
      "id": 31115,
      "keyword": "octopus",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apretar la zapatilla": [
    {
      "id": 31054,
      "keyword": "apretar la zapatilla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flotar en el agua": [
    {
      "id": 37296,
      "keyword": "flotar en el agua",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37297,
      "keyword": "flotar en el agua",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37273,
      "keyword": "flotar en el agua",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31121,
      "keyword": "flotar en el agua",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peña de los enamorados": [
    {
      "id": 31131,
      "keyword": "Peña de los enamorados",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torcal de antequera": [
    {
      "id": 31129,
      "keyword": "Torcal de Antequera",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tholos de el romeral": [
    {
      "id": 31133,
      "keyword": "Tholos de El Romeral",
      "keywords": 3,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolmen de viera": [
    {
      "id": 31135,
      "keyword": "Dolmen de Viera",
      "keywords": 3,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cinturón de buceo": [
    {
      "id": 31119,
      "keyword": "cinturón de buceo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "diving"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cinturones de buceo": [
    {
      "id": 31119,
      "keyword": "cinturón de buceo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "diving"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chaleco de buceo": [
    {
      "id": 31117,
      "keyword": "chaleco de buceo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "diving"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chalecos de buceo": [
    {
      "id": 31117,
      "keyword": "chaleco de buceo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "diving"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "papá": [
    {
      "id": 31146,
      "keyword": "papá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 31146,
      "keyword": "papá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papás": [
    {
      "id": 31146,
      "keyword": "papá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": true
    },
    {
      "id": 31146,
      "keyword": "papá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "madre": [
    {
      "id": 31148,
      "keyword": "madre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "madres": [
    {
      "id": 31148,
      "keyword": "madre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35067,
      "keyword": "madres",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caerse patinando": [
    {
      "id": 31150,
      "keyword": "caerse patinando",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31153,
      "keyword": "caerse patinando",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31152,
      "keyword": "caerse patinando",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31151,
      "keyword": "caerse patinando",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caer patinando": [
    {
      "id": 31150,
      "keyword": "caer patinando",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31153,
      "keyword": "caer patinando",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31152,
      "keyword": "caer patinando",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31151,
      "keyword": "caer patinando",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "skating",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "angiólogo": [
    {
      "id": 31168,
      "keyword": "angiólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "angiólogos": [
    {
      "id": 31168,
      "keyword": "angiólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "angiología": [
    {
      "id": 31168,
      "keyword": "angiología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31170,
      "keyword": "angiología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "angióloga": [
    {
      "id": 31170,
      "keyword": "angióloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "angiólogas": [
    {
      "id": 31170,
      "keyword": "angióloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alergólogo": [
    {
      "id": 38837,
      "keyword": "alergólogo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "immune system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31172,
      "keyword": "alergólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "immune system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alergólogos": [
    {
      "id": 38837,
      "keyword": "alergólogo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "immune system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31172,
      "keyword": "alergólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "immune system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alergología": [
    {
      "id": 38837,
      "keyword": "alergología",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "immune system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31172,
      "keyword": "alergología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "immune system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31174,
      "keyword": "alergología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "immune system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "analista clínica": [
    {
      "id": 31176,
      "keyword": "analista clínica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "analistas clínicas": [
    {
      "id": 31176,
      "keyword": "analista clínica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nudillo": [
    {
      "id": 31182,
      "keyword": "nudillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nudillos": [
    {
      "id": 31182,
      "keyword": "nudillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alergóloga": [
    {
      "id": 38837,
      "keyword": "alergóloga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "immune system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31174,
      "keyword": "alergóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "immune system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alergólogas": [
    {
      "id": 38837,
      "keyword": "alergóloga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "immune system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31174,
      "keyword": "alergóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "immune system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "analista clínico": [
    {
      "id": 38836,
      "keyword": "analista clínico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31178,
      "keyword": "analista clínico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "analistas clínicos": [
    {
      "id": 38836,
      "keyword": "analista clínico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31178,
      "keyword": "analista clínico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "regocijar": [
    {
      "id": 31186,
      "keyword": "regocijar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escondite inglés": [
    {
      "id": 31193,
      "keyword": "escondite inglés",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rígido": [
    {
      "id": 31191,
      "keyword": "rígido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rígidos": [
    {
      "id": 31191,
      "keyword": "rígido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rígida": [
    {
      "id": 31191,
      "keyword": "rígida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rígidas": [
    {
      "id": 31191,
      "keyword": "rígida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "texture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "partido político": [
    {
      "id": 31184,
      "keyword": "partido político",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "partidos políticos": [
    {
      "id": 31184,
      "keyword": "partido político",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botella sensorial": [
    {
      "id": 31204,
      "keyword": "botella sensorial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botellas sensoriales": [
    {
      "id": 31204,
      "keyword": "botella sensorial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "congelado": [
    {
      "id": 31197,
      "keyword": "congelado",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "congelados": [
    {
      "id": 31197,
      "keyword": "congelado",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "engaño": [
    {
      "id": 31195,
      "keyword": "engaño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31226,
      "keyword": "engaño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "engaños": [
    {
      "id": 31195,
      "keyword": "engaño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31226,
      "keyword": "engaño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "karateka": [
    {
      "id": 31228,
      "keyword": "karateka",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "karate"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31234,
      "keyword": "karateka",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "karate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "karatekas": [
    {
      "id": 31228,
      "keyword": "karateka",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "karate"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31234,
      "keyword": "karateka",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "karate"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "kárate saludo": [
    {
      "id": 31231,
      "keyword": "kárate saludo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "karate"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31230,
      "keyword": "kárate saludo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "karate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "triaje": [
    {
      "id": 31219,
      "keyword": "triaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "triajes": [
    {
      "id": 31219,
      "keyword": "triaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enfermedad celíaca": [
    {
      "id": 31224,
      "keyword": "enfermedad celíaca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "karate katas": [
    {
      "id": 31240,
      "keyword": "karate katas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "karate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tanatorio": [
    {
      "id": 31215,
      "keyword": "tanatorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "event",
        "social event",
        "death",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tanatorios": [
    {
      "id": 31215,
      "keyword": "tanatorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "event",
        "social event",
        "death",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "kárate karategui": [
    {
      "id": 31238,
      "keyword": "kárate karategui",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing",
        "karate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kimono": [
    {
      "id": 31238,
      "keyword": "kimono",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing",
        "karate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kimonos": [
    {
      "id": 31238,
      "keyword": "kimono",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing",
        "karate"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quimono": [
    {
      "id": 31238,
      "keyword": "quimono",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing",
        "karate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quimonos": [
    {
      "id": 31238,
      "keyword": "quimono",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing",
        "karate"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "árbitra de kárate": [
    {
      "id": 31244,
      "keyword": "árbitra de kárate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport rules",
        "work",
        "professional",
        "karate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "árbitras de kárate": [
    {
      "id": 31244,
      "keyword": "árbitra de kárate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport rules",
        "work",
        "professional",
        "karate"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "kárate seiza": [
    {
      "id": 31236,
      "keyword": "kárate seiza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "karate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espinilleras": [
    {
      "id": 31248,
      "keyword": "espinilleras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "karate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espinilleras de kárate": [
    {
      "id": 31248,
      "keyword": "espinilleras de kárate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "karate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kárate kumite": [
    {
      "id": 31246,
      "keyword": "kárate kumite",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "karate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acuchillar": [
    {
      "id": 31273,
      "keyword": "acuchillar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tatami para kárate": [
    {
      "id": 31275,
      "keyword": "tatami para kárate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "karate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tatamis para kárate": [
    {
      "id": 31275,
      "keyword": "tatami para kárate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "karate"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tatami": [
    {
      "id": 31275,
      "keyword": "tatami",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "karate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tatamis": [
    {
      "id": 31275,
      "keyword": "tatami",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "karate"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trabajo cooperativo": [
    {
      "id": 31278,
      "keyword": "trabajo cooperativo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trabajos cooperativos": [
    {
      "id": 31278,
      "keyword": "trabajo cooperativo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "árbitro de kárate": [
    {
      "id": 31242,
      "keyword": "árbitro de kárate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport rules",
        "work",
        "professional",
        "karate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "árbitros de kárate": [
    {
      "id": 31242,
      "keyword": "árbitro de kárate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport rules",
        "work",
        "professional",
        "karate"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guantillas de kárate": [
    {
      "id": 31269,
      "keyword": "guantillas de kárate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "karate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adaptación curricular": [
    {
      "id": 31291,
      "keyword": "adaptación curricular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31290,
      "keyword": "adaptación curricular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31301,
      "keyword": "adaptación curricular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adaptaciones curriculares": [
    {
      "id": 31291,
      "keyword": "adaptación curricular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31290,
      "keyword": "adaptación curricular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31301,
      "keyword": "adaptación curricular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atención temprana": [
    {
      "id": 36613,
      "keyword": "atención temprana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31299,
      "keyword": "atención temprana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36614,
      "keyword": "atención temprana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36615,
      "keyword": "atención temprana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36616,
      "keyword": "atención temprana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36617,
      "keyword": "atención temprana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39260,
      "keyword": "atención temprana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39261,
      "keyword": "atención temprana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "insomnio": [
    {
      "id": 31276,
      "keyword": "insomnio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "insomnios": [
    {
      "id": 31276,
      "keyword": "insomnio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "insomne": [
    {
      "id": 31276,
      "keyword": "insomne",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "insomnes": [
    {
      "id": 31276,
      "keyword": "insomne",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tumbar bocarriba": [
    {
      "id": 31312,
      "keyword": "tumbar bocarriba",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parpadear": [
    {
      "id": 31314,
      "keyword": "parpadear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "port-a-cath": [
    {
      "id": 31316,
      "keyword": "Port-a-Cath",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31317,
      "keyword": "Port-a-Cath",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31318,
      "keyword": "Port-a-Cath",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31319,
      "keyword": "Port-a-Cath",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31354,
      "keyword": "Port-a-Cath",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "port-a-caths": [
    {
      "id": 31316,
      "keyword": "Port-a-Cath",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31317,
      "keyword": "Port-a-Cath",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31318,
      "keyword": "Port-a-Cath",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31319,
      "keyword": "Port-a-Cath",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31354,
      "keyword": "Port-a-Cath",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reservorio subcutáneo": [
    {
      "id": 31316,
      "keyword": "reservorio subcutáneo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31317,
      "keyword": "reservorio subcutáneo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31318,
      "keyword": "reservorio subcutáneo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31319,
      "keyword": "reservorio subcutáneo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31354,
      "keyword": "reservorio subcutáneo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reservorios subcutáneos": [
    {
      "id": 31316,
      "keyword": "reservorio subcutáneo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31317,
      "keyword": "reservorio subcutáneo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31318,
      "keyword": "reservorio subcutáneo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31319,
      "keyword": "reservorio subcutáneo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31354,
      "keyword": "reservorio subcutáneo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tranquilo": [
    {
      "id": 31310,
      "keyword": "tranquilo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38050,
      "keyword": "tranquilo",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38932,
      "keyword": "tranquilo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37828,
      "keyword": "tranquilo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tranquilos": [
    {
      "id": 31310,
      "keyword": "tranquilo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38932,
      "keyword": "tranquilo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37828,
      "keyword": "tranquilo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tranquila": [
    {
      "id": 31310,
      "keyword": "tranquila",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38050,
      "keyword": "tranquila",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38931,
      "keyword": "tranquila",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37828,
      "keyword": "tranquila",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tranquilas": [
    {
      "id": 31310,
      "keyword": "tranquila",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38050,
      "keyword": "tranquila",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38931,
      "keyword": "tranquila",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37828,
      "keyword": "tranquila",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adaptaciones de acceso": [
    {
      "id": 31294,
      "keyword": "adaptaciones de acceso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "engañar": [
    {
      "id": 31195,
      "keyword": "engañar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recepción": [
    {
      "id": 31328,
      "keyword": "recepción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recepciones": [
    {
      "id": 31328,
      "keyword": "recepción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "base 10": [
    {
      "id": 31334,
      "keyword": "base 10",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31335,
      "keyword": "base 10",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31337,
      "keyword": "base 10",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31336,
      "keyword": "base 10",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31338,
      "keyword": "base 10",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medidas de intervención educativa": [
    {
      "id": 31305,
      "keyword": "medidas de intervención educativa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "analgésico": [
    {
      "id": 31306,
      "keyword": "analgésico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "analgésicos": [
    {
      "id": 31306,
      "keyword": "analgésico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "columna": [
    {
      "id": 31308,
      "keyword": "columna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "history",
        "civilization",
        "Rome",
        "Greece"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "columnas": [
    {
      "id": 31308,
      "keyword": "columna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "history",
        "civilization",
        "Rome",
        "Greece"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amamantar con sonda": [
    {
      "id": 31346,
      "keyword": "amamantar con sonda",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "residuos peligrosos": [
    {
      "id": 31348,
      "keyword": "residuos peligrosos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bomba de perfusión": [
    {
      "id": 31352,
      "keyword": "bomba de perfusión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31350,
      "keyword": "bomba de perfusión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bombas de perfusión": [
    {
      "id": 31352,
      "keyword": "bomba de perfusión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31350,
      "keyword": "bomba de perfusión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manteleta": [
    {
      "id": 31364,
      "keyword": "manteleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manteletas": [
    {
      "id": 31364,
      "keyword": "manteleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pololos": [
    {
      "id": 31366,
      "keyword": "pololos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de escayola": [
    {
      "id": 31370,
      "keyword": "tienda de escayola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de escayola": [
    {
      "id": 31370,
      "keyword": "tienda de escayola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de patinaje": [
    {
      "id": 31368,
      "keyword": "tienda de patinaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de patinaje": [
    {
      "id": 31368,
      "keyword": "tienda de patinaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "sport",
        "skating"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pirotecnia": [
    {
      "id": 31372,
      "keyword": "pirotecnia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pirotecnias": [
    {
      "id": 31372,
      "keyword": "pirotecnia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aula de tecnología": [
    {
      "id": 31376,
      "keyword": "aula de tecnología",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aulas de tecnología": [
    {
      "id": 31376,
      "keyword": "aula de tecnología",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "entrar sin llamar": [
    {
      "id": 31374,
      "keyword": "entrar sin llamar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nuggets de pollo": [
    {
      "id": 31378,
      "keyword": "nuggets de pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nuggets": [
    {
      "id": 31378,
      "keyword": "nuggets",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mandar besos": [
    {
      "id": 31380,
      "keyword": "mandar besos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crujirse los dedos": [
    {
      "id": 31382,
      "keyword": "crujirse los dedos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crujir los dedos": [
    {
      "id": 31382,
      "keyword": "crujir los dedos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ópera de sídney": [
    {
      "id": 31386,
      "keyword": "Ópera de Sídney",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reloj inteligente": [
    {
      "id": 31384,
      "keyword": "reloj inteligente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "time",
        "chronological device",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "relojes inteligentes": [
    {
      "id": 31384,
      "keyword": "reloj inteligente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "time",
        "chronological device",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "smartwatch": [
    {
      "id": 31384,
      "keyword": "smartwatch",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "time",
        "chronological device",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "smartwatchs": [
    {
      "id": 31384,
      "keyword": "smartwatch",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "time",
        "chronological device",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "torre de san salvador": [
    {
      "id": 31388,
      "keyword": "Torre de San Salvador",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "building",
        "religion",
        "Aragon",
        "Teruel"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pocilga": [
    {
      "id": 31392,
      "keyword": "pocilga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pocilgas": [
    {
      "id": 31392,
      "keyword": "pocilga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuadra": [
    {
      "id": 31396,
      "keyword": "cuadra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31400,
      "keyword": "cuadra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuadras": [
    {
      "id": 31396,
      "keyword": "cuadra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31400,
      "keyword": "cuadra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conejera": [
    {
      "id": 31398,
      "keyword": "conejera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conejeras": [
    {
      "id": 31398,
      "keyword": "conejera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "majada": [
    {
      "id": 31394,
      "keyword": "majada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31404,
      "keyword": "majada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "majadas": [
    {
      "id": 31394,
      "keyword": "majada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31404,
      "keyword": "majada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "piñata": [
    {
      "id": 31406,
      "keyword": "piñata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piñatas": [
    {
      "id": 31406,
      "keyword": "piñata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hacer trampas": [
    {
      "id": 31414,
      "keyword": "hacer trampas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "psychology",
        "disruptive behavior",
        "communication",
        "language",
        "verb",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caradura": [
    {
      "id": 31416,
      "keyword": "caradura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caraduras": [
    {
      "id": 31416,
      "keyword": "caradura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jeta": [
    {
      "id": 31416,
      "keyword": "jeta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jetas": [
    {
      "id": 31416,
      "keyword": "jeta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "imagen personal": [
    {
      "id": 31418,
      "keyword": "imagen personal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lanzar arena": [
    {
      "id": 31420,
      "keyword": "lanzar arena",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31421,
      "keyword": "lanzar arena",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tirar arena": [
    {
      "id": 31424,
      "keyword": "tirar arena",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31420,
      "keyword": "tirar arena",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31421,
      "keyword": "tirar arena",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "risoterapia": [
    {
      "id": 31430,
      "keyword": "risoterapia",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "risoterapias": [
    {
      "id": 31430,
      "keyword": "risoterapia",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "casquería": [
    {
      "id": 31402,
      "keyword": "casquería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casquerías": [
    {
      "id": 31402,
      "keyword": "casquería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "epilepsia": [
    {
      "id": 31432,
      "keyword": "epilepsia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ataque epiléptico": [
    {
      "id": 31432,
      "keyword": "ataque epiléptico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ataques epilépticos": [
    {
      "id": 31432,
      "keyword": "ataque epiléptico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trituradora": [
    {
      "id": 31428,
      "keyword": "trituradora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trituradoras": [
    {
      "id": 31428,
      "keyword": "trituradora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "destructor de papel": [
    {
      "id": 31428,
      "keyword": "destructor de papel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "destructoras de papel": [
    {
      "id": 31428,
      "keyword": "destructor de papel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trituradora de papel": [
    {
      "id": 31428,
      "keyword": "trituradora de papel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trituradoras de papel": [
    {
      "id": 31428,
      "keyword": "trituradora de papel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "orgulloso": [
    {
      "id": 31408,
      "keyword": "orgulloso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orgullosos": [
    {
      "id": 31408,
      "keyword": "orgulloso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "orgullosa": [
    {
      "id": 31408,
      "keyword": "orgullosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orgullosas": [
    {
      "id": 31408,
      "keyword": "orgullosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ok": [
    {
      "id": 31410,
      "keyword": "ok",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cruzar los brazos": [
    {
      "id": 31412,
      "keyword": "cruzar los brazos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "familia numerosa": [
    {
      "id": 31466,
      "keyword": "familia numerosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31467,
      "keyword": "familia numerosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "familias numerosas": [
    {
      "id": 31466,
      "keyword": "familia numerosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31467,
      "keyword": "familia numerosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "educación infantil": [
    {
      "id": 31470,
      "keyword": "educación infantil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monoaleta": [
    {
      "id": 31474,
      "keyword": "monoaleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monoaletas": [
    {
      "id": 31474,
      "keyword": "monoaleta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "educación primaria": [
    {
      "id": 31472,
      "keyword": "educación primaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "primaria": [
    {
      "id": 31472,
      "keyword": "primaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ropa rota": [
    {
      "id": 31476,
      "keyword": "ropa rota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ropas rotas": [
    {
      "id": 31476,
      "keyword": "ropa rota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agarrar la mesa": [
    {
      "id": 31480,
      "keyword": "agarrar la mesa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "código postal": [
    {
      "id": 31482,
      "keyword": "código postal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38565,
      "keyword": "código postal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "códigos postales": [
    {
      "id": 31482,
      "keyword": "código postal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38565,
      "keyword": "código postal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿cuál es el código postal?": [
    {
      "id": 31482,
      "keyword": "¿cuál es el código postal?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "mass media",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38565,
      "keyword": "¿cuál es el código postal?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "número de teléfono": [
    {
      "id": 31484,
      "keyword": "número de teléfono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31485,
      "keyword": "número de teléfono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38572,
      "keyword": "número de teléfono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38573,
      "keyword": "número de teléfono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "números de teléfono": [
    {
      "id": 31484,
      "keyword": "número de teléfono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31485,
      "keyword": "número de teléfono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38572,
      "keyword": "número de teléfono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38573,
      "keyword": "número de teléfono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿cuál es tu número de móvil?": [
    {
      "id": 31484,
      "keyword": "¿cuál es tu número de móvil?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38573,
      "keyword": "¿cuál es tu número de móvil?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vapor": [
    {
      "id": 31478,
      "keyword": "vapor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vapores": [
    {
      "id": 31478,
      "keyword": "vapor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿cuál es tu número de teléfono?": [
    {
      "id": 31485,
      "keyword": "¿cuál es tu número de teléfono?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38572,
      "keyword": "¿cuál es tu número de teléfono?",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulsar el timbre": [
    {
      "id": 31947,
      "keyword": "pulsar el timbre",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31488,
      "keyword": "pulsar el timbre",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "no necesito ayuda": [
    {
      "id": 31664,
      "keyword": "no necesito ayuda",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nadar con aletas": [
    {
      "id": 31460,
      "keyword": "nadar con aletas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "de espaldas": [
    {
      "id": 31464,
      "keyword": "de espaldas",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "group",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "preservativo": [
    {
      "id": 31682,
      "keyword": "preservativo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "preservativos": [
    {
      "id": 31682,
      "keyword": "preservativo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "condón": [
    {
      "id": 31682,
      "keyword": "condón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "condones": [
    {
      "id": 31682,
      "keyword": "condón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sonda de doble balón": [
    {
      "id": 31690,
      "keyword": "sonda de doble balón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sondas de doble balón": [
    {
      "id": 31690,
      "keyword": "sonda de doble balón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "edema": [
    {
      "id": 31678,
      "keyword": "edema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31738,
      "keyword": "edema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "edemas": [
    {
      "id": 31678,
      "keyword": "edema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31738,
      "keyword": "edema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "movimiento fetal": [
    {
      "id": 31692,
      "keyword": "movimiento fetal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "movimientos fetales": [
    {
      "id": 31692,
      "keyword": "movimiento fetal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "copa menstrual": [
    {
      "id": 31696,
      "keyword": "copa menstrual",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "intimate hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "copas menstruales": [
    {
      "id": 31696,
      "keyword": "copa menstrual",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "intimate hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sacaleches": [
    {
      "id": 31698,
      "keyword": "sacaleches",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31908,
      "keyword": "sacaleches",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "propess": [
    {
      "id": 31700,
      "keyword": "Propess",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medicación vaginal": [
    {
      "id": 31694,
      "keyword": "medicación vaginal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "gynecology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31869,
      "keyword": "medicación vaginal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "gynecology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medicaciones vaginales": [
    {
      "id": 31694,
      "keyword": "medicación vaginal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "gynecology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31869,
      "keyword": "medicación vaginal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "gynecology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pinchar el culo": [
    {
      "id": 31702,
      "keyword": "pinchar el culo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parto": [
    {
      "id": 31706,
      "keyword": "parto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31707,
      "keyword": "parto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31769,
      "keyword": "parto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32021,
      "keyword": "parto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32022,
      "keyword": "parto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32019,
      "keyword": "parto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "partos": [
    {
      "id": 31706,
      "keyword": "parto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31707,
      "keyword": "parto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31769,
      "keyword": "parto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32021,
      "keyword": "parto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32022,
      "keyword": "parto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32019,
      "keyword": "parto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mutilación": [
    {
      "id": 31684,
      "keyword": "mutilación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31710,
      "keyword": "mutilación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31704,
      "keyword": "mutilación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31686,
      "keyword": "mutilación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31685,
      "keyword": "mutilación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31817,
      "keyword": "mutilación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31929,
      "keyword": "mutilación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31930,
      "keyword": "mutilación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32009,
      "keyword": "mutilación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32039,
      "keyword": "mutilación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mutilaciones": [
    {
      "id": 31684,
      "keyword": "mutilación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31710,
      "keyword": "mutilación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31704,
      "keyword": "mutilación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31686,
      "keyword": "mutilación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31685,
      "keyword": "mutilación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31817,
      "keyword": "mutilación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31929,
      "keyword": "mutilación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31930,
      "keyword": "mutilación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32009,
      "keyword": "mutilación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32039,
      "keyword": "mutilación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mutilación genital femenina": [
    {
      "id": 31710,
      "keyword": "mutilación genital femenina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31704,
      "keyword": "mutilación genital femenina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31686,
      "keyword": "mutilación genital femenina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31685,
      "keyword": "mutilación genital femenina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31817,
      "keyword": "mutilación genital femenina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31929,
      "keyword": "mutilación genital femenina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31930,
      "keyword": "mutilación genital femenina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32009,
      "keyword": "mutilación genital femenina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32039,
      "keyword": "mutilación genital femenina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mutilaciones genitales femeninas": [
    {
      "id": 31710,
      "keyword": "mutilación genital femenina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31704,
      "keyword": "mutilación genital femenina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31686,
      "keyword": "mutilación genital femenina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31685,
      "keyword": "mutilación genital femenina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31817,
      "keyword": "mutilación genital femenina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31929,
      "keyword": "mutilación genital femenina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31930,
      "keyword": "mutilación genital femenina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32009,
      "keyword": "mutilación genital femenina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32039,
      "keyword": "mutilación genital femenina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parir": [
    {
      "id": 31712,
      "keyword": "parir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31959,
      "keyword": "parir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32168,
      "keyword": "parir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cordón umbilical": [
    {
      "id": 31722,
      "keyword": "cordón umbilical",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32262,
      "keyword": "cordón umbilical",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31833,
      "keyword": "cordón umbilical",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cordones umbilicales": [
    {
      "id": 31722,
      "keyword": "cordón umbilical",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32262,
      "keyword": "cordón umbilical",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31833,
      "keyword": "cordón umbilical",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dar el pecho": [
    {
      "id": 31719,
      "keyword": "dar el pecho",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31718,
      "keyword": "dar el pecho",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32027,
      "keyword": "dar el pecho",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32030,
      "keyword": "dar el pecho",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37608,
      "keyword": "dar el pecho",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boca arriba": [
    {
      "id": 31724,
      "keyword": "boca arriba",
      "keywords": 2,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bocarriba": [
    {
      "id": 31724,
      "keyword": "bocarriba",
      "keywords": 2,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gastroscopia": [
    {
      "id": 31716,
      "keyword": "gastroscopia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gastroscopias": [
    {
      "id": 31716,
      "keyword": "gastroscopia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "endoscopia": [
    {
      "id": 31716,
      "keyword": "endoscopia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "endoscopias": [
    {
      "id": 31716,
      "keyword": "endoscopia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escotoma": [
    {
      "id": 31734,
      "keyword": "escotoma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32005,
      "keyword": "escotoma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escotomas": [
    {
      "id": 31734,
      "keyword": "escotoma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32005,
      "keyword": "escotoma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ortopantomografía": [
    {
      "id": 32078,
      "keyword": "ortopantomografía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31825,
      "keyword": "ortopantomografía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31728,
      "keyword": "ortopantomografía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ortopantomografías": [
    {
      "id": 32078,
      "keyword": "ortopantomografía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31825,
      "keyword": "ortopantomografía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31728,
      "keyword": "ortopantomografía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ortopantógrafo": [
    {
      "id": 31825,
      "keyword": "ortopantógrafo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31728,
      "keyword": "ortopantógrafo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ortopantógrafos": [
    {
      "id": 31825,
      "keyword": "ortopantógrafo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31728,
      "keyword": "ortopantógrafo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centelleos": [
    {
      "id": 31736,
      "keyword": "centelleos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31935,
      "keyword": "centelleos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "epidural": [
    {
      "id": 32286,
      "keyword": "epidural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31740,
      "keyword": "epidural",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "epidurales": [
    {
      "id": 32286,
      "keyword": "epidural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31740,
      "keyword": "epidural",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anestesia epidural": [
    {
      "id": 32286,
      "keyword": "anestesia epidural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31740,
      "keyword": "anestesia epidural",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anestesias epidurales": [
    {
      "id": 32286,
      "keyword": "anestesia epidural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31740,
      "keyword": "anestesia epidural",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "procurador": [
    {
      "id": 31756,
      "keyword": "procurador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "procuradores": [
    {
      "id": 31756,
      "keyword": "procurador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "despistarse": [
    {
      "id": 31762,
      "keyword": "despistarse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ictericia": [
    {
      "id": 31768,
      "keyword": "ictericia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31879,
      "keyword": "ictericia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32075,
      "keyword": "ictericia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ictericias": [
    {
      "id": 31768,
      "keyword": "ictericia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31879,
      "keyword": "ictericia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32075,
      "keyword": "ictericia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "infección urinaria": [
    {
      "id": 31773,
      "keyword": "infección urinaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease",
        "human body",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "infecciones urinarias": [
    {
      "id": 31773,
      "keyword": "infección urinaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease",
        "human body",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "infección": [
    {
      "id": 31773,
      "keyword": "infección",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease",
        "human body",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "infecciones": [
    {
      "id": 31773,
      "keyword": "infección",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease",
        "human body",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sangrado vaginal": [
    {
      "id": 31781,
      "keyword": "sangrado vaginal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32017,
      "keyword": "sangrado vaginal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sangrados vaginales": [
    {
      "id": 31781,
      "keyword": "sangrado vaginal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32017,
      "keyword": "sangrado vaginal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colonoscopia": [
    {
      "id": 31771,
      "keyword": "colonoscopia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colonoscopias": [
    {
      "id": 31771,
      "keyword": "colonoscopia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perineo": [
    {
      "id": 31783,
      "keyword": "perineo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31831,
      "keyword": "perineo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perineos": [
    {
      "id": 31783,
      "keyword": "perineo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31831,
      "keyword": "perineo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anillo vaginal": [
    {
      "id": 31788,
      "keyword": "anillo vaginal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anillos vaginales": [
    {
      "id": 31788,
      "keyword": "anillo vaginal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "compresa higiénica manchada": [
    {
      "id": 31787,
      "keyword": "compresa higiénica manchada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "intimate hygiene",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32092,
      "keyword": "compresa higiénica manchada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "intimate hygiene",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32137,
      "keyword": "compresa higiénica manchada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "intimate hygiene",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compresas higiénicas manchadas": [
    {
      "id": 31787,
      "keyword": "compresa higiénica manchada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "intimate hygiene",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32092,
      "keyword": "compresa higiénica manchada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "intimate hygiene",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32137,
      "keyword": "compresa higiénica manchada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "intimate hygiene",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "secreción": [
    {
      "id": 39511,
      "keyword": "secreción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31785,
      "keyword": "secreción",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare",
        "gynecology",
        "obstetrics",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secreciones": [
    {
      "id": 39511,
      "keyword": "secreción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31785,
      "keyword": "secreción",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare",
        "gynecology",
        "obstetrics",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "segregar": [
    {
      "id": 31785,
      "keyword": "segregar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare",
        "gynecology",
        "obstetrics",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secretar": [
    {
      "id": 31785,
      "keyword": "secretar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare",
        "gynecology",
        "obstetrics",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "girar en la silla": [
    {
      "id": 31790,
      "keyword": "girar en la silla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parche anticonceptivo": [
    {
      "id": 31779,
      "keyword": "parche anticonceptivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parches anticonceptivos": [
    {
      "id": 31779,
      "keyword": "parche anticonceptivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ano": [
    {
      "id": 31777,
      "keyword": "ano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anos": [
    {
      "id": 31777,
      "keyword": "ano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pirámide alimenticia": [
    {
      "id": 31813,
      "keyword": "pirámide alimenticia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "dietetics",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pirámides alimenticias": [
    {
      "id": 31813,
      "keyword": "pirámide alimenticia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "dietetics",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lácteos": [
    {
      "id": 31815,
      "keyword": "lácteos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lácteo": [
    {
      "id": 31815,
      "keyword": "lácteo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "test de embarazo": [
    {
      "id": 31809,
      "keyword": "test de embarazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "human body",
        "human reproduction",
        "gynecology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tests de embarazo": [
    {
      "id": 31809,
      "keyword": "test de embarazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "human body",
        "human reproduction",
        "gynecology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anticonceptivo": [
    {
      "id": 31811,
      "keyword": "anticonceptivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anticonceptivos": [
    {
      "id": 31811,
      "keyword": "anticonceptivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31811,
      "keyword": "anticonceptivos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "menores de edad": [
    {
      "id": 31843,
      "keyword": "menores de edad",
      "keywords": 4,
      "type": 4,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31843,
      "keyword": "menores de edad",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inflamación": [
    {
      "id": 31833,
      "keyword": "inflamación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inflamaciones": [
    {
      "id": 31833,
      "keyword": "inflamación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fabada": [
    {
      "id": 31821,
      "keyword": "fabada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fabadas": [
    {
      "id": 31821,
      "keyword": "fabada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esperma": [
    {
      "id": 31835,
      "keyword": "esperma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espermas": [
    {
      "id": 31835,
      "keyword": "esperma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "odontología": [
    {
      "id": 31829,
      "keyword": "odontología",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32082,
      "keyword": "odontología",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "velar": [
    {
      "id": 31874,
      "keyword": "velar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31873,
      "keyword": "velar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "duelo": [
    {
      "id": 39106,
      "keyword": "duelo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31874,
      "keyword": "duelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31873,
      "keyword": "duelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "duelos": [
    {
      "id": 39106,
      "keyword": "duelo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31874,
      "keyword": "duelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31873,
      "keyword": "duelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "incubadora": [
    {
      "id": 31877,
      "keyword": "incubadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "incubadoras": [
    {
      "id": 31877,
      "keyword": "incubadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugar a la pelota": [
    {
      "id": 31892,
      "keyword": "jugar a la pelota",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35371,
      "keyword": "jugar a la pelota",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35411,
      "keyword": "jugar a la pelota",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "delito": [
    {
      "id": 31900,
      "keyword": "delito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "delitos": [
    {
      "id": 31900,
      "keyword": "delito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "explorar": [
    {
      "id": 37601,
      "keyword": "explorar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "geography",
        "physical geography"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31904,
      "keyword": "explorar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36922,
      "keyword": "explorar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "biology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paciente embarazada": [
    {
      "id": 31911,
      "keyword": "paciente embarazada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32099,
      "keyword": "paciente embarazada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pacientes embarazadas": [
    {
      "id": 31911,
      "keyword": "paciente embarazada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32099,
      "keyword": "paciente embarazada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "matrón": [
    {
      "id": 31933,
      "keyword": "matrón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "matrones": [
    {
      "id": 31933,
      "keyword": "matrón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sarro": [
    {
      "id": 31941,
      "keyword": "sarro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sarros": [
    {
      "id": 31941,
      "keyword": "sarro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prohibido ir al baño": [
    {
      "id": 31951,
      "keyword": "prohibido ir al baño",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32196,
      "keyword": "prohibido ir al baño",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibido andar": [
    {
      "id": 31949,
      "keyword": "prohibido andar",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intercambio": [
    {
      "id": 31955,
      "keyword": "intercambio",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "intercambios": [
    {
      "id": 31955,
      "keyword": "intercambio",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de partos": [
    {
      "id": 31963,
      "keyword": "sala de partos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32310,
      "keyword": "sala de partos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de partos": [
    {
      "id": 31963,
      "keyword": "sala de partos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32310,
      "keyword": "sala de partos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prohibido mojar el cordón umbilical": [
    {
      "id": 31961,
      "keyword": "prohibido mojar el cordón umbilical",
      "keywords": 1,
      "type": 5,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medicación intramuscular": [
    {
      "id": 31969,
      "keyword": "medicación intramuscular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medicaciones intramusculares": [
    {
      "id": 31969,
      "keyword": "medicación intramuscular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reservorio": [
    {
      "id": 31979,
      "keyword": "reservorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reservorios": [
    {
      "id": 31979,
      "keyword": "reservorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "justicia social": [
    {
      "id": 31983,
      "keyword": "justicia social",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciclo formativo": [
    {
      "id": 31985,
      "keyword": "ciclo formativo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciclos formativos": [
    {
      "id": 31985,
      "keyword": "ciclo formativo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31985,
      "keyword": "ciclos formativos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taquicardia": [
    {
      "id": 38313,
      "keyword": "taquicardia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 31993,
      "keyword": "taquicardia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32059,
      "keyword": "taquicardia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taquicardias": [
    {
      "id": 38313,
      "keyword": "taquicardia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 31993,
      "keyword": "taquicardia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32059,
      "keyword": "taquicardia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prohibido usar tampón": [
    {
      "id": 31965,
      "keyword": "prohibido usar tampón",
      "keywords": 1,
      "type": 5,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atención al paciente": [
    {
      "id": 31967,
      "keyword": "atención al paciente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "person",
        "patient",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿qué curso?": [
    {
      "id": 32002,
      "keyword": "¿qué curso?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32001,
      "keyword": "¿qué curso?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuna térmica": [
    {
      "id": 32011,
      "keyword": "cuna térmica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cunas térmicas": [
    {
      "id": 32011,
      "keyword": "cuna térmica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuna radiante": [
    {
      "id": 32011,
      "keyword": "cuna radiante",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cunas radiantes": [
    {
      "id": 32011,
      "keyword": "cuna radiante",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "promocionar": [
    {
      "id": 31999,
      "keyword": "promocionar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bachillerato": [
    {
      "id": 31997,
      "keyword": "bachillerato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bachilleratos": [
    {
      "id": 31997,
      "keyword": "bachillerato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cesárea": [
    {
      "id": 32020,
      "keyword": "cesárea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cesáreas": [
    {
      "id": 32020,
      "keyword": "cesárea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diu": [
    {
      "id": 32035,
      "keyword": "diu",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dius": [
    {
      "id": 32035,
      "keyword": "diu",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "implante anticonceptivo": [
    {
      "id": 32037,
      "keyword": "implante anticonceptivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "implantes anticonceptivos": [
    {
      "id": 32037,
      "keyword": "implante anticonceptivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inyección anticonceptiva": [
    {
      "id": 32043,
      "keyword": "inyección anticonceptiva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inyecciones anticonceptivas": [
    {
      "id": 32043,
      "keyword": "inyección anticonceptiva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sujetar el pecho": [
    {
      "id": 32029,
      "keyword": "sujetar el pecho",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "visión borrosa": [
    {
      "id": 32054,
      "keyword": "visión borrosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32053,
      "keyword": "visión borrosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "visiones borrosas": [
    {
      "id": 32054,
      "keyword": "visión borrosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32053,
      "keyword": "visión borrosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quitarse el condón": [
    {
      "id": 32071,
      "keyword": "quitarse el condón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar el condón": [
    {
      "id": 32071,
      "keyword": "quitar el condón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ponerse el condón": [
    {
      "id": 32073,
      "keyword": "ponerse el condón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner el condón": [
    {
      "id": 32073,
      "keyword": "poner el condón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "sexuality",
        "contraceptive method"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ventosa obstétrica": [
    {
      "id": 32049,
      "keyword": "ventosa obstétrica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ventosas obstétricas": [
    {
      "id": 32049,
      "keyword": "ventosa obstétrica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pezoneras": [
    {
      "id": 32076,
      "keyword": "pezoneras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36568,
      "keyword": "pezonera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "víctima": [
    {
      "id": 32065,
      "keyword": "víctima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "víctimas": [
    {
      "id": 32065,
      "keyword": "víctima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "matrona": [
    {
      "id": 32080,
      "keyword": "matrona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "matronas": [
    {
      "id": 32080,
      "keyword": "matrona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human reproduction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "médico de familia": [
    {
      "id": 32084,
      "keyword": "médico de familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32085,
      "keyword": "médico de familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "médicos de familia": [
    {
      "id": 32084,
      "keyword": "médico de familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32085,
      "keyword": "médico de familia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "romano": [
    {
      "id": 32088,
      "keyword": "romano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "romanos": [
    {
      "id": 32088,
      "keyword": "romano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "automensaje": [
    {
      "id": 32101,
      "keyword": "automensaje",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "automensajes": [
    {
      "id": 32101,
      "keyword": "automensaje",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "hablar a uno mismo": [
    {
      "id": 32101,
      "keyword": "hablar a uno mismo",
      "keywords": 2,
      "type": 3,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "pésame": [
    {
      "id": 32105,
      "keyword": "pésame",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pésames": [
    {
      "id": 32105,
      "keyword": "pésame",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "romper aguas": [
    {
      "id": 32103,
      "keyword": "romper aguas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32210,
      "keyword": "romper aguas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bulto": [
    {
      "id": 32097,
      "keyword": "bulto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "gynecology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bultos": [
    {
      "id": 32097,
      "keyword": "bulto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "gynecology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arqueólogo": [
    {
      "id": 35791,
      "keyword": "arqueólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32095,
      "keyword": "arqueólogo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32384,
      "keyword": "arqueólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arqueólogos": [
    {
      "id": 35791,
      "keyword": "arqueólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32095,
      "keyword": "arqueólogo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32384,
      "keyword": "arqueólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arqueología": [
    {
      "id": 32095,
      "keyword": "arqueología",
      "keywords": 5,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32380,
      "keyword": "arqueología",
      "keywords": 3,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "place",
        "workplace"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "egiptólogo": [
    {
      "id": 32095,
      "keyword": "egiptólogo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "egiptólogos": [
    {
      "id": 32095,
      "keyword": "egiptólogo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "egiptóloga": [
    {
      "id": 32095,
      "keyword": "egiptóloga",
      "keywords": 5,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "egiptólogas": [
    {
      "id": 32095,
      "keyword": "egiptóloga",
      "keywords": 5,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "egiptología": [
    {
      "id": 32095,
      "keyword": "egiptología",
      "keywords": 5,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maduración pulmonar": [
    {
      "id": 32109,
      "keyword": "maduración pulmonar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contracciones uterinas": [
    {
      "id": 32115,
      "keyword": "contracciones uterinas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "análisis": [
    {
      "id": 32111,
      "keyword": "análisis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32112,
      "keyword": "análisis",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "análisis clínico": [
    {
      "id": 32111,
      "keyword": "análisis clínico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32112,
      "keyword": "análisis clínico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "análisis clínicos": [
    {
      "id": 32111,
      "keyword": "análisis clínico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32112,
      "keyword": "análisis clínico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "analítica": [
    {
      "id": 32112,
      "keyword": "analítica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "analíticas": [
    {
      "id": 32112,
      "keyword": "analítica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "forúnculo": [
    {
      "id": 32117,
      "keyword": "forúnculo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "forúnculos": [
    {
      "id": 32117,
      "keyword": "forúnculo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recuerdos": [
    {
      "id": 32107,
      "keyword": "recuerdos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿de qué color?": [
    {
      "id": 32137,
      "keyword": "¿de qué color?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "intimate hygiene",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sudoroso": [
    {
      "id": 32125,
      "keyword": "sudoroso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sudorosos": [
    {
      "id": 32125,
      "keyword": "sudoroso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oir música": [
    {
      "id": 32131,
      "keyword": "oir música",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "mass media",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "mass media device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hablar lento": [
    {
      "id": 32133,
      "keyword": "hablar lento",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diez días": [
    {
      "id": 32127,
      "keyword": "diez días",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "10 días": [
    {
      "id": 32127,
      "keyword": "10 días",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "epigastralgia": [
    {
      "id": 32148,
      "keyword": "epigastralgia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "epigastralgias": [
    {
      "id": 32148,
      "keyword": "epigastralgia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ayunar": [
    {
      "id": 32166,
      "keyword": "ayunar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despistado": [
    {
      "id": 32146,
      "keyword": "despistado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despistados": [
    {
      "id": 32146,
      "keyword": "despistado",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿qué rincón?": [
    {
      "id": 32178,
      "keyword": "¿qué rincón?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "education",
        "educational space"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "episiotomía": [
    {
      "id": 32180,
      "keyword": "episiotomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "episiotomías": [
    {
      "id": 32180,
      "keyword": "episiotomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inflamación del pecho": [
    {
      "id": 32182,
      "keyword": "inflamación del pecho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "gynecology",
        "obstetrics",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32184,
      "keyword": "inflamación del pecho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "gynecology",
        "obstetrics",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inflamaciones del pecho": [
    {
      "id": 32184,
      "keyword": "inflamación del pecho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "gynecology",
        "obstetrics",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prohibido beber durante el embarazo": [
    {
      "id": 32172,
      "keyword": "prohibido beber durante el embarazo",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "collarín de rayos x": [
    {
      "id": 32186,
      "keyword": "collarín de rayos x",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32187,
      "keyword": "collarín de rayos x",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "collarínes de rayos x": [
    {
      "id": 32186,
      "keyword": "collarín de rayos x",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32187,
      "keyword": "collarín de rayos x",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "protector de tiroides": [
    {
      "id": 32186,
      "keyword": "protector de tiroides",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32187,
      "keyword": "protector de tiroides",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "protectores de tiroides": [
    {
      "id": 32186,
      "keyword": "protector de tiroides",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32187,
      "keyword": "protector de tiroides",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abrebocas": [
    {
      "id": 32198,
      "keyword": "abrebocas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ingurgitación mamaria": [
    {
      "id": 32200,
      "keyword": "ingurgitación mamaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ingurgitaciones mamarias": [
    {
      "id": 32200,
      "keyword": "ingurgitación mamaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cardiotocografía": [
    {
      "id": 32206,
      "keyword": "cardiotocografía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cardiotocografías": [
    {
      "id": 32206,
      "keyword": "cardiotocografía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "registro cardiotocográfico": [
    {
      "id": 32206,
      "keyword": "registro cardiotocográfico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "registros cardiotocográficos": [
    {
      "id": 32206,
      "keyword": "registro cardiotocográfico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cardiotocografía interna": [
    {
      "id": 32208,
      "keyword": "cardiotocografía interna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cardiotocografías internas": [
    {
      "id": 32208,
      "keyword": "cardiotocografía interna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amniorrexis": [
    {
      "id": 32210,
      "keyword": "amniorrexis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibido dormir bocabajo": [
    {
      "id": 32218,
      "keyword": "prohibido dormir bocabajo",
      "keywords": 1,
      "type": 5,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aliviar": [
    {
      "id": 32220,
      "keyword": "aliviar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32224,
      "keyword": "aliviar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32222,
      "keyword": "aliviar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32221,
      "keyword": "aliviar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32223,
      "keyword": "aliviar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "analgesia": [
    {
      "id": 32220,
      "keyword": "analgesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32224,
      "keyword": "analgesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32222,
      "keyword": "analgesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32221,
      "keyword": "analgesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32223,
      "keyword": "analgesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "analgesias": [
    {
      "id": 32220,
      "keyword": "analgesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32224,
      "keyword": "analgesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32222,
      "keyword": "analgesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32221,
      "keyword": "analgesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32223,
      "keyword": "analgesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agitar la cabeza": [
    {
      "id": 32230,
      "keyword": "agitar la cabeza",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacudir la cabeza": [
    {
      "id": 32230,
      "keyword": "sacudir la cabeza",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maligno": [
    {
      "id": 32192,
      "keyword": "maligno",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "malignos": [
    {
      "id": 32192,
      "keyword": "maligno",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de trabajo": [
    {
      "id": 32232,
      "keyword": "sala de trabajo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38873,
      "keyword": "sala de trabajo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de trabajo": [
    {
      "id": 32232,
      "keyword": "sala de trabajo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38873,
      "keyword": "sala de trabajo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dormir de lado": [
    {
      "id": 32236,
      "keyword": "dormir de lado",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "habitación de hospital": [
    {
      "id": 35325,
      "keyword": "habitación de hospital",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32234,
      "keyword": "habitación de hospital",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "habitaciones de hospital": [
    {
      "id": 35325,
      "keyword": "habitación de hospital",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32234,
      "keyword": "habitación de hospital",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de dilatación": [
    {
      "id": 32240,
      "keyword": "sala de dilatación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de dilatación": [
    {
      "id": 32240,
      "keyword": "sala de dilatación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zapatilla por detrás": [
    {
      "id": 32216,
      "keyword": "Zapatilla por Detrás",
      "keywords": 2,
      "type": 1,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "a la zapatilla por detrás": [
    {
      "id": 32216,
      "keyword": "a la zapatilla por detrás",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exploración ginecológica": [
    {
      "id": 32244,
      "keyword": "exploración ginecológica",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "exploraciones ginecológicas": [
    {
      "id": 32244,
      "keyword": "exploración ginecológica",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "ducha caliente": [
    {
      "id": 32238,
      "keyword": "ducha caliente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "duchas calientes": [
    {
      "id": 32238,
      "keyword": "ducha caliente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cama de partos": [
    {
      "id": 32248,
      "keyword": "cama de partos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camas de partos": [
    {
      "id": 32248,
      "keyword": "cama de partos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "catéter": [
    {
      "id": 32252,
      "keyword": "catéter",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "catéteres": [
    {
      "id": 32252,
      "keyword": "catéter",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cartilla": [
    {
      "id": 32259,
      "keyword": "cartilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "medicine",
        "health",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cartillas": [
    {
      "id": 32259,
      "keyword": "cartilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "medicine",
        "health",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "permitido ir al baño": [
    {
      "id": 32266,
      "keyword": "permitido ir al baño",
      "keywords": 1,
      "type": 5,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32267,
      "keyword": "permitido ir al baño",
      "keywords": 1,
      "type": 5,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sentar correctamente": [
    {
      "id": 34683,
      "keyword": "sentar correctamente",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39067,
      "keyword": "sentar correctamente",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32270,
      "keyword": "sentar correctamente",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "postura correcta": [
    {
      "id": 34683,
      "keyword": "postura correcta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37199,
      "keyword": "postura correcta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39067,
      "keyword": "postura correcta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32270,
      "keyword": "postura correcta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "posturas correctas": [
    {
      "id": 34683,
      "keyword": "postura correcta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37199,
      "keyword": "postura correcta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39067,
      "keyword": "postura correcta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32270,
      "keyword": "postura correcta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sentar de forma incorrecta": [
    {
      "id": 34689,
      "keyword": "sentar de forma incorrecta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32272,
      "keyword": "sentar de forma incorrecta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "postura incorrecta": [
    {
      "id": 34689,
      "keyword": "postura incorrecta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32272,
      "keyword": "postura incorrecta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "posturas incorrectas": [
    {
      "id": 34689,
      "keyword": "postura incorrecta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32272,
      "keyword": "postura incorrecta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bultos genitales": [
    {
      "id": 32274,
      "keyword": "bultos genitales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "gynecology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ponerse la bata": [
    {
      "id": 32282,
      "keyword": "ponerse la bata",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "no hace pis": [
    {
      "id": 32279,
      "keyword": "no hace pis",
      "keywords": 2,
      "type": 5,
      "tags": [
        "health",
        "medicine",
        "babycare",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32278,
      "keyword": "no hace pis",
      "keywords": 2,
      "type": 5,
      "tags": [
        "health",
        "medicine",
        "babycare",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "no orina": [
    {
      "id": 32279,
      "keyword": "no orina",
      "keywords": 2,
      "type": 5,
      "tags": [
        "health",
        "medicine",
        "babycare",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32278,
      "keyword": "no orina",
      "keywords": 2,
      "type": 5,
      "tags": [
        "health",
        "medicine",
        "babycare",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grietas en el pezón": [
    {
      "id": 32284,
      "keyword": "grietas en el pezón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿qué modalidad?": [
    {
      "id": 32292,
      "keyword": "¿qué modalidad?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnicas para hablar en público": [
    {
      "id": 32290,
      "keyword": "técnicas para hablar en público",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "sala de reanimación neonatal": [
    {
      "id": 32242,
      "keyword": "sala de reanimación neonatal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "babycare",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de reanimación neonatal": [
    {
      "id": 32242,
      "keyword": "sala de reanimación neonatal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "babycare",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "no sé leer": [
    {
      "id": 32308,
      "keyword": "no sé leer",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "educación secundaria": [
    {
      "id": 32294,
      "keyword": "educación secundaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secundaria": [
    {
      "id": 32294,
      "keyword": "secundaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asociar": [
    {
      "id": 32324,
      "keyword": "asociar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "emparejar": [
    {
      "id": 32324,
      "keyword": "emparejar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "depresión": [
    {
      "id": 32326,
      "keyword": "depresión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "depresiones": [
    {
      "id": 32326,
      "keyword": "depresión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desanimado": [
    {
      "id": 32328,
      "keyword": "desanimado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32329,
      "keyword": "desanimado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desanimados": [
    {
      "id": 32328,
      "keyword": "desanimado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32329,
      "keyword": "desanimado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desanimada": [
    {
      "id": 32328,
      "keyword": "desanimada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37766,
      "keyword": "desanimada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32329,
      "keyword": "desanimada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desanimadas": [
    {
      "id": 32328,
      "keyword": "desanimada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37766,
      "keyword": "desanimada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32329,
      "keyword": "desanimada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desmotivado": [
    {
      "id": 32328,
      "keyword": "desmotivado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32329,
      "keyword": "desmotivado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desmotivados": [
    {
      "id": 32328,
      "keyword": "desmotivado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32329,
      "keyword": "desmotivado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desmotivada": [
    {
      "id": 32328,
      "keyword": "desmotivada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37766,
      "keyword": "desmotivada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32329,
      "keyword": "desmotivada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desmotivadas": [
    {
      "id": 32328,
      "keyword": "desmotivada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37766,
      "keyword": "desmotivada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32329,
      "keyword": "desmotivada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apático": [
    {
      "id": 32328,
      "keyword": "apático",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32329,
      "keyword": "apático",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apáticos": [
    {
      "id": 32328,
      "keyword": "apático",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32329,
      "keyword": "apático",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apática": [
    {
      "id": 32328,
      "keyword": "apática",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32329,
      "keyword": "apática",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apáticas": [
    {
      "id": 32328,
      "keyword": "apática",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32329,
      "keyword": "apática",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asqueroso": [
    {
      "id": 32338,
      "keyword": "asqueroso",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asquerosos": [
    {
      "id": 32338,
      "keyword": "asqueroso",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asquerosa": [
    {
      "id": 32338,
      "keyword": "asquerosa",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asquerosas": [
    {
      "id": 32338,
      "keyword": "asquerosa",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asociación de empresarios": [
    {
      "id": 32342,
      "keyword": "asociación de empresarios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asociaciones de empresarios": [
    {
      "id": 32342,
      "keyword": "asociación de empresarios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parto en agua": [
    {
      "id": 32310,
      "keyword": "parto en agua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "partos en agua": [
    {
      "id": 32310,
      "keyword": "parto en agua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology",
        "obstetrics",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asociación cultural": [
    {
      "id": 32344,
      "keyword": "asociación cultural",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asociaciones culturales": [
    {
      "id": 32344,
      "keyword": "asociación cultural",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asociación vinícola": [
    {
      "id": 32346,
      "keyword": "asociación vinícola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "work",
        "primary sector",
        "agriculture",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asociaciones vinícolas": [
    {
      "id": 32346,
      "keyword": "asociación vinícola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "work",
        "primary sector",
        "agriculture",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sabroso": [
    {
      "id": 32340,
      "keyword": "sabroso",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sabrosos": [
    {
      "id": 32340,
      "keyword": "sabroso",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sabrosa": [
    {
      "id": 32340,
      "keyword": "sabrosa",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sabrosas": [
    {
      "id": 32340,
      "keyword": "sabrosa",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apetitoso": [
    {
      "id": 32340,
      "keyword": "apetitoso",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apetitosos": [
    {
      "id": 32340,
      "keyword": "apetitoso",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apetitosa": [
    {
      "id": 32340,
      "keyword": "apetitosa",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apetitosas": [
    {
      "id": 32340,
      "keyword": "apetitosa",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "exquisito": [
    {
      "id": 32340,
      "keyword": "exquisito",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exquisitos": [
    {
      "id": 32340,
      "keyword": "exquisito",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "exquisita": [
    {
      "id": 32340,
      "keyword": "exquisita",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exquisitas": [
    {
      "id": 32340,
      "keyword": "exquisita",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "delicioso": [
    {
      "id": 32340,
      "keyword": "delicioso",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "deliciosos": [
    {
      "id": 32340,
      "keyword": "delicioso",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "deliciosa": [
    {
      "id": 32340,
      "keyword": "deliciosa",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "deliciosas": [
    {
      "id": 32340,
      "keyword": "deliciosa",
      "keywords": 11,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "taste"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "correduría de seguros": [
    {
      "id": 32356,
      "keyword": "correduría de seguros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corredurías de seguros": [
    {
      "id": 32356,
      "keyword": "correduría de seguros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cervecería": [
    {
      "id": 32358,
      "keyword": "cervecería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cervecerías": [
    {
      "id": 32358,
      "keyword": "cervecería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de pinturas": [
    {
      "id": 32354,
      "keyword": "tienda de pinturas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de pinturas": [
    {
      "id": 32354,
      "keyword": "tienda de pinturas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nostálgico": [
    {
      "id": 32360,
      "keyword": "nostálgico",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32360,
      "keyword": "nostálgico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nostálgicos": [
    {
      "id": 32360,
      "keyword": "nostálgico",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32360,
      "keyword": "nostálgico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nostálgica": [
    {
      "id": 32360,
      "keyword": "nostálgica",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32360,
      "keyword": "nostálgica",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nostálgicas": [
    {
      "id": 32360,
      "keyword": "nostálgica",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32360,
      "keyword": "nostálgica",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro de interpretación": [
    {
      "id": 32348,
      "keyword": "centro de interpretación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32349,
      "keyword": "centro de interpretación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros de interpretación": [
    {
      "id": 32348,
      "keyword": "centro de interpretación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32349,
      "keyword": "centro de interpretación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "autobús escolar": [
    {
      "id": 32370,
      "keyword": "autobús escolar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autobuses escolares": [
    {
      "id": 32370,
      "keyword": "autobús escolar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colectivo escolar": [
    {
      "id": 32370,
      "keyword": "colectivo escolar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colectivos escolares": [
    {
      "id": 32370,
      "keyword": "colectivo escolar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "micro escolar": [
    {
      "id": 32370,
      "keyword": "micro escolar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "micros escolares": [
    {
      "id": 32370,
      "keyword": "micro escolar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "batido proteico": [
    {
      "id": 32368,
      "keyword": "batido proteico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "batidos proteicos": [
    {
      "id": 32368,
      "keyword": "batido proteico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "licuado proteíco": [
    {
      "id": 32368,
      "keyword": "licuado proteíco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "licuados proteícos": [
    {
      "id": 32368,
      "keyword": "licuado proteíco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prohibido": [
    {
      "id": 32366,
      "keyword": "prohibido",
      "keywords": 1,
      "type": 5,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casa de la mujer": [
    {
      "id": 32352,
      "keyword": "casa de la mujer",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casas de la mujer": [
    {
      "id": 32352,
      "keyword": "casa de la mujer",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silla infantil": [
    {
      "id": 32374,
      "keyword": "silla infantil",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas infantiles": [
    {
      "id": 32374,
      "keyword": "silla infantil",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asiento de seguridad": [
    {
      "id": 32374,
      "keyword": "asiento de seguridad",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asientos de seguridad": [
    {
      "id": 32374,
      "keyword": "asiento de seguridad",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asiento infantil": [
    {
      "id": 32374,
      "keyword": "asiento infantil",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asientos infantiles": [
    {
      "id": 32374,
      "keyword": "asiento infantil",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silla de coche": [
    {
      "id": 32374,
      "keyword": "silla de coche",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas de coche": [
    {
      "id": 32374,
      "keyword": "silla de coche",
      "keywords": 4,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "yacimiento": [
    {
      "id": 32380,
      "keyword": "yacimiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "place",
        "workplace"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yacimientos": [
    {
      "id": 32380,
      "keyword": "yacimiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "place",
        "workplace"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "excavación": [
    {
      "id": 32380,
      "keyword": "excavación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "place",
        "workplace"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "excavaciones": [
    {
      "id": 32380,
      "keyword": "excavación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "place",
        "workplace"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arqueóloga": [
    {
      "id": 32382,
      "keyword": "arqueóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arqueólogas": [
    {
      "id": 32382,
      "keyword": "arqueóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "varones": [
    {
      "id": 32362,
      "keyword": "varones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "traqueotomía": [
    {
      "id": 38740,
      "keyword": "traqueotomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32372,
      "keyword": "traqueotomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "traqueotomías": [
    {
      "id": 38740,
      "keyword": "traqueotomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32372,
      "keyword": "traqueotomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fines de semana": [
    {
      "id": 32396,
      "keyword": "fin de semana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "day"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peculiar": [
    {
      "id": 32390,
      "keyword": "peculiar",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peculiares": [
    {
      "id": 32390,
      "keyword": "peculiar",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "singular": [
    {
      "id": 32390,
      "keyword": "singular",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "singulares": [
    {
      "id": 32390,
      "keyword": "singular",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolsa de almuerzo": [
    {
      "id": 32376,
      "keyword": "bolsa de almuerzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas de almuerzo": [
    {
      "id": 32376,
      "keyword": "bolsa de almuerzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desenterrar": [
    {
      "id": 34037,
      "keyword": "desenterrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "paleontology",
        "extinct being",
        "fossil"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34397,
      "keyword": "desenterrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32378,
      "keyword": "desenterrar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exhumar": [
    {
      "id": 32378,
      "keyword": "exhumar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "excavar": [
    {
      "id": 32378,
      "keyword": "excavar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "idéntico": [
    {
      "id": 32392,
      "keyword": "idéntico",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "idénticos": [
    {
      "id": 32392,
      "keyword": "idéntico",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gemelo": [
    {
      "id": 32392,
      "keyword": "gemelo",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gemela": [
    {
      "id": 32392,
      "keyword": "gemela",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "idéntica": [
    {
      "id": 32392,
      "keyword": "idéntica",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "idénticas": [
    {
      "id": 32392,
      "keyword": "idéntica",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bondadoso": [
    {
      "id": 32432,
      "keyword": "bondadoso",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bondadosos": [
    {
      "id": 32432,
      "keyword": "bondadoso",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bondadosa": [
    {
      "id": 32432,
      "keyword": "bondadosa",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bondadosas": [
    {
      "id": 32432,
      "keyword": "bondadosa",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asequible": [
    {
      "id": 32434,
      "keyword": "asequible",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asequibles": [
    {
      "id": 32434,
      "keyword": "asequible",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "complejo": [
    {
      "id": 32436,
      "keyword": "complejo",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "complejos": [
    {
      "id": 32436,
      "keyword": "complejo",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "compleja": [
    {
      "id": 32436,
      "keyword": "compleja",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "complejas": [
    {
      "id": 32436,
      "keyword": "compleja",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mentiroso": [
    {
      "id": 37792,
      "keyword": "mentiroso",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32444,
      "keyword": "mentiroso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mentirosos": [
    {
      "id": 37792,
      "keyword": "mentiroso",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32444,
      "keyword": "mentiroso",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¡feliz navidad!": [
    {
      "id": 32456,
      "keyword": "¡Feliz Navidad!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "event",
        "popular event",
        "christmas",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32458,
      "keyword": "¡Feliz Navidad!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "feliz navidad": [
    {
      "id": 32456,
      "keyword": "Feliz Navidad",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "event",
        "popular event",
        "christmas",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32458,
      "keyword": "Feliz Navidad",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entremés": [
    {
      "id": 32474,
      "keyword": "entremés",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "entremeses": [
    {
      "id": 32474,
      "keyword": "entremés",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "entrante": [
    {
      "id": 32474,
      "keyword": "entrante",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "entrantes": [
    {
      "id": 32474,
      "keyword": "entrante",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "masa": [
    {
      "id": 32476,
      "keyword": "masa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38442,
      "keyword": "masa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "masas": [
    {
      "id": 32476,
      "keyword": "masa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38442,
      "keyword": "masa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¡feliz año nuevo!": [
    {
      "id": 32480,
      "keyword": "¡Feliz año nuevo!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "event",
        "popular event",
        "new year",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "feliz año nuevo": [
    {
      "id": 32480,
      "keyword": "Feliz año nuevo",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "event",
        "popular event",
        "new year",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arboleda": [
    {
      "id": 32462,
      "keyword": "arboleda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "forestry",
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arboledas": [
    {
      "id": 32462,
      "keyword": "arboleda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "forestry",
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diálisis": [
    {
      "id": 38348,
      "keyword": "diálisis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38927,
      "keyword": "diálisis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32494,
      "keyword": "diálisis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ir en silla de ruedas": [
    {
      "id": 35715,
      "keyword": "ir en silla de ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32500,
      "keyword": "ir en silla de ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32501,
      "keyword": "ir en silla de ruedas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuchara de madera": [
    {
      "id": 32468,
      "keyword": "cuchara de madera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cucharas de madera": [
    {
      "id": 32468,
      "keyword": "cuchara de madera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jarra medidora": [
    {
      "id": 32466,
      "keyword": "jarra medidora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jarras medidoras": [
    {
      "id": 32466,
      "keyword": "jarra medidora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quiche": [
    {
      "id": 32472,
      "keyword": "quiche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quiches": [
    {
      "id": 32472,
      "keyword": "quiche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bandeja de horno": [
    {
      "id": 32510,
      "keyword": "bandeja de horno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bandejas de horno": [
    {
      "id": 32510,
      "keyword": "bandeja de horno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bocadillería": [
    {
      "id": 32486,
      "keyword": "bocadillería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bocadillerías": [
    {
      "id": 32486,
      "keyword": "bocadillería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "incómodo": [
    {
      "id": 32528,
      "keyword": "incómodo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "incómodos": [
    {
      "id": 32528,
      "keyword": "incómodo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "incómoda": [
    {
      "id": 32528,
      "keyword": "incómoda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "incómodas": [
    {
      "id": 32528,
      "keyword": "incómoda",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "body sensation",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "historia de las religiones": [
    {
      "id": 32544,
      "keyword": "historia de las religiones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "historias de las religiones": [
    {
      "id": 32544,
      "keyword": "historia de las religiones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "psicomotricidad": [
    {
      "id": 32552,
      "keyword": "psicomotricidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dislexia": [
    {
      "id": 32558,
      "keyword": "dislexia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dislexias": [
    {
      "id": 32558,
      "keyword": "dislexia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ballet": [
    {
      "id": 32560,
      "keyword": "ballet",
      "keywords": 2,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ballets": [
    {
      "id": 32560,
      "keyword": "ballet",
      "keywords": 2,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "danza clásica": [
    {
      "id": 32560,
      "keyword": "danza clásica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "danzas clásicas": [
    {
      "id": 32560,
      "keyword": "danza clásica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esperanza": [
    {
      "id": 32564,
      "keyword": "esperanza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esperanzas": [
    {
      "id": 32564,
      "keyword": "esperanza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "actividades y fiestas": [
    {
      "id": 32566,
      "keyword": "actividades y fiestas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juego y deporte": [
    {
      "id": 32574,
      "keyword": "juego y deporte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "sport",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aparatos y muebles": [
    {
      "id": 32578,
      "keyword": "aparatos y muebles",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "furniture",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "naturales": [
    {
      "id": 32542,
      "keyword": "naturales",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "subject",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "animales y plantas": [
    {
      "id": 32572,
      "keyword": "animales y plantas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "objetos cotidianos": [
    {
      "id": 32582,
      "keyword": "objetos cotidianos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "objeto cotidiano": [
    {
      "id": 32582,
      "keyword": "objeto cotidiano",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "danza": [
    {
      "id": 32562,
      "keyword": "danza",
      "keywords": 4,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "danzas": [
    {
      "id": 32562,
      "keyword": "danza",
      "keywords": 4,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "danza contemporánea": [
    {
      "id": 32562,
      "keyword": "danza contemporánea",
      "keywords": 4,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "danzas contemporáneas": [
    {
      "id": 32562,
      "keyword": "danza contemporánea",
      "keywords": 4,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "break dance": [
    {
      "id": 32562,
      "keyword": "break dance",
      "keywords": 4,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "break dances": [
    {
      "id": 32562,
      "keyword": "break dance",
      "keywords": 4,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "forma y medida": [
    {
      "id": 32586,
      "keyword": "forma y medida",
      "keywords": 4,
      "type": 2,
      "tags": [
        "shape",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "color y forma": [
    {
      "id": 32586,
      "keyword": "color y forma",
      "keywords": 4,
      "type": 2,
      "tags": [
        "shape",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colores y formas": [
    {
      "id": 32586,
      "keyword": "colores y formas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "shape",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "formas y medidas": [
    {
      "id": 32586,
      "keyword": "formas y medidas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "shape",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salud e higiene": [
    {
      "id": 32576,
      "keyword": "salud e higiene",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "hygiene",
        "corporal hygiene",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sensaciones y sentimientos": [
    {
      "id": 32590,
      "keyword": "sensaciones y sentimientos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human body",
        "body sensation",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ropa y complementos": [
    {
      "id": 32570,
      "keyword": "ropa y complementos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conceptos espaciales": [
    {
      "id": 32596,
      "keyword": "conceptos espaciales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "basic concepts",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiempo y clima": [
    {
      "id": 32600,
      "keyword": "tiempo y clima",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "alimentos y bebidas": [
    {
      "id": 32602,
      "keyword": "alimentos y bebidas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "personal": [
    {
      "id": 32588,
      "keyword": "personal",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "personales": [
    {
      "id": 32588,
      "keyword": "personal",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adjetivos": [
    {
      "id": 32584,
      "keyword": "adjetivos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atributos": [
    {
      "id": 32584,
      "keyword": "atributos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cualidades": [
    {
      "id": 32584,
      "keyword": "cualidades",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "expresión": [
    {
      "id": 32592,
      "keyword": "expresión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "expresiones": [
    {
      "id": 32592,
      "keyword": "expresión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32592,
      "keyword": "expresiones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32606,
      "keyword": "expresiones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "expression",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muebles": [
    {
      "id": 32594,
      "keyword": "muebles",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32594,
      "keyword": "mueble",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mobiliario": [
    {
      "id": 32594,
      "keyword": "mobiliario",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mueble": [
    {
      "id": 32594,
      "keyword": "mueble",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piedra pulida": [
    {
      "id": 32616,
      "keyword": "piedra pulida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piedras pulidas": [
    {
      "id": 32616,
      "keyword": "piedra pulida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nómada": [
    {
      "id": 32608,
      "keyword": "nómada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nómadas": [
    {
      "id": 32608,
      "keyword": "nómada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tallar": [
    {
      "id": 33100,
      "keyword": "tallar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "human body"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32618,
      "keyword": "tallar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32619,
      "keyword": "tallar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38718,
      "keyword": "tallar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "human body"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerámica cardial": [
    {
      "id": 32622,
      "keyword": "cerámica cardial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "craftsmanship",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerámicas cardiales": [
    {
      "id": 32622,
      "keyword": "cerámica cardial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "craftsmanship",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "evolución": [
    {
      "id": 32628,
      "keyword": "evolución",
      "keywords": 2,
      "type": 2,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "evoluciones": [
    {
      "id": 32628,
      "keyword": "evolución",
      "keywords": 2,
      "type": 2,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "evolución biológica": [
    {
      "id": 32628,
      "keyword": "evolución biológica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barco de remos": [
    {
      "id": 32624,
      "keyword": "barco de remos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barcos de remos": [
    {
      "id": 32624,
      "keyword": "barco de remos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trirreme": [
    {
      "id": 32624,
      "keyword": "trirreme",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trirremes": [
    {
      "id": 32624,
      "keyword": "trirreme",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "historia": [
    {
      "id": 32634,
      "keyword": "historia",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32632,
      "keyword": "Historia",
      "keywords": 1,
      "type": 1,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36368,
      "keyword": "historia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fundir": [
    {
      "id": 32626,
      "keyword": "fundir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tool",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paleolítico": [
    {
      "id": 32636,
      "keyword": "Paleolítico",
      "keywords": 2,
      "type": 1,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "edad de piedra": [
    {
      "id": 32636,
      "keyword": "Edad de Piedra",
      "keywords": 2,
      "type": 1,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32638,
      "keyword": "Edad de Piedra",
      "keywords": 2,
      "type": 1,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "edad de los metales": [
    {
      "id": 32640,
      "keyword": "Edad de los Metales",
      "keywords": 1,
      "type": 1,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "neolítico": [
    {
      "id": 32638,
      "keyword": "Neolítico",
      "keywords": 2,
      "type": 1,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prehistoria": [
    {
      "id": 32630,
      "keyword": "Prehistoria",
      "keywords": 1,
      "type": 1,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bifaz": [
    {
      "id": 32614,
      "keyword": "bifaz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bifaces": [
    {
      "id": 32614,
      "keyword": "bifaz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diputada": [
    {
      "id": 32642,
      "keyword": "diputada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32644,
      "keyword": "diputada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diputadas": [
    {
      "id": 32642,
      "keyword": "diputada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32644,
      "keyword": "diputada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diputado": [
    {
      "id": 32642,
      "keyword": "diputado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37561,
      "keyword": "diputado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32646,
      "keyword": "diputado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diputados": [
    {
      "id": 32642,
      "keyword": "diputado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37561,
      "keyword": "diputado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32646,
      "keyword": "diputado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "políglota": [
    {
      "id": 32660,
      "keyword": "políglota",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "políglotas": [
    {
      "id": 32660,
      "keyword": "políglota",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cruel": [
    {
      "id": 32652,
      "keyword": "cruel",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crueles": [
    {
      "id": 32652,
      "keyword": "cruel",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "corcho": [
    {
      "id": 32656,
      "keyword": "corcho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corchos": [
    {
      "id": 32656,
      "keyword": "corcho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manual": [
    {
      "id": 32661,
      "keyword": "manual",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "manuales": [
    {
      "id": 32661,
      "keyword": "manual",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "estudiante": [
    {
      "id": 32666,
      "keyword": "estudiante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32665,
      "keyword": "estudiante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estudiantes": [
    {
      "id": 32666,
      "keyword": "estudiante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32665,
      "keyword": "estudiante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tridente": [
    {
      "id": 32671,
      "keyword": "tridente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tridentes": [
    {
      "id": 32671,
      "keyword": "tridente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "masticar": [
    {
      "id": 38558,
      "keyword": "masticar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32654,
      "keyword": "masticar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tajín": [
    {
      "id": 32673,
      "keyword": "tajín",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tajines": [
    {
      "id": 32673,
      "keyword": "tajín",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tayín": [
    {
      "id": 32673,
      "keyword": "tayín",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tayines": [
    {
      "id": 32673,
      "keyword": "tayín",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sales de baño": [
    {
      "id": 32683,
      "keyword": "sales de baño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "posición": [
    {
      "id": 32675,
      "keyword": "posición",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "position",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "posiciones": [
    {
      "id": 32675,
      "keyword": "posición",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "position",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escoliosis": [
    {
      "id": 32681,
      "keyword": "escoliosis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cloroplasto": [
    {
      "id": 32685,
      "keyword": "cloroplasto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cloroplastos": [
    {
      "id": 32685,
      "keyword": "cloroplasto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fotosíntesis": [
    {
      "id": 32687,
      "keyword": "fotosíntesis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caminar con el andador": [
    {
      "id": 32946,
      "keyword": "caminar con el andador",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32693,
      "keyword": "caminar con el andador",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32694,
      "keyword": "caminar con el andador",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32945,
      "keyword": "caminar con el andador",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32944,
      "keyword": "caminar con el andador",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monasterio": [
    {
      "id": 32677,
      "keyword": "monasterio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32678,
      "keyword": "monasterio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32790,
      "keyword": "monasterio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monasterios": [
    {
      "id": 32677,
      "keyword": "monasterio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32678,
      "keyword": "monasterio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32790,
      "keyword": "monasterio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mindfulness": [
    {
      "id": 32734,
      "keyword": "mindfulness",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34239,
      "keyword": "mindfulness",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32689,
      "keyword": "mindfulness",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meditar": [
    {
      "id": 32689,
      "keyword": "meditar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mediodía": [
    {
      "id": 32708,
      "keyword": "mediodía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32709,
      "keyword": "mediodía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hospital infantil": [
    {
      "id": 32714,
      "keyword": "hospital infantil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36710,
      "keyword": "hospital infantil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36714,
      "keyword": "hospital infantil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hospitales infantiles": [
    {
      "id": 32714,
      "keyword": "hospital infantil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36710,
      "keyword": "hospital infantil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36714,
      "keyword": "hospital infantil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro de rehabilitación": [
    {
      "id": 32712,
      "keyword": "centro de rehabilitación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros de rehabilitación": [
    {
      "id": 32712,
      "keyword": "centro de rehabilitación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barrera": [
    {
      "id": 32716,
      "keyword": "barrera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barreras": [
    {
      "id": 32716,
      "keyword": "barrera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "educación vial": [
    {
      "id": 32703,
      "keyword": "educación vial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "transición a la vida adulta": [
    {
      "id": 32706,
      "keyword": "transición a la vida adulta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tva": [
    {
      "id": 32706,
      "keyword": "TVA",
      "keywords": 2,
      "type": 1,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sílaba": [
    {
      "id": 32722,
      "keyword": "sílaba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sílabas": [
    {
      "id": 32722,
      "keyword": "sílaba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parque de patinaje": [
    {
      "id": 32718,
      "keyword": "parque de patinaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "skating"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parques de patinaje": [
    {
      "id": 32718,
      "keyword": "parque de patinaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "skating"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "skatepark": [
    {
      "id": 32718,
      "keyword": "skatepark",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "skating"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "skateparks": [
    {
      "id": 32718,
      "keyword": "skatepark",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "skating"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "educación básica obligatoria": [
    {
      "id": 32720,
      "keyword": "educación básica obligatoria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ebo": [
    {
      "id": 32720,
      "keyword": "EBO",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de latín": [
    {
      "id": 32697,
      "keyword": "clase de latín",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de latín": [
    {
      "id": 32697,
      "keyword": "clase de latín",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "latín": [
    {
      "id": 32697,
      "keyword": "latín",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bibliobús": [
    {
      "id": 32732,
      "keyword": "bibliobús",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bibliobuses": [
    {
      "id": 32732,
      "keyword": "bibliobús",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "library science"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colegio electoral": [
    {
      "id": 32736,
      "keyword": "colegio electoral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "political representation",
        "election",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colegios electorales": [
    {
      "id": 32736,
      "keyword": "colegio electoral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "political representation",
        "election",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lactosa": [
    {
      "id": 32739,
      "keyword": "lactosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lactosas": [
    {
      "id": 32739,
      "keyword": "lactosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clorofila": [
    {
      "id": 32738,
      "keyword": "clorofila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clorofilas": [
    {
      "id": 32738,
      "keyword": "clorofila",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inglés": [
    {
      "id": 32705,
      "keyword": "inglés",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de inglés": [
    {
      "id": 32705,
      "keyword": "clase de inglés",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de inglés": [
    {
      "id": 32705,
      "keyword": "clase de inglés",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "océano atlántico": [
    {
      "id": 32699,
      "keyword": "Océano Atlántico",
      "keywords": 2,
      "type": 1,
      "tags": [
        "oceanography",
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grana": [
    {
      "id": 32741,
      "keyword": "grana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "granas": [
    {
      "id": 32741,
      "keyword": "grana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿de quién es?": [
    {
      "id": 32743,
      "keyword": "¿de quién es?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "de quién es?": [
    {
      "id": 32743,
      "keyword": "de quién es?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quiero más": [
    {
      "id": 32753,
      "keyword": "quiero más",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dame más": [
    {
      "id": 32753,
      "keyword": "dame más",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "querer más": [
    {
      "id": 32753,
      "keyword": "querer más",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paracaidismo": [
    {
      "id": 32759,
      "keyword": "paracaidismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sostener": [
    {
      "id": 32761,
      "keyword": "sostener",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sujetar": [
    {
      "id": 32761,
      "keyword": "sujetar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39414,
      "keyword": "sujetar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "límite": [
    {
      "id": 32765,
      "keyword": "límite",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "political geography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "límites": [
    {
      "id": 32765,
      "keyword": "límite",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "political geography"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asociación de madres y padres de alumnos": [
    {
      "id": 32724,
      "keyword": "asociación de madres y padres de alumnos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "organization",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asociaciones de madres y padres de alumnos": [
    {
      "id": 32724,
      "keyword": "asociación de madres y padres de alumnos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "organization",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ampa": [
    {
      "id": 32724,
      "keyword": "AMPA",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "organization",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ampas": [
    {
      "id": 32724,
      "keyword": "AMPA",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "organization",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "qué es?": [
    {
      "id": 32771,
      "keyword": "qué es?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "invisible": [
    {
      "id": 32755,
      "keyword": "invisible",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "character",
        "movie character",
        "cinema",
        "book character",
        "literature",
        "physics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "invisibles": [
    {
      "id": 32755,
      "keyword": "invisible",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "character",
        "movie character",
        "cinema",
        "book character",
        "literature",
        "physics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agarrar": [
    {
      "id": 32773,
      "keyword": "agarrar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34185,
      "keyword": "agarrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34186,
      "keyword": "agarrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39414,
      "keyword": "agarrar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asir": [
    {
      "id": 32773,
      "keyword": "asir",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39414,
      "keyword": "asir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿cuál es el resultado?": [
    {
      "id": 32775,
      "keyword": "¿cuál es el resultado?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "multilingüe": [
    {
      "id": 32777,
      "keyword": "multilingüe",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "multilingües": [
    {
      "id": 32777,
      "keyword": "multilingüe",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "logotipo": [
    {
      "id": 32782,
      "keyword": "logotipo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "logotipos": [
    {
      "id": 32782,
      "keyword": "logotipo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agotar": [
    {
      "id": 32778,
      "keyword": "agotar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vida privada": [
    {
      "id": 32788,
      "keyword": "vida privada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vidas privadas": [
    {
      "id": 32788,
      "keyword": "vida privada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "marmita de bonito": [
    {
      "id": 32784,
      "keyword": "marmita de bonito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marmitas de bonito": [
    {
      "id": 32784,
      "keyword": "marmita de bonito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casa de muñecas": [
    {
      "id": 32798,
      "keyword": "casa de muñecas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casas de muñecas": [
    {
      "id": 32798,
      "keyword": "casa de muñecas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "danzantes": [
    {
      "id": 32794,
      "keyword": "danzantes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "dance",
        "regional dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aurresku": [
    {
      "id": 32794,
      "keyword": "aurresku",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "dance",
        "regional dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aurreskus": [
    {
      "id": 32794,
      "keyword": "aurresku",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "dance",
        "regional dance",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "exclamar": [
    {
      "id": 32804,
      "keyword": "exclamar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "interjection",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "antiguo": [
    {
      "id": 32806,
      "keyword": "antiguo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "history",
        "ancient history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "antiguos": [
    {
      "id": 32806,
      "keyword": "antiguo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "history",
        "ancient history"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "festividades": [
    {
      "id": 32800,
      "keyword": "festividades",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fondo": [
    {
      "id": 32818,
      "keyword": "fondo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "oceanography",
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fondos": [
    {
      "id": 32818,
      "keyword": "fondo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "oceanography",
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tranquilizar": [
    {
      "id": 32780,
      "keyword": "tranquilizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36688,
      "keyword": "tranquilizar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estoy listo": [
    {
      "id": 32820,
      "keyword": "estoy listo",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "omitir": [
    {
      "id": 32822,
      "keyword": "omitir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colegio de educación especial": [
    {
      "id": 32824,
      "keyword": "colegio de educación especial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colegios de educación especial": [
    {
      "id": 32824,
      "keyword": "colegio de educación especial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro de educación especial": [
    {
      "id": 32824,
      "keyword": "centro de educación especial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros de educación especial": [
    {
      "id": 32824,
      "keyword": "centro de educación especial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rincón de la calma": [
    {
      "id": 32826,
      "keyword": "rincón de la calma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rincones de la calma": [
    {
      "id": 32826,
      "keyword": "rincón de la calma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aquagym": [
    {
      "id": 32812,
      "keyword": "aquagym",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terminar la tarea": [
    {
      "id": 32814,
      "keyword": "terminar la tarea",
      "keywords": 1,
      "type": 3,
      "tags": [
        "education",
        "educational task",
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orientación sexual": [
    {
      "id": 32828,
      "keyword": "orientación sexual",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orientaciones sexuales": [
    {
      "id": 32828,
      "keyword": "orientación sexual",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sexuality",
        "sexual orientation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tumbar en la cama ": [
    {
      "id": 32832,
      "keyword": "tumbar en la cama ",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exámen ginecológico": [
    {
      "id": 32838,
      "keyword": "exámen ginecológico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38724,
      "keyword": "exámen ginecológico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38725,
      "keyword": "exámen ginecológico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exámenes ginecológicos": [
    {
      "id": 32838,
      "keyword": "exámen ginecológico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38724,
      "keyword": "exámen ginecológico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38725,
      "keyword": "exámen ginecológico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "gynecology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bebida isotónica": [
    {
      "id": 32830,
      "keyword": "bebida isotónica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bebidas isotónicas": [
    {
      "id": 32830,
      "keyword": "bebida isotónica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "subir las piernas": [
    {
      "id": 32836,
      "keyword": "subir las piernas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tener las piernas en alto": [
    {
      "id": 32834,
      "keyword": "tener las piernas en alto",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tapones para los oídos": [
    {
      "id": 32808,
      "keyword": "tapones para los oídos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36599,
      "keyword": "tapón para los oídos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "después del mediodía": [
    {
      "id": 32850,
      "keyword": "después del mediodía",
      "keywords": 3,
      "type": 4,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "p.m.": [
    {
      "id": 32850,
      "keyword": "p.m.",
      "keywords": 3,
      "type": 4,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "post meridiem": [
    {
      "id": 32850,
      "keyword": "post meridiem",
      "keywords": 3,
      "type": 4,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fístula arterio-venosa interna": [
    {
      "id": 32854,
      "keyword": "fístula arterio-venosa interna",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32855,
      "keyword": "fístula arterio-venosa interna",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fístulas arterio-venosas internas": [
    {
      "id": 32854,
      "keyword": "fístula arterio-venosa interna",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32855,
      "keyword": "fístula arterio-venosa interna",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "favi": [
    {
      "id": 32854,
      "keyword": "FAVI",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32855,
      "keyword": "FAVI",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "favis": [
    {
      "id": 32854,
      "keyword": "FAVI",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32855,
      "keyword": "FAVI",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "presionar": [
    {
      "id": 32858,
      "keyword": "presionar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tirarse de los pelos": [
    {
      "id": 32860,
      "keyword": "tirarse de los pelos",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compartir una idea": [
    {
      "id": 32862,
      "keyword": "compartir una idea",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "slinky": [
    {
      "id": 32864,
      "keyword": "slinky",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "slinkies": [
    {
      "id": 32864,
      "keyword": "slinky",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "muelle de juguete": [
    {
      "id": 32864,
      "keyword": "muelle de juguete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muelles de juguete": [
    {
      "id": 32864,
      "keyword": "muelle de juguete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "antes del mediodía": [
    {
      "id": 32848,
      "keyword": "antes del mediodía",
      "keywords": 3,
      "type": 4,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "a.m.": [
    {
      "id": 32848,
      "keyword": "a.m.",
      "keywords": 3,
      "type": 4,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ante meridiem": [
    {
      "id": 32848,
      "keyword": "ante meridiem",
      "keywords": 3,
      "type": 4,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "análisis de heces": [
    {
      "id": 32852,
      "keyword": "análisis de heces",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿dónde está?": [
    {
      "id": 32872,
      "keyword": "¿dónde está?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seguimiento cefálico": [
    {
      "id": 32877,
      "keyword": "seguimiento cefálico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32878,
      "keyword": "seguimiento cefálico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puntero cefálico": [
    {
      "id": 32876,
      "keyword": "puntero cefálico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36436,
      "keyword": "puntero cefálico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "punteros cefálicos": [
    {
      "id": 32876,
      "keyword": "puntero cefálico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36436,
      "keyword": "puntero cefálico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "seguimiento de ojos": [
    {
      "id": 32879,
      "keyword": "seguimiento de ojos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32880,
      "keyword": "seguimiento de ojos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seguimientos de ojos": [
    {
      "id": 32879,
      "keyword": "seguimiento de ojos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32880,
      "keyword": "seguimiento de ojos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grapa": [
    {
      "id": 32894,
      "keyword": "grapa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clavija": [
    {
      "id": 32890,
      "keyword": "clavija",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clavijas": [
    {
      "id": 32890,
      "keyword": "clavija",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trasplantar": [
    {
      "id": 32896,
      "keyword": "trasplantar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "visera": [
    {
      "id": 32898,
      "keyword": "visera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32914,
      "keyword": "visera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viseras": [
    {
      "id": 32898,
      "keyword": "visera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32914,
      "keyword": "visera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "molinete": [
    {
      "id": 32892,
      "keyword": "molinete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "molinetes": [
    {
      "id": 32892,
      "keyword": "molinete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zapato": [
    {
      "id": 32923,
      "keyword": "zapato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32922,
      "keyword": "zapato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "surfear": [
    {
      "id": 32928,
      "keyword": "surfear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "surf"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32929,
      "keyword": "surfear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "surf"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32930,
      "keyword": "surfear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "surf"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "auditorio": [
    {
      "id": 32935,
      "keyword": "auditorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32934,
      "keyword": "auditorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "auditorios": [
    {
      "id": 32935,
      "keyword": "auditorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32934,
      "keyword": "auditorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "surf": [
    {
      "id": 32930,
      "keyword": "surf",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "surf"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mercado": [
    {
      "id": 32942,
      "keyword": "mercado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "plant-based food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mercados": [
    {
      "id": 32942,
      "keyword": "mercado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "plant-based food",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vámonos a casa": [
    {
      "id": 32940,
      "keyword": "vámonos a casa",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "separador de barra": [
    {
      "id": 32920,
      "keyword": "separador de barra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "separadores de barra": [
    {
      "id": 32920,
      "keyword": "separador de barra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ortesis": [
    {
      "id": 32920,
      "keyword": "ortesis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taichí": [
    {
      "id": 32960,
      "keyword": "taichí",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32961,
      "keyword": "taichí",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿cuál es la diferencia?": [
    {
      "id": 32792,
      "keyword": "¿cuál es la diferencia?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vámonos a otra tienda": [
    {
      "id": 32954,
      "keyword": "vámonos a otra tienda",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vamos a la tienda": [
    {
      "id": 32954,
      "keyword": "vamos a la tienda",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aikido": [
    {
      "id": 32964,
      "keyword": "aikido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "auxiliar de enfermería": [
    {
      "id": 38411,
      "keyword": "auxiliar de enfermería",
      "keywords": 6,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32982,
      "keyword": "auxiliar de enfermería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32983,
      "keyword": "auxiliar de enfermería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "auxiliares de enfermería": [
    {
      "id": 38411,
      "keyword": "auxiliar de enfermería",
      "keywords": 6,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32982,
      "keyword": "auxiliar de enfermería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32983,
      "keyword": "auxiliar de enfermería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parque biosaludable": [
    {
      "id": 32986,
      "keyword": "parque biosaludable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "sport",
        "sports facility",
        "communication",
        "signaling system",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32987,
      "keyword": "parque biosaludable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "sport",
        "sports facility",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parques biosaludables": [
    {
      "id": 32986,
      "keyword": "parque biosaludable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "sport",
        "sports facility",
        "communication",
        "signaling system",
        "physical exercise"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 32987,
      "keyword": "parque biosaludable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "sport",
        "sports facility",
        "physical exercise"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "viernes santo": [
    {
      "id": 32950,
      "keyword": "Viernes Santo",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "easter week",
        "religious event",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 32951,
      "keyword": "Viernes Santo",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "easter week",
        "religious event",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juez de paz": [
    {
      "id": 32992,
      "keyword": "juez de paz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jueces de paz": [
    {
      "id": 32992,
      "keyword": "juez de paz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juzgado de paz": [
    {
      "id": 32994,
      "keyword": "juzgado de paz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "law",
        "justice",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juzgados de paz": [
    {
      "id": 32994,
      "keyword": "juzgado de paz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "law",
        "justice",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "registro civil": [
    {
      "id": 32996,
      "keyword": "registro civil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "registros civiles": [
    {
      "id": 32996,
      "keyword": "registro civil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "yincana": [
    {
      "id": 33008,
      "keyword": "yincana",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yincanas": [
    {
      "id": 33008,
      "keyword": "yincana",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gymkana": [
    {
      "id": 33008,
      "keyword": "gymkana",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gymkanas": [
    {
      "id": 33008,
      "keyword": "gymkana",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gincana": [
    {
      "id": 33008,
      "keyword": "gincana",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gincanas": [
    {
      "id": 33008,
      "keyword": "gincana",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "raqueta de pádel": [
    {
      "id": 33010,
      "keyword": "raqueta de pádel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "raquetas de pádel": [
    {
      "id": 33010,
      "keyword": "raqueta de pádel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pala de pádel": [
    {
      "id": 33010,
      "keyword": "pala de pádel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palas de pádel": [
    {
      "id": 33010,
      "keyword": "pala de pádel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "neopreno": [
    {
      "id": 33012,
      "keyword": "neopreno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "neoprenos": [
    {
      "id": 33012,
      "keyword": "neopreno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "traje de surf": [
    {
      "id": 33012,
      "keyword": "traje de surf",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trajes de surf": [
    {
      "id": 33012,
      "keyword": "traje de surf",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desmontar": [
    {
      "id": 39275,
      "keyword": "desmontar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33014,
      "keyword": "desmontar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar del caballo": [
    {
      "id": 33014,
      "keyword": "bajar del caballo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orinar fuera": [
    {
      "id": 33004,
      "keyword": "orinar fuera",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "person",
        "basic needs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "funeral": [
    {
      "id": 33018,
      "keyword": "funeral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "funerales": [
    {
      "id": 33018,
      "keyword": "funeral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "event",
        "religious event",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "showdown": [
    {
      "id": 33023,
      "keyword": "showdown",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "adapted sport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33022,
      "keyword": "showdown",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "adapted sport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tolerancia": [
    {
      "id": 33002,
      "keyword": "tolerancia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jefa de almacén": [
    {
      "id": 33026,
      "keyword": "jefa de almacén",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jefas de almacén": [
    {
      "id": 33026,
      "keyword": "jefa de almacén",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "futbolín": [
    {
      "id": 33020,
      "keyword": "futbolín",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "futbolines": [
    {
      "id": 33020,
      "keyword": "futbolín",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "metegol": [
    {
      "id": 33020,
      "keyword": "metegol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "metegoles": [
    {
      "id": 33020,
      "keyword": "metegol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "subir al caballo": [
    {
      "id": 33016,
      "keyword": "subir al caballo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tolerar": [
    {
      "id": 33000,
      "keyword": "tolerar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desarrollo sostenible": [
    {
      "id": 33034,
      "keyword": "desarrollo sostenible",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "biomoléculas": [
    {
      "id": 33032,
      "keyword": "biomoléculas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "biology",
        "chemistry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "biomoléculas inorgánicas": [
    {
      "id": 33032,
      "keyword": "biomoléculas inorgánicas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "biology",
        "chemistry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salina": [
    {
      "id": 33042,
      "keyword": "salina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "workplace",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salinas": [
    {
      "id": 33042,
      "keyword": "salina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "workplace",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jefe de almacén": [
    {
      "id": 33028,
      "keyword": "jefe de almacén",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jefes de almacén": [
    {
      "id": 33028,
      "keyword": "jefe de almacén",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mar menor": [
    {
      "id": 33040,
      "keyword": "Mar Menor",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "sea",
        "ocean",
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "integrador social": [
    {
      "id": 33030,
      "keyword": "integrador social",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "integradores sociales": [
    {
      "id": 33030,
      "keyword": "integrador social",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fagot": [
    {
      "id": 33044,
      "keyword": "fagot",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fagots": [
    {
      "id": 33044,
      "keyword": "fagot",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trabajo uno a uno": [
    {
      "id": 33050,
      "keyword": "trabajo uno a uno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trabajos uno a uno": [
    {
      "id": 33050,
      "keyword": "trabajo uno a uno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "memory": [
    {
      "id": 33052,
      "keyword": "memory",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39085,
      "keyword": "memory",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "memorys": [
    {
      "id": 33052,
      "keyword": "memory",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39085,
      "keyword": "memory",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agencia de desarrollo": [
    {
      "id": 33048,
      "keyword": "agencia de desarrollo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agencias de desarrollo": [
    {
      "id": 33048,
      "keyword": "agencia de desarrollo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "el tiempo vuela": [
    {
      "id": 33054,
      "keyword": "el tiempo vuela",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "set phrase"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aula de apoyo": [
    {
      "id": 33080,
      "keyword": "aula de apoyo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aulas de apoyo": [
    {
      "id": 33080,
      "keyword": "aula de apoyo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aula de acogida": [
    {
      "id": 33078,
      "keyword": "aula de acogida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aulas de acogida": [
    {
      "id": 33078,
      "keyword": "aula de acogida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aula de teatro": [
    {
      "id": 33082,
      "keyword": "aula de teatro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aulas de teatro": [
    {
      "id": 33082,
      "keyword": "aula de teatro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conquistador": [
    {
      "id": 33060,
      "keyword": "conquistador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conquistadores": [
    {
      "id": 33060,
      "keyword": "conquistador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aula de tva": [
    {
      "id": 33084,
      "keyword": "aula de TVA",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aulas de tva": [
    {
      "id": 33084,
      "keyword": "aula de TVA",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aula de aprendizaje de tareas": [
    {
      "id": 33084,
      "keyword": "aula de aprendizaje de tareas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aulas de aprendizaje de tareas": [
    {
      "id": 33084,
      "keyword": "aula de aprendizaje de tareas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "medición": [
    {
      "id": 33100,
      "keyword": "medición",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "human body"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mediciones": [
    {
      "id": 33100,
      "keyword": "medición",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "human body"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuánto mide": [
    {
      "id": 33102,
      "keyword": "cuánto mide",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máquina de rayos x": [
    {
      "id": 33104,
      "keyword": "máquina de rayos x",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33105,
      "keyword": "máquina de rayos x",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máquinas de rayos x": [
    {
      "id": 33104,
      "keyword": "máquina de rayos x",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33105,
      "keyword": "máquina de rayos x",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "resonancia": [
    {
      "id": 33112,
      "keyword": "resonancia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "resonancias": [
    {
      "id": 33112,
      "keyword": "resonancia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "examen físico": [
    {
      "id": 33114,
      "keyword": "examen físico",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exámenes físicos": [
    {
      "id": 33114,
      "keyword": "examen físico",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "éxamen": [
    {
      "id": 33114,
      "keyword": "éxamen",
      "keywords": 5,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sonda de alimentación": [
    {
      "id": 33118,
      "keyword": "sonda de alimentación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sondas de alimentación": [
    {
      "id": 33118,
      "keyword": "sonda de alimentación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sonda de nutrición": [
    {
      "id": 33118,
      "keyword": "sonda de nutrición",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sondas de nutrición": [
    {
      "id": 33118,
      "keyword": "sonda de nutrición",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espéculo vaginal": [
    {
      "id": 33120,
      "keyword": "espéculo vaginal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espéculos vaginales": [
    {
      "id": 33120,
      "keyword": "espéculo vaginal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "citología vaginal": [
    {
      "id": 33122,
      "keyword": "citología vaginal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "citologías vaginales": [
    {
      "id": 33122,
      "keyword": "citología vaginal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frotis vaginal": [
    {
      "id": 33122,
      "keyword": "frotis vaginal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frotis vaginales": [
    {
      "id": 33122,
      "keyword": "frotis vaginal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿cuánto pesa?": [
    {
      "id": 33128,
      "keyword": "¿cuánto pesa?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuánto pesa": [
    {
      "id": 33128,
      "keyword": "cuánto pesa",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "protector genital": [
    {
      "id": 33132,
      "keyword": "protector genital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33133,
      "keyword": "protector genital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33134,
      "keyword": "protector genital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33135,
      "keyword": "protector genital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33136,
      "keyword": "protector genital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33137,
      "keyword": "protector genital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33139,
      "keyword": "protector genital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33138,
      "keyword": "protector genital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33130,
      "keyword": "protector genital",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33131,
      "keyword": "protector genital",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33150,
      "keyword": "protector genital",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "protectores genitales": [
    {
      "id": 33132,
      "keyword": "protector genital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33133,
      "keyword": "protector genital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33134,
      "keyword": "protector genital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33135,
      "keyword": "protector genital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33136,
      "keyword": "protector genital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33137,
      "keyword": "protector genital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33139,
      "keyword": "protector genital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33138,
      "keyword": "protector genital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33130,
      "keyword": "protector genital",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33131,
      "keyword": "protector genital",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33150,
      "keyword": "protector genital",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "protector testicular": [
    {
      "id": 33130,
      "keyword": "protector testicular",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33131,
      "keyword": "protector testicular",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33150,
      "keyword": "protector testicular",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "protectores testiculares": [
    {
      "id": 33130,
      "keyword": "protector testicular",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33131,
      "keyword": "protector testicular",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33150,
      "keyword": "protector testicular",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amniocentesis": [
    {
      "id": 33124,
      "keyword": "amniocentesis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "gynecology",
        "obstetrics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inspirar por la boca": [
    {
      "id": 33908,
      "keyword": "inspirar por la boca",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "respiratory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conquistar": [
    {
      "id": 33062,
      "keyword": "conquistar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "history",
        "middle ages"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner un parche": [
    {
      "id": 33914,
      "keyword": "poner un parche",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33916,
      "keyword": "poner un parche",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33915,
      "keyword": "poner un parche",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secador de manos": [
    {
      "id": 33921,
      "keyword": "secador de manos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secadores de manos": [
    {
      "id": 33921,
      "keyword": "secador de manos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dar el alta": [
    {
      "id": 33912,
      "keyword": "dar el alta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secador de pelo": [
    {
      "id": 33920,
      "keyword": "secador de pelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secadores de pelo": [
    {
      "id": 33920,
      "keyword": "secador de pelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ingresar": [
    {
      "id": 33910,
      "keyword": "ingresar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "amamantar a gemelos o mellizos": [
    {
      "id": 33924,
      "keyword": "amamantar a gemelos o mellizos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brazo con algodón": [
    {
      "id": 33946,
      "keyword": "brazo con algodón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brazos con algodón": [
    {
      "id": 33946,
      "keyword": "brazo con algodón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "señalizar": [
    {
      "id": 33956,
      "keyword": "señalizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33957,
      "keyword": "señalizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33958,
      "keyword": "señalizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "libros para jóvenes": [
    {
      "id": 33963,
      "keyword": "libros para jóvenes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "libros para niños": [
    {
      "id": 33962,
      "keyword": "libros para niños",
      "keywords": 3,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33965,
      "keyword": "libros para niños",
      "keywords": 3,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33964,
      "keyword": "libros para niños",
      "keywords": 3,
      "type": 2,
      "tags": [
        "library science",
        "decimal classification"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coordinadora del comedor": [
    {
      "id": 33968,
      "keyword": "coordinadora del comedor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coordinadoras del comedor": [
    {
      "id": 33968,
      "keyword": "coordinadora del comedor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coordinar": [
    {
      "id": 33970,
      "keyword": "coordinar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mediador comunicativo": [
    {
      "id": 33976,
      "keyword": "mediador comunicativo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mediadores comunicativos": [
    {
      "id": 33976,
      "keyword": "mediador comunicativo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "delfinoterapia": [
    {
      "id": 33980,
      "keyword": "delfinoterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 33981,
      "keyword": "delfinoterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "delfinoterapias": [
    {
      "id": 33980,
      "keyword": "delfinoterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 33981,
      "keyword": "delfinoterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casita de jardín": [
    {
      "id": 33988,
      "keyword": "casita de jardín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casitas de jardín": [
    {
      "id": 33988,
      "keyword": "casita de jardín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "técnico en atención a personas en situación de dependencia": [
    {
      "id": 33974,
      "keyword": "técnico en atención a personas en situación de dependencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnicos en atención a personas en situación de dependencia": [
    {
      "id": 33974,
      "keyword": "técnico en atención a personas en situación de dependencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "portavoz": [
    {
      "id": 33992,
      "keyword": "portavoz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "work",
        "organization",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "portavoces": [
    {
      "id": 33992,
      "keyword": "portavoz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "work",
        "organization",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "material de piscina": [
    {
      "id": 33986,
      "keyword": "material de piscina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "materiales de piscina": [
    {
      "id": 33986,
      "keyword": "material de piscina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "material de pileta": [
    {
      "id": 33986,
      "keyword": "material de pileta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "materiales de pileta": [
    {
      "id": 33986,
      "keyword": "material de pileta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amable": [
    {
      "id": 33994,
      "keyword": "amable",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "amables": [
    {
      "id": 33994,
      "keyword": "amable",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amigable": [
    {
      "id": 33994,
      "keyword": "amigable",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "amigables": [
    {
      "id": 33994,
      "keyword": "amigable",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juego simbólico": [
    {
      "id": 33990,
      "keyword": "juego simbólico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salario": [
    {
      "id": 33996,
      "keyword": "salario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salarios": [
    {
      "id": 33996,
      "keyword": "salario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "subvención": [
    {
      "id": 33998,
      "keyword": "subvención",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subvenciones": [
    {
      "id": 33998,
      "keyword": "subvención",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mellizos": [
    {
      "id": 34002,
      "keyword": "mellizos",
      "keywords": 1,
      "type": 4,
      "tags": [
        "person",
        "group",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "punto de encuentro familiar": [
    {
      "id": 34000,
      "keyword": "punto de encuentro familiar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34317,
      "keyword": "punto de encuentro familiar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puntos de encuentro familiar": [
    {
      "id": 34000,
      "keyword": "punto de encuentro familiar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34317,
      "keyword": "punto de encuentro familiar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "psicopedagogo": [
    {
      "id": 33972,
      "keyword": "psicopedagogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "psicopedagogos": [
    {
      "id": 33972,
      "keyword": "psicopedagogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espesante": [
    {
      "id": 34015,
      "keyword": "espesante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38739,
      "keyword": "espesante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espesantes": [
    {
      "id": 34015,
      "keyword": "espesante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38739,
      "keyword": "espesante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tutorial": [
    {
      "id": 34004,
      "keyword": "tutorial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tutoriales": [
    {
      "id": 34004,
      "keyword": "tutorial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espeso": [
    {
      "id": 34017,
      "keyword": "espeso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espesos": [
    {
      "id": 34017,
      "keyword": "espeso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espesa": [
    {
      "id": 34017,
      "keyword": "espesa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espesas": [
    {
      "id": 34017,
      "keyword": "espesa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "leche sin lactosa": [
    {
      "id": 34008,
      "keyword": "leche sin lactosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leches sin lactosa": [
    {
      "id": 34008,
      "keyword": "leche sin lactosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "langostino": [
    {
      "id": 34010,
      "keyword": "langostino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "langostinos": [
    {
      "id": 34010,
      "keyword": "langostino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "marimba": [
    {
      "id": 34027,
      "keyword": "marimba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marimbas": [
    {
      "id": 34027,
      "keyword": "marimba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vibrar": [
    {
      "id": 34025,
      "keyword": "vibrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subirse la camiseta": [
    {
      "id": 37818,
      "keyword": "subirse la camiseta",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34021,
      "keyword": "subirse la camiseta",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34022,
      "keyword": "subirse la camiseta",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir la camiseta": [
    {
      "id": 37818,
      "keyword": "subir la camiseta",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34021,
      "keyword": "subir la camiseta",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34022,
      "keyword": "subir la camiseta",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir la remera": [
    {
      "id": 37818,
      "keyword": "subir la remera",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34021,
      "keyword": "subir la remera",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34022,
      "keyword": "subir la remera",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gluten": [
    {
      "id": 34006,
      "keyword": "gluten",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "dietetics",
        "feeding",
        "food",
        "plant-based food",
        "cereal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pesar y medir": [
    {
      "id": 34031,
      "keyword": "pesar y medir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38909,
      "keyword": "pesar y medir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bombo": [
    {
      "id": 34029,
      "keyword": "bombo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bombos": [
    {
      "id": 34029,
      "keyword": "bombo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "erizo de mar": [
    {
      "id": 34033,
      "keyword": "erizo de mar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "extinct being",
        "fossil",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "erizos de mar": [
    {
      "id": 34033,
      "keyword": "erizo de mar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "extinct being",
        "fossil",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cachorro": [
    {
      "id": 34072,
      "keyword": "cachorro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal reproduction"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34041,
      "keyword": "cachorro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cachorros": [
    {
      "id": 34072,
      "keyword": "cachorro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal reproduction"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34041,
      "keyword": "cachorro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trilobites": [
    {
      "id": 34035,
      "keyword": "trilobites",
      "keywords": 1,
      "type": 2,
      "tags": [
        "extinct being",
        "fossil",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "portacelo": [
    {
      "id": 34047,
      "keyword": "portacelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "portacelos": [
    {
      "id": 34047,
      "keyword": "portacelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "embarrar": [
    {
      "id": 34049,
      "keyword": "embarrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34050,
      "keyword": "embarrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "material",
        "derived material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pétalo": [
    {
      "id": 34063,
      "keyword": "pétalo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pétalos": [
    {
      "id": 34063,
      "keyword": "pétalo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "regla y compás": [
    {
      "id": 34065,
      "keyword": "regla y compás",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reglas y compases": [
    {
      "id": 34065,
      "keyword": "regla y compás",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guante de boxeo": [
    {
      "id": 34067,
      "keyword": "guante de boxeo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rebanadas": [
    {
      "id": 35045,
      "keyword": "rebanada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34070,
      "keyword": "rebanadas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escandinavia": [
    {
      "id": 34069,
      "keyword": "Escandinavia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gatito": [
    {
      "id": 34082,
      "keyword": "gatito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gatitos": [
    {
      "id": 34082,
      "keyword": "gatito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gatita": [
    {
      "id": 34082,
      "keyword": "gatita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gatitas": [
    {
      "id": 34082,
      "keyword": "gatita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plato pequeño": [
    {
      "id": 34088,
      "keyword": "plato pequeño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "platos pequeños": [
    {
      "id": 34088,
      "keyword": "plato pequeño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diente de ajo": [
    {
      "id": 34084,
      "keyword": "diente de ajo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dientes de ajo": [
    {
      "id": 34084,
      "keyword": "diente de ajo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34086,
      "keyword": "dientes de ajo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bate y pelota": [
    {
      "id": 34090,
      "keyword": "bate y pelota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bates y pelotas": [
    {
      "id": 34090,
      "keyword": "bate y pelota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bicicleta de spinning": [
    {
      "id": 34100,
      "keyword": "bicicleta de spinning",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bicicletas de spinning": [
    {
      "id": 34100,
      "keyword": "bicicleta de spinning",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "spinning": [
    {
      "id": 34102,
      "keyword": "spinning",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cono de chocolate": [
    {
      "id": 34092,
      "keyword": "cono de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conos de chocolate": [
    {
      "id": 34092,
      "keyword": "cono de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "punto limpio": [
    {
      "id": 34104,
      "keyword": "punto limpio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recycling center",
        "recycling",
        "environmental science"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34105,
      "keyword": "punto limpio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recycling center",
        "recycling",
        "environmental science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puntos limpios": [
    {
      "id": 34104,
      "keyword": "punto limpio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recycling center",
        "recycling",
        "environmental science"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34105,
      "keyword": "punto limpio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recycling center",
        "recycling",
        "environmental science"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ecoparque": [
    {
      "id": 34104,
      "keyword": "ecoparque",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recycling center",
        "recycling",
        "environmental science"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34105,
      "keyword": "ecoparque",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recycling center",
        "recycling",
        "environmental science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ecoparques": [
    {
      "id": 34104,
      "keyword": "ecoparque",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recycling center",
        "recycling",
        "environmental science"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34105,
      "keyword": "ecoparque",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recycling center",
        "recycling",
        "environmental science"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pintarse los labios": [
    {
      "id": 34108,
      "keyword": "pintarse los labios",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pintar los labios": [
    {
      "id": 34108,
      "keyword": "pintar los labios",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balón de balonmano": [
    {
      "id": 34112,
      "keyword": "balón de balonmano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balones de balonmano": [
    {
      "id": 34112,
      "keyword": "balón de balonmano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "balón de voleybol": [
    {
      "id": 34114,
      "keyword": "balón de voleybol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balones de voleybol": [
    {
      "id": 34114,
      "keyword": "balón de voleybol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pregón": [
    {
      "id": 34116,
      "keyword": "pregón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pregones": [
    {
      "id": 34116,
      "keyword": "pregón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "remolcador": [
    {
      "id": 34121,
      "keyword": "remolcador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "remolcadores": [
    {
      "id": 34121,
      "keyword": "remolcador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "uvas negras": [
    {
      "id": 34120,
      "keyword": "uvas negras",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espárragos verdes": [
    {
      "id": 34127,
      "keyword": "espárragos verdes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "churrería": [
    {
      "id": 34129,
      "keyword": "churrería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34195,
      "keyword": "churrería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "churrerías": [
    {
      "id": 34129,
      "keyword": "churrería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34195,
      "keyword": "churrería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerrajería": [
    {
      "id": 34131,
      "keyword": "cerrajería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerrajerías": [
    {
      "id": 34131,
      "keyword": "cerrajería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro auditivo": [
    {
      "id": 34133,
      "keyword": "centro auditivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "orthopedic product",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros auditivos": [
    {
      "id": 34133,
      "keyword": "centro auditivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "orthopedic product",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de regalos": [
    {
      "id": 34137,
      "keyword": "tienda de regalos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de regalos": [
    {
      "id": 34137,
      "keyword": "tienda de regalos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de disfraces": [
    {
      "id": 34135,
      "keyword": "tienda de disfraces",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de disfraces": [
    {
      "id": 34135,
      "keyword": "tienda de disfraces",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "loterías y apuestas": [
    {
      "id": 34139,
      "keyword": "loterías y apuestas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "leisure",
        "game",
        "gambling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "remolcar": [
    {
      "id": 34123,
      "keyword": "remolcar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsa de hielo": [
    {
      "id": 34125,
      "keyword": "bolsa de hielo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas de hielo": [
    {
      "id": 34125,
      "keyword": "bolsa de hielo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pipican": [
    {
      "id": 34143,
      "keyword": "pipican",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "animal",
        "pet",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pipicanes": [
    {
      "id": 34143,
      "keyword": "pipican",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "animal",
        "pet",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pan de hamburguesa": [
    {
      "id": 34151,
      "keyword": "pan de hamburguesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panes de hamburguesa": [
    {
      "id": 34151,
      "keyword": "pan de hamburguesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "brocha de maquillaje": [
    {
      "id": 34145,
      "keyword": "brocha de maquillaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brochas de maquillaje": [
    {
      "id": 34145,
      "keyword": "brocha de maquillaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camilla plegable": [
    {
      "id": 34155,
      "keyword": "camilla plegable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camillas plegables": [
    {
      "id": 34155,
      "keyword": "camilla plegable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "material escolar": [
    {
      "id": 34153,
      "keyword": "material escolar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "materiales escolares": [
    {
      "id": 34153,
      "keyword": "material escolar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aguja y bobina": [
    {
      "id": 34159,
      "keyword": "aguja y bobina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agujas y bobinas": [
    {
      "id": 34159,
      "keyword": "aguja y bobina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juego de la carretilla": [
    {
      "id": 34157,
      "keyword": "juego de la carretilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos de la carretilla": [
    {
      "id": 34157,
      "keyword": "juego de la carretilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asesoría": [
    {
      "id": 34163,
      "keyword": "asesoría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "professional services",
        "place",
        "building",
        "trade",
        "consultancy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asesorías": [
    {
      "id": 34163,
      "keyword": "asesoría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "professional services",
        "place",
        "building",
        "trade",
        "consultancy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "academia": [
    {
      "id": 34161,
      "keyword": "academia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38815,
      "keyword": "academia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "academias": [
    {
      "id": 34161,
      "keyword": "academia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38815,
      "keyword": "academia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zumba": [
    {
      "id": 34149,
      "keyword": "zumba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peón": [
    {
      "id": 34167,
      "keyword": "peón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "chess"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peones": [
    {
      "id": 34167,
      "keyword": "peón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "chess"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alfil": [
    {
      "id": 34169,
      "keyword": "alfil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "chess"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alfiles": [
    {
      "id": 34169,
      "keyword": "alfil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "chess"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "liana": [
    {
      "id": 34179,
      "keyword": "liana",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "lianas": [
    {
      "id": 34179,
      "keyword": "liana",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "ensordecer": [
    {
      "id": 34177,
      "keyword": "ensordecer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ojeras": [
    {
      "id": 34193,
      "keyword": "ojeras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diapasón": [
    {
      "id": 34181,
      "keyword": "diapasón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diapasones": [
    {
      "id": 34181,
      "keyword": "diapasón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guardarropa": [
    {
      "id": 34183,
      "keyword": "guardarropa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guardarropas": [
    {
      "id": 34183,
      "keyword": "guardarropa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "legrado": [
    {
      "id": 34199,
      "keyword": "legrado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "legrados": [
    {
      "id": 34199,
      "keyword": "legrado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "human reproduction",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colinas": [
    {
      "id": 34147,
      "keyword": "colinas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "place",
        "rural area"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38728,
      "keyword": "colina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "place",
        "rural area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "platea": [
    {
      "id": 34209,
      "keyword": "platea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "theater",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plateas": [
    {
      "id": 34209,
      "keyword": "platea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "theater",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palco": [
    {
      "id": 34211,
      "keyword": "palco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "theater",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palcos": [
    {
      "id": 34211,
      "keyword": "palco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "theater",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acículas": [
    {
      "id": 34223,
      "keyword": "acículas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34229,
      "keyword": "acículas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marcapáginas": [
    {
      "id": 34225,
      "keyword": "marcapáginas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crepería": [
    {
      "id": 34231,
      "keyword": "crepería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "creperías": [
    {
      "id": 34231,
      "keyword": "crepería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "traumatólogo": [
    {
      "id": 38828,
      "keyword": "traumatólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "joint system",
        "muscular system",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34235,
      "keyword": "traumatólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "osseous system",
        "muscular system",
        "joint system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "traumatólogos": [
    {
      "id": 38828,
      "keyword": "traumatólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "joint system",
        "muscular system",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34235,
      "keyword": "traumatólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "osseous system",
        "muscular system",
        "joint system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gofre": [
    {
      "id": 34227,
      "keyword": "gofre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gofres": [
    {
      "id": 34227,
      "keyword": "gofre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "crep": [
    {
      "id": 34233,
      "keyword": "crep",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crepes": [
    {
      "id": 34233,
      "keyword": "crep",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34233,
      "keyword": "crepe",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "crepe": [
    {
      "id": 34233,
      "keyword": "crepe",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panqueque": [
    {
      "id": 34233,
      "keyword": "panqueque",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panqueques": [
    {
      "id": 34233,
      "keyword": "panqueque",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37849,
      "keyword": "panqueques",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "traumatóloga": [
    {
      "id": 38828,
      "keyword": "traumatóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "joint system",
        "muscular system",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34237,
      "keyword": "traumatóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "osseous system",
        "muscular system",
        "joint system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "traumatólogas": [
    {
      "id": 38828,
      "keyword": "traumatóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "joint system",
        "muscular system",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34237,
      "keyword": "traumatóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "osseous system",
        "muscular system",
        "joint system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "claustrofobia": [
    {
      "id": 34242,
      "keyword": "claustrofobia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colegio bilingüe": [
    {
      "id": 34247,
      "keyword": "colegio bilingüe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34248,
      "keyword": "colegio bilingüe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34246,
      "keyword": "colegio bilingüe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colegios bilingües": [
    {
      "id": 34247,
      "keyword": "colegio bilingüe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34248,
      "keyword": "colegio bilingüe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34246,
      "keyword": "colegio bilingüe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "meteorito": [
    {
      "id": 34241,
      "keyword": "meteorito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35001,
      "keyword": "meteorito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meteoritos": [
    {
      "id": 34241,
      "keyword": "meteorito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35001,
      "keyword": "meteorito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paleontóloga": [
    {
      "id": 34256,
      "keyword": "paleontóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "paleontology",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paleontólogas": [
    {
      "id": 34256,
      "keyword": "paleontóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "paleontology",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paleontólogo": [
    {
      "id": 34254,
      "keyword": "paleontólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "paleontology",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paleontólogos": [
    {
      "id": 34254,
      "keyword": "paleontólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "paleontology",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "yacer": [
    {
      "id": 34203,
      "keyword": "yacer",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38054,
      "keyword": "yacer",
      "keywords": 4,
      "type": 3,
      "tags": [
        "document",
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parafarmacia": [
    {
      "id": 34274,
      "keyword": "parafarmacia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "fashion",
        "cosmetic",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parafarmacias": [
    {
      "id": 34274,
      "keyword": "parafarmacia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "fashion",
        "cosmetic",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cosquilleo": [
    {
      "id": 34276,
      "keyword": "cosquilleo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cosquilleos": [
    {
      "id": 34276,
      "keyword": "cosquilleo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "poner el audífono": [
    {
      "id": 34278,
      "keyword": "poner el audífono",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34279,
      "keyword": "poner el audífono",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34280,
      "keyword": "poner el audífono",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cavar una tumba": [
    {
      "id": 34272,
      "keyword": "cavar una tumba",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "edad de hielo": [
    {
      "id": 34268,
      "keyword": "Edad de Hielo",
      "keywords": 1,
      "type": 1,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pedir la mano": [
    {
      "id": 34286,
      "keyword": "pedir la mano",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bola de pinchos": [
    {
      "id": 34288,
      "keyword": "bola de pinchos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolas de pinchos": [
    {
      "id": 34288,
      "keyword": "bola de pinchos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "therasuit": [
    {
      "id": 34290,
      "keyword": "therasuit",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "therasuits": [
    {
      "id": 34290,
      "keyword": "therasuit",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cabina de prensa": [
    {
      "id": 34270,
      "keyword": "cabina de prensa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cabinas de prensa": [
    {
      "id": 34270,
      "keyword": "cabina de prensa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bañar un animal": [
    {
      "id": 34294,
      "keyword": "bañar un animal",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anfiteatro": [
    {
      "id": 34300,
      "keyword": "anfiteatro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "theater",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anfiteatros": [
    {
      "id": 34300,
      "keyword": "anfiteatro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "theater",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "movilizar": [
    {
      "id": 34292,
      "keyword": "movilizar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barquillo": [
    {
      "id": 34302,
      "keyword": "barquillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barquillos": [
    {
      "id": 34302,
      "keyword": "barquillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mostrador": [
    {
      "id": 34298,
      "keyword": "mostrador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mostradores": [
    {
      "id": 34298,
      "keyword": "mostrador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "martillo de geólogo": [
    {
      "id": 34306,
      "keyword": "martillo de geólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "geology",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "martillos de geólogo": [
    {
      "id": 34306,
      "keyword": "martillo de geólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "geology",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pico para roca": [
    {
      "id": 34306,
      "keyword": "pico para roca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "geology",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "picos para roca": [
    {
      "id": 34306,
      "keyword": "pico para roca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "geology",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peligro de caída": [
    {
      "id": 34304,
      "keyword": "peligro de caída",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peligro por caídas": [
    {
      "id": 34304,
      "keyword": "peligro por caídas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "riesgo por caídas": [
    {
      "id": 34304,
      "keyword": "riesgo por caídas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lonja": [
    {
      "id": 34284,
      "keyword": "lonja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lonjas": [
    {
      "id": 34284,
      "keyword": "lonja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dientes de sable": [
    {
      "id": 34310,
      "keyword": "dientes de sable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "extinct being",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "smilodon": [
    {
      "id": 34310,
      "keyword": "smilodon",
      "keywords": 2,
      "type": 2,
      "tags": [
        "extinct being",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "smilodones": [
    {
      "id": 34310,
      "keyword": "smilodon",
      "keywords": 2,
      "type": 2,
      "tags": [
        "extinct being",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lavado de mascotas": [
    {
      "id": 34308,
      "keyword": "lavado de mascotas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavados de mascotas": [
    {
      "id": 34308,
      "keyword": "lavado de mascotas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro especial de empleo": [
    {
      "id": 34312,
      "keyword": "centro especial de empleo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "industry",
        "workplace",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros especiales de empleo": [
    {
      "id": 34312,
      "keyword": "centro especial de empleo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "industry",
        "workplace",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ver una película": [
    {
      "id": 34319,
      "keyword": "ver una película",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "scenic art",
        "cinema",
        "show",
        "leisure",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vendaval": [
    {
      "id": 34296,
      "keyword": "vendaval",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vendavales": [
    {
      "id": 34296,
      "keyword": "vendaval",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "simulador": [
    {
      "id": 34335,
      "keyword": "simulador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "simuladores": [
    {
      "id": 34335,
      "keyword": "simulador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "unidad de media estancia": [
    {
      "id": 34337,
      "keyword": "unidad de media estancia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "unidades de media estancia": [
    {
      "id": 34337,
      "keyword": "unidad de media estancia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "unidad de larga estancia": [
    {
      "id": 34337,
      "keyword": "unidad de larga estancia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "unidades de larga estancia": [
    {
      "id": 34337,
      "keyword": "unidad de larga estancia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sede comarcal": [
    {
      "id": 34331,
      "keyword": "sede comarcal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sedes comarcales": [
    {
      "id": 34331,
      "keyword": "sede comarcal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cine 4d": [
    {
      "id": 34333,
      "keyword": "cine 4D",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cines 4d": [
    {
      "id": 34333,
      "keyword": "cine 4D",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pegar una  bofetada": [
    {
      "id": 34343,
      "keyword": "pegar una  bofetada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime",
        "bullying"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "siluro": [
    {
      "id": 34355,
      "keyword": "siluro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "work",
        "primary sector",
        "fishing",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "siluros": [
    {
      "id": 34355,
      "keyword": "siluro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "work",
        "primary sector",
        "fishing",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vestuario local": [
    {
      "id": 34327,
      "keyword": "vestuario local",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vestuarios locales": [
    {
      "id": 34327,
      "keyword": "vestuario local",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aderezo": [
    {
      "id": 34359,
      "keyword": "aderezo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aderezos": [
    {
      "id": 34359,
      "keyword": "aderezos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dermatóloga": [
    {
      "id": 38833,
      "keyword": "dermatóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human physiology",
        "physiology",
        "integumentary system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34373,
      "keyword": "dermatóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human physiology",
        "physiology",
        "integumentary system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dermatólogas": [
    {
      "id": 38833,
      "keyword": "dermatóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human physiology",
        "physiology",
        "integumentary system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34373,
      "keyword": "dermatóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human physiology",
        "physiology",
        "integumentary system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dermatólogo": [
    {
      "id": 38833,
      "keyword": "dermatólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human physiology",
        "physiology",
        "integumentary system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34375,
      "keyword": "dermatólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human physiology",
        "physiology",
        "integumentary system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dermatólogos": [
    {
      "id": 38833,
      "keyword": "dermatólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human physiology",
        "physiology",
        "integumentary system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34375,
      "keyword": "dermatólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human physiology",
        "physiology",
        "integumentary system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "respirar": [
    {
      "id": 34377,
      "keyword": "respirar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34409,
      "keyword": "respirar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34508,
      "keyword": "respirar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buceador": [
    {
      "id": 34379,
      "keyword": "buceador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "diving"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buceadores": [
    {
      "id": 34379,
      "keyword": "buceador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "diving"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vestuario visitante": [
    {
      "id": 34329,
      "keyword": "vestuario visitante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vestuarios visitantes": [
    {
      "id": 34329,
      "keyword": "vestuario visitante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bidón": [
    {
      "id": 34385,
      "keyword": "bidón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bidones": [
    {
      "id": 34385,
      "keyword": "bidón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sudamérica": [
    {
      "id": 34387,
      "keyword": "Sudamérica",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nublar": [
    {
      "id": 34383,
      "keyword": "nublar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34896,
      "keyword": "nublar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "letras": [
    {
      "id": 34361,
      "keyword": "letras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39235,
      "keyword": "letra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nilo": [
    {
      "id": 34389,
      "keyword": "Nilo",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "river",
        "history",
        "civilization",
        "Egypt"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prenda": [
    {
      "id": 34395,
      "keyword": "prenda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "footwear",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prendas": [
    {
      "id": 34395,
      "keyword": "prenda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "footwear",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugadora de hockey hierba": [
    {
      "id": 34401,
      "keyword": "jugadora de hockey hierba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadoras de hockey hierba": [
    {
      "id": 34401,
      "keyword": "jugadora de hockey hierba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "río murray": [
    {
      "id": 34391,
      "keyword": "río Murray",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadora de voleibol": [
    {
      "id": 34399,
      "keyword": "jugadora de voleibol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadoras de voleibol": [
    {
      "id": 34399,
      "keyword": "jugadora de voleibol",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gurami perla": [
    {
      "id": 34425,
      "keyword": "gurami perla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guramis perla": [
    {
      "id": 34425,
      "keyword": "gurami perla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugadora de balonmano": [
    {
      "id": 34413,
      "keyword": "jugadora de balonmano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadoras de balonmano": [
    {
      "id": 34413,
      "keyword": "jugadora de balonmano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carpa koi": [
    {
      "id": 34427,
      "keyword": "carpa koi",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "domestic",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carpas koi": [
    {
      "id": 34427,
      "keyword": "carpa koi",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "domestic",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pez cirujano azul": [
    {
      "id": 34417,
      "keyword": "pez cirujano azul",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peces cirujanos azules": [
    {
      "id": 34417,
      "keyword": "pez cirujano azul",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arowana australiana": [
    {
      "id": 34429,
      "keyword": "arowana australiana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arowanas australianas": [
    {
      "id": 34429,
      "keyword": "arowana australiana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pez arquero": [
    {
      "id": 34431,
      "keyword": "pez arquero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peces arquero": [
    {
      "id": 34431,
      "keyword": "pez arquero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pez arlequín": [
    {
      "id": 34419,
      "keyword": "pez arlequín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peces arlequín": [
    {
      "id": 34419,
      "keyword": "pez arlequín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tití": [
    {
      "id": 34421,
      "keyword": "tití",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "titís": [
    {
      "id": 34421,
      "keyword": "tití",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "torvosaurus": [
    {
      "id": 34435,
      "keyword": "Torvosaurus",
      "keywords": 1,
      "type": 1,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rana arborícola": [
    {
      "id": 34415,
      "keyword": "rana arborícola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "amphibian",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ranas arborícolas": [
    {
      "id": 34415,
      "keyword": "rana arborícola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "amphibian",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cocodrilo del nilo": [
    {
      "id": 34433,
      "keyword": "cocodrilo del Nilo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cocodrilos del nilo": [
    {
      "id": 34433,
      "keyword": "cocodrilo del Nilo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tiburón bala": [
    {
      "id": 34423,
      "keyword": "tiburón bala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiburones bala": [
    {
      "id": 34423,
      "keyword": "tiburón bala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aragosaurus ischiaticus": [
    {
      "id": 34437,
      "keyword": "Aragosaurus ischiaticus",
      "keywords": 1,
      "type": 1,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadora de waterpolo": [
    {
      "id": 34449,
      "keyword": "jugadora de waterpolo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadoras de waterpolo": [
    {
      "id": 34449,
      "keyword": "jugadora de waterpolo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "brachiosaurus": [
    {
      "id": 34441,
      "keyword": "Brachiosaurus",
      "keywords": 1,
      "type": 1,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vehículo": [
    {
      "id": 34461,
      "keyword": "vehículo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vehículos": [
    {
      "id": 34461,
      "keyword": "vehículo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "baryonyx": [
    {
      "id": 34439,
      "keyword": "Baryonyx",
      "keywords": 1,
      "type": 1,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "batucada": [
    {
      "id": 34455,
      "keyword": "batucada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "batucadas": [
    {
      "id": 34455,
      "keyword": "batucada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cesto": [
    {
      "id": 34486,
      "keyword": "cesto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cestos": [
    {
      "id": 34486,
      "keyword": "cesto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encajable": [
    {
      "id": 34518,
      "keyword": "encajable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37448,
      "keyword": "encajable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encajables": [
    {
      "id": 34518,
      "keyword": "encajable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37448,
      "keyword": "encajable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bibliotecaria": [
    {
      "id": 34531,
      "keyword": "bibliotecaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bibliotecarias": [
    {
      "id": 34531,
      "keyword": "bibliotecaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "library science"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "continente": [
    {
      "id": 34547,
      "keyword": "continente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "political geography",
        "continent"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "continentes": [
    {
      "id": 34547,
      "keyword": "continente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "political geography",
        "continent"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "persona": [
    {
      "id": 34558,
      "keyword": "persona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 34558,
      "keyword": "persona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34560,
      "keyword": "persona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "core vocabulary"
      ],
      "noColor": true,
      "plural": false
    },
    {
      "id": 34560,
      "keyword": "persona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34559,
      "keyword": "persona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34557,
      "keyword": "persona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner el abrigo ": [
    {
      "id": 34569,
      "keyword": "poner el abrigo ",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "princesa de burundi": [
    {
      "id": 34571,
      "keyword": "Princesa de Burundi",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "princesas de burundi": [
    {
      "id": 34571,
      "keyword": "Princesa de Burundi",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cíclido frontosa": [
    {
      "id": 34573,
      "keyword": "cíclido frontosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cíclidos frontosa": [
    {
      "id": 34573,
      "keyword": "cíclido frontosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tiburón malayo": [
    {
      "id": 34575,
      "keyword": "tiburón malayo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiburones malayos": [
    {
      "id": 34575,
      "keyword": "tiburón malayo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "turiasaurus": [
    {
      "id": 34585,
      "keyword": "Turiasaurus",
      "keywords": 1,
      "type": 1,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tastavinsaurus": [
    {
      "id": 34579,
      "keyword": "Tastavinsaurus",
      "keywords": 1,
      "type": 1,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortuga cuello de serpiente": [
    {
      "id": 34589,
      "keyword": "tortuga cuello de serpiente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortugas cuello de serpiente": [
    {
      "id": 34589,
      "keyword": "tortuga cuello de serpiente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "triceratops": [
    {
      "id": 34593,
      "keyword": "Triceratops",
      "keywords": 1,
      "type": 1,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pez pulmonado": [
    {
      "id": 34583,
      "keyword": "pez pulmonado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peces pulmonados": [
    {
      "id": 34583,
      "keyword": "pez pulmonado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dacentrurus armatus": [
    {
      "id": 34595,
      "keyword": "Dacentrurus armatus",
      "keywords": 1,
      "type": 1,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "galápago europeo": [
    {
      "id": 34581,
      "keyword": "galápago europeo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "galápagos europeos": [
    {
      "id": 34581,
      "keyword": "galápago europeo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pacú negro": [
    {
      "id": 34599,
      "keyword": "pacú negro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pacús negros": [
    {
      "id": 34599,
      "keyword": "pacú negro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pez globo ocelado": [
    {
      "id": 34597,
      "keyword": "pez globo ocelado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peces globo ocelado": [
    {
      "id": 34597,
      "keyword": "pez globo ocelado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "echar nata montada": [
    {
      "id": 34603,
      "keyword": "echar nata montada",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "violación": [
    {
      "id": 34605,
      "keyword": "violación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "violaciones": [
    {
      "id": 34605,
      "keyword": "violación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "violar": [
    {
      "id": 34605,
      "keyword": "violar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "law",
        "crime",
        "sexual crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "proa valdearinnoensis": [
    {
      "id": 34587,
      "keyword": "Proa Valdearinnoensis",
      "keywords": 1,
      "type": 1,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavar la cara": [
    {
      "id": 34777,
      "keyword": "lavar la cara",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34611,
      "keyword": "lavar la cara",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34775,
      "keyword": "lavar la cara",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "médica de medicina nuclear": [
    {
      "id": 38850,
      "keyword": "médica de medicina nuclear",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34609,
      "keyword": "médica de medicina nuclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "médicas de medicina nuclear": [
    {
      "id": 38850,
      "keyword": "médica de medicina nuclear",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34609,
      "keyword": "médica de medicina nuclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "europelta carbonensis": [
    {
      "id": 34591,
      "keyword": "Europelta carbonensis",
      "keywords": 1,
      "type": 1,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tapar la cara ": [
    {
      "id": 34619,
      "keyword": "tapar la cara ",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pantalla estropeada": [
    {
      "id": 34621,
      "keyword": "pantalla estropeada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pantallas estropeadas": [
    {
      "id": 34621,
      "keyword": "pantalla estropeada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pez disco": [
    {
      "id": 34577,
      "keyword": "pez disco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "omnivorous",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peces disco": [
    {
      "id": 34577,
      "keyword": "pez disco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "omnivorous",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "raya": [
    {
      "id": 34627,
      "keyword": "raya",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "ovoviviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fenómeno atmosférico": [
    {
      "id": 34613,
      "keyword": "fenómeno atmosférico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fenómenos atmosféricos": [
    {
      "id": 34613,
      "keyword": "fenómeno atmosférico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34613,
      "keyword": "fenómenos atmosféricos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "concha": [
    {
      "id": 34625,
      "keyword": "concha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "signo ortográfico": [
    {
      "id": 34629,
      "keyword": "signo ortográfico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "signos ortográficos": [
    {
      "id": 34629,
      "keyword": "signo ortográfico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34629,
      "keyword": "signos ortográficos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "orthographic sign"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "utensilios de cocina": [
    {
      "id": 34631,
      "keyword": "utensilios de cocina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34631,
      "keyword": "utensilio de cocina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "utensilio de cocina": [
    {
      "id": 34631,
      "keyword": "utensilio de cocina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "extinción": [
    {
      "id": 34633,
      "keyword": "extinción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "paleontology",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "extinciones": [
    {
      "id": 34633,
      "keyword": "extinción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "paleontology",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desvestida": [
    {
      "id": 34635,
      "keyword": "desvestida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desvestidas": [
    {
      "id": 34635,
      "keyword": "desvestida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desvestido": [
    {
      "id": 34637,
      "keyword": "desvestido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desvestidos": [
    {
      "id": 34637,
      "keyword": "desvestido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "empatizar": [
    {
      "id": 34647,
      "keyword": "empatizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arapaima": [
    {
      "id": 34601,
      "keyword": "arapaima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arapaimas": [
    {
      "id": 34601,
      "keyword": "arapaima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bajar la mesa del asiento delantero": [
    {
      "id": 34649,
      "keyword": "bajar la mesa del asiento delantero",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salidas de emergencia": [
    {
      "id": 34651,
      "keyword": "salidas de emergencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38245,
      "keyword": "salida de emergencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "echar sirope de chocolate": [
    {
      "id": 34615,
      "keyword": "echar sirope de chocolate",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "número par": [
    {
      "id": 34643,
      "keyword": "número par",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "números pares": [
    {
      "id": 34643,
      "keyword": "número par",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34643,
      "keyword": "números pares",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "médico de medicina nuclear": [
    {
      "id": 38850,
      "keyword": "médico de medicina nuclear",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34653,
      "keyword": "médico de medicina nuclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "médicos de medicina nuclear": [
    {
      "id": 38850,
      "keyword": "médico de medicina nuclear",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34653,
      "keyword": "médico de medicina nuclear",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guardar debajo del asiento": [
    {
      "id": 34665,
      "keyword": "guardar debajo del asiento",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meter la maleta en el portaequipajes": [
    {
      "id": 34661,
      "keyword": "meter la maleta en el portaequipajes",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meter la valija en el portaequipajes": [
    {
      "id": 34661,
      "keyword": "meter la valija en el portaequipajes",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrocharse el cinturón": [
    {
      "id": 34663,
      "keyword": "abrocharse el cinturón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir la mesa del asiento delantero": [
    {
      "id": 34667,
      "keyword": "subir la mesa del asiento delantero",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "levantar la lengüeta del cinturón de seguridad": [
    {
      "id": 34659,
      "keyword": "levantar la lengüeta del cinturón de seguridad",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "solicitar consentimiento": [
    {
      "id": 34675,
      "keyword": "solicitar consentimiento",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "sexuality",
        "sexual practice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espectáculo t-rex": [
    {
      "id": 34673,
      "keyword": "espectáculo T-Rex",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guardar debajo del asiento delantero": [
    {
      "id": 34657,
      "keyword": "guardar debajo del asiento delantero",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reclinar el asiento": [
    {
      "id": 34681,
      "keyword": "reclinar el asiento",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir el asiento": [
    {
      "id": 34679,
      "keyword": "subir el asiento",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tobogán inflable": [
    {
      "id": 34687,
      "keyword": "tobogán inflable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toboganes inflables": [
    {
      "id": 34687,
      "keyword": "tobogán inflable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "revista pornográfica": [
    {
      "id": 34693,
      "keyword": "revista pornográfica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "publication",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "revistas pornográficas": [
    {
      "id": 34693,
      "keyword": "revista pornográfica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "publication",
        "sexuality"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "solicitar permiso": [
    {
      "id": 34697,
      "keyword": "solicitar permiso",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "capa de peluquería": [
    {
      "id": 34701,
      "keyword": "capa de peluquería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "capas de peluquería": [
    {
      "id": 34701,
      "keyword": "capa de peluquería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "modo avión": [
    {
      "id": 34685,
      "keyword": "modo avión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "altura correcta": [
    {
      "id": 34703,
      "keyword": "altura correcta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alturas correctas": [
    {
      "id": 34703,
      "keyword": "altura correcta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "instrucciones": [
    {
      "id": 34705,
      "keyword": "instrucciones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34755,
      "keyword": "instrucciones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gastroenteróloga": [
    {
      "id": 38851,
      "keyword": "gastroenteróloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34719,
      "keyword": "gastroenteróloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gastroenterólogas": [
    {
      "id": 38851,
      "keyword": "gastroenteróloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34719,
      "keyword": "gastroenteróloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gastroenterólogo": [
    {
      "id": 38851,
      "keyword": "gastroenterólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34721,
      "keyword": "gastroenterólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gastroenterólogos": [
    {
      "id": 38851,
      "keyword": "gastroenterólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34721,
      "keyword": "gastroenterólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "endocrinóloga": [
    {
      "id": 38849,
      "keyword": "endocrinóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "endocrine system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34723,
      "keyword": "endocrinóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "endocrine system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "endocrinólogas": [
    {
      "id": 38849,
      "keyword": "endocrinóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "endocrine system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34723,
      "keyword": "endocrinóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "endocrine system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarjeta sanitaria": [
    {
      "id": 34717,
      "keyword": "tarjeta sanitaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "supporting document",
        "medicine",
        "health"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36729,
      "keyword": "tarjeta sanitaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "medicine",
        "supporting document",
        "health"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36730,
      "keyword": "tarjeta sanitaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "medicine",
        "supporting document",
        "health"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarjetas sanitarias": [
    {
      "id": 34717,
      "keyword": "tarjeta sanitaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "supporting document",
        "medicine",
        "health"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36729,
      "keyword": "tarjeta sanitaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "medicine",
        "supporting document",
        "health"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36730,
      "keyword": "tarjeta sanitaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "medicine",
        "supporting document",
        "health"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "endocrinólogo": [
    {
      "id": 38849,
      "keyword": "endocrinólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "endocrine system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34725,
      "keyword": "endocrinólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "endocrine system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "endocrinólogos": [
    {
      "id": 38849,
      "keyword": "endocrinólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "endocrine system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34725,
      "keyword": "endocrinólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "endocrine system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oncóloga": [
    {
      "id": 38848,
      "keyword": "oncóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34729,
      "keyword": "oncóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oncólogas": [
    {
      "id": 38848,
      "keyword": "oncóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34729,
      "keyword": "oncóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oncólogo": [
    {
      "id": 38848,
      "keyword": "oncólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34727,
      "keyword": "oncólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oncólogos": [
    {
      "id": 38848,
      "keyword": "oncólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34727,
      "keyword": "oncólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cambio de turno": [
    {
      "id": 34713,
      "keyword": "cambio de turno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "sport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cambios de turno": [
    {
      "id": 34713,
      "keyword": "cambio de turno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "sport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "otorrinolaringóloga": [
    {
      "id": 38847,
      "keyword": "otorrinolaringóloga",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34731,
      "keyword": "otorrinolaringóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "otorrinolaringólogas": [
    {
      "id": 38847,
      "keyword": "otorrinolaringóloga",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34731,
      "keyword": "otorrinolaringóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "otorrina": [
    {
      "id": 38847,
      "keyword": "otorrina",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34731,
      "keyword": "otorrina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "otorrinas": [
    {
      "id": 38847,
      "keyword": "otorrina",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34731,
      "keyword": "otorrina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "otorrinolaringólogo": [
    {
      "id": 38847,
      "keyword": "otorrinolaringólogo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34733,
      "keyword": "otorrinolaringólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "otorrinolaringólogos": [
    {
      "id": 38847,
      "keyword": "otorrinolaringólogo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34733,
      "keyword": "otorrinolaringólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "otorrino": [
    {
      "id": 38847,
      "keyword": "otorrino",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34733,
      "keyword": "otorrino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "otorrinos": [
    {
      "id": 38847,
      "keyword": "otorrino",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34733,
      "keyword": "otorrino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sirope de chocolate": [
    {
      "id": 34747,
      "keyword": "sirope de chocolate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cosmético": [
    {
      "id": 34741,
      "keyword": "cosmético",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cosméticos": [
    {
      "id": 34741,
      "keyword": "cosmético",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34741,
      "keyword": "cosméticos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vestida": [
    {
      "id": 34735,
      "keyword": "vestida",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vestidas": [
    {
      "id": 34735,
      "keyword": "vestida",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clase de ética y valores": [
    {
      "id": 34709,
      "keyword": "clase de ética y valores",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de ética y valores": [
    {
      "id": 34709,
      "keyword": "clase de ética y valores",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de moda": [
    {
      "id": 34711,
      "keyword": "tienda de moda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de moda": [
    {
      "id": 34711,
      "keyword": "tienda de moda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aeroplano": [
    {
      "id": 34757,
      "keyword": "aeroplano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aeroplanos": [
    {
      "id": 34757,
      "keyword": "aeroplano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34757,
      "keyword": "aeroplanos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "artista": [
    {
      "id": 34767,
      "keyword": "artista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "artistas": [
    {
      "id": 34767,
      "keyword": "artista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34767,
      "keyword": "artistas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carácter": [
    {
      "id": 34769,
      "keyword": "carácter",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carácteres": [
    {
      "id": 34769,
      "keyword": "carácter",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34769,
      "keyword": "carácteres",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "número impar": [
    {
      "id": 34773,
      "keyword": "número impar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "números impares": [
    {
      "id": 34773,
      "keyword": "número impar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34773,
      "keyword": "números impares",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "number",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cereal": [
    {
      "id": 34749,
      "keyword": "cereal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "cereal",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reglamento": [
    {
      "id": 34779,
      "keyword": "reglamento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reglamentos": [
    {
      "id": 34779,
      "keyword": "reglamento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "director de escuela": [
    {
      "id": 34782,
      "keyword": "director de escuela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "directores de escuela": [
    {
      "id": 34782,
      "keyword": "director de escuela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "directora de escuela": [
    {
      "id": 34782,
      "keyword": "directora de escuela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "directoras de escuela": [
    {
      "id": 34782,
      "keyword": "directora de escuela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "árboles frutales": [
    {
      "id": 34753,
      "keyword": "árboles frutales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34753,
      "keyword": "árbol frutal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "árbol frutal": [
    {
      "id": 34753,
      "keyword": "árbol frutal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prestar un libro": [
    {
      "id": 34790,
      "keyword": "prestar un libro",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "normas": [
    {
      "id": 34794,
      "keyword": "normas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "education",
        "information document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reescribir": [
    {
      "id": 34792,
      "keyword": "reescribir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asignaturas": [
    {
      "id": 34796,
      "keyword": "asignaturas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34796,
      "keyword": "asignatura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asignatura": [
    {
      "id": 34796,
      "keyword": "asignatura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fecha": [
    {
      "id": 34799,
      "keyword": "fecha",
      "keywords": 1,
      "type": 6,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34803,
      "keyword": "fecha",
      "keywords": 1,
      "type": 6,
      "tags": [
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de gallego": [
    {
      "id": 34798,
      "keyword": "clase de gallego",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desabrochar el cinturón": [
    {
      "id": 34761,
      "keyword": "desabrochar el cinturón",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nata montada": [
    {
      "id": 34763,
      "keyword": "nata montada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "duración de la actividad": [
    {
      "id": 34805,
      "keyword": "duración de la actividad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "catástrofe": [
    {
      "id": 34765,
      "keyword": "catástrofe",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "catástrofes": [
    {
      "id": 34765,
      "keyword": "catástrofe",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34765,
      "keyword": "catástrofes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "selfi": [
    {
      "id": 34809,
      "keyword": "selfi",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "selfis": [
    {
      "id": 34809,
      "keyword": "selfi",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hacer un selfi": [
    {
      "id": 37664,
      "keyword": "hacer un selfi",
      "keywords": 1,
      "type": 3,
      "tags": [
        "visual art",
        "photography",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34809,
      "keyword": "hacer un selfi",
      "keywords": 2,
      "type": 3,
      "tags": [
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tapar los ojos": [
    {
      "id": 34822,
      "keyword": "tapar los ojos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34819,
      "keyword": "tapar los ojos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34818,
      "keyword": "tapar los ojos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesa de luz": [
    {
      "id": 34801,
      "keyword": "mesa de luz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas de luz": [
    {
      "id": 34801,
      "keyword": "mesa de luz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "amazona": [
    {
      "id": 34834,
      "keyword": "amazona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "horse riding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "amazonas": [
    {
      "id": 34834,
      "keyword": "amazona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "horse riding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sumergir": [
    {
      "id": 34828,
      "keyword": "sumergir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vaquillera": [
    {
      "id": 34838,
      "keyword": "vaquillera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume",
        "Aragon",
        "Teruel"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vaquilleras": [
    {
      "id": 34838,
      "keyword": "vaquillera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume",
        "Aragon",
        "Teruel"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vaquillero": [
    {
      "id": 34836,
      "keyword": "vaquillero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume",
        "Aragon",
        "Teruel"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vaquilleros": [
    {
      "id": 34836,
      "keyword": "vaquillero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume",
        "Aragon",
        "Teruel"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "galopar": [
    {
      "id": 34832,
      "keyword": "galopar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "animal physiology",
        "leisure",
        "sport",
        "horse riding",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meter la mano en la boca": [
    {
      "id": 34848,
      "keyword": "meter la mano en la boca",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carrera de caballos": [
    {
      "id": 34830,
      "keyword": "carrera de caballos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "event",
        "sport event",
        "animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carreras de caballos": [
    {
      "id": 34830,
      "keyword": "carrera de caballos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "horse riding",
        "event",
        "sport event",
        "animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "préstamo": [
    {
      "id": 34814,
      "keyword": "préstamo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "préstamos": [
    {
      "id": 34814,
      "keyword": "préstamo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espiar por la cerradura": [
    {
      "id": 34854,
      "keyword": "espiar por la cerradura",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "golpear el cristal": [
    {
      "id": 34816,
      "keyword": "golpear el cristal",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trapo": [
    {
      "id": 34862,
      "keyword": "trapo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trapos": [
    {
      "id": 34862,
      "keyword": "trapo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rapaz": [
    {
      "id": 34860,
      "keyword": "rapaz",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "animal physiology",
        "vertebrate",
        "bird",
        "categorization",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rapaces": [
    {
      "id": 34860,
      "keyword": "rapaz",
      "keywords": 2,
      "type": 4,
      "tags": [
        "animal",
        "animal physiology",
        "vertebrate",
        "bird",
        "categorization",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34860,
      "keyword": "rapaces",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "animal physiology",
        "vertebrate",
        "bird",
        "categorization",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calefacción": [
    {
      "id": 34872,
      "keyword": "calefacción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calefacciones": [
    {
      "id": 34872,
      "keyword": "calefacción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "planificación": [
    {
      "id": 34870,
      "keyword": "planificación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38846,
      "keyword": "planificación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "planificaciones": [
    {
      "id": 34870,
      "keyword": "planificación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lendrera": [
    {
      "id": 34874,
      "keyword": "lendrera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lendreras": [
    {
      "id": 34874,
      "keyword": "lendrera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de menaje": [
    {
      "id": 34882,
      "keyword": "tienda de menaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "household",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de menaje": [
    {
      "id": 34882,
      "keyword": "tienda de menaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "household",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de alquiler de coches": [
    {
      "id": 34880,
      "keyword": "tienda de alquiler de coches",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de alquiler de coches": [
    {
      "id": 34880,
      "keyword": "tienda de alquiler de coches",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de ropa infantil": [
    {
      "id": 34884,
      "keyword": "tienda de ropa infantil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de ropa infantil": [
    {
      "id": 34884,
      "keyword": "tienda de ropa infantil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de rótulos": [
    {
      "id": 34886,
      "keyword": "tienda de rótulos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de rótulos": [
    {
      "id": 34886,
      "keyword": "tienda de rótulos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "haba del roscón": [
    {
      "id": 34888,
      "keyword": "haba del roscón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "habas del roscón": [
    {
      "id": 34888,
      "keyword": "haba del roscón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "haba seca": [
    {
      "id": 34890,
      "keyword": "haba seca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "habas secas": [
    {
      "id": 34890,
      "keyword": "haba seca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "haber una tormenta": [
    {
      "id": 34892,
      "keyword": "haber una tormenta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anciana": [
    {
      "id": 34894,
      "keyword": "anciana",
      "keywords": 3,
      "type": 4,
      "tags": [
        "person",
        "elderly"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ancianas": [
    {
      "id": 34894,
      "keyword": "anciana",
      "keywords": 3,
      "type": 4,
      "tags": [
        "person",
        "elderly"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "baño árabe": [
    {
      "id": 34902,
      "keyword": "baño árabe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baños árabes": [
    {
      "id": 34902,
      "keyword": "baño árabe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bajar por el tobogán inflable": [
    {
      "id": 34900,
      "keyword": "bajar por el tobogán inflable",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ecocardiograma": [
    {
      "id": 34904,
      "keyword": "ecocardiograma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ecocardiogramas": [
    {
      "id": 34904,
      "keyword": "ecocardiograma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "roedor": [
    {
      "id": 34864,
      "keyword": "roedor",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "animal physiology",
        "vertebrate",
        "mammal",
        "herbivorous",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34864,
      "keyword": "roedor",
      "keywords": 4,
      "type": 4,
      "tags": [
        "animal",
        "animal physiology",
        "vertebrate",
        "mammal",
        "herbivorous",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "roedores": [
    {
      "id": 34864,
      "keyword": "roedor",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "animal physiology",
        "vertebrate",
        "mammal",
        "herbivorous",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34864,
      "keyword": "roedores",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "animal physiology",
        "vertebrate",
        "mammal",
        "herbivorous",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34864,
      "keyword": "roedor",
      "keywords": 4,
      "type": 4,
      "tags": [
        "animal",
        "animal physiology",
        "vertebrate",
        "mammal",
        "herbivorous",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "roedora": [
    {
      "id": 34864,
      "keyword": "roedora",
      "keywords": 4,
      "type": 4,
      "tags": [
        "animal",
        "animal physiology",
        "vertebrate",
        "mammal",
        "herbivorous",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "roedoras": [
    {
      "id": 34864,
      "keyword": "roedora",
      "keywords": 4,
      "type": 4,
      "tags": [
        "animal",
        "animal physiology",
        "vertebrate",
        "mammal",
        "herbivorous",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "superponer": [
    {
      "id": 34868,
      "keyword": "superponer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "color",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34866,
      "keyword": "superponer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pantalla rota": [
    {
      "id": 34908,
      "keyword": "pantalla rota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pantallas rotas": [
    {
      "id": 34908,
      "keyword": "pantalla rota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugadora de bádminton": [
    {
      "id": 34922,
      "keyword": "jugadora de bádminton",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadoras de bádminton": [
    {
      "id": 34922,
      "keyword": "jugadora de bádminton",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "intromisión en la intimidad": [
    {
      "id": 34925,
      "keyword": "intromisión en la intimidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intromisiones en la intimidad": [
    {
      "id": 34925,
      "keyword": "intromisión en la intimidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diego de marcilla": [
    {
      "id": 34927,
      "keyword": "Diego de Marcilla",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "isabel de segura": [
    {
      "id": 34929,
      "keyword": "Isabel de Segura",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dispositivo móvil": [
    {
      "id": 34906,
      "keyword": "dispositivo móvil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dispositivos móviles": [
    {
      "id": 34906,
      "keyword": "dispositivo móvil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34906,
      "keyword": "dispositivos móviles",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "batería agotada": [
    {
      "id": 34910,
      "keyword": "batería agotada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baterías agotadas": [
    {
      "id": 34910,
      "keyword": "batería agotada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pedro de segura": [
    {
      "id": 34931,
      "keyword": "Pedro de Segura",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "batalla": [
    {
      "id": 34937,
      "keyword": "batalla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "middle ages",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "batallas": [
    {
      "id": 34937,
      "keyword": "batalla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "middle ages",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cargar la batería": [
    {
      "id": 34939,
      "keyword": "cargar la batería",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38333,
      "keyword": "cargar la batería",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recargar la batería": [
    {
      "id": 34939,
      "keyword": "recargar la batería",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38333,
      "keyword": "recargar la batería",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "río amazonas": [
    {
      "id": 34941,
      "keyword": "río Amazonas",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "río mekong": [
    {
      "id": 34943,
      "keyword": "río Mekong",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terrario": [
    {
      "id": 34946,
      "keyword": "terrario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terrarios": [
    {
      "id": 34946,
      "keyword": "terrario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "placas de dinosaurio": [
    {
      "id": 34949,
      "keyword": "placas de dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "garras de dinosaurio": [
    {
      "id": 34951,
      "keyword": "garras de dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "isabel y diego": [
    {
      "id": 34935,
      "keyword": "Isabel y Diego",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuello de dinosaurio": [
    {
      "id": 34953,
      "keyword": "cuello de dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34957,
      "keyword": "cuello de dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuellos de dinosaurio": [
    {
      "id": 34953,
      "keyword": "cuello de dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34957,
      "keyword": "cuello de dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dientes de dinosaurio": [
    {
      "id": 34959,
      "keyword": "dientes de dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brazos de dinosaurio": [
    {
      "id": 34945,
      "keyword": "brazos de dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espumadera": [
    {
      "id": 34916,
      "keyword": "espumadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espumaderas": [
    {
      "id": 34916,
      "keyword": "espumadera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alquiler de bicicletas": [
    {
      "id": 34918,
      "keyword": "alquiler de bicicletas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alquileres de bicicletas": [
    {
      "id": 34918,
      "keyword": "alquiler de bicicletas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vértebras de dinosaurio": [
    {
      "id": 34963,
      "keyword": "vértebras de dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadora de baloncesto": [
    {
      "id": 34920,
      "keyword": "jugadora de baloncesto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadoras de baloncesto": [
    {
      "id": 34920,
      "keyword": "jugadora de baloncesto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "basketball"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cráneo de triceratops": [
    {
      "id": 34967,
      "keyword": "cráneo de triceratops",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "fossil",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cráneos de triceratops": [
    {
      "id": 34967,
      "keyword": "cráneo de triceratops",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "fossil",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fósil de vértebras de dinosaruio": [
    {
      "id": 34965,
      "keyword": "fósil de vértebras de dinosaruio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "fossil",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fósiles de vértebras de dinosaruio": [
    {
      "id": 34965,
      "keyword": "fósil de vértebras de dinosaruio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "fossil",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cráneo de tyrannosaurus rex": [
    {
      "id": 34969,
      "keyword": "cráneo de Tyrannosaurus Rex",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "fossil",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cráneos de tyrannosaurus rex": [
    {
      "id": 34969,
      "keyword": "cráneo de Tyrannosaurus Rex",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "fossil",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huella de dinosaurio": [
    {
      "id": 34975,
      "keyword": "huella de dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34974,
      "keyword": "huella de dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34976,
      "keyword": "huella de dinosaurio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34973,
      "keyword": "huella de dinosaurio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huellas de dinosaurio": [
    {
      "id": 34975,
      "keyword": "huella de dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34974,
      "keyword": "huella de dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34976,
      "keyword": "huella de dinosaurio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34973,
      "keyword": "huella de dinosaurio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34985,
      "keyword": "huellas de dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "fossil",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pedro de azagra": [
    {
      "id": 34933,
      "keyword": "Pedro de Azagra",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cola de dinosaurio": [
    {
      "id": 34961,
      "keyword": "cola de dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colas de dinosaurio": [
    {
      "id": 34961,
      "keyword": "cola de dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tyrannosaurus rex": [
    {
      "id": 34981,
      "keyword": "Tyrannosaurus Rex",
      "keywords": 1,
      "type": 1,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nido de dinosaurios": [
    {
      "id": 34987,
      "keyword": "nido de dinosaurios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nidos de dinosaurios": [
    {
      "id": 34987,
      "keyword": "nido de dinosaurios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "patas de dinosaurio": [
    {
      "id": 34971,
      "keyword": "patas de dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "imagen 3d": [
    {
      "id": 34995,
      "keyword": "imagen 3d",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "drawing",
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "imágenes 3d": [
    {
      "id": 34995,
      "keyword": "imagen 3d",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "drawing",
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cine 3d": [
    {
      "id": 34997,
      "keyword": "cine 3d",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cines 3d": [
    {
      "id": 34997,
      "keyword": "cine 3d",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cazador prehistórico": [
    {
      "id": 38591,
      "keyword": "cazador prehistórico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 34991,
      "keyword": "cazador prehistórico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cazadores prehistóricos": [
    {
      "id": 38591,
      "keyword": "cazador prehistórico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 34991,
      "keyword": "cazador prehistórico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "iguanodón galvensis": [
    {
      "id": 34983,
      "keyword": "Iguanodón galvensis",
      "keywords": 1,
      "type": 1,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parque de dinosaurios": [
    {
      "id": 35005,
      "keyword": "parque de dinosaurios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility",
        "paleontology",
        "animal",
        "extinct being",
        "dinosaur"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35006,
      "keyword": "parque de dinosaurios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility",
        "paleontology",
        "animal",
        "extinct being",
        "dinosaur"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parques de dinosaurios": [
    {
      "id": 35005,
      "keyword": "parque de dinosaurios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility",
        "paleontology",
        "animal",
        "extinct being",
        "dinosaur"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35006,
      "keyword": "parque de dinosaurios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility",
        "paleontology",
        "animal",
        "extinct being",
        "dinosaur"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carrusel sauriopark": [
    {
      "id": 35013,
      "keyword": "carrusel sauriopark",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yacimiento paleontológico": [
    {
      "id": 35009,
      "keyword": "yacimiento paleontológico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "paleontology",
        "place",
        "workplace"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yacimientos paleontológicos": [
    {
      "id": 35009,
      "keyword": "yacimiento paleontológico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "paleontology",
        "place",
        "workplace"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peluche de dinosaurio": [
    {
      "id": 34989,
      "keyword": "peluche de dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peluches de dinosaurio": [
    {
      "id": 34989,
      "keyword": "peluche de dinosaurio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atracción de troncomóviles": [
    {
      "id": 35011,
      "keyword": "atracción de troncomóviles",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botas camperas": [
    {
      "id": 35025,
      "keyword": "botas camperas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bach": [
    {
      "id": 35023,
      "keyword": "Bach",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "impacto": [
    {
      "id": 35003,
      "keyword": "impacto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "impactos": [
    {
      "id": 35003,
      "keyword": "impacto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caracola": [
    {
      "id": 35035,
      "keyword": "caracola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caracolas": [
    {
      "id": 35035,
      "keyword": "caracola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39076,
      "keyword": "caracolas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hardware": [
    {
      "id": 35027,
      "keyword": "hardware",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rebanada": [
    {
      "id": 35045,
      "keyword": "rebanada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tórtola": [
    {
      "id": 35053,
      "keyword": "tórtola",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tórtolas": [
    {
      "id": 35053,
      "keyword": "tórtola",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tórtolo": [
    {
      "id": 35053,
      "keyword": "tórtolo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tórtolos": [
    {
      "id": 35053,
      "keyword": "tórtolo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "culebra": [
    {
      "id": 35051,
      "keyword": "culebra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "culebras": [
    {
      "id": 35051,
      "keyword": "culebra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nautilus": [
    {
      "id": 35055,
      "keyword": "nautilus",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niebla": [
    {
      "id": 35049,
      "keyword": "niebla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nieblas": [
    {
      "id": 35049,
      "keyword": "niebla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "beethoven": [
    {
      "id": 35057,
      "keyword": "Beethoven",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arasaac": [
    {
      "id": 35071,
      "keyword": "ARASAAC",
      "keywords": 1,
      "type": 1,
      "tags": [
        "communication",
        "augmentative communication",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "astro": [
    {
      "id": 35073,
      "keyword": "astro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "astros": [
    {
      "id": 35073,
      "keyword": "astro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35073,
      "keyword": "astros",
      "keywords": 2,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escultora": [
    {
      "id": 35081,
      "keyword": "escultora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "sculpture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escultoras": [
    {
      "id": 35081,
      "keyword": "escultora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "sculpture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "herrar": [
    {
      "id": 35089,
      "keyword": "herrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "horse riding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35088,
      "keyword": "herrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "horse riding"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35087,
      "keyword": "herrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "horse riding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escultor": [
    {
      "id": 35077,
      "keyword": "escultor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "sculpture"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35078,
      "keyword": "escultor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "sculpture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escultores": [
    {
      "id": 35077,
      "keyword": "escultor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "sculpture"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35078,
      "keyword": "escultor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "visual art",
        "sculpture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mapa conceptual": [
    {
      "id": 35075,
      "keyword": "mapa conceptual",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38143,
      "keyword": "mapa conceptual",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mapas conceptuales": [
    {
      "id": 35075,
      "keyword": "mapa conceptual",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38143,
      "keyword": "mapa conceptual",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fez": [
    {
      "id": 35109,
      "keyword": "fez",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paseo": [
    {
      "id": 35111,
      "keyword": "paseo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35112,
      "keyword": "paseo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paseos": [
    {
      "id": 35111,
      "keyword": "paseo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35112,
      "keyword": "paseo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jaima": [
    {
      "id": 35119,
      "keyword": "jaima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jaimas": [
    {
      "id": 35119,
      "keyword": "jaima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acreditar": [
    {
      "id": 35097,
      "keyword": "acreditar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ambulatorio": [
    {
      "id": 35121,
      "keyword": "ambulatorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ambulatorios": [
    {
      "id": 35121,
      "keyword": "ambulatorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "granizar": [
    {
      "id": 35105,
      "keyword": "granizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tablero de ajedrez": [
    {
      "id": 35129,
      "keyword": "tablero de ajedrez",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "chess"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tableros de ajedrez": [
    {
      "id": 35129,
      "keyword": "tablero de ajedrez",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "chess"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "temporizador": [
    {
      "id": 37659,
      "keyword": "temporizador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "time",
        "chronological device",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35127,
      "keyword": "temporizador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "temporizadores": [
    {
      "id": 37659,
      "keyword": "temporizador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "time",
        "chronological device",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35127,
      "keyword": "temporizador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abrecartas": [
    {
      "id": 35115,
      "keyword": "abrecartas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsa sensorial": [
    {
      "id": 35131,
      "keyword": "bolsa sensorial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas sensoriales": [
    {
      "id": 35131,
      "keyword": "bolsa sensorial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "consulta": [
    {
      "id": 35139,
      "keyword": "consulta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35337,
      "keyword": "consulta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38881,
      "keyword": "consulta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38877,
      "keyword": "consulta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38870,
      "keyword": "consulta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "consultas": [
    {
      "id": 35139,
      "keyword": "consulta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35337,
      "keyword": "consulta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38881,
      "keyword": "consulta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38877,
      "keyword": "consulta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38870,
      "keyword": "consulta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tornillo y tuerca": [
    {
      "id": 35125,
      "keyword": "tornillo y tuerca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tornillos y tuercas": [
    {
      "id": 35125,
      "keyword": "tornillo y tuerca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anacardos": [
    {
      "id": 35141,
      "keyword": "anacardos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "dried fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "photocall": [
    {
      "id": 35149,
      "keyword": "photocall",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "photocalls": [
    {
      "id": 35149,
      "keyword": "photocall",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bayas": [
    {
      "id": 35145,
      "keyword": "bayas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "filete": [
    {
      "id": 35147,
      "keyword": "filete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "filetes": [
    {
      "id": 35147,
      "keyword": "filete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tomate de pera": [
    {
      "id": 35151,
      "keyword": "tomate de pera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomates de pera": [
    {
      "id": 35151,
      "keyword": "tomate de pera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "onomástica": [
    {
      "id": 35155,
      "keyword": "onomástica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "religious event",
        "religion",
        "christianity",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "onomásticas": [
    {
      "id": 35155,
      "keyword": "onomástica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "religious event",
        "religion",
        "christianity",
        "popular event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "piel de plátano": [
    {
      "id": 35159,
      "keyword": "piel de plátano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pieles de plátano": [
    {
      "id": 35159,
      "keyword": "piel de plátano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "loncha": [
    {
      "id": 35163,
      "keyword": "loncha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lonchas": [
    {
      "id": 35163,
      "keyword": "loncha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35163,
      "keyword": "lonchas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillón odontológico": [
    {
      "id": 35173,
      "keyword": "sillón odontológico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillones odontológicos": [
    {
      "id": 35173,
      "keyword": "sillón odontológico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agente": [
    {
      "id": 35133,
      "keyword": "agente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agentes": [
    {
      "id": 35133,
      "keyword": "agente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recursos humanos": [
    {
      "id": 35177,
      "keyword": "recursos humanos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asesoría jurídica": [
    {
      "id": 35179,
      "keyword": "asesoría jurídica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "consultancy",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asesorías jurídicas": [
    {
      "id": 35179,
      "keyword": "asesoría jurídica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "consultancy",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escupidera": [
    {
      "id": 35171,
      "keyword": "escupidera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escupideras": [
    {
      "id": 35171,
      "keyword": "escupidera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "igualdad de género": [
    {
      "id": 35183,
      "keyword": "igualdad de género",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35184,
      "keyword": "igualdad de género",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortilla de atún": [
    {
      "id": 35135,
      "keyword": "tortilla de atún",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortillas de atún": [
    {
      "id": 35135,
      "keyword": "tortilla de atún",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coordinador": [
    {
      "id": 35167,
      "keyword": "coordinador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coordinadores": [
    {
      "id": 35167,
      "keyword": "coordinador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aula maker": [
    {
      "id": 35169,
      "keyword": "aula maker",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aulas maker": [
    {
      "id": 35169,
      "keyword": "aula maker",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inspección urbanística": [
    {
      "id": 35175,
      "keyword": "inspección urbanística",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inspecciones urbanísticas": [
    {
      "id": 35175,
      "keyword": "inspección urbanística",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plano urbano": [
    {
      "id": 35181,
      "keyword": "plano urbano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "planos urbanos": [
    {
      "id": 35181,
      "keyword": "plano urbano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abrir la valla": [
    {
      "id": 35193,
      "keyword": "abrir la valla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saltar la valla": [
    {
      "id": 35189,
      "keyword": "saltar la valla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "choque de pecho": [
    {
      "id": 35195,
      "keyword": "choque de pecho",
      "keywords": 1,
      "type": 5,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "padres adoptivos": [
    {
      "id": 35201,
      "keyword": "padres adoptivos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chocar los cinco": [
    {
      "id": 35197,
      "keyword": "chocar los cinco",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esperar en fila": [
    {
      "id": 35187,
      "keyword": "esperar en fila",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36391,
      "keyword": "esperar en fila",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36845,
      "keyword": "esperar en fila",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer pis sentado": [
    {
      "id": 35211,
      "keyword": "hacer pis sentado",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orinar sentado": [
    {
      "id": 35211,
      "keyword": "orinar sentado",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "helado": [
    {
      "id": 35209,
      "keyword": "helado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "helados": [
    {
      "id": 35209,
      "keyword": "helado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "summer"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35209,
      "keyword": "helados",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir al tobogán": [
    {
      "id": 35203,
      "keyword": "subir al tobogán",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jeringa aire-agua": [
    {
      "id": 35217,
      "keyword": "jeringa aire-agua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jeringas aire-agua": [
    {
      "id": 35217,
      "keyword": "jeringa aire-agua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jeringa multifunción": [
    {
      "id": 35217,
      "keyword": "jeringa multifunción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jeringas multifunción": [
    {
      "id": 35217,
      "keyword": "jeringa multifunción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "eyector dental": [
    {
      "id": 35213,
      "keyword": "eyector dental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "eyectores dentales": [
    {
      "id": 35213,
      "keyword": "eyector dental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aspirador dental": [
    {
      "id": 35213,
      "keyword": "aspirador dental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aspiradores dentales": [
    {
      "id": 35213,
      "keyword": "aspirador dental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espejo dental": [
    {
      "id": 35221,
      "keyword": "espejo dental",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espejos dentales": [
    {
      "id": 35221,
      "keyword": "espejo dental",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espejo odontológico": [
    {
      "id": 35221,
      "keyword": "espejo odontológico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espejos odontológicos": [
    {
      "id": 35221,
      "keyword": "espejo odontológico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "subir a una atracción": [
    {
      "id": 35205,
      "keyword": "subir a una atracción",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "explorador dental": [
    {
      "id": 35223,
      "keyword": "explorador dental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exploradores dentales": [
    {
      "id": 35223,
      "keyword": "explorador dental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sonda dental": [
    {
      "id": 35223,
      "keyword": "sonda dental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sondas dentales": [
    {
      "id": 35223,
      "keyword": "sonda dental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bajar de una atracción": [
    {
      "id": 35207,
      "keyword": "bajar de una atracción",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juego de las anillas": [
    {
      "id": 35231,
      "keyword": "juego de las anillas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos de las anillas": [
    {
      "id": 35231,
      "keyword": "juego de las anillas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hematología": [
    {
      "id": 35233,
      "keyword": "hematología",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner de pie": [
    {
      "id": 35229,
      "keyword": "poner de pie",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38991,
      "keyword": "poner de pie",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lámpara dental": [
    {
      "id": 35225,
      "keyword": "lámpara dental",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lámparas dentales": [
    {
      "id": 35225,
      "keyword": "lámpara dental",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sacar los brazos": [
    {
      "id": 35227,
      "keyword": "sacar los brazos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "turbina dental": [
    {
      "id": 35219,
      "keyword": "turbina dental",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "turbinas dentales": [
    {
      "id": 35219,
      "keyword": "turbina dental",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "uróloga": [
    {
      "id": 38829,
      "keyword": "uróloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "excretory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35273,
      "keyword": "uróloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "excretory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "urólogas": [
    {
      "id": 38829,
      "keyword": "uróloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "excretory system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35273,
      "keyword": "uróloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "excretory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "urólogo": [
    {
      "id": 38829,
      "keyword": "urólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "excretory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35275,
      "keyword": "urólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "excretory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "urólogos": [
    {
      "id": 38829,
      "keyword": "urólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "excretory system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35275,
      "keyword": "urólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "excretory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ginecóloga": [
    {
      "id": 38839,
      "keyword": "ginecóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "gynecology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35283,
      "keyword": "ginecóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "gynecology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ginecólogas": [
    {
      "id": 38839,
      "keyword": "ginecóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "gynecology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35283,
      "keyword": "ginecóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "gynecology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bióloga molecular": [
    {
      "id": 35289,
      "keyword": "bióloga molecular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "biólogas moleculares": [
    {
      "id": 35289,
      "keyword": "bióloga molecular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "neuróloga": [
    {
      "id": 35293,
      "keyword": "neuróloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38840,
      "keyword": "neuróloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "neurólogas": [
    {
      "id": 35293,
      "keyword": "neuróloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38840,
      "keyword": "neuróloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "biólogo molecular": [
    {
      "id": 35291,
      "keyword": "biólogo molecular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "biólogos moleculares": [
    {
      "id": 35291,
      "keyword": "biólogo molecular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anestesióloga": [
    {
      "id": 38843,
      "keyword": "anestesióloga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35277,
      "keyword": "anestesióloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anestesiólogas": [
    {
      "id": 38843,
      "keyword": "anestesióloga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35277,
      "keyword": "anestesióloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anestesista": [
    {
      "id": 38843,
      "keyword": "anestesista",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35277,
      "keyword": "anestesista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35279,
      "keyword": "anestesista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anestesistas": [
    {
      "id": 38843,
      "keyword": "anestesista",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35277,
      "keyword": "anestesista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35279,
      "keyword": "anestesista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ginecólogo": [
    {
      "id": 38839,
      "keyword": "ginecólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "gynecology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35285,
      "keyword": "ginecólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "gynecology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ginecólogos": [
    {
      "id": 38839,
      "keyword": "ginecólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "gynecology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35285,
      "keyword": "ginecólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "reproductive system",
        "gynecology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "neurólogo": [
    {
      "id": 38840,
      "keyword": "neurólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35295,
      "keyword": "neurólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "neurólogos": [
    {
      "id": 38840,
      "keyword": "neurólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35295,
      "keyword": "neurólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anatomopatólogo": [
    {
      "id": 38838,
      "keyword": "anatomopatólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35299,
      "keyword": "anatomopatólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anatomopatólogos": [
    {
      "id": 38838,
      "keyword": "anatomopatólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35299,
      "keyword": "anatomopatólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nefróloga": [
    {
      "id": 38842,
      "keyword": "nefróloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35309,
      "keyword": "nefróloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nefrólogas": [
    {
      "id": 38842,
      "keyword": "nefróloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35309,
      "keyword": "nefróloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anatomopatóloga": [
    {
      "id": 38838,
      "keyword": "anatomopatóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35297,
      "keyword": "anatomopatóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anatomopatólogas": [
    {
      "id": 38838,
      "keyword": "anatomopatóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35297,
      "keyword": "anatomopatóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apósito": [
    {
      "id": 35317,
      "keyword": "apósito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apósitos": [
    {
      "id": 35317,
      "keyword": "apósito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anestesiólogo": [
    {
      "id": 38843,
      "keyword": "anestesiólogo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35279,
      "keyword": "anestesiólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anestesiólogos": [
    {
      "id": 38843,
      "keyword": "anestesiólogo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35279,
      "keyword": "anestesiólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hematólogo": [
    {
      "id": 38841,
      "keyword": "hematólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35315,
      "keyword": "hematólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hematólogos": [
    {
      "id": 38841,
      "keyword": "hematólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35315,
      "keyword": "hematólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "donar": [
    {
      "id": 35319,
      "keyword": "donar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sala de donación": [
    {
      "id": 35321,
      "keyword": "sala de donación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sala de extracción": [
    {
      "id": 35323,
      "keyword": "sala de extracción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nefrólogo": [
    {
      "id": 38842,
      "keyword": "nefrólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35311,
      "keyword": "nefrólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nefrólogos": [
    {
      "id": 38842,
      "keyword": "nefrólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35311,
      "keyword": "nefrólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "excretory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hematóloga": [
    {
      "id": 38841,
      "keyword": "hematóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35313,
      "keyword": "hematóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hematólogas": [
    {
      "id": 38841,
      "keyword": "hematóloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35313,
      "keyword": "hematóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pijama hospitalario": [
    {
      "id": 35333,
      "keyword": "pijama hospitalario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pijamas hospitalarios": [
    {
      "id": 35333,
      "keyword": "pijama hospitalario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "máquina de anestesia": [
    {
      "id": 35335,
      "keyword": "máquina de anestesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máquinas de anestesia": [
    {
      "id": 35335,
      "keyword": "máquina de anestesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carro de anestesia": [
    {
      "id": 35335,
      "keyword": "carro de anestesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carros de anestesia": [
    {
      "id": 35335,
      "keyword": "carro de anestesia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peligro de infección": [
    {
      "id": 35345,
      "keyword": "peligro de infección",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medicación intravenosa": [
    {
      "id": 35343,
      "keyword": "medicación intravenosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38722,
      "keyword": "medicación intravenosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contagiar": [
    {
      "id": 35339,
      "keyword": "contagiar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "disease",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "infectar": [
    {
      "id": 35339,
      "keyword": "infectar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "disease",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sala de reanimación": [
    {
      "id": 35329,
      "keyword": "sala de reanimación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cama de hospital": [
    {
      "id": 35341,
      "keyword": "cama de hospital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camas de hospital": [
    {
      "id": 35341,
      "keyword": "cama de hospital",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesa de operaciones": [
    {
      "id": 35331,
      "keyword": "mesa de operaciones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas de operaciones": [
    {
      "id": 35331,
      "keyword": "mesa de operaciones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barreño": [
    {
      "id": 35353,
      "keyword": "barreño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barreños": [
    {
      "id": 35353,
      "keyword": "barreño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sopa de letras": [
    {
      "id": 35355,
      "keyword": "sopa de letras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sopas de letras": [
    {
      "id": 35355,
      "keyword": "sopa de letras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cabina electoral": [
    {
      "id": 35369,
      "keyword": "cabina electoral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39231,
      "keyword": "cabina electoral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cabinas electorales": [
    {
      "id": 35369,
      "keyword": "cabina electoral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39231,
      "keyword": "cabina electoral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vieira": [
    {
      "id": 35375,
      "keyword": "vieira",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35395,
      "keyword": "vieira",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vieiras": [
    {
      "id": 35375,
      "keyword": "vieira",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35395,
      "keyword": "vieira",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "helipuerto": [
    {
      "id": 35377,
      "keyword": "helipuerto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "facility",
        "work",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "helipuertos": [
    {
      "id": 35377,
      "keyword": "helipuerto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "facility",
        "work",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "martillo de zapatero": [
    {
      "id": 35379,
      "keyword": "martillo de zapatero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "martillos de zapatero": [
    {
      "id": 35379,
      "keyword": "martillo de zapatero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ramo de novia": [
    {
      "id": 35357,
      "keyword": "ramo de novia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ramos de novia": [
    {
      "id": 35357,
      "keyword": "ramo de novia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "wedding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rueda dentada": [
    {
      "id": 35381,
      "keyword": "rueda dentada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ruedas dentadas": [
    {
      "id": 35381,
      "keyword": "rueda dentada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gorro de cocina": [
    {
      "id": 35387,
      "keyword": "gorro de cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gorros de cocina": [
    {
      "id": 35387,
      "keyword": "gorro de cocina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quitagrapas": [
    {
      "id": 35397,
      "keyword": "quitagrapas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinar": [
    {
      "id": 35367,
      "keyword": "pinar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "natural habitat",
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinares": [
    {
      "id": 35367,
      "keyword": "pinar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "natural habitat",
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diente de tiburón": [
    {
      "id": 35405,
      "keyword": "diente de tiburón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "fossil",
        "paleontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dientes de tiburón": [
    {
      "id": 35405,
      "keyword": "diente de tiburón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "extinct being",
        "dinosaur",
        "anatomy",
        "dinosaur anatomy",
        "fossil",
        "paleontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pompón": [
    {
      "id": 35409,
      "keyword": "pompón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kentia": [
    {
      "id": 35399,
      "keyword": "kentia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kentias": [
    {
      "id": 35399,
      "keyword": "kentia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "notaria": [
    {
      "id": 35415,
      "keyword": "notaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "notarias": [
    {
      "id": 35415,
      "keyword": "notaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "notaría": [
    {
      "id": 35417,
      "keyword": "notaría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "law",
        "justice",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "notarías": [
    {
      "id": 35417,
      "keyword": "notaría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "law",
        "justice",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "notario": [
    {
      "id": 35413,
      "keyword": "notario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "notarios": [
    {
      "id": 35413,
      "keyword": "notario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gomet": [
    {
      "id": 35425,
      "keyword": "gomet",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodamiento": [
    {
      "id": 35429,
      "keyword": "rodamiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodamientos": [
    {
      "id": 35429,
      "keyword": "rodamiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "país": [
    {
      "id": 35431,
      "keyword": "país",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "países": [
    {
      "id": 35431,
      "keyword": "país",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trozo de tarta": [
    {
      "id": 35423,
      "keyword": "trozo de tarta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trozos de tarta": [
    {
      "id": 35423,
      "keyword": "trozo de tarta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clase de música": [
    {
      "id": 35433,
      "keyword": "clase de música",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35434,
      "keyword": "clase de música",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de música": [
    {
      "id": 35433,
      "keyword": "clase de música",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35434,
      "keyword": "clase de música",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ciencias": [
    {
      "id": 35437,
      "keyword": "ciencias",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuartel": [
    {
      "id": 35419,
      "keyword": "cuartel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuarteles": [
    {
      "id": 35419,
      "keyword": "cuartel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asador": [
    {
      "id": 35443,
      "keyword": "asador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asadores": [
    {
      "id": 35443,
      "keyword": "asador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "imprenta": [
    {
      "id": 35445,
      "keyword": "imprenta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "imprentas": [
    {
      "id": 35445,
      "keyword": "imprenta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "delegación de hacienda": [
    {
      "id": 35447,
      "keyword": "delegación de hacienda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "impuesto": [
    {
      "id": 35449,
      "keyword": "impuesto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "impuestos": [
    {
      "id": 35449,
      "keyword": "impuesto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "declaración de la renta": [
    {
      "id": 35449,
      "keyword": "declaración de la renta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "declaraciones de la renta": [
    {
      "id": 35449,
      "keyword": "declaración de la renta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "puerto deportivo": [
    {
      "id": 35453,
      "keyword": "puerto deportivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puertos deportivos": [
    {
      "id": 35453,
      "keyword": "puerto deportivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cementerio judío": [
    {
      "id": 35457,
      "keyword": "cementerio judío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "judaism",
        "event",
        "social event",
        "death",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cementerios judíos": [
    {
      "id": 35457,
      "keyword": "cementerio judío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "judaism",
        "event",
        "social event",
        "death",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cementerio musulmán": [
    {
      "id": 35459,
      "keyword": "cementerio musulmán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "islamism",
        "event",
        "social event",
        "death",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cementerios musulmanes": [
    {
      "id": 35459,
      "keyword": "cementerio musulmán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "islamism",
        "event",
        "social event",
        "death",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "güiro": [
    {
      "id": 35461,
      "keyword": "güiro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "güiros": [
    {
      "id": 35461,
      "keyword": "güiro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peluquería canina": [
    {
      "id": 35451,
      "keyword": "peluquería canina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peluquerías caninas": [
    {
      "id": 35451,
      "keyword": "peluquería canina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "flauta de tres agujeros": [
    {
      "id": 35465,
      "keyword": "flauta de tres agujeros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flautas de tres agujeros": [
    {
      "id": 35465,
      "keyword": "flauta de tres agujeros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nazareno": [
    {
      "id": 35475,
      "keyword": "nazareno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "easter week",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nazarenos": [
    {
      "id": 35475,
      "keyword": "nazareno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "easter week",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paso": [
    {
      "id": 35811,
      "keyword": "paso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35477,
      "keyword": "paso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "event",
        "popular event",
        "easter week",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasos": [
    {
      "id": 35811,
      "keyword": "paso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35477,
      "keyword": "paso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "event",
        "popular event",
        "easter week",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "intervenir": [
    {
      "id": 35473,
      "keyword": "intervenir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasear al caballo": [
    {
      "id": 35485,
      "keyword": "pasear al caballo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arrear": [
    {
      "id": 35487,
      "keyword": "arrear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espolear": [
    {
      "id": 35487,
      "keyword": "espolear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equinoterapia": [
    {
      "id": 35481,
      "keyword": "equinoterapia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salterio": [
    {
      "id": 35463,
      "keyword": "salterio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salterios": [
    {
      "id": 35463,
      "keyword": "salterio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "globoflexia": [
    {
      "id": 35495,
      "keyword": "globoflexia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "hobby"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comedero": [
    {
      "id": 35497,
      "keyword": "comedero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38506,
      "keyword": "comedero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "pet",
        "animal nutrition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comederos": [
    {
      "id": 35497,
      "keyword": "comedero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38506,
      "keyword": "comedero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "pet",
        "animal nutrition"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salvaescaleras": [
    {
      "id": 35491,
      "keyword": "salvaescaleras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "matadero": [
    {
      "id": 35501,
      "keyword": "matadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "primary sector",
        "cattle farming",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mataderos": [
    {
      "id": 35501,
      "keyword": "matadero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "primary sector",
        "cattle farming",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "wifi": [
    {
      "id": 35503,
      "keyword": "wifi",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fisioterapia acuática": [
    {
      "id": 35511,
      "keyword": "fisioterapia acuática",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gabinete de prensa": [
    {
      "id": 35513,
      "keyword": "gabinete de prensa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gabinetes de prensa": [
    {
      "id": 35513,
      "keyword": "gabinete de prensa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comunidades autónomas": [
    {
      "id": 35509,
      "keyword": "comunidades autónomas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "political geography",
        "spain region"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taller de chapa y pintura": [
    {
      "id": 35517,
      "keyword": "taller de chapa y pintura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "workplace",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talleres de chapa y pintura": [
    {
      "id": 35517,
      "keyword": "taller de chapa y pintura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "workplace",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "indicador": [
    {
      "id": 35505,
      "keyword": "indicador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "indicadores": [
    {
      "id": 35505,
      "keyword": "indicador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "señal": [
    {
      "id": 35507,
      "keyword": "señal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "señales": [
    {
      "id": 35507,
      "keyword": "señal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comida para llevar": [
    {
      "id": 35519,
      "keyword": "comida para llevar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monitor de signos vitales": [
    {
      "id": 35527,
      "keyword": "monitor de signos vitales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monitores de signos vitales": [
    {
      "id": 35527,
      "keyword": "monitor de signos vitales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aburrimiento": [
    {
      "id": 35553,
      "keyword": "aburrimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aburrimientos": [
    {
      "id": 35553,
      "keyword": "aburrimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "risa": [
    {
      "id": 35555,
      "keyword": "risa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "risas": [
    {
      "id": 35555,
      "keyword": "risa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hambre": [
    {
      "id": 35559,
      "keyword": "hambre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "basic needs",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calor": [
    {
      "id": 35561,
      "keyword": "calor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35597,
      "keyword": "calor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calores": [
    {
      "id": 35561,
      "keyword": "calor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35597,
      "keyword": "calor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "confusión": [
    {
      "id": 35575,
      "keyword": "confusión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "susto": [
    {
      "id": 35571,
      "keyword": "susto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sustos": [
    {
      "id": 35571,
      "keyword": "susto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mareo": [
    {
      "id": 35569,
      "keyword": "mareo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "body sensation",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mareos": [
    {
      "id": 35569,
      "keyword": "mareo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "body sensation",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enfado": [
    {
      "id": 35567,
      "keyword": "enfado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfados": [
    {
      "id": 35567,
      "keyword": "enfado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hacer viento": [
    {
      "id": 35591,
      "keyword": "hacer viento",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubo de agua": [
    {
      "id": 35605,
      "keyword": "cubo de agua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubos de agua": [
    {
      "id": 35605,
      "keyword": "cubo de agua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "balde de agua": [
    {
      "id": 35605,
      "keyword": "balde de agua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baldes de agua": [
    {
      "id": 35605,
      "keyword": "balde de agua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vaso con pipeta": [
    {
      "id": 35607,
      "keyword": "vaso con pipeta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare",
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vasos con pipeta": [
    {
      "id": 35607,
      "keyword": "vaso con pipeta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare",
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cruzar con precaución": [
    {
      "id": 35609,
      "keyword": "cruzar con precaución",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37184,
      "keyword": "cruzar con precaución",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tener frío": [
    {
      "id": 35583,
      "keyword": "tener frío",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "body sensation",
        "winter",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mascarilla de anestesia": [
    {
      "id": 38906,
      "keyword": "mascarilla de anestesia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35613,
      "keyword": "mascarilla de anestesia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mascarillas de anestesia": [
    {
      "id": 38906,
      "keyword": "mascarilla de anestesia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35613,
      "keyword": "mascarilla de anestesia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "servicio provincial de educación": [
    {
      "id": 35603,
      "keyword": "servicio provincial de educación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational institution",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "servicios provinciales de educación": [
    {
      "id": 35603,
      "keyword": "servicio provincial de educación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational institution",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cansancio": [
    {
      "id": 35573,
      "keyword": "cansancio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human body",
        "body sensation",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "malestar": [
    {
      "id": 35573,
      "keyword": "malestar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human body",
        "body sensation",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "interpretar": [
    {
      "id": 35626,
      "keyword": "interpretar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35625,
      "keyword": "interpretar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35711,
      "keyword": "interpretar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "testamento": [
    {
      "id": 35629,
      "keyword": "testamento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "testamentos": [
    {
      "id": 35629,
      "keyword": "testamento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saltar en la cama elástica": [
    {
      "id": 35621,
      "keyword": "saltar en la cama elástica",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35617,
      "keyword": "saltar en la cama elástica",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35620,
      "keyword": "saltar en la cama elástica",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35619,
      "keyword": "saltar en la cama elástica",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desembarcar": [
    {
      "id": 35633,
      "keyword": "desembarcar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35751,
      "keyword": "desembarcar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carne picada": [
    {
      "id": 35635,
      "keyword": "carne picada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tos": [
    {
      "id": 35585,
      "keyword": "tos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toses": [
    {
      "id": 35585,
      "keyword": "tos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asociación de personas con autimo": [
    {
      "id": 35647,
      "keyword": "asociación de personas con autimo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asociaciones de personas con autimo": [
    {
      "id": 35647,
      "keyword": "asociación de personas con autimo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manos de cerdo": [
    {
      "id": 35649,
      "keyword": "manos de cerdo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patas de cerdo": [
    {
      "id": 35649,
      "keyword": "patas de cerdo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "organizar": [
    {
      "id": 35653,
      "keyword": "organizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centro de datos": [
    {
      "id": 35645,
      "keyword": "centro de datos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "computing",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros de datos": [
    {
      "id": 35645,
      "keyword": "centro de datos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "computing",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "instrumentos de cuerda": [
    {
      "id": 35641,
      "keyword": "instrumentos de cuerda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "instrumentos de viento": [
    {
      "id": 35667,
      "keyword": "instrumentos de viento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peregrina": [
    {
      "id": 35675,
      "keyword": "peregrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peregrinas": [
    {
      "id": 35675,
      "keyword": "peregrina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peregrinar": [
    {
      "id": 35713,
      "keyword": "peregrinar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "actuar": [
    {
      "id": 35709,
      "keyword": "actuar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "scenic art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "embarcar": [
    {
      "id": 35725,
      "keyword": "embarcar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35745,
      "keyword": "embarcar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sudor": [
    {
      "id": 35721,
      "keyword": "sudor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sudor frío": [
    {
      "id": 35721,
      "keyword": "sudor frío",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sudores fríos": [
    {
      "id": 35721,
      "keyword": "sudor frío",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "facturar": [
    {
      "id": 35733,
      "keyword": "facturar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anochecer": [
    {
      "id": 35731,
      "keyword": "anochecer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ensobrar": [
    {
      "id": 35743,
      "keyword": "ensobrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salsa": [
    {
      "id": 35735,
      "keyword": "salsa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salsas": [
    {
      "id": 35735,
      "keyword": "salsa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trufa": [
    {
      "id": 35753,
      "keyword": "trufa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "fungus",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trufas": [
    {
      "id": 35753,
      "keyword": "trufa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "fungus",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rúcula": [
    {
      "id": 35755,
      "keyword": "rúcula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llamar al 061": [
    {
      "id": 35757,
      "keyword": "llamar al 061",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bistec de vaca": [
    {
      "id": 35759,
      "keyword": "bistec de vaca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bistecs de vaca": [
    {
      "id": 35759,
      "keyword": "bistec de vaca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bistec": [
    {
      "id": 35759,
      "keyword": "bistec",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bistecs": [
    {
      "id": 35759,
      "keyword": "bistec",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "queso de oveja": [
    {
      "id": 35761,
      "keyword": "queso de oveja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quesos de oveja": [
    {
      "id": 35761,
      "keyword": "queso de oveja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugar al baloncesto": [
    {
      "id": 35749,
      "keyword": "jugar al baloncesto",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "queso de vaca": [
    {
      "id": 35763,
      "keyword": "queso de vaca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quesos de vaca": [
    {
      "id": 35763,
      "keyword": "queso de vaca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "entrecot": [
    {
      "id": 35771,
      "keyword": "entrecot",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entrecots": [
    {
      "id": 35771,
      "keyword": "entrecot",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pasar la pelota": [
    {
      "id": 35773,
      "keyword": "pasar la pelota",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35774,
      "keyword": "pasar la pelota",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35775,
      "keyword": "pasar la pelota",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39224,
      "keyword": "pasar la pelota",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39399,
      "keyword": "pasar la pelota",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "adapted sport",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "queso brie": [
    {
      "id": 35767,
      "keyword": "queso brie",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quesos brie": [
    {
      "id": 35767,
      "keyword": "queso brie",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "queso de cabra": [
    {
      "id": 35765,
      "keyword": "queso de cabra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quesos de cabra": [
    {
      "id": 35765,
      "keyword": "queso de cabra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abrir el pestillo": [
    {
      "id": 35785,
      "keyword": "abrir el pestillo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerrar el pestillo": [
    {
      "id": 35787,
      "keyword": "cerrar el pestillo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "témperas": [
    {
      "id": 35793,
      "keyword": "témperas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "licuado": [
    {
      "id": 35795,
      "keyword": "licuado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "babuchas": [
    {
      "id": 35797,
      "keyword": "babuchas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35798,
      "keyword": "babuchas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "echar salsa": [
    {
      "id": 35779,
      "keyword": "echar salsa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food",
        "condiment",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hundimiento": [
    {
      "id": 35801,
      "keyword": "hundimiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hundimientos": [
    {
      "id": 35801,
      "keyword": "hundimiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "history",
        "archaeology",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nutricionista": [
    {
      "id": 38832,
      "keyword": "nutricionista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35803,
      "keyword": "nutricionista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "dietetics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35804,
      "keyword": "nutricionista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "dietetics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nutricionistas": [
    {
      "id": 38832,
      "keyword": "nutricionista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35803,
      "keyword": "nutricionista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "dietetics"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35804,
      "keyword": "nutricionista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "dietetics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolor de pie": [
    {
      "id": 35809,
      "keyword": "dolor de pie",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alioli": [
    {
      "id": 35813,
      "keyword": "alioli",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aliolis": [
    {
      "id": 35813,
      "keyword": "alioli",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ampolla": [
    {
      "id": 35807,
      "keyword": "ampolla",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "ampollas": [
    {
      "id": 35807,
      "keyword": "ampolla",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "curry": [
    {
      "id": 35817,
      "keyword": "curry",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "spices"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "probador": [
    {
      "id": 35819,
      "keyword": "probador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "probadores": [
    {
      "id": 35819,
      "keyword": "probador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palitos de pollo": [
    {
      "id": 35815,
      "keyword": "palitos de pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiras de pollo": [
    {
      "id": 35815,
      "keyword": "tiras de pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "banda depilatoria": [
    {
      "id": 35821,
      "keyword": "banda depilatoria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bandas depilatorias": [
    {
      "id": 35821,
      "keyword": "banda depilatoria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cera fría": [
    {
      "id": 35821,
      "keyword": "cera fría",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crema corporal": [
    {
      "id": 35829,
      "keyword": "crema corporal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cremas corporales": [
    {
      "id": 35829,
      "keyword": "crema corporal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camino de santiago": [
    {
      "id": 35835,
      "keyword": "Camino de Santiago",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "surf de remo": [
    {
      "id": 35839,
      "keyword": "surf de remo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "surf"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35840,
      "keyword": "surf de remo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "surf"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35837,
      "keyword": "surf de remo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "surf"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35838,
      "keyword": "surf de remo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "surf"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35841,
      "keyword": "surf de remo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "surf"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "surf de pala": [
    {
      "id": 35839,
      "keyword": "surf de pala",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "surf"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35840,
      "keyword": "surf de pala",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "surf"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35837,
      "keyword": "surf de pala",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "surf"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35838,
      "keyword": "surf de pala",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "surf"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35841,
      "keyword": "surf de pala",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "surf"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "santiago de compostela": [
    {
      "id": 35831,
      "keyword": "Santiago de Compostela",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "city"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pañal sucio": [
    {
      "id": 35848,
      "keyword": "pañal sucio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35847,
      "keyword": "pañal sucio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pañales sucios": [
    {
      "id": 35848,
      "keyword": "pañal sucio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35847,
      "keyword": "pañal sucio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "instrumentos de percusión": [
    {
      "id": 35851,
      "keyword": "instrumentos de percusión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "animales marinos": [
    {
      "id": 35853,
      "keyword": "animales marinos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "aquatic animal",
        "marine animal",
        "sea",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mascarilla capilar": [
    {
      "id": 35827,
      "keyword": "mascarilla capilar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mascarillas capilares": [
    {
      "id": 35827,
      "keyword": "mascarilla capilar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "animales terrestres": [
    {
      "id": 35857,
      "keyword": "animales terrestres",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "terrestrial animal",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "construcción": [
    {
      "id": 35859,
      "keyword": "construcción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction",
        "architecture",
        "building",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recinto ferial": [
    {
      "id": 35861,
      "keyword": "recinto ferial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility",
        "event",
        "popular event",
        "fiestas del pilar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recintos feriales": [
    {
      "id": 35861,
      "keyword": "recinto ferial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "place",
        "facility",
        "recreational facility",
        "event",
        "popular event",
        "fiestas del pilar"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "park güell": [
    {
      "id": 35863,
      "keyword": "Park Güell",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "día de santiago": [
    {
      "id": 35865,
      "keyword": "Día de Santiago",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botafumeiro": [
    {
      "id": 35867,
      "keyword": "Botafumeiro",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "object",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "santiago el mayor": [
    {
      "id": 35871,
      "keyword": "Santiago el Mayor",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "historical character",
        "history",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poco hecho": [
    {
      "id": 35873,
      "keyword": "poco hecho",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vuelta y vuelta": [
    {
      "id": 35873,
      "keyword": "vuelta y vuelta",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pastas de té": [
    {
      "id": 35879,
      "keyword": "pastas de té",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "lloro": [
    {
      "id": 35881,
      "keyword": "lloro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lloros": [
    {
      "id": 35881,
      "keyword": "lloro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llanto": [
    {
      "id": 35881,
      "keyword": "llanto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "voto secreto": [
    {
      "id": 35883,
      "keyword": "voto secreto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35884,
      "keyword": "voto secreto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "votos secretos": [
    {
      "id": 35883,
      "keyword": "voto secreto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 35884,
      "keyword": "voto secreto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "al punto": [
    {
      "id": 35877,
      "keyword": "al punto",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "animales aéreos": [
    {
      "id": 35855,
      "keyword": "animales aéreos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "flying animal",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cambio postural": [
    {
      "id": 35889,
      "keyword": "cambio postural",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cambios posturales": [
    {
      "id": 35889,
      "keyword": "cambio postural",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "muy hecho": [
    {
      "id": 35875,
      "keyword": "muy hecho",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bastón de senderismo": [
    {
      "id": 35887,
      "keyword": "bastón de senderismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bastones de senderismo": [
    {
      "id": 35887,
      "keyword": "bastón de senderismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barrita de cereal": [
    {
      "id": 35899,
      "keyword": "barrita de cereal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "silla con bipedestador": [
    {
      "id": 35901,
      "keyword": "silla con bipedestador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas con bipedestador": [
    {
      "id": 35901,
      "keyword": "silla con bipedestador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "catering": [
    {
      "id": 35903,
      "keyword": "catering",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de cortafiambres": [
    {
      "id": 35907,
      "keyword": "tienda de cortafiambres",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de cortafiambres": [
    {
      "id": 35907,
      "keyword": "tienda de cortafiambres",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silla de peluqero": [
    {
      "id": 35897,
      "keyword": "silla de peluqero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas de peluqero": [
    {
      "id": 35897,
      "keyword": "silla de peluqero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sombrero australiano": [
    {
      "id": 35909,
      "keyword": "sombrero australiano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sombreros australianos": [
    {
      "id": 35909,
      "keyword": "sombrero australiano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cortafiambres": [
    {
      "id": 35905,
      "keyword": "cortafiambres",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monitor de transporte": [
    {
      "id": 35911,
      "keyword": "monitor de transporte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monitores de transporte": [
    {
      "id": 35911,
      "keyword": "monitor de transporte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "la compostela": [
    {
      "id": 35913,
      "keyword": "La Compostela",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acreditar peregrinación": [
    {
      "id": 35915,
      "keyword": "acreditar peregrinación",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comidas con huevo": [
    {
      "id": 35917,
      "keyword": "comidas con huevo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comida con huevo": [
    {
      "id": 35917,
      "keyword": "comida con huevo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "accidente de sillas": [
    {
      "id": 35895,
      "keyword": "accidente de sillas",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "chatarrería": [
    {
      "id": 35921,
      "keyword": "chatarrería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recycling center",
        "recycling",
        "environmental science",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chatarrerías": [
    {
      "id": 35921,
      "keyword": "chatarrería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recycling center",
        "recycling",
        "environmental science",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pegar con blu-tack": [
    {
      "id": 35919,
      "keyword": "pegar con blu-tack",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esquiadora": [
    {
      "id": 35959,
      "keyword": "esquiadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esquiadoras": [
    {
      "id": 35959,
      "keyword": "esquiadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trona": [
    {
      "id": 35961,
      "keyword": "trona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tronas": [
    {
      "id": 35961,
      "keyword": "trona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "boceto": [
    {
      "id": 35947,
      "keyword": "boceto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bocetos": [
    {
      "id": 35947,
      "keyword": "boceto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reiki": [
    {
      "id": 35967,
      "keyword": "reiki",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35968,
      "keyword": "reiki",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "armería": [
    {
      "id": 35975,
      "keyword": "armería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "armerías": [
    {
      "id": 35975,
      "keyword": "armería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bipedestación": [
    {
      "id": 35981,
      "keyword": "bipedestación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35982,
      "keyword": "bipedestación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calidad": [
    {
      "id": 35993,
      "keyword": "calidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calidades": [
    {
      "id": 35993,
      "keyword": "calidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuadrupedía": [
    {
      "id": 35985,
      "keyword": "cuadrupedía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35986,
      "keyword": "cuadrupedía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sedestación": [
    {
      "id": 35989,
      "keyword": "sedestación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 35990,
      "keyword": "sedestación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perro de asistencia": [
    {
      "id": 35997,
      "keyword": "perro de asistencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal-assisted therapy",
        "dog-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perros de asistencia": [
    {
      "id": 35997,
      "keyword": "perro de asistencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal-assisted therapy",
        "dog-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "castell": [
    {
      "id": 35995,
      "keyword": "castell",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "droguería": [
    {
      "id": 35999,
      "keyword": "droguería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "cleaning product",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37578,
      "keyword": "droguería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "cleaning product",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "droguerías": [
    {
      "id": 35999,
      "keyword": "droguería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "cleaning product",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37578,
      "keyword": "droguería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "cleaning product",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manto": [
    {
      "id": 36003,
      "keyword": "manto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mantos": [
    {
      "id": 36003,
      "keyword": "manto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "panel táctil": [
    {
      "id": 36013,
      "keyword": "panel táctil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paneles táctiles": [
    {
      "id": 36013,
      "keyword": "panel táctil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hummus": [
    {
      "id": 36015,
      "keyword": "hummus",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mural": [
    {
      "id": 36011,
      "keyword": "mural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "murales": [
    {
      "id": 36011,
      "keyword": "mural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pintura mural": [
    {
      "id": 36011,
      "keyword": "pintura mural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinturas murales": [
    {
      "id": 36011,
      "keyword": "pintura mural",
      "keywords": 2,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "evaporar": [
    {
      "id": 36009,
      "keyword": "evaporar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "physics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "condensar": [
    {
      "id": 36027,
      "keyword": "condensar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "physics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escenario de un crimen": [
    {
      "id": 36019,
      "keyword": "escenario de un crimen",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escenarios de un crimen": [
    {
      "id": 36019,
      "keyword": "escenario de un crimen",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "congelar": [
    {
      "id": 36023,
      "keyword": "congelar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "physics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rabino": [
    {
      "id": 36037,
      "keyword": "rabino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rabinos": [
    {
      "id": 36037,
      "keyword": "rabino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "person",
        "judaism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mirada": [
    {
      "id": 36041,
      "keyword": "mirada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "miradas": [
    {
      "id": 36041,
      "keyword": "mirada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vistazo": [
    {
      "id": 36041,
      "keyword": "vistazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vistazos": [
    {
      "id": 36041,
      "keyword": "vistazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "patinódromo": [
    {
      "id": 36029,
      "keyword": "patinódromo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patinódromos": [
    {
      "id": 36029,
      "keyword": "patinódromo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "obispado": [
    {
      "id": 36043,
      "keyword": "obispado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "place",
        "christianity",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obispados": [
    {
      "id": 36043,
      "keyword": "obispado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "place",
        "christianity",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "congelación": [
    {
      "id": 36053,
      "keyword": "congelación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics",
        "chemistry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "congelaciones": [
    {
      "id": 36053,
      "keyword": "congelación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics",
        "chemistry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "galeón": [
    {
      "id": 36057,
      "keyword": "galeón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "galeones": [
    {
      "id": 36057,
      "keyword": "galeón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atacar": [
    {
      "id": 36045,
      "keyword": "atacar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36494,
      "keyword": "atacar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36496,
      "keyword": "atacar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38344,
      "keyword": "atacar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "war",
        "history",
        "middle ages"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chatarra": [
    {
      "id": 36061,
      "keyword": "chatarra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chatarras": [
    {
      "id": 36061,
      "keyword": "chatarra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "condensación": [
    {
      "id": 36059,
      "keyword": "condensación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics",
        "chemistry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "condensaciones": [
    {
      "id": 36059,
      "keyword": "condensación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics",
        "chemistry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro de atención temprana": [
    {
      "id": 36079,
      "keyword": "centro de atención temprana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros de atención temprana": [
    {
      "id": 36079,
      "keyword": "centro de atención temprana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "special education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "monarquía": [
    {
      "id": 36069,
      "keyword": "monarquía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "leader"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monarquías": [
    {
      "id": 36069,
      "keyword": "monarquía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "leader"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taller de motos": [
    {
      "id": 36065,
      "keyword": "taller de motos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "workplace",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talleres de motos": [
    {
      "id": 36065,
      "keyword": "taller de motos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "workplace",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "faláfel": [
    {
      "id": 36097,
      "keyword": "faláfel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "faláfels": [
    {
      "id": 36097,
      "keyword": "faláfel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuscús israelí": [
    {
      "id": 36099,
      "keyword": "cuscús israelí",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ptitim": [
    {
      "id": 36099,
      "keyword": "ptitim",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ptitims": [
    {
      "id": 36099,
      "keyword": "ptitim",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arca de la alianza": [
    {
      "id": 36087,
      "keyword": "Arca de la Alianza",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "object",
        "christianity",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "portaestandarte": [
    {
      "id": 36085,
      "keyword": "portaestandarte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "portaestandartes": [
    {
      "id": 36085,
      "keyword": "portaestandarte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carrera de relevos": [
    {
      "id": 36105,
      "keyword": "carrera de relevos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carreras de relevos": [
    {
      "id": 36105,
      "keyword": "carrera de relevos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games",
        "sport modality",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casco de realidad virtual": [
    {
      "id": 36103,
      "keyword": "casco de realidad virtual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cascos de realidad virtual": [
    {
      "id": 36103,
      "keyword": "casco de realidad virtual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estandarte": [
    {
      "id": 36067,
      "keyword": "estandarte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estandartes": [
    {
      "id": 36067,
      "keyword": "estandarte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "velódromo": [
    {
      "id": 36111,
      "keyword": "velódromo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "velódromos": [
    {
      "id": 36111,
      "keyword": "velódromo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "cycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "criminólogo": [
    {
      "id": 36113,
      "keyword": "criminólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "criminólogos": [
    {
      "id": 36113,
      "keyword": "criminólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bajo eléctrico": [
    {
      "id": 36115,
      "keyword": "bajo eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajos eléctricos": [
    {
      "id": 36115,
      "keyword": "bajo eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bar mitzvah": [
    {
      "id": 36119,
      "keyword": "bar Mitzvah",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "religious event",
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "matzá": [
    {
      "id": 36117,
      "keyword": "matzá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "matzás": [
    {
      "id": 36117,
      "keyword": "matzá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pausa": [
    {
      "id": 36109,
      "keyword": "pausa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pausas": [
    {
      "id": 36109,
      "keyword": "pausa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "feeding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "janucá": [
    {
      "id": 36125,
      "keyword": "Janucá",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brit milá": [
    {
      "id": 36123,
      "keyword": "Brit Milá",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "circuncisión": [
    {
      "id": 36123,
      "keyword": "circuncisión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "religious event",
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "circuncisiones": [
    {
      "id": 36123,
      "keyword": "circuncisión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "religious event",
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jalá": [
    {
      "id": 36127,
      "keyword": "jalá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jalás": [
    {
      "id": 36127,
      "keyword": "jalá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "shofar": [
    {
      "id": 36129,
      "keyword": "shofar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "shofars": [
    {
      "id": 36129,
      "keyword": "shofar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "judaism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sabbat": [
    {
      "id": 36133,
      "keyword": "Sabbat",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pésaj": [
    {
      "id": 36131,
      "keyword": "Pésaj",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pascua judía": [
    {
      "id": 36131,
      "keyword": "Pascua Judía",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bat mitzvah": [
    {
      "id": 36121,
      "keyword": "bat Mitzvah",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "religious event",
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sordera": [
    {
      "id": 36143,
      "keyword": "sordera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sorderas": [
    {
      "id": 36143,
      "keyword": "sordera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pérdida de audición": [
    {
      "id": 36143,
      "keyword": "pérdida de audición",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lienzo": [
    {
      "id": 36139,
      "keyword": "lienzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lienzos": [
    {
      "id": 36139,
      "keyword": "lienzo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estornudar": [
    {
      "id": 36149,
      "keyword": "estornudar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36537,
      "keyword": "estornudar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom",
        "prevention measure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parque infantil": [
    {
      "id": 36145,
      "keyword": "parque infantil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38085,
      "keyword": "parque infantil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parques infantiles": [
    {
      "id": 36145,
      "keyword": "parque infantil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38085,
      "keyword": "parque infantil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "querubín": [
    {
      "id": 36141,
      "keyword": "querubín",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "character",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "querubines": [
    {
      "id": 36141,
      "keyword": "querubín",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "character",
        "christianity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mentir": [
    {
      "id": 36161,
      "keyword": "mentir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "valiente": [
    {
      "id": 36163,
      "keyword": "valiente",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "valientes": [
    {
      "id": 36163,
      "keyword": "valiente",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "valeroso": [
    {
      "id": 36163,
      "keyword": "valeroso",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "valerosos": [
    {
      "id": 36163,
      "keyword": "valeroso",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "valerosa": [
    {
      "id": 36163,
      "keyword": "valerosa",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "valerosas": [
    {
      "id": 36163,
      "keyword": "valerosa",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atrevido": [
    {
      "id": 36163,
      "keyword": "atrevido",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atrevidos": [
    {
      "id": 36163,
      "keyword": "atrevido",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atrevida": [
    {
      "id": 36163,
      "keyword": "atrevida",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atrevidas": [
    {
      "id": 36163,
      "keyword": "atrevida",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pitonisa": [
    {
      "id": 36151,
      "keyword": "pitonisa",
      "keywords": 4,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pitonisas": [
    {
      "id": 36151,
      "keyword": "pitonisa",
      "keywords": 4,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adivina": [
    {
      "id": 36151,
      "keyword": "adivina",
      "keywords": 4,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adivinas": [
    {
      "id": 36151,
      "keyword": "adivina",
      "keywords": 4,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "tale character",
        "literature",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuscús": [
    {
      "id": 36167,
      "keyword": "cuscús",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arder": [
    {
      "id": 36155,
      "keyword": "arder",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortita de arroz": [
    {
      "id": 36169,
      "keyword": "tortita de arroz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortitas de arroz": [
    {
      "id": 36169,
      "keyword": "tortita de arroz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "kebab": [
    {
      "id": 36994,
      "keyword": "kebab",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36171,
      "keyword": "kebab",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kebabs": [
    {
      "id": 36994,
      "keyword": "kebab",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36171,
      "keyword": "kebab",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerámica": [
    {
      "id": 36147,
      "keyword": "cerámica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "work",
        "secondary sector",
        "craftsmanship",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerámicas": [
    {
      "id": 36147,
      "keyword": "cerámica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "work",
        "secondary sector",
        "craftsmanship",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adiestrador": [
    {
      "id": 36177,
      "keyword": "adiestrador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adiestradores": [
    {
      "id": 36177,
      "keyword": "adiestrador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "azutera": [
    {
      "id": 36175,
      "keyword": "Azutera",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "evaporación": [
    {
      "id": 36157,
      "keyword": "evaporación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics",
        "chemistry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "evaporaciones": [
    {
      "id": 36157,
      "keyword": "evaporación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics",
        "chemistry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "técnico en terapias asistidas con animales": [
    {
      "id": 36179,
      "keyword": "técnico en terapias asistidas con animales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "animal",
        "animal-assisted therapy",
        "dog-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnicos en terapias asistidas con animales": [
    {
      "id": 36179,
      "keyword": "técnico en terapias asistidas con animales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "animal",
        "animal-assisted therapy",
        "dog-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guía en terapias asistidas con animales": [
    {
      "id": 36179,
      "keyword": "guía en terapias asistidas con animales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "animal",
        "animal-assisted therapy",
        "dog-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guías en terapias asistidas con animales": [
    {
      "id": 36179,
      "keyword": "guía en terapias asistidas con animales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "animal",
        "animal-assisted therapy",
        "dog-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cigarrera": [
    {
      "id": 36173,
      "keyword": "Cigarrera",
      "keywords": 2,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "fiestas del pilar",
        "character"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "silla monorueda": [
    {
      "id": 36193,
      "keyword": "silla monorueda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas monorueda": [
    {
      "id": 36193,
      "keyword": "silla monorueda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "joëlette": [
    {
      "id": 36193,
      "keyword": "joëlette",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "joëlettes": [
    {
      "id": 36193,
      "keyword": "joëlette",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de materiales de construcción": [
    {
      "id": 36185,
      "keyword": "tienda de materiales de construcción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de materiales de construcción": [
    {
      "id": 36185,
      "keyword": "tienda de materiales de construcción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maguén david adom": [
    {
      "id": 36195,
      "keyword": "Maguén David Adom",
      "keywords": 1,
      "type": 1,
      "tags": [
        "international organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36227,
      "keyword": "Maguén David Adom",
      "keywords": 1,
      "type": 1,
      "tags": [
        "international organization",
        "work",
        "professional",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "media luna roja": [
    {
      "id": 36197,
      "keyword": "Media Luna Roja",
      "keywords": 1,
      "type": 1,
      "tags": [
        "international organization"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36225,
      "keyword": "Media Luna Roja",
      "keywords": 1,
      "type": 1,
      "tags": [
        "international organization",
        "work",
        "professional",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tanaj": [
    {
      "id": 36183,
      "keyword": "Tanaj",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "biblia hebrea": [
    {
      "id": 36183,
      "keyword": "Biblia hebrea",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "biblias hebreas": [
    {
      "id": 36183,
      "keyword": "Biblia hebrea",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "judaism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "canaleta de boccia": [
    {
      "id": 36189,
      "keyword": "canaleta de boccia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "adapted sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canaletas de boccia": [
    {
      "id": 36189,
      "keyword": "canaleta de boccia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "adapted sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hospital judío": [
    {
      "id": 36210,
      "keyword": "hospital judío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hospitales judíos": [
    {
      "id": 36210,
      "keyword": "hospital judío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zapatos cortesanos": [
    {
      "id": 36213,
      "keyword": "zapatos cortesanos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "traje cortesano": [
    {
      "id": 36219,
      "keyword": "traje cortesano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trajes cortesanos": [
    {
      "id": 36219,
      "keyword": "traje cortesano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hospital árabe": [
    {
      "id": 36205,
      "keyword": "hospital árabe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hospitales árabes": [
    {
      "id": 36205,
      "keyword": "hospital árabe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "echar lavavajillas": [
    {
      "id": 36235,
      "keyword": "echar lavavajillas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mojar el estropajo": [
    {
      "id": 36237,
      "keyword": "mojar el estropajo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mojar la esponja": [
    {
      "id": 36237,
      "keyword": "mojar la esponja",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "feria de muestras": [
    {
      "id": 36241,
      "keyword": "feria de muestras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "tertiary sector",
        "trade",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ferias de muestras": [
    {
      "id": 36241,
      "keyword": "feria de muestras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "tertiary sector",
        "trade",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "polígono industrial": [
    {
      "id": 36243,
      "keyword": "polígono industrial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "polígonos industriales": [
    {
      "id": 36243,
      "keyword": "polígono industrial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parque tecnológico": [
    {
      "id": 36245,
      "keyword": "parque tecnológico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "tertiary sector",
        "computing",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parques tecnológicos": [
    {
      "id": 36245,
      "keyword": "parque tecnológico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "tertiary sector",
        "computing",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugadora de fútbol": [
    {
      "id": 36229,
      "keyword": "jugadora de fútbol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadoras de fútbol": [
    {
      "id": 36229,
      "keyword": "jugadora de fútbol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro cívico": [
    {
      "id": 36247,
      "keyword": "centro cívico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros cívicos": [
    {
      "id": 36247,
      "keyword": "centro cívico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro histórico": [
    {
      "id": 36249,
      "keyword": "centro histórico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros históricos": [
    {
      "id": 36249,
      "keyword": "centro histórico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coger el estropajo": [
    {
      "id": 36239,
      "keyword": "coger el estropajo",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomar el estropajo": [
    {
      "id": 36239,
      "keyword": "tomar el estropajo",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomar la esponja": [
    {
      "id": 36239,
      "keyword": "tomar la esponja",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agarrar la esponja": [
    {
      "id": 36239,
      "keyword": "agarrar la esponja",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "restaurante de comida rápida": [
    {
      "id": 36251,
      "keyword": "restaurante de comida rápida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "restaurantes de comida rápida": [
    {
      "id": 36251,
      "keyword": "restaurante de comida rápida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolas de bochas": [
    {
      "id": 36255,
      "keyword": "bolas de bochas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maestra de audición y lenguaje": [
    {
      "id": 36263,
      "keyword": "maestra de audición y lenguaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36271,
      "keyword": "maestra de audición y lenguaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maestras de audición y lenguaje": [
    {
      "id": 36263,
      "keyword": "maestra de audición y lenguaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36271,
      "keyword": "maestra de audición y lenguaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "leer pictogramas": [
    {
      "id": 36257,
      "keyword": "leer pictogramas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "augmentative communication",
        "communication system",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maestro de audición y lenguaje": [
    {
      "id": 36261,
      "keyword": "maestro de audición y lenguaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36267,
      "keyword": "maestro de audición y lenguaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36268,
      "keyword": "maestro de audición y lenguaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maestros de audición y lenguaje": [
    {
      "id": 36261,
      "keyword": "maestro de audición y lenguaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36267,
      "keyword": "maestro de audición y lenguaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36268,
      "keyword": "maestro de audición y lenguaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de maquinaria agrícola": [
    {
      "id": 36253,
      "keyword": "tienda de maquinaria agrícola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "work machine",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de maquinaria agrícola": [
    {
      "id": 36253,
      "keyword": "tienda de maquinaria agrícola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "work machine",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perdido": [
    {
      "id": 36295,
      "keyword": "perdido",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perdidos": [
    {
      "id": 36295,
      "keyword": "perdido",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perdida": [
    {
      "id": 36295,
      "keyword": "perdida",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perdidas": [
    {
      "id": 36295,
      "keyword": "perdida",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desorientado": [
    {
      "id": 36295,
      "keyword": "desorientado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desorientados": [
    {
      "id": 36295,
      "keyword": "desorientado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desorientada": [
    {
      "id": 36295,
      "keyword": "desorientada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desorientadas": [
    {
      "id": 36295,
      "keyword": "desorientada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "extraviado": [
    {
      "id": 36295,
      "keyword": "extraviado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "extraviados": [
    {
      "id": 36295,
      "keyword": "extraviado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "extraviada": [
    {
      "id": 36295,
      "keyword": "extraviada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "extraviadas": [
    {
      "id": 36295,
      "keyword": "extraviada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "monumento": [
    {
      "id": 36297,
      "keyword": "monumento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monumentos": [
    {
      "id": 36297,
      "keyword": "monumento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de objetos funerarios": [
    {
      "id": 36301,
      "keyword": "tienda de objetos funerarios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de objetos funerarios": [
    {
      "id": 36301,
      "keyword": "tienda de objetos funerarios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estación de autobuses": [
    {
      "id": 36291,
      "keyword": "estación de autobuses",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estaciones de autobuses": [
    {
      "id": 36291,
      "keyword": "estación de autobuses",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "no veo bien": [
    {
      "id": 36259,
      "keyword": "no veo bien",
      "keywords": 1,
      "type": 5,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda abierta": [
    {
      "id": 36313,
      "keyword": "tienda abierta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas abiertas": [
    {
      "id": 36313,
      "keyword": "tienda abierta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda cerrada": [
    {
      "id": 36315,
      "keyword": "tienda cerrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas cerradas": [
    {
      "id": 36315,
      "keyword": "tienda cerrada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "edificio abierto": [
    {
      "id": 36317,
      "keyword": "edificio abierto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "edificios abiertos": [
    {
      "id": 36317,
      "keyword": "edificio abierto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "edificio cerrado": [
    {
      "id": 36319,
      "keyword": "edificio cerrado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "edificios cerrados": [
    {
      "id": 36319,
      "keyword": "edificio cerrado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estados de la materia": [
    {
      "id": 36327,
      "keyword": "estados de la materia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pedir por teléfono": [
    {
      "id": 36330,
      "keyword": "pedir por teléfono",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36329,
      "keyword": "pedir por teléfono",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mirar a los ojos": [
    {
      "id": 36333,
      "keyword": "mirar a los ojos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contacto visual": [
    {
      "id": 36333,
      "keyword": "contacto visual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empresa de mensajería": [
    {
      "id": 36335,
      "keyword": "empresa de mensajería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "transport services",
        "place",
        "building",
        "industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empresas de mensajería": [
    {
      "id": 36335,
      "keyword": "empresa de mensajería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "transport services",
        "place",
        "building",
        "industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "uci pediátrica": [
    {
      "id": 36337,
      "keyword": "UCI pediátrica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36339,
      "keyword": "UCI pediátrica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ucis pediátricas": [
    {
      "id": 36337,
      "keyword": "UCI pediátrica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36339,
      "keyword": "UCI pediátrica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sólido": [
    {
      "id": 36323,
      "keyword": "sólido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sólidos": [
    {
      "id": 36323,
      "keyword": "sólido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "liquido": [
    {
      "id": 36325,
      "keyword": "liquido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "liquidos": [
    {
      "id": 36325,
      "keyword": "liquido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "célula": [
    {
      "id": 36340,
      "keyword": "célula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "biology",
        "human body",
        "physiology",
        "human physiology",
        "animal",
        "animal physiology",
        "plant",
        "plant physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "células": [
    {
      "id": 36340,
      "keyword": "célula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "biology",
        "human body",
        "physiology",
        "human physiology",
        "animal",
        "animal physiology",
        "plant",
        "plant physiology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arroz con leche": [
    {
      "id": 36344,
      "keyword": "arroz con leche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asociación de vecinos": [
    {
      "id": 36345,
      "keyword": "asociación de vecinos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agobiado": [
    {
      "id": 36341,
      "keyword": "agobiado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agobiados": [
    {
      "id": 36341,
      "keyword": "agobiado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agobiada": [
    {
      "id": 36341,
      "keyword": "agobiada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agobiadas": [
    {
      "id": 36341,
      "keyword": "agobiada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "angustiado": [
    {
      "id": 36341,
      "keyword": "angustiado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "angustiados": [
    {
      "id": 36341,
      "keyword": "angustiado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "angustiada": [
    {
      "id": 36341,
      "keyword": "angustiada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "angustiadas": [
    {
      "id": 36341,
      "keyword": "angustiada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abrumado": [
    {
      "id": 36341,
      "keyword": "abrumado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrumados": [
    {
      "id": 36341,
      "keyword": "abrumado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abrumada": [
    {
      "id": 36341,
      "keyword": "abrumada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrumadas": [
    {
      "id": 36341,
      "keyword": "abrumada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ingreso": [
    {
      "id": 36346,
      "keyword": "ingreso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ingresos": [
    {
      "id": 36346,
      "keyword": "ingreso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bacalao con tomate": [
    {
      "id": 36348,
      "keyword": "bacalao con tomate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bacalaos con tomate": [
    {
      "id": 36348,
      "keyword": "bacalao con tomate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dispositivo anti-atragantamiento": [
    {
      "id": 36343,
      "keyword": "dispositivo anti-atragantamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dispositivos anti-atragantamiento": [
    {
      "id": 36343,
      "keyword": "dispositivo anti-atragantamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aparato anti-atragantamiento": [
    {
      "id": 36343,
      "keyword": "aparato anti-atragantamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aparatos anti-atragantamiento": [
    {
      "id": 36343,
      "keyword": "aparato anti-atragantamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anti atragantamiento": [
    {
      "id": 36343,
      "keyword": "anti atragantamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autonomía personal": [
    {
      "id": 36347,
      "keyword": "autonomía personal",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tareas domésticas": [
    {
      "id": 36347,
      "keyword": "tareas domésticas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tareas del hogar": [
    {
      "id": 36347,
      "keyword": "tareas del hogar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bastón de caramelo": [
    {
      "id": 36350,
      "keyword": "bastón de caramelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bastones de caramelo": [
    {
      "id": 36350,
      "keyword": "bastón de caramelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bastón navideño": [
    {
      "id": 36350,
      "keyword": "bastón navideño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bastones navideños": [
    {
      "id": 36350,
      "keyword": "bastón navideño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bazar": [
    {
      "id": 36351,
      "keyword": "bazar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bazares": [
    {
      "id": 36351,
      "keyword": "bazar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alarma de incendios": [
    {
      "id": 36342,
      "keyword": "alarma de incendios",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alarmas de incendios": [
    {
      "id": 36342,
      "keyword": "alarma de incendios",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "berenjenas con miel": [
    {
      "id": 36352,
      "keyword": "berenjenas con miel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carta a papá noel": [
    {
      "id": 36356,
      "keyword": "carta a Papá Noel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cartas a papá noel": [
    {
      "id": 36356,
      "keyword": "carta a Papá Noel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "mass media",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chaqueta del chándal": [
    {
      "id": 36358,
      "keyword": "chaqueta del chándal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chaquetas del chándal": [
    {
      "id": 36358,
      "keyword": "chaqueta del chándal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "boniato": [
    {
      "id": 36354,
      "keyword": "boniato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boniatos": [
    {
      "id": 36354,
      "keyword": "boniato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cinta de regalo": [
    {
      "id": 36360,
      "keyword": "cinta de regalo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cintas de regalo": [
    {
      "id": 36360,
      "keyword": "cinta de regalo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chumbera": [
    {
      "id": 36359,
      "keyword": "chumbera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "cactus"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chumberas": [
    {
      "id": 36359,
      "keyword": "chumbera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "cactus"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nopal": [
    {
      "id": 36359,
      "keyword": "nopal",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "cactus"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nopales": [
    {
      "id": 36359,
      "keyword": "nopal",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "cactus"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palera": [
    {
      "id": 36359,
      "keyword": "palera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "cactus"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paleras": [
    {
      "id": 36359,
      "keyword": "palera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "cactus"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clase de biología": [
    {
      "id": 36362,
      "keyword": "clase de biología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de biología": [
    {
      "id": 36362,
      "keyword": "clase de biología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "biología": [
    {
      "id": 36362,
      "keyword": "biología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cafetería turronería": [
    {
      "id": 36355,
      "keyword": "cafetería turronería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cafeterías turronerías": [
    {
      "id": 36355,
      "keyword": "cafetería turronería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bola de espejos": [
    {
      "id": 36353,
      "keyword": "bola de espejos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bola de discoteca": [
    {
      "id": 36353,
      "keyword": "bola de discoteca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de economía": [
    {
      "id": 36364,
      "keyword": "clase de economía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de economía": [
    {
      "id": 36364,
      "keyword": "clase de economía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "auriculares aislantes": [
    {
      "id": 36357,
      "keyword": "auriculares aislantes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cascos aislantes": [
    {
      "id": 36357,
      "keyword": "cascos aislantes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "protector auditivo": [
    {
      "id": 36357,
      "keyword": "protector auditivo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de física": [
    {
      "id": 36366,
      "keyword": "clase de física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de física": [
    {
      "id": 36366,
      "keyword": "clase de física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "física": [
    {
      "id": 36366,
      "keyword": "física",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de francés": [
    {
      "id": 36367,
      "keyword": "clase de francés",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de francés": [
    {
      "id": 36367,
      "keyword": "clase de francés",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "francés": [
    {
      "id": 36367,
      "keyword": "francés",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de historia": [
    {
      "id": 36368,
      "keyword": "clase de historia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de historia": [
    {
      "id": 36368,
      "keyword": "clase de historia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clase de geología": [
    {
      "id": 36369,
      "keyword": "clase de geología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de geología": [
    {
      "id": 36369,
      "keyword": "clase de geología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "geología": [
    {
      "id": 36369,
      "keyword": "geología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de griego": [
    {
      "id": 36370,
      "keyword": "clase de griego",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject",
        "history",
        "civilization",
        "Greece"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de griego": [
    {
      "id": 36370,
      "keyword": "clase de griego",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject",
        "history",
        "civilization",
        "Greece"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "griego": [
    {
      "id": 36370,
      "keyword": "griego",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject",
        "history",
        "civilization",
        "Greece"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de dibujo técnico": [
    {
      "id": 36363,
      "keyword": "clase de dibujo técnico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de dibujo técnico": [
    {
      "id": 36363,
      "keyword": "clase de dibujo técnico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dibujo técnico": [
    {
      "id": 36363,
      "keyword": "dibujo técnico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de lengua y literatura": [
    {
      "id": 36371,
      "keyword": "clase de lengua y literatura",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de lengua y literatura": [
    {
      "id": 36371,
      "keyword": "clase de lengua y literatura",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lengua y literatura": [
    {
      "id": 36371,
      "keyword": "lengua y literatura",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lengua y literatura española": [
    {
      "id": 36371,
      "keyword": "lengua y literatura española",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de lengua y literatura española": [
    {
      "id": 36371,
      "keyword": "clase de lengua y literatura española",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de química": [
    {
      "id": 36374,
      "keyword": "clase de química",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de química": [
    {
      "id": 36374,
      "keyword": "clase de química",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "química": [
    {
      "id": 36374,
      "keyword": "química",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de lengua y literatura catalana": [
    {
      "id": 36372,
      "keyword": "clase de lengua y literatura catalana",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de lengua y literatura catalana": [
    {
      "id": 36372,
      "keyword": "clase de lengua y literatura catalana",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lengua y literatura catalana": [
    {
      "id": 36372,
      "keyword": "lengua y literatura catalana",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lengua y literatura valenciana": [
    {
      "id": 36372,
      "keyword": "lengua y literatura valenciana",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de lengua y literatura valenciana": [
    {
      "id": 36372,
      "keyword": "clase de lengua y literatura valenciana",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de lengua y literatura valenciana": [
    {
      "id": 36372,
      "keyword": "clase de lengua y literatura valenciana",
      "keywords": 4,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clase de tecnología": [
    {
      "id": 36375,
      "keyword": "clase de tecnología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de tecnología": [
    {
      "id": 36375,
      "keyword": "clase de tecnología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cóctel de gambas": [
    {
      "id": 36376,
      "keyword": "cóctel de gambas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cócteles de gambas": [
    {
      "id": 36376,
      "keyword": "cóctel de gambas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rendir cuentas": [
    {
      "id": 36377,
      "keyword": "rendir cuentas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "law",
        "justice",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rendición de cuentas": [
    {
      "id": 36377,
      "keyword": "rendición de cuentas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "law",
        "justice",
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de filosofía": [
    {
      "id": 36365,
      "keyword": "clase de filosofía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de filosofía": [
    {
      "id": 36365,
      "keyword": "clase de filosofía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "filosofía": [
    {
      "id": 36365,
      "keyword": "filosofía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "disfraz de bruja": [
    {
      "id": 36382,
      "keyword": "disfraz de bruja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume",
        "event",
        "popular event",
        "carnival",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "disfraces de bruja": [
    {
      "id": 36382,
      "keyword": "disfraz de bruja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume",
        "event",
        "popular event",
        "carnival",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hacer la peineta": [
    {
      "id": 36380,
      "keyword": "hacer la peineta",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacar el dedo": [
    {
      "id": 36380,
      "keyword": "sacar el dedo",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corte de mangas": [
    {
      "id": 36380,
      "keyword": "corte de mangas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer un corte de mangas": [
    {
      "id": 36380,
      "keyword": "hacer un corte de mangas",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de matemáticas": [
    {
      "id": 36373,
      "keyword": "clase de matemáticas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "disfraz de esqueleto": [
    {
      "id": 36383,
      "keyword": "disfraz de esqueleto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "disfraces de esqueleto": [
    {
      "id": 36383,
      "keyword": "disfraz de esqueleto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gasto": [
    {
      "id": 36384,
      "keyword": "gasto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gastos": [
    {
      "id": 36384,
      "keyword": "gasto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "elfa": [
    {
      "id": 36387,
      "keyword": "elfa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "elfas": [
    {
      "id": 36387,
      "keyword": "elfa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "elfo": [
    {
      "id": 36388,
      "keyword": "elfo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "elfos": [
    {
      "id": 36388,
      "keyword": "elfo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estor": [
    {
      "id": 36393,
      "keyword": "estor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estores": [
    {
      "id": 36393,
      "keyword": "estor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fregar la taza": [
    {
      "id": 36395,
      "keyword": "fregar la taza",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "crockery",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flor de pascua": [
    {
      "id": 36394,
      "keyword": "flor de pascua",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flores de pascua": [
    {
      "id": 36394,
      "keyword": "flor de pascua",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "poinsetia": [
    {
      "id": 36394,
      "keyword": "poinsetia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poinsetias": [
    {
      "id": 36394,
      "keyword": "poinsetia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "flor de navidad": [
    {
      "id": 36394,
      "keyword": "flor de Navidad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flores de navidad": [
    {
      "id": 36394,
      "keyword": "flor de Navidad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "catedral de santiago": [
    {
      "id": 35833,
      "keyword": "Catedral de Santiago",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "building",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacerse pis": [
    {
      "id": 36400,
      "keyword": "hacerse pis",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36399,
      "keyword": "hacerse pis",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mearse": [
    {
      "id": 36400,
      "keyword": "mearse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36399,
      "keyword": "mearse",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "heladería turronería": [
    {
      "id": 36401,
      "keyword": "heladería turronería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "heladerías turronerías": [
    {
      "id": 36401,
      "keyword": "heladería turronería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "higo chumbo": [
    {
      "id": 36402,
      "keyword": "higo chumbo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "higos chumbos": [
    {
      "id": 36402,
      "keyword": "higo chumbo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ahorro": [
    {
      "id": 36403,
      "keyword": "ahorro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ahorros": [
    {
      "id": 36403,
      "keyword": "ahorro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juego de las sillas": [
    {
      "id": 36404,
      "keyword": "juego de las sillas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos didácticos": [
    {
      "id": 36405,
      "keyword": "juegos didácticos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "leisure",
        "game",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juego": [
    {
      "id": 36405,
      "keyword": "juego",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "leisure",
        "game",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hablar a la vez": [
    {
      "id": 36398,
      "keyword": "hablar a la vez",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bola luminosa": [
    {
      "id": 36408,
      "keyword": "bola luminosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolas luminosas": [
    {
      "id": 36408,
      "keyword": "bola luminosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bola de colores": [
    {
      "id": 36408,
      "keyword": "bola de colores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolas de colores": [
    {
      "id": 36408,
      "keyword": "bola de colores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huevo relleno": [
    {
      "id": 36409,
      "keyword": "huevo relleno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huevos rellenos": [
    {
      "id": 36409,
      "keyword": "huevo relleno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ensartable": [
    {
      "id": 36389,
      "keyword": "ensartable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37092,
      "keyword": "ensartable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manguera de incendios": [
    {
      "id": 36413,
      "keyword": "manguera de incendios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mangueras de incendios": [
    {
      "id": 36413,
      "keyword": "manguera de incendios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lámpara de calor": [
    {
      "id": 36407,
      "keyword": "lámpara de calor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lámparas de calor": [
    {
      "id": 36407,
      "keyword": "lámpara de calor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "locutorio": [
    {
      "id": 37906,
      "keyword": "locutorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36412,
      "keyword": "locutorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "locutorios": [
    {
      "id": 37906,
      "keyword": "locutorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36412,
      "keyword": "locutorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "medalla de bronce": [
    {
      "id": 36416,
      "keyword": "medalla de bronce",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medallas de bronce": [
    {
      "id": 36416,
      "keyword": "medalla de bronce",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "medalla de plata": [
    {
      "id": 36417,
      "keyword": "medalla de plata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medallas de plata": [
    {
      "id": 36417,
      "keyword": "medalla de plata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lámpara luminosa": [
    {
      "id": 36410,
      "keyword": "lámpara luminosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lámparas luminosas": [
    {
      "id": 36410,
      "keyword": "lámpara luminosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lámpara de fibra ": [
    {
      "id": 36410,
      "keyword": "lámpara de fibra ",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lámparas de fibra": [
    {
      "id": 36410,
      "keyword": "lámpara de fibra ",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "meter el almuerzo": [
    {
      "id": 36418,
      "keyword": "meter el almuerzo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "teaching activity",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dafo": [
    {
      "id": 36419,
      "keyword": "dafo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "masajeador de cabeza": [
    {
      "id": 36415,
      "keyword": "masajeador de cabeza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "masajeadores de cabeza": [
    {
      "id": 36415,
      "keyword": "masajeador de cabeza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paje": [
    {
      "id": 36420,
      "keyword": "paje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36421,
      "keyword": "paje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pajes": [
    {
      "id": 36420,
      "keyword": "paje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36421,
      "keyword": "paje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paje real": [
    {
      "id": 36420,
      "keyword": "paje real",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36421,
      "keyword": "paje real",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pajes reales": [
    {
      "id": 36420,
      "keyword": "paje real",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36421,
      "keyword": "paje real",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "panel japonés": [
    {
      "id": 36422,
      "keyword": "panel japonés",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paneles japoneses": [
    {
      "id": 36422,
      "keyword": "panel japonés",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cortina japonesa": [
    {
      "id": 36422,
      "keyword": "cortina japonesa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortinas japonesas": [
    {
      "id": 36422,
      "keyword": "cortina japonesa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "patatas asadas": [
    {
      "id": 36425,
      "keyword": "patatas asadas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patatas a lo pobre": [
    {
      "id": 36425,
      "keyword": "patatas a lo pobre",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papas asadas": [
    {
      "id": 36425,
      "keyword": "papas asadas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "película en dvd": [
    {
      "id": 36427,
      "keyword": "película en DVD",
      "keywords": 2,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "películas en dvd": [
    {
      "id": 36427,
      "keyword": "película en DVD",
      "keywords": 2,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "película en br": [
    {
      "id": 36427,
      "keyword": "película en BR",
      "keywords": 2,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "películas en br": [
    {
      "id": 36427,
      "keyword": "película en BR",
      "keywords": 2,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pescado a la plancha": [
    {
      "id": 36428,
      "keyword": "pescado a la plancha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pescados a la plancha": [
    {
      "id": 36428,
      "keyword": "pescado a la plancha",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pescado hervido": [
    {
      "id": 36429,
      "keyword": "pescado hervido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pescados hervidos": [
    {
      "id": 36429,
      "keyword": "pescado hervido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pescado en salsa de espárragos": [
    {
      "id": 36430,
      "keyword": "pescado en salsa de espárragos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pantalón del chándal": [
    {
      "id": 36423,
      "keyword": "pantalón del chándal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pantalones del chándal": [
    {
      "id": 36423,
      "keyword": "pantalón del chándal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sportswear",
        "clothing",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juego de piedra papel o tijera": [
    {
      "id": 36431,
      "keyword": "juego de piedra papel o tijera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ponerse serio": [
    {
      "id": 36434,
      "keyword": "ponerse serio",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner serio": [
    {
      "id": 36434,
      "keyword": "poner serio",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pisto": [
    {
      "id": 36432,
      "keyword": "pisto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botón de alarma": [
    {
      "id": 36435,
      "keyword": "botón de alarma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de alarma": [
    {
      "id": 36435,
      "keyword": "botón de alarma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pulsador de alarma": [
    {
      "id": 36435,
      "keyword": "pulsador de alarma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulsadores de alarma": [
    {
      "id": 36435,
      "keyword": "pulsador de alarma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "licornio": [
    {
      "id": 36436,
      "keyword": "licornio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "licornios": [
    {
      "id": 36436,
      "keyword": "licornio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "purpurina": [
    {
      "id": 36437,
      "keyword": "purpurina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "purpurinas": [
    {
      "id": 36437,
      "keyword": "purpurina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "cosmetic",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ramadán": [
    {
      "id": 36438,
      "keyword": "Ramadán",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "religion",
        "islamism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maicena": [
    {
      "id": 36414,
      "keyword": "maicena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plano inclinado": [
    {
      "id": 36433,
      "keyword": "plano inclinado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "planos inclinados": [
    {
      "id": 36433,
      "keyword": "plano inclinado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rodajas de berenjena": [
    {
      "id": 36443,
      "keyword": "rodajas de berenjena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacar el almuerzo": [
    {
      "id": 36444,
      "keyword": "sacar el almuerzo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "teaching activity",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "revuelto de ajetes": [
    {
      "id": 36442,
      "keyword": "revuelto de ajetes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "revueltos de ajetes": [
    {
      "id": 36442,
      "keyword": "revuelto de ajetes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sacar el cuaderno de comunicación": [
    {
      "id": 36447,
      "keyword": "sacar el cuaderno de comunicación",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de audiovisuales": [
    {
      "id": 36361,
      "keyword": "clase de audiovisuales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de audiovisuales": [
    {
      "id": 36361,
      "keyword": "clase de audiovisuales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "semáforo en ámbar": [
    {
      "id": 36445,
      "keyword": "semáforo en ámbar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sexóloga": [
    {
      "id": 36451,
      "keyword": "sexóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36450,
      "keyword": "sexóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sexólogas": [
    {
      "id": 36451,
      "keyword": "sexóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "sexuality"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36450,
      "keyword": "sexóloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "sexuality"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sogatira": [
    {
      "id": 36454,
      "keyword": "sogatira",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juego de la soga": [
    {
      "id": 36454,
      "keyword": "juego de la soga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tira y afloja": [
    {
      "id": 36454,
      "keyword": "tira y afloja",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teatro de luz negra": [
    {
      "id": 36455,
      "keyword": "teatro de luz negra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "theater",
        "show",
        "leisure",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sexólogo": [
    {
      "id": 36452,
      "keyword": "sexólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36453,
      "keyword": "sexólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "sexuality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sexólogos": [
    {
      "id": 36452,
      "keyword": "sexólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "sexuality"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36453,
      "keyword": "sexólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "sexuality"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "terapia de pareja": [
    {
      "id": 36457,
      "keyword": "terapia de pareja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36459,
      "keyword": "terapia de pareja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36461,
      "keyword": "terapia de pareja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36460,
      "keyword": "terapia de pareja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36458,
      "keyword": "terapia de pareja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36462,
      "keyword": "terapia de pareja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terapias de pareja": [
    {
      "id": 36457,
      "keyword": "terapia de pareja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36459,
      "keyword": "terapia de pareja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36461,
      "keyword": "terapia de pareja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36460,
      "keyword": "terapia de pareja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36458,
      "keyword": "terapia de pareja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36462,
      "keyword": "terapia de pareja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "restaurante chino": [
    {
      "id": 36440,
      "keyword": "restaurante chino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "restaurantes chinos": [
    {
      "id": 36440,
      "keyword": "restaurante chino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reutilizar": [
    {
      "id": 36441,
      "keyword": "reutilizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gavetero": [
    {
      "id": 36396,
      "keyword": "gavetero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gaveteros": [
    {
      "id": 36396,
      "keyword": "gavetero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clasificador": [
    {
      "id": 36396,
      "keyword": "clasificador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clasificadores": [
    {
      "id": 36396,
      "keyword": "clasificador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de cortinas": [
    {
      "id": 36463,
      "keyword": "tienda de cortinas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de cortinas": [
    {
      "id": 36463,
      "keyword": "tienda de cortinas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de ropa de casa": [
    {
      "id": 36465,
      "keyword": "tienda de ropa de casa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de ropa de casa": [
    {
      "id": 36465,
      "keyword": "tienda de ropa de casa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de ropa flamenca": [
    {
      "id": 36466,
      "keyword": "tienda de ropa flamenca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de ropa flamenca": [
    {
      "id": 36466,
      "keyword": "tienda de ropa flamenca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tiras de colores": [
    {
      "id": 36467,
      "keyword": "tiras de colores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kinesio tapes": [
    {
      "id": 36467,
      "keyword": "kinesio tapes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de persianas": [
    {
      "id": 36464,
      "keyword": "tienda de persianas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de persianas": [
    {
      "id": 36464,
      "keyword": "tienda de persianas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tens": [
    {
      "id": 36456,
      "keyword": "tens",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "electroestimulador": [
    {
      "id": 36456,
      "keyword": "electroestimulador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torta de pan": [
    {
      "id": 36469,
      "keyword": "torta de pan",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortas de pan": [
    {
      "id": 36469,
      "keyword": "torta de pan",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pan de pita": [
    {
      "id": 36469,
      "keyword": "pan de pita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panes de pita": [
    {
      "id": 36469,
      "keyword": "pan de pita",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "traje de flamenca": [
    {
      "id": 36471,
      "keyword": "traje de flamenca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trajes de flamenca": [
    {
      "id": 36471,
      "keyword": "traje de flamenca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "turrón de jijona": [
    {
      "id": 36475,
      "keyword": "turrón de jijona",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "turrones de jijona": [
    {
      "id": 36475,
      "keyword": "turrón de jijona",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "turrón blando": [
    {
      "id": 36475,
      "keyword": "turrón blando",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "turrones blandos": [
    {
      "id": 36475,
      "keyword": "turrón blando",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ir al colegio": [
    {
      "id": 36473,
      "keyword": "ir al colegio",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "education",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tocar el tambor": [
    {
      "id": 36468,
      "keyword": "tocar el tambor",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "transgénero": [
    {
      "id": 36472,
      "keyword": "transgénero",
      "keywords": 1,
      "type": 4,
      "tags": [
        "sexuality",
        "gender identity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "turrón de chocolate": [
    {
      "id": 36474,
      "keyword": "turrón de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "turrones de chocolote": [
    {
      "id": 36474,
      "keyword": "turrón de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trackball": [
    {
      "id": 36470,
      "keyword": "trackball",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trackballs": [
    {
      "id": 36470,
      "keyword": "trackball",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cineforum": [
    {
      "id": 36477,
      "keyword": "cineforum",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cineforums": [
    {
      "id": 36477,
      "keyword": "cineforum",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parecer": [
    {
      "id": 36480,
      "keyword": "parecer",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary",
        "adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrir las puertas": [
    {
      "id": 36483,
      "keyword": "abrir las puertas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36871,
      "keyword": "abrir las puertas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dormida sobre la mesa": [
    {
      "id": 36485,
      "keyword": "dormida sobre la mesa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dormidas sobre la mesa": [
    {
      "id": 36485,
      "keyword": "dormida sobre la mesa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dormida en clase": [
    {
      "id": 36485,
      "keyword": "dormida en clase",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dormidas en clase": [
    {
      "id": 36485,
      "keyword": "dormida en clase",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dormido sobre la mesa": [
    {
      "id": 36486,
      "keyword": "dormido sobre la mesa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dormidos sobre la mesa": [
    {
      "id": 36486,
      "keyword": "dormido sobre la mesa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dormido en clase": [
    {
      "id": 36486,
      "keyword": "dormido en clase",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dormidos en clase": [
    {
      "id": 36486,
      "keyword": "dormido en clase",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alpargata": [
    {
      "id": 36487,
      "keyword": "alpargata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arándano": [
    {
      "id": 36488,
      "keyword": "arándano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dormir en clase": [
    {
      "id": 36489,
      "keyword": "dormir en clase",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dormir sobre la mesa": [
    {
      "id": 36489,
      "keyword": "dormir sobre la mesa",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "árbitra de boccia": [
    {
      "id": 36490,
      "keyword": "árbitra de boccia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport rules",
        "adapted sport",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "árbitras de boccia": [
    {
      "id": 36490,
      "keyword": "árbitra de boccia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport rules",
        "adapted sport",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "árbitro de boccia": [
    {
      "id": 36491,
      "keyword": "árbitro de boccia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport rules",
        "adapted sport",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "árbitros de boccia": [
    {
      "id": 36491,
      "keyword": "árbitro de boccia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport rules",
        "adapted sport",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arrodillado": [
    {
      "id": 36492,
      "keyword": "arrodillado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arrodillados": [
    {
      "id": 36492,
      "keyword": "arrodillado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tirar a canasta": [
    {
      "id": 36495,
      "keyword": "tirar a canasta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36674,
      "keyword": "tirar a canasta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39400,
      "keyword": "tirar a canasta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "basketball",
        "adapted sport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar los leotardos": [
    {
      "id": 36497,
      "keyword": "bajar los leotardos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar la media": [
    {
      "id": 36498,
      "keyword": "quitar la media",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bota de montaña": [
    {
      "id": 36502,
      "keyword": "bota de montaña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bota de fútbol": [
    {
      "id": 36503,
      "keyword": "bota de fútbol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vitamina": [
    {
      "id": 36504,
      "keyword": "vitamina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bote de vitaminas": [
    {
      "id": 36504,
      "keyword": "bote de vitaminas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botes de vitaminas": [
    {
      "id": 36504,
      "keyword": "bote de vitaminas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "butaca": [
    {
      "id": 36505,
      "keyword": "butaca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "scenic art",
        "theater",
        "show",
        "cinema",
        "event",
        "social event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "butacas": [
    {
      "id": 36505,
      "keyword": "butaca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "scenic art",
        "theater",
        "show",
        "cinema",
        "event",
        "social event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calentamiento": [
    {
      "id": 36506,
      "keyword": "calentamiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "canica": [
    {
      "id": 36507,
      "keyword": "canica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolilla": [
    {
      "id": 36507,
      "keyword": "bolilla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolita": [
    {
      "id": 36507,
      "keyword": "bolita",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caridad": [
    {
      "id": 36508,
      "keyword": "caridad",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "casco romano": [
    {
      "id": 36509,
      "keyword": "casco romano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "history",
        "civilization",
        "Rome",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cascos romanos": [
    {
      "id": 36509,
      "keyword": "casco romano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "history",
        "civilization",
        "Rome",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chocar los puños": [
    {
      "id": 36510,
      "keyword": "chocar los puños",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "choque de puños": [
    {
      "id": 36510,
      "keyword": "choque de puños",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacar el cepillo": [
    {
      "id": 36511,
      "keyword": "sacar el cepillo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coger una toallita": [
    {
      "id": 36512,
      "keyword": "coger una toallita",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomar una toallita": [
    {
      "id": 36512,
      "keyword": "tomar una toallita",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cúpula": [
    {
      "id": 36514,
      "keyword": "cúpula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cúpulas": [
    {
      "id": 36514,
      "keyword": "cúpula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dátil": [
    {
      "id": 36515,
      "keyword": "dátil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "defender el tiro": [
    {
      "id": 36517,
      "keyword": "defender el tiro",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39401,
      "keyword": "defender el tiro",
      "keywords": 1,
      "type": null,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "basketball",
        "adapted sport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desfibrilador": [
    {
      "id": 36519,
      "keyword": "desfibrilador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desfibriladores": [
    {
      "id": 36519,
      "keyword": "desfibrilador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dispensador de jabón": [
    {
      "id": 36524,
      "keyword": "dispensador de jabón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dispensadores de jabón": [
    {
      "id": 36524,
      "keyword": "dispensador de jabón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "entrenador de baloncesto": [
    {
      "id": 38544,
      "keyword": "entrenador de baloncesto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport rules",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36526,
      "keyword": "entrenador de baloncesto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport rules",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entrenadores de baloncesto": [
    {
      "id": 38544,
      "keyword": "entrenador de baloncesto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport rules",
        "basketball"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36526,
      "keyword": "entrenador de baloncesto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport rules",
        "basketball"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "entrenadora de baloncesto": [
    {
      "id": 38544,
      "keyword": "entrenadora de baloncesto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport rules",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36527,
      "keyword": "entrenadora de baloncesto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport rules",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entrenadoras de baloncesto": [
    {
      "id": 38544,
      "keyword": "entrenadora de baloncesto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport rules",
        "basketball"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36527,
      "keyword": "entrenadora de baloncesto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport rules",
        "basketball"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "elevador": [
    {
      "id": 36528,
      "keyword": "elevador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "elevadores": [
    {
      "id": 36528,
      "keyword": "elevador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alzador": [
    {
      "id": 36528,
      "keyword": "alzador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alzadores": [
    {
      "id": 36528,
      "keyword": "alzador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alzador para butaca": [
    {
      "id": 36528,
      "keyword": "alzador para butaca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alzadores para butaca": [
    {
      "id": 36528,
      "keyword": "alzador para butaca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "entrenadora": [
    {
      "id": 38542,
      "keyword": "entrenadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport rules",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36529,
      "keyword": "entrenadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport rules",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entrenadoras": [
    {
      "id": 38542,
      "keyword": "entrenadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport rules",
        "football"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36529,
      "keyword": "entrenadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "sport",
        "sport rules",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "equipo de orientación": [
    {
      "id": 36532,
      "keyword": "equipo de orientación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equipos de orientación": [
    {
      "id": 36532,
      "keyword": "equipo de orientación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fe": [
    {
      "id": 36538,
      "keyword": "fe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36704,
      "keyword": "fe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fortaleza": [
    {
      "id": 36539,
      "keyword": "fortaleza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37621,
      "keyword": "fortaleza",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "middle ages",
        "building"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frambuesa": [
    {
      "id": 36540,
      "keyword": "frambuesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guardar el cepillo": [
    {
      "id": 36542,
      "keyword": "guardar el cepillo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "la meca": [
    {
      "id": 36550,
      "keyword": "La Meca",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "building",
        "religion",
        "islamism",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillón lavacabezas": [
    {
      "id": 36554,
      "keyword": "sillón lavacabezas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillones lavacabezas": [
    {
      "id": 36554,
      "keyword": "sillón lavacabezas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lavacabezas": [
    {
      "id": 36554,
      "keyword": "lavacabezas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiar el pis": [
    {
      "id": 38409,
      "keyword": "limpiar el pis",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36555,
      "keyword": "limpiar el pis",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "object",
        "hygiene product",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36652,
      "keyword": "limpiar el pis",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36653,
      "keyword": "limpiar el pis",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "linier": [
    {
      "id": 36556,
      "keyword": "linier",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport rules",
        "football"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36557,
      "keyword": "linier",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport rules",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "linieres": [
    {
      "id": 36556,
      "keyword": "linier",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport rules",
        "football"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36557,
      "keyword": "linier",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport rules",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maquinilla": [
    {
      "id": 36558,
      "keyword": "maquinilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maquinillas": [
    {
      "id": 36558,
      "keyword": "maquinilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maquinilla de cortar pelo": [
    {
      "id": 36558,
      "keyword": "maquinilla de cortar pelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maquinillas de cortar pelo": [
    {
      "id": 36558,
      "keyword": "maquinilla de cortar pelo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "work",
        "tool",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "niños de perfil": [
    {
      "id": 36561,
      "keyword": "niños de perfil",
      "keywords": 3,
      "type": 2,
      "tags": [
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "de perfil": [
    {
      "id": 36561,
      "keyword": "de perfil",
      "keywords": 3,
      "type": 4,
      "tags": [
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pechina": [
    {
      "id": 36565,
      "keyword": "pechina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pechinas": [
    {
      "id": 36565,
      "keyword": "pechina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pepinillo": [
    {
      "id": 36567,
      "keyword": "pepinillo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pezonera": [
    {
      "id": 36568,
      "keyword": "pezonera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plano basculante": [
    {
      "id": 36570,
      "keyword": "plano basculante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "planos basculantes": [
    {
      "id": 36570,
      "keyword": "plano basculante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "poner el bañador": [
    {
      "id": 36571,
      "keyword": "poner el bañador",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36572,
      "keyword": "poner el bañador",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner la malla": [
    {
      "id": 36572,
      "keyword": "poner la malla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner el calcetín": [
    {
      "id": 36573,
      "keyword": "poner el calcetín",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner el babi": [
    {
      "id": 36574,
      "keyword": "poner el babi",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner la bota": [
    {
      "id": 36575,
      "keyword": "poner la bota",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner la bufanda": [
    {
      "id": 36576,
      "keyword": "poner la bufanda",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner la gorra": [
    {
      "id": 36577,
      "keyword": "poner la gorra",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "psicólogo clínico": [
    {
      "id": 36578,
      "keyword": "psicólogo clínico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "psychology",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37670,
      "keyword": "psicólogo clínico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "psychology",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38871,
      "keyword": "psicólogo clínico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine",
        "health",
        "psychology",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38872,
      "keyword": "psicólogo clínico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "psychology",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "psicólogos clínicos": [
    {
      "id": 36578,
      "keyword": "psicólogo clínico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "psychology",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37670,
      "keyword": "psicólogo clínico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "psychology",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38871,
      "keyword": "psicólogo clínico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine",
        "health",
        "psychology",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38872,
      "keyword": "psicólogo clínico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "psychology",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "psicóloga clínica": [
    {
      "id": 36578,
      "keyword": "psicóloga clínica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "psychology",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37670,
      "keyword": "psicóloga clínica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "psychology",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38871,
      "keyword": "psicóloga clínica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine",
        "health",
        "psychology",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38872,
      "keyword": "psicóloga clínica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "psychology",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "psicólogas clínicas": [
    {
      "id": 36578,
      "keyword": "psicóloga clínica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "psychology",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37670,
      "keyword": "psicóloga clínica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "psychology",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38871,
      "keyword": "psicóloga clínica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine",
        "health",
        "psychology",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38872,
      "keyword": "psicóloga clínica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "psychology",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quitar el bañador": [
    {
      "id": 36579,
      "keyword": "quitar el bañador",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36607,
      "keyword": "quitar el bañador",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar el calcetín": [
    {
      "id": 36581,
      "keyword": "quitar el calcetín",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar la gorra": [
    {
      "id": 36582,
      "keyword": "quitar la gorra",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rabanito": [
    {
      "id": 36583,
      "keyword": "rabanito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "radióloga": [
    {
      "id": 38831,
      "keyword": "radióloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36584,
      "keyword": "radióloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "radiólogas": [
    {
      "id": 38831,
      "keyword": "radióloga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36584,
      "keyword": "radióloga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "radiólogo": [
    {
      "id": 38831,
      "keyword": "radiólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36585,
      "keyword": "radiólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "radiólogos": [
    {
      "id": 38831,
      "keyword": "radiólogo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36585,
      "keyword": "radiólogo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "robar el balón": [
    {
      "id": 36587,
      "keyword": "robar el balón",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacar el peine": [
    {
      "id": 36590,
      "keyword": "sacar el peine",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sentar en semicírculo": [
    {
      "id": 36592,
      "keyword": "sentar en semicírculo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir al autobús": [
    {
      "id": 36968,
      "keyword": "subir al autobús",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36595,
      "keyword": "subir al autobús",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36593,
      "keyword": "subir al autobús",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36594,
      "keyword": "subir al autobús",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "montar en autobús": [
    {
      "id": 36968,
      "keyword": "montar en autobús",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36595,
      "keyword": "montar en autobús",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36593,
      "keyword": "montar en autobús",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36594,
      "keyword": "montar en autobús",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir al colectivo": [
    {
      "id": 36595,
      "keyword": "subir al colectivo",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36593,
      "keyword": "subir al colectivo",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36594,
      "keyword": "subir al colectivo",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir al micro": [
    {
      "id": 36595,
      "keyword": "subir al micro",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36593,
      "keyword": "subir al micro",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36594,
      "keyword": "subir al micro",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner la media": [
    {
      "id": 36596,
      "keyword": "poner la media",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir los leotardos": [
    {
      "id": 36597,
      "keyword": "subir los leotardos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sudorosa": [
    {
      "id": 36598,
      "keyword": "sudorosa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sudorosas": [
    {
      "id": 36598,
      "keyword": "sudorosa",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "symptom",
        "human body",
        "body sensation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tapón para los oídos": [
    {
      "id": 36599,
      "keyword": "tapón para los oídos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ser paciente": [
    {
      "id": 36600,
      "keyword": "ser paciente",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "core vocabulary",
        "psychology",
        "human response",
        "education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiza": [
    {
      "id": 36602,
      "keyword": "tiza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tubillón": [
    {
      "id": 36604,
      "keyword": "tubillón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yeguada": [
    {
      "id": 36605,
      "keyword": "yeguada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing",
        "leisure",
        "sport",
        "horse riding",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yeguadas": [
    {
      "id": 36605,
      "keyword": "yeguada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing",
        "leisure",
        "sport",
        "horse riding",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zueco": [
    {
      "id": 36606,
      "keyword": "zueco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38693,
      "keyword": "zueco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear",
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar la malla": [
    {
      "id": 36607,
      "keyword": "quitar la malla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vestuario de la árbitra": [
    {
      "id": 36609,
      "keyword": "vestuario de la árbitra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vestuarios de la árbitra": [
    {
      "id": 36609,
      "keyword": "vestuario de la árbitra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vestuario del árbitro": [
    {
      "id": 36610,
      "keyword": "vestuario del árbitro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vestuarios del árbitro": [
    {
      "id": 36610,
      "keyword": "vestuario del árbitro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "compostador": [
    {
      "id": 36611,
      "keyword": "compostador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compostadores": [
    {
      "id": 36611,
      "keyword": "compostador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "báscula de cocina": [
    {
      "id": 36618,
      "keyword": "báscula de cocina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "básculas de cocina": [
    {
      "id": 36618,
      "keyword": "báscula de cocina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peso de cocina": [
    {
      "id": 36618,
      "keyword": "peso de cocina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pesos de cocina": [
    {
      "id": 36618,
      "keyword": "peso de cocina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "base aérea": [
    {
      "id": 36619,
      "keyword": "base aérea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bases aéreas": [
    {
      "id": 36619,
      "keyword": "base aérea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolígrafos de colores": [
    {
      "id": 36620,
      "keyword": "bolígrafos de colores",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "montar claras": [
    {
      "id": 36621,
      "keyword": "montar claras",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "batir la clara": [
    {
      "id": 36621,
      "keyword": "batir la clara",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "briouat de gambas": [
    {
      "id": 36622,
      "keyword": "briouat de gambas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "briouats de gambas": [
    {
      "id": 36622,
      "keyword": "briouat de gambas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "breua de gambas": [
    {
      "id": 36622,
      "keyword": "breua de gambas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "breuas de gambas": [
    {
      "id": 36622,
      "keyword": "breua de gambas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "buque de guerra": [
    {
      "id": 36623,
      "keyword": "buque de guerra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buques de guerra": [
    {
      "id": 36623,
      "keyword": "buque de guerra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fragata": [
    {
      "id": 36623,
      "keyword": "fragata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fragatas": [
    {
      "id": 36623,
      "keyword": "fragata",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "briouat de pollo": [
    {
      "id": 36624,
      "keyword": "briouat de pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "briouats de pollo": [
    {
      "id": 36624,
      "keyword": "briouat de pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "breua de pollo": [
    {
      "id": 36624,
      "keyword": "breua de pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "breuas de pollo": [
    {
      "id": 36624,
      "keyword": "breua de pollo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cápsulas de café": [
    {
      "id": 36625,
      "keyword": "cápsulas de café",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chilaba": [
    {
      "id": 36626,
      "keyword": "chilaba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chilabas": [
    {
      "id": 36626,
      "keyword": "chilaba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jellaba": [
    {
      "id": 36626,
      "keyword": "jellaba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jellabas": [
    {
      "id": 36626,
      "keyword": "jellaba",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chuparquia": [
    {
      "id": 36627,
      "keyword": "chuparquia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chuparquias": [
    {
      "id": 36627,
      "keyword": "chuparquia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chebakia": [
    {
      "id": 36627,
      "keyword": "chebakia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chebakias": [
    {
      "id": 36627,
      "keyword": "chebakia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "shebbakiyya": [
    {
      "id": 36627,
      "keyword": "shebbakiyya",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "shebbakiyyas": [
    {
      "id": 36627,
      "keyword": "shebbakiyya",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coger el cuchillo": [
    {
      "id": 36628,
      "keyword": "coger el cuchillo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "cutlery",
        "home",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coger cuchillo y tenedor": [
    {
      "id": 36628,
      "keyword": "coger cuchillo y tenedor",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "cutlery",
        "home",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomar el cuchillo": [
    {
      "id": 36628,
      "keyword": "tomar el cuchillo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "cutlery",
        "home",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coger el tenedor": [
    {
      "id": 36629,
      "keyword": "coger el tenedor",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "cutlery",
        "home",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomar el tenedor": [
    {
      "id": 36629,
      "keyword": "tomar el tenedor",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "cutlery",
        "home",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortar un filete": [
    {
      "id": 36632,
      "keyword": "cortar un filete",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "animal-based food",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortar la comida": [
    {
      "id": 36632,
      "keyword": "cortar la comida",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "animal-based food",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entrar a canasta": [
    {
      "id": 36636,
      "keyword": "entrar a canasta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entrada a canasta": [
    {
      "id": 36636,
      "keyword": "entrada a canasta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gong": [
    {
      "id": 36639,
      "keyword": "gong",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gongs": [
    {
      "id": 36639,
      "keyword": "gong",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hercules": [
    {
      "id": 36641,
      "keyword": "Hercules",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "c-130": [
    {
      "id": 36641,
      "keyword": "C-130",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "avión de transporte": [
    {
      "id": 36641,
      "keyword": "avión de transporte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aviones de transporte": [
    {
      "id": 36641,
      "keyword": "avión de transporte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "harira": [
    {
      "id": 36642,
      "keyword": "harira",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hariras": [
    {
      "id": 36642,
      "keyword": "harira",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jabador": [
    {
      "id": 36643,
      "keyword": "jabador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jabadores": [
    {
      "id": 36643,
      "keyword": "jabador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juego de la muralla": [
    {
      "id": 36647,
      "keyword": "juego de la muralla",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juego de la araña": [
    {
      "id": 36647,
      "keyword": "juego de la araña",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bulldog": [
    {
      "id": 36647,
      "keyword": "Bulldog",
      "keywords": 3,
      "type": 1,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caftán": [
    {
      "id": 36648,
      "keyword": "caftán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caftanes": [
    {
      "id": 36648,
      "keyword": "caftán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "kefta": [
    {
      "id": 36649,
      "keyword": "kefta",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36650,
      "keyword": "kefta",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "keftas": [
    {
      "id": 36649,
      "keyword": "kefta",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36650,
      "keyword": "kefta",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "kefta de cordero": [
    {
      "id": 36649,
      "keyword": "kefta de cordero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "keftas de cordero": [
    {
      "id": 36649,
      "keyword": "kefta de cordero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "kofta": [
    {
      "id": 36649,
      "keyword": "kofta",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36650,
      "keyword": "kofta",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "koftas": [
    {
      "id": 36649,
      "keyword": "kofta",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36650,
      "keyword": "kofta",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "kofta de cordero": [
    {
      "id": 36649,
      "keyword": "kofta de cordero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "koftas de cordero": [
    {
      "id": 36649,
      "keyword": "kofta de cordero",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "kefta de ternera": [
    {
      "id": 36650,
      "keyword": "kefta de ternera",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "keftas de ternera": [
    {
      "id": 36650,
      "keyword": "kefta de ternera",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "kofta de ternera": [
    {
      "id": 36650,
      "keyword": "kofta de ternera",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36650,
      "keyword": "kofta de ternera",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ladrillo de psicomotricidad": [
    {
      "id": 36651,
      "keyword": "ladrillo de psicomotricidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ladrillos de psicomotricidad": [
    {
      "id": 36651,
      "keyword": "ladrillo de psicomotricidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pinchar la comida": [
    {
      "id": 36654,
      "keyword": "pinchar la comida",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "cutlery",
        "home",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36658,
      "keyword": "pinchar la comida",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "cutlery",
        "home",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "preparado para comer": [
    {
      "id": 36655,
      "keyword": "preparado para comer",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "cutlery",
        "home",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "listo para comer": [
    {
      "id": 36655,
      "keyword": "listo para comer",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "cutlery",
        "home",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puf": [
    {
      "id": 36660,
      "keyword": "puf",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pufs": [
    {
      "id": 36660,
      "keyword": "puf",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recoger el equipaje": [
    {
      "id": 36661,
      "keyword": "recoger el equipaje",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recogida de equipajes": [
    {
      "id": 36662,
      "keyword": "recogida de equipajes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recogidas de equipajes": [
    {
      "id": 36662,
      "keyword": "recogida de equipajes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rúa de carnaval": [
    {
      "id": 36663,
      "keyword": "rúa de carnaval",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "carnival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rúas de carnaval": [
    {
      "id": 36663,
      "keyword": "rúa de carnaval",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "carnival"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desfile de carnaval": [
    {
      "id": 36663,
      "keyword": "desfile de carnaval",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "carnival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desfiles de carnaval": [
    {
      "id": 36663,
      "keyword": "desfile de carnaval",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "carnival"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salvamanteles": [
    {
      "id": 36664,
      "keyword": "salvamanteles",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "trousseau",
        "home",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38710,
      "keyword": "salvamanteles",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "somalia": [
    {
      "id": 36665,
      "keyword": "Somalia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36666,
      "keyword": "Somalia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de electrónica y electricidad": [
    {
      "id": 36667,
      "keyword": "tienda de electrónica y electricidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "music device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de electronica y electricidad": [
    {
      "id": 36667,
      "keyword": "tienda de electrónica y electricidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "music device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "timbal": [
    {
      "id": 36669,
      "keyword": "timbal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "timbales": [
    {
      "id": 36669,
      "keyword": "timbal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36670,
      "keyword": "timbales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tirar la compresa": [
    {
      "id": 36671,
      "keyword": "tirar la compresa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "intimate hygiene",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38607,
      "keyword": "tirar la compresa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "intimate hygiene",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "túnel de tela": [
    {
      "id": 36672,
      "keyword": "túnel de tela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "túneles de tela": [
    {
      "id": 36672,
      "keyword": "túnel de tela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "urgente": [
    {
      "id": 36675,
      "keyword": "urgente",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "urgentes": [
    {
      "id": 36675,
      "keyword": "urgente",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apremiante": [
    {
      "id": 36675,
      "keyword": "apremiante",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apremiantes": [
    {
      "id": 36675,
      "keyword": "apremiante",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acuciante": [
    {
      "id": 36675,
      "keyword": "acuciante",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acuciantes": [
    {
      "id": 36675,
      "keyword": "acuciante",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juego de enroscar": [
    {
      "id": 36676,
      "keyword": "juego de enroscar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos de enroscar": [
    {
      "id": 36676,
      "keyword": "juego de enroscar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "yogurtera": [
    {
      "id": 36677,
      "keyword": "yogurtera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yogurteras": [
    {
      "id": 36677,
      "keyword": "yogurtera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zancos": [
    {
      "id": 36678,
      "keyword": "zancos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calima": [
    {
      "id": 36681,
      "keyword": "calima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calimas": [
    {
      "id": 36681,
      "keyword": "calima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botiquín árabe": [
    {
      "id": 36683,
      "keyword": "botiquín árabe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botiquines árabes": [
    {
      "id": 36683,
      "keyword": "botiquín árabe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carne envasada de cerdo": [
    {
      "id": 36684,
      "keyword": "carne envasada de cerdo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carne envasada de conejo": [
    {
      "id": 36685,
      "keyword": "carne envasada de conejo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botiquín judío": [
    {
      "id": 36686,
      "keyword": "botiquín judío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botiquines judíos": [
    {
      "id": 36686,
      "keyword": "botiquín judío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pañuelo tubular": [
    {
      "id": 36687,
      "keyword": "pañuelo tubular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pañuelos tubulares": [
    {
      "id": 36687,
      "keyword": "pañuelo tubular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calmar": [
    {
      "id": 36688,
      "keyword": "calmar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carne envasada de ternera": [
    {
      "id": 36689,
      "keyword": "carne envasada de ternera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carne envasada de cordero": [
    {
      "id": 36690,
      "keyword": "carne envasada de cordero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carne envasada de pavo": [
    {
      "id": 36691,
      "keyword": "carne envasada de pavo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carne envasada de pollo": [
    {
      "id": 36692,
      "keyword": "carne envasada de pollo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alimentos de juguete": [
    {
      "id": 36693,
      "keyword": "alimentos de juguete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "confiar": [
    {
      "id": 36694,
      "keyword": "confiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36695,
      "keyword": "confiar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "confinamiento": [
    {
      "id": 36696,
      "keyword": "confinamiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "confinamientos": [
    {
      "id": 36696,
      "keyword": "confinamiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuarentena": [
    {
      "id": 36696,
      "keyword": "cuarentena",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38391,
      "keyword": "cuarentena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "aquatic animal",
        "veterinary medicine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuarentenas": [
    {
      "id": 36696,
      "keyword": "cuarentena",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38391,
      "keyword": "cuarentena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "aquatic animal",
        "veterinary medicine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "criticar": [
    {
      "id": 36697,
      "keyword": "criticar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "día de puertas abiertas": [
    {
      "id": 36698,
      "keyword": "día de puertas abiertas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "días de puertas abiertas": [
    {
      "id": 36698,
      "keyword": "día de puertas abiertas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "empresa de limpieza": [
    {
      "id": 36700,
      "keyword": "empresa de limpieza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empresas de limpieza": [
    {
      "id": 36700,
      "keyword": "empresa de limpieza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mantener la distancia de seguridad": [
    {
      "id": 36702,
      "keyword": "mantener la distancia de seguridad",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36725,
      "keyword": "mantener la distancia de seguridad",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36987,
      "keyword": "mantener la distancia de seguridad",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37096,
      "keyword": "mantener la distancia de seguridad",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37245,
      "keyword": "mantener la distancia de seguridad",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36701,
      "keyword": "mantener la distancia de seguridad",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "distancia de seguridad": [
    {
      "id": 37271,
      "keyword": "distancia de seguridad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36702,
      "keyword": "distancia de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36725,
      "keyword": "distancia de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36987,
      "keyword": "distancia de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37096,
      "keyword": "distancia de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37245,
      "keyword": "distancia de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36701,
      "keyword": "distancia de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frotis nasal": [
    {
      "id": 36703,
      "keyword": "frotis nasal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "feminismo": [
    {
      "id": 36705,
      "keyword": "feminismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "feminista": [
    {
      "id": 36707,
      "keyword": "feminista",
      "keywords": 1,
      "type": 4,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36713,
      "keyword": "feminista",
      "keywords": 1,
      "type": 4,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "feministas": [
    {
      "id": 36707,
      "keyword": "feminista",
      "keywords": 1,
      "type": 4,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36713,
      "keyword": "feminista",
      "keywords": 1,
      "type": 4,
      "tags": [
        "sociology",
        "social movement"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "intereses restringidos": [
    {
      "id": 36711,
      "keyword": "intereses restringidos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "machismo": [
    {
      "id": 36712,
      "keyword": "machismo",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "niña con pañal": [
    {
      "id": 36715,
      "keyword": "niña con pañal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niñas con pañal": [
    {
      "id": 36715,
      "keyword": "niña con pañal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "niño con pañal": [
    {
      "id": 36716,
      "keyword": "niño con pañal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niños con pañal": [
    {
      "id": 36716,
      "keyword": "niño con pañal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "obsesión": [
    {
      "id": 36717,
      "keyword": "obsesión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obsesiones": [
    {
      "id": 36717,
      "keyword": "obsesión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fijación": [
    {
      "id": 36717,
      "keyword": "fijación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fijaciones": [
    {
      "id": 36717,
      "keyword": "fijación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "obsesionar": [
    {
      "id": 36718,
      "keyword": "obsesionar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿por qué?": [
    {
      "id": 36719,
      "keyword": "¿por qué?",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porqué": [
    {
      "id": 36719,
      "keyword": "porqué",
      "keywords": 3,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "interrogative pronoun",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rotulador permanente": [
    {
      "id": 36721,
      "keyword": "rotulador permanente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rotuladores permanentes": [
    {
      "id": 36721,
      "keyword": "rotulador permanente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rotulador para pizarra": [
    {
      "id": 36722,
      "keyword": "rotulador para pizarra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rotuladores para pizarra": [
    {
      "id": 36722,
      "keyword": "rotulador para pizarra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "superhéroes": [
    {
      "id": 36728,
      "keyword": "superhéroes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "comic character",
        "comic",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teletrabajo": [
    {
      "id": 36731,
      "keyword": "teletrabajo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de bacalao": [
    {
      "id": 36732,
      "keyword": "tienda de bacalao",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de bacalao": [
    {
      "id": 36732,
      "keyword": "tienda de bacalao",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "fish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "toser en la cara": [
    {
      "id": 36733,
      "keyword": "toser en la cara",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toser en el codo": [
    {
      "id": 36734,
      "keyword": "toser en el codo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tutoría": [
    {
      "id": 36735,
      "keyword": "tutoría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tutorías": [
    {
      "id": 36735,
      "keyword": "tutoría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sentir vergüenza ajena": [
    {
      "id": 36736,
      "keyword": "sentir vergüenza ajena",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "wonder woman": [
    {
      "id": 36737,
      "keyword": "Wonder Woman",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "comic character",
        "comic",
        "movie character",
        "cinema"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ő": [
    {
      "id": 36738,
      "keyword": "Ő",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36775,
      "keyword": "ő",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cs": [
    {
      "id": 36739,
      "keyword": "CS",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36784,
      "keyword": "cs",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "á": [
    {
      "id": 36740,
      "keyword": "Á",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36785,
      "keyword": "á",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dzs": [
    {
      "id": 36741,
      "keyword": "DZS",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36781,
      "keyword": "dzs",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dz": [
    {
      "id": 36742,
      "keyword": "DZ",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36782,
      "keyword": "dz",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "í": [
    {
      "id": 36743,
      "keyword": "Í",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36779,
      "keyword": "í",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "é": [
    {
      "id": 36744,
      "keyword": "É",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36783,
      "keyword": "é",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ly": [
    {
      "id": 36745,
      "keyword": "LY",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36778,
      "keyword": "ly",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ny": [
    {
      "id": 36746,
      "keyword": "NY",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36777,
      "keyword": "ny",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gy": [
    {
      "id": 36747,
      "keyword": "GY",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36780,
      "keyword": "gy",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sz": [
    {
      "id": 36748,
      "keyword": "SZ",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36773,
      "keyword": "sz",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ó": [
    {
      "id": 36749,
      "keyword": "Ó",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36776,
      "keyword": "ó",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ö": [
    {
      "id": 36750,
      "keyword": "Ö",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36774,
      "keyword": "ö",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ű": [
    {
      "id": 36751,
      "keyword": "Ű",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36771,
      "keyword": "ű",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ü": [
    {
      "id": 36752,
      "keyword": "Ü",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36772,
      "keyword": "ü",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zs": [
    {
      "id": 36753,
      "keyword": "ZS",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36768,
      "keyword": "zs",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ú": [
    {
      "id": 36754,
      "keyword": "Ú",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36769,
      "keyword": "ú",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ty": [
    {
      "id": 36755,
      "keyword": "TY",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36770,
      "keyword": "ty",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "language",
        "alphabet",
        "letter"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desconfinamiento": [
    {
      "id": 36756,
      "keyword": "desconfinamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desconfinamientos": [
    {
      "id": 36756,
      "keyword": "desconfinamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desescalada": [
    {
      "id": 36756,
      "keyword": "desescalada",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desescaladas": [
    {
      "id": 36756,
      "keyword": "desescalada",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desescalar": [
    {
      "id": 36756,
      "keyword": "desescalar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "echar gel hidroalcohólico": [
    {
      "id": 36760,
      "keyword": "echar gel hidroalcohólico",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37410,
      "keyword": "echar gel hidroalcohólico",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "echar higienizante": [
    {
      "id": 36760,
      "keyword": "echar higienizante",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37410,
      "keyword": "echar higienizante",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "echar higienizante de manos": [
    {
      "id": 36760,
      "keyword": "echar higienizante de manos",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37410,
      "keyword": "echar higienizante de manos",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desinfección de manos": [
    {
      "id": 36860,
      "keyword": "desinfección de manos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36918,
      "keyword": "desinfección de manos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37030,
      "keyword": "desinfección de manos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37031,
      "keyword": "desinfección de manos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37032,
      "keyword": "desinfección de manos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37033,
      "keyword": "desinfección de manos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36760,
      "keyword": "desinfección de manos",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37410,
      "keyword": "desinfección de manos",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desinfectante para manos": [
    {
      "id": 36761,
      "keyword": "desinfectante para manos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "medicine",
        "medical equipment",
        "covid-19",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desinfectantes para manos": [
    {
      "id": 36761,
      "keyword": "desinfectante para manos",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "medicine",
        "medical equipment",
        "covid-19",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gel hidroalcohólico": [
    {
      "id": 36761,
      "keyword": "gel hidroalcohólico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "medicine",
        "medical equipment",
        "covid-19",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "geles hidroalcohólicos": [
    {
      "id": 36761,
      "keyword": "gel hidroalcohólico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "medicine",
        "medical equipment",
        "covid-19",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gel higienizante": [
    {
      "id": 36761,
      "keyword": "gel higienizante",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "medicine",
        "medical equipment",
        "covid-19",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "geles higienizante": [
    {
      "id": 36761,
      "keyword": "gel higienizante",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "medicine",
        "medical equipment",
        "covid-19",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maquinista": [
    {
      "id": 36762,
      "keyword": "maquinista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36763,
      "keyword": "maquinista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maquinistas": [
    {
      "id": 36762,
      "keyword": "maquinista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36763,
      "keyword": "maquinista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conductor de tren": [
    {
      "id": 36762,
      "keyword": "conductor de tren",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36763,
      "keyword": "conductor de tren",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conductores de tren": [
    {
      "id": 36762,
      "keyword": "conductor de tren",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36763,
      "keyword": "conductor de tren",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "porra": [
    {
      "id": 36764,
      "keyword": "porra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "object",
        "weapon",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porras": [
    {
      "id": 36764,
      "keyword": "porra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "object",
        "weapon",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "porra de policía": [
    {
      "id": 36764,
      "keyword": "porra de policía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "object",
        "weapon",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porras de policía": [
    {
      "id": 36764,
      "keyword": "porra de policía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "object",
        "weapon",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "armario de baño": [
    {
      "id": 36767,
      "keyword": "armario de baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "armarios de baño": [
    {
      "id": 36767,
      "keyword": "armario de baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alacena para baño": [
    {
      "id": 36767,
      "keyword": "alacena para baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alacenaa para baño": [
    {
      "id": 36767,
      "keyword": "alacena para baño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mezuzá": [
    {
      "id": 36786,
      "keyword": "mezuzá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mezuzás": [
    {
      "id": 36786,
      "keyword": "mezuzá",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "judaism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mascarilla ffp3": [
    {
      "id": 36787,
      "keyword": "mascarilla FFP3",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mascarillas ffp3": [
    {
      "id": 36787,
      "keyword": "mascarilla FFP3",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mascarilla con válvula": [
    {
      "id": 36788,
      "keyword": "mascarilla con válvula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36790,
      "keyword": "mascarilla con válvula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mascarillas con válvula": [
    {
      "id": 36788,
      "keyword": "mascarilla con válvula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36790,
      "keyword": "mascarilla con válvula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mascarilla ffp1": [
    {
      "id": 36789,
      "keyword": "mascarilla FFP1",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mascarillas ffp1": [
    {
      "id": 36789,
      "keyword": "mascarilla FFP1",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mascarilla quirúrgica": [
    {
      "id": 36791,
      "keyword": "mascarilla quirúrgica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36793,
      "keyword": "mascarilla quirúrgica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mascarillas quirúrgicas": [
    {
      "id": 36791,
      "keyword": "mascarilla quirúrgica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36793,
      "keyword": "mascarilla quirúrgica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mascarilla desechable": [
    {
      "id": 36791,
      "keyword": "mascarilla desechable",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36793,
      "keyword": "mascarilla desechable",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mascarillas desechables": [
    {
      "id": 36791,
      "keyword": "mascarilla desechable",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36793,
      "keyword": "mascarilla desechable",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anudar la mascarilla": [
    {
      "id": 36792,
      "keyword": "anudar la mascarilla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mujer con mascarilla": [
    {
      "id": 36795,
      "keyword": "mujer con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36938,
      "keyword": "mujer con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mujeres con mascarilla": [
    {
      "id": 36795,
      "keyword": "mujer con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36938,
      "keyword": "mujer con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hombre con mascarilla": [
    {
      "id": 36796,
      "keyword": "hombre con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36929,
      "keyword": "hombre con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hombres con mascarilla": [
    {
      "id": 36796,
      "keyword": "hombre con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36929,
      "keyword": "hombre con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "imitar": [
    {
      "id": 36797,
      "keyword": "imitar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "filtrar": [
    {
      "id": 36798,
      "keyword": "filtrar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "geology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colocar la mascarilla": [
    {
      "id": 36799,
      "keyword": "colocar la mascarilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36800,
      "keyword": "colocar la mascarilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36801,
      "keyword": "colocar la mascarilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36802,
      "keyword": "colocar la mascarilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36826,
      "keyword": "colocar la mascarilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner la mascarilla": [
    {
      "id": 36799,
      "keyword": "poner la mascarilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36800,
      "keyword": "poner la mascarilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36801,
      "keyword": "poner la mascarilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36802,
      "keyword": "poner la mascarilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36826,
      "keyword": "poner la mascarilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niño con mascarilla": [
    {
      "id": 36807,
      "keyword": "niño con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36822,
      "keyword": "niño con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36823,
      "keyword": "niño con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36803,
      "keyword": "niño con mascarilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36820,
      "keyword": "niño con mascarilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niños con mascarilla": [
    {
      "id": 36807,
      "keyword": "niño con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36822,
      "keyword": "niño con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36823,
      "keyword": "niño con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36803,
      "keyword": "niño con mascarilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36820,
      "keyword": "niño con mascarilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llevar mascarilla": [
    {
      "id": 36867,
      "keyword": "llevar mascarilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "covid-19",
        "health",
        "prevention measure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36803,
      "keyword": "llevar mascarilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36806,
      "keyword": "llevar mascarilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36819,
      "keyword": "llevar mascarilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36820,
      "keyword": "llevar mascarilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niña con mascarilla": [
    {
      "id": 36808,
      "keyword": "niña con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36821,
      "keyword": "niña con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36824,
      "keyword": "niña con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36806,
      "keyword": "niña con mascarilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36819,
      "keyword": "niña con mascarilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niñas con mascarilla": [
    {
      "id": 36808,
      "keyword": "niña con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36821,
      "keyword": "niña con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36824,
      "keyword": "niña con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36806,
      "keyword": "niña con mascarilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36819,
      "keyword": "niña con mascarilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bajar la mascarilla": [
    {
      "id": 37280,
      "keyword": "bajar la mascarilla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36810,
      "keyword": "bajar la mascarilla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36809,
      "keyword": "bajar la mascarilla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tocar la mascarilla": [
    {
      "id": 36811,
      "keyword": "tocar la mascarilla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36812,
      "keyword": "tocar la mascarilla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar la mascarilla": [
    {
      "id": 36813,
      "keyword": "quitar la mascarilla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36815,
      "keyword": "quitar la mascarilla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sujetar la mascarilla": [
    {
      "id": 36814,
      "keyword": "sujetar la mascarilla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36816,
      "keyword": "sujetar la mascarilla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36817,
      "keyword": "sujetar la mascarilla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36818,
      "keyword": "sujetar la mascarilla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpia biberones": [
    {
      "id": 36825,
      "keyword": "limpia biberones",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cepillo limpia biberones": [
    {
      "id": 36825,
      "keyword": "cepillo limpia biberones",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "impia mamadera": [
    {
      "id": 36825,
      "keyword": "impia mamadera",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cepillo limpia mamadera": [
    {
      "id": 36825,
      "keyword": "cepillo limpia mamadera",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leche en polvo": [
    {
      "id": 36827,
      "keyword": "leche en polvo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "siclo": [
    {
      "id": 36829,
      "keyword": "siclo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "foreign currency"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "siclos": [
    {
      "id": 36829,
      "keyword": "siclo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "foreign currency"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "₪": [
    {
      "id": 36829,
      "keyword": "₪",
      "keywords": 3,
      "type": 6,
      "tags": [
        "economy",
        "money",
        "foreign currency"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "signo del siclo": [
    {
      "id": 36829,
      "keyword": "signo del siclo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "foreign currency"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desempleada": [
    {
      "id": 36839,
      "keyword": "desempleada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desempleadas": [
    {
      "id": 36839,
      "keyword": "desempleada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "body": [
    {
      "id": 36840,
      "keyword": "body",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bodies": [
    {
      "id": 36840,
      "keyword": "body",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36840,
      "keyword": "bodi",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bodi": [
    {
      "id": 36840,
      "keyword": "bodi",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pcr": [
    {
      "id": 36841,
      "keyword": "PCR",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pcrs": [
    {
      "id": 36841,
      "keyword": "PCR",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "test pcr": [
    {
      "id": 36841,
      "keyword": "test PCR",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tests pcr": [
    {
      "id": 36841,
      "keyword": "test PCR",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bajar del autobús": [
    {
      "id": 36842,
      "keyword": "bajar del autobús",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36843,
      "keyword": "bajar del autobús",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36844,
      "keyword": "bajar del autobús",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar del colectivo": [
    {
      "id": 36842,
      "keyword": "bajar del colectivo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36843,
      "keyword": "bajar del colectivo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36844,
      "keyword": "bajar del colectivo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar del micro": [
    {
      "id": 36842,
      "keyword": "bajar del micro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36843,
      "keyword": "bajar del micro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36844,
      "keyword": "bajar del micro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estampar": [
    {
      "id": 36846,
      "keyword": "estampar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulverizar desinfectante": [
    {
      "id": 36847,
      "keyword": "pulverizar desinfectante",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "furniture",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "termómetro de infrarrojos": [
    {
      "id": 36848,
      "keyword": "termómetro de infrarrojos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "termómetros de infrarrojos": [
    {
      "id": 36848,
      "keyword": "termómetro de infrarrojos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pulverizar": [
    {
      "id": 36849,
      "keyword": "pulverizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "cleaning product",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "san isidro labrador": [
    {
      "id": 36850,
      "keyword": "San Isidro Labrador",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "historical character",
        "history",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "billete de autobús": [
    {
      "id": 36851,
      "keyword": "billete de autobús",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "billetes de autobús": [
    {
      "id": 36851,
      "keyword": "billete de autobús",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "billete de colectivo": [
    {
      "id": 36851,
      "keyword": "billete de colectivo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "billetes de colectivo": [
    {
      "id": 36851,
      "keyword": "billete de colectivo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "billete de micro": [
    {
      "id": 36851,
      "keyword": "billete de micro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "billetes de micro": [
    {
      "id": 36851,
      "keyword": "billete de micro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tomar la temperatura": [
    {
      "id": 36973,
      "keyword": "tomar la temperatura",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36852,
      "keyword": "tomar la temperatura",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36853,
      "keyword": "tomar la temperatura",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36854,
      "keyword": "tomar la temperatura",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38752,
      "keyword": "tomar la temperatura",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equipo de protección individual": [
    {
      "id": 36855,
      "keyword": "equipo de protección individual",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equipos de protección individual": [
    {
      "id": 36855,
      "keyword": "equipo de protección individual",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "epi": [
    {
      "id": 36855,
      "keyword": "EPI",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "epis": [
    {
      "id": 36855,
      "keyword": "EPI",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "persona con epi": [
    {
      "id": 36855,
      "keyword": "persona con EPI",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "personas con epi": [
    {
      "id": 36855,
      "keyword": "persona con EPI",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quitar el guante": [
    {
      "id": 36856,
      "keyword": "quitar el guante",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36858,
      "keyword": "quitar el guante",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner cubrecalzado": [
    {
      "id": 36857,
      "keyword": "poner cubrecalzado",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner cubrezapatos": [
    {
      "id": 36857,
      "keyword": "poner cubrezapatos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trabajar con mampara": [
    {
      "id": 36859,
      "keyword": "trabajar con mampara",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "extender jabón": [
    {
      "id": 36860,
      "keyword": "extender jabón",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36918,
      "keyword": "extender jabón",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37030,
      "keyword": "extender jabón",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37031,
      "keyword": "extender jabón",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37032,
      "keyword": "extender jabón",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "extender el desinfectante": [
    {
      "id": 36860,
      "keyword": "extender el desinfectante",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36918,
      "keyword": "extender el desinfectante",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37030,
      "keyword": "extender el desinfectante",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37031,
      "keyword": "extender el desinfectante",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37032,
      "keyword": "extender el desinfectante",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37033,
      "keyword": "extender el desinfectante",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar cubrecalzado": [
    {
      "id": 36861,
      "keyword": "quitar cubrecalzado",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar cubrezapatos": [
    {
      "id": 36861,
      "keyword": "quitar cubrezapatos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubrecalzado": [
    {
      "id": 36862,
      "keyword": "cubrecalzado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubrecalzados": [
    {
      "id": 36862,
      "keyword": "cubrecalzado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cubrezapatos": [
    {
      "id": 36862,
      "keyword": "cubrezapatos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mampara": [
    {
      "id": 36863,
      "keyword": "mampara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mamparas": [
    {
      "id": 36863,
      "keyword": "mampara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mampara protectora": [
    {
      "id": 36863,
      "keyword": "mampara protectora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mamparas protectoras": [
    {
      "id": 36863,
      "keyword": "mampara protectora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "persona con pantalla": [
    {
      "id": 36864,
      "keyword": "persona con pantalla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "personas con pantalla": [
    {
      "id": 36864,
      "keyword": "persona con pantalla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llevar pantalla": [
    {
      "id": 36864,
      "keyword": "llevar pantalla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36865,
      "keyword": "llevar pantalla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36866,
      "keyword": "llevar pantalla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niña con pantalla": [
    {
      "id": 36865,
      "keyword": "niña con pantalla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niñas con pantalla": [
    {
      "id": 36865,
      "keyword": "niña con pantalla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "niño con pantalla": [
    {
      "id": 36866,
      "keyword": "niño con pantalla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niños con pantalla": [
    {
      "id": 36866,
      "keyword": "niño con pantalla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "persona con mascarilla": [
    {
      "id": 36867,
      "keyword": "persona con mascarilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "covid-19",
        "health",
        "prevention measure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "personas con mascarilla": [
    {
      "id": 36867,
      "keyword": "persona con mascarilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "covid-19",
        "health",
        "prevention measure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "accidente doméstico": [
    {
      "id": 36869,
      "keyword": "accidente doméstico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "accidentes domésticos": [
    {
      "id": 36869,
      "keyword": "accidente doméstico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acompañante": [
    {
      "id": 36870,
      "keyword": "acompañante",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acompañantes": [
    {
      "id": 36870,
      "keyword": "acompañante",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "copiloto": [
    {
      "id": 36870,
      "keyword": "copiloto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "copilotos": [
    {
      "id": 36870,
      "keyword": "copiloto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abrir las puertas del autobús": [
    {
      "id": 36871,
      "keyword": "abrir las puertas del autobús",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anciana con mascarilla": [
    {
      "id": 36872,
      "keyword": "anciana con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ancianas con mascarilla": [
    {
      "id": 36872,
      "keyword": "anciana con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anciano con mascarilla": [
    {
      "id": 36873,
      "keyword": "anciano con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ancianos con mascarilla": [
    {
      "id": 36873,
      "keyword": "anciano con mascarilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adicción": [
    {
      "id": 36874,
      "keyword": "adicción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adicciones": [
    {
      "id": 36874,
      "keyword": "adicción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "categorization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alfombrilla desinfectante": [
    {
      "id": 36875,
      "keyword": "alfombrilla desinfectante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alfombrillas desinfectantes": [
    {
      "id": 36875,
      "keyword": "alfombrilla desinfectante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desinfectar los zapatos": [
    {
      "id": 36876,
      "keyword": "desinfectar los zapatos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "añorar": [
    {
      "id": 36877,
      "keyword": "añorar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39426,
      "keyword": "añorar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36909,
      "keyword": "añorar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autorretrato": [
    {
      "id": 36878,
      "keyword": "autorretrato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autorretratos": [
    {
      "id": 36878,
      "keyword": "autorretrato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "painting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salir del autobús": [
    {
      "id": 36879,
      "keyword": "salir del autobús",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar la rampa": [
    {
      "id": 38149,
      "keyword": "bajar la rampa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "place",
        "building",
        "trade",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36879,
      "keyword": "bajar la rampa",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar por el tobogán": [
    {
      "id": 36880,
      "keyword": "bajar por el tobogán",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37019,
      "keyword": "bajar por el tobogán",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37020,
      "keyword": "bajar por el tobogán",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balancear": [
    {
      "id": 38014,
      "keyword": "balancear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "sensory stimulation",
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36881,
      "keyword": "balancear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36882,
      "keyword": "balancear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bicornio": [
    {
      "id": 36888,
      "keyword": "bicornio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bicornios": [
    {
      "id": 36888,
      "keyword": "bicornio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolsa de ensalada": [
    {
      "id": 36889,
      "keyword": "bolsa de ensalada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas de ensalada": [
    {
      "id": 36889,
      "keyword": "bolsa de ensalada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bóveda": [
    {
      "id": 36891,
      "keyword": "bóveda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bóvedas": [
    {
      "id": 36891,
      "keyword": "bóveda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camilla hidráulica": [
    {
      "id": 36894,
      "keyword": "camilla hidráulica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camillas hidráulicas": [
    {
      "id": 36894,
      "keyword": "camilla hidráulica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carro de correo": [
    {
      "id": 36895,
      "keyword": "carro de correo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carros de correo": [
    {
      "id": 36895,
      "keyword": "carro de correo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "tertiary sector",
        "telecommunication",
        "communication",
        "mass media",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "catalogar": [
    {
      "id": 36896,
      "keyword": "catalogar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "biology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "catedral de burgos": [
    {
      "id": 36897,
      "keyword": "Catedral de Burgos",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "building",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centro gallego de arte contemporáneo": [
    {
      "id": 36898,
      "keyword": "Centro Gallego de Arte Contemporáneo",
      "keywords": 3,
      "type": 1,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cgac": [
    {
      "id": 36898,
      "keyword": "CGAC",
      "keywords": 3,
      "type": 1,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centro de arte": [
    {
      "id": 36898,
      "keyword": "centro de arte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros de arte": [
    {
      "id": 36898,
      "keyword": "centro de arte",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comisaria": [
    {
      "id": 36901,
      "keyword": "comisaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comisarias": [
    {
      "id": 36901,
      "keyword": "comisaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "viajar en colectivo": [
    {
      "id": 36903,
      "keyword": "viajar en colectivo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36962,
      "keyword": "viajar en colectivo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36963,
      "keyword": "viajar en colectivo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36960,
      "keyword": "viajar en colectivo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36961,
      "keyword": "viajar en colectivo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viajar en micro": [
    {
      "id": 36903,
      "keyword": "viajar en micro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36962,
      "keyword": "viajar en micro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36963,
      "keyword": "viajar en micro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36960,
      "keyword": "viajar en micro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36961,
      "keyword": "viajar en micro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cambiador": [
    {
      "id": 36904,
      "keyword": "cambiador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cambiadores": [
    {
      "id": 36904,
      "keyword": "cambiador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ornamento": [
    {
      "id": 36905,
      "keyword": "ornamento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ornamentos": [
    {
      "id": 36905,
      "keyword": "ornamento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desembocadura": [
    {
      "id": 36906,
      "keyword": "desembocadura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desembocaduras": [
    {
      "id": 36906,
      "keyword": "desembocadura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "delta": [
    {
      "id": 36906,
      "keyword": "delta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "deltas": [
    {
      "id": 36906,
      "keyword": "delta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "disecado": [
    {
      "id": 36907,
      "keyword": "disecado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "object",
        "decorative item",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39179,
      "keyword": "disecado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "object",
        "decorative item",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "disecados": [
    {
      "id": 36907,
      "keyword": "disecado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "object",
        "decorative item",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39179,
      "keyword": "disecado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "object",
        "decorative item",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "animal disecado": [
    {
      "id": 36907,
      "keyword": "animal disecado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39179,
      "keyword": "animal disecado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "animales disecados": [
    {
      "id": 36907,
      "keyword": "animal disecado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39179,
      "keyword": "animal disecado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taxidermia": [
    {
      "id": 36907,
      "keyword": "taxidermia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39179,
      "keyword": "taxidermia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dorar": [
    {
      "id": 36908,
      "keyword": "dorar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "visual art",
        "work",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "echar de menos": [
    {
      "id": 36909,
      "keyword": "echar de menos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "envidia": [
    {
      "id": 36911,
      "keyword": "envidia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "envidiar": [
    {
      "id": 36911,
      "keyword": "envidiar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esperar en el autobús": [
    {
      "id": 36912,
      "keyword": "esperar en el autobús",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36915,
      "keyword": "esperar en el autobús",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "persona con parálisis cerebral": [
    {
      "id": 36916,
      "keyword": "persona con parálisis cerebral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child",
        "teenager",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36946,
      "keyword": "persona con parálisis cerebral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36939,
      "keyword": "persona con parálisis cerebral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "teenager",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36940,
      "keyword": "persona con parálisis cerebral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "teenager",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "personas con parálisis cerebral": [
    {
      "id": 36916,
      "keyword": "persona con parálisis cerebral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "child",
        "teenager",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36946,
      "keyword": "persona con parálisis cerebral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36939,
      "keyword": "persona con parálisis cerebral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "teenager",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36940,
      "keyword": "persona con parálisis cerebral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "teenager",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "film transparente": [
    {
      "id": 36919,
      "keyword": "film transparente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "films transparentes": [
    {
      "id": 36919,
      "keyword": "film transparente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "germinar": [
    {
      "id": 36921,
      "keyword": "germinar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "plant",
        "plant physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grabado": [
    {
      "id": 36923,
      "keyword": "grabado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grabados": [
    {
      "id": 36923,
      "keyword": "grabado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guerra de la independencia": [
    {
      "id": 36925,
      "keyword": "Guerra de la Independencia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "history",
        "early modern period",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guía naturalista": [
    {
      "id": 36926,
      "keyword": "guía naturalista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "environmental science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guías naturalistas": [
    {
      "id": 36926,
      "keyword": "guía naturalista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "environmental science"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hijos menores": [
    {
      "id": 36927,
      "keyword": "hijo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hijo menor": [
    {
      "id": 36927,
      "keyword": "hijo menor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "historia del arte": [
    {
      "id": 36928,
      "keyword": "historia del arte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huellas de zapato": [
    {
      "id": 36930,
      "keyword": "huellas de zapato",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pisadas de zapato": [
    {
      "id": 36930,
      "keyword": "pisadas de zapato",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "experto en arte": [
    {
      "id": 36931,
      "keyword": "experto en arte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "expertos en arte": [
    {
      "id": 36931,
      "keyword": "experto en arte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "visual art"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "experta en arte": [
    {
      "id": 36931,
      "keyword": "experta en arte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "expertas en arte": [
    {
      "id": 36931,
      "keyword": "experta en arte",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "visual art"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huevo duro sin yema": [
    {
      "id": 36932,
      "keyword": "huevo duro sin yema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huevos duro sin yema": [
    {
      "id": 36932,
      "keyword": "huevo duro sin yema",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "egg product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "limpiar la suela": [
    {
      "id": 36933,
      "keyword": "limpiar la suela",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "covid-19",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "persona de medio cuerpo": [
    {
      "id": 36935,
      "keyword": "persona de medio cuerpo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38508,
      "keyword": "persona de medio cuerpo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "personas de medio cuerpo": [
    {
      "id": 36935,
      "keyword": "persona de medio cuerpo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38508,
      "keyword": "persona de medio cuerpo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "medio cuerpo": [
    {
      "id": 36935,
      "keyword": "medio cuerpo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38376,
      "keyword": "medio cuerpo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38508,
      "keyword": "medio cuerpo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "metralleta": [
    {
      "id": 36936,
      "keyword": "metralleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "metralletas": [
    {
      "id": 36936,
      "keyword": "metralleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ametralladora": [
    {
      "id": 36936,
      "keyword": "ametralladora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ametralladoras": [
    {
      "id": 36936,
      "keyword": "ametralladora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mazo": [
    {
      "id": 36937,
      "keyword": "mazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mazos": [
    {
      "id": 36937,
      "keyword": "mazo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mazo de juez": [
    {
      "id": 36937,
      "keyword": "mazo de juez",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mazos de juez": [
    {
      "id": 36937,
      "keyword": "mazo de juez",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mujer con parálisis cerebral": [
    {
      "id": 36939,
      "keyword": "mujer con parálisis cerebral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "teenager",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mujeres con parálisis cerebral": [
    {
      "id": 36939,
      "keyword": "mujer con parálisis cerebral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "teenager",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "niña con parálisis cerebral": [
    {
      "id": 36941,
      "keyword": "niña con parálisis cerebral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "child",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36939,
      "keyword": "niña con parálisis cerebral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "teenager",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niñas con parálisis cerebral": [
    {
      "id": 36941,
      "keyword": "niña con parálisis cerebral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "child",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36939,
      "keyword": "niña con parálisis cerebral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "teenager",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jóven con parálisis cerebral": [
    {
      "id": 36939,
      "keyword": "jóven con parálisis cerebral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "teenager",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36940,
      "keyword": "jóven con parálisis cerebral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "teenager",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jóvenes con parálisis cerebral": [
    {
      "id": 36939,
      "keyword": "jóven con parálisis cerebral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "teenager",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36940,
      "keyword": "jóven con parálisis cerebral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "teenager",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hombre con parálisis cerebral": [
    {
      "id": 36940,
      "keyword": "hombre con parálisis cerebral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "teenager",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36940,
      "keyword": "hombre con parálisis cerebral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "teenager",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "niño con parálisis cerebral": [
    {
      "id": 36941,
      "keyword": "niño con parálisis cerebral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "child",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36940,
      "keyword": "niño con parálisis cerebral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "teenager",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niños con parálisis cerebral": [
    {
      "id": 36941,
      "keyword": "niño con parálisis cerebral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "child",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36940,
      "keyword": "niño con parálisis cerebral",
      "keywords": 4,
      "type": 2,
      "tags": [
        "person",
        "child",
        "teenager",
        "adult",
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "nobles": [
    {
      "id": 36942,
      "keyword": "nobles",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nobleza": [
    {
      "id": 36942,
      "keyword": "nobleza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parlamento": [
    {
      "id": 36943,
      "keyword": "parlamento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parlamentos": [
    {
      "id": 36943,
      "keyword": "parlamento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pelar un huevo": [
    {
      "id": 36944,
      "keyword": "pelar un huevo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "animal-based food",
        "egg product",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perla": [
    {
      "id": 36947,
      "keyword": "perla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "animal material",
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perlas": [
    {
      "id": 36947,
      "keyword": "perla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "animal material",
        "object",
        "fashion",
        "jewelry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "policias": [
    {
      "id": 36948,
      "keyword": "policía",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36949,
      "keyword": "policía",
      "keywords": 4,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "puerta trasera": [
    {
      "id": 36951,
      "keyword": "puerta trasera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puertas traseras": [
    {
      "id": 36951,
      "keyword": "puerta trasera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rampa de autobús": [
    {
      "id": 36952,
      "keyword": "rampa de autobús",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rampas de autobús": [
    {
      "id": 36952,
      "keyword": "rampa de autobús",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plataforma de autobús": [
    {
      "id": 36952,
      "keyword": "plataforma de autobús",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plataformas de autobús": [
    {
      "id": 36952,
      "keyword": "plataforma de autobús",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "retablo": [
    {
      "id": 36953,
      "keyword": "retablo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "place",
        "christianity",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "retablos": [
    {
      "id": 36953,
      "keyword": "retablo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "place",
        "christianity",
        "visual art"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vidriera": [
    {
      "id": 36954,
      "keyword": "vidriera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "religion",
        "work",
        "secondary sector",
        "craftsmanship",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vidrieras": [
    {
      "id": 36954,
      "keyword": "vidriera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "religion",
        "work",
        "secondary sector",
        "craftsmanship",
        "visual art"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sacerdotisa": [
    {
      "id": 36956,
      "keyword": "sacerdotisa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacerdotisas": [
    {
      "id": 36956,
      "keyword": "sacerdotisa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rosetón": [
    {
      "id": 36957,
      "keyword": "rosetón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "religion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rosetones": [
    {
      "id": 36957,
      "keyword": "rosetón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "religion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salir del coche": [
    {
      "id": 36958,
      "keyword": "salir del coche",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar del coche": [
    {
      "id": 36958,
      "keyword": "bajar del coche",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "santa columna": [
    {
      "id": 36959,
      "keyword": "Santa Columna",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "place",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "silla con comunicador": [
    {
      "id": 36966,
      "keyword": "silla con comunicador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas con comunicador": [
    {
      "id": 36966,
      "keyword": "silla con comunicador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "soldado francés": [
    {
      "id": 36967,
      "keyword": "soldado francés",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soldados franceses": [
    {
      "id": 36967,
      "keyword": "soldado francés",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "subir la rampa": [
    {
      "id": 38150,
      "keyword": "subir la rampa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "place",
        "building",
        "trade",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36968,
      "keyword": "subir la rampa",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir al coche": [
    {
      "id": 36969,
      "keyword": "subir al coche",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "montar en coche": [
    {
      "id": 38115,
      "keyword": "montar en coche",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36969,
      "keyword": "montar en coche",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tapiz": [
    {
      "id": 36970,
      "keyword": "tapiz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tapices": [
    {
      "id": 36970,
      "keyword": "tapiz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frotis faríngeo": [
    {
      "id": 36972,
      "keyword": "frotis faríngeo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frotis faríngeos": [
    {
      "id": 36972,
      "keyword": "frotis faríngeo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "exudado faríngeo": [
    {
      "id": 36972,
      "keyword": "exudado faríngeo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exudados faríngeos": [
    {
      "id": 36972,
      "keyword": "exudado faríngeo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "toma de temperatura": [
    {
      "id": 36973,
      "keyword": "toma de temperatura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viajar en coche": [
    {
      "id": 36974,
      "keyword": "viajar en coche",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hija menor": [
    {
      "id": 36977,
      "keyword": "hija menor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hijas menores": [
    {
      "id": 36977,
      "keyword": "hija menor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alpaca": [
    {
      "id": 36978,
      "keyword": "alpaca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alpacas": [
    {
      "id": 36978,
      "keyword": "alpaca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anticuerpos": [
    {
      "id": 36979,
      "keyword": "anticuerpos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "immune system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "defensas": [
    {
      "id": 36979,
      "keyword": "defensas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "immune system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boca llena": [
    {
      "id": 36980,
      "keyword": "boca llena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bocas llenas": [
    {
      "id": 36980,
      "keyword": "boca llena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "wiphala": [
    {
      "id": 36981,
      "keyword": "Wiphala",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bogavante": [
    {
      "id": 36982,
      "keyword": "bogavante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "crustacean",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bogavantes": [
    {
      "id": 36982,
      "keyword": "bogavante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "crustacean",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bogavante americano": [
    {
      "id": 36983,
      "keyword": "bogavante americano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "crustacean",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bogavantes americanos": [
    {
      "id": 36983,
      "keyword": "bogavante americano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "crustacean",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "choripán": [
    {
      "id": 36984,
      "keyword": "choripán",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "choripanes": [
    {
      "id": 36984,
      "keyword": "choripán",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bocadillo de chorizo": [
    {
      "id": 36984,
      "keyword": "bocadillo de chorizo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bocadillos de chorizo": [
    {
      "id": 36984,
      "keyword": "bocadillo de chorizo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chullo": [
    {
      "id": 36985,
      "keyword": "chullo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chullos": [
    {
      "id": 36985,
      "keyword": "chullo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gorro con orejeras": [
    {
      "id": 36985,
      "keyword": "gorro con orejeras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gorros con orejeras": [
    {
      "id": 36985,
      "keyword": "gorro con orejeras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cóndor": [
    {
      "id": 36986,
      "keyword": "cóndor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cóndores": [
    {
      "id": 36986,
      "keyword": "cóndor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "eco": [
    {
      "id": 36989,
      "keyword": "eco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics",
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ecos": [
    {
      "id": 36989,
      "keyword": "eco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "physics",
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gaucho": [
    {
      "id": 36990,
      "keyword": "gaucho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gauchos": [
    {
      "id": 36990,
      "keyword": "gaucho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 36991,
      "keyword": "gauchos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer test rápido": [
    {
      "id": 36992,
      "keyword": "hacer test rápido",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hormiguero": [
    {
      "id": 36993,
      "keyword": "hormiguero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hormigueros": [
    {
      "id": 36993,
      "keyword": "hormiguero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mascarilla mal colocada": [
    {
      "id": 36995,
      "keyword": "mascarilla mal colocada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36996,
      "keyword": "mascarilla mal colocada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36997,
      "keyword": "mascarilla mal colocada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 36998,
      "keyword": "mascarilla mal colocada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "milanesa de cerdo": [
    {
      "id": 36999,
      "keyword": "milanesa de cerdo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "milanesas de cerdo": [
    {
      "id": 36999,
      "keyword": "milanesa de cerdo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "milanesa de ternera": [
    {
      "id": 37000,
      "keyword": "milanesa de ternera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "milanesas de ternera": [
    {
      "id": 37000,
      "keyword": "milanesa de ternera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "milanesa de pollo": [
    {
      "id": 37001,
      "keyword": "milanesa de pollo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "milanesas de pollo": [
    {
      "id": 37001,
      "keyword": "milanesa de pollo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mineral del hierro": [
    {
      "id": 37002,
      "keyword": "mineral del hierro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material",
        "geology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "minerales del hierro": [
    {
      "id": 37002,
      "keyword": "mineral del hierro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material",
        "geology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mollete": [
    {
      "id": 37003,
      "keyword": "mollete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "molletes": [
    {
      "id": 37003,
      "keyword": "mollete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paisana": [
    {
      "id": 37004,
      "keyword": "paisana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paisanas": [
    {
      "id": 37004,
      "keyword": "paisana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "yerba mate": [
    {
      "id": 37005,
      "keyword": "yerba mate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37013,
      "keyword": "yerba mate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paquete de mate": [
    {
      "id": 37005,
      "keyword": "paquete de mate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paquetes de mate": [
    {
      "id": 37005,
      "keyword": "paquete de mate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pastar": [
    {
      "id": 37006,
      "keyword": "pastar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "animal physiology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37007,
      "keyword": "pastar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "animal physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "test rápido": [
    {
      "id": 37010,
      "keyword": "test rápido",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tests rápidos": [
    {
      "id": 37010,
      "keyword": "test rápido",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "test rápido de sangre": [
    {
      "id": 37010,
      "keyword": "test rápido de sangre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tests rápidos de sangre": [
    {
      "id": 37010,
      "keyword": "test rápido de sangre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "usutas": [
    {
      "id": 37011,
      "keyword": "usutas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abarcas": [
    {
      "id": 38440,
      "keyword": "abarcas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37011,
      "keyword": "abarcas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ojotas": [
    {
      "id": 37011,
      "keyword": "ojotas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "albarcas": [
    {
      "id": 38440,
      "keyword": "albarcas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37011,
      "keyword": "albarcas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vicuña": [
    {
      "id": 37012,
      "keyword": "vicuña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vicuñas": [
    {
      "id": 37012,
      "keyword": "vicuña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "yerbas mate": [
    {
      "id": 37013,
      "keyword": "yerba mate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ilex paraguariensis": [
    {
      "id": 37013,
      "keyword": "Ilex paraguariensis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrir la papelera": [
    {
      "id": 37016,
      "keyword": "abrir la papelera",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar la persiana": [
    {
      "id": 37018,
      "keyword": "bajar la persiana",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barandilla": [
    {
      "id": 37021,
      "keyword": "barandilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barandillas": [
    {
      "id": 37021,
      "keyword": "barandilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chocar los codos": [
    {
      "id": 37024,
      "keyword": "chocar los codos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "choque de codos": [
    {
      "id": 37024,
      "keyword": "choque de codos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chupar el juguete": [
    {
      "id": 37027,
      "keyword": "chupar el juguete",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dictar": [
    {
      "id": 37028,
      "keyword": "dictar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dictado": [
    {
      "id": 37028,
      "keyword": "dictado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dictados": [
    {
      "id": 37028,
      "keyword": "dictado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frecuente": [
    {
      "id": 37029,
      "keyword": "frecuente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frecuentes": [
    {
      "id": 37029,
      "keyword": "frecuente",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "a menudo": [
    {
      "id": 37029,
      "keyword": "a menudo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "extender el jabón": [
    {
      "id": 37033,
      "keyword": "extender el jabón",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "health",
        "prevention measure",
        "covid-19",
        "object",
        "hygiene product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fuente de agua": [
    {
      "id": 37034,
      "keyword": "fuente de agua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37035,
      "keyword": "fuente de agua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fuentes de agua": [
    {
      "id": 37034,
      "keyword": "fuente de agua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37035,
      "keyword": "fuente de agua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llevar al colegio": [
    {
      "id": 37036,
      "keyword": "llevar al colegio",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llevar la riñonera": [
    {
      "id": 37037,
      "keyword": "llevar la riñonera",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "funcionar": [
    {
      "id": 37038,
      "keyword": "funcionar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lucha canaria": [
    {
      "id": 37039,
      "keyword": "lucha canaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mascarilla en la bolsa": [
    {
      "id": 37040,
      "keyword": "mascarilla en la bolsa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lucha del garrote": [
    {
      "id": 37041,
      "keyword": "lucha del garrote",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recoger la silla": [
    {
      "id": 37042,
      "keyword": "recoger la silla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "furniture",
        "education",
        "educational equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guardar la mascarilla": [
    {
      "id": 37043,
      "keyword": "guardar la mascarilla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "moros y cristianos": [
    {
      "id": 37044,
      "keyword": "Moros y Cristianos",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "popular event",
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porche": [
    {
      "id": 37045,
      "keyword": "porche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porches": [
    {
      "id": 37045,
      "keyword": "porche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prometer": [
    {
      "id": 37860,
      "keyword": "prometer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37046,
      "keyword": "prometer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recoger del colegio": [
    {
      "id": 37047,
      "keyword": "recoger del colegio",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "building",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "riñonera": [
    {
      "id": 37048,
      "keyword": "riñonera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "riñoneras": [
    {
      "id": 37048,
      "keyword": "riñonera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "subir la persiana": [
    {
      "id": 37050,
      "keyword": "subir la persiana",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tirar el pañuelo": [
    {
      "id": 37051,
      "keyword": "tirar el pañuelo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37084,
      "keyword": "tirar el pañuelo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toser en el pañuelo": [
    {
      "id": 37052,
      "keyword": "toser en el pañuelo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trinquete": [
    {
      "id": 37053,
      "keyword": "trinquete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trinquetes": [
    {
      "id": 37053,
      "keyword": "trinquete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sacar la mascarilla": [
    {
      "id": 37054,
      "keyword": "sacar la mascarilla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juego de falda": [
    {
      "id": 37055,
      "keyword": "juego de falda",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37066,
      "keyword": "juego de falda",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37067,
      "keyword": "juego de falda",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos de falda": [
    {
      "id": 37055,
      "keyword": "juego de falda",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37066,
      "keyword": "juego de falda",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37067,
      "keyword": "juego de falda",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cantar una nana": [
    {
      "id": 37055,
      "keyword": "cantar una nana",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37066,
      "keyword": "cantar una nana",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37067,
      "keyword": "cantar una nana",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugar con el bebé": [
    {
      "id": 37055,
      "keyword": "jugar con el bebé",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37066,
      "keyword": "jugar con el bebé",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37067,
      "keyword": "jugar con el bebé",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entretener al bebé": [
    {
      "id": 37055,
      "keyword": "entretener al bebé",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37066,
      "keyword": "entretener al bebé",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37067,
      "keyword": "entretener al bebé",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caparazón": [
    {
      "id": 37057,
      "keyword": "caparazón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caparazones": [
    {
      "id": 37057,
      "keyword": "caparazón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caja de madera": [
    {
      "id": 37058,
      "keyword": "caja de madera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajas de madera": [
    {
      "id": 37058,
      "keyword": "caja de madera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caja de fruta": [
    {
      "id": 37058,
      "keyword": "caja de fruta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajas de fruta": [
    {
      "id": 37058,
      "keyword": "caja de fruta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "directorio telefónico": [
    {
      "id": 37059,
      "keyword": "directorio telefónico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "directorios telefónicos": [
    {
      "id": 37059,
      "keyword": "directorio telefónico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clase de lengua y literatura vasca": [
    {
      "id": 37060,
      "keyword": "clase de lengua y literatura vasca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de lengua y literatura vasca": [
    {
      "id": 37060,
      "keyword": "clase de lengua y literatura vasca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lengua y literatura vasca": [
    {
      "id": 37060,
      "keyword": "lengua y literatura vasca",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de euskera": [
    {
      "id": 37060,
      "keyword": "clase de euskera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de euskera": [
    {
      "id": 37060,
      "keyword": "clase de euskera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escurridor de ensalada": [
    {
      "id": 37061,
      "keyword": "escurridor de ensalada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escurridores de ensalada": [
    {
      "id": 37061,
      "keyword": "escurridor de ensalada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fantasear": [
    {
      "id": 37062,
      "keyword": "fantasear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grueso": [
    {
      "id": 37063,
      "keyword": "grueso",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gruesos": [
    {
      "id": 37063,
      "keyword": "grueso",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gruesa": [
    {
      "id": 37063,
      "keyword": "gruesa",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gruesas": [
    {
      "id": 37063,
      "keyword": "gruesa",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recio": [
    {
      "id": 37063,
      "keyword": "recio",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recios": [
    {
      "id": 37063,
      "keyword": "recio",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recia": [
    {
      "id": 37063,
      "keyword": "recia",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recias": [
    {
      "id": 37063,
      "keyword": "recia",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fino": [
    {
      "id": 37064,
      "keyword": "fino",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "finos": [
    {
      "id": 37064,
      "keyword": "fino",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fina": [
    {
      "id": 37064,
      "keyword": "fina",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "object"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "finas": [
    {
      "id": 37064,
      "keyword": "fina",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "mathematics",
        "basic concepts",
        "object"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fuente de cristal": [
    {
      "id": 37065,
      "keyword": "fuente de cristal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "utensil",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fuentes de cristal": [
    {
      "id": 37065,
      "keyword": "fuente de cristal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "utensil",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "monte fuji": [
    {
      "id": 37069,
      "keyword": "Monte Fuji",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nachos": [
    {
      "id": 37070,
      "keyword": "nachos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "masticador": [
    {
      "id": 37071,
      "keyword": "masticador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "masticadores": [
    {
      "id": 37071,
      "keyword": "masticador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "neumático": [
    {
      "id": 37072,
      "keyword": "neumático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37103,
      "keyword": "neumático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "neumáticos": [
    {
      "id": 37072,
      "keyword": "neumático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37103,
      "keyword": "neumático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palé": [
    {
      "id": 37073,
      "keyword": "palé",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palés": [
    {
      "id": 37073,
      "keyword": "palé",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pelotari": [
    {
      "id": 37074,
      "keyword": "pelotari",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37076,
      "keyword": "pelotari",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37077,
      "keyword": "pelotari",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37079,
      "keyword": "pelotari",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelotaris": [
    {
      "id": 37074,
      "keyword": "pelotari",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37076,
      "keyword": "pelotari",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37077,
      "keyword": "pelotari",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37079,
      "keyword": "pelotari",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person",
        "sport modality"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugar a pelota mano": [
    {
      "id": 37074,
      "keyword": "jugar a pelota mano",
      "keywords": 3,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "person",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37077,
      "keyword": "jugar a pelota mano",
      "keywords": 3,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "person",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patinete eléctrico": [
    {
      "id": 37075,
      "keyword": "patinete eléctrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patinetes eléctricos": [
    {
      "id": 37075,
      "keyword": "patinete eléctrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugar a pelota paleta": [
    {
      "id": 37076,
      "keyword": "jugar a pelota paleta",
      "keywords": 3,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "person",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37079,
      "keyword": "jugar a pelota paleta",
      "keywords": 3,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "person",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pólvora": [
    {
      "id": 37078,
      "keyword": "pólvora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "derived material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "restaurante japonés": [
    {
      "id": 37080,
      "keyword": "restaurante japonés",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "restaurantes japoneses": [
    {
      "id": 37080,
      "keyword": "restaurante japonés",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "semáforo verde intermitente": [
    {
      "id": 37081,
      "keyword": "semáforo verde intermitente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37109,
      "keyword": "semáforo verde intermitente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37111,
      "keyword": "semáforo verde intermitente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "semáforos verdes intermitente": [
    {
      "id": 37081,
      "keyword": "semáforo verde intermitente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety",
        "traffic signal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "semáforo del dolor": [
    {
      "id": 37082,
      "keyword": "semáforo del dolor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "semáforos del dolor": [
    {
      "id": 37082,
      "keyword": "semáforo del dolor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escala de dolor": [
    {
      "id": 37082,
      "keyword": "escala de dolor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escalas de dolor": [
    {
      "id": 37082,
      "keyword": "escala de dolor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "semáforo de las emociones": [
    {
      "id": 37083,
      "keyword": "semáforo de las emociones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "semáforos de las emociones": [
    {
      "id": 37083,
      "keyword": "semáforo de las emociones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "traducir": [
    {
      "id": 39433,
      "keyword": "traducir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "work",
        "communication",
        "language",
        "verb",
        "professional"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37085,
      "keyword": "traducir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caminar hacia atrás": [
    {
      "id": 37086,
      "keyword": "caminar hacia atrás",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "andar hacia atrás": [
    {
      "id": 37086,
      "keyword": "andar hacia atrás",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diseñador": [
    {
      "id": 37088,
      "keyword": "diseñador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "visual art",
        "drawing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diseñadores": [
    {
      "id": 37088,
      "keyword": "diseñador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "visual art",
        "drawing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diseñador gráfico": [
    {
      "id": 37088,
      "keyword": "diseñador gráfico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "visual art",
        "drawing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diseñadores gráficos": [
    {
      "id": 37088,
      "keyword": "diseñador gráfico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "visual art",
        "drawing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arrastrar el culo": [
    {
      "id": 37089,
      "keyword": "arrastrar el culo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exceso de velocidad": [
    {
      "id": 37090,
      "keyword": "exceso de velocidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "excesos de velocidad": [
    {
      "id": 37090,
      "keyword": "exceso de velocidad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saltar el radar": [
    {
      "id": 37090,
      "keyword": "saltar el radar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ensartables": [
    {
      "id": 37092,
      "keyword": "ensartable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ensartable de anillas": [
    {
      "id": 37092,
      "keyword": "ensartable de anillas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ensartables de anillas": [
    {
      "id": 37092,
      "keyword": "ensartable de anillas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escuela de diseño gráfico": [
    {
      "id": 37093,
      "keyword": "escuela de diseño gráfico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution",
        "visual art",
        "drawing",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escuelas de diseño gráfico": [
    {
      "id": 37093,
      "keyword": "escuela de diseño gráfico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution",
        "visual art",
        "drawing",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "especias": [
    {
      "id": 37094,
      "keyword": "especias",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "spices",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botes de especias": [
    {
      "id": 37094,
      "keyword": "botes de especias",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "spices",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "portería de hurling": [
    {
      "id": 37095,
      "keyword": "portería de hurling",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porterías de hurling": [
    {
      "id": 37095,
      "keyword": "portería de hurling",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "campo de hurling": [
    {
      "id": 37095,
      "keyword": "campo de hurling",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campos de hurling": [
    {
      "id": 37095,
      "keyword": "campo de hurling",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hacer la croqueta": [
    {
      "id": 37097,
      "keyword": "hacer la croqueta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodar sobre sí mismo": [
    {
      "id": 37097,
      "keyword": "rodar sobre sí mismo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hurler": [
    {
      "id": 37098,
      "keyword": "hurler",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hurlers": [
    {
      "id": 37098,
      "keyword": "hurler",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugador de hurling": [
    {
      "id": 37098,
      "keyword": "jugador de hurling",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadores de hurling": [
    {
      "id": 37098,
      "keyword": "jugador de hurling",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hurley": [
    {
      "id": 37099,
      "keyword": "hurley",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hurleys": [
    {
      "id": 37099,
      "keyword": "hurley",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camán": [
    {
      "id": 37099,
      "keyword": "camán",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camanes": [
    {
      "id": 37099,
      "keyword": "camán",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palo de hurling": [
    {
      "id": 37099,
      "keyword": "palo de hurling",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palos de hurling": [
    {
      "id": 37099,
      "keyword": "palo de hurling",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugar al hurling": [
    {
      "id": 37100,
      "keyword": "jugar al hurling",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hurling": [
    {
      "id": 37100,
      "keyword": "hurling",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mirar a ambos lados": [
    {
      "id": 37101,
      "keyword": "mirar a ambos lados",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37184,
      "keyword": "mirar a ambos lados",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sentar en el asiento de seguridad": [
    {
      "id": 37104,
      "keyword": "sentar en el asiento de seguridad",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "radar": [
    {
      "id": 37105,
      "keyword": "radar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "radares": [
    {
      "id": 37105,
      "keyword": "radar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "radar fijo": [
    {
      "id": 37105,
      "keyword": "radar fijo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "radares fijos": [
    {
      "id": 37105,
      "keyword": "radar fijo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sliotar": [
    {
      "id": 37112,
      "keyword": "sliotar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sliotars": [
    {
      "id": 37112,
      "keyword": "sliotar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sliothar": [
    {
      "id": 37112,
      "keyword": "sliothar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sliothars": [
    {
      "id": 37112,
      "keyword": "sliothar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pelota de hurling": [
    {
      "id": 37112,
      "keyword": "pelota de hurling",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelotas de hurling": [
    {
      "id": 37112,
      "keyword": "pelota de hurling",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "astillero": [
    {
      "id": 37113,
      "keyword": "astillero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry",
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37113,
      "keyword": "astillero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry",
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atarazana": [
    {
      "id": 37113,
      "keyword": "atarazana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry",
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atarazanas": [
    {
      "id": 37113,
      "keyword": "atarazana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "secondary sector",
        "industry",
        "manufacturing industry",
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esparto": [
    {
      "id": 37114,
      "keyword": "esparto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "foso": [
    {
      "id": 37115,
      "keyword": "foso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fosos": [
    {
      "id": 37115,
      "keyword": "foso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trastear": [
    {
      "id": 37116,
      "keyword": "trastear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diosa": [
    {
      "id": 37117,
      "keyword": "diosa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diosas": [
    {
      "id": 37117,
      "keyword": "diosa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diosa romana": [
    {
      "id": 37117,
      "keyword": "diosa romana",
      "keywords": 3,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diosas romanas": [
    {
      "id": 37117,
      "keyword": "diosa romana",
      "keywords": 3,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "minerva": [
    {
      "id": 37117,
      "keyword": "Minerva",
      "keywords": 3,
      "type": 1,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "history",
        "civilization",
        "Rome"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escudo íbero": [
    {
      "id": 37118,
      "keyword": "escudo íbero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "history",
        "civilization",
        "Iberians",
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escudos íberos": [
    {
      "id": 37118,
      "keyword": "escudo íbero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "history",
        "civilization",
        "Iberians",
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "íbero": [
    {
      "id": 37119,
      "keyword": "íbero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "civilization",
        "Iberians",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37122,
      "keyword": "íbero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "civilization",
        "Iberians"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frisbee": [
    {
      "id": 37120,
      "keyword": "frisbee",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frisbees": [
    {
      "id": 37120,
      "keyword": "frisbee",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "disco volador": [
    {
      "id": 37120,
      "keyword": "disco volador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37127,
      "keyword": "disco volador",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "discos voladores": [
    {
      "id": 37120,
      "keyword": "disco volador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frisbi": [
    {
      "id": 37120,
      "keyword": "frisbi",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frisbis": [
    {
      "id": 37120,
      "keyword": "frisbi",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guerrero íbero": [
    {
      "id": 37121,
      "keyword": "guerrero íbero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "civilization",
        "Iberians",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guerreros íberos": [
    {
      "id": 37121,
      "keyword": "guerrero íbero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "civilization",
        "Iberians",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "soldado íbero": [
    {
      "id": 37121,
      "keyword": "soldado íbero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "civilization",
        "Iberians",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soldados íberos": [
    {
      "id": 37121,
      "keyword": "soldado íbero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "civilization",
        "Iberians",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atrapar la cola": [
    {
      "id": 37123,
      "keyword": "atrapar la cola",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "robar la cola": [
    {
      "id": 37123,
      "keyword": "robar la cola",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juego del stop": [
    {
      "id": 37124,
      "keyword": "juego del Stop",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "íbera": [
    {
      "id": 37125,
      "keyword": "íbera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "civilization",
        "Iberians",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soldado romano": [
    {
      "id": 37126,
      "keyword": "soldado romano",
      "keywords": 3,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "civilization",
        "Rome",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soldados romanos": [
    {
      "id": 37126,
      "keyword": "soldado romano",
      "keywords": 3,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "civilization",
        "Rome",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "legionario": [
    {
      "id": 37126,
      "keyword": "legionario",
      "keywords": 3,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "civilization",
        "Rome",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "legionarios": [
    {
      "id": 37126,
      "keyword": "legionario",
      "keywords": 3,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "civilization",
        "Rome",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "legionario romano": [
    {
      "id": 37126,
      "keyword": "legionario romano",
      "keywords": 3,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "civilization",
        "Rome",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "legionarios romanos": [
    {
      "id": 37126,
      "keyword": "legionario romano",
      "keywords": 3,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "civilization",
        "Rome",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ultimate": [
    {
      "id": 37127,
      "keyword": "ultimate",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lanzar el frisbee": [
    {
      "id": 37127,
      "keyword": "lanzar el frisbee",
      "keywords": 4,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasar el frisbee": [
    {
      "id": 37127,
      "keyword": "pasar el frisbee",
      "keywords": 4,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "squash": [
    {
      "id": 37128,
      "keyword": "squash",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zanja": [
    {
      "id": 37129,
      "keyword": "zanja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zanjas": [
    {
      "id": 37129,
      "keyword": "zanja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fosa": [
    {
      "id": 38076,
      "keyword": "fosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37129,
      "keyword": "fosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fosas": [
    {
      "id": 38076,
      "keyword": "fosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37129,
      "keyword": "fosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "íberos": [
    {
      "id": 37130,
      "keyword": "íberos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "history",
        "civilization",
        "Iberians"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "olmo": [
    {
      "id": 37131,
      "keyword": "olmo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "olmos": [
    {
      "id": 37131,
      "keyword": "olmo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peluquera canina": [
    {
      "id": 37132,
      "keyword": "peluquera canina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peluqueras caninas": [
    {
      "id": 37132,
      "keyword": "peluquera canina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peluquero canino": [
    {
      "id": 37133,
      "keyword": "peluquero canino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peluqueros caninos": [
    {
      "id": 37133,
      "keyword": "peluquero canino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alfombrilla sensorial": [
    {
      "id": 37134,
      "keyword": "alfombrilla sensorial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alfombrillas sensoriales": [
    {
      "id": 37134,
      "keyword": "alfombrilla sensorial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asomar al balcón": [
    {
      "id": 37135,
      "keyword": "asomar al balcón",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "amenazar": [
    {
      "id": 37136,
      "keyword": "amenazar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patear la puerta": [
    {
      "id": 37139,
      "keyword": "patear la puerta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37140,
      "keyword": "patear la puerta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37141,
      "keyword": "patear la puerta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "correr la cortina": [
    {
      "id": 37142,
      "keyword": "correr la cortina",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "descorrer la cortina": [
    {
      "id": 37143,
      "keyword": "descorrer la cortina",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "distensión muscular": [
    {
      "id": 37144,
      "keyword": "distensión muscular",
      "keywords": 4,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "muscular system",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "extendido": [
    {
      "id": 37144,
      "keyword": "extendido",
      "keywords": 4,
      "type": 4,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "muscular system",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bíceps relajado": [
    {
      "id": 37144,
      "keyword": "bíceps relajado",
      "keywords": 4,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "muscular system",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bíceps relajados": [
    {
      "id": 37144,
      "keyword": "bíceps relajado",
      "keywords": 4,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "muscular system",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "extendida": [
    {
      "id": 37144,
      "keyword": "extendida",
      "keywords": 4,
      "type": 4,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "muscular system",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "electrocutar": [
    {
      "id": 37146,
      "keyword": "electrocutar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "work accident",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estambre": [
    {
      "id": 37147,
      "keyword": "estambre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estambres": [
    {
      "id": 37147,
      "keyword": "estambre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estigma": [
    {
      "id": 37148,
      "keyword": "estigma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estigmas": [
    {
      "id": 37148,
      "keyword": "estigma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estilo": [
    {
      "id": 37150,
      "keyword": "estilo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estilos": [
    {
      "id": 37150,
      "keyword": "estilo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ovario": [
    {
      "id": 37151,
      "keyword": "ovario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sépalo": [
    {
      "id": 37152,
      "keyword": "sépalo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sépalos": [
    {
      "id": 37152,
      "keyword": "sépalo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "polen": [
    {
      "id": 37153,
      "keyword": "polen",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juego de salto": [
    {
      "id": 37154,
      "keyword": "juego de salto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos de salto": [
    {
      "id": 37154,
      "keyword": "juego de salto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "masaje sonoro": [
    {
      "id": 37769,
      "keyword": "masaje sonoro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37155,
      "keyword": "masaje sonoro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37157,
      "keyword": "masaje sonoro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "masajes sonoros": [
    {
      "id": 37769,
      "keyword": "masaje sonoro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37155,
      "keyword": "masaje sonoro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37157,
      "keyword": "masaje sonoro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juguetes de baño": [
    {
      "id": 37156,
      "keyword": "juguetes de baño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir a la mesa": [
    {
      "id": 37158,
      "keyword": "subir a la mesa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "deslumbrar": [
    {
      "id": 37159,
      "keyword": "deslumbrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "molestar el sol": [
    {
      "id": 37159,
      "keyword": "molestar el sol",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "necesitar": [
    {
      "id": 37160,
      "keyword": "necesitar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "psychology",
        "human response",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "otra vez": [
    {
      "id": 37162,
      "keyword": "otra vez",
      "keywords": 2,
      "type": 4,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37163,
      "keyword": "otra vez",
      "keywords": 2,
      "type": 4,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "una vez más": [
    {
      "id": 37162,
      "keyword": "una vez más",
      "keywords": 2,
      "type": 4,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "de nuevo": [
    {
      "id": 37163,
      "keyword": "de nuevo",
      "keywords": 2,
      "type": 4,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "genitales masculinos": [
    {
      "id": 37165,
      "keyword": "genitales masculinos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "reproductive system",
        "excretory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "percebes": [
    {
      "id": 37167,
      "keyword": "percebes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "crustacean"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espiguilla de avena": [
    {
      "id": 37168,
      "keyword": "espiguilla de avena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "polinizar": [
    {
      "id": 37169,
      "keyword": "polinizar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "plant",
        "plant physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "polinización": [
    {
      "id": 37169,
      "keyword": "polinización",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dentadura postiza": [
    {
      "id": 37170,
      "keyword": "dentadura postiza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dentaduras postizas": [
    {
      "id": 37170,
      "keyword": "dentadura postiza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prótesis dental": [
    {
      "id": 37170,
      "keyword": "prótesis dental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prótesis dentales": [
    {
      "id": 37170,
      "keyword": "prótesis dental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "savia": [
    {
      "id": 37171,
      "keyword": "savia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tensión muscular": [
    {
      "id": 37172,
      "keyword": "tensión muscular",
      "keywords": 6,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "muscular system",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flexionado": [
    {
      "id": 37172,
      "keyword": "flexionado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "muscular system",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flexionados": [
    {
      "id": 37172,
      "keyword": "flexionado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "muscular system",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bíceps tenso": [
    {
      "id": 37172,
      "keyword": "bíceps tenso",
      "keywords": 6,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "muscular system",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bíceps tensos": [
    {
      "id": 37172,
      "keyword": "bíceps tenso",
      "keywords": 6,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "muscular system",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "flexionada": [
    {
      "id": 37172,
      "keyword": "flexionada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "muscular system",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flexionadas": [
    {
      "id": 37172,
      "keyword": "flexionada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "muscular system",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contraído": [
    {
      "id": 37172,
      "keyword": "contraído",
      "keywords": 6,
      "type": 4,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "muscular system",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contraídos": [
    {
      "id": 37172,
      "keyword": "contraído",
      "keywords": 6,
      "type": 4,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "muscular system",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contraída": [
    {
      "id": 37172,
      "keyword": "contraída",
      "keywords": 6,
      "type": 4,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "muscular system",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contraídas": [
    {
      "id": 37172,
      "keyword": "contraída",
      "keywords": 6,
      "type": 4,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "muscular system",
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adviento": [
    {
      "id": 37174,
      "keyword": "Adviento",
      "keywords": 1,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "religion",
        "christianity",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coche detenido": [
    {
      "id": 37177,
      "keyword": "coche detenido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coches detenidos": [
    {
      "id": 37177,
      "keyword": "coche detenido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37178,
      "keyword": "coches detenidos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cucharilla de café": [
    {
      "id": 37179,
      "keyword": "cucharilla de café",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37179,
      "keyword": "cucharilla de café",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cucharilla de postre": [
    {
      "id": 37180,
      "keyword": "cucharilla de postre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cucharillas de postre": [
    {
      "id": 37180,
      "keyword": "cucharilla de postre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "cutlery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desenroscar": [
    {
      "id": 37181,
      "keyword": "desenroscar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estoy mal": [
    {
      "id": 37182,
      "keyword": "estoy mal",
      "keywords": 4,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡estoy mal!": [
    {
      "id": 37182,
      "keyword": "¡estoy mal!",
      "keywords": 4,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estoy regular": [
    {
      "id": 37183,
      "keyword": "estoy regular",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡estoy regular!": [
    {
      "id": 37183,
      "keyword": "¡estoy regular!",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasar la hoja": [
    {
      "id": 37186,
      "keyword": "pasar la hoja",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guardar el cuaderno de comunicación": [
    {
      "id": 37189,
      "keyword": "guardar el cuaderno de comunicación",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meter el cuaderno de comunicación": [
    {
      "id": 37189,
      "keyword": "meter el cuaderno de comunicación",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sensación": [
    {
      "id": 37190,
      "keyword": "sensación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "body sensation",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sensaciones": [
    {
      "id": 37190,
      "keyword": "sensación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "body sensation",
        "categorization",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "walkie-talkie": [
    {
      "id": 37192,
      "keyword": "walkie-talkie",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "walkie-talkies": [
    {
      "id": 37192,
      "keyword": "walkie-talkie",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37193,
      "keyword": "walkie-talkies",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "actividad física": [
    {
      "id": 37196,
      "keyword": "actividad física",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "healthy habit",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "actividades físicas": [
    {
      "id": 37196,
      "keyword": "actividad física",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "healthy habit",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "postura": [
    {
      "id": 37199,
      "keyword": "postura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "posturas": [
    {
      "id": 37199,
      "keyword": "postura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerrar con llave": [
    {
      "id": 37200,
      "keyword": "cerrar con llave",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alimento saludable": [
    {
      "id": 37201,
      "keyword": "alimento saludable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "healthy habit",
        "feeding",
        "dietetics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alimentos saludables": [
    {
      "id": 37201,
      "keyword": "alimento saludable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "healthy habit",
        "feeding",
        "dietetics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alimentación saludable": [
    {
      "id": 37201,
      "keyword": "alimentación saludable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "healthy habit",
        "feeding",
        "dietetics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "confección": [
    {
      "id": 37202,
      "keyword": "confección",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "secondary sector",
        "clothing industry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taller de confección": [
    {
      "id": 37202,
      "keyword": "taller de confección",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "secondary sector",
        "clothing industry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talleres de confección": [
    {
      "id": 37202,
      "keyword": "taller de confección",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "secondary sector",
        "clothing industry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dormir bien": [
    {
      "id": 37203,
      "keyword": "dormir bien",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ensalada de pasta": [
    {
      "id": 37204,
      "keyword": "ensalada de pasta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ensaladas de pasta": [
    {
      "id": 37204,
      "keyword": "ensalada de pasta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estirar la ropa": [
    {
      "id": 37205,
      "keyword": "estirar la ropa",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "household",
        "trousseau",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hidratar": [
    {
      "id": 37207,
      "keyword": "hidratar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hidratación": [
    {
      "id": 37207,
      "keyword": "hidratación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jardinería": [
    {
      "id": 37209,
      "keyword": "jardinería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "primary sector",
        "gardening",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pandoro": [
    {
      "id": 37212,
      "keyword": "pandoro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pandoros": [
    {
      "id": 37212,
      "keyword": "pandoro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "panettone": [
    {
      "id": 37213,
      "keyword": "panettone",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panettones": [
    {
      "id": 37213,
      "keyword": "panettone",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "panetone": [
    {
      "id": 37213,
      "keyword": "panetone",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panetones": [
    {
      "id": 37213,
      "keyword": "panetone",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prohibido el alcohol": [
    {
      "id": 37215,
      "keyword": "prohibido el alcohol",
      "keywords": 2,
      "type": 5,
      "tags": [
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibido el consumo de alcohol": [
    {
      "id": 37215,
      "keyword": "prohibido el consumo de alcohol",
      "keywords": 2,
      "type": 5,
      "tags": [
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "prohibidas las drogas": [
    {
      "id": 37216,
      "keyword": "prohibidas las drogas",
      "keywords": 1,
      "type": 5,
      "tags": [
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrir un regalo": [
    {
      "id": 37218,
      "keyword": "abrir un regalo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camiseta del revés": [
    {
      "id": 37219,
      "keyword": "camiseta del revés",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37220,
      "keyword": "camiseta del revés",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camisetas del revés": [
    {
      "id": 37219,
      "keyword": "camiseta del revés",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37220,
      "keyword": "camiseta del revés",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "del revés": [
    {
      "id": 37219,
      "keyword": "del revés",
      "keywords": 3,
      "type": 4,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37220,
      "keyword": "del revés",
      "keywords": 3,
      "type": 4,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "al revés": [
    {
      "id": 37219,
      "keyword": "al revés",
      "keywords": 3,
      "type": 4,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37220,
      "keyword": "al revés",
      "keywords": 3,
      "type": 4,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reanimador ambu": [
    {
      "id": 37221,
      "keyword": "reanimador AMBU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reanimadores ambu": [
    {
      "id": 37221,
      "keyword": "reanimador AMBU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "resucitador ambu": [
    {
      "id": 37221,
      "keyword": "resucitador AMBU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "resucitadores ambu": [
    {
      "id": 37221,
      "keyword": "resucitador AMBU",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escuela de música y danza": [
    {
      "id": 37225,
      "keyword": "escuela de música y danza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "educational institution",
        "scenic art",
        "music",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parque canino": [
    {
      "id": 37226,
      "keyword": "parque canino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "animal",
        "pet",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bondad": [
    {
      "id": 37231,
      "keyword": "bondad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empatía": [
    {
      "id": 37232,
      "keyword": "empatía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gratitud": [
    {
      "id": 37233,
      "keyword": "gratitud",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agradecimiento": [
    {
      "id": 37233,
      "keyword": "agradecimiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agradecimientos": [
    {
      "id": 37233,
      "keyword": "agradecimiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "responsabilidad": [
    {
      "id": 37234,
      "keyword": "responsabilidad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sinceridad": [
    {
      "id": 37236,
      "keyword": "sinceridad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "solidaridad": [
    {
      "id": 37237,
      "keyword": "solidaridad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cruzar el puente": [
    {
      "id": 37242,
      "keyword": "cruzar el puente",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture",
        "infrastructure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cruzar la pasarela": [
    {
      "id": 37242,
      "keyword": "cruzar la pasarela",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture",
        "infrastructure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entrar en el túnel": [
    {
      "id": 37247,
      "keyword": "entrar en el túnel",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hurón": [
    {
      "id": 37251,
      "keyword": "hurón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hurones": [
    {
      "id": 37251,
      "keyword": "hurón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "turón": [
    {
      "id": 37251,
      "keyword": "turón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "turones": [
    {
      "id": 37251,
      "keyword": "turón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jengibre": [
    {
      "id": 37252,
      "keyword": "jengibre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "spices"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "montar en patinete": [
    {
      "id": 37253,
      "keyword": "montar en patinete",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pilas de botón": [
    {
      "id": 37254,
      "keyword": "pilas de botón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piscina hinchable": [
    {
      "id": 37255,
      "keyword": "piscina hinchable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piscinas hinchables": [
    {
      "id": 37255,
      "keyword": "piscina hinchable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pasarela": [
    {
      "id": 37257,
      "keyword": "pasarela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture",
        "infrastructure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasarelas": [
    {
      "id": 37257,
      "keyword": "pasarela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture",
        "infrastructure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pulgón": [
    {
      "id": 37258,
      "keyword": "pulgón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "herbivorous",
        "oviparous",
        "viviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pulgones": [
    {
      "id": 37258,
      "keyword": "pulgón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "herbivorous",
        "oviparous",
        "viviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salir del túnel": [
    {
      "id": 37259,
      "keyword": "salir del túnel",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sobre de gaseosa": [
    {
      "id": 37260,
      "keyword": "sobre de gaseosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sobres de gaseosa": [
    {
      "id": 37260,
      "keyword": "sobre de gaseosa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rollo de papel": [
    {
      "id": 37261,
      "keyword": "rollo de papel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rollos de papel": [
    {
      "id": 37261,
      "keyword": "rollo de papel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rollo de papel higiénico": [
    {
      "id": 37261,
      "keyword": "rollo de papel higiénico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rollos de papel higiénico": [
    {
      "id": 37261,
      "keyword": "rollo de papel higiénico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bañar en la piscina hinchable": [
    {
      "id": 37263,
      "keyword": "bañar en la piscina hinchable",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alzar las copas": [
    {
      "id": 37264,
      "keyword": "alzar las copas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "popular event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mover la silla": [
    {
      "id": 37265,
      "keyword": "mover la silla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pirámide de escalada": [
    {
      "id": 37266,
      "keyword": "pirámide de escalada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pirámides de escalada": [
    {
      "id": 37266,
      "keyword": "pirámide de escalada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pirámide de cuerdas": [
    {
      "id": 37266,
      "keyword": "pirámide de cuerdas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pirámides de cuerdas": [
    {
      "id": 37266,
      "keyword": "pirámide de cuerdas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mascarilla con nombre": [
    {
      "id": 37267,
      "keyword": "mascarilla con nombre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mascarillas con nombre": [
    {
      "id": 37267,
      "keyword": "mascarilla con nombre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ventilar la habitación": [
    {
      "id": 37268,
      "keyword": "ventilar la habitación",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "etiqueta con nombre": [
    {
      "id": 37269,
      "keyword": "etiqueta con nombre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "etiquetas con nombre": [
    {
      "id": 37269,
      "keyword": "etiqueta con nombre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ración": [
    {
      "id": 37270,
      "keyword": "ración",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "raciones": [
    {
      "id": 37270,
      "keyword": "ración",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vaso con nombre": [
    {
      "id": 37272,
      "keyword": "vaso con nombre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vasos con nombre": [
    {
      "id": 37272,
      "keyword": "vaso con nombre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "posición de estrella": [
    {
      "id": 37273,
      "keyword": "posición de estrella",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "posición de salida": [
    {
      "id": 37274,
      "keyword": "posición de salida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soplar en el agua": [
    {
      "id": 37275,
      "keyword": "soplar en el agua",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orinar en la cuña": [
    {
      "id": 37278,
      "keyword": "orinar en la cuña",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37282,
      "keyword": "orinar en la cuña",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37285,
      "keyword": "orinar en la cuña",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37276,
      "keyword": "orinar en la cuña",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37279,
      "keyword": "orinar en la cuña",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37283,
      "keyword": "orinar en la cuña",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "defecar en la cuña": [
    {
      "id": 37277,
      "keyword": "defecar en la cuña",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37281,
      "keyword": "defecar en la cuña",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37284,
      "keyword": "defecar en la cuña",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37276,
      "keyword": "defecar en la cuña",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37279,
      "keyword": "defecar en la cuña",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37283,
      "keyword": "defecar en la cuña",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orinar en la botella": [
    {
      "id": 37286,
      "keyword": "orinar en la botella",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caminar por el agua": [
    {
      "id": 37287,
      "keyword": "caminar por el agua",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sumergir la cabeza": [
    {
      "id": 37291,
      "keyword": "sumergir la cabeza",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meter la cabeza": [
    {
      "id": 37291,
      "keyword": "meter la cabeza",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desplazar por el borde": [
    {
      "id": 37292,
      "keyword": "desplazar por el borde",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nadar con churro": [
    {
      "id": 37293,
      "keyword": "nadar con churro",
      "keywords": 1,
      "type": 3,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37294,
      "keyword": "nadar con churro",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bucear a través del aro": [
    {
      "id": 37295,
      "keyword": "bucear a través del aro",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aparato reproductor": [
    {
      "id": 37304,
      "keyword": "aparato reproductor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37307,
      "keyword": "aparato reproductor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aparatos reproductores": [
    {
      "id": 37304,
      "keyword": "aparato reproductor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37307,
      "keyword": "aparato reproductor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aparato reproductor femenino": [
    {
      "id": 37304,
      "keyword": "aparato reproductor femenino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aparatos reproductores femeninos": [
    {
      "id": 37304,
      "keyword": "aparato reproductor femenino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aparato reproductor masculino": [
    {
      "id": 37307,
      "keyword": "aparato reproductor masculino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aparatos reproductores masculinos": [
    {
      "id": 37307,
      "keyword": "aparato reproductor masculino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "reproductive system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hacer raquetas": [
    {
      "id": 37308,
      "keyword": "hacer raquetas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "protocolo": [
    {
      "id": 37310,
      "keyword": "protocolo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "protocolos": [
    {
      "id": 37310,
      "keyword": "protocolo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manos quietas": [
    {
      "id": 37312,
      "keyword": "manos quietas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37314,
      "keyword": "manos quietas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hércules": [
    {
      "id": 37316,
      "keyword": "Hércules",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "history",
        "civilization",
        "Rome",
        "Greece"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "heracles": [
    {
      "id": 37316,
      "keyword": "Heracles",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "history",
        "civilization",
        "Rome",
        "Greece"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esquilar": [
    {
      "id": 37317,
      "keyword": "esquilar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "cattle farming",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clínica podológica": [
    {
      "id": 37322,
      "keyword": "clínica podológica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clínicas podológicas": [
    {
      "id": 37322,
      "keyword": "clínica podológica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "human body",
        "physiology",
        "human physiology",
        "locomotor system",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "interventor": [
    {
      "id": 37324,
      "keyword": "interventor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "public administration",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "interventores": [
    {
      "id": 37324,
      "keyword": "interventor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "public administration",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "interventora": [
    {
      "id": 37324,
      "keyword": "interventora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "public administration",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "interventoras": [
    {
      "id": 37324,
      "keyword": "interventora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "public administration",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "teleasistencia": [
    {
      "id": 37326,
      "keyword": "teleasistencia",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "servicio de teleasistencia": [
    {
      "id": 37326,
      "keyword": "servicio de teleasistencia",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "servicios de teleasistencia": [
    {
      "id": 37326,
      "keyword": "servicio de teleasistencia",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "tocar la flauta": [
    {
      "id": 37327,
      "keyword": "tocar la flauta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sala de servidores": [
    {
      "id": 37328,
      "keyword": "sala de servidores",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "computing",
        "hardware",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de servidores": [
    {
      "id": 37328,
      "keyword": "sala de servidores",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "computing",
        "hardware",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asuntos económicos": [
    {
      "id": 37329,
      "keyword": "asuntos económicos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "economy",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "departamento de economía": [
    {
      "id": 37329,
      "keyword": "departamento de economía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "economy",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿qué haces?": [
    {
      "id": 37330,
      "keyword": "¿qué haces?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿qué hace?": [
    {
      "id": 37330,
      "keyword": "¿qué hace?",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reprografía": [
    {
      "id": 37333,
      "keyword": "reprografía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "servicio de reprografía": [
    {
      "id": 37333,
      "keyword": "servicio de reprografía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "servicios de reprografía": [
    {
      "id": 37333,
      "keyword": "servicio de reprografía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuarzo hematoide": [
    {
      "id": 37335,
      "keyword": "cuarzo hematoide",
      "keywords": 2,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuarzos hematoides": [
    {
      "id": 37335,
      "keyword": "cuarzo hematoide",
      "keywords": 2,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jacinto de compostela": [
    {
      "id": 37335,
      "keyword": "jacinto de Compostela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jacintos de compostela": [
    {
      "id": 37335,
      "keyword": "jacinto de Compostela",
      "keywords": 2,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "mineral origin material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de vídeo y tv": [
    {
      "id": 37336,
      "keyword": "sala de vídeo y TV",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de vídeo y tv": [
    {
      "id": 37336,
      "keyword": "sala de vídeo y TV",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manchar": [
    {
      "id": 37338,
      "keyword": "manchar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37339,
      "keyword": "manchar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ensuciar": [
    {
      "id": 37338,
      "keyword": "ensuciar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37339,
      "keyword": "ensuciar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "texto": [
    {
      "id": 37340,
      "keyword": "texto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "textos": [
    {
      "id": 37340,
      "keyword": "texto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mensaje escrito": [
    {
      "id": 37340,
      "keyword": "mensaje escrito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mensajes escritos": [
    {
      "id": 37340,
      "keyword": "mensaje escrito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "corbata de payaso": [
    {
      "id": 37342,
      "keyword": "corbata de payaso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corbatas de payaso": [
    {
      "id": 37342,
      "keyword": "corbata de payaso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mimo": [
    {
      "id": 37343,
      "keyword": "mimo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mimos": [
    {
      "id": 37343,
      "keyword": "mimo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "informática y nuevas tecnologías": [
    {
      "id": 37347,
      "keyword": "informática y nuevas tecnologías",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "computing",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sala de ponencias": [
    {
      "id": 37348,
      "keyword": "sala de ponencias",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37349,
      "keyword": "sala de ponencias",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de ponencias": [
    {
      "id": 37348,
      "keyword": "sala de ponencias",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37349,
      "keyword": "sala de ponencias",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de prensa": [
    {
      "id": 37350,
      "keyword": "sala de prensa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "mass media",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de prensa": [
    {
      "id": 37350,
      "keyword": "sala de prensa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "mass media",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comisión": [
    {
      "id": 37351,
      "keyword": "comisión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comisiones": [
    {
      "id": 37351,
      "keyword": "comisión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colocar los pies en la mesa": [
    {
      "id": 37356,
      "keyword": "colocar los pies en la mesa",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inclinar la silla": [
    {
      "id": 37356,
      "keyword": "inclinar la silla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manoletinas": [
    {
      "id": 37357,
      "keyword": "manoletinas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "merceditas": [
    {
      "id": 37357,
      "keyword": "merceditas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zapatos de niña": [
    {
      "id": 37357,
      "keyword": "zapatos de niña",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leer la huella": [
    {
      "id": 37358,
      "keyword": "leer la huella",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "human body",
        "physical features",
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lector de huellas": [
    {
      "id": 37358,
      "keyword": "lector de huellas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "human body",
        "physical features",
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lectores de huellas": [
    {
      "id": 37358,
      "keyword": "lector de huellas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "human body",
        "physical features",
        "document",
        "supporting document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arepa": [
    {
      "id": 37359,
      "keyword": "arepa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arepas": [
    {
      "id": 37359,
      "keyword": "arepa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aniversario": [
    {
      "id": 37363,
      "keyword": "aniversario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "birthday",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aniversarios": [
    {
      "id": 37363,
      "keyword": "aniversario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "birthday",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerdo ibérico": [
    {
      "id": 37365,
      "keyword": "cerdo ibérico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerdos ibéricos": [
    {
      "id": 37365,
      "keyword": "cerdo ibérico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerda ibérica": [
    {
      "id": 37365,
      "keyword": "cerda ibérica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerdas ibéricas": [
    {
      "id": 37365,
      "keyword": "cerda ibérica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "work",
        "primary sector",
        "cattle farming",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acordar": [
    {
      "id": 37369,
      "keyword": "acordar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37861,
      "keyword": "acordar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "minuto": [
    {
      "id": 37374,
      "keyword": "minuto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "unit of time",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "minutos": [
    {
      "id": 37374,
      "keyword": "minuto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "unit of time",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "universo": [
    {
      "id": 37375,
      "keyword": "universo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "universos": [
    {
      "id": 37375,
      "keyword": "universo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolsa de colostomía": [
    {
      "id": 37376,
      "keyword": "bolsa de colostomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37377,
      "keyword": "bolsa de colostomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas de colostomía": [
    {
      "id": 37377,
      "keyword": "bolsa de colostomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolsa de urostomía": [
    {
      "id": 37378,
      "keyword": "bolsa de urostomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37379,
      "keyword": "bolsa de urostomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas de urostomía": [
    {
      "id": 37378,
      "keyword": "bolsa de urostomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37379,
      "keyword": "bolsa de urostomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colocar bolsa de ostomía": [
    {
      "id": 37380,
      "keyword": "colocar bolsa de ostomía",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colocar disco de ostomía": [
    {
      "id": 37381,
      "keyword": "colocar disco de ostomía",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medir el estoma": [
    {
      "id": 37382,
      "keyword": "medir el estoma",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner bolsa de ostomía": [
    {
      "id": 37383,
      "keyword": "poner bolsa de ostomía",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar bolsa de ostomía": [
    {
      "id": 37383,
      "keyword": "quitar bolsa de ostomía",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiar el estoma": [
    {
      "id": 37384,
      "keyword": "limpiar el estoma",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secar el estoma": [
    {
      "id": 37385,
      "keyword": "secar el estoma",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estreñimiento por ostomía": [
    {
      "id": 37386,
      "keyword": "estreñimiento por ostomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diarrea por ostomía": [
    {
      "id": 37387,
      "keyword": "diarrea por ostomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abrir pinza de bolsa de ostomía": [
    {
      "id": 37388,
      "keyword": "abrir pinza de bolsa de ostomía",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "expulsar gases": [
    {
      "id": 37389,
      "keyword": "expulsar gases",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerrar pinza de bolsa de ostomía": [
    {
      "id": 37390,
      "keyword": "cerrar pinza de bolsa de ostomía",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsa de ilestomía": [
    {
      "id": 37391,
      "keyword": "bolsa de ilestomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37395,
      "keyword": "bolsa de ilestomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37396,
      "keyword": "bolsa de ilestomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas de ilestomía": [
    {
      "id": 37391,
      "keyword": "bolsa de ilestomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37395,
      "keyword": "bolsa de ilestomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37396,
      "keyword": "bolsa de ilestomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bolsa con orina": [
    {
      "id": 37392,
      "keyword": "bolsa con orina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas con orina": [
    {
      "id": 37392,
      "keyword": "bolsa con orina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "disco de ostomía": [
    {
      "id": 37393,
      "keyword": "disco de ostomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37394,
      "keyword": "disco de ostomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "discos de ostomía": [
    {
      "id": 37393,
      "keyword": "disco de ostomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37394,
      "keyword": "disco de ostomía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerrar bolsa de ostomía": [
    {
      "id": 37397,
      "keyword": "cerrar bolsa de ostomía",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37398,
      "keyword": "cerrar bolsa de ostomía",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ostomía": [
    {
      "id": 37399,
      "keyword": "ostomía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ostomías": [
    {
      "id": 37399,
      "keyword": "ostomía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colostomía": [
    {
      "id": 37399,
      "keyword": "colostomía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colostomías": [
    {
      "id": 37399,
      "keyword": "colostomía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "limpiar el inodoro": [
    {
      "id": 37401,
      "keyword": "limpiar el inodoro",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiar el váter": [
    {
      "id": 37401,
      "keyword": "limpiar el váter",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barritar": [
    {
      "id": 37403,
      "keyword": "barritar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "interjection",
        "onomatopoeia",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rellenar la ficha": [
    {
      "id": 37405,
      "keyword": "rellenar la ficha",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escribir el título": [
    {
      "id": 37406,
      "keyword": "escribir el título",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escribir el nombre": [
    {
      "id": 37407,
      "keyword": "escribir el nombre",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asunto del email": [
    {
      "id": 37412,
      "keyword": "asunto del email",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trinar": [
    {
      "id": 37413,
      "keyword": "trinar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "animal behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar la cremallera": [
    {
      "id": 37429,
      "keyword": "bajar la cremallera",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37414,
      "keyword": "bajar la cremallera",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar el cierre": [
    {
      "id": 37414,
      "keyword": "bajar el cierre",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "interrumpir la conversación": [
    {
      "id": 37419,
      "keyword": "interrumpir la conversación",
      "keywords": 1,
      "type": 3,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfurecer": [
    {
      "id": 37420,
      "keyword": "enfurecer",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "remitente del email": [
    {
      "id": 37422,
      "keyword": "remitente del email",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calsots": [
    {
      "id": 37425,
      "keyword": "calsots",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner la chancla": [
    {
      "id": 37426,
      "keyword": "poner la chancla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear",
        "leisure",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar la chancla": [
    {
      "id": 37427,
      "keyword": "quitar la chancla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear",
        "leisure",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar por la escalerilla": [
    {
      "id": 37428,
      "keyword": "bajar por la escalerilla",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entrar a la piscina": [
    {
      "id": 37428,
      "keyword": "entrar a la piscina",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entrar al agua": [
    {
      "id": 37428,
      "keyword": "entrar al agua",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entrar a la pileta": [
    {
      "id": 37428,
      "keyword": "entrar a la pileta",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "swimming",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rugby tag": [
    {
      "id": 37431,
      "keyword": "rugby tag",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37432,
      "keyword": "rugby tag",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rugby flag": [
    {
      "id": 37431,
      "keyword": "rugby flag",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37432,
      "keyword": "rugby flag",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuerpo del email": [
    {
      "id": 37433,
      "keyword": "cuerpo del email",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mensaje del email": [
    {
      "id": 37433,
      "keyword": "mensaje del email",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "destinatario del email": [
    {
      "id": 37434,
      "keyword": "destinatario del email",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "destinatarios del email": [
    {
      "id": 37434,
      "keyword": "destinatario del email",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clavícula": [
    {
      "id": 37435,
      "keyword": "clavícula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clavículas": [
    {
      "id": 37435,
      "keyword": "clavícula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peligro químico": [
    {
      "id": 37436,
      "keyword": "peligro químico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "chemistry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "riesgo químico": [
    {
      "id": 37436,
      "keyword": "riesgo químico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "chemistry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "altavoz inalámbrico": [
    {
      "id": 37438,
      "keyword": "altavoz inalámbrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "altavoces inalámbricos": [
    {
      "id": 37438,
      "keyword": "altavoz inalámbrico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware",
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "las cuatro esquinas": [
    {
      "id": 37449,
      "keyword": "Las cuatro esquinas",
      "keywords": 2,
      "type": 1,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juego de las 4 esquinas": [
    {
      "id": 37449,
      "keyword": "juego de las 4 esquinas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "figuras de pascua": [
    {
      "id": 37450,
      "keyword": "figuras de Pascua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "figuras de chocolate": [
    {
      "id": 37450,
      "keyword": "figuras de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oveja de chocolate": [
    {
      "id": 37451,
      "keyword": "oveja de chocolate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ovejas de chocolate": [
    {
      "id": 37451,
      "keyword": "oveja de chocolate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huevos de pascua": [
    {
      "id": 37452,
      "keyword": "huevos de Pascua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37466,
      "keyword": "huevos de Pascua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buscar huevos de pascua": [
    {
      "id": 37453,
      "keyword": "buscar huevos de Pascua",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esconder huevo de pascua": [
    {
      "id": 37454,
      "keyword": "esconder huevo de Pascua",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niña con síndrome de down": [
    {
      "id": 37455,
      "keyword": "niña con síndrome de Down",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "special education",
        "person",
        "child"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "audiocuento": [
    {
      "id": 37460,
      "keyword": "audiocuento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature",
        "library science",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "audiocuentos": [
    {
      "id": 37460,
      "keyword": "audiocuento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "literature",
        "library science",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colchón antiescaras": [
    {
      "id": 37461,
      "keyword": "colchón antiescaras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colchones antiescaras": [
    {
      "id": 37461,
      "keyword": "colchón antiescaras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "edificio oficial": [
    {
      "id": 37462,
      "keyword": "edificio oficial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37463,
      "keyword": "edificio oficial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "edificios oficiales": [
    {
      "id": 37462,
      "keyword": "edificio oficial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37463,
      "keyword": "edificio oficial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "edificio gubernamental": [
    {
      "id": 37462,
      "keyword": "edificio gubernamental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37463,
      "keyword": "edificio gubernamental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "edificios gubernamentales": [
    {
      "id": 37462,
      "keyword": "edificio gubernamental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37463,
      "keyword": "edificio gubernamental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mando de la consola": [
    {
      "id": 37464,
      "keyword": "mando de la consola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mandos de la consola": [
    {
      "id": 37464,
      "keyword": "mando de la consola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro de estancia temporal de inmigrantes": [
    {
      "id": 37465,
      "keyword": "centro de estancia temporal de inmigrantes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarso": [
    {
      "id": 37469,
      "keyword": "tarso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarsos": [
    {
      "id": 37469,
      "keyword": "tarso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carpo": [
    {
      "id": 37470,
      "keyword": "carpo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carpos": [
    {
      "id": 37470,
      "keyword": "carpo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "metacarpo": [
    {
      "id": 37471,
      "keyword": "metacarpo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "metacarpos": [
    {
      "id": 37471,
      "keyword": "metacarpo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maxilar superior": [
    {
      "id": 37472,
      "keyword": "maxilar superior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maxilares superiores": [
    {
      "id": 37472,
      "keyword": "maxilar superior",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mandíbula": [
    {
      "id": 37473,
      "keyword": "mandíbula",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mandíbulas": [
    {
      "id": 37473,
      "keyword": "mandíbula",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maxilar inferior": [
    {
      "id": 37473,
      "keyword": "maxilar inferior",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maxilares inferiores": [
    {
      "id": 37473,
      "keyword": "maxilar inferior",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "metatarso": [
    {
      "id": 37474,
      "keyword": "metatarso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "metatarsos": [
    {
      "id": 37474,
      "keyword": "metatarso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerrar las puertas": [
    {
      "id": 37476,
      "keyword": "cerrar las puertas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barómetro": [
    {
      "id": 37477,
      "keyword": "barómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "atmospheric device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barómetros": [
    {
      "id": 37477,
      "keyword": "barómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "atmospheric device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "termómetro atmosférico": [
    {
      "id": 37478,
      "keyword": "termómetro atmosférico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "atmospheric device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "termómetros atmosféricos": [
    {
      "id": 37478,
      "keyword": "termómetro atmosférico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "atmospheric device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anemómetro": [
    {
      "id": 37479,
      "keyword": "anemómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "atmospheric device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anemómetros": [
    {
      "id": 37479,
      "keyword": "anemómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "atmospheric device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pluviómetro": [
    {
      "id": 37480,
      "keyword": "pluviómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "atmospheric device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pluviómetros": [
    {
      "id": 37480,
      "keyword": "pluviómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "atmospheric device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "safari fotográfico": [
    {
      "id": 37481,
      "keyword": "safari fotográfico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "work",
        "tertiary sector",
        "tourism",
        "animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "safaris fotográfico": [
    {
      "id": 37481,
      "keyword": "safari fotográfico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "work",
        "tertiary sector",
        "tourism",
        "animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rótula": [
    {
      "id": 37482,
      "keyword": "rótula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rótulas": [
    {
      "id": 37482,
      "keyword": "rótula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "osseous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tabla de equilibrio": [
    {
      "id": 37483,
      "keyword": "tabla de equilibrio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tablas de equilibrio": [
    {
      "id": 37483,
      "keyword": "tabla de equilibrio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cinta de correr con arnés": [
    {
      "id": 37484,
      "keyword": "cinta de correr con arnés",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cintas de correr con arnés": [
    {
      "id": 37484,
      "keyword": "cinta de correr con arnés",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cinta rodante con arnés": [
    {
      "id": 37484,
      "keyword": "cinta rodante con arnés",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cintas rodantes con arnés": [
    {
      "id": 37484,
      "keyword": "cinta rodante con arnés",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tapiz rodante con arnés": [
    {
      "id": 37484,
      "keyword": "tapiz rodante con arnés",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tapices rodantes con arnés": [
    {
      "id": 37484,
      "keyword": "tapiz rodante con arnés",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mirar por la ventana": [
    {
      "id": 37487,
      "keyword": "mirar por la ventana",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cirugía plástica": [
    {
      "id": 37488,
      "keyword": "cirugía plástica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cirugía estética": [
    {
      "id": 37488,
      "keyword": "cirugía estética",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cirujana plástica": [
    {
      "id": 37489,
      "keyword": "cirujana plástica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cirujanas plásticas": [
    {
      "id": 37489,
      "keyword": "cirujana plástica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cirujana estética": [
    {
      "id": 37489,
      "keyword": "cirujana estética",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cirujanas estéticas": [
    {
      "id": 37489,
      "keyword": "cirujana estética",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cirujano plástico": [
    {
      "id": 38826,
      "keyword": "cirujano plástico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37490,
      "keyword": "cirujano plástico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cirujanos plásticos": [
    {
      "id": 38826,
      "keyword": "cirujano plástico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37490,
      "keyword": "cirujano plástico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cirujano estético": [
    {
      "id": 38826,
      "keyword": "cirujano estético",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37490,
      "keyword": "cirujano estético",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cirujanos estéticos": [
    {
      "id": 38826,
      "keyword": "cirujano estético",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37490,
      "keyword": "cirujano estético",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "psiquiatra": [
    {
      "id": 38830,
      "keyword": "psiquiatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38474,
      "keyword": "psiquiatra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38880,
      "keyword": "psiquiatra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37491,
      "keyword": "psiquiatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37492,
      "keyword": "psiquiatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "psiquiatras": [
    {
      "id": 38830,
      "keyword": "psiquiatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38474,
      "keyword": "psiquiatra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37491,
      "keyword": "psiquiatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37492,
      "keyword": "psiquiatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tejón": [
    {
      "id": 37493,
      "keyword": "tejón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tejones": [
    {
      "id": 37493,
      "keyword": "tejón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "papel articular": [
    {
      "id": 37494,
      "keyword": "papel articular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fresas dentales": [
    {
      "id": 37495,
      "keyword": "fresas dentales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ácido ortofosfórico": [
    {
      "id": 37496,
      "keyword": "ácido ortofosfórico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "composite dental": [
    {
      "id": 37497,
      "keyword": "composite dental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cemento dental": [
    {
      "id": 37497,
      "keyword": "cemento dental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "microaplicador": [
    {
      "id": 37498,
      "keyword": "microaplicador",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "microaplicadores": [
    {
      "id": 37498,
      "keyword": "microaplicador",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "microcepillo": [
    {
      "id": 37498,
      "keyword": "microcepillo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "microcepillos": [
    {
      "id": 37498,
      "keyword": "microcepillo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bastoncillo aplicador": [
    {
      "id": 37498,
      "keyword": "bastoncillo aplicador",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bastoncillos aplicadores": [
    {
      "id": 37498,
      "keyword": "bastoncillo aplicador",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "microcepillo aplicador": [
    {
      "id": 37498,
      "keyword": "microcepillo aplicador",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "microcepillos aplicadores": [
    {
      "id": 37498,
      "keyword": "microcepillo aplicador",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "adhesivo": [
    {
      "id": 37499,
      "keyword": "adhesivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "adhesivos": [
    {
      "id": 37499,
      "keyword": "adhesivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "work",
        "tool",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lámpara fotopolimerizadora": [
    {
      "id": 37500,
      "keyword": "lámpara fotopolimerizadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lámparas fotopolimerizadoras": [
    {
      "id": 37500,
      "keyword": "lámpara fotopolimerizadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "teléfono de emergencias": [
    {
      "id": 37501,
      "keyword": "teléfono de emergencias",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teléfono público": [
    {
      "id": 37502,
      "keyword": "teléfono público",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "communication",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teléfonos públicos": [
    {
      "id": 37502,
      "keyword": "teléfono público",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "communication",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "teléfono de mantenimiento": [
    {
      "id": 37503,
      "keyword": "teléfono de mantenimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plátano verde": [
    {
      "id": 37505,
      "keyword": "plátano verde",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plátanos verdes": [
    {
      "id": 37505,
      "keyword": "plátano verde",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plátano macho": [
    {
      "id": 37505,
      "keyword": "plátano macho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plátanos macho": [
    {
      "id": 37505,
      "keyword": "plátano macho",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chifles": [
    {
      "id": 37506,
      "keyword": "chifles",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37507,
      "keyword": "chifles",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "platanitos": [
    {
      "id": 37506,
      "keyword": "platanitos",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37507,
      "keyword": "platanitos",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chicharritas": [
    {
      "id": 37506,
      "keyword": "chicharritas",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37507,
      "keyword": "chicharritas",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plataninas": [
    {
      "id": 37506,
      "keyword": "plataninas",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37507,
      "keyword": "plataninas",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "platanutres": [
    {
      "id": 37506,
      "keyword": "platanutres",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37507,
      "keyword": "platanutres",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "níspero": [
    {
      "id": 37508,
      "keyword": "níspero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nísperos": [
    {
      "id": 37508,
      "keyword": "níspero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37509,
      "keyword": "nísperos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "patacones": [
    {
      "id": 37510,
      "keyword": "patacones",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tostones": [
    {
      "id": 37510,
      "keyword": "tostones",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tachinos": [
    {
      "id": 37510,
      "keyword": "tachinos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encuadernadora": [
    {
      "id": 37511,
      "keyword": "encuadernadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encuadernadoras": [
    {
      "id": 37511,
      "keyword": "encuadernadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guillotina": [
    {
      "id": 37512,
      "keyword": "guillotina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guillotinas": [
    {
      "id": 37512,
      "keyword": "guillotina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guillotina de papel": [
    {
      "id": 37512,
      "keyword": "guillotina de papel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guillotinas de papel": [
    {
      "id": 37512,
      "keyword": "guillotina de papel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pistola de silicona": [
    {
      "id": 37513,
      "keyword": "pistola de silicona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pistolas de silicona": [
    {
      "id": 37513,
      "keyword": "pistola de silicona",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ordenador con pulsador": [
    {
      "id": 37514,
      "keyword": "ordenador con pulsador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ordenadores con pulsador": [
    {
      "id": 37514,
      "keyword": "ordenador con pulsador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid",
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "correfoc": [
    {
      "id": 37515,
      "keyword": "correfoc",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "disfraz de diablo": [
    {
      "id": 37516,
      "keyword": "disfraz de diablo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "costume",
        "event",
        "popular event",
        "carnival",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "banquete": [
    {
      "id": 37517,
      "keyword": "banquete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "banquetes": [
    {
      "id": 37517,
      "keyword": "banquete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "feeding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llevar la mochila correctamente": [
    {
      "id": 37518,
      "keyword": "llevar la mochila correctamente",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llevar la mochila de forma incorrecta": [
    {
      "id": 37519,
      "keyword": "llevar la mochila de forma incorrecta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atragantar": [
    {
      "id": 37520,
      "keyword": "atragantar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "levantar correctamente": [
    {
      "id": 37521,
      "keyword": "levantar correctamente",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "healthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "levantar de forma incorrecta": [
    {
      "id": 37522,
      "keyword": "levantar de forma incorrecta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "posición de seguridad": [
    {
      "id": 37524,
      "keyword": "posición de seguridad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chino": [
    {
      "id": 37526,
      "keyword": "chino",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "adult"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puesto ambulante": [
    {
      "id": 37527,
      "keyword": "puesto ambulante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38443,
      "keyword": "puesto ambulante",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puestos ambulantes": [
    {
      "id": 37527,
      "keyword": "puesto ambulante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38443,
      "keyword": "puesto ambulante",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "beber en biberón": [
    {
      "id": 37528,
      "keyword": "beber en biberón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máquina de bebidas": [
    {
      "id": 37529,
      "keyword": "máquina de bebidas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máquina expendedora de bebidas": [
    {
      "id": 37529,
      "keyword": "máquina expendedora de bebidas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máquinas expendedoras de bebidas": [
    {
      "id": 37529,
      "keyword": "máquina expendedora de bebidas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "máquina de café": [
    {
      "id": 37530,
      "keyword": "máquina de café",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máquinas de café": [
    {
      "id": 37530,
      "keyword": "máquina de café",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "máquina expendedora de café": [
    {
      "id": 37530,
      "keyword": "máquina expendedora de café",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máquinas expendedora de café": [
    {
      "id": 37530,
      "keyword": "máquina expendedora de café",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "máquina de alimentos": [
    {
      "id": 37531,
      "keyword": "máquina de alimentos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máquinas de alimentos": [
    {
      "id": 37531,
      "keyword": "máquina de alimentos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "máquina expendedora de alimentos": [
    {
      "id": 37531,
      "keyword": "máquina expendedora de alimentos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máquinas expendedoras de alimentos": [
    {
      "id": 37531,
      "keyword": "máquina expendedora de alimentos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolor de mano": [
    {
      "id": 37532,
      "keyword": "dolor de mano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesa ordenada": [
    {
      "id": 37534,
      "keyword": "mesa ordenada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas ordenadas": [
    {
      "id": 37534,
      "keyword": "mesa ordenada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "invitación": [
    {
      "id": 37535,
      "keyword": "invitación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "invitaciones": [
    {
      "id": 37535,
      "keyword": "invitación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "invitación de cumpleaños": [
    {
      "id": 37535,
      "keyword": "invitación de cumpleaños",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "invitaciones de cumpleaños": [
    {
      "id": 37535,
      "keyword": "invitación de cumpleaños",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "birthday"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casco protector": [
    {
      "id": 37536,
      "keyword": "casco protector",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "karate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cascos protectores": [
    {
      "id": 37536,
      "keyword": "casco protector",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "karate"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casco de kárate": [
    {
      "id": 37536,
      "keyword": "casco de kárate",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "karate"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cascos de kárate": [
    {
      "id": 37536,
      "keyword": "casco de kárate",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "karate"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dormir en la cuna": [
    {
      "id": 37540,
      "keyword": "dormir en la cuna",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tribuna de público": [
    {
      "id": 37541,
      "keyword": "tribuna de público",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "work",
        "tertiary sector",
        "political representation",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entrada al hemiciclo": [
    {
      "id": 37542,
      "keyword": "entrada al hemiciclo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "work",
        "tertiary sector",
        "political representation",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entrada al salón de plenos": [
    {
      "id": 37542,
      "keyword": "entrada al salón de plenos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "work",
        "tertiary sector",
        "political representation",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trabajo en grupo": [
    {
      "id": 37866,
      "keyword": "trabajo en grupo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37543,
      "keyword": "trabajo en grupo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trabajos en grupo": [
    {
      "id": 37866,
      "keyword": "trabajo en grupo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37543,
      "keyword": "trabajo en grupo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grupo parlamentario": [
    {
      "id": 37544,
      "keyword": "grupo parlamentario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grupos parlamentarios": [
    {
      "id": 37544,
      "keyword": "grupo parlamentario",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clase de robótica": [
    {
      "id": 37545,
      "keyword": "clase de robótica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "refugio antiaéreo": [
    {
      "id": 37546,
      "keyword": "refugio antiaéreo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37549,
      "keyword": "refugio antiaéreo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37547,
      "keyword": "refugio antiaéreo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "refugios antiaéreos": [
    {
      "id": 37546,
      "keyword": "refugio antiaéreo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37549,
      "keyword": "refugio antiaéreo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37547,
      "keyword": "refugio antiaéreo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "refugio antibombas": [
    {
      "id": 37546,
      "keyword": "refugio antibombas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37549,
      "keyword": "refugio antibombas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37547,
      "keyword": "refugio antibombas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "refugios antibombas": [
    {
      "id": 37546,
      "keyword": "refugio antibombas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37549,
      "keyword": "refugio antibombas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37547,
      "keyword": "refugio antibombas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "misil": [
    {
      "id": 37548,
      "keyword": "misil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "misiles": [
    {
      "id": 37548,
      "keyword": "misil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plinto": [
    {
      "id": 37550,
      "keyword": "plinto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "gymnastics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plintos": [
    {
      "id": 37550,
      "keyword": "plinto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "gymnastics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salmorejo": [
    {
      "id": 37551,
      "keyword": "salmorejo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnico de mantenimiento": [
    {
      "id": 37554,
      "keyword": "técnico de mantenimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnicos de mantenimiento": [
    {
      "id": 37554,
      "keyword": "técnico de mantenimiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "director de gabinete": [
    {
      "id": 37555,
      "keyword": "director de gabinete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gabinete": [
    {
      "id": 37556,
      "keyword": "gabinete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jefe de prensa": [
    {
      "id": 37557,
      "keyword": "jefe de prensa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "mass media",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jefes de prensa": [
    {
      "id": 37557,
      "keyword": "jefe de prensa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "mass media",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "secretaría de la mesa": [
    {
      "id": 37558,
      "keyword": "secretaría de la mesa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "political representation",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secretaría de servicios jurídicos": [
    {
      "id": 37559,
      "keyword": "secretaría de servicios jurídicos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "law",
        "justice",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secretaría de presidencia": [
    {
      "id": 37560,
      "keyword": "secretaría de presidencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "political representation",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "senador": [
    {
      "id": 37561,
      "keyword": "senador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "senadores": [
    {
      "id": 37561,
      "keyword": "senador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jefe de protocolo": [
    {
      "id": 37562,
      "keyword": "jefe de protocolo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "political representation",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presidente del congreso": [
    {
      "id": 37563,
      "keyword": "presidente del congreso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presidente del parlamento": [
    {
      "id": 37563,
      "keyword": "presidente del parlamento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presidente del senado": [
    {
      "id": 37563,
      "keyword": "presidente del senado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "leader",
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secretaría del congreso": [
    {
      "id": 37564,
      "keyword": "secretaría del congreso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37565,
      "keyword": "secretaría del congreso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secretaría del parlamento": [
    {
      "id": 37564,
      "keyword": "secretaría del parlamento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37565,
      "keyword": "secretaría del parlamento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vicepresidencia del congreso": [
    {
      "id": 37566,
      "keyword": "vicepresidencia del congreso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37567,
      "keyword": "vicepresidencia del congreso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vicepresidencia del parlamento": [
    {
      "id": 37566,
      "keyword": "vicepresidencia del parlamento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37567,
      "keyword": "vicepresidencia del parlamento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vicepresidencia del senado": [
    {
      "id": 37566,
      "keyword": "vicepresidencia del senado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37567,
      "keyword": "vicepresidencia del senado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presidencia del congreso": [
    {
      "id": 37568,
      "keyword": "presidencia del congreso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presidencia del parlamento": [
    {
      "id": 37568,
      "keyword": "presidencia del parlamento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presidencia del senado": [
    {
      "id": 37568,
      "keyword": "presidencia del senado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesa del parlamento": [
    {
      "id": 37569,
      "keyword": "mesa del parlamento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesa del congreso": [
    {
      "id": 37569,
      "keyword": "mesa del congreso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "departamento de comunicación": [
    {
      "id": 37570,
      "keyword": "departamento de comunicación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "mass media",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jefe de informática y nntt": [
    {
      "id": 37571,
      "keyword": "jefe de informática y NNTT",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "computing",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jefe de asuntos económicos": [
    {
      "id": 37572,
      "keyword": "jefe de asuntos económicos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "economy",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnico jurídico": [
    {
      "id": 37573,
      "keyword": "técnico jurídico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "law",
        "justice",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnico jurídicos": [
    {
      "id": 37573,
      "keyword": "técnico jurídico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "law",
        "justice",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chanclas con velcro": [
    {
      "id": 37574,
      "keyword": "chanclas con velcro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37575,
      "keyword": "chancla con velcro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sandalia con velcro": [
    {
      "id": 37575,
      "keyword": "sandalia con velcro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sandalias con velcro": [
    {
      "id": 37575,
      "keyword": "sandalia con velcro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chancla con velcro": [
    {
      "id": 37575,
      "keyword": "chancla con velcro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cripta": [
    {
      "id": 37579,
      "keyword": "cripta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "criptas": [
    {
      "id": 37579,
      "keyword": "cripta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abandonado": [
    {
      "id": 37703,
      "keyword": "abandonado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37580,
      "keyword": "abandonado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "secondary sector",
        "construction",
        "place",
        "building",
        "home",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abandonadas": [
    {
      "id": 37703,
      "keyword": "abandonada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37580,
      "keyword": "abandonado",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "secondary sector",
        "construction",
        "place",
        "building",
        "home",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37580,
      "keyword": "abandonada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "secondary sector",
        "construction",
        "place",
        "building",
        "home",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abandonada": [
    {
      "id": 37703,
      "keyword": "abandonada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37580,
      "keyword": "abandonada",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "work",
        "secondary sector",
        "construction",
        "place",
        "building",
        "home",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de tatuajes": [
    {
      "id": 37581,
      "keyword": "tienda de tatuajes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de tatuajes": [
    {
      "id": 37581,
      "keyword": "tienda de tatuajes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estudio de tatuajes": [
    {
      "id": 37581,
      "keyword": "estudio de tatuajes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estudios de tatuajes": [
    {
      "id": 37581,
      "keyword": "estudio de tatuajes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "human body",
        "physical features"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jarrete": [
    {
      "id": 37582,
      "keyword": "jarrete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jarretes": [
    {
      "id": 37582,
      "keyword": "jarrete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alitas de pollo": [
    {
      "id": 37583,
      "keyword": "alitas de pollo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clavel chino": [
    {
      "id": 37584,
      "keyword": "clavel chino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "claveles chinos": [
    {
      "id": 37584,
      "keyword": "clavel chino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "flower",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palometa negra": [
    {
      "id": 37586,
      "keyword": "palometa negra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "ovoviviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palometas negras": [
    {
      "id": 37586,
      "keyword": "palometa negra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "ovoviviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palometa": [
    {
      "id": 37586,
      "keyword": "palometa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "ovoviviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palometas": [
    {
      "id": 37586,
      "keyword": "palometa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "ovoviviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zamburiña": [
    {
      "id": 37587,
      "keyword": "zamburiña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zamburiñas": [
    {
      "id": 37587,
      "keyword": "zamburiña",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "mollusc",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palometa roja": [
    {
      "id": 37588,
      "keyword": "palometa roja",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palometas rojas": [
    {
      "id": 37588,
      "keyword": "palometa roja",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pez de rey": [
    {
      "id": 37588,
      "keyword": "pez de rey",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pezces de rey": [
    {
      "id": 37588,
      "keyword": "pez de rey",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cachucho": [
    {
      "id": 37588,
      "keyword": "cachucho",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cachuchos": [
    {
      "id": 37588,
      "keyword": "cachucho",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alfonsino": [
    {
      "id": 37588,
      "keyword": "alfonsino",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alfonsinos": [
    {
      "id": 37588,
      "keyword": "alfonsino",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "parecido a": [
    {
      "id": 37590,
      "keyword": "parecido a",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "comparative adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parecidos a": [
    {
      "id": 37590,
      "keyword": "parecido a",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "comparative adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "similar a": [
    {
      "id": 37590,
      "keyword": "similar a",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "comparative adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "similares a": [
    {
      "id": 37590,
      "keyword": "similar a",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "comparative adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "morro de cerdo": [
    {
      "id": 37591,
      "keyword": "morro de cerdo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "morros de cerdo": [
    {
      "id": 37591,
      "keyword": "morro de cerdo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "picotas": [
    {
      "id": 37592,
      "keyword": "picotas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerezas picotas": [
    {
      "id": 37592,
      "keyword": "cerezas picotas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "buey de mar": [
    {
      "id": 37593,
      "keyword": "buey de mar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bueyes de mar": [
    {
      "id": 37593,
      "keyword": "buey de mar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oreja de cerdo": [
    {
      "id": 37594,
      "keyword": "oreja de cerdo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orejas de cerdo": [
    {
      "id": 37594,
      "keyword": "oreja de cerdo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "feeding",
        "food",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cabracho": [
    {
      "id": 37596,
      "keyword": "cabracho",
      "keywords": 6,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cabrachos": [
    {
      "id": 37596,
      "keyword": "cabracho",
      "keywords": 6,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gallineta": [
    {
      "id": 37596,
      "keyword": "gallineta",
      "keywords": 6,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gallinetas": [
    {
      "id": 37596,
      "keyword": "gallineta",
      "keywords": 6,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escorpena": [
    {
      "id": 37596,
      "keyword": "escorpena",
      "keywords": 6,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escorpenas": [
    {
      "id": 37596,
      "keyword": "escorpena",
      "keywords": 6,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escorpión rojo": [
    {
      "id": 37596,
      "keyword": "escorpión rojo",
      "keywords": 6,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escorpiones rojos": [
    {
      "id": 37596,
      "keyword": "escorpión rojo",
      "keywords": 6,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rascasote": [
    {
      "id": 37596,
      "keyword": "rascasote",
      "keywords": 6,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rascasotes": [
    {
      "id": 37596,
      "keyword": "rascasote",
      "keywords": 6,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cantarero": [
    {
      "id": 37596,
      "keyword": "cantarero",
      "keywords": 6,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cantareros": [
    {
      "id": 37596,
      "keyword": "cantarero",
      "keywords": 6,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caballa": [
    {
      "id": 37597,
      "keyword": "caballa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caballas": [
    {
      "id": 37597,
      "keyword": "caballa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "verdel": [
    {
      "id": 37597,
      "keyword": "verdel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "verdeles": [
    {
      "id": 37597,
      "keyword": "verdel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "macarela": [
    {
      "id": 37597,
      "keyword": "macarela",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "macarelas": [
    {
      "id": 37597,
      "keyword": "macarela",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grelos": [
    {
      "id": 37598,
      "keyword": "grelos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable",
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nectarina": [
    {
      "id": 37599,
      "keyword": "nectarina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "nectarinas": [
    {
      "id": 37599,
      "keyword": "nectarina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "peladillo": [
    {
      "id": 37599,
      "keyword": "peladillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37599,
      "keyword": "peladillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cebolleta": [
    {
      "id": 37600,
      "keyword": "cebolleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cebolletas": [
    {
      "id": 37600,
      "keyword": "cebolleta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cebolla tierna": [
    {
      "id": 37600,
      "keyword": "cebolla tierna",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cebollas tiernas": [
    {
      "id": 37600,
      "keyword": "cebolla tierna",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pala para queso": [
    {
      "id": 37602,
      "keyword": "pala para queso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palas para queso": [
    {
      "id": 37602,
      "keyword": "pala para queso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "laminador de queso": [
    {
      "id": 37602,
      "keyword": "laminador de queso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "laminadores de queso": [
    {
      "id": 37602,
      "keyword": "laminador de queso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pala corta queso": [
    {
      "id": 37602,
      "keyword": "pala corta queso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palas corta queso": [
    {
      "id": 37602,
      "keyword": "pala corta queso",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "puente levadizo": [
    {
      "id": 37603,
      "keyword": "puente levadizo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puentes levadizos": [
    {
      "id": 37603,
      "keyword": "puente levadizo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camarón": [
    {
      "id": 37605,
      "keyword": "camarón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camarones": [
    {
      "id": 37605,
      "keyword": "camarón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pez de san pedro": [
    {
      "id": 37606,
      "keyword": "pez de san Pedro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peces de san pedro": [
    {
      "id": 37606,
      "keyword": "pez de san Pedro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de lactancia": [
    {
      "id": 37607,
      "keyword": "sala de lactancia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de lactancia": [
    {
      "id": 37607,
      "keyword": "sala de lactancia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lactancia": [
    {
      "id": 37608,
      "keyword": "lactancia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "retinoscopio": [
    {
      "id": 37610,
      "keyword": "retinoscopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "retinoscopios": [
    {
      "id": 37610,
      "keyword": "retinoscopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "retinoscopia": [
    {
      "id": 37612,
      "keyword": "retinoscopia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37624,
      "keyword": "retinoscopia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "retinoscopias": [
    {
      "id": 37612,
      "keyword": "retinoscopia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37624,
      "keyword": "retinoscopia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "oclusores": [
    {
      "id": 37613,
      "keyword": "oclusores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oclusores oculares": [
    {
      "id": 37613,
      "keyword": "oclusores oculares",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gafas verdes y rojas": [
    {
      "id": 37614,
      "keyword": "gafas verdes y rojas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gafas grises": [
    {
      "id": 37615,
      "keyword": "gafas grises",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "auto refractómetro": [
    {
      "id": 37616,
      "keyword": "auto refractómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "auto refractómetros": [
    {
      "id": 37616,
      "keyword": "auto refractómetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tapar un ojo": [
    {
      "id": 37617,
      "keyword": "tapar un ojo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "busto": [
    {
      "id": 37618,
      "keyword": "busto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "sculpture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bustos": [
    {
      "id": 37618,
      "keyword": "busto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "sculpture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "torreón": [
    {
      "id": 37621,
      "keyword": "torreón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "middle ages",
        "building"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torreones": [
    {
      "id": 37621,
      "keyword": "torreón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "middle ages",
        "building"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fortalezas": [
    {
      "id": 37621,
      "keyword": "fortaleza",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "middle ages",
        "building"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "monolito": [
    {
      "id": 37622,
      "keyword": "monolito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monolitos": [
    {
      "id": 37622,
      "keyword": "monolito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "obelisco": [
    {
      "id": 37622,
      "keyword": "obelisco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obeliscos": [
    {
      "id": 37622,
      "keyword": "obelisco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "regla de retinoscopia": [
    {
      "id": 37629,
      "keyword": "regla de retinoscopia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reglas de retinoscopia": [
    {
      "id": 37629,
      "keyword": "regla de retinoscopia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "linterna de exploración ocular": [
    {
      "id": 37630,
      "keyword": "linterna de exploración ocular",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "linternas de exploración ocular": [
    {
      "id": 37630,
      "keyword": "linterna de exploración ocular",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "linterna para optometría": [
    {
      "id": 37630,
      "keyword": "linterna para optometría",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "linternas para optometría": [
    {
      "id": 37630,
      "keyword": "linterna para optometría",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gafas de optometría": [
    {
      "id": 37631,
      "keyword": "gafas de optometría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "montura de prueba": [
    {
      "id": 37631,
      "keyword": "montura de prueba",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gafas de prueba": [
    {
      "id": 37631,
      "keyword": "gafas de prueba",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillón oftalmológico": [
    {
      "id": 37632,
      "keyword": "sillón oftalmológico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillones oftalmológicos": [
    {
      "id": 37632,
      "keyword": "sillón oftalmológico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maremoto": [
    {
      "id": 37633,
      "keyword": "maremoto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maremotos": [
    {
      "id": 37633,
      "keyword": "maremoto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "falta de contacto visual": [
    {
      "id": 37634,
      "keyword": "falta de contacto visual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ausencia de contacto visual": [
    {
      "id": 37634,
      "keyword": "ausencia de contacto visual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reciclaje de medicamentos": [
    {
      "id": 37635,
      "keyword": "reciclaje de medicamentos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament",
        "environmental science",
        "recycling",
        "place",
        "facility",
        "recycling center"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "punto sigre": [
    {
      "id": 37635,
      "keyword": "punto sigre",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament",
        "environmental science",
        "recycling",
        "place",
        "facility",
        "recycling center"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "andar de puntillas": [
    {
      "id": 37637,
      "keyword": "andar de puntillas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ausencia de lenguaje": [
    {
      "id": 37638,
      "keyword": "ausencia de lenguaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dificultad para aceptar los cambios": [
    {
      "id": 37639,
      "keyword": "dificultad para aceptar los cambios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ausencia de juego simbólico": [
    {
      "id": 37640,
      "keyword": "ausencia de juego simbólico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "falta de juego simbólico": [
    {
      "id": 37640,
      "keyword": "falta de juego simbólico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "falta de interés para relacionarse": [
    {
      "id": 37641,
      "keyword": "falta de interés para relacionarse",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dificultad en la socialización": [
    {
      "id": 37641,
      "keyword": "dificultad en la socialización",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pan con tomate": [
    {
      "id": 37642,
      "keyword": "pan con tomate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kenia": [
    {
      "id": 37649,
      "keyword": "Kenia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "country"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37650,
      "keyword": "Kenia",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "petit suisse": [
    {
      "id": 37652,
      "keyword": "petit suisse",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "petit suisses": [
    {
      "id": 37652,
      "keyword": "petit suisse",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "petit-suisse": [
    {
      "id": 37652,
      "keyword": "petit-suisse",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "petit-suisses": [
    {
      "id": 37652,
      "keyword": "petit-suisse",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fiesta junina": [
    {
      "id": 37654,
      "keyword": "fiesta junina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37656,
      "keyword": "fiesta junina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juegos de agua": [
    {
      "id": 37655,
      "keyword": "juegos de agua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "makey makey": [
    {
      "id": 37657,
      "keyword": "makey makey",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "circuit board": [
    {
      "id": 37657,
      "keyword": "circuit board",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "circuit boards": [
    {
      "id": 37657,
      "keyword": "circuit board",
      "keywords": 2,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "time-timer": [
    {
      "id": 37659,
      "keyword": "Time-Timer",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "time",
        "chronological device",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "repelente de mosquitos": [
    {
      "id": 37660,
      "keyword": "repelente de mosquitos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "repelentes de mosquitos": [
    {
      "id": 37660,
      "keyword": "repelente de mosquitos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "poco tiempo": [
    {
      "id": 37661,
      "keyword": "poco tiempo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "emblemático": [
    {
      "id": 37662,
      "keyword": "emblemático",
      "keywords": 3,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "emblemáticos": [
    {
      "id": 37662,
      "keyword": "emblemático",
      "keywords": 3,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "simbólico": [
    {
      "id": 37662,
      "keyword": "simbólico",
      "keywords": 3,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "simbólicos": [
    {
      "id": 37662,
      "keyword": "simbólico",
      "keywords": 3,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "representativo": [
    {
      "id": 37662,
      "keyword": "representativo",
      "keywords": 3,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "representativos": [
    {
      "id": 37662,
      "keyword": "representativo",
      "keywords": 3,
      "type": 4,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "fiscal": [
    {
      "id": 37665,
      "keyword": "fiscal",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "fiscales": [
    {
      "id": 37665,
      "keyword": "fiscal",
      "keywords": 1,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "abogado defensor": [
    {
      "id": 37668,
      "keyword": "abogado defensor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abogados defensores": [
    {
      "id": 37668,
      "keyword": "abogado defensor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "law",
        "justice",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de vistas": [
    {
      "id": 37671,
      "keyword": "sala de vistas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de vistas": [
    {
      "id": 37671,
      "keyword": "sala de vistas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "work",
        "tertiary sector",
        "law",
        "justice"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rifle de paintball": [
    {
      "id": 37672,
      "keyword": "rifle de paintball",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "leisure",
        "game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rifles de paintball": [
    {
      "id": 37672,
      "keyword": "rifle de paintball",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "leisure",
        "game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barco fluvial": [
    {
      "id": 37673,
      "keyword": "barco fluvial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "outdoor activity",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barcos fluviales": [
    {
      "id": 37673,
      "keyword": "barco fluvial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "leisure",
        "outdoor activity",
        "river"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esfinge": [
    {
      "id": 37674,
      "keyword": "esfinge",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "civilization",
        "Egypt"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esfinges": [
    {
      "id": 37674,
      "keyword": "esfinge",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "civilization",
        "Egypt"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tiburón ballena": [
    {
      "id": 37675,
      "keyword": "tiburón ballena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "carnivorous",
        "ovoviviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiburones ballnea": [
    {
      "id": 37675,
      "keyword": "tiburón ballena",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "carnivorous",
        "ovoviviparous",
        "aquatic animal",
        "marine animal",
        "sea"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "baobab": [
    {
      "id": 37676,
      "keyword": "baobab",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baobabs": [
    {
      "id": 37676,
      "keyword": "baobab",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "góndola": [
    {
      "id": 37677,
      "keyword": "góndola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "góndolas": [
    {
      "id": 37677,
      "keyword": "góndola",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mucho tiempo": [
    {
      "id": 37678,
      "keyword": "mucho tiempo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of degree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dispositivo de presión positiva": [
    {
      "id": 37679,
      "keyword": "dispositivo de presión positiva",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aparato de presión positiva continua": [
    {
      "id": 37679,
      "keyword": "aparato de presión positiva continua",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terapia cpap": [
    {
      "id": 37679,
      "keyword": "terapia CPAP",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tapar la nariz": [
    {
      "id": 37680,
      "keyword": "tapar la nariz",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obstrucción de la laringe": [
    {
      "id": 37681,
      "keyword": "obstrucción de la laringe",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "obstrucción de la vía aérea": [
    {
      "id": 37681,
      "keyword": "obstrucción de la vía aérea",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "síndrome de apnea del sueño": [
    {
      "id": 37682,
      "keyword": "síndrome de apnea del sueño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "funda para móvil": [
    {
      "id": 37683,
      "keyword": "funda para móvil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fundas para móvil": [
    {
      "id": 37683,
      "keyword": "funda para móvil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "línea de salida": [
    {
      "id": 37684,
      "keyword": "línea de salida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bodegón": [
    {
      "id": 37688,
      "keyword": "bodegón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "painting",
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bodegones": [
    {
      "id": 37688,
      "keyword": "bodegón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "visual art",
        "painting",
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cántaro": [
    {
      "id": 37689,
      "keyword": "cántaro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cántaros": [
    {
      "id": 37689,
      "keyword": "cántaro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "container",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mantear": [
    {
      "id": 37690,
      "keyword": "mantear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espiga": [
    {
      "id": 37691,
      "keyword": "espiga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "feeding",
        "food",
        "plant-based food",
        "cereal",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espigas": [
    {
      "id": 37691,
      "keyword": "espiga",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "feeding",
        "food",
        "plant-based food",
        "cereal",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "segador": [
    {
      "id": 37695,
      "keyword": "segador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "segadores": [
    {
      "id": 37695,
      "keyword": "segador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "empresa de distribución": [
    {
      "id": 37696,
      "keyword": "empresa de distribución",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "transport services",
        "place",
        "building",
        "industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empresas de distribución": [
    {
      "id": 37696,
      "keyword": "empresa de distribución",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "transport services",
        "place",
        "building",
        "industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "toldo": [
    {
      "id": 37697,
      "keyword": "toldo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toldos": [
    {
      "id": 37697,
      "keyword": "toldo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carpintería metálica": [
    {
      "id": 37698,
      "keyword": "carpintería metálica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carpinterías metálicas": [
    {
      "id": 37698,
      "keyword": "carpintería metálica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "industry",
        "work",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hinchar": [
    {
      "id": 37699,
      "keyword": "hinchar",
      "keywords": 2,
      "type": 3,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "inflar": [
    {
      "id": 37699,
      "keyword": "inflar",
      "keywords": 2,
      "type": 3,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "fusilar": [
    {
      "id": 37700,
      "keyword": "fusilar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fusilamiento": [
    {
      "id": 37700,
      "keyword": "fusilamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fusilamientos": [
    {
      "id": 37700,
      "keyword": "fusilamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ejecución": [
    {
      "id": 37700,
      "keyword": "ejecución",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ejecuciones": [
    {
      "id": 37700,
      "keyword": "ejecución",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "invadir": [
    {
      "id": 37701,
      "keyword": "invadir",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ocupar": [
    {
      "id": 37701,
      "keyword": "ocupar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "invasión": [
    {
      "id": 37701,
      "keyword": "invasión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abandonados": [
    {
      "id": 37703,
      "keyword": "abandonado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dueño": [
    {
      "id": 37704,
      "keyword": "dueño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dueños": [
    {
      "id": 37704,
      "keyword": "dueño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "napoléon": [
    {
      "id": 37705,
      "keyword": "Napoléon",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  " napoleón bonaparte": [
    {
      "id": 37705,
      "keyword": " Napoleón Bonaparte",
      "keywords": 2,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "turbante": [
    {
      "id": 37706,
      "keyword": "turbante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "turbantes": [
    {
      "id": 37706,
      "keyword": "turbante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tambor metálico": [
    {
      "id": 37707,
      "keyword": "tambor metálico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tambores metálicos": [
    {
      "id": 37707,
      "keyword": "tambor metálico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recomendar": [
    {
      "id": 37708,
      "keyword": "recomendar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aconsejar": [
    {
      "id": 37708,
      "keyword": "aconsejar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "interesar": [
    {
      "id": 37709,
      "keyword": "interesar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "solución": [
    {
      "id": 37711,
      "keyword": "solución",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "soluciones": [
    {
      "id": 37711,
      "keyword": "solución",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "solucionar": [
    {
      "id": 37711,
      "keyword": "solucionar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "resolver": [
    {
      "id": 37711,
      "keyword": "resolver",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cornamenta": [
    {
      "id": 37712,
      "keyword": "cornamenta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cornamentas": [
    {
      "id": 37712,
      "keyword": "cornamenta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "homo sapiens": [
    {
      "id": 37713,
      "keyword": "Homo sapiens",
      "keywords": 1,
      "type": 1,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "resaltar": [
    {
      "id": 37714,
      "keyword": "resaltar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "computing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "protector bucal": [
    {
      "id": 37715,
      "keyword": "protector bucal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "protectores bucales": [
    {
      "id": 37715,
      "keyword": "protector bucal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "extinguir": [
    {
      "id": 37716,
      "keyword": "extinguir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "erosión": [
    {
      "id": 37717,
      "keyword": "erosión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "goma elástica": [
    {
      "id": 37718,
      "keyword": "goma elástica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gomas elásticas": [
    {
      "id": 37718,
      "keyword": "goma elástica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tantear": [
    {
      "id": 37719,
      "keyword": "tantear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "albahaca": [
    {
      "id": 37722,
      "keyword": "albahaca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meses": [
    {
      "id": 37724,
      "keyword": "mes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "time",
        "calendar",
        "month",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espiral": [
    {
      "id": 37733,
      "keyword": "espiral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espirales": [
    {
      "id": 37733,
      "keyword": "espiral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "shape",
        "mathematics",
        "geometry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "té helado": [
    {
      "id": 37734,
      "keyword": "té helado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tés helados": [
    {
      "id": 37734,
      "keyword": "té helado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "accidente cerebrovascular": [
    {
      "id": 37735,
      "keyword": "accidente cerebrovascular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "accidentes cerebrovasculares": [
    {
      "id": 37735,
      "keyword": "accidente cerebrovascular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolencia renal": [
    {
      "id": 37737,
      "keyword": "dolencia renal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "disfunción renal": [
    {
      "id": 37737,
      "keyword": "disfunción renal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hipertensión": [
    {
      "id": 37738,
      "keyword": "hipertensión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "delegaciones": [
    {
      "id": 37739,
      "keyword": "delegaciones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "public administration",
        "service building",
        "industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sucursales": [
    {
      "id": 37739,
      "keyword": "sucursales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "public administration",
        "service building",
        "industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de alemán": [
    {
      "id": 37740,
      "keyword": "clase de alemán",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de alemán": [
    {
      "id": 37740,
      "keyword": "clase de alemán",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alemán": [
    {
      "id": 37740,
      "keyword": "alemán",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mercadillo": [
    {
      "id": 38297,
      "keyword": "mercadillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "tertiary sector",
        "trade",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37741,
      "keyword": "mercadillo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "tertiary sector",
        "trade",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mercadillos": [
    {
      "id": 38297,
      "keyword": "mercadillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "tertiary sector",
        "trade",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37741,
      "keyword": "mercadillo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "tertiary sector",
        "trade",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rastro": [
    {
      "id": 37741,
      "keyword": "rastro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "tertiary sector",
        "trade",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "antigüedades": [
    {
      "id": 37742,
      "keyword": "antigüedades",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "object",
        "decorative item",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puesto de antigüedades": [
    {
      "id": 37742,
      "keyword": "puesto de antigüedades",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "object",
        "decorative item",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puestos de antigüedades": [
    {
      "id": 37742,
      "keyword": "puesto de antigüedades",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "object",
        "decorative item",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cacharrería": [
    {
      "id": 37743,
      "keyword": "cacharrería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "object",
        "household",
        "crockery",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cacharrerías": [
    {
      "id": 37743,
      "keyword": "cacharrería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "object",
        "household",
        "crockery",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "última vez": [
    {
      "id": 37744,
      "keyword": "última vez",
      "keywords": 1,
      "type": 4,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuarta vez": [
    {
      "id": 37745,
      "keyword": "cuarta vez",
      "keywords": 1,
      "type": 4,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tercera vez": [
    {
      "id": 37746,
      "keyword": "tercera vez",
      "keywords": 1,
      "type": 4,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "segunda vez": [
    {
      "id": 37747,
      "keyword": "segunda vez",
      "keywords": 1,
      "type": 4,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tercer": [
    {
      "id": 37749,
      "keyword": "tercer",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "primera vez": [
    {
      "id": 37752,
      "keyword": "primera vez",
      "keywords": 1,
      "type": 4,
      "tags": [
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "primer": [
    {
      "id": 37753,
      "keyword": "primer",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "ordinal adjective",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tinta": [
    {
      "id": 37754,
      "keyword": "tinta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tintas": [
    {
      "id": 37754,
      "keyword": "tinta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "visual art"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "morder el mordedor": [
    {
      "id": 37761,
      "keyword": "morder el mordedor",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37762,
      "keyword": "morder el mordedor",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gorro bandana": [
    {
      "id": 37763,
      "keyword": "gorro bandana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gorros bandanas": [
    {
      "id": 37763,
      "keyword": "gorro bandana",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bandana de cocinero": [
    {
      "id": 37763,
      "keyword": "bandana de cocinero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bandanas de cocinero": [
    {
      "id": 37763,
      "keyword": "bandana de cocinero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cambiar las pilas": [
    {
      "id": 37775,
      "keyword": "cambiar las pilas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner pilas": [
    {
      "id": 37775,
      "keyword": "poner pilas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alguien": [
    {
      "id": 37779,
      "keyword": "alguien",
      "keywords": 1,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "indefinite pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mediar": [
    {
      "id": 37781,
      "keyword": "mediar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37785,
      "keyword": "mediar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reconciliar": [
    {
      "id": 37781,
      "keyword": "reconciliar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mediador": [
    {
      "id": 37782,
      "keyword": "mediador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mediadores": [
    {
      "id": 37782,
      "keyword": "mediador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "psychology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "voluntariedad": [
    {
      "id": 37784,
      "keyword": "voluntariedad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "disposición": [
    {
      "id": 37784,
      "keyword": "disposición",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intermediar": [
    {
      "id": 37785,
      "keyword": "intermediar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conflicto": [
    {
      "id": 37786,
      "keyword": "conflicto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conflictos": [
    {
      "id": 37786,
      "keyword": "conflicto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comilona": [
    {
      "id": 37789,
      "keyword": "comilona",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comilonas": [
    {
      "id": 37789,
      "keyword": "comilona",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tragona": [
    {
      "id": 37789,
      "keyword": "tragona",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tragonas": [
    {
      "id": 37789,
      "keyword": "tragona",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "lifestyle",
        "unhealthy habit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "embustero": [
    {
      "id": 37792,
      "keyword": "embustero",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "embusteros": [
    {
      "id": 37792,
      "keyword": "embustero",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "embustera": [
    {
      "id": 37792,
      "keyword": "embustera",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "embusteras": [
    {
      "id": 37792,
      "keyword": "embustera",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "confortable": [
    {
      "id": 37793,
      "keyword": "confortable",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "confortables": [
    {
      "id": 37793,
      "keyword": "confortable",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pudiente": [
    {
      "id": 37803,
      "keyword": "pudiente",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pudientes": [
    {
      "id": 37803,
      "keyword": "pudiente",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "economy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tenderas": [
    {
      "id": 37809,
      "keyword": "tendera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "seller",
        "tertiary sector",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "niño con estrabismo": [
    {
      "id": 37814,
      "keyword": "niño con estrabismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niños con estrabismo": [
    {
      "id": 37814,
      "keyword": "niño con estrabismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "niña con estrabismo": [
    {
      "id": 37815,
      "keyword": "niña con estrabismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "niñas con estrabismo": [
    {
      "id": 37815,
      "keyword": "niña con estrabismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "ophthalmology",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estrabismo": [
    {
      "id": 37819,
      "keyword": "estrabismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37820,
      "keyword": "estrabismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "ophthalmology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estreñir": [
    {
      "id": 37829,
      "keyword": "estreñir",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vaguear": [
    {
      "id": 37830,
      "keyword": "vaguear",
      "keywords": 9,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "holgazanear": [
    {
      "id": 37830,
      "keyword": "holgazanear",
      "keywords": 9,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gandul": [
    {
      "id": 37830,
      "keyword": "gandul",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gandules": [
    {
      "id": 37830,
      "keyword": "gandul",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "holgazán": [
    {
      "id": 37830,
      "keyword": "holgazán",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "holgazanes": [
    {
      "id": 37830,
      "keyword": "holgazán",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "holgazana": [
    {
      "id": 37830,
      "keyword": "holgazana",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "holgazanas": [
    {
      "id": 37830,
      "keyword": "holgazana",
      "keywords": 9,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesa infantil": [
    {
      "id": 37831,
      "keyword": "mesa infantil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational equipment",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas infantiles": [
    {
      "id": 37831,
      "keyword": "mesa infantil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational equipment",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesa para niños": [
    {
      "id": 37831,
      "keyword": "mesa para niños",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational equipment",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas para niños": [
    {
      "id": 37831,
      "keyword": "mesa para niños",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational equipment",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desinfectante para superficies": [
    {
      "id": 37837,
      "keyword": "desinfectante para superficies",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desinfectantes para superficies": [
    {
      "id": 37837,
      "keyword": "desinfectante para superficies",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "limpiador desinfectante": [
    {
      "id": 37837,
      "keyword": "limpiador desinfectante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiadores desinfectante": [
    {
      "id": 37837,
      "keyword": "limpiador desinfectante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "spray desinfectante": [
    {
      "id": 37837,
      "keyword": "spray desinfectante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sprays desinfectante": [
    {
      "id": 37837,
      "keyword": "spray desinfectante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "health",
        "prevention measure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lluvia de ceniza": [
    {
      "id": 37838,
      "keyword": "lluvia de ceniza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "río de lava": [
    {
      "id": 37839,
      "keyword": "río de lava",
      "keywords": 3,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ríos de lava": [
    {
      "id": 37839,
      "keyword": "río de lava",
      "keywords": 3,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "erupción de lava": [
    {
      "id": 37840,
      "keyword": "erupción de lava",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37839,
      "keyword": "erupción de lava",
      "keywords": 3,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "erupciones de lava": [
    {
      "id": 37840,
      "keyword": "erupción de lava",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37839,
      "keyword": "erupción de lava",
      "keywords": 3,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colada de lava": [
    {
      "id": 37840,
      "keyword": "colada de lava",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37839,
      "keyword": "colada de lava",
      "keywords": 3,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coladas de lava": [
    {
      "id": 37840,
      "keyword": "colada de lava",
      "keywords": 2,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37839,
      "keyword": "colada de lava",
      "keywords": 3,
      "type": 2,
      "tags": [
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bol con frutas": [
    {
      "id": 37842,
      "keyword": "bol con frutas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frotis oral": [
    {
      "id": 37844,
      "keyword": "frotis oral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37845,
      "keyword": "frotis oral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37846,
      "keyword": "frotis oral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37847,
      "keyword": "frotis oral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frotis orales": [
    {
      "id": 37844,
      "keyword": "frotis oral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37845,
      "keyword": "frotis oral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37846,
      "keyword": "frotis oral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37847,
      "keyword": "frotis oral",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frotis bucal": [
    {
      "id": 37844,
      "keyword": "frotis bucal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37845,
      "keyword": "frotis bucal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37846,
      "keyword": "frotis bucal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37847,
      "keyword": "frotis bucal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frotis bucales": [
    {
      "id": 37844,
      "keyword": "frotis bucal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37845,
      "keyword": "frotis bucal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37846,
      "keyword": "frotis bucal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37847,
      "keyword": "frotis bucal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sucot": [
    {
      "id": 37848,
      "keyword": "Sucot",
      "keywords": 3,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fiesta de las cabañas": [
    {
      "id": 37848,
      "keyword": "Fiesta de las Cabañas",
      "keywords": 3,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fiesta de los tabernáculos": [
    {
      "id": 37848,
      "keyword": "Fiesta de los Tabernáculos",
      "keywords": 3,
      "type": 1,
      "tags": [
        "event",
        "religious event",
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortitas": [
    {
      "id": 37849,
      "keyword": "tortitas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pancakes": [
    {
      "id": 37849,
      "keyword": "pancakes",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hotcakes": [
    {
      "id": 37849,
      "keyword": "hotcakes",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rapidez": [
    {
      "id": 37850,
      "keyword": "rapidez",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "human body",
        "physiology",
        "human physiology",
        "leisure",
        "sport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "resistencia": [
    {
      "id": 37851,
      "keyword": "resistencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolso de mano": [
    {
      "id": 37852,
      "keyword": "bolso de mano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsos de mano": [
    {
      "id": 37852,
      "keyword": "bolso de mano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "portamóvil": [
    {
      "id": 37853,
      "keyword": "portamóvil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "portamóviles": [
    {
      "id": 37853,
      "keyword": "portamóvil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "etapas de la vida": [
    {
      "id": 38617,
      "keyword": "etapas de la vida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37854,
      "keyword": "etapas de la vida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugar con la comida": [
    {
      "id": 37855,
      "keyword": "jugar con la comida",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rascar la herida": [
    {
      "id": 37856,
      "keyword": "rascar la herida",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar la costra": [
    {
      "id": 37856,
      "keyword": "quitar la costra",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cascos de cancelación de ruido": [
    {
      "id": 37857,
      "keyword": "cascos de cancelación de ruido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "relajar": [
    {
      "id": 37858,
      "keyword": "relajar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bicicleta elíptica": [
    {
      "id": 37859,
      "keyword": "bicicleta elíptica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bicicletas elípticas": [
    {
      "id": 37859,
      "keyword": "bicicleta elíptica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "neutral": [
    {
      "id": 37862,
      "keyword": "neutral",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "neutrales": [
    {
      "id": 37862,
      "keyword": "neutral",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "imparcial": [
    {
      "id": 37862,
      "keyword": "imparcial",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "imparciales": [
    {
      "id": 37862,
      "keyword": "imparcial",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "equitativo": [
    {
      "id": 37862,
      "keyword": "equitativo",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equitativos": [
    {
      "id": 37862,
      "keyword": "equitativo",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "equitativa": [
    {
      "id": 37862,
      "keyword": "equitativa",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equitativas": [
    {
      "id": 37862,
      "keyword": "equitativa",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ecuánime": [
    {
      "id": 37862,
      "keyword": "ecuánime",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ecuánimes": [
    {
      "id": 37862,
      "keyword": "ecuánime",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "evacuar": [
    {
      "id": 37863,
      "keyword": "evacuar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "evacuación": [
    {
      "id": 37863,
      "keyword": "evacuación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "evacuaciones": [
    {
      "id": 37863,
      "keyword": "evacuación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "último piso": [
    {
      "id": 37865,
      "keyword": "último piso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "architecture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "últimos pisos": [
    {
      "id": 37865,
      "keyword": "último piso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "architecture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "última planta": [
    {
      "id": 37865,
      "keyword": "última planta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "architecture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "últimas plantas": [
    {
      "id": 37865,
      "keyword": "última planta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "architecture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "wasapear": [
    {
      "id": 37867,
      "keyword": "wasapear",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guasapear": [
    {
      "id": 37867,
      "keyword": "guasapear",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enviar un mensaje de whatapp": [
    {
      "id": 37867,
      "keyword": "enviar un mensaje de WhatApp",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escurrir las manos": [
    {
      "id": 37868,
      "keyword": "escurrir las manos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "granado": [
    {
      "id": 37869,
      "keyword": "granado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "granados": [
    {
      "id": 37869,
      "keyword": "granado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "registro de la propiedad": [
    {
      "id": 37870,
      "keyword": "registro de la propiedad",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "public administration",
        "work",
        "tertiary sector",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pizarra blanca": [
    {
      "id": 37872,
      "keyword": "pizarra blanca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pizarras blancas": [
    {
      "id": 37872,
      "keyword": "pizarra blanca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pizarrón blanco": [
    {
      "id": 37872,
      "keyword": "pizarrón blanco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pizarrones blancos": [
    {
      "id": 37872,
      "keyword": "pizarrón blanco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesa de restaurante": [
    {
      "id": 37873,
      "keyword": "mesa de restaurante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "place",
        "building",
        "catering establishment",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jefe de servicio de comunicacion y participacion": [
    {
      "id": 37874,
      "keyword": "jefe de servicio de comunicacion y participacion",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "mass media",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar puntos de sutura": [
    {
      "id": 37886,
      "keyword": "quitar puntos de sutura",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37875,
      "keyword": "quitar puntos de sutura",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37885,
      "keyword": "quitar puntos de sutura",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortar puntos de sutura": [
    {
      "id": 37875,
      "keyword": "cortar puntos de sutura",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37885,
      "keyword": "cortar puntos de sutura",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "realizador": [
    {
      "id": 37876,
      "keyword": "realizador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "realizadores": [
    {
      "id": 37876,
      "keyword": "realizador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "realizador de televisión": [
    {
      "id": 37876,
      "keyword": "realizador de televisión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37876,
      "keyword": "realizador de televisión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "communication",
        "mass media"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "emisora de televisión": [
    {
      "id": 37878,
      "keyword": "emisora de televisión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "communication",
        "mass media",
        "signaling system",
        "work",
        "tertiary sector",
        "telecommunication"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "emisoras de televisión": [
    {
      "id": 37878,
      "keyword": "emisora de televisión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "communication",
        "mass media",
        "signaling system",
        "work",
        "tertiary sector",
        "telecommunication"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "emisora de tv": [
    {
      "id": 37878,
      "keyword": "emisora de TV",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "communication",
        "mass media",
        "signaling system",
        "work",
        "tertiary sector",
        "telecommunication"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "emisoras de tv": [
    {
      "id": 37878,
      "keyword": "emisora de TV",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "communication",
        "mass media",
        "signaling system",
        "work",
        "tertiary sector",
        "telecommunication"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "insignia judía": [
    {
      "id": 37879,
      "keyword": "insignia judía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jefe de ujieres": [
    {
      "id": 37880,
      "keyword": "jefe de ujieres",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pan de pipas": [
    {
      "id": 37881,
      "keyword": "pan de pipas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panes de pipas": [
    {
      "id": 37881,
      "keyword": "pan de pipas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "galleta salada": [
    {
      "id": 37883,
      "keyword": "galleta salada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "galletas saladas": [
    {
      "id": 37883,
      "keyword": "galleta salada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quitar grapas": [
    {
      "id": 37884,
      "keyword": "quitar grapas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ukelele": [
    {
      "id": 37887,
      "keyword": "ukelele",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ukeleles": [
    {
      "id": 37887,
      "keyword": "ukelele",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "egg shaker": [
    {
      "id": 37888,
      "keyword": "egg shaker",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "egg shakers": [
    {
      "id": 37888,
      "keyword": "egg shaker",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ganzá": [
    {
      "id": 37888,
      "keyword": "ganzá",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ganzás": [
    {
      "id": 37888,
      "keyword": "ganzá",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pelota cacahuete": [
    {
      "id": 37890,
      "keyword": "pelota cacahuete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelotas cacahuete": [
    {
      "id": 37890,
      "keyword": "pelota cacahuete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pelota boti boti": [
    {
      "id": 37891,
      "keyword": "pelota boti boti",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelotas boti boti": [
    {
      "id": 37891,
      "keyword": "pelota boti boti",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pelota canguro": [
    {
      "id": 37891,
      "keyword": "pelota canguro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelotas canguro": [
    {
      "id": 37891,
      "keyword": "pelota canguro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chotis": [
    {
      "id": 37892,
      "keyword": "chotis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "regional dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chulapa": [
    {
      "id": 37893,
      "keyword": "chulapa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chulapas": [
    {
      "id": 37893,
      "keyword": "chulapa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chulapo": [
    {
      "id": 37894,
      "keyword": "chulapo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chulapos": [
    {
      "id": 37894,
      "keyword": "chulapo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37919,
      "keyword": "chulapos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colgar el abrigo": [
    {
      "id": 37895,
      "keyword": "colgar el abrigo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "education",
        "teaching activity",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colgar la mochila": [
    {
      "id": 37896,
      "keyword": "colgar la mochila",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mandala": [
    {
      "id": 37897,
      "keyword": "mandala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "pattern",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mandalas": [
    {
      "id": 37897,
      "keyword": "mandala",
      "keywords": 1,
      "type": 2,
      "tags": [
        "pattern",
        "visual art"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zombi": [
    {
      "id": 37898,
      "keyword": "zombi",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "comic character",
        "comic",
        "book character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zombis": [
    {
      "id": 37898,
      "keyword": "zombi",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "comic character",
        "comic",
        "book character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "muerto viviente": [
    {
      "id": 37898,
      "keyword": "muerto viviente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "comic character",
        "comic",
        "book character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muertos vivientes": [
    {
      "id": 37898,
      "keyword": "muerto viviente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "comic character",
        "comic",
        "book character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pintar un mandala": [
    {
      "id": 37899,
      "keyword": "pintar un mandala",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task",
        "pattern",
        "visual art",
        "work",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "resbalar la arena": [
    {
      "id": 37900,
      "keyword": "resbalar la arena",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "material",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escurrir la arena": [
    {
      "id": 37900,
      "keyword": "escurrir la arena",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "material",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espuma": [
    {
      "id": 37901,
      "keyword": "espuma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espuma de mar": [
    {
      "id": 37901,
      "keyword": "espuma de mar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chapotear": [
    {
      "id": 37902,
      "keyword": "chapotear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "swimming pool",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aseos adaptados": [
    {
      "id": 37904,
      "keyword": "aseo adaptado",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "health",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "despacho de paquetería": [
    {
      "id": 37905,
      "keyword": "despacho de paquetería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "work",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "despachos de paquetería": [
    {
      "id": 37905,
      "keyword": "despacho de paquetería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "work",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "director de prisión": [
    {
      "id": 37908,
      "keyword": "director de prisión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "director de la cárcel": [
    {
      "id": 37908,
      "keyword": "director de la cárcel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "control": [
    {
      "id": 37909,
      "keyword": "control",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "controles": [
    {
      "id": 37909,
      "keyword": "control",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "control de seguridad": [
    {
      "id": 37909,
      "keyword": "control de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "controles de seguridad": [
    {
      "id": 37909,
      "keyword": "control de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acrosport": [
    {
      "id": 37910,
      "keyword": "acrosport",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37913,
      "keyword": "acrosport",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37916,
      "keyword": "acrosport",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37917,
      "keyword": "acrosport",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38989,
      "keyword": "acrosport",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37912,
      "keyword": "acrosport",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37915,
      "keyword": "acrosport",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37914,
      "keyword": "acrosport",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gimnasia acrobática": [
    {
      "id": 37910,
      "keyword": "gimnasia acrobática",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37913,
      "keyword": "gimnasia acrobática",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37916,
      "keyword": "gimnasia acrobática",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37917,
      "keyword": "gimnasia acrobática",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38989,
      "keyword": "gimnasia acrobática",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37912,
      "keyword": "gimnasia acrobática",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37915,
      "keyword": "gimnasia acrobática",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37914,
      "keyword": "gimnasia acrobática",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cucurucho de papel": [
    {
      "id": 37911,
      "keyword": "cucurucho de papel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "shape",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cucuruchos de papel": [
    {
      "id": 37911,
      "keyword": "cucurucho de papel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "shape",
        "object",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acrosport ayudante": [
    {
      "id": 37912,
      "keyword": "acrosport ayudante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acrosport base": [
    {
      "id": 37914,
      "keyword": "acrosport base",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acrosport portor": [
    {
      "id": 37914,
      "keyword": "acrosport portor",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acrosport ágil": [
    {
      "id": 37915,
      "keyword": "acrosport ágil",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "gymnastics",
        "acrobatic gymnastics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bebida vegetal": [
    {
      "id": 37918,
      "keyword": "bebida vegetal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bebidas vegetales": [
    {
      "id": 37918,
      "keyword": "bebida vegetal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frenar la silla": [
    {
      "id": 37920,
      "keyword": "frenar la silla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bandeja sensorial": [
    {
      "id": 37921,
      "keyword": "bandeja sensorial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bandejas sensoriales": [
    {
      "id": 37921,
      "keyword": "bandeja sensorial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mirar en el espejo": [
    {
      "id": 37922,
      "keyword": "mirar en el espejo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "babear": [
    {
      "id": 37923,
      "keyword": "babear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "physiology",
        "human physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grito": [
    {
      "id": 37924,
      "keyword": "grito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gritos": [
    {
      "id": 37924,
      "keyword": "grito",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rodar una pelota": [
    {
      "id": 37925,
      "keyword": "rodar una pelota",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "revolución francesa": [
    {
      "id": 37926,
      "keyword": "Revolución Francesa",
      "keywords": 1,
      "type": 1,
      "tags": [
        "history",
        "late modern period"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "la bastilla": [
    {
      "id": 37929,
      "keyword": "La Bastilla",
      "keywords": 1,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cristobal colón": [
    {
      "id": 37932,
      "keyword": "Cristobal Colón",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner velcro": [
    {
      "id": 37934,
      "keyword": "poner velcro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner zapatilla con velcro": [
    {
      "id": 37934,
      "keyword": "poner zapatilla con velcro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner zapato con velcro": [
    {
      "id": 37934,
      "keyword": "poner zapato con velcro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar velcro": [
    {
      "id": 37935,
      "keyword": "quitar velcro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar las zapatillas con velcro": [
    {
      "id": 37935,
      "keyword": "quitar las zapatillas con velcro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar los zapatos con velcro": [
    {
      "id": 37935,
      "keyword": "quitar los zapatos con velcro",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "footwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estante para libros": [
    {
      "id": 37937,
      "keyword": "estante para libros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estantes para libros": [
    {
      "id": 37937,
      "keyword": "estante para libros",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guardar ropa": [
    {
      "id": 37938,
      "keyword": "guardar ropa",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colgar ropa": [
    {
      "id": 37938,
      "keyword": "colgar ropa",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacar ropa": [
    {
      "id": 37938,
      "keyword": "sacar ropa",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dreidel": [
    {
      "id": 37939,
      "keyword": "dreidel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dreidels": [
    {
      "id": 37939,
      "keyword": "dreidel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cubitera": [
    {
      "id": 37942,
      "keyword": "cubitera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubiteras": [
    {
      "id": 37942,
      "keyword": "cubitera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caja de pañuelos": [
    {
      "id": 37943,
      "keyword": "caja de pañuelos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajas de pañuelos": [
    {
      "id": 37943,
      "keyword": "caja de pañuelos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ropa blanca": [
    {
      "id": 37944,
      "keyword": "ropa blanca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ropa de color": [
    {
      "id": 37945,
      "keyword": "ropa de color",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "portacepillo de dientes": [
    {
      "id": 37946,
      "keyword": "portacepillo de dientes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "portacepillos de dientes": [
    {
      "id": 37946,
      "keyword": "portacepillo de dientes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caja cerrada": [
    {
      "id": 37948,
      "keyword": "caja cerrada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajas cerradas": [
    {
      "id": 37948,
      "keyword": "caja cerrada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugar a la rayuela": [
    {
      "id": 37950,
      "keyword": "jugar a la rayuela",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37982,
      "keyword": "jugar a la rayuela",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37983,
      "keyword": "jugar a la rayuela",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "complejo deportivo": [
    {
      "id": 37951,
      "keyword": "complejo deportivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "complejos deportivos": [
    {
      "id": 37951,
      "keyword": "complejo deportivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "instalaciones deportivas": [
    {
      "id": 37951,
      "keyword": "instalaciones deportivas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "infiltrado": [
    {
      "id": 37953,
      "keyword": "infiltrado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "infiltrados": [
    {
      "id": 37953,
      "keyword": "infiltrado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "book character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saltar a pies juntos sobre cuerda": [
    {
      "id": 37954,
      "keyword": "saltar a pies juntos sobre cuerda",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tapón nasal": [
    {
      "id": 37955,
      "keyword": "tapón nasal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tapones nasales": [
    {
      "id": 37955,
      "keyword": "tapón nasal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tampón nasal": [
    {
      "id": 37955,
      "keyword": "tampón nasal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tampones nasales": [
    {
      "id": 37955,
      "keyword": "tampón nasal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hacer flexiones": [
    {
      "id": 37956,
      "keyword": "hacer flexiones",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gel frío": [
    {
      "id": 37957,
      "keyword": "gel frío",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsa de gel frío": [
    {
      "id": 37957,
      "keyword": "bolsa de gel frío",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas de gel frío": [
    {
      "id": 37957,
      "keyword": "bolsa de gel frío",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saltar valla": [
    {
      "id": 37959,
      "keyword": "saltar valla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pop it": [
    {
      "id": 37960,
      "keyword": "pop it",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pop its": [
    {
      "id": 37960,
      "keyword": "pop it",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rodar por el cilindro": [
    {
      "id": 37962,
      "keyword": "rodar por el cilindro",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caminar sobre barra de equilibrio": [
    {
      "id": 37963,
      "keyword": "caminar sobre barra de equilibrio",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37972,
      "keyword": "caminar sobre barra de equilibrio",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37973,
      "keyword": "caminar sobre barra de equilibrio",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reptar debajo de una valla": [
    {
      "id": 37965,
      "keyword": "reptar debajo de una valla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saltar neumáticos a pies juntos": [
    {
      "id": 37968,
      "keyword": "saltar neumáticos a pies juntos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caminar a cuatro patas": [
    {
      "id": 37969,
      "keyword": "caminar a cuatro patas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reptar boca arriba": [
    {
      "id": 37970,
      "keyword": "reptar boca arriba",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer voltereta sobre plano inclinado": [
    {
      "id": 37971,
      "keyword": "hacer voltereta sobre plano inclinado",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dar una voltereta sobre plano inclinado": [
    {
      "id": 37971,
      "keyword": "dar una voltereta sobre plano inclinado",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caminar sobre puntón": [
    {
      "id": 37973,
      "keyword": "caminar sobre puntón",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saltar aros a pata coja": [
    {
      "id": 37974,
      "keyword": "saltar aros a pata coja",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer la voltereta": [
    {
      "id": 37975,
      "keyword": "hacer la voltereta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dar una voltereta": [
    {
      "id": 37975,
      "keyword": "dar una voltereta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer equilibrio": [
    {
      "id": 37976,
      "keyword": "hacer equilibrio",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39153,
      "keyword": "hacer equilibrio",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39154,
      "keyword": "hacer equilibrio",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "braquiar": [
    {
      "id": 37977,
      "keyword": "braquiar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escalera de braquiación": [
    {
      "id": 37977,
      "keyword": "escalera de braquiación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escaleras de braquiación": [
    {
      "id": 37977,
      "keyword": "escalera de braquiación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "echar encima ": [
    {
      "id": 37978,
      "keyword": "echar encima ",
      "keywords": 2,
      "type": 3,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tirar encima": [
    {
      "id": 37978,
      "keyword": "tirar encima",
      "keywords": 2,
      "type": 3,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sistema solar": [
    {
      "id": 37979,
      "keyword": "sistema solar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sistemas solares": [
    {
      "id": 37979,
      "keyword": "sistema solar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ecolalia": [
    {
      "id": 37984,
      "keyword": "ecolalia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ecolalias": [
    {
      "id": 37984,
      "keyword": "ecolalia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calendario de adviento": [
    {
      "id": 37985,
      "keyword": "calendario de Adviento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "religious event",
        "religion",
        "christianity",
        "popular event",
        "christmas",
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calendarios de adviento": [
    {
      "id": 37985,
      "keyword": "calendario de Adviento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "religious event",
        "religion",
        "christianity",
        "popular event",
        "christmas",
        "time",
        "calendar"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pista ecuestre": [
    {
      "id": 37987,
      "keyword": "pista ecuestre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37988,
      "keyword": "pista ecuestre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pistas ecuestres": [
    {
      "id": 37987,
      "keyword": "pista ecuestre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 37988,
      "keyword": "pista ecuestre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "habilitación saac": [
    {
      "id": 37989,
      "keyword": "habilitación saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37990,
      "keyword": "habilitación saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37991,
      "keyword": "habilitación saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37992,
      "keyword": "habilitación saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37993,
      "keyword": "habilitación saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37994,
      "keyword": "habilitación saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37995,
      "keyword": "habilitación saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "implementación saac": [
    {
      "id": 37989,
      "keyword": "implementación saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37990,
      "keyword": "implementación saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37991,
      "keyword": "implementación saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37992,
      "keyword": "implementación saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37993,
      "keyword": "implementación saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37994,
      "keyword": "implementación saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37995,
      "keyword": "implementación saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enseñanza saac": [
    {
      "id": 37989,
      "keyword": "enseñanza saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37990,
      "keyword": "enseñanza saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37991,
      "keyword": "enseñanza saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37992,
      "keyword": "enseñanza saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37993,
      "keyword": "enseñanza saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37994,
      "keyword": "enseñanza saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 37995,
      "keyword": "enseñanza saac",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pastel de verduras": [
    {
      "id": 37996,
      "keyword": "pastel de verduras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasteles de verduras": [
    {
      "id": 37996,
      "keyword": "pastel de verduras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "moda": [
    {
      "id": 37997,
      "keyword": "moda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "condición": [
    {
      "id": 37998,
      "keyword": "condición",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "condiciones": [
    {
      "id": 37998,
      "keyword": "condición",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inspiración": [
    {
      "id": 37999,
      "keyword": "inspiración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inspiraciones": [
    {
      "id": 37999,
      "keyword": "inspiración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estímulo": [
    {
      "id": 37999,
      "keyword": "estímulo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estímulos": [
    {
      "id": 37999,
      "keyword": "estímulo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "himno": [
    {
      "id": 38000,
      "keyword": "himno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "himnos": [
    {
      "id": 38000,
      "keyword": "himno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical notation",
        "musical composition"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ilusión": [
    {
      "id": 38001,
      "keyword": "ilusión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ilusiones": [
    {
      "id": 38001,
      "keyword": "ilusión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "deseo": [
    {
      "id": 38001,
      "keyword": "deseo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "deseos": [
    {
      "id": 38001,
      "keyword": "deseo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anhelo": [
    {
      "id": 38001,
      "keyword": "anhelo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anhelos": [
    {
      "id": 38001,
      "keyword": "anhelo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "copa del árbol": [
    {
      "id": 38002,
      "keyword": "copa del árbol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "tree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "copas del árbol": [
    {
      "id": 38002,
      "keyword": "copa del árbol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant anatomy",
        "anatomy",
        "tree"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "imaginación": [
    {
      "id": 38003,
      "keyword": "imaginación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "imaginaciones": [
    {
      "id": 38003,
      "keyword": "imaginación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esencia": [
    {
      "id": 38004,
      "keyword": "esencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esencias": [
    {
      "id": 38004,
      "keyword": "esencia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abismo": [
    {
      "id": 38005,
      "keyword": "abismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abismos": [
    {
      "id": 38005,
      "keyword": "abismo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perfecto": [
    {
      "id": 38006,
      "keyword": "perfecto",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perfectos": [
    {
      "id": 38006,
      "keyword": "perfecto",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "perfecta": [
    {
      "id": 38006,
      "keyword": "perfecta",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perfectas": [
    {
      "id": 38006,
      "keyword": "perfecta",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¡perfecto!": [
    {
      "id": 38006,
      "keyword": "¡perfecto!",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crema de verdura": [
    {
      "id": 38007,
      "keyword": "crema de verdura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cremas de verduras": [
    {
      "id": 38007,
      "keyword": "crema de verdura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "puré de verdura": [
    {
      "id": 38007,
      "keyword": "puré de verdura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "purés de verduras": [
    {
      "id": 38007,
      "keyword": "puré de verdura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "buñuelos de bacalao": [
    {
      "id": 38008,
      "keyword": "buñuelos de bacalao",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centro de control aéreo": [
    {
      "id": 38009,
      "keyword": "centro de control aéreo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros de control aéreo": [
    {
      "id": 38009,
      "keyword": "centro de control aéreo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "control de tráfico aéreo": [
    {
      "id": 38009,
      "keyword": "control de tráfico aéreo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "controlador aéreo": [
    {
      "id": 38009,
      "keyword": "controlador aéreo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "controladores aéreo": [
    {
      "id": 38009,
      "keyword": "controlador aéreo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "controladora aérea": [
    {
      "id": 38009,
      "keyword": "controladora aérea",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "controladoras aéreas ": [
    {
      "id": 38009,
      "keyword": "controladora aérea",
      "keywords": 4,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "work",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lanzar la jabalina": [
    {
      "id": 38010,
      "keyword": "lanzar la jabalina",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event",
        "olympic games",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sujetar el vaso": [
    {
      "id": 38011,
      "keyword": "sujetar el vaso",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plato vestibular": [
    {
      "id": 38012,
      "keyword": "plato vestibular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation",
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "platos vestibulares": [
    {
      "id": 38012,
      "keyword": "plato vestibular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation",
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "puzzle para atar zapatos": [
    {
      "id": 38013,
      "keyword": "puzzle para atar zapatos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puzzles para atar zapatos": [
    {
      "id": 38013,
      "keyword": "puzzle para atar zapatos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sedentarios": [
    {
      "id": 38015,
      "keyword": "sedentarios",
      "keywords": 1,
      "type": 4,
      "tags": [
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "podoscopio": [
    {
      "id": 38016,
      "keyword": "podoscopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "podoscopios": [
    {
      "id": 38016,
      "keyword": "podoscopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rádar": [
    {
      "id": 38018,
      "keyword": "rádar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "water transport",
        "vehicle component",
        "route"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rádares": [
    {
      "id": 38018,
      "keyword": "rádar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "water transport",
        "vehicle component",
        "route"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "derechos humanos": [
    {
      "id": 38019,
      "keyword": "derechos humanos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "work",
        "tertiary sector",
        "justice"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "restricción": [
    {
      "id": 38020,
      "keyword": "restricción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "restricciones": [
    {
      "id": 38020,
      "keyword": "restricción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "educar": [
    {
      "id": 38021,
      "keyword": "educar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "education",
        "communication",
        "language",
        "verb",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "columpio oscilante": [
    {
      "id": 38023,
      "keyword": "columpio oscilante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "columpios oscilantes": [
    {
      "id": 38023,
      "keyword": "columpio oscilante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "columpio inclusivo": [
    {
      "id": 38025,
      "keyword": "columpio inclusivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "columpios inclusivos": [
    {
      "id": 38025,
      "keyword": "columpio inclusivo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pellizcar la mejilla": [
    {
      "id": 38026,
      "keyword": "pellizcar la mejilla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "copo de nieve": [
    {
      "id": 38027,
      "keyword": "copo de nieve",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "copos de nieve": [
    {
      "id": 38027,
      "keyword": "copo de nieve",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almacén de educación física ": [
    {
      "id": 38029,
      "keyword": "almacén de educación física ",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "leisure",
        "sport",
        "sport material",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almacenes de educación física": [
    {
      "id": 38029,
      "keyword": "almacén de educación física ",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "leisure",
        "sport",
        "sport material",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almacén de material deportivo": [
    {
      "id": 38029,
      "keyword": "almacén de material deportivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "leisure",
        "sport",
        "sport material",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almacenes de material deportivo": [
    {
      "id": 38029,
      "keyword": "almacén de material deportivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "leisure",
        "sport",
        "sport material",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesa plegable": [
    {
      "id": 38030,
      "keyword": "mesa plegable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas plegables": [
    {
      "id": 38030,
      "keyword": "mesa plegable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silla balancín ": [
    {
      "id": 38031,
      "keyword": "silla balancín ",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational equipment",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas balancín": [
    {
      "id": 38031,
      "keyword": "silla balancín ",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational equipment",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cafetera de cápsulas": [
    {
      "id": 38032,
      "keyword": "cafetera de cápsulas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cafeteras de cápsulas": [
    {
      "id": 38032,
      "keyword": "cafetera de cápsulas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estirar de la camiseta": [
    {
      "id": 38033,
      "keyword": "estirar de la camiseta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "psychology",
        "disruptive behavior",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38033,
      "keyword": "estirar de la camiseta",
      "keywords": 2,
      "type": 3,
      "tags": [
        "psychology",
        "disruptive behavior",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "árbol musical": [
    {
      "id": 38034,
      "keyword": "árbol musical",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "árboles musicales": [
    {
      "id": 38034,
      "keyword": "árbol musical",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pasar al inodoro": [
    {
      "id": 38035,
      "keyword": "pasar al inodoro",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sentar en el inodoro": [
    {
      "id": 38035,
      "keyword": "sentar en el inodoro",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasar a la silla": [
    {
      "id": 38036,
      "keyword": "pasar a la silla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "silla plegable": [
    {
      "id": 38037,
      "keyword": "silla plegable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillas plegables": [
    {
      "id": 38037,
      "keyword": "silla plegable",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "batidora de varillas": [
    {
      "id": 38038,
      "keyword": "batidora de varillas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "batidoras de varillas": [
    {
      "id": 38038,
      "keyword": "batidora de varillas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "impresora 3d": [
    {
      "id": 38039,
      "keyword": "impresora 3D",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "impresoras 3d": [
    {
      "id": 38039,
      "keyword": "impresora 3D",
      "keywords": 1,
      "type": 2,
      "tags": [
        "computing",
        "hardware"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "placa solar": [
    {
      "id": 38040,
      "keyword": "placa solar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "placas solares": [
    {
      "id": 38040,
      "keyword": "placa solar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "work",
        "secondary sector",
        "energy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "graduación": [
    {
      "id": 38043,
      "keyword": "graduación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "event",
        "social event"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "graduaciones": [
    {
      "id": 38043,
      "keyword": "graduación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "event",
        "social event"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "monumento andres guazurari": [
    {
      "id": 38044,
      "keyword": "Monumento Andres Guazurari",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barretina": [
    {
      "id": 38045,
      "keyword": "barretina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barretinas": [
    {
      "id": 38045,
      "keyword": "barretina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories",
        "clothes",
        "regional costume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "queso fresco": [
    {
      "id": 38046,
      "keyword": "queso fresco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quesos frescos": [
    {
      "id": 38046,
      "keyword": "queso fresco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carrera popular": [
    {
      "id": 38047,
      "keyword": "carrera popular",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carreras populares": [
    {
      "id": 38047,
      "keyword": "carrera popular",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carrera adaptada": [
    {
      "id": 38047,
      "keyword": "carrera adaptada",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carreras adaptadas": [
    {
      "id": 38047,
      "keyword": "carrera adaptada",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carrera inclusiva": [
    {
      "id": 38047,
      "keyword": "carrera inclusiva",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event",
        "athletics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carreras inclusivas": [
    {
      "id": 38047,
      "keyword": "carrera inclusiva",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "event",
        "sport event",
        "athletics"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dar la pata ": [
    {
      "id": 38048,
      "keyword": "dar la pata ",
      "keywords": 1,
      "type": 3,
      "tags": [
        "animal",
        "animal-assisted therapy",
        "dog-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palma de semana santa": [
    {
      "id": 38049,
      "keyword": "palma de Semana Santa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "event",
        "popular event",
        "easter week"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palmas de semana santa": [
    {
      "id": 38049,
      "keyword": "palma de Semana Santa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "event",
        "popular event",
        "easter week"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palma de domingo de ramos": [
    {
      "id": 38049,
      "keyword": "palma de domingo de ramos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "event",
        "popular event",
        "easter week"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palmas de domingo de ramos": [
    {
      "id": 38049,
      "keyword": "palma de domingo de ramos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "object",
        "event",
        "popular event",
        "easter week"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sereno": [
    {
      "id": 38050,
      "keyword": "sereno",
      "keywords": 4,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "serena": [
    {
      "id": 38050,
      "keyword": "serena",
      "keywords": 4,
      "type": null,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "serenas": [
    {
      "id": 38050,
      "keyword": "serena",
      "keywords": 4,
      "type": null,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pera de irrigación": [
    {
      "id": 38052,
      "keyword": "pera de irrigación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peras de irrigación": [
    {
      "id": 38052,
      "keyword": "pera de irrigación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pera para enema": [
    {
      "id": 38052,
      "keyword": "pera para enema",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peras para enema": [
    {
      "id": 38052,
      "keyword": "pera para enema",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "levantar los brazos": [
    {
      "id": 38053,
      "keyword": "levantar los brazos",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brazos arriba": [
    {
      "id": 38053,
      "keyword": "brazos arriba",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38629,
      "keyword": "brazos arriba",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¡manos arriba!": [
    {
      "id": 38053,
      "keyword": "¡manos arriba!",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "verb",
        "expression",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "domesticar": [
    {
      "id": 38055,
      "keyword": "domesticar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "cattle farming",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ganadería": [
    {
      "id": 38056,
      "keyword": "ganadería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "cattle farming",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer un escáner": [
    {
      "id": 38058,
      "keyword": "hacer un escáner",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer una tomografía": [
    {
      "id": 38058,
      "keyword": "hacer una tomografía",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "andar con muletas": [
    {
      "id": 38059,
      "keyword": "andar con muletas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "treatment",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38060,
      "keyword": "andar con muletas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "treatment",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38062,
      "keyword": "andar con muletas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "treatment",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vendar en sindactilia": [
    {
      "id": 38064,
      "keyword": "vendar en sindactilia",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortador de yeso": [
    {
      "id": 38065,
      "keyword": "cortador de yeso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cortadores de yeso": [
    {
      "id": 38065,
      "keyword": "cortador de yeso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "separador de yeso ": [
    {
      "id": 38066,
      "keyword": "separador de yeso ",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "separadores de yeso": [
    {
      "id": 38066,
      "keyword": "separador de yeso ",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "férula de dedo": [
    {
      "id": 38067,
      "keyword": "férula de dedo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "férulas de dedo": [
    {
      "id": 38067,
      "keyword": "férula de dedo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "férula de slim": [
    {
      "id": 38067,
      "keyword": "férula de slim",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "férulas de slim": [
    {
      "id": 38067,
      "keyword": "férula de slim",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fibroscopio": [
    {
      "id": 38068,
      "keyword": "fibroscopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fibroscopios": [
    {
      "id": 38068,
      "keyword": "fibroscopio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manguito": [
    {
      "id": 38069,
      "keyword": "manguito",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manguito de tensiómetro": [
    {
      "id": 38069,
      "keyword": "manguito de tensiómetro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manguitos de tensiómetro": [
    {
      "id": 38069,
      "keyword": "manguito de tensiómetro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lino": [
    {
      "id": 38070,
      "keyword": "lino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lenteja": [
    {
      "id": 38071,
      "keyword": "lenteja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant",
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "planta de lenteja": [
    {
      "id": 38071,
      "keyword": "planta de lenteja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant",
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plantas de lenteja": [
    {
      "id": 38071,
      "keyword": "planta de lenteja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant",
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cavar una fosa": [
    {
      "id": 38072,
      "keyword": "cavar una fosa",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enterrar": [
    {
      "id": 38072,
      "keyword": "enterrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "event",
        "social event",
        "death",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "concha cardial": [
    {
      "id": 38075,
      "keyword": "concha cardial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conchas cardiales": [
    {
      "id": 38075,
      "keyword": "concha cardial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "moler": [
    {
      "id": 38077,
      "keyword": "moler",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poblado": [
    {
      "id": 38078,
      "keyword": "poblado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poblados": [
    {
      "id": 38078,
      "keyword": "poblado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "history",
        "prehistory"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agricultura": [
    {
      "id": 38079,
      "keyword": "agricultura",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cultivo": [
    {
      "id": 38079,
      "keyword": "cultivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cultivos": [
    {
      "id": 38079,
      "keyword": "cultivo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cultivar": [
    {
      "id": 38080,
      "keyword": "cultivar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacar del agua": [
    {
      "id": 38081,
      "keyword": "sacar del agua",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sacar del mar": [
    {
      "id": 38081,
      "keyword": "sacar del mar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "beach"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "urgencias": [
    {
      "id": 38082,
      "keyword": "urgencias",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "medicine",
        "medical center",
        "health",
        "covid-19",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38082,
      "keyword": "urgencias",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "medicine",
        "medical center",
        "health",
        "covid-19",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "servicio de urgencias": [
    {
      "id": 38082,
      "keyword": "servicio de urgencias",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "medicine",
        "medical center",
        "health",
        "covid-19",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "servicios de urgencias": [
    {
      "id": 38082,
      "keyword": "servicio de urgencias",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "medicine",
        "medical center",
        "health",
        "covid-19",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "media cucharada": [
    {
      "id": 38084,
      "keyword": "media cucharada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conductor de autobús": [
    {
      "id": 38545,
      "keyword": "conductor de autobús",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38545,
      "keyword": "conductor de autobús",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38086,
      "keyword": "conductor de autobús",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38087,
      "keyword": "conductor de autobús",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conductores de autobús": [
    {
      "id": 38086,
      "keyword": "conductor de autobús",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38087,
      "keyword": "conductor de autobús",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conductora de autobús": [
    {
      "id": 38545,
      "keyword": "conductora de autobús",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38088,
      "keyword": "conductora de autobús",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38089,
      "keyword": "conductora de autobús",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conductoras de autobús": [
    {
      "id": 38545,
      "keyword": "conductora de autobús",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38088,
      "keyword": "conductora de autobús",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38089,
      "keyword": "conductora de autobús",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "silvicultura": [
    {
      "id": 38093,
      "keyword": "silvicultura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "forestry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "restaurante italiano": [
    {
      "id": 38094,
      "keyword": "restaurante italiano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "restaurantes italianos": [
    {
      "id": 38094,
      "keyword": "restaurante italiano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "banco de alimentos": [
    {
      "id": 38095,
      "keyword": "banco de alimentos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "feeding",
        "food",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bancos de alimentos": [
    {
      "id": 38095,
      "keyword": "banco de alimentos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "service building",
        "feeding",
        "food",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carillón": [
    {
      "id": 38096,
      "keyword": "carillón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carillones": [
    {
      "id": 38096,
      "keyword": "carillón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trinxat": [
    {
      "id": 38097,
      "keyword": "trinxat",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trinxats": [
    {
      "id": 38097,
      "keyword": "trinxat",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rampa mecánica": [
    {
      "id": 38098,
      "keyword": "rampa mecánica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rampas mecánicas": [
    {
      "id": 38098,
      "keyword": "rampa mecánica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "trade"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "crampones": [
    {
      "id": 38099,
      "keyword": "crampones",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cambiar de mano": [
    {
      "id": 38100,
      "keyword": "cambiar de mano",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lanzarse contra la pared": [
    {
      "id": 38101,
      "keyword": "lanzarse contra la pared",
      "keywords": 2,
      "type": 3,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lanzar contra la pared": [
    {
      "id": 38101,
      "keyword": "lanzar contra la pared",
      "keywords": 2,
      "type": 3,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palangana": [
    {
      "id": 38102,
      "keyword": "palangana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "container"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palanganas": [
    {
      "id": 38102,
      "keyword": "palangana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product",
        "container"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "derbake": [
    {
      "id": 38103,
      "keyword": "derbake",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "derbakes": [
    {
      "id": 38103,
      "keyword": "derbake",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "darbuka": [
    {
      "id": 38103,
      "keyword": "darbuka",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "darbukas": [
    {
      "id": 38103,
      "keyword": "darbuka",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conga": [
    {
      "id": 38104,
      "keyword": "conga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "congas": [
    {
      "id": 38104,
      "keyword": "conga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tumbadora": [
    {
      "id": 38104,
      "keyword": "tumbadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tumbadoras": [
    {
      "id": 38104,
      "keyword": "tumbadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "yembé": [
    {
      "id": 38105,
      "keyword": "yembé",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yembés": [
    {
      "id": 38105,
      "keyword": "yembé",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "djembé": [
    {
      "id": 38105,
      "keyword": "djembé",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "djembés": [
    {
      "id": 38105,
      "keyword": "djembé",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trompetilla": [
    {
      "id": 38106,
      "keyword": "trompetilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trompetillas": [
    {
      "id": 38106,
      "keyword": "trompetilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "planeamiento territorial": [
    {
      "id": 38107,
      "keyword": "planeamiento territorial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "public administration",
        "place",
        "urban area",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "silla todoterreno": [
    {
      "id": 38108,
      "keyword": "silla todoterreno",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "silla de ruedas hippocampe": [
    {
      "id": 38108,
      "keyword": "silla de ruedas hippocampe",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bloques lógicos": [
    {
      "id": 38110,
      "keyword": "bloques lógicos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "mathematics",
        "geometry",
        "basic concepts"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "martillo rompecristales": [
    {
      "id": 38111,
      "keyword": "martillo rompecristales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38244,
      "keyword": "martillo rompecristales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "martillos rompecristales": [
    {
      "id": 38111,
      "keyword": "martillo rompecristales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38244,
      "keyword": "martillo rompecristales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "martillo de seguridad": [
    {
      "id": 38111,
      "keyword": "martillo de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38244,
      "keyword": "martillo de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "martillos de seguridad": [
    {
      "id": 38111,
      "keyword": "martillo de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38244,
      "keyword": "martillo de seguridad",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "regletas cuisenaire": [
    {
      "id": 38112,
      "keyword": "regletas cuisenaire",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de muebles de baño": [
    {
      "id": 38113,
      "keyword": "tienda de muebles de baño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de muebles de baño": [
    {
      "id": 38113,
      "keyword": "tienda de muebles de baño",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "torta de azúcar": [
    {
      "id": 38114,
      "keyword": "torta de azúcar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tortas de azúcar": [
    {
      "id": 38114,
      "keyword": "torta de azúcar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "montar en el tiovivo": [
    {
      "id": 38116,
      "keyword": "montar en el tiovivo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "montar en moto": [
    {
      "id": 38117,
      "keyword": "montar en moto",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ir en moto": [
    {
      "id": 38117,
      "keyword": "ir en moto",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de telas": [
    {
      "id": 38118,
      "keyword": "tienda de telas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de telas": [
    {
      "id": 38118,
      "keyword": "tienda de telas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "secondary sector",
        "clothing industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acupuntura": [
    {
      "id": 38119,
      "keyword": "acupuntura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de productos de estética y peluquería": [
    {
      "id": 38120,
      "keyword": "tienda de productos de estética y peluquería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38120,
      "keyword": "tienda de productos de estética y peluquería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de fundas para el móvil": [
    {
      "id": 38121,
      "keyword": "tienda de fundas para el móvil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "computing",
        "hardware",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de recambios": [
    {
      "id": 38122,
      "keyword": "tienda de recambios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de recambios": [
    {
      "id": 38122,
      "keyword": "tienda de recambios",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "me importa": [
    {
      "id": 38123,
      "keyword": "me importa",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tubos sensoriales": [
    {
      "id": 38124,
      "keyword": "tubos sensoriales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "raquetas de nieve": [
    {
      "id": 38125,
      "keyword": "raquetas de nieve",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tirar basura al suelo": [
    {
      "id": 38126,
      "keyword": "tirar basura al suelo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dar patadas a la basura": [
    {
      "id": 38126,
      "keyword": "dar patadas a la basura",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pintar un grafiti": [
    {
      "id": 38127,
      "keyword": "pintar un grafiti",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "visual art",
        "painting",
        "place",
        "urban area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "romper el mobiliario": [
    {
      "id": 38128,
      "keyword": "romper el mobiliario",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "romper el mobiliario urbano": [
    {
      "id": 38128,
      "keyword": "romper el mobiliario urbano",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tirar a la basura": [
    {
      "id": 38129,
      "keyword": "tirar a la basura",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "person",
        "routine",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38226,
      "keyword": "tirar a la basura",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "person",
        "routine",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38227,
      "keyword": "tirar a la basura",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "urban area",
        "street furniture",
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "person",
        "routine",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de artículos de fiesta": [
    {
      "id": 38130,
      "keyword": "tienda de artículos de fiesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de maquinaria": [
    {
      "id": 38131,
      "keyword": "tienda de maquinaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "work machine",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de maquinaria": [
    {
      "id": 38131,
      "keyword": "tienda de maquinaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "work",
        "work machine",
        "primary sector",
        "agriculture",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de sofás": [
    {
      "id": 38132,
      "keyword": "tienda de sofás",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peletería": [
    {
      "id": 38134,
      "keyword": "peletería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peleterías": [
    {
      "id": 38134,
      "keyword": "peletería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ropa plegada": [
    {
      "id": 38135,
      "keyword": "ropa plegada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taller de arquitectura": [
    {
      "id": 38137,
      "keyword": "taller de arquitectura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "architecture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talleres de arquitectura": [
    {
      "id": 38137,
      "keyword": "taller de arquitectura",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "architecture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "relojería": [
    {
      "id": 38138,
      "keyword": "relojería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "chronological device",
        "time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "relojerías": [
    {
      "id": 38138,
      "keyword": "relojería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "chronological device",
        "time"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de relojes": [
    {
      "id": 38138,
      "keyword": "tienda de relojes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "chronological device",
        "time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de relojes": [
    {
      "id": 38138,
      "keyword": "tienda de relojes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "chronological device",
        "time"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fisioterapia animal": [
    {
      "id": 38141,
      "keyword": "fisioterapia animal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palmas": [
    {
      "id": 38142,
      "keyword": "palmas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "senses"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marco teórico": [
    {
      "id": 38144,
      "keyword": "marco teórico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marcos teóricos": [
    {
      "id": 38144,
      "keyword": "marco teórico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "introducción": [
    {
      "id": 38145,
      "keyword": "introducción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "introducciones": [
    {
      "id": 38145,
      "keyword": "introducción",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "preceptos": [
    {
      "id": 38146,
      "keyword": "preceptos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "morsa": [
    {
      "id": 38147,
      "keyword": "morsa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "morsas": [
    {
      "id": 38147,
      "keyword": "morsa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bajar la escalera mecánica": [
    {
      "id": 38148,
      "keyword": "bajar la escalera mecánica",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir la escalera mecánica": [
    {
      "id": 38151,
      "keyword": "subir la escalera mecánica",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "place",
        "building",
        "trade",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botón de borrar último": [
    {
      "id": 38199,
      "keyword": "botón de borrar último",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38200,
      "keyword": "botón de borrar último",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de borrado": [
    {
      "id": 38199,
      "keyword": "botón de borrar último",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38200,
      "keyword": "botón de borrar último",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de borrar todo": [
    {
      "id": 38201,
      "keyword": "botón de borrar todo",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38202,
      "keyword": "botón de borrar todo",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papel vegetal": [
    {
      "id": 38203,
      "keyword": "papel vegetal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papeles vegetales": [
    {
      "id": 38203,
      "keyword": "papel vegetal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gorro quirúrgico": [
    {
      "id": 38204,
      "keyword": "gorro quirúrgico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gorros quirúrgicos": [
    {
      "id": 38204,
      "keyword": "gorro quirúrgico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gorro desechable": [
    {
      "id": 38204,
      "keyword": "gorro desechable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gorros desechables": [
    {
      "id": 38204,
      "keyword": "gorro desechable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear",
        "protective equipment",
        "health",
        "medicine",
        "medical equipment",
        "covid-19"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contenedor de restos": [
    {
      "id": 38205,
      "keyword": "contenedor de restos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contenedores de restos": [
    {
      "id": 38205,
      "keyword": "contenedor de restos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contenedor de fracción resto": [
    {
      "id": 38205,
      "keyword": "contenedor de fracción resto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contenedores de fracción resto": [
    {
      "id": 38205,
      "keyword": "contenedor de fracción resto",
      "keywords": 3,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vídeo en línea": [
    {
      "id": 38207,
      "keyword": "vídeo en línea",
      "keywords": 6,
      "type": 6,
      "tags": [
        "communication",
        "signaling system",
        "mass media",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vídeos en línea": [
    {
      "id": 38207,
      "keyword": "vídeo en línea",
      "keywords": 6,
      "type": 6,
      "tags": [
        "communication",
        "signaling system",
        "mass media",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vídeo online": [
    {
      "id": 38207,
      "keyword": "vídeo online",
      "keywords": 6,
      "type": 6,
      "tags": [
        "communication",
        "signaling system",
        "mass media",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vídeos online": [
    {
      "id": 38207,
      "keyword": "vídeo online",
      "keywords": 6,
      "type": 6,
      "tags": [
        "communication",
        "signaling system",
        "mass media",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vídeo en streaming": [
    {
      "id": 38207,
      "keyword": "vídeo en streaming",
      "keywords": 6,
      "type": 6,
      "tags": [
        "communication",
        "signaling system",
        "mass media",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vídeos en streaming": [
    {
      "id": 38207,
      "keyword": "vídeo en streaming",
      "keywords": 6,
      "type": 6,
      "tags": [
        "communication",
        "signaling system",
        "mass media",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plataforma de vídeos": [
    {
      "id": 38207,
      "keyword": "plataforma de vídeos",
      "keywords": 6,
      "type": 6,
      "tags": [
        "communication",
        "signaling system",
        "mass media",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plataformas de vídeos": [
    {
      "id": 38207,
      "keyword": "plataforma de vídeos",
      "keywords": 6,
      "type": 6,
      "tags": [
        "communication",
        "signaling system",
        "mass media",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "servicio de alojamiento de videos": [
    {
      "id": 38207,
      "keyword": "servicio de alojamiento de videos",
      "keywords": 6,
      "type": 6,
      "tags": [
        "communication",
        "signaling system",
        "mass media",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38207,
      "keyword": "servicio de alojamiento de videos",
      "keywords": 6,
      "type": 6,
      "tags": [
        "communication",
        "signaling system",
        "mass media",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de vídeo en línea": [
    {
      "id": 38207,
      "keyword": "botón de vídeo en línea",
      "keywords": 6,
      "type": 6,
      "tags": [
        "communication",
        "signaling system",
        "mass media",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de vídeo en línea": [
    {
      "id": 38207,
      "keyword": "botón de vídeo en línea",
      "keywords": 6,
      "type": 6,
      "tags": [
        "communication",
        "signaling system",
        "mass media",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contenedor orgánico": [
    {
      "id": 38208,
      "keyword": "contenedor orgánico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contenedores orgánicos": [
    {
      "id": 38208,
      "keyword": "contenedor orgánico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de teclado": [
    {
      "id": 38209,
      "keyword": "botón de teclado",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de teclado": [
    {
      "id": 38209,
      "keyword": "botón de teclado",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de grabación": [
    {
      "id": 38210,
      "keyword": "botón de grabación",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de grabación": [
    {
      "id": 38210,
      "keyword": "botón de grabación",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de grabar": [
    {
      "id": 38210,
      "keyword": "botón de grabar",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botón de radio": [
    {
      "id": 38211,
      "keyword": "botón de radio",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de radio": [
    {
      "id": 38211,
      "keyword": "botón de radio",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de encendido": [
    {
      "id": 38212,
      "keyword": "botón de encendido",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de encendido": [
    {
      "id": 38212,
      "keyword": "botón de encendido",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de encender": [
    {
      "id": 38212,
      "keyword": "botón de encender",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botón de pausa": [
    {
      "id": 38213,
      "keyword": "botón de pausa",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de pausa": [
    {
      "id": 38213,
      "keyword": "botón de pausa",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de pausar": [
    {
      "id": 38213,
      "keyword": "botón de pausar",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botón de silencio del volumen": [
    {
      "id": 38214,
      "keyword": "botón de silencio del volumen",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de silencio del volumen": [
    {
      "id": 38214,
      "keyword": "botón de silencio del volumen",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de silenciar el volumen": [
    {
      "id": 38214,
      "keyword": "botón de silenciar el volumen",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de silenciar el volumen": [
    {
      "id": 38214,
      "keyword": "botón de silenciar el volumen",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de bajada de volumen": [
    {
      "id": 38215,
      "keyword": "botón de bajada de volumen",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de bajada de volumen": [
    {
      "id": 38215,
      "keyword": "botón de bajada de volumen",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38216,
      "keyword": "botón de subida de volumen",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de bajar volumen": [
    {
      "id": 38215,
      "keyword": "botón de bajar volumen",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de bajar volumen": [
    {
      "id": 38215,
      "keyword": "botón de bajar volumen",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de subida de volumen": [
    {
      "id": 38216,
      "keyword": "botón de subida de volumen",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botón de subir volumen": [
    {
      "id": 38216,
      "keyword": "botón de subir volumen",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de subir volumen": [
    {
      "id": 38216,
      "keyword": "botón de subir volumen",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de lista de reproducción": [
    {
      "id": 38217,
      "keyword": "botón de lista de reproducción",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de lista de reproducción": [
    {
      "id": 38217,
      "keyword": "botón de lista de reproducción",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón más": [
    {
      "id": 38218,
      "keyword": "botón más",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones más": [
    {
      "id": 38218,
      "keyword": "botón más",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de añadir": [
    {
      "id": 38218,
      "keyword": "botón de añadir",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de añadir": [
    {
      "id": 38218,
      "keyword": "botón de añadir",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de retroceso": [
    {
      "id": 38219,
      "keyword": "botón de retroceso",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de retroceso": [
    {
      "id": 38219,
      "keyword": "botón de retroceso",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón para retroceder": [
    {
      "id": 38219,
      "keyword": "botón para retroceder",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones para retroceder": [
    {
      "id": 38219,
      "keyword": "botón para retroceder",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de avance": [
    {
      "id": 38220,
      "keyword": "botón de avance",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de avance": [
    {
      "id": 38220,
      "keyword": "botón de avance",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón para avanzar": [
    {
      "id": 38220,
      "keyword": "botón para avanzar",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones para avanzar": [
    {
      "id": 38220,
      "keyword": "botón para avanzar",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de reproducción": [
    {
      "id": 38221,
      "keyword": "botón de reproducción",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de reproducción": [
    {
      "id": 38221,
      "keyword": "botón de reproducción",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón play": [
    {
      "id": 38221,
      "keyword": "botón play",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones play": [
    {
      "id": 38221,
      "keyword": "botón play",
      "keywords": 2,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de inicio": [
    {
      "id": 38222,
      "keyword": "botón de inicio",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de inicio": [
    {
      "id": 38222,
      "keyword": "botón de inicio",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón siguiente": [
    {
      "id": 38223,
      "keyword": "botón siguiente",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botón anterior": [
    {
      "id": 38224,
      "keyword": "botón anterior",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "san fermín": [
    {
      "id": 38225,
      "keyword": "San Fermín",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oboe": [
    {
      "id": 38228,
      "keyword": "oboe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oboes": [
    {
      "id": 38228,
      "keyword": "oboe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "¿qué quieres?": [
    {
      "id": 38229,
      "keyword": "¿qué quieres?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavar con guante": [
    {
      "id": 38230,
      "keyword": "lavar con guante",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38242,
      "keyword": "lavar con guante",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "robot aspirador": [
    {
      "id": 38234,
      "keyword": "robot aspirador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "robots aspiradores": [
    {
      "id": 38234,
      "keyword": "robot aspirador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bar restaurante": [
    {
      "id": 38235,
      "keyword": "bar restaurante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compañía de teatro": [
    {
      "id": 38236,
      "keyword": "compañía de teatro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "scenic art",
        "theater",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compañías de teatro": [
    {
      "id": 38236,
      "keyword": "compañía de teatro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "scenic art",
        "theater",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diseñador de interiores": [
    {
      "id": 38237,
      "keyword": "diseñador de interiores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "place",
        "building",
        "building facility",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diseñadores de interiores": [
    {
      "id": 38237,
      "keyword": "diseñador de interiores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "place",
        "building",
        "building facility",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "interiorismo": [
    {
      "id": 38237,
      "keyword": "interiorismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "place",
        "building",
        "building facility",
        "object",
        "furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coger el ticket": [
    {
      "id": 38238,
      "keyword": "coger el ticket",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coger el billete": [
    {
      "id": 38238,
      "keyword": "coger el billete",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomar el ticket": [
    {
      "id": 38238,
      "keyword": "tomar el ticket",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomar el billete": [
    {
      "id": 38238,
      "keyword": "tomar el billete",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estación meteorológica": [
    {
      "id": 38241,
      "keyword": "estación meteorológica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "atmospheric device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estaciones meteorológicas": [
    {
      "id": 38241,
      "keyword": "estación meteorológica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "atmospheric device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cámper": [
    {
      "id": 38243,
      "keyword": "cámper",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campers": [
    {
      "id": 38243,
      "keyword": "cámper",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "asiento anatómico": [
    {
      "id": 38246,
      "keyword": "asiento anatómico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asientos anatómicos": [
    {
      "id": 38246,
      "keyword": "asiento anatómico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de apagado": [
    {
      "id": 38247,
      "keyword": "botón de apagado",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de apagado": [
    {
      "id": 38247,
      "keyword": "botón de apagado",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de actualizar": [
    {
      "id": 38248,
      "keyword": "botón de actualizar",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de actualizar": [
    {
      "id": 38248,
      "keyword": "botón de actualizar",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de volver": [
    {
      "id": 38249,
      "keyword": "botón de volver",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de volver": [
    {
      "id": 38249,
      "keyword": "botón de volver",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de anterior": [
    {
      "id": 38250,
      "keyword": "botón de anterior",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de anterior": [
    {
      "id": 38250,
      "keyword": "botón de anterior",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de stop": [
    {
      "id": 38251,
      "keyword": "botón de stop",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de stop": [
    {
      "id": 38251,
      "keyword": "botón de stop",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de siguiente": [
    {
      "id": 38252,
      "keyword": "botón de siguiente",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de siguiente": [
    {
      "id": 38252,
      "keyword": "botón de siguiente",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de productos a granel": [
    {
      "id": 38253,
      "keyword": "tienda de productos a granel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de productos a granel": [
    {
      "id": 38253,
      "keyword": "tienda de productos a granel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pala para llenar": [
    {
      "id": 38254,
      "keyword": "pala para llenar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palas para llenar": [
    {
      "id": 38254,
      "keyword": "pala para llenar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pala medidora": [
    {
      "id": 38254,
      "keyword": "pala medidora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palas medidoras": [
    {
      "id": 38254,
      "keyword": "pala medidora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cargador usb": [
    {
      "id": 38255,
      "keyword": "cargador USB",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cargadores usb": [
    {
      "id": 38255,
      "keyword": "cargador USB",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "punto de recarga móvil": [
    {
      "id": 38255,
      "keyword": "punto de recarga móvil",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puntos de recarga móvil": [
    {
      "id": 38255,
      "keyword": "punto de recarga móvil",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "punto de carga usb": [
    {
      "id": 38255,
      "keyword": "punto de carga USB",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puntos de carga usb": [
    {
      "id": 38255,
      "keyword": "punto de carga USB",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "academia de inglés": [
    {
      "id": 38257,
      "keyword": "academia de inglés",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "academias de inglés": [
    {
      "id": 38257,
      "keyword": "academia de inglés",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tener miedo": [
    {
      "id": 38258,
      "keyword": "tener miedo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human response",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tener miedo a la guerra": [
    {
      "id": 38258,
      "keyword": "tener miedo a la guerra",
      "keywords": 3,
      "type": 3,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human response",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "miedo a la guerra": [
    {
      "id": 38258,
      "keyword": "miedo a la guerra",
      "keywords": 3,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human response",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leonardo da vinci": [
    {
      "id": 38259,
      "keyword": "Leonardo da Vinci",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "historical character",
        "history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colegio de enfermería": [
    {
      "id": 38264,
      "keyword": "colegio de enfermería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "health",
        "medicine",
        "professional",
        "work",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner la mochila": [
    {
      "id": 38265,
      "keyword": "poner la mochila",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "person",
        "routine",
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trastada": [
    {
      "id": 38266,
      "keyword": "trastada",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trastadas": [
    {
      "id": 38266,
      "keyword": "trastada",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "picia": [
    {
      "id": 38266,
      "keyword": "picia",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "picias": [
    {
      "id": 38266,
      "keyword": "picia",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "travesura": [
    {
      "id": 38266,
      "keyword": "travesura",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "travesuras": [
    {
      "id": 38266,
      "keyword": "travesura",
      "keywords": 5,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hacer travesuras": [
    {
      "id": 38266,
      "keyword": "hacer travesuras",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer una trastada": [
    {
      "id": 38266,
      "keyword": "hacer una trastada",
      "keywords": 5,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "morcón": [
    {
      "id": 38267,
      "keyword": "morcón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "morcones": [
    {
      "id": 38267,
      "keyword": "morcón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agallón": [
    {
      "id": 38268,
      "keyword": "agallón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agallones": [
    {
      "id": 38268,
      "keyword": "agallón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant physiology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agalla": [
    {
      "id": 38268,
      "keyword": "agalla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agallas": [
    {
      "id": 38268,
      "keyword": "agalla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant physiology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "flor amarilla": [
    {
      "id": 38269,
      "keyword": "flor amarilla",
      "keywords": 4,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flores amarillas": [
    {
      "id": 38269,
      "keyword": "flor amarilla",
      "keywords": 4,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hierba cana": [
    {
      "id": 38269,
      "keyword": "hierba cana",
      "keywords": 4,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hierbas cana": [
    {
      "id": 38269,
      "keyword": "hierba cana",
      "keywords": 4,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "yuyito": [
    {
      "id": 38269,
      "keyword": "yuyito",
      "keywords": 4,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "yuyitos": [
    {
      "id": 38269,
      "keyword": "yuyito",
      "keywords": 4,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "senecio": [
    {
      "id": 38269,
      "keyword": "senecio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "senecios": [
    {
      "id": 38269,
      "keyword": "senecio",
      "keywords": 4,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encenegar": [
    {
      "id": 38271,
      "keyword": "encenegar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "material",
        "derived material",
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atollar": [
    {
      "id": 38271,
      "keyword": "atollar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "material",
        "derived material",
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "antes de ayer": [
    {
      "id": 38272,
      "keyword": "antes de ayer",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasado mañana": [
    {
      "id": 38277,
      "keyword": "pasado mañana",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adverb",
        "adverb of time",
        "mathematics",
        "basic concepts",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "embestir": [
    {
      "id": 38281,
      "keyword": "embestir",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "animal behavior",
        "scenic art",
        "bullfighting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fuga": [
    {
      "id": 38282,
      "keyword": "fuga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fugas": [
    {
      "id": 38282,
      "keyword": "fuga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fuga de agua": [
    {
      "id": 38282,
      "keyword": "fuga de agua",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fugas de agua": [
    {
      "id": 38282,
      "keyword": "fuga de agua",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escape de agua": [
    {
      "id": 38282,
      "keyword": "escape de agua",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escapes de agua": [
    {
      "id": 38282,
      "keyword": "escape de agua",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atajo": [
    {
      "id": 38284,
      "keyword": "atajo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "place",
        "rural area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atajos": [
    {
      "id": 38284,
      "keyword": "atajo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "place",
        "rural area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atajar": [
    {
      "id": 38284,
      "keyword": "atajar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "place",
        "rural area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasear por el campo": [
    {
      "id": 38286,
      "keyword": "pasear por el campo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caminar por el campo": [
    {
      "id": 38286,
      "keyword": "caminar por el campo",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomar el aire": [
    {
      "id": 38286,
      "keyword": "tomar el aire",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer bolitas": [
    {
      "id": 38287,
      "keyword": "hacer bolitas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer el puente": [
    {
      "id": 38288,
      "keyword": "hacer el puente",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "riego por goteo": [
    {
      "id": 38289,
      "keyword": "riego por goteo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "gardening",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "regar por goteo": [
    {
      "id": 38289,
      "keyword": "regar por goteo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "primary sector",
        "gardening",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oficina de denuncias": [
    {
      "id": 38290,
      "keyword": "oficina de denuncias",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oficinas de denuncias": [
    {
      "id": 38290,
      "keyword": "oficina de denuncias",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "justice",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "renovación del dni": [
    {
      "id": 38291,
      "keyword": "renovación del DNI",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "supporting document",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "renovación del pasaporte": [
    {
      "id": 38292,
      "keyword": "renovación del pasaporte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "supporting document",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oficina de extranjería": [
    {
      "id": 38293,
      "keyword": "oficina de extranjería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "unidad de extranjería": [
    {
      "id": 38293,
      "keyword": "unidad de extranjería",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grupo de menores": [
    {
      "id": 38294,
      "keyword": "grupo de menores",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grupos de menores": [
    {
      "id": 38294,
      "keyword": "grupo de menores",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "unidad de atención a la mujer": [
    {
      "id": 38295,
      "keyword": "unidad de atención a la mujer",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "turismo familiar": [
    {
      "id": 38298,
      "keyword": "turismo familiar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "montar en monociclo": [
    {
      "id": 38300,
      "keyword": "montar en monociclo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "scenic art",
        "circus",
        "show",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38303,
      "keyword": "montar en monociclo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "scenic art",
        "circus",
        "show",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "andar en monociclo": [
    {
      "id": 38300,
      "keyword": "andar en monociclo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "scenic art",
        "circus",
        "show",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38303,
      "keyword": "andar en monociclo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "scenic art",
        "circus",
        "show",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "food truck": [
    {
      "id": 38302,
      "keyword": "food truck",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "food trucks": [
    {
      "id": 38302,
      "keyword": "food truck",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gastroneta": [
    {
      "id": 38302,
      "keyword": "gastroneta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gastronetas": [
    {
      "id": 38302,
      "keyword": "gastroneta",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camión restaurante": [
    {
      "id": 38302,
      "keyword": "camión restaurante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camiones restaurante": [
    {
      "id": 38302,
      "keyword": "camión restaurante",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juego de la rana": [
    {
      "id": 38304,
      "keyword": "juego de la rana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paloteado": [
    {
      "id": 38305,
      "keyword": "paloteado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "regional dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hoyetes": [
    {
      "id": 38306,
      "keyword": "hoyetes",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolinches": [
    {
      "id": 38307,
      "keyword": "bolinches",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chucrut alsaciano": [
    {
      "id": 38308,
      "keyword": "chucrut alsaciano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chucruts alsacianos": [
    {
      "id": 38308,
      "keyword": "chucrut alsaciano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chucrut": [
    {
      "id": 38309,
      "keyword": "chucrut",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38308,
      "keyword": "chucrut",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chucruts": [
    {
      "id": 38309,
      "keyword": "chucrut",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38308,
      "keyword": "chucrut",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "refugiar debajo de la mesa": [
    {
      "id": 38310,
      "keyword": "refugiar debajo de la mesa",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esconder debajo de la mesa": [
    {
      "id": 38310,
      "keyword": "esconder debajo de la mesa",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "resguardarse bajo la mesa": [
    {
      "id": 38310,
      "keyword": "resguardarse bajo la mesa",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "resguardar bajo la mesa": [
    {
      "id": 38310,
      "keyword": "resguardar bajo la mesa",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "meteorology",
        "natural disaster"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rghayif": [
    {
      "id": 38311,
      "keyword": "rghayif",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38358,
      "keyword": "rghayif",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rghayifs": [
    {
      "id": 38311,
      "keyword": "rghayif",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38358,
      "keyword": "rghayif",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "beghrir": [
    {
      "id": 38311,
      "keyword": "beghrir",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38358,
      "keyword": "beghrir",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "beghrirs": [
    {
      "id": 38311,
      "keyword": "beghrir",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38358,
      "keyword": "beghrir",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "baghrir": [
    {
      "id": 38311,
      "keyword": "baghrir",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38358,
      "keyword": "baghrir",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baghrirs": [
    {
      "id": 38311,
      "keyword": "baghrir",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38358,
      "keyword": "baghrir",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "té moruno": [
    {
      "id": 38312,
      "keyword": "té moruno",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tés morunos": [
    {
      "id": 38312,
      "keyword": "té moruno",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "té con yerbabuena": [
    {
      "id": 38312,
      "keyword": "té con yerbabuena",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tés con yerbabuena": [
    {
      "id": 38312,
      "keyword": "té con yerbabuena",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "té con hierbabuena": [
    {
      "id": 38312,
      "keyword": "té con hierbabuena",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tés con hierbabuena": [
    {
      "id": 38312,
      "keyword": "té con hierbabuena",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atay": [
    {
      "id": 38312,
      "keyword": "atay",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atays": [
    {
      "id": 38312,
      "keyword": "atay",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "campo de concentración": [
    {
      "id": 38315,
      "keyword": "campo de concentración",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campos de concentración": [
    {
      "id": 38315,
      "keyword": "campo de concentración",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salvar": [
    {
      "id": 38316,
      "keyword": "salvar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "globo sonda": [
    {
      "id": 38317,
      "keyword": "globo sonda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "object",
        "appliance",
        "atmospheric device",
        "meteorology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "globos sonda": [
    {
      "id": 38317,
      "keyword": "globo sonda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "object",
        "appliance",
        "atmospheric device",
        "meteorology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "globo meteorológico": [
    {
      "id": 38317,
      "keyword": "globo meteorológico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "object",
        "appliance",
        "atmospheric device",
        "meteorology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "globos meteorológicos": [
    {
      "id": 38317,
      "keyword": "globo meteorológico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport",
        "object",
        "appliance",
        "atmospheric device",
        "meteorology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pez cristal": [
    {
      "id": 38318,
      "keyword": "pez cristal",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "oviparous",
        "omnivorous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peces cristal": [
    {
      "id": 38318,
      "keyword": "pez cristal",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "oviparous",
        "omnivorous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pez gato de cristal": [
    {
      "id": 38318,
      "keyword": "pez gato de cristal",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "oviparous",
        "omnivorous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peces gato de cristal": [
    {
      "id": 38318,
      "keyword": "pez gato de cristal",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "oviparous",
        "omnivorous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bicirri": [
    {
      "id": 38318,
      "keyword": "bicirri",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "oviparous",
        "omnivorous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bicirris": [
    {
      "id": 38318,
      "keyword": "bicirri",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "oviparous",
        "omnivorous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pez vidrio": [
    {
      "id": 38318,
      "keyword": "pez vidrio",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "oviparous",
        "omnivorous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peces vidrio": [
    {
      "id": 38318,
      "keyword": "pez vidrio",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "oviparous",
        "omnivorous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "siluro de cristal": [
    {
      "id": 38318,
      "keyword": "siluro de cristal",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "oviparous",
        "omnivorous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "siluros de cristal": [
    {
      "id": 38318,
      "keyword": "siluro de cristal",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "oviparous",
        "omnivorous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barbo hojalata": [
    {
      "id": 38319,
      "keyword": "barbo hojalata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "herbivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barbos hojalata": [
    {
      "id": 38319,
      "keyword": "barbo hojalata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "herbivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pez cuchillo payaso": [
    {
      "id": 38320,
      "keyword": "pez cuchillo payaso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peces cuchillo payaso": [
    {
      "id": 38320,
      "keyword": "pez cuchillo payaso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diálogo compartido": [
    {
      "id": 38321,
      "keyword": "diálogo compartido",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "AAC implementation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gecko de madagascar": [
    {
      "id": 38322,
      "keyword": "gecko de Madagascar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "reptile",
        "omnivorous",
        "ovoviviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "geckos de madagascar": [
    {
      "id": 38322,
      "keyword": "gecko de Madagascar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "reptile",
        "omnivorous",
        "ovoviviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tiburón pangasio": [
    {
      "id": 38323,
      "keyword": "tiburón pangasio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "work",
        "primary sector",
        "fishing",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiburones pangasios": [
    {
      "id": 38323,
      "keyword": "tiburón pangasio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "work",
        "primary sector",
        "fishing",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "panga": [
    {
      "id": 38323,
      "keyword": "panga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "work",
        "primary sector",
        "fishing",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pangas": [
    {
      "id": 38323,
      "keyword": "panga",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "work",
        "primary sector",
        "fishing",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pez gato de cola roja": [
    {
      "id": 38324,
      "keyword": "pez gato de cola roja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peces gato de cola roja": [
    {
      "id": 38324,
      "keyword": "pez gato de cola roja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cajaro": [
    {
      "id": 38324,
      "keyword": "cajaro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajaros": [
    {
      "id": 38324,
      "keyword": "cajaro",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anguila de fuego": [
    {
      "id": 38325,
      "keyword": "anguila de fuego",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "omnivorous",
        "wild",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anguilas de fuego": [
    {
      "id": 38325,
      "keyword": "anguila de fuego",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "omnivorous",
        "wild",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saltarín del fango": [
    {
      "id": 38326,
      "keyword": "saltarín del fango",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "aquatic animal",
        "marine animal",
        "sea",
        "freshwater animal",
        "river",
        "terrestrial animal",
        "carnivorous",
        "oviparous"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saltarines del fango": [
    {
      "id": 38326,
      "keyword": "saltarín del fango",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "aquatic animal",
        "marine animal",
        "sea",
        "freshwater animal",
        "river",
        "terrestrial animal",
        "carnivorous",
        "oviparous"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pez oscar": [
    {
      "id": 38327,
      "keyword": "pez oscar",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peces oscar": [
    {
      "id": 38327,
      "keyword": "pez oscar",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "copaneca": [
    {
      "id": 38327,
      "keyword": "copaneca",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "copanecas": [
    {
      "id": 38327,
      "keyword": "copaneca",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acarahuazú": [
    {
      "id": 38327,
      "keyword": "acarahuazú",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acarahuazús": [
    {
      "id": 38327,
      "keyword": "acarahuazú",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acara-acui": [
    {
      "id": 38327,
      "keyword": "acara-acui",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acara-acuis": [
    {
      "id": 38327,
      "keyword": "acara-acui",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enfermero de quirófano": [
    {
      "id": 38328,
      "keyword": "enfermero de quirófano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfermeros de quirófano": [
    {
      "id": 38328,
      "keyword": "enfermero de quirófano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "enfermera de quirófano": [
    {
      "id": 38329,
      "keyword": "enfermera de quirófano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfermeras de quirófano": [
    {
      "id": 38329,
      "keyword": "enfermera de quirófano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pez lobo": [
    {
      "id": 38330,
      "keyword": "pez lobo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peces lobo": [
    {
      "id": 38330,
      "keyword": "pez lobo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarira": [
    {
      "id": 38330,
      "keyword": "tarira",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tariras": [
    {
      "id": 38330,
      "keyword": "tarira",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "wild",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pitón reticulada": [
    {
      "id": 38331,
      "keyword": "pitón reticulada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "reptile",
        "carnivorous",
        "ovoviviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pitones reticuladas": [
    {
      "id": 38331,
      "keyword": "pitón reticulada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "reptile",
        "carnivorous",
        "ovoviviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coche eléctrico": [
    {
      "id": 38332,
      "keyword": "coche eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coches eléctricos": [
    {
      "id": 38332,
      "keyword": "coche eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "auto eléctrico": [
    {
      "id": 38332,
      "keyword": "auto eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "auto eléctricos": [
    {
      "id": 38332,
      "keyword": "auto eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "electrolinera": [
    {
      "id": 38334,
      "keyword": "electrolinera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "electrolineras": [
    {
      "id": 38334,
      "keyword": "electrolinera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estación de carga": [
    {
      "id": 38334,
      "keyword": "estación de carga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38335,
      "keyword": "estación de carga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estaciones de carga": [
    {
      "id": 38334,
      "keyword": "estación de carga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38335,
      "keyword": "estación de carga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estación de carga eléctrica": [
    {
      "id": 38334,
      "keyword": "estación de carga eléctrica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38335,
      "keyword": "estación de carga eléctrica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estaciones de carga eléctrica": [
    {
      "id": 38334,
      "keyword": "estación de carga eléctrica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38335,
      "keyword": "estación de carga eléctrica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "punto de recarga": [
    {
      "id": 38335,
      "keyword": "punto de recarga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puntos de recarga": [
    {
      "id": 38335,
      "keyword": "punto de recarga",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estación de carga y repostaje": [
    {
      "id": 38336,
      "keyword": "estación de carga y repostaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estaciones de carga y repostaje": [
    {
      "id": 38336,
      "keyword": "estación de carga y repostaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "petauro del azúcar": [
    {
      "id": 38337,
      "keyword": "petauro del azúcar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "mammal",
        "omnivorous",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "petauros del azúcar": [
    {
      "id": 38337,
      "keyword": "petauro del azúcar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "mammal",
        "omnivorous",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "turaco": [
    {
      "id": 38338,
      "keyword": "turaco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "bird",
        "herbivorous",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "turacos": [
    {
      "id": 38338,
      "keyword": "turaco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "bird",
        "herbivorous",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rana punta de flecha": [
    {
      "id": 38339,
      "keyword": "rana punta de flecha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "amphibian",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ranas punta de flecha": [
    {
      "id": 38339,
      "keyword": "rana punta de flecha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "amphibian",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rana venenosa de dardo": [
    {
      "id": 38339,
      "keyword": "rana venenosa de dardo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "amphibian",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ranas venenosas de dardo": [
    {
      "id": 38339,
      "keyword": "rana venenosa de dardo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "amphibian",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gurami gigante": [
    {
      "id": 38340,
      "keyword": "gurami gigante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "herbivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guramis gigantes": [
    {
      "id": 38340,
      "keyword": "gurami gigante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "herbivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pez besucón": [
    {
      "id": 38341,
      "keyword": "pez besucón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peces besucones": [
    {
      "id": 38341,
      "keyword": "pez besucón",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gurami besador": [
    {
      "id": 38341,
      "keyword": "gurami besador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guramis besadores": [
    {
      "id": 38341,
      "keyword": "gurami besador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "omnivorous",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "basilisco": [
    {
      "id": 38342,
      "keyword": "basilisco",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "reptile",
        "omnivorous",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "basiliscos": [
    {
      "id": 38342,
      "keyword": "basilisco",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "reptile",
        "omnivorous",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "teterete": [
    {
      "id": 38342,
      "keyword": "teterete",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "reptile",
        "omnivorous",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "teteretes": [
    {
      "id": 38342,
      "keyword": "teterete",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "reptile",
        "omnivorous",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cherepo": [
    {
      "id": 38342,
      "keyword": "cherepo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "reptile",
        "omnivorous",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cherepos": [
    {
      "id": 38342,
      "keyword": "cherepo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "reptile",
        "omnivorous",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tenguereche": [
    {
      "id": 38342,
      "keyword": "tenguereche",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "reptile",
        "omnivorous",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tenguereches": [
    {
      "id": 38342,
      "keyword": "tenguereche",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "reptile",
        "omnivorous",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "moracho": [
    {
      "id": 38342,
      "keyword": "moracho",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "reptile",
        "omnivorous",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "morachos": [
    {
      "id": 38342,
      "keyword": "moracho",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "reptile",
        "omnivorous",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "embajador": [
    {
      "id": 38343,
      "keyword": "embajador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "middle ages"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "embajadores": [
    {
      "id": 38343,
      "keyword": "embajador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "historical character",
        "history",
        "middle ages"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maqueta de barco": [
    {
      "id": 38345,
      "keyword": "maqueta de barco",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maquetas de barcos": [
    {
      "id": 38345,
      "keyword": "maqueta de barco",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jabeque": [
    {
      "id": 38345,
      "keyword": "jabeque",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jabeques": [
    {
      "id": 38345,
      "keyword": "jabeque",
      "keywords": 3,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport",
        "object",
        "decorative item"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desfilar": [
    {
      "id": 38346,
      "keyword": "desfilar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marchar": [
    {
      "id": 38346,
      "keyword": "marchar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38426,
      "keyword": "marchar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ballesta": [
    {
      "id": 38347,
      "keyword": "ballesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "history",
        "middle ages",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ballestas": [
    {
      "id": 38347,
      "keyword": "ballesta",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon",
        "history",
        "middle ages",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diálisis peritoneal": [
    {
      "id": 38349,
      "keyword": "diálisis peritoneal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38928,
      "keyword": "diálisis peritoneal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diálisis peritoneales": [
    {
      "id": 38349,
      "keyword": "diálisis peritoneal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38928,
      "keyword": "diálisis peritoneal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "radiodiagnóstico": [
    {
      "id": 38353,
      "keyword": "radiodiagnóstico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "radiología": [
    {
      "id": 38353,
      "keyword": "radiología",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "servicio de radiodiagnóstico": [
    {
      "id": 38353,
      "keyword": "servicio de radiodiagnóstico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "servicio de radiología": [
    {
      "id": 38353,
      "keyword": "servicio de radiología",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "imagen por resonancia magnética": [
    {
      "id": 38354,
      "keyword": "imagen por resonancia magnética",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "imágenes por resonancia magnética": [
    {
      "id": 38354,
      "keyword": "imagen por resonancia magnética",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "irm": [
    {
      "id": 38354,
      "keyword": "IRM",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pet tac": [
    {
      "id": 38355,
      "keyword": "PET TAC",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tomografía por emisión de positrones": [
    {
      "id": 38355,
      "keyword": "tomografía por emisión de positrones",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "omografías por emisión de positrones": [
    {
      "id": 38355,
      "keyword": "tomografía por emisión de positrones",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pet": [
    {
      "id": 38355,
      "keyword": "PET",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sala de exploración infantil": [
    {
      "id": 38874,
      "keyword": "sala de exploración infantil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "medical procedure",
        "medical test",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38357,
      "keyword": "sala de exploración infantil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "medical procedure",
        "medical test",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de exploración infantil": [
    {
      "id": 38874,
      "keyword": "sala de exploración infantil",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "medical procedure",
        "medical test",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38357,
      "keyword": "sala de exploración infantil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "medical procedure",
        "medical test",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pagrer": [
    {
      "id": 38358,
      "keyword": "pagrer",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pagrers": [
    {
      "id": 38358,
      "keyword": "pagrer",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jeringo": [
    {
      "id": 38358,
      "keyword": "jeringo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jeringos": [
    {
      "id": 38358,
      "keyword": "jeringo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "altramuces": [
    {
      "id": 38359,
      "keyword": "altramuces",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chochos": [
    {
      "id": 38359,
      "keyword": "chochos",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chorchos": [
    {
      "id": 38359,
      "keyword": "chorchos",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lupines": [
    {
      "id": 38359,
      "keyword": "lupines",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almortas": [
    {
      "id": 38359,
      "keyword": "almortas",
      "keywords": 5,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anémona": [
    {
      "id": 38362,
      "keyword": "anémona",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "aquatic animal",
        "marine animal",
        "sea",
        "carnivorous",
        "oceanography",
        "geography",
        "physical geography",
        "landform",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anémonas": [
    {
      "id": 38362,
      "keyword": "anémona",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "aquatic animal",
        "marine animal",
        "sea",
        "carnivorous",
        "oceanography",
        "geography",
        "physical geography",
        "landform",
        "ocean"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anémona de mar": [
    {
      "id": 38362,
      "keyword": "anémona de mar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "aquatic animal",
        "marine animal",
        "sea",
        "carnivorous",
        "oceanography",
        "geography",
        "physical geography",
        "landform",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anémonas de mar": [
    {
      "id": 38362,
      "keyword": "anémona de mar",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "aquatic animal",
        "marine animal",
        "sea",
        "carnivorous",
        "oceanography",
        "geography",
        "physical geography",
        "landform",
        "ocean"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "actinia": [
    {
      "id": 38362,
      "keyword": "actinia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "aquatic animal",
        "marine animal",
        "sea",
        "carnivorous",
        "oceanography",
        "geography",
        "physical geography",
        "landform",
        "ocean"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "actinias": [
    {
      "id": 38362,
      "keyword": "actinia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "aquatic animal",
        "marine animal",
        "sea",
        "carnivorous",
        "oceanography",
        "geography",
        "physical geography",
        "landform",
        "ocean"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesa abatible": [
    {
      "id": 38363,
      "keyword": "mesa abatible",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "education",
        "educational equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas abatibles": [
    {
      "id": 38363,
      "keyword": "mesa abatible",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "education",
        "educational equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "varano": [
    {
      "id": 38364,
      "keyword": "varano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "reptile",
        "carnivorous",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "varanos": [
    {
      "id": 38364,
      "keyword": "varano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "reptile",
        "carnivorous",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "varanus": [
    {
      "id": 38364,
      "keyword": "varanus",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "reptile",
        "carnivorous",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frotis de uñas": [
    {
      "id": 38365,
      "keyword": "frotis de uñas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huérfana": [
    {
      "id": 38366,
      "keyword": "huérfana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huérfanas": [
    {
      "id": 38366,
      "keyword": "huérfana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huérfano": [
    {
      "id": 38367,
      "keyword": "huérfano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huérfanos": [
    {
      "id": 38367,
      "keyword": "huérfano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trapichear": [
    {
      "id": 38369,
      "keyword": "trapichear",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "traficar": [
    {
      "id": 38369,
      "keyword": "traficar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime",
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secuestradora": [
    {
      "id": 38370,
      "keyword": "secuestradora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secuestradoras": [
    {
      "id": 38370,
      "keyword": "secuestradora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "scooter eléctrica": [
    {
      "id": 38371,
      "keyword": "scooter eléctrica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "scooters eléctricas": [
    {
      "id": 38371,
      "keyword": "scooter eléctrica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarántula": [
    {
      "id": 38372,
      "keyword": "tarántula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "arachnid",
        "oviparous",
        "terrestrial animal",
        "carnivorous",
        "wild",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarántulas": [
    {
      "id": 38372,
      "keyword": "tarántula",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "arachnid",
        "oviparous",
        "terrestrial animal",
        "carnivorous",
        "wild",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "marcar un teléfono": [
    {
      "id": 38375,
      "keyword": "marcar un teléfono",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "mass media device",
        "mass media"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mujer de medio cuerpo": [
    {
      "id": 38376,
      "keyword": "mujer de medio cuerpo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mujeres de medio cuerpo": [
    {
      "id": 38376,
      "keyword": "mujer de medio cuerpo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de relajación": [
    {
      "id": 38377,
      "keyword": "sala de relajación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sala de descanso": [
    {
      "id": 38918,
      "keyword": "sala de descanso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38933,
      "keyword": "sala de descanso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38377,
      "keyword": "sala de descanso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asistente": [
    {
      "id": 38378,
      "keyword": "asistente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "tourism",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38379,
      "keyword": "asistente",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "tourism",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asistente personal": [
    {
      "id": 38378,
      "keyword": "asistente personal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "tourism",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38379,
      "keyword": "asistente personal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "tourism",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "asistentes personales": [
    {
      "id": 38378,
      "keyword": "asistente personal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "tourism",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38379,
      "keyword": "asistente personal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "tourism",
        "personal services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "audio descripción web": [
    {
      "id": 38380,
      "keyword": "audio descripción web",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "audio descripciones web": [
    {
      "id": 38380,
      "keyword": "audio descripción web",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "flash": [
    {
      "id": 38381,
      "keyword": "flash",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flashes": [
    {
      "id": 38381,
      "keyword": "flash",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "visita virtual": [
    {
      "id": 38382,
      "keyword": "visita virtual",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "culture",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "visitas virtuales": [
    {
      "id": 38382,
      "keyword": "visita virtual",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "culture",
        "visual art"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tour virtual": [
    {
      "id": 38382,
      "keyword": "tour virtual",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "culture",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tours virtuales": [
    {
      "id": 38382,
      "keyword": "tour virtual",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "culture",
        "visual art"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recorrido virtual": [
    {
      "id": 38382,
      "keyword": "recorrido virtual",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "culture",
        "visual art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recorridos virtuales": [
    {
      "id": 38382,
      "keyword": "recorrido virtual",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "culture",
        "visual art"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prohibido hacer fotos con flash": [
    {
      "id": 38383,
      "keyword": "prohibido hacer fotos con flash",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "signaling system",
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fotografiar con flash": [
    {
      "id": 38384,
      "keyword": "fotografiar con flash",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plantillas ortopédicas": [
    {
      "id": 38385,
      "keyword": "plantillas ortopédicas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plantilla": [
    {
      "id": 38385,
      "keyword": "plantilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plantillas": [
    {
      "id": 38385,
      "keyword": "plantilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ciclido delfín": [
    {
      "id": 38388,
      "keyword": "ciclido delfín",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciclidos delfín": [
    {
      "id": 38388,
      "keyword": "ciclido delfín",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "delfín azul de malawi": [
    {
      "id": 38388,
      "keyword": "delfín azul de Malawi",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "delfines azules de malawi": [
    {
      "id": 38388,
      "keyword": "delfín azul de Malawi",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "delfín de malawi": [
    {
      "id": 38388,
      "keyword": "delfín de Malawi",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "delfines de malawi": [
    {
      "id": 38388,
      "keyword": "delfín de Malawi",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "omnivorous",
        "vertebrate",
        "fish",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atropellos": [
    {
      "id": 38389,
      "keyword": "atropello",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "traffic accident",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "villano": [
    {
      "id": 38390,
      "keyword": "villano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "comic character",
        "comic",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "villanos": [
    {
      "id": 38390,
      "keyword": "villano",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "movie character",
        "cinema",
        "comic character",
        "comic",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aula hospitalaria": [
    {
      "id": 39050,
      "keyword": "aula hospitalaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38392,
      "keyword": "aula hospitalaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "work",
        "professional",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38393,
      "keyword": "aula hospitalaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "work",
        "professional",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aulas hospitalarias": [
    {
      "id": 39050,
      "keyword": "aula hospitalaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38392,
      "keyword": "aula hospitalaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "work",
        "professional",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38393,
      "keyword": "aula hospitalaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "work",
        "professional",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maestra hospitalaria": [
    {
      "id": 38392,
      "keyword": "maestra hospitalaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "work",
        "professional",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maestras hospitalarias": [
    {
      "id": 38392,
      "keyword": "maestra hospitalaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "work",
        "professional",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "maestro hospitalario": [
    {
      "id": 38393,
      "keyword": "maestro hospitalario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "work",
        "professional",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maestros hospitalarios": [
    {
      "id": 38393,
      "keyword": "maestro hospitalario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "education",
        "educational space",
        "work",
        "professional",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vivir en el mar": [
    {
      "id": 38394,
      "keyword": "vivir en el mar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "aquatic animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "insecto palo": [
    {
      "id": 38395,
      "keyword": "insecto palo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "insectos palo": [
    {
      "id": 38395,
      "keyword": "insecto palo",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palote": [
    {
      "id": 38395,
      "keyword": "palote",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palotes": [
    {
      "id": 38395,
      "keyword": "palote",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "zacatón": [
    {
      "id": 38395,
      "keyword": "zacatón",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zacatones": [
    {
      "id": 38395,
      "keyword": "zacatón",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "campamocha": [
    {
      "id": 38395,
      "keyword": "campamocha",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campamochas": [
    {
      "id": 38395,
      "keyword": "campamocha",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mariapalito": [
    {
      "id": 38395,
      "keyword": "mariapalito",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mariapalitos": [
    {
      "id": 38395,
      "keyword": "mariapalito",
      "keywords": 5,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "herbivorous"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "insecto hoja": [
    {
      "id": 38396,
      "keyword": "insecto hoja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "ovoviviparous",
        "herbivorous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "insectos hoja": [
    {
      "id": 38396,
      "keyword": "insecto hoja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "ovoviviparous",
        "herbivorous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pesca de patos": [
    {
      "id": 38398,
      "keyword": "pesca de patos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atracción portería de precisión": [
    {
      "id": 38399,
      "keyword": "atracción portería de precisión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barraca": [
    {
      "id": 38400,
      "keyword": "barraca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barracas": [
    {
      "id": 38400,
      "keyword": "barraca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caseta": [
    {
      "id": 38400,
      "keyword": "caseta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casetas": [
    {
      "id": 38400,
      "keyword": "caseta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atracción del barco pirata ": [
    {
      "id": 38401,
      "keyword": "atracción del barco pirata ",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atracción rana saltarina": [
    {
      "id": 38402,
      "keyword": "atracción rana saltarina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atracción saltamontes": [
    {
      "id": 38402,
      "keyword": "atracción saltamontes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "náuseas": [
    {
      "id": 38403,
      "keyword": "náuseas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38404,
      "keyword": "náuseas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arcadas": [
    {
      "id": 38403,
      "keyword": "arcadas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38404,
      "keyword": "arcadas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tener náuseas": [
    {
      "id": 38405,
      "keyword": "tener náuseas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tener arcadas": [
    {
      "id": 38405,
      "keyword": "tener arcadas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esperar en la fila": [
    {
      "id": 38406,
      "keyword": "esperar en la fila",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38410,
      "keyword": "esperar en la fila",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atracción inclusiva": [
    {
      "id": 38407,
      "keyword": "atracción inclusiva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atracciones inclusivas": [
    {
      "id": 38407,
      "keyword": "atracción inclusiva",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esperar al tren turístico": [
    {
      "id": 38408,
      "keyword": "esperar al tren turístico",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comer con la mano": [
    {
      "id": 38413,
      "keyword": "comer con la mano",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zona de picnic": [
    {
      "id": 38414,
      "keyword": "zona de picnic",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zonas de picnic": [
    {
      "id": 38414,
      "keyword": "zona de picnic",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "área de picnic": [
    {
      "id": 38414,
      "keyword": "área de picnic",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "áreas de picnic": [
    {
      "id": 38414,
      "keyword": "área de picnic",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "merendero": [
    {
      "id": 38414,
      "keyword": "merendero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "merenderos": [
    {
      "id": 38414,
      "keyword": "merendero",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mesa de picnic": [
    {
      "id": 38415,
      "keyword": "mesa de picnic",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas de picnic": [
    {
      "id": 38415,
      "keyword": "mesa de picnic",
      "keywords": 1,
      "type": 2,
      "tags": [
        "urban area",
        "street furniture",
        "leisure",
        "outdoor activity"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aurora boreal": [
    {
      "id": 38416,
      "keyword": "aurora boreal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "auroras boreales": [
    {
      "id": 38416,
      "keyword": "aurora boreal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fobia": [
    {
      "id": 38417,
      "keyword": "fobia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fobias": [
    {
      "id": 38417,
      "keyword": "fobia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human response",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tableta efervescente": [
    {
      "id": 38419,
      "keyword": "tableta efervescente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tabletas efervescentes": [
    {
      "id": 38419,
      "keyword": "tableta efervescente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pastilla efervescente": [
    {
      "id": 38419,
      "keyword": "pastilla efervescente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pastillas efervescentes": [
    {
      "id": 38419,
      "keyword": "pastilla efervescente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comprimido efervescente": [
    {
      "id": 38419,
      "keyword": "comprimido efervescente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comprimidos efervescentes": [
    {
      "id": 38419,
      "keyword": "comprimido efervescente",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agua con gas": [
    {
      "id": 38420,
      "keyword": "agua con gas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cucaracha gigante": [
    {
      "id": 38421,
      "keyword": "cucaracha gigante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "herbivorous",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cucarachas gigantes": [
    {
      "id": 38421,
      "keyword": "cucaracha gigante",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "herbivorous",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chinche asesino": [
    {
      "id": 38422,
      "keyword": "chinche asesino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "omnivorous",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chinches asesinos": [
    {
      "id": 38422,
      "keyword": "chinche asesino",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "invertebrate",
        "arthropod",
        "insect",
        "omnivorous",
        "oviparous",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dolor muscular": [
    {
      "id": 38423,
      "keyword": "dolor muscular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dolores musculares": [
    {
      "id": 38423,
      "keyword": "dolor muscular",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "portería de precisión": [
    {
      "id": 38424,
      "keyword": "portería de precisión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porterías de precisión": [
    {
      "id": 38424,
      "keyword": "portería de precisión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "red de precisión": [
    {
      "id": 38424,
      "keyword": "red de precisión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "redes de precisión": [
    {
      "id": 38424,
      "keyword": "red de precisión",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "portería con objetivos": [
    {
      "id": 38424,
      "keyword": "portería con objetivos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porterías con objetivos": [
    {
      "id": 38424,
      "keyword": "portería con objetivos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "football"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esquí nórdico": [
    {
      "id": 38425,
      "keyword": "esquí nórdico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marcha nórdica": [
    {
      "id": 38426,
      "keyword": "marcha nórdica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marchas nórdicas": [
    {
      "id": 38426,
      "keyword": "marcha nórdica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caminata nórdica": [
    {
      "id": 38426,
      "keyword": "caminata nórdica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caminatas nórdicas": [
    {
      "id": 38426,
      "keyword": "caminata nórdica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hall": [
    {
      "id": 38427,
      "keyword": "hall",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "halls": [
    {
      "id": 38427,
      "keyword": "hall",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vestíbulo": [
    {
      "id": 38427,
      "keyword": "vestíbulo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38432,
      "keyword": "vestíbulo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vestíbulos": [
    {
      "id": 38427,
      "keyword": "vestíbulo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38432,
      "keyword": "vestíbulo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apendicitis": [
    {
      "id": 38429,
      "keyword": "apendicitis",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apéndice": [
    {
      "id": 38430,
      "keyword": "apéndice",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apéndices": [
    {
      "id": 38430,
      "keyword": "apéndice",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "human physiology",
        "physiology",
        "digestive system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esturión": [
    {
      "id": 38433,
      "keyword": "esturión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "esturiones": [
    {
      "id": 38433,
      "keyword": "esturión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "vertebrate",
        "fish",
        "carnivorous",
        "oviparous",
        "aquatic animal",
        "work",
        "primary sector",
        "fishing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "carbonera": [
    {
      "id": 38436,
      "keyword": "carbonera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "vegetal origin material",
        "work",
        "primary sector",
        "forestry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carboneras": [
    {
      "id": 38436,
      "keyword": "carbonera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "material",
        "raw material",
        "vegetal origin material",
        "work",
        "primary sector",
        "forestry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pepitas de chocolate": [
    {
      "id": 38438,
      "keyword": "pepitas de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lagrimas de chocolate": [
    {
      "id": 38438,
      "keyword": "lagrimas de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mari domingui": [
    {
      "id": 38439,
      "keyword": "Mari Domingui",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "mythological character",
        "mythology",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boina": [
    {
      "id": 38441,
      "keyword": "boina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boinas": [
    {
      "id": 38441,
      "keyword": "boina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "grupo": [
    {
      "id": 38444,
      "keyword": "grupo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grupos": [
    {
      "id": 38444,
      "keyword": "grupo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "multitud": [
    {
      "id": 38445,
      "keyword": "multitud",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "multitudes": [
    {
      "id": 38445,
      "keyword": "multitud",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aglomeración": [
    {
      "id": 38445,
      "keyword": "aglomeración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aglomeraciones": [
    {
      "id": 38445,
      "keyword": "aglomeración",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "muchedumbre": [
    {
      "id": 38445,
      "keyword": "muchedumbre",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "muchedumbres": [
    {
      "id": 38445,
      "keyword": "muchedumbre",
      "keywords": 3,
      "type": 2,
      "tags": [
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fiesta de la espuma": [
    {
      "id": 38448,
      "keyword": "fiesta de la espuma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cebada perlada": [
    {
      "id": 38449,
      "keyword": "cebada perlada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "cereal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sonaja": [
    {
      "id": 38450,
      "keyword": "sonaja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38453,
      "keyword": "sonaja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sonajas": [
    {
      "id": 38450,
      "keyword": "sonaja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38453,
      "keyword": "sonaja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "echar agua oxigenada": [
    {
      "id": 38451,
      "keyword": "echar agua oxigenada",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "communication",
        "language",
        "verb",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "poner una tirita": [
    {
      "id": 38452,
      "keyword": "poner una tirita",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parar la bicicleta": [
    {
      "id": 38454,
      "keyword": "parar la bicicleta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boomwhackers": [
    {
      "id": 38455,
      "keyword": "boomwhackers",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "girar a la izquierda": [
    {
      "id": 38456,
      "keyword": "girar a la izquierda",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38458,
      "keyword": "girar a la izquierda",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "girar a la derecha": [
    {
      "id": 38457,
      "keyword": "girar a la derecha",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "cycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recoger residuos": [
    {
      "id": 38459,
      "keyword": "recoger residuos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "recoger basura": [
    {
      "id": 38459,
      "keyword": "recoger basura",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "waste disposal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bangladés": [
    {
      "id": 38460,
      "keyword": "Bangladés",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "república popular de bangladés": [
    {
      "id": 38460,
      "keyword": "República Popular de Bangladés",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "examen": [
    {
      "id": 38462,
      "keyword": "examen",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exámenes": [
    {
      "id": 38462,
      "keyword": "examen",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cabaré": [
    {
      "id": 38464,
      "keyword": "cabaré",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cabarés": [
    {
      "id": 38464,
      "keyword": "cabaré",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cabaret": [
    {
      "id": 38464,
      "keyword": "cabaret",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cabarets": [
    {
      "id": 38464,
      "keyword": "cabaret",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "toro de fuego": [
    {
      "id": 38465,
      "keyword": "toro de fuego",
      "keywords": 2,
      "type": 2,
      "tags": [
        "scenic art",
        "bullfighting",
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toros de fuego": [
    {
      "id": 38465,
      "keyword": "toro de fuego",
      "keywords": 2,
      "type": 2,
      "tags": [
        "scenic art",
        "bullfighting",
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "toro embolado": [
    {
      "id": 38465,
      "keyword": "toro embolado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "scenic art",
        "bullfighting",
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toros embolados": [
    {
      "id": 38465,
      "keyword": "toro embolado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "scenic art",
        "bullfighting",
        "event",
        "popular event",
        "popular festival"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "galoubet": [
    {
      "id": 38466,
      "keyword": "galoubet",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "galoubets": [
    {
      "id": 38466,
      "keyword": "galoubet",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "txistu": [
    {
      "id": 38466,
      "keyword": "txistu",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dar crema en los pies": [
    {
      "id": 38467,
      "keyword": "dar crema en los pies",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar durezas": [
    {
      "id": 39458,
      "keyword": "quitar durezas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38468,
      "keyword": "quitar durezas",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limar durezas": [
    {
      "id": 38468,
      "keyword": "limar durezas",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar un callo": [
    {
      "id": 39458,
      "keyword": "quitar un callo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38468,
      "keyword": "quitar un callo",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "eliminación de durezas": [
    {
      "id": 38468,
      "keyword": "eliminación de durezas",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "secar el pie": [
    {
      "id": 38469,
      "keyword": "secar el pie",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "granizado": [
    {
      "id": 38470,
      "keyword": "granizado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "granizados": [
    {
      "id": 38470,
      "keyword": "granizado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "raspado": [
    {
      "id": 38470,
      "keyword": "raspado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "raspados": [
    {
      "id": 38470,
      "keyword": "raspado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cortacallos": [
    {
      "id": 38472,
      "keyword": "cortacallos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corta callos": [
    {
      "id": 38472,
      "keyword": "corta callos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "consulta de psiquiatría": [
    {
      "id": 38474,
      "keyword": "consulta de psiquiatría",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38880,
      "keyword": "consulta de psiquiatría",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "consultas de psiquiatría": [
    {
      "id": 38474,
      "keyword": "consulta de psiquiatría",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38880,
      "keyword": "consulta de psiquiatría",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "psiquiatra infantil": [
    {
      "id": 38475,
      "keyword": "psiquiatra infantil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38879,
      "keyword": "psiquiatra infantil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "psiquiatras infantiles": [
    {
      "id": 38475,
      "keyword": "psiquiatra infantil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38879,
      "keyword": "psiquiatra infantil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "consulta de psiquiatría infantil": [
    {
      "id": 38475,
      "keyword": "consulta de psiquiatría infantil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38879,
      "keyword": "consulta de psiquiatría infantil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "consultas de psiquiatría infantil": [
    {
      "id": 38475,
      "keyword": "consulta de psiquiatría infantil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38879,
      "keyword": "consulta de psiquiatría infantil",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "human body",
        "physiology",
        "human physiology",
        "nervous system",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ciberestafador": [
    {
      "id": 38478,
      "keyword": "ciberestafador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38479,
      "keyword": "ciberestafador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciberestafadores": [
    {
      "id": 38478,
      "keyword": "ciberestafador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38479,
      "keyword": "ciberestafador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ciberestafadora": [
    {
      "id": 38480,
      "keyword": "ciberestafadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciberestafadoras": [
    {
      "id": 38480,
      "keyword": "ciberestafadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "picatostes": [
    {
      "id": 38484,
      "keyword": "picatostes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "croûtons": [
    {
      "id": 38484,
      "keyword": "croûtons",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "café con hielo": [
    {
      "id": 38485,
      "keyword": "café con hielo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cafés con hielo": [
    {
      "id": 38485,
      "keyword": "café con hielo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salsa de soja": [
    {
      "id": 38486,
      "keyword": "salsa de soja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salsas de soja": [
    {
      "id": 38486,
      "keyword": "salsa de soja",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salsa barbacoa": [
    {
      "id": 38487,
      "keyword": "salsa barbacoa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salsas barbacoa": [
    {
      "id": 38487,
      "keyword": "salsa barbacoa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bebida de almendras": [
    {
      "id": 38488,
      "keyword": "bebida de almendras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bebidas de almendras": [
    {
      "id": 38488,
      "keyword": "bebida de almendras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sirope de caramelo": [
    {
      "id": 38489,
      "keyword": "sirope de caramelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "siropes de caramelo": [
    {
      "id": 38489,
      "keyword": "sirope de caramelo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chocolate blanco": [
    {
      "id": 38490,
      "keyword": "chocolate blanco",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "roll de canela": [
    {
      "id": 38491,
      "keyword": "roll de canela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38491,
      "keyword": "roll de canela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "crema de cacahuete": [
    {
      "id": 38492,
      "keyword": "crema de cacahuete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cremas de cacahuete": [
    {
      "id": 38492,
      "keyword": "crema de cacahuete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mantequilla de cacahuete": [
    {
      "id": 38492,
      "keyword": "mantequilla de cacahuete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38492,
      "keyword": "mantequilla de cacahuete",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "merengue": [
    {
      "id": 38493,
      "keyword": "merengue",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "merengues": [
    {
      "id": 38493,
      "keyword": "merengue",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "suspiro": [
    {
      "id": 38493,
      "keyword": "suspiro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "suspiros": [
    {
      "id": 38493,
      "keyword": "suspiro",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "meringue": [
    {
      "id": 38493,
      "keyword": "meringue",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meringues": [
    {
      "id": 38493,
      "keyword": "meringue",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acai": [
    {
      "id": 38494,
      "keyword": "acai",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acais": [
    {
      "id": 38494,
      "keyword": "acai",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "azaí": [
    {
      "id": 38494,
      "keyword": "azaí",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "azaís": [
    {
      "id": 38494,
      "keyword": "azaí",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huasaí": [
    {
      "id": 38494,
      "keyword": "huasaí",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huasaís": [
    {
      "id": 38494,
      "keyword": "huasaí",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "naidí": [
    {
      "id": 38494,
      "keyword": "naidí",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "naidís": [
    {
      "id": 38494,
      "keyword": "naidí",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "glaseado de limón": [
    {
      "id": 38495,
      "keyword": "glaseado de limón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "glaseados de limón": [
    {
      "id": 38495,
      "keyword": "glaseado de limón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarta de zanahoria": [
    {
      "id": 38496,
      "keyword": "tarta de zanahoria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tartas de zanahoria": [
    {
      "id": 38496,
      "keyword": "tarta de zanahoria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chipá": [
    {
      "id": 38497,
      "keyword": "chipá",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chipás": [
    {
      "id": 38497,
      "keyword": "chipá",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chipa": [
    {
      "id": 38497,
      "keyword": "chipa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chipas": [
    {
      "id": 38497,
      "keyword": "chipa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "budin": [
    {
      "id": 38498,
      "keyword": "budin",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "budines": [
    {
      "id": 38498,
      "keyword": "budin",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pudines": [
    {
      "id": 38498,
      "keyword": "pudin",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarta de queso": [
    {
      "id": 38499,
      "keyword": "tarta de queso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tartas de queso": [
    {
      "id": 38499,
      "keyword": "tarta de queso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "harina de almendras": [
    {
      "id": 38500,
      "keyword": "harina de almendras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "galletas oreo": [
    {
      "id": 38501,
      "keyword": "galletas oreo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oreos": [
    {
      "id": 38501,
      "keyword": "oreos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bizcocho de chocolate": [
    {
      "id": 38503,
      "keyword": "bizcocho de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bizcochos de chocolate": [
    {
      "id": 38503,
      "keyword": "bizcocho de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "brownie": [
    {
      "id": 38503,
      "keyword": "brownie",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brownies": [
    {
      "id": 38503,
      "keyword": "brownie",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sándwich mixto": [
    {
      "id": 38504,
      "keyword": "sándwich mixto",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38504,
      "keyword": "sándwich mixto",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "plato para macetas": [
    {
      "id": 38505,
      "keyword": "plato para macetas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "platos para macetas": [
    {
      "id": 38505,
      "keyword": "plato para macetas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bol para perros": [
    {
      "id": 38506,
      "keyword": "bol para perros",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "pet",
        "animal nutrition"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boles para perros": [
    {
      "id": 38506,
      "keyword": "bol para perros",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "pet",
        "animal nutrition"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mosquitera": [
    {
      "id": 38507,
      "keyword": "mosquitera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mosquiteras": [
    {
      "id": 38507,
      "keyword": "mosquitera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ciberacoso": [
    {
      "id": 38509,
      "keyword": "ciberacoso",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acoso virtual": [
    {
      "id": 38509,
      "keyword": "acoso virtual",
      "keywords": 2,
      "type": 2,
      "tags": [
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pirsin": [
    {
      "id": 38510,
      "keyword": "pirsin",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38511,
      "keyword": "pirsin",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38512,
      "keyword": "pirsin",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pirsines": [
    {
      "id": 38510,
      "keyword": "pirsin",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38511,
      "keyword": "pirsin",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38512,
      "keyword": "pirsin",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "piercing": [
    {
      "id": 38510,
      "keyword": "piercing",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38511,
      "keyword": "piercing",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38512,
      "keyword": "piercing",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "piercings": [
    {
      "id": 38510,
      "keyword": "piercing",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38511,
      "keyword": "piercing",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38512,
      "keyword": "piercing",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "jewelry",
        "accessories"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "machete": [
    {
      "id": 38513,
      "keyword": "machete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "machetes": [
    {
      "id": 38513,
      "keyword": "machete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "qr": [
    {
      "id": 38514,
      "keyword": "QR",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "information document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "código qr": [
    {
      "id": 38514,
      "keyword": "código QR",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "information document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "códigos qr": [
    {
      "id": 38514,
      "keyword": "código QR",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "information document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quidditch": [
    {
      "id": 38515,
      "keyword": "quidditch",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quidditch muggle": [
    {
      "id": 38515,
      "keyword": "quidditch muggle",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tchoukball": [
    {
      "id": 38516,
      "keyword": "tchoukball",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hinduísmo": [
    {
      "id": 38517,
      "keyword": "Hinduísmo",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "hinduism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "atea": [
    {
      "id": 38518,
      "keyword": "atea",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ateas": [
    {
      "id": 38518,
      "keyword": "atea",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agnóstico": [
    {
      "id": 38518,
      "keyword": "agnóstico",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agnósticos": [
    {
      "id": 38518,
      "keyword": "agnóstico",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "agnóstica": [
    {
      "id": 38518,
      "keyword": "agnóstica",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agnósticas": [
    {
      "id": 38518,
      "keyword": "agnóstica",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "religion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botella rota": [
    {
      "id": 38521,
      "keyword": "botella rota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botellas rotas": [
    {
      "id": 38521,
      "keyword": "botella rota",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "weapon"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alfajor de almendra": [
    {
      "id": 38522,
      "keyword": "alfajor de almendra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alfajores de almendra": [
    {
      "id": 38522,
      "keyword": "alfajor de almendra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "brotes de alfalfa": [
    {
      "id": 38523,
      "keyword": "brotes de alfalfa",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "galletas de avena y pasas": [
    {
      "id": 38524,
      "keyword": "galletas de avena y pasas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alfajor de dulce de leche": [
    {
      "id": 38525,
      "keyword": "alfajor de dulce de leche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alfajores de dulce de leche": [
    {
      "id": 38525,
      "keyword": "alfajor de dulce de leche",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chía": [
    {
      "id": 38526,
      "keyword": "chía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quinoa": [
    {
      "id": 38527,
      "keyword": "quinoa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quinua": [
    {
      "id": 38527,
      "keyword": "quinua",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quínoa": [
    {
      "id": 38527,
      "keyword": "quínoa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huevos revueltos": [
    {
      "id": 38528,
      "keyword": "huevos revueltos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuadraditos de manzana": [
    {
      "id": 38529,
      "keyword": "cuadraditos de manzana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cebolla morada": [
    {
      "id": 38530,
      "keyword": "cebolla morada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cebollas moradas": [
    {
      "id": 38530,
      "keyword": "cebolla morada",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bagel": [
    {
      "id": 38531,
      "keyword": "bagel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bagels": [
    {
      "id": 38531,
      "keyword": "bagel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "atención al cliente": [
    {
      "id": 38533,
      "keyword": "atención al cliente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "communication",
        "mass media",
        "telecommunication"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38532,
      "keyword": "atención al cliente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "personal services",
        "communication",
        "mass media",
        "telecommunication"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelo rizado": [
    {
      "id": 38534,
      "keyword": "pelo rizado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38538,
      "keyword": "pelo rizado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perilla": [
    {
      "id": 38536,
      "keyword": "perilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "perillas": [
    {
      "id": 38536,
      "keyword": "perilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sardana": [
    {
      "id": 38537,
      "keyword": "sardana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "regional dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sardanas": [
    {
      "id": 38537,
      "keyword": "sardana",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "dance",
        "regional dance",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aceto": [
    {
      "id": 38539,
      "keyword": "aceto",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aceto balsámico": [
    {
      "id": 38539,
      "keyword": "aceto balsámico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vinagre de módena": [
    {
      "id": 38539,
      "keyword": "vinagre de Módena",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "vinagre balsámico": [
    {
      "id": 38539,
      "keyword": "vinagre balsámico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "condiment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsa de aseo": [
    {
      "id": 38541,
      "keyword": "bolsa de aseo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "fashion",
        "accessories",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bolsas de aseo": [
    {
      "id": 38541,
      "keyword": "bolsa de aseo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "fashion",
        "accessories",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugar al minigolf": [
    {
      "id": 38547,
      "keyword": "jugar al minigolf",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "minigolf": [
    {
      "id": 38547,
      "keyword": "minigolf",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugar a la petanca": [
    {
      "id": 38549,
      "keyword": "jugar a la petanca",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dormir en la silla": [
    {
      "id": 38550,
      "keyword": "dormir en la silla",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "usual verbs",
        "person",
        "basic needs",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cilindro para la integración sensorial": [
    {
      "id": 38551,
      "keyword": "cilindro para la integración sensorial",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cilindros para la integración sensorial": [
    {
      "id": 38551,
      "keyword": "cilindro para la integración sensorial",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cilindro de equilibrio": [
    {
      "id": 38551,
      "keyword": "cilindro de equilibrio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cilindros de equilibrio": [
    {
      "id": 38551,
      "keyword": "cilindro de equilibrio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cilindro de psicomotricidad": [
    {
      "id": 38551,
      "keyword": "cilindro de psicomotricidad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cilindros de psicomotricidad": [
    {
      "id": 38551,
      "keyword": "cilindro de psicomotricidad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cojín antiescaras": [
    {
      "id": 38552,
      "keyword": "cojín antiescaras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cojines antiescaras": [
    {
      "id": 38552,
      "keyword": "cojín antiescaras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "semicilindro para la integración sensorial": [
    {
      "id": 38553,
      "keyword": "semicilindro para la integración sensorial",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "semicilindros para la integración sensorial": [
    {
      "id": 38553,
      "keyword": "semicilindro para la integración sensorial",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "semicilindro de equilibrio": [
    {
      "id": 38553,
      "keyword": "semicilindro de equilibrio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "semicilindros de equilibrio": [
    {
      "id": 38553,
      "keyword": "semicilindro de equilibrio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "semicilindro de psicomotricidad": [
    {
      "id": 38553,
      "keyword": "semicilindro de psicomotricidad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "semicilindros de psicomotricidad": [
    {
      "id": 38553,
      "keyword": "semicilindro de psicomotricidad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "psychomotor equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gira-gira": [
    {
      "id": 38554,
      "keyword": "gira-gira",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "playground",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "seitán": [
    {
      "id": 38556,
      "keyword": "seitán",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tofu": [
    {
      "id": 38557,
      "keyword": "tofu",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mascar": [
    {
      "id": 38558,
      "keyword": "mascar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "felicidades!": [
    {
      "id": 38566,
      "keyword": "felicidades!",
      "keywords": 3,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "voltear los brazos": [
    {
      "id": 38578,
      "keyword": "voltear los brazos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "girar los brazos": [
    {
      "id": 38578,
      "keyword": "girar los brazos",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "music",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "papel reciclado": [
    {
      "id": 38580,
      "keyword": "papel reciclado",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "teaching activity",
        "educational material",
        "work",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reciclado de papel": [
    {
      "id": 38580,
      "keyword": "reciclado de papel",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "teaching activity",
        "educational material",
        "work",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer papel reciclado": [
    {
      "id": 38580,
      "keyword": "hacer papel reciclado",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "teaching activity",
        "educational material",
        "work",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer papel": [
    {
      "id": 38580,
      "keyword": "hacer papel",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "teaching activity",
        "educational material",
        "work",
        "secondary sector",
        "craftsmanship"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colegio de psicólogos": [
    {
      "id": 38583,
      "keyword": "colegio de psicólogos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "psychology",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colegio profesional de psicología": [
    {
      "id": 38583,
      "keyword": "colegio profesional de psicología",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "group",
        "psychology",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer la maleta": [
    {
      "id": 38584,
      "keyword": "hacer la maleta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "clothes",
        "work",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pedanía": [
    {
      "id": 38586,
      "keyword": "pedanía",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pedanías": [
    {
      "id": 38586,
      "keyword": "pedanía",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aldea": [
    {
      "id": 38586,
      "keyword": "aldea",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aldeas": [
    {
      "id": 38586,
      "keyword": "aldea",
      "keywords": 5,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paquete de lentejas": [
    {
      "id": 38593,
      "keyword": "paquete de lentejas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paquete de garbanzos": [
    {
      "id": 38594,
      "keyword": "paquete de garbanzos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paquetes de garbanzos": [
    {
      "id": 38594,
      "keyword": "paquete de garbanzos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paquete de judías": [
    {
      "id": 38595,
      "keyword": "paquete de judías",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paquetes de judías": [
    {
      "id": 38595,
      "keyword": "paquete de judías",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ateísmo": [
    {
      "id": 38598,
      "keyword": "ateísmo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ateísmos": [
    {
      "id": 38598,
      "keyword": "ateísmo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "dharma chakra": [
    {
      "id": 38599,
      "keyword": "dharma chakra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "buddhism",
        "hinduism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rueda del darma": [
    {
      "id": 38599,
      "keyword": "rueda del darma",
      "keywords": 2,
      "type": 2,
      "tags": [
        "religion",
        "buddhism",
        "hinduism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botella de metal": [
    {
      "id": 38604,
      "keyword": "botella de metal",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "container",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botellas de metal": [
    {
      "id": 38604,
      "keyword": "botella de metal",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "container",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botella metálica": [
    {
      "id": 38604,
      "keyword": "botella metálica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "container",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botellas metálicas": [
    {
      "id": 38604,
      "keyword": "botella metálica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "container",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botella de agua metálica": [
    {
      "id": 38604,
      "keyword": "botella de agua metálica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "container",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botellas de agua metálicas": [
    {
      "id": 38604,
      "keyword": "botella de agua metálica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "container",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "intacto": [
    {
      "id": 38605,
      "keyword": "intacto",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intactos": [
    {
      "id": 38605,
      "keyword": "intacto",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "intacta": [
    {
      "id": 38605,
      "keyword": "intacta",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intactas": [
    {
      "id": 38605,
      "keyword": "intacta",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inalterado": [
    {
      "id": 38605,
      "keyword": "inalterado",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inalterados": [
    {
      "id": 38605,
      "keyword": "inalterado",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inalterada": [
    {
      "id": 38605,
      "keyword": "inalterada",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inalteradas": [
    {
      "id": 38605,
      "keyword": "inalterada",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "indemne": [
    {
      "id": 38605,
      "keyword": "indemne",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "indemnes": [
    {
      "id": 38605,
      "keyword": "indemne",
      "keywords": 5,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tratamiento": [
    {
      "id": 38606,
      "keyword": "tratamiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tratamientos": [
    {
      "id": 38606,
      "keyword": "tratamiento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contenedor higiénico": [
    {
      "id": 38609,
      "keyword": "contenedor higiénico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "education",
        "educational equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contenedores higiénicos": [
    {
      "id": 38609,
      "keyword": "contenedor higiénico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "education",
        "educational equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contenedor de compresas": [
    {
      "id": 38609,
      "keyword": "contenedor de compresas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "education",
        "educational equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contenedores de compresas": [
    {
      "id": 38609,
      "keyword": "contenedor de compresas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "building facility",
        "education",
        "educational equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coger un libro": [
    {
      "id": 38610,
      "keyword": "coger un libro",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "library science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lavar el pie": [
    {
      "id": 38611,
      "keyword": "lavar el pie",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mochila pulverizadora": [
    {
      "id": 38612,
      "keyword": "mochila pulverizadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mochilas pulverizadoras": [
    {
      "id": 38612,
      "keyword": "mochila pulverizadora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fumigador": [
    {
      "id": 38612,
      "keyword": "fumigador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fumigadores": [
    {
      "id": 38612,
      "keyword": "fumigador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "frankfurtería": [
    {
      "id": 38618,
      "keyword": "frankfurtería",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frankfurterías": [
    {
      "id": 38618,
      "keyword": "frankfurtería",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hot dogs": [
    {
      "id": 38618,
      "keyword": "hot dogs",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centro de fisioterapia": [
    {
      "id": 38619,
      "keyword": "centro de fisioterapia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros de fisioterapia": [
    {
      "id": 38619,
      "keyword": "centro de fisioterapia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro fisioterapéutico": [
    {
      "id": 38619,
      "keyword": "centro fisioterapéutico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros fisioterapéuticos": [
    {
      "id": 38619,
      "keyword": "centro fisioterapéutico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "physiotherapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "academia de idiomas": [
    {
      "id": 38620,
      "keyword": "academia de idiomas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "academias de idiomas": [
    {
      "id": 38620,
      "keyword": "academia de idiomas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "education",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acurrucar": [
    {
      "id": 38621,
      "keyword": "acurrucar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "human body",
        "position"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "envoltorio": [
    {
      "id": 38622,
      "keyword": "envoltorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "envoltorios": [
    {
      "id": 38622,
      "keyword": "envoltorio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "decorative item",
        "event",
        "social event",
        "birthday",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clínica veterinaria": [
    {
      "id": 38623,
      "keyword": "clínica veterinaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "veterinary medicine",
        "place",
        "building",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clínicas veterinarias": [
    {
      "id": 38623,
      "keyword": "clínica veterinaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "veterinary medicine",
        "place",
        "building",
        "medicine",
        "medical center",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cyclamen": [
    {
      "id": 38624,
      "keyword": "cyclamen",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cyclámenes": [
    {
      "id": 38624,
      "keyword": "cyclamen",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ciclamen": [
    {
      "id": 38624,
      "keyword": "ciclamen",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciclámenes": [
    {
      "id": 38624,
      "keyword": "ciclamen",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "artánita": [
    {
      "id": 38624,
      "keyword": "artánita",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "artánitas": [
    {
      "id": 38624,
      "keyword": "artánita",
      "keywords": 3,
      "type": 2,
      "tags": [
        "plant",
        "flower"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jumping jacks": [
    {
      "id": 38628,
      "keyword": "jumping jacks",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38629,
      "keyword": "jumping jacks",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38632,
      "keyword": "jumping jacks",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brazos abajo": [
    {
      "id": 38628,
      "keyword": "brazos abajo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir los brazos": [
    {
      "id": 38629,
      "keyword": "subir los brazos",
      "keywords": 4,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar el audífono": [
    {
      "id": 38630,
      "keyword": "quitar el audífono",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contar un cuento": [
    {
      "id": 38631,
      "keyword": "contar un cuento",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "narrar una historia": [
    {
      "id": 38631,
      "keyword": "narrar una historia",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brazos pegados al cuerpo": [
    {
      "id": 38632,
      "keyword": "brazos pegados al cuerpo",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "posición inicial": [
    {
      "id": 38632,
      "keyword": "posición inicial",
      "keywords": 4,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mediateca": [
    {
      "id": 38633,
      "keyword": "mediateca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mediatecas": [
    {
      "id": 38633,
      "keyword": "mediateca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "library science",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "anaconda amarilla": [
    {
      "id": 38634,
      "keyword": "anaconda amarilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "ovoviviparous",
        "terrestrial animal",
        "aquatic animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "anacondas amarillas": [
    {
      "id": 38634,
      "keyword": "anaconda amarilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "ovoviviparous",
        "terrestrial animal",
        "aquatic animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "curiyú": [
    {
      "id": 38634,
      "keyword": "curiyú",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "ovoviviparous",
        "terrestrial animal",
        "aquatic animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "curiyús": [
    {
      "id": 38634,
      "keyword": "curiyú",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "reptile",
        "oviparous",
        "ovoviviparous",
        "terrestrial animal",
        "aquatic animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mantis orquídea": [
    {
      "id": 38635,
      "keyword": "mantis orquídea",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "insect",
        "oviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cangrejo ermitaño": [
    {
      "id": 38636,
      "keyword": "cangrejo ermitaño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cangrejos ermitaños": [
    {
      "id": 38636,
      "keyword": "cangrejo ermitaño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ermitaño": [
    {
      "id": 38636,
      "keyword": "ermitaño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ermitaños": [
    {
      "id": 38636,
      "keyword": "ermitaño",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "invertebrate",
        "arthropod",
        "crustacean",
        "oviparous",
        "aquatic animal",
        "marine animal",
        "sea",
        "terrestrial animal"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "morder las uñas": [
    {
      "id": 38639,
      "keyword": "morder las uñas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "onicofagia": [
    {
      "id": 38639,
      "keyword": "onicofagia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "líder": [
    {
      "id": 38642,
      "keyword": "líder",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "líderes": [
    {
      "id": 38642,
      "keyword": "líder",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "liderar": [
    {
      "id": 38642,
      "keyword": "liderar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "homofobia": [
    {
      "id": 38643,
      "keyword": "homofobia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38644,
      "keyword": "homofobia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juguete de cuerda": [
    {
      "id": 38645,
      "keyword": "juguete de cuerda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juguetes de cuerda": [
    {
      "id": 38645,
      "keyword": "juguete de cuerda",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ciudad amurallada": [
    {
      "id": 38646,
      "keyword": "ciudad amurallada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "middle ages"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ciudades amuralladas": [
    {
      "id": 38646,
      "keyword": "ciudad amurallada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "middle ages"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pueblo amurallado": [
    {
      "id": 38646,
      "keyword": "pueblo amurallado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "middle ages"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pueblos amurallados": [
    {
      "id": 38646,
      "keyword": "pueblo amurallado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "monument",
        "history",
        "middle ages"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de audiovisuales": [
    {
      "id": 38647,
      "keyword": "sala de audiovisuales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de audiovisuales": [
    {
      "id": 38647,
      "keyword": "sala de audiovisuales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de proyecciones": [
    {
      "id": 38647,
      "keyword": "sala de proyecciones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de proyecciones": [
    {
      "id": 38647,
      "keyword": "sala de proyecciones",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "torre octogonal": [
    {
      "id": 38648,
      "keyword": "torre octogonal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torres octogonales": [
    {
      "id": 38648,
      "keyword": "torre octogonal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "galleta de jenjibre": [
    {
      "id": 38649,
      "keyword": "galleta de jenjibre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "galletas de jenjibre": [
    {
      "id": 38649,
      "keyword": "galleta de jenjibre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vivienda almohade": [
    {
      "id": 38650,
      "keyword": "vivienda almohade",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "history",
        "ancient history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viviendas almohades": [
    {
      "id": 38650,
      "keyword": "vivienda almohade",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "history",
        "ancient history"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vivienda árabe": [
    {
      "id": 38650,
      "keyword": "vivienda árabe",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "history",
        "ancient history"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viviendas árabes": [
    {
      "id": 38650,
      "keyword": "vivienda árabe",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "history",
        "ancient history"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alcazaba de badajoz": [
    {
      "id": 38651,
      "keyword": "Alcazaba de Badajoz",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "restaurar": [
    {
      "id": 38652,
      "keyword": "restaurar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "restauración": [
    {
      "id": 38652,
      "keyword": "restauración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "restauraciones": [
    {
      "id": 38652,
      "keyword": "restauración",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "history",
        "archaeology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "palacio árabe": [
    {
      "id": 38653,
      "keyword": "palacio árabe",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palacios árabes": [
    {
      "id": 38653,
      "keyword": "palacio árabe",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aljibe": [
    {
      "id": 38654,
      "keyword": "aljibe",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aljibes": [
    {
      "id": 38654,
      "keyword": "aljibe",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cisterna": [
    {
      "id": 38654,
      "keyword": "cisterna",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cisternas": [
    {
      "id": 38654,
      "keyword": "cisterna",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "place",
        "room"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alberca": [
    {
      "id": 38655,
      "keyword": "alberca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "albercas": [
    {
      "id": 38655,
      "keyword": "alberca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "junta de portavoces": [
    {
      "id": 38656,
      "keyword": "junta de portavoces",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "juntas de portavoces": [
    {
      "id": 38656,
      "keyword": "junta de portavoces",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diputación permanente": [
    {
      "id": 38657,
      "keyword": "diputación permanente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diputaciones permanentes": [
    {
      "id": 38657,
      "keyword": "diputación permanente",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "albergue municipal": [
    {
      "id": 38658,
      "keyword": "albergue municipal",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "albergues municipales": [
    {
      "id": 38658,
      "keyword": "albergue municipal",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "albergue para indigentes": [
    {
      "id": 38658,
      "keyword": "albergue para indigentes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "albergues para indigentes": [
    {
      "id": 38658,
      "keyword": "albergue para indigentes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "movimiento vecinal": [
    {
      "id": 38660,
      "keyword": "movimiento vecinal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sociology",
        "social movement",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "movimientos vecinales": [
    {
      "id": 38660,
      "keyword": "movimiento vecinal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "sociology",
        "social movement",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sordociego": [
    {
      "id": 38664,
      "keyword": "sordociego",
      "keywords": 3,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sordociegos": [
    {
      "id": 38664,
      "keyword": "sordociego",
      "keywords": 3,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sordociega": [
    {
      "id": 38664,
      "keyword": "sordociega",
      "keywords": 3,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sordociegas": [
    {
      "id": 38664,
      "keyword": "sordociega",
      "keywords": 3,
      "type": 4,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sordoceguera": [
    {
      "id": 38664,
      "keyword": "sordoceguera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "special education"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apartamento turístico": [
    {
      "id": 38665,
      "keyword": "apartamento turístico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apartamentos turísticos": [
    {
      "id": 38665,
      "keyword": "apartamento turístico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "work",
        "tertiary sector",
        "hospitality industry",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alma": [
    {
      "id": 38666,
      "keyword": "alma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human value",
        "religion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almas": [
    {
      "id": 38666,
      "keyword": "alma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "psychology",
        "human value",
        "religion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de profesoras": [
    {
      "id": 38667,
      "keyword": "sala de profesoras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational space",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equipo de densitometría": [
    {
      "id": 38668,
      "keyword": "equipo de densitometría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equipos de densitometría": [
    {
      "id": 38668,
      "keyword": "equipo de densitometría",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escáner de densidad ósea": [
    {
      "id": 38668,
      "keyword": "escáner de densidad ósea",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escáneres de densidad ósea": [
    {
      "id": 38668,
      "keyword": "escáner de densidad ósea",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escáner dexa": [
    {
      "id": 38668,
      "keyword": "escáner DEXA",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escáneres dexa": [
    {
      "id": 38668,
      "keyword": "escáner DEXA",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "densitometría ósea": [
    {
      "id": 38669,
      "keyword": "densitometría ósea",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer una densitometría": [
    {
      "id": 38669,
      "keyword": "hacer una densitometría",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "realizar una densitometría": [
    {
      "id": 38669,
      "keyword": "realizar una densitometría",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "envasadora": [
    {
      "id": 38671,
      "keyword": "envasadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "envasadora de fruta": [
    {
      "id": 38671,
      "keyword": "envasadora de fruta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "agriculture",
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "facilitador de la comunicación en justicia": [
    {
      "id": 38672,
      "keyword": "facilitador de la comunicación en justicia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "law",
        "justice",
        "speech therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "facilitadores de la comunicación en justicia": [
    {
      "id": 38672,
      "keyword": "facilitador de la comunicación en justicia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "law",
        "justice",
        "speech therapy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pepito de lomo": [
    {
      "id": 38673,
      "keyword": "pepito de lomo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pepitos de lomo": [
    {
      "id": 38673,
      "keyword": "pepito de lomo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bocadillo de lomo": [
    {
      "id": 38673,
      "keyword": "bocadillo de lomo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bocadillos de lomo": [
    {
      "id": 38673,
      "keyword": "bocadillo de lomo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fajita": [
    {
      "id": 38674,
      "keyword": "fajita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fajitas": [
    {
      "id": 38674,
      "keyword": "fajita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "puerta modernista": [
    {
      "id": 38675,
      "keyword": "puerta modernista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "history",
        "early modern period",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puertas modernistas": [
    {
      "id": 38675,
      "keyword": "puerta modernista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "history",
        "early modern period",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "modernismo": [
    {
      "id": 38675,
      "keyword": "modernismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "history",
        "early modern period",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38676,
      "keyword": "modernismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "history",
        "early modern period",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38680,
      "keyword": "modernismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "history",
        "early modern period",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38682,
      "keyword": "modernismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "history",
        "early modern period"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38684,
      "keyword": "modernismo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "architecture",
        "history",
        "early modern period"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balcón modernista": [
    {
      "id": 38676,
      "keyword": "balcón modernista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "history",
        "early modern period",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "balcones modernistas": [
    {
      "id": 38676,
      "keyword": "balcón modernista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "history",
        "early modern period",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "extender": [
    {
      "id": 38678,
      "keyword": "extender",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presentador": [
    {
      "id": 38679,
      "keyword": "presentador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38683,
      "keyword": "presentador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presentadores": [
    {
      "id": 38679,
      "keyword": "presentador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38683,
      "keyword": "presentador",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "presentadora": [
    {
      "id": 38679,
      "keyword": "presentadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38681,
      "keyword": "presentadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presentadoras": [
    {
      "id": 38679,
      "keyword": "presentadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38681,
      "keyword": "presentadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "leisure",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mirador modernista": [
    {
      "id": 38680,
      "keyword": "mirador modernista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "history",
        "early modern period",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "miradores modernistas": [
    {
      "id": 38680,
      "keyword": "mirador modernista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "history",
        "early modern period",
        "place",
        "building facility"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "columna modernista": [
    {
      "id": 38682,
      "keyword": "columna modernista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "history",
        "early modern period"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "columnas modernistas": [
    {
      "id": 38682,
      "keyword": "columna modernista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "history",
        "early modern period"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "edificio modernista": [
    {
      "id": 38684,
      "keyword": "edificio modernista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home",
        "architecture",
        "history",
        "early modern period"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cariátide": [
    {
      "id": 38685,
      "keyword": "cariátide",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cariátides": [
    {
      "id": 38685,
      "keyword": "cariátide",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "la ratita presumida": [
    {
      "id": 38686,
      "keyword": "La Ratita Presumida",
      "keywords": 1,
      "type": 1,
      "tags": [
        "character",
        "book character",
        "tale character",
        "literature"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "psicomotricista": [
    {
      "id": 38687,
      "keyword": "psicomotricista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38688,
      "keyword": "psicomotricista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "psicomotricistas": [
    {
      "id": 38687,
      "keyword": "psicomotricista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38688,
      "keyword": "psicomotricista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "levadura fresca": [
    {
      "id": 38689,
      "keyword": "levadura fresca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "levaduras frescas": [
    {
      "id": 38689,
      "keyword": "levadura fresca",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fermentar": [
    {
      "id": 38690,
      "keyword": "fermentar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "croma": [
    {
      "id": 38691,
      "keyword": "croma",
      "keywords": 3,
      "type": 2,
      "tags": [
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cromas": [
    {
      "id": 38691,
      "keyword": "croma",
      "keywords": 3,
      "type": 2,
      "tags": [
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "croma verde": [
    {
      "id": 38691,
      "keyword": "croma verde",
      "keywords": 3,
      "type": 2,
      "tags": [
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cromas verdes": [
    {
      "id": 38691,
      "keyword": "croma verde",
      "keywords": 3,
      "type": 2,
      "tags": [
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pantalla de croma": [
    {
      "id": 38691,
      "keyword": "pantalla de croma",
      "keywords": 3,
      "type": 2,
      "tags": [
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pantallas de croma": [
    {
      "id": 38691,
      "keyword": "pantalla de croma",
      "keywords": 3,
      "type": 2,
      "tags": [
        "visual art",
        "photography"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rejilla para enfriar": [
    {
      "id": 38692,
      "keyword": "rejilla para enfriar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rejillas para enfriar": [
    {
      "id": 38692,
      "keyword": "rejilla para enfriar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerrar la mochila": [
    {
      "id": 38695,
      "keyword": "cerrar la mochila",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chaqueta de cocinero": [
    {
      "id": 38696,
      "keyword": "chaqueta de cocinero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chaquetas de cocinero": [
    {
      "id": 38696,
      "keyword": "chaqueta de cocinero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gorro de pastelero": [
    {
      "id": 38697,
      "keyword": "gorro de pastelero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gorros de pastelero": [
    {
      "id": 38697,
      "keyword": "gorro de pastelero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "clothes",
        "workwear"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trozo de pizza": [
    {
      "id": 38699,
      "keyword": "trozo de pizza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trozos de pizza": [
    {
      "id": 38699,
      "keyword": "trozo de pizza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "porción de pizza": [
    {
      "id": 38699,
      "keyword": "porción de pizza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "porciones de pizza": [
    {
      "id": 38699,
      "keyword": "porción de pizza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abrir la mochila": [
    {
      "id": 38700,
      "keyword": "abrir la mochila",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lengua de gato": [
    {
      "id": 38701,
      "keyword": "lengua de gato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lenguas de gato": [
    {
      "id": 38701,
      "keyword": "lengua de gato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tumbar en la mesa": [
    {
      "id": 38702,
      "keyword": "tumbar en la mesa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tamizar": [
    {
      "id": 38703,
      "keyword": "tamizar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rock": [
    {
      "id": 38704,
      "keyword": "rock",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rock and roll": [
    {
      "id": 38704,
      "keyword": "rock and roll",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desmoldar": [
    {
      "id": 38705,
      "keyword": "desmoldar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "cookery",
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sentar en la mesa": [
    {
      "id": 38706,
      "keyword": "sentar en la mesa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "meter al frigorífico": [
    {
      "id": 38708,
      "keyword": "meter al frigorífico",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "refrigerar": [
    {
      "id": 38708,
      "keyword": "refrigerar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "llevar en brazos": [
    {
      "id": 38713,
      "keyword": "llevar en brazos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38717,
      "keyword": "llevar en brazos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caminar con cuerda": [
    {
      "id": 38714,
      "keyword": "caminar con cuerda",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "frenar": [
    {
      "id": 38715,
      "keyword": "frenar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bastones de esquí": [
    {
      "id": 38716,
      "keyword": "bastones de esquí",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contenedor de ropa": [
    {
      "id": 38719,
      "keyword": "contenedor de ropa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contenedores de ropa": [
    {
      "id": 38719,
      "keyword": "contenedor de ropa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contenedor de ropa usada": [
    {
      "id": 38719,
      "keyword": "contenedor de ropa usada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contenedores de ropa usada": [
    {
      "id": 38719,
      "keyword": "contenedor de ropa usada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "environmental science",
        "recycling",
        "urban area",
        "street furniture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esquí nórdico adaptado": [
    {
      "id": 38720,
      "keyword": "esquí nórdico adaptado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "adapted sport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brócoli con patatas": [
    {
      "id": 38721,
      "keyword": "brócoli con patatas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pan integral": [
    {
      "id": 38723,
      "keyword": "pan integral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panes integrales": [
    {
      "id": 38723,
      "keyword": "pan integral",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lavar a mano": [
    {
      "id": 38726,
      "keyword": "lavar a mano",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viaducto": [
    {
      "id": 38727,
      "keyword": "viaducto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viaductos": [
    {
      "id": 38727,
      "keyword": "viaducto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colina": [
    {
      "id": 38728,
      "keyword": "colina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "place",
        "rural area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "calvario": [
    {
      "id": 38730,
      "keyword": "Calvario",
      "keywords": 2,
      "type": 1,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monte calvario": [
    {
      "id": 38730,
      "keyword": "Monte Calvario",
      "keywords": 2,
      "type": 1,
      "tags": [
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cetrería": [
    {
      "id": 38731,
      "keyword": "cetrería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "hunting"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hogaza": [
    {
      "id": 38733,
      "keyword": "hogaza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hogazas": [
    {
      "id": 38733,
      "keyword": "hogaza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pan de hogaza": [
    {
      "id": 38733,
      "keyword": "pan de hogaza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "panes de hogaza": [
    {
      "id": 38733,
      "keyword": "pan de hogaza",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quebradizo": [
    {
      "id": 38734,
      "keyword": "quebradizo",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quebradizos": [
    {
      "id": 38734,
      "keyword": "quebradizo",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quebradiza": [
    {
      "id": 38734,
      "keyword": "quebradiza",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quebradizas": [
    {
      "id": 38734,
      "keyword": "quebradiza",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desmenuzable": [
    {
      "id": 38734,
      "keyword": "desmenuzable",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "endeble": [
    {
      "id": 38734,
      "keyword": "endeble",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "endebles": [
    {
      "id": 38734,
      "keyword": "endeble",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rompible": [
    {
      "id": 38734,
      "keyword": "rompible",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rompibles": [
    {
      "id": 38734,
      "keyword": "rompible",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "marioneta de dedo": [
    {
      "id": 38735,
      "keyword": "marioneta de dedo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marionetas de dedo": [
    {
      "id": 38735,
      "keyword": "marioneta de dedo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "moto de agua": [
    {
      "id": 38736,
      "keyword": "moto de agua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "motos de agua": [
    {
      "id": 38736,
      "keyword": "moto de agua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "water transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "protector labial": [
    {
      "id": 38737,
      "keyword": "protector labial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "protectores labiales": [
    {
      "id": 38737,
      "keyword": "protector labial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "fashion",
        "cosmetic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "natilla de chocolate": [
    {
      "id": 38738,
      "keyword": "natilla de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "natillas de chocolate": [
    {
      "id": 38738,
      "keyword": "natilla de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pudin de chocolate": [
    {
      "id": 38738,
      "keyword": "pudin de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pudins de chocolate": [
    {
      "id": 38738,
      "keyword": "pudin de chocolate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "spätzle": [
    {
      "id": 38742,
      "keyword": "Spätzle",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comida fría": [
    {
      "id": 38743,
      "keyword": "comida fría",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comidas frías": [
    {
      "id": 38743,
      "keyword": "comida fría",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plato frío": [
    {
      "id": 38743,
      "keyword": "plato frío",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "platos fríos": [
    {
      "id": 38743,
      "keyword": "plato frío",
      "keywords": 2,
      "type": 4,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "comida caliente": [
    {
      "id": 38744,
      "keyword": "comida caliente",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "comidas calientes": [
    {
      "id": 38744,
      "keyword": "comida caliente",
      "keywords": 1,
      "type": 4,
      "tags": [
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tetina": [
    {
      "id": 38745,
      "keyword": "tetina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "babycare"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tetinas": [
    {
      "id": 38745,
      "keyword": "tetina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "babycare"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "punzante": [
    {
      "id": 38746,
      "keyword": "punzante",
      "keywords": 2,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "medical procedure",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "punzantes": [
    {
      "id": 38746,
      "keyword": "punzante",
      "keywords": 2,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "medical procedure",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "klöße": [
    {
      "id": 38747,
      "keyword": "Klöße",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "knödel": [
    {
      "id": 38747,
      "keyword": "Knödel",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dar crema en la herida": [
    {
      "id": 38748,
      "keyword": "dar crema en la herida",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terapia intravenosa": [
    {
      "id": 38749,
      "keyword": "terapia intravenosa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terapia i.v.": [
    {
      "id": 38749,
      "keyword": "terapia I.V.",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gasometría": [
    {
      "id": 38751,
      "keyword": "gasometría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gasometrías": [
    {
      "id": 38751,
      "keyword": "gasometría",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conmutar": [
    {
      "id": 38753,
      "keyword": "conmutar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alternar": [
    {
      "id": 38753,
      "keyword": "alternar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botón abajo": [
    {
      "id": 38754,
      "keyword": "botón abajo",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botón arriba": [
    {
      "id": 38755,
      "keyword": "botón arriba",
      "keywords": 1,
      "type": 6,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuidador de animales": [
    {
      "id": 38756,
      "keyword": "cuidador de animales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "veterinary medicine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuidadores de animales": [
    {
      "id": 38756,
      "keyword": "cuidador de animales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "veterinary medicine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuidador de zoo": [
    {
      "id": 38756,
      "keyword": "cuidador de zoo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "veterinary medicine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuidadores de zoo": [
    {
      "id": 38756,
      "keyword": "cuidador de zoo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "veterinary medicine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuidadora de animales": [
    {
      "id": 38757,
      "keyword": "cuidadora de animales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "veterinary medicine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuidadoras de animales": [
    {
      "id": 38757,
      "keyword": "cuidadora de animales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "veterinary medicine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cuidadora de zoo": [
    {
      "id": 38757,
      "keyword": "cuidadora de zoo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "veterinary medicine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuidadoras de zoo": [
    {
      "id": 38757,
      "keyword": "cuidadora de zoo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "veterinary medicine"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guía turístico": [
    {
      "id": 38758,
      "keyword": "guía turístico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guías turísticos": [
    {
      "id": 38758,
      "keyword": "guía turístico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "tourism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diseñador de moda": [
    {
      "id": 38759,
      "keyword": "diseñador de moda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "object",
        "fashion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diseñadores de moda": [
    {
      "id": 38759,
      "keyword": "diseñador de moda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "object",
        "fashion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "diseñadora de moda": [
    {
      "id": 38759,
      "keyword": "diseñadora de moda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "object",
        "fashion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "diseñadoras de moda": [
    {
      "id": 38759,
      "keyword": "diseñadora de moda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "object",
        "fashion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "fénix": [
    {
      "id": 38764,
      "keyword": "fénix",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ave fénix": [
    {
      "id": 38764,
      "keyword": "ave fénix",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aves fénix": [
    {
      "id": 38764,
      "keyword": "ave fénix",
      "keywords": 2,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centauro": [
    {
      "id": 38765,
      "keyword": "centauro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centauros": [
    {
      "id": 38765,
      "keyword": "centauro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "character",
        "mythological character",
        "mythology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de plantas": [
    {
      "id": 38767,
      "keyword": "tienda de plantas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "plant",
        "hervaceouos plant",
        "aromatic plant",
        "flower",
        "bush",
        "cactus"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de plantas": [
    {
      "id": 38767,
      "keyword": "tienda de plantas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "plant",
        "hervaceouos plant",
        "aromatic plant",
        "flower",
        "bush",
        "cactus"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "vivero": [
    {
      "id": 38767,
      "keyword": "vivero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "plant",
        "hervaceouos plant",
        "aromatic plant",
        "flower",
        "bush",
        "cactus"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "viveros": [
    {
      "id": 38767,
      "keyword": "vivero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "plant",
        "hervaceouos plant",
        "aromatic plant",
        "flower",
        "bush",
        "cactus"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chocar contra algo": [
    {
      "id": 38768,
      "keyword": "chocar contra algo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "work accident"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "golpear contra algo": [
    {
      "id": 38768,
      "keyword": "golpear contra algo",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "work accident"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "radicchio": [
    {
      "id": 38769,
      "keyword": "radicchio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "radicchios": [
    {
      "id": 38769,
      "keyword": "radicchio",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "achicoria roja": [
    {
      "id": 38769,
      "keyword": "achicoria roja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "achicorias rojas": [
    {
      "id": 38769,
      "keyword": "achicoria roja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alcoholímetro": [
    {
      "id": 38771,
      "keyword": "alcoholímetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alcoholímetros": [
    {
      "id": 38771,
      "keyword": "alcoholímetro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "realizar control de alcoholemia": [
    {
      "id": 38772,
      "keyword": "realizar control de alcoholemia",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "control de alcoholemia": [
    {
      "id": 38772,
      "keyword": "control de alcoholemia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "controles de alcoholemia": [
    {
      "id": 38772,
      "keyword": "control de alcoholemia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "prueba de alcoholemia": [
    {
      "id": 38772,
      "keyword": "prueba de alcoholemia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pruebas de alcoholemia": [
    {
      "id": 38772,
      "keyword": "prueba de alcoholemia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "road safety",
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarallo": [
    {
      "id": 38775,
      "keyword": "tarallo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarallos": [
    {
      "id": 38775,
      "keyword": "tarallo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tarallino": [
    {
      "id": 38775,
      "keyword": "tarallino",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tarallinos": [
    {
      "id": 38775,
      "keyword": "tarallino",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guardia civil de tráfico": [
    {
      "id": 38776,
      "keyword": "guardia civil de tráfico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guardias civiles de tráfico": [
    {
      "id": 38776,
      "keyword": "guardia civil de tráfico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "flauta de émbolo": [
    {
      "id": 38779,
      "keyword": "flauta de émbolo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flautas de émbolo": [
    {
      "id": 38779,
      "keyword": "flauta de émbolo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "validar tarjeta": [
    {
      "id": 38781,
      "keyword": "validar tarjeta",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bañar con manguitos": [
    {
      "id": 38782,
      "keyword": "bañar con manguitos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "outdoor activity",
        "swimming pool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "agradecer": [
    {
      "id": 38783,
      "keyword": "agradecer",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human value"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "banjo": [
    {
      "id": 38784,
      "keyword": "banjo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "banjos": [
    {
      "id": 38784,
      "keyword": "banjo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "banyo": [
    {
      "id": 38784,
      "keyword": "banyo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "banyos": [
    {
      "id": 38784,
      "keyword": "banyo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "string instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "flauta de pan": [
    {
      "id": 38785,
      "keyword": "flauta de pan",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flautas de pan": [
    {
      "id": 38785,
      "keyword": "flauta de pan",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ocarina": [
    {
      "id": 38786,
      "keyword": "ocarina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ocarinas": [
    {
      "id": 38786,
      "keyword": "ocarina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "wind instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "llamar al 016": [
    {
      "id": 38787,
      "keyword": "llamar al 016",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "appliance",
        "mass media device",
        "mass media",
        "work",
        "tertiary sector",
        "defense",
        "security"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aparcamiento para personas con movilidad reducida": [
    {
      "id": 38790,
      "keyword": "aparcamiento para personas con movilidad reducida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aparcamientos para persona": [
    {
      "id": 38790,
      "keyword": "aparcamiento para personas con movilidad reducida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plaza para personas con movilidad reducida": [
    {
      "id": 38790,
      "keyword": "plaza para personas con movilidad reducida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plazas para personas con movilidad reducida": [
    {
      "id": 38790,
      "keyword": "plaza para personas con movilidad reducida",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reír a carcajadas": [
    {
      "id": 38792,
      "keyword": "reír a carcajadas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carcajada": [
    {
      "id": 38792,
      "keyword": "carcajada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carcajadas": [
    {
      "id": 38792,
      "keyword": "carcajada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pilates": [
    {
      "id": 38793,
      "keyword": "pilates",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carnicería halal": [
    {
      "id": 38794,
      "keyword": "carnicería halal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "meat",
        "religion",
        "islamism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carnicerías halal": [
    {
      "id": 38794,
      "keyword": "carnicería halal",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "feeding",
        "food",
        "animal-based food",
        "meat",
        "religion",
        "islamism"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manzanilla": [
    {
      "id": 38795,
      "keyword": "manzanilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "24h": [
    {
      "id": 38797,
      "keyword": "24h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "24 horas": [
    {
      "id": 38797,
      "keyword": "24 horas",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "24 horas al día": [
    {
      "id": 38797,
      "keyword": "24 horas al día",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "quitar sensor de glucosa": [
    {
      "id": 38800,
      "keyword": "quitar sensor de glucosa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empachado": [
    {
      "id": 38801,
      "keyword": "empachado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empachados": [
    {
      "id": 38801,
      "keyword": "empachado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "satisfecho": [
    {
      "id": 38801,
      "keyword": "satisfecho",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "satisfechos": [
    {
      "id": 38801,
      "keyword": "satisfecho",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saciado": [
    {
      "id": 38801,
      "keyword": "saciado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saciados": [
    {
      "id": 38801,
      "keyword": "saciado",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "empachada": [
    {
      "id": 38801,
      "keyword": "empachada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "empachadas": [
    {
      "id": 38801,
      "keyword": "empachada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "satisfecha": [
    {
      "id": 38801,
      "keyword": "satisfecha",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "satisfechas": [
    {
      "id": 38801,
      "keyword": "satisfecha",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saciada": [
    {
      "id": 38801,
      "keyword": "saciada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saciadas": [
    {
      "id": 38801,
      "keyword": "saciada",
      "keywords": 6,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "poner sensor de glucosa": [
    {
      "id": 38802,
      "keyword": "poner sensor de glucosa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38803,
      "keyword": "poner sensor de glucosa",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medir la glucosa en sangre": [
    {
      "id": 38804,
      "keyword": "medir la glucosa en sangre",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "monitorizar la glucosa en sangre": [
    {
      "id": 38804,
      "keyword": "monitorizar la glucosa en sangre",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chequear la glucosa en sangre": [
    {
      "id": 38804,
      "keyword": "chequear la glucosa en sangre",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campo de frutales": [
    {
      "id": 38806,
      "keyword": "campo de frutales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "campos de frutales": [
    {
      "id": 38806,
      "keyword": "campo de frutales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plantación de frutales": [
    {
      "id": 38806,
      "keyword": "plantación de frutales",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pizzero": [
    {
      "id": 38807,
      "keyword": "pizzero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pizzeros": [
    {
      "id": 38807,
      "keyword": "pizzero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "repartidor de pizza": [
    {
      "id": 38808,
      "keyword": "repartidor de pizza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "repartidores de pizzas": [
    {
      "id": 38808,
      "keyword": "repartidor de pizza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "actor de doblaje": [
    {
      "id": 38810,
      "keyword": "actor de doblaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "scenic art",
        "visual art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "actores de doblaje": [
    {
      "id": 38810,
      "keyword": "actor de doblaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "scenic art",
        "visual art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "actriz de doblaje": [
    {
      "id": 38810,
      "keyword": "actriz de doblaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "scenic art",
        "visual art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "actrices de doable": [
    {
      "id": 38810,
      "keyword": "actriz de doblaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "artist",
        "scenic art",
        "visual art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "furioso": [
    {
      "id": 38811,
      "keyword": "furioso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "furiosos": [
    {
      "id": 38811,
      "keyword": "furioso",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "furiosa": [
    {
      "id": 38811,
      "keyword": "furiosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "furiosas": [
    {
      "id": 38811,
      "keyword": "furiosa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "doblaje": [
    {
      "id": 38812,
      "keyword": "doblaje",
      "keywords": 1,
      "type": 2,
      "tags": [
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "depósito municipal": [
    {
      "id": 38814,
      "keyword": "depósito municipal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "depósitos municipales": [
    {
      "id": 38814,
      "keyword": "depósito municipal",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "depósito de vehículos": [
    {
      "id": 38814,
      "keyword": "depósito de vehículos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "depósitos de vehículos": [
    {
      "id": 38814,
      "keyword": "depósito de vehículos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "work",
        "tertiary sector",
        "defense",
        "security",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro de formación": [
    {
      "id": 38815,
      "keyword": "centro de formación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros de formación": [
    {
      "id": 38815,
      "keyword": "centro de formación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "astrónoma": [
    {
      "id": 38818,
      "keyword": "astrónoma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "astronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "astrónomas": [
    {
      "id": 38818,
      "keyword": "astrónoma",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "astronomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cannabis": [
    {
      "id": 38819,
      "keyword": "cannabis",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cáñamo": [
    {
      "id": 38819,
      "keyword": "cáñamo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "marihuana": [
    {
      "id": 38819,
      "keyword": "marihuana",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "lifestyle",
        "unhealthy habit",
        "addiction",
        "drugs"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesa sensorial": [
    {
      "id": 38821,
      "keyword": "mesa sensorial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mesas sensoriales": [
    {
      "id": 38821,
      "keyword": "mesa sensorial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mudar": [
    {
      "id": 38822,
      "keyword": "mudar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trasladar": [
    {
      "id": 38822,
      "keyword": "trasladar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnica de rayos x": [
    {
      "id": 38827,
      "keyword": "técnica de rayos X",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnicas de rayos x": [
    {
      "id": 38827,
      "keyword": "técnica de rayos X",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "geriatra": [
    {
      "id": 38835,
      "keyword": "geriatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "person",
        "elderly"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "geriatras": [
    {
      "id": 38835,
      "keyword": "geriatra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "person",
        "elderly"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "médico especialista": [
    {
      "id": 38852,
      "keyword": "médico especialista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "médicos especialistas": [
    {
      "id": 38852,
      "keyword": "médico especialista",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apretar la goma": [
    {
      "id": 38853,
      "keyword": "apretar la goma",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apretar el manguito": [
    {
      "id": 38854,
      "keyword": "apretar el manguito",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "symptom"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toma de presión": [
    {
      "id": 38855,
      "keyword": "toma de presión",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "presión arterial": [
    {
      "id": 38855,
      "keyword": "presión arterial",
      "keywords": 4,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sala de preingreso": [
    {
      "id": 38859,
      "keyword": "sala de preingreso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de preingreso": [
    {
      "id": 38859,
      "keyword": "sala de preingreso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sillón hospitalario": [
    {
      "id": 38860,
      "keyword": "sillón hospitalario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillones hospitalarios": [
    {
      "id": 38860,
      "keyword": "sillón hospitalario",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sillón reclinable": [
    {
      "id": 38860,
      "keyword": "sillón reclinable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sillones reclinables": [
    {
      "id": 38860,
      "keyword": "sillón reclinable",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "furniture",
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hacer una radiografía": [
    {
      "id": 38865,
      "keyword": "hacer una radiografía",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "traje de gala": [
    {
      "id": 38866,
      "keyword": "traje de gala",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trajes de gala": [
    {
      "id": 38866,
      "keyword": "traje de gala",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "traje de etiqueta": [
    {
      "id": 38866,
      "keyword": "traje de etiqueta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trajes de etiqueta": [
    {
      "id": 38866,
      "keyword": "traje de etiqueta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "consultorio": [
    {
      "id": 38870,
      "keyword": "consultorio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "consultorios": [
    {
      "id": 38870,
      "keyword": "consultorio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gabinete médico": [
    {
      "id": 38870,
      "keyword": "gabinete médico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gabinetes médicos": [
    {
      "id": 38870,
      "keyword": "gabinete médico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "psicología clínica": [
    {
      "id": 38871,
      "keyword": "psicología clínica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "medicine",
        "health",
        "psychology",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38872,
      "keyword": "psicología clínica",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work",
        "psychology",
        "medical center",
        "place",
        "building",
        "room"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "consultar": [
    {
      "id": 38877,
      "keyword": "consultar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sala de aislamiento": [
    {
      "id": 38892,
      "keyword": "sala de aislamiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de aislamiento": [
    {
      "id": 38892,
      "keyword": "sala de aislamiento",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "macho": [
    {
      "id": 38895,
      "keyword": "macho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "animal reproduction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "machos": [
    {
      "id": 38895,
      "keyword": "macho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "animal reproduction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hembra": [
    {
      "id": 38896,
      "keyword": "hembra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "animal reproduction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hembras": [
    {
      "id": 38896,
      "keyword": "hembra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy",
        "animal reproduction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "base de pizza": [
    {
      "id": 38897,
      "keyword": "base de pizza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bases de pizza": [
    {
      "id": 38897,
      "keyword": "base de pizza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "circuito de calistenia": [
    {
      "id": 38898,
      "keyword": "circuito de calistenia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "recreational facility",
        "physical exercise",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "circuitos de calistenia": [
    {
      "id": 38898,
      "keyword": "circuito de calistenia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "recreational facility",
        "physical exercise",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "calistenia": [
    {
      "id": 38898,
      "keyword": "calistenia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "facility",
        "sports facility",
        "place",
        "recreational facility",
        "physical exercise",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "queso emmental": [
    {
      "id": 38899,
      "keyword": "queso Emmental",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aguijón": [
    {
      "id": 38902,
      "keyword": "aguijón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "aguijones": [
    {
      "id": 38902,
      "keyword": "aguijón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "anatomy",
        "animal anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "corsé ortopédico": [
    {
      "id": 38903,
      "keyword": "corsé ortopédico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "corsés ortopédico": [
    {
      "id": 38903,
      "keyword": "corsé ortopédico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hacer aguadillas": [
    {
      "id": 38904,
      "keyword": "hacer aguadillas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer ahogadillas": [
    {
      "id": 38904,
      "keyword": "hacer ahogadillas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "celdadoras": [
    {
      "id": 38910,
      "keyword": "celadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "focaccia": [
    {
      "id": 38915,
      "keyword": "focaccia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "focaccias": [
    {
      "id": 38915,
      "keyword": "focaccia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "validar pulsera": [
    {
      "id": 38916,
      "keyword": "validar pulsera",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "place",
        "building",
        "building facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camino escolar": [
    {
      "id": 38917,
      "keyword": "camino escolar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "route",
        "accessories",
        "road safety",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "caminos escolares": [
    {
      "id": 38917,
      "keyword": "camino escolar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "route",
        "accessories",
        "road safety",
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "salas de descanso": [
    {
      "id": 38918,
      "keyword": "sala de descanso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38933,
      "keyword": "sala de descanso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "room",
        "home",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huevo de tiburón": [
    {
      "id": 38920,
      "keyword": "huevo de tiburón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "ovoviviparous"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huevos de tiburón": [
    {
      "id": 38920,
      "keyword": "huevo de tiburón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "ovoviviparous"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "huevo de raya": [
    {
      "id": 38921,
      "keyword": "huevo de raya",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "ovoviviparous"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "huevos de raya": [
    {
      "id": 38921,
      "keyword": "huevo de raya",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "ovoviviparous"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "las pajaritas": [
    {
      "id": 38923,
      "keyword": "Las Pajaritas",
      "keywords": 2,
      "type": 1,
      "tags": [
        "place",
        "monument",
        "Aragon",
        "Huesca"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manipulador de alimentos": [
    {
      "id": 38925,
      "keyword": "manipulador de alimentos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manipuladores de alimentos": [
    {
      "id": 38925,
      "keyword": "manipulador de alimentos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "manipuladora de alimentos": [
    {
      "id": 38925,
      "keyword": "manipuladora de alimentos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manipuladoras de alimentos": [
    {
      "id": 38925,
      "keyword": "manipuladora de alimentos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sujetar de las piernas": [
    {
      "id": 38926,
      "keyword": "sujetar de las piernas",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior",
        "leisure",
        "sport",
        "swimming"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "golpear el pecho": [
    {
      "id": 38934,
      "keyword": "golpear el pecho",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tocar los genitales": [
    {
      "id": 38935,
      "keyword": "tocar los genitales",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38943,
      "keyword": "tocar los genitales",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "odiar": [
    {
      "id": 38936,
      "keyword": "odiar",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "qualifying adjective",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pareja": [
    {
      "id": 38937,
      "keyword": "pareja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38938,
      "keyword": "pareja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38939,
      "keyword": "pareja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38940,
      "keyword": "pareja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parejas": [
    {
      "id": 38937,
      "keyword": "pareja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38938,
      "keyword": "pareja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "psychology",
        "feeling",
        "emotion",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38939,
      "keyword": "pareja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38940,
      "keyword": "pareja",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "marital status",
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mejor amiga": [
    {
      "id": 38941,
      "keyword": "mejor amiga",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mejores amigas": [
    {
      "id": 38941,
      "keyword": "mejor amiga",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mejor amigo": [
    {
      "id": 38942,
      "keyword": "mejor amigo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mejores amigos": [
    {
      "id": 38942,
      "keyword": "mejor amigo",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "person",
        "group"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esperar la comida": [
    {
      "id": 38944,
      "keyword": "esperar la comida",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sentado en la mesa": [
    {
      "id": 38944,
      "keyword": "sentado en la mesa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "feeding"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sentados en la mesa": [
    {
      "id": 38944,
      "keyword": "sentado en la mesa",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "feeding"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hacer ruido": [
    {
      "id": 38945,
      "keyword": "hacer ruido",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paquete": [
    {
      "id": 38946,
      "keyword": "paquete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paquetes": [
    {
      "id": 38946,
      "keyword": "paquete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "transport services"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "halcón": [
    {
      "id": 38947,
      "keyword": "halcón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "halcones": [
    {
      "id": 38947,
      "keyword": "halcón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "bird",
        "oviparous",
        "flying animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rodaja de salchichón": [
    {
      "id": 38949,
      "keyword": "rodaja de salchichón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodajas de salchichón": [
    {
      "id": 38949,
      "keyword": "rodaja de salchichón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rodaja de mortadela": [
    {
      "id": 38950,
      "keyword": "rodaja de mortadela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodajas de mortadela": [
    {
      "id": 38950,
      "keyword": "rodaja de mortadela",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "filete de panceta": [
    {
      "id": 38951,
      "keyword": "filete de panceta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "filetes de panceta": [
    {
      "id": 38951,
      "keyword": "filete de panceta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "filete de beicon": [
    {
      "id": 38951,
      "keyword": "filete de beicon",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "filetes de beicon": [
    {
      "id": 38951,
      "keyword": "filete de beicon",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rodaja de tomate": [
    {
      "id": 38953,
      "keyword": "rodaja de tomate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rodajas de tomate": [
    {
      "id": 38953,
      "keyword": "rodaja de tomate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "filete de carne": [
    {
      "id": 38956,
      "keyword": "filete de carne",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "filetes de carne": [
    {
      "id": 38956,
      "keyword": "filete de carne",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "animal-based food",
        "meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "loncha de queso": [
    {
      "id": 38959,
      "keyword": "loncha de queso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lonchas de queso": [
    {
      "id": 38959,
      "keyword": "loncha de queso",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "animal-based food",
        "dairy product",
        "processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rodajas de chorizo": [
    {
      "id": 38961,
      "keyword": "rodajas de chorizo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "filete de jamón de york": [
    {
      "id": 38962,
      "keyword": "filete de jamón de york",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "filetes de jamón de york": [
    {
      "id": 38962,
      "keyword": "filete de jamón de york",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "filete de jamón": [
    {
      "id": 38963,
      "keyword": "filete de jamón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "filetes de jamón": [
    {
      "id": 38963,
      "keyword": "filete de jamón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "shavuot": [
    {
      "id": 38964,
      "keyword": "Shavuot",
      "keywords": 2,
      "type": 1,
      "tags": [
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "fiesta de las primicias": [
    {
      "id": 38964,
      "keyword": "Fiesta de las Primicias",
      "keywords": 2,
      "type": 1,
      "tags": [
        "religion",
        "judaism"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maniobra de heimlich": [
    {
      "id": 38966,
      "keyword": "maniobra de Heimlich",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gato doméstico": [
    {
      "id": 38968,
      "keyword": "gato doméstico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gatos domésticos": [
    {
      "id": 38968,
      "keyword": "gato doméstico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "gata doméstica": [
    {
      "id": 38968,
      "keyword": "gata doméstica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gatas domésticas": [
    {
      "id": 38968,
      "keyword": "gata doméstica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "pet",
        "domestic"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encina": [
    {
      "id": 38970,
      "keyword": "encina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encinas": [
    {
      "id": 38970,
      "keyword": "encina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "propina": [
    {
      "id": 38972,
      "keyword": "propina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 38973,
      "keyword": "propina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "propinas": [
    {
      "id": 38972,
      "keyword": "propina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 38973,
      "keyword": "propina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "economy",
        "money",
        "work",
        "tertiary sector",
        "hospitality industry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chaleco protector": [
    {
      "id": 38975,
      "keyword": "chaleco protector",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chalecos protectores": [
    {
      "id": 38975,
      "keyword": "chaleco protector",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "protector de rayos x": [
    {
      "id": 38975,
      "keyword": "protector de rayos x",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "protectores de rayos x": [
    {
      "id": 38975,
      "keyword": "protector de rayos x",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "protector radiológico": [
    {
      "id": 38975,
      "keyword": "protector radiológico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "protectores radiológicos": [
    {
      "id": 38975,
      "keyword": "protector radiológico",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chaleco emplomado": [
    {
      "id": 38975,
      "keyword": "chaleco emplomado",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chalecos emplomados": [
    {
      "id": 38975,
      "keyword": "chaleco emplomado",
      "keywords": 4,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sendero": [
    {
      "id": 38976,
      "keyword": "sendero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "leisure",
        "outdoor activity",
        "mountain",
        "rural area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "senderos": [
    {
      "id": 38976,
      "keyword": "sendero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "infrastructure",
        "leisure",
        "outdoor activity",
        "mountain",
        "rural area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ladera": [
    {
      "id": 38977,
      "keyword": "ladera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "place",
        "rural area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "laderas": [
    {
      "id": 38977,
      "keyword": "ladera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "geography",
        "physical geography",
        "landform",
        "place",
        "rural area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "subir al tren": [
    {
      "id": 38978,
      "keyword": "subir al tren",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "subir al tranvía": [
    {
      "id": 38978,
      "keyword": "subir al tranvía",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar del tren": [
    {
      "id": 38979,
      "keyword": "bajar del tren",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bajar del tranvía": [
    {
      "id": 38979,
      "keyword": "bajar del tranvía",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "halterofilia": [
    {
      "id": 38980,
      "keyword": "halterofilia",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39282,
      "keyword": "halterofilia",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crossfit": [
    {
      "id": 38981,
      "keyword": "crossfit",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelar una patata": [
    {
      "id": 38983,
      "keyword": "pelar una patata",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sala de ensayos": [
    {
      "id": 38984,
      "keyword": "sala de ensayos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de ensayos": [
    {
      "id": 38984,
      "keyword": "sala de ensayos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ermita": [
    {
      "id": 38990,
      "keyword": "ermita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "rural area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ermitas": [
    {
      "id": 38990,
      "keyword": "ermita",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "religion",
        "christianity",
        "rural area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barra para golpes": [
    {
      "id": 38992,
      "keyword": "barra para golpes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barras para golpes": [
    {
      "id": 38992,
      "keyword": "barra para golpes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "stick para golpes": [
    {
      "id": 38992,
      "keyword": "stick para golpes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sticks para golpes": [
    {
      "id": 38992,
      "keyword": "stick para golpes",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medicament"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sushi": [
    {
      "id": 38993,
      "keyword": "sushi",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sopa wonton": [
    {
      "id": 38994,
      "keyword": "sopa wonton",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "brida": [
    {
      "id": 38995,
      "keyword": "brida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bridas": [
    {
      "id": 38995,
      "keyword": "brida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tela aárea": [
    {
      "id": 38996,
      "keyword": "tela aárea",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "danza aérea": [
    {
      "id": 38996,
      "keyword": "danza aérea",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tela acrobática": [
    {
      "id": 38996,
      "keyword": "tela acrobática",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "velada nocturna": [
    {
      "id": 38997,
      "keyword": "velada nocturna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "veladas nocturnas": [
    {
      "id": 38997,
      "keyword": "velada nocturna",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taquilla de feria": [
    {
      "id": 38998,
      "keyword": "taquilla de feria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taquillas de feria": [
    {
      "id": 38998,
      "keyword": "taquilla de feria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caseta de baile": [
    {
      "id": 38999,
      "keyword": "caseta de baile",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "facility",
        "recreational facility",
        "leisure",
        "scenic art",
        "dance",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puesto de comida": [
    {
      "id": 39000,
      "keyword": "puesto de comida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "facility",
        "recreational facility",
        "leisure",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "puestos de comida": [
    {
      "id": 39000,
      "keyword": "puesto de comida",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "facility",
        "recreational facility",
        "leisure",
        "work",
        "tertiary sector"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "masía": [
    {
      "id": 39001,
      "keyword": "masía",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "masías": [
    {
      "id": 39001,
      "keyword": "masía",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "masada": [
    {
      "id": 39001,
      "keyword": "masada",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "masadas": [
    {
      "id": 39001,
      "keyword": "masada",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mas": [
    {
      "id": 39001,
      "keyword": "mas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mases": [
    {
      "id": 39001,
      "keyword": "mas",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "túnel sensorial": [
    {
      "id": 39002,
      "keyword": "túnel sensorial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "túneles sensoriales": [
    {
      "id": 39002,
      "keyword": "túnel sensorial",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hervidor de agua": [
    {
      "id": 39004,
      "keyword": "hervidor de agua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hervidores de agua": [
    {
      "id": 39004,
      "keyword": "hervidor de agua",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "hervidor": [
    {
      "id": 39004,
      "keyword": "hervidor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hervidores": [
    {
      "id": 39004,
      "keyword": "hervidor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "padrastro": [
    {
      "id": 39008,
      "keyword": "padrastro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "padrastros": [
    {
      "id": 39008,
      "keyword": "padrastro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "eslalon adaptado": [
    {
      "id": 39009,
      "keyword": "eslalon adaptado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "adapted sport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "slalom en silla de ruedas": [
    {
      "id": 39009,
      "keyword": "slalom en silla de ruedas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "adapted sport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "voleibol adaptado": [
    {
      "id": 39010,
      "keyword": "voleibol adaptado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "adapted sport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bicicleta adaptada": [
    {
      "id": 39011,
      "keyword": "bicicleta adaptada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "sport",
        "cycling",
        "sport material",
        "adapted sport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bicicletas adaptadas": [
    {
      "id": 39011,
      "keyword": "bicicleta adaptada",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "sport",
        "cycling",
        "sport material",
        "adapted sport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "triciclo adaptado": [
    {
      "id": 39011,
      "keyword": "triciclo adaptado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "sport",
        "cycling",
        "sport material",
        "adapted sport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "triciclos adaptados": [
    {
      "id": 39011,
      "keyword": "triciclo adaptado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport",
        "leisure",
        "sport",
        "cycling",
        "sport material",
        "adapted sport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tablero de elección": [
    {
      "id": 39012,
      "keyword": "tablero de elección",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tableros de elección": [
    {
      "id": 39012,
      "keyword": "tablero de elección",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tablero de sí o no": [
    {
      "id": 39012,
      "keyword": "tablero de sí o no",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tableros de sí o no": [
    {
      "id": 39012,
      "keyword": "tablero de sí o no",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tablero de letras": [
    {
      "id": 39013,
      "keyword": "tablero de letras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tableros de letras": [
    {
      "id": 39013,
      "keyword": "tablero de letras",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "augmentative communication",
        "communication aid"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "descampado": [
    {
      "id": 39017,
      "keyword": "descampado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "urban area"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "descampados": [
    {
      "id": 39017,
      "keyword": "descampado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "rural area",
        "urban area"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "leer qr": [
    {
      "id": 39018,
      "keyword": "leer QR",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "document",
        "information document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "toka": [
    {
      "id": 39019,
      "keyword": "toka",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tuka": [
    {
      "id": 39019,
      "keyword": "tuka",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "traditional game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bao-pao": [
    {
      "id": 39020,
      "keyword": "bao-pao",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bao-paos": [
    {
      "id": 39020,
      "keyword": "bao-pao",
      "keywords": 1,
      "type": 2,
      "tags": [
        "music",
        "musical instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "baozi": [
    {
      "id": 39021,
      "keyword": "baozi",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baozis": [
    {
      "id": 39021,
      "keyword": "baozi",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bao": [
    {
      "id": 39021,
      "keyword": "bao",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "baos": [
    {
      "id": 39021,
      "keyword": "bao",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ascender a la superficie": [
    {
      "id": 39022,
      "keyword": "ascender a la superficie",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "descompresión": [
    {
      "id": 39025,
      "keyword": "descompresión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39023,
      "keyword": "descompresión",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bucear juntos": [
    {
      "id": 39024,
      "keyword": "bucear juntos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "diving"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "serrín": [
    {
      "id": 39027,
      "keyword": "serrín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "serrines": [
    {
      "id": 39027,
      "keyword": "serrín",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "carpentry"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro de formación del profesorado": [
    {
      "id": 39028,
      "keyword": "centro de formación del profesorado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "professional",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros de formación del profesorado": [
    {
      "id": 39028,
      "keyword": "centro de formación del profesorado",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "professional",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "centro de profesores": [
    {
      "id": 39028,
      "keyword": "centro de profesores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "professional",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "centros de profesores": [
    {
      "id": 39028,
      "keyword": "centro de profesores",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "building",
        "professional",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "chaleco de punto": [
    {
      "id": 39029,
      "keyword": "chaleco de punto",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chalecos de punto": [
    {
      "id": 39029,
      "keyword": "chaleco de punto",
      "keywords": 5,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "slime": [
    {
      "id": 39030,
      "keyword": "slime",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "object",
        "sensory stimulation",
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "scalextric": [
    {
      "id": 39031,
      "keyword": "scalextric",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubo para vidrio": [
    {
      "id": 39032,
      "keyword": "cubo para vidrio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubos para vidrio": [
    {
      "id": 39032,
      "keyword": "cubo para vidrio",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cubo para reciclaje": [
    {
      "id": 39032,
      "keyword": "cubo para reciclaje",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39033,
      "keyword": "cubo para reciclaje",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39034,
      "keyword": "cubo para reciclaje",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39035,
      "keyword": "cubo para reciclaje",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubos para reciclaje": [
    {
      "id": 39032,
      "keyword": "cubo para reciclaje",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39033,
      "keyword": "cubo para reciclaje",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39034,
      "keyword": "cubo para reciclaje",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39035,
      "keyword": "cubo para reciclaje",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cubo para orgánico": [
    {
      "id": 39033,
      "keyword": "cubo para orgánico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubos para orgánico": [
    {
      "id": 39033,
      "keyword": "cubo para orgánico",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cubo para papel": [
    {
      "id": 39034,
      "keyword": "cubo para papel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubos para papel": [
    {
      "id": 39034,
      "keyword": "cubo para papel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cubo para envases": [
    {
      "id": 39035,
      "keyword": "cubo para envases",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cubos para envases": [
    {
      "id": 39035,
      "keyword": "cubo para envases",
      "keywords": 3,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "environmental science",
        "recycling"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "metalófono": [
    {
      "id": 39045,
      "keyword": "metalófono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "metalófonos": [
    {
      "id": 39045,
      "keyword": "metalófono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "medalófono": [
    {
      "id": 39045,
      "keyword": "medalófono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medalófonos": [
    {
      "id": 39045,
      "keyword": "medalófono",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "recoger excrementos": [
    {
      "id": 39046,
      "keyword": "recoger excrementos",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "animal",
        "pet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de lengua y literatura árabe": [
    {
      "id": 39047,
      "keyword": "clase de lengua y literatura árabe",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de lengua y literatura árabe": [
    {
      "id": 39047,
      "keyword": "clase de lengua y literatura árabe",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lengua y literatura árabe": [
    {
      "id": 39047,
      "keyword": "lengua y literatura árabe",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clase de árabe": [
    {
      "id": 39047,
      "keyword": "clase de árabe",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clases de árabe": [
    {
      "id": 39047,
      "keyword": "clase de árabe",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "esperar en clase": [
    {
      "id": 39049,
      "keyword": "esperar en clase",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "manos tocando pies": [
    {
      "id": 39053,
      "keyword": "manos tocando pies",
      "keywords": 3,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "skipping": [
    {
      "id": 39054,
      "keyword": "skipping",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39056,
      "keyword": "skipping",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "graduado social": [
    {
      "id": 39057,
      "keyword": "graduado social",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "economy",
        "law",
        "tertiary sector",
        "consultancy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lazo salado": [
    {
      "id": 39058,
      "keyword": "lazo salado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lazos salados": [
    {
      "id": 39058,
      "keyword": "lazo salado",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bretzel": [
    {
      "id": 39058,
      "keyword": "bretzel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bretzels": [
    {
      "id": 39058,
      "keyword": "bretzel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pretzel": [
    {
      "id": 39058,
      "keyword": "pretzel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pretzels": [
    {
      "id": 39058,
      "keyword": "pretzel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arena mágica": [
    {
      "id": 39059,
      "keyword": "arena mágica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "leisure",
        "sport",
        "toy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arnés": [
    {
      "id": 39060,
      "keyword": "arnés",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arneses": [
    {
      "id": 39060,
      "keyword": "arnés",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pies de gato": [
    {
      "id": 39061,
      "keyword": "pies de gato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport material",
        "outdoor activity",
        "mountain"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autoradio": [
    {
      "id": 39063,
      "keyword": "autoradio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "autoradios": [
    {
      "id": 39063,
      "keyword": "autoradio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "vehicle component"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "puenting": [
    {
      "id": 39064,
      "keyword": "puenting",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinza extensible": [
    {
      "id": 39066,
      "keyword": "pinza extensible",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinzas extensibles": [
    {
      "id": 39066,
      "keyword": "pinza extensible",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pinza recoge objetos": [
    {
      "id": 39066,
      "keyword": "pinza recoge objetos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinzas recoge objetos": [
    {
      "id": 39066,
      "keyword": "pinza recoge objetos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "tool",
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pincel de cocina": [
    {
      "id": 39070,
      "keyword": "pincel de cocina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinceles de cocina": [
    {
      "id": 39070,
      "keyword": "pincel de cocina",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pincel de silicona": [
    {
      "id": 39070,
      "keyword": "pincel de silicona",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pinceles de silicona": [
    {
      "id": 39070,
      "keyword": "pincel de silicona",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "algarroba": [
    {
      "id": 39071,
      "keyword": "algarroba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "algarrobas": [
    {
      "id": 39071,
      "keyword": "algarroba",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "legume"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trasvasar": [
    {
      "id": 39072,
      "keyword": "trasvasar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39073,
      "keyword": "trasvasar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trasvase": [
    {
      "id": 39072,
      "keyword": "trasvase",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39073,
      "keyword": "trasvase",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "educational task"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "galets": [
    {
      "id": 39076,
      "keyword": "galets",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasta tiburón": [
    {
      "id": 39076,
      "keyword": "pasta tiburón",
      "keywords": 3,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasar por debajo": [
    {
      "id": 39077,
      "keyword": "pasar por debajo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cambio climático": [
    {
      "id": 39081,
      "keyword": "cambio climático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "environmental science"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dar coces": [
    {
      "id": 39082,
      "keyword": "dar coces",
      "keywords": 2,
      "type": 3,
      "tags": [
        "animal",
        "animal behavior",
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plato sucio": [
    {
      "id": 39083,
      "keyword": "plato sucio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "platos sucios": [
    {
      "id": 39083,
      "keyword": "plato sucio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "household",
        "crockery",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pierna en alto": [
    {
      "id": 39084,
      "keyword": "pierna en alto",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tener la pierna en alto": [
    {
      "id": 39084,
      "keyword": "tener la pierna en alto",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "health",
        "medicine",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saturado": [
    {
      "id": 39086,
      "keyword": "saturado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saturados": [
    {
      "id": 39086,
      "keyword": "saturado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "saturada": [
    {
      "id": 39086,
      "keyword": "saturada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "saturadas": [
    {
      "id": 39086,
      "keyword": "saturada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sindicato": [
    {
      "id": 39087,
      "keyword": "sindicato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sindicatos": [
    {
      "id": 39087,
      "keyword": "sindicato",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "organization"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "semiesfera de equilibrio": [
    {
      "id": 39088,
      "keyword": "semiesfera de equilibrio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "semiesferas de equilibrio": [
    {
      "id": 39088,
      "keyword": "semiesfera de equilibrio",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acabar el papel higiénico": [
    {
      "id": 39089,
      "keyword": "acabar el papel higiénico",
      "keywords": 1,
      "type": 3,
      "tags": [
        "object",
        "hygiene product",
        "hygiene",
        "corporal hygiene",
        "person",
        "routine"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "emocionado": [
    {
      "id": 39090,
      "keyword": "emocionado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "emocionados": [
    {
      "id": 39090,
      "keyword": "emocionado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "emocionada": [
    {
      "id": 39090,
      "keyword": "emocionada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "emocionadas": [
    {
      "id": 39090,
      "keyword": "emocionada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encantado": [
    {
      "id": 39091,
      "keyword": "encantado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encantados": [
    {
      "id": 39091,
      "keyword": "encantado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "encantada": [
    {
      "id": 39091,
      "keyword": "encantada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encantadas": [
    {
      "id": 39091,
      "keyword": "encantada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "psychology",
        "feeling",
        "emotion"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "paraguayo": [
    {
      "id": 39093,
      "keyword": "paraguayo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "paraguayos": [
    {
      "id": 39093,
      "keyword": "paraguayo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "arriate": [
    {
      "id": 39094,
      "keyword": "arriate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arriates": [
    {
      "id": 39094,
      "keyword": "arriate",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "árbol genealógico": [
    {
      "id": 39097,
      "keyword": "árbol genealógico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "árboles genealógicos": [
    {
      "id": 39097,
      "keyword": "árbol genealógico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "genealogía": [
    {
      "id": 39097,
      "keyword": "genealogía",
      "keywords": 2,
      "type": 2,
      "tags": [
        "person",
        "family"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "capazo": [
    {
      "id": 39098,
      "keyword": "capazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "gardening",
        "tool"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "capazos": [
    {
      "id": 39098,
      "keyword": "capazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "gardening",
        "tool"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trepadora": [
    {
      "id": 39099,
      "keyword": "trepadora",
      "keywords": 2,
      "type": 4,
      "tags": [
        "plant",
        "plant physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trepadoras": [
    {
      "id": 39099,
      "keyword": "trepadora",
      "keywords": 2,
      "type": 4,
      "tags": [
        "plant",
        "plant physiology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "planta trepadora": [
    {
      "id": 39099,
      "keyword": "planta trepadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant physiology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "plantas trepadoras": [
    {
      "id": 39099,
      "keyword": "planta trepadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "plant physiology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rocalla": [
    {
      "id": 39100,
      "keyword": "rocalla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rocallas": [
    {
      "id": 39100,
      "keyword": "rocalla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plantas aromáticas": [
    {
      "id": 39101,
      "keyword": "plantas aromáticas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parterre": [
    {
      "id": 39102,
      "keyword": "parterre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parterres": [
    {
      "id": 39102,
      "keyword": "parterre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "primary sector",
        "gardening"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rotuladores de colores": [
    {
      "id": 39103,
      "keyword": "rotuladores de colores",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "granadilla": [
    {
      "id": 39105,
      "keyword": "granadilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "granadillas": [
    {
      "id": 39105,
      "keyword": "granadilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "fruit"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "batir en duelo": [
    {
      "id": 39106,
      "keyword": "batir en duelo",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "enfrentar": [
    {
      "id": 39106,
      "keyword": "enfrentar",
      "keywords": 4,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "general": [
    {
      "id": 39107,
      "keyword": "general",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "generales": [
    {
      "id": 39107,
      "keyword": "general",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coronel": [
    {
      "id": 39107,
      "keyword": "coronel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "coroneles": [
    {
      "id": 39107,
      "keyword": "coronel",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "defense",
        "security",
        "event",
        "war"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sala de estar": [
    {
      "id": 39108,
      "keyword": "sala de estar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de estar": [
    {
      "id": 39108,
      "keyword": "sala de estar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de búsqueda": [
    {
      "id": 39110,
      "keyword": "botón de búsqueda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de búsqueda": [
    {
      "id": 39110,
      "keyword": "botón de búsqueda",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de buscar": [
    {
      "id": 39110,
      "keyword": "botón de buscar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de buscar": [
    {
      "id": 39110,
      "keyword": "botón de buscar",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "quitar la mochila": [
    {
      "id": 39115,
      "keyword": "quitar la mochila",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "accessories",
        "person",
        "routine",
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colgar la bata": [
    {
      "id": 39116,
      "keyword": "colgar la bata",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "education",
        "teaching activity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "montar en pony": [
    {
      "id": 39117,
      "keyword": "montar en pony",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "horse riding",
        "animal",
        "animal-assisted therapy",
        "equine-assisted therapy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tritón": [
    {
      "id": 39118,
      "keyword": "tritón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "amphibian",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tritones": [
    {
      "id": 39118,
      "keyword": "tritón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "amphibian",
        "oviparous",
        "aquatic animal",
        "freshwater animal",
        "river",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "macarrones carbonara": [
    {
      "id": 39119,
      "keyword": "macarrones carbonara",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espaguetis carbonara": [
    {
      "id": 39121,
      "keyword": "espaguetis carbonara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carbonara": [
    {
      "id": 39121,
      "keyword": "carbonara",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "dron": [
    {
      "id": 39123,
      "keyword": "dron",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "drones": [
    {
      "id": 39123,
      "keyword": "dron",
      "keywords": 1,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "antebrazo": [
    {
      "id": 39124,
      "keyword": "antebrazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "antebrazos": [
    {
      "id": 39124,
      "keyword": "antebrazo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pantorrilla": [
    {
      "id": 39125,
      "keyword": "pantorrilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pantorrillas": [
    {
      "id": 39125,
      "keyword": "pantorrilla",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "talit": [
    {
      "id": 39126,
      "keyword": "talit",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "judaism",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "talits": [
    {
      "id": 39126,
      "keyword": "talit",
      "keywords": 1,
      "type": 2,
      "tags": [
        "religion",
        "judaism",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tangram": [
    {
      "id": 39129,
      "keyword": "tangram",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tangrams": [
    {
      "id": 39129,
      "keyword": "tangram",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "board game",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "guacamole": [
    {
      "id": 39132,
      "keyword": "guacamole",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guacamol": [
    {
      "id": 39132,
      "keyword": "guacamol",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zancadilla": [
    {
      "id": 39133,
      "keyword": "zancadilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zancadillas": [
    {
      "id": 39133,
      "keyword": "zancadilla",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "poner la zancadilla": [
    {
      "id": 39133,
      "keyword": "poner la zancadilla",
      "keywords": 2,
      "type": 3,
      "tags": [
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reverencia": [
    {
      "id": 39136,
      "keyword": "reverencia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "reverencias": [
    {
      "id": 39136,
      "keyword": "reverencia",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response",
        "expression",
        "polite set expression"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "meter en el oído": [
    {
      "id": 39138,
      "keyword": "meter en el oído",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "introducir en el oído": [
    {
      "id": 39138,
      "keyword": "introducir en el oído",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "disruptive behavior"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tienda de minerales": [
    {
      "id": 39140,
      "keyword": "tienda de minerales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "material",
        "raw material",
        "mineral origin material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tiendas de minerales": [
    {
      "id": 39140,
      "keyword": "tienda de minerales",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade",
        "material",
        "raw material",
        "mineral origin material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "insano": [
    {
      "id": 39142,
      "keyword": "insano",
      "keywords": 4,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "insanos": [
    {
      "id": 39142,
      "keyword": "insano",
      "keywords": 4,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "insana": [
    {
      "id": 39142,
      "keyword": "insana",
      "keywords": 4,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "insanas": [
    {
      "id": 39142,
      "keyword": "insana",
      "keywords": 4,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "disease"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "tienda de climatización": [
    {
      "id": 39143,
      "keyword": "tienda de climatización",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "trade"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "constructora": [
    {
      "id": 39144,
      "keyword": "constructora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "constructoras": [
    {
      "id": 39144,
      "keyword": "constructora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "construction"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "alfombrilla musical": [
    {
      "id": 39151,
      "keyword": "alfombrilla musical",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alfombrillas musicales": [
    {
      "id": 39151,
      "keyword": "alfombrilla musical",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "campanas de viento": [
    {
      "id": 39152,
      "keyword": "campanas de viento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carillón de viento": [
    {
      "id": 39152,
      "keyword": "carillón de viento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "carillones de viento": [
    {
      "id": 39152,
      "keyword": "carillón de viento",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music",
        "musical instrument",
        "percussion instrument",
        "object",
        "sensory stimulation"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "funambulismo": [
    {
      "id": 39153,
      "keyword": "funambulismo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39154,
      "keyword": "funambulismo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise",
        "scenic art",
        "circus",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "audioguía": [
    {
      "id": 39156,
      "keyword": "audioguía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device",
        "work",
        "tertiary sector",
        "tourism",
        "culture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "audioguías": [
    {
      "id": 39156,
      "keyword": "audioguía",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "music device",
        "work",
        "tertiary sector",
        "tourism",
        "culture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escuchar la audioguía": [
    {
      "id": 39157,
      "keyword": "escuchar la audioguía",
      "keywords": 2,
      "type": 3,
      "tags": [
        "work",
        "tertiary sector",
        "tourism",
        "culture",
        "object",
        "appliance",
        "music device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "refugio climático": [
    {
      "id": 39158,
      "keyword": "refugio climático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "refugios climáticos": [
    {
      "id": 39158,
      "keyword": "refugio climático",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "conejo de pascua": [
    {
      "id": 39162,
      "keyword": "conejo de Pascua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "easter week",
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "conejos de pascua": [
    {
      "id": 39162,
      "keyword": "conejo de Pascua",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "popular event",
        "easter week",
        "feeding",
        "food",
        "ultra-processed food",
        "sweets"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "plaquetas": [
    {
      "id": 39163,
      "keyword": "plaquetas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trombocitos": [
    {
      "id": 39163,
      "keyword": "trombocitos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "glóbulos blancos": [
    {
      "id": 39164,
      "keyword": "glóbulos blancos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leucocitos": [
    {
      "id": 39164,
      "keyword": "leucocitos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "glóbulos rojos": [
    {
      "id": 39165,
      "keyword": "glóbulos rojos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "eritrocitos": [
    {
      "id": 39165,
      "keyword": "eritrocitos",
      "keywords": 3,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hematíes": [
    {
      "id": 39165,
      "keyword": "hematíes",
      "keywords": 3,
      "type": 2,
      "tags": [
        "human body",
        "physiology",
        "human physiology",
        "circulatory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "podrido": [
    {
      "id": 39167,
      "keyword": "podrido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "plant-based food",
        "animal-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "podridos": [
    {
      "id": 39167,
      "keyword": "podrido",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "plant-based food",
        "animal-based food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "podrida": [
    {
      "id": 39167,
      "keyword": "podrida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "plant-based food",
        "animal-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "podridas": [
    {
      "id": 39167,
      "keyword": "podrida",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "feeding",
        "food",
        "plant-based food",
        "animal-based food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "túnez": [
    {
      "id": 39168,
      "keyword": "Túnez",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "república tunecina": [
    {
      "id": 39168,
      "keyword": "República Tunecina",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "santo tomé y príncipe": [
    {
      "id": 39169,
      "keyword": "Santo Tomé y Príncipe",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "república democrática de santo tomé y príncipe": [
    {
      "id": 39169,
      "keyword": "República Democrática de Santo Tomé y Príncipe",
      "keywords": 2,
      "type": 2,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guinea-bisáu": [
    {
      "id": 39170,
      "keyword": "Guinea-Bisáu",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guinea-bissau": [
    {
      "id": 39170,
      "keyword": "Guinea-Bissau",
      "keywords": 2,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "informe": [
    {
      "id": 39172,
      "keyword": "informe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "informes": [
    {
      "id": 39172,
      "keyword": "informe",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "information document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inspectora educativa": [
    {
      "id": 39173,
      "keyword": "inspectora educativa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inspectoras educativas": [
    {
      "id": 39173,
      "keyword": "inspectora educativa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inspectora de educación": [
    {
      "id": 39173,
      "keyword": "inspectora de educación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inspectoras de educación": [
    {
      "id": 39173,
      "keyword": "inspectora de educación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inspector educativo": [
    {
      "id": 39174,
      "keyword": "inspector educativo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inspectores educativos": [
    {
      "id": 39174,
      "keyword": "inspector educativo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inspector de educación": [
    {
      "id": 39174,
      "keyword": "inspector de educación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "inspectores de educación": [
    {
      "id": 39174,
      "keyword": "inspector de educación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "education",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "currículum": [
    {
      "id": 39177,
      "keyword": "currículum",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "currículums": [
    {
      "id": 39177,
      "keyword": "currículum",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "supporting document"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cv": [
    {
      "id": 39177,
      "keyword": "CV",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "information document",
        "supporting document"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "catequesis": [
    {
      "id": 39178,
      "keyword": "catequesis",
      "keywords": 3,
      "type": 2,
      "tags": [
        "education",
        "subject"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contigo": [
    {
      "id": 39181,
      "keyword": "contigo",
      "keywords": 1,
      "type": 1,
      "tags": [
        "communication",
        "language",
        "pronoun",
        "personal pronoun"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "churrero": [
    {
      "id": 39183,
      "keyword": "churrero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39186,
      "keyword": "churrero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "churreros": [
    {
      "id": 39183,
      "keyword": "churrero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39186,
      "keyword": "churrero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "churrera": [
    {
      "id": 39183,
      "keyword": "churrera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39184,
      "keyword": "churrera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "churreras": [
    {
      "id": 39183,
      "keyword": "churrera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39184,
      "keyword": "churrera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "juegos de madera": [
    {
      "id": 39187,
      "keyword": "juegos de madera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "demasiado": [
    {
      "id": 39188,
      "keyword": "demasiado",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "demasiados": [
    {
      "id": 39188,
      "keyword": "demasiado",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "demasiada": [
    {
      "id": 39188,
      "keyword": "demasiada",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "demasiadas": [
    {
      "id": 39188,
      "keyword": "demasiada",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "desbordar": [
    {
      "id": 39188,
      "keyword": "desbordar",
      "keywords": 7,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "excesivo": [
    {
      "id": 39188,
      "keyword": "excesivo",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "excesivos": [
    {
      "id": 39188,
      "keyword": "excesivo",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "excesiva": [
    {
      "id": 39188,
      "keyword": "excesiva",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "excesivas": [
    {
      "id": 39188,
      "keyword": "excesiva",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sobrado": [
    {
      "id": 39188,
      "keyword": "sobrado",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sobrados": [
    {
      "id": 39188,
      "keyword": "sobrado",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sobrada": [
    {
      "id": 39188,
      "keyword": "sobrada",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sobradas": [
    {
      "id": 39188,
      "keyword": "sobrada",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "verb",
        "adjective",
        "indefinite adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "depredador": [
    {
      "id": 39189,
      "keyword": "depredador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "animal behavior",
        "wild"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39189,
      "keyword": "depredador",
      "keywords": 3,
      "type": 4,
      "tags": [
        "animal",
        "carnivorous",
        "animal behavior",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "depredadores": [
    {
      "id": 39189,
      "keyword": "depredador",
      "keywords": 3,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "animal behavior",
        "wild"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39189,
      "keyword": "depredador",
      "keywords": 3,
      "type": 4,
      "tags": [
        "animal",
        "carnivorous",
        "animal behavior",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "depredadora": [
    {
      "id": 39189,
      "keyword": "depredadora",
      "keywords": 3,
      "type": 4,
      "tags": [
        "animal",
        "carnivorous",
        "animal behavior",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "depredadoras": [
    {
      "id": 39189,
      "keyword": "depredadora",
      "keywords": 3,
      "type": 4,
      "tags": [
        "animal",
        "carnivorous",
        "animal behavior",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sésamo": [
    {
      "id": 39192,
      "keyword": "sésamo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "semillas de sésamo": [
    {
      "id": 39192,
      "keyword": "semillas de sésamo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "hervaceouos plant",
        "feeding",
        "food",
        "plant-based food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer el pino": [
    {
      "id": 39193,
      "keyword": "hacer el pino",
      "keywords": 2,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "equilibrio invertido de brazos": [
    {
      "id": 39193,
      "keyword": "equilibrio invertido de brazos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pelo rapado": [
    {
      "id": 39194,
      "keyword": "pelo rapado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "physical features",
        "work",
        "tertiary sector",
        "personal services",
        "hairdresser"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "alta voluntaria": [
    {
      "id": 39196,
      "keyword": "alta voluntaria",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "confidencial": [
    {
      "id": 39197,
      "keyword": "confidencial",
      "keywords": 2,
      "type": 4,
      "tags": [
        "document",
        "public administration",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39204,
      "keyword": "confidencial",
      "keywords": 2,
      "type": 4,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "confidenciales": [
    {
      "id": 39197,
      "keyword": "confidencial",
      "keywords": 2,
      "type": 4,
      "tags": [
        "document",
        "public administration",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39204,
      "keyword": "confidencial",
      "keywords": 2,
      "type": 4,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "documento confidencial": [
    {
      "id": 39197,
      "keyword": "documento confidencial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39204,
      "keyword": "documento confidencial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "documentos confidenciales": [
    {
      "id": 39197,
      "keyword": "documento confidencial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration",
        "health",
        "medicine"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39204,
      "keyword": "documento confidencial",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "public administration"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "motilo": [
    {
      "id": 39198,
      "keyword": "motilo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "motilos": [
    {
      "id": 39198,
      "keyword": "motilo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "psicólogo educativo": [
    {
      "id": 39200,
      "keyword": "psicólogo educativo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "psychology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39201,
      "keyword": "psicólogo educativo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "psychology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "psicólogos educativos": [
    {
      "id": 39200,
      "keyword": "psicólogo educativo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "psychology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39201,
      "keyword": "psicólogo educativo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "psychology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "psicóloga educativa": [
    {
      "id": 39200,
      "keyword": "psicóloga educativa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "psychology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39201,
      "keyword": "psicóloga educativa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "psychology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "psicólogas educativas": [
    {
      "id": 39200,
      "keyword": "psicóloga educativa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "psychology"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39201,
      "keyword": "psicóloga educativa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "psychology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "psicología educativa": [
    {
      "id": 39200,
      "keyword": "psicología educativa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "psychology"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39201,
      "keyword": "psicología educativa",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "education",
        "psychology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiar el ojo": [
    {
      "id": 39202,
      "keyword": "limpiar el ojo",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casa cueva": [
    {
      "id": 39203,
      "keyword": "casa cueva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casas cueva": [
    {
      "id": 39203,
      "keyword": "casa cueva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casa-cueva": [
    {
      "id": 39203,
      "keyword": "casa-cueva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casas-cueva": [
    {
      "id": 39203,
      "keyword": "casa-cueva",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "trufas de chocolate": [
    {
      "id": 39205,
      "keyword": "trufas de chocolate",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cine al aire libre": [
    {
      "id": 39207,
      "keyword": "cine al aire libre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "cinema",
        "show",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cines al aire libre": [
    {
      "id": 39207,
      "keyword": "cine al aire libre",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "culture",
        "scenic art",
        "cinema",
        "show",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "inauguración de los juegos": [
    {
      "id": 39208,
      "keyword": "inauguración de los juegos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "encendido del pebetero": [
    {
      "id": 39208,
      "keyword": "encendido del pebetero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "relevo de la antorcha paralímpica": [
    {
      "id": 39209,
      "keyword": "relevo de la antorcha paralímpica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "relevo de la antorcha": [
    {
      "id": 39209,
      "keyword": "relevo de la antorcha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39210,
      "keyword": "relevo de la antorcha",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "relevo de la antorcha olímpica": [
    {
      "id": 39210,
      "keyword": "relevo de la antorcha olímpica",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desatar": [
    {
      "id": 39213,
      "keyword": "desatar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpieza dental": [
    {
      "id": 39216,
      "keyword": "limpieza dental",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "limpiar los dientes": [
    {
      "id": 39216,
      "keyword": "limpiar los dientes",
      "keywords": 2,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "parcialmente nublado": [
    {
      "id": 39218,
      "keyword": "parcialmente nublado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "venoclicis": [
    {
      "id": 39219,
      "keyword": "venoclicis",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cateterismo venoso periférico": [
    {
      "id": 39219,
      "keyword": "cateterismo venoso periférico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "treatment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "san pedro": [
    {
      "id": 39220,
      "keyword": "San Pedro",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "san antón": [
    {
      "id": 39221,
      "keyword": "San Antón",
      "keywords": 1,
      "type": 1,
      "tags": [
        "religion",
        "character",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "driblar": [
    {
      "id": 39223,
      "keyword": "driblar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rebotear": [
    {
      "id": 39225,
      "keyword": "rebotear",
      "keywords": 1,
      "type": 3,
      "tags": [
        "leisure",
        "sport",
        "basketball"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "abbocaths": [
    {
      "id": 39227,
      "keyword": "abbocaths",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "nursing equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cabina audiométrica": [
    {
      "id": 39228,
      "keyword": "cabina audiométrica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cabinas audiométricas": [
    {
      "id": 39228,
      "keyword": "cabina audiométrica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device",
        "medical procedure",
        "medical test"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "director centro de día": [
    {
      "id": 39229,
      "keyword": "director centro de día",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "tertiary sector",
        "personal services"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maquina de votación": [
    {
      "id": 39232,
      "keyword": "maquina de votación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39233,
      "keyword": "maquina de votación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "maquinas de votación": [
    {
      "id": 39232,
      "keyword": "maquina de votación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39233,
      "keyword": "maquina de votación",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "confirmar voto": [
    {
      "id": 39234,
      "keyword": "confirmar voto",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "work",
        "tertiary sector",
        "political representation",
        "election"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "letra": [
    {
      "id": 39235,
      "keyword": "letra",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "letra de canción": [
    {
      "id": 39235,
      "keyword": "letra de canción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "letras de cancón": [
    {
      "id": 39235,
      "keyword": "letra de canción",
      "keywords": 2,
      "type": 2,
      "tags": [
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bicicleta de bmx": [
    {
      "id": 39236,
      "keyword": "bicicleta de BMX",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "cycling",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bicicletas de bmx": [
    {
      "id": 39236,
      "keyword": "bicicleta de BMX",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "cycling",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bmx": [
    {
      "id": 39237,
      "keyword": "BMX",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "cycling",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "circuito de bmx": [
    {
      "id": 39237,
      "keyword": "circuito de BMX",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "cycling",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39237,
      "keyword": "circuito de BMX",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "cycling",
        "facility",
        "sports facility",
        "place",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pebetero": [
    {
      "id": 39239,
      "keyword": "pebetero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pebeteros": [
    {
      "id": 39239,
      "keyword": "pebetero",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pebetero olímpico": [
    {
      "id": 39239,
      "keyword": "pebetero olímpico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pebeteros olímpicos": [
    {
      "id": 39239,
      "keyword": "pebetero olímpico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "event",
        "sport event",
        "olympic games"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camisón de hospital": [
    {
      "id": 39240,
      "keyword": "camisón de hospital",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camisones de hospital": [
    {
      "id": 39240,
      "keyword": "camisón de hospital",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "person",
        "patient",
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "kohlrabi": [
    {
      "id": 39243,
      "keyword": "kohlrabi",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "kohlrabis": [
    {
      "id": 39243,
      "keyword": "kohlrabi",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "colirrábano": [
    {
      "id": 39243,
      "keyword": "colirrábano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "colirrábanos": [
    {
      "id": 39243,
      "keyword": "colirrábano",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cruce": [
    {
      "id": 39244,
      "keyword": "cruce",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cruces": [
    {
      "id": 39244,
      "keyword": "cruce",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "urban area",
        "movement",
        "traffic",
        "road safety"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "botón de editar": [
    {
      "id": 39245,
      "keyword": "botón de editar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botones de editar": [
    {
      "id": 39245,
      "keyword": "botón de editar",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "soledad": [
    {
      "id": 39247,
      "keyword": "soledad",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "terror": [
    {
      "id": 39248,
      "keyword": "terror",
      "keywords": 2,
      "type": 2,
      "tags": [
        "psychology",
        "feeling",
        "emotion",
        "human response",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ecología": [
    {
      "id": 39249,
      "keyword": "ecología",
      "keywords": 1,
      "type": 2,
      "tags": [
        "biology",
        "ecology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "chocolate negro": [
    {
      "id": 39250,
      "keyword": "chocolate negro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pantalla completa": [
    {
      "id": 39251,
      "keyword": "pantalla completa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botón de pantalla completa": [
    {
      "id": 39251,
      "keyword": "botón de pantalla completa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pócima": [
    {
      "id": 39252,
      "keyword": "pócima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "chemistry",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pócimas": [
    {
      "id": 39252,
      "keyword": "pócima",
      "keywords": 1,
      "type": 2,
      "tags": [
        "chemistry",
        "event",
        "popular event",
        "halloween"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "túnica": [
    {
      "id": 39253,
      "keyword": "túnica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "túnicas": [
    {
      "id": 39253,
      "keyword": "túnica",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bandeja de comedor": [
    {
      "id": 39254,
      "keyword": "bandeja de comedor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bandejas de comedor": [
    {
      "id": 39254,
      "keyword": "bandeja de comedor",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "intubado": [
    {
      "id": 39255,
      "keyword": "intubado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intubados": [
    {
      "id": 39255,
      "keyword": "intubado",
      "keywords": 2,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "intubada": [
    {
      "id": 39255,
      "keyword": "intubada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intubadas": [
    {
      "id": 39255,
      "keyword": "intubada",
      "keywords": 2,
      "type": 4,
      "tags": [
        "health",
        "medicine",
        "medical procedure",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "intubar": [
    {
      "id": 39256,
      "keyword": "intubar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "health",
        "medicine",
        "medical procedure"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿durante cuánto tiempo?": [
    {
      "id": 39257,
      "keyword": "¿durante cuánto tiempo?",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "durante cuánto tiempo": [
    {
      "id": 39257,
      "keyword": "durante cuánto tiempo",
      "keywords": 2,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "time",
        "unit of time"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "policubos": [
    {
      "id": 39258,
      "keyword": "policubos",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "educational material",
        "mathematics"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "trabajo en cadena": [
    {
      "id": 39263,
      "keyword": "trabajo en cadena",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "organization",
        "workplace"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cadena de montaje": [
    {
      "id": 39263,
      "keyword": "cadena de montaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "organization",
        "workplace"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39263,
      "keyword": "cadena de montaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "secondary sector",
        "organization",
        "workplace"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "estanque": [
    {
      "id": 39264,
      "keyword": "estanque",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "estanques": [
    {
      "id": 39264,
      "keyword": "estanque",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "charca": [
    {
      "id": 39264,
      "keyword": "charca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "charcas": [
    {
      "id": 39264,
      "keyword": "charca",
      "keywords": 2,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element",
        "geography",
        "physical geography",
        "landform"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casa para pájaros": [
    {
      "id": 39265,
      "keyword": "casa para pájaros",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casas para pájaros": [
    {
      "id": 39265,
      "keyword": "casa para pájaros",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "casa de pájaros": [
    {
      "id": 39265,
      "keyword": "casa de pájaros",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "casas de pájaros": [
    {
      "id": 39265,
      "keyword": "casa de pájaros",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caja nido": [
    {
      "id": 39265,
      "keyword": "caja nido",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cajas nido": [
    {
      "id": 39265,
      "keyword": "caja nido",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pajarera": [
    {
      "id": 39265,
      "keyword": "pajarera",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pajareras": [
    {
      "id": 39265,
      "keyword": "pajarera",
      "keywords": 4,
      "type": 2,
      "tags": [
        "animal",
        "animal housing"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "freidora de aire": [
    {
      "id": 39266,
      "keyword": "freidora de aire",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "freidoras de aire": [
    {
      "id": 39266,
      "keyword": "freidora de aire",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "airfryer": [
    {
      "id": 39266,
      "keyword": "airfryer",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "airfryers": [
    {
      "id": 39266,
      "keyword": "airfryer",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "appliance",
        "electrical appliance",
        "home"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "coliflor con patata": [
    {
      "id": 39267,
      "keyword": "coliflor con patata",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  " coro": [
    {
      "id": 39268,
      "keyword": " coro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "person",
        "group",
        "music",
        "event",
        "popular event",
        "christmas"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espacio amigable": [
    {
      "id": 39269,
      "keyword": "espacio amigable",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espacios amigables": [
    {
      "id": 39269,
      "keyword": "espacio amigable",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espacio de relajación": [
    {
      "id": 39269,
      "keyword": "espacio de relajación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espacios de relajación": [
    {
      "id": 39269,
      "keyword": "espacio de relajación",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "espacio tranquilo": [
    {
      "id": 39269,
      "keyword": "espacio tranquilo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "espacios tranquilos": [
    {
      "id": 39269,
      "keyword": "espacio tranquilo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lanzar un beso": [
    {
      "id": 39272,
      "keyword": "lanzar un beso",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mandar un beso": [
    {
      "id": 39272,
      "keyword": "mandar un beso",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torrezno": [
    {
      "id": 39273,
      "keyword": "torrezno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "torreznos": [
    {
      "id": 39273,
      "keyword": "torrezno",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "processed food",
        "cold meat",
        "gastronomy",
        "traditional dish"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugador": [
    {
      "id": 39276,
      "keyword": "jugador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadores": [
    {
      "id": 39276,
      "keyword": "jugador",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "deportista": [
    {
      "id": 39276,
      "keyword": "deportista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39279,
      "keyword": "deportista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "deportistas": [
    {
      "id": 39276,
      "keyword": "deportista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    },
    {
      "id": 39279,
      "keyword": "deportista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "jugadora": [
    {
      "id": 39279,
      "keyword": "jugadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "jugadoras": [
    {
      "id": 39279,
      "keyword": "jugadora",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "levantar pesas": [
    {
      "id": 39282,
      "keyword": "levantar pesas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "sport modality"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sincero": [
    {
      "id": 39287,
      "keyword": "sincero",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sinceros": [
    {
      "id": 39287,
      "keyword": "sincero",
      "keywords": 7,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "productos de limpieza": [
    {
      "id": 39289,
      "keyword": "productos de limpieza",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "investigar un crimen": [
    {
      "id": 39290,
      "keyword": "investigar un crimen",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "law",
        "crime"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cilantro": [
    {
      "id": 39291,
      "keyword": "cilantro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cilantros": [
    {
      "id": 39291,
      "keyword": "cilantro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "aromatic plant",
        "feeding",
        "food",
        "plant-based food",
        "hervaceouos plant"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "las dos": [
    {
      "id": 39292,
      "keyword": "las dos",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "04:00h": [
    {
      "id": 39301,
      "keyword": "04:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "03:45h": [
    {
      "id": 39302,
      "keyword": "03:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "03:30h": [
    {
      "id": 39303,
      "keyword": "03:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "03:15h": [
    {
      "id": 39304,
      "keyword": "03:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "las tres": [
    {
      "id": 39305,
      "keyword": "las tres",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39320,
      "keyword": "las tres",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "las 3": [
    {
      "id": 39305,
      "keyword": "las 3",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    },
    {
      "id": 39320,
      "keyword": "las 3",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "03:00h": [
    {
      "id": 39305,
      "keyword": "03:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "02:45h": [
    {
      "id": 39306,
      "keyword": "02:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "02:30h": [
    {
      "id": 39307,
      "keyword": "02:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "02:15h": [
    {
      "id": 39308,
      "keyword": "02:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "la una": [
    {
      "id": 39330,
      "keyword": "la una",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours",
        "communication",
        "language",
        "adverb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "la 1": [
    {
      "id": 39330,
      "keyword": "la 1",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours",
        "communication",
        "language",
        "adverb"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "09:45h": [
    {
      "id": 39340,
      "keyword": "09:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "09:30h": [
    {
      "id": 39341,
      "keyword": "09:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "09:00h": [
    {
      "id": 39343,
      "keyword": "09:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "08:45h": [
    {
      "id": 39344,
      "keyword": "08:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "08:30h": [
    {
      "id": 39345,
      "keyword": "08:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "08:00h": [
    {
      "id": 39346,
      "keyword": "08:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "08:15h": [
    {
      "id": 39347,
      "keyword": "08:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "07:45h": [
    {
      "id": 39349,
      "keyword": "07:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "07:15h": [
    {
      "id": 39350,
      "keyword": "07:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "07:00h": [
    {
      "id": 39351,
      "keyword": "07:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "06:30h": [
    {
      "id": 39353,
      "keyword": "06:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "06:15h": [
    {
      "id": 39354,
      "keyword": "06:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "06:00h": [
    {
      "id": 39355,
      "keyword": "06:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "05:45h": [
    {
      "id": 39356,
      "keyword": "05:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "05:30h": [
    {
      "id": 39357,
      "keyword": "05:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cinco y cuiarto": [
    {
      "id": 39358,
      "keyword": "cinco y cuiarto",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "05:15h": [
    {
      "id": 39358,
      "keyword": "05:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "05:00h": [
    {
      "id": 39359,
      "keyword": "05:00h",
      "keywords": 3,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "06:45h": [
    {
      "id": 39360,
      "keyword": "06:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "04:45h": [
    {
      "id": 39361,
      "keyword": "04:45h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "04:30h": [
    {
      "id": 39362,
      "keyword": "04:30h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "04:15h": [
    {
      "id": 39363,
      "keyword": "04:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "23:!5h": [
    {
      "id": 39365,
      "keyword": "23:!5h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "18:15h": [
    {
      "id": 39386,
      "keyword": "18:15h",
      "keywords": 2,
      "type": 6,
      "tags": [
        "time",
        "unit of time",
        "day hours"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arroz blanco": [
    {
      "id": 39387,
      "keyword": "arroz blanco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "arroces blancos": [
    {
      "id": 39387,
      "keyword": "arroz blanco",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "gastronomy",
        "core vocabulary"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pimiento amarillo": [
    {
      "id": 39388,
      "keyword": "pimiento amarillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pimientos amarillos": [
    {
      "id": 39388,
      "keyword": "pimiento amarillo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "plant-based food",
        "vegetable"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "lilo": [
    {
      "id": 39389,
      "keyword": "lilo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "lilos": [
    {
      "id": 39389,
      "keyword": "lilo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "tree"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "membrillero": [
    {
      "id": 39390,
      "keyword": "membrillero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "membrilleros": [
    {
      "id": 39390,
      "keyword": "membrillero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "albaricoquero": [
    {
      "id": 39391,
      "keyword": "albaricoquero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "albaricoqueros": [
    {
      "id": 39391,
      "keyword": "albaricoquero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "tree",
        "work",
        "primary sector",
        "agriculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "clínica dental": [
    {
      "id": 39392,
      "keyword": "clínica dental",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "odontology",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cílnicas dentales": [
    {
      "id": 39392,
      "keyword": "clínica dental",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical center",
        "place",
        "building",
        "odontology",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "abrir las piernas": [
    {
      "id": 39396,
      "keyword": "abrir las piernas",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hacer el espagat": [
    {
      "id": 39396,
      "keyword": "hacer el espagat",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salir de la bañera": [
    {
      "id": 39397,
      "keyword": "salir de la bañera",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "entrar en la bañera": [
    {
      "id": 39398,
      "keyword": "entrar en la bañera",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "person",
        "routine",
        "human body",
        "hygiene",
        "corporal hygiene"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "moho": [
    {
      "id": 39404,
      "keyword": "moho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "fungus",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mohos": [
    {
      "id": 39404,
      "keyword": "moho",
      "keywords": 1,
      "type": 2,
      "tags": [
        "plant",
        "fungus",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "camioneta": [
    {
      "id": 39405,
      "keyword": "camioneta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "camionetas": [
    {
      "id": 39405,
      "keyword": "camioneta",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pickup": [
    {
      "id": 39405,
      "keyword": "pickup",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pickups": [
    {
      "id": 39405,
      "keyword": "pickup",
      "keywords": 2,
      "type": 2,
      "tags": [
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "exoesqueleto": [
    {
      "id": 39406,
      "keyword": "exoesqueleto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "health",
        "physiotherapy",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "exoesqueletos": [
    {
      "id": 39406,
      "keyword": "exoesqueleto",
      "keywords": 1,
      "type": 2,
      "tags": [
        "object",
        "orthopedic product",
        "health",
        "physiotherapy",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pedalier eléctrico": [
    {
      "id": 39407,
      "keyword": "pedalier eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pedaliers eléctricos": [
    {
      "id": 39407,
      "keyword": "pedalier eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pedaleador eléctrico": [
    {
      "id": 39407,
      "keyword": "pedaleador eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pedaleadores eléctricos": [
    {
      "id": 39407,
      "keyword": "pedaleador eléctrico",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "physiotherapy equipment",
        "leisure",
        "sport",
        "sport material"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "caminar lateralmente": [
    {
      "id": 39408,
      "keyword": "caminar lateralmente",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasos laterales": [
    {
      "id": 39408,
      "keyword": "pasos laterales",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "desplazamiento lateral": [
    {
      "id": 39408,
      "keyword": "desplazamiento lateral",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "sport",
        "physical exercise"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sala de banderas": [
    {
      "id": 39410,
      "keyword": "sala de banderas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salas de banderas": [
    {
      "id": 39410,
      "keyword": "sala de banderas",
      "keywords": 1,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "communication",
        "signaling system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "almacén de canoas": [
    {
      "id": 39411,
      "keyword": "almacén de canoas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "leisure",
        "sport",
        "facility",
        "sports facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "almacén de traineras": [
    {
      "id": 39411,
      "keyword": "almacén de traineras",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "room",
        "leisure",
        "sport",
        "facility",
        "sports facility"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clamp dental": [
    {
      "id": 39412,
      "keyword": "clamp dental",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "clamp dentales": [
    {
      "id": 39412,
      "keyword": "clamp dental",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pastilla de lavavajillas": [
    {
      "id": 39415,
      "keyword": "pastilla de lavavajillas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pastillas de lavavajillas": [
    {
      "id": 39415,
      "keyword": "pastilla de lavavajillas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "detergente lavavajillas": [
    {
      "id": 39415,
      "keyword": "detergente lavavajillas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "detergentes lavavajillas": [
    {
      "id": 39415,
      "keyword": "detergente lavavajillas",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "cleaning product"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "mamógrafo": [
    {
      "id": 39416,
      "keyword": "mamógrafo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mamógrafos": [
    {
      "id": 39416,
      "keyword": "mamógrafo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment",
        "medical device"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "internista": [
    {
      "id": 39417,
      "keyword": "internista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "internistas": [
    {
      "id": 39417,
      "keyword": "internista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "médico internista": [
    {
      "id": 39417,
      "keyword": "médico internista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "médicos internistas": [
    {
      "id": 39417,
      "keyword": "médico internista",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "professional",
        "work"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "luz negra": [
    {
      "id": 39418,
      "keyword": "luz negra",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "show",
        "work",
        "scenic art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rocío": [
    {
      "id": 39419,
      "keyword": "rocío",
      "keywords": 1,
      "type": 2,
      "tags": [
        "meteorology",
        "atmospheric phenomena"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compañero": [
    {
      "id": 39421,
      "keyword": "compañero",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compañera": [
    {
      "id": 39422,
      "keyword": "compañera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "compañeras": [
    {
      "id": 39422,
      "keyword": "compañera",
      "keywords": 1,
      "type": 2,
      "tags": [
        "education",
        "students"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "traductor": [
    {
      "id": 39433,
      "keyword": "traductor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "communication",
        "language",
        "verb",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "traductores": [
    {
      "id": 39433,
      "keyword": "traductor",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "communication",
        "language",
        "verb",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "traductora": [
    {
      "id": 39433,
      "keyword": "traductora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "communication",
        "language",
        "verb",
        "professional"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "traductoras": [
    {
      "id": 39433,
      "keyword": "traductora",
      "keywords": 3,
      "type": 2,
      "tags": [
        "work",
        "communication",
        "language",
        "verb",
        "professional"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "leggings": [
    {
      "id": 39452,
      "keyword": "leggings",
      "keywords": 2,
      "type": 2,
      "tags": [
        "object",
        "fashion",
        "clothes"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apicultor": [
    {
      "id": 39453,
      "keyword": "apicultor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "apiculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apicultores": [
    {
      "id": 39453,
      "keyword": "apicultor",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "apiculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "apicultora": [
    {
      "id": 39454,
      "keyword": "apicultora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "apiculture"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "apicultoras": [
    {
      "id": 39454,
      "keyword": "apicultora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "primary sector",
        "apiculture"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "islas feroe": [
    {
      "id": 39459,
      "keyword": "Islas Feroe",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mayúscula": [
    {
      "id": 39460,
      "keyword": "mayúscula",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "computing",
        "communication system",
        "language",
        "alphabet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "mayúsculas": [
    {
      "id": 39460,
      "keyword": "mayúscula",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "computing",
        "communication system",
        "language",
        "alphabet"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "letra mayúscula": [
    {
      "id": 39460,
      "keyword": "letra mayúscula",
      "keywords": 3,
      "type": 2,
      "tags": [
        "communication",
        "computing",
        "communication system",
        "language",
        "alphabet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cambiar a mayúsculas": [
    {
      "id": 39460,
      "keyword": "cambiar a mayúsculas",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "computing",
        "communication system",
        "language",
        "alphabet"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "gales": [
    {
      "id": 39461,
      "keyword": "Gales",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "hong kong": [
    {
      "id": 39462,
      "keyword": "Hong Kong",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sudán": [
    {
      "id": 39463,
      "keyword": "Sudán",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tanzania": [
    {
      "id": 39464,
      "keyword": "Tanzania",
      "keywords": 1,
      "type": 1,
      "tags": [
        "geography",
        "political geography",
        "flag",
        "country"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botón de salir de pantalla completa": [
    {
      "id": 39465,
      "keyword": "botón de salir de pantalla completa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "salir de pantalla completa": [
    {
      "id": 39465,
      "keyword": "salir de pantalla completa",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "botón de configuración": [
    {
      "id": 39466,
      "keyword": "botón de configuración",
      "keywords": 1,
      "type": 2,
      "tags": [
        "communication",
        "computing",
        "communication system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escenógrafo": [
    {
      "id": 39467,
      "keyword": "escenógrafo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escenógrafos": [
    {
      "id": 39467,
      "keyword": "escenógrafo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "escenógrafa": [
    {
      "id": 39467,
      "keyword": "escenógrafa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "escenógrafas": [
    {
      "id": 39467,
      "keyword": "escenógrafa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "aloe vera": [
    {
      "id": 39468,
      "keyword": "aloe vera",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "cactus"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sábila": [
    {
      "id": 39468,
      "keyword": "sábila",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "cactus"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sábilas": [
    {
      "id": 39468,
      "keyword": "sábila",
      "keywords": 2,
      "type": 2,
      "tags": [
        "plant",
        "cactus"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "técnico de iluminación": [
    {
      "id": 39469,
      "keyword": "técnico de iluminación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnicos de iluminación": [
    {
      "id": 39469,
      "keyword": "técnico de iluminación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "técnica de iluminación": [
    {
      "id": 39469,
      "keyword": "técnica de iluminación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "music"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "técnicas de iluminación": [
    {
      "id": 39469,
      "keyword": "técnica de iluminación",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "music"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "director de cine": [
    {
      "id": 39470,
      "keyword": "director de cine",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "directores de cine": [
    {
      "id": 39470,
      "keyword": "director de cine",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "directora de cine": [
    {
      "id": 39470,
      "keyword": "directora de cine",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "directoras de cine": [
    {
      "id": 39470,
      "keyword": "directora de cine",
      "keywords": 2,
      "type": 2,
      "tags": [
        "work",
        "professional",
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "rodaje": [
    {
      "id": 39471,
      "keyword": "rodaje",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "rodajes": [
    {
      "id": 39471,
      "keyword": "rodaje",
      "keywords": 2,
      "type": 2,
      "tags": [],
      "noColor": false,
      "plural": true
    }
  ],
  "rodar una película": [
    {
      "id": 39471,
      "keyword": "rodar una película",
      "keywords": 2,
      "type": 3,
      "tags": [],
      "noColor": false,
      "plural": false
    }
  ],
  "flemón": [
    {
      "id": 39472,
      "keyword": "flemón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "odontology"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "flemones": [
    {
      "id": 39472,
      "keyword": "flemón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "odontology"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "bar del cine": [
    {
      "id": 39475,
      "keyword": "bar del cine",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ambigú": [
    {
      "id": 39475,
      "keyword": "ambigú",
      "keywords": 2,
      "type": 2,
      "tags": [
        "place",
        "building",
        "catering establishment",
        "hospitality industry",
        "work",
        "tertiary sector",
        "scenic art",
        "cinema",
        "show"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "freír": [
    {
      "id": 39476,
      "keyword": "freír",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sofreír": [
    {
      "id": 39476,
      "keyword": "sofreír",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "freír verduras": [
    {
      "id": 39477,
      "keyword": "freír verduras",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "object",
        "household",
        "utensil",
        "home",
        "feeding",
        "cookery"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "1/2 kilo": [
    {
      "id": 39478,
      "keyword": "1/2 kilo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medio kilo": [
    {
      "id": 39478,
      "keyword": "medio kilo",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "medio kg": [
    {
      "id": 39478,
      "keyword": "medio kg",
      "keywords": 3,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "1/4 de kilo": [
    {
      "id": 39479,
      "keyword": "1/4 de kilo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cuarto de kilo": [
    {
      "id": 39479,
      "keyword": "cuarto de kilo",
      "keywords": 2,
      "type": 2,
      "tags": [
        "mathematics",
        "measurement unit"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palo de helado": [
    {
      "id": 39480,
      "keyword": "palo de helado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "palos de helado": [
    {
      "id": 39480,
      "keyword": "palo de helado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "copa de helado": [
    {
      "id": 39482,
      "keyword": "copa de helado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "copas de helado": [
    {
      "id": 39482,
      "keyword": "copa de helado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "barra de helado": [
    {
      "id": 39483,
      "keyword": "barra de helado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "summer"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barras de helado": [
    {
      "id": 39483,
      "keyword": "barra de helado",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "summer"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sorbete": [
    {
      "id": 39484,
      "keyword": "sorbete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sorbetes": [
    {
      "id": 39484,
      "keyword": "sorbete",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sorbete de limón": [
    {
      "id": 39485,
      "keyword": "sorbete de limón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sorbetes de limón": [
    {
      "id": 39485,
      "keyword": "sorbete de limón",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "beverage"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "repostería": [
    {
      "id": 39486,
      "keyword": "repostería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "laberinto motriz": [
    {
      "id": 39487,
      "keyword": "laberinto motriz",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "toy",
        "education",
        "educational material"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guepardo": [
    {
      "id": 39488,
      "keyword": "guepardo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "guepardos": [
    {
      "id": 39488,
      "keyword": "guepardo",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "carnivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "orangután": [
    {
      "id": 39491,
      "keyword": "orangután",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "orangutanes": [
    {
      "id": 39491,
      "keyword": "orangután",
      "keywords": 1,
      "type": 2,
      "tags": [
        "animal",
        "herbivorous",
        "vertebrate",
        "mammal",
        "viviparous",
        "terrestrial animal",
        "wild"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "billete de avión": [
    {
      "id": 39492,
      "keyword": "billete de avión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "billetes de avión": [
    {
      "id": 39492,
      "keyword": "billete de avión",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "pasaje": [
    {
      "id": 39492,
      "keyword": "pasaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "pasajes": [
    {
      "id": 39492,
      "keyword": "pasaje",
      "keywords": 2,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "air transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "billete de tren": [
    {
      "id": 39493,
      "keyword": "billete de tren",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "billetes de tren": [
    {
      "id": 39493,
      "keyword": "billete de tren",
      "keywords": 1,
      "type": 2,
      "tags": [
        "document",
        "trade",
        "movement",
        "traffic",
        "mode of transport",
        "land transport"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "retroceder": [
    {
      "id": 39494,
      "keyword": "retroceder",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "retroceder la ficha": [
    {
      "id": 39494,
      "keyword": "retroceder la ficha",
      "keywords": 3,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "game",
        "board game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "barajar": [
    {
      "id": 39495,
      "keyword": "barajar",
      "keywords": 1,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "leisure",
        "game",
        "card game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "bollería": [
    {
      "id": 39497,
      "keyword": "bollería",
      "keywords": 1,
      "type": 2,
      "tags": [
        "feeding",
        "food",
        "ultra-processed food",
        "dessert",
        "baking",
        "categorization"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oído": [
    {
      "id": 39498,
      "keyword": "oído",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "auditory system",
        "senses"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "oídos": [
    {
      "id": 39498,
      "keyword": "oído",
      "keywords": 1,
      "type": 2,
      "tags": [
        "human body",
        "anatomy",
        "human anatomy",
        "physiology",
        "human physiology",
        "auditory system",
        "senses"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "boxeadora": [
    {
      "id": 39501,
      "keyword": "boxeadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "boxeadoras": [
    {
      "id": 39501,
      "keyword": "boxeadora",
      "keywords": 1,
      "type": 2,
      "tags": [
        "leisure",
        "sport",
        "person"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "contrafuerte": [
    {
      "id": 39503,
      "keyword": "contrafuerte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "contrafuertes": [
    {
      "id": 39503,
      "keyword": "contrafuerte",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "capitel": [
    {
      "id": 39504,
      "keyword": "capitel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "capiteles": [
    {
      "id": 39504,
      "keyword": "capitel",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "sepulcro": [
    {
      "id": 39505,
      "keyword": "sepulcro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "sepulcros": [
    {
      "id": 39505,
      "keyword": "sepulcro",
      "keywords": 1,
      "type": 2,
      "tags": [
        "event",
        "social event",
        "death"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ventana saetera": [
    {
      "id": 39506,
      "keyword": "ventana saetera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ventanas saeteras": [
    {
      "id": 39506,
      "keyword": "ventana saetera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ventana aspillera": [
    {
      "id": 39506,
      "keyword": "ventana aspillera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ventanas aspilleras": [
    {
      "id": 39506,
      "keyword": "ventana aspillera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "ventana arquera": [
    {
      "id": 39506,
      "keyword": "ventana arquera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "ventanas arqueras": [
    {
      "id": 39506,
      "keyword": "ventana arquera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "architectural element"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "planta de cruz latina": [
    {
      "id": 39507,
      "keyword": "planta de cruz latina",
      "keywords": 1,
      "type": 2,
      "tags": [
        "architecture",
        "building",
        "place",
        "religion",
        "christianity"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tinnitus": [
    {
      "id": 39508,
      "keyword": "tinnitus",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zumbido": [
    {
      "id": 39508,
      "keyword": "zumbido",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "zumbidos": [
    {
      "id": 39508,
      "keyword": "zumbido",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "acúfeno": [
    {
      "id": 39508,
      "keyword": "acúfeno",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "acúfenos": [
    {
      "id": 39508,
      "keyword": "acúfeno",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "instrumental médico": [
    {
      "id": 39509,
      "keyword": "instrumental médico",
      "keywords": 1,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "medical equipment"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tapón de cera": [
    {
      "id": 39510,
      "keyword": "tapón de cera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "tapones de cera": [
    {
      "id": 39510,
      "keyword": "tapón de cera",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "cerumen": [
    {
      "id": 39510,
      "keyword": "cerumen",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "cerúmenes": [
    {
      "id": 39510,
      "keyword": "cerumen",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "taponamiento": [
    {
      "id": 39510,
      "keyword": "taponamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "taponamientos": [
    {
      "id": 39510,
      "keyword": "taponamiento",
      "keywords": 3,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "human body",
        "physiology",
        "human physiology",
        "auditory system"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "muy grave": [
    {
      "id": 39512,
      "keyword": "muy grave",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "crítico": [
    {
      "id": 39512,
      "keyword": "crítico",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "peor": [
    {
      "id": 39512,
      "keyword": "peor",
      "keywords": 3,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "grave": [
    {
      "id": 39513,
      "keyword": "grave",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "leve": [
    {
      "id": 39514,
      "keyword": "leve",
      "keywords": 1,
      "type": 4,
      "tags": [
        "communication",
        "language",
        "adjective",
        "qualifying adjective",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "¿cuál es la gravedad?": [
    {
      "id": 39516,
      "keyword": "¿Cuál es la gravedad?",
      "keywords": 1,
      "type": 5,
      "tags": [
        "communication",
        "language",
        "expression",
        "health",
        "medicine",
        "disease",
        "person",
        "patient"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intolerancia alimentaria": [
    {
      "id": 39517,
      "keyword": "intolerancia alimentaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "intolerancias alimentarias": [
    {
      "id": 39517,
      "keyword": "intolerancia alimentaria",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "intolerancia a los alimentos": [
    {
      "id": 39517,
      "keyword": "intolerancia a los alimentos",
      "keywords": 2,
      "type": 2,
      "tags": [
        "health",
        "medicine",
        "symptom",
        "feeding",
        "food"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máquina recreativa": [
    {
      "id": 39518,
      "keyword": "máquina recreativa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máquinas recreativas": [
    {
      "id": 39518,
      "keyword": "máquina recreativa",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "máquina de arcade": [
    {
      "id": 39518,
      "keyword": "máquina de arcade",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "máquinas de arcade": [
    {
      "id": 39518,
      "keyword": "máquina de arcade",
      "keywords": 2,
      "type": 2,
      "tags": [
        "leisure",
        "game",
        "video game"
      ],
      "noColor": false,
      "plural": true
    }
  ],
  "reencontrar": [
    {
      "id": 39520,
      "keyword": "reencontrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ],
  "rencontrar": [
    {
      "id": 39520,
      "keyword": "rencontrar",
      "keywords": 2,
      "type": 3,
      "tags": [
        "communication",
        "language",
        "verb",
        "psychology",
        "human response"
      ],
      "noColor": false,
      "plural": false
    }
  ]
};
